import { FontAwesomeIcon as Le } from "@fortawesome/react-fontawesome";
import * as C from "react";
import x, { useCallback as De, createContext as wn, useMemo as Lt, createElement as X, useContext as Me, forwardRef as ke, Children as Ui, isValidElement as Ps, cloneElement as qf, Fragment as t1, useEffect as be, useRef as me, useState as de, useLayoutEffect as eo, useReducer as Yf, Component as y$, useDebugValue as w$, lazy as iS, Suspense as oS, useImperativeHandle as aS, PureComponent as b$ } from "react";
import * as Kf from "react-dom";
import Xf, { flushSync as Zf, createPortal as _c } from "react-dom";
var x$ = {
  prefix: "fas",
  iconName: "trash-can",
  icon: [448, 512, [61460, "trash-alt"], "f2ed", "M135.2 17.7C140.6 6.8 151.7 0 163.8 0H284.2c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64S14.3 32 32 32h96l7.2-14.3zM32 128H416V448c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm96 64c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16zm96 0c-8.8 0-16 7.2-16 16V432c0 8.8 7.2 16 16 16s16-7.2 16-16V208c0-8.8-7.2-16-16-16z"]
}, G1e = {
  prefix: "fas",
  iconName: "message",
  icon: [512, 512, ["comment-alt"], "f27a", "M64 0C28.7 0 0 28.7 0 64V352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L309.3 416H448c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64z"]
}, E$ = {
  prefix: "fas",
  iconName: "chevrons-left",
  icon: [512, 512, ["chevron-double-left"], "f323", "M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 278.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192zm384-192l-192 192c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 470.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z"]
}, C$ = {
  prefix: "fas",
  iconName: "house-building",
  icon: [640, 512, [], "e1b1", "M368 0c-26.5 0-48 21.5-48 48V153.9l64 58.7V208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H413.2c1.9 6.8 2.8 13.9 2.8 21.1V288h16c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H416V464c0 18-6 34.6-16 48H592c26.5 0 48-21.5 48-48V48c0-26.5-21.5-48-48-48H368zM512 208c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V208zm16 80h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V304c0-8.8 7.2-16 16-16zM400 96h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H400c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16zm112 16c0-8.8 7.2-16 16-16h32c8.8 0 16 7.2 16 16v32c0 8.8-7.2 16-16 16H528c-8.8 0-16-7.2-16-16V112zM0 277.1V464c0 26.5 21.5 48 48 48H336c26.5 0 48-21.5 48-48V277.1c0-13.5-5.6-26.3-15.6-35.4l-144-132c-18.4-16.8-46.5-16.8-64.9 0l-144 132C5.6 250.8 0 263.7 0 277.1zM144 296c0-13.3 10.7-24 24-24h48c13.3 0 24 10.7 24 24v48c0 13.3-10.7 24-24 24H168c-13.3 0-24-10.7-24-24V296z"]
}, S$ = {
  prefix: "fas",
  iconName: "pencil",
  icon: [512, 512, [9999, 61504, "pencil-alt"], "f303", "M410.3 231l11.3-11.3-33.9-33.9-62.1-62.1L291.7 89.8l-11.3 11.3-22.6 22.6L58.6 322.9c-10.4 10.4-18 23.3-22.2 37.4L1 480.7c-2.5 8.4-.2 17.5 6.1 23.7s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L387.7 253.7 410.3 231zM160 399.4l-9.1 22.7c-4 3.1-8.5 5.4-13.3 6.9L59.4 452l23-78.1c1.4-4.9 3.8-9.4 6.9-13.3l22.7-9.1v32c0 8.8 7.2 16 16 16h32zM362.7 18.7L348.3 33.2 325.7 55.8 314.3 67.1l33.9 33.9 62.1 62.1 33.9 33.9 11.3-11.3 22.6-22.6 14.5-14.5c25-25 25-65.5 0-90.5L453.3 18.7c-25-25-65.5-25-90.5 0zm-47.4 168l-144 144c-6.2 6.2-16.4 6.2-22.6 0s-6.2-16.4 0-22.6l144-144c6.2-6.2 16.4-6.2 22.6 0s6.2 16.4 0 22.6z"]
}, sS = {
  prefix: "fas",
  iconName: "lightbulb",
  icon: [384, 512, [128161], "f0eb", "M272 384c9.6-31.9 29.5-59.1 49.2-86.2l0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4l0 0c19.8 27.1 39.7 54.4 49.2 86.2H272zM192 512c44.2 0 80-35.8 80-80V416H112v16c0 44.2 35.8 80 80 80zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z"]
}, _$ = {
  prefix: "fas",
  iconName: "volume-low",
  icon: [448, 512, [128264, "volume-down"], "f027", "M301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zM412.6 181.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z"]
}, lS = {
  prefix: "fas",
  iconName: "list",
  icon: [512, 512, ["list-squares"], "f03a", "M40 48C26.7 48 16 58.7 16 72v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V72c0-13.3-10.7-24-24-24H40zM192 64c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zm0 160c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H192zM16 232v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V232c0-13.3-10.7-24-24-24H40c-13.3 0-24 10.7-24 24zM40 368c-13.3 0-24 10.7-24 24v48c0 13.3 10.7 24 24 24H88c13.3 0 24-10.7 24-24V392c0-13.3-10.7-24-24-24H40z"]
}, P$ = {
  prefix: "fas",
  iconName: "pen-to-square",
  icon: [512, 512, ["edit"], "f044", "M471.6 21.7c-21.9-21.9-57.3-21.9-79.2 0L362.3 51.7l97.9 97.9 30.1-30.1c21.9-21.9 21.9-57.3 0-79.2L471.6 21.7zm-299.2 220c-6.1 6.1-10.8 13.6-13.5 21.9l-29.6 88.8c-2.9 8.6-.6 18.1 5.8 24.6s15.9 8.7 24.6 5.8l88.8-29.6c8.2-2.7 15.7-7.4 21.9-13.5L437.7 172.3 339.7 74.3 172.4 241.7zM96 64C43 64 0 107 0 160V416c0 53 43 96 96 96H352c53 0 96-43 96-96V320c0-17.7-14.3-32-32-32s-32 14.3-32 32v96c0 17.7-14.3 32-32 32H96c-17.7 0-32-14.3-32-32V160c0-17.7 14.3-32 32-32h96c17.7 0 32-14.3 32-32s-14.3-32-32-32H96z"]
}, k$ = {
  prefix: "fas",
  iconName: "lightbulb-on",
  icon: [640, 512, [], "f672", "M69.3 4l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3S58.3-3.3 69.3 4zM597.3 44l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zM24 160H88c13.3 0 24 10.7 24 24s-10.7 24-24 24H24c-13.3 0-24-10.7-24-24s10.7-24 24-24zm528 0h64c13.3 0 24 10.7 24 24s-10.7 24-24 24H552c-13.3 0-24-10.7-24-24s10.7-24 24-24zM117.3 332l-48 32c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l48-32c11-7.4 25.9-4.4 33.3 6.7s4.4 25.9-6.7 33.3zm432-39.9l48 32c11 7.4 14 22.3 6.7 33.3s-22.3 14-33.3 6.7l-48-32c-11-7.4-14-22.3-6.7-33.3s22.3-14 33.3-6.7zm-100.1 5.7c-19.8 27.1-39.7 54.4-49.2 86.2H240c-9.6-31.9-29.5-59.1-49.2-86.2l0 0 0 0c-5.2-7.1-10.4-14.2-15.4-21.4C155.6 247.9 144 213.3 144 176C144 78.8 222.8 0 320 0s176 78.8 176 176c0 37.3-11.6 71.9-31.4 100.3c-5 7.2-10.2 14.3-15.4 21.4l0 0 0 0zM400 432c0 44.2-35.8 80-80 80s-80-35.8-80-80V416H400v16zM320 96c8.8 0 16-7.2 16-16s-7.2-16-16-16c-61.9 0-112 50.1-112 112c0 8.8 7.2 16 16 16s16-7.2 16-16c0-44.2 35.8-80 80-80z"]
}, T$ = {
  prefix: "fas",
  iconName: "draw-square",
  icon: [448, 512, [], "f5ef", "M96 151.4V360.6c9.7 5.6 17.8 13.7 23.4 23.4H328.6c5.6-9.7 13.7-17.8 23.4-23.4V151.4c-9.7-5.6-17.8-13.7-23.4-23.4H119.4c-5.6 9.7-13.7 17.8-23.4 23.4zM119.4 448c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V151.4C12.9 140.4 0 119.7 0 96C0 60.7 28.7 32 64 32c23.7 0 44.4 12.9 55.4 32H328.6c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 23.7-12.9 44.4-32 55.4V360.6c19.1 11.1 32 31.7 32 55.4c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4z"]
}, Ls = {
  prefix: "fas",
  iconName: "sparkles",
  icon: [512, 512, [10024], "f890", "M327.5 85.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 128l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 128l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 64 426.8 7.5C425.1 3 420.8 0 416 0s-9.1 3-10.8 7.5L384 64 327.5 85.2zM205.1 73.3c-2.6-5.7-8.3-9.3-14.5-9.3s-11.9 3.6-14.5 9.3L123.3 187.3 9.3 240C3.6 242.6 0 248.3 0 254.6s3.6 11.9 9.3 14.5l114.1 52.7L176 435.8c2.6 5.7 8.3 9.3 14.5 9.3s11.9-3.6 14.5-9.3l52.7-114.1 114.1-52.7c5.7-2.6 9.3-8.3 9.3-14.5s-3.6-11.9-9.3-14.5L257.8 187.4 205.1 73.3zM384 384l-56.5 21.2c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L384 448l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L448 448l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L448 384l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L384 384z"]
}, cS = {
  prefix: "fas",
  iconName: "arrow-left-to-line",
  icon: [448, 512, [8676, "arrow-to-left"], "f33e", "M0 96C0 78.3 14.3 64 32 64s32 14.3 32 32V416c0 17.7-14.3 32-32 32s-32-14.3-32-32V96zM137.4 278.6c-12.5-12.5-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L237.3 224 416 224c17.7 0 32 14.3 32 32s-14.3 32-32 32l-178.7 0 73.4 73.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0l-128-128z"]
}, A$ = {
  prefix: "fas",
  iconName: "wand-magic-sparkles",
  icon: [576, 512, ["magic-wand-sparkles"], "e2ca", "M234.7 42.7L197 56.8c-3 1.1-5 4-5 7.2s2 6.1 5 7.2l37.7 14.1L248.8 123c1.1 3 4 5 7.2 5s6.1-2 7.2-5l14.1-37.7L315 71.2c3-1.1 5-4 5-7.2s-2-6.1-5-7.2L277.3 42.7 263.2 5c-1.1-3-4-5-7.2-5s-6.1 2-7.2 5L234.7 42.7zM46.1 395.4c-18.7 18.7-18.7 49.1 0 67.9l34.6 34.6c18.7 18.7 49.1 18.7 67.9 0L529.9 116.5c18.7-18.7 18.7-49.1 0-67.9L495.3 14.1c-18.7-18.7-49.1-18.7-67.9 0L46.1 395.4zM484.6 82.6l-105 105-23.3-23.3 105-105 23.3 23.3zM7.5 117.2C3 118.9 0 123.2 0 128s3 9.1 7.5 10.8L64 160l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L128 160l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L128 96 106.8 39.5C105.1 35 100.8 32 96 32s-9.1 3-10.8 7.5L64 96 7.5 117.2zm352 256c-4.5 1.7-7.5 6-7.5 10.8s3 9.1 7.5 10.8L416 416l21.2 56.5c1.7 4.5 6 7.5 10.8 7.5s9.1-3 10.8-7.5L480 416l56.5-21.2c4.5-1.7 7.5-6 7.5-10.8s-3-9.1-7.5-10.8L480 352l-21.2-56.5c-1.7-4.5-6-7.5-10.8-7.5s-9.1 3-10.8 7.5L416 352l-56.5 21.2z"]
}, uS = {
  prefix: "fas",
  iconName: "user",
  icon: [448, 512, [128100, 62144], "f007", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H418.3c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304H178.3z"]
}, M$ = {
  prefix: "fas",
  iconName: "chart-line-up",
  icon: [512, 512, [], "e0e5", "M64 64c0-17.7-14.3-32-32-32S0 46.3 0 64V400c0 44.2 35.8 80 80 80H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H80c-8.8 0-16-7.2-16-16V64zM439 279c15.1 15.1 41 4.4 41-17V152c0-13.3-10.7-24-24-24H345.9c-21.4 0-32.1 25.9-17 41l32.4 32.4L304 258.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0l-80 80c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L208 253.3l73.4 73.4c12.5 12.5 32.8 12.5 45.3 0l80-80L439 279z"]
}, n1 = {
  prefix: "fas",
  iconName: "paper-plane-top",
  icon: [512, 512, ["paper-plane-alt", "send"], "e20a", "M49.9 27.8C15.1 12.7-19.2 50.1-1.2 83.5L68.1 212.2c4.4 8.3 12.6 13.8 21.9 15c0 0 0 0 0 0l176 22c3.4 .4 6 3.3 6 6.7s-2.6 6.3-6 6.7l-176 22s0 0 0 0c-9.3 1.2-17.5 6.8-21.9 15L-1.2 428.5c-18 33.4 16.3 70.8 51.1 55.7L491.8 292.7c32.1-13.9 32.1-59.5 0-73.4L49.9 27.8z"]
}, O$ = {
  prefix: "fas",
  iconName: "comment-smile",
  icon: [512, 512, [], "f4b4", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM192 144a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM150.5 270.1c9.9-8.8 25-8 33.9 1.9c17.6 19.7 43.1 32 71.6 32s53.9-12.3 71.6-32c8.8-9.9 24-10.7 33.9-1.9s10.7 24 1.9 33.9C337 333.4 298.6 352 256 352s-81-18.6-107.3-48c-8.8-9.9-8-25 1.9-33.9z"]
}, dS = {
  prefix: "fas",
  iconName: "books",
  icon: [512, 512, [128218], "f5db", "M0 32C0 14.3 14.3 0 32 0H96c17.7 0 32 14.3 32 32V96H0V32zm0 96H128V384H0V128zM0 416H128v64c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V416zM160 32c0-17.7 14.3-32 32-32h64c17.7 0 32 14.3 32 32V96H160V32zm0 96H288V384H160V128zm0 288H288v64c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V416zm203.6-19.9L320 232.6V142.8l100.4-26.9 66 247.4L363.6 396.1zM412.2 85L320 109.6V11l36.9-9.9c16.9-4.6 34.4 5.5 38.9 22.6L412.2 85zM371.8 427l122.8-32.9 16.3 61.1c4.5 17-5.5 34.5-22.5 39.1l-61.4 16.5c-16.9 4.6-34.4-5.5-38.9-22.6L371.8 427z"]
}, R$ = {
  prefix: "fas",
  iconName: "messages",
  icon: [640, 512, ["comments-alt"], "f4b6", "M64 0C28.7 0 0 28.7 0 64V256c0 35.3 28.7 64 64 64H96v48c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L202.7 320H352c35.3 0 64-28.7 64-64V64c0-35.3-28.7-64-64-64H64zM352 352H256v32c0 35.3 28.7 64 64 64H437.3l81.1 60.8c4.8 3.6 11.3 4.2 16.8 1.5s8.8-8.2 8.8-14.3V448h32c35.3 0 64-28.7 64-64V192c0-35.3-28.7-64-64-64H448V256c0 53-43 96-96 96z"]
}, q1e = {
  prefix: "fas",
  iconName: "user-pen",
  icon: [640, 512, ["user-edit"], "f4ff", "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512H322.8c-3.1-8.8-3.7-18.4-1.4-27.8l15-60.1c2.8-11.3 8.6-21.5 16.8-29.7l40.3-40.3c-32.1-31-75.7-50.1-123.9-50.1H178.3zm435.5-68.3c-15.6-15.6-40.9-15.6-56.6 0l-29.4 29.4 71 71 29.4-29.4c15.6-15.6 15.6-40.9 0-56.6l-14.4-14.4zM375.9 417c-4.1 4.1-7 9.2-8.4 14.9l-15 60.1c-1.4 5.5 .2 11.2 4.2 15.2s9.7 5.6 15.2 4.2l60.1-15c5.6-1.4 10.8-4.3 14.9-8.4L576.1 358.7l-71-71L375.9 417z"]
}, I$ = {
  prefix: "fas",
  iconName: "volume",
  icon: [576, 512, [128265, "volume-medium"], "f6a8", "M333.1 34.8C344.6 40 352 51.4 352 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L163.8 352H96c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L298.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3zm172 72.2c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C507.3 341.3 528 301.1 528 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C466.1 199.1 480 225.9 480 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C425.1 284.4 432 271 432 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5z"]
}, D$ = I$, N$ = {
  prefix: "fas",
  iconName: "arrow-up-right-and-arrow-down-left-from-center",
  icon: [512, 512, [], "e0a0", "M352 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h50.7L297.4 169.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V160c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H352zM214.6 297.4c-12.5-12.5-32.8-12.5-45.3 0L64 402.7V352c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32H160c17.7 0 32-14.3 32-32s-14.3-32-32-32H109.3L214.6 342.6c12.5-12.5 12.5-32.8 0-45.3z"]
}, $$ = {
  prefix: "fas",
  iconName: "circle-check",
  icon: [512, 512, [61533, "check-circle"], "f058", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
}, L$ = $$, F$ = {
  prefix: "fas",
  iconName: "user-tie",
  icon: [448, 512, [], "f508", "M96 128a128 128 0 1 0 256 0A128 128 0 1 0 96 128zm94.5 200.2l18.6 31L175.8 483.1l-36-146.9c-2-8.1-9.8-13.4-17.9-11.3C51.9 342.4 0 405.8 0 481.3c0 17 13.8 30.7 30.7 30.7H162.5c0 0 0 0 .1 0H168 280h5.5c0 0 0 0 .1 0H417.3c17 0 30.7-13.8 30.7-30.7c0-75.5-51.9-138.9-121.9-156.4c-8.1-2-15.9 3.3-17.9 11.3l-36 146.9L238.9 359.2l18.6-31c6.4-10.7-1.3-24.2-13.7-24.2H224 204.3c-12.4 0-20.1 13.6-13.7 24.2z"]
}, z$ = {
  prefix: "fas",
  iconName: "draw-circle",
  icon: [512, 512, [], "f5ed", "M472.1 196.7c-20.8-76-80.7-135.9-156.7-156.7C305.8 16.5 282.8 0 256 0s-49.8 16.5-59.3 39.9c-76 20.8-135.9 80.7-156.7 156.7C16.5 206.2 0 229.2 0 256s16.5 49.8 39.9 59.3c20.8 76 80.7 135.9 156.7 156.7c9.5 23.4 32.5 39.9 59.3 39.9s49.8-16.5 59.3-39.9c76-20.8 135.9-80.7 156.7-156.7c23.4-9.5 39.9-32.5 39.9-59.3s-16.5-49.8-39.9-59.3zM408 206c-14.7 11.7-24 29.8-24 50s9.4 38.3 24 50c-15.8 48.2-53.9 86.2-102 102c-11.7-14.7-29.8-24-50-24s-38.3 9.4-50 24c-48.2-15.8-86.2-53.9-102-102c14.7-11.7 24-29.8 24-50s-9.4-38.3-24-50c15.8-48.2 53.9-86.2 102-102c11.7 14.7 29.8 24 50 24s38.3-9.4 50-24c48.2 15.8 86.2 53.9 102 102z"]
}, V$ = {
  prefix: "fas",
  iconName: "arrows-rotate",
  icon: [512, 512, [128472, "refresh", "sync"], "f021", "M105.1 202.6c7.7-21.8 20.2-42.3 37.8-59.8c62.5-62.5 163.8-62.5 226.3 0L386.3 160H352c-17.7 0-32 14.3-32 32s14.3 32 32 32H463.5c0 0 0 0 0 0h.4c17.7 0 32-14.3 32-32V80c0-17.7-14.3-32-32-32s-32 14.3-32 32v35.2L414.4 97.6c-87.5-87.5-229.3-87.5-316.8 0C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5zM39 289.3c-5 1.5-9.8 4.2-13.7 8.2c-4 4-6.7 8.8-8.1 14c-.3 1.2-.6 2.5-.8 3.8c-.3 1.7-.4 3.4-.4 5.1V432c0 17.7 14.3 32 32 32s32-14.3 32-32V396.9l17.6 17.5 0 0c87.5 87.4 229.3 87.4 316.7 0c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.5 62.5-163.8 62.5-226.3 0l-.1-.1L125.6 352H160c17.7 0 32-14.3 32-32s-14.3-32-32-32H48.4c-1.6 0-3.2 .1-4.8 .3s-3.1 .5-4.6 1z"]
}, Y1e = {
  prefix: "fas",
  iconName: "comment-check",
  icon: [512, 512, [], "f4ac", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM369 193L241 321c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 159c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"]
}, B$ = {
  prefix: "fas",
  iconName: "broom-wide",
  icon: [512, 512, [], "e5d1", "M502.6 9.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128-15.8-15.8c-15.2-15.2-38.5-18.4-57.3-8l-32.5 18L380.4 288.1l18-32.5c10.4-18.7 7.1-42.1-8-57.3l-15.8-15.8 128-128c12.5-12.5 12.5-32.8 0-45.3zM187.5 151.8L16.4 246.9C6.3 252.5 0 263.2 0 274.8c0 8.5 3.4 16.6 9.3 22.6l43.2 43.2c2.1 2.1 5.3 2.9 8.2 1.9l52.1-17.4c6.3-2.1 12.2 3.9 10.1 10.1l-17.4 52.1c-1 2.9-.2 6 1.9 8.2L214.7 502.7c6 6 14.1 9.3 22.6 9.3c11.6 0 22.3-6.3 27.9-16.4l95.1-171.1L187.5 151.8z"]
}, K1e = {
  prefix: "fas",
  iconName: "question",
  icon: [320, 512, [10067, 10068, 61736], "3f", "M80 160c0-35.3 28.7-64 64-64h32c35.3 0 64 28.7 64 64v3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74V320c0 17.7 14.3 32 32 32s32-14.3 32-32v-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7V160c0-70.7-57.3-128-128-128H144C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z"]
}, j$ = {
  prefix: "fas",
  iconName: "arrow-up-right-from-square",
  icon: [512, 512, ["external-link"], "f08e", "M320 0c-17.7 0-32 14.3-32 32s14.3 32 32 32h82.7L201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L448 109.3V192c0 17.7 14.3 32 32 32s32-14.3 32-32V32c0-17.7-14.3-32-32-32H320zM80 32C35.8 32 0 67.8 0 112V432c0 44.2 35.8 80 80 80H400c44.2 0 80-35.8 80-80V320c0-17.7-14.3-32-32-32s-32 14.3-32 32V432c0 8.8-7.2 16-16 16H80c-8.8 0-16-7.2-16-16V112c0-8.8 7.2-16 16-16H192c17.7 0 32-14.3 32-32s-14.3-32-32-32H80z"]
}, W$ = {
  prefix: "fas",
  iconName: "arrow-right",
  icon: [448, 512, [8594], "f061", "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"]
}, U$ = {
  prefix: "fas",
  iconName: "circle",
  icon: [512, 512, [128308, 128309, 128992, 128993, 128994, 128995, 128996, 9679, 9898, 9899, 11044, 61708, 61915], "f111", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z"]
}, H$ = {
  prefix: "fas",
  iconName: "volume-high",
  icon: [640, 512, [128266, "volume-up"], "f028", "M533.6 32.5C598.5 85.2 640 165.8 640 256s-41.5 170.7-106.4 223.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C557.5 398.2 592 331.2 592 256s-34.5-142.2-88.7-186.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM473.1 107c43.2 35.2 70.9 88.9 70.9 149s-27.7 113.8-70.9 149c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C475.3 341.3 496 301.1 496 256s-20.7-85.3-53.2-111.8c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zm-60.5 74.5C434.1 199.1 448 225.9 448 256s-13.9 56.9-35.4 74.5c-10.3 8.4-25.4 6.8-33.8-3.5s-6.8-25.4 3.5-33.8C393.1 284.4 400 271 400 256s-6.9-28.4-17.7-37.3c-10.3-8.4-11.8-23.5-3.5-33.8s23.5-11.8 33.8-3.5zM301.1 34.8C312.6 40 320 51.4 320 64V448c0 12.6-7.4 24-18.9 29.2s-25 3.1-34.4-5.3L131.8 352H64c-35.3 0-64-28.7-64-64V224c0-35.3 28.7-64 64-64h67.8L266.7 40.1c9.4-8.4 22.9-10.4 34.4-5.3z"]
}, X1e = {
  prefix: "fas",
  iconName: "eye",
  icon: [576, 512, [128065], "f06e", "M288 32c-80.8 0-145.5 36.8-192.6 80.6C48.6 156 17.3 208 2.5 243.7c-3.3 7.9-3.3 16.7 0 24.6C17.3 304 48.6 356 95.4 399.4C142.5 443.2 207.2 480 288 480s145.5-36.8 192.6-80.6c46.8-43.5 78.1-95.4 93-131.1c3.3-7.9 3.3-16.7 0-24.6c-14.9-35.7-46.2-87.7-93-131.1C433.5 68.8 368.8 32 288 32zM144 256a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm144-64c0 35.3-28.7 64-64 64c-7.1 0-13.9-1.2-20.3-3.3c-5.5-1.8-11.9 1.6-11.7 7.4c.3 6.9 1.3 13.8 3.2 20.7c13.7 51.2 66.4 81.6 117.6 67.9s81.6-66.4 67.9-117.6c-11.1-41.5-47.8-69.4-88.6-71.1c-5.8-.2-9.2 6.1-7.4 11.7c2.1 6.4 3.3 13.2 3.3 20.3z"]
}, G$ = {
  prefix: "fas",
  iconName: "comment-dots",
  icon: [512, 512, [128172, 62075, "commenting"], "f4ad", "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3 0 0 0 0 0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"]
}, q$ = {
  prefix: "fas",
  iconName: "hand-pointer",
  icon: [448, 512, [], "f25a", "M128 40c0-22.1 17.9-40 40-40s40 17.9 40 40V188.2c8.5-7.6 19.7-12.2 32-12.2c20.6 0 38.2 13 45 31.2c8.8-9.3 21.2-15.2 35-15.2c25.3 0 46 19.5 47.9 44.3c8.5-7.7 19.8-12.3 32.1-12.3c26.5 0 48 21.5 48 48v48 16 48c0 70.7-57.3 128-128 128l-16 0H240l-.1 0h-5.2c-5 0-9.9-.3-14.7-1c-55.3-5.6-106.2-34-140-79L8 336c-13.3-17.7-9.7-42.7 8-56s42.7-9.7 56 8l56 74.7V40zM240 304c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304zm48-16c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16v96c0 8.8 7.2 16 16 16s16-7.2 16-16V304z"]
}, Z1e = {
  prefix: "fas",
  iconName: "spinner-third",
  icon: [512, 512, [], "f3f4", "M224 32c0-17.7 14.3-32 32-32C397.4 0 512 114.6 512 256c0 46.6-12.5 90.4-34.3 128c-8.8 15.3-28.4 20.5-43.7 11.7s-20.5-28.4-11.7-43.7c16.3-28.2 25.7-61 25.7-96c0-106-86-192-192-192c-17.7 0-32-14.3-32-32z"]
}, Y$ = {
  prefix: "fas",
  iconName: "arrow-left",
  icon: [448, 512, [8592], "f060", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z"]
}, Q1e = {
  prefix: "fas",
  iconName: "waveform-lines",
  icon: [640, 512, ["waveform-path"], "f8f2", "M352 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V480c0 17.7 14.3 32 32 32s32-14.3 32-32V32zM544 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96zM256 128c0-17.7-14.3-32-32-32s-32 14.3-32 32V384c0 17.7 14.3 32 32 32s32-14.3 32-32V128zm192 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V352c0 17.7 14.3 32 32 32s32-14.3 32-32V160zM160 224c0-17.7-14.3-32-32-32s-32 14.3-32 32v64c0 17.7 14.3 32 32 32s32-14.3 32-32V224zM0 256a32 32 0 1 0 64 0A32 32 0 1 0 0 256zm576 0a32 32 0 1 0 64 0 32 32 0 1 0 -64 0z"]
}, K$ = {
  prefix: "fas",
  iconName: "caret-down",
  icon: [320, 512, [], "f0d7", "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z"]
}, J1e = {
  prefix: "fas",
  iconName: "house",
  icon: [576, 512, [127968, 63498, 63500, "home", "home-alt", "home-lg-alt"], "f015", "M575.8 255.5c0 18-15 32.1-32 32.1h-32l.7 160.2c0 2.7-.2 5.4-.5 8.1V472c0 22.1-17.9 40-40 40H456c-1.1 0-2.2 0-3.3-.1c-1.4 .1-2.8 .1-4.2 .1H416 392c-22.1 0-40-17.9-40-40V448 384c0-17.7-14.3-32-32-32H256c-17.7 0-32 14.3-32 32v64 24c0 22.1-17.9 40-40 40H160 128.1c-1.5 0-3-.1-4.5-.2c-1.2 .1-2.4 .2-3.6 .2H104c-22.1 0-40-17.9-40-40V360c0-.9 0-1.9 .1-2.8V287.6H32c-18 0-32-14-32-32.1c0-9 3-17 10-24L266.4 8c7-7 15-8 22-8s15 2 21 7L564.8 231.5c8 7 12 15 11 24z"]
}, fS = {
  prefix: "fas",
  iconName: "stop",
  icon: [384, 512, [9209], "f04d", "M0 128C0 92.7 28.7 64 64 64H320c35.3 0 64 28.7 64 64V384c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V128z"]
}, eye = {
  prefix: "fas",
  iconName: "hand-wave",
  icon: [512, 512, [], "e1a7", "M352.2 82.3L351 73.8c-3-21.1-19.6-37.7-40.7-40.7l-8.5-1.2c-8.7-1.2-14.8-9.4-13.6-18.1S297.5-1.1 306.3 .2l8.5 1.2c35.2 5 62.9 32.7 67.9 67.9l1.2 8.5c1.2 8.7-4.8 16.9-13.6 18.1s-16.9-4.8-18.1-13.6zM185.4 70.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192c3.3 3.3 9.4 1.1 9.4-3.7l0-77.7c0-22.1 17.9-40 40-40s40 17.9 40 40V312.3c0 60.2-27.9 116.9-75.5 153.7C385.7 505.3 321 515.7 263 498.7c-28.4-7.1-55.3-21.8-77.6-44.1l-4.9-4.9L73.4 342.6l-32-32c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l31.9 31.9 .1 .1L165.3 344c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L57.4 198.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L229.3 280c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L105.4 118.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L293.3 216c5.2 5.2 13.6 5.2 18.7 0s5.2-13.6 0-18.7L185.4 70.6zM13.7 352.2c8.7-1.3 16.9 4.8 18.1 13.6l1.2 8.5c3 21.1 19.6 37.7 40.7 40.7l8.5 1.2c8.7 1.2 14.8 9.4 13.6 18.1s-9.4 14.8-18.1 13.6l-8.5-1.2c-35.2-5-62.9-32.7-67.9-67.9L.2 370.3c-1.2-8.7 4.8-16.9 13.6-18.1z"]
}, tye = {
  prefix: "fas",
  iconName: "message-slash",
  icon: [640, 512, ["comment-alt-slash"], "f4a9", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-82.3-64.5C565.1 393 576 373.8 576 352V64c0-35.3-28.7-64-64-64H128C104.4 0 83.8 12.7 72.7 31.7L38.8 5.1zM406.2 416L64 146.4V352c0 35.3 28.7 64 64 64h96v80c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L373.3 416h32.8z"]
}, X$ = {
  prefix: "fas",
  iconName: "bolt",
  icon: [448, 512, [9889, "zap"], "f0e7", "M349.4 44.6c5.9-13.7 1.5-29.7-10.6-38.5s-28.6-8-39.9 1.8l-256 224c-10 8.8-13.6 22.9-8.9 35.3S50.7 288 64 288H175.5L98.6 467.4c-5.9 13.7-1.5 29.7 10.6 38.5s28.6 8 39.9-1.8l256-224c10-8.8 13.6-22.9 8.9-35.3s-16.6-20.7-30-20.7H272.5L349.4 44.6z"]
}, Z$ = {
  prefix: "fas",
  iconName: "thumbs-down",
  icon: [512, 512, [128078, 61576], "f165", "M313.4 479.1c26-5.2 42.9-30.5 37.7-56.5l-2.3-11.4c-5.3-26.7-15.1-52.1-28.8-75.2H464c26.5 0 48-21.5 48-48c0-18.5-10.5-34.6-25.9-42.6C497 236.6 504 223.1 504 208c0-23.4-16.8-42.9-38.9-47.1c4.4-7.3 6.9-15.8 6.9-24.9c0-21.3-13.9-39.4-33.1-45.6c.7-3.3 1.1-6.8 1.1-10.4c0-26.5-21.5-48-48-48H294.5c-19 0-37.5 5.6-53.3 16.1L202.7 73.8C176 91.6 160 121.6 160 153.7V192v48 24.9c0 29.2 13.3 56.7 36 75l7.4 5.9c26.5 21.2 44.6 51 51.2 84.2l2.3 11.4c5.2 26 30.5 42.9 56.5 37.7zM32 384H96c17.7 0 32-14.3 32-32V128c0-17.7-14.3-32-32-32H32C14.3 96 0 110.3 0 128V352c0 17.7 14.3 32 32 32z"]
}, Q$ = {
  prefix: "fas",
  iconName: "ellipsis",
  icon: [448, 512, ["ellipsis-h"], "f141", "M8 256a56 56 0 1 1 112 0A56 56 0 1 1 8 256zm160 0a56 56 0 1 1 112 0 56 56 0 1 1 -112 0zm216-56a56 56 0 1 1 0 112 56 56 0 1 1 0-112z"]
}, J$ = Q$, hS = {
  prefix: "fas",
  iconName: "xmark-large",
  icon: [448, 512, [], "e59b", "M393.4 41.4c12.5-12.5 32.8-12.5 45.3 0s12.5 32.8 0 45.3L269.3 256 438.6 425.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L224 301.3 54.6 470.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L178.7 256 9.4 86.6C-3.1 74.1-3.1 53.9 9.4 41.4s32.8-12.5 45.3 0L224 210.7 393.4 41.4z"]
}, nye = {
  prefix: "fas",
  iconName: "location-dot",
  icon: [384, 512, ["map-marker-alt"], "f3c5", "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z"]
}, rye = {
  prefix: "fas",
  iconName: "droplet",
  icon: [384, 512, [128167, "tint"], "f043", "M192 512C86 512 0 426 0 320C0 228.8 130.2 57.7 166.6 11.7C172.6 4.2 181.5 0 191.1 0h1.8c9.6 0 18.5 4.2 24.5 11.7C253.8 57.7 384 228.8 384 320c0 106-86 192-192 192zM96 336c0-8.8-7.2-16-16-16s-16 7.2-16 16c0 61.9 50.1 112 112 112c8.8 0 16-7.2 16-16s-7.2-16-16-16c-44.2 0-80-35.8-80-80z"]
}, eL = {
  prefix: "fas",
  iconName: "link",
  icon: [640, 512, [128279, "chain"], "f0c1", "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"]
}, pS = {
  prefix: "fas",
  iconName: "play",
  icon: [384, 512, [9654], "f04b", "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80V432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z"]
}, tL = {
  prefix: "fas",
  iconName: "magnifying-glass",
  icon: [512, 512, [128269, "search"], "f002", "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"]
}, r1 = {
  prefix: "fas",
  iconName: "chevron-down",
  icon: [512, 512, [], "f078", "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"]
}, iye = {
  prefix: "fas",
  iconName: "list-check",
  icon: [512, 512, ["tasks"], "f0ae", "M152.1 38.2c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 113C-2.3 103.6-2.3 88.4 7 79s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zm0 160c9.9 8.9 10.7 24 1.8 33.9l-72 80c-4.4 4.9-10.6 7.8-17.2 7.9s-12.9-2.4-17.6-7L7 273c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l22.1 22.1 55.1-61.2c8.9-9.9 24-10.7 33.9-1.8zM224 96c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zm0 160c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H256c-17.7 0-32-14.3-32-32zM160 416c0-17.7 14.3-32 32-32H480c17.7 0 32 14.3 32 32s-14.3 32-32 32H192c-17.7 0-32-14.3-32-32zM48 368a48 48 0 1 1 0 96 48 48 0 1 1 0-96z"]
}, Qf = {
  prefix: "fas",
  iconName: "xmark",
  icon: [384, 512, [128473, 10005, 10006, 10060, 215, "close", "multiply", "remove", "times"], "f00d", "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"]
}, i1 = Qf, nL = Qf, oye = {
  prefix: "fas",
  iconName: "chevron-left",
  icon: [320, 512, [9001], "f053", "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l192 192c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L77.3 256 246.6 86.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-192 192z"]
}, aye = {
  prefix: "fas",
  iconName: "chevron-right",
  icon: [320, 512, [9002], "f054", "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"]
}, rL = {
  prefix: "fas",
  iconName: "rotate",
  icon: [512, 512, [128260, "sync-alt"], "f2f1", "M142.9 142.9c62.2-62.2 162.7-62.5 225.3-1L327 183c-6.9 6.9-8.9 17.2-5.2 26.2s12.5 14.8 22.2 14.8H463.5c0 0 0 0 0 0H472c13.3 0 24-10.7 24-24V72c0-9.7-5.8-18.5-14.8-22.2s-19.3-1.7-26.2 5.2L413.4 96.6c-87.6-86.5-228.7-86.2-315.8 1C73.2 122 55.6 150.7 44.8 181.4c-5.9 16.7 2.9 34.9 19.5 40.8s34.9-2.9 40.8-19.5c7.7-21.8 20.2-42.3 37.8-59.8zM16 312v7.6 .7V440c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2l41.6-41.6c87.6 86.5 228.7 86.2 315.8-1c24.4-24.4 42.1-53.1 52.9-83.7c5.9-16.7-2.9-34.9-19.5-40.8s-34.9 2.9-40.8 19.5c-7.7 21.8-20.2 42.3-37.8 59.8c-62.2 62.2-162.7 62.5-225.3 1L185 329c6.9-6.9 8.9-17.2 5.2-26.2s-12.5-14.8-22.2-14.8H48.4h-.7H40c-13.3 0-24 10.7-24 24z"]
}, iL = rL, mS = {
  prefix: "fas",
  iconName: "arrow-right-to-line",
  icon: [448, 512, [8677, "arrow-to-right"], "f340", "M448 96c0-17.7-14.3-32-32-32s-32 14.3-32 32V416c0 17.7 14.3 32 32 32s32-14.3 32-32V96zM310.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-128-128c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L210.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l178.7 0-73.4 73.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l128-128z"]
}, oL = {
  prefix: "fas",
  iconName: "volume-slash",
  icon: [640, 512, [128263], "f2e2", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7L525.1 386.2C556.7 352 576 306.3 576 256c0-60.1-27.7-113.8-70.9-149c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C507.3 170.7 528 210.9 528 256c0 39.1-15.6 74.5-40.9 100.5L449 326.6c19-17.5 31-42.7 31-70.6c0-30.1-13.9-56.9-35.4-74.5c-10.3-8.4-25.4-6.8-33.8 3.5s-6.8 25.4 3.5 33.8C425.1 227.6 432 241 432 256s-6.9 28.4-17.7 37.3c-1.3 1-2.4 2.2-3.4 3.4L352 250.6V64c0-12.6-7.4-24-18.9-29.2s-25-3.1-34.4 5.3L197.8 129.8 38.8 5.1zM352 373.3L82.9 161.3C53.8 167.4 32 193.1 32 224v64c0 35.3 28.7 64 64 64h67.8L298.7 471.9c9.4 8.4 22.9 10.4 34.4 5.3S352 460.6 352 448V373.3z"]
}, aL = {
  prefix: "fas",
  iconName: "draw-polygon",
  icon: [448, 512, [], "f5ee", "M96 151.4V360.6c9.7 5.6 17.8 13.7 23.4 23.4H328.6c0-.1 .1-.2 .1-.3l-4.5-7.9-32-56 0 0c-1.4 .1-2.8 .1-4.2 .1c-35.3 0-64-28.7-64-64s28.7-64 64-64c1.4 0 2.8 0 4.2 .1l0 0 32-56 4.5-7.9-.1-.3H119.4c-5.6 9.7-13.7 17.8-23.4 23.4zM384.3 352c35.2 .2 63.7 28.7 63.7 64c0 35.3-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H119.4c-11.1 19.1-31.7 32-55.4 32c-35.3 0-64-28.7-64-64c0-23.7 12.9-44.4 32-55.4V151.4C12.9 140.4 0 119.7 0 96C0 60.7 28.7 32 64 32c23.7 0 44.4 12.9 55.4 32H328.6c11.1-19.1 31.7-32 55.4-32c35.3 0 64 28.7 64 64c0 35.3-28.5 63.8-63.7 64l-4.5 7.9-32 56-2.3 4c4.2 8.5 6.5 18 6.5 28.1s-2.3 19.6-6.5 28.1l2.3 4 32 56 4.5 7.9z"]
}, gS = {
  prefix: "fas",
  iconName: "check",
  icon: [448, 512, [10003, 10004], "f00c", "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z"]
}, sL = {
  prefix: "fas",
  iconName: "triangle-exclamation",
  icon: [512, 512, [9888, "exclamation-triangle", "warning"], "f071", "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480H40c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24V296c0 13.3 10.7 24 24 24s24-10.7 24-24V184c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"]
}, to = sL, lL = {
  prefix: "fas",
  iconName: "circle-xmark",
  icon: [512, 512, [61532, "times-circle", "xmark-circle"], "f057", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"]
}, cL = lL, uL = {
  prefix: "fas",
  iconName: "thumbs-up",
  icon: [512, 512, [128077, 61575], "f164", "M313.4 32.9c26 5.2 42.9 30.5 37.7 56.5l-2.3 11.4c-5.3 26.7-15.1 52.1-28.8 75.2H464c26.5 0 48 21.5 48 48c0 18.5-10.5 34.6-25.9 42.6C497 275.4 504 288.9 504 304c0 23.4-16.8 42.9-38.9 47.1c4.4 7.3 6.9 15.8 6.9 24.9c0 21.3-13.9 39.4-33.1 45.6c.7 3.3 1.1 6.8 1.1 10.4c0 26.5-21.5 48-48 48H294.5c-19 0-37.5-5.6-53.3-16.1l-38.5-25.7C176 420.4 160 390.4 160 358.3V320 272 247.1c0-29.2 13.3-56.7 36-75l7.4-5.9c26.5-21.2 44.6-51 51.2-84.2l2.3-11.4c5.2-26 30.5-42.9 56.5-37.7zM32 192H96c17.7 0 32 14.3 32 32V448c0 17.7-14.3 32-32 32H32c-17.7 0-32-14.3-32-32V224c0-17.7 14.3-32 32-32z"]
}, dL = {
  prefix: "fas",
  iconName: "window-minimize",
  icon: [512, 512, [128469], "f2d1", "M32 416c-17.7 0-32 14.3-32 32s14.3 32 32 32H480c17.7 0 32-14.3 32-32s-14.3-32-32-32H32z"]
}, fL = {
  prefix: "fas",
  iconName: "square-full",
  icon: [512, 512, [128997, 128998, 128999, 129e3, 129001, 129002, 129003, 11035, 11036], "f45c", "M0 0H512V512H0V0z"]
}, hL = {
  prefix: "fas",
  iconName: "face-smile-relaxed",
  icon: [512, 512, [], "e392", "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM164.1 325.5C182 346.2 212.6 368 256 368s74-21.8 91.9-42.5c5.8-6.7 15.9-7.4 22.6-1.6s7.4 15.9 1.6 22.6C349.8 372.1 311.1 400 256 400s-93.8-27.9-116.1-53.5c-5.8-6.7-5.1-16.8 1.6-22.6s16.8-5.1 22.6 1.6zm47.1-91.9c-17.6-23.5-52.8-23.5-70.4 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2zm89.6 0c-5.3 7.1-15.3 8.5-22.4 3.2s-8.5-15.3-3.2-22.4c30.4-40.5 91.2-40.5 121.6 0c5.3 7.1 3.9 17.1-3.2 22.4s-17.1 3.9-22.4-3.2c-17.6-23.5-52.8-23.5-70.4 0z"]
};
function ge() {
  return ge = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, ge.apply(null, arguments);
}
function $e(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function pL(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function Jf(...e) {
  return (t) => e.forEach(
    (n) => pL(n, t)
  );
}
function Ft(...e) {
  return De(Jf(...e), e);
}
function rr(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = /* @__PURE__ */ wn(a), l = n.length;
    n = [
      ...n,
      a
    ];
    function u(f) {
      const { scope: p, children: m, ...g } = f, v = (p == null ? void 0 : p[e][l]) || s, y = Lt(
        () => g,
        Object.values(g)
      );
      return /* @__PURE__ */ X(v.Provider, {
        value: y
      }, m);
    }
    function d(f, p) {
      const m = (p == null ? void 0 : p[e][l]) || s, g = Me(m);
      if (g)
        return g;
      if (a !== void 0)
        return a;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return u.displayName = o + "Provider", [
      u,
      d
    ];
  }
  const i = () => {
    const o = n.map((a) => /* @__PURE__ */ wn(a));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || o;
      return Lt(
        () => ({
          [`__scope${e}`]: {
            ...s,
            [e]: l
          }
        }),
        [
          s,
          l
        ]
      );
    };
  };
  return i.scopeName = e, [
    r,
    mL(i, ...t)
  ];
}
function mL(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map(
      (i) => ({
        useScope: i(),
        scopeName: i.scopeName
      })
    );
    return function(o) {
      const a = r.reduce((s, { useScope: l, scopeName: u }) => {
        const f = l(o)[`__scope${u}`];
        return {
          ...s,
          ...f
        };
      }, {});
      return Lt(
        () => ({
          [`__scope${t.scopeName}`]: a
        }),
        [
          a
        ]
      );
    };
  };
  return n.scopeName = t.scopeName, n;
}
const qi = /* @__PURE__ */ ke((e, t) => {
  const { children: n, ...r } = e, i = Ui.toArray(n), o = i.find(gL);
  if (o) {
    const a = o.props.children, s = i.map((l) => l === o ? Ui.count(a) > 1 ? Ui.only(null) : /* @__PURE__ */ Ps(a) ? a.props.children : null : l);
    return /* @__PURE__ */ X(Jg, ge({}, r, {
      ref: t
    }), /* @__PURE__ */ Ps(a) ? /* @__PURE__ */ qf(a, void 0, s) : null);
  }
  return /* @__PURE__ */ X(Jg, ge({}, r, {
    ref: t
  }), n);
});
qi.displayName = "Slot";
const Jg = /* @__PURE__ */ ke((e, t) => {
  const { children: n, ...r } = e;
  return /* @__PURE__ */ Ps(n) ? /* @__PURE__ */ qf(n, {
    ...vL(r, n.props),
    ref: t ? Jf(t, n.ref) : n.ref
  }) : Ui.count(n) > 1 ? Ui.only(null) : null;
});
Jg.displayName = "SlotClone";
const vS = ({ children: e }) => /* @__PURE__ */ X(t1, null, e);
function gL(e) {
  return /* @__PURE__ */ Ps(e) && e.type === vS;
}
function vL(e, t) {
  const n = {
    ...t
  };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...s) => {
      o(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = {
      ...i,
      ...o
    } : r === "className" && (n[r] = [
      i,
      o
    ].filter(Boolean).join(" "));
  }
  return {
    ...e,
    ...n
  };
}
const yL = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], rt = yL.reduce((e, t) => {
  const n = /* @__PURE__ */ ke((r, i) => {
    const { asChild: o, ...a } = r, s = o ? qi : t;
    return be(() => {
      window[Symbol.for("radix-ui")] = !0;
    }, []), /* @__PURE__ */ X(s, ge({}, a, {
      ref: i
    }));
  });
  return n.displayName = `Primitive.${t}`, {
    ...e,
    [t]: n
  };
}, {});
function yS(e, t) {
  e && Zf(
    () => e.dispatchEvent(t)
  );
}
function Ei(e) {
  const t = me(e);
  return be(() => {
    t.current = e;
  }), Lt(
    () => (...n) => {
      var r;
      return (r = t.current) === null || r === void 0 ? void 0 : r.call(t, ...n);
    },
    []
  );
}
function wL(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ei(e);
  be(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return t.addEventListener("keydown", r), () => t.removeEventListener("keydown", r);
  }, [
    n,
    t
  ]);
}
const ev = "dismissableLayer.update", bL = "dismissableLayer.pointerDownOutside", xL = "dismissableLayer.focusOutside";
let cx;
const EL = /* @__PURE__ */ wn({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), eh = /* @__PURE__ */ ke((e, t) => {
  var n;
  const { disableOutsidePointerEvents: r = !1, onEscapeKeyDown: i, onPointerDownOutside: o, onFocusOutside: a, onInteractOutside: s, onDismiss: l, ...u } = e, d = Me(EL), [f, p] = de(null), m = (n = f == null ? void 0 : f.ownerDocument) !== null && n !== void 0 ? n : globalThis == null ? void 0 : globalThis.document, [, g] = de({}), v = Ft(
    t,
    (R) => p(R)
  ), y = Array.from(d.layers), [b] = [
    ...d.layersWithOutsidePointerEventsDisabled
  ].slice(-1), E = y.indexOf(b), S = f ? y.indexOf(f) : -1, _ = d.layersWithOutsidePointerEventsDisabled.size > 0, k = S >= E, T = CL((R) => {
    const F = R.target, D = [
      ...d.branches
    ].some(
      (W) => W.contains(F)
    );
    !k || D || (o == null || o(R), s == null || s(R), R.defaultPrevented || l == null || l());
  }, m), A = SL((R) => {
    const F = R.target;
    [
      ...d.branches
    ].some(
      (W) => W.contains(F)
    ) || (a == null || a(R), s == null || s(R), R.defaultPrevented || l == null || l());
  }, m);
  return wL((R) => {
    S === d.layers.size - 1 && (i == null || i(R), !R.defaultPrevented && l && (R.preventDefault(), l()));
  }, m), be(() => {
    if (f)
      return r && (d.layersWithOutsidePointerEventsDisabled.size === 0 && (cx = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), d.layersWithOutsidePointerEventsDisabled.add(f)), d.layers.add(f), ux(), () => {
        r && d.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = cx);
      };
  }, [
    f,
    m,
    r,
    d
  ]), be(() => () => {
    f && (d.layers.delete(f), d.layersWithOutsidePointerEventsDisabled.delete(f), ux());
  }, [
    f,
    d
  ]), be(() => {
    const R = () => g({});
    return document.addEventListener(ev, R), () => document.removeEventListener(ev, R);
  }, []), /* @__PURE__ */ X(rt.div, ge({}, u, {
    ref: v,
    style: {
      pointerEvents: _ ? k ? "auto" : "none" : void 0,
      ...e.style
    },
    onFocusCapture: $e(e.onFocusCapture, A.onFocusCapture),
    onBlurCapture: $e(e.onBlurCapture, A.onBlurCapture),
    onPointerDownCapture: $e(e.onPointerDownCapture, T.onPointerDownCapture)
  }));
});
function CL(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ei(e), r = me(!1), i = me(() => {
  });
  return be(() => {
    const o = (s) => {
      if (s.target && !r.current) {
        let u = function() {
          wS(bL, n, l, {
            discrete: !0
          });
        };
        const l = {
          originalEvent: s
        };
        s.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = u, t.addEventListener("click", i.current, {
          once: !0
        })) : u();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", o), t.removeEventListener("click", i.current);
    };
  }, [
    t,
    n
  ]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function SL(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = Ei(e), r = me(!1);
  return be(() => {
    const i = (o) => {
      o.target && !r.current && wS(xL, n, {
        originalEvent: o
      }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [
    t,
    n
  ]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function ux() {
  const e = new CustomEvent(ev);
  document.dispatchEvent(e);
}
function wS(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(e, {
    bubbles: !1,
    cancelable: !0,
    detail: n
  });
  t && i.addEventListener(e, t, {
    once: !0
  }), r ? yS(i, o) : i.dispatchEvent(o);
}
let km = 0;
function o1() {
  be(() => {
    var e, t;
    const n = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", (e = n[0]) !== null && e !== void 0 ? e : dx()), document.body.insertAdjacentElement("beforeend", (t = n[1]) !== null && t !== void 0 ? t : dx()), km++, () => {
      km === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach(
        (r) => r.remove()
      ), km--;
    };
  }, []);
}
function dx() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.cssText = "outline: none; opacity: 0; position: fixed; pointer-events: none", e;
}
const Tm = "focusScope.autoFocusOnMount", Am = "focusScope.autoFocusOnUnmount", fx = {
  bubbles: !1,
  cancelable: !0
}, a1 = /* @__PURE__ */ ke((e, t) => {
  const { loop: n = !1, trapped: r = !1, onMountAutoFocus: i, onUnmountAutoFocus: o, ...a } = e, [s, l] = de(null), u = Ei(i), d = Ei(o), f = me(null), p = Ft(
    t,
    (v) => l(v)
  ), m = me({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  be(() => {
    if (r) {
      let v = function(S) {
        if (m.paused || !s)
          return;
        const _ = S.target;
        s.contains(_) ? f.current = _ : bo(f.current, {
          select: !0
        });
      }, y = function(S) {
        if (m.paused || !s)
          return;
        const _ = S.relatedTarget;
        _ !== null && (s.contains(_) || bo(f.current, {
          select: !0
        }));
      }, b = function(S) {
        if (document.activeElement === document.body)
          for (const k of S)
            k.removedNodes.length > 0 && bo(s);
      };
      document.addEventListener("focusin", v), document.addEventListener("focusout", y);
      const E = new MutationObserver(b);
      return s && E.observe(s, {
        childList: !0,
        subtree: !0
      }), () => {
        document.removeEventListener("focusin", v), document.removeEventListener("focusout", y), E.disconnect();
      };
    }
  }, [
    r,
    s,
    m.paused
  ]), be(() => {
    if (s) {
      px.add(m);
      const v = document.activeElement;
      if (!s.contains(v)) {
        const b = new CustomEvent(Tm, fx);
        s.addEventListener(Tm, u), s.dispatchEvent(b), b.defaultPrevented || (_L(ML(bS(s)), {
          select: !0
        }), document.activeElement === v && bo(s));
      }
      return () => {
        s.removeEventListener(Tm, u), setTimeout(() => {
          const b = new CustomEvent(Am, fx);
          s.addEventListener(Am, d), s.dispatchEvent(b), b.defaultPrevented || bo(v ?? document.body, {
            select: !0
          }), s.removeEventListener(Am, d), px.remove(m);
        }, 0);
      };
    }
  }, [
    s,
    u,
    d,
    m
  ]);
  const g = De((v) => {
    if (!n && !r || m.paused)
      return;
    const y = v.key === "Tab" && !v.altKey && !v.ctrlKey && !v.metaKey, b = document.activeElement;
    if (y && b) {
      const E = v.currentTarget, [S, _] = PL(E);
      S && _ ? !v.shiftKey && b === _ ? (v.preventDefault(), n && bo(S, {
        select: !0
      })) : v.shiftKey && b === S && (v.preventDefault(), n && bo(_, {
        select: !0
      })) : b === E && v.preventDefault();
    }
  }, [
    n,
    r,
    m.paused
  ]);
  return /* @__PURE__ */ X(rt.div, ge({
    tabIndex: -1
  }, a, {
    ref: p,
    onKeyDown: g
  }));
});
function _L(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (bo(r, {
      select: t
    }), document.activeElement !== n)
      return;
}
function PL(e) {
  const t = bS(e), n = hx(t, e), r = hx(t.reverse(), e);
  return [
    n,
    r
  ];
}
function bS(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function hx(e, t) {
  for (const n of e)
    if (!kL(n, {
      upTo: t
    }))
      return n;
}
function kL(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function TL(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function bo(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({
      preventScroll: !0
    }), e !== n && TL(e) && t && e.select();
  }
}
const px = AL();
function AL() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = mx(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = mx(e, t), (n = e[0]) === null || n === void 0 || n.resume();
    }
  };
}
function mx(e, t) {
  const n = [
    ...e
  ], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function ML(e) {
  return e.filter(
    (t) => t.tagName !== "A"
  );
}
const ma = globalThis != null && globalThis.document ? eo : () => {
}, OL = C["useId".toString()] || (() => {
});
let RL = 0;
function ti(e) {
  const [t, n] = C.useState(OL());
  return ma(() => {
    e || n(
      (r) => r ?? String(RL++)
    );
  }, [
    e
  ]), e || (t ? `radix-${t}` : "");
}
const IL = ["top", "right", "bottom", "left"], Mo = Math.min, hr = Math.max, Qd = Math.round, Vu = Math.floor, yi = (e) => ({
  x: e,
  y: e
}), DL = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, NL = {
  start: "end",
  end: "start"
};
function tv(e, t, n) {
  return hr(e, Mo(t, n));
}
function Yi(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ki(e) {
  return e.split("-")[0];
}
function Fs(e) {
  return e.split("-")[1];
}
function s1(e) {
  return e === "x" ? "y" : "x";
}
function l1(e) {
  return e === "y" ? "height" : "width";
}
function Oo(e) {
  return ["top", "bottom"].includes(Ki(e)) ? "y" : "x";
}
function c1(e) {
  return s1(Oo(e));
}
function $L(e, t, n) {
  n === void 0 && (n = !1);
  const r = Fs(e), i = c1(e), o = l1(i);
  let a = i === "x" ? r === (n ? "end" : "start") ? "right" : "left" : r === "start" ? "bottom" : "top";
  return t.reference[o] > t.floating[o] && (a = Jd(a)), [a, Jd(a)];
}
function LL(e) {
  const t = Jd(e);
  return [nv(e), t, nv(t)];
}
function nv(e) {
  return e.replace(/start|end/g, (t) => NL[t]);
}
function FL(e, t, n) {
  const r = ["left", "right"], i = ["right", "left"], o = ["top", "bottom"], a = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return n ? t ? i : r : t ? r : i;
    case "left":
    case "right":
      return t ? o : a;
    default:
      return [];
  }
}
function zL(e, t, n, r) {
  const i = Fs(e);
  let o = FL(Ki(e), n === "start", r);
  return i && (o = o.map((a) => a + "-" + i), t && (o = o.concat(o.map(nv)))), o;
}
function Jd(e) {
  return e.replace(/left|right|bottom|top/g, (t) => DL[t]);
}
function VL(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function xS(e) {
  return typeof e != "number" ? VL(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function ef(e) {
  const {
    x: t,
    y: n,
    width: r,
    height: i
  } = e;
  return {
    width: r,
    height: i,
    top: n,
    left: t,
    right: t + r,
    bottom: n + i,
    x: t,
    y: n
  };
}
function gx(e, t, n) {
  let {
    reference: r,
    floating: i
  } = e;
  const o = Oo(t), a = c1(t), s = l1(a), l = Ki(t), u = o === "y", d = r.x + r.width / 2 - i.width / 2, f = r.y + r.height / 2 - i.height / 2, p = r[s] / 2 - i[s] / 2;
  let m;
  switch (l) {
    case "top":
      m = {
        x: d,
        y: r.y - i.height
      };
      break;
    case "bottom":
      m = {
        x: d,
        y: r.y + r.height
      };
      break;
    case "right":
      m = {
        x: r.x + r.width,
        y: f
      };
      break;
    case "left":
      m = {
        x: r.x - i.width,
        y: f
      };
      break;
    default:
      m = {
        x: r.x,
        y: r.y
      };
  }
  switch (Fs(t)) {
    case "start":
      m[a] -= p * (n && u ? -1 : 1);
      break;
    case "end":
      m[a] += p * (n && u ? -1 : 1);
      break;
  }
  return m;
}
const BL = async (e, t, n) => {
  const {
    placement: r = "bottom",
    strategy: i = "absolute",
    middleware: o = [],
    platform: a
  } = n, s = o.filter(Boolean), l = await (a.isRTL == null ? void 0 : a.isRTL(t));
  let u = await a.getElementRects({
    reference: e,
    floating: t,
    strategy: i
  }), {
    x: d,
    y: f
  } = gx(u, r, l), p = r, m = {}, g = 0;
  for (let v = 0; v < s.length; v++) {
    const {
      name: y,
      fn: b
    } = s[v], {
      x: E,
      y: S,
      data: _,
      reset: k
    } = await b({
      x: d,
      y: f,
      initialPlacement: r,
      placement: p,
      strategy: i,
      middlewareData: m,
      rects: u,
      platform: a,
      elements: {
        reference: e,
        floating: t
      }
    });
    d = E ?? d, f = S ?? f, m = {
      ...m,
      [y]: {
        ...m[y],
        ..._
      }
    }, k && g <= 50 && (g++, typeof k == "object" && (k.placement && (p = k.placement), k.rects && (u = k.rects === !0 ? await a.getElementRects({
      reference: e,
      floating: t,
      strategy: i
    }) : k.rects), {
      x: d,
      y: f
    } = gx(u, p, l)), v = -1);
  }
  return {
    x: d,
    y: f,
    placement: p,
    strategy: i,
    middlewareData: m
  };
};
async function tc(e, t) {
  var n;
  t === void 0 && (t = {});
  const {
    x: r,
    y: i,
    platform: o,
    rects: a,
    elements: s,
    strategy: l
  } = e, {
    boundary: u = "clippingAncestors",
    rootBoundary: d = "viewport",
    elementContext: f = "floating",
    altBoundary: p = !1,
    padding: m = 0
  } = Yi(t, e), g = xS(m), y = s[p ? f === "floating" ? "reference" : "floating" : f], b = ef(await o.getClippingRect({
    element: (n = await (o.isElement == null ? void 0 : o.isElement(y))) == null || n ? y : y.contextElement || await (o.getDocumentElement == null ? void 0 : o.getDocumentElement(s.floating)),
    boundary: u,
    rootBoundary: d,
    strategy: l
  })), E = f === "floating" ? {
    x: r,
    y: i,
    width: a.floating.width,
    height: a.floating.height
  } : a.reference, S = await (o.getOffsetParent == null ? void 0 : o.getOffsetParent(s.floating)), _ = await (o.isElement == null ? void 0 : o.isElement(S)) ? await (o.getScale == null ? void 0 : o.getScale(S)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, k = ef(o.convertOffsetParentRelativeRectToViewportRelativeRect ? await o.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: E,
    offsetParent: S,
    strategy: l
  }) : E);
  return {
    top: (b.top - k.top + g.top) / _.y,
    bottom: (k.bottom - b.bottom + g.bottom) / _.y,
    left: (b.left - k.left + g.left) / _.x,
    right: (k.right - b.right + g.right) / _.x
  };
}
const jL = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: n,
      y: r,
      placement: i,
      rects: o,
      platform: a,
      elements: s,
      middlewareData: l
    } = t, {
      element: u,
      padding: d = 0
    } = Yi(e, t) || {};
    if (u == null)
      return {};
    const f = xS(d), p = {
      x: n,
      y: r
    }, m = c1(i), g = l1(m), v = await a.getDimensions(u), y = m === "y", b = y ? "top" : "left", E = y ? "bottom" : "right", S = y ? "clientHeight" : "clientWidth", _ = o.reference[g] + o.reference[m] - p[m] - o.floating[g], k = p[m] - o.reference[m], T = await (a.getOffsetParent == null ? void 0 : a.getOffsetParent(u));
    let A = T ? T[S] : 0;
    (!A || !await (a.isElement == null ? void 0 : a.isElement(T))) && (A = s.floating[S] || o.floating[g]);
    const R = _ / 2 - k / 2, F = A / 2 - v[g] / 2 - 1, D = Mo(f[b], F), W = Mo(f[E], F), L = D, z = A - v[g] - W, B = A / 2 - v[g] / 2 + R, G = tv(L, B, z), H = !l.arrow && Fs(i) != null && B !== G && o.reference[g] / 2 - (B < L ? D : W) - v[g] / 2 < 0, J = H ? B < L ? B - L : B - z : 0;
    return {
      [m]: p[m] + J,
      data: {
        [m]: G,
        centerOffset: B - G - J,
        ...H && {
          alignmentOffset: J
        }
      },
      reset: H
    };
  }
}), WL = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        middlewareData: o,
        rects: a,
        initialPlacement: s,
        platform: l,
        elements: u
      } = t, {
        mainAxis: d = !0,
        crossAxis: f = !0,
        fallbackPlacements: p,
        fallbackStrategy: m = "bestFit",
        fallbackAxisSideDirection: g = "none",
        flipAlignment: v = !0,
        ...y
      } = Yi(e, t);
      if ((n = o.arrow) != null && n.alignmentOffset)
        return {};
      const b = Ki(i), E = Oo(s), S = Ki(s) === s, _ = await (l.isRTL == null ? void 0 : l.isRTL(u.floating)), k = p || (S || !v ? [Jd(s)] : LL(s)), T = g !== "none";
      !p && T && k.push(...zL(s, v, g, _));
      const A = [s, ...k], R = await tc(t, y), F = [];
      let D = ((r = o.flip) == null ? void 0 : r.overflows) || [];
      if (d && F.push(R[b]), f) {
        const B = $L(i, a, _);
        F.push(R[B[0]], R[B[1]]);
      }
      if (D = [...D, {
        placement: i,
        overflows: F
      }], !F.every((B) => B <= 0)) {
        var W, L;
        const B = (((W = o.flip) == null ? void 0 : W.index) || 0) + 1, G = A[B];
        if (G)
          return {
            data: {
              index: B,
              overflows: D
            },
            reset: {
              placement: G
            }
          };
        let H = (L = D.filter((J) => J.overflows[0] <= 0).sort((J, q) => J.overflows[1] - q.overflows[1])[0]) == null ? void 0 : L.placement;
        if (!H)
          switch (m) {
            case "bestFit": {
              var z;
              const J = (z = D.filter((q) => {
                if (T) {
                  const Z = Oo(q.placement);
                  return Z === E || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  Z === "y";
                }
                return !0;
              }).map((q) => [q.placement, q.overflows.filter((Z) => Z > 0).reduce((Z, O) => Z + O, 0)]).sort((q, Z) => q[1] - Z[1])[0]) == null ? void 0 : z[0];
              J && (H = J);
              break;
            }
            case "initialPlacement":
              H = s;
              break;
          }
        if (i !== H)
          return {
            reset: {
              placement: H
            }
          };
      }
      return {};
    }
  };
};
function vx(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function yx(e) {
  return IL.some((t) => e[t] >= 0);
}
const UL = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: n
      } = t, {
        strategy: r = "referenceHidden",
        ...i
      } = Yi(e, t);
      switch (r) {
        case "referenceHidden": {
          const o = await tc(t, {
            ...i,
            elementContext: "reference"
          }), a = vx(o, n.reference);
          return {
            data: {
              referenceHiddenOffsets: a,
              referenceHidden: yx(a)
            }
          };
        }
        case "escaped": {
          const o = await tc(t, {
            ...i,
            altBoundary: !0
          }), a = vx(o, n.floating);
          return {
            data: {
              escapedOffsets: a,
              escaped: yx(a)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function HL(e, t) {
  const {
    placement: n,
    platform: r,
    elements: i
  } = e, o = await (r.isRTL == null ? void 0 : r.isRTL(i.floating)), a = Ki(n), s = Fs(n), l = Oo(n) === "y", u = ["left", "top"].includes(a) ? -1 : 1, d = o && l ? -1 : 1, f = Yi(t, e);
  let {
    mainAxis: p,
    crossAxis: m,
    alignmentAxis: g
  } = typeof f == "number" ? {
    mainAxis: f,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: f.mainAxis || 0,
    crossAxis: f.crossAxis || 0,
    alignmentAxis: f.alignmentAxis
  };
  return s && typeof g == "number" && (m = s === "end" ? g * -1 : g), l ? {
    x: m * d,
    y: p * u
  } : {
    x: p * u,
    y: m * d
  };
}
const GL = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var n, r;
      const {
        x: i,
        y: o,
        placement: a,
        middlewareData: s
      } = t, l = await HL(t, e);
      return a === ((n = s.offset) == null ? void 0 : n.placement) && (r = s.arrow) != null && r.alignmentOffset ? {} : {
        x: i + l.x,
        y: o + l.y,
        data: {
          ...l,
          placement: a
        }
      };
    }
  };
}, qL = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: n,
        y: r,
        placement: i
      } = t, {
        mainAxis: o = !0,
        crossAxis: a = !1,
        limiter: s = {
          fn: (y) => {
            let {
              x: b,
              y: E
            } = y;
            return {
              x: b,
              y: E
            };
          }
        },
        ...l
      } = Yi(e, t), u = {
        x: n,
        y: r
      }, d = await tc(t, l), f = Oo(Ki(i)), p = s1(f);
      let m = u[p], g = u[f];
      if (o) {
        const y = p === "y" ? "top" : "left", b = p === "y" ? "bottom" : "right", E = m + d[y], S = m - d[b];
        m = tv(E, m, S);
      }
      if (a) {
        const y = f === "y" ? "top" : "left", b = f === "y" ? "bottom" : "right", E = g + d[y], S = g - d[b];
        g = tv(E, g, S);
      }
      const v = s.fn({
        ...t,
        [p]: m,
        [f]: g
      });
      return {
        ...v,
        data: {
          x: v.x - n,
          y: v.y - r,
          enabled: {
            [p]: o,
            [f]: a
          }
        }
      };
    }
  };
}, YL = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: n,
        y: r,
        placement: i,
        rects: o,
        middlewareData: a
      } = t, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: u = !0
      } = Yi(e, t), d = {
        x: n,
        y: r
      }, f = Oo(i), p = s1(f);
      let m = d[p], g = d[f];
      const v = Yi(s, t), y = typeof v == "number" ? {
        mainAxis: v,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...v
      };
      if (l) {
        const S = p === "y" ? "height" : "width", _ = o.reference[p] - o.floating[S] + y.mainAxis, k = o.reference[p] + o.reference[S] - y.mainAxis;
        m < _ ? m = _ : m > k && (m = k);
      }
      if (u) {
        var b, E;
        const S = p === "y" ? "width" : "height", _ = ["top", "left"].includes(Ki(i)), k = o.reference[f] - o.floating[S] + (_ && ((b = a.offset) == null ? void 0 : b[f]) || 0) + (_ ? 0 : y.crossAxis), T = o.reference[f] + o.reference[S] + (_ ? 0 : ((E = a.offset) == null ? void 0 : E[f]) || 0) - (_ ? y.crossAxis : 0);
        g < k ? g = k : g > T && (g = T);
      }
      return {
        [p]: m,
        [f]: g
      };
    }
  };
}, KL = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var n, r;
      const {
        placement: i,
        rects: o,
        platform: a,
        elements: s
      } = t, {
        apply: l = () => {
        },
        ...u
      } = Yi(e, t), d = await tc(t, u), f = Ki(i), p = Fs(i), m = Oo(i) === "y", {
        width: g,
        height: v
      } = o.floating;
      let y, b;
      f === "top" || f === "bottom" ? (y = f, b = p === (await (a.isRTL == null ? void 0 : a.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (b = f, y = p === "end" ? "top" : "bottom");
      const E = v - d.top - d.bottom, S = g - d.left - d.right, _ = Mo(v - d[y], E), k = Mo(g - d[b], S), T = !t.middlewareData.shift;
      let A = _, R = k;
      if ((n = t.middlewareData.shift) != null && n.enabled.x && (R = S), (r = t.middlewareData.shift) != null && r.enabled.y && (A = E), T && !p) {
        const D = hr(d.left, 0), W = hr(d.right, 0), L = hr(d.top, 0), z = hr(d.bottom, 0);
        m ? R = g - 2 * (D !== 0 || W !== 0 ? D + W : hr(d.left, d.right)) : A = v - 2 * (L !== 0 || z !== 0 ? L + z : hr(d.top, d.bottom));
      }
      await l({
        ...t,
        availableWidth: R,
        availableHeight: A
      });
      const F = await a.getDimensions(s.floating);
      return g !== F.width || v !== F.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function th() {
  return typeof window < "u";
}
function zs(e) {
  return ES(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function pr(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function _i(e) {
  var t;
  return (t = (ES(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function ES(e) {
  return th() ? e instanceof Node || e instanceof pr(e).Node : !1;
}
function ai(e) {
  return th() ? e instanceof Element || e instanceof pr(e).Element : !1;
}
function Ci(e) {
  return th() ? e instanceof HTMLElement || e instanceof pr(e).HTMLElement : !1;
}
function wx(e) {
  return !th() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof pr(e).ShadowRoot;
}
function Pc(e) {
  const {
    overflow: t,
    overflowX: n,
    overflowY: r,
    display: i
  } = si(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + r + n) && !["inline", "contents"].includes(i);
}
function XL(e) {
  return ["table", "td", "th"].includes(zs(e));
}
function nh(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function u1(e) {
  const t = d1(), n = ai(e) ? si(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((r) => n[r] ? n[r] !== "none" : !1) || (n.containerType ? n.containerType !== "normal" : !1) || !t && (n.backdropFilter ? n.backdropFilter !== "none" : !1) || !t && (n.filter ? n.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((r) => (n.willChange || "").includes(r)) || ["paint", "layout", "strict", "content"].some((r) => (n.contain || "").includes(r));
}
function ZL(e) {
  let t = Ro(e);
  for (; Ci(t) && !ks(t); ) {
    if (u1(t))
      return t;
    if (nh(t))
      return null;
    t = Ro(t);
  }
  return null;
}
function d1() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function ks(e) {
  return ["html", "body", "#document"].includes(zs(e));
}
function si(e) {
  return pr(e).getComputedStyle(e);
}
function rh(e) {
  return ai(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Ro(e) {
  if (zs(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    wx(e) && e.host || // Fallback.
    _i(e)
  );
  return wx(t) ? t.host : t;
}
function CS(e) {
  const t = Ro(e);
  return ks(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Ci(t) && Pc(t) ? t : CS(t);
}
function nc(e, t, n) {
  var r;
  t === void 0 && (t = []), n === void 0 && (n = !0);
  const i = CS(e), o = i === ((r = e.ownerDocument) == null ? void 0 : r.body), a = pr(i);
  if (o) {
    const s = rv(a);
    return t.concat(a, a.visualViewport || [], Pc(i) ? i : [], s && n ? nc(s) : []);
  }
  return t.concat(i, nc(i, [], n));
}
function rv(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function SS(e) {
  const t = si(e);
  let n = parseFloat(t.width) || 0, r = parseFloat(t.height) || 0;
  const i = Ci(e), o = i ? e.offsetWidth : n, a = i ? e.offsetHeight : r, s = Qd(n) !== o || Qd(r) !== a;
  return s && (n = o, r = a), {
    width: n,
    height: r,
    $: s
  };
}
function f1(e) {
  return ai(e) ? e : e.contextElement;
}
function ms(e) {
  const t = f1(e);
  if (!Ci(t))
    return yi(1);
  const n = t.getBoundingClientRect(), {
    width: r,
    height: i,
    $: o
  } = SS(t);
  let a = (o ? Qd(n.width) : n.width) / r, s = (o ? Qd(n.height) : n.height) / i;
  return (!a || !Number.isFinite(a)) && (a = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: a,
    y: s
  };
}
const QL = /* @__PURE__ */ yi(0);
function _S(e) {
  const t = pr(e);
  return !d1() || !t.visualViewport ? QL : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function JL(e, t, n) {
  return t === void 0 && (t = !1), !n || t && n !== pr(e) ? !1 : t;
}
function ga(e, t, n, r) {
  t === void 0 && (t = !1), n === void 0 && (n = !1);
  const i = e.getBoundingClientRect(), o = f1(e);
  let a = yi(1);
  t && (r ? ai(r) && (a = ms(r)) : a = ms(e));
  const s = JL(o, n, r) ? _S(o) : yi(0);
  let l = (i.left + s.x) / a.x, u = (i.top + s.y) / a.y, d = i.width / a.x, f = i.height / a.y;
  if (o) {
    const p = pr(o), m = r && ai(r) ? pr(r) : r;
    let g = p, v = rv(g);
    for (; v && r && m !== g; ) {
      const y = ms(v), b = v.getBoundingClientRect(), E = si(v), S = b.left + (v.clientLeft + parseFloat(E.paddingLeft)) * y.x, _ = b.top + (v.clientTop + parseFloat(E.paddingTop)) * y.y;
      l *= y.x, u *= y.y, d *= y.x, f *= y.y, l += S, u += _, g = pr(v), v = rv(g);
    }
  }
  return ef({
    width: d,
    height: f,
    x: l,
    y: u
  });
}
function h1(e, t) {
  const n = rh(e).scrollLeft;
  return t ? t.left + n : ga(_i(e)).left + n;
}
function PS(e, t, n) {
  n === void 0 && (n = !1);
  const r = e.getBoundingClientRect(), i = r.left + t.scrollLeft - (n ? 0 : (
    // RTL <body> scrollbar.
    h1(e, r)
  )), o = r.top + t.scrollTop;
  return {
    x: i,
    y: o
  };
}
function eF(e) {
  let {
    elements: t,
    rect: n,
    offsetParent: r,
    strategy: i
  } = e;
  const o = i === "fixed", a = _i(r), s = t ? nh(t.floating) : !1;
  if (r === a || s && o)
    return n;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, u = yi(1);
  const d = yi(0), f = Ci(r);
  if ((f || !f && !o) && ((zs(r) !== "body" || Pc(a)) && (l = rh(r)), Ci(r))) {
    const m = ga(r);
    u = ms(r), d.x = m.x + r.clientLeft, d.y = m.y + r.clientTop;
  }
  const p = a && !f && !o ? PS(a, l, !0) : yi(0);
  return {
    width: n.width * u.x,
    height: n.height * u.y,
    x: n.x * u.x - l.scrollLeft * u.x + d.x + p.x,
    y: n.y * u.y - l.scrollTop * u.y + d.y + p.y
  };
}
function tF(e) {
  return Array.from(e.getClientRects());
}
function nF(e) {
  const t = _i(e), n = rh(e), r = e.ownerDocument.body, i = hr(t.scrollWidth, t.clientWidth, r.scrollWidth, r.clientWidth), o = hr(t.scrollHeight, t.clientHeight, r.scrollHeight, r.clientHeight);
  let a = -n.scrollLeft + h1(e);
  const s = -n.scrollTop;
  return si(r).direction === "rtl" && (a += hr(t.clientWidth, r.clientWidth) - i), {
    width: i,
    height: o,
    x: a,
    y: s
  };
}
function rF(e, t) {
  const n = pr(e), r = _i(e), i = n.visualViewport;
  let o = r.clientWidth, a = r.clientHeight, s = 0, l = 0;
  if (i) {
    o = i.width, a = i.height;
    const u = d1();
    (!u || u && t === "fixed") && (s = i.offsetLeft, l = i.offsetTop);
  }
  return {
    width: o,
    height: a,
    x: s,
    y: l
  };
}
function iF(e, t) {
  const n = ga(e, !0, t === "fixed"), r = n.top + e.clientTop, i = n.left + e.clientLeft, o = Ci(e) ? ms(e) : yi(1), a = e.clientWidth * o.x, s = e.clientHeight * o.y, l = i * o.x, u = r * o.y;
  return {
    width: a,
    height: s,
    x: l,
    y: u
  };
}
function bx(e, t, n) {
  let r;
  if (t === "viewport")
    r = rF(e, n);
  else if (t === "document")
    r = nF(_i(e));
  else if (ai(t))
    r = iF(t, n);
  else {
    const i = _S(e);
    r = {
      x: t.x - i.x,
      y: t.y - i.y,
      width: t.width,
      height: t.height
    };
  }
  return ef(r);
}
function kS(e, t) {
  const n = Ro(e);
  return n === t || !ai(n) || ks(n) ? !1 : si(n).position === "fixed" || kS(n, t);
}
function oF(e, t) {
  const n = t.get(e);
  if (n)
    return n;
  let r = nc(e, [], !1).filter((s) => ai(s) && zs(s) !== "body"), i = null;
  const o = si(e).position === "fixed";
  let a = o ? Ro(e) : e;
  for (; ai(a) && !ks(a); ) {
    const s = si(a), l = u1(a);
    !l && s.position === "fixed" && (i = null), (o ? !l && !i : !l && s.position === "static" && !!i && ["absolute", "fixed"].includes(i.position) || Pc(a) && !l && kS(e, a)) ? r = r.filter((d) => d !== a) : i = s, a = Ro(a);
  }
  return t.set(e, r), r;
}
function aF(e) {
  let {
    element: t,
    boundary: n,
    rootBoundary: r,
    strategy: i
  } = e;
  const a = [...n === "clippingAncestors" ? nh(t) ? [] : oF(t, this._c) : [].concat(n), r], s = a[0], l = a.reduce((u, d) => {
    const f = bx(t, d, i);
    return u.top = hr(f.top, u.top), u.right = Mo(f.right, u.right), u.bottom = Mo(f.bottom, u.bottom), u.left = hr(f.left, u.left), u;
  }, bx(t, s, i));
  return {
    width: l.right - l.left,
    height: l.bottom - l.top,
    x: l.left,
    y: l.top
  };
}
function sF(e) {
  const {
    width: t,
    height: n
  } = SS(e);
  return {
    width: t,
    height: n
  };
}
function lF(e, t, n) {
  const r = Ci(t), i = _i(t), o = n === "fixed", a = ga(e, !0, o, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = yi(0);
  if (r || !r && !o)
    if ((zs(t) !== "body" || Pc(i)) && (s = rh(t)), r) {
      const p = ga(t, !0, o, t);
      l.x = p.x + t.clientLeft, l.y = p.y + t.clientTop;
    } else
      i && (l.x = h1(i));
  const u = i && !r && !o ? PS(i, s) : yi(0), d = a.left + s.scrollLeft - l.x - u.x, f = a.top + s.scrollTop - l.y - u.y;
  return {
    x: d,
    y: f,
    width: a.width,
    height: a.height
  };
}
function Mm(e) {
  return si(e).position === "static";
}
function xx(e, t) {
  if (!Ci(e) || si(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let n = e.offsetParent;
  return _i(e) === n && (n = n.ownerDocument.body), n;
}
function TS(e, t) {
  const n = pr(e);
  if (nh(e))
    return n;
  if (!Ci(e)) {
    let i = Ro(e);
    for (; i && !ks(i); ) {
      if (ai(i) && !Mm(i))
        return i;
      i = Ro(i);
    }
    return n;
  }
  let r = xx(e, t);
  for (; r && XL(r) && Mm(r); )
    r = xx(r, t);
  return r && ks(r) && Mm(r) && !u1(r) ? n : r || ZL(e) || n;
}
const cF = async function(e) {
  const t = this.getOffsetParent || TS, n = this.getDimensions, r = await n(e.floating);
  return {
    reference: lF(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: r.width,
      height: r.height
    }
  };
};
function uF(e) {
  return si(e).direction === "rtl";
}
const dF = {
  convertOffsetParentRelativeRectToViewportRelativeRect: eF,
  getDocumentElement: _i,
  getClippingRect: aF,
  getOffsetParent: TS,
  getElementRects: cF,
  getClientRects: tF,
  getDimensions: sF,
  getScale: ms,
  isElement: ai,
  isRTL: uF
};
function AS(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function fF(e, t) {
  let n = null, r;
  const i = _i(e);
  function o() {
    var s;
    clearTimeout(r), (s = n) == null || s.disconnect(), n = null;
  }
  function a(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), o();
    const u = e.getBoundingClientRect(), {
      left: d,
      top: f,
      width: p,
      height: m
    } = u;
    if (s || t(), !p || !m)
      return;
    const g = Vu(f), v = Vu(i.clientWidth - (d + p)), y = Vu(i.clientHeight - (f + m)), b = Vu(d), S = {
      rootMargin: -g + "px " + -v + "px " + -y + "px " + -b + "px",
      threshold: hr(0, Mo(1, l)) || 1
    };
    let _ = !0;
    function k(T) {
      const A = T[0].intersectionRatio;
      if (A !== l) {
        if (!_)
          return a();
        A ? a(!1, A) : r = setTimeout(() => {
          a(!1, 1e-7);
        }, 1e3);
      }
      A === 1 && !AS(u, e.getBoundingClientRect()) && a(), _ = !1;
    }
    try {
      n = new IntersectionObserver(k, {
        ...S,
        // Handle <iframe>s
        root: i.ownerDocument
      });
    } catch {
      n = new IntersectionObserver(k, S);
    }
    n.observe(e);
  }
  return a(!0), o;
}
function MS(e, t, n, r) {
  r === void 0 && (r = {});
  const {
    ancestorScroll: i = !0,
    ancestorResize: o = !0,
    elementResize: a = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = r, u = f1(e), d = i || o ? [...u ? nc(u) : [], ...nc(t)] : [];
  d.forEach((b) => {
    i && b.addEventListener("scroll", n, {
      passive: !0
    }), o && b.addEventListener("resize", n);
  });
  const f = u && s ? fF(u, n) : null;
  let p = -1, m = null;
  a && (m = new ResizeObserver((b) => {
    let [E] = b;
    E && E.target === u && m && (m.unobserve(t), cancelAnimationFrame(p), p = requestAnimationFrame(() => {
      var S;
      (S = m) == null || S.observe(t);
    })), n();
  }), u && !l && m.observe(u), m.observe(t));
  let g, v = l ? ga(e) : null;
  l && y();
  function y() {
    const b = ga(e);
    v && !AS(v, b) && n(), v = b, g = requestAnimationFrame(y);
  }
  return n(), () => {
    var b;
    d.forEach((E) => {
      i && E.removeEventListener("scroll", n), o && E.removeEventListener("resize", n);
    }), f == null || f(), (b = m) == null || b.disconnect(), m = null, l && cancelAnimationFrame(g);
  };
}
const hF = GL, pF = qL, mF = WL, gF = KL, vF = UL, Ex = jL, yF = YL, wF = (e, t, n) => {
  const r = /* @__PURE__ */ new Map(), i = {
    platform: dF,
    ...n
  }, o = {
    ...i.platform,
    _c: r
  };
  return BL(e, t, {
    ...i,
    platform: o
  });
};
var Dd = typeof document < "u" ? eo : be;
function tf(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let n, r, i;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (n = e.length, n !== t.length)
        return !1;
      for (r = n; r-- !== 0; )
        if (!tf(e[r], t[r]))
          return !1;
      return !0;
    }
    if (i = Object.keys(e), n = i.length, n !== Object.keys(t).length)
      return !1;
    for (r = n; r-- !== 0; )
      if (!{}.hasOwnProperty.call(t, i[r]))
        return !1;
    for (r = n; r-- !== 0; ) {
      const o = i[r];
      if (!(o === "_owner" && e.$$typeof) && !tf(e[o], t[o]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function OS(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function Cx(e, t) {
  const n = OS(e);
  return Math.round(t * n) / n;
}
function Om(e) {
  const t = C.useRef(e);
  return Dd(() => {
    t.current = e;
  }), t;
}
function RS(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i,
    elements: {
      reference: o,
      floating: a
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: u
  } = e, [d, f] = C.useState({
    x: 0,
    y: 0,
    strategy: n,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [p, m] = C.useState(r);
  tf(p, r) || m(r);
  const [g, v] = C.useState(null), [y, b] = C.useState(null), E = C.useCallback((q) => {
    q !== T.current && (T.current = q, v(q));
  }, []), S = C.useCallback((q) => {
    q !== A.current && (A.current = q, b(q));
  }, []), _ = o || g, k = a || y, T = C.useRef(null), A = C.useRef(null), R = C.useRef(d), F = l != null, D = Om(l), W = Om(i), L = Om(u), z = C.useCallback(() => {
    if (!T.current || !A.current)
      return;
    const q = {
      placement: t,
      strategy: n,
      middleware: p
    };
    W.current && (q.platform = W.current), wF(T.current, A.current, q).then((Z) => {
      const O = {
        ...Z,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: L.current !== !1
      };
      B.current && !tf(R.current, O) && (R.current = O, Kf.flushSync(() => {
        f(O);
      }));
    });
  }, [p, t, n, W, L]);
  Dd(() => {
    u === !1 && R.current.isPositioned && (R.current.isPositioned = !1, f((q) => ({
      ...q,
      isPositioned: !1
    })));
  }, [u]);
  const B = C.useRef(!1);
  Dd(() => (B.current = !0, () => {
    B.current = !1;
  }), []), Dd(() => {
    if (_ && (T.current = _), k && (A.current = k), _ && k) {
      if (D.current)
        return D.current(_, k, z);
      z();
    }
  }, [_, k, z, D, F]);
  const G = C.useMemo(() => ({
    reference: T,
    floating: A,
    setReference: E,
    setFloating: S
  }), [E, S]), H = C.useMemo(() => ({
    reference: _,
    floating: k
  }), [_, k]), J = C.useMemo(() => {
    const q = {
      position: n,
      left: 0,
      top: 0
    };
    if (!H.floating)
      return q;
    const Z = Cx(H.floating, d.x), O = Cx(H.floating, d.y);
    return s ? {
      ...q,
      transform: "translate(" + Z + "px, " + O + "px)",
      ...OS(H.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: n,
      left: Z,
      top: O
    };
  }, [n, s, H.floating, d.x, d.y]);
  return C.useMemo(() => ({
    ...d,
    update: z,
    refs: G,
    elements: H,
    floatingStyles: J
  }), [d, z, G, H, J]);
}
const bF = (e) => {
  function t(n) {
    return {}.hasOwnProperty.call(n, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(n) {
      const {
        element: r,
        padding: i
      } = typeof e == "function" ? e(n) : e;
      return r && t(r) ? r.current != null ? Ex({
        element: r.current,
        padding: i
      }).fn(n) : {} : r ? Ex({
        element: r,
        padding: i
      }).fn(n) : {};
    }
  };
}, IS = (e, t) => ({
  ...hF(e),
  options: [e, t]
}), DS = (e, t) => ({
  ...pF(e),
  options: [e, t]
}), NS = (e, t) => ({
  ...yF(e),
  options: [e, t]
}), $S = (e, t) => ({
  ...mF(e),
  options: [e, t]
}), LS = (e, t) => ({
  ...gF(e),
  options: [e, t]
}), FS = (e, t) => ({
  ...vF(e),
  options: [e, t]
}), zS = (e, t) => ({
  ...bF(e),
  options: [e, t]
}), xF = /* @__PURE__ */ ke((e, t) => {
  const { children: n, width: r = 10, height: i = 5, ...o } = e;
  return /* @__PURE__ */ X(rt.svg, ge({}, o, {
    ref: t,
    width: r,
    height: i,
    viewBox: "0 0 30 10",
    preserveAspectRatio: "none"
  }), e.asChild ? n : /* @__PURE__ */ X("polygon", {
    points: "0,0 30,0 15,10"
  }));
}), EF = xF;
function p1(e) {
  const [t, n] = de(void 0);
  return ma(() => {
    if (e) {
      n({
        width: e.offsetWidth,
        height: e.offsetHeight
      });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const o = i[0];
        let a, s;
        if ("borderBoxSize" in o) {
          const l = o.borderBoxSize, u = Array.isArray(l) ? l[0] : l;
          a = u.inlineSize, s = u.blockSize;
        } else
          a = e.offsetWidth, s = e.offsetHeight;
        n({
          width: a,
          height: s
        });
      });
      return r.observe(e, {
        box: "border-box"
      }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [
    e
  ]), t;
}
const VS = "Popper", [BS, Vs] = rr(VS), [CF, jS] = BS(VS), SF = (e) => {
  const { __scopePopper: t, children: n } = e, [r, i] = de(null);
  return /* @__PURE__ */ X(CF, {
    scope: t,
    anchor: r,
    onAnchorChange: i
  }, n);
}, _F = "PopperAnchor", PF = /* @__PURE__ */ ke((e, t) => {
  const { __scopePopper: n, virtualRef: r, ...i } = e, o = jS(_F, n), a = me(null), s = Ft(t, a);
  return be(() => {
    o.onAnchorChange((r == null ? void 0 : r.current) || a.current);
  }), r ? null : /* @__PURE__ */ X(rt.div, ge({}, i, {
    ref: s
  }));
}), WS = "PopperContent", [kF, TF] = BS(WS), AF = /* @__PURE__ */ ke((e, t) => {
  var n, r, i, o, a, s, l, u;
  const { __scopePopper: d, side: f = "bottom", sideOffset: p = 0, align: m = "center", alignOffset: g = 0, arrowPadding: v = 0, avoidCollisions: y = !0, collisionBoundary: b = [], collisionPadding: E = 0, sticky: S = "partial", hideWhenDetached: _ = !1, updatePositionStrategy: k = "optimized", onPlaced: T, ...A } = e, R = jS(WS, d), [F, D] = de(null), W = Ft(
    t,
    (ze) => D(ze)
  ), [L, z] = de(null), B = p1(L), G = (n = B == null ? void 0 : B.width) !== null && n !== void 0 ? n : 0, H = (r = B == null ? void 0 : B.height) !== null && r !== void 0 ? r : 0, J = f + (m !== "center" ? "-" + m : ""), q = typeof E == "number" ? E : {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...E
  }, Z = Array.isArray(b) ? b : [
    b
  ], O = Z.length > 0, Q = {
    padding: q,
    boundary: Z.filter(IF),
    // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
    altBoundary: O
  }, { refs: he, floatingStyles: N, placement: ee, isPositioned: ae, middlewareData: pe } = RS({
    // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
    strategy: "fixed",
    placement: J,
    whileElementsMounted: (...ze) => MS(...ze, {
      animationFrame: k === "always"
    }),
    elements: {
      reference: R.anchor
    },
    middleware: [
      IS({
        mainAxis: p + H,
        alignmentAxis: g
      }),
      y && DS({
        mainAxis: !0,
        crossAxis: !1,
        limiter: S === "partial" ? NS() : void 0,
        ...Q
      }),
      y && $S({
        ...Q
      }),
      LS({
        ...Q,
        apply: ({ elements: ze, rects: dt, availableWidth: ht, availableHeight: vt }) => {
          const { width: mt, height: Ht } = dt.reference, zt = ze.floating.style;
          zt.setProperty("--radix-popper-available-width", `${ht}px`), zt.setProperty("--radix-popper-available-height", `${vt}px`), zt.setProperty("--radix-popper-anchor-width", `${mt}px`), zt.setProperty("--radix-popper-anchor-height", `${Ht}px`);
        }
      }),
      L && zS({
        element: L,
        padding: v
      }),
      DF({
        arrowWidth: G,
        arrowHeight: H
      }),
      _ && FS({
        strategy: "referenceHidden",
        ...Q
      })
    ]
  }), [se, Se] = US(ee), le = Ei(T);
  ma(() => {
    ae && (le == null || le());
  }, [
    ae,
    le
  ]);
  const Ee = (i = pe.arrow) === null || i === void 0 ? void 0 : i.x, Ie = (o = pe.arrow) === null || o === void 0 ? void 0 : o.y, te = ((a = pe.arrow) === null || a === void 0 ? void 0 : a.centerOffset) !== 0, [Re, we] = de();
  return ma(() => {
    F && we(window.getComputedStyle(F).zIndex);
  }, [
    F
  ]), /* @__PURE__ */ X("div", {
    ref: he.setFloating,
    "data-radix-popper-content-wrapper": "",
    style: {
      ...N,
      transform: ae ? N.transform : "translate(0, -200%)",
      // keep off the page when measuring
      minWidth: "max-content",
      zIndex: Re,
      ["--radix-popper-transform-origin"]: [
        (s = pe.transformOrigin) === null || s === void 0 ? void 0 : s.x,
        (l = pe.transformOrigin) === null || l === void 0 ? void 0 : l.y
      ].join(" ")
    },
    dir: e.dir
  }, /* @__PURE__ */ X(kF, {
    scope: d,
    placedSide: se,
    onArrowChange: z,
    arrowX: Ee,
    arrowY: Ie,
    shouldHideArrow: te
  }, /* @__PURE__ */ X(rt.div, ge({
    "data-side": se,
    "data-align": Se
  }, A, {
    ref: W,
    style: {
      ...A.style,
      // if the PopperContent hasn't been placed yet (not all measurements done)
      // we prevent animations so that users's animation don't kick in too early referring wrong sides
      animation: ae ? void 0 : "none",
      // hide the content if using the hide middleware and should be hidden
      opacity: (u = pe.hide) !== null && u !== void 0 && u.referenceHidden ? 0 : void 0
    }
  }))));
}), MF = "PopperArrow", OF = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, RF = /* @__PURE__ */ ke(function(t, n) {
  const { __scopePopper: r, ...i } = t, o = TF(MF, r), a = OF[o.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ X("span", {
      ref: o.onArrowChange,
      style: {
        position: "absolute",
        left: o.arrowX,
        top: o.arrowY,
        [a]: 0,
        transformOrigin: {
          top: "",
          right: "0 0",
          bottom: "center 0",
          left: "100% 0"
        }[o.placedSide],
        transform: {
          top: "translateY(100%)",
          right: "translateY(50%) rotate(90deg) translateX(-50%)",
          bottom: "rotate(180deg)",
          left: "translateY(50%) rotate(-90deg) translateX(50%)"
        }[o.placedSide],
        visibility: o.shouldHideArrow ? "hidden" : void 0
      }
    }, /* @__PURE__ */ X(EF, ge({}, i, {
      ref: n,
      style: {
        ...i.style,
        // ensures the element can be measured correctly (mostly for if SVG)
        display: "block"
      }
    })))
  );
});
function IF(e) {
  return e !== null;
}
const DF = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var n, r, i, o, a;
    const { placement: s, rects: l, middlewareData: u } = t, f = ((n = u.arrow) === null || n === void 0 ? void 0 : n.centerOffset) !== 0, p = f ? 0 : e.arrowWidth, m = f ? 0 : e.arrowHeight, [g, v] = US(s), y = {
      start: "0%",
      center: "50%",
      end: "100%"
    }[v], b = ((r = (i = u.arrow) === null || i === void 0 ? void 0 : i.x) !== null && r !== void 0 ? r : 0) + p / 2, E = ((o = (a = u.arrow) === null || a === void 0 ? void 0 : a.y) !== null && o !== void 0 ? o : 0) + m / 2;
    let S = "", _ = "";
    return g === "bottom" ? (S = f ? y : `${b}px`, _ = `${-m}px`) : g === "top" ? (S = f ? y : `${b}px`, _ = `${l.floating.height + m}px`) : g === "right" ? (S = `${-m}px`, _ = f ? y : `${E}px`) : g === "left" && (S = `${l.floating.width + m}px`, _ = f ? y : `${E}px`), {
      data: {
        x: S,
        y: _
      }
    };
  }
});
function US(e) {
  const [t, n = "center"] = e.split("-");
  return [
    t,
    n
  ];
}
const m1 = SF, ih = PF, g1 = AF, NF = RF, oh = /* @__PURE__ */ ke((e, t) => {
  var n;
  const { container: r = globalThis == null || (n = globalThis.document) === null || n === void 0 ? void 0 : n.body, ...i } = e;
  return r ? /* @__PURE__ */ Xf.createPortal(/* @__PURE__ */ X(rt.div, ge({}, i, {
    ref: t
  })), r) : null;
});
function $F(e, t) {
  return Yf((n, r) => {
    const i = t[n][r];
    return i ?? n;
  }, e);
}
const On = (e) => {
  const { present: t, children: n } = e, r = LF(t), i = typeof n == "function" ? n({
    present: r.isPresent
  }) : Ui.only(n), o = Ft(r.ref, i.ref);
  return typeof n == "function" || r.isPresent ? /* @__PURE__ */ qf(i, {
    ref: o
  }) : null;
};
On.displayName = "Presence";
function LF(e) {
  const [t, n] = de(), r = me({}), i = me(e), o = me("none"), a = e ? "mounted" : "unmounted", [s, l] = $F(a, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return be(() => {
    const u = Bu(r.current);
    o.current = s === "mounted" ? u : "none";
  }, [
    s
  ]), ma(() => {
    const u = r.current, d = i.current;
    if (d !== e) {
      const p = o.current, m = Bu(u);
      e ? l("MOUNT") : m === "none" || (u == null ? void 0 : u.display) === "none" ? l("UNMOUNT") : l(d && p !== m ? "ANIMATION_OUT" : "UNMOUNT"), i.current = e;
    }
  }, [
    e,
    l
  ]), ma(() => {
    if (t) {
      const u = (f) => {
        const m = Bu(r.current).includes(f.animationName);
        f.target === t && m && Zf(
          () => l("ANIMATION_END")
        );
      }, d = (f) => {
        f.target === t && (o.current = Bu(r.current));
      };
      return t.addEventListener("animationstart", d), t.addEventListener("animationcancel", u), t.addEventListener("animationend", u), () => {
        t.removeEventListener("animationstart", d), t.removeEventListener("animationcancel", u), t.removeEventListener("animationend", u);
      };
    } else
      l("ANIMATION_END");
  }, [
    t,
    l
  ]), {
    isPresent: [
      "mounted",
      "unmountSuspended"
    ].includes(s),
    ref: De((u) => {
      u && (r.current = getComputedStyle(u)), n(u);
    }, [])
  };
}
function Bu(e) {
  return (e == null ? void 0 : e.animationName) || "none";
}
function li({ prop: e, defaultProp: t, onChange: n = () => {
} }) {
  const [r, i] = FF({
    defaultProp: t,
    onChange: n
  }), o = e !== void 0, a = o ? e : r, s = Ei(n), l = De((u) => {
    if (o) {
      const f = typeof u == "function" ? u(e) : u;
      f !== e && s(f);
    } else
      i(u);
  }, [
    o,
    e,
    i,
    s
  ]);
  return [
    a,
    l
  ];
}
function FF({ defaultProp: e, onChange: t }) {
  const n = de(e), [r] = n, i = me(r), o = Ei(t);
  return be(() => {
    i.current !== r && (o(r), i.current = r);
  }, [
    r,
    i,
    o
  ]), n;
}
var zF = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, Ka = /* @__PURE__ */ new WeakMap(), ju = /* @__PURE__ */ new WeakMap(), Wu = {}, Rm = 0, HS = function(e) {
  return e && (e.host || HS(e.parentNode));
}, VF = function(e, t) {
  return t.map(function(n) {
    if (e.contains(n))
      return n;
    var r = HS(n);
    return r && e.contains(r) ? r : (console.error("aria-hidden", n, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(n) {
    return !!n;
  });
}, BF = function(e, t, n, r) {
  var i = VF(t, Array.isArray(e) ? e : [e]);
  Wu[n] || (Wu[n] = /* @__PURE__ */ new WeakMap());
  var o = Wu[n], a = [], s = /* @__PURE__ */ new Set(), l = new Set(i), u = function(f) {
    !f || s.has(f) || (s.add(f), u(f.parentNode));
  };
  i.forEach(u);
  var d = function(f) {
    !f || l.has(f) || Array.prototype.forEach.call(f.children, function(p) {
      if (s.has(p))
        d(p);
      else
        try {
          var m = p.getAttribute(r), g = m !== null && m !== "false", v = (Ka.get(p) || 0) + 1, y = (o.get(p) || 0) + 1;
          Ka.set(p, v), o.set(p, y), a.push(p), v === 1 && g && ju.set(p, !0), y === 1 && p.setAttribute(n, "true"), g || p.setAttribute(r, "true");
        } catch (b) {
          console.error("aria-hidden: cannot operate on ", p, b);
        }
    });
  };
  return d(t), s.clear(), Rm++, function() {
    a.forEach(function(f) {
      var p = Ka.get(f) - 1, m = o.get(f) - 1;
      Ka.set(f, p), o.set(f, m), p || (ju.has(f) || f.removeAttribute(r), ju.delete(f)), m || f.removeAttribute(n);
    }), Rm--, Rm || (Ka = /* @__PURE__ */ new WeakMap(), Ka = /* @__PURE__ */ new WeakMap(), ju = /* @__PURE__ */ new WeakMap(), Wu = {});
  };
}, ah = function(e, t, n) {
  n === void 0 && (n = "data-aria-hidden");
  var r = Array.from(Array.isArray(e) ? e : [e]), i = t || zF(e);
  return i ? (r.push.apply(r, Array.from(i.querySelectorAll("[aria-live]"))), BF(r, i, n, "aria-hidden")) : function() {
    return null;
  };
}, iv = function(e, t) {
  return iv = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r)
      Object.prototype.hasOwnProperty.call(r, i) && (n[i] = r[i]);
  }, iv(e, t);
};
function GS(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  iv(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var ye = function() {
  return ye = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, ye.apply(this, arguments);
};
function Bn(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
function jF(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, n = t && e[t], r = 0;
  if (n)
    return n.call(e);
  if (e && typeof e.length == "number")
    return {
      next: function() {
        return e && r >= e.length && (e = void 0), { value: e && e[r++], done: !e };
      }
    };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Kt(e, t) {
  var n = typeof Symbol == "function" && e[Symbol.iterator];
  if (!n)
    return e;
  var r = n.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = r.next()).done; )
      o.push(i.value);
  } catch (s) {
    a = { error: s };
  } finally {
    try {
      i && !i.done && (n = r.return) && n.call(r);
    } finally {
      if (a)
        throw a.error;
    }
  }
  return o;
}
function mr(e, t, n) {
  if (n || arguments.length === 2)
    for (var r = 0, i = t.length, o; r < i; r++)
      (o || !(r in t)) && (o || (o = Array.prototype.slice.call(t, 0, r)), o[r] = t[r]);
  return e.concat(o || Array.prototype.slice.call(t));
}
var Bl = "right-scroll-bar-position", jl = "width-before-scroll-bar", WF = "with-scroll-bars-hidden", UF = "--removed-body-scroll-bar-size";
function Im(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function HF(e, t) {
  var n = de(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return n.value;
        },
        set current(r) {
          var i = n.value;
          i !== r && (n.value = r, n.callback(r, i));
        }
      }
    };
  })[0];
  return n.callback = t, n.facade;
}
var GF = typeof window < "u" ? C.useLayoutEffect : C.useEffect, Sx = /* @__PURE__ */ new WeakMap();
function qS(e, t) {
  var n = HF(t || null, function(r) {
    return e.forEach(function(i) {
      return Im(i, r);
    });
  });
  return GF(function() {
    var r = Sx.get(n);
    if (r) {
      var i = new Set(r), o = new Set(e), a = n.current;
      i.forEach(function(s) {
        o.has(s) || Im(s, null);
      }), o.forEach(function(s) {
        i.has(s) || Im(s, a);
      });
    }
    Sx.set(n, e);
  }, [e]), n;
}
function qF(e) {
  return e;
}
function YF(e, t) {
  t === void 0 && (t = qF);
  var n = [], r = !1, i = {
    read: function() {
      if (r)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return n.length ? n[n.length - 1] : e;
    },
    useMedium: function(o) {
      var a = t(o, r);
      return n.push(a), function() {
        n = n.filter(function(s) {
          return s !== a;
        });
      };
    },
    assignSyncMedium: function(o) {
      for (r = !0; n.length; ) {
        var a = n;
        n = [], a.forEach(o);
      }
      n = {
        push: function(s) {
          return o(s);
        },
        filter: function() {
          return n;
        }
      };
    },
    assignMedium: function(o) {
      r = !0;
      var a = [];
      if (n.length) {
        var s = n;
        n = [], s.forEach(o), a = n;
      }
      var l = function() {
        var d = a;
        a = [], d.forEach(o);
      }, u = function() {
        return Promise.resolve().then(l);
      };
      u(), n = {
        push: function(d) {
          a.push(d), u();
        },
        filter: function(d) {
          return a = a.filter(d), n;
        }
      };
    }
  };
  return i;
}
function YS(e) {
  e === void 0 && (e = {});
  var t = YF(null);
  return t.options = ye({ async: !0, ssr: !1 }, e), t;
}
var KS = function(e) {
  var t = e.sideCar, n = Bn(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var r = t.read();
  if (!r)
    throw new Error("Sidecar medium not found");
  return C.createElement(r, ye({}, n));
};
KS.isSideCarExport = !0;
function XS(e, t) {
  return e.useMedium(t), KS;
}
var ZS = YS(), Dm = function() {
}, sh = C.forwardRef(function(e, t) {
  var n = C.useRef(null), r = C.useState({
    onScrollCapture: Dm,
    onWheelCapture: Dm,
    onTouchMoveCapture: Dm
  }), i = r[0], o = r[1], a = e.forwardProps, s = e.children, l = e.className, u = e.removeScrollBar, d = e.enabled, f = e.shards, p = e.sideCar, m = e.noIsolation, g = e.inert, v = e.allowPinchZoom, y = e.as, b = y === void 0 ? "div" : y, E = Bn(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as"]), S = p, _ = qS([n, t]), k = ye(ye({}, E), i);
  return C.createElement(
    C.Fragment,
    null,
    d && C.createElement(S, { sideCar: ZS, removeScrollBar: u, shards: f, noIsolation: m, inert: g, setCallbacks: o, allowPinchZoom: !!v, lockRef: n }),
    a ? C.cloneElement(C.Children.only(s), ye(ye({}, k), { ref: _ })) : C.createElement(b, ye({}, k, { className: l, ref: _ }), s)
  );
});
sh.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
sh.classNames = {
  fullWidth: jl,
  zeroRight: Bl
};
var _x, KF = function() {
  if (_x)
    return _x;
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function XF() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = KF();
  return t && e.setAttribute("nonce", t), e;
}
function ZF(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function QF(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var JF = function() {
  var e = 0, t = null;
  return {
    add: function(n) {
      e == 0 && (t = XF()) && (ZF(t, n), QF(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, ez = function() {
  var e = JF();
  return function(t, n) {
    C.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && n]);
  };
}, v1 = function() {
  var e = ez(), t = function(n) {
    var r = n.styles, i = n.dynamic;
    return e(r, i), null;
  };
  return t;
}, tz = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, Nm = function(e) {
  return parseInt(e || "", 10) || 0;
}, nz = function(e) {
  var t = window.getComputedStyle(document.body), n = t[e === "padding" ? "paddingLeft" : "marginLeft"], r = t[e === "padding" ? "paddingTop" : "marginTop"], i = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [Nm(n), Nm(r), Nm(i)];
}, rz = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return tz;
  var t = nz(e), n = document.documentElement.clientWidth, r = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, r - n + t[2] - t[0])
  };
}, iz = v1(), gs = "data-scroll-locked", oz = function(e, t, n, r) {
  var i = e.left, o = e.top, a = e.right, s = e.gap;
  return n === void 0 && (n = "margin"), `
  .`.concat(WF, ` {
   overflow: hidden `).concat(r, `;
   padding-right: `).concat(s, "px ").concat(r, `;
  }
  body[`).concat(gs, `] {
    overflow: hidden `).concat(r, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(r, ";"),
    n === "margin" && `
    padding-left: `.concat(i, `px;
    padding-top: `).concat(o, `px;
    padding-right: `).concat(a, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(r, `;
    `),
    n === "padding" && "padding-right: ".concat(s, "px ").concat(r, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Bl, ` {
    right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(jl, ` {
    margin-right: `).concat(s, "px ").concat(r, `;
  }
  
  .`).concat(Bl, " .").concat(Bl, ` {
    right: 0 `).concat(r, `;
  }
  
  .`).concat(jl, " .").concat(jl, ` {
    margin-right: 0 `).concat(r, `;
  }
  
  body[`).concat(gs, `] {
    `).concat(UF, ": ").concat(s, `px;
  }
`);
}, Px = function() {
  var e = parseInt(document.body.getAttribute(gs) || "0", 10);
  return isFinite(e) ? e : 0;
}, az = function() {
  C.useEffect(function() {
    return document.body.setAttribute(gs, (Px() + 1).toString()), function() {
      var e = Px() - 1;
      e <= 0 ? document.body.removeAttribute(gs) : document.body.setAttribute(gs, e.toString());
    };
  }, []);
}, QS = function(e) {
  var t = e.noRelative, n = e.noImportant, r = e.gapMode, i = r === void 0 ? "margin" : r;
  az();
  var o = C.useMemo(function() {
    return rz(i);
  }, [i]);
  return C.createElement(iz, { styles: oz(o, !t, i, n ? "" : "!important") });
}, ov = !1;
if (typeof window < "u")
  try {
    var Uu = Object.defineProperty({}, "passive", {
      get: function() {
        return ov = !0, !0;
      }
    });
    window.addEventListener("test", Uu, Uu), window.removeEventListener("test", Uu, Uu);
  } catch {
    ov = !1;
  }
var Xa = ov ? { passive: !1 } : !1, sz = function(e) {
  return e.tagName === "TEXTAREA";
}, JS = function(e, t) {
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !sz(e) && n[t] === "visible")
  );
}, lz = function(e) {
  return JS(e, "overflowY");
}, cz = function(e) {
  return JS(e, "overflowX");
}, kx = function(e, t) {
  var n = t;
  do {
    typeof ShadowRoot < "u" && n instanceof ShadowRoot && (n = n.host);
    var r = e_(e, n);
    if (r) {
      var i = t_(e, n), o = i[1], a = i[2];
      if (o > a)
        return !0;
    }
    n = n.parentNode;
  } while (n && n !== document.body);
  return !1;
}, uz = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, dz = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, e_ = function(e, t) {
  return e === "v" ? lz(t) : cz(t);
}, t_ = function(e, t) {
  return e === "v" ? uz(t) : dz(t);
}, fz = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, hz = function(e, t, n, r, i) {
  var o = fz(e, window.getComputedStyle(t).direction), a = o * r, s = n.target, l = t.contains(s), u = !1, d = a > 0, f = 0, p = 0;
  do {
    var m = t_(e, s), g = m[0], v = m[1], y = m[2], b = v - y - o * g;
    (g || b) && e_(e, s) && (f += b, p += g), s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (d && (i && f === 0 || !i && a > f) || !d && (i && p === 0 || !i && -a > p)) && (u = !0), u;
}, Hu = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Tx = function(e) {
  return [e.deltaX, e.deltaY];
}, Ax = function(e) {
  return e && "current" in e ? e.current : e;
}, pz = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, mz = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, gz = 0, Za = [];
function vz(e) {
  var t = C.useRef([]), n = C.useRef([0, 0]), r = C.useRef(), i = C.useState(gz++)[0], o = C.useState(function() {
    return v1();
  })[0], a = C.useRef(e);
  C.useEffect(function() {
    a.current = e;
  }, [e]), C.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var v = mr([e.lockRef.current], (e.shards || []).map(Ax), !0).filter(Boolean);
      return v.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), v.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = C.useCallback(function(v, y) {
    if ("touches" in v && v.touches.length === 2)
      return !a.current.allowPinchZoom;
    var b = Hu(v), E = n.current, S = "deltaX" in v ? v.deltaX : E[0] - b[0], _ = "deltaY" in v ? v.deltaY : E[1] - b[1], k, T = v.target, A = Math.abs(S) > Math.abs(_) ? "h" : "v";
    if ("touches" in v && A === "h" && T.type === "range")
      return !1;
    var R = kx(A, T);
    if (!R)
      return !0;
    if (R ? k = A : (k = A === "v" ? "h" : "v", R = kx(A, T)), !R)
      return !1;
    if (!r.current && "changedTouches" in v && (S || _) && (r.current = k), !k)
      return !0;
    var F = r.current || k;
    return hz(F, y, v, F === "h" ? S : _, !0);
  }, []), l = C.useCallback(function(v) {
    var y = v;
    if (!(!Za.length || Za[Za.length - 1] !== o)) {
      var b = "deltaY" in y ? Tx(y) : Hu(y), E = t.current.filter(function(k) {
        return k.name === y.type && k.target === y.target && pz(k.delta, b);
      })[0];
      if (E && E.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!E) {
        var S = (a.current.shards || []).map(Ax).filter(Boolean).filter(function(k) {
          return k.contains(y.target);
        }), _ = S.length > 0 ? s(y, S[0]) : !a.current.noIsolation;
        _ && y.cancelable && y.preventDefault();
      }
    }
  }, []), u = C.useCallback(function(v, y, b, E) {
    var S = { name: v, delta: y, target: b, should: E };
    t.current.push(S), setTimeout(function() {
      t.current = t.current.filter(function(_) {
        return _ !== S;
      });
    }, 1);
  }, []), d = C.useCallback(function(v) {
    n.current = Hu(v), r.current = void 0;
  }, []), f = C.useCallback(function(v) {
    u(v.type, Tx(v), v.target, s(v, e.lockRef.current));
  }, []), p = C.useCallback(function(v) {
    u(v.type, Hu(v), v.target, s(v, e.lockRef.current));
  }, []);
  C.useEffect(function() {
    return Za.push(o), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: p
    }), document.addEventListener("wheel", l, Xa), document.addEventListener("touchmove", l, Xa), document.addEventListener("touchstart", d, Xa), function() {
      Za = Za.filter(function(v) {
        return v !== o;
      }), document.removeEventListener("wheel", l, Xa), document.removeEventListener("touchmove", l, Xa), document.removeEventListener("touchstart", d, Xa);
    };
  }, []);
  var m = e.removeScrollBar, g = e.inert;
  return C.createElement(
    C.Fragment,
    null,
    g ? C.createElement(o, { styles: mz(i) }) : null,
    m ? C.createElement(QS, { gapMode: "margin" }) : null
  );
}
const yz = XS(ZS, vz);
var n_ = C.forwardRef(function(e, t) {
  return C.createElement(sh, ye({}, e, { ref: t, sideCar: yz }));
});
n_.classNames = sh.classNames;
const y1 = n_, r_ = "Popover", [i_, sye] = rr(r_, [
  Vs
]), lh = Vs(), [wz, Io] = i_(r_), bz = (e) => {
  const { __scopePopover: t, children: n, open: r, defaultOpen: i, onOpenChange: o, modal: a = !1 } = e, s = lh(t), l = me(null), [u, d] = de(!1), [f = !1, p] = li({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ X(m1, s, /* @__PURE__ */ X(wz, {
    scope: t,
    contentId: ti(),
    triggerRef: l,
    open: f,
    onOpenChange: p,
    onOpenToggle: De(
      () => p(
        (m) => !m
      ),
      [
        p
      ]
    ),
    hasCustomAnchor: u,
    onCustomAnchorAdd: De(
      () => d(!0),
      []
    ),
    onCustomAnchorRemove: De(
      () => d(!1),
      []
    ),
    modal: a
  }, n));
}, xz = "PopoverAnchor", Ez = /* @__PURE__ */ ke((e, t) => {
  const { __scopePopover: n, ...r } = e, i = Io(xz, n), o = lh(n), { onCustomAnchorAdd: a, onCustomAnchorRemove: s } = i;
  return be(() => (a(), () => s()), [
    a,
    s
  ]), /* @__PURE__ */ X(ih, ge({}, o, r, {
    ref: t
  }));
}), Cz = "PopoverTrigger", Sz = /* @__PURE__ */ ke((e, t) => {
  const { __scopePopover: n, ...r } = e, i = Io(Cz, n), o = lh(n), a = Ft(t, i.triggerRef), s = /* @__PURE__ */ X(rt.button, ge({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": i.open,
    "aria-controls": i.contentId,
    "data-state": s_(i.open)
  }, r, {
    ref: a,
    onClick: $e(e.onClick, i.onOpenToggle)
  }));
  return i.hasCustomAnchor ? s : /* @__PURE__ */ X(ih, ge({
    asChild: !0
  }, o), s);
}), o_ = "PopoverPortal", [_z, Pz] = i_(o_, {
  forceMount: void 0
}), kz = (e) => {
  const { __scopePopover: t, forceMount: n, children: r, container: i } = e, o = Io(o_, t);
  return /* @__PURE__ */ X(_z, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ X(On, {
    present: n || o.open
  }, /* @__PURE__ */ X(oh, {
    asChild: !0,
    container: i
  }, r)));
}, rc = "PopoverContent", Tz = /* @__PURE__ */ ke((e, t) => {
  const n = Pz(rc, e.__scopePopover), { forceMount: r = n.forceMount, ...i } = e, o = Io(rc, e.__scopePopover);
  return /* @__PURE__ */ X(On, {
    present: r || o.open
  }, o.modal ? /* @__PURE__ */ X(Az, ge({}, i, {
    ref: t
  })) : /* @__PURE__ */ X(Mz, ge({}, i, {
    ref: t
  })));
}), Az = /* @__PURE__ */ ke((e, t) => {
  const n = Io(rc, e.__scopePopover), r = me(null), i = Ft(t, r), o = me(!1);
  return be(() => {
    const a = r.current;
    if (a)
      return ah(a);
  }, []), /* @__PURE__ */ X(y1, {
    as: qi,
    allowPinchZoom: !0
  }, /* @__PURE__ */ X(a_, ge({}, e, {
    ref: i,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: $e(e.onCloseAutoFocus, (a) => {
      var s;
      a.preventDefault(), o.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus();
    }),
    onPointerDownOutside: $e(e.onPointerDownOutside, (a) => {
      const s = a.detail.originalEvent, l = s.button === 0 && s.ctrlKey === !0, u = s.button === 2 || l;
      o.current = u;
    }, {
      checkForDefaultPrevented: !1
    }),
    onFocusOutside: $e(
      e.onFocusOutside,
      (a) => a.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), Mz = /* @__PURE__ */ ke((e, t) => {
  const n = Io(rc, e.__scopePopover), r = me(!1), i = me(!1);
  return /* @__PURE__ */ X(a_, ge({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (o) => {
      var a;
      if ((a = e.onCloseAutoFocus) === null || a === void 0 || a.call(e, o), !o.defaultPrevented) {
        var s;
        r.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), o.preventDefault();
      }
      r.current = !1, i.current = !1;
    },
    onInteractOutside: (o) => {
      var a, s;
      (a = e.onInteractOutside) === null || a === void 0 || a.call(e, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (i.current = !0));
      const l = o.target;
      ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(l)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && i.current && o.preventDefault();
    }
  }));
}), a_ = /* @__PURE__ */ ke((e, t) => {
  const { __scopePopover: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: o, disableOutsidePointerEvents: a, onEscapeKeyDown: s, onPointerDownOutside: l, onFocusOutside: u, onInteractOutside: d, ...f } = e, p = Io(rc, n), m = lh(n);
  return o1(), /* @__PURE__ */ X(a1, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: i,
    onUnmountAutoFocus: o
  }, /* @__PURE__ */ X(eh, {
    asChild: !0,
    disableOutsidePointerEvents: a,
    onInteractOutside: d,
    onEscapeKeyDown: s,
    onPointerDownOutside: l,
    onFocusOutside: u,
    onDismiss: () => p.onOpenChange(!1)
  }, /* @__PURE__ */ X(g1, ge({
    "data-state": s_(p.open),
    role: "dialog",
    id: p.contentId
  }, m, f, {
    ref: t,
    style: {
      ...f.style,
      "--radix-popover-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-popover-content-available-width": "var(--radix-popper-available-width)",
      "--radix-popover-content-available-height": "var(--radix-popper-available-height)",
      "--radix-popover-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-popover-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }))));
}), Oz = "PopoverClose", Rz = /* @__PURE__ */ ke((e, t) => {
  const { __scopePopover: n, ...r } = e, i = Io(Oz, n);
  return /* @__PURE__ */ X(rt.button, ge({
    type: "button"
  }, r, {
    ref: t,
    onClick: $e(
      e.onClick,
      () => i.onOpenChange(!1)
    )
  }));
});
function s_(e) {
  return e ? "open" : "closed";
}
const l_ = bz, Iz = Ez, c_ = Sz, u_ = kz, w1 = Tz, Dz = Rz;
var Mx = "production", b1 = typeof process > "u" || process.env === void 0 ? Mx : process.env.NODE_ENV || Mx, Vi = function(e) {
  return {
    isEnabled: function(t) {
      return e.some(function(n) {
        return !!t[n];
      });
    }
  };
}, ic = {
  measureLayout: Vi(["layout", "layoutId", "drag"]),
  animation: Vi([
    "animate",
    "exit",
    "variants",
    "whileHover",
    "whileTap",
    "whileFocus",
    "whileDrag",
    "whileInView"
  ]),
  exit: Vi(["exit"]),
  drag: Vi(["drag", "dragControls"]),
  focus: Vi(["whileFocus"]),
  hover: Vi(["whileHover", "onHoverStart", "onHoverEnd"]),
  tap: Vi(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
  pan: Vi([
    "onPan",
    "onPanStart",
    "onPanSessionStart",
    "onPanEnd"
  ]),
  inView: Vi([
    "whileInView",
    "onViewportEnter",
    "onViewportLeave"
  ])
};
function Nz(e) {
  for (var t in e)
    e[t] !== null && (t === "projectionNodeConstructor" ? ic.projectionNodeConstructor = e[t] : ic[t].Component = e[t]);
}
var kc = function() {
}, Nr = function() {
};
process.env.NODE_ENV !== "production" && (kc = function(e, t) {
  !e && typeof console < "u" && console.warn(t);
}, Nr = function(e, t) {
  if (!e)
    throw new Error(t);
});
var d_ = wn({ strict: !1 }), f_ = Object.keys(ic), $z = f_.length;
function Lz(e, t, n) {
  var r = [], i = Me(d_);
  if (!t)
    return null;
  b1 !== "production" && n && i.strict && Nr(!1, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
  for (var o = 0; o < $z; o++) {
    var a = f_[o], s = ic[a], l = s.isEnabled, u = s.Component;
    l(e) && u && r.push(C.createElement(u, ye({ key: a }, e, { visualElement: t })));
  }
  return r;
}
var x1 = wn({
  transformPagePoint: function(e) {
    return e;
  },
  isStatic: !1,
  reducedMotion: "never"
}), ch = wn({});
function Fz() {
  return Me(ch).visualElement;
}
var Tc = wn(null), Bs = typeof document < "u", nf = Bs ? eo : be, av = { current: null }, h_ = !1;
function zz() {
  if (h_ = !0, !!Bs)
    if (window.matchMedia) {
      var e = window.matchMedia("(prefers-reduced-motion)"), t = function() {
        return av.current = e.matches;
      };
      e.addListener(t), t();
    } else
      av.current = !1;
}
function Vz() {
  !h_ && zz();
  var e = Kt(de(av.current), 1), t = e[0];
  return t;
}
function Bz() {
  var e = Vz(), t = Me(x1).reducedMotion;
  return t === "never" ? !1 : t === "always" ? !0 : e;
}
function jz(e, t, n, r) {
  var i = Me(d_), o = Fz(), a = Me(Tc), s = Bz(), l = me(void 0);
  r || (r = i.renderer), !l.current && r && (l.current = r(e, {
    visualState: t,
    parent: o,
    props: n,
    presenceId: a == null ? void 0 : a.id,
    blockInitialAnimation: (a == null ? void 0 : a.initial) === !1,
    shouldReduceMotion: s
  }));
  var u = l.current;
  return nf(function() {
    u == null || u.syncRender();
  }), be(function() {
    var d;
    (d = u == null ? void 0 : u.animationState) === null || d === void 0 || d.animateChanges();
  }), nf(function() {
    return function() {
      return u == null ? void 0 : u.notifyUnmount();
    };
  }, []), u;
}
function ds(e) {
  return typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function Wz(e, t, n) {
  return De(
    function(r) {
      var i;
      r && ((i = e.mount) === null || i === void 0 || i.call(e, r)), t && (r ? t.mount(r) : t.unmount()), n && (typeof n == "function" ? n(r) : ds(n) && (n.current = r));
    },
    /**
     * Only pass a new ref callback to React if we've received a visual element
     * factory. Otherwise we'll be mounting/remounting every time externalRef
     * or other dependencies change.
     */
    [t]
  );
}
function p_(e) {
  return Array.isArray(e);
}
function Qr(e) {
  return typeof e == "string" || p_(e);
}
function Uz(e) {
  var t = {};
  return e.forEachValue(function(n, r) {
    return t[r] = n.get();
  }), t;
}
function Hz(e) {
  var t = {};
  return e.forEachValue(function(n, r) {
    return t[r] = n.getVelocity();
  }), t;
}
function m_(e, t, n, r, i) {
  var o;
  return r === void 0 && (r = {}), i === void 0 && (i = {}), typeof t == "function" && (t = t(n ?? e.custom, r, i)), typeof t == "string" && (t = (o = e.variants) === null || o === void 0 ? void 0 : o[t]), typeof t == "function" && (t = t(n ?? e.custom, r, i)), t;
}
function uh(e, t, n) {
  var r = e.getProps();
  return m_(r, t, n ?? r.custom, Uz(e), Hz(e));
}
function dh(e) {
  var t;
  return typeof ((t = e.animate) === null || t === void 0 ? void 0 : t.start) == "function" || Qr(e.initial) || Qr(e.animate) || Qr(e.whileHover) || Qr(e.whileDrag) || Qr(e.whileTap) || Qr(e.whileFocus) || Qr(e.exit);
}
function g_(e) {
  return !!(dh(e) || e.variants);
}
function Gz(e, t) {
  if (dh(e)) {
    var n = e.initial, r = e.animate;
    return {
      initial: n === !1 || Qr(n) ? n : void 0,
      animate: Qr(r) ? r : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function qz(e) {
  var t = Gz(e, Me(ch)), n = t.initial, r = t.animate;
  return Lt(function() {
    return { initial: n, animate: r };
  }, [Ox(n), Ox(r)]);
}
function Ox(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
function js(e) {
  var t = me(null);
  return t.current === null && (t.current = e()), t.current;
}
var Wl = {
  /**
   * Global flag as to whether the tree has animated since the last time
   * we resized the window
   */
  hasAnimatedSinceResize: !0,
  /**
   * We set this to true once, on the first update. Any nodes added to the tree beyond that
   * update will be given a `data-projection-id` attribute.
   */
  hasEverUpdated: !1
}, Yz = 1;
function Kz() {
  return js(function() {
    if (Wl.hasEverUpdated)
      return Yz++;
  });
}
var E1 = wn({}), v_ = wn({});
function Xz(e, t, n, r) {
  var i, o = t.layoutId, a = t.layout, s = t.drag, l = t.dragConstraints, u = t.layoutScroll, d = Me(v_);
  !r || !n || n != null && n.projection || (n.projection = new r(e, n.getLatestValues(), (i = n.parent) === null || i === void 0 ? void 0 : i.projection), n.projection.setOptions({
    layoutId: o,
    layout: a,
    alwaysMeasureLayout: !!s || l && ds(l),
    visualElement: n,
    scheduleRender: function() {
      return n.scheduleRender();
    },
    /**
     * TODO: Update options in an effect. This could be tricky as it'll be too late
     * to update by the time layout animations run.
     * We also need to fix this safeToRemove by linking it up to the one returned by usePresence,
     * ensuring it gets called if there's no potential layout animations.
     *
     */
    animationType: typeof a == "string" ? a : "both",
    initialPromotionConfig: d,
    layoutScroll: u
  }));
}
var Zz = (
  /** @class */
  function(e) {
    GS(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.getSnapshotBeforeUpdate = function() {
      return this.updateProps(), null;
    }, t.prototype.componentDidUpdate = function() {
    }, t.prototype.updateProps = function() {
      var n = this.props, r = n.visualElement, i = n.props;
      r && r.setProps(i);
    }, t.prototype.render = function() {
      return this.props.children;
    }, t;
  }(x.Component)
);
function Qz(e) {
  var t = e.preloadedFeatures, n = e.createVisualElement, r = e.projectionNodeConstructor, i = e.useRender, o = e.useVisualState, a = e.Component;
  t && Nz(t);
  function s(l, u) {
    var d = Jz(l);
    l = ye(ye({}, l), { layoutId: d });
    var f = Me(x1), p = null, m = qz(l), g = f.isStatic ? void 0 : Kz(), v = o(l, f.isStatic);
    return !f.isStatic && Bs && (m.visualElement = jz(a, v, ye(ye({}, f), l), n), Xz(g, l, m.visualElement, r || ic.projectionNodeConstructor), p = Lz(l, m.visualElement, t)), C.createElement(
      Zz,
      { visualElement: m.visualElement, props: ye(ye({}, f), l) },
      p,
      C.createElement(ch.Provider, { value: m }, i(a, l, g, Wz(v, m.visualElement, u), v, f.isStatic, m.visualElement))
    );
  }
  return ke(s);
}
function Jz(e) {
  var t, n = e.layoutId, r = (t = Me(E1)) === null || t === void 0 ? void 0 : t.id;
  return r && n !== void 0 ? r + "-" + n : n;
}
function eV(e) {
  function t(r, i) {
    return i === void 0 && (i = {}), Qz(e(r, i));
  }
  if (typeof Proxy > "u")
    return t;
  var n = /* @__PURE__ */ new Map();
  return new Proxy(t, {
    /**
     * Called when `motion` is referenced with a prop: `motion.div`, `motion.input` etc.
     * The prop name is passed through as `key` and we can use that to generate a `motion`
     * DOM component with that name.
     */
    get: function(r, i) {
      return n.has(i) || n.set(i, t(i)), n.get(i);
    }
  });
}
var tV = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "tspan",
  "use",
  "view"
];
function C1(e) {
  return (
    /**
     * If it's not a string, it's a custom React component. Currently we only support
     * HTML custom React components.
     */
    typeof e != "string" || /**
     * If it contains a dash, the element is a custom HTML webcomponent.
     */
    e.includes("-") ? !1 : (
      /**
       * If it's in our list of lowercase SVG tags, it's an SVG component
       */
      !!(tV.indexOf(e) > -1 || /**
       * If it contains a capital letter, it's an SVG component
       */
      /[A-Z]/.test(e))
    )
  );
}
var rf = {};
function nV(e) {
  Object.assign(rf, e);
}
var sv = ["", "X", "Y", "Z"], rV = ["translate", "scale", "rotate", "skew"], oc = ["transformPerspective", "x", "y", "z"];
rV.forEach(function(e) {
  return sv.forEach(function(t) {
    return oc.push(e + t);
  });
});
function iV(e, t) {
  return oc.indexOf(e) - oc.indexOf(t);
}
var oV = new Set(oc);
function Ac(e) {
  return oV.has(e);
}
var aV = /* @__PURE__ */ new Set(["originX", "originY", "originZ"]);
function y_(e) {
  return aV.has(e);
}
function w_(e, t) {
  var n = t.layout, r = t.layoutId;
  return Ac(e) || y_(e) || (n || r !== void 0) && (!!rf[e] || e === "opacity");
}
var Xi = function(e) {
  return !!(e !== null && typeof e == "object" && e.getVelocity);
}, sV = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
function lV(e, t, n, r) {
  var i = e.transform, o = e.transformKeys, a = t.enableHardwareAcceleration, s = a === void 0 ? !0 : a, l = t.allowTransformNone, u = l === void 0 ? !0 : l, d = "";
  o.sort(iV);
  for (var f = !1, p = o.length, m = 0; m < p; m++) {
    var g = o[m];
    d += "".concat(sV[g] || g, "(").concat(i[g], ") "), g === "z" && (f = !0);
  }
  return !f && s ? d += "translateZ(0)" : d = d.trim(), r ? d = r(i, n ? "" : d) : u && n && (d = "none"), d;
}
function cV(e) {
  var t = e.originX, n = t === void 0 ? "50%" : t, r = e.originY, i = r === void 0 ? "50%" : r, o = e.originZ, a = o === void 0 ? 0 : o;
  return "".concat(n, " ").concat(i, " ").concat(a);
}
function b_(e) {
  return e.startsWith("--");
}
var uV = function(e, t) {
  return t && typeof e == "number" ? t.transform(e) : e;
};
const x_ = (e, t) => (n) => Math.max(Math.min(n, t), e), Ul = (e) => e % 1 ? Number(e.toFixed(5)) : e, ac = /(-)?([\d]*\.?[\d])+/g, lv = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi, dV = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function Mc(e) {
  return typeof e == "string";
}
const ka = {
  test: (e) => typeof e == "number",
  parse: parseFloat,
  transform: (e) => e
}, Hl = Object.assign(Object.assign({}, ka), { transform: x_(0, 1) }), Gu = Object.assign(Object.assign({}, ka), { default: 1 }), Oc = (e) => ({
  test: (t) => Mc(t) && t.endsWith(e) && t.split(" ").length === 1,
  parse: parseFloat,
  transform: (t) => `${t}${e}`
}), xo = Oc("deg"), wi = Oc("%"), Ue = Oc("px"), fV = Oc("vh"), hV = Oc("vw"), Rx = Object.assign(Object.assign({}, wi), { parse: (e) => wi.parse(e) / 100, transform: (e) => wi.transform(e * 100) }), S1 = (e, t) => (n) => !!(Mc(n) && dV.test(n) && n.startsWith(e) || t && Object.prototype.hasOwnProperty.call(n, t)), E_ = (e, t, n) => (r) => {
  if (!Mc(r))
    return r;
  const [i, o, a, s] = r.match(ac);
  return {
    [e]: parseFloat(i),
    [t]: parseFloat(o),
    [n]: parseFloat(a),
    alpha: s !== void 0 ? parseFloat(s) : 1
  };
}, ca = {
  test: S1("hsl", "hue"),
  parse: E_("hue", "saturation", "lightness"),
  transform: ({ hue: e, saturation: t, lightness: n, alpha: r = 1 }) => "hsla(" + Math.round(e) + ", " + wi.transform(Ul(t)) + ", " + wi.transform(Ul(n)) + ", " + Ul(Hl.transform(r)) + ")"
}, pV = x_(0, 255), $m = Object.assign(Object.assign({}, ka), { transform: (e) => Math.round(pV(e)) }), Po = {
  test: S1("rgb", "red"),
  parse: E_("red", "green", "blue"),
  transform: ({ red: e, green: t, blue: n, alpha: r = 1 }) => "rgba(" + $m.transform(e) + ", " + $m.transform(t) + ", " + $m.transform(n) + ", " + Ul(Hl.transform(r)) + ")"
};
function mV(e) {
  let t = "", n = "", r = "", i = "";
  return e.length > 5 ? (t = e.substr(1, 2), n = e.substr(3, 2), r = e.substr(5, 2), i = e.substr(7, 2)) : (t = e.substr(1, 1), n = e.substr(2, 1), r = e.substr(3, 1), i = e.substr(4, 1), t += t, n += n, r += r, i += i), {
    red: parseInt(t, 16),
    green: parseInt(n, 16),
    blue: parseInt(r, 16),
    alpha: i ? parseInt(i, 16) / 255 : 1
  };
}
const cv = {
  test: S1("#"),
  parse: mV,
  transform: Po.transform
}, zn = {
  test: (e) => Po.test(e) || cv.test(e) || ca.test(e),
  parse: (e) => Po.test(e) ? Po.parse(e) : ca.test(e) ? ca.parse(e) : cv.parse(e),
  transform: (e) => Mc(e) ? e : e.hasOwnProperty("red") ? Po.transform(e) : ca.transform(e)
}, C_ = "${c}", S_ = "${n}";
function gV(e) {
  var t, n, r, i;
  return isNaN(e) && Mc(e) && ((n = (t = e.match(ac)) === null || t === void 0 ? void 0 : t.length) !== null && n !== void 0 ? n : 0) + ((i = (r = e.match(lv)) === null || r === void 0 ? void 0 : r.length) !== null && i !== void 0 ? i : 0) > 0;
}
function __(e) {
  typeof e == "number" && (e = `${e}`);
  const t = [];
  let n = 0;
  const r = e.match(lv);
  r && (n = r.length, e = e.replace(lv, C_), t.push(...r.map(zn.parse)));
  const i = e.match(ac);
  return i && (e = e.replace(ac, S_), t.push(...i.map(ka.parse))), { values: t, numColors: n, tokenised: e };
}
function P_(e) {
  return __(e).values;
}
function k_(e) {
  const { values: t, numColors: n, tokenised: r } = __(e), i = t.length;
  return (o) => {
    let a = r;
    for (let s = 0; s < i; s++)
      a = a.replace(s < n ? C_ : S_, s < n ? zn.transform(o[s]) : Ul(o[s]));
    return a;
  };
}
const vV = (e) => typeof e == "number" ? 0 : e;
function yV(e) {
  const t = P_(e);
  return k_(e)(t.map(vV));
}
const Zi = { test: gV, parse: P_, createTransformer: k_, getAnimatableNone: yV }, wV = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function bV(e) {
  let [t, n] = e.slice(0, -1).split("(");
  if (t === "drop-shadow")
    return e;
  const [r] = n.match(ac) || [];
  if (!r)
    return e;
  const i = n.replace(r, "");
  let o = wV.has(t) ? 1 : 0;
  return r !== n && (o *= 100), t + "(" + o + i + ")";
}
const xV = /([a-z-]*)\(.*?\)/g, uv = Object.assign(Object.assign({}, Zi), { getAnimatableNone: (e) => {
  const t = e.match(xV);
  return t ? t.map(bV).join(" ") : e;
} });
var Ix = ye(ye({}, ka), { transform: Math.round }), T_ = {
  // Border props
  borderWidth: Ue,
  borderTopWidth: Ue,
  borderRightWidth: Ue,
  borderBottomWidth: Ue,
  borderLeftWidth: Ue,
  borderRadius: Ue,
  radius: Ue,
  borderTopLeftRadius: Ue,
  borderTopRightRadius: Ue,
  borderBottomRightRadius: Ue,
  borderBottomLeftRadius: Ue,
  // Positioning props
  width: Ue,
  maxWidth: Ue,
  height: Ue,
  maxHeight: Ue,
  size: Ue,
  top: Ue,
  right: Ue,
  bottom: Ue,
  left: Ue,
  // Spacing props
  padding: Ue,
  paddingTop: Ue,
  paddingRight: Ue,
  paddingBottom: Ue,
  paddingLeft: Ue,
  margin: Ue,
  marginTop: Ue,
  marginRight: Ue,
  marginBottom: Ue,
  marginLeft: Ue,
  // Transform props
  rotate: xo,
  rotateX: xo,
  rotateY: xo,
  rotateZ: xo,
  scale: Gu,
  scaleX: Gu,
  scaleY: Gu,
  scaleZ: Gu,
  skew: xo,
  skewX: xo,
  skewY: xo,
  distance: Ue,
  translateX: Ue,
  translateY: Ue,
  translateZ: Ue,
  x: Ue,
  y: Ue,
  z: Ue,
  perspective: Ue,
  transformPerspective: Ue,
  opacity: Hl,
  originX: Rx,
  originY: Rx,
  originZ: Ue,
  // Misc
  zIndex: Ix,
  // SVG
  fillOpacity: Hl,
  strokeOpacity: Hl,
  numOctaves: Ix
};
function _1(e, t, n, r) {
  var i, o = e.style, a = e.vars, s = e.transform, l = e.transformKeys, u = e.transformOrigin;
  l.length = 0;
  var d = !1, f = !1, p = !0;
  for (var m in t) {
    var g = t[m];
    if (b_(m)) {
      a[m] = g;
      continue;
    }
    var v = T_[m], y = uV(g, v);
    if (Ac(m)) {
      if (d = !0, s[m] = y, l.push(m), !p)
        continue;
      g !== ((i = v.default) !== null && i !== void 0 ? i : 0) && (p = !1);
    } else
      y_(m) ? (u[m] = y, f = !0) : o[m] = y;
  }
  d ? o.transform = lV(e, n, p, r) : r ? o.transform = r({}, "") : !t.transform && o.transform && (o.transform = "none"), f && (o.transformOrigin = cV(u));
}
var P1 = function() {
  return {
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {}
  };
};
function A_(e, t, n) {
  for (var r in t)
    !Xi(t[r]) && !w_(r, n) && (e[r] = t[r]);
}
function EV(e, t, n) {
  var r = e.transformTemplate;
  return Lt(function() {
    var i = P1();
    _1(i, t, { enableHardwareAcceleration: !n }, r);
    var o = i.vars, a = i.style;
    return ye(ye({}, o), a);
  }, [t]);
}
function CV(e, t, n) {
  var r = e.style || {}, i = {};
  return A_(i, r, e), Object.assign(i, EV(e, t, n)), e.transformValues && (i = e.transformValues(i)), i;
}
function SV(e, t, n) {
  var r = {}, i = CV(e, t, n);
  return e.drag && e.dragListener !== !1 && (r.draggable = !1, i.userSelect = i.WebkitUserSelect = i.WebkitTouchCallout = "none", i.touchAction = e.drag === !0 ? "none" : "pan-".concat(e.drag === "x" ? "y" : "x")), r.style = i, r;
}
var _V = /* @__PURE__ */ new Set([
  "initial",
  "animate",
  "exit",
  "style",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "layout",
  "layoutId",
  "layoutDependency",
  "onLayoutAnimationStart",
  "onLayoutAnimationComplete",
  "onLayoutMeasure",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "drag",
  "dragControls",
  "dragListener",
  "dragConstraints",
  "dragDirectionLock",
  "dragSnapToOrigin",
  "_dragX",
  "_dragY",
  "dragElastic",
  "dragMomentum",
  "dragPropagation",
  "dragTransition",
  "whileDrag",
  "onPan",
  "onPanStart",
  "onPanEnd",
  "onPanSessionStart",
  "onTap",
  "onTapStart",
  "onTapCancel",
  "onHoverStart",
  "onHoverEnd",
  "whileFocus",
  "whileTap",
  "whileHover",
  "whileInView",
  "onViewportEnter",
  "onViewportLeave",
  "viewport",
  "layoutScroll"
]);
function of(e) {
  return _V.has(e);
}
var M_ = function(e) {
  return !of(e);
};
function PV(e) {
  e && (M_ = function(t) {
    return t.startsWith("on") ? !of(t) : e(t);
  });
}
try {
  PV(require("@emotion/is-prop-valid").default);
} catch {
}
function kV(e, t, n) {
  var r = {};
  for (var i in e)
    (M_(i) || n === !0 && of(i) || !t && !of(i) || // If trying to use native HTML drag events, forward drag listeners
    e.draggable && i.startsWith("onDrag")) && (r[i] = e[i]);
  return r;
}
function Dx(e, t, n) {
  return typeof e == "string" ? e : Ue.transform(t + n * e);
}
function TV(e, t, n) {
  var r = Dx(t, e.x, e.width), i = Dx(n, e.y, e.height);
  return "".concat(r, " ").concat(i);
}
var AV = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, MV = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function OV(e, t, n, r, i) {
  n === void 0 && (n = 1), r === void 0 && (r = 0), i === void 0 && (i = !0), e.pathLength = 1;
  var o = i ? AV : MV;
  e[o.offset] = Ue.transform(-r);
  var a = Ue.transform(t), s = Ue.transform(n);
  e[o.array] = "".concat(a, " ").concat(s);
}
function k1(e, t, n, r) {
  var i = t.attrX, o = t.attrY, a = t.originX, s = t.originY, l = t.pathLength, u = t.pathSpacing, d = u === void 0 ? 1 : u, f = t.pathOffset, p = f === void 0 ? 0 : f, m = Bn(t, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
  _1(e, m, n, r), e.attrs = e.style, e.style = {};
  var g = e.attrs, v = e.style, y = e.dimensions;
  g.transform && (y && (v.transform = g.transform), delete g.transform), y && (a !== void 0 || s !== void 0 || v.transform) && (v.transformOrigin = TV(y, a !== void 0 ? a : 0.5, s !== void 0 ? s : 0.5)), i !== void 0 && (g.x = i), o !== void 0 && (g.y = o), l !== void 0 && OV(g, l, d, p, !1);
}
var O_ = function() {
  return ye(ye({}, P1()), { attrs: {} });
};
function RV(e, t) {
  var n = Lt(function() {
    var i = O_();
    return k1(i, t, { enableHardwareAcceleration: !1 }, e.transformTemplate), ye(ye({}, i.attrs), { style: ye({}, i.style) });
  }, [t]);
  if (e.style) {
    var r = {};
    A_(r, e.style, e), n.style = ye(ye({}, r), n.style);
  }
  return n;
}
function IV(e) {
  e === void 0 && (e = !1);
  var t = function(n, r, i, o, a, s) {
    var l = a.latestValues, u = C1(n) ? RV : SV, d = u(r, l, s), f = kV(r, typeof n == "string", e), p = ye(ye(ye({}, f), d), { ref: o });
    return i && (p["data-projection-id"] = i), X(n, p);
  };
  return t;
}
var DV = /([a-z])([A-Z])/g, NV = "$1-$2", R_ = function(e) {
  return e.replace(DV, NV).toLowerCase();
};
function I_(e, t, n, r) {
  var i = t.style, o = t.vars;
  Object.assign(e.style, i, r && r.getProjectionStyles(n));
  for (var a in o)
    e.style.setProperty(a, o[a]);
}
var D_ = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform",
  "pathLength"
]);
function N_(e, t, n, r) {
  I_(e, t, void 0, r);
  for (var i in t.attrs)
    e.setAttribute(D_.has(i) ? i : R_(i), t.attrs[i]);
}
function T1(e) {
  var t = e.style, n = {};
  for (var r in t)
    (Xi(t[r]) || w_(r, e)) && (n[r] = t[r]);
  return n;
}
function $_(e) {
  var t = T1(e);
  for (var n in e)
    if (Xi(e[n])) {
      var r = n === "x" || n === "y" ? "attr" + n.toUpperCase() : n;
      t[r] = e[n];
    }
  return t;
}
function A1(e) {
  return typeof e == "object" && typeof e.start == "function";
}
var sc = function(e) {
  return Array.isArray(e);
}, $V = function(e) {
  return !!(e && typeof e == "object" && e.mix && e.toValue);
}, L_ = function(e) {
  return sc(e) ? e[e.length - 1] || 0 : e;
};
function Nd(e) {
  var t = Xi(e) ? e.get() : e;
  return $V(t) ? t.toValue() : t;
}
function Nx(e, t, n, r) {
  var i = e.scrapeMotionValuesFromProps, o = e.createRenderState, a = e.onMount, s = {
    latestValues: LV(t, n, r, i),
    renderState: o()
  };
  return a && (s.mount = function(l) {
    return a(t, l, s);
  }), s;
}
var F_ = function(e) {
  return function(t, n) {
    var r = Me(ch), i = Me(Tc);
    return n ? Nx(e, t, r, i) : js(function() {
      return Nx(e, t, r, i);
    });
  };
};
function LV(e, t, n, r) {
  var i = {}, o = (n == null ? void 0 : n.initial) === !1, a = r(e);
  for (var s in a)
    i[s] = Nd(a[s]);
  var l = e.initial, u = e.animate, d = dh(e), f = g_(e);
  t && f && !d && e.inherit !== !1 && (l ?? (l = t.initial), u ?? (u = t.animate));
  var p = o || l === !1, m = p ? u : l;
  if (m && typeof m != "boolean" && !A1(m)) {
    var g = Array.isArray(m) ? m : [m];
    g.forEach(function(v) {
      var y = m_(e, v);
      if (y) {
        var b = y.transitionEnd;
        y.transition;
        var E = Bn(y, ["transitionEnd", "transition"]);
        for (var S in E) {
          var _ = E[S];
          if (Array.isArray(_)) {
            var k = p ? _.length - 1 : 0;
            _ = _[k];
          }
          _ !== null && (i[S] = _);
        }
        for (var S in b)
          i[S] = b[S];
      }
    });
  }
  return i;
}
var FV = {
  useVisualState: F_({
    scrapeMotionValuesFromProps: $_,
    createRenderState: O_,
    onMount: function(e, t, n) {
      var r = n.renderState, i = n.latestValues;
      try {
        r.dimensions = typeof t.getBBox == "function" ? t.getBBox() : t.getBoundingClientRect();
      } catch {
        r.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      k1(r, i, { enableHardwareAcceleration: !1 }, e.transformTemplate), N_(t, r);
    }
  })
}, zV = {
  useVisualState: F_({
    scrapeMotionValuesFromProps: T1,
    createRenderState: P1
  })
};
function VV(e, t, n, r, i) {
  var o = t.forwardMotionProps, a = o === void 0 ? !1 : o, s = C1(e) ? FV : zV;
  return ye(ye({}, s), { preloadedFeatures: n, useRender: IV(a), createVisualElement: r, projectionNodeConstructor: i, Component: e });
}
var Rt;
(function(e) {
  e.Animate = "animate", e.Hover = "whileHover", e.Tap = "whileTap", e.Drag = "whileDrag", e.Focus = "whileFocus", e.InView = "whileInView", e.Exit = "exit";
})(Rt || (Rt = {}));
function fh(e, t, n, r) {
  return r === void 0 && (r = { passive: !0 }), e.addEventListener(t, n, r), function() {
    return e.removeEventListener(t, n);
  };
}
function dv(e, t, n, r) {
  be(function() {
    var i = e.current;
    if (n && i)
      return fh(i, t, n, r);
  }, [e, t, n, r]);
}
function BV(e) {
  var t = e.whileFocus, n = e.visualElement, r = function() {
    var o;
    (o = n.animationState) === null || o === void 0 || o.setActive(Rt.Focus, !0);
  }, i = function() {
    var o;
    (o = n.animationState) === null || o === void 0 || o.setActive(Rt.Focus, !1);
  };
  dv(n, "focus", t ? r : void 0), dv(n, "blur", t ? i : void 0);
}
function z_(e) {
  return typeof PointerEvent < "u" && e instanceof PointerEvent ? e.pointerType === "mouse" : e instanceof MouseEvent;
}
function V_(e) {
  var t = !!e.touches;
  return t;
}
function jV(e) {
  return function(t) {
    var n = t instanceof MouseEvent, r = !n || n && t.button === 0;
    r && e(t);
  };
}
var WV = { pageX: 0, pageY: 0 };
function UV(e, t) {
  t === void 0 && (t = "page");
  var n = e.touches[0] || e.changedTouches[0], r = n || WV;
  return {
    x: r[t + "X"],
    y: r[t + "Y"]
  };
}
function HV(e, t) {
  return t === void 0 && (t = "page"), {
    x: e[t + "X"],
    y: e[t + "Y"]
  };
}
function M1(e, t) {
  return t === void 0 && (t = "page"), {
    point: V_(e) ? UV(e, t) : HV(e, t)
  };
}
var B_ = function(e, t) {
  t === void 0 && (t = !1);
  var n = function(r) {
    return e(r, M1(r));
  };
  return t ? jV(n) : n;
}, GV = function() {
  return Bs && window.onpointerdown === null;
}, qV = function() {
  return Bs && window.ontouchstart === null;
}, YV = function() {
  return Bs && window.onmousedown === null;
}, KV = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
}, XV = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function j_(e) {
  return GV() ? e : qV() ? XV[e] : YV() ? KV[e] : e;
}
function vs(e, t, n, r) {
  return fh(e, j_(t), B_(n, t === "pointerdown"), r);
}
function af(e, t, n, r) {
  return dv(e, j_(t), n && B_(n, t === "pointerdown"), r);
}
function W_(e) {
  var t = null;
  return function() {
    var n = function() {
      t = null;
    };
    return t === null ? (t = e, n) : !1;
  };
}
var $x = W_("dragHorizontal"), Lx = W_("dragVertical");
function U_(e) {
  var t = !1;
  if (e === "y")
    t = Lx();
  else if (e === "x")
    t = $x();
  else {
    var n = $x(), r = Lx();
    n && r ? t = function() {
      n(), r();
    } : (n && n(), r && r());
  }
  return t;
}
function H_() {
  var e = U_(!0);
  return e ? (e(), !1) : !0;
}
function Fx(e, t, n) {
  return function(r, i) {
    var o;
    !z_(r) || H_() || ((o = e.animationState) === null || o === void 0 || o.setActive(Rt.Hover, t), n == null || n(r, i));
  };
}
function ZV(e) {
  var t = e.onHoverStart, n = e.onHoverEnd, r = e.whileHover, i = e.visualElement;
  af(i, "pointerenter", t || r ? Fx(i, !0, t) : void 0, { passive: !t }), af(i, "pointerleave", n || r ? Fx(i, !1, n) : void 0, { passive: !n });
}
var G_ = function(e, t) {
  return t ? e === t ? !0 : G_(e, t.parentElement) : !1;
};
function O1(e) {
  return be(function() {
    return function() {
      return e();
    };
  }, []);
}
const sf = (e, t, n) => Math.min(Math.max(n, e), t), Lm = 1e-3, QV = 0.01, zx = 10, JV = 0.05, eB = 1;
function tB({ duration: e = 800, bounce: t = 0.25, velocity: n = 0, mass: r = 1 }) {
  let i, o;
  kc(e <= zx * 1e3, "Spring duration must be 10 seconds or less");
  let a = 1 - t;
  a = sf(JV, eB, a), e = sf(QV, zx, e / 1e3), a < 1 ? (i = (u) => {
    const d = u * a, f = d * e, p = d - n, m = fv(u, a), g = Math.exp(-f);
    return Lm - p / m * g;
  }, o = (u) => {
    const f = u * a * e, p = f * n + n, m = Math.pow(a, 2) * Math.pow(u, 2) * e, g = Math.exp(-f), v = fv(Math.pow(u, 2), a);
    return (-i(u) + Lm > 0 ? -1 : 1) * ((p - m) * g) / v;
  }) : (i = (u) => {
    const d = Math.exp(-u * e), f = (u - n) * e + 1;
    return -Lm + d * f;
  }, o = (u) => {
    const d = Math.exp(-u * e), f = (n - u) * (e * e);
    return d * f;
  });
  const s = 5 / e, l = rB(i, o, s);
  if (e = e * 1e3, isNaN(l))
    return {
      stiffness: 100,
      damping: 10,
      duration: e
    };
  {
    const u = Math.pow(l, 2) * r;
    return {
      stiffness: u,
      damping: a * 2 * Math.sqrt(r * u),
      duration: e
    };
  }
}
const nB = 12;
function rB(e, t, n) {
  let r = n;
  for (let i = 1; i < nB; i++)
    r = r - e(r) / t(r);
  return r;
}
function fv(e, t) {
  return e * Math.sqrt(1 - t * t);
}
const iB = ["duration", "bounce"], oB = ["stiffness", "damping", "mass"];
function Vx(e, t) {
  return t.some((n) => e[n] !== void 0);
}
function aB(e) {
  let t = Object.assign({ velocity: 0, stiffness: 100, damping: 10, mass: 1, isResolvedFromDuration: !1 }, e);
  if (!Vx(e, oB) && Vx(e, iB)) {
    const n = tB(e);
    t = Object.assign(Object.assign(Object.assign({}, t), n), { velocity: 0, mass: 1 }), t.isResolvedFromDuration = !0;
  }
  return t;
}
function R1(e) {
  var { from: t = 0, to: n = 1, restSpeed: r = 2, restDelta: i } = e, o = Bn(e, ["from", "to", "restSpeed", "restDelta"]);
  const a = { done: !1, value: t };
  let { stiffness: s, damping: l, mass: u, velocity: d, duration: f, isResolvedFromDuration: p } = aB(o), m = Bx, g = Bx;
  function v() {
    const y = d ? -(d / 1e3) : 0, b = n - t, E = l / (2 * Math.sqrt(s * u)), S = Math.sqrt(s / u) / 1e3;
    if (i === void 0 && (i = Math.min(Math.abs(n - t) / 100, 0.4)), E < 1) {
      const _ = fv(S, E);
      m = (k) => {
        const T = Math.exp(-E * S * k);
        return n - T * ((y + E * S * b) / _ * Math.sin(_ * k) + b * Math.cos(_ * k));
      }, g = (k) => {
        const T = Math.exp(-E * S * k);
        return E * S * T * (Math.sin(_ * k) * (y + E * S * b) / _ + b * Math.cos(_ * k)) - T * (Math.cos(_ * k) * (y + E * S * b) - _ * b * Math.sin(_ * k));
      };
    } else if (E === 1)
      m = (_) => n - Math.exp(-S * _) * (b + (y + S * b) * _);
    else {
      const _ = S * Math.sqrt(E * E - 1);
      m = (k) => {
        const T = Math.exp(-E * S * k), A = Math.min(_ * k, 300);
        return n - T * ((y + E * S * b) * Math.sinh(A) + _ * b * Math.cosh(A)) / _;
      };
    }
  }
  return v(), {
    next: (y) => {
      const b = m(y);
      if (p)
        a.done = y >= f;
      else {
        const E = g(y) * 1e3, S = Math.abs(E) <= r, _ = Math.abs(n - b) <= i;
        a.done = S && _;
      }
      return a.value = a.done ? n : b, a;
    },
    flipTarget: () => {
      d = -d, [t, n] = [n, t], v();
    }
  };
}
R1.needsInterpolation = (e, t) => typeof e == "string" || typeof t == "string";
const Bx = (e) => 0, lc = (e, t, n) => {
  const r = t - e;
  return r === 0 ? 1 : (n - e) / r;
}, Yt = (e, t, n) => -n * e + n * t + e;
function Fm(e, t, n) {
  return n < 0 && (n += 1), n > 1 && (n -= 1), n < 1 / 6 ? e + (t - e) * 6 * n : n < 1 / 2 ? t : n < 2 / 3 ? e + (t - e) * (2 / 3 - n) * 6 : e;
}
function jx({ hue: e, saturation: t, lightness: n, alpha: r }) {
  e /= 360, t /= 100, n /= 100;
  let i = 0, o = 0, a = 0;
  if (!t)
    i = o = a = n;
  else {
    const s = n < 0.5 ? n * (1 + t) : n + t - n * t, l = 2 * n - s;
    i = Fm(l, s, e + 1 / 3), o = Fm(l, s, e), a = Fm(l, s, e - 1 / 3);
  }
  return {
    red: Math.round(i * 255),
    green: Math.round(o * 255),
    blue: Math.round(a * 255),
    alpha: r
  };
}
const sB = (e, t, n) => {
  const r = e * e, i = t * t;
  return Math.sqrt(Math.max(0, n * (i - r) + r));
}, lB = [cv, Po, ca], Wx = (e) => lB.find((t) => t.test(e)), Ux = (e) => `'${e}' is not an animatable color. Use the equivalent color code instead.`, q_ = (e, t) => {
  let n = Wx(e), r = Wx(t);
  Nr(!!n, Ux(e)), Nr(!!r, Ux(t));
  let i = n.parse(e), o = r.parse(t);
  n === ca && (i = jx(i), n = Po), r === ca && (o = jx(o), r = Po);
  const a = Object.assign({}, i);
  return (s) => {
    for (const l in a)
      l !== "alpha" && (a[l] = sB(i[l], o[l], s));
    return a.alpha = Yt(i.alpha, o.alpha, s), n.transform(a);
  };
}, hv = (e) => typeof e == "number", cB = (e, t) => (n) => t(e(n)), hh = (...e) => e.reduce(cB);
function Y_(e, t) {
  return hv(e) ? (n) => Yt(e, t, n) : zn.test(e) ? q_(e, t) : X_(e, t);
}
const K_ = (e, t) => {
  const n = [...e], r = n.length, i = e.map((o, a) => Y_(o, t[a]));
  return (o) => {
    for (let a = 0; a < r; a++)
      n[a] = i[a](o);
    return n;
  };
}, uB = (e, t) => {
  const n = Object.assign(Object.assign({}, e), t), r = {};
  for (const i in n)
    e[i] !== void 0 && t[i] !== void 0 && (r[i] = Y_(e[i], t[i]));
  return (i) => {
    for (const o in r)
      n[o] = r[o](i);
    return n;
  };
};
function Hx(e) {
  const t = Zi.parse(e), n = t.length;
  let r = 0, i = 0, o = 0;
  for (let a = 0; a < n; a++)
    r || typeof t[a] == "number" ? r++ : t[a].hue !== void 0 ? o++ : i++;
  return { parsed: t, numNumbers: r, numRGB: i, numHSL: o };
}
const X_ = (e, t) => {
  const n = Zi.createTransformer(t), r = Hx(e), i = Hx(t);
  return r.numHSL === i.numHSL && r.numRGB === i.numRGB && r.numNumbers >= i.numNumbers ? hh(K_(r.parsed, i.parsed), n) : (kc(!0, `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`), (a) => `${a > 0 ? t : e}`);
}, dB = (e, t) => (n) => Yt(e, t, n);
function fB(e) {
  if (typeof e == "number")
    return dB;
  if (typeof e == "string")
    return zn.test(e) ? q_ : X_;
  if (Array.isArray(e))
    return K_;
  if (typeof e == "object")
    return uB;
}
function hB(e, t, n) {
  const r = [], i = n || fB(e[0]), o = e.length - 1;
  for (let a = 0; a < o; a++) {
    let s = i(e[a], e[a + 1]);
    if (t) {
      const l = Array.isArray(t) ? t[a] : t;
      s = hh(l, s);
    }
    r.push(s);
  }
  return r;
}
function pB([e, t], [n]) {
  return (r) => n(lc(e, t, r));
}
function mB(e, t) {
  const n = e.length, r = n - 1;
  return (i) => {
    let o = 0, a = !1;
    if (i <= e[0] ? a = !0 : i >= e[r] && (o = r - 1, a = !0), !a) {
      let l = 1;
      for (; l < n && !(e[l] > i || l === r); l++)
        ;
      o = l - 1;
    }
    const s = lc(e[o], e[o + 1], i);
    return t[o](s);
  };
}
function Z_(e, t, { clamp: n = !0, ease: r, mixer: i } = {}) {
  const o = e.length;
  Nr(o === t.length, "Both input and output ranges must be the same length"), Nr(!r || !Array.isArray(r) || r.length === o - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values."), e[0] > e[o - 1] && (e = [].concat(e), t = [].concat(t), e.reverse(), t.reverse());
  const a = hB(t, r, i), s = o === 2 ? pB(e, a) : mB(e, a);
  return n ? (l) => s(sf(e[0], e[o - 1], l)) : s;
}
const ph = (e) => (t) => 1 - e(1 - t), I1 = (e) => (t) => t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2, gB = (e) => (t) => Math.pow(t, e), Q_ = (e) => (t) => t * t * ((e + 1) * t - e), vB = (e) => {
  const t = Q_(e);
  return (n) => (n *= 2) < 1 ? 0.5 * t(n) : 0.5 * (2 - Math.pow(2, -10 * (n - 1)));
}, J_ = 1.525, yB = 4 / 11, wB = 8 / 11, bB = 9 / 10, D1 = (e) => e, N1 = gB(2), xB = ph(N1), e5 = I1(N1), t5 = (e) => 1 - Math.sin(Math.acos(e)), $1 = ph(t5), EB = I1($1), L1 = Q_(J_), CB = ph(L1), SB = I1(L1), _B = vB(J_), PB = 4356 / 361, kB = 35442 / 1805, TB = 16061 / 1805, lf = (e) => {
  if (e === 1 || e === 0)
    return e;
  const t = e * e;
  return e < yB ? 7.5625 * t : e < wB ? 9.075 * t - 9.9 * e + 3.4 : e < bB ? PB * t - kB * e + TB : 10.8 * e * e - 20.52 * e + 10.72;
}, AB = ph(lf), MB = (e) => e < 0.5 ? 0.5 * (1 - lf(1 - e * 2)) : 0.5 * lf(e * 2 - 1) + 0.5;
function OB(e, t) {
  return e.map(() => t || e5).splice(0, e.length - 1);
}
function RB(e) {
  const t = e.length;
  return e.map((n, r) => r !== 0 ? r / (t - 1) : 0);
}
function IB(e, t) {
  return e.map((n) => n * t);
}
function $d({ from: e = 0, to: t = 1, ease: n, offset: r, duration: i = 300 }) {
  const o = { done: !1, value: e }, a = Array.isArray(t) ? t : [e, t], s = IB(r && r.length === a.length ? r : RB(a), i);
  function l() {
    return Z_(s, a, {
      ease: Array.isArray(n) ? n : OB(a, n)
    });
  }
  let u = l();
  return {
    next: (d) => (o.value = u(d), o.done = d >= i, o),
    flipTarget: () => {
      a.reverse(), u = l();
    }
  };
}
function DB({ velocity: e = 0, from: t = 0, power: n = 0.8, timeConstant: r = 350, restDelta: i = 0.5, modifyTarget: o }) {
  const a = { done: !1, value: t };
  let s = n * e;
  const l = t + s, u = o === void 0 ? l : o(l);
  return u !== l && (s = u - t), {
    next: (d) => {
      const f = -s * Math.exp(-d / r);
      return a.done = !(f > i || f < -i), a.value = a.done ? u : u + f, a;
    },
    flipTarget: () => {
    }
  };
}
const Gx = { keyframes: $d, spring: R1, decay: DB };
function NB(e) {
  if (Array.isArray(e.to))
    return $d;
  if (Gx[e.type])
    return Gx[e.type];
  const t = new Set(Object.keys(e));
  return t.has("ease") || t.has("duration") && !t.has("dampingRatio") ? $d : t.has("dampingRatio") || t.has("stiffness") || t.has("mass") || t.has("damping") || t.has("restSpeed") || t.has("restDelta") ? R1 : $d;
}
const n5 = 1 / 60 * 1e3, $B = typeof performance < "u" ? () => performance.now() : () => Date.now(), r5 = typeof window < "u" ? (e) => window.requestAnimationFrame(e) : (e) => setTimeout(() => e($B()), n5);
function LB(e) {
  let t = [], n = [], r = 0, i = !1, o = !1;
  const a = /* @__PURE__ */ new WeakSet(), s = {
    schedule: (l, u = !1, d = !1) => {
      const f = d && i, p = f ? t : n;
      return u && a.add(l), p.indexOf(l) === -1 && (p.push(l), f && i && (r = t.length)), l;
    },
    cancel: (l) => {
      const u = n.indexOf(l);
      u !== -1 && n.splice(u, 1), a.delete(l);
    },
    process: (l) => {
      if (i) {
        o = !0;
        return;
      }
      if (i = !0, [t, n] = [n, t], n.length = 0, r = t.length, r)
        for (let u = 0; u < r; u++) {
          const d = t[u];
          d(l), a.has(d) && (s.schedule(d), e());
        }
      i = !1, o && (o = !1, s.process(l));
    }
  };
  return s;
}
const FB = 40;
let pv = !0, cc = !1, mv = !1;
const ys = {
  delta: 0,
  timestamp: 0
}, Rc = [
  "read",
  "update",
  "preRender",
  "render",
  "postRender"
], mh = Rc.reduce((e, t) => (e[t] = LB(() => cc = !0), e), {}), ni = Rc.reduce((e, t) => {
  const n = mh[t];
  return e[t] = (r, i = !1, o = !1) => (cc || VB(), n.schedule(r, i, o)), e;
}, {}), Ts = Rc.reduce((e, t) => (e[t] = mh[t].cancel, e), {}), zm = Rc.reduce((e, t) => (e[t] = () => mh[t].process(ys), e), {}), zB = (e) => mh[e].process(ys), i5 = (e) => {
  cc = !1, ys.delta = pv ? n5 : Math.max(Math.min(e - ys.timestamp, FB), 1), ys.timestamp = e, mv = !0, Rc.forEach(zB), mv = !1, cc && (pv = !1, r5(i5));
}, VB = () => {
  cc = !0, pv = !0, mv || r5(i5);
}, cf = () => ys;
function o5(e, t, n = 0) {
  return e - t - n;
}
function BB(e, t, n = 0, r = !0) {
  return r ? o5(t + -e, t, n) : t - (e - t) + n;
}
function jB(e, t, n, r) {
  return r ? e >= t + n : e <= -n;
}
const WB = (e) => {
  const t = ({ delta: n }) => e(n);
  return {
    start: () => ni.update(t, !0),
    stop: () => Ts.update(t)
  };
};
function a5(e) {
  var t, n, { from: r, autoplay: i = !0, driver: o = WB, elapsed: a = 0, repeat: s = 0, repeatType: l = "loop", repeatDelay: u = 0, onPlay: d, onStop: f, onComplete: p, onRepeat: m, onUpdate: g } = e, v = Bn(e, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]);
  let { to: y } = v, b, E = 0, S = v.duration, _, k = !1, T = !0, A;
  const R = NB(v);
  !((n = (t = R).needsInterpolation) === null || n === void 0) && n.call(t, r, y) && (A = Z_([0, 100], [r, y], {
    clamp: !1
  }), r = 0, y = 100);
  const F = R(Object.assign(Object.assign({}, v), { from: r, to: y }));
  function D() {
    E++, l === "reverse" ? (T = E % 2 === 0, a = BB(a, S, u, T)) : (a = o5(a, S, u), l === "mirror" && F.flipTarget()), k = !1, m && m();
  }
  function W() {
    b.stop(), p && p();
  }
  function L(B) {
    if (T || (B = -B), a += B, !k) {
      const G = F.next(Math.max(0, a));
      _ = G.value, A && (_ = A(_)), k = T ? G.done : a <= 0;
    }
    g == null || g(_), k && (E === 0 && (S ?? (S = a)), E < s ? jB(a, S, u, T) && D() : W());
  }
  function z() {
    d == null || d(), b = o(L), b.start();
  }
  return i && z(), {
    stop: () => {
      f == null || f(), b.stop();
    }
  };
}
function s5(e, t) {
  return t ? e * (1e3 / t) : 0;
}
function UB({ from: e = 0, velocity: t = 0, min: n, max: r, power: i = 0.8, timeConstant: o = 750, bounceStiffness: a = 500, bounceDamping: s = 10, restDelta: l = 1, modifyTarget: u, driver: d, onUpdate: f, onComplete: p, onStop: m }) {
  let g;
  function v(S) {
    return n !== void 0 && S < n || r !== void 0 && S > r;
  }
  function y(S) {
    return n === void 0 ? r : r === void 0 || Math.abs(n - S) < Math.abs(r - S) ? n : r;
  }
  function b(S) {
    g == null || g.stop(), g = a5(Object.assign(Object.assign({}, S), {
      driver: d,
      onUpdate: (_) => {
        var k;
        f == null || f(_), (k = S.onUpdate) === null || k === void 0 || k.call(S, _);
      },
      onComplete: p,
      onStop: m
    }));
  }
  function E(S) {
    b(Object.assign({ type: "spring", stiffness: a, damping: s, restDelta: l }, S));
  }
  if (v(e))
    E({ from: e, velocity: t, to: y(e) });
  else {
    let S = i * t + e;
    typeof u < "u" && (S = u(S));
    const _ = y(S), k = _ === n ? -1 : 1;
    let T, A;
    const R = (F) => {
      T = A, A = F, t = s5(F - T, cf().delta), (k === 1 && F > _ || k === -1 && F < _) && E({ from: F, to: _, velocity: t });
    };
    b({
      type: "decay",
      from: e,
      velocity: t,
      timeConstant: o,
      power: i,
      restDelta: l,
      modifyTarget: u,
      onUpdate: v(S) ? R : void 0
    });
  }
  return {
    stop: () => g == null ? void 0 : g.stop()
  };
}
const gv = (e) => e.hasOwnProperty("x") && e.hasOwnProperty("y"), qx = (e) => gv(e) && e.hasOwnProperty("z"), qu = (e, t) => Math.abs(e - t);
function l5(e, t) {
  if (hv(e) && hv(t))
    return qu(e, t);
  if (gv(e) && gv(t)) {
    const n = qu(e.x, t.x), r = qu(e.y, t.y), i = qx(e) && qx(t) ? qu(e.z, t.z) : 0;
    return Math.sqrt(Math.pow(n, 2) + Math.pow(r, 2) + Math.pow(i, 2));
  }
}
const c5 = (e, t) => 1 - 3 * t + 3 * e, u5 = (e, t) => 3 * t - 6 * e, d5 = (e) => 3 * e, uf = (e, t, n) => ((c5(t, n) * e + u5(t, n)) * e + d5(t)) * e, f5 = (e, t, n) => 3 * c5(t, n) * e * e + 2 * u5(t, n) * e + d5(t), HB = 1e-7, GB = 10;
function qB(e, t, n, r, i) {
  let o, a, s = 0;
  do
    a = t + (n - t) / 2, o = uf(a, r, i) - e, o > 0 ? n = a : t = a;
  while (Math.abs(o) > HB && ++s < GB);
  return a;
}
const YB = 8, KB = 1e-3;
function XB(e, t, n, r) {
  for (let i = 0; i < YB; ++i) {
    const o = f5(t, n, r);
    if (o === 0)
      return t;
    const a = uf(t, n, r) - e;
    t -= a / o;
  }
  return t;
}
const Ld = 11, Yu = 1 / (Ld - 1);
function ZB(e, t, n, r) {
  if (e === t && n === r)
    return D1;
  const i = new Float32Array(Ld);
  for (let a = 0; a < Ld; ++a)
    i[a] = uf(a * Yu, e, n);
  function o(a) {
    let s = 0, l = 1;
    const u = Ld - 1;
    for (; l !== u && i[l] <= a; ++l)
      s += Yu;
    --l;
    const d = (a - i[l]) / (i[l + 1] - i[l]), f = s + d * Yu, p = f5(f, e, n);
    return p >= KB ? XB(a, f, e, n) : p === 0 ? f : qB(a, s, s + Yu, e, n);
  }
  return (a) => a === 0 || a === 1 ? a : uf(o(a), t, r);
}
function QB(e) {
  var t = e.onTap, n = e.onTapStart, r = e.onTapCancel, i = e.whileTap, o = e.visualElement, a = t || n || r || i, s = me(!1), l = me(null), u = {
    passive: !(n || t || r || g)
  };
  function d() {
    var v;
    (v = l.current) === null || v === void 0 || v.call(l), l.current = null;
  }
  function f() {
    var v;
    return d(), s.current = !1, (v = o.animationState) === null || v === void 0 || v.setActive(Rt.Tap, !1), !H_();
  }
  function p(v, y) {
    f() && (G_(o.getInstance(), v.target) ? t == null || t(v, y) : r == null || r(v, y));
  }
  function m(v, y) {
    f() && (r == null || r(v, y));
  }
  function g(v, y) {
    var b;
    d(), !s.current && (s.current = !0, l.current = hh(vs(window, "pointerup", p, u), vs(window, "pointercancel", m, u)), (b = o.animationState) === null || b === void 0 || b.setActive(Rt.Tap, !0), n == null || n(v, y));
  }
  af(o, "pointerdown", a ? g : void 0, u), O1(d);
}
var Yx = /* @__PURE__ */ new Set();
function h5(e, t, n) {
  e || Yx.has(t) || (console.warn(t), n && console.warn(n), Yx.add(t));
}
var vv = /* @__PURE__ */ new WeakMap(), Vm = /* @__PURE__ */ new WeakMap(), JB = function(e) {
  var t;
  (t = vv.get(e.target)) === null || t === void 0 || t(e);
}, ej = function(e) {
  e.forEach(JB);
};
function tj(e) {
  var t = e.root, n = Bn(e, ["root"]), r = t || document;
  Vm.has(r) || Vm.set(r, {});
  var i = Vm.get(r), o = JSON.stringify(n);
  return i[o] || (i[o] = new IntersectionObserver(ej, ye({ root: t }, n))), i[o];
}
function nj(e, t, n) {
  var r = tj(t);
  return vv.set(e, n), r.observe(e), function() {
    vv.delete(e), r.unobserve(e);
  };
}
function rj(e) {
  var t = e.visualElement, n = e.whileInView, r = e.onViewportEnter, i = e.onViewportLeave, o = e.viewport, a = o === void 0 ? {} : o, s = me({
    hasEnteredView: !1,
    isInView: !1
  }), l = !!(n || r || i);
  a.once && s.current.hasEnteredView && (l = !1);
  var u = typeof IntersectionObserver > "u" ? aj : oj;
  u(l, s.current, t, a);
}
var ij = {
  some: 0,
  all: 1
};
function oj(e, t, n, r) {
  var i = r.root, o = r.margin, a = r.amount, s = a === void 0 ? "some" : a, l = r.once;
  be(function() {
    if (e) {
      var u = {
        root: i == null ? void 0 : i.current,
        rootMargin: o,
        threshold: typeof s == "number" ? s : ij[s]
      }, d = function(f) {
        var p, m = f.isIntersecting;
        if (t.isInView !== m && (t.isInView = m, !(l && !m && t.hasEnteredView))) {
          m && (t.hasEnteredView = !0), (p = n.animationState) === null || p === void 0 || p.setActive(Rt.InView, m);
          var g = n.getProps(), v = m ? g.onViewportEnter : g.onViewportLeave;
          v == null || v(f);
        }
      };
      return nj(n.getInstance(), u, d);
    }
  }, [e, i, o, s]);
}
function aj(e, t, n, r) {
  var i = r.fallback, o = i === void 0 ? !0 : i;
  be(function() {
    !e || !o || (b1 !== "production" && h5(!1, "IntersectionObserver not available on this device. whileInView animations will trigger on mount."), requestAnimationFrame(function() {
      var a;
      t.hasEnteredView = !0;
      var s = n.getProps().onViewportEnter;
      s == null || s(null), (a = n.animationState) === null || a === void 0 || a.setActive(Rt.InView, !0);
    }));
  }, [e]);
}
var ko = function(e) {
  return function(t) {
    return e(t), null;
  };
}, sj = {
  inView: ko(rj),
  tap: ko(QB),
  focus: ko(BV),
  hover: ko(ZV)
}, lj = 0, cj = function() {
  return lj++;
}, p5 = function() {
  return js(cj);
};
function m5() {
  var e = Me(Tc);
  if (e === null)
    return [!0, null];
  var t = e.isPresent, n = e.onExitComplete, r = e.register, i = p5();
  be(function() {
    return r(i);
  }, []);
  var o = function() {
    return n == null ? void 0 : n(i);
  };
  return !t && n ? [!1, o] : [!0];
}
function g5(e, t) {
  if (!Array.isArray(t))
    return !1;
  var n = t.length;
  if (n !== e.length)
    return !1;
  for (var r = 0; r < n; r++)
    if (t[r] !== e[r])
      return !1;
  return !0;
}
var df = function(e) {
  return e * 1e3;
}, Kx = {
  linear: D1,
  easeIn: N1,
  easeInOut: e5,
  easeOut: xB,
  circIn: t5,
  circInOut: EB,
  circOut: $1,
  backIn: L1,
  backInOut: SB,
  backOut: CB,
  anticipate: _B,
  bounceIn: AB,
  bounceInOut: MB,
  bounceOut: lf
}, Xx = function(e) {
  if (Array.isArray(e)) {
    Nr(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    var t = Kt(e, 4), n = t[0], r = t[1], i = t[2], o = t[3];
    return ZB(n, r, i, o);
  } else if (typeof e == "string")
    return Nr(Kx[e] !== void 0, "Invalid easing type '".concat(e, "'")), Kx[e];
  return e;
}, uj = function(e) {
  return Array.isArray(e) && typeof e[0] != "number";
}, Zx = function(e, t) {
  return e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && // It's animatable if we have a string
  Zi.test(t) && // And it contains numbers and/or colors
  !t.startsWith("url("));
}, Xo = function() {
  return {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restSpeed: 10
  };
}, Ku = function(e) {
  return {
    type: "spring",
    stiffness: 550,
    damping: e === 0 ? 2 * Math.sqrt(550) : 30,
    restSpeed: 10
  };
}, Bm = function() {
  return {
    type: "keyframes",
    ease: "linear",
    duration: 0.3
  };
}, dj = function(e) {
  return {
    type: "keyframes",
    duration: 0.8,
    values: e
  };
}, Qx = {
  x: Xo,
  y: Xo,
  z: Xo,
  rotate: Xo,
  rotateX: Xo,
  rotateY: Xo,
  rotateZ: Xo,
  scaleX: Ku,
  scaleY: Ku,
  scale: Ku,
  opacity: Bm,
  backgroundColor: Bm,
  color: Bm,
  default: Ku
}, fj = function(e, t) {
  var n;
  return sc(t) ? n = dj : n = Qx[e] || Qx.default, ye({ to: t }, n(t));
}, hj = ye(ye({}, T_), {
  // Color props
  color: zn,
  backgroundColor: zn,
  outlineColor: zn,
  fill: zn,
  stroke: zn,
  // Border props
  borderColor: zn,
  borderTopColor: zn,
  borderRightColor: zn,
  borderBottomColor: zn,
  borderLeftColor: zn,
  filter: uv,
  WebkitFilter: uv
}), F1 = function(e) {
  return hj[e];
};
function z1(e, t) {
  var n, r = F1(e);
  return r !== uv && (r = Zi), (n = r.getAnimatableNone) === null || n === void 0 ? void 0 : n.call(r, t);
}
function pj(e) {
  e.when, e.delay, e.delayChildren, e.staggerChildren, e.staggerDirection, e.repeat, e.repeatType, e.repeatDelay, e.from;
  var t = Bn(e, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
  return !!Object.keys(t).length;
}
var Jx = !1;
function mj(e) {
  var t = e.ease, n = e.times, r = e.yoyo, i = e.flip, o = e.loop, a = Bn(e, ["ease", "times", "yoyo", "flip", "loop"]), s = ye({}, a);
  return n && (s.offset = n), a.duration && (s.duration = df(a.duration)), a.repeatDelay && (s.repeatDelay = df(a.repeatDelay)), t && (s.ease = uj(t) ? t.map(Xx) : Xx(t)), a.type === "tween" && (s.type = "keyframes"), (r || o || i) && (kc(!Jx, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options."), Jx = !0, r ? s.repeatType = "reverse" : o ? s.repeatType = "loop" : i && (s.repeatType = "mirror"), s.repeat = o || r || i || a.repeat), a.type !== "spring" && (s.type = "keyframes"), s;
}
function gj(e, t) {
  var n, r, i = V1(e, t) || {};
  return (r = (n = i.delay) !== null && n !== void 0 ? n : e.delay) !== null && r !== void 0 ? r : 0;
}
function vj(e) {
  return Array.isArray(e.to) && e.to[0] === null && (e.to = mr([], Kt(e.to), !1), e.to[0] = e.from), e;
}
function yj(e, t, n) {
  var r;
  return Array.isArray(t.to) && ((r = e.duration) !== null && r !== void 0 || (e.duration = 0.8)), vj(t), pj(e) || (e = ye(ye({}, e), fj(n, t.to))), ye(ye({}, t), mj(e));
}
function wj(e, t, n, r, i) {
  var o, a = V1(r, e), s = (o = a.from) !== null && o !== void 0 ? o : t.get(), l = Zx(e, n);
  s === "none" && l && typeof n == "string" ? s = z1(e, n) : e3(s) && typeof n == "string" ? s = t3(n) : !Array.isArray(n) && e3(n) && typeof s == "string" && (n = t3(s));
  var u = Zx(e, s);
  kc(u === l, "You are trying to animate ".concat(e, ' from "').concat(s, '" to "').concat(n, '". ').concat(s, " is not an animatable value - to enable this animation set ").concat(s, " to a value animatable to ").concat(n, " via the `style` property."));
  function d() {
    var p = {
      from: s,
      to: n,
      velocity: t.getVelocity(),
      onComplete: i,
      onUpdate: function(m) {
        return t.set(m);
      }
    };
    return a.type === "inertia" || a.type === "decay" ? UB(ye(ye({}, p), a)) : a5(ye(ye({}, yj(a, p, e)), { onUpdate: function(m) {
      var g;
      p.onUpdate(m), (g = a.onUpdate) === null || g === void 0 || g.call(a, m);
    }, onComplete: function() {
      var m;
      p.onComplete(), (m = a.onComplete) === null || m === void 0 || m.call(a);
    } }));
  }
  function f() {
    var p, m, g = L_(n);
    return t.set(g), i(), (p = a == null ? void 0 : a.onUpdate) === null || p === void 0 || p.call(a, g), (m = a == null ? void 0 : a.onComplete) === null || m === void 0 || m.call(a), { stop: function() {
    } };
  }
  return !u || !l || a.type === !1 ? f : d;
}
function e3(e) {
  return e === 0 || typeof e == "string" && parseFloat(e) === 0 && e.indexOf(" ") === -1;
}
function t3(e) {
  return typeof e == "number" ? 0 : z1("", e);
}
function V1(e, t) {
  return e[t] || e.default || e;
}
function B1(e, t, n, r) {
  return r === void 0 && (r = {}), t.start(function(i) {
    var o, a, s = wj(e, t, n, r, i), l = gj(r, e), u = function() {
      return a = s();
    };
    return l ? o = window.setTimeout(u, df(l)) : u(), function() {
      clearTimeout(o), a == null || a.stop();
    };
  });
}
var bj = function(e) {
  return /^\-?\d*\.?\d+$/.test(e);
}, xj = function(e) {
  return /^0[^.\s]+$/.test(e);
};
function j1(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function W1(e, t) {
  var n = e.indexOf(t);
  n > -1 && e.splice(n, 1);
}
var Gl = (
  /** @class */
  function() {
    function e() {
      this.subscriptions = [];
    }
    return e.prototype.add = function(t) {
      var n = this;
      return j1(this.subscriptions, t), function() {
        return W1(n.subscriptions, t);
      };
    }, e.prototype.notify = function(t, n, r) {
      var i = this.subscriptions.length;
      if (i)
        if (i === 1)
          this.subscriptions[0](t, n, r);
        else
          for (var o = 0; o < i; o++) {
            var a = this.subscriptions[o];
            a && a(t, n, r);
          }
    }, e.prototype.getSize = function() {
      return this.subscriptions.length;
    }, e.prototype.clear = function() {
      this.subscriptions.length = 0;
    }, e;
  }()
), Ej = function(e) {
  return !isNaN(parseFloat(e));
}, Cj = (
  /** @class */
  function() {
    function e(t) {
      var n = this;
      this.version = "6.5.1", this.timeDelta = 0, this.lastUpdated = 0, this.updateSubscribers = new Gl(), this.velocityUpdateSubscribers = new Gl(), this.renderSubscribers = new Gl(), this.canTrackVelocity = !1, this.updateAndNotify = function(r, i) {
        i === void 0 && (i = !0), n.prev = n.current, n.current = r;
        var o = cf(), a = o.delta, s = o.timestamp;
        n.lastUpdated !== s && (n.timeDelta = a, n.lastUpdated = s, ni.postRender(n.scheduleVelocityCheck)), n.prev !== n.current && n.updateSubscribers.notify(n.current), n.velocityUpdateSubscribers.getSize() && n.velocityUpdateSubscribers.notify(n.getVelocity()), i && n.renderSubscribers.notify(n.current);
      }, this.scheduleVelocityCheck = function() {
        return ni.postRender(n.velocityCheck);
      }, this.velocityCheck = function(r) {
        var i = r.timestamp;
        i !== n.lastUpdated && (n.prev = n.current, n.velocityUpdateSubscribers.notify(n.getVelocity()));
      }, this.hasAnimated = !1, this.prev = this.current = t, this.canTrackVelocity = Ej(this.current);
    }
    return e.prototype.onChange = function(t) {
      return this.updateSubscribers.add(t);
    }, e.prototype.clearListeners = function() {
      this.updateSubscribers.clear();
    }, e.prototype.onRenderRequest = function(t) {
      return t(this.get()), this.renderSubscribers.add(t);
    }, e.prototype.attach = function(t) {
      this.passiveEffect = t;
    }, e.prototype.set = function(t, n) {
      n === void 0 && (n = !0), !n || !this.passiveEffect ? this.updateAndNotify(t, n) : this.passiveEffect(t, this.updateAndNotify);
    }, e.prototype.get = function() {
      return this.current;
    }, e.prototype.getPrevious = function() {
      return this.prev;
    }, e.prototype.getVelocity = function() {
      return this.canTrackVelocity ? (
        // These casts could be avoided if parseFloat would be typed better
        s5(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta)
      ) : 0;
    }, e.prototype.start = function(t) {
      var n = this;
      return this.stop(), new Promise(function(r) {
        n.hasAnimated = !0, n.stopAnimation = t(r);
      }).then(function() {
        return n.clearAnimation();
      });
    }, e.prototype.stop = function() {
      this.stopAnimation && this.stopAnimation(), this.clearAnimation();
    }, e.prototype.isAnimating = function() {
      return !!this.stopAnimation;
    }, e.prototype.clearAnimation = function() {
      this.stopAnimation = null;
    }, e.prototype.destroy = function() {
      this.updateSubscribers.clear(), this.renderSubscribers.clear(), this.stop();
    }, e;
  }()
);
function As(e) {
  return new Cj(e);
}
var v5 = function(e) {
  return function(t) {
    return t.test(e);
  };
}, Sj = {
  test: function(e) {
    return e === "auto";
  },
  parse: function(e) {
    return e;
  }
}, y5 = [ka, Ue, wi, xo, hV, fV, Sj], yl = function(e) {
  return y5.find(v5(e));
}, _j = mr(mr([], Kt(y5), !1), [zn, Zi], !1), Pj = function(e) {
  return _j.find(v5(e));
};
function kj(e, t, n) {
  e.hasValue(t) ? e.getValue(t).set(n) : e.addValue(t, As(n));
}
function Tj(e, t) {
  var n = uh(e, t), r = n ? e.makeTargetAnimatable(n, !1) : {}, i = r.transitionEnd, o = i === void 0 ? {} : i;
  r.transition;
  var a = Bn(r, ["transitionEnd", "transition"]);
  a = ye(ye({}, a), o);
  for (var s in a) {
    var l = L_(a[s]);
    kj(e, s, l);
  }
}
function Aj(e, t, n) {
  var r, i, o, a, s = Object.keys(t).filter(function(m) {
    return !e.hasValue(m);
  }), l = s.length;
  if (l)
    for (var u = 0; u < l; u++) {
      var d = s[u], f = t[d], p = null;
      Array.isArray(f) && (p = f[0]), p === null && (p = (i = (r = n[d]) !== null && r !== void 0 ? r : e.readValue(d)) !== null && i !== void 0 ? i : t[d]), p != null && (typeof p == "string" && (bj(p) || xj(p)) ? p = parseFloat(p) : !Pj(p) && Zi.test(f) && (p = z1(d, f)), e.addValue(d, As(p)), (o = (a = n)[d]) !== null && o !== void 0 || (a[d] = p), e.setBaseTarget(d, p));
    }
}
function Mj(e, t) {
  if (t) {
    var n = t[e] || t.default || t;
    return n.from;
  }
}
function Oj(e, t, n) {
  var r, i, o = {};
  for (var a in e)
    o[a] = (r = Mj(a, t)) !== null && r !== void 0 ? r : (i = n.getValue(a)) === null || i === void 0 ? void 0 : i.get();
  return o;
}
function Rj(e, t, n) {
  n === void 0 && (n = {}), e.notifyAnimationStart(t);
  var r;
  if (Array.isArray(t)) {
    var i = t.map(function(a) {
      return yv(e, a, n);
    });
    r = Promise.all(i);
  } else if (typeof t == "string")
    r = yv(e, t, n);
  else {
    var o = typeof t == "function" ? uh(e, t, n.custom) : t;
    r = w5(e, o, n);
  }
  return r.then(function() {
    return e.notifyAnimationComplete(t);
  });
}
function yv(e, t, n) {
  var r;
  n === void 0 && (n = {});
  var i = uh(e, t, n.custom), o = (i || {}).transition, a = o === void 0 ? e.getDefaultTransition() || {} : o;
  n.transitionOverride && (a = n.transitionOverride);
  var s = i ? function() {
    return w5(e, i, n);
  } : function() {
    return Promise.resolve();
  }, l = !((r = e.variantChildren) === null || r === void 0) && r.size ? function(m) {
    m === void 0 && (m = 0);
    var g = a.delayChildren, v = g === void 0 ? 0 : g, y = a.staggerChildren, b = a.staggerDirection;
    return Ij(e, t, v + m, y, b, n);
  } : function() {
    return Promise.resolve();
  }, u = a.when;
  if (u) {
    var d = Kt(u === "beforeChildren" ? [s, l] : [l, s], 2), f = d[0], p = d[1];
    return f().then(p);
  } else
    return Promise.all([s(), l(n.delay)]);
}
function w5(e, t, n) {
  var r, i = n === void 0 ? {} : n, o = i.delay, a = o === void 0 ? 0 : o, s = i.transitionOverride, l = i.type, u = e.makeTargetAnimatable(t), d = u.transition, f = d === void 0 ? e.getDefaultTransition() : d, p = u.transitionEnd, m = Bn(u, ["transition", "transitionEnd"]);
  s && (f = s);
  var g = [], v = l && ((r = e.animationState) === null || r === void 0 ? void 0 : r.getState()[l]);
  for (var y in m) {
    var b = e.getValue(y), E = m[y];
    if (!(!b || E === void 0 || v && Nj(v, y))) {
      var S = ye({ delay: a }, f);
      e.shouldReduceMotion && Ac(y) && (S = ye(ye({}, S), { type: !1, delay: 0 }));
      var _ = B1(y, b, E, S);
      g.push(_);
    }
  }
  return Promise.all(g).then(function() {
    p && Tj(e, p);
  });
}
function Ij(e, t, n, r, i, o) {
  n === void 0 && (n = 0), r === void 0 && (r = 0), i === void 0 && (i = 1);
  var a = [], s = (e.variantChildren.size - 1) * r, l = i === 1 ? function(u) {
    return u === void 0 && (u = 0), u * r;
  } : function(u) {
    return u === void 0 && (u = 0), s - u * r;
  };
  return Array.from(e.variantChildren).sort(Dj).forEach(function(u, d) {
    a.push(yv(u, t, ye(ye({}, o), { delay: n + l(d) })).then(function() {
      return u.notifyAnimationComplete(t);
    }));
  }), Promise.all(a);
}
function Dj(e, t) {
  return e.sortNodePosition(t);
}
function Nj(e, t) {
  var n = e.protectedKeys, r = e.needsAnimating, i = n.hasOwnProperty(t) && r[t] !== !0;
  return r[t] = !1, i;
}
var U1 = [
  Rt.Animate,
  Rt.InView,
  Rt.Focus,
  Rt.Hover,
  Rt.Tap,
  Rt.Drag,
  Rt.Exit
], $j = mr([], Kt(U1), !1).reverse(), Lj = U1.length;
function Fj(e) {
  return function(t) {
    return Promise.all(t.map(function(n) {
      var r = n.animation, i = n.options;
      return Rj(e, r, i);
    }));
  };
}
function zj(e) {
  var t = Fj(e), n = Bj(), r = {}, i = !0, o = function(d, f) {
    var p = uh(e, f);
    if (p) {
      p.transition;
      var m = p.transitionEnd, g = Bn(p, ["transition", "transitionEnd"]);
      d = ye(ye(ye({}, d), g), m);
    }
    return d;
  };
  function a(d) {
    return r[d] !== void 0;
  }
  function s(d) {
    t = d(e);
  }
  function l(d, f) {
    for (var p, m = e.getProps(), g = e.getVariantContext(!0) || {}, v = [], y = /* @__PURE__ */ new Set(), b = {}, E = 1 / 0, S = function(A) {
      var R = $j[A], F = n[R], D = (p = m[R]) !== null && p !== void 0 ? p : g[R], W = Qr(D), L = R === f ? F.isActive : null;
      L === !1 && (E = A);
      var z = D === g[R] && D !== m[R] && W;
      if (z && i && e.manuallyAnimateOnMount && (z = !1), F.protectedKeys = ye({}, b), // If it isn't active and hasn't *just* been set as inactive
      !F.isActive && L === null || // If we didn't and don't have any defined prop for this animation type
      !D && !F.prevProp || // Or if the prop doesn't define an animation
      A1(D) || typeof D == "boolean")
        return "continue";
      var B = Vj(F.prevProp, D), G = B || // If we're making this variant active, we want to always make it active
      R === f && F.isActive && !z && W || // If we removed a higher-priority variant (i is in reverse order)
      A > E && W, H = Array.isArray(D) ? D : [D], J = H.reduce(o, {});
      L === !1 && (J = {});
      var q = F.prevResolvedValues, Z = q === void 0 ? {} : q, O = ye(ye({}, Z), J), Q = function(ae) {
        G = !0, y.delete(ae), F.needsAnimating[ae] = !0;
      };
      for (var he in O) {
        var N = J[he], ee = Z[he];
        b.hasOwnProperty(he) || (N !== ee ? sc(N) && sc(ee) ? !g5(N, ee) || B ? Q(he) : F.protectedKeys[he] = !0 : N !== void 0 ? Q(he) : y.add(he) : N !== void 0 && y.has(he) ? Q(he) : F.protectedKeys[he] = !0);
      }
      F.prevProp = D, F.prevResolvedValues = J, F.isActive && (b = ye(ye({}, b), J)), i && e.blockInitialAnimation && (G = !1), G && !z && v.push.apply(v, mr([], Kt(H.map(function(ae) {
        return {
          animation: ae,
          options: ye({ type: R }, d)
        };
      })), !1));
    }, _ = 0; _ < Lj; _++)
      S(_);
    if (r = ye({}, b), y.size) {
      var k = {};
      y.forEach(function(A) {
        var R = e.getBaseTarget(A);
        R !== void 0 && (k[A] = R);
      }), v.push({ animation: k });
    }
    var T = !!v.length;
    return i && m.initial === !1 && !e.manuallyAnimateOnMount && (T = !1), i = !1, T ? t(v) : Promise.resolve();
  }
  function u(d, f, p) {
    var m;
    if (n[d].isActive === f)
      return Promise.resolve();
    (m = e.variantChildren) === null || m === void 0 || m.forEach(function(y) {
      var b;
      return (b = y.animationState) === null || b === void 0 ? void 0 : b.setActive(d, f);
    }), n[d].isActive = f;
    var g = l(p, d);
    for (var v in n)
      n[v].protectedKeys = {};
    return g;
  }
  return {
    isAnimated: a,
    animateChanges: l,
    setActive: u,
    setAnimateFunction: s,
    getState: function() {
      return n;
    }
  };
}
function Vj(e, t) {
  return typeof t == "string" ? t !== e : p_(t) ? !g5(t, e) : !1;
}
function Zo(e) {
  return e === void 0 && (e = !1), {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function Bj() {
  var e;
  return e = {}, e[Rt.Animate] = Zo(!0), e[Rt.InView] = Zo(), e[Rt.Hover] = Zo(), e[Rt.Tap] = Zo(), e[Rt.Drag] = Zo(), e[Rt.Focus] = Zo(), e[Rt.Exit] = Zo(), e;
}
var jj = {
  animation: ko(function(e) {
    var t = e.visualElement, n = e.animate;
    t.animationState || (t.animationState = zj(t)), A1(n) && be(function() {
      return n.subscribe(t);
    }, [n]);
  }),
  exit: ko(function(e) {
    var t = e.custom, n = e.visualElement, r = Kt(m5(), 2), i = r[0], o = r[1], a = Me(Tc);
    be(function() {
      var s, l;
      n.isPresent = i;
      var u = (s = n.animationState) === null || s === void 0 ? void 0 : s.setActive(Rt.Exit, !i, { custom: (l = a == null ? void 0 : a.custom) !== null && l !== void 0 ? l : t });
      !i && (u == null || u.then(o));
    }, [i]);
  })
}, b5 = (
  /** @class */
  function() {
    function e(t, n, r) {
      var i = this, o = r === void 0 ? {} : r, a = o.transformPagePoint;
      if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = function() {
        if (i.lastMoveEvent && i.lastMoveEventInfo) {
          var p = Wm(i.lastMoveEventInfo, i.history), m = i.startEvent !== null, g = l5(p.offset, { x: 0, y: 0 }) >= 3;
          if (!(!m && !g)) {
            var v = p.point, y = cf().timestamp;
            i.history.push(ye(ye({}, v), { timestamp: y }));
            var b = i.handlers, E = b.onStart, S = b.onMove;
            m || (E && E(i.lastMoveEvent, p), i.startEvent = i.lastMoveEvent), S && S(i.lastMoveEvent, p);
          }
        }
      }, this.handlePointerMove = function(p, m) {
        if (i.lastMoveEvent = p, i.lastMoveEventInfo = jm(m, i.transformPagePoint), z_(p) && p.buttons === 0) {
          i.handlePointerUp(p, m);
          return;
        }
        ni.update(i.updatePoint, !0);
      }, this.handlePointerUp = function(p, m) {
        i.end();
        var g = i.handlers, v = g.onEnd, y = g.onSessionEnd, b = Wm(jm(m, i.transformPagePoint), i.history);
        i.startEvent && v && v(p, b), y && y(p, b);
      }, !(V_(t) && t.touches.length > 1)) {
        this.handlers = n, this.transformPagePoint = a;
        var s = M1(t), l = jm(s, this.transformPagePoint), u = l.point, d = cf().timestamp;
        this.history = [ye(ye({}, u), { timestamp: d })];
        var f = n.onSessionStart;
        f && f(t, Wm(l, this.history)), this.removeListeners = hh(vs(window, "pointermove", this.handlePointerMove), vs(window, "pointerup", this.handlePointerUp), vs(window, "pointercancel", this.handlePointerUp));
      }
    }
    return e.prototype.updateHandlers = function(t) {
      this.handlers = t;
    }, e.prototype.end = function() {
      this.removeListeners && this.removeListeners(), Ts.update(this.updatePoint);
    }, e;
  }()
);
function jm(e, t) {
  return t ? { point: t(e.point) } : e;
}
function n3(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function Wm(e, t) {
  var n = e.point;
  return {
    point: n,
    delta: n3(n, x5(t)),
    offset: n3(n, Wj(t)),
    velocity: Uj(t, 0.1)
  };
}
function Wj(e) {
  return e[0];
}
function x5(e) {
  return e[e.length - 1];
}
function Uj(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  for (var n = e.length - 1, r = null, i = x5(e); n >= 0 && (r = e[n], !(i.timestamp - r.timestamp > df(t))); )
    n--;
  if (!r)
    return { x: 0, y: 0 };
  var o = (i.timestamp - r.timestamp) / 1e3;
  if (o === 0)
    return { x: 0, y: 0 };
  var a = {
    x: (i.x - r.x) / o,
    y: (i.y - r.y) / o
  };
  return a.x === 1 / 0 && (a.x = 0), a.y === 1 / 0 && (a.y = 0), a;
}
function Qi(e) {
  return e.max - e.min;
}
function r3(e, t, n) {
  return t === void 0 && (t = 0), n === void 0 && (n = 0.01), l5(e, t) < n;
}
function i3(e, t, n, r) {
  r === void 0 && (r = 0.5), e.origin = r, e.originPoint = Yt(t.min, t.max, e.origin), e.scale = Qi(n) / Qi(t), (r3(e.scale, 1, 1e-4) || isNaN(e.scale)) && (e.scale = 1), e.translate = Yt(n.min, n.max, e.origin) - e.originPoint, (r3(e.translate) || isNaN(e.translate)) && (e.translate = 0);
}
function ql(e, t, n, r) {
  i3(e.x, t.x, n.x, r == null ? void 0 : r.originX), i3(e.y, t.y, n.y, r == null ? void 0 : r.originY);
}
function o3(e, t, n) {
  e.min = n.min + t.min, e.max = e.min + Qi(t);
}
function Hj(e, t, n) {
  o3(e.x, t.x, n.x), o3(e.y, t.y, n.y);
}
function a3(e, t, n) {
  e.min = t.min - n.min, e.max = e.min + Qi(t);
}
function Yl(e, t, n) {
  a3(e.x, t.x, n.x), a3(e.y, t.y, n.y);
}
function Gj(e, t, n) {
  var r = t.min, i = t.max;
  return r !== void 0 && e < r ? e = n ? Yt(r, e, n.min) : Math.max(e, r) : i !== void 0 && e > i && (e = n ? Yt(i, e, n.max) : Math.min(e, i)), e;
}
function s3(e, t, n) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: n !== void 0 ? e.max + n - (e.max - e.min) : void 0
  };
}
function qj(e, t) {
  var n = t.top, r = t.left, i = t.bottom, o = t.right;
  return {
    x: s3(e.x, r, o),
    y: s3(e.y, n, i)
  };
}
function l3(e, t) {
  var n, r = t.min - e.min, i = t.max - e.max;
  return t.max - t.min < e.max - e.min && (n = Kt([i, r], 2), r = n[0], i = n[1]), { min: r, max: i };
}
function Yj(e, t) {
  return {
    x: l3(e.x, t.x),
    y: l3(e.y, t.y)
  };
}
function Kj(e, t) {
  var n = 0.5, r = Qi(e), i = Qi(t);
  return i > r ? n = lc(t.min, t.max - r, e.min) : r > i && (n = lc(e.min, e.max - i, t.min)), sf(0, 1, n);
}
function Xj(e, t) {
  var n = {};
  return t.min !== void 0 && (n.min = t.min - e.min), t.max !== void 0 && (n.max = t.max - e.min), n;
}
var wv = 0.35;
function Zj(e) {
  return e === void 0 && (e = wv), e === !1 ? e = 0 : e === !0 && (e = wv), {
    x: c3(e, "left", "right"),
    y: c3(e, "top", "bottom")
  };
}
function c3(e, t, n) {
  return {
    min: u3(e, t),
    max: u3(e, n)
  };
}
function u3(e, t) {
  var n;
  return typeof e == "number" ? e : (n = e[t]) !== null && n !== void 0 ? n : 0;
}
var d3 = function() {
  return {
    translate: 0,
    scale: 1,
    origin: 0,
    originPoint: 0
  };
}, Kl = function() {
  return {
    x: d3(),
    y: d3()
  };
}, f3 = function() {
  return { min: 0, max: 0 };
}, An = function() {
  return {
    x: f3(),
    y: f3()
  };
};
function mi(e) {
  return [e("x"), e("y")];
}
function E5(e) {
  var t = e.top, n = e.left, r = e.right, i = e.bottom;
  return {
    x: { min: n, max: r },
    y: { min: t, max: i }
  };
}
function Qj(e) {
  var t = e.x, n = e.y;
  return { top: n.min, right: t.max, bottom: n.max, left: t.min };
}
function Jj(e, t) {
  if (!t)
    return e;
  var n = t({ x: e.left, y: e.top }), r = t({ x: e.right, y: e.bottom });
  return {
    top: n.y,
    left: n.x,
    bottom: r.y,
    right: r.x
  };
}
function Um(e) {
  return e === void 0 || e === 1;
}
function C5(e) {
  var t = e.scale, n = e.scaleX, r = e.scaleY;
  return !Um(t) || !Um(n) || !Um(r);
}
function Eo(e) {
  return C5(e) || h3(e.x) || h3(e.y) || e.z || e.rotate || e.rotateX || e.rotateY;
}
function h3(e) {
  return e && e !== "0%";
}
function ff(e, t, n) {
  var r = e - n, i = t * r;
  return n + i;
}
function p3(e, t, n, r, i) {
  return i !== void 0 && (e = ff(e, i, r)), ff(e, n, r) + t;
}
function bv(e, t, n, r, i) {
  t === void 0 && (t = 0), n === void 0 && (n = 1), e.min = p3(e.min, t, n, r, i), e.max = p3(e.max, t, n, r, i);
}
function S5(e, t) {
  var n = t.x, r = t.y;
  bv(e.x, n.translate, n.scale, n.originPoint), bv(e.y, r.translate, r.scale, r.originPoint);
}
function eW(e, t, n, r) {
  var i, o;
  r === void 0 && (r = !1);
  var a = n.length;
  if (a) {
    t.x = t.y = 1;
    for (var s, l, u = 0; u < a; u++)
      s = n[u], l = s.projectionDelta, ((o = (i = s.instance) === null || i === void 0 ? void 0 : i.style) === null || o === void 0 ? void 0 : o.display) !== "contents" && (r && s.options.layoutScroll && s.scroll && s !== s.root && fs(e, { x: -s.scroll.x, y: -s.scroll.y }), l && (t.x *= l.x.scale, t.y *= l.y.scale, S5(e, l)), r && Eo(s.latestValues) && fs(e, s.latestValues));
  }
}
function So(e, t) {
  e.min = e.min + t, e.max = e.max + t;
}
function m3(e, t, n) {
  var r = Kt(n, 3), i = r[0], o = r[1], a = r[2], s = t[a] !== void 0 ? t[a] : 0.5, l = Yt(e.min, e.max, s);
  bv(e, t[i], t[o], l, t.scale);
}
var tW = ["x", "scaleX", "originX"], nW = ["y", "scaleY", "originY"];
function fs(e, t) {
  m3(e.x, t, tW), m3(e.y, t, nW);
}
function _5(e, t) {
  return E5(Jj(e.getBoundingClientRect(), t));
}
function rW(e, t, n) {
  var r = _5(e, n), i = t.scroll;
  return i && (So(r.x, i.x), So(r.y, i.y)), r;
}
var iW = /* @__PURE__ */ new WeakMap(), oW = (
  /** @class */
  function() {
    function e(t) {
      this.openGlobalLock = null, this.isDragging = !1, this.currentDirection = null, this.originPoint = { x: 0, y: 0 }, this.constraints = !1, this.hasMutatedConstraints = !1, this.elastic = An(), this.visualElement = t;
    }
    return e.prototype.start = function(t, n) {
      var r = this, i = n === void 0 ? {} : n, o = i.snapToCursor, a = o === void 0 ? !1 : o;
      if (this.visualElement.isPresent !== !1) {
        var s = function(f) {
          r.stopAnimation(), a && r.snapToCursor(M1(f, "page").point);
        }, l = function(f, p) {
          var m, g = r.getProps(), v = g.drag, y = g.dragPropagation, b = g.onDragStart;
          v && !y && (r.openGlobalLock && r.openGlobalLock(), r.openGlobalLock = U_(v), !r.openGlobalLock) || (r.isDragging = !0, r.currentDirection = null, r.resolveConstraints(), r.visualElement.projection && (r.visualElement.projection.isAnimationBlocked = !0, r.visualElement.projection.target = void 0), mi(function(E) {
            var S, _, k = r.getAxisMotionValue(E).get() || 0;
            if (wi.test(k)) {
              var T = (_ = (S = r.visualElement.projection) === null || S === void 0 ? void 0 : S.layout) === null || _ === void 0 ? void 0 : _.actual[E];
              if (T) {
                var A = Qi(T);
                k = A * (parseFloat(k) / 100);
              }
            }
            r.originPoint[E] = k;
          }), b == null || b(f, p), (m = r.visualElement.animationState) === null || m === void 0 || m.setActive(Rt.Drag, !0));
        }, u = function(f, p) {
          var m = r.getProps(), g = m.dragPropagation, v = m.dragDirectionLock, y = m.onDirectionLock, b = m.onDrag;
          if (!(!g && !r.openGlobalLock)) {
            var E = p.offset;
            if (v && r.currentDirection === null) {
              r.currentDirection = aW(E), r.currentDirection !== null && (y == null || y(r.currentDirection));
              return;
            }
            r.updateAxis("x", p.point, E), r.updateAxis("y", p.point, E), r.visualElement.syncRender(), b == null || b(f, p);
          }
        }, d = function(f, p) {
          return r.stop(f, p);
        };
        this.panSession = new b5(t, {
          onSessionStart: s,
          onStart: l,
          onMove: u,
          onSessionEnd: d
        }, { transformPagePoint: this.visualElement.getTransformPagePoint() });
      }
    }, e.prototype.stop = function(t, n) {
      var r = this.isDragging;
      if (this.cancel(), !!r) {
        var i = n.velocity;
        this.startAnimation(i);
        var o = this.getProps().onDragEnd;
        o == null || o(t, n);
      }
    }, e.prototype.cancel = function() {
      var t, n;
      this.isDragging = !1, this.visualElement.projection && (this.visualElement.projection.isAnimationBlocked = !1), (t = this.panSession) === null || t === void 0 || t.end(), this.panSession = void 0;
      var r = this.getProps().dragPropagation;
      !r && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), (n = this.visualElement.animationState) === null || n === void 0 || n.setActive(Rt.Drag, !1);
    }, e.prototype.updateAxis = function(t, n, r) {
      var i = this.getProps().drag;
      if (!(!r || !Xu(t, i, this.currentDirection))) {
        var o = this.getAxisMotionValue(t), a = this.originPoint[t] + r[t];
        this.constraints && this.constraints[t] && (a = Gj(a, this.constraints[t], this.elastic[t])), o.set(a);
      }
    }, e.prototype.resolveConstraints = function() {
      var t = this, n = this.getProps(), r = n.dragConstraints, i = n.dragElastic, o = (this.visualElement.projection || {}).layout, a = this.constraints;
      r && ds(r) ? this.constraints || (this.constraints = this.resolveRefConstraints()) : r && o ? this.constraints = qj(o.actual, r) : this.constraints = !1, this.elastic = Zj(i), a !== this.constraints && o && this.constraints && !this.hasMutatedConstraints && mi(function(s) {
        t.getAxisMotionValue(s) && (t.constraints[s] = Xj(o.actual[s], t.constraints[s]));
      });
    }, e.prototype.resolveRefConstraints = function() {
      var t = this.getProps(), n = t.dragConstraints, r = t.onMeasureDragConstraints;
      if (!n || !ds(n))
        return !1;
      var i = n.current;
      Nr(i !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop.");
      var o = this.visualElement.projection;
      if (!o || !o.layout)
        return !1;
      var a = rW(i, o.root, this.visualElement.getTransformPagePoint()), s = Yj(o.layout.actual, a);
      if (r) {
        var l = r(Qj(s));
        this.hasMutatedConstraints = !!l, l && (s = E5(l));
      }
      return s;
    }, e.prototype.startAnimation = function(t) {
      var n = this, r = this.getProps(), i = r.drag, o = r.dragMomentum, a = r.dragElastic, s = r.dragTransition, l = r.dragSnapToOrigin, u = r.onDragTransitionEnd, d = this.constraints || {}, f = mi(function(p) {
        var m;
        if (Xu(p, i, n.currentDirection)) {
          var g = (m = d == null ? void 0 : d[p]) !== null && m !== void 0 ? m : {};
          l && (g = { min: 0, max: 0 });
          var v = a ? 200 : 1e6, y = a ? 40 : 1e7, b = ye(ye({ type: "inertia", velocity: o ? t[p] : 0, bounceStiffness: v, bounceDamping: y, timeConstant: 750, restDelta: 1, restSpeed: 10 }, s), g);
          return n.startAxisValueAnimation(p, b);
        }
      });
      return Promise.all(f).then(u);
    }, e.prototype.startAxisValueAnimation = function(t, n) {
      var r = this.getAxisMotionValue(t);
      return B1(t, r, 0, n);
    }, e.prototype.stopAnimation = function() {
      var t = this;
      mi(function(n) {
        return t.getAxisMotionValue(n).stop();
      });
    }, e.prototype.getAxisMotionValue = function(t) {
      var n, r, i = "_drag" + t.toUpperCase(), o = this.visualElement.getProps()[i];
      return o || this.visualElement.getValue(t, (r = (n = this.visualElement.getProps().initial) === null || n === void 0 ? void 0 : n[t]) !== null && r !== void 0 ? r : 0);
    }, e.prototype.snapToCursor = function(t) {
      var n = this;
      mi(function(r) {
        var i = n.getProps().drag;
        if (Xu(r, i, n.currentDirection)) {
          var o = n.visualElement.projection, a = n.getAxisMotionValue(r);
          if (o && o.layout) {
            var s = o.layout.actual[r], l = s.min, u = s.max;
            a.set(t[r] - Yt(l, u, 0.5));
          }
        }
      });
    }, e.prototype.scalePositionWithinConstraints = function() {
      var t = this, n, r = this.getProps(), i = r.drag, o = r.dragConstraints, a = this.visualElement.projection;
      if (!(!ds(o) || !a || !this.constraints)) {
        this.stopAnimation();
        var s = { x: 0, y: 0 };
        mi(function(u) {
          var d = t.getAxisMotionValue(u);
          if (d) {
            var f = d.get();
            s[u] = Kj({ min: f, max: f }, t.constraints[u]);
          }
        });
        var l = this.visualElement.getProps().transformTemplate;
        this.visualElement.getInstance().style.transform = l ? l({}, "") : "none", (n = a.root) === null || n === void 0 || n.updateScroll(), a.updateLayout(), this.resolveConstraints(), mi(function(u) {
          if (Xu(u, i, null)) {
            var d = t.getAxisMotionValue(u), f = t.constraints[u], p = f.min, m = f.max;
            d.set(Yt(p, m, s[u]));
          }
        });
      }
    }, e.prototype.addListeners = function() {
      var t = this, n;
      iW.set(this.visualElement, this);
      var r = this.visualElement.getInstance(), i = vs(r, "pointerdown", function(u) {
        var d = t.getProps(), f = d.drag, p = d.dragListener, m = p === void 0 ? !0 : p;
        f && m && t.start(u);
      }), o = function() {
        var u = t.getProps().dragConstraints;
        ds(u) && (t.constraints = t.resolveRefConstraints());
      }, a = this.visualElement.projection, s = a.addEventListener("measure", o);
      a && !a.layout && ((n = a.root) === null || n === void 0 || n.updateScroll(), a.updateLayout()), o();
      var l = fh(window, "resize", function() {
        return t.scalePositionWithinConstraints();
      });
      return a.addEventListener("didUpdate", function(u) {
        var d = u.delta, f = u.hasLayoutChanged;
        t.isDragging && f && (mi(function(p) {
          var m = t.getAxisMotionValue(p);
          m && (t.originPoint[p] += d[p].translate, m.set(m.get() + d[p].translate));
        }), t.visualElement.syncRender());
      }), function() {
        l(), i(), s();
      };
    }, e.prototype.getProps = function() {
      var t = this.visualElement.getProps(), n = t.drag, r = n === void 0 ? !1 : n, i = t.dragDirectionLock, o = i === void 0 ? !1 : i, a = t.dragPropagation, s = a === void 0 ? !1 : a, l = t.dragConstraints, u = l === void 0 ? !1 : l, d = t.dragElastic, f = d === void 0 ? wv : d, p = t.dragMomentum, m = p === void 0 ? !0 : p;
      return ye(ye({}, t), { drag: r, dragDirectionLock: o, dragPropagation: s, dragConstraints: u, dragElastic: f, dragMomentum: m });
    }, e;
  }()
);
function Xu(e, t, n) {
  return (t === !0 || t === e) && (n === null || n === e);
}
function aW(e, t) {
  t === void 0 && (t = 10);
  var n = null;
  return Math.abs(e.y) > t ? n = "y" : Math.abs(e.x) > t && (n = "x"), n;
}
function sW(e) {
  var t = e.dragControls, n = e.visualElement, r = js(function() {
    return new oW(n);
  });
  be(function() {
    return t && t.subscribe(r);
  }, [r, t]), be(function() {
    return r.addListeners();
  }, [r]);
}
function lW(e) {
  var t = e.onPan, n = e.onPanStart, r = e.onPanEnd, i = e.onPanSessionStart, o = e.visualElement, a = t || n || r || i, s = me(null), l = Me(x1).transformPagePoint, u = {
    onSessionStart: i,
    onStart: n,
    onMove: t,
    onEnd: function(f, p) {
      s.current = null, r && r(f, p);
    }
  };
  be(function() {
    s.current !== null && s.current.updateHandlers(u);
  });
  function d(f) {
    s.current = new b5(f, u, {
      transformPagePoint: l
    });
  }
  af(o, "pointerdown", a && d), O1(function() {
    return s.current && s.current.end();
  });
}
var cW = {
  pan: ko(lW),
  drag: ko(sW)
}, Zu = [
  "LayoutMeasure",
  "BeforeLayoutMeasure",
  "LayoutUpdate",
  "ViewportBoxUpdate",
  "Update",
  "Render",
  "AnimationComplete",
  "LayoutAnimationComplete",
  "AnimationStart",
  "LayoutAnimationStart",
  "SetAxisTarget",
  "Unmount"
];
function uW() {
  var e = Zu.map(function() {
    return new Gl();
  }), t = {}, n = {
    clearAllListeners: function() {
      return e.forEach(function(r) {
        return r.clear();
      });
    },
    updatePropListeners: function(r) {
      Zu.forEach(function(i) {
        var o, a = "on" + i, s = r[a];
        (o = t[i]) === null || o === void 0 || o.call(t), s && (t[i] = n[a](s));
      });
    }
  };
  return e.forEach(function(r, i) {
    n["on" + Zu[i]] = function(o) {
      return r.add(o);
    }, n["notify" + Zu[i]] = function() {
      for (var o = [], a = 0; a < arguments.length; a++)
        o[a] = arguments[a];
      return r.notify.apply(r, mr([], Kt(o), !1));
    };
  }), n;
}
function dW(e, t, n) {
  var r;
  for (var i in t) {
    var o = t[i], a = n[i];
    if (Xi(o))
      e.addValue(i, o), process.env.NODE_ENV === "development" && h5(o.version === "6.5.1", "Attempting to mix Framer Motion versions ".concat(o.version, " with 6.5.1 may not work as expected."));
    else if (Xi(a))
      e.addValue(i, As(o));
    else if (a !== o)
      if (e.hasValue(i)) {
        var s = e.getValue(i);
        !s.hasAnimated && s.set(o);
      } else
        e.addValue(i, As((r = e.getStaticValue(i)) !== null && r !== void 0 ? r : o));
  }
  for (var i in n)
    t[i] === void 0 && e.removeValue(i);
  return t;
}
var P5 = function(e) {
  var t = e.treeType, n = t === void 0 ? "" : t, r = e.build, i = e.getBaseTarget, o = e.makeTargetAnimatable, a = e.measureViewportBox, s = e.render, l = e.readValueFromInstance, u = e.removeValueFromRenderState, d = e.sortNodePosition, f = e.scrapeMotionValuesFromProps;
  return function(p, m) {
    var g = p.parent, v = p.props, y = p.presenceId, b = p.blockInitialAnimation, E = p.visualState, S = p.shouldReduceMotion;
    m === void 0 && (m = {});
    var _ = !1, k = E.latestValues, T = E.renderState, A, R = uW(), F = /* @__PURE__ */ new Map(), D = /* @__PURE__ */ new Map(), W = {}, L = ye({}, k), z;
    function B() {
      !A || !_ || (G(), s(A, T, v.style, N.projection));
    }
    function G() {
      r(N, T, k, m, v);
    }
    function H() {
      R.notifyUpdate(k);
    }
    function J(ee, ae) {
      var pe = ae.onChange(function(Se) {
        k[ee] = Se, v.onUpdate && ni.update(H, !1, !0);
      }), se = ae.onRenderRequest(N.scheduleRender);
      D.set(ee, function() {
        pe(), se();
      });
    }
    var q = f(v);
    for (var Z in q) {
      var O = q[Z];
      k[Z] !== void 0 && Xi(O) && O.set(k[Z], !1);
    }
    var Q = dh(v), he = g_(v), N = ye(ye({
      treeType: n,
      /**
       * This is a mirror of the internal instance prop, which keeps
       * VisualElement type-compatible with React's RefObject.
       */
      current: null,
      /**
       * The depth of this visual element within the visual element tree.
       */
      depth: g ? g.depth + 1 : 0,
      parent: g,
      children: /* @__PURE__ */ new Set(),
      /**
       *
       */
      presenceId: y,
      shouldReduceMotion: S,
      /**
       * If this component is part of the variant tree, it should track
       * any children that are also part of the tree. This is essentially
       * a shadow tree to simplify logic around how to stagger over children.
       */
      variantChildren: he ? /* @__PURE__ */ new Set() : void 0,
      /**
       * Whether this instance is visible. This can be changed imperatively
       * by the projection tree, is analogous to CSS's visibility in that
       * hidden elements should take up layout, and needs enacting by the configured
       * render function.
       */
      isVisible: void 0,
      /**
       * Normally, if a component is controlled by a parent's variants, it can
       * rely on that ancestor to trigger animations further down the tree.
       * However, if a component is created after its parent is mounted, the parent
       * won't trigger that mount animation so the child needs to.
       *
       * TODO: This might be better replaced with a method isParentMounted
       */
      manuallyAnimateOnMount: !!(g != null && g.isMounted()),
      /**
       * This can be set by AnimatePresence to force components that mount
       * at the same time as it to mount as if they have initial={false} set.
       */
      blockInitialAnimation: b,
      /**
       * Determine whether this component has mounted yet. This is mostly used
       * by variant children to determine whether they need to trigger their
       * own animations on mount.
       */
      isMounted: function() {
        return !!A;
      },
      mount: function(ee) {
        _ = !0, A = N.current = ee, N.projection && N.projection.mount(ee), he && g && !Q && (z = g == null ? void 0 : g.addVariantChild(N)), F.forEach(function(ae, pe) {
          return J(pe, ae);
        }), g == null || g.children.add(N), N.setProps(v);
      },
      /**
       *
       */
      unmount: function() {
        var ee;
        (ee = N.projection) === null || ee === void 0 || ee.unmount(), Ts.update(H), Ts.render(B), D.forEach(function(ae) {
          return ae();
        }), z == null || z(), g == null || g.children.delete(N), R.clearAllListeners(), A = void 0, _ = !1;
      },
      /**
       * Add a child visual element to our set of children.
       */
      addVariantChild: function(ee) {
        var ae, pe = N.getClosestVariantNode();
        if (pe)
          return (ae = pe.variantChildren) === null || ae === void 0 || ae.add(ee), function() {
            return pe.variantChildren.delete(ee);
          };
      },
      sortNodePosition: function(ee) {
        return !d || n !== ee.treeType ? 0 : d(N.getInstance(), ee.getInstance());
      },
      /**
       * Returns the closest variant node in the tree starting from
       * this visual element.
       */
      getClosestVariantNode: function() {
        return he ? N : g == null ? void 0 : g.getClosestVariantNode();
      },
      /**
       * Expose the latest layoutId prop.
       */
      getLayoutId: function() {
        return v.layoutId;
      },
      /**
       * Returns the current instance.
       */
      getInstance: function() {
        return A;
      },
      /**
       * Get/set the latest static values.
       */
      getStaticValue: function(ee) {
        return k[ee];
      },
      setStaticValue: function(ee, ae) {
        return k[ee] = ae;
      },
      /**
       * Returns the latest motion value state. Currently only used to take
       * a snapshot of the visual element - perhaps this can return the whole
       * visual state
       */
      getLatestValues: function() {
        return k;
      },
      /**
       * Set the visiblity of the visual element. If it's changed, schedule
       * a render to reflect these changes.
       */
      setVisibility: function(ee) {
        N.isVisible !== ee && (N.isVisible = ee, N.scheduleRender());
      },
      /**
       * Make a target animatable by Popmotion. For instance, if we're
       * trying to animate width from 100px to 100vw we need to measure 100vw
       * in pixels to determine what we really need to animate to. This is also
       * pluggable to support Framer's custom value types like Color,
       * and CSS variables.
       */
      makeTargetAnimatable: function(ee, ae) {
        return ae === void 0 && (ae = !0), o(N, ee, v, ae);
      },
      /**
       * Measure the current viewport box with or without transforms.
       * Only measures axis-aligned boxes, rotate and skew must be manually
       * removed with a re-render to work.
       */
      measureViewportBox: function() {
        return a(A, v);
      },
      // Motion values ========================
      /**
       * Add a motion value and bind it to this visual element.
       */
      addValue: function(ee, ae) {
        N.hasValue(ee) && N.removeValue(ee), F.set(ee, ae), k[ee] = ae.get(), J(ee, ae);
      },
      /**
       * Remove a motion value and unbind any active subscriptions.
       */
      removeValue: function(ee) {
        var ae;
        F.delete(ee), (ae = D.get(ee)) === null || ae === void 0 || ae(), D.delete(ee), delete k[ee], u(ee, T);
      },
      /**
       * Check whether we have a motion value for this key
       */
      hasValue: function(ee) {
        return F.has(ee);
      },
      /**
       * Get a motion value for this key. If called with a default
       * value, we'll create one if none exists.
       */
      getValue: function(ee, ae) {
        var pe = F.get(ee);
        return pe === void 0 && ae !== void 0 && (pe = As(ae), N.addValue(ee, pe)), pe;
      },
      /**
       * Iterate over our motion values.
       */
      forEachValue: function(ee) {
        return F.forEach(ee);
      },
      /**
       * If we're trying to animate to a previously unencountered value,
       * we need to check for it in our state and as a last resort read it
       * directly from the instance (which might have performance implications).
       */
      readValue: function(ee) {
        var ae;
        return (ae = k[ee]) !== null && ae !== void 0 ? ae : l(A, ee, m);
      },
      /**
       * Set the base target to later animate back to. This is currently
       * only hydrated on creation and when we first read a value.
       */
      setBaseTarget: function(ee, ae) {
        L[ee] = ae;
      },
      /**
       * Find the base target for a value thats been removed from all animation
       * props.
       */
      getBaseTarget: function(ee) {
        if (i) {
          var ae = i(v, ee);
          if (ae !== void 0 && !Xi(ae))
            return ae;
        }
        return L[ee];
      }
    }, R), {
      /**
       * Build the renderer state based on the latest visual state.
       */
      build: function() {
        return G(), T;
      },
      /**
       * Schedule a render on the next animation frame.
       */
      scheduleRender: function() {
        ni.render(B, !1, !0);
      },
      /**
       * Synchronously fire render. It's prefered that we batch renders but
       * in many circumstances, like layout measurement, we need to run this
       * synchronously. However in those instances other measures should be taken
       * to batch reads/writes.
       */
      syncRender: B,
      /**
       * Update the provided props. Ensure any newly-added motion values are
       * added to our map, old ones removed, and listeners updated.
       */
      setProps: function(ee) {
        (ee.transformTemplate || v.transformTemplate) && N.scheduleRender(), v = ee, R.updatePropListeners(ee), W = dW(N, f(v), W);
      },
      getProps: function() {
        return v;
      },
      // Variants ==============================
      /**
       * Returns the variant definition with a given name.
       */
      getVariant: function(ee) {
        var ae;
        return (ae = v.variants) === null || ae === void 0 ? void 0 : ae[ee];
      },
      /**
       * Returns the defined default transition on this component.
       */
      getDefaultTransition: function() {
        return v.transition;
      },
      getTransformPagePoint: function() {
        return v.transformPagePoint;
      },
      /**
       * Used by child variant nodes to get the closest ancestor variant props.
       */
      getVariantContext: function(ee) {
        if (ee === void 0 && (ee = !1), ee)
          return g == null ? void 0 : g.getVariantContext();
        if (!Q) {
          var ae = (g == null ? void 0 : g.getVariantContext()) || {};
          return v.initial !== void 0 && (ae.initial = v.initial), ae;
        }
        for (var pe = {}, se = 0; se < fW; se++) {
          var Se = k5[se], le = v[Se];
          (Qr(le) || le === !1) && (pe[Se] = le);
        }
        return pe;
      }
    });
    return N;
  };
}, k5 = mr(["initial"], Kt(U1), !1), fW = k5.length;
function xv(e) {
  return typeof e == "string" && e.startsWith("var(--");
}
var T5 = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function hW(e) {
  var t = T5.exec(e);
  if (!t)
    return [,];
  var n = Kt(t, 3), r = n[1], i = n[2];
  return [r, i];
}
var pW = 4;
function Ev(e, t, n) {
  n === void 0 && (n = 1), Nr(n <= pW, 'Max CSS variable fallback depth detected in property "'.concat(e, '". This may indicate a circular fallback dependency.'));
  var r = Kt(hW(e), 2), i = r[0], o = r[1];
  if (i) {
    var a = window.getComputedStyle(t).getPropertyValue(i);
    return a ? a.trim() : xv(o) ? Ev(o, t, n + 1) : o;
  }
}
function mW(e, t, n) {
  var r, i = Bn(t, []), o = e.getInstance();
  if (!(o instanceof Element))
    return { target: i, transitionEnd: n };
  n && (n = ye({}, n)), e.forEachValue(function(u) {
    var d = u.get();
    if (xv(d)) {
      var f = Ev(d, o);
      f && u.set(f);
    }
  });
  for (var a in i) {
    var s = i[a];
    if (xv(s)) {
      var l = Ev(s, o);
      l && (i[a] = l, n && ((r = n[a]) !== null && r !== void 0 || (n[a] = s)));
    }
  }
  return { target: i, transitionEnd: n };
}
var gW = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y"
]), A5 = function(e) {
  return gW.has(e);
}, vW = function(e) {
  return Object.keys(e).some(A5);
}, M5 = function(e, t) {
  e.set(t, !1), e.set(t);
}, Qu = function(e) {
  return e === ka || e === Ue;
}, g3;
(function(e) {
  e.width = "width", e.height = "height", e.left = "left", e.right = "right", e.top = "top", e.bottom = "bottom";
})(g3 || (g3 = {}));
var v3 = function(e, t) {
  return parseFloat(e.split(", ")[t]);
}, y3 = function(e, t) {
  return function(n, r) {
    var i = r.transform;
    if (i === "none" || !i)
      return 0;
    var o = i.match(/^matrix3d\((.+)\)$/);
    if (o)
      return v3(o[1], t);
    var a = i.match(/^matrix\((.+)\)$/);
    return a ? v3(a[1], e) : 0;
  };
}, yW = /* @__PURE__ */ new Set(["x", "y", "z"]), wW = oc.filter(function(e) {
  return !yW.has(e);
});
function bW(e) {
  var t = [];
  return wW.forEach(function(n) {
    var r = e.getValue(n);
    r !== void 0 && (t.push([n, r.get()]), r.set(n.startsWith("scale") ? 1 : 0));
  }), t.length && e.syncRender(), t;
}
var w3 = {
  // Dimensions
  width: function(e, t) {
    var n = e.x, r = t.paddingLeft, i = r === void 0 ? "0" : r, o = t.paddingRight, a = o === void 0 ? "0" : o;
    return n.max - n.min - parseFloat(i) - parseFloat(a);
  },
  height: function(e, t) {
    var n = e.y, r = t.paddingTop, i = r === void 0 ? "0" : r, o = t.paddingBottom, a = o === void 0 ? "0" : o;
    return n.max - n.min - parseFloat(i) - parseFloat(a);
  },
  top: function(e, t) {
    var n = t.top;
    return parseFloat(n);
  },
  left: function(e, t) {
    var n = t.left;
    return parseFloat(n);
  },
  bottom: function(e, t) {
    var n = e.y, r = t.top;
    return parseFloat(r) + (n.max - n.min);
  },
  right: function(e, t) {
    var n = e.x, r = t.left;
    return parseFloat(r) + (n.max - n.min);
  },
  // Transform
  x: y3(4, 13),
  y: y3(5, 14)
}, xW = function(e, t, n) {
  var r = t.measureViewportBox(), i = t.getInstance(), o = getComputedStyle(i), a = o.display, s = {};
  a === "none" && t.setStaticValue("display", e.display || "block"), n.forEach(function(u) {
    s[u] = w3[u](r, o);
  }), t.syncRender();
  var l = t.measureViewportBox();
  return n.forEach(function(u) {
    var d = t.getValue(u);
    M5(d, s[u]), e[u] = w3[u](l, o);
  }), e;
}, EW = function(e, t, n, r) {
  n === void 0 && (n = {}), r === void 0 && (r = {}), t = ye({}, t), r = ye({}, r);
  var i = Object.keys(t).filter(A5), o = [], a = !1, s = [];
  if (i.forEach(function(d) {
    var f = e.getValue(d);
    if (e.hasValue(d)) {
      var p = n[d], m = yl(p), g = t[d], v;
      if (sc(g)) {
        var y = g.length, b = g[0] === null ? 1 : 0;
        p = g[b], m = yl(p);
        for (var E = b; E < y; E++)
          v ? Nr(yl(g[E]) === v, "All keyframes must be of the same type") : (v = yl(g[E]), Nr(v === m || Qu(m) && Qu(v), "Keyframes must be of the same dimension as the current value"));
      } else
        v = yl(g);
      if (m !== v)
        if (Qu(m) && Qu(v)) {
          var S = f.get();
          typeof S == "string" && f.set(parseFloat(S)), typeof g == "string" ? t[d] = parseFloat(g) : Array.isArray(g) && v === Ue && (t[d] = g.map(parseFloat));
        } else
          m != null && m.transform && (v != null && v.transform) && (p === 0 || g === 0) ? p === 0 ? f.set(v.transform(p)) : t[d] = m.transform(g) : (a || (o = bW(e), a = !0), s.push(d), r[d] = r[d] !== void 0 ? r[d] : t[d], M5(f, g));
    }
  }), s.length) {
    var l = s.indexOf("height") >= 0 ? window.pageYOffset : null, u = xW(t, e, s);
    return o.length && o.forEach(function(d) {
      var f = Kt(d, 2), p = f[0], m = f[1];
      e.getValue(p).set(m);
    }), e.syncRender(), l !== null && window.scrollTo({ top: l }), { target: u, transitionEnd: r };
  } else
    return { target: t, transitionEnd: r };
};
function CW(e, t, n, r) {
  return vW(t) ? EW(e, t, n, r) : { target: t, transitionEnd: r };
}
var SW = function(e, t, n, r) {
  var i = mW(e, t, r);
  return t = i.target, r = i.transitionEnd, CW(e, t, n, r);
};
function _W(e) {
  return window.getComputedStyle(e);
}
var O5 = {
  treeType: "dom",
  readValueFromInstance: function(e, t) {
    if (Ac(t)) {
      var n = F1(t);
      return n && n.default || 0;
    } else {
      var r = _W(e);
      return (b_(t) ? r.getPropertyValue(t) : r[t]) || 0;
    }
  },
  sortNodePosition: function(e, t) {
    return e.compareDocumentPosition(t) & 2 ? 1 : -1;
  },
  getBaseTarget: function(e, t) {
    var n;
    return (n = e.style) === null || n === void 0 ? void 0 : n[t];
  },
  measureViewportBox: function(e, t) {
    var n = t.transformPagePoint;
    return _5(e, n);
  },
  /**
   * Reset the transform on the current Element. This is called as part
   * of a batched process across the entire layout tree. To remove this write
   * cycle it'd be interesting to see if it's possible to "undo" all the current
   * layout transforms up the tree in the same way this.getBoundingBoxWithoutTransforms
   * works
   */
  resetTransform: function(e, t, n) {
    var r = n.transformTemplate;
    t.style.transform = r ? r({}, "") : "none", e.scheduleRender();
  },
  restoreTransform: function(e, t) {
    e.style.transform = t.style.transform;
  },
  removeValueFromRenderState: function(e, t) {
    var n = t.vars, r = t.style;
    delete n[e], delete r[e];
  },
  /**
   * Ensure that HTML and Framer-specific value types like `px`->`%` and `Color`
   * can be animated by Motion.
   */
  makeTargetAnimatable: function(e, t, n, r) {
    var i = n.transformValues;
    r === void 0 && (r = !0);
    var o = t.transition, a = t.transitionEnd, s = Bn(t, ["transition", "transitionEnd"]), l = Oj(s, o || {}, e);
    if (i && (a && (a = i(a)), s && (s = i(s)), l && (l = i(l))), r) {
      Aj(e, s, l);
      var u = SW(e, s, l, a);
      a = u.transitionEnd, s = u.target;
    }
    return ye({ transition: o, transitionEnd: a }, s);
  },
  scrapeMotionValuesFromProps: T1,
  build: function(e, t, n, r, i) {
    e.isVisible !== void 0 && (t.style.visibility = e.isVisible ? "visible" : "hidden"), _1(t, n, r, i.transformTemplate);
  },
  render: I_
}, PW = P5(O5), kW = P5(ye(ye({}, O5), { getBaseTarget: function(e, t) {
  return e[t];
}, readValueFromInstance: function(e, t) {
  var n;
  return Ac(t) ? ((n = F1(t)) === null || n === void 0 ? void 0 : n.default) || 0 : (t = D_.has(t) ? t : R_(t), e.getAttribute(t));
}, scrapeMotionValuesFromProps: $_, build: function(e, t, n, r, i) {
  k1(t, n, r, i.transformTemplate);
}, render: N_ })), TW = function(e, t) {
  return C1(e) ? kW(t, { enableHardwareAcceleration: !1 }) : PW(t, { enableHardwareAcceleration: !0 });
};
function b3(e, t) {
  return t.max === t.min ? 0 : e / (t.max - t.min) * 100;
}
var wl = {
  correct: function(e, t) {
    if (!t.target)
      return e;
    if (typeof e == "string")
      if (Ue.test(e))
        e = parseFloat(e);
      else
        return e;
    var n = b3(e, t.target.x), r = b3(e, t.target.y);
    return "".concat(n, "% ").concat(r, "%");
  }
}, x3 = "_$css", AW = {
  correct: function(e, t) {
    var n = t.treeScale, r = t.projectionDelta, i = e, o = e.includes("var("), a = [];
    o && (e = e.replace(T5, function(v) {
      return a.push(v), x3;
    }));
    var s = Zi.parse(e);
    if (s.length > 5)
      return i;
    var l = Zi.createTransformer(e), u = typeof s[0] != "number" ? 1 : 0, d = r.x.scale * n.x, f = r.y.scale * n.y;
    s[0 + u] /= d, s[1 + u] /= f;
    var p = Yt(d, f, 0.5);
    typeof s[2 + u] == "number" && (s[2 + u] /= p), typeof s[3 + u] == "number" && (s[3 + u] /= p);
    var m = l(s);
    if (o) {
      var g = 0;
      m = m.replace(x3, function() {
        var v = a[g];
        return g++, v;
      });
    }
    return m;
  }
}, MW = (
  /** @class */
  function(e) {
    GS(t, e);
    function t() {
      return e !== null && e.apply(this, arguments) || this;
    }
    return t.prototype.componentDidMount = function() {
      var n = this, r = this.props, i = r.visualElement, o = r.layoutGroup, a = r.switchLayoutGroup, s = r.layoutId, l = i.projection;
      nV(RW), l && (o != null && o.group && o.group.add(l), a != null && a.register && s && a.register(l), l.root.didUpdate(), l.addEventListener("animationComplete", function() {
        n.safeToRemove();
      }), l.setOptions(ye(ye({}, l.options), { onExitComplete: function() {
        return n.safeToRemove();
      } }))), Wl.hasEverUpdated = !0;
    }, t.prototype.getSnapshotBeforeUpdate = function(n) {
      var r = this, i = this.props, o = i.layoutDependency, a = i.visualElement, s = i.drag, l = i.isPresent, u = a.projection;
      return u && (u.isPresent = l, s || n.layoutDependency !== o || o === void 0 ? u.willUpdate() : this.safeToRemove(), n.isPresent !== l && (l ? u.promote() : u.relegate() || ni.postRender(function() {
        var d;
        !((d = u.getStack()) === null || d === void 0) && d.members.length || r.safeToRemove();
      }))), null;
    }, t.prototype.componentDidUpdate = function() {
      var n = this.props.visualElement.projection;
      n && (n.root.didUpdate(), !n.currentAnimation && n.isLead() && this.safeToRemove());
    }, t.prototype.componentWillUnmount = function() {
      var n = this.props, r = n.visualElement, i = n.layoutGroup, o = n.switchLayoutGroup, a = r.projection;
      a && (a.scheduleCheckAfterUnmount(), i != null && i.group && i.group.remove(a), o != null && o.deregister && o.deregister(a));
    }, t.prototype.safeToRemove = function() {
      var n = this.props.safeToRemove;
      n == null || n();
    }, t.prototype.render = function() {
      return null;
    }, t;
  }(x.Component)
);
function OW(e) {
  var t = Kt(m5(), 2), n = t[0], r = t[1], i = Me(E1);
  return x.createElement(MW, ye({}, e, { layoutGroup: i, switchLayoutGroup: Me(v_), isPresent: n, safeToRemove: r }));
}
var RW = {
  borderRadius: ye(ye({}, wl), { applyTo: [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ] }),
  borderTopLeftRadius: wl,
  borderTopRightRadius: wl,
  borderBottomLeftRadius: wl,
  borderBottomRightRadius: wl,
  boxShadow: AW
}, IW = {
  measureLayout: OW
};
function DW(e, t, n) {
  n === void 0 && (n = {});
  var r = Xi(e) ? e : As(e);
  return B1("", r, t, n), {
    stop: function() {
      return r.stop();
    },
    isAnimating: function() {
      return r.isAnimating();
    }
  };
}
var R5 = ["TopLeft", "TopRight", "BottomLeft", "BottomRight"], NW = R5.length, E3 = function(e) {
  return typeof e == "string" ? parseFloat(e) : e;
}, C3 = function(e) {
  return typeof e == "number" || Ue.test(e);
};
function $W(e, t, n, r, i, o) {
  var a, s, l, u;
  i ? (e.opacity = Yt(
    0,
    // (follow?.opacity as number) ?? 0,
    // TODO Reinstate this if only child
    (a = n.opacity) !== null && a !== void 0 ? a : 1,
    LW(r)
  ), e.opacityExit = Yt((s = t.opacity) !== null && s !== void 0 ? s : 1, 0, FW(r))) : o && (e.opacity = Yt((l = t.opacity) !== null && l !== void 0 ? l : 1, (u = n.opacity) !== null && u !== void 0 ? u : 1, r));
  for (var d = 0; d < NW; d++) {
    var f = "border".concat(R5[d], "Radius"), p = S3(t, f), m = S3(n, f);
    if (!(p === void 0 && m === void 0)) {
      p || (p = 0), m || (m = 0);
      var g = p === 0 || m === 0 || C3(p) === C3(m);
      g ? (e[f] = Math.max(Yt(E3(p), E3(m), r), 0), (wi.test(m) || wi.test(p)) && (e[f] += "%")) : e[f] = m;
    }
  }
  (t.rotate || n.rotate) && (e.rotate = Yt(t.rotate || 0, n.rotate || 0, r));
}
function S3(e, t) {
  var n;
  return (n = e[t]) !== null && n !== void 0 ? n : e.borderRadius;
}
var LW = I5(0, 0.5, $1), FW = I5(0.5, 0.95, D1);
function I5(e, t, n) {
  return function(r) {
    return r < e ? 0 : r > t ? 1 : n(lc(e, t, r));
  };
}
function _3(e, t) {
  e.min = t.min, e.max = t.max;
}
function Yr(e, t) {
  _3(e.x, t.x), _3(e.y, t.y);
}
function P3(e, t, n, r, i) {
  return e -= t, e = ff(e, 1 / n, r), i !== void 0 && (e = ff(e, 1 / i, r)), e;
}
function zW(e, t, n, r, i, o, a) {
  if (t === void 0 && (t = 0), n === void 0 && (n = 1), r === void 0 && (r = 0.5), o === void 0 && (o = e), a === void 0 && (a = e), wi.test(t)) {
    t = parseFloat(t);
    var s = Yt(a.min, a.max, t / 100);
    t = s - a.min;
  }
  if (typeof t == "number") {
    var l = Yt(o.min, o.max, r);
    e === o && (l -= t), e.min = P3(e.min, t, n, l, i), e.max = P3(e.max, t, n, l, i);
  }
}
function k3(e, t, n, r, i) {
  var o = Kt(n, 3), a = o[0], s = o[1], l = o[2];
  zW(e, t[a], t[s], t[l], t.scale, r, i);
}
var VW = ["x", "scaleX", "originX"], BW = ["y", "scaleY", "originY"];
function T3(e, t, n, r) {
  k3(e.x, t, VW, n == null ? void 0 : n.x, r == null ? void 0 : r.x), k3(e.y, t, BW, n == null ? void 0 : n.y, r == null ? void 0 : r.y);
}
function A3(e) {
  return e.translate === 0 && e.scale === 1;
}
function D5(e) {
  return A3(e.x) && A3(e.y);
}
function N5(e, t) {
  return e.x.min === t.x.min && e.x.max === t.x.max && e.y.min === t.y.min && e.y.max === t.y.max;
}
var jW = (
  /** @class */
  function() {
    function e() {
      this.members = [];
    }
    return e.prototype.add = function(t) {
      j1(this.members, t), t.scheduleRender();
    }, e.prototype.remove = function(t) {
      if (W1(this.members, t), t === this.prevLead && (this.prevLead = void 0), t === this.lead) {
        var n = this.members[this.members.length - 1];
        n && this.promote(n);
      }
    }, e.prototype.relegate = function(t) {
      var n = this.members.findIndex(function(a) {
        return t === a;
      });
      if (n === 0)
        return !1;
      for (var r, i = n; i >= 0; i--) {
        var o = this.members[i];
        if (o.isPresent !== !1) {
          r = o;
          break;
        }
      }
      return r ? (this.promote(r), !0) : !1;
    }, e.prototype.promote = function(t, n) {
      var r, i = this.lead;
      if (t !== i && (this.prevLead = i, this.lead = t, t.show(), i)) {
        i.instance && i.scheduleRender(), t.scheduleRender(), t.resumeFrom = i, n && (t.resumeFrom.preserveOpacity = !0), i.snapshot && (t.snapshot = i.snapshot, t.snapshot.latestValues = i.animationValues || i.latestValues, t.snapshot.isShared = !0), !((r = t.root) === null || r === void 0) && r.isUpdating && (t.isLayoutDirty = !0);
        var o = t.options.crossfade;
        o === !1 && i.hide();
      }
    }, e.prototype.exitAnimationComplete = function() {
      this.members.forEach(function(t) {
        var n, r, i, o, a;
        (r = (n = t.options).onExitComplete) === null || r === void 0 || r.call(n), (a = (i = t.resumingFrom) === null || i === void 0 ? void 0 : (o = i.options).onExitComplete) === null || a === void 0 || a.call(o);
      });
    }, e.prototype.scheduleRender = function() {
      this.members.forEach(function(t) {
        t.instance && t.scheduleRender(!1);
      });
    }, e.prototype.removeLeadSnapshot = function() {
      this.lead && this.lead.snapshot && (this.lead.snapshot = void 0);
    }, e;
  }()
), WW = "translate3d(0px, 0px, 0) scale(1, 1) scale(1, 1)";
function M3(e, t, n) {
  var r = e.x.translate / t.x, i = e.y.translate / t.y, o = "translate3d(".concat(r, "px, ").concat(i, "px, 0) ");
  if (o += "scale(".concat(1 / t.x, ", ").concat(1 / t.y, ") "), n) {
    var a = n.rotate, s = n.rotateX, l = n.rotateY;
    a && (o += "rotate(".concat(a, "deg) ")), s && (o += "rotateX(".concat(s, "deg) ")), l && (o += "rotateY(".concat(l, "deg) "));
  }
  var u = e.x.scale * t.x, d = e.y.scale * t.y;
  return o += "scale(".concat(u, ", ").concat(d, ")"), o === WW ? "none" : o;
}
var UW = function(e, t) {
  return e.depth - t.depth;
}, HW = (
  /** @class */
  function() {
    function e() {
      this.children = [], this.isDirty = !1;
    }
    return e.prototype.add = function(t) {
      j1(this.children, t), this.isDirty = !0;
    }, e.prototype.remove = function(t) {
      W1(this.children, t), this.isDirty = !0;
    }, e.prototype.forEach = function(t) {
      this.isDirty && this.children.sort(UW), this.isDirty = !1, this.children.forEach(t);
    }, e;
  }()
), O3 = 1e3;
function $5(e) {
  var t = e.attachResizeListener, n = e.defaultParent, r = e.measureScroll, i = e.checkIsScrollRoot, o = e.resetTransform;
  return (
    /** @class */
    function() {
      function a(s, l, u) {
        var d = this;
        l === void 0 && (l = {}), u === void 0 && (u = n == null ? void 0 : n()), this.children = /* @__PURE__ */ new Set(), this.options = {}, this.isTreeAnimating = !1, this.isAnimationBlocked = !1, this.isLayoutDirty = !1, this.updateManuallyBlocked = !1, this.updateBlockedByResize = !1, this.isUpdating = !1, this.isSVG = !1, this.needsReset = !1, this.shouldResetTransform = !1, this.treeScale = { x: 1, y: 1 }, this.eventHandlers = /* @__PURE__ */ new Map(), this.potentialNodes = /* @__PURE__ */ new Map(), this.checkUpdateFailed = function() {
          d.isUpdating && (d.isUpdating = !1, d.clearAllSnapshots());
        }, this.updateProjection = function() {
          d.nodes.forEach(ZW), d.nodes.forEach(QW);
        }, this.hasProjected = !1, this.isVisible = !0, this.animationProgress = 0, this.sharedNodes = /* @__PURE__ */ new Map(), this.id = s, this.latestValues = l, this.root = u ? u.root || u : this, this.path = u ? mr(mr([], Kt(u.path), !1), [u], !1) : [], this.parent = u, this.depth = u ? u.depth + 1 : 0, s && this.root.registerPotentialNode(s, this);
        for (var f = 0; f < this.path.length; f++)
          this.path[f].shouldResetTransform = !0;
        this.root === this && (this.nodes = new HW());
      }
      return a.prototype.addEventListener = function(s, l) {
        return this.eventHandlers.has(s) || this.eventHandlers.set(s, new Gl()), this.eventHandlers.get(s).add(l);
      }, a.prototype.notifyListeners = function(s) {
        for (var l = [], u = 1; u < arguments.length; u++)
          l[u - 1] = arguments[u];
        var d = this.eventHandlers.get(s);
        d == null || d.notify.apply(d, mr([], Kt(l), !1));
      }, a.prototype.hasListeners = function(s) {
        return this.eventHandlers.has(s);
      }, a.prototype.registerPotentialNode = function(s, l) {
        this.potentialNodes.set(s, l);
      }, a.prototype.mount = function(s, l) {
        var u = this, d;
        if (l === void 0 && (l = !1), !this.instance) {
          this.isSVG = s instanceof SVGElement && s.tagName !== "svg", this.instance = s;
          var f = this.options, p = f.layoutId, m = f.layout, g = f.visualElement;
          if (g && !g.getInstance() && g.mount(s), this.root.nodes.add(this), (d = this.parent) === null || d === void 0 || d.children.add(this), this.id && this.root.potentialNodes.delete(this.id), l && (m || p) && (this.isLayoutDirty = !0), t) {
            var v, y = function() {
              return u.root.updateBlockedByResize = !1;
            };
            t(s, function() {
              u.root.updateBlockedByResize = !0, clearTimeout(v), v = window.setTimeout(y, 250), Wl.hasAnimatedSinceResize && (Wl.hasAnimatedSinceResize = !1, u.nodes.forEach(XW));
            });
          }
          p && this.root.registerSharedNode(p, this), this.options.animate !== !1 && g && (p || m) && this.addEventListener("didUpdate", function(b) {
            var E, S, _, k, T, A = b.delta, R = b.hasLayoutChanged, F = b.hasRelativeTargetChanged, D = b.layout;
            if (u.isTreeAnimationBlocked()) {
              u.target = void 0, u.relativeTarget = void 0;
              return;
            }
            var W = (S = (E = u.options.transition) !== null && E !== void 0 ? E : g.getDefaultTransition()) !== null && S !== void 0 ? S : rU, L = g.getProps(), z = L.onLayoutAnimationStart, B = L.onLayoutAnimationComplete, G = !u.targetLayout || !N5(u.targetLayout, D) || F, H = !R && F;
            if (!((_ = u.resumeFrom) === null || _ === void 0) && _.instance || H || R && (G || !u.currentAnimation)) {
              u.resumeFrom && (u.resumingFrom = u.resumeFrom, u.resumingFrom.resumingFrom = void 0), u.setAnimationOrigin(A, H);
              var J = ye(ye({}, V1(W, "layout")), { onPlay: z, onComplete: B });
              g.shouldReduceMotion && (J.delay = 0, J.type = !1), u.startAnimation(J);
            } else
              !R && u.animationProgress === 0 && u.finishAnimation(), u.isLead() && ((T = (k = u.options).onExitComplete) === null || T === void 0 || T.call(k));
            u.targetLayout = D;
          });
        }
      }, a.prototype.unmount = function() {
        var s, l;
        this.options.layoutId && this.willUpdate(), this.root.nodes.remove(this), (s = this.getStack()) === null || s === void 0 || s.remove(this), (l = this.parent) === null || l === void 0 || l.children.delete(this), this.instance = void 0, Ts.preRender(this.updateProjection);
      }, a.prototype.blockUpdate = function() {
        this.updateManuallyBlocked = !0;
      }, a.prototype.unblockUpdate = function() {
        this.updateManuallyBlocked = !1;
      }, a.prototype.isUpdateBlocked = function() {
        return this.updateManuallyBlocked || this.updateBlockedByResize;
      }, a.prototype.isTreeAnimationBlocked = function() {
        var s;
        return this.isAnimationBlocked || ((s = this.parent) === null || s === void 0 ? void 0 : s.isTreeAnimationBlocked()) || !1;
      }, a.prototype.startUpdate = function() {
        var s;
        this.isUpdateBlocked() || (this.isUpdating = !0, (s = this.nodes) === null || s === void 0 || s.forEach(JW));
      }, a.prototype.willUpdate = function(s) {
        var l, u, d;
        if (s === void 0 && (s = !0), this.root.isUpdateBlocked()) {
          (u = (l = this.options).onExitComplete) === null || u === void 0 || u.call(l);
          return;
        }
        if (!this.root.isUpdating && this.root.startUpdate(), !this.isLayoutDirty) {
          this.isLayoutDirty = !0;
          for (var f = 0; f < this.path.length; f++) {
            var p = this.path[f];
            p.shouldResetTransform = !0, p.updateScroll();
          }
          var m = this.options, g = m.layoutId, v = m.layout;
          if (!(g === void 0 && !v)) {
            var y = (d = this.options.visualElement) === null || d === void 0 ? void 0 : d.getProps().transformTemplate;
            this.prevTransformTemplateValue = y == null ? void 0 : y(this.latestValues, ""), this.updateSnapshot(), s && this.notifyListeners("willUpdate");
          }
        }
      }, a.prototype.didUpdate = function() {
        var s = this.isUpdateBlocked();
        if (s) {
          this.unblockUpdate(), this.clearAllSnapshots(), this.nodes.forEach(R3);
          return;
        }
        this.isUpdating && (this.isUpdating = !1, this.potentialNodes.size && (this.potentialNodes.forEach(iU), this.potentialNodes.clear()), this.nodes.forEach(KW), this.nodes.forEach(GW), this.nodes.forEach(qW), this.clearAllSnapshots(), zm.update(), zm.preRender(), zm.render());
      }, a.prototype.clearAllSnapshots = function() {
        this.nodes.forEach(YW), this.sharedNodes.forEach(eU);
      }, a.prototype.scheduleUpdateProjection = function() {
        ni.preRender(this.updateProjection, !1, !0);
      }, a.prototype.scheduleCheckAfterUnmount = function() {
        var s = this;
        ni.postRender(function() {
          s.isLayoutDirty ? s.root.didUpdate() : s.root.checkUpdateFailed();
        });
      }, a.prototype.updateSnapshot = function() {
        if (!(this.snapshot || !this.instance)) {
          var s = this.measure(), l = this.removeTransform(this.removeElementScroll(s));
          $3(l), this.snapshot = {
            measured: s,
            layout: l,
            latestValues: {}
          };
        }
      }, a.prototype.updateLayout = function() {
        var s;
        if (this.instance && (this.updateScroll(), !(!(this.options.alwaysMeasureLayout && this.isLead()) && !this.isLayoutDirty))) {
          if (this.resumeFrom && !this.resumeFrom.instance)
            for (var l = 0; l < this.path.length; l++) {
              var u = this.path[l];
              u.updateScroll();
            }
          var d = this.measure();
          $3(d);
          var f = this.layout;
          this.layout = {
            measured: d,
            actual: this.removeElementScroll(d)
          }, this.layoutCorrected = An(), this.isLayoutDirty = !1, this.projectionDelta = void 0, this.notifyListeners("measure", this.layout.actual), (s = this.options.visualElement) === null || s === void 0 || s.notifyLayoutMeasure(this.layout.actual, f == null ? void 0 : f.actual);
        }
      }, a.prototype.updateScroll = function() {
        this.options.layoutScroll && this.instance && (this.isScrollRoot = i(this.instance), this.scroll = r(this.instance));
      }, a.prototype.resetTransform = function() {
        var s;
        if (o) {
          var l = this.isLayoutDirty || this.shouldResetTransform, u = this.projectionDelta && !D5(this.projectionDelta), d = (s = this.options.visualElement) === null || s === void 0 ? void 0 : s.getProps().transformTemplate, f = d == null ? void 0 : d(this.latestValues, ""), p = f !== this.prevTransformTemplateValue;
          l && (u || Eo(this.latestValues) || p) && (o(this.instance, f), this.shouldResetTransform = !1, this.scheduleRender());
        }
      }, a.prototype.measure = function() {
        var s = this.options.visualElement;
        if (!s)
          return An();
        var l = s.measureViewportBox(), u = this.root.scroll;
        return u && (So(l.x, u.x), So(l.y, u.y)), l;
      }, a.prototype.removeElementScroll = function(s) {
        var l = An();
        Yr(l, s);
        for (var u = 0; u < this.path.length; u++) {
          var d = this.path[u], f = d.scroll, p = d.options, m = d.isScrollRoot;
          if (d !== this.root && f && p.layoutScroll) {
            if (m) {
              Yr(l, s);
              var g = this.root.scroll;
              g && (So(l.x, -g.x), So(l.y, -g.y));
            }
            So(l.x, f.x), So(l.y, f.y);
          }
        }
        return l;
      }, a.prototype.applyTransform = function(s, l) {
        l === void 0 && (l = !1);
        var u = An();
        Yr(u, s);
        for (var d = 0; d < this.path.length; d++) {
          var f = this.path[d];
          !l && f.options.layoutScroll && f.scroll && f !== f.root && fs(u, {
            x: -f.scroll.x,
            y: -f.scroll.y
          }), Eo(f.latestValues) && fs(u, f.latestValues);
        }
        return Eo(this.latestValues) && fs(u, this.latestValues), u;
      }, a.prototype.removeTransform = function(s) {
        var l, u = An();
        Yr(u, s);
        for (var d = 0; d < this.path.length; d++) {
          var f = this.path[d];
          if (f.instance && Eo(f.latestValues)) {
            C5(f.latestValues) && f.updateSnapshot();
            var p = An(), m = f.measure();
            Yr(p, m), T3(u, f.latestValues, (l = f.snapshot) === null || l === void 0 ? void 0 : l.layout, p);
          }
        }
        return Eo(this.latestValues) && T3(u, this.latestValues), u;
      }, a.prototype.setTargetDelta = function(s) {
        this.targetDelta = s, this.root.scheduleUpdateProjection();
      }, a.prototype.setOptions = function(s) {
        var l;
        this.options = ye(ye(ye({}, this.options), s), { crossfade: (l = s.crossfade) !== null && l !== void 0 ? l : !0 });
      }, a.prototype.clearMeasurements = function() {
        this.scroll = void 0, this.layout = void 0, this.snapshot = void 0, this.prevTransformTemplateValue = void 0, this.targetDelta = void 0, this.target = void 0, this.isLayoutDirty = !1;
      }, a.prototype.resolveTargetDelta = function() {
        var s, l = this.options, u = l.layout, d = l.layoutId;
        !this.layout || !(u || d) || (!this.targetDelta && !this.relativeTarget && (this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && this.relativeParent.layout && (this.relativeTarget = An(), this.relativeTargetOrigin = An(), Yl(this.relativeTargetOrigin, this.layout.actual, this.relativeParent.layout.actual), Yr(this.relativeTarget, this.relativeTargetOrigin))), !(!this.relativeTarget && !this.targetDelta) && (this.target || (this.target = An(), this.targetWithTransforms = An()), this.relativeTarget && this.relativeTargetOrigin && (!((s = this.relativeParent) === null || s === void 0) && s.target) ? Hj(this.target, this.relativeTarget, this.relativeParent.target) : this.targetDelta ? (this.resumingFrom ? this.target = this.applyTransform(this.layout.actual) : Yr(this.target, this.layout.actual), S5(this.target, this.targetDelta)) : Yr(this.target, this.layout.actual), this.attemptToResolveRelativeTarget && (this.attemptToResolveRelativeTarget = !1, this.relativeParent = this.getClosestProjectingParent(), this.relativeParent && !!this.relativeParent.resumingFrom == !!this.resumingFrom && !this.relativeParent.options.layoutScroll && this.relativeParent.target && (this.relativeTarget = An(), this.relativeTargetOrigin = An(), Yl(this.relativeTargetOrigin, this.target, this.relativeParent.target), Yr(this.relativeTarget, this.relativeTargetOrigin)))));
      }, a.prototype.getClosestProjectingParent = function() {
        if (!(!this.parent || Eo(this.parent.latestValues)))
          return (this.parent.relativeTarget || this.parent.targetDelta) && this.parent.layout ? this.parent : this.parent.getClosestProjectingParent();
      }, a.prototype.calcProjection = function() {
        var s, l = this.options, u = l.layout, d = l.layoutId;
        if (this.isTreeAnimating = !!(!((s = this.parent) === null || s === void 0) && s.isTreeAnimating || this.currentAnimation || this.pendingAnimation), this.isTreeAnimating || (this.targetDelta = this.relativeTarget = void 0), !(!this.layout || !(u || d))) {
          var f = this.getLead();
          Yr(this.layoutCorrected, this.layout.actual), eW(this.layoutCorrected, this.treeScale, this.path, !!this.resumingFrom || this !== f);
          var p = f.target;
          if (p) {
            this.projectionDelta || (this.projectionDelta = Kl(), this.projectionDeltaWithTransform = Kl());
            var m = this.treeScale.x, g = this.treeScale.y, v = this.projectionTransform;
            ql(this.projectionDelta, this.layoutCorrected, p, this.latestValues), this.projectionTransform = M3(this.projectionDelta, this.treeScale), (this.projectionTransform !== v || this.treeScale.x !== m || this.treeScale.y !== g) && (this.hasProjected = !0, this.scheduleRender(), this.notifyListeners("projectionUpdate", p));
          }
        }
      }, a.prototype.hide = function() {
        this.isVisible = !1;
      }, a.prototype.show = function() {
        this.isVisible = !0;
      }, a.prototype.scheduleRender = function(s) {
        var l, u, d;
        s === void 0 && (s = !0), (u = (l = this.options).scheduleRender) === null || u === void 0 || u.call(l), s && ((d = this.getStack()) === null || d === void 0 || d.scheduleRender()), this.resumingFrom && !this.resumingFrom.instance && (this.resumingFrom = void 0);
      }, a.prototype.setAnimationOrigin = function(s, l) {
        var u = this, d;
        l === void 0 && (l = !1);
        var f = this.snapshot, p = (f == null ? void 0 : f.latestValues) || {}, m = ye({}, this.latestValues), g = Kl();
        this.relativeTarget = this.relativeTargetOrigin = void 0, this.attemptToResolveRelativeTarget = !l;
        var v = An(), y = f == null ? void 0 : f.isShared, b = (((d = this.getStack()) === null || d === void 0 ? void 0 : d.members.length) || 0) <= 1, E = !!(y && !b && this.options.crossfade === !0 && !this.path.some(nU));
        this.animationProgress = 0, this.mixTargetDelta = function(S) {
          var _, k = S / 1e3;
          I3(g.x, s.x, k), I3(g.y, s.y, k), u.setTargetDelta(g), u.relativeTarget && u.relativeTargetOrigin && u.layout && (!((_ = u.relativeParent) === null || _ === void 0) && _.layout) && (Yl(v, u.layout.actual, u.relativeParent.layout.actual), tU(u.relativeTarget, u.relativeTargetOrigin, v, k)), y && (u.animationValues = m, $W(m, p, u.latestValues, k, E, b)), u.root.scheduleUpdateProjection(), u.scheduleRender(), u.animationProgress = k;
        }, this.mixTargetDelta(0);
      }, a.prototype.startAnimation = function(s) {
        var l = this, u, d;
        this.notifyListeners("animationStart"), (u = this.currentAnimation) === null || u === void 0 || u.stop(), this.resumingFrom && ((d = this.resumingFrom.currentAnimation) === null || d === void 0 || d.stop()), this.pendingAnimation && (Ts.update(this.pendingAnimation), this.pendingAnimation = void 0), this.pendingAnimation = ni.update(function() {
          Wl.hasAnimatedSinceResize = !0, l.currentAnimation = DW(0, O3, ye(ye({}, s), { onUpdate: function(f) {
            var p;
            l.mixTargetDelta(f), (p = s.onUpdate) === null || p === void 0 || p.call(s, f);
          }, onComplete: function() {
            var f;
            (f = s.onComplete) === null || f === void 0 || f.call(s), l.completeAnimation();
          } })), l.resumingFrom && (l.resumingFrom.currentAnimation = l.currentAnimation), l.pendingAnimation = void 0;
        });
      }, a.prototype.completeAnimation = function() {
        var s;
        this.resumingFrom && (this.resumingFrom.currentAnimation = void 0, this.resumingFrom.preserveOpacity = void 0), (s = this.getStack()) === null || s === void 0 || s.exitAnimationComplete(), this.resumingFrom = this.currentAnimation = this.animationValues = void 0, this.notifyListeners("animationComplete");
      }, a.prototype.finishAnimation = function() {
        var s;
        this.currentAnimation && ((s = this.mixTargetDelta) === null || s === void 0 || s.call(this, O3), this.currentAnimation.stop()), this.completeAnimation();
      }, a.prototype.applyTransformsToTarget = function() {
        var s = this.getLead(), l = s.targetWithTransforms, u = s.target, d = s.layout, f = s.latestValues;
        !l || !u || !d || (Yr(l, u), fs(l, f), ql(this.projectionDeltaWithTransform, this.layoutCorrected, l, f));
      }, a.prototype.registerSharedNode = function(s, l) {
        var u, d, f;
        this.sharedNodes.has(s) || this.sharedNodes.set(s, new jW());
        var p = this.sharedNodes.get(s);
        p.add(l), l.promote({
          transition: (u = l.options.initialPromotionConfig) === null || u === void 0 ? void 0 : u.transition,
          preserveFollowOpacity: (f = (d = l.options.initialPromotionConfig) === null || d === void 0 ? void 0 : d.shouldPreserveFollowOpacity) === null || f === void 0 ? void 0 : f.call(d, l)
        });
      }, a.prototype.isLead = function() {
        var s = this.getStack();
        return s ? s.lead === this : !0;
      }, a.prototype.getLead = function() {
        var s, l = this.options.layoutId;
        return l ? ((s = this.getStack()) === null || s === void 0 ? void 0 : s.lead) || this : this;
      }, a.prototype.getPrevLead = function() {
        var s, l = this.options.layoutId;
        return l ? (s = this.getStack()) === null || s === void 0 ? void 0 : s.prevLead : void 0;
      }, a.prototype.getStack = function() {
        var s = this.options.layoutId;
        if (s)
          return this.root.sharedNodes.get(s);
      }, a.prototype.promote = function(s) {
        var l = s === void 0 ? {} : s, u = l.needsReset, d = l.transition, f = l.preserveFollowOpacity, p = this.getStack();
        p && p.promote(this, f), u && (this.projectionDelta = void 0, this.needsReset = !0), d && this.setOptions({ transition: d });
      }, a.prototype.relegate = function() {
        var s = this.getStack();
        return s ? s.relegate(this) : !1;
      }, a.prototype.resetRotation = function() {
        var s = this.options.visualElement;
        if (s) {
          for (var l = !1, u = {}, d = 0; d < sv.length; d++) {
            var f = sv[d], p = "rotate" + f;
            s.getStaticValue(p) && (l = !0, u[p] = s.getStaticValue(p), s.setStaticValue(p, 0));
          }
          if (l) {
            s == null || s.syncRender();
            for (var p in u)
              s.setStaticValue(p, u[p]);
            s.scheduleRender();
          }
        }
      }, a.prototype.getProjectionStyles = function(s) {
        var l, u, d, f, p, m;
        s === void 0 && (s = {});
        var g = {};
        if (!this.instance || this.isSVG)
          return g;
        if (this.isVisible)
          g.visibility = "";
        else
          return { visibility: "hidden" };
        var v = (l = this.options.visualElement) === null || l === void 0 ? void 0 : l.getProps().transformTemplate;
        if (this.needsReset)
          return this.needsReset = !1, g.opacity = "", g.pointerEvents = Nd(s.pointerEvents) || "", g.transform = v ? v(this.latestValues, "") : "none", g;
        var y = this.getLead();
        if (!this.projectionDelta || !this.layout || !y.target) {
          var b = {};
          return this.options.layoutId && (b.opacity = (u = this.latestValues.opacity) !== null && u !== void 0 ? u : 1, b.pointerEvents = Nd(s.pointerEvents) || ""), this.hasProjected && !Eo(this.latestValues) && (b.transform = v ? v({}, "") : "none", this.hasProjected = !1), b;
        }
        var E = y.animationValues || y.latestValues;
        this.applyTransformsToTarget(), g.transform = M3(this.projectionDeltaWithTransform, this.treeScale, E), v && (g.transform = v(E, g.transform));
        var S = this.projectionDelta, _ = S.x, k = S.y;
        g.transformOrigin = "".concat(_.origin * 100, "% ").concat(k.origin * 100, "% 0"), y.animationValues ? g.opacity = y === this ? (f = (d = E.opacity) !== null && d !== void 0 ? d : this.latestValues.opacity) !== null && f !== void 0 ? f : 1 : this.preserveOpacity ? this.latestValues.opacity : E.opacityExit : g.opacity = y === this ? (p = E.opacity) !== null && p !== void 0 ? p : "" : (m = E.opacityExit) !== null && m !== void 0 ? m : 0;
        for (var T in rf)
          if (E[T] !== void 0) {
            var A = rf[T], R = A.correct, F = A.applyTo, D = R(E[T], y);
            if (F)
              for (var W = F.length, L = 0; L < W; L++)
                g[F[L]] = D;
            else
              g[T] = D;
          }
        return this.options.layoutId && (g.pointerEvents = y === this ? Nd(s.pointerEvents) || "" : "none"), g;
      }, a.prototype.clearSnapshot = function() {
        this.resumeFrom = this.snapshot = void 0;
      }, a.prototype.resetTree = function() {
        this.root.nodes.forEach(function(s) {
          var l;
          return (l = s.currentAnimation) === null || l === void 0 ? void 0 : l.stop();
        }), this.root.nodes.forEach(R3), this.root.sharedNodes.clear();
      }, a;
    }()
  );
}
function GW(e) {
  e.updateLayout();
}
function qW(e) {
  var t, n, r, i, o = (n = (t = e.resumeFrom) === null || t === void 0 ? void 0 : t.snapshot) !== null && n !== void 0 ? n : e.snapshot;
  if (e.isLead() && e.layout && o && e.hasListeners("didUpdate")) {
    var a = e.layout, s = a.actual, l = a.measured;
    e.options.animationType === "size" ? mi(function(E) {
      var S = o.isShared ? o.measured[E] : o.layout[E], _ = Qi(S);
      S.min = s[E].min, S.max = S.min + _;
    }) : e.options.animationType === "position" && mi(function(E) {
      var S = o.isShared ? o.measured[E] : o.layout[E], _ = Qi(s[E]);
      S.max = S.min + _;
    });
    var u = Kl();
    ql(u, s, o.layout);
    var d = Kl();
    o.isShared ? ql(d, e.applyTransform(l, !0), o.measured) : ql(d, s, o.layout);
    var f = !D5(u), p = !1;
    if (!e.resumeFrom && (e.relativeParent = e.getClosestProjectingParent(), e.relativeParent && !e.relativeParent.resumeFrom)) {
      var m = e.relativeParent, g = m.snapshot, v = m.layout;
      if (g && v) {
        var y = An();
        Yl(y, o.layout, g.layout);
        var b = An();
        Yl(b, s, v.actual), N5(y, b) || (p = !0);
      }
    }
    e.notifyListeners("didUpdate", {
      layout: s,
      snapshot: o,
      delta: d,
      layoutDelta: u,
      hasLayoutChanged: f,
      hasRelativeTargetChanged: p
    });
  } else
    e.isLead() && ((i = (r = e.options).onExitComplete) === null || i === void 0 || i.call(r));
  e.options.transition = void 0;
}
function YW(e) {
  e.clearSnapshot();
}
function R3(e) {
  e.clearMeasurements();
}
function KW(e) {
  var t = e.options.visualElement;
  t != null && t.getProps().onBeforeLayoutMeasure && t.notifyBeforeLayoutMeasure(), e.resetTransform();
}
function XW(e) {
  e.finishAnimation(), e.targetDelta = e.relativeTarget = e.target = void 0;
}
function ZW(e) {
  e.resolveTargetDelta();
}
function QW(e) {
  e.calcProjection();
}
function JW(e) {
  e.resetRotation();
}
function eU(e) {
  e.removeLeadSnapshot();
}
function I3(e, t, n) {
  e.translate = Yt(t.translate, 0, n), e.scale = Yt(t.scale, 1, n), e.origin = t.origin, e.originPoint = t.originPoint;
}
function D3(e, t, n, r) {
  e.min = Yt(t.min, n.min, r), e.max = Yt(t.max, n.max, r);
}
function tU(e, t, n, r) {
  D3(e.x, t.x, n.x, r), D3(e.y, t.y, n.y, r);
}
function nU(e) {
  return e.animationValues && e.animationValues.opacityExit !== void 0;
}
var rU = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
function iU(e, t) {
  for (var n = e.root, r = e.path.length - 1; r >= 0; r--)
    if (e.path[r].instance) {
      n = e.path[r];
      break;
    }
  var i = n && n !== e.root ? n.instance : document, o = i.querySelector('[data-projection-id="'.concat(t, '"]'));
  o && e.mount(o, !0);
}
function N3(e) {
  e.min = Math.round(e.min), e.max = Math.round(e.max);
}
function $3(e) {
  N3(e.x), N3(e.y);
}
var oU = $5({
  attachResizeListener: function(e, t) {
    return fh(e, "resize", t);
  },
  measureScroll: function() {
    return {
      x: document.documentElement.scrollLeft || document.body.scrollLeft,
      y: document.documentElement.scrollTop || document.body.scrollTop
    };
  },
  checkIsScrollRoot: function() {
    return !0;
  }
}), Hm = {
  current: void 0
}, aU = $5({
  measureScroll: function(e) {
    return {
      x: e.scrollLeft,
      y: e.scrollTop
    };
  },
  defaultParent: function() {
    if (!Hm.current) {
      var e = new oU(0, {});
      e.mount(window), e.setOptions({ layoutScroll: !0 }), Hm.current = e;
    }
    return Hm.current;
  },
  resetTransform: function(e, t) {
    e.style.transform = t ?? "none";
  },
  checkIsScrollRoot: function(e) {
    return window.getComputedStyle(e).position === "fixed";
  }
}), sU = ye(ye(ye(ye({}, jj), sj), cW), IW), mn = /* @__PURE__ */ eV(function(e, t) {
  return VV(e, t, sU, TW, aU);
});
function L5() {
  var e = me(!1);
  return nf(function() {
    return e.current = !0, function() {
      e.current = !1;
    };
  }, []), e;
}
function lU() {
  var e = L5(), t = Kt(de(0), 2), n = t[0], r = t[1], i = De(function() {
    e.current && r(n + 1);
  }, [n]), o = De(function() {
    return ni.postRender(i);
  }, [i]);
  return [o, n];
}
var Gm = function(e) {
  var t = e.children, n = e.initial, r = e.isPresent, i = e.onExitComplete, o = e.custom, a = e.presenceAffectsLayout, s = js(cU), l = p5(), u = Lt(
    function() {
      return {
        id: l,
        initial: n,
        isPresent: r,
        custom: o,
        onExitComplete: function(d) {
          var f, p;
          s.set(d, !0);
          try {
            for (var m = jF(s.values()), g = m.next(); !g.done; g = m.next()) {
              var v = g.value;
              if (!v)
                return;
            }
          } catch (y) {
            f = { error: y };
          } finally {
            try {
              g && !g.done && (p = m.return) && p.call(m);
            } finally {
              if (f)
                throw f.error;
            }
          }
          i == null || i();
        },
        register: function(d) {
          return s.set(d, !1), function() {
            return s.delete(d);
          };
        }
      };
    },
    /**
     * If the presence of a child affects the layout of the components around it,
     * we want to make a new context value to ensure they get re-rendered
     * so they can detect that layout change.
     */
    a ? void 0 : [r]
  );
  return Lt(function() {
    s.forEach(function(d, f) {
      return s.set(f, !1);
    });
  }, [r]), C.useEffect(function() {
    !r && !s.size && (i == null || i());
  }, [r]), C.createElement(Tc.Provider, { value: u }, t);
};
function cU() {
  return /* @__PURE__ */ new Map();
}
var os = function(e) {
  return e.key || "";
};
function uU(e, t) {
  e.forEach(function(n) {
    var r = os(n);
    t.set(r, n);
  });
}
function dU(e) {
  var t = [];
  return Ui.forEach(e, function(n) {
    Ps(n) && t.push(n);
  }), t;
}
var ri = function(e) {
  var t = e.children, n = e.custom, r = e.initial, i = r === void 0 ? !0 : r, o = e.onExitComplete, a = e.exitBeforeEnter, s = e.presenceAffectsLayout, l = s === void 0 ? !0 : s, u = Kt(lU(), 1), d = u[0], f = Me(E1).forceRender;
  f && (d = f);
  var p = L5(), m = dU(t), g = m, v = /* @__PURE__ */ new Set(), y = me(g), b = me(/* @__PURE__ */ new Map()).current, E = me(!0);
  if (nf(function() {
    E.current = !1, uU(m, b), y.current = g;
  }), O1(function() {
    E.current = !0, b.clear(), v.clear();
  }), E.current)
    return C.createElement(C.Fragment, null, g.map(function(R) {
      return C.createElement(Gm, { key: os(R), isPresent: !0, initial: i ? void 0 : !1, presenceAffectsLayout: l }, R);
    }));
  g = mr([], Kt(g), !1);
  for (var S = y.current.map(os), _ = m.map(os), k = S.length, T = 0; T < k; T++) {
    var A = S[T];
    _.indexOf(A) === -1 && v.add(A);
  }
  return a && v.size && (g = []), v.forEach(function(R) {
    if (_.indexOf(R) === -1) {
      var F = b.get(R);
      if (F) {
        var D = S.indexOf(R), W = function() {
          b.delete(R), v.delete(R);
          var L = y.current.findIndex(function(z) {
            return z.key === R;
          });
          if (y.current.splice(L, 1), !v.size) {
            if (y.current = m, p.current === !1)
              return;
            d(), o && o();
          }
        };
        g.splice(D, 0, C.createElement(Gm, { key: os(F), isPresent: !1, onExitComplete: W, custom: n, presenceAffectsLayout: l }, F));
      }
    }
  }), g = g.map(function(R) {
    var F = R.key;
    return v.has(F) ? R : C.createElement(Gm, { key: os(R), isPresent: !0, presenceAffectsLayout: l }, R);
  }), b1 !== "production" && a && g.length > 1 && console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour."), C.createElement(C.Fragment, null, v.size ? g : g.map(function(R) {
    return qf(R);
  }));
}, fU = (
  /** @class */
  function() {
    function e() {
      this.componentControls = /* @__PURE__ */ new Set();
    }
    return e.prototype.subscribe = function(t) {
      var n = this;
      return this.componentControls.add(t), function() {
        return n.componentControls.delete(t);
      };
    }, e.prototype.start = function(t, n) {
      this.componentControls.forEach(function(r) {
        r.start(t.nativeEvent || t, n);
      });
    }, e;
  }()
), hU = function() {
  return new fU();
};
function pU() {
  return js(hU);
}
const mU = wn(null), qm = {
  didCatch: !1,
  error: null
};
class Do extends y$ {
  constructor(t) {
    super(t), this.resetErrorBoundary = this.resetErrorBoundary.bind(this), this.state = qm;
  }
  static getDerivedStateFromError(t) {
    return {
      didCatch: !0,
      error: t
    };
  }
  resetErrorBoundary() {
    const {
      error: t
    } = this.state;
    if (t !== null) {
      for (var n, r, i = arguments.length, o = new Array(i), a = 0; a < i; a++)
        o[a] = arguments[a];
      (n = (r = this.props).onReset) === null || n === void 0 || n.call(r, {
        args: o,
        reason: "imperative-api"
      }), this.setState(qm);
    }
  }
  componentDidCatch(t, n) {
    var r, i;
    (r = (i = this.props).onError) === null || r === void 0 || r.call(i, t, n);
  }
  componentDidUpdate(t, n) {
    const {
      didCatch: r
    } = this.state, {
      resetKeys: i
    } = this.props;
    if (r && n.error !== null && gU(t.resetKeys, i)) {
      var o, a;
      (o = (a = this.props).onReset) === null || o === void 0 || o.call(a, {
        next: i,
        prev: t.resetKeys,
        reason: "keys"
      }), this.setState(qm);
    }
  }
  render() {
    const {
      children: t,
      fallbackRender: n,
      FallbackComponent: r,
      fallback: i
    } = this.props, {
      didCatch: o,
      error: a
    } = this.state;
    let s = t;
    if (o) {
      const l = {
        error: a,
        resetErrorBoundary: this.resetErrorBoundary
      };
      if (Ps(i))
        s = i;
      else if (typeof n == "function")
        s = n(l);
      else if (r)
        s = X(r, l);
      else
        throw new Error("react-error-boundary requires either a fallback, fallbackRender, or FallbackComponent prop");
    }
    return X(mU.Provider, {
      value: {
        didCatch: o,
        error: a,
        resetErrorBoundary: this.resetErrorBoundary
      }
    }, s);
  }
}
function gU() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  return e.length !== t.length || e.some((n, r) => !Object.is(n, t[r]));
}
function F5(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = F5(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function vU() {
  for (var e, t, n = 0, r = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = F5(e)) && (r && (r += " "), r += t);
  return r;
}
const L3 = (e) => typeof e == "boolean" ? "".concat(e) : e === 0 ? "0" : e, F3 = vU, $r = (e, t) => (n) => {
  var r;
  if ((t == null ? void 0 : t.variants) == null)
    return F3(e, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
  const { variants: i, defaultVariants: o } = t, a = Object.keys(i).map((u) => {
    const d = n == null ? void 0 : n[u], f = o == null ? void 0 : o[u];
    if (d === null)
      return null;
    const p = L3(d) || L3(f);
    return i[u][p];
  }), s = n && Object.entries(n).reduce((u, d) => {
    let [f, p] = d;
    return p === void 0 || (u[f] = p), u;
  }, {}), l = t == null || (r = t.compoundVariants) === null || r === void 0 ? void 0 : r.reduce((u, d) => {
    let { class: f, className: p, ...m } = d;
    return Object.entries(m).every((g) => {
      let [v, y] = g;
      return Array.isArray(y) ? y.includes({
        ...o,
        ...s
      }[v]) : {
        ...o,
        ...s
      }[v] === y;
    }) ? [
      ...u,
      f,
      p
    ] : u;
  }, []);
  return F3(e, a, l, n == null ? void 0 : n.class, n == null ? void 0 : n.className);
};
function z5(e) {
  var t, n, r = "";
  if (typeof e == "string" || typeof e == "number")
    r += e;
  else if (typeof e == "object")
    if (Array.isArray(e))
      for (t = 0; t < e.length; t++)
        e[t] && (n = z5(e[t])) && (r && (r += " "), r += n);
    else
      for (t in e)
        e[t] && (r && (r += " "), r += t);
  return r;
}
function uc() {
  for (var e, t, n = 0, r = ""; n < arguments.length; )
    (e = arguments[n++]) && (t = z5(e)) && (r && (r += " "), r += t);
  return r;
}
const yU = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clsx: uc,
  default: uc
}, Symbol.toStringTag, { value: "Module" }));
function wU() {
  for (var e = 0, t, n, r = ""; e < arguments.length; )
    (t = arguments[e++]) && (n = V5(t)) && (r && (r += " "), r += n);
  return r;
}
function V5(e) {
  if (typeof e == "string")
    return e;
  for (var t, n = "", r = 0; r < e.length; r++)
    e[r] && (t = V5(e[r])) && (n && (n += " "), n += t);
  return n;
}
var H1 = "-";
function bU(e) {
  var t = EU(e), n = e.conflictingClassGroups, r = e.conflictingClassGroupModifiers, i = r === void 0 ? {} : r;
  function o(s) {
    var l = s.split(H1);
    return l[0] === "" && l.length !== 1 && l.shift(), B5(l, t) || xU(s);
  }
  function a(s, l) {
    var u = n[s] || [];
    return l && i[s] ? [].concat(u, i[s]) : u;
  }
  return {
    getClassGroupId: o,
    getConflictingClassGroupIds: a
  };
}
function B5(e, t) {
  var a;
  if (e.length === 0)
    return t.classGroupId;
  var n = e[0], r = t.nextPart.get(n), i = r ? B5(e.slice(1), r) : void 0;
  if (i)
    return i;
  if (t.validators.length !== 0) {
    var o = e.join(H1);
    return (a = t.validators.find(function(s) {
      var l = s.validator;
      return l(o);
    })) == null ? void 0 : a.classGroupId;
  }
}
var z3 = /^\[(.+)\]$/;
function xU(e) {
  if (z3.test(e)) {
    var t = z3.exec(e)[1], n = t == null ? void 0 : t.substring(0, t.indexOf(":"));
    if (n)
      return "arbitrary.." + n;
  }
}
function EU(e) {
  var t = e.theme, n = e.prefix, r = {
    nextPart: /* @__PURE__ */ new Map(),
    validators: []
  }, i = SU(Object.entries(e.classGroups), n);
  return i.forEach(function(o) {
    var a = o[0], s = o[1];
    Cv(s, r, a, t);
  }), r;
}
function Cv(e, t, n, r) {
  e.forEach(function(i) {
    if (typeof i == "string") {
      var o = i === "" ? t : V3(t, i);
      o.classGroupId = n;
      return;
    }
    if (typeof i == "function") {
      if (CU(i)) {
        Cv(i(r), t, n, r);
        return;
      }
      t.validators.push({
        validator: i,
        classGroupId: n
      });
      return;
    }
    Object.entries(i).forEach(function(a) {
      var s = a[0], l = a[1];
      Cv(l, V3(t, s), n, r);
    });
  });
}
function V3(e, t) {
  var n = e;
  return t.split(H1).forEach(function(r) {
    n.nextPart.has(r) || n.nextPart.set(r, {
      nextPart: /* @__PURE__ */ new Map(),
      validators: []
    }), n = n.nextPart.get(r);
  }), n;
}
function CU(e) {
  return e.isThemeGetter;
}
function SU(e, t) {
  return t ? e.map(function(n) {
    var r = n[0], i = n[1], o = i.map(function(a) {
      return typeof a == "string" ? t + a : typeof a == "object" ? Object.fromEntries(Object.entries(a).map(function(s) {
        var l = s[0], u = s[1];
        return [t + l, u];
      })) : a;
    });
    return [r, o];
  }) : e;
}
function _U(e) {
  if (e < 1)
    return {
      get: function() {
      },
      set: function() {
      }
    };
  var t = 0, n = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  function i(o, a) {
    n.set(o, a), t++, t > e && (t = 0, r = n, n = /* @__PURE__ */ new Map());
  }
  return {
    get: function(a) {
      var s = n.get(a);
      if (s !== void 0)
        return s;
      if ((s = r.get(a)) !== void 0)
        return i(a, s), s;
    },
    set: function(a, s) {
      n.has(a) ? n.set(a, s) : i(a, s);
    }
  };
}
var j5 = "!";
function PU(e) {
  var t = e.separator || ":", n = t.length === 1, r = t[0], i = t.length;
  return function(a) {
    for (var s = [], l = 0, u = 0, d, f = 0; f < a.length; f++) {
      var p = a[f];
      if (l === 0) {
        if (p === r && (n || a.slice(f, f + i) === t)) {
          s.push(a.slice(u, f)), u = f + i;
          continue;
        }
        if (p === "/") {
          d = f;
          continue;
        }
      }
      p === "[" ? l++ : p === "]" && l--;
    }
    var m = s.length === 0 ? a : a.substring(u), g = m.startsWith(j5), v = g ? m.substring(1) : m, y = d && d > u ? d - u : void 0;
    return {
      modifiers: s,
      hasImportantModifier: g,
      baseClassName: v,
      maybePostfixModifierPosition: y
    };
  };
}
function kU(e) {
  if (e.length <= 1)
    return e;
  var t = [], n = [];
  return e.forEach(function(r) {
    var i = r[0] === "[";
    i ? (t.push.apply(t, n.sort().concat([r])), n = []) : n.push(r);
  }), t.push.apply(t, n.sort()), t;
}
function TU(e) {
  return {
    cache: _U(e.cacheSize),
    splitModifiers: PU(e),
    ...bU(e)
  };
}
var AU = /\s+/;
function MU(e, t) {
  var n = t.splitModifiers, r = t.getClassGroupId, i = t.getConflictingClassGroupIds, o = /* @__PURE__ */ new Set();
  return e.trim().split(AU).map(function(a) {
    var s = n(a), l = s.modifiers, u = s.hasImportantModifier, d = s.baseClassName, f = s.maybePostfixModifierPosition, p = r(f ? d.substring(0, f) : d), m = !!f;
    if (!p) {
      if (!f)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      if (p = r(d), !p)
        return {
          isTailwindClass: !1,
          originalClassName: a
        };
      m = !1;
    }
    var g = kU(l).join(":"), v = u ? g + j5 : g;
    return {
      isTailwindClass: !0,
      modifierId: v,
      classGroupId: p,
      originalClassName: a,
      hasPostfixModifier: m
    };
  }).reverse().filter(function(a) {
    if (!a.isTailwindClass)
      return !0;
    var s = a.modifierId, l = a.classGroupId, u = a.hasPostfixModifier, d = s + l;
    return o.has(d) ? !1 : (o.add(d), i(l, u).forEach(function(f) {
      return o.add(s + f);
    }), !0);
  }).reverse().map(function(a) {
    return a.originalClassName;
  }).join(" ");
}
function OU() {
  for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
    t[n] = arguments[n];
  var r, i, o, a = s;
  function s(u) {
    var d = t[0], f = t.slice(1), p = f.reduce(function(m, g) {
      return g(m);
    }, d());
    return r = TU(p), i = r.cache.get, o = r.cache.set, a = l, l(u);
  }
  function l(u) {
    var d = i(u);
    if (d)
      return d;
    var f = MU(u, r);
    return o(u, f), f;
  }
  return function() {
    return a(wU.apply(null, arguments));
  };
}
function Dt(e) {
  var t = function(r) {
    return r[e] || [];
  };
  return t.isThemeGetter = !0, t;
}
var W5 = /^\[(?:([a-z-]+):)?(.+)\]$/i, RU = /^\d+\/\d+$/, IU = /* @__PURE__ */ new Set(["px", "full", "screen"]), DU = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, NU = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, $U = /^-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
function Kr(e) {
  return ua(e) || IU.has(e) || RU.test(e) || Sv(e);
}
function Sv(e) {
  return Ta(e, "length", jU);
}
function LU(e) {
  return Ta(e, "size", U5);
}
function FU(e) {
  return Ta(e, "position", U5);
}
function zU(e) {
  return Ta(e, "url", WU);
}
function Ju(e) {
  return Ta(e, "number", ua);
}
function ua(e) {
  return !Number.isNaN(Number(e));
}
function VU(e) {
  return e.endsWith("%") && ua(e.slice(0, -1));
}
function bl(e) {
  return B3(e) || Ta(e, "number", B3);
}
function at(e) {
  return W5.test(e);
}
function xl() {
  return !0;
}
function po(e) {
  return DU.test(e);
}
function BU(e) {
  return Ta(e, "", UU);
}
function Ta(e, t, n) {
  var r = W5.exec(e);
  return r ? r[1] ? r[1] === t : n(r[2]) : !1;
}
function jU(e) {
  return NU.test(e);
}
function U5() {
  return !1;
}
function WU(e) {
  return e.startsWith("url(");
}
function B3(e) {
  return Number.isInteger(Number(e));
}
function UU(e) {
  return $U.test(e);
}
function HU() {
  var e = Dt("colors"), t = Dt("spacing"), n = Dt("blur"), r = Dt("brightness"), i = Dt("borderColor"), o = Dt("borderRadius"), a = Dt("borderSpacing"), s = Dt("borderWidth"), l = Dt("contrast"), u = Dt("grayscale"), d = Dt("hueRotate"), f = Dt("invert"), p = Dt("gap"), m = Dt("gradientColorStops"), g = Dt("gradientColorStopPositions"), v = Dt("inset"), y = Dt("margin"), b = Dt("opacity"), E = Dt("padding"), S = Dt("saturate"), _ = Dt("scale"), k = Dt("sepia"), T = Dt("skew"), A = Dt("space"), R = Dt("translate"), F = function() {
    return ["auto", "contain", "none"];
  }, D = function() {
    return ["auto", "hidden", "clip", "visible", "scroll"];
  }, W = function() {
    return ["auto", at, t];
  }, L = function() {
    return [at, t];
  }, z = function() {
    return ["", Kr];
  }, B = function() {
    return ["auto", ua, at];
  }, G = function() {
    return ["bottom", "center", "left", "left-bottom", "left-top", "right", "right-bottom", "right-top", "top"];
  }, H = function() {
    return ["solid", "dashed", "dotted", "double", "none"];
  }, J = function() {
    return ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity", "plus-lighter"];
  }, q = function() {
    return ["start", "end", "center", "between", "around", "evenly", "stretch"];
  }, Z = function() {
    return ["", "0", at];
  }, O = function() {
    return ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"];
  }, Q = function() {
    return [ua, Ju];
  }, he = function() {
    return [ua, at];
  };
  return {
    cacheSize: 500,
    theme: {
      colors: [xl],
      spacing: [Kr],
      blur: ["none", "", po, at],
      brightness: Q(),
      borderColor: [e],
      borderRadius: ["none", "", "full", po, at],
      borderSpacing: L(),
      borderWidth: z(),
      contrast: Q(),
      grayscale: Z(),
      hueRotate: he(),
      invert: Z(),
      gap: L(),
      gradientColorStops: [e],
      gradientColorStopPositions: [VU, Sv],
      inset: W(),
      margin: W(),
      opacity: Q(),
      padding: L(),
      saturate: Q(),
      scale: Q(),
      sepia: Z(),
      skew: he(),
      space: L(),
      translate: L()
    },
    classGroups: {
      // Layout
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", "video", at]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [po]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": O()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": O()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: [].concat(G(), [at])
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: D()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": D()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": D()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: F()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": F()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": F()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Top / Right / Bottom / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: [v]
      }],
      /**
       * Right / Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": [v]
      }],
      /**
       * Top / Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": [v]
      }],
      /**
       * Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      start: [{
        start: [v]
      }],
      /**
       * End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      end: [{
        end: [v]
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: [v]
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: [v]
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: [v]
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: [v]
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: ["auto", bl]
      }],
      // Flexbox and Grid
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: W()
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["wrap", "wrap-reverse", "nowrap"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: ["1", "auto", "initial", "none", at]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: Z()
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: Z()
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: ["first", "last", "none", bl]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": [xl]
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: ["auto", {
          span: ["full", bl]
        }, at]
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": B()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": B()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": [xl]
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: ["auto", {
          span: [bl]
        }, at]
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": B()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": B()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": ["auto", "min", "max", "fr", at]
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": ["auto", "min", "max", "fr", at]
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: [p]
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": [p]
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": [p]
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: ["normal"].concat(q())
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": ["start", "end", "center", "stretch"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", "start", "end", "center", "stretch"]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal"].concat(q(), ["baseline"])
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", "start", "end", "center", "stretch", "baseline"]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": [].concat(q(), ["baseline"])
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": ["start", "end", "center", "baseline", "stretch"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", "start", "end", "center", "stretch"]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: [E]
      }],
      /**
       * Padding X
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: [E]
      }],
      /**
       * Padding Y
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: [E]
      }],
      /**
       * Padding Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: [E]
      }],
      /**
       * Padding End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: [E]
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: [E]
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: [E]
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: [E]
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: [E]
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: [y]
      }],
      /**
       * Margin X
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: [y]
      }],
      /**
       * Margin Y
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: [y]
      }],
      /**
       * Margin Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: [y]
      }],
      /**
       * Margin End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: [y]
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: [y]
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: [y]
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: [y]
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: [y]
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/space
       */
      "space-x": [{
        "space-x": [A]
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/space
       */
      "space-y": [{
        "space-y": [A]
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/space
       */
      "space-y-reverse": ["space-y-reverse"],
      // Sizing
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: ["auto", "min", "max", "fit", at, t]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": ["min", "max", "fit", at, Kr]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": ["0", "none", "full", "min", "max", "fit", "prose", {
          screen: [po]
        }, po, at]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: [at, t, "auto", "min", "max", "fit"]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["min", "max", "fit", at, Kr]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": [at, t, "min", "max", "fit"]
      }],
      // Typography
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", po, Sv]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black", Ju]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [xl]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractons"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: ["tighter", "tight", "normal", "wide", "wider", "widest", at]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": ["none", ua, Ju]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: ["none", "tight", "snug", "normal", "relaxed", "loose", at, Kr]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", at]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["none", "disc", "decimal", at]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: [e]
      }],
      /**
       * Placeholder Opacity
       * @see https://tailwindcss.com/docs/placeholder-opacity
       */
      "placeholder-opacity": [{
        "placeholder-opacity": [b]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: [e]
      }],
      /**
       * Text Opacity
       * @see https://tailwindcss.com/docs/text-opacity
       */
      "text-opacity": [{
        "text-opacity": [b]
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [].concat(H(), ["wavy"])
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: ["auto", "from-font", Kr]
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": ["auto", at, Kr]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: [e]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: L()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", at]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", at]
      }],
      // Backgrounds
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Opacity
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/background-opacity
       */
      "bg-opacity": [{
        "bg-opacity": [b]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: [].concat(G(), [FU])
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: ["no-repeat", {
          repeat: ["", "x", "y", "round", "space"]
        }]
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: ["auto", "cover", "contain", LU]
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          "gradient-to": ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
        }, zU]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: [e]
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: [g]
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: [g]
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: [g]
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: [m]
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: [m]
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: [m]
      }],
      // Borders
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: [o]
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": [o]
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": [o]
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": [o]
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": [o]
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": [o]
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": [o]
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": [o]
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": [o]
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": [o]
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": [o]
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": [o]
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": [o]
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": [o]
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": [o]
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: [s]
      }],
      /**
       * Border Width X
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": [s]
      }],
      /**
       * Border Width Y
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": [s]
      }],
      /**
       * Border Width Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": [s]
      }],
      /**
       * Border Width End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": [s]
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": [s]
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": [s]
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": [s]
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": [s]
      }],
      /**
       * Border Opacity
       * @see https://tailwindcss.com/docs/border-opacity
       */
      "border-opacity": [{
        "border-opacity": [b]
      }],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [].concat(H(), ["hidden"])
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x": [{
        "divide-x": [s]
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y": [{
        "divide-y": [s]
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/divide-width
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Divide Opacity
       * @see https://tailwindcss.com/docs/divide-opacity
       */
      "divide-opacity": [{
        "divide-opacity": [b]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/divide-style
       */
      "divide-style": [{
        divide: H()
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: [i]
      }],
      /**
       * Border Color X
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": [i]
      }],
      /**
       * Border Color Y
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": [i]
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": [i]
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": [i]
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": [i]
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": [i]
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: [i]
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [""].concat(H())
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [at, Kr]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: [Kr]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: [e]
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w": [{
        ring: z()
      }],
      /**
       * Ring Width Inset
       * @see https://tailwindcss.com/docs/ring-width
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/ring-color
       */
      "ring-color": [{
        ring: [e]
      }],
      /**
       * Ring Opacity
       * @see https://tailwindcss.com/docs/ring-opacity
       */
      "ring-opacity": [{
        "ring-opacity": [b]
      }],
      /**
       * Ring Offset Width
       * @see https://tailwindcss.com/docs/ring-offset-width
       */
      "ring-offset-w": [{
        "ring-offset": [Kr]
      }],
      /**
       * Ring Offset Color
       * @see https://tailwindcss.com/docs/ring-offset-color
       */
      "ring-offset-color": [{
        "ring-offset": [e]
      }],
      // Effects
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: ["", "inner", "none", po, BU]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow-color
       */
      "shadow-color": [{
        shadow: [xl]
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [b]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": J()
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": J()
      }],
      // Filters
      /**
       * Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: ["", "none"]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: [n]
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [r]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [l]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": ["", "none", po, at]
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: [u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [d]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: [f]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [S]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: [k]
      }],
      /**
       * Backdrop Filter
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": ["", "none"]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": [n]
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [r]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [l]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": [u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [d]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": [f]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [b]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [S]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": [k]
      }],
      // Tables
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": [a]
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": [a]
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": [a]
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // Transitions and Animation
      /**
       * Tranisition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["none", "all", "", "colors", "opacity", "shadow", "transform", at]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: he()
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "in", "out", "in-out", at]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: he()
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", "spin", "ping", "pulse", "bounce", at]
      }],
      // Transforms
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: ["", "gpu", "none"]
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: [_]
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": [_]
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": [_]
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: [bl, at]
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": [R]
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": [R]
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": [T]
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": [T]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: ["center", "top", "top-right", "right", "bottom-right", "bottom", "bottom-left", "left", "top-left", at]
      }],
      // Interactivity
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: ["auto", e]
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: ["appearance-none"],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", at]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: [e]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["none", "auto"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "y", "x", ""]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": L()
      }],
      /**
       * Scroll Margin X
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": L()
      }],
      /**
       * Scroll Margin Y
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": L()
      }],
      /**
       * Scroll Margin Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": L()
      }],
      /**
       * Scroll Margin End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": L()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": L()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": L()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": L()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": L()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": L()
      }],
      /**
       * Scroll Padding X
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": L()
      }],
      /**
       * Scroll Padding Y
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": L()
      }],
      /**
       * Scroll Padding Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": L()
      }],
      /**
       * Scroll Padding End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": L()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": L()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": L()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": L()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": L()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "pinch-zoom", "manipulation", {
          pan: ["x", "left", "right", "y", "up", "down"]
        }]
      }],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", at]
      }],
      // SVG
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: [e, "none"]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [Kr, Ju]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: [e, "none"]
      }],
      // Accessibility
      /**
       * Screen Readers
       * @see https://tailwindcss.com/docs/screen-readers
       */
      sr: ["sr-only", "not-sr-only"]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-s", "border-w-e", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    }
  };
}
const GU = OU(() => ({
  ...HU(),
  prefix: "ai-tw-"
}));
function ie(...e) {
  return GU(uc(e));
}
function qU(e) {
  return e.endsWith("/") ? e.slice(0, -1) : e;
}
const YU = $r(
  ie(
    "ai-tw-inline-flex ai-tw-items-center ai-tw-justify-center ai-tw-rounded-full ai-tw-border-none ai-tw-bg-transparent ai-tw-bg-none ai-tw-transition-colors",
    "focus-visible:ai-tw-outline-none focus-visible:ai-tw-ring-2 focus-visible:ai-tw-ring-ring focus-visible:ai-tw-ring-offset-2",
    "ai-tw-cursor-pointer disabled:ai-tw-pointer-events-none"
  ),
  {
    variants: {
      background: {
        light: ie(
          "ai-tw-text-foreground hover:ai-tw-bg-black/5 active:ai-tw-bg-black/30",
          "disabled:ai-tw-text-black/25"
        ),
        dark: ie(
          "ai-tw-text-white hover:ai-tw-bg-white/10 active:ai-tw-bg-white/25",
          "disabled:ai-tw-text-white/25"
        )
      },
      size: {
        md: ie("ai-tw-h-6 ai-tw-w-6 ai-tw-text-sm"),
        lg: ie("ai-tw-h-8 ai-tw-w-8 ai-tw-text-base")
      }
    },
    defaultVariants: {
      background: "light",
      size: "md"
    }
  }
), G1 = C.forwardRef(
  ({ className: e, background: t, size: n, asChild: r = !1, ...i }, o) => {
    const a = r ? qi : "button";
    return /* @__PURE__ */ C.createElement(
      a,
      {
        className: ie(YU({ background: t, size: n, className: e })),
        ref: o,
        ...i
      }
    );
  }
);
G1.displayName = "Button";
var Bi = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Pi(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function KU(e) {
  if (e.__esModule)
    return e;
  var t = e.default;
  if (typeof t == "function") {
    var n = function r() {
      if (this instanceof r) {
        var i = [null];
        i.push.apply(i, arguments);
        var o = Function.bind.apply(t, i);
        return new o();
      }
      return t.apply(this, arguments);
    };
    n.prototype = t.prototype;
  } else
    n = {};
  return Object.defineProperty(n, "__esModule", { value: !0 }), Object.keys(e).forEach(function(r) {
    var i = Object.getOwnPropertyDescriptor(e, r);
    Object.defineProperty(n, r, i.get ? i : {
      enumerable: !0,
      get: function() {
        return e[r];
      }
    });
  }), n;
}
var _v = { exports: {} }, Ym = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var j3;
function XU() {
  if (j3)
    return Ym;
  j3 = 1;
  var e = x;
  function t(f, p) {
    return f === p && (f !== 0 || 1 / f === 1 / p) || f !== f && p !== p;
  }
  var n = typeof Object.is == "function" ? Object.is : t, r = e.useState, i = e.useEffect, o = e.useLayoutEffect, a = e.useDebugValue;
  function s(f, p) {
    var m = p(), g = r({ inst: { value: m, getSnapshot: p } }), v = g[0].inst, y = g[1];
    return o(
      function() {
        v.value = m, v.getSnapshot = p, l(v) && y({ inst: v });
      },
      [f, m, p]
    ), i(
      function() {
        return l(v) && y({ inst: v }), f(function() {
          l(v) && y({ inst: v });
        });
      },
      [f]
    ), a(m), m;
  }
  function l(f) {
    var p = f.getSnapshot;
    f = f.value;
    try {
      var m = p();
      return !n(f, m);
    } catch {
      return !0;
    }
  }
  function u(f, p) {
    return p();
  }
  var d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? u : s;
  return Ym.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : d, Ym;
}
var Km = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var W3;
function ZU() {
  return W3 || (W3 = 1, process.env.NODE_ENV !== "production" && function() {
    function e(m, g) {
      return m === g && (m !== 0 || 1 / m === 1 / g) || m !== m && g !== g;
    }
    function t(m, g) {
      d || i.startTransition === void 0 || (d = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var v = g();
      if (!f) {
        var y = g();
        o(v, y) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), f = !0);
      }
      y = a({
        inst: { value: v, getSnapshot: g }
      });
      var b = y[0].inst, E = y[1];
      return l(
        function() {
          b.value = v, b.getSnapshot = g, n(b) && E({ inst: b });
        },
        [m, v, g]
      ), s(
        function() {
          return n(b) && E({ inst: b }), m(function() {
            n(b) && E({ inst: b });
          });
        },
        [m]
      ), u(v), v;
    }
    function n(m) {
      var g = m.getSnapshot;
      m = m.value;
      try {
        var v = g();
        return !o(m, v);
      } catch {
        return !0;
      }
    }
    function r(m, g) {
      return g();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var i = x, o = typeof Object.is == "function" ? Object.is : e, a = i.useState, s = i.useEffect, l = i.useLayoutEffect, u = i.useDebugValue, d = !1, f = !1, p = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? r : t;
    Km.useSyncExternalStore = i.useSyncExternalStore !== void 0 ? i.useSyncExternalStore : p, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), Km;
}
process.env.NODE_ENV === "production" ? _v.exports = XU() : _v.exports = ZU();
var gh = _v.exports;
const To = () => {
}, pn = (
  /*#__NOINLINE__*/
  To()
), Fd = Object, Qe = (e) => e === pn, ei = (e) => typeof e == "function", Dr = (e, t) => ({
  ...e,
  ...t
}), QU = (e) => ei(e.then), ed = /* @__PURE__ */ new WeakMap();
let JU = 0;
const dc = (e) => {
  const t = typeof e, n = e && e.constructor, r = n == Date;
  let i, o;
  if (Fd(e) === e && !r && n != RegExp) {
    if (i = ed.get(e), i)
      return i;
    if (i = ++JU + "~", ed.set(e, i), n == Array) {
      for (i = "@", o = 0; o < e.length; o++)
        i += dc(e[o]) + ",";
      ed.set(e, i);
    }
    if (n == Fd) {
      i = "#";
      const a = Fd.keys(e).sort();
      for (; !Qe(o = a.pop()); )
        Qe(e[o]) || (i += o + ":" + dc(e[o]) + ",");
      ed.set(e, i);
    }
  } else
    i = r ? e.toJSON() : t == "symbol" ? e.toString() : t == "string" ? JSON.stringify(e) : "" + e;
  return i;
}, ji = /* @__PURE__ */ new WeakMap(), Xm = {}, td = {}, q1 = "undefined", vh = typeof window != q1, Pv = typeof document != q1, eH = () => vh && typeof window.requestAnimationFrame != q1, _o = (e, t) => {
  const n = ji.get(e);
  return [
    // Getter
    () => !Qe(t) && e.get(t) || Xm,
    // Setter
    (r) => {
      if (!Qe(t)) {
        const i = e.get(t);
        t in td || (td[t] = i), n[5](t, Dr(i, r), i || Xm);
      }
    },
    // Subscriber
    n[6],
    // Get server cache snapshot
    () => !Qe(t) && t in td ? td[t] : !Qe(t) && e.get(t) || Xm
  ];
};
let kv = !0;
const tH = () => kv, [Tv, Av] = vh && window.addEventListener ? [
  window.addEventListener.bind(window),
  window.removeEventListener.bind(window)
] : [
  To,
  To
], nH = () => {
  const e = Pv && document.visibilityState;
  return Qe(e) || e !== "hidden";
}, rH = (e) => (Pv && document.addEventListener("visibilitychange", e), Tv("focus", e), () => {
  Pv && document.removeEventListener("visibilitychange", e), Av("focus", e);
}), iH = (e) => {
  const t = () => {
    kv = !0, e();
  }, n = () => {
    kv = !1;
  };
  return Tv("online", t), Tv("offline", n), () => {
    Av("online", t), Av("offline", n);
  };
}, oH = {
  isOnline: tH,
  isVisible: nH
}, aH = {
  initFocus: rH,
  initReconnect: iH
}, Mv = !x.useId, fc = !vh || "Deno" in window, sH = (e) => eH() ? window.requestAnimationFrame(e) : setTimeout(e, 1), da = fc ? be : eo, Zm = typeof navigator < "u" && navigator.connection, U3 = !fc && Zm && ([
  "slow-2g",
  "2g"
].includes(Zm.effectiveType) || Zm.saveData), va = (e) => {
  if (ei(e))
    try {
      e = e();
    } catch {
      e = "";
    }
  const t = e;
  return e = typeof e == "string" ? e : (Array.isArray(e) ? e.length : e) ? dc(e) : "", [
    e,
    t
  ];
};
let lH = 0;
const hc = () => ++lH, H5 = 0, G5 = 1, q5 = 2, cH = 3;
var El = {
  __proto__: null,
  ERROR_REVALIDATE_EVENT: cH,
  FOCUS_EVENT: H5,
  MUTATE_EVENT: q5,
  RECONNECT_EVENT: G5
};
async function Y5(...e) {
  const [t, n, r, i] = e, o = Dr({
    populateCache: !0,
    throwOnError: !0
  }, typeof i == "boolean" ? {
    revalidate: i
  } : i || {});
  let a = o.populateCache;
  const s = o.rollbackOnError;
  let l = o.optimisticData;
  const u = o.revalidate !== !1, d = (m) => typeof s == "function" ? s(m) : s !== !1, f = o.throwOnError;
  if (ei(n)) {
    const m = n, g = [], v = t.keys();
    for (const y of v)
      // Skip the special useSWRInfinite and useSWRSubscription keys.
      !/^\$(inf|sub)\$/.test(y) && m(t.get(y)._k) && g.push(y);
    return Promise.all(g.map(p));
  }
  return p(n);
  async function p(m) {
    const [g] = va(m);
    if (!g)
      return;
    const [v, y] = _o(t, g), [b, E, S, _] = ji.get(t), k = b[g], T = () => u && (delete S[g], delete _[g], k && k[0]) ? k[0](q5).then(() => v().data) : v().data;
    if (e.length < 3)
      return T();
    let A = r, R;
    const F = hc();
    E[g] = [
      F,
      0
    ];
    const D = !Qe(l), W = v(), L = W.data, z = W._c, B = Qe(z) ? L : z;
    if (D && (l = ei(l) ? l(B, L) : l, y({
      data: l,
      _c: B
    })), ei(A))
      try {
        A = A(B);
      } catch (H) {
        R = H;
      }
    if (A && QU(A))
      if (A = await A.catch((H) => {
        R = H;
      }), F !== E[g][0]) {
        if (R)
          throw R;
        return A;
      } else
        R && D && d(R) && (a = !0, A = B, y({
          data: A,
          _c: pn
        }));
    a && (R || (ei(a) && (A = a(A, B)), y({
      data: A,
      error: pn,
      _c: pn
    }))), E[g][1] = hc();
    const G = await T();
    if (y({
      _c: pn
    }), R) {
      if (f)
        throw R;
      return;
    }
    return a ? G : A;
  }
}
const H3 = (e, t) => {
  for (const n in e)
    e[n][0] && e[n][0](t);
}, K5 = (e, t) => {
  if (!ji.has(e)) {
    const n = Dr(aH, t), r = {}, i = Y5.bind(pn, e);
    let o = To;
    const a = {}, s = (d, f) => {
      const p = a[d] || [];
      return a[d] = p, p.push(f), () => p.splice(p.indexOf(f), 1);
    }, l = (d, f, p) => {
      e.set(d, f);
      const m = a[d];
      if (m)
        for (const g of m)
          g(f, p);
    }, u = () => {
      if (!ji.has(e) && (ji.set(e, [
        r,
        {},
        {},
        {},
        i,
        l,
        s
      ]), !fc)) {
        const d = n.initFocus(setTimeout.bind(pn, H3.bind(pn, r, H5))), f = n.initReconnect(setTimeout.bind(pn, H3.bind(pn, r, G5)));
        o = () => {
          d && d(), f && f(), ji.delete(e);
        };
      }
    };
    return u(), [
      e,
      i,
      u,
      o
    ];
  }
  return [
    e,
    ji.get(e)[4]
  ];
}, uH = (e, t, n, r, i) => {
  const o = n.errorRetryCount, a = i.retryCount, s = ~~((Math.random() + 0.5) * (1 << (a < 8 ? a : 8))) * n.errorRetryInterval;
  !Qe(o) && a > o || setTimeout(r, s, i);
}, dH = (e, t) => dc(e) == dc(t), [Y1, Ov] = K5(/* @__PURE__ */ new Map()), X5 = Dr(
  {
    // events
    onLoadingSlow: To,
    onSuccess: To,
    onError: To,
    onErrorRetry: uH,
    onDiscarded: To,
    // switches
    revalidateOnFocus: !0,
    revalidateOnReconnect: !0,
    revalidateIfStale: !0,
    shouldRetryOnError: !0,
    // timeouts
    errorRetryInterval: U3 ? 1e4 : 5e3,
    focusThrottleInterval: 5 * 1e3,
    dedupingInterval: 2 * 1e3,
    loadingTimeout: U3 ? 5e3 : 3e3,
    // providers
    compare: dH,
    isPaused: () => !1,
    cache: Y1,
    mutate: Ov,
    fallback: {}
  },
  // use web preset by default
  oH
), Z5 = (e, t) => {
  const n = Dr(e, t);
  if (t) {
    const { use: r, fallback: i } = e, { use: o, fallback: a } = t;
    r && o && (n.use = r.concat(o)), i && a && (n.fallback = Dr(i, a));
  }
  return n;
}, Rv = wn({}), fH = (e) => {
  const { value: t } = e, n = Me(Rv), r = ei(t), i = Lt(() => r ? t(n) : t, [
    r,
    n,
    t
  ]), o = Lt(() => r ? i : Z5(n, i), [
    r,
    n,
    i
  ]), a = i && i.provider, s = me(pn);
  a && !s.current && (s.current = K5(a(o.cache || Y1), i));
  const l = s.current;
  return l && (o.cache = l[0], o.mutate = l[1]), da(() => {
    if (l)
      return l[2] && l[2](), l[3];
  }, []), X(Rv.Provider, Dr(e, {
    value: o
  }));
}, Q5 = vh && window.__SWR_DEVTOOLS_USE__, hH = Q5 ? window.__SWR_DEVTOOLS_USE__ : [], pH = () => {
  Q5 && (window.__SWR_DEVTOOLS_REACT__ = x);
}, J5 = (e) => ei(e[1]) ? [
  e[0],
  e[1],
  e[2] || {}
] : [
  e[0],
  null,
  (e[1] === null ? e[2] : e[1]) || {}
], K1 = () => Dr(X5, Me(Rv)), mH = (e) => (t, n, r) => e(t, n && ((...o) => {
  const [a] = va(t), [, , , s] = ji.get(Y1), l = s[a];
  return Qe(l) ? n(...o) : (delete s[a], l);
}), r), gH = hH.concat(mH), vH = (e) => function(...n) {
  const r = K1(), [i, o, a] = J5(n), s = Z5(r, a);
  let l = e;
  const { use: u } = s, d = (u || []).concat(gH);
  for (let f = d.length; f--; )
    l = d[f](l);
  return l(i, o || s.fetcher || null, s);
}, yH = (e) => {
  const t = de({})[1], n = me(!1), r = me(e), i = me({
    data: !1,
    error: !1,
    isValidating: !1
  }), o = De((a) => {
    let s = !1;
    const l = r.current;
    for (const u in a) {
      const d = u;
      l[d] !== a[d] && (l[d] = a[d], i.current[d] && (s = !0));
    }
    s && !n.current && (Mv ? t({}) : x.startTransition(() => t({})));
  }, [
    t
  ]);
  return da(() => (n.current = !1, () => {
    n.current = !0;
  })), [
    r,
    i.current,
    o
  ];
}, wH = (e, t, n) => {
  const r = t[e] || (t[e] = []);
  return r.push(n), () => {
    const i = r.indexOf(n);
    i >= 0 && (r[i] = r[r.length - 1], r.pop());
  };
}, X1 = (e, t) => (...n) => {
  const [r, i, o] = J5(n), a = (o.use || []).concat(t);
  return e(r, i, {
    ...o,
    use: a
  });
};
pH();
const G3 = x.use || ((e) => {
  if (e.status === "pending")
    throw e;
  if (e.status === "fulfilled")
    return e.value;
  throw e.status === "rejected" ? e.reason : (e.status = "pending", e.then((t) => {
    e.status = "fulfilled", e.value = t;
  }, (t) => {
    e.status = "rejected", e.reason = t;
  }), e);
}), Qm = {
  dedupe: !0
}, bH = (e, t, n) => {
  const { cache: r, compare: i, suspense: o, fallbackData: a, revalidateOnMount: s, revalidateIfStale: l, refreshInterval: u, refreshWhenHidden: d, refreshWhenOffline: f, keepPreviousData: p } = n, [m, g, v, y] = ji.get(r), [b, E] = va(e), S = me(!1), _ = me(!1), k = me(b), T = me(t), A = me(n), R = () => A.current, F = () => R().isVisible() && R().isOnline(), [D, W, L, z] = _o(r, b), B = me({}).current, G = Qe(a) ? n.fallback[b] : a, H = (te, Re) => {
    for (const we in B) {
      const ze = we;
      if (ze === "data") {
        if (!i(te[ze], Re[ze]) && (!Qe(te[ze]) || !i(ae, Re[ze])))
          return !1;
      } else if (Re[ze] !== te[ze])
        return !1;
    }
    return !0;
  }, J = Lt(() => {
    const te = (() => !b || !t ? !1 : Qe(s) ? R().isPaused() || o ? !1 : Qe(l) ? !0 : l : s)(), Re = (mt) => {
      const Ht = Dr(mt);
      return delete Ht._k, te ? {
        isValidating: !0,
        isLoading: !0,
        ...Ht
      } : Ht;
    }, we = D(), ze = z(), dt = Re(we), ht = we === ze ? dt : Re(ze);
    let vt = dt;
    return [
      () => {
        const mt = Re(D());
        return H(mt, vt) ? (vt.data = mt.data, vt.isLoading = mt.isLoading, vt.isValidating = mt.isValidating, vt.error = mt.error, vt) : (vt = mt, mt);
      },
      () => ht
    ];
  }, [
    r,
    b
  ]), q = gh.useSyncExternalStore(De(
    (te) => L(b, (Re, we) => {
      H(we, Re) || te();
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      r,
      b
    ]
  ), J[0], J[1]), Z = !S.current, O = m[b] && m[b].length > 0, Q = q.data, he = Qe(Q) ? G : Q, N = q.error, ee = me(he), ae = p ? Qe(Q) ? ee.current : Q : he, pe = (() => O && !Qe(N) ? !1 : Z && !Qe(s) ? s : R().isPaused() ? !1 : o ? Qe(he) ? !1 : l : Qe(he) || l)(), se = !!(b && t && Z && pe), Se = Qe(q.isValidating) ? se : q.isValidating, le = Qe(q.isLoading) ? se : q.isLoading, Ee = De(
    async (te) => {
      const Re = T.current;
      if (!b || !Re || _.current || R().isPaused())
        return !1;
      let we, ze, dt = !0;
      const ht = te || {}, vt = !v[b] || !ht.dedupe, mt = () => Mv ? !_.current && b === k.current && S.current : b === k.current, Ht = {
        isValidating: !1,
        isLoading: !1
      }, zt = () => {
        W(Ht);
      }, Wn = () => {
        const gn = v[b];
        gn && gn[1] === ze && delete v[b];
      }, Vr = {
        isValidating: !0
      };
      Qe(D().data) && (Vr.isLoading = !0);
      try {
        if (vt && (W(Vr), n.loadingTimeout && Qe(D().data) && setTimeout(() => {
          dt && mt() && R().onLoadingSlow(b, n);
        }, n.loadingTimeout), v[b] = [
          Re(E),
          hc()
        ]), [we, ze] = v[b], we = await we, vt && setTimeout(Wn, n.dedupingInterval), !v[b] || v[b][1] !== ze)
          return vt && mt() && R().onDiscarded(b), !1;
        Ht.error = pn;
        const gn = g[b];
        if (!Qe(gn) && // case 1
        (ze <= gn[0] || // case 2
        ze <= gn[1] || // case 3
        gn[1] === 0))
          return zt(), vt && mt() && R().onDiscarded(b), !1;
        const nn = D().data;
        Ht.data = i(nn, we) ? nn : we, vt && mt() && R().onSuccess(we, b, n);
      } catch (gn) {
        Wn();
        const nn = R(), { shouldRetryOnError: ui } = nn;
        nn.isPaused() || (Ht.error = gn, vt && mt() && (nn.onError(gn, b, nn), (ui === !0 || ei(ui) && ui(gn)) && F() && nn.onErrorRetry(gn, b, nn, (re) => {
          const Ce = m[b];
          Ce && Ce[0] && Ce[0](El.ERROR_REVALIDATE_EVENT, re);
        }, {
          retryCount: (ht.retryCount || 0) + 1,
          dedupe: !0
        })));
      }
      return dt = !1, zt(), !0;
    },
    // `setState` is immutable, and `eventsCallback`, `fnArg`, and
    // `keyValidating` are depending on `key`, so we can exclude them from
    // the deps array.
    //
    // FIXME:
    // `fn` and `config` might be changed during the lifecycle,
    // but they might be changed every render like this.
    // `useSWR('key', () => fetch('/api/'), { suspense: true })`
    // So we omit the values from the deps array
    // even though it might cause unexpected behaviors.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      b,
      r
    ]
  ), Ie = De(
    // Use callback to make sure `keyRef.current` returns latest result every time
    (...te) => Y5(r, k.current, ...te),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  if (da(() => {
    T.current = t, A.current = n, Qe(Q) || (ee.current = Q);
  }), da(() => {
    if (!b)
      return;
    const te = Ee.bind(pn, Qm);
    let Re = 0;
    const ze = wH(b, m, (dt, ht = {}) => {
      if (dt == El.FOCUS_EVENT) {
        const vt = Date.now();
        R().revalidateOnFocus && vt > Re && F() && (Re = vt + R().focusThrottleInterval, te());
      } else if (dt == El.RECONNECT_EVENT)
        R().revalidateOnReconnect && F() && te();
      else {
        if (dt == El.MUTATE_EVENT)
          return Ee();
        if (dt == El.ERROR_REVALIDATE_EVENT)
          return Ee(ht);
      }
    });
    return _.current = !1, k.current = b, S.current = !0, W({
      _k: E
    }), pe && (Qe(he) || fc ? te() : sH(te)), () => {
      _.current = !0, ze();
    };
  }, [
    b
  ]), da(() => {
    let te;
    function Re() {
      const ze = ei(u) ? u(D().data) : u;
      ze && te !== -1 && (te = setTimeout(we, ze));
    }
    function we() {
      !D().error && (d || R().isVisible()) && (f || R().isOnline()) ? Ee(Qm).then(Re) : Re();
    }
    return Re(), () => {
      te && (clearTimeout(te), te = -1);
    };
  }, [
    u,
    d,
    f,
    b
  ]), w$(ae), o && Qe(he) && b) {
    if (!Mv && fc)
      throw new Error("Fallback data is required when using suspense in SSR.");
    T.current = t, A.current = n, _.current = !1;
    const te = y[b];
    if (!Qe(te)) {
      const Re = Ie(te);
      G3(Re);
    }
    if (Qe(N)) {
      const Re = Ee(Qm);
      Qe(ae) || (Re.status = "fulfilled", Re.value = !0), G3(Re);
    } else
      throw N;
  }
  return {
    mutate: Ie,
    get data() {
      return B.data = !0, ae;
    },
    get error() {
      return B.error = !0, N;
    },
    get isValidating() {
      return B.isValidating = !0, Se;
    },
    get isLoading() {
      return B.isLoading = !0, le;
    }
  };
}, Z1 = Fd.defineProperty(fH, "defaultValue", {
  value: X5
}), br = vH(bH), xH = (e) => (t, n, r) => (r.revalidateOnFocus = !1, r.revalidateIfStale = !1, r.revalidateOnReconnect = !1, e(t, n, r)), yh = X1(br, xH);
class hf extends Error {
  constructor(t, n, r) {
    const i = t.status || t.status === 0 ? t.status : "", o = t.statusText || "", a = `${i} ${o}`.trim(), s = a ? `status code ${a}` : "an unknown error";
    super(`Request failed with ${s}`), Object.defineProperty(this, "response", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "request", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "options", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = "HTTPError", this.response = t, this.request = n, this.options = r;
  }
}
class e6 extends Error {
  constructor(t) {
    super("Request timed out"), Object.defineProperty(this, "request", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this.name = "TimeoutError", this.request = t;
  }
}
const zd = (e) => e !== null && typeof e == "object", nd = (...e) => {
  for (const t of e)
    if ((!zd(t) || Array.isArray(t)) && typeof t < "u")
      throw new TypeError("The `options` argument must be an object");
  return Q1({}, ...e);
}, t6 = (e = {}, t = {}) => {
  const n = new globalThis.Headers(e), r = t instanceof globalThis.Headers, i = new globalThis.Headers(t);
  for (const [o, a] of i.entries())
    r && a === "undefined" || a === void 0 ? n.delete(o) : n.set(o, a);
  return n;
}, Q1 = (...e) => {
  let t = {}, n = {};
  for (const r of e)
    if (Array.isArray(r))
      Array.isArray(t) || (t = []), t = [...t, ...r];
    else if (zd(r)) {
      for (let [i, o] of Object.entries(r))
        zd(o) && i in t && (o = Q1(t[i], o)), t = { ...t, [i]: o };
      zd(r.headers) && (n = t6(n, r.headers), t.headers = n);
    }
  return t;
}, EH = (() => {
  let e = !1, t = !1;
  const n = typeof globalThis.ReadableStream == "function", r = typeof globalThis.Request == "function";
  return n && r && (t = new globalThis.Request("https://a.com", {
    body: new globalThis.ReadableStream(),
    method: "POST",
    // @ts-expect-error - Types are outdated.
    get duplex() {
      return e = !0, "half";
    }
  }).headers.has("Content-Type")), e && !t;
})(), CH = typeof globalThis.AbortController == "function", SH = typeof globalThis.ReadableStream == "function", _H = typeof globalThis.FormData == "function", n6 = ["get", "post", "put", "patch", "head", "delete"], PH = {
  json: "application/json",
  text: "text/*",
  formData: "multipart/form-data",
  arrayBuffer: "*/*",
  blob: "*/*"
}, Jm = 2147483647, r6 = Symbol("stop"), kH = (e) => n6.includes(e) ? e.toUpperCase() : e, TH = ["get", "put", "head", "delete", "options", "trace"], AH = [408, 413, 429, 500, 502, 503, 504], i6 = [413, 429, 503], q3 = {
  limit: 2,
  methods: TH,
  statusCodes: AH,
  afterStatusCodes: i6,
  maxRetryAfter: Number.POSITIVE_INFINITY,
  backoffLimit: Number.POSITIVE_INFINITY
}, MH = (e = {}) => {
  if (typeof e == "number")
    return {
      ...q3,
      limit: e
    };
  if (e.methods && !Array.isArray(e.methods))
    throw new Error("retry.methods must be an array");
  if (e.statusCodes && !Array.isArray(e.statusCodes))
    throw new Error("retry.statusCodes must be an array");
  return {
    ...q3,
    ...e,
    afterStatusCodes: i6
  };
};
async function OH(e, t, n) {
  return new Promise((r, i) => {
    const o = setTimeout(() => {
      t && t.abort(), i(new e6(e));
    }, n.timeout);
    n.fetch(e).then(r).catch(i).then(() => {
      clearTimeout(o);
    });
  });
}
const RH = !!globalThis.DOMException;
function Y3(e) {
  if (RH)
    return new DOMException((e == null ? void 0 : e.reason) ?? "The operation was aborted.", "AbortError");
  const t = new Error((e == null ? void 0 : e.reason) ?? "The operation was aborted.");
  return t.name = "AbortError", t;
}
async function IH(e, { signal: t }) {
  return new Promise((n, r) => {
    if (t) {
      if (t.aborted) {
        r(Y3(t));
        return;
      }
      t.addEventListener("abort", i, { once: !0 });
    }
    function i() {
      r(Y3(t)), clearTimeout(o);
    }
    const o = setTimeout(() => {
      t == null || t.removeEventListener("abort", i), n();
    }, e);
  });
}
class pf {
  // eslint-disable-next-line @typescript-eslint/promise-function-async
  static create(t, n) {
    const r = new pf(t, n), i = async () => {
      if (r._options.timeout > Jm)
        throw new RangeError(`The \`timeout\` option cannot be greater than ${Jm}`);
      await Promise.resolve();
      let s = await r._fetch();
      for (const l of r._options.hooks.afterResponse) {
        const u = await l(r.request, r._options, r._decorateResponse(s.clone()));
        u instanceof globalThis.Response && (s = u);
      }
      if (r._decorateResponse(s), !s.ok && r._options.throwHttpErrors) {
        let l = new hf(s, r.request, r._options);
        for (const u of r._options.hooks.beforeError)
          l = await u(l);
        throw l;
      }
      if (r._options.onDownloadProgress) {
        if (typeof r._options.onDownloadProgress != "function")
          throw new TypeError("The `onDownloadProgress` option must be a function");
        if (!SH)
          throw new Error("Streams are not supported in your environment. `ReadableStream` is missing.");
        return r._stream(s.clone(), r._options.onDownloadProgress);
      }
      return s;
    }, a = r._options.retry.methods.includes(r.request.method.toLowerCase()) ? r._retry(i) : i();
    for (const [s, l] of Object.entries(PH))
      a[s] = async () => {
        r.request.headers.set("accept", r.request.headers.get("accept") || l);
        const d = (await a).clone();
        if (s === "json") {
          if (d.status === 204 || (await d.clone().arrayBuffer()).byteLength === 0)
            return "";
          if (n.parseJson)
            return n.parseJson(await d.text());
        }
        return d[s]();
      };
    return a;
  }
  // eslint-disable-next-line complexity
  constructor(t, n = {}) {
    if (Object.defineProperty(this, "request", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "abortController", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "_retryCount", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "_input", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), Object.defineProperty(this, "_options", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: void 0
    }), this._input = t, this._options = {
      // TODO: credentials can be removed when the spec change is implemented in all browsers. Context: https://www.chromestatus.com/feature/4539473312350208
      credentials: this._input.credentials || "same-origin",
      ...n,
      headers: t6(this._input.headers, n.headers),
      hooks: Q1({
        beforeRequest: [],
        beforeRetry: [],
        beforeError: [],
        afterResponse: []
      }, n.hooks),
      method: kH(n.method ?? this._input.method),
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      prefixUrl: String(n.prefixUrl || ""),
      retry: MH(n.retry),
      throwHttpErrors: n.throwHttpErrors !== !1,
      timeout: typeof n.timeout > "u" ? 1e4 : n.timeout,
      fetch: n.fetch ?? globalThis.fetch.bind(globalThis)
    }, typeof this._input != "string" && !(this._input instanceof URL || this._input instanceof globalThis.Request))
      throw new TypeError("`input` must be a string, URL, or Request");
    if (this._options.prefixUrl && typeof this._input == "string") {
      if (this._input.startsWith("/"))
        throw new Error("`input` must not begin with a slash when using `prefixUrl`");
      this._options.prefixUrl.endsWith("/") || (this._options.prefixUrl += "/"), this._input = this._options.prefixUrl + this._input;
    }
    if (CH) {
      if (this.abortController = new globalThis.AbortController(), this._options.signal) {
        const r = this._options.signal;
        this._options.signal.addEventListener("abort", () => {
          this.abortController.abort(r.reason);
        });
      }
      this._options.signal = this.abortController.signal;
    }
    if (EH && (this._options.duplex = "half"), this.request = new globalThis.Request(this._input, this._options), this._options.searchParams) {
      const i = "?" + (typeof this._options.searchParams == "string" ? this._options.searchParams.replace(/^\?/, "") : new URLSearchParams(this._options.searchParams).toString()), o = this.request.url.replace(/(?:\?.*?)?(?=#|$)/, i);
      (_H && this._options.body instanceof globalThis.FormData || this._options.body instanceof URLSearchParams) && !(this._options.headers && this._options.headers["content-type"]) && this.request.headers.delete("content-type"), this.request = new globalThis.Request(new globalThis.Request(o, { ...this.request }), this._options);
    }
    this._options.json !== void 0 && (this._options.body = JSON.stringify(this._options.json), this.request.headers.set("content-type", this._options.headers.get("content-type") ?? "application/json"), this.request = new globalThis.Request(this.request, { body: this._options.body }));
  }
  _calculateRetryDelay(t) {
    if (this._retryCount++, this._retryCount < this._options.retry.limit && !(t instanceof e6)) {
      if (t instanceof hf) {
        if (!this._options.retry.statusCodes.includes(t.response.status))
          return 0;
        const r = t.response.headers.get("Retry-After");
        if (r && this._options.retry.afterStatusCodes.includes(t.response.status)) {
          let i = Number(r);
          return Number.isNaN(i) ? i = Date.parse(r) - Date.now() : i *= 1e3, typeof this._options.retry.maxRetryAfter < "u" && i > this._options.retry.maxRetryAfter ? 0 : i;
        }
        if (t.response.status === 413)
          return 0;
      }
      const n = 0.3;
      return Math.min(this._options.retry.backoffLimit, n * 2 ** (this._retryCount - 1) * 1e3);
    }
    return 0;
  }
  _decorateResponse(t) {
    return this._options.parseJson && (t.json = async () => this._options.parseJson(await t.text())), t;
  }
  async _retry(t) {
    try {
      return await t();
    } catch (n) {
      const r = Math.min(this._calculateRetryDelay(n), Jm);
      if (r !== 0 && this._retryCount > 0) {
        await IH(r, { signal: this._options.signal });
        for (const i of this._options.hooks.beforeRetry)
          if (await i({
            request: this.request,
            options: this._options,
            error: n,
            retryCount: this._retryCount
          }) === r6)
            return;
        return this._retry(t);
      }
      throw n;
    }
  }
  async _fetch() {
    for (const t of this._options.hooks.beforeRequest) {
      const n = await t(this.request, this._options);
      if (n instanceof Request) {
        this.request = n;
        break;
      }
      if (n instanceof Response)
        return n;
    }
    return this._options.timeout === !1 ? this._options.fetch(this.request.clone()) : OH(this.request.clone(), this.abortController, this._options);
  }
  /* istanbul ignore next */
  _stream(t, n) {
    const r = Number(t.headers.get("content-length")) || 0;
    let i = 0;
    return t.status === 204 ? (n && n({ percent: 1, totalBytes: r, transferredBytes: i }, new Uint8Array()), new globalThis.Response(null, {
      status: t.status,
      statusText: t.statusText,
      headers: t.headers
    })) : new globalThis.Response(new globalThis.ReadableStream({
      async start(o) {
        const a = t.body.getReader();
        n && n({ percent: 0, transferredBytes: 0, totalBytes: r }, new Uint8Array());
        async function s() {
          const { done: l, value: u } = await a.read();
          if (l) {
            o.close();
            return;
          }
          if (n) {
            i += u.byteLength;
            const d = r === 0 ? 0 : i / r;
            n({ percent: d, transferredBytes: i, totalBytes: r }, u);
          }
          o.enqueue(u), await s();
        }
        await s();
      }
    }), {
      status: t.status,
      statusText: t.statusText,
      headers: t.headers
    });
  }
}
/*! MIT License © Sindre Sorhus */
const Iv = (e) => {
  const t = (n, r) => pf.create(n, nd(e, r));
  for (const n of n6)
    t[n] = (r, i) => pf.create(r, nd(e, i, { method: n }));
  return t.create = (n) => Iv(nd(n)), t.extend = (n) => Iv(nd(e, n)), t.stop = r6, t;
}, DH = Iv(), o6 = DH, NH = /* @__PURE__ */ ke((e, t) => /* @__PURE__ */ X(rt.span, ge({}, e, {
  ref: t,
  style: {
    // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
    position: "absolute",
    border: 0,
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: "hidden",
    clip: "rect(0, 0, 0, 0)",
    whiteSpace: "nowrap",
    wordWrap: "normal",
    ...e.style
  }
}))), $H = NH, [wh, lye] = rr("Tooltip", [
  Vs
]), bh = Vs(), LH = "TooltipProvider", FH = 700, Dv = "tooltip.open", [zH, J1] = wh(LH), VH = (e) => {
  const { __scopeTooltip: t, delayDuration: n = FH, skipDelayDuration: r = 300, disableHoverableContent: i = !1, children: o } = e, [a, s] = de(!0), l = me(!1), u = me(0);
  return be(() => {
    const d = u.current;
    return () => window.clearTimeout(d);
  }, []), /* @__PURE__ */ X(zH, {
    scope: t,
    isOpenDelayed: a,
    delayDuration: n,
    onOpen: De(() => {
      window.clearTimeout(u.current), s(!1);
    }, []),
    onClose: De(() => {
      window.clearTimeout(u.current), u.current = window.setTimeout(
        () => s(!0),
        r
      );
    }, [
      r
    ]),
    isPointerInTransitRef: l,
    onPointerInTransitChange: De((d) => {
      l.current = d;
    }, []),
    disableHoverableContent: i
  }, o);
}, ey = "Tooltip", [BH, Ic] = wh(ey), jH = (e) => {
  const { __scopeTooltip: t, children: n, open: r, defaultOpen: i = !1, onOpenChange: o, disableHoverableContent: a, delayDuration: s } = e, l = J1(ey, e.__scopeTooltip), u = bh(t), [d, f] = de(null), p = ti(), m = me(0), g = a ?? l.disableHoverableContent, v = s ?? l.delayDuration, y = me(!1), [b = !1, E] = li({
    prop: r,
    defaultProp: i,
    onChange: (A) => {
      A ? (l.onOpen(), document.dispatchEvent(new CustomEvent(Dv))) : l.onClose(), o == null || o(A);
    }
  }), S = Lt(() => b ? y.current ? "delayed-open" : "instant-open" : "closed", [
    b
  ]), _ = De(() => {
    window.clearTimeout(m.current), y.current = !1, E(!0);
  }, [
    E
  ]), k = De(() => {
    window.clearTimeout(m.current), E(!1);
  }, [
    E
  ]), T = De(() => {
    window.clearTimeout(m.current), m.current = window.setTimeout(() => {
      y.current = !0, E(!0);
    }, v);
  }, [
    v,
    E
  ]);
  return be(() => () => window.clearTimeout(m.current), []), /* @__PURE__ */ X(m1, u, /* @__PURE__ */ X(BH, {
    scope: t,
    contentId: p,
    open: b,
    stateAttribute: S,
    trigger: d,
    onTriggerChange: f,
    onTriggerEnter: De(() => {
      l.isOpenDelayed ? T() : _();
    }, [
      l.isOpenDelayed,
      T,
      _
    ]),
    onTriggerLeave: De(() => {
      g ? k() : window.clearTimeout(m.current);
    }, [
      k,
      g
    ]),
    onOpen: _,
    onClose: k,
    disableHoverableContent: g
  }, n));
}, K3 = "TooltipTrigger", WH = /* @__PURE__ */ ke((e, t) => {
  const { __scopeTooltip: n, ...r } = e, i = Ic(K3, n), o = J1(K3, n), a = bh(n), s = me(null), l = Ft(t, s, i.onTriggerChange), u = me(!1), d = me(!1), f = De(
    () => u.current = !1,
    []
  );
  return be(() => () => document.removeEventListener("pointerup", f), [
    f
  ]), /* @__PURE__ */ X(ih, ge({
    asChild: !0
  }, a), /* @__PURE__ */ X(rt.button, ge({
    // We purposefully avoid adding `type=button` here because tooltip triggers are also
    // commonly anchors and the anchor `type` attribute signifies MIME type.
    "aria-describedby": i.open ? i.contentId : void 0,
    "data-state": i.stateAttribute
  }, r, {
    ref: l,
    onPointerMove: $e(e.onPointerMove, (p) => {
      p.pointerType !== "touch" && !d.current && !o.isPointerInTransitRef.current && (i.onTriggerEnter(), d.current = !0);
    }),
    onPointerLeave: $e(e.onPointerLeave, () => {
      i.onTriggerLeave(), d.current = !1;
    }),
    onPointerDown: $e(e.onPointerDown, () => {
      u.current = !0, document.addEventListener("pointerup", f, {
        once: !0
      });
    }),
    onFocus: $e(e.onFocus, () => {
      u.current || i.onOpen();
    }),
    onBlur: $e(e.onBlur, i.onClose),
    onClick: $e(e.onClick, i.onClose)
  })));
}), a6 = "TooltipPortal", [UH, HH] = wh(a6, {
  forceMount: void 0
}), GH = (e) => {
  const { __scopeTooltip: t, forceMount: n, children: r, container: i } = e, o = Ic(a6, t);
  return /* @__PURE__ */ X(UH, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ X(On, {
    present: n || o.open
  }, /* @__PURE__ */ X(oh, {
    asChild: !0,
    container: i
  }, r)));
}, pc = "TooltipContent", qH = /* @__PURE__ */ ke((e, t) => {
  const n = HH(pc, e.__scopeTooltip), { forceMount: r = n.forceMount, side: i = "top", ...o } = e, a = Ic(pc, e.__scopeTooltip);
  return /* @__PURE__ */ X(On, {
    present: r || a.open
  }, a.disableHoverableContent ? /* @__PURE__ */ X(s6, ge({
    side: i
  }, o, {
    ref: t
  })) : /* @__PURE__ */ X(YH, ge({
    side: i
  }, o, {
    ref: t
  })));
}), YH = /* @__PURE__ */ ke((e, t) => {
  const n = Ic(pc, e.__scopeTooltip), r = J1(pc, e.__scopeTooltip), i = me(null), o = Ft(t, i), [a, s] = de(null), { trigger: l, onClose: u } = n, d = i.current, { onPointerInTransitChange: f } = r, p = De(() => {
    s(null), f(!1);
  }, [
    f
  ]), m = De((g, v) => {
    const y = g.currentTarget, b = {
      x: g.clientX,
      y: g.clientY
    }, E = JH(b, y.getBoundingClientRect()), S = eG(b, E), _ = tG(v.getBoundingClientRect()), k = rG([
      ...S,
      ..._
    ]);
    s(k), f(!0);
  }, [
    f
  ]);
  return be(() => () => p(), [
    p
  ]), be(() => {
    if (l && d) {
      const g = (y) => m(y, d), v = (y) => m(y, l);
      return l.addEventListener("pointerleave", g), d.addEventListener("pointerleave", v), () => {
        l.removeEventListener("pointerleave", g), d.removeEventListener("pointerleave", v);
      };
    }
  }, [
    l,
    d,
    m,
    p
  ]), be(() => {
    if (a) {
      const g = (v) => {
        const y = v.target, b = {
          x: v.clientX,
          y: v.clientY
        }, E = (l == null ? void 0 : l.contains(y)) || (d == null ? void 0 : d.contains(y)), S = !nG(b, a);
        E ? p() : S && (p(), u());
      };
      return document.addEventListener("pointermove", g), () => document.removeEventListener("pointermove", g);
    }
  }, [
    l,
    d,
    a,
    u,
    p
  ]), /* @__PURE__ */ X(s6, ge({}, e, {
    ref: o
  }));
}), [KH, XH] = wh(ey, {
  isInside: !1
}), s6 = /* @__PURE__ */ ke((e, t) => {
  const { __scopeTooltip: n, children: r, "aria-label": i, onEscapeKeyDown: o, onPointerDownOutside: a, ...s } = e, l = Ic(pc, n), u = bh(n), { onClose: d } = l;
  return be(() => (document.addEventListener(Dv, d), () => document.removeEventListener(Dv, d)), [
    d
  ]), be(() => {
    if (l.trigger) {
      const f = (p) => {
        const m = p.target;
        m != null && m.contains(l.trigger) && d();
      };
      return window.addEventListener("scroll", f, {
        capture: !0
      }), () => window.removeEventListener("scroll", f, {
        capture: !0
      });
    }
  }, [
    l.trigger,
    d
  ]), /* @__PURE__ */ X(eh, {
    asChild: !0,
    disableOutsidePointerEvents: !1,
    onEscapeKeyDown: o,
    onPointerDownOutside: a,
    onFocusOutside: (f) => f.preventDefault(),
    onDismiss: d
  }, /* @__PURE__ */ X(g1, ge({
    "data-state": l.stateAttribute
  }, u, s, {
    ref: t,
    style: {
      ...s.style,
      "--radix-tooltip-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-tooltip-content-available-width": "var(--radix-popper-available-width)",
      "--radix-tooltip-content-available-height": "var(--radix-popper-available-height)",
      "--radix-tooltip-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-tooltip-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }), /* @__PURE__ */ X(vS, null, r), /* @__PURE__ */ X(KH, {
    scope: n,
    isInside: !0
  }, /* @__PURE__ */ X($H, {
    id: l.contentId,
    role: "tooltip"
  }, i || r))));
}), ZH = "TooltipArrow", QH = /* @__PURE__ */ ke((e, t) => {
  const { __scopeTooltip: n, ...r } = e, i = bh(n);
  return XH(ZH, n).isInside ? null : /* @__PURE__ */ X(NF, ge({}, i, r, {
    ref: t
  }));
});
function JH(e, t) {
  const n = Math.abs(t.top - e.y), r = Math.abs(t.bottom - e.y), i = Math.abs(t.right - e.x), o = Math.abs(t.left - e.x);
  switch (Math.min(n, r, i, o)) {
    case o:
      return "left";
    case i:
      return "right";
    case n:
      return "top";
    case r:
      return "bottom";
    default:
      throw new Error("unreachable");
  }
}
function eG(e, t, n = 5) {
  const r = [];
  switch (t) {
    case "top":
      r.push({
        x: e.x - n,
        y: e.y + n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "bottom":
      r.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y - n
      });
      break;
    case "left":
      r.push({
        x: e.x + n,
        y: e.y - n
      }, {
        x: e.x + n,
        y: e.y + n
      });
      break;
    case "right":
      r.push({
        x: e.x - n,
        y: e.y - n
      }, {
        x: e.x - n,
        y: e.y + n
      });
      break;
  }
  return r;
}
function tG(e) {
  const { top: t, right: n, bottom: r, left: i } = e;
  return [
    {
      x: i,
      y: t
    },
    {
      x: n,
      y: t
    },
    {
      x: n,
      y: r
    },
    {
      x: i,
      y: r
    }
  ];
}
function nG(e, t) {
  const { x: n, y: r } = e;
  let i = !1;
  for (let o = 0, a = t.length - 1; o < t.length; a = o++) {
    const s = t[o].x, l = t[o].y, u = t[a].x, d = t[a].y;
    l > r != d > r && n < (u - s) * (r - l) / (d - l) + s && (i = !i);
  }
  return i;
}
function rG(e) {
  const t = e.slice();
  return t.sort((n, r) => n.x < r.x ? -1 : n.x > r.x ? 1 : n.y < r.y ? -1 : n.y > r.y ? 1 : 0), iG(t);
}
function iG(e) {
  if (e.length <= 1)
    return e.slice();
  const t = [];
  for (let r = 0; r < e.length; r++) {
    const i = e[r];
    for (; t.length >= 2; ) {
      const o = t[t.length - 1], a = t[t.length - 2];
      if ((o.x - a.x) * (i.y - a.y) >= (o.y - a.y) * (i.x - a.x))
        t.pop();
      else
        break;
    }
    t.push(i);
  }
  t.pop();
  const n = [];
  for (let r = e.length - 1; r >= 0; r--) {
    const i = e[r];
    for (; n.length >= 2; ) {
      const o = n[n.length - 1], a = n[n.length - 2];
      if ((o.x - a.x) * (i.y - a.y) >= (o.y - a.y) * (i.x - a.x))
        n.pop();
      else
        break;
    }
    n.push(i);
  }
  return n.pop(), t.length === 1 && n.length === 1 && t[0].x === n[0].x && t[0].y === n[0].y ? t : t.concat(n);
}
const oG = VH, l6 = jH, c6 = WH, u6 = GH, ty = qH, d6 = QH, aG = oG, f6 = l6, h6 = c6, sG = u6, ny = C.forwardRef(
  ({ className: e, children: t, sideOffset: n = 4, tooltipArrowClassName: r, ...i }, o) => /* @__PURE__ */ C.createElement(
    ty,
    {
      ref: o,
      sideOffset: n,
      className: ie(
        "ai-tw-z-[1200] ai-tw-w-[400px] ai-tw-overflow-hidden ai-tw-rounded-sm ai-tw-bg-grey-60 ai-tw-px-2 ai-tw-py-1.5 ai-tw-text-white ai-tw-shadow-md ai-tw-animate-in ai-tw-fade-in-0 ai-tw-zoom-in-95 ai-tw-body-sm data-[state=closed]:ai-tw-animate-out data-[state=closed]:ai-tw-fade-out-0 data-[state=closed]:ai-tw-zoom-out-95 data-[side=bottom]:ai-tw-slide-in-from-top-2 data-[side=left]:ai-tw-slide-in-from-right-2 data-[side=right]:ai-tw-slide-in-from-left-2 data-[side=top]:ai-tw-slide-in-from-bottom-2",
        e
      ),
      ...i
    },
    t,
    /* @__PURE__ */ C.createElement(p6, { className: r })
  )
);
ny.displayName = ty.displayName;
const p6 = C.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ C.createElement(
  d6,
  {
    ref: n,
    className: ie("ai-tw-fill-grey-60", e),
    ...t
  }
));
p6.displayName = d6.displayName;
const lG = ["ai-brivity", "ai-place"], cG = {
  theme: "ai-brivity",
  setTheme: () => null,
  apiUrl: void 0,
  token: ""
}, m6 = wn(cG), uG = "https://write-a-plumber.brivity.com";
typeof window < "u" && (window.localStorage.setItem("ai-components-version", "9.2.4"), window.localStorage.removeItem("writingAssistVersion"));
function cye({
  children: e,
  theme: t = "ai-brivity",
  apiUrl: n,
  token: r,
  fetchToken: i,
  swrConfigValue: o
}) {
  const [a, s] = de(), {
    data: l,
    isLoading: u,
    error: d
  } = br(i ? "token" : null, i || null, {
    refreshInterval: 10 * 60 * 1e3
  }), f = l || r;
  if (be(() => {
    const m = window.document.documentElement;
    m.classList.remove(...lG), m.classList.add(a || t), m.id = "ai-tw-app";
  }, [t, a]), u && !r)
    return null;
  if (d && !r)
    return console.error("Error fetching token:", d), null;
  if (!f)
    return console.error("Token is undefined"), null;
  const p = {
    apiUrl: qU(n || uG),
    token: f,
    theme: t,
    setTheme: s
  };
  return /* @__PURE__ */ x.createElement(m6.Provider, { value: p }, /* @__PURE__ */ x.createElement(Z1, { value: o }, /* @__PURE__ */ x.createElement(aG, { delayDuration: 400, skipDelayDuration: 200 }, e)));
}
const Dc = () => {
  const e = Me(m6);
  if (e === void 0)
    throw new Error(
      "useAiComponentsContext must be used within a AiComponentsProvider"
    );
  return e;
};
function g6(e, t) {
  const n = t || "https://write-a-plumber.brivity.com";
  if (!n)
    throw new Error("Missing API URL");
  return new URL(`v1${e}`, n);
}
function ln() {
  const { apiUrl: e, token: t } = Dc();
  if (!t)
    throw new Error("Missing API token");
  return De(
    (r, i) => {
      const o = {
        timeout: 6e4,
        ...i,
        headers: {
          Authorization: `Bearer ${t}`,
          ...i == null ? void 0 : i.headers
        }
      };
      return o6(g6(r, e), o).json();
    },
    [e, t]
  );
}
function dG() {
  const { apiUrl: e, token: t } = Dc();
  if (!t)
    throw new Error("Missing API token");
  return De(
    async (r, i) => {
      const o = {
        timeout: 6e4,
        throwHttpErrors: !1,
        ...i,
        headers: {
          Authorization: `Bearer ${t}`,
          ...i == null ? void 0 : i.headers
        }
      };
      return await o6(g6(r, e), o);
    },
    [e, t]
  );
}
function fG() {
  const e = ln();
  return yh(
    "/instruction-categories",
    (t) => e(t)
  );
}
function uye(e) {
  const t = ln();
  return yh(e ? `/instructions?search=${e}` : null, () => t("/instructions", {
    searchParams: {
      search: e,
      limit: "8"
    }
  }));
}
const hG = $r(
  "ai-tw-box-border ai-tw-inline-flex ai-tw-h-6 ai-tw-w-6 ai-tw-animate-spin ai-tw-rounded-full ai-tw-border-solid",
  {
    variants: {
      variant: {
        default: "ai-tw-border-stroke-primary-dark",
        ai: "ai-tw-border-stroke-ai-light",
        primary: "ai-tw-border-stroke-brand-light"
      },
      size: {
        small: "ai-tw-h-4 ai-tw-w-4 ai-tw-border-2",
        medium: "ai-tw-h-8 ai-tw-w-8 ai-tw-border-4",
        large: "ai-tw-h-10 ai-tw-w-10 ai-tw-border-[5px]"
      }
    }
  }
);
function jn({
  variant: e = "default",
  size: t = "medium",
  className: n
}) {
  return /* @__PURE__ */ x.createElement(
    "span",
    {
      "data-testid": "spinner",
      className: ie(
        hG({ variant: e, size: t }),
        n,
        "ai-tw-border-b-transparent"
      )
    }
  );
}
function pG() {
  return /* @__PURE__ */ C.createElement("div", { className: ie("ai-tw-grid ai-tw-h-[88px] ai-tw-place-items-center") }, /* @__PURE__ */ C.createElement(jn, { variant: "ai" }));
}
const xh = ke(({ children: e, className: t = "", ...n }, r) => /* @__PURE__ */ x.createElement(
  "button",
  {
    className: ie(
      "ai-tw-border-solid ai-tw-bg-transparent ai-tw-bg-none",
      "ai-tw-grid ai-tw-h-7 ai-tw-w-7 ai-tw-place-items-center ai-tw-rounded-full",
      "ai-tw-shrink-0 ai-tw-border-2 ai-tw-border-transparent ai-tw-text-grey-60",
      "disabled:ai-tw-cursor-not-allowed disabled:ai-tw-opacity-50",
      "hover:enabled:ai-tw-cursor-pointer hover:enabled:ai-tw-border-purple-20",
      "focus:ai-tw-outline-purple-40 focus:enabled:ai-tw-cursor-pointer focus:enabled:ai-tw-border-purple-20",
      "active:enabled:ai-tw-bg-purple-50 active:enabled:ai-tw-text-white",
      "[&>svg]:ai-tw-h-4 [&>svg]:ai-tw-w-4",
      t
    ),
    ...n,
    ref: r
  },
  e
));
xh.displayName = "ButtonInput";
const ry = $r(
  [
    "ai-tw-w-full ai-tw-rounded ai-tw-border ai-tw-border-stroke-primary-dark ai-tw-px-3 ai-tw-py-2 ai-tw-outline-none placeholder:ai-tw-text-grey-50",
    "ai-tw-bg-element-primary-alt ai-tw-outline-offset-0 ai-tw-body-md focus:ai-tw-bg-element-primary-subtle-lightest"
  ],
  {
    variants: {
      variant: {
        default: [
          "hover:ai-tw-border-stroke-brand-light focus:ai-tw-border-stroke-brand  focus:ai-tw-outline-stroke-brand-lightest",
          "selection:ai-tw-bg-element-brand-lightest"
        ],
        error: [
          "ai-tw-border-stroke-critical hover:ai-tw-border-stroke-critical-dark focus:ai-tw-border-stroke-critical-dark focus:ai-tw-outline-stroke-critical-lightest",
          "selection:ai-tw-bg-element-critical-light"
        ],
        ai: [
          "hover:ai-tw-border-stroke-ai-light focus:ai-tw-border-stroke-ai focus:ai-tw-outline-stroke-ai-lightest",
          "selection:ai-tw-bg-element-ai-light"
        ]
      }
    }
  }
), v6 = ke(
  ({ className: e = "", variant: t = "default", labelText: n, ...r }, i) => /* @__PURE__ */ x.createElement("div", { className: "ai-tw-preflight ai-tw-flex ai-tw-w-full ai-tw-flex-col ai-tw-gap-1.5" }, n && /* @__PURE__ */ x.createElement("label", { className: "ai-tw-font-semibold ai-tw-text-content-primary-light ai-tw-subtitle-md" }, n), /* @__PURE__ */ x.createElement(
    "input",
    {
      className: ie(ry({ variant: t }), e),
      ...r,
      ref: i
    }
  ))
);
v6.displayName = "Input";
const Eh = ke(
  ({
    containerClassName: e = "",
    className: t = "",
    labelText: n,
    variant: r = "default",
    ...i
  }, o) => /* @__PURE__ */ x.createElement(
    "div",
    {
      className: ie(
        "ai-tw-preflight ai-tw-flex ai-tw-w-full ai-tw-flex-col ai-tw-gap-1.5",
        e
      )
    },
    n && /* @__PURE__ */ x.createElement("label", { className: "ai-tw-font-semibold ai-tw-text-content-primary-light ai-tw-subtitle-md" }, n),
    /* @__PURE__ */ x.createElement(
      "textarea",
      {
        className: uc(
          ry({ variant: r }),
          "ai-tw-bg-tinted-grey-50 ai-tw-resize-none focus:ai-tw-bg-white",
          t
        ),
        ...i,
        ref: o
      }
    )
  )
);
Eh.displayName = "TextArea";
const iy = ke(
  (e, t) => {
    const n = x.useRef(null);
    return be(() => {
      const r = n.current, i = new MutationObserver(() => {
        r && (r.style.height = "0px", r.style.height = `${Math.min(r.scrollHeight, 120) + 2}px`);
      });
      return r && i.observe(r, { childList: !0 }), () => {
        i.disconnect();
      };
    }, [t]), /* @__PURE__ */ x.createElement(
      Eh,
      {
        ...e,
        ref: (r) => {
          n.current = r, typeof t == "function" ? t(r) : t && (t.current = r);
        }
      }
    );
  }
);
iy.displayName = "TextAreaAutoSize";
const y6 = wn(null);
function mG({
  children: e,
  value: t
}) {
  const [n, r] = x.useState("library");
  return /* @__PURE__ */ x.createElement(
    y6.Provider,
    {
      value: {
        ...t,
        source: n,
        setSource: r
      }
    },
    e
  );
}
function Ch() {
  const e = Me(y6);
  if (!e)
    throw new Error(
      "useMainContext must be used within a MainProvider component"
    );
  return e;
}
const gG = $r(
  [
    "ai-tw-relative ai-tw-inline-grid ai-tw-h-min ai-tw-w-max ai-tw-place-items-center ai-tw-rounded-full ai-tw-border-solid ai-tw-uppercase"
  ],
  {
    variants: {
      variant: {
        primary: [
          "ai-tw-border-element-brand-alt ai-tw-bg-element-brand-alt ai-tw-text-white",
          "hover:enabled:ai-tw-border-element-brand-alt-dark hover:enabled:ai-tw-bg-element-brand-alt-dark",
          "active:enabled:ai-tw-border-element-brand-darkest active:enabled:ai-tw-bg-element-brand-darkest",
          "disabled:ai-tw-border-element-brand-alt-light disabled:ai-tw-bg-element-brand-alt-light disabled:ai-tw-text-white"
        ],
        secondary: [
          "ai-tw-border-element-brand-alt ai-tw-bg-transparent ai-tw-text-element-brand-alt ",
          "active:enabled:ai-tw-bg-element-brand-alt active:enabled:ai-tw-text-white",
          "disabled:ai-tw-border-stroke-brand-alt-disabled disabled:ai-tw-text-stroke-brand-alt-disabled"
        ],
        "secondary-alt": [
          "ai-tw-border-element-brand-alt ai-tw-bg-white ai-tw-text-element-brand-alt",
          "active:enabled:ai-tw-border-element-brand-darkest active:enabled:ai-tw-bg-element-brand-lightest active:enabled:ai-tw-text-element-brand-darkest",
          "disabled:ai-tw-border-stroke-brand-alt-disabled disabled:ai-tw-text-stroke-brand-alt-disabled"
        ],
        tertiary: [
          "ai-tw-border-element-primary-subtle ai-tw-bg-element-primary-subtle ai-tw-text-content-primary",
          "hover:enabled:ai-tw-border-element-primary-subtle-dark hover:enabled:ai-tw-bg-element-primary-subtle-dark",
          "active:enabled:ai-tw-border-element-primary-subtle-darkest active:enabled:ai-tw-bg-element-primary-subtle-darkest",
          "disabled:ai-tw-border-element-primary-subtle-light disabled:ai-tw-bg-element-primary-subtle-light disabled:ai-tw-text-content-primary-disabled"
        ],
        "transparent-primary": [
          "ai-tw-border-stroke-primary-lightest ai-tw-bg-transparent ai-tw-text-content-on-color",
          "hover:enabled:ai-tw-border-element-brand-alt hover:enabled:ai-tw-bg-element-brand-alt",
          "active:enabled:ai-tw-border-element-brand-alt-dark active:enabled:ai-tw-bg-element-brand-alt-dark",
          "disabled:ai-tw-border-stroke-primary-darkest disabled:ai-tw-text-stroke-primary-darkest"
        ],
        "transparent-secondary": [
          "ai-tw-border-stroke-primary-lightest ai-tw-bg-transparent ai-tw-text-content-on-color",
          "hover:enabled:ai-tw-bg-black/50",
          "active:enabled:ai-tw-bg-black/75",
          "disabled:ai-tw-border-stroke-primary-darkest disabled:ai-tw-text-stroke-primary-darkest"
        ],
        destructive: [
          "ai-tw-border-stroke-critical-dark ai-tw-bg-transparent ai-tw-text-stroke-critical-dark ai-tw-outline-stroke-critical-dark",
          "active:enabled:ai-tw-bg-stroke-critical-dark active:enabled:ai-tw-text-content-on-color",
          "disabled:ai-tw-border-stroke-critical-lightest disabled:ai-tw-text-stroke-critical-lightest"
        ],
        "ai-primary": [
          "ai-tw-border-element-ai ai-tw-bg-element-ai ai-tw-text-white",
          "hover:enabled:ai-tw-border-element-ai-dark hover:enabled:ai-tw-bg-element-ai-dark",
          "active:enabled:ai-tw-border-element-ai-darkest active:enabled:ai-tw-bg-element-ai-darkest",
          "disabled:ai-tw-border-element-ai-light disabled:ai-tw-bg-element-ai-light"
        ],
        "ai-secondary": [
          "ai-tw-border-element-ai ai-tw-bg-transparent ai-tw-text-element-ai",
          "active:enabled:ai-tw-bg-element-ai active:enabled:ai-tw-text-white",
          "disabled:ai-tw-border-element-ai-light disabled:ai-tw-text-element-ai-light"
        ]
      },
      size: {
        sm: [
          "ai-tw-border ai-tw-px-2 ai-tw-py-1 ai-tw-button-sm",
          "hover:enabled:ai-tw-border-2 hover:enabled:ai-tw-px-[7px] hover:enabled:ai-tw-py-[3px]"
        ],
        md: [
          "ai-tw-border-2 ai-tw-px-5 ai-tw-py-2 ai-tw-button-md hover:enabled:ai-tw-border-[3px] hover:enabled:ai-tw-px-[19px] hover:enabled:ai-tw-py-[7px]"
        ],
        icon: [
          "ai-tw-h-8 ai-tw-w-8 ai-tw-border-2",
          "ai-tw-button-md hover:enabled:ai-tw-border-[3px]"
        ],
        "icon-sm": [
          "ai-tw-h-6 ai-tw-w-6 ai-tw-border",
          "ai-tw-button-sm hover:enabled:ai-tw-border-2"
        ]
      },
      status: {
        default: "",
        loading: "ai-tw-relative",
        success: "ai-tw-relative"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "md",
      status: "default"
    }
  }
), vG = $r("", {
  variants: {
    variant: {
      primary: "ai-tw-border-white",
      secondary: "ai-tw-border-element-brand-alt-light",
      "secondary-alt": "ai-tw-border-element-brand-alt-light",
      tertiary: "ai-tw-border-content-primary-disabled",
      "transparent-primary": "ai-tw-border-stroke-primary-darkest",
      "transparent-secondary": "ai-tw-border-stroke-primary-darkest",
      destructive: "ai-tw-border-stroke-critical-lightest",
      "ai-primary": "ai-tw-border-white",
      "ai-secondary": "ai-tw-border-element-ai-light"
    }
  }
}), Xt = C.forwardRef(
  ({
    className: e,
    contentClassName: t,
    variant: n = "primary",
    size: r = "md",
    status: i = "default",
    disabled: o,
    children: a,
    asChild: s = !1,
    ...l
  }, u) => {
    const d = s ? qi : "button";
    return /* @__PURE__ */ C.createElement(
      d,
      {
        className: ie(gG({ variant: n, size: r, status: i, className: e })),
        ref: u,
        disabled: i === "loading" || o,
        ...l
      },
      /* @__PURE__ */ C.createElement(
        "span",
        {
          className: ie(
            t,
            i === "loading" && "ai-tw-opacity-50",
            i === "success" && "ai-tw-opacity-0"
          )
        },
        a
      ),
      /* @__PURE__ */ C.createElement("div", { className: "ai-tw-absolute ai-tw-inset-0 ai-tw-grid ai-tw-h-full ai-tw-w-full ai-tw-place-items-center" }, i === "loading" ? /* @__PURE__ */ C.createElement(jn, { className: vG({ variant: n }), size: "small" }) : i === "success" ? /* @__PURE__ */ C.createElement(
        Le,
        {
          icon: gS,
          fixedWidth: !0,
          size: r != null && r.includes("sm") ? "1x" : "lg"
        }
      ) : null)
    );
  }
);
Xt.displayName = "Button";
const yG = [
  {
    option: "Clean Up",
    icon: B$
  },
  {
    option: "Rephrase",
    icon: iL
  },
  {
    option: "Make Shorter",
    icon: cS
  },
  {
    option: "Make Longer",
    icon: mS
  },
  {
    option: "Summarize",
    icon: lS
  }
];
function wG({
  activeElement: e,
  portalPosition: t,
  textPosition: n,
  handleImproveClick: r,
  textSelection: i
}) {
  const o = me(null), a = me(null), { tinyMceDocument: s } = Ch(), [l, u] = de(!1), [d, f] = de(null), [p, m] = de(""), [g, v] = de(null), y = De(() => {
    var E, S;
    (E = document.getSelection()) == null || E.removeAllRanges(), (S = s == null ? void 0 : s.getSelection()) == null || S.removeAllRanges(), f(null), m(""), setTimeout(() => {
      u(!1);
    }, 50);
  }, [s]);
  if (be(() => {
    function E(S) {
      S.key === "Escape" && y();
    }
    return document.addEventListener("keydown", E), s == null || s.addEventListener("keydown", E), () => {
      document.removeEventListener("keydown", E), s == null || s.removeEventListener("keydown", E);
    };
  }, [y, s]), be(() => {
    const E = `improve-clone-${e == null ? void 0 : e.id}`, S = document.getElementById(E);
    if (!e || E === (S == null ? void 0 : S.dataset.id))
      return;
    S && S.remove();
    const _ = document.createElement("div");
    _.id = E, _.dataset.id = e.id, _.style.position = "absolute", _.style.left = `${(t == null ? void 0 : t.left) || 0}px`, _.style.top = `${(t == null ? void 0 : t.top) || 0 + window.scrollY}px`, document.body.appendChild(_), v(_);
  }, [e, t]), n && (n.left !== (d == null ? void 0 : d.left) || n.bottom !== (d == null ? void 0 : d.bottom)) && f(n), !g || !(d != null && d.left) || !(d != null && d.bottom) || !l && !n || !i)
    return null;
  function b(E) {
    E.key === "Enter" && E.currentTarget.value !== "" && (E.preventDefault(), r(E.currentTarget.value), y());
  }
  return _c(
    /* @__PURE__ */ x.createElement(
      mn.div,
      {
        ref: o,
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        style: {
          left: d == null ? void 0 : d.left,
          top: (d == null ? void 0 : d.bottom) + 2 || 2
        },
        className: "ai-tw-preflight ai-tw-absolute ai-tw-z-[1250]"
      },
      l ? /* @__PURE__ */ x.createElement(
        mn.div,
        {
          initial: { opacity: 0 },
          animate: { opacity: 1 },
          transition: { duration: 0.2 },
          className: "ai-tw-flex ai-tw-w-[340px] ai-tw-flex-col ai-tw-gap-2.5"
        },
        /* @__PURE__ */ x.createElement(
          Xt,
          {
            variant: "ai-primary",
            size: "icon",
            className: "ai-tw-absolute -ai-tw-right-7 -ai-tw-top-7",
            onClick: y
          },
          /* @__PURE__ */ x.createElement(Le, { fixedWidth: !0, icon: i1 })
        ),
        /* @__PURE__ */ x.createElement(
          iy,
          {
            autoFocus: !0,
            variant: "ai",
            className: ie(
              "prompt-input",
              "ai-tw-h-[38px] ai-tw-w-full ai-tw-bg-white ai-tw-pr-10 ai-tw-shadow-purple"
            ),
            ref: a,
            placeholder: "Create from or edit selection...",
            value: p,
            onChange: (E) => m(E.currentTarget.value),
            onKeyDown: b
          }
        ),
        /* @__PURE__ */ x.createElement(
          xh,
          {
            type: "button",
            disabled: !p,
            "aria-label": "send",
            className: "ai-tw-absolute ai-tw-right-3 ai-tw-top-1.5 ai-tw-h-6 ai-tw-w-6",
            onClick: () => {
              r(p), y();
            }
          },
          /* @__PURE__ */ x.createElement(Le, { icon: n1 })
        ),
        /* @__PURE__ */ x.createElement("div", { className: "ai-tw-w-fit ai-tw-rounded ai-tw-bg-white ai-tw-shadow-purple" }, /* @__PURE__ */ x.createElement("span", { className: "ai-tw-ml-2 ai-tw-mt-1.5 ai-tw-text-[10px] ai-tw-font-semibold ai-tw-text-grey-50" }, "Edit or Review"), /* @__PURE__ */ x.createElement("ul", { className: "ai-tw-m-0 ai-tw-p-0" }, yG.map(({ option: E, icon: S }) => /* @__PURE__ */ x.createElement("li", { key: E, className: "ai-tw-list-none" }, /* @__PURE__ */ x.createElement(
          "button",
          {
            className: ie(
              "ai-tw-flex ai-tw-cursor-pointer ai-tw-items-center ai-tw-gap-2",
              "ai-tw-w-full ai-tw-px-4 ai-tw-py-1",
              "hover:ai-tw-bg-tinted-grey-50 active:ai-tw-bg-tinted-grey-60"
            ),
            onClick: () => {
              r(E), y();
            }
          },
          /* @__PURE__ */ x.createElement(
            Le,
            {
              className: "ai-tw-text-purple-60",
              fixedWidth: !0,
              icon: S
            }
          ),
          /* @__PURE__ */ x.createElement("span", null, E)
        )))))
      ) : /* @__PURE__ */ x.createElement(
        "button",
        {
          className: ie(
            "ai-tw-bg-white ai-tw-px-2.5 ai-tw-py-1 ai-tw-font-semibold",
            "ai-tw-rounded-full ai-tw-border ai-tw-border-grey-30 ai-tw-shadow-purple",
            "ai-tw-flex ai-tw-cursor-pointer ai-tw-items-center ai-tw-gap-2 ai-tw-text-element-ai",
            "hover:ai-tw-bg-element-ai hover:ai-tw-text-white",
            "focus:ai-tw-bg-element-ai focus:ai-tw-text-white"
          ),
          onClick: (E) => {
            E.stopPropagation(), E.preventDefault(), u(!0);
          }
        },
        /* @__PURE__ */ x.createElement(Le, { icon: A$ }),
        /* @__PURE__ */ x.createElement("span", null, "Improve")
      )
    ),
    g
  );
}
const Si = /* @__PURE__ */ Object.create(null);
Si.open = "0";
Si.close = "1";
Si.ping = "2";
Si.pong = "3";
Si.message = "4";
Si.upgrade = "5";
Si.noop = "6";
const Vd = /* @__PURE__ */ Object.create(null);
Object.keys(Si).forEach((e) => {
  Vd[Si[e]] = e;
});
const Nv = { type: "error", data: "parser error" }, w6 = typeof Blob == "function" || typeof Blob < "u" && Object.prototype.toString.call(Blob) === "[object BlobConstructor]", b6 = typeof ArrayBuffer == "function", x6 = (e) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e && e.buffer instanceof ArrayBuffer, oy = ({ type: e, data: t }, n, r) => w6 && t instanceof Blob ? n ? r(t) : X3(t, r) : b6 && (t instanceof ArrayBuffer || x6(t)) ? n ? r(t) : X3(new Blob([t]), r) : r(Si[e] + (t || "")), X3 = (e, t) => {
  const n = new FileReader();
  return n.onload = function() {
    const r = n.result.split(",")[1];
    t("b" + (r || ""));
  }, n.readAsDataURL(e);
};
function Z3(e) {
  return e instanceof Uint8Array ? e : e instanceof ArrayBuffer ? new Uint8Array(e) : new Uint8Array(e.buffer, e.byteOffset, e.byteLength);
}
let eg;
function bG(e, t) {
  if (w6 && e.data instanceof Blob)
    return e.data.arrayBuffer().then(Z3).then(t);
  if (b6 && (e.data instanceof ArrayBuffer || x6(e.data)))
    return t(Z3(e.data));
  oy(e, !1, (n) => {
    eg || (eg = new TextEncoder()), t(eg.encode(n));
  });
}
const Q3 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Nl = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (let e = 0; e < Q3.length; e++)
  Nl[Q3.charCodeAt(e)] = e;
const xG = (e) => {
  let t = e.length * 0.75, n = e.length, r, i = 0, o, a, s, l;
  e[e.length - 1] === "=" && (t--, e[e.length - 2] === "=" && t--);
  const u = new ArrayBuffer(t), d = new Uint8Array(u);
  for (r = 0; r < n; r += 4)
    o = Nl[e.charCodeAt(r)], a = Nl[e.charCodeAt(r + 1)], s = Nl[e.charCodeAt(r + 2)], l = Nl[e.charCodeAt(r + 3)], d[i++] = o << 2 | a >> 4, d[i++] = (a & 15) << 4 | s >> 2, d[i++] = (s & 3) << 6 | l & 63;
  return u;
}, EG = typeof ArrayBuffer == "function", ay = (e, t) => {
  if (typeof e != "string")
    return {
      type: "message",
      data: E6(e, t)
    };
  const n = e.charAt(0);
  return n === "b" ? {
    type: "message",
    data: CG(e.substring(1), t)
  } : Vd[n] ? e.length > 1 ? {
    type: Vd[n],
    data: e.substring(1)
  } : {
    type: Vd[n]
  } : Nv;
}, CG = (e, t) => {
  if (EG) {
    const n = xG(e);
    return E6(n, t);
  } else
    return { base64: !0, data: e };
}, E6 = (e, t) => {
  switch (t) {
    case "blob":
      return e instanceof Blob ? e : new Blob([e]);
    case "arraybuffer":
    default:
      return e instanceof ArrayBuffer ? e : e.buffer;
  }
}, C6 = String.fromCharCode(30), SG = (e, t) => {
  const n = e.length, r = new Array(n);
  let i = 0;
  e.forEach((o, a) => {
    oy(o, !1, (s) => {
      r[a] = s, ++i === n && t(r.join(C6));
    });
  });
}, _G = (e, t) => {
  const n = e.split(C6), r = [];
  for (let i = 0; i < n.length; i++) {
    const o = ay(n[i], t);
    if (r.push(o), o.type === "error")
      break;
  }
  return r;
};
function PG() {
  return new TransformStream({
    transform(e, t) {
      bG(e, (n) => {
        const r = n.length;
        let i;
        if (r < 126)
          i = new Uint8Array(1), new DataView(i.buffer).setUint8(0, r);
        else if (r < 65536) {
          i = new Uint8Array(3);
          const o = new DataView(i.buffer);
          o.setUint8(0, 126), o.setUint16(1, r);
        } else {
          i = new Uint8Array(9);
          const o = new DataView(i.buffer);
          o.setUint8(0, 127), o.setBigUint64(1, BigInt(r));
        }
        e.data && typeof e.data != "string" && (i[0] |= 128), t.enqueue(i), t.enqueue(n);
      });
    }
  });
}
let tg;
function rd(e) {
  return e.reduce((t, n) => t + n.length, 0);
}
function id(e, t) {
  if (e[0].length === t)
    return e.shift();
  const n = new Uint8Array(t);
  let r = 0;
  for (let i = 0; i < t; i++)
    n[i] = e[0][r++], r === e[0].length && (e.shift(), r = 0);
  return e.length && r < e[0].length && (e[0] = e[0].slice(r)), n;
}
function kG(e, t) {
  tg || (tg = new TextDecoder());
  const n = [];
  let r = 0, i = -1, o = !1;
  return new TransformStream({
    transform(a, s) {
      for (n.push(a); ; ) {
        if (r === 0) {
          if (rd(n) < 1)
            break;
          const l = id(n, 1);
          o = (l[0] & 128) === 128, i = l[0] & 127, i < 126 ? r = 3 : i === 126 ? r = 1 : r = 2;
        } else if (r === 1) {
          if (rd(n) < 2)
            break;
          const l = id(n, 2);
          i = new DataView(l.buffer, l.byteOffset, l.length).getUint16(0), r = 3;
        } else if (r === 2) {
          if (rd(n) < 8)
            break;
          const l = id(n, 8), u = new DataView(l.buffer, l.byteOffset, l.length), d = u.getUint32(0);
          if (d > Math.pow(2, 53 - 32) - 1) {
            s.enqueue(Nv);
            break;
          }
          i = d * Math.pow(2, 32) + u.getUint32(4), r = 3;
        } else {
          if (rd(n) < i)
            break;
          const l = id(n, i);
          s.enqueue(ay(o ? l : tg.decode(l), t)), r = 0;
        }
        if (i === 0 || i > e) {
          s.enqueue(Nv);
          break;
        }
      }
    }
  });
}
const S6 = 4;
function sn(e) {
  if (e)
    return TG(e);
}
function TG(e) {
  for (var t in sn.prototype)
    e[t] = sn.prototype[t];
  return e;
}
sn.prototype.on = sn.prototype.addEventListener = function(e, t) {
  return this._callbacks = this._callbacks || {}, (this._callbacks["$" + e] = this._callbacks["$" + e] || []).push(t), this;
};
sn.prototype.once = function(e, t) {
  function n() {
    this.off(e, n), t.apply(this, arguments);
  }
  return n.fn = t, this.on(e, n), this;
};
sn.prototype.off = sn.prototype.removeListener = sn.prototype.removeAllListeners = sn.prototype.removeEventListener = function(e, t) {
  if (this._callbacks = this._callbacks || {}, arguments.length == 0)
    return this._callbacks = {}, this;
  var n = this._callbacks["$" + e];
  if (!n)
    return this;
  if (arguments.length == 1)
    return delete this._callbacks["$" + e], this;
  for (var r, i = 0; i < n.length; i++)
    if (r = n[i], r === t || r.fn === t) {
      n.splice(i, 1);
      break;
    }
  return n.length === 0 && delete this._callbacks["$" + e], this;
};
sn.prototype.emit = function(e) {
  this._callbacks = this._callbacks || {};
  for (var t = new Array(arguments.length - 1), n = this._callbacks["$" + e], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  if (n) {
    n = n.slice(0);
    for (var r = 0, i = n.length; r < i; ++r)
      n[r].apply(this, t);
  }
  return this;
};
sn.prototype.emitReserved = sn.prototype.emit;
sn.prototype.listeners = function(e) {
  return this._callbacks = this._callbacks || {}, this._callbacks["$" + e] || [];
};
sn.prototype.hasListeners = function(e) {
  return !!this.listeners(e).length;
};
const Or = (() => typeof self < "u" ? self : typeof window < "u" ? window : Function("return this")())();
function _6(e, ...t) {
  return t.reduce((n, r) => (e.hasOwnProperty(r) && (n[r] = e[r]), n), {});
}
const AG = Or.setTimeout, MG = Or.clearTimeout;
function Sh(e, t) {
  t.useNativeTimers ? (e.setTimeoutFn = AG.bind(Or), e.clearTimeoutFn = MG.bind(Or)) : (e.setTimeoutFn = Or.setTimeout.bind(Or), e.clearTimeoutFn = Or.clearTimeout.bind(Or));
}
const OG = 1.33;
function RG(e) {
  return typeof e == "string" ? IG(e) : Math.ceil((e.byteLength || e.size) * OG);
}
function IG(e) {
  let t = 0, n = 0;
  for (let r = 0, i = e.length; r < i; r++)
    t = e.charCodeAt(r), t < 128 ? n += 1 : t < 2048 ? n += 2 : t < 55296 || t >= 57344 ? n += 3 : (r++, n += 4);
  return n;
}
function DG(e) {
  let t = "";
  for (let n in e)
    e.hasOwnProperty(n) && (t.length && (t += "&"), t += encodeURIComponent(n) + "=" + encodeURIComponent(e[n]));
  return t;
}
function NG(e) {
  let t = {}, n = e.split("&");
  for (let r = 0, i = n.length; r < i; r++) {
    let o = n[r].split("=");
    t[decodeURIComponent(o[0])] = decodeURIComponent(o[1]);
  }
  return t;
}
class $G extends Error {
  constructor(t, n, r) {
    super(t), this.description = n, this.context = r, this.type = "TransportError";
  }
}
class sy extends sn {
  /**
   * Transport abstract constructor.
   *
   * @param {Object} opts - options
   * @protected
   */
  constructor(t) {
    super(), this.writable = !1, Sh(this, t), this.opts = t, this.query = t.query, this.socket = t.socket;
  }
  /**
   * Emits an error.
   *
   * @param {String} reason
   * @param description
   * @param context - the error context
   * @return {Transport} for chaining
   * @protected
   */
  onError(t, n, r) {
    return super.emitReserved("error", new $G(t, n, r)), this;
  }
  /**
   * Opens the transport.
   */
  open() {
    return this.readyState = "opening", this.doOpen(), this;
  }
  /**
   * Closes the transport.
   */
  close() {
    return (this.readyState === "opening" || this.readyState === "open") && (this.doClose(), this.onClose()), this;
  }
  /**
   * Sends multiple packets.
   *
   * @param {Array} packets
   */
  send(t) {
    this.readyState === "open" && this.write(t);
  }
  /**
   * Called upon open
   *
   * @protected
   */
  onOpen() {
    this.readyState = "open", this.writable = !0, super.emitReserved("open");
  }
  /**
   * Called with data.
   *
   * @param {String} data
   * @protected
   */
  onData(t) {
    const n = ay(t, this.socket.binaryType);
    this.onPacket(n);
  }
  /**
   * Called with a decoded packet.
   *
   * @protected
   */
  onPacket(t) {
    super.emitReserved("packet", t);
  }
  /**
   * Called upon close.
   *
   * @protected
   */
  onClose(t) {
    this.readyState = "closed", super.emitReserved("close", t);
  }
  /**
   * Pauses the transport, in order not to lose packets during an upgrade.
   *
   * @param onPause
   */
  pause(t) {
  }
  createUri(t, n = {}) {
    return t + "://" + this._hostname() + this._port() + this.opts.path + this._query(n);
  }
  _hostname() {
    const t = this.opts.hostname;
    return t.indexOf(":") === -1 ? t : "[" + t + "]";
  }
  _port() {
    return this.opts.port && (this.opts.secure && +(this.opts.port !== 443) || !this.opts.secure && Number(this.opts.port) !== 80) ? ":" + this.opts.port : "";
  }
  _query(t) {
    const n = DG(t);
    return n.length ? "?" + n : "";
  }
}
const P6 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz-_".split(""), $v = 64, LG = {};
let J3 = 0, od = 0, eE;
function tE(e) {
  let t = "";
  do
    t = P6[e % $v] + t, e = Math.floor(e / $v);
  while (e > 0);
  return t;
}
function k6() {
  const e = tE(+/* @__PURE__ */ new Date());
  return e !== eE ? (J3 = 0, eE = e) : e + "." + tE(J3++);
}
for (; od < $v; od++)
  LG[P6[od]] = od;
let T6 = !1;
try {
  T6 = typeof XMLHttpRequest < "u" && "withCredentials" in new XMLHttpRequest();
} catch {
}
const FG = T6;
function A6(e) {
  const t = e.xdomain;
  try {
    if (typeof XMLHttpRequest < "u" && (!t || FG))
      return new XMLHttpRequest();
  } catch {
  }
  if (!t)
    try {
      return new Or[["Active"].concat("Object").join("X")]("Microsoft.XMLHTTP");
    } catch {
    }
}
function zG() {
}
const VG = function() {
  return new A6({
    xdomain: !1
  }).responseType != null;
}();
class BG extends sy {
  /**
   * XHR Polling constructor.
   *
   * @param {Object} opts
   * @package
   */
  constructor(t) {
    if (super(t), this.polling = !1, typeof location < "u") {
      const r = location.protocol === "https:";
      let i = location.port;
      i || (i = r ? "443" : "80"), this.xd = typeof location < "u" && t.hostname !== location.hostname || i !== t.port;
    }
    const n = t && t.forceBase64;
    this.supportsBinary = VG && !n, this.opts.withCredentials && (this.cookieJar = void 0);
  }
  get name() {
    return "polling";
  }
  /**
   * Opens the socket (triggers polling). We write a PING message to determine
   * when the transport is open.
   *
   * @protected
   */
  doOpen() {
    this.poll();
  }
  /**
   * Pauses polling.
   *
   * @param {Function} onPause - callback upon buffers are flushed and transport is paused
   * @package
   */
  pause(t) {
    this.readyState = "pausing";
    const n = () => {
      this.readyState = "paused", t();
    };
    if (this.polling || !this.writable) {
      let r = 0;
      this.polling && (r++, this.once("pollComplete", function() {
        --r || n();
      })), this.writable || (r++, this.once("drain", function() {
        --r || n();
      }));
    } else
      n();
  }
  /**
   * Starts polling cycle.
   *
   * @private
   */
  poll() {
    this.polling = !0, this.doPoll(), this.emitReserved("poll");
  }
  /**
   * Overloads onData to detect payloads.
   *
   * @protected
   */
  onData(t) {
    const n = (r) => {
      if (this.readyState === "opening" && r.type === "open" && this.onOpen(), r.type === "close")
        return this.onClose({ description: "transport closed by the server" }), !1;
      this.onPacket(r);
    };
    _G(t, this.socket.binaryType).forEach(n), this.readyState !== "closed" && (this.polling = !1, this.emitReserved("pollComplete"), this.readyState === "open" && this.poll());
  }
  /**
   * For polling, send a close packet.
   *
   * @protected
   */
  doClose() {
    const t = () => {
      this.write([{ type: "close" }]);
    };
    this.readyState === "open" ? t() : this.once("open", t);
  }
  /**
   * Writes a packets payload.
   *
   * @param {Array} packets - data packets
   * @protected
   */
  write(t) {
    this.writable = !1, SG(t, (n) => {
      this.doWrite(n, () => {
        this.writable = !0, this.emitReserved("drain");
      });
    });
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const t = this.opts.secure ? "https" : "http", n = this.query || {};
    return this.opts.timestampRequests !== !1 && (n[this.opts.timestampParam] = k6()), !this.supportsBinary && !n.sid && (n.b64 = 1), this.createUri(t, n);
  }
  /**
   * Creates a request.
   *
   * @param {String} method
   * @private
   */
  request(t = {}) {
    return Object.assign(t, { xd: this.xd, cookieJar: this.cookieJar }, this.opts), new ws(this.uri(), t);
  }
  /**
   * Sends data.
   *
   * @param {String} data to send.
   * @param {Function} called upon flush.
   * @private
   */
  doWrite(t, n) {
    const r = this.request({
      method: "POST",
      data: t
    });
    r.on("success", n), r.on("error", (i, o) => {
      this.onError("xhr post error", i, o);
    });
  }
  /**
   * Starts a poll cycle.
   *
   * @private
   */
  doPoll() {
    const t = this.request();
    t.on("data", this.onData.bind(this)), t.on("error", (n, r) => {
      this.onError("xhr poll error", n, r);
    }), this.pollXhr = t;
  }
}
let ws = class Bd extends sn {
  /**
   * Request constructor
   *
   * @param {Object} options
   * @package
   */
  constructor(t, n) {
    super(), Sh(this, n), this.opts = n, this.method = n.method || "GET", this.uri = t, this.data = n.data !== void 0 ? n.data : null, this.create();
  }
  /**
   * Creates the XHR object and sends the request.
   *
   * @private
   */
  create() {
    var t;
    const n = _6(this.opts, "agent", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "autoUnref");
    n.xdomain = !!this.opts.xd;
    const r = this.xhr = new A6(n);
    try {
      r.open(this.method, this.uri, !0);
      try {
        if (this.opts.extraHeaders) {
          r.setDisableHeaderCheck && r.setDisableHeaderCheck(!0);
          for (let i in this.opts.extraHeaders)
            this.opts.extraHeaders.hasOwnProperty(i) && r.setRequestHeader(i, this.opts.extraHeaders[i]);
        }
      } catch {
      }
      if (this.method === "POST")
        try {
          r.setRequestHeader("Content-type", "text/plain;charset=UTF-8");
        } catch {
        }
      try {
        r.setRequestHeader("Accept", "*/*");
      } catch {
      }
      (t = this.opts.cookieJar) === null || t === void 0 || t.addCookies(r), "withCredentials" in r && (r.withCredentials = this.opts.withCredentials), this.opts.requestTimeout && (r.timeout = this.opts.requestTimeout), r.onreadystatechange = () => {
        var i;
        r.readyState === 3 && ((i = this.opts.cookieJar) === null || i === void 0 || i.parseCookies(r)), r.readyState === 4 && (r.status === 200 || r.status === 1223 ? this.onLoad() : this.setTimeoutFn(() => {
          this.onError(typeof r.status == "number" ? r.status : 0);
        }, 0));
      }, r.send(this.data);
    } catch (i) {
      this.setTimeoutFn(() => {
        this.onError(i);
      }, 0);
      return;
    }
    typeof document < "u" && (this.index = Bd.requestsCount++, Bd.requests[this.index] = this);
  }
  /**
   * Called upon error.
   *
   * @private
   */
  onError(t) {
    this.emitReserved("error", t, this.xhr), this.cleanup(!0);
  }
  /**
   * Cleans up house.
   *
   * @private
   */
  cleanup(t) {
    if (!(typeof this.xhr > "u" || this.xhr === null)) {
      if (this.xhr.onreadystatechange = zG, t)
        try {
          this.xhr.abort();
        } catch {
        }
      typeof document < "u" && delete Bd.requests[this.index], this.xhr = null;
    }
  }
  /**
   * Called upon load.
   *
   * @private
   */
  onLoad() {
    const t = this.xhr.responseText;
    t !== null && (this.emitReserved("data", t), this.emitReserved("success"), this.cleanup());
  }
  /**
   * Aborts the request.
   *
   * @package
   */
  abort() {
    this.cleanup();
  }
};
ws.requestsCount = 0;
ws.requests = {};
if (typeof document < "u") {
  if (typeof attachEvent == "function")
    attachEvent("onunload", nE);
  else if (typeof addEventListener == "function") {
    const e = "onpagehide" in Or ? "pagehide" : "unload";
    addEventListener(e, nE, !1);
  }
}
function nE() {
  for (let e in ws.requests)
    ws.requests.hasOwnProperty(e) && ws.requests[e].abort();
}
const ly = (() => typeof Promise == "function" && typeof Promise.resolve == "function" ? (t) => Promise.resolve().then(t) : (t, n) => n(t, 0))(), ad = Or.WebSocket || Or.MozWebSocket, rE = !0, jG = "arraybuffer", iE = typeof navigator < "u" && typeof navigator.product == "string" && navigator.product.toLowerCase() === "reactnative";
class WG extends sy {
  /**
   * WebSocket transport constructor.
   *
   * @param {Object} opts - connection options
   * @protected
   */
  constructor(t) {
    super(t), this.supportsBinary = !t.forceBase64;
  }
  get name() {
    return "websocket";
  }
  doOpen() {
    if (!this.check())
      return;
    const t = this.uri(), n = this.opts.protocols, r = iE ? {} : _6(this.opts, "agent", "perMessageDeflate", "pfx", "key", "passphrase", "cert", "ca", "ciphers", "rejectUnauthorized", "localAddress", "protocolVersion", "origin", "maxPayload", "family", "checkServerIdentity");
    this.opts.extraHeaders && (r.headers = this.opts.extraHeaders);
    try {
      this.ws = rE && !iE ? n ? new ad(t, n) : new ad(t) : new ad(t, n, r);
    } catch (i) {
      return this.emitReserved("error", i);
    }
    this.ws.binaryType = this.socket.binaryType, this.addEventListeners();
  }
  /**
   * Adds event listeners to the socket
   *
   * @private
   */
  addEventListeners() {
    this.ws.onopen = () => {
      this.opts.autoUnref && this.ws._socket.unref(), this.onOpen();
    }, this.ws.onclose = (t) => this.onClose({
      description: "websocket connection closed",
      context: t
    }), this.ws.onmessage = (t) => this.onData(t.data), this.ws.onerror = (t) => this.onError("websocket error", t);
  }
  write(t) {
    this.writable = !1;
    for (let n = 0; n < t.length; n++) {
      const r = t[n], i = n === t.length - 1;
      oy(r, this.supportsBinary, (o) => {
        const a = {};
        try {
          rE && this.ws.send(o);
        } catch {
        }
        i && ly(() => {
          this.writable = !0, this.emitReserved("drain");
        }, this.setTimeoutFn);
      });
    }
  }
  doClose() {
    typeof this.ws < "u" && (this.ws.close(), this.ws = null);
  }
  /**
   * Generates uri for connection.
   *
   * @private
   */
  uri() {
    const t = this.opts.secure ? "wss" : "ws", n = this.query || {};
    return this.opts.timestampRequests && (n[this.opts.timestampParam] = k6()), this.supportsBinary || (n.b64 = 1), this.createUri(t, n);
  }
  /**
   * Feature detection for WebSocket.
   *
   * @return {Boolean} whether this transport is available.
   * @private
   */
  check() {
    return !!ad;
  }
}
class UG extends sy {
  get name() {
    return "webtransport";
  }
  doOpen() {
    typeof WebTransport == "function" && (this.transport = new WebTransport(this.createUri("https"), this.opts.transportOptions[this.name]), this.transport.closed.then(() => {
      this.onClose();
    }).catch((t) => {
      this.onError("webtransport error", t);
    }), this.transport.ready.then(() => {
      this.transport.createBidirectionalStream().then((t) => {
        const n = kG(Number.MAX_SAFE_INTEGER, this.socket.binaryType), r = t.readable.pipeThrough(n).getReader(), i = PG();
        i.readable.pipeTo(t.writable), this.writer = i.writable.getWriter();
        const o = () => {
          r.read().then(({ done: s, value: l }) => {
            s || (this.onPacket(l), o());
          }).catch((s) => {
          });
        };
        o();
        const a = { type: "open" };
        this.query.sid && (a.data = `{"sid":"${this.query.sid}"}`), this.writer.write(a).then(() => this.onOpen());
      });
    }));
  }
  write(t) {
    this.writable = !1;
    for (let n = 0; n < t.length; n++) {
      const r = t[n], i = n === t.length - 1;
      this.writer.write(r).then(() => {
        i && ly(() => {
          this.writable = !0, this.emitReserved("drain");
        }, this.setTimeoutFn);
      });
    }
  }
  doClose() {
    var t;
    (t = this.transport) === null || t === void 0 || t.close();
  }
}
const HG = {
  websocket: WG,
  webtransport: UG,
  polling: BG
}, GG = /^(?:(?![^:@\/?#]+:[^:@\/]*@)(http|https|ws|wss):\/\/)?((?:(([^:@\/?#]*)(?::([^:@\/?#]*))?)?@)?((?:[a-f0-9]{0,4}:){2,7}[a-f0-9]{0,4}|[^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/, qG = [
  "source",
  "protocol",
  "authority",
  "userInfo",
  "user",
  "password",
  "host",
  "port",
  "relative",
  "path",
  "directory",
  "file",
  "query",
  "anchor"
];
function Lv(e) {
  if (e.length > 2e3)
    throw "URI too long";
  const t = e, n = e.indexOf("["), r = e.indexOf("]");
  n != -1 && r != -1 && (e = e.substring(0, n) + e.substring(n, r).replace(/:/g, ";") + e.substring(r, e.length));
  let i = GG.exec(e || ""), o = {}, a = 14;
  for (; a--; )
    o[qG[a]] = i[a] || "";
  return n != -1 && r != -1 && (o.source = t, o.host = o.host.substring(1, o.host.length - 1).replace(/;/g, ":"), o.authority = o.authority.replace("[", "").replace("]", "").replace(/;/g, ":"), o.ipv6uri = !0), o.pathNames = YG(o, o.path), o.queryKey = KG(o, o.query), o;
}
function YG(e, t) {
  const n = /\/{2,9}/g, r = t.replace(n, "/").split("/");
  return (t.slice(0, 1) == "/" || t.length === 0) && r.splice(0, 1), t.slice(-1) == "/" && r.splice(r.length - 1, 1), r;
}
function KG(e, t) {
  const n = {};
  return t.replace(/(?:^|&)([^&=]*)=?([^&]*)/g, function(r, i, o) {
    i && (n[i] = o);
  }), n;
}
let M6 = class as extends sn {
  /**
   * Socket constructor.
   *
   * @param {String|Object} uri - uri or options
   * @param {Object} opts - options
   */
  constructor(t, n = {}) {
    super(), this.binaryType = jG, this.writeBuffer = [], t && typeof t == "object" && (n = t, t = null), t ? (t = Lv(t), n.hostname = t.host, n.secure = t.protocol === "https" || t.protocol === "wss", n.port = t.port, t.query && (n.query = t.query)) : n.host && (n.hostname = Lv(n.host).host), Sh(this, n), this.secure = n.secure != null ? n.secure : typeof location < "u" && location.protocol === "https:", n.hostname && !n.port && (n.port = this.secure ? "443" : "80"), this.hostname = n.hostname || (typeof location < "u" ? location.hostname : "localhost"), this.port = n.port || (typeof location < "u" && location.port ? location.port : this.secure ? "443" : "80"), this.transports = n.transports || [
      "polling",
      "websocket",
      "webtransport"
    ], this.writeBuffer = [], this.prevBufferLen = 0, this.opts = Object.assign({
      path: "/engine.io",
      agent: !1,
      withCredentials: !1,
      upgrade: !0,
      timestampParam: "t",
      rememberUpgrade: !1,
      addTrailingSlash: !0,
      rejectUnauthorized: !0,
      perMessageDeflate: {
        threshold: 1024
      },
      transportOptions: {},
      closeOnBeforeunload: !1
    }, n), this.opts.path = this.opts.path.replace(/\/$/, "") + (this.opts.addTrailingSlash ? "/" : ""), typeof this.opts.query == "string" && (this.opts.query = NG(this.opts.query)), this.id = null, this.upgrades = null, this.pingInterval = null, this.pingTimeout = null, this.pingTimeoutTimer = null, typeof addEventListener == "function" && (this.opts.closeOnBeforeunload && (this.beforeunloadEventListener = () => {
      this.transport && (this.transport.removeAllListeners(), this.transport.close());
    }, addEventListener("beforeunload", this.beforeunloadEventListener, !1)), this.hostname !== "localhost" && (this.offlineEventListener = () => {
      this.onClose("transport close", {
        description: "network connection lost"
      });
    }, addEventListener("offline", this.offlineEventListener, !1))), this.open();
  }
  /**
   * Creates transport of the given type.
   *
   * @param {String} name - transport name
   * @return {Transport}
   * @private
   */
  createTransport(t) {
    const n = Object.assign({}, this.opts.query);
    n.EIO = S6, n.transport = t, this.id && (n.sid = this.id);
    const r = Object.assign({}, this.opts, {
      query: n,
      socket: this,
      hostname: this.hostname,
      secure: this.secure,
      port: this.port
    }, this.opts.transportOptions[t]);
    return new HG[t](r);
  }
  /**
   * Initializes transport to use and starts probe.
   *
   * @private
   */
  open() {
    let t;
    if (this.opts.rememberUpgrade && as.priorWebsocketSuccess && this.transports.indexOf("websocket") !== -1)
      t = "websocket";
    else if (this.transports.length === 0) {
      this.setTimeoutFn(() => {
        this.emitReserved("error", "No transports available");
      }, 0);
      return;
    } else
      t = this.transports[0];
    this.readyState = "opening";
    try {
      t = this.createTransport(t);
    } catch {
      this.transports.shift(), this.open();
      return;
    }
    t.open(), this.setTransport(t);
  }
  /**
   * Sets the current transport. Disables the existing one (if any).
   *
   * @private
   */
  setTransport(t) {
    this.transport && this.transport.removeAllListeners(), this.transport = t, t.on("drain", this.onDrain.bind(this)).on("packet", this.onPacket.bind(this)).on("error", this.onError.bind(this)).on("close", (n) => this.onClose("transport close", n));
  }
  /**
   * Probes a transport.
   *
   * @param {String} name - transport name
   * @private
   */
  probe(t) {
    let n = this.createTransport(t), r = !1;
    as.priorWebsocketSuccess = !1;
    const i = () => {
      r || (n.send([{ type: "ping", data: "probe" }]), n.once("packet", (f) => {
        if (!r)
          if (f.type === "pong" && f.data === "probe") {
            if (this.upgrading = !0, this.emitReserved("upgrading", n), !n)
              return;
            as.priorWebsocketSuccess = n.name === "websocket", this.transport.pause(() => {
              r || this.readyState !== "closed" && (d(), this.setTransport(n), n.send([{ type: "upgrade" }]), this.emitReserved("upgrade", n), n = null, this.upgrading = !1, this.flush());
            });
          } else {
            const p = new Error("probe error");
            p.transport = n.name, this.emitReserved("upgradeError", p);
          }
      }));
    };
    function o() {
      r || (r = !0, d(), n.close(), n = null);
    }
    const a = (f) => {
      const p = new Error("probe error: " + f);
      p.transport = n.name, o(), this.emitReserved("upgradeError", p);
    };
    function s() {
      a("transport closed");
    }
    function l() {
      a("socket closed");
    }
    function u(f) {
      n && f.name !== n.name && o();
    }
    const d = () => {
      n.removeListener("open", i), n.removeListener("error", a), n.removeListener("close", s), this.off("close", l), this.off("upgrading", u);
    };
    n.once("open", i), n.once("error", a), n.once("close", s), this.once("close", l), this.once("upgrading", u), this.upgrades.indexOf("webtransport") !== -1 && t !== "webtransport" ? this.setTimeoutFn(() => {
      r || n.open();
    }, 200) : n.open();
  }
  /**
   * Called when connection is deemed open.
   *
   * @private
   */
  onOpen() {
    if (this.readyState = "open", as.priorWebsocketSuccess = this.transport.name === "websocket", this.emitReserved("open"), this.flush(), this.readyState === "open" && this.opts.upgrade) {
      let t = 0;
      const n = this.upgrades.length;
      for (; t < n; t++)
        this.probe(this.upgrades[t]);
    }
  }
  /**
   * Handles a packet.
   *
   * @private
   */
  onPacket(t) {
    if (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing")
      switch (this.emitReserved("packet", t), this.emitReserved("heartbeat"), this.resetPingTimeout(), t.type) {
        case "open":
          this.onHandshake(JSON.parse(t.data));
          break;
        case "ping":
          this.sendPacket("pong"), this.emitReserved("ping"), this.emitReserved("pong");
          break;
        case "error":
          const n = new Error("server error");
          n.code = t.data, this.onError(n);
          break;
        case "message":
          this.emitReserved("data", t.data), this.emitReserved("message", t.data);
          break;
      }
  }
  /**
   * Called upon handshake completion.
   *
   * @param {Object} data - handshake obj
   * @private
   */
  onHandshake(t) {
    this.emitReserved("handshake", t), this.id = t.sid, this.transport.query.sid = t.sid, this.upgrades = this.filterUpgrades(t.upgrades), this.pingInterval = t.pingInterval, this.pingTimeout = t.pingTimeout, this.maxPayload = t.maxPayload, this.onOpen(), this.readyState !== "closed" && this.resetPingTimeout();
  }
  /**
   * Sets and resets ping timeout timer based on server pings.
   *
   * @private
   */
  resetPingTimeout() {
    this.clearTimeoutFn(this.pingTimeoutTimer), this.pingTimeoutTimer = this.setTimeoutFn(() => {
      this.onClose("ping timeout");
    }, this.pingInterval + this.pingTimeout), this.opts.autoUnref && this.pingTimeoutTimer.unref();
  }
  /**
   * Called on `drain` event
   *
   * @private
   */
  onDrain() {
    this.writeBuffer.splice(0, this.prevBufferLen), this.prevBufferLen = 0, this.writeBuffer.length === 0 ? this.emitReserved("drain") : this.flush();
  }
  /**
   * Flush write buffers.
   *
   * @private
   */
  flush() {
    if (this.readyState !== "closed" && this.transport.writable && !this.upgrading && this.writeBuffer.length) {
      const t = this.getWritablePackets();
      this.transport.send(t), this.prevBufferLen = t.length, this.emitReserved("flush");
    }
  }
  /**
   * Ensure the encoded size of the writeBuffer is below the maxPayload value sent by the server (only for HTTP
   * long-polling)
   *
   * @private
   */
  getWritablePackets() {
    if (!(this.maxPayload && this.transport.name === "polling" && this.writeBuffer.length > 1))
      return this.writeBuffer;
    let n = 1;
    for (let r = 0; r < this.writeBuffer.length; r++) {
      const i = this.writeBuffer[r].data;
      if (i && (n += RG(i)), r > 0 && n > this.maxPayload)
        return this.writeBuffer.slice(0, r);
      n += 2;
    }
    return this.writeBuffer;
  }
  /**
   * Sends a message.
   *
   * @param {String} msg - message.
   * @param {Object} options.
   * @param {Function} callback function.
   * @return {Socket} for chaining.
   */
  write(t, n, r) {
    return this.sendPacket("message", t, n, r), this;
  }
  send(t, n, r) {
    return this.sendPacket("message", t, n, r), this;
  }
  /**
   * Sends a packet.
   *
   * @param {String} type: packet type.
   * @param {String} data.
   * @param {Object} options.
   * @param {Function} fn - callback function.
   * @private
   */
  sendPacket(t, n, r, i) {
    if (typeof n == "function" && (i = n, n = void 0), typeof r == "function" && (i = r, r = null), this.readyState === "closing" || this.readyState === "closed")
      return;
    r = r || {}, r.compress = r.compress !== !1;
    const o = {
      type: t,
      data: n,
      options: r
    };
    this.emitReserved("packetCreate", o), this.writeBuffer.push(o), i && this.once("flush", i), this.flush();
  }
  /**
   * Closes the connection.
   */
  close() {
    const t = () => {
      this.onClose("forced close"), this.transport.close();
    }, n = () => {
      this.off("upgrade", n), this.off("upgradeError", n), t();
    }, r = () => {
      this.once("upgrade", n), this.once("upgradeError", n);
    };
    return (this.readyState === "opening" || this.readyState === "open") && (this.readyState = "closing", this.writeBuffer.length ? this.once("drain", () => {
      this.upgrading ? r() : t();
    }) : this.upgrading ? r() : t()), this;
  }
  /**
   * Called upon transport error
   *
   * @private
   */
  onError(t) {
    as.priorWebsocketSuccess = !1, this.emitReserved("error", t), this.onClose("transport error", t);
  }
  /**
   * Called upon transport close.
   *
   * @private
   */
  onClose(t, n) {
    (this.readyState === "opening" || this.readyState === "open" || this.readyState === "closing") && (this.clearTimeoutFn(this.pingTimeoutTimer), this.transport.removeAllListeners("close"), this.transport.close(), this.transport.removeAllListeners(), typeof removeEventListener == "function" && (removeEventListener("beforeunload", this.beforeunloadEventListener, !1), removeEventListener("offline", this.offlineEventListener, !1)), this.readyState = "closed", this.id = null, this.emitReserved("close", t, n), this.writeBuffer = [], this.prevBufferLen = 0);
  }
  /**
   * Filters upgrades, returning only those matching client transports.
   *
   * @param {Array} upgrades - server upgrades
   * @private
   */
  filterUpgrades(t) {
    const n = [];
    let r = 0;
    const i = t.length;
    for (; r < i; r++)
      ~this.transports.indexOf(t[r]) && n.push(t[r]);
    return n;
  }
};
M6.protocol = S6;
function XG(e, t = "", n) {
  let r = e;
  n = n || typeof location < "u" && location, e == null && (e = n.protocol + "//" + n.host), typeof e == "string" && (e.charAt(0) === "/" && (e.charAt(1) === "/" ? e = n.protocol + e : e = n.host + e), /^(https?|wss?):\/\//.test(e) || (typeof n < "u" ? e = n.protocol + "//" + e : e = "https://" + e), r = Lv(e)), r.port || (/^(http|ws)$/.test(r.protocol) ? r.port = "80" : /^(http|ws)s$/.test(r.protocol) && (r.port = "443")), r.path = r.path || "/";
  const o = r.host.indexOf(":") !== -1 ? "[" + r.host + "]" : r.host;
  return r.id = r.protocol + "://" + o + ":" + r.port + t, r.href = r.protocol + "://" + o + (n && n.port === r.port ? "" : ":" + r.port), r;
}
const ZG = typeof ArrayBuffer == "function", QG = (e) => typeof ArrayBuffer.isView == "function" ? ArrayBuffer.isView(e) : e.buffer instanceof ArrayBuffer, O6 = Object.prototype.toString, JG = typeof Blob == "function" || typeof Blob < "u" && O6.call(Blob) === "[object BlobConstructor]", eq = typeof File == "function" || typeof File < "u" && O6.call(File) === "[object FileConstructor]";
function cy(e) {
  return ZG && (e instanceof ArrayBuffer || QG(e)) || JG && e instanceof Blob || eq && e instanceof File;
}
function jd(e, t) {
  if (!e || typeof e != "object")
    return !1;
  if (Array.isArray(e)) {
    for (let n = 0, r = e.length; n < r; n++)
      if (jd(e[n]))
        return !0;
    return !1;
  }
  if (cy(e))
    return !0;
  if (e.toJSON && typeof e.toJSON == "function" && arguments.length === 1)
    return jd(e.toJSON(), !0);
  for (const n in e)
    if (Object.prototype.hasOwnProperty.call(e, n) && jd(e[n]))
      return !0;
  return !1;
}
function tq(e) {
  const t = [], n = e.data, r = e;
  return r.data = Fv(n, t), r.attachments = t.length, { packet: r, buffers: t };
}
function Fv(e, t) {
  if (!e)
    return e;
  if (cy(e)) {
    const n = { _placeholder: !0, num: t.length };
    return t.push(e), n;
  } else if (Array.isArray(e)) {
    const n = new Array(e.length);
    for (let r = 0; r < e.length; r++)
      n[r] = Fv(e[r], t);
    return n;
  } else if (typeof e == "object" && !(e instanceof Date)) {
    const n = {};
    for (const r in e)
      Object.prototype.hasOwnProperty.call(e, r) && (n[r] = Fv(e[r], t));
    return n;
  }
  return e;
}
function nq(e, t) {
  return e.data = zv(e.data, t), delete e.attachments, e;
}
function zv(e, t) {
  if (!e)
    return e;
  if (e && e._placeholder === !0) {
    if (typeof e.num == "number" && e.num >= 0 && e.num < t.length)
      return t[e.num];
    throw new Error("illegal attachments");
  } else if (Array.isArray(e))
    for (let n = 0; n < e.length; n++)
      e[n] = zv(e[n], t);
  else if (typeof e == "object")
    for (const n in e)
      Object.prototype.hasOwnProperty.call(e, n) && (e[n] = zv(e[n], t));
  return e;
}
const rq = [
  "connect",
  "connect_error",
  "disconnect",
  "disconnecting",
  "newListener",
  "removeListener"
  // used by the Node.js EventEmitter
], iq = 5;
var ut;
(function(e) {
  e[e.CONNECT = 0] = "CONNECT", e[e.DISCONNECT = 1] = "DISCONNECT", e[e.EVENT = 2] = "EVENT", e[e.ACK = 3] = "ACK", e[e.CONNECT_ERROR = 4] = "CONNECT_ERROR", e[e.BINARY_EVENT = 5] = "BINARY_EVENT", e[e.BINARY_ACK = 6] = "BINARY_ACK";
})(ut || (ut = {}));
class oq {
  /**
   * Encoder constructor
   *
   * @param {function} replacer - custom replacer to pass down to JSON.parse
   */
  constructor(t) {
    this.replacer = t;
  }
  /**
   * Encode a packet as a single string if non-binary, or as a
   * buffer sequence, depending on packet type.
   *
   * @param {Object} obj - packet object
   */
  encode(t) {
    return (t.type === ut.EVENT || t.type === ut.ACK) && jd(t) ? this.encodeAsBinary({
      type: t.type === ut.EVENT ? ut.BINARY_EVENT : ut.BINARY_ACK,
      nsp: t.nsp,
      data: t.data,
      id: t.id
    }) : [this.encodeAsString(t)];
  }
  /**
   * Encode packet as string.
   */
  encodeAsString(t) {
    let n = "" + t.type;
    return (t.type === ut.BINARY_EVENT || t.type === ut.BINARY_ACK) && (n += t.attachments + "-"), t.nsp && t.nsp !== "/" && (n += t.nsp + ","), t.id != null && (n += t.id), t.data != null && (n += JSON.stringify(t.data, this.replacer)), n;
  }
  /**
   * Encode packet as 'buffer sequence' by removing blobs, and
   * deconstructing packet into object with placeholders and
   * a list of buffers.
   */
  encodeAsBinary(t) {
    const n = tq(t), r = this.encodeAsString(n.packet), i = n.buffers;
    return i.unshift(r), i;
  }
}
function oE(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
class uy extends sn {
  /**
   * Decoder constructor
   *
   * @param {function} reviver - custom reviver to pass down to JSON.stringify
   */
  constructor(t) {
    super(), this.reviver = t;
  }
  /**
   * Decodes an encoded packet string into packet JSON.
   *
   * @param {String} obj - encoded packet
   */
  add(t) {
    let n;
    if (typeof t == "string") {
      if (this.reconstructor)
        throw new Error("got plaintext data when reconstructing a packet");
      n = this.decodeString(t);
      const r = n.type === ut.BINARY_EVENT;
      r || n.type === ut.BINARY_ACK ? (n.type = r ? ut.EVENT : ut.ACK, this.reconstructor = new aq(n), n.attachments === 0 && super.emitReserved("decoded", n)) : super.emitReserved("decoded", n);
    } else if (cy(t) || t.base64)
      if (this.reconstructor)
        n = this.reconstructor.takeBinaryData(t), n && (this.reconstructor = null, super.emitReserved("decoded", n));
      else
        throw new Error("got binary data when not reconstructing a packet");
    else
      throw new Error("Unknown type: " + t);
  }
  /**
   * Decode a packet String (JSON data)
   *
   * @param {String} str
   * @return {Object} packet
   */
  decodeString(t) {
    let n = 0;
    const r = {
      type: Number(t.charAt(0))
    };
    if (ut[r.type] === void 0)
      throw new Error("unknown packet type " + r.type);
    if (r.type === ut.BINARY_EVENT || r.type === ut.BINARY_ACK) {
      const o = n + 1;
      for (; t.charAt(++n) !== "-" && n != t.length; )
        ;
      const a = t.substring(o, n);
      if (a != Number(a) || t.charAt(n) !== "-")
        throw new Error("Illegal attachments");
      r.attachments = Number(a);
    }
    if (t.charAt(n + 1) === "/") {
      const o = n + 1;
      for (; ++n && !(t.charAt(n) === "," || n === t.length); )
        ;
      r.nsp = t.substring(o, n);
    } else
      r.nsp = "/";
    const i = t.charAt(n + 1);
    if (i !== "" && Number(i) == i) {
      const o = n + 1;
      for (; ++n; ) {
        const a = t.charAt(n);
        if (a == null || Number(a) != a) {
          --n;
          break;
        }
        if (n === t.length)
          break;
      }
      r.id = Number(t.substring(o, n + 1));
    }
    if (t.charAt(++n)) {
      const o = this.tryParse(t.substr(n));
      if (uy.isPayloadValid(r.type, o))
        r.data = o;
      else
        throw new Error("invalid payload");
    }
    return r;
  }
  tryParse(t) {
    try {
      return JSON.parse(t, this.reviver);
    } catch {
      return !1;
    }
  }
  static isPayloadValid(t, n) {
    switch (t) {
      case ut.CONNECT:
        return oE(n);
      case ut.DISCONNECT:
        return n === void 0;
      case ut.CONNECT_ERROR:
        return typeof n == "string" || oE(n);
      case ut.EVENT:
      case ut.BINARY_EVENT:
        return Array.isArray(n) && (typeof n[0] == "number" || typeof n[0] == "string" && rq.indexOf(n[0]) === -1);
      case ut.ACK:
      case ut.BINARY_ACK:
        return Array.isArray(n);
    }
  }
  /**
   * Deallocates a parser's resources
   */
  destroy() {
    this.reconstructor && (this.reconstructor.finishedReconstruction(), this.reconstructor = null);
  }
}
class aq {
  constructor(t) {
    this.packet = t, this.buffers = [], this.reconPack = t;
  }
  /**
   * Method to be called when binary data received from connection
   * after a BINARY_EVENT packet.
   *
   * @param {Buffer | ArrayBuffer} binData - the raw binary data received
   * @return {null | Object} returns null if more binary data is expected or
   *   a reconstructed packet object if all buffers have been received.
   */
  takeBinaryData(t) {
    if (this.buffers.push(t), this.buffers.length === this.reconPack.attachments) {
      const n = nq(this.reconPack, this.buffers);
      return this.finishedReconstruction(), n;
    }
    return null;
  }
  /**
   * Cleans up binary packet reconstruction variables.
   */
  finishedReconstruction() {
    this.reconPack = null, this.buffers = [];
  }
}
const sq = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Decoder: uy,
  Encoder: oq,
  get PacketType() {
    return ut;
  },
  protocol: iq
}, Symbol.toStringTag, { value: "Module" }));
function Jr(e, t, n) {
  return e.on(t, n), function() {
    e.off(t, n);
  };
}
const lq = Object.freeze({
  connect: 1,
  connect_error: 1,
  disconnect: 1,
  disconnecting: 1,
  // EventEmitter reserved events: https://nodejs.org/api/events.html#events_event_newlistener
  newListener: 1,
  removeListener: 1
});
class R6 extends sn {
  /**
   * `Socket` constructor.
   */
  constructor(t, n, r) {
    super(), this.connected = !1, this.recovered = !1, this.receiveBuffer = [], this.sendBuffer = [], this._queue = [], this._queueSeq = 0, this.ids = 0, this.acks = {}, this.flags = {}, this.io = t, this.nsp = n, r && r.auth && (this.auth = r.auth), this._opts = Object.assign({}, r), this.io._autoConnect && this.open();
  }
  /**
   * Whether the socket is currently disconnected
   *
   * @example
   * const socket = io();
   *
   * socket.on("connect", () => {
   *   console.log(socket.disconnected); // false
   * });
   *
   * socket.on("disconnect", () => {
   *   console.log(socket.disconnected); // true
   * });
   */
  get disconnected() {
    return !this.connected;
  }
  /**
   * Subscribe to open, close and packet events
   *
   * @private
   */
  subEvents() {
    if (this.subs)
      return;
    const t = this.io;
    this.subs = [
      Jr(t, "open", this.onopen.bind(this)),
      Jr(t, "packet", this.onpacket.bind(this)),
      Jr(t, "error", this.onerror.bind(this)),
      Jr(t, "close", this.onclose.bind(this))
    ];
  }
  /**
   * Whether the Socket will try to reconnect when its Manager connects or reconnects.
   *
   * @example
   * const socket = io();
   *
   * console.log(socket.active); // true
   *
   * socket.on("disconnect", (reason) => {
   *   if (reason === "io server disconnect") {
   *     // the disconnection was initiated by the server, you need to manually reconnect
   *     console.log(socket.active); // false
   *   }
   *   // else the socket will automatically try to reconnect
   *   console.log(socket.active); // true
   * });
   */
  get active() {
    return !!this.subs;
  }
  /**
   * "Opens" the socket.
   *
   * @example
   * const socket = io({
   *   autoConnect: false
   * });
   *
   * socket.connect();
   */
  connect() {
    return this.connected ? this : (this.subEvents(), this.io._reconnecting || this.io.open(), this.io._readyState === "open" && this.onopen(), this);
  }
  /**
   * Alias for {@link connect()}.
   */
  open() {
    return this.connect();
  }
  /**
   * Sends a `message` event.
   *
   * This method mimics the WebSocket.send() method.
   *
   * @see https://developer.mozilla.org/en-US/docs/Web/API/WebSocket/send
   *
   * @example
   * socket.send("hello");
   *
   * // this is equivalent to
   * socket.emit("message", "hello");
   *
   * @return self
   */
  send(...t) {
    return t.unshift("message"), this.emit.apply(this, t), this;
  }
  /**
   * Override `emit`.
   * If the event is in `events`, it's emitted normally.
   *
   * @example
   * socket.emit("hello", "world");
   *
   * // all serializable datastructures are supported (no need to call JSON.stringify)
   * socket.emit("hello", 1, "2", { 3: ["4"], 5: Uint8Array.from([6]) });
   *
   * // with an acknowledgement from the server
   * socket.emit("hello", "world", (val) => {
   *   // ...
   * });
   *
   * @return self
   */
  emit(t, ...n) {
    if (lq.hasOwnProperty(t))
      throw new Error('"' + t.toString() + '" is a reserved event name');
    if (n.unshift(t), this._opts.retries && !this.flags.fromQueue && !this.flags.volatile)
      return this._addToQueue(n), this;
    const r = {
      type: ut.EVENT,
      data: n
    };
    if (r.options = {}, r.options.compress = this.flags.compress !== !1, typeof n[n.length - 1] == "function") {
      const a = this.ids++, s = n.pop();
      this._registerAckCallback(a, s), r.id = a;
    }
    const i = this.io.engine && this.io.engine.transport && this.io.engine.transport.writable;
    return this.flags.volatile && (!i || !this.connected) || (this.connected ? (this.notifyOutgoingListeners(r), this.packet(r)) : this.sendBuffer.push(r)), this.flags = {}, this;
  }
  /**
   * @private
   */
  _registerAckCallback(t, n) {
    var r;
    const i = (r = this.flags.timeout) !== null && r !== void 0 ? r : this._opts.ackTimeout;
    if (i === void 0) {
      this.acks[t] = n;
      return;
    }
    const o = this.io.setTimeoutFn(() => {
      delete this.acks[t];
      for (let a = 0; a < this.sendBuffer.length; a++)
        this.sendBuffer[a].id === t && this.sendBuffer.splice(a, 1);
      n.call(this, new Error("operation has timed out"));
    }, i);
    this.acks[t] = (...a) => {
      this.io.clearTimeoutFn(o), n.apply(this, [null, ...a]);
    };
  }
  /**
   * Emits an event and waits for an acknowledgement
   *
   * @example
   * // without timeout
   * const response = await socket.emitWithAck("hello", "world");
   *
   * // with a specific timeout
   * try {
   *   const response = await socket.timeout(1000).emitWithAck("hello", "world");
   * } catch (err) {
   *   // the server did not acknowledge the event in the given delay
   * }
   *
   * @return a Promise that will be fulfilled when the server acknowledges the event
   */
  emitWithAck(t, ...n) {
    const r = this.flags.timeout !== void 0 || this._opts.ackTimeout !== void 0;
    return new Promise((i, o) => {
      n.push((a, s) => r ? a ? o(a) : i(s) : i(a)), this.emit(t, ...n);
    });
  }
  /**
   * Add the packet to the queue.
   * @param args
   * @private
   */
  _addToQueue(t) {
    let n;
    typeof t[t.length - 1] == "function" && (n = t.pop());
    const r = {
      id: this._queueSeq++,
      tryCount: 0,
      pending: !1,
      args: t,
      flags: Object.assign({ fromQueue: !0 }, this.flags)
    };
    t.push((i, ...o) => r !== this._queue[0] ? void 0 : (i !== null ? r.tryCount > this._opts.retries && (this._queue.shift(), n && n(i)) : (this._queue.shift(), n && n(null, ...o)), r.pending = !1, this._drainQueue())), this._queue.push(r), this._drainQueue();
  }
  /**
   * Send the first packet of the queue, and wait for an acknowledgement from the server.
   * @param force - whether to resend a packet that has not been acknowledged yet
   *
   * @private
   */
  _drainQueue(t = !1) {
    if (!this.connected || this._queue.length === 0)
      return;
    const n = this._queue[0];
    n.pending && !t || (n.pending = !0, n.tryCount++, this.flags = n.flags, this.emit.apply(this, n.args));
  }
  /**
   * Sends a packet.
   *
   * @param packet
   * @private
   */
  packet(t) {
    t.nsp = this.nsp, this.io._packet(t);
  }
  /**
   * Called upon engine `open`.
   *
   * @private
   */
  onopen() {
    typeof this.auth == "function" ? this.auth((t) => {
      this._sendConnectPacket(t);
    }) : this._sendConnectPacket(this.auth);
  }
  /**
   * Sends a CONNECT packet to initiate the Socket.IO session.
   *
   * @param data
   * @private
   */
  _sendConnectPacket(t) {
    this.packet({
      type: ut.CONNECT,
      data: this._pid ? Object.assign({ pid: this._pid, offset: this._lastOffset }, t) : t
    });
  }
  /**
   * Called upon engine or manager `error`.
   *
   * @param err
   * @private
   */
  onerror(t) {
    this.connected || this.emitReserved("connect_error", t);
  }
  /**
   * Called upon engine `close`.
   *
   * @param reason
   * @param description
   * @private
   */
  onclose(t, n) {
    this.connected = !1, delete this.id, this.emitReserved("disconnect", t, n);
  }
  /**
   * Called with socket packet.
   *
   * @param packet
   * @private
   */
  onpacket(t) {
    if (t.nsp === this.nsp)
      switch (t.type) {
        case ut.CONNECT:
          t.data && t.data.sid ? this.onconnect(t.data.sid, t.data.pid) : this.emitReserved("connect_error", new Error("It seems you are trying to reach a Socket.IO server in v2.x with a v3.x client, but they are not compatible (more information here: https://socket.io/docs/v3/migrating-from-2-x-to-3-0/)"));
          break;
        case ut.EVENT:
        case ut.BINARY_EVENT:
          this.onevent(t);
          break;
        case ut.ACK:
        case ut.BINARY_ACK:
          this.onack(t);
          break;
        case ut.DISCONNECT:
          this.ondisconnect();
          break;
        case ut.CONNECT_ERROR:
          this.destroy();
          const r = new Error(t.data.message);
          r.data = t.data.data, this.emitReserved("connect_error", r);
          break;
      }
  }
  /**
   * Called upon a server event.
   *
   * @param packet
   * @private
   */
  onevent(t) {
    const n = t.data || [];
    t.id != null && n.push(this.ack(t.id)), this.connected ? this.emitEvent(n) : this.receiveBuffer.push(Object.freeze(n));
  }
  emitEvent(t) {
    if (this._anyListeners && this._anyListeners.length) {
      const n = this._anyListeners.slice();
      for (const r of n)
        r.apply(this, t);
    }
    super.emit.apply(this, t), this._pid && t.length && typeof t[t.length - 1] == "string" && (this._lastOffset = t[t.length - 1]);
  }
  /**
   * Produces an ack callback to emit with an event.
   *
   * @private
   */
  ack(t) {
    const n = this;
    let r = !1;
    return function(...i) {
      r || (r = !0, n.packet({
        type: ut.ACK,
        id: t,
        data: i
      }));
    };
  }
  /**
   * Called upon a server acknowlegement.
   *
   * @param packet
   * @private
   */
  onack(t) {
    const n = this.acks[t.id];
    typeof n == "function" && (n.apply(this, t.data), delete this.acks[t.id]);
  }
  /**
   * Called upon server connect.
   *
   * @private
   */
  onconnect(t, n) {
    this.id = t, this.recovered = n && this._pid === n, this._pid = n, this.connected = !0, this.emitBuffered(), this.emitReserved("connect"), this._drainQueue(!0);
  }
  /**
   * Emit buffered events (received and emitted).
   *
   * @private
   */
  emitBuffered() {
    this.receiveBuffer.forEach((t) => this.emitEvent(t)), this.receiveBuffer = [], this.sendBuffer.forEach((t) => {
      this.notifyOutgoingListeners(t), this.packet(t);
    }), this.sendBuffer = [];
  }
  /**
   * Called upon server disconnect.
   *
   * @private
   */
  ondisconnect() {
    this.destroy(), this.onclose("io server disconnect");
  }
  /**
   * Called upon forced client/server side disconnections,
   * this method ensures the manager stops tracking us and
   * that reconnections don't get triggered for this.
   *
   * @private
   */
  destroy() {
    this.subs && (this.subs.forEach((t) => t()), this.subs = void 0), this.io._destroy(this);
  }
  /**
   * Disconnects the socket manually. In that case, the socket will not try to reconnect.
   *
   * If this is the last active Socket instance of the {@link Manager}, the low-level connection will be closed.
   *
   * @example
   * const socket = io();
   *
   * socket.on("disconnect", (reason) => {
   *   // console.log(reason); prints "io client disconnect"
   * });
   *
   * socket.disconnect();
   *
   * @return self
   */
  disconnect() {
    return this.connected && this.packet({ type: ut.DISCONNECT }), this.destroy(), this.connected && this.onclose("io client disconnect"), this;
  }
  /**
   * Alias for {@link disconnect()}.
   *
   * @return self
   */
  close() {
    return this.disconnect();
  }
  /**
   * Sets the compress flag.
   *
   * @example
   * socket.compress(false).emit("hello");
   *
   * @param compress - if `true`, compresses the sending data
   * @return self
   */
  compress(t) {
    return this.flags.compress = t, this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the event message will be dropped when this socket is not
   * ready to send messages.
   *
   * @example
   * socket.volatile.emit("hello"); // the server may or may not receive it
   *
   * @returns self
   */
  get volatile() {
    return this.flags.volatile = !0, this;
  }
  /**
   * Sets a modifier for a subsequent event emission that the callback will be called with an error when the
   * given number of milliseconds have elapsed without an acknowledgement from the server:
   *
   * @example
   * socket.timeout(5000).emit("my-event", (err) => {
   *   if (err) {
   *     // the server did not acknowledge the event in the given delay
   *   }
   * });
   *
   * @returns self
   */
  timeout(t) {
    return this.flags.timeout = t, this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * @example
   * socket.onAny((event, ...args) => {
   *   console.log(`got ${event}`);
   * });
   *
   * @param listener
   */
  onAny(t) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.push(t), this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * @example
   * socket.prependAny((event, ...args) => {
   *   console.log(`got event ${event}`);
   * });
   *
   * @param listener
   */
  prependAny(t) {
    return this._anyListeners = this._anyListeners || [], this._anyListeners.unshift(t), this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`got event ${event}`);
   * }
   *
   * socket.onAny(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAny(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAny();
   *
   * @param listener
   */
  offAny(t) {
    if (!this._anyListeners)
      return this;
    if (t) {
      const n = this._anyListeners;
      for (let r = 0; r < n.length; r++)
        if (t === n[r])
          return n.splice(r, 1), this;
    } else
      this._anyListeners = [];
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAny() {
    return this._anyListeners || [];
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.onAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  onAnyOutgoing(t) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.push(t), this;
  }
  /**
   * Adds a listener that will be fired when any event is emitted. The event name is passed as the first argument to the
   * callback. The listener is added to the beginning of the listeners array.
   *
   * Note: acknowledgements sent to the server are not included.
   *
   * @example
   * socket.prependAnyOutgoing((event, ...args) => {
   *   console.log(`sent event ${event}`);
   * });
   *
   * @param listener
   */
  prependAnyOutgoing(t) {
    return this._anyOutgoingListeners = this._anyOutgoingListeners || [], this._anyOutgoingListeners.unshift(t), this;
  }
  /**
   * Removes the listener that will be fired when any event is emitted.
   *
   * @example
   * const catchAllListener = (event, ...args) => {
   *   console.log(`sent event ${event}`);
   * }
   *
   * socket.onAnyOutgoing(catchAllListener);
   *
   * // remove a specific listener
   * socket.offAnyOutgoing(catchAllListener);
   *
   * // or remove all listeners
   * socket.offAnyOutgoing();
   *
   * @param [listener] - the catch-all listener (optional)
   */
  offAnyOutgoing(t) {
    if (!this._anyOutgoingListeners)
      return this;
    if (t) {
      const n = this._anyOutgoingListeners;
      for (let r = 0; r < n.length; r++)
        if (t === n[r])
          return n.splice(r, 1), this;
    } else
      this._anyOutgoingListeners = [];
    return this;
  }
  /**
   * Returns an array of listeners that are listening for any event that is specified. This array can be manipulated,
   * e.g. to remove listeners.
   */
  listenersAnyOutgoing() {
    return this._anyOutgoingListeners || [];
  }
  /**
   * Notify the listeners for each packet sent
   *
   * @param packet
   *
   * @private
   */
  notifyOutgoingListeners(t) {
    if (this._anyOutgoingListeners && this._anyOutgoingListeners.length) {
      const n = this._anyOutgoingListeners.slice();
      for (const r of n)
        r.apply(this, t.data);
    }
  }
}
function Ws(e) {
  e = e || {}, this.ms = e.min || 100, this.max = e.max || 1e4, this.factor = e.factor || 2, this.jitter = e.jitter > 0 && e.jitter <= 1 ? e.jitter : 0, this.attempts = 0;
}
Ws.prototype.duration = function() {
  var e = this.ms * Math.pow(this.factor, this.attempts++);
  if (this.jitter) {
    var t = Math.random(), n = Math.floor(t * this.jitter * e);
    e = Math.floor(t * 10) & 1 ? e + n : e - n;
  }
  return Math.min(e, this.max) | 0;
};
Ws.prototype.reset = function() {
  this.attempts = 0;
};
Ws.prototype.setMin = function(e) {
  this.ms = e;
};
Ws.prototype.setMax = function(e) {
  this.max = e;
};
Ws.prototype.setJitter = function(e) {
  this.jitter = e;
};
class Vv extends sn {
  constructor(t, n) {
    var r;
    super(), this.nsps = {}, this.subs = [], t && typeof t == "object" && (n = t, t = void 0), n = n || {}, n.path = n.path || "/socket.io", this.opts = n, Sh(this, n), this.reconnection(n.reconnection !== !1), this.reconnectionAttempts(n.reconnectionAttempts || 1 / 0), this.reconnectionDelay(n.reconnectionDelay || 1e3), this.reconnectionDelayMax(n.reconnectionDelayMax || 5e3), this.randomizationFactor((r = n.randomizationFactor) !== null && r !== void 0 ? r : 0.5), this.backoff = new Ws({
      min: this.reconnectionDelay(),
      max: this.reconnectionDelayMax(),
      jitter: this.randomizationFactor()
    }), this.timeout(n.timeout == null ? 2e4 : n.timeout), this._readyState = "closed", this.uri = t;
    const i = n.parser || sq;
    this.encoder = new i.Encoder(), this.decoder = new i.Decoder(), this._autoConnect = n.autoConnect !== !1, this._autoConnect && this.open();
  }
  reconnection(t) {
    return arguments.length ? (this._reconnection = !!t, this) : this._reconnection;
  }
  reconnectionAttempts(t) {
    return t === void 0 ? this._reconnectionAttempts : (this._reconnectionAttempts = t, this);
  }
  reconnectionDelay(t) {
    var n;
    return t === void 0 ? this._reconnectionDelay : (this._reconnectionDelay = t, (n = this.backoff) === null || n === void 0 || n.setMin(t), this);
  }
  randomizationFactor(t) {
    var n;
    return t === void 0 ? this._randomizationFactor : (this._randomizationFactor = t, (n = this.backoff) === null || n === void 0 || n.setJitter(t), this);
  }
  reconnectionDelayMax(t) {
    var n;
    return t === void 0 ? this._reconnectionDelayMax : (this._reconnectionDelayMax = t, (n = this.backoff) === null || n === void 0 || n.setMax(t), this);
  }
  timeout(t) {
    return arguments.length ? (this._timeout = t, this) : this._timeout;
  }
  /**
   * Starts trying to reconnect if reconnection is enabled and we have not
   * started reconnecting yet
   *
   * @private
   */
  maybeReconnectOnOpen() {
    !this._reconnecting && this._reconnection && this.backoff.attempts === 0 && this.reconnect();
  }
  /**
   * Sets the current transport `socket`.
   *
   * @param {Function} fn - optional, callback
   * @return self
   * @public
   */
  open(t) {
    if (~this._readyState.indexOf("open"))
      return this;
    this.engine = new M6(this.uri, this.opts);
    const n = this.engine, r = this;
    this._readyState = "opening", this.skipReconnect = !1;
    const i = Jr(n, "open", function() {
      r.onopen(), t && t();
    }), o = (s) => {
      this.cleanup(), this._readyState = "closed", this.emitReserved("error", s), t ? t(s) : this.maybeReconnectOnOpen();
    }, a = Jr(n, "error", o);
    if (this._timeout !== !1) {
      const s = this._timeout, l = this.setTimeoutFn(() => {
        i(), o(new Error("timeout")), n.close();
      }, s);
      this.opts.autoUnref && l.unref(), this.subs.push(() => {
        this.clearTimeoutFn(l);
      });
    }
    return this.subs.push(i), this.subs.push(a), this;
  }
  /**
   * Alias for open()
   *
   * @return self
   * @public
   */
  connect(t) {
    return this.open(t);
  }
  /**
   * Called upon transport open.
   *
   * @private
   */
  onopen() {
    this.cleanup(), this._readyState = "open", this.emitReserved("open");
    const t = this.engine;
    this.subs.push(Jr(t, "ping", this.onping.bind(this)), Jr(t, "data", this.ondata.bind(this)), Jr(t, "error", this.onerror.bind(this)), Jr(t, "close", this.onclose.bind(this)), Jr(this.decoder, "decoded", this.ondecoded.bind(this)));
  }
  /**
   * Called upon a ping.
   *
   * @private
   */
  onping() {
    this.emitReserved("ping");
  }
  /**
   * Called with data.
   *
   * @private
   */
  ondata(t) {
    try {
      this.decoder.add(t);
    } catch (n) {
      this.onclose("parse error", n);
    }
  }
  /**
   * Called when parser fully decodes a packet.
   *
   * @private
   */
  ondecoded(t) {
    ly(() => {
      this.emitReserved("packet", t);
    }, this.setTimeoutFn);
  }
  /**
   * Called upon socket error.
   *
   * @private
   */
  onerror(t) {
    this.emitReserved("error", t);
  }
  /**
   * Creates a new socket for the given `nsp`.
   *
   * @return {Socket}
   * @public
   */
  socket(t, n) {
    let r = this.nsps[t];
    return r ? this._autoConnect && !r.active && r.connect() : (r = new R6(this, t, n), this.nsps[t] = r), r;
  }
  /**
   * Called upon a socket close.
   *
   * @param socket
   * @private
   */
  _destroy(t) {
    const n = Object.keys(this.nsps);
    for (const r of n)
      if (this.nsps[r].active)
        return;
    this._close();
  }
  /**
   * Writes a packet.
   *
   * @param packet
   * @private
   */
  _packet(t) {
    const n = this.encoder.encode(t);
    for (let r = 0; r < n.length; r++)
      this.engine.write(n[r], t.options);
  }
  /**
   * Clean up transport subscriptions and packet buffer.
   *
   * @private
   */
  cleanup() {
    this.subs.forEach((t) => t()), this.subs.length = 0, this.decoder.destroy();
  }
  /**
   * Close the current socket.
   *
   * @private
   */
  _close() {
    this.skipReconnect = !0, this._reconnecting = !1, this.onclose("forced close"), this.engine && this.engine.close();
  }
  /**
   * Alias for close()
   *
   * @private
   */
  disconnect() {
    return this._close();
  }
  /**
   * Called upon engine close.
   *
   * @private
   */
  onclose(t, n) {
    this.cleanup(), this.backoff.reset(), this._readyState = "closed", this.emitReserved("close", t, n), this._reconnection && !this.skipReconnect && this.reconnect();
  }
  /**
   * Attempt a reconnection.
   *
   * @private
   */
  reconnect() {
    if (this._reconnecting || this.skipReconnect)
      return this;
    const t = this;
    if (this.backoff.attempts >= this._reconnectionAttempts)
      this.backoff.reset(), this.emitReserved("reconnect_failed"), this._reconnecting = !1;
    else {
      const n = this.backoff.duration();
      this._reconnecting = !0;
      const r = this.setTimeoutFn(() => {
        t.skipReconnect || (this.emitReserved("reconnect_attempt", t.backoff.attempts), !t.skipReconnect && t.open((i) => {
          i ? (t._reconnecting = !1, t.reconnect(), this.emitReserved("reconnect_error", i)) : t.onreconnect();
        }));
      }, n);
      this.opts.autoUnref && r.unref(), this.subs.push(() => {
        this.clearTimeoutFn(r);
      });
    }
  }
  /**
   * Called upon successful reconnect.
   *
   * @private
   */
  onreconnect() {
    const t = this.backoff.attempts;
    this._reconnecting = !1, this.backoff.reset(), this.emitReserved("reconnect", t);
  }
}
const Cl = {};
function Xl(e, t) {
  typeof e == "object" && (t = e, e = void 0), t = t || {};
  const n = XG(e, t.path || "/socket.io"), r = n.source, i = n.id, o = n.path, a = Cl[i] && o in Cl[i].nsps, s = t.forceNew || t["force new connection"] || t.multiplex === !1 || a;
  let l;
  return s ? l = new Vv(r, t) : (Cl[i] || (Cl[i] = new Vv(r, t)), l = Cl[i]), n.query && !t.query && (t.query = n.queryKey), l.socket(n.path, t);
}
Object.assign(Xl, {
  Manager: Vv,
  Socket: R6,
  io: Xl,
  connect: Xl
});
let sd;
const cq = new Uint8Array(16);
function uq() {
  if (!sd && (sd = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !sd))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return sd(cq);
}
const Sn = [];
for (let e = 0; e < 256; ++e)
  Sn.push((e + 256).toString(16).slice(1));
function dq(e, t = 0) {
  return (Sn[e[t + 0]] + Sn[e[t + 1]] + Sn[e[t + 2]] + Sn[e[t + 3]] + "-" + Sn[e[t + 4]] + Sn[e[t + 5]] + "-" + Sn[e[t + 6]] + Sn[e[t + 7]] + "-" + Sn[e[t + 8]] + Sn[e[t + 9]] + "-" + Sn[e[t + 10]] + Sn[e[t + 11]] + Sn[e[t + 12]] + Sn[e[t + 13]] + Sn[e[t + 14]] + Sn[e[t + 15]]).toLowerCase();
}
const fq = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto), aE = {
  randomUUID: fq
};
function I6(e, t, n) {
  if (aE.randomUUID && !t && !e)
    return aE.randomUUID();
  e = e || {};
  const r = e.random || (e.rng || uq)();
  if (r[6] = r[6] & 15 | 64, r[8] = r[8] & 63 | 128, t) {
    n = n || 0;
    for (let i = 0; i < 16; ++i)
      t[n + i] = r[i];
    return t;
  }
  return dq(r);
}
const D6 = x.createContext(null);
function hq({
  children: e
}) {
  const [t, n] = x.useState([]);
  return /* @__PURE__ */ x.createElement(
    D6.Provider,
    {
      value: {
        generations: t,
        setGenerations: n
      }
    },
    e
  );
}
function pq() {
  const e = Me(D6);
  if (!e)
    throw new Error(
      "useGenerationsContext must be used within a GenerationsProvider component"
    );
  return e;
}
function mq({
  setActiveSocket: e
}) {
  const { mutate: t } = K1(), { apiUrl: n, token: r } = Dc(), [i, o] = de(null), [a, s] = de(!1), [l, u] = de(!1), { contactUuid: d, context: f, messageType: p } = Ch(), { generations: m, setGenerations: g } = pq(), v = [...m].sort((E, S) => (E.createdAt ?? 0) - (S.createdAt ?? 0)).flatMap((E) => [
    {
      from: "human",
      timestamp: E.createdAt || 0,
      text: E.instruction
    },
    {
      from: "ai",
      timestamp: E.createdAt || 0,
      text: E.generation
    }
  ]), y = De(
    ({
      id: E,
      newData: S,
      prompt: _,
      isStreaming: k = !0,
      createdAt: T = Date.now()
    }) => {
      g((A) => A.find((F) => (F == null ? void 0 : F._id) === E) ? A.map((F) => F._id === E ? {
        ...F,
        generation: `${F.generation}${S || ""}`
      } : F) : [{
        _id: E,
        instruction: _,
        generation: S || "",
        isStreaming: k,
        createdAt: T
      }, ...A]);
    },
    [g]
  ), b = De(
    async (E) => {
      o(null);
      try {
        let S = !0, _ = E.messageType || p;
        E.improveText && (_ = "Improve"), p === "ListingDescription" && !E.messageType && (_ = "Generic"), s(!0);
        const k = I6(), A = `${n || "https://write-a-plumber.brivity.com"}/v1/generations/stream`, R = Xl(A, {
          auth: { token: r },
          timeout: 1e4,
          requestTimeout: 1e4,
          reconnectionAttempts: 3,
          withCredentials: !0,
          transports: ["websocket"]
        });
        R.on("connect", () => {
          e(R), R.emit("payload", {
            ...E,
            context: f,
            leadId: d,
            messageType: _,
            transcript: v
          });
        }), R.on("data", (F) => {
          S && (u(!0), s(!1), S = !1), y({
            id: k,
            prompt: E.userInstruction,
            newData: F
          });
        }), R.on("generation", (F) => {
          u(!1), e(null), g((D) => D.findIndex((W) => W._id === k) === -1 ? [{
            ...F,
            _id: k,
            isStreaming: !1,
            createdAt: Date.now()
          }, ...D] : D.map((W) => W._id === k ? {
            ...W,
            ...F,
            isStreaming: !1
          } : W)), t("/auth/current-user");
        }), R.on("error", (F) => {
          throw R.disconnect(), F;
        }), R.on("disconnect", () => {
          u(!1), s(!1), e(null);
        });
      } catch (S) {
        S instanceof Error ? o(S) : o(new Error("An unknown error occurred"));
      }
    },
    [
      n,
      t,
      g,
      e,
      r,
      y,
      d,
      p,
      v,
      f
    ]
  );
  return {
    generationError: i,
    setGenerationError: o,
    isLoading: a,
    isStreaming: l,
    streamGeneration: b
  };
}
const N6 = ke(
  ({ isOpen: e, className: t, ...n }, r) => /* @__PURE__ */ x.createElement(
    "button",
    {
      className: ie([
        "ai-tw-inline-flex ai-tw-h-fit ai-tw-w-fit ai-tw-items-center ai-tw-gap-1 ai-tw-rounded-full ai-tw-border ai-tw-border-purple-50 ai-tw-px-2 ai-tw-py-1",
        "ai-tw-uppercase ai-tw-button-sm",
        "active:ai-tw-bg-purple-50 active:ai-tw-text-white",
        "hover:ai-tw-outline hover:ai-tw-outline-1 hover:ai-tw-outline-purple-50",
        "disabled:ai-tw-pointer-events-none disabled:ai-tw-opacity-50",
        e ? "ai-tw-bg-purple-50 ai-tw-text-white ai-tw-outline ai-tw-outline-1 ai-tw-outline-purple-50" : "ai-tw-bg-transparent ai-tw-text-purple-50",
        t
      ]),
      ...n,
      ref: r
    },
    /* @__PURE__ */ x.createElement(Le, { icon: Ls }),
    /* @__PURE__ */ x.createElement("span", null, "AI: Help Me Write")
  )
);
N6.displayName = "TriggerButton";
var $6 = Symbol.for("immer-nothing"), sE = Symbol.for("immer-draftable"), yr = Symbol.for("immer-state"), gq = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(e) {
    return `The plugin for '${e}' has not been loaded into Immer. To enable the plugin, import and call \`enable${e}()\` when initializing your application.`;
  },
  function(e) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${e}'`;
  },
  "This object has been frozen and should not be mutated",
  function(e) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + e;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(e) {
    return `'current' expects a draft, got: ${e}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(e) {
    return `'original' expects a draft, got: ${e}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function er(e, ...t) {
  if (process.env.NODE_ENV !== "production") {
    const n = gq[e], r = typeof n == "function" ? n.apply(null, t) : n;
    throw new Error(`[Immer] ${r}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${e}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var Ms = Object.getPrototypeOf;
function Os(e) {
  return !!e && !!e[yr];
}
function ya(e) {
  var t;
  return e ? L6(e) || Array.isArray(e) || !!e[sE] || !!((t = e.constructor) != null && t[sE]) || Ph(e) || kh(e) : !1;
}
var vq = Object.prototype.constructor.toString();
function L6(e) {
  if (!e || typeof e != "object")
    return !1;
  const t = Ms(e);
  if (t === null)
    return !0;
  const n = Object.hasOwnProperty.call(t, "constructor") && t.constructor;
  return n === Object ? !0 : typeof n == "function" && Function.toString.call(n) === vq;
}
function mf(e, t) {
  _h(e) === 0 ? Reflect.ownKeys(e).forEach((n) => {
    t(n, e[n], e);
  }) : e.forEach((n, r) => t(r, n, e));
}
function _h(e) {
  const t = e[yr];
  return t ? t.type_ : Array.isArray(e) ? 1 : Ph(e) ? 2 : kh(e) ? 3 : 0;
}
function Bv(e, t) {
  return _h(e) === 2 ? e.has(t) : Object.prototype.hasOwnProperty.call(e, t);
}
function F6(e, t, n) {
  const r = _h(e);
  r === 2 ? e.set(t, n) : r === 3 ? e.add(n) : e[t] = n;
}
function yq(e, t) {
  return e === t ? e !== 0 || 1 / e === 1 / t : e !== e && t !== t;
}
function Ph(e) {
  return e instanceof Map;
}
function kh(e) {
  return e instanceof Set;
}
function ia(e) {
  return e.copy_ || e.base_;
}
function jv(e, t) {
  if (Ph(e))
    return new Map(e);
  if (kh(e))
    return new Set(e);
  if (Array.isArray(e))
    return Array.prototype.slice.call(e);
  const n = L6(e);
  if (t === !0 || t === "class_only" && !n) {
    const r = Object.getOwnPropertyDescriptors(e);
    delete r[yr];
    let i = Reflect.ownKeys(r);
    for (let o = 0; o < i.length; o++) {
      const a = i[o], s = r[a];
      s.writable === !1 && (s.writable = !0, s.configurable = !0), (s.get || s.set) && (r[a] = {
        configurable: !0,
        writable: !0,
        // could live with !!desc.set as well here...
        enumerable: s.enumerable,
        value: e[a]
      });
    }
    return Object.create(Ms(e), r);
  } else {
    const r = Ms(e);
    if (r !== null && n)
      return { ...e };
    const i = Object.create(r);
    return Object.assign(i, e);
  }
}
function mc(e, t = !1) {
  return Th(e) || Os(e) || !ya(e) || (_h(e) > 1 && (e.set = e.add = e.clear = e.delete = wq), Object.freeze(e), t && Object.entries(e).forEach(([n, r]) => mc(r, !0))), e;
}
function wq() {
  er(2);
}
function Th(e) {
  return Object.isFrozen(e);
}
var bq = {};
function wa(e) {
  const t = bq[e];
  return t || er(0, e), t;
}
var gc;
function z6() {
  return gc;
}
function xq(e, t) {
  return {
    drafts_: [],
    parent_: e,
    immer_: t,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: !0,
    unfinalizedDrafts_: 0
  };
}
function lE(e, t) {
  t && (wa("Patches"), e.patches_ = [], e.inversePatches_ = [], e.patchListener_ = t);
}
function Wv(e) {
  Uv(e), e.drafts_.forEach(Eq), e.drafts_ = null;
}
function Uv(e) {
  e === gc && (gc = e.parent_);
}
function cE(e) {
  return gc = xq(gc, e);
}
function Eq(e) {
  const t = e[yr];
  t.type_ === 0 || t.type_ === 1 ? t.revoke_() : t.revoked_ = !0;
}
function uE(e, t) {
  t.unfinalizedDrafts_ = t.drafts_.length;
  const n = t.drafts_[0];
  return e !== void 0 && e !== n ? (n[yr].modified_ && (Wv(t), er(4)), ya(e) && (e = gf(t, e), t.parent_ || vf(t, e)), t.patches_ && wa("Patches").generateReplacementPatches_(
    n[yr].base_,
    e,
    t.patches_,
    t.inversePatches_
  )) : e = gf(t, n, []), Wv(t), t.patches_ && t.patchListener_(t.patches_, t.inversePatches_), e !== $6 ? e : void 0;
}
function gf(e, t, n) {
  if (Th(t))
    return t;
  const r = t[yr];
  if (!r)
    return mf(
      t,
      (i, o) => dE(e, r, t, i, o, n)
    ), t;
  if (r.scope_ !== e)
    return t;
  if (!r.modified_)
    return vf(e, r.base_, !0), r.base_;
  if (!r.finalized_) {
    r.finalized_ = !0, r.scope_.unfinalizedDrafts_--;
    const i = r.copy_;
    let o = i, a = !1;
    r.type_ === 3 && (o = new Set(i), i.clear(), a = !0), mf(
      o,
      (s, l) => dE(e, r, i, s, l, n, a)
    ), vf(e, i, !1), n && e.patches_ && wa("Patches").generatePatches_(
      r,
      n,
      e.patches_,
      e.inversePatches_
    );
  }
  return r.copy_;
}
function dE(e, t, n, r, i, o, a) {
  if (process.env.NODE_ENV !== "production" && i === n && er(5), Os(i)) {
    const s = o && t && t.type_ !== 3 && // Set objects are atomic since they have no keys.
    !Bv(t.assigned_, r) ? o.concat(r) : void 0, l = gf(e, i, s);
    if (F6(n, r, l), Os(l))
      e.canAutoFreeze_ = !1;
    else
      return;
  } else
    a && n.add(i);
  if (ya(i) && !Th(i)) {
    if (!e.immer_.autoFreeze_ && e.unfinalizedDrafts_ < 1)
      return;
    gf(e, i), (!t || !t.scope_.parent_) && typeof r != "symbol" && Object.prototype.propertyIsEnumerable.call(n, r) && vf(e, i);
  }
}
function vf(e, t, n = !1) {
  !e.parent_ && e.immer_.autoFreeze_ && e.canAutoFreeze_ && mc(t, n);
}
function Cq(e, t) {
  const n = Array.isArray(e), r = {
    type_: n ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: t ? t.scope_ : z6(),
    // True for both shallow and deep changes.
    modified_: !1,
    // Used during finalization.
    finalized_: !1,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: t,
    // The base state.
    base_: e,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: !1
  };
  let i = r, o = dy;
  n && (i = [r], o = vc);
  const { revoke: a, proxy: s } = Proxy.revocable(i, o);
  return r.draft_ = s, r.revoke_ = a, s;
}
var dy = {
  get(e, t) {
    if (t === yr)
      return e;
    const n = ia(e);
    if (!Bv(n, t))
      return Sq(e, n, t);
    const r = n[t];
    return e.finalized_ || !ya(r) ? r : r === ng(e.base_, t) ? (rg(e), e.copy_[t] = Gv(r, e)) : r;
  },
  has(e, t) {
    return t in ia(e);
  },
  ownKeys(e) {
    return Reflect.ownKeys(ia(e));
  },
  set(e, t, n) {
    const r = V6(ia(e), t);
    if (r != null && r.set)
      return r.set.call(e.draft_, n), !0;
    if (!e.modified_) {
      const i = ng(ia(e), t), o = i == null ? void 0 : i[yr];
      if (o && o.base_ === n)
        return e.copy_[t] = n, e.assigned_[t] = !1, !0;
      if (yq(n, i) && (n !== void 0 || Bv(e.base_, t)))
        return !0;
      rg(e), Hv(e);
    }
    return e.copy_[t] === n && // special case: handle new props with value 'undefined'
    (n !== void 0 || t in e.copy_) || // special case: NaN
    Number.isNaN(n) && Number.isNaN(e.copy_[t]) || (e.copy_[t] = n, e.assigned_[t] = !0), !0;
  },
  deleteProperty(e, t) {
    return ng(e.base_, t) !== void 0 || t in e.base_ ? (e.assigned_[t] = !1, rg(e), Hv(e)) : delete e.assigned_[t], e.copy_ && delete e.copy_[t], !0;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(e, t) {
    const n = ia(e), r = Reflect.getOwnPropertyDescriptor(n, t);
    return r && {
      writable: !0,
      configurable: e.type_ !== 1 || t !== "length",
      enumerable: r.enumerable,
      value: n[t]
    };
  },
  defineProperty() {
    er(11);
  },
  getPrototypeOf(e) {
    return Ms(e.base_);
  },
  setPrototypeOf() {
    er(12);
  }
}, vc = {};
mf(dy, (e, t) => {
  vc[e] = function() {
    return arguments[0] = arguments[0][0], t.apply(this, arguments);
  };
});
vc.deleteProperty = function(e, t) {
  return process.env.NODE_ENV !== "production" && isNaN(parseInt(t)) && er(13), vc.set.call(this, e, t, void 0);
};
vc.set = function(e, t, n) {
  return process.env.NODE_ENV !== "production" && t !== "length" && isNaN(parseInt(t)) && er(14), dy.set.call(this, e[0], t, n, e[0]);
};
function ng(e, t) {
  const n = e[yr];
  return (n ? ia(n) : e)[t];
}
function Sq(e, t, n) {
  var i;
  const r = V6(t, n);
  return r ? "value" in r ? r.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (i = r.get) == null ? void 0 : i.call(e.draft_)
  ) : void 0;
}
function V6(e, t) {
  if (!(t in e))
    return;
  let n = Ms(e);
  for (; n; ) {
    const r = Object.getOwnPropertyDescriptor(n, t);
    if (r)
      return r;
    n = Ms(n);
  }
}
function Hv(e) {
  e.modified_ || (e.modified_ = !0, e.parent_ && Hv(e.parent_));
}
function rg(e) {
  e.copy_ || (e.copy_ = jv(
    e.base_,
    e.scope_.immer_.useStrictShallowCopy_
  ));
}
var _q = class {
  constructor(e) {
    this.autoFreeze_ = !0, this.useStrictShallowCopy_ = !1, this.produce = (t, n, r) => {
      if (typeof t == "function" && typeof n != "function") {
        const o = n;
        n = t;
        const a = this;
        return function(l = o, ...u) {
          return a.produce(l, (d) => n.call(this, d, ...u));
        };
      }
      typeof n != "function" && er(6), r !== void 0 && typeof r != "function" && er(7);
      let i;
      if (ya(t)) {
        const o = cE(this), a = Gv(t, void 0);
        let s = !0;
        try {
          i = n(a), s = !1;
        } finally {
          s ? Wv(o) : Uv(o);
        }
        return lE(o, r), uE(i, o);
      } else if (!t || typeof t != "object") {
        if (i = n(t), i === void 0 && (i = t), i === $6 && (i = void 0), this.autoFreeze_ && mc(i, !0), r) {
          const o = [], a = [];
          wa("Patches").generateReplacementPatches_(t, i, o, a), r(o, a);
        }
        return i;
      } else
        er(1, t);
    }, this.produceWithPatches = (t, n) => {
      if (typeof t == "function")
        return (a, ...s) => this.produceWithPatches(a, (l) => t(l, ...s));
      let r, i;
      return [this.produce(t, n, (a, s) => {
        r = a, i = s;
      }), r, i];
    }, typeof (e == null ? void 0 : e.autoFreeze) == "boolean" && this.setAutoFreeze(e.autoFreeze), typeof (e == null ? void 0 : e.useStrictShallowCopy) == "boolean" && this.setUseStrictShallowCopy(e.useStrictShallowCopy);
  }
  createDraft(e) {
    ya(e) || er(8), Os(e) && (e = Pq(e));
    const t = cE(this), n = Gv(e, void 0);
    return n[yr].isManual_ = !0, Uv(t), n;
  }
  finishDraft(e, t) {
    const n = e && e[yr];
    (!n || !n.isManual_) && er(9);
    const { scope_: r } = n;
    return lE(r, t), uE(void 0, r);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(e) {
    this.autoFreeze_ = e;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(e) {
    this.useStrictShallowCopy_ = e;
  }
  applyPatches(e, t) {
    let n;
    for (n = t.length - 1; n >= 0; n--) {
      const i = t[n];
      if (i.path.length === 0 && i.op === "replace") {
        e = i.value;
        break;
      }
    }
    n > -1 && (t = t.slice(n + 1));
    const r = wa("Patches").applyPatches_;
    return Os(e) ? r(e, t) : this.produce(
      e,
      (i) => r(i, t)
    );
  }
};
function Gv(e, t) {
  const n = Ph(e) ? wa("MapSet").proxyMap_(e, t) : kh(e) ? wa("MapSet").proxySet_(e, t) : Cq(e, t);
  return (t ? t.scope_ : z6()).drafts_.push(n), n;
}
function Pq(e) {
  return Os(e) || er(10, e), B6(e);
}
function B6(e) {
  if (!ya(e) || Th(e))
    return e;
  const t = e[yr];
  let n;
  if (t) {
    if (!t.modified_)
      return t.base_;
    t.finalized_ = !0, n = jv(e, t.scope_.immer_.useStrictShallowCopy_);
  } else
    n = jv(e, !0);
  return mf(n, (r, i) => {
    F6(n, r, B6(i));
  }), t && (t.finalized_ = !1), n;
}
var wr = new _q(), j6 = wr.produce;
wr.produceWithPatches.bind(
  wr
);
wr.setAutoFreeze.bind(wr);
wr.setUseStrictShallowCopy.bind(wr);
wr.applyPatches.bind(wr);
wr.createDraft.bind(wr);
wr.finishDraft.bind(wr);
function kq(e) {
  var t = de(function() {
    return mc(typeof e == "function" ? e() : e, !0);
  }), n = t[1];
  return [t[0], De(function(r) {
    n(typeof r == "function" ? j6(r) : mc(r));
  }, [])];
}
function fE(e, t, n) {
  var r = Lt(function() {
    return j6(e);
  }, [e]);
  return Yf(r, t, n);
}
const W6 = x.createContext(null);
function Tq({
  children: e
}) {
  const [t, n] = x.useState(0), [r, i] = kq(
    []
  ), [o, a] = x.useState(null);
  function s(d) {
    a(d), i(
      d != null && d.fields ? d.fields.map((f) => ({
        ...f,
        inputValue: ""
      })) : []
    );
  }
  const l = De(
    (d, f) => {
      i((p) => {
        p[t].inputValue = d, f && (p[t].data = f);
      });
    },
    [t, i]
  ), u = () => {
    n(0), i([]), a(null);
  };
  return /* @__PURE__ */ x.createElement(
    W6.Provider,
    {
      value: {
        clearFields: u,
        currentField: t,
        setCurrentField: n,
        fieldInputValues: r,
        setCurrentFieldValue: l,
        selectedInstruction: o,
        setInstruction: s
      }
    },
    e
  );
}
function Aq() {
  const e = Me(W6);
  if (!e)
    throw new Error(
      "useInstructionsContext must be used within a InstructionsProvider component"
    );
  return e;
}
const U6 = x.createContext(
  null
);
function Mq({
  children: e
}) {
  const [t, n] = x.useState("");
  return /* @__PURE__ */ x.createElement(
    U6.Provider,
    {
      value: {
        userPrompt: t,
        setUserPrompt: n
      }
    },
    e
  );
}
function Oq() {
  const e = Me(U6);
  if (!e)
    throw new Error(
      "useUserPromptContext must be used within a UserPromptProvider component"
    );
  return e;
}
function Rq() {
  const [e, t] = de(null), [n, r] = de(null), [i, o] = de(""), [a, s] = de(null), { textareaId: l, tinyMceDocument: u } = Ch(), [d, f] = de("");
  return be(() => {
    (i == null ? void 0 : i.length) > 0 && f(i);
  }, [i]), be(() => {
    if (u)
      return;
    function p() {
      const m = document.getSelection(), g = m == null ? void 0 : m.toString().trim();
      if (g && g.length < 10) {
        o(""), s(null);
        return;
      }
      const v = document.activeElement;
      if (v.classList.contains("prompt-input") || v.id !== l)
        return;
      v.isSameNode(e) || (t(v), r(v.getBoundingClientRect()));
      const y = Iq(v);
      s(y), o(g ?? "");
    }
    return document.addEventListener("selectionchange", p), () => {
      document.removeEventListener("selectionchange", p);
    };
  }, [e, l, u]), be(() => {
    if (!u)
      return;
    function p() {
      var S, _;
      if (!u)
        return;
      const m = u.getSelection(), g = m == null ? void 0 : m.toString().trim();
      if (g && (g == null ? void 0 : g.length) < 10) {
        o(""), s(null);
        return;
      }
      const v = (S = u.defaultView) == null ? void 0 : S.frameElement, y = v == null ? void 0 : v.getBoundingClientRect();
      (_ = u.activeElement) != null && _.isSameNode(e) || (t(u.activeElement), r(y ?? null));
      const b = m == null ? void 0 : m.getRangeAt(0), E = b == null ? void 0 : b.getBoundingClientRect();
      s(E ?? null), o(g ?? "");
    }
    return u.addEventListener("selectionchange", p), () => {
      u.removeEventListener(
        "selectionchange",
        p
      );
    };
  }, [u, e]), {
    activeElement: e,
    portalPosition: n,
    textSelection: i,
    lastNonEmptySelection: d,
    textPosition: a,
    setTextPosition: s
  };
}
function Iq(e) {
  let t = 0, n = 0, r = "";
  if (e instanceof HTMLTextAreaElement)
    t = e.selectionStart, n = e.selectionEnd, r = e.value;
  else {
    const k = document.getSelection();
    t = (k == null ? void 0 : k.anchorOffset) ?? 0, n = (k == null ? void 0 : k.focusOffset) ?? 0, r = e.textContent ?? "";
  }
  const { width: i, height: o } = e.getBoundingClientRect();
  let a = "white-space:pre-wrap";
  const s = [
    "direction",
    "font-family",
    "font-size",
    "font-size-adjust",
    "font-variant",
    "font-weight",
    "font-style",
    "letter-spacing",
    "line-height",
    "text-align",
    "text-indent",
    "text-transform",
    "word-wrap",
    "word-spacing"
  ], l = _("padding-top"), u = _("padding-left"), d = _("padding-right");
  let f = l;
  f += _("border-top-width");
  let p = u;
  p += _("border-left-width");
  for (let k = 0; k < s.length; k++) {
    const T = s[k];
    a += T + ":" + S(T) + ";";
  }
  const m = r.length, g = document.createElement("div");
  t > 0 && E(0, t);
  const v = E(t, n);
  m > n && E(n, m), g.style.cssText = a, g.style.position = "fixed", g.style.top = f + "px", g.style.left = p + "px", g.style.width = i - u - d + "px", g.style.height = o + "px", document.body.appendChild(g);
  let y = v.getBoundingClientRect().bottom;
  const b = v.getBoundingClientRect().left;
  return y > g.offsetTop + g.offsetHeight && (y = g.offsetTop + g.offsetHeight), document.body.removeChild(g), {
    ...v.getBoundingClientRect(),
    left: b,
    bottom: y
  };
  function E(k, T) {
    const A = document.createElement("span");
    return A.style.cssText = a, A.textContent = r.substring(k, T), g.appendChild(A), A;
  }
  function S(k) {
    var A;
    return (A = document.defaultView) == null ? void 0 : A.getComputedStyle(e, null).getPropertyValue(k);
  }
  function _(k) {
    var A;
    const T = (A = document.defaultView) == null ? void 0 : A.getComputedStyle(e, null).getPropertyValue(k);
    return parseFloat(T || "0");
  }
}
const Dq = iS(() => import("./Content-fb66d890.js"));
function Nq() {
  return /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-w-max ai-tw-items-center ai-tw-gap-2 ai-tw-px-1 ai-tw-py-0.5 ai-tw-text-destructive" }, /* @__PURE__ */ x.createElement(Le, { icon: to }), /* @__PURE__ */ x.createElement("span", null, "Error loading AI"));
}
function dye({
  align: e = "end",
  contactUuid: t,
  context: n,
  messageType: r = "SMS",
  mlsIds: i = [],
  onInsertClick: o,
  side: a = "bottom",
  textareaId: s,
  tinyMceDocument: l
}) {
  return /* @__PURE__ */ x.createElement(Do, { fallback: /* @__PURE__ */ x.createElement(Nq, null) }, /* @__PURE__ */ x.createElement(
    mG,
    {
      value: {
        contactUuid: t,
        context: n,
        messageType: r,
        mlsIds: i,
        textareaId: s,
        tinyMceDocument: l
      }
    },
    /* @__PURE__ */ x.createElement(Tq, null, /* @__PURE__ */ x.createElement(Mq, null, /* @__PURE__ */ x.createElement(hq, null, /* @__PURE__ */ x.createElement(
      Lq,
      {
        align: e,
        side: a,
        onInsertClick: o
      }
    ))))
  ));
}
const $q = x.createContext(null);
function Lq({
  align: e,
  side: t,
  onInsertClick: n
}) {
  const r = x.useRef(document.body), i = x.useRef(null), [o, a] = de(null), [s, l] = de(!1), [u, d] = de(!1), { fieldInputValues: f, selectedInstruction: p, setInstruction: m } = Aq(), { setSource: g, messageType: v } = Ch(), { data: y } = fG(), { setUserPrompt: b } = Oq(), {
    activeElement: E,
    portalPosition: S,
    textSelection: _,
    lastNonEmptySelection: k,
    textPosition: T,
    setTextPosition: A
  } = Rq();
  function R(q) {
    u || d(!0), g("improve"), B({
      improveText: k,
      userInstruction: q
    });
  }
  const {
    generationError: F,
    setGenerationError: D,
    isLoading: W,
    isStreaming: L,
    streamGeneration: z
  } = mq({ setActiveSocket: a });
  async function B(q) {
    let Z = q.userInstruction;
    if ((f == null ? void 0 : f.length) > 0) {
      const O = f.map(
        (Q) => `${Q.placeholder} ${Q.inputValue}`
      );
      Z = `${p == null ? void 0 : p.value}: ${O.join(
        " - "
      )}`;
    }
    l(!1), b(""), m(null), A(null), await z({
      ...q,
      userInstruction: Z,
      fields: f,
      messageType: p == null ? void 0 : p.messageType
    });
  }
  const G = pU();
  function H(q) {
    G.start(q);
  }
  function J() {
    if (y != null && y.length && v === "ListingDescription") {
      const q = y.map((Z) => Z.instructions).flat().find(
        (Z) => Z.value === "Write a listing description"
      );
      m(q ?? null);
    }
  }
  return /* @__PURE__ */ x.createElement("div", { className: "ai-tw-preflight" }, /* @__PURE__ */ x.createElement(
    wG,
    {
      activeElement: E,
      portalPosition: S,
      textPosition: T,
      textSelection: _,
      handleImproveClick: R
    }
  ), /* @__PURE__ */ x.createElement(
    l_,
    {
      open: u,
      onOpenChange: () => {
        d((q) => !q), g("library"), J();
      }
    },
    /* @__PURE__ */ x.createElement(c_, { asChild: !0 }, /* @__PURE__ */ x.createElement(N6, { isOpen: u })),
    /* @__PURE__ */ x.createElement(u_, null, /* @__PURE__ */ x.createElement(
      w1,
      {
        className: "ai-tw-preflight",
        asChild: !0,
        sideOffset: 8,
        align: e,
        side: t,
        onInteractOutside: (q) => q.preventDefault(),
        onOpenAutoFocus: (q) => {
          q.preventDefault(), i.current && i.current.focus();
        }
      },
      /* @__PURE__ */ x.createElement(
        mn.div,
        {
          drag: !0,
          dragControls: G,
          dragListener: !1,
          dragConstraints: r,
          dragMomentum: !1,
          className: ie(
            "ai-tw-z-[5000] ai-tw-h-[400px] ai-tw-w-[520px] ai-tw-overflow-hidden ai-tw-rounded-xl ai-tw-bg-background ai-tw-text-sm ai-tw-text-foreground",
            "ai-tw-animate-in ai-tw-fade-in-0 data-[side=bottom]:ai-tw-slide-in-from-top-4 data-[side=top]:ai-tw-slide-in-from-bottom-4",
            "ai-tw-shadow-purple"
          )
        },
        /* @__PURE__ */ x.createElement(oS, { fallback: /* @__PURE__ */ x.createElement(pG, null) }, /* @__PURE__ */ x.createElement(
          $q.Provider,
          {
            value: {
              addGeneration: B,
              promptInputRef: i,
              generationError: F,
              setGenerationError: D,
              isStreaming: L,
              isStreamLoading: W,
              streamGeneration: z
            }
          },
          /* @__PURE__ */ x.createElement(
            Dq,
            {
              activeSocket: o,
              isLibraryOpen: s,
              onInsertClick: n,
              setIsLibraryOpen: l,
              startDrag: H
            }
          )
        )),
        /* @__PURE__ */ x.createElement(Dz, { asChild: !0 }, /* @__PURE__ */ x.createElement(
          G1,
          {
            className: "ai-tw-absolute ai-tw-right-3 ai-tw-top-3 focus-visible:ai-tw-ring-stroke-ai-light",
            onClick: () => A(null)
          },
          /* @__PURE__ */ x.createElement(Le, { icon: i1 })
        ))
      )
    ))
  ));
}
function yf({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ C.createElement(
    "div",
    {
      className: ie(
        "ai-tw-h-5 ai-tw-w-full ai-tw-animate-pulse ai-tw-rounded-md ai-tw-bg-muted",
        e
      ),
      ...t
    }
  );
}
const Fq = iS(() => import("./AiSummaryContent-e621fbfc.js"));
function fye({
  leadPersonUuid: e,
  variant: t = "stand-alone",
  allowAddAI: n = !0
}) {
  return /* @__PURE__ */ x.createElement(Do, { fallback: /* @__PURE__ */ x.createElement(zq, null) }, /* @__PURE__ */ x.createElement("div", { className: "ai-tw-preflight" }, /* @__PURE__ */ x.createElement(oS, { fallback: /* @__PURE__ */ x.createElement(Vq, null) }, /* @__PURE__ */ x.createElement(
    Fq,
    {
      leadPersonUuid: e,
      variant: t,
      allowAddAI: n
    }
  ))));
}
function zq() {
  return /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-w-max ai-tw-items-center ai-tw-gap-2 ai-tw-p-1 ai-tw-text-stroke-critical-dark" }, /* @__PURE__ */ x.createElement(Le, { icon: to }), /* @__PURE__ */ x.createElement("span", null, "Error Loading AI Summary"));
}
function Vq() {
  return /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-flex-wrap ai-tw-items-center ai-tw-justify-between ai-tw-gap-3 ai-tw-border-b ai-tw-border-t-2 ai-tw-border-stroke-primary ai-tw-bg-white ai-tw-px-6 ai-tw-py-2" }, /* @__PURE__ */ x.createElement(yf, { className: "ai-tw-h-7 ai-tw-w-40" }), /* @__PURE__ */ x.createElement(yf, { className: "ai-tw-h-7 ai-tw-w-60" }));
}
const Bq = $r(
  ["ai-tw-border-none ai-tw-bg-transparent ai-tw-bg-none ai-tw-uppercase"],
  {
    variants: {
      variant: {
        ai: [
          "ai-tw-text-purple-50",
          "hover:enabled:ai-tw-text-purple-60 active:enabled:ai-tw-text-purple-70",
          "disabled:ai-tw-text-purple-30"
        ],
        destructive: [
          "ai-tw-text-stroke-critical-dark",
          "hover:enabled:ai-tw-text-content-critical-dark active:enabled:ai-tw-text-content-critical-dark",
          "disabled:ai-tw-text-stroke-critical-lightest"
        ],
        "destructive-grey": [
          "ai-tw-text-content-primary-light",
          "hover:enabled:ai-tw-text-content-critical-dark active:enabled:ai-tw-text-content-critical-dark",
          "disabled:ai-tw-text-content-primary-disabled"
        ],
        primary: [
          "ai-tw-text-content-brand",
          "hover:ai-tw-text-content-brand-dark active:ai-tw-text-content-brand-dark",
          "disabled:ai-tw-text-content-brand-disabled"
        ],
        "on-color": [
          "ai-tw-text-content-on-color",
          "hover:ai-tw-text-content-on-color active:ai-tw-text-content-on-color",
          "disabled:ai-tw-text-content-on-color"
        ]
      },
      size: {
        md: "ai-tw-text-sm ai-tw-button-md",
        sm: "ai-tw-text-xs ai-tw-button-sm"
      }
    }
  }
), wf = ke(
  ({ children: e, className: t = "", variant: n = "primary", size: r = "md", ...i }, o) => /* @__PURE__ */ x.createElement(
    "button",
    {
      className: ie(Bq({ variant: n, size: r }), t),
      ...i,
      ref: o
    },
    e
  )
);
wf.displayName = "ButtonText";
const H6 = "Dialog", [G6, hye] = rr(H6), [jq, ci] = G6(H6), Wq = (e) => {
  const { __scopeDialog: t, children: n, open: r, defaultOpen: i, onOpenChange: o, modal: a = !0 } = e, s = me(null), l = me(null), [u = !1, d] = li({
    prop: r,
    defaultProp: i,
    onChange: o
  });
  return /* @__PURE__ */ X(jq, {
    scope: t,
    triggerRef: s,
    contentRef: l,
    contentId: ti(),
    titleId: ti(),
    descriptionId: ti(),
    open: u,
    onOpenChange: d,
    onOpenToggle: De(
      () => d(
        (f) => !f
      ),
      [
        d
      ]
    ),
    modal: a
  }, n);
}, Uq = "DialogTrigger", Hq = /* @__PURE__ */ ke((e, t) => {
  const { __scopeDialog: n, ...r } = e, i = ci(Uq, n), o = Ft(t, i.triggerRef);
  return /* @__PURE__ */ X(rt.button, ge({
    type: "button",
    "aria-haspopup": "dialog",
    "aria-expanded": i.open,
    "aria-controls": i.contentId,
    "data-state": fy(i.open)
  }, r, {
    ref: o,
    onClick: $e(e.onClick, i.onOpenToggle)
  }));
}), q6 = "DialogPortal", [Gq, Y6] = G6(q6, {
  forceMount: void 0
}), qq = (e) => {
  const { __scopeDialog: t, forceMount: n, children: r, container: i } = e, o = ci(q6, t);
  return /* @__PURE__ */ X(Gq, {
    scope: t,
    forceMount: n
  }, Ui.map(
    r,
    (a) => /* @__PURE__ */ X(On, {
      present: n || o.open
    }, /* @__PURE__ */ X(oh, {
      asChild: !0,
      container: i
    }, a))
  ));
}, qv = "DialogOverlay", Yq = /* @__PURE__ */ ke((e, t) => {
  const n = Y6(qv, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = ci(qv, e.__scopeDialog);
  return o.modal ? /* @__PURE__ */ X(On, {
    present: r || o.open
  }, /* @__PURE__ */ X(Kq, ge({}, i, {
    ref: t
  }))) : null;
}), Kq = /* @__PURE__ */ ke((e, t) => {
  const { __scopeDialog: n, ...r } = e, i = ci(qv, n);
  return (
    // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
    // ie. when `Overlay` and `Content` are siblings
    /* @__PURE__ */ X(y1, {
      as: qi,
      allowPinchZoom: !0,
      shards: [
        i.contentRef
      ]
    }, /* @__PURE__ */ X(rt.div, ge({
      "data-state": fy(i.open)
    }, r, {
      ref: t,
      style: {
        pointerEvents: "auto",
        ...r.style
      }
    })))
  );
}), yc = "DialogContent", Xq = /* @__PURE__ */ ke((e, t) => {
  const n = Y6(yc, e.__scopeDialog), { forceMount: r = n.forceMount, ...i } = e, o = ci(yc, e.__scopeDialog);
  return /* @__PURE__ */ X(On, {
    present: r || o.open
  }, o.modal ? /* @__PURE__ */ X(Zq, ge({}, i, {
    ref: t
  })) : /* @__PURE__ */ X(Qq, ge({}, i, {
    ref: t
  })));
}), Zq = /* @__PURE__ */ ke((e, t) => {
  const n = ci(yc, e.__scopeDialog), r = me(null), i = Ft(t, n.contentRef, r);
  return be(() => {
    const o = r.current;
    if (o)
      return ah(o);
  }, []), /* @__PURE__ */ X(K6, ge({}, e, {
    ref: i,
    trapFocus: n.open,
    disableOutsidePointerEvents: !0,
    onCloseAutoFocus: $e(e.onCloseAutoFocus, (o) => {
      var a;
      o.preventDefault(), (a = n.triggerRef.current) === null || a === void 0 || a.focus();
    }),
    onPointerDownOutside: $e(e.onPointerDownOutside, (o) => {
      const a = o.detail.originalEvent, s = a.button === 0 && a.ctrlKey === !0;
      (a.button === 2 || s) && o.preventDefault();
    }),
    onFocusOutside: $e(
      e.onFocusOutside,
      (o) => o.preventDefault()
    )
  }));
}), Qq = /* @__PURE__ */ ke((e, t) => {
  const n = ci(yc, e.__scopeDialog), r = me(!1), i = me(!1);
  return /* @__PURE__ */ X(K6, ge({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    onCloseAutoFocus: (o) => {
      var a;
      if ((a = e.onCloseAutoFocus) === null || a === void 0 || a.call(e, o), !o.defaultPrevented) {
        var s;
        r.current || (s = n.triggerRef.current) === null || s === void 0 || s.focus(), o.preventDefault();
      }
      r.current = !1, i.current = !1;
    },
    onInteractOutside: (o) => {
      var a, s;
      (a = e.onInteractOutside) === null || a === void 0 || a.call(e, o), o.defaultPrevented || (r.current = !0, o.detail.originalEvent.type === "pointerdown" && (i.current = !0));
      const l = o.target;
      ((s = n.triggerRef.current) === null || s === void 0 ? void 0 : s.contains(l)) && o.preventDefault(), o.detail.originalEvent.type === "focusin" && i.current && o.preventDefault();
    }
  }));
}), K6 = /* @__PURE__ */ ke((e, t) => {
  const { __scopeDialog: n, trapFocus: r, onOpenAutoFocus: i, onCloseAutoFocus: o, ...a } = e, s = ci(yc, n), l = me(null), u = Ft(t, l);
  return o1(), /* @__PURE__ */ X(t1, null, /* @__PURE__ */ X(a1, {
    asChild: !0,
    loop: !0,
    trapped: r,
    onMountAutoFocus: i,
    onUnmountAutoFocus: o
  }, /* @__PURE__ */ X(eh, ge({
    role: "dialog",
    id: s.contentId,
    "aria-describedby": s.descriptionId,
    "aria-labelledby": s.titleId,
    "data-state": fy(s.open)
  }, a, {
    ref: u,
    onDismiss: () => s.onOpenChange(!1)
  }))), !1);
}), Jq = "DialogTitle", eY = /* @__PURE__ */ ke((e, t) => {
  const { __scopeDialog: n, ...r } = e, i = ci(Jq, n);
  return /* @__PURE__ */ X(rt.h2, ge({
    id: i.titleId
  }, r, {
    ref: t
  }));
}), tY = "DialogDescription", nY = /* @__PURE__ */ ke((e, t) => {
  const { __scopeDialog: n, ...r } = e, i = ci(tY, n);
  return /* @__PURE__ */ X(rt.p, ge({
    id: i.descriptionId
  }, r, {
    ref: t
  }));
}), rY = "DialogClose", iY = /* @__PURE__ */ ke((e, t) => {
  const { __scopeDialog: n, ...r } = e, i = ci(rY, n);
  return /* @__PURE__ */ X(rt.button, ge({
    type: "button"
  }, r, {
    ref: t,
    onClick: $e(
      e.onClick,
      () => i.onOpenChange(!1)
    )
  }));
});
function fy(e) {
  return e ? "open" : "closed";
}
const X6 = Wq, oY = Hq, aY = qq, hy = Yq, py = Xq, my = eY, gy = nY, Z6 = iY, vy = X6, pye = oY, sY = aY, Yv = Z6, Q6 = C.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ C.createElement(
  hy,
  {
    ref: n,
    className: ie(
      "ai-tw- ai-tw-fixed ai-tw-inset-0 ai-tw-z-[1200] ai-tw-bg-black/40 data-[state=open]:ai-tw-animate-in data-[state=closed]:ai-tw-animate-out data-[state=closed]:ai-tw-fade-out-0 data-[state=open]:ai-tw-fade-in-0",
      e
    ),
    ...t
  }
));
Q6.displayName = hy.displayName;
const Ah = C.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ C.createElement(sY, null, /* @__PURE__ */ C.createElement(Q6, null), /* @__PURE__ */ C.createElement(
  py,
  {
    ref: r,
    className: ie(
      "ai-tw-preflight",
      "ai-tw-fixed ai-tw-left-[50%] ai-tw-top-[50%] ai-tw-z-[1200] ai-tw-grid ai-tw-max-h-screen ai-tw-w-screen ai-tw-max-w-xl ai-tw-translate-x-[-50%] ai-tw-translate-y-[-50%] ai-tw-gap-4 ai-tw-overflow-auto ai-tw-rounded-lg ai-tw-bg-background ai-tw-p-8 ai-tw-text-foreground ai-tw-shadow-modal ai-tw-duration-200 data-[state=open]:ai-tw-animate-in data-[state=closed]:ai-tw-animate-out data-[state=closed]:ai-tw-fade-out-0 data-[state=open]:ai-tw-fade-in-0 data-[state=closed]:ai-tw-zoom-out-95 data-[state=open]:ai-tw-zoom-in-95 data-[state=closed]:ai-tw-slide-out-to-left-1/2 data-[state=closed]:ai-tw-slide-out-to-top-[48%] data-[state=open]:ai-tw-slide-in-from-left-1/2 data-[state=open]:ai-tw-slide-in-from-top-[48%]",
      e
    ),
    ...n
  },
  t,
  /* @__PURE__ */ C.createElement(
    Z6,
    {
      asChild: !0,
      className: "ai-tw-absolute ai-tw-right-8 ai-tw-top-8 disabled:ai-tw-pointer-events-none data-[state=open]:ai-tw-bg-accent data-[state=open]:ai-tw-text-muted-foreground"
    },
    /* @__PURE__ */ C.createElement(Xt, { size: "icon", variant: "tertiary" }, /* @__PURE__ */ C.createElement(Le, { icon: i1 }), /* @__PURE__ */ C.createElement("span", { className: "ai-tw-sr-only" }, "Close"))
  )
)));
Ah.displayName = py.displayName;
const yy = ({
  className: e,
  ...t
}) => /* @__PURE__ */ C.createElement(
  "div",
  {
    className: ie(
      "ai-tw-flex ai-tw-flex-col ai-tw-space-y-1.5 ai-tw-text-center sm:ai-tw-text-left",
      e
    ),
    ...t
  }
);
yy.displayName = "DialogHeader";
const lY = ({
  className: e,
  ...t
}) => /* @__PURE__ */ C.createElement(
  "div",
  {
    className: ie(
      "ai-tw-flex ai-tw-flex-col-reverse sm:ai-tw-flex-row sm:ai-tw-justify-between sm:ai-tw-space-x-2",
      e
    ),
    ...t
  }
);
lY.displayName = "DialogFooter";
const wy = C.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ C.createElement(
  my,
  {
    ref: n,
    className: ie("ai-tw-text-content-primary ai-tw-heading-1", e),
    ...t
  }
));
wy.displayName = my.displayName;
const cY = C.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ C.createElement(
  gy,
  {
    ref: n,
    className: ie("ai-tw-text-muted-foreground ai-tw-subtitle-md", e),
    ...t
  }
));
cY.displayName = gy.displayName;
const uY = ({
  open: e,
  setOpen: t,
  handleDelete: n
}) => /* @__PURE__ */ x.createElement(vy, { open: e, onOpenChange: t }, /* @__PURE__ */ x.createElement(Ah, { className: "ai-tw-gap-8" }, /* @__PURE__ */ x.createElement(yy, null, /* @__PURE__ */ x.createElement(wy, null, "Delete Recording")), /* @__PURE__ */ x.createElement("p", null, "Are you sure you want to delete this recording?", /* @__PURE__ */ x.createElement("br", null), " It will delete the recording, transcript, and summary."), /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-justify-between" }, /* @__PURE__ */ x.createElement(Yv, { asChild: !0 }, /* @__PURE__ */ x.createElement(Xt, { variant: "tertiary" }, "Cancel")), /* @__PURE__ */ x.createElement(Yv, { asChild: !0 }, /* @__PURE__ */ x.createElement(Xt, { onClick: n, variant: "destructive" }, "Yes, Delete")))));
function by(e) {
  const t = e + "CollectionProvider", [n, r] = rr(t), [i, o] = n(t, {
    collectionRef: {
      current: null
    },
    itemMap: /* @__PURE__ */ new Map()
  }), a = (m) => {
    const { scope: g, children: v } = m, y = x.useRef(null), b = x.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ x.createElement(i, {
      scope: g,
      itemMap: b,
      collectionRef: y
    }, v);
  }, s = e + "CollectionSlot", l = /* @__PURE__ */ x.forwardRef((m, g) => {
    const { scope: v, children: y } = m, b = o(s, v), E = Ft(g, b.collectionRef);
    return /* @__PURE__ */ x.createElement(qi, {
      ref: E
    }, y);
  }), u = e + "CollectionItemSlot", d = "data-radix-collection-item", f = /* @__PURE__ */ x.forwardRef((m, g) => {
    const { scope: v, children: y, ...b } = m, E = x.useRef(null), S = Ft(g, E), _ = o(u, v);
    return x.useEffect(() => (_.itemMap.set(E, {
      ref: E,
      ...b
    }), () => void _.itemMap.delete(E))), /* @__PURE__ */ x.createElement(qi, {
      [d]: "",
      ref: S
    }, y);
  });
  function p(m) {
    const g = o(e + "CollectionConsumer", m);
    return x.useCallback(() => {
      const y = g.collectionRef.current;
      if (!y)
        return [];
      const b = Array.from(y.querySelectorAll(`[${d}]`));
      return Array.from(g.itemMap.values()).sort(
        (_, k) => b.indexOf(_.ref.current) - b.indexOf(k.ref.current)
      );
    }, [
      g.collectionRef,
      g.itemMap
    ]);
  }
  return [
    {
      Provider: a,
      Slot: l,
      ItemSlot: f
    },
    p,
    r
  ];
}
const dY = /* @__PURE__ */ wn(void 0);
function Nc(e) {
  const t = Me(dY);
  return e || t || "ltr";
}
const ig = "rovingFocusGroup.onEntryFocus", fY = {
  bubbles: !1,
  cancelable: !0
}, xy = "RovingFocusGroup", [Kv, J6, hY] = by(xy), [pY, Us] = rr(xy, [
  hY
]), [mY, gY] = pY(xy), vY = /* @__PURE__ */ ke((e, t) => /* @__PURE__ */ X(Kv.Provider, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ X(Kv.Slot, {
  scope: e.__scopeRovingFocusGroup
}, /* @__PURE__ */ X(yY, ge({}, e, {
  ref: t
}))))), yY = /* @__PURE__ */ ke((e, t) => {
  const { __scopeRovingFocusGroup: n, orientation: r, loop: i = !1, dir: o, currentTabStopId: a, defaultCurrentTabStopId: s, onCurrentTabStopIdChange: l, onEntryFocus: u, ...d } = e, f = me(null), p = Ft(t, f), m = Nc(o), [g = null, v] = li({
    prop: a,
    defaultProp: s,
    onChange: l
  }), [y, b] = de(!1), E = Ei(u), S = J6(n), _ = me(!1), [k, T] = de(0);
  return be(() => {
    const A = f.current;
    if (A)
      return A.addEventListener(ig, E), () => A.removeEventListener(ig, E);
  }, [
    E
  ]), /* @__PURE__ */ X(mY, {
    scope: n,
    orientation: r,
    dir: m,
    loop: i,
    currentTabStopId: g,
    onItemFocus: De(
      (A) => v(A),
      [
        v
      ]
    ),
    onItemShiftTab: De(
      () => b(!0),
      []
    ),
    onFocusableItemAdd: De(
      () => T(
        (A) => A + 1
      ),
      []
    ),
    onFocusableItemRemove: De(
      () => T(
        (A) => A - 1
      ),
      []
    )
  }, /* @__PURE__ */ X(rt.div, ge({
    tabIndex: y || k === 0 ? -1 : 0,
    "data-orientation": r
  }, d, {
    ref: p,
    style: {
      outline: "none",
      ...e.style
    },
    onMouseDown: $e(e.onMouseDown, () => {
      _.current = !0;
    }),
    onFocus: $e(e.onFocus, (A) => {
      const R = !_.current;
      if (A.target === A.currentTarget && R && !y) {
        const F = new CustomEvent(ig, fY);
        if (A.currentTarget.dispatchEvent(F), !F.defaultPrevented) {
          const D = S().filter(
            (G) => G.focusable
          ), W = D.find(
            (G) => G.active
          ), L = D.find(
            (G) => G.id === g
          ), B = [
            W,
            L,
            ...D
          ].filter(Boolean).map(
            (G) => G.ref.current
          );
          eP(B);
        }
      }
      _.current = !1;
    }),
    onBlur: $e(
      e.onBlur,
      () => b(!1)
    )
  })));
}), wY = "RovingFocusGroupItem", bY = /* @__PURE__ */ ke((e, t) => {
  const { __scopeRovingFocusGroup: n, focusable: r = !0, active: i = !1, tabStopId: o, ...a } = e, s = ti(), l = o || s, u = gY(wY, n), d = u.currentTabStopId === l, f = J6(n), { onFocusableItemAdd: p, onFocusableItemRemove: m } = u;
  return be(() => {
    if (r)
      return p(), () => m();
  }, [
    r,
    p,
    m
  ]), /* @__PURE__ */ X(Kv.ItemSlot, {
    scope: n,
    id: l,
    focusable: r,
    active: i
  }, /* @__PURE__ */ X(rt.span, ge({
    tabIndex: d ? 0 : -1,
    "data-orientation": u.orientation
  }, a, {
    ref: t,
    onMouseDown: $e(e.onMouseDown, (g) => {
      r ? u.onItemFocus(l) : g.preventDefault();
    }),
    onFocus: $e(
      e.onFocus,
      () => u.onItemFocus(l)
    ),
    onKeyDown: $e(e.onKeyDown, (g) => {
      if (g.key === "Tab" && g.shiftKey) {
        u.onItemShiftTab();
        return;
      }
      if (g.target !== g.currentTarget)
        return;
      const v = CY(g, u.orientation, u.dir);
      if (v !== void 0) {
        g.preventDefault();
        let b = f().filter(
          (E) => E.focusable
        ).map(
          (E) => E.ref.current
        );
        if (v === "last")
          b.reverse();
        else if (v === "prev" || v === "next") {
          v === "prev" && b.reverse();
          const E = b.indexOf(g.currentTarget);
          b = u.loop ? SY(b, E + 1) : b.slice(E + 1);
        }
        setTimeout(
          () => eP(b)
        );
      }
    })
  })));
}), xY = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function EY(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function CY(e, t, n) {
  const r = EY(e.key, n);
  if (!(t === "vertical" && [
    "ArrowLeft",
    "ArrowRight"
  ].includes(r)) && !(t === "horizontal" && [
    "ArrowUp",
    "ArrowDown"
  ].includes(r)))
    return xY[r];
}
function eP(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function SY(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
const Ey = vY, Cy = bY;
function tP(e) {
  const t = me({
    value: e,
    previous: e
  });
  return Lt(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [
    e
  ]);
}
const nP = "Radio", [_Y, rP] = rr(nP), [PY, kY] = _Y(nP), TY = /* @__PURE__ */ ke((e, t) => {
  const { __scopeRadio: n, name: r, checked: i = !1, required: o, disabled: a, value: s = "on", onCheck: l, ...u } = e, [d, f] = de(null), p = Ft(
    t,
    (v) => f(v)
  ), m = me(!1), g = d ? !!d.closest("form") : !0;
  return /* @__PURE__ */ X(PY, {
    scope: n,
    checked: i,
    disabled: a
  }, /* @__PURE__ */ X(rt.button, ge({
    type: "button",
    role: "radio",
    "aria-checked": i,
    "data-state": iP(i),
    "data-disabled": a ? "" : void 0,
    disabled: a,
    value: s
  }, u, {
    ref: p,
    onClick: $e(e.onClick, (v) => {
      i || l == null || l(), g && (m.current = v.isPropagationStopped(), m.current || v.stopPropagation());
    })
  })), g && /* @__PURE__ */ X(OY, {
    control: d,
    bubbles: !m.current,
    name: r,
    value: s,
    checked: i,
    required: o,
    disabled: a,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), AY = "RadioIndicator", MY = /* @__PURE__ */ ke((e, t) => {
  const { __scopeRadio: n, forceMount: r, ...i } = e, o = kY(AY, n);
  return /* @__PURE__ */ X(On, {
    present: r || o.checked
  }, /* @__PURE__ */ X(rt.span, ge({
    "data-state": iP(o.checked),
    "data-disabled": o.disabled ? "" : void 0
  }, i, {
    ref: t
  })));
}), OY = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...i } = e, o = me(null), a = tP(n), s = p1(t);
  return be(() => {
    const l = o.current, u = window.HTMLInputElement.prototype, f = Object.getOwnPropertyDescriptor(u, "checked").set;
    if (a !== n && f) {
      const p = new Event("click", {
        bubbles: r
      });
      f.call(l, n), l.dispatchEvent(p);
    }
  }, [
    a,
    n,
    r
  ]), /* @__PURE__ */ X("input", ge({
    type: "radio",
    "aria-hidden": !0,
    defaultChecked: n
  }, i, {
    tabIndex: -1,
    ref: o,
    style: {
      ...e.style,
      ...s,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function iP(e) {
  return e ? "checked" : "unchecked";
}
const RY = [
  "ArrowUp",
  "ArrowDown",
  "ArrowLeft",
  "ArrowRight"
], oP = "RadioGroup", [IY, mye] = rr(oP, [
  Us,
  rP
]), aP = Us(), sP = rP(), [DY, NY] = IY(oP), $Y = /* @__PURE__ */ ke((e, t) => {
  const { __scopeRadioGroup: n, name: r, defaultValue: i, value: o, required: a = !1, disabled: s = !1, orientation: l, dir: u, loop: d = !0, onValueChange: f, ...p } = e, m = aP(n), g = Nc(u), [v, y] = li({
    prop: o,
    defaultProp: i,
    onChange: f
  });
  return /* @__PURE__ */ X(DY, {
    scope: n,
    name: r,
    required: a,
    disabled: s,
    value: v,
    onValueChange: y
  }, /* @__PURE__ */ X(Ey, ge({
    asChild: !0
  }, m, {
    orientation: l,
    dir: g,
    loop: d
  }), /* @__PURE__ */ X(rt.div, ge({
    role: "radiogroup",
    "aria-required": a,
    "aria-orientation": l,
    "data-disabled": s ? "" : void 0,
    dir: g
  }, p, {
    ref: t
  }))));
}), LY = "RadioGroupItem", FY = /* @__PURE__ */ ke((e, t) => {
  const { __scopeRadioGroup: n, disabled: r, ...i } = e, o = NY(LY, n), a = o.disabled || r, s = aP(n), l = sP(n), u = me(null), d = Ft(t, u), f = o.value === i.value, p = me(!1);
  return be(() => {
    const m = (v) => {
      RY.includes(v.key) && (p.current = !0);
    }, g = () => p.current = !1;
    return document.addEventListener("keydown", m), document.addEventListener("keyup", g), () => {
      document.removeEventListener("keydown", m), document.removeEventListener("keyup", g);
    };
  }, []), /* @__PURE__ */ X(Cy, ge({
    asChild: !0
  }, s, {
    focusable: !a,
    active: f
  }), /* @__PURE__ */ X(TY, ge({
    disabled: a,
    required: o.required,
    checked: f
  }, l, i, {
    name: o.name,
    ref: d,
    onCheck: () => o.onValueChange(i.value),
    onKeyDown: $e((m) => {
      m.key === "Enter" && m.preventDefault();
    }),
    onFocus: $e(i.onFocus, () => {
      var m;
      p.current && ((m = u.current) === null || m === void 0 || m.click());
    })
  })));
}), zY = /* @__PURE__ */ ke((e, t) => {
  const { __scopeRadioGroup: n, ...r } = e, i = sP(n);
  return /* @__PURE__ */ X(MY, ge({}, i, r, {
    ref: t
  }));
}), Sy = $Y, bf = FY, VY = zY, hE = $r(
  [
    "ai-tw-grid ai-tw-cursor-pointer ai-tw-place-items-center",
    "ai-tw-rounded-lg ai-tw-border ai-tw-border-grey-20 ai-tw-p-4",
    "disabled:ai-tw-opacity-40"
  ],
  {
    variants: {
      value: {
        positive: [
          "data-[state=checked]:ai-tw-bg-element-success-light data-[state=checked]:ai-tw-text-element-success",
          "hover:enabled:ai-tw-border-element-success focus:enabled:ai-tw-border-element-success"
        ],
        negative: [
          "data-[state=checked]:ai-tw-bg-element-critical-light data-[state=checked]:ai-tw-text-element-critical",
          "hover:enabled:ai-tw-border-element-critical focus:enabled:ai-tw-border-element-critical"
        ]
      }
    }
  }
);
function lP({
  className: e,
  onValueChange: t,
  ...n
}) {
  const [r, i] = C.useState("");
  return /* @__PURE__ */ C.createElement("div", { className: "ai-tw-preflight ai-tw-grid ai-tw-gap-2" }, /* @__PURE__ */ C.createElement(
    Sy,
    {
      name: "result",
      className: ie(e, "ai-tw-grid ai-tw-grid-cols-2 ai-tw-gap-3"),
      onInvalid: (o) => {
        o.preventDefault(), i("Please select an option");
      },
      onValueChange: (o) => {
        o && i(""), t && t(o);
      },
      ...n
    },
    /* @__PURE__ */ C.createElement(
      bf,
      {
        className: ie(hE({ value: "negative" })),
        value: "negative"
      },
      /* @__PURE__ */ C.createElement(Le, { className: "ai-tw-h-5", icon: Z$ })
    ),
    /* @__PURE__ */ C.createElement(
      bf,
      {
        className: ie(hE({ value: "positive" })),
        value: "positive"
      },
      /* @__PURE__ */ C.createElement(Le, { className: "ai-tw-h-5", icon: uL })
    )
  ), !!r && /* @__PURE__ */ C.createElement("p", { className: "ai-tw-text-sm ai-tw-text-red-50" }, r));
}
const BY = () => (e, t, n = {}) => {
  const { mutate: r } = K1(), i = me(e), o = me(t), a = me(n), s = me(0), [l, u, d] = yH({
    data: pn,
    error: pn,
    isMutating: !1
  }), f = l.current, p = De(
    async (g, v) => {
      const [y, b] = va(i.current);
      if (!o.current)
        throw new Error("Can’t trigger the mutation: missing fetcher.");
      if (!y)
        throw new Error("Can’t trigger the mutation: missing key.");
      const E = Dr(Dr({
        populateCache: !1,
        throwOnError: !0
      }, a.current), v), S = hc();
      s.current = S, d({
        isMutating: !0
      });
      try {
        const _ = await r(
          y,
          o.current(b, {
            arg: g
          }),
          // We must throw the error here so we can catch and update the states.
          Dr(E, {
            throwOnError: !0
          })
        );
        return s.current <= S && (d({
          data: _,
          isMutating: !1,
          error: void 0
        }), E.onSuccess == null || E.onSuccess(_, y, E)), _;
      } catch (_) {
        if (s.current <= S && (d({
          error: _,
          isMutating: !1
        }), E.onError == null || E.onError(_, y, E), E.throwOnError))
          throw _;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  ), m = De(() => {
    s.current = hc(), d({
      data: pn,
      error: pn,
      isMutating: !1
    });
  }, []);
  return da(() => {
    i.current = e, o.current = t, a.current = n;
  }), {
    trigger: p,
    reset: m,
    get data() {
      return u.data = !0, f.data;
    },
    get error() {
      return u.error = !0, f.error;
    },
    get isMutating() {
      return u.isMutating = !0, f.isMutating;
    }
  };
}, Hs = X1(br, BY);
function jY(e) {
  const t = ln(), n = e ? `/transcription/${e}` : null;
  return yh(
    n,
    (r) => t(r, {
      timeout: 30 * 1e3
    }),
    {
      errorRetryCount: 1
    }
  );
}
function WY(e) {
  const t = ln(), n = `/transcription/${e}`;
  return De(() => t(n, {
    method: "DELETE"
  }), [t, n]);
}
function UY(e) {
  const t = ln(), n = `/transcription/${e}/feedback`;
  async function r(i, {
    arg: o
  }) {
    const { result: a, feedbackFor: s, comment: l, runId: u } = o;
    if (!["positive", "negative"].includes(a))
      throw new Error('Feedback must be "positive" or "negative"');
    if (!["summary", "transcription"].includes(s))
      throw new Error('Feedback for must be "summary" or "transcription"');
    return await new Promise((d) => setTimeout(d, 1e3)), o.feedbackFor === "summary" ? t(n, {
      method: "POST",
      json: {
        summary: {
          result: a,
          comment: l,
          runId: u
        }
      }
    }) : t(n, {
      method: "POST",
      json: {
        transcription: {
          result: a,
          comment: l
        }
      }
    });
  }
  return Hs(n, r, {});
}
const HY = /* @__PURE__ */ ke((e, t) => /* @__PURE__ */ X(rt.label, ge({}, e, {
  ref: t,
  onMouseDown: (n) => {
    var r;
    (r = e.onMouseDown) === null || r === void 0 || r.call(e, n), !n.defaultPrevented && n.detail > 1 && n.preventDefault();
  }
}))), cP = HY, GY = $r(
  "ai-tw-leading-none peer-disabled:ai-tw-cursor-not-allowed peer-disabled:ai-tw-opacity-70"
), yn = C.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ C.createElement(
  cP,
  {
    ref: n,
    className: ie(GY(), "ai-tw-mb-0 ai-tw-body-md", e),
    ...t
  }
));
yn.displayName = cP.displayName;
var qY = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
const YY = (e) => e.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), Gs = (e, t) => {
  const n = ke(
    ({ color: r = "currentColor", size: i = 24, strokeWidth: o = 2, absoluteStrokeWidth: a, children: s, ...l }, u) => X(
      "svg",
      {
        ref: u,
        ...qY,
        width: i,
        height: i,
        stroke: r,
        strokeWidth: a ? Number(o) * 24 / Number(i) : o,
        className: `lucide lucide-${YY(e)}`,
        ...l
      },
      [
        ...t.map(([d, f]) => X(d, f)),
        ...(Array.isArray(s) ? s : [s]) || []
      ]
    )
  );
  return n.displayName = `${e}`, n;
}, uP = Gs("Check", [
  ["polyline", { points: "20 6 9 17 4 12", key: "10jjfj" }]
]), KY = Gs("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]), XY = Gs("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]), ZY = Gs("ChevronUp", [
  ["path", { d: "m18 15-6-6-6 6", key: "153udz" }]
]), dP = Gs("Circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]), QY = Gs("Option", [
  ["path", { d: "M3 3h6l6 18h6", key: "ph9rgk" }],
  ["path", { d: "M14 3h7", key: "16f0ms" }]
]), fP = C.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ C.createElement(
  Sy,
  {
    className: ie("ai-tw-grid ai-tw-gap-2", e),
    ...t,
    ref: n
  }
));
fP.displayName = Sy.displayName;
const Xv = C.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ C.createElement(
  bf,
  {
    ref: n,
    className: ie(
      "ai-tw-aspect-square ai-tw-h-4 ai-tw-w-4 ai-tw-rounded-full ai-tw-border ai-tw-border-primary ai-tw-text-primary ai-tw-ring-offset-background focus:ai-tw-outline-none focus-visible:ai-tw-ring-2 focus-visible:ai-tw-ring-ring focus-visible:ai-tw-ring-offset-2 disabled:ai-tw-cursor-not-allowed disabled:ai-tw-opacity-50",
      e
    ),
    ...t
  },
  /* @__PURE__ */ C.createElement(VY, { className: "ai-tw-flex ai-tw-items-center ai-tw-justify-center" }, /* @__PURE__ */ C.createElement(dP, { className: "ai-tw-h-2.5 ai-tw-w-2.5 ai-tw-fill-current ai-tw-text-current" }))
));
Xv.displayName = bf.displayName;
const JY = ({
  callSID: e,
  open: t,
  setOpen: n,
  runId: r
}) => {
  const [i, o] = de(), [a, s] = de(!1), {
    trigger: l,
    error: u,
    isMutating: d
  } = UY(e);
  return /* @__PURE__ */ x.createElement(vy, { open: t, onOpenChange: n }, /* @__PURE__ */ x.createElement(Ah, { className: "ai-tw-max-w-xl ai-tw-gap-6" }, /* @__PURE__ */ x.createElement(yy, null, /* @__PURE__ */ x.createElement(wy, null, "Provide Feedback")), /* @__PURE__ */ x.createElement("p", null, "Tell us about your experience with call recording and transcription."), /* @__PURE__ */ x.createElement(
    "form",
    {
      onSubmit: (f) => {
        f.preventDefault();
        const p = f.target, m = new FormData(p);
        l({
          result: m.get("result"),
          feedbackFor: m.get("feedbackFor"),
          comment: m.get("comment"),
          runId: r
        }).then(() => {
          s(!0), setTimeout(() => {
            n(!1), s(!1);
          }, 1500);
        }).catch((g) => {
          console.error(g);
        });
      },
      className: "ai-tw-grid ai-tw-gap-6",
      action: ""
    },
    /* @__PURE__ */ x.createElement(
      lP,
      {
        name: "result",
        required: !0,
        onValueChange: o
      }
    ),
    /* @__PURE__ */ x.createElement(eK, null),
    /* @__PURE__ */ x.createElement(
      Eh,
      {
        rows: 3,
        name: "comment",
        labelText: i === "positive" ? "What went well?" : "What can be improved?"
      }
    ),
    u && /* @__PURE__ */ x.createElement("p", { className: "ai-tw-text-sm ai-tw-text-red-50" }, /* @__PURE__ */ x.createElement(
      Le,
      {
        icon: to,
        className: "ai-tw-mr-2"
      }
    ), "Error submitting feedback. Please try again."),
    a && /* @__PURE__ */ x.createElement("p", { className: "ai-tw-text-sm ai-tw-text-green-50" }, /* @__PURE__ */ x.createElement(Le, { icon: L$, className: "ai-tw-mr-2" }), "Feedback submitted successfully."),
    /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-justify-between" }, /* @__PURE__ */ x.createElement(Yv, { asChild: !0 }, /* @__PURE__ */ x.createElement(Xt, { variant: "tertiary" }, "Cancel")), /* @__PURE__ */ x.createElement(
      Xt,
      {
        type: "submit",
        variant: "primary",
        status: d ? "loading" : a ? "success" : "default"
      },
      "Submit"
    ))
  )));
};
function eK() {
  const [e, t] = de("");
  return /* @__PURE__ */ x.createElement("div", { className: "ai-tw-grid ai-tw-gap-2" }, /* @__PURE__ */ x.createElement("label", { className: "ai-tw-font-semibold ai-tw-text-content-primary-light ai-tw-subtitle-md" }, "What are you submitting feedback for?", /* @__PURE__ */ x.createElement("span", { className: "ai-tw-ml-1 ai-tw-text-destructive" }, "*")), /* @__PURE__ */ x.createElement(
    fP,
    {
      onInvalid: (n) => {
        n.preventDefault(), t("Please select an option");
      },
      onValueChange: (n) => {
        n && t("");
      },
      required: !0,
      name: "feedbackFor"
    },
    /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-items-center ai-tw-gap-2" }, /* @__PURE__ */ x.createElement(Xv, { id: "for-transcription", value: "transcription" }), /* @__PURE__ */ x.createElement(yn, { htmlFor: "for-transcription" }, "Transcript")),
    /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-items-center ai-tw-gap-2" }, /* @__PURE__ */ x.createElement(Xv, { id: "for-summary", value: "summary" }), /* @__PURE__ */ x.createElement(yn, { htmlFor: "for-summary" }, "Summary"))
  ), !!e && /* @__PURE__ */ x.createElement("p", { className: "ai-tw-text-sm ai-tw-text-red-50" }, e));
}
const Zv = [
  "Enter",
  " "
], tK = [
  "ArrowDown",
  "PageUp",
  "Home"
], hP = [
  "ArrowUp",
  "PageDown",
  "End"
], nK = [
  ...tK,
  ...hP
], rK = {
  ltr: [
    ...Zv,
    "ArrowRight"
  ],
  rtl: [
    ...Zv,
    "ArrowLeft"
  ]
}, iK = {
  ltr: [
    "ArrowLeft"
  ],
  rtl: [
    "ArrowRight"
  ]
}, Mh = "Menu", [wc, oK, aK] = by(Mh), [Aa, pP] = rr(Mh, [
  aK,
  Vs,
  Us
]), _y = Vs(), mP = Us(), [sK, Ma] = Aa(Mh), [lK, $c] = Aa(Mh), cK = (e) => {
  const { __scopeMenu: t, open: n = !1, children: r, dir: i, onOpenChange: o, modal: a = !0 } = e, s = _y(t), [l, u] = de(null), d = me(!1), f = Ei(o), p = Nc(i);
  return be(() => {
    const m = () => {
      d.current = !0, document.addEventListener("pointerdown", g, {
        capture: !0,
        once: !0
      }), document.addEventListener("pointermove", g, {
        capture: !0,
        once: !0
      });
    }, g = () => d.current = !1;
    return document.addEventListener("keydown", m, {
      capture: !0
    }), () => {
      document.removeEventListener("keydown", m, {
        capture: !0
      }), document.removeEventListener("pointerdown", g, {
        capture: !0
      }), document.removeEventListener("pointermove", g, {
        capture: !0
      });
    };
  }, []), /* @__PURE__ */ X(m1, s, /* @__PURE__ */ X(sK, {
    scope: t,
    open: n,
    onOpenChange: f,
    content: l,
    onContentChange: u
  }, /* @__PURE__ */ X(lK, {
    scope: t,
    onClose: De(
      () => f(!1),
      [
        f
      ]
    ),
    isUsingKeyboardRef: d,
    dir: p,
    modal: a
  }, r)));
}, gP = /* @__PURE__ */ ke((e, t) => {
  const { __scopeMenu: n, ...r } = e, i = _y(n);
  return /* @__PURE__ */ X(ih, ge({}, i, r, {
    ref: t
  }));
}), vP = "MenuPortal", [uK, yP] = Aa(vP, {
  forceMount: void 0
}), dK = (e) => {
  const { __scopeMenu: t, forceMount: n, children: r, container: i } = e, o = Ma(vP, t);
  return /* @__PURE__ */ X(uK, {
    scope: t,
    forceMount: n
  }, /* @__PURE__ */ X(On, {
    present: n || o.open
  }, /* @__PURE__ */ X(oh, {
    asChild: !0,
    container: i
  }, r)));
}, ii = "MenuContent", [fK, Py] = Aa(ii), hK = /* @__PURE__ */ ke((e, t) => {
  const n = yP(ii, e.__scopeMenu), { forceMount: r = n.forceMount, ...i } = e, o = Ma(ii, e.__scopeMenu), a = $c(ii, e.__scopeMenu);
  return /* @__PURE__ */ X(wc.Provider, {
    scope: e.__scopeMenu
  }, /* @__PURE__ */ X(On, {
    present: r || o.open
  }, /* @__PURE__ */ X(wc.Slot, {
    scope: e.__scopeMenu
  }, a.modal ? /* @__PURE__ */ X(pK, ge({}, i, {
    ref: t
  })) : /* @__PURE__ */ X(mK, ge({}, i, {
    ref: t
  })))));
}), pK = /* @__PURE__ */ ke((e, t) => {
  const n = Ma(ii, e.__scopeMenu), r = me(null), i = Ft(t, r);
  return be(() => {
    const o = r.current;
    if (o)
      return ah(o);
  }, []), /* @__PURE__ */ X(ky, ge({}, e, {
    ref: i,
    trapFocus: n.open,
    disableOutsidePointerEvents: n.open,
    disableOutsideScroll: !0,
    onFocusOutside: $e(
      e.onFocusOutside,
      (o) => o.preventDefault(),
      {
        checkForDefaultPrevented: !1
      }
    ),
    onDismiss: () => n.onOpenChange(!1)
  }));
}), mK = /* @__PURE__ */ ke((e, t) => {
  const n = Ma(ii, e.__scopeMenu);
  return /* @__PURE__ */ X(ky, ge({}, e, {
    ref: t,
    trapFocus: !1,
    disableOutsidePointerEvents: !1,
    disableOutsideScroll: !1,
    onDismiss: () => n.onOpenChange(!1)
  }));
}), ky = /* @__PURE__ */ ke((e, t) => {
  const { __scopeMenu: n, loop: r = !1, trapFocus: i, onOpenAutoFocus: o, onCloseAutoFocus: a, disableOutsidePointerEvents: s, onEntryFocus: l, onEscapeKeyDown: u, onPointerDownOutside: d, onFocusOutside: f, onInteractOutside: p, onDismiss: m, disableOutsideScroll: g, ...v } = e, y = Ma(ii, n), b = $c(ii, n), E = _y(n), S = mP(n), _ = oK(n), [k, T] = de(null), A = me(null), R = Ft(t, A, y.onContentChange), F = me(0), D = me(""), W = me(0), L = me(null), z = me("right"), B = me(0), G = g ? y1 : t1, H = g ? {
    as: qi,
    allowPinchZoom: !0
  } : void 0, J = (Z) => {
    var O, Q;
    const he = D.current + Z, N = _().filter(
      (le) => !le.disabled
    ), ee = document.activeElement, ae = (O = N.find(
      (le) => le.ref.current === ee
    )) === null || O === void 0 ? void 0 : O.textValue, pe = N.map(
      (le) => le.textValue
    ), se = OK(pe, he, ae), Se = (Q = N.find(
      (le) => le.textValue === se
    )) === null || Q === void 0 ? void 0 : Q.ref.current;
    (function le(Ee) {
      D.current = Ee, window.clearTimeout(F.current), Ee !== "" && (F.current = window.setTimeout(
        () => le(""),
        1e3
      ));
    })(he), Se && setTimeout(
      () => Se.focus()
    );
  };
  be(() => () => window.clearTimeout(F.current), []), o1();
  const q = De((Z) => {
    var O, Q;
    return z.current === ((O = L.current) === null || O === void 0 ? void 0 : O.side) && IK(Z, (Q = L.current) === null || Q === void 0 ? void 0 : Q.area);
  }, []);
  return /* @__PURE__ */ X(fK, {
    scope: n,
    searchRef: D,
    onItemEnter: De((Z) => {
      q(Z) && Z.preventDefault();
    }, [
      q
    ]),
    onItemLeave: De((Z) => {
      var O;
      q(Z) || ((O = A.current) === null || O === void 0 || O.focus(), T(null));
    }, [
      q
    ]),
    onTriggerLeave: De((Z) => {
      q(Z) && Z.preventDefault();
    }, [
      q
    ]),
    pointerGraceTimerRef: W,
    onPointerGraceIntentChange: De((Z) => {
      L.current = Z;
    }, [])
  }, /* @__PURE__ */ X(G, H, /* @__PURE__ */ X(a1, {
    asChild: !0,
    trapped: i,
    onMountAutoFocus: $e(o, (Z) => {
      var O;
      Z.preventDefault(), (O = A.current) === null || O === void 0 || O.focus();
    }),
    onUnmountAutoFocus: a
  }, /* @__PURE__ */ X(eh, {
    asChild: !0,
    disableOutsidePointerEvents: s,
    onEscapeKeyDown: u,
    onPointerDownOutside: d,
    onFocusOutside: f,
    onInteractOutside: p,
    onDismiss: m
  }, /* @__PURE__ */ X(Ey, ge({
    asChild: !0
  }, S, {
    dir: b.dir,
    orientation: "vertical",
    loop: r,
    currentTabStopId: k,
    onCurrentTabStopIdChange: T,
    onEntryFocus: $e(l, (Z) => {
      b.isUsingKeyboardRef.current || Z.preventDefault();
    })
  }), /* @__PURE__ */ X(g1, ge({
    role: "menu",
    "aria-orientation": "vertical",
    "data-state": CP(y.open),
    "data-radix-menu-content": "",
    dir: b.dir
  }, E, v, {
    ref: R,
    style: {
      outline: "none",
      ...v.style
    },
    onKeyDown: $e(v.onKeyDown, (Z) => {
      const Q = Z.target.closest("[data-radix-menu-content]") === Z.currentTarget, he = Z.ctrlKey || Z.altKey || Z.metaKey, N = Z.key.length === 1;
      Q && (Z.key === "Tab" && Z.preventDefault(), !he && N && J(Z.key));
      const ee = A.current;
      if (Z.target !== ee || !nK.includes(Z.key))
        return;
      Z.preventDefault();
      const pe = _().filter(
        (se) => !se.disabled
      ).map(
        (se) => se.ref.current
      );
      hP.includes(Z.key) && pe.reverse(), AK(pe);
    }),
    onBlur: $e(e.onBlur, (Z) => {
      Z.currentTarget.contains(Z.target) || (window.clearTimeout(F.current), D.current = "");
    }),
    onPointerMove: $e(e.onPointerMove, bc((Z) => {
      const O = Z.target, Q = B.current !== Z.clientX;
      if (Z.currentTarget.contains(O) && Q) {
        const he = Z.clientX > B.current ? "right" : "left";
        z.current = he, B.current = Z.clientX;
      }
    }))
  })))))));
}), gK = /* @__PURE__ */ ke((e, t) => {
  const { __scopeMenu: n, ...r } = e;
  return /* @__PURE__ */ X(rt.div, ge({}, r, {
    ref: t
  }));
}), Qv = "MenuItem", pE = "menu.itemSelect", Ty = /* @__PURE__ */ ke((e, t) => {
  const { disabled: n = !1, onSelect: r, ...i } = e, o = me(null), a = $c(Qv, e.__scopeMenu), s = Py(Qv, e.__scopeMenu), l = Ft(t, o), u = me(!1), d = () => {
    const f = o.current;
    if (!n && f) {
      const p = new CustomEvent(pE, {
        bubbles: !0,
        cancelable: !0
      });
      f.addEventListener(
        pE,
        (m) => r == null ? void 0 : r(m),
        {
          once: !0
        }
      ), yS(f, p), p.defaultPrevented ? u.current = !1 : a.onClose();
    }
  };
  return /* @__PURE__ */ X(wP, ge({}, i, {
    ref: l,
    disabled: n,
    onClick: $e(e.onClick, d),
    onPointerDown: (f) => {
      var p;
      (p = e.onPointerDown) === null || p === void 0 || p.call(e, f), u.current = !0;
    },
    onPointerUp: $e(e.onPointerUp, (f) => {
      var p;
      u.current || (p = f.currentTarget) === null || p === void 0 || p.click();
    }),
    onKeyDown: $e(e.onKeyDown, (f) => {
      const p = s.searchRef.current !== "";
      n || p && f.key === " " || Zv.includes(f.key) && (f.currentTarget.click(), f.preventDefault());
    })
  }));
}), wP = /* @__PURE__ */ ke((e, t) => {
  const { __scopeMenu: n, disabled: r = !1, textValue: i, ...o } = e, a = Py(Qv, n), s = mP(n), l = me(null), u = Ft(t, l), [d, f] = de(!1), [p, m] = de("");
  return be(() => {
    const g = l.current;
    if (g) {
      var v;
      m(((v = g.textContent) !== null && v !== void 0 ? v : "").trim());
    }
  }, [
    o.children
  ]), /* @__PURE__ */ X(wc.ItemSlot, {
    scope: n,
    disabled: r,
    textValue: i ?? p
  }, /* @__PURE__ */ X(Cy, ge({
    asChild: !0
  }, s, {
    focusable: !r
  }), /* @__PURE__ */ X(rt.div, ge({
    role: "menuitem",
    "data-highlighted": d ? "" : void 0,
    "aria-disabled": r || void 0,
    "data-disabled": r ? "" : void 0
  }, o, {
    ref: u,
    onPointerMove: $e(e.onPointerMove, bc((g) => {
      r ? a.onItemLeave(g) : (a.onItemEnter(g), g.defaultPrevented || g.currentTarget.focus());
    })),
    onPointerLeave: $e(e.onPointerLeave, bc(
      (g) => a.onItemLeave(g)
    )),
    onFocus: $e(
      e.onFocus,
      () => f(!0)
    ),
    onBlur: $e(
      e.onBlur,
      () => f(!1)
    )
  }))));
}), vK = /* @__PURE__ */ ke((e, t) => {
  const { checked: n = !1, onCheckedChange: r, ...i } = e;
  return /* @__PURE__ */ X(xP, {
    scope: e.__scopeMenu,
    checked: n
  }, /* @__PURE__ */ X(Ty, ge({
    role: "menuitemcheckbox",
    "aria-checked": xf(n) ? "mixed" : n
  }, i, {
    ref: t,
    "data-state": Ay(n),
    onSelect: $e(
      i.onSelect,
      () => r == null ? void 0 : r(xf(n) ? !0 : !n),
      {
        checkForDefaultPrevented: !1
      }
    )
  })));
}), yK = "MenuRadioGroup", [gye, wK] = Aa(yK, {
  value: void 0,
  onValueChange: () => {
  }
}), bK = "MenuRadioItem", xK = /* @__PURE__ */ ke((e, t) => {
  const { value: n, ...r } = e, i = wK(bK, e.__scopeMenu), o = n === i.value;
  return /* @__PURE__ */ X(xP, {
    scope: e.__scopeMenu,
    checked: o
  }, /* @__PURE__ */ X(Ty, ge({
    role: "menuitemradio",
    "aria-checked": o
  }, r, {
    ref: t,
    "data-state": Ay(o),
    onSelect: $e(r.onSelect, () => {
      var a;
      return (a = i.onValueChange) === null || a === void 0 ? void 0 : a.call(i, n);
    }, {
      checkForDefaultPrevented: !1
    })
  })));
}), bP = "MenuItemIndicator", [xP, EK] = Aa(bP, {
  checked: !1
}), CK = /* @__PURE__ */ ke((e, t) => {
  const { __scopeMenu: n, forceMount: r, ...i } = e, o = EK(bP, n);
  return /* @__PURE__ */ X(On, {
    present: r || xf(o.checked) || o.checked === !0
  }, /* @__PURE__ */ X(rt.span, ge({}, i, {
    ref: t,
    "data-state": Ay(o.checked)
  })));
}), SK = /* @__PURE__ */ ke((e, t) => {
  const { __scopeMenu: n, ...r } = e;
  return /* @__PURE__ */ X(rt.div, ge({
    role: "separator",
    "aria-orientation": "horizontal"
  }, r, {
    ref: t
  }));
}), _K = "MenuSub", [vye, EP] = Aa(_K), ld = "MenuSubTrigger", PK = /* @__PURE__ */ ke((e, t) => {
  const n = Ma(ld, e.__scopeMenu), r = $c(ld, e.__scopeMenu), i = EP(ld, e.__scopeMenu), o = Py(ld, e.__scopeMenu), a = me(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: l } = o, u = {
    __scopeMenu: e.__scopeMenu
  }, d = De(() => {
    a.current && window.clearTimeout(a.current), a.current = null;
  }, []);
  return be(
    () => d,
    [
      d
    ]
  ), be(() => {
    const f = s.current;
    return () => {
      window.clearTimeout(f), l(null);
    };
  }, [
    s,
    l
  ]), /* @__PURE__ */ X(gP, ge({
    asChild: !0
  }, u), /* @__PURE__ */ X(wP, ge({
    id: i.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": n.open,
    "aria-controls": i.contentId,
    "data-state": CP(n.open)
  }, e, {
    ref: Jf(t, i.onTriggerChange),
    onClick: (f) => {
      var p;
      (p = e.onClick) === null || p === void 0 || p.call(e, f), !(e.disabled || f.defaultPrevented) && (f.currentTarget.focus(), n.open || n.onOpenChange(!0));
    },
    onPointerMove: $e(e.onPointerMove, bc((f) => {
      o.onItemEnter(f), !f.defaultPrevented && !e.disabled && !n.open && !a.current && (o.onPointerGraceIntentChange(null), a.current = window.setTimeout(() => {
        n.onOpenChange(!0), d();
      }, 100));
    })),
    onPointerLeave: $e(e.onPointerLeave, bc((f) => {
      var p;
      d();
      const m = (p = n.content) === null || p === void 0 ? void 0 : p.getBoundingClientRect();
      if (m) {
        var g;
        const v = (g = n.content) === null || g === void 0 ? void 0 : g.dataset.side, y = v === "right", b = y ? -5 : 5, E = m[y ? "left" : "right"], S = m[y ? "right" : "left"];
        o.onPointerGraceIntentChange({
          area: [
            // consistently within polygon bounds
            {
              x: f.clientX + b,
              y: f.clientY
            },
            {
              x: E,
              y: m.top
            },
            {
              x: S,
              y: m.top
            },
            {
              x: S,
              y: m.bottom
            },
            {
              x: E,
              y: m.bottom
            }
          ],
          side: v
        }), window.clearTimeout(s.current), s.current = window.setTimeout(
          () => o.onPointerGraceIntentChange(null),
          300
        );
      } else {
        if (o.onTriggerLeave(f), f.defaultPrevented)
          return;
        o.onPointerGraceIntentChange(null);
      }
    })),
    onKeyDown: $e(e.onKeyDown, (f) => {
      const p = o.searchRef.current !== "";
      if (!(e.disabled || p && f.key === " ") && rK[r.dir].includes(f.key)) {
        var m;
        n.onOpenChange(!0), (m = n.content) === null || m === void 0 || m.focus(), f.preventDefault();
      }
    })
  })));
}), kK = "MenuSubContent", TK = /* @__PURE__ */ ke((e, t) => {
  const n = yP(ii, e.__scopeMenu), { forceMount: r = n.forceMount, ...i } = e, o = Ma(ii, e.__scopeMenu), a = $c(ii, e.__scopeMenu), s = EP(kK, e.__scopeMenu), l = me(null), u = Ft(t, l);
  return /* @__PURE__ */ X(wc.Provider, {
    scope: e.__scopeMenu
  }, /* @__PURE__ */ X(On, {
    present: r || o.open
  }, /* @__PURE__ */ X(wc.Slot, {
    scope: e.__scopeMenu
  }, /* @__PURE__ */ X(ky, ge({
    id: s.contentId,
    "aria-labelledby": s.triggerId
  }, i, {
    ref: u,
    align: "start",
    side: a.dir === "rtl" ? "left" : "right",
    disableOutsidePointerEvents: !1,
    disableOutsideScroll: !1,
    trapFocus: !1,
    onOpenAutoFocus: (d) => {
      var f;
      a.isUsingKeyboardRef.current && ((f = l.current) === null || f === void 0 || f.focus()), d.preventDefault();
    },
    onCloseAutoFocus: (d) => d.preventDefault(),
    onFocusOutside: $e(e.onFocusOutside, (d) => {
      d.target !== s.trigger && o.onOpenChange(!1);
    }),
    onEscapeKeyDown: $e(e.onEscapeKeyDown, (d) => {
      a.onClose(), d.preventDefault();
    }),
    onKeyDown: $e(e.onKeyDown, (d) => {
      const f = d.currentTarget.contains(d.target), p = iK[a.dir].includes(d.key);
      if (f && p) {
        var m;
        o.onOpenChange(!1), (m = s.trigger) === null || m === void 0 || m.focus(), d.preventDefault();
      }
    })
  })))));
});
function CP(e) {
  return e ? "open" : "closed";
}
function xf(e) {
  return e === "indeterminate";
}
function Ay(e) {
  return xf(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
function AK(e) {
  const t = document.activeElement;
  for (const n of e)
    if (n === t || (n.focus(), document.activeElement !== t))
      return;
}
function MK(e, t) {
  return e.map(
    (n, r) => e[(t + r) % e.length]
  );
}
function OK(e, t, n) {
  const i = t.length > 1 && Array.from(t).every(
    (u) => u === t[0]
  ) ? t[0] : t, o = n ? e.indexOf(n) : -1;
  let a = MK(e, Math.max(o, 0));
  i.length === 1 && (a = a.filter(
    (u) => u !== n
  ));
  const l = a.find(
    (u) => u.toLowerCase().startsWith(i.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function RK(e, t) {
  const { x: n, y: r } = e;
  let i = !1;
  for (let o = 0, a = t.length - 1; o < t.length; a = o++) {
    const s = t[o].x, l = t[o].y, u = t[a].x, d = t[a].y;
    l > r != d > r && n < (u - s) * (r - l) / (d - l) + s && (i = !i);
  }
  return i;
}
function IK(e, t) {
  if (!t)
    return !1;
  const n = {
    x: e.clientX,
    y: e.clientY
  };
  return RK(n, t);
}
function bc(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
const DK = cK, NK = gP, $K = dK, LK = hK, FK = gK, zK = Ty, VK = vK, BK = xK, jK = CK, WK = SK, UK = PK, HK = TK, SP = "DropdownMenu", [GK, yye] = rr(SP, [
  pP
]), Lr = pP(), [qK, _P] = GK(SP), YK = (e) => {
  const { __scopeDropdownMenu: t, children: n, dir: r, open: i, defaultOpen: o, onOpenChange: a, modal: s = !0 } = e, l = Lr(t), u = me(null), [d = !1, f] = li({
    prop: i,
    defaultProp: o,
    onChange: a
  });
  return /* @__PURE__ */ X(qK, {
    scope: t,
    triggerId: ti(),
    triggerRef: u,
    contentId: ti(),
    open: d,
    onOpenChange: f,
    onOpenToggle: De(
      () => f(
        (p) => !p
      ),
      [
        f
      ]
    ),
    modal: s
  }, /* @__PURE__ */ X(DK, ge({}, l, {
    open: d,
    onOpenChange: f,
    dir: r,
    modal: s
  }), n));
}, KK = "DropdownMenuTrigger", XK = /* @__PURE__ */ ke((e, t) => {
  const { __scopeDropdownMenu: n, disabled: r = !1, ...i } = e, o = _P(KK, n), a = Lr(n);
  return /* @__PURE__ */ X(NK, ge({
    asChild: !0
  }, a), /* @__PURE__ */ X(rt.button, ge({
    type: "button",
    id: o.triggerId,
    "aria-haspopup": "menu",
    "aria-expanded": o.open,
    "aria-controls": o.open ? o.contentId : void 0,
    "data-state": o.open ? "open" : "closed",
    "data-disabled": r ? "" : void 0,
    disabled: r
  }, i, {
    ref: Jf(t, o.triggerRef),
    onPointerDown: $e(e.onPointerDown, (s) => {
      !r && s.button === 0 && s.ctrlKey === !1 && (o.onOpenToggle(), o.open || s.preventDefault());
    }),
    onKeyDown: $e(e.onKeyDown, (s) => {
      r || ([
        "Enter",
        " "
      ].includes(s.key) && o.onOpenToggle(), s.key === "ArrowDown" && o.onOpenChange(!0), [
        "Enter",
        " ",
        "ArrowDown"
      ].includes(s.key) && s.preventDefault());
    })
  })));
}), ZK = (e) => {
  const { __scopeDropdownMenu: t, ...n } = e, r = Lr(t);
  return /* @__PURE__ */ X($K, ge({}, r, n));
}, QK = "DropdownMenuContent", JK = /* @__PURE__ */ ke((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = _P(QK, n), o = Lr(n), a = me(!1);
  return /* @__PURE__ */ X(LK, ge({
    id: i.contentId,
    "aria-labelledby": i.triggerId
  }, o, r, {
    ref: t,
    onCloseAutoFocus: $e(e.onCloseAutoFocus, (s) => {
      var l;
      a.current || (l = i.triggerRef.current) === null || l === void 0 || l.focus(), a.current = !1, s.preventDefault();
    }),
    onInteractOutside: $e(e.onInteractOutside, (s) => {
      const l = s.detail.originalEvent, u = l.button === 0 && l.ctrlKey === !0, d = l.button === 2 || u;
      (!i.modal || d) && (a.current = !0);
    }),
    style: {
      ...e.style,
      "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), eX = /* @__PURE__ */ ke((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = Lr(n);
  return /* @__PURE__ */ X(FK, ge({}, i, r, {
    ref: t
  }));
}), tX = /* @__PURE__ */ ke((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = Lr(n);
  return /* @__PURE__ */ X(zK, ge({}, i, r, {
    ref: t
  }));
}), nX = /* @__PURE__ */ ke((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = Lr(n);
  return /* @__PURE__ */ X(VK, ge({}, i, r, {
    ref: t
  }));
}), rX = /* @__PURE__ */ ke((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = Lr(n);
  return /* @__PURE__ */ X(BK, ge({}, i, r, {
    ref: t
  }));
}), iX = /* @__PURE__ */ ke((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = Lr(n);
  return /* @__PURE__ */ X(jK, ge({}, i, r, {
    ref: t
  }));
}), oX = /* @__PURE__ */ ke((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = Lr(n);
  return /* @__PURE__ */ X(WK, ge({}, i, r, {
    ref: t
  }));
}), aX = /* @__PURE__ */ ke((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = Lr(n);
  return /* @__PURE__ */ X(UK, ge({}, i, r, {
    ref: t
  }));
}), sX = /* @__PURE__ */ ke((e, t) => {
  const { __scopeDropdownMenu: n, ...r } = e, i = Lr(n);
  return /* @__PURE__ */ X(HK, ge({}, i, r, {
    ref: t,
    style: {
      ...e.style,
      "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
      "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
      "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
      "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
      "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
    }
  }));
}), lX = YK, cX = XK, uX = ZK, PP = JK, kP = eX, TP = tX, AP = nX, MP = rX, OP = iX, RP = oX, IP = aX, DP = sX, dX = lX, fX = cX, hX = C.forwardRef(({ className: e, inset: t, children: n, ...r }, i) => /* @__PURE__ */ C.createElement(
  IP,
  {
    ref: i,
    className: ie(
      "ai-tw-flex ai-tw-cursor-default ai-tw-select-none ai-tw-items-center ai-tw-rounded-sm ai-tw-px-2 ai-tw-py-1.5 ai-tw-text-sm ai-tw-outline-none focus:ai-tw-bg-accent data-[state=open]:ai-tw-bg-accent",
      t && "ai-tw-pl-8",
      e
    ),
    ...r
  },
  n,
  /* @__PURE__ */ C.createElement(XY, { className: "ai-tw-ml-auto ai-tw-h-4 ai-tw-w-4" })
));
hX.displayName = IP.displayName;
const pX = C.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ C.createElement(
  DP,
  {
    ref: n,
    className: ie(
      "ai-tw-z-[1200] ai-tw-min-w-[8rem] ai-tw-overflow-hidden ai-tw-rounded-md ai-tw-bg-popover ai-tw-p-1 ai-tw-text-popover-foreground ai-tw-shadow-dropdown data-[state=open]:ai-tw-animate-in data-[state=closed]:ai-tw-animate-out data-[state=closed]:ai-tw-fade-out-0 data-[state=open]:ai-tw-fade-in-0 data-[state=closed]:ai-tw-zoom-out-95 data-[state=open]:ai-tw-zoom-in-95 data-[side=bottom]:ai-tw-slide-in-from-top-2 data-[side=left]:ai-tw-slide-in-from-right-2 data-[side=right]:ai-tw-slide-in-from-left-2 data-[side=top]:ai-tw-slide-in-from-bottom-2",
      e
    ),
    ...t
  }
));
pX.displayName = DP.displayName;
const NP = C.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ C.createElement(uX, null, /* @__PURE__ */ C.createElement(
  PP,
  {
    ref: r,
    sideOffset: t,
    className: ie(
      "ai-tw-z-[1200] ai-tw-min-w-[8rem] ai-tw-overflow-hidden ai-tw-rounded-md ai-tw-bg-popover ai-tw-p-1 ai-tw-text-popover-foreground ai-tw-shadow-dropdown data-[state=open]:ai-tw-animate-in data-[state=closed]:ai-tw-animate-out data-[state=closed]:ai-tw-fade-out-0 data-[state=open]:ai-tw-fade-in-0 data-[state=closed]:ai-tw-zoom-out-95 data-[state=open]:ai-tw-zoom-in-95 data-[side=bottom]:ai-tw-slide-in-from-top-2 data-[side=left]:ai-tw-slide-in-from-right-2 data-[side=right]:ai-tw-slide-in-from-left-2 data-[side=top]:ai-tw-slide-in-from-bottom-2",
      e
    ),
    ...n
  }
)));
NP.displayName = PP.displayName;
const Jv = C.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ C.createElement(
  TP,
  {
    ref: r,
    className: ie(
      "ai-tw-relative ai-tw-flex ai-tw-cursor-pointer ai-tw-select-none ai-tw-items-center ai-tw-rounded-sm ai-tw-px-2 ai-tw-py-1.5 ai-tw-text-sm ai-tw-outline-none ai-tw-transition-colors focus:ai-tw-bg-accent focus:ai-tw-text-accent-foreground active:ai-tw-bg-element-primary-alt-dark data-[disabled]:ai-tw-pointer-events-none data-[disabled]:ai-tw-opacity-50",
      t && "ai-tw-pl-8",
      e
    ),
    ...n
  }
));
Jv.displayName = TP.displayName;
const mX = C.forwardRef(({ className: e, children: t, checked: n, ...r }, i) => /* @__PURE__ */ C.createElement(
  AP,
  {
    ref: i,
    className: ie(
      "ai-tw-relative ai-tw-flex ai-tw-cursor-pointer ai-tw-select-none ai-tw-items-center ai-tw-rounded-sm ai-tw-py-1.5 ai-tw-pl-8 ai-tw-pr-2 ai-tw-text-sm ai-tw-outline-none ai-tw-transition-colors focus:ai-tw-bg-accent focus:ai-tw-text-accent-foreground active:ai-tw-bg-element-primary-alt-dark data-[disabled]:ai-tw-pointer-events-none data-[state=checked]:ai-tw-font-bold data-[disabled]:ai-tw-opacity-50",
      e
    ),
    checked: n,
    ...r
  },
  /* @__PURE__ */ C.createElement("span", { className: "ai-tw-absolute ai-tw-left-2 ai-tw-flex ai-tw-h-3.5 ai-tw-w-3.5 ai-tw-items-center ai-tw-justify-center" }, /* @__PURE__ */ C.createElement(OP, null, /* @__PURE__ */ C.createElement(uP, { className: "ai-tw-h-4 ai-tw-w-4" }))),
  t
));
mX.displayName = AP.displayName;
const gX = C.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ C.createElement(
  MP,
  {
    ref: r,
    className: ie(
      "ai-tw-relative ai-tw-flex ai-tw-cursor-pointer ai-tw-select-none ai-tw-items-center ai-tw-rounded-sm ai-tw-py-1.5 ai-tw-pl-8 ai-tw-pr-2 ai-tw-text-sm ai-tw-outline-none ai-tw-transition-colors focus:ai-tw-bg-accent focus:ai-tw-text-accent-foreground active:ai-tw-bg-element-primary-alt-dark data-[disabled]:ai-tw-pointer-events-none data-[state=checked]:ai-tw-font-bold data-[disabled]:ai-tw-opacity-50",
      e
    ),
    ...n
  },
  /* @__PURE__ */ C.createElement("span", { className: "ai-tw-absolute ai-tw-left-2 ai-tw-flex ai-tw-h-3.5 ai-tw-w-3.5 ai-tw-items-center ai-tw-justify-center" }, /* @__PURE__ */ C.createElement(OP, null, /* @__PURE__ */ C.createElement(dP, { className: "ai-tw-h-2 ai-tw-w-2 ai-tw-fill-current" }))),
  t
));
gX.displayName = MP.displayName;
const vX = C.forwardRef(({ className: e, inset: t, ...n }, r) => /* @__PURE__ */ C.createElement(
  kP,
  {
    ref: r,
    className: ie(
      "ai-tw-px-2 ai-tw-py-1.5 ai-tw-text-sm ai-tw-font-semibold",
      t && "ai-tw-pl-8",
      e
    ),
    ...n
  }
));
vX.displayName = kP.displayName;
const yX = C.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ C.createElement(
  RP,
  {
    ref: n,
    className: ie(
      "ai-tw--mx-1 ai-tw-my-1 ai-tw-h-px ai-tw-bg-muted",
      e
    ),
    ...t
  }
));
yX.displayName = RP.displayName;
function mE({
  openDeleteModal: e,
  openFeedbackModal: t
}) {
  return /* @__PURE__ */ C.createElement(dX, { modal: !1 }, /* @__PURE__ */ C.createElement(fX, { asChild: !0 }, /* @__PURE__ */ C.createElement(
    Xt,
    {
      "aria-label": "Customize Options",
      className: "ai-tw-shrink-0",
      variant: "tertiary",
      size: "icon"
    },
    /* @__PURE__ */ C.createElement(Le, { icon: J$ })
  )), /* @__PURE__ */ C.createElement(NP, { align: "end" }, /* @__PURE__ */ C.createElement(
    Jv,
    {
      className: "ai-tw-flex ai-tw-gap-2",
      onSelect: t
    },
    /* @__PURE__ */ C.createElement(Le, { icon: O$, className: "ai-tw-w-4" }),
    "Provide Feedback"
  ), /* @__PURE__ */ C.createElement(
    Jv,
    {
      className: "ai-tw-flex ai-tw-gap-2",
      onSelect: e
    },
    /* @__PURE__ */ C.createElement(Le, { icon: x$, className: "ai-tw-w-4" }),
    "Delete"
  )));
}
const e0 = (e) => {
  if (e === 1 / 0 || isNaN(e) || e == null)
    return null;
  if (e <= 0)
    return "00:00";
  const t = new Date(e * 1e3).toISOString();
  return t.slice(11, 13) === "00" ? t.slice(14, 19) : t.slice(11, 19);
}, wX = ({
  transcript: e,
  onClickTime: t
}) => !e || e.length === 0 ? /* @__PURE__ */ x.createElement("p", null, "No transcript available.") : /* @__PURE__ */ x.createElement("div", null, e.map((n, r) => {
  const i = n.startTimeMS / 1e3;
  return /* @__PURE__ */ x.createElement(
    "div",
    {
      key: r,
      onClick: () => t(i),
      className: ie(
        "ai-tw-mb-2.5 ai-tw-flex ai-tw-cursor-pointer ai-tw-body-md hover:ai-tw-text-stroke-brand-alt",
        n.who === "CUSTOMER" ? "ai-tw-text-grey-50" : "ai-tw-text-grey-60"
      )
    },
    /* @__PURE__ */ x.createElement("span", { className: "ai-tw-mr-5" }, e0(i)),
    n.message
  );
}));
function $P({
  children: e,
  root: t,
  callback: n,
  rootMargin: r,
  threshold: i,
  ...o
}) {
  const a = me(null);
  return be(() => {
    const s = a.current;
    if (!s)
      return;
    const l = new IntersectionObserver(
      (u) => {
        for (const d of u)
          n(d.isIntersecting);
      },
      {
        root: t || null,
        rootMargin: r,
        threshold: i
      }
    );
    return l.observe(s), () => {
      l.disconnect();
    };
  }, [t, n, r, i]), /* @__PURE__ */ x.createElement("div", { ref: a, ...o }, e);
}
function bX({ onClick: e, isPlaying: t, isLoading: n }) {
  return /* @__PURE__ */ x.createElement(
    Xt,
    {
      className: "ai-tw-shrink-0",
      onClick: e,
      variant: "tertiary",
      size: "icon",
      status: n ? "loading" : "default"
    },
    t ? /* @__PURE__ */ x.createElement(Le, { fixedWidth: !0, icon: fS }) : /* @__PURE__ */ x.createElement(Le, { fixedWidth: !0, icon: pS, transform: "right-1" })
  );
}
const xX = "_range_sv2gd_1", EX = {
  range: xX
}, CX = ({
  audioRef: e,
  duration: t,
  timeProgress: n,
  setTimeProgress: r
}) => {
  const i = n / t * 100;
  return /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-w-full ai-tw-items-center ai-tw-gap-4" }, /* @__PURE__ */ x.createElement("span", { className: "ai-tw-min-w-fit ai-tw-body-sm" }, /* @__PURE__ */ x.createElement(SX, { timeProgress: n, duration: t })), /* @__PURE__ */ x.createElement(
    "input",
    {
      style: {
        background: `linear-gradient(to right, hsl(var(--ai-grey-60)) ${i}%, hsl(var(--ai-grey-20)) ${i}%)`
      },
      className: ie(EX.range),
      type: "range",
      min: 0,
      max: t,
      onChange: (o) => {
        r(o.target.valueAsNumber), e.current && (e.current.currentTime = o.target.valueAsNumber);
      },
      value: n
    }
  ));
};
function SX({
  timeProgress: e,
  duration: t
}) {
  const n = e0(e), r = e0(t);
  return n === null && r === null ? null : n === null ? `--- / ${r}` : r === null ? `${n}` : `${n} / ${r}`;
}
const LP = l_, My = c_, _X = Iz, Oh = C.forwardRef(({ className: e, sideOffset: t = 4, ...n }, r) => /* @__PURE__ */ C.createElement(u_, null, /* @__PURE__ */ C.createElement(
  w1,
  {
    ref: r,
    sideOffset: t,
    className: ie(
      "ai-tw-z-[1200] ai-tw-w-72 ai-tw-rounded-md ai-tw-bg-popover ai-tw-p-4 ai-tw-text-popover-foreground ai-tw-shadow-dropdown ai-tw-outline-none data-[state=open]:ai-tw-animate-in data-[state=closed]:ai-tw-animate-out data-[state=closed]:ai-tw-fade-out-0 data-[state=open]:ai-tw-fade-in-0 data-[state=closed]:ai-tw-zoom-out-95 data-[state=open]:ai-tw-zoom-in-95 data-[side=bottom]:ai-tw-slide-in-from-top-2 data-[side=left]:ai-tw-slide-in-from-right-2 data-[side=right]:ai-tw-slide-in-from-left-2 data-[side=top]:ai-tw-slide-in-from-bottom-2",
      e
    ),
    ...n
  }
)));
Oh.displayName = w1.displayName;
function FP(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function hs(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function PX(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function zP(...e) {
  return (t) => e.forEach((n) => PX(n, t));
}
function ba(...e) {
  return C.useCallback(zP(...e), e);
}
var t0 = { exports: {} }, Sl = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gE;
function kX() {
  if (gE)
    return Sl;
  gE = 1;
  var e = x, t = Symbol.for("react.element"), n = Symbol.for("react.fragment"), r = Object.prototype.hasOwnProperty, i = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, o = { key: !0, ref: !0, __self: !0, __source: !0 };
  function a(s, l, u) {
    var d, f = {}, p = null, m = null;
    u !== void 0 && (p = "" + u), l.key !== void 0 && (p = "" + l.key), l.ref !== void 0 && (m = l.ref);
    for (d in l)
      r.call(l, d) && !o.hasOwnProperty(d) && (f[d] = l[d]);
    if (s && s.defaultProps)
      for (d in l = s.defaultProps, l)
        f[d] === void 0 && (f[d] = l[d]);
    return { $$typeof: t, type: s, key: p, ref: m, props: f, _owner: i.current };
  }
  return Sl.Fragment = n, Sl.jsx = a, Sl.jsxs = a, Sl;
}
var _l = {};
/**
 * @license React
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var vE;
function TX() {
  return vE || (vE = 1, process.env.NODE_ENV !== "production" && function() {
    var e = x, t = Symbol.for("react.element"), n = Symbol.for("react.portal"), r = Symbol.for("react.fragment"), i = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), a = Symbol.for("react.provider"), s = Symbol.for("react.context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), g = Symbol.iterator, v = "@@iterator";
    function y(j) {
      if (j === null || typeof j != "object")
        return null;
      var xe = g && j[g] || j[v];
      return typeof xe == "function" ? xe : null;
    }
    var b = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function E(j) {
      {
        for (var xe = arguments.length, Te = new Array(xe > 1 ? xe - 1 : 0), He = 1; He < xe; He++)
          Te[He - 1] = arguments[He];
        S("error", j, Te);
      }
    }
    function S(j, xe, Te) {
      {
        var He = b.ReactDebugCurrentFrame, pt = He.getStackAddendum();
        pt !== "" && (xe += "%s", Te = Te.concat([pt]));
        var yt = Te.map(function(it) {
          return String(it);
        });
        yt.unshift("Warning: " + xe), Function.prototype.apply.call(console[j], console, yt);
      }
    }
    var _ = !1, k = !1, T = !1, A = !1, R = !1, F;
    F = Symbol.for("react.module.reference");
    function D(j) {
      return !!(typeof j == "string" || typeof j == "function" || j === r || j === o || R || j === i || j === u || j === d || A || j === m || _ || k || T || typeof j == "object" && j !== null && (j.$$typeof === p || j.$$typeof === f || j.$$typeof === a || j.$$typeof === s || j.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      j.$$typeof === F || j.getModuleId !== void 0));
    }
    function W(j, xe, Te) {
      var He = j.displayName;
      if (He)
        return He;
      var pt = xe.displayName || xe.name || "";
      return pt !== "" ? Te + "(" + pt + ")" : Te;
    }
    function L(j) {
      return j.displayName || "Context";
    }
    function z(j) {
      if (j == null)
        return null;
      if (typeof j.tag == "number" && E("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof j == "function")
        return j.displayName || j.name || null;
      if (typeof j == "string")
        return j;
      switch (j) {
        case r:
          return "Fragment";
        case n:
          return "Portal";
        case o:
          return "Profiler";
        case i:
          return "StrictMode";
        case u:
          return "Suspense";
        case d:
          return "SuspenseList";
      }
      if (typeof j == "object")
        switch (j.$$typeof) {
          case s:
            var xe = j;
            return L(xe) + ".Consumer";
          case a:
            var Te = j;
            return L(Te._context) + ".Provider";
          case l:
            return W(j, j.render, "ForwardRef");
          case f:
            var He = j.displayName || null;
            return He !== null ? He : z(j.type) || "Memo";
          case p: {
            var pt = j, yt = pt._payload, it = pt._init;
            try {
              return z(it(yt));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var B = Object.assign, G = 0, H, J, q, Z, O, Q, he;
    function N() {
    }
    N.__reactDisabledLog = !0;
    function ee() {
      {
        if (G === 0) {
          H = console.log, J = console.info, q = console.warn, Z = console.error, O = console.group, Q = console.groupCollapsed, he = console.groupEnd;
          var j = {
            configurable: !0,
            enumerable: !0,
            value: N,
            writable: !0
          };
          Object.defineProperties(console, {
            info: j,
            log: j,
            warn: j,
            error: j,
            group: j,
            groupCollapsed: j,
            groupEnd: j
          });
        }
        G++;
      }
    }
    function ae() {
      {
        if (G--, G === 0) {
          var j = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: B({}, j, {
              value: H
            }),
            info: B({}, j, {
              value: J
            }),
            warn: B({}, j, {
              value: q
            }),
            error: B({}, j, {
              value: Z
            }),
            group: B({}, j, {
              value: O
            }),
            groupCollapsed: B({}, j, {
              value: Q
            }),
            groupEnd: B({}, j, {
              value: he
            })
          });
        }
        G < 0 && E("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var pe = b.ReactCurrentDispatcher, se;
    function Se(j, xe, Te) {
      {
        if (se === void 0)
          try {
            throw Error();
          } catch (pt) {
            var He = pt.stack.trim().match(/\n( *(at )?)/);
            se = He && He[1] || "";
          }
        return `
` + se + j;
      }
    }
    var le = !1, Ee;
    {
      var Ie = typeof WeakMap == "function" ? WeakMap : Map;
      Ee = new Ie();
    }
    function te(j, xe) {
      if (!j || le)
        return "";
      {
        var Te = Ee.get(j);
        if (Te !== void 0)
          return Te;
      }
      var He;
      le = !0;
      var pt = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var yt;
      yt = pe.current, pe.current = null, ee();
      try {
        if (xe) {
          var it = function() {
            throw Error();
          };
          if (Object.defineProperty(it.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(it, []);
            } catch (Gn) {
              He = Gn;
            }
            Reflect.construct(j, [], it);
          } else {
            try {
              it.call();
            } catch (Gn) {
              He = Gn;
            }
            j.call(it.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (Gn) {
            He = Gn;
          }
          j();
        }
      } catch (Gn) {
        if (Gn && He && typeof Gn.stack == "string") {
          for (var Je = Gn.stack.split(`
`), xn = He.stack.split(`
`), jt = Je.length - 1, Gt = xn.length - 1; jt >= 1 && Gt >= 0 && Je[jt] !== xn[Gt]; )
            Gt--;
          for (; jt >= 1 && Gt >= 0; jt--, Gt--)
            if (Je[jt] !== xn[Gt]) {
              if (jt !== 1 || Gt !== 1)
                do
                  if (jt--, Gt--, Gt < 0 || Je[jt] !== xn[Gt]) {
                    var Hn = `
` + Je[jt].replace(" at new ", " at ");
                    return j.displayName && Hn.includes("<anonymous>") && (Hn = Hn.replace("<anonymous>", j.displayName)), typeof j == "function" && Ee.set(j, Hn), Hn;
                  }
                while (jt >= 1 && Gt >= 0);
              break;
            }
        }
      } finally {
        le = !1, pe.current = yt, ae(), Error.prepareStackTrace = pt;
      }
      var Wr = j ? j.displayName || j.name : "", Jc = Wr ? Se(Wr) : "";
      return typeof j == "function" && Ee.set(j, Jc), Jc;
    }
    function Re(j, xe, Te) {
      return te(j, !1);
    }
    function we(j) {
      var xe = j.prototype;
      return !!(xe && xe.isReactComponent);
    }
    function ze(j, xe, Te) {
      if (j == null)
        return "";
      if (typeof j == "function")
        return te(j, we(j));
      if (typeof j == "string")
        return Se(j);
      switch (j) {
        case u:
          return Se("Suspense");
        case d:
          return Se("SuspenseList");
      }
      if (typeof j == "object")
        switch (j.$$typeof) {
          case l:
            return Re(j.render);
          case f:
            return ze(j.type, xe, Te);
          case p: {
            var He = j, pt = He._payload, yt = He._init;
            try {
              return ze(yt(pt), xe, Te);
            } catch {
            }
          }
        }
      return "";
    }
    var dt = Object.prototype.hasOwnProperty, ht = {}, vt = b.ReactDebugCurrentFrame;
    function mt(j) {
      if (j) {
        var xe = j._owner, Te = ze(j.type, j._source, xe ? xe.type : null);
        vt.setExtraStackFrame(Te);
      } else
        vt.setExtraStackFrame(null);
    }
    function Ht(j, xe, Te, He, pt) {
      {
        var yt = Function.call.bind(dt);
        for (var it in j)
          if (yt(j, it)) {
            var Je = void 0;
            try {
              if (typeof j[it] != "function") {
                var xn = Error((He || "React class") + ": " + Te + " type `" + it + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof j[it] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw xn.name = "Invariant Violation", xn;
              }
              Je = j[it](xe, it, He, Te, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (jt) {
              Je = jt;
            }
            Je && !(Je instanceof Error) && (mt(pt), E("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", He || "React class", Te, it, typeof Je), mt(null)), Je instanceof Error && !(Je.message in ht) && (ht[Je.message] = !0, mt(pt), E("Failed %s type: %s", Te, Je.message), mt(null));
          }
      }
    }
    var zt = Array.isArray;
    function Wn(j) {
      return zt(j);
    }
    function Vr(j) {
      {
        var xe = typeof Symbol == "function" && Symbol.toStringTag, Te = xe && j[Symbol.toStringTag] || j.constructor.name || "Object";
        return Te;
      }
    }
    function gn(j) {
      try {
        return nn(j), !1;
      } catch {
        return !0;
      }
    }
    function nn(j) {
      return "" + j;
    }
    function ui(j) {
      if (gn(j))
        return E("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Vr(j)), nn(j);
    }
    var re = b.ReactCurrentOwner, Ce = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Fe, st, lt;
    lt = {};
    function bn(j) {
      if (dt.call(j, "ref")) {
        var xe = Object.getOwnPropertyDescriptor(j, "ref").get;
        if (xe && xe.isReactWarning)
          return !1;
      }
      return j.ref !== void 0;
    }
    function Un(j) {
      if (dt.call(j, "key")) {
        var xe = Object.getOwnPropertyDescriptor(j, "key").get;
        if (xe && xe.isReactWarning)
          return !1;
      }
      return j.key !== void 0;
    }
    function Rn(j, xe) {
      if (typeof j.ref == "string" && re.current && xe && re.current.stateNode !== xe) {
        var Te = z(re.current.type);
        lt[Te] || (E('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', z(re.current.type), j.ref), lt[Te] = !0);
      }
    }
    function Br(j, xe) {
      {
        var Te = function() {
          Fe || (Fe = !0, E("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", xe));
        };
        Te.isReactWarning = !0, Object.defineProperty(j, "key", {
          get: Te,
          configurable: !0
        });
      }
    }
    function jr(j, xe) {
      {
        var Te = function() {
          st || (st = !0, E("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", xe));
        };
        Te.isReactWarning = !0, Object.defineProperty(j, "ref", {
          get: Te,
          configurable: !0
        });
      }
    }
    var Pt = function(j, xe, Te, He, pt, yt, it) {
      var Je = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: t,
        // Built-in properties that belong on the element
        type: j,
        key: xe,
        ref: Te,
        props: it,
        // Record the component responsible for creating this element.
        _owner: yt
      };
      return Je._store = {}, Object.defineProperty(Je._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Je, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: He
      }), Object.defineProperty(Je, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: pt
      }), Object.freeze && (Object.freeze(Je.props), Object.freeze(Je)), Je;
    };
    function Vo(j, xe, Te, He, pt) {
      {
        var yt, it = {}, Je = null, xn = null;
        Te !== void 0 && (ui(Te), Je = "" + Te), Un(xe) && (ui(xe.key), Je = "" + xe.key), bn(xe) && (xn = xe.ref, Rn(xe, pt));
        for (yt in xe)
          dt.call(xe, yt) && !Ce.hasOwnProperty(yt) && (it[yt] = xe[yt]);
        if (j && j.defaultProps) {
          var jt = j.defaultProps;
          for (yt in jt)
            it[yt] === void 0 && (it[yt] = jt[yt]);
        }
        if (Je || xn) {
          var Gt = typeof j == "function" ? j.displayName || j.name || "Unknown" : j;
          Je && Br(it, Gt), xn && jr(it, Gt);
        }
        return Pt(j, Je, xn, pt, He, re.current, it);
      }
    }
    var In = b.ReactCurrentOwner, Gc = b.ReactDebugCurrentFrame;
    function Mi(j) {
      if (j) {
        var xe = j._owner, Te = ze(j.type, j._source, xe ? xe.type : null);
        Gc.setExtraStackFrame(Te);
      } else
        Gc.setExtraStackFrame(null);
    }
    var Da;
    Da = !1;
    function el(j) {
      return typeof j == "object" && j !== null && j.$$typeof === t;
    }
    function qc() {
      {
        if (In.current) {
          var j = z(In.current.type);
          if (j)
            return `

Check the render method of \`` + j + "`.";
        }
        return "";
      }
    }
    function fp(j) {
      {
        if (j !== void 0) {
          var xe = j.fileName.replace(/^.*[\\\/]/, ""), Te = j.lineNumber;
          return `

Check your code at ` + xe + ":" + Te + ".";
        }
        return "";
      }
    }
    var Yc = {};
    function Kc(j) {
      {
        var xe = qc();
        if (!xe) {
          var Te = typeof j == "string" ? j : j.displayName || j.name;
          Te && (xe = `

Check the top-level render call using <` + Te + ">.");
        }
        return xe;
      }
    }
    function Xc(j, xe) {
      {
        if (!j._store || j._store.validated || j.key != null)
          return;
        j._store.validated = !0;
        var Te = Kc(xe);
        if (Yc[Te])
          return;
        Yc[Te] = !0;
        var He = "";
        j && j._owner && j._owner !== In.current && (He = " It was passed a child from " + z(j._owner.type) + "."), Mi(j), E('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Te, He), Mi(null);
      }
    }
    function Zc(j, xe) {
      {
        if (typeof j != "object")
          return;
        if (Wn(j))
          for (var Te = 0; Te < j.length; Te++) {
            var He = j[Te];
            el(He) && Xc(He, xe);
          }
        else if (el(j))
          j._store && (j._store.validated = !0);
        else if (j) {
          var pt = y(j);
          if (typeof pt == "function" && pt !== j.entries)
            for (var yt = pt.call(j), it; !(it = yt.next()).done; )
              el(it.value) && Xc(it.value, xe);
        }
      }
    }
    function hp(j) {
      {
        var xe = j.type;
        if (xe == null || typeof xe == "string")
          return;
        var Te;
        if (typeof xe == "function")
          Te = xe.propTypes;
        else if (typeof xe == "object" && (xe.$$typeof === l || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        xe.$$typeof === f))
          Te = xe.propTypes;
        else
          return;
        if (Te) {
          var He = z(xe);
          Ht(Te, j.props, "prop", He, j);
        } else if (xe.PropTypes !== void 0 && !Da) {
          Da = !0;
          var pt = z(xe);
          E("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", pt || "Unknown");
        }
        typeof xe.getDefaultProps == "function" && !xe.getDefaultProps.isReactClassApproved && E("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function tl(j) {
      {
        for (var xe = Object.keys(j.props), Te = 0; Te < xe.length; Te++) {
          var He = xe[Te];
          if (He !== "children" && He !== "key") {
            Mi(j), E("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", He), Mi(null);
            break;
          }
        }
        j.ref !== null && (Mi(j), E("Invalid attribute `ref` supplied to `React.Fragment`."), Mi(null));
      }
    }
    function Qc(j, xe, Te, He, pt, yt) {
      {
        var it = D(j);
        if (!it) {
          var Je = "";
          (j === void 0 || typeof j == "object" && j !== null && Object.keys(j).length === 0) && (Je += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var xn = fp(pt);
          xn ? Je += xn : Je += qc();
          var jt;
          j === null ? jt = "null" : Wn(j) ? jt = "array" : j !== void 0 && j.$$typeof === t ? (jt = "<" + (z(j.type) || "Unknown") + " />", Je = " Did you accidentally export a JSX literal instead of a component?") : jt = typeof j, E("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", jt, Je);
        }
        var Gt = Vo(j, xe, Te, pt, yt);
        if (Gt == null)
          return Gt;
        if (it) {
          var Hn = xe.children;
          if (Hn !== void 0)
            if (He)
              if (Wn(Hn)) {
                for (var Wr = 0; Wr < Hn.length; Wr++)
                  Zc(Hn[Wr], j);
                Object.freeze && Object.freeze(Hn);
              } else
                E("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Zc(Hn, j);
        }
        return j === r ? tl(Gt) : hp(Gt), Gt;
      }
    }
    function nl(j, xe, Te) {
      return Qc(j, xe, Te, !0);
    }
    function pp(j, xe, Te) {
      return Qc(j, xe, Te, !1);
    }
    var mp = pp, gp = nl;
    _l.Fragment = r, _l.jsx = mp, _l.jsxs = gp;
  }()), _l;
}
process.env.NODE_ENV === "production" ? t0.exports = kX() : t0.exports = TX();
var fe = t0.exports;
function AX(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = C.createContext(a), l = n.length;
    n = [...n, a];
    const u = (f) => {
      var b;
      const { scope: p, children: m, ...g } = f, v = ((b = p == null ? void 0 : p[e]) == null ? void 0 : b[l]) || s, y = C.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ fe.jsx(v.Provider, { value: y, children: m });
    };
    u.displayName = o + "Provider";
    function d(f, p) {
      var v;
      const m = ((v = p == null ? void 0 : p[e]) == null ? void 0 : v[l]) || s, g = C.useContext(m);
      if (g)
        return g;
      if (a !== void 0)
        return a;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [u, d];
  }
  const i = () => {
    const o = n.map((a) => C.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || o;
      return C.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return i.scopeName = e, [r, MX(i, ...t)];
}
function MX(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const a = r.reduce((s, { useScope: l, scopeName: u }) => {
        const f = l(o)[`__scope${u}`];
        return { ...s, ...f };
      }, {});
      return C.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function VP(e) {
  const t = C.useRef(e);
  return C.useEffect(() => {
    t.current = e;
  }), C.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function OX({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, i] = RX({ defaultProp: t, onChange: n }), o = e !== void 0, a = o ? e : r, s = VP(n), l = C.useCallback(
    (u) => {
      if (o) {
        const f = typeof u == "function" ? u(e) : u;
        f !== e && s(f);
      } else
        i(u);
    },
    [o, e, i, s]
  );
  return [a, l];
}
function RX({
  defaultProp: e,
  onChange: t
}) {
  const n = C.useState(e), [r] = n, i = C.useRef(r), o = VP(t);
  return C.useEffect(() => {
    i.current !== r && (o(r), i.current = r);
  }, [r, i, o]), n;
}
var IX = C.createContext(void 0);
function DX(e) {
  const t = C.useContext(IX);
  return e || t || "ltr";
}
function NX(e) {
  const t = C.useRef({ value: e, previous: e });
  return C.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var $X = globalThis != null && globalThis.document ? C.useLayoutEffect : () => {
};
function LX(e) {
  const [t, n] = C.useState(void 0);
  return $X(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const o = i[0];
        let a, s;
        if ("borderBoxSize" in o) {
          const l = o.borderBoxSize, u = Array.isArray(l) ? l[0] : l;
          a = u.inlineSize, s = u.blockSize;
        } else
          a = e.offsetWidth, s = e.offsetHeight;
        n({ width: a, height: s });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var Ef = C.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = C.Children.toArray(n), o = i.find(zX);
  if (o) {
    const a = o.props.children, s = i.map((l) => l === o ? C.Children.count(a) > 1 ? C.Children.only(null) : C.isValidElement(a) ? a.props.children : null : l);
    return /* @__PURE__ */ fe.jsx(n0, { ...r, ref: t, children: C.isValidElement(a) ? C.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ fe.jsx(n0, { ...r, ref: t, children: n });
});
Ef.displayName = "Slot";
var n0 = C.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (C.isValidElement(n)) {
    const i = BX(n);
    return C.cloneElement(n, {
      ...VX(r, n.props),
      // @ts-ignore
      ref: t ? zP(t, i) : i
    });
  }
  return C.Children.count(n) > 1 ? C.Children.only(null) : null;
});
n0.displayName = "SlotClone";
var FX = ({ children: e }) => /* @__PURE__ */ fe.jsx(fe.Fragment, { children: e });
function zX(e) {
  return C.isValidElement(e) && e.type === FX;
}
function VX(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...s) => {
      o(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function BX(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var jX = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Rh = jX.reduce((e, t) => {
  const n = C.forwardRef((r, i) => {
    const { asChild: o, ...a } = r, s = o ? Ef : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ fe.jsx(s, { ...a, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {});
function WX(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = C.createContext(a), l = n.length;
    n = [...n, a];
    function u(f) {
      const { scope: p, children: m, ...g } = f, v = (p == null ? void 0 : p[e][l]) || s, y = C.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ fe.jsx(v.Provider, { value: y, children: m });
    }
    function d(f, p) {
      const m = (p == null ? void 0 : p[e][l]) || s, g = C.useContext(m);
      if (g)
        return g;
      if (a !== void 0)
        return a;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return u.displayName = o + "Provider", [u, d];
  }
  const i = () => {
    const o = n.map((a) => C.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || o;
      return C.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return i.scopeName = e, [r, UX(i, ...t)];
}
function UX(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const a = r.reduce((s, { useScope: l, scopeName: u }) => {
        const f = l(o)[`__scope${u}`];
        return { ...s, ...f };
      }, {});
      return C.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function HX(e) {
  const t = e + "CollectionProvider", [n, r] = WX(t), [i, o] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (m) => {
    const { scope: g, children: v } = m, y = x.useRef(null), b = x.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ fe.jsx(i, { scope: g, itemMap: b, collectionRef: y, children: v });
  };
  a.displayName = t;
  const s = e + "CollectionSlot", l = x.forwardRef(
    (m, g) => {
      const { scope: v, children: y } = m, b = o(s, v), E = ba(g, b.collectionRef);
      return /* @__PURE__ */ fe.jsx(Ef, { ref: E, children: y });
    }
  );
  l.displayName = s;
  const u = e + "CollectionItemSlot", d = "data-radix-collection-item", f = x.forwardRef(
    (m, g) => {
      const { scope: v, children: y, ...b } = m, E = x.useRef(null), S = ba(g, E), _ = o(u, v);
      return x.useEffect(() => (_.itemMap.set(E, { ref: E, ...b }), () => void _.itemMap.delete(E))), /* @__PURE__ */ fe.jsx(Ef, { [d]: "", ref: S, children: y });
    }
  );
  f.displayName = u;
  function p(m) {
    const g = o(e + "CollectionConsumer", m);
    return x.useCallback(() => {
      const y = g.collectionRef.current;
      if (!y)
        return [];
      const b = Array.from(y.querySelectorAll(`[${d}]`));
      return Array.from(g.itemMap.values()).sort(
        (_, k) => b.indexOf(_.ref.current) - b.indexOf(k.ref.current)
      );
    }, [g.collectionRef, g.itemMap]);
  }
  return [
    { Provider: a, Slot: l, ItemSlot: f },
    p,
    r
  ];
}
var BP = ["PageUp", "PageDown"], jP = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], WP = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, qs = "Slider", [r0, GX, qX] = HX(qs), [UP, wye] = AX(qs, [
  qX
]), [YX, Ih] = UP(qs), HP = C.forwardRef(
  (e, t) => {
    const {
      name: n,
      min: r = 0,
      max: i = 100,
      step: o = 1,
      orientation: a = "horizontal",
      disabled: s = !1,
      minStepsBetweenThumbs: l = 0,
      defaultValue: u = [r],
      value: d,
      onValueChange: f = () => {
      },
      onValueCommit: p = () => {
      },
      inverted: m = !1,
      form: g,
      ...v
    } = e, y = C.useRef(/* @__PURE__ */ new Set()), b = C.useRef(0), S = a === "horizontal" ? KX : XX, [_ = [], k] = OX({
      prop: d,
      defaultProp: u,
      onChange: (W) => {
        var z;
        (z = [...y.current][b.current]) == null || z.focus(), f(W);
      }
    }), T = C.useRef(_);
    function A(W) {
      const L = tZ(_, W);
      D(W, L);
    }
    function R(W) {
      D(W, b.current);
    }
    function F() {
      const W = T.current[b.current];
      _[b.current] !== W && p(_);
    }
    function D(W, L, { commit: z } = { commit: !1 }) {
      const B = oZ(o), G = aZ(Math.round((W - r) / o) * o + r, B), H = FP(G, [r, i]);
      k((J = []) => {
        const q = JX(J, H, L);
        if (iZ(q, l * o)) {
          b.current = q.indexOf(H);
          const Z = String(q) !== String(J);
          return Z && z && p(q), Z ? q : J;
        } else
          return J;
      });
    }
    return /* @__PURE__ */ fe.jsx(
      YX,
      {
        scope: e.__scopeSlider,
        name: n,
        disabled: s,
        min: r,
        max: i,
        valueIndexToChangeRef: b,
        thumbs: y.current,
        values: _,
        orientation: a,
        form: g,
        children: /* @__PURE__ */ fe.jsx(r0.Provider, { scope: e.__scopeSlider, children: /* @__PURE__ */ fe.jsx(r0.Slot, { scope: e.__scopeSlider, children: /* @__PURE__ */ fe.jsx(
          S,
          {
            "aria-disabled": s,
            "data-disabled": s ? "" : void 0,
            ...v,
            ref: t,
            onPointerDown: hs(v.onPointerDown, () => {
              s || (T.current = _);
            }),
            min: r,
            max: i,
            inverted: m,
            onSlideStart: s ? void 0 : A,
            onSlideMove: s ? void 0 : R,
            onSlideEnd: s ? void 0 : F,
            onHomeKeyDown: () => !s && D(r, 0, { commit: !0 }),
            onEndKeyDown: () => !s && D(i, _.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: W, direction: L }) => {
              if (!s) {
                const G = BP.includes(W.key) || W.shiftKey && jP.includes(W.key) ? 10 : 1, H = b.current, J = _[H], q = o * G * L;
                D(J + q, H, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
HP.displayName = qs;
var [GP, qP] = UP(qs, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), KX = C.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: r,
      dir: i,
      inverted: o,
      onSlideStart: a,
      onSlideMove: s,
      onSlideEnd: l,
      onStepKeyDown: u,
      ...d
    } = e, [f, p] = C.useState(null), m = ba(t, (S) => p(S)), g = C.useRef(), v = DX(i), y = v === "ltr", b = y && !o || !y && o;
    function E(S) {
      const _ = g.current || f.getBoundingClientRect(), k = [0, _.width], A = Oy(k, b ? [n, r] : [r, n]);
      return g.current = _, A(S - _.left);
    }
    return /* @__PURE__ */ fe.jsx(
      GP,
      {
        scope: e.__scopeSlider,
        startEdge: b ? "left" : "right",
        endEdge: b ? "right" : "left",
        direction: b ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ fe.jsx(
          YP,
          {
            dir: v,
            "data-orientation": "horizontal",
            ...d,
            ref: m,
            style: {
              ...d.style,
              ["--radix-slider-thumb-transform"]: "translateX(-50%)"
            },
            onSlideStart: (S) => {
              const _ = E(S.clientX);
              a == null || a(_);
            },
            onSlideMove: (S) => {
              const _ = E(S.clientX);
              s == null || s(_);
            },
            onSlideEnd: () => {
              g.current = void 0, l == null || l();
            },
            onStepKeyDown: (S) => {
              const k = WP[b ? "from-left" : "from-right"].includes(S.key);
              u == null || u({ event: S, direction: k ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), XX = C.forwardRef(
  (e, t) => {
    const {
      min: n,
      max: r,
      inverted: i,
      onSlideStart: o,
      onSlideMove: a,
      onSlideEnd: s,
      onStepKeyDown: l,
      ...u
    } = e, d = C.useRef(null), f = ba(t, d), p = C.useRef(), m = !i;
    function g(v) {
      const y = p.current || d.current.getBoundingClientRect(), b = [0, y.height], S = Oy(b, m ? [r, n] : [n, r]);
      return p.current = y, S(v - y.top);
    }
    return /* @__PURE__ */ fe.jsx(
      GP,
      {
        scope: e.__scopeSlider,
        startEdge: m ? "bottom" : "top",
        endEdge: m ? "top" : "bottom",
        size: "height",
        direction: m ? 1 : -1,
        children: /* @__PURE__ */ fe.jsx(
          YP,
          {
            "data-orientation": "vertical",
            ...u,
            ref: f,
            style: {
              ...u.style,
              ["--radix-slider-thumb-transform"]: "translateY(50%)"
            },
            onSlideStart: (v) => {
              const y = g(v.clientY);
              o == null || o(y);
            },
            onSlideMove: (v) => {
              const y = g(v.clientY);
              a == null || a(y);
            },
            onSlideEnd: () => {
              p.current = void 0, s == null || s();
            },
            onStepKeyDown: (v) => {
              const b = WP[m ? "from-bottom" : "from-top"].includes(v.key);
              l == null || l({ event: v, direction: b ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), YP = C.forwardRef(
  (e, t) => {
    const {
      __scopeSlider: n,
      onSlideStart: r,
      onSlideMove: i,
      onSlideEnd: o,
      onHomeKeyDown: a,
      onEndKeyDown: s,
      onStepKeyDown: l,
      ...u
    } = e, d = Ih(qs, n);
    return /* @__PURE__ */ fe.jsx(
      Rh.span,
      {
        ...u,
        ref: t,
        onKeyDown: hs(e.onKeyDown, (f) => {
          f.key === "Home" ? (a(f), f.preventDefault()) : f.key === "End" ? (s(f), f.preventDefault()) : BP.concat(jP).includes(f.key) && (l(f), f.preventDefault());
        }),
        onPointerDown: hs(e.onPointerDown, (f) => {
          const p = f.target;
          p.setPointerCapture(f.pointerId), f.preventDefault(), d.thumbs.has(p) ? p.focus() : r(f);
        }),
        onPointerMove: hs(e.onPointerMove, (f) => {
          f.target.hasPointerCapture(f.pointerId) && i(f);
        }),
        onPointerUp: hs(e.onPointerUp, (f) => {
          const p = f.target;
          p.hasPointerCapture(f.pointerId) && (p.releasePointerCapture(f.pointerId), o(f));
        })
      }
    );
  }
), KP = "SliderTrack", XP = C.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...r } = e, i = Ih(KP, n);
    return /* @__PURE__ */ fe.jsx(
      Rh.span,
      {
        "data-disabled": i.disabled ? "" : void 0,
        "data-orientation": i.orientation,
        ...r,
        ref: t
      }
    );
  }
);
XP.displayName = KP;
var i0 = "SliderRange", ZP = C.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, ...r } = e, i = Ih(i0, n), o = qP(i0, n), a = C.useRef(null), s = ba(t, a), l = i.values.length, u = i.values.map(
      (p) => JP(p, i.min, i.max)
    ), d = l > 1 ? Math.min(...u) : 0, f = 100 - Math.max(...u);
    return /* @__PURE__ */ fe.jsx(
      Rh.span,
      {
        "data-orientation": i.orientation,
        "data-disabled": i.disabled ? "" : void 0,
        ...r,
        ref: s,
        style: {
          ...e.style,
          [o.startEdge]: d + "%",
          [o.endEdge]: f + "%"
        }
      }
    );
  }
);
ZP.displayName = i0;
var o0 = "SliderThumb", QP = C.forwardRef(
  (e, t) => {
    const n = GX(e.__scopeSlider), [r, i] = C.useState(null), o = ba(t, (s) => i(s)), a = C.useMemo(
      () => r ? n().findIndex((s) => s.ref.current === r) : -1,
      [n, r]
    );
    return /* @__PURE__ */ fe.jsx(ZX, { ...e, ref: o, index: a });
  }
), ZX = C.forwardRef(
  (e, t) => {
    const { __scopeSlider: n, index: r, name: i, ...o } = e, a = Ih(o0, n), s = qP(o0, n), [l, u] = C.useState(null), d = ba(t, (E) => u(E)), f = l ? a.form || !!l.closest("form") : !0, p = LX(l), m = a.values[r], g = m === void 0 ? 0 : JP(m, a.min, a.max), v = eZ(r, a.values.length), y = p == null ? void 0 : p[s.size], b = y ? nZ(y, g, s.direction) : 0;
    return C.useEffect(() => {
      if (l)
        return a.thumbs.add(l), () => {
          a.thumbs.delete(l);
        };
    }, [l, a.thumbs]), /* @__PURE__ */ fe.jsxs(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [s.startEdge]: `calc(${g}% + ${b}px)`
        },
        children: [
          /* @__PURE__ */ fe.jsx(r0.ItemSlot, { scope: e.__scopeSlider, children: /* @__PURE__ */ fe.jsx(
            Rh.span,
            {
              role: "slider",
              "aria-label": e["aria-label"] || v,
              "aria-valuemin": a.min,
              "aria-valuenow": m,
              "aria-valuemax": a.max,
              "aria-orientation": a.orientation,
              "data-orientation": a.orientation,
              "data-disabled": a.disabled ? "" : void 0,
              tabIndex: a.disabled ? void 0 : 0,
              ...o,
              ref: d,
              style: m === void 0 ? { display: "none" } : e.style,
              onFocus: hs(e.onFocus, () => {
                a.valueIndexToChangeRef.current = r;
              })
            }
          ) }),
          f && /* @__PURE__ */ fe.jsx(
            QX,
            {
              name: i ?? (a.name ? a.name + (a.values.length > 1 ? "[]" : "") : void 0),
              form: a.form,
              value: m
            },
            r
          )
        ]
      }
    );
  }
);
QP.displayName = o0;
var QX = (e) => {
  const { value: t, ...n } = e, r = C.useRef(null), i = NX(t);
  return C.useEffect(() => {
    const o = r.current, a = window.HTMLInputElement.prototype, l = Object.getOwnPropertyDescriptor(a, "value").set;
    if (i !== t && l) {
      const u = new Event("input", { bubbles: !0 });
      l.call(o, t), o.dispatchEvent(u);
    }
  }, [i, t]), /* @__PURE__ */ fe.jsx("input", { style: { display: "none" }, ...n, ref: r, defaultValue: t });
};
function JX(e = [], t, n) {
  const r = [...e];
  return r[n] = t, r.sort((i, o) => i - o);
}
function JP(e, t, n) {
  const o = 100 / (n - t) * (e - t);
  return FP(o, [0, 100]);
}
function eZ(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][e] : void 0;
}
function tZ(e, t) {
  if (e.length === 1)
    return 0;
  const n = e.map((i) => Math.abs(i - t)), r = Math.min(...n);
  return n.indexOf(r);
}
function nZ(e, t, n) {
  const r = e / 2, o = Oy([0, 50], [0, r]);
  return (r - o(t) * n) * n;
}
function rZ(e) {
  return e.slice(0, -1).map((t, n) => e[n + 1] - t);
}
function iZ(e, t) {
  if (t > 0) {
    const n = rZ(e);
    return Math.min(...n) >= t;
  }
  return !0;
}
function Oy(e, t) {
  return (n) => {
    if (e[0] === e[1] || t[0] === t[1])
      return t[0];
    const r = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + r * (n - e[0]);
  };
}
function oZ(e) {
  return (String(e).split(".")[1] || "").length;
}
function aZ(e, t) {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
}
var ek = HP, sZ = XP, lZ = ZP, cZ = QP;
const tk = C.forwardRef(({ className: e, variant: t = "neutral", ...n }, r) => {
  var i;
  return /* @__PURE__ */ C.createElement(
    ek,
    {
      ref: r,
      className: ie(
        "ai-tw-relative ai-tw-flex ai-tw-w-full ai-tw-touch-none ai-tw-select-none ai-tw-items-center",
        "data-[orientation='horizontal']:ai-tw-h-1.5 data-[orientation='horizontal']:ai-tw-w-full data-[orientation='horizontal']:ai-tw-items-center",
        "data-[orientation='vertical']:ai-tw-h-full data-[orientation='vertical']:ai-tw-w-1.5 data-[orientation='vertical']:ai-tw-justify-center",
        n.disabled && "ai-tw-pointer-events-none ai-tw-opacity-50",
        e
      ),
      ...n
    },
    /* @__PURE__ */ C.createElement(
      sZ,
      {
        className: ie(
          "ai-tw-relative ai-tw-grow ai-tw-overflow-hidden ai-tw-rounded-full ",
          t === "brand" && "ai-tw-bg-element-brand-light",
          t === "neutral" && "ai-tw-bg-element-primary-subtle-dark",
          "data-[orientation='horizontal']:ai-tw-h-1.5 data-[orientation='horizontal']:ai-tw-w-full",
          "data-[orientation='vertical']:ai-tw-h-full data-[orientation='vertical']:ai-tw-w-1.5"
        )
      },
      /* @__PURE__ */ C.createElement(
        lZ,
        {
          className: ie(
            "ai-tw-absolute",
            t === "brand" && "ai-tw-bg-element-brand-dark",
            t === "neutral" && "ai-tw-bg-element-primary-bold",
            "data-[orientation='horizontal']:ai-tw-h-full",
            "data-[orientation='vertical']:ai-tw-w-full"
          )
        }
      )
    ),
    (i = n.defaultValue || n.value) == null ? void 0 : i.map((o, a) => /* @__PURE__ */ C.createElement(
      cZ,
      {
        key: `thumb-${a}`,
        className: ie(
          "ai-tw-block ai-tw-h-3 ai-tw-w-3 ai-tw-rounded-full ai-tw-border-2 ai-tw-border-solid ai-tw-bg-background ai-tw-ring-offset-background ai-tw-transition-colors focus-visible:ai-tw-outline-none focus-visible:ai-tw-ring-2 focus-visible:ai-tw-ring-ring focus-visible:ai-tw-ring-offset-2 disabled:ai-tw-pointer-events-none disabled:ai-tw-opacity-50",
          t === "brand" && "ai-tw-border-element-brand-dark",
          t === "neutral" && "ai-tw-border-element-primary-bold"
        )
      }
    ))
  );
});
tk.displayName = ek.displayName;
function uZ(e) {
  return e === 0 ? oL : e <= 33 ? _$ : e <= 66 ? D$ : H$;
}
const dZ = ({ volume: e, onChangeVolume: t }) => {
  const n = uZ(e);
  return /* @__PURE__ */ x.createElement(LP, { modal: !1 }, /* @__PURE__ */ x.createElement(My, null, /* @__PURE__ */ x.createElement("span", { className: "ai-tw-p-2", "aria-label": "Volume Controls" }, /* @__PURE__ */ x.createElement(Le, { fixedWidth: !0, icon: n }))), /* @__PURE__ */ x.createElement(Oh, { side: "top", className: "ai-tw-h-28 ai-tw-w-fit" }, /* @__PURE__ */ x.createElement(
    tk,
    {
      value: [e],
      onValueChange: ([r]) => t(r),
      orientation: "vertical",
      step: 5
    }
  )));
}, fZ = ({
  audioRef: e,
  duration: t,
  isPlaying: n,
  setIsPlaying: r,
  setTimeProgress: i,
  timeProgress: o
}) => {
  var p;
  const [a, s] = de(60), [l, u] = de(!1);
  if (!((p = e.current) != null && p.src))
    return null;
  const d = (m) => {
    s(m), e.current && (e.current.volume = m / 100);
  }, f = () => {
    var g;
    !n ? (g = e.current) != null && g.currentSrc ? e.current.play() : u(!0) : e.current && e.current.pause(), r((v) => !v);
  };
  return /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement(
    bX,
    {
      isPlaying: n,
      isLoading: l,
      onClick: f
    }
  ), /* @__PURE__ */ x.createElement(
    CX,
    {
      audioRef: e,
      duration: t,
      timeProgress: o,
      setTimeProgress: i
    }
  ), /* @__PURE__ */ x.createElement(dZ, { volume: a, onChangeVolume: d }));
};
function Ry({
  isPlaying: e,
  setIsPlaying: t,
  ...n
}) {
  const [r, i] = de(0), [o, a] = de(0), s = me(null), { onTimeUpdate: l, onEnded: u, onLoadedMetadata: d, ...f } = n;
  return /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement(
    "audio",
    {
      crossOrigin: "anonymous",
      preload: "metadata",
      ref: s,
      onTimeUpdate: (p) => {
        a(p.currentTarget.currentTime), p.currentTarget.duration && i(p.currentTarget.duration), n.onTimeUpdate && n.onTimeUpdate(p);
      },
      onEnded: (p) => {
        t(!1), n.onEnded && n.onEnded(p);
      },
      onLoadedMetadata: (p) => {
        const m = p.currentTarget.duration;
        m === 1 / 0 && s.current ? (s.current.currentTime = 1e101, setTimeout(() => {
          s.current && (s.current.currentTime = 0);
        }, 500)) : i(m), n.onLoadedMetadata && n.onLoadedMetadata(p);
      },
      ...f
    }
  ), /* @__PURE__ */ x.createElement(
    fZ,
    {
      audioRef: s,
      duration: r,
      isPlaying: e,
      setIsPlaying: t,
      setTimeProgress: a,
      timeProgress: o
    }
  ));
}
const nk = C.forwardRef(
  ({ className: e, withFade: t, children: n, onScroll: r, ...i }, o) => {
    const a = C.useRef(null);
    C.useImperativeHandle(
      o,
      () => a.current
    );
    const [s, l] = C.useState(!1);
    C.useEffect(() => {
      if (a.current && t) {
        const d = new ResizeObserver(() => {
          if (!a.current)
            return;
          const { scrollTop: f, scrollHeight: p, clientHeight: m } = a.current;
          l(f + m >= p);
        });
        return d.observe(a.current), () => d.disconnect();
      }
    }, [t]);
    function u(d) {
      if (t) {
        const { scrollTop: f, scrollHeight: p, clientHeight: m } = d.currentTarget;
        l(f + m >= p);
      }
      r == null || r(d);
    }
    return /* @__PURE__ */ C.createElement("div", { className: "ai-tw-relative ai-tw-overflow-hidden" }, /* @__PURE__ */ C.createElement(
      "div",
      {
        ref: a,
        className: ie("ai-tw-overflow-auto", e),
        onScroll: u,
        ...i
      },
      n
    ), /* @__PURE__ */ C.createElement(
      "div",
      {
        className: ie(
          !t || s ? "ai-tw-opacity-0" : "ai-tw-opacity-100",
          "ai-tw-pointer-events-none ai-tw-absolute ai-tw-bottom-0 ai-tw-h-8 ai-tw-w-full ai-tw-bg-gradient-to-b ai-tw-from-transparent ai-tw-to-white"
        )
      }
    ));
  }
);
nk.displayName = "ScrollArea";
const rk = "Tabs", [hZ, bye] = rr(rk, [
  Us
]), ik = Us(), [pZ, Iy] = hZ(rk), mZ = /* @__PURE__ */ ke((e, t) => {
  const { __scopeTabs: n, value: r, onValueChange: i, defaultValue: o, orientation: a = "horizontal", dir: s, activationMode: l = "automatic", ...u } = e, d = Nc(s), [f, p] = li({
    prop: r,
    onChange: i,
    defaultProp: o
  });
  return /* @__PURE__ */ X(pZ, {
    scope: n,
    baseId: ti(),
    value: f,
    onValueChange: p,
    orientation: a,
    dir: d,
    activationMode: l
  }, /* @__PURE__ */ X(rt.div, ge({
    dir: d,
    "data-orientation": a
  }, u, {
    ref: t
  })));
}), gZ = "TabsList", vZ = /* @__PURE__ */ ke((e, t) => {
  const { __scopeTabs: n, loop: r = !0, ...i } = e, o = Iy(gZ, n), a = ik(n);
  return /* @__PURE__ */ X(Ey, ge({
    asChild: !0
  }, a, {
    orientation: o.orientation,
    dir: o.dir,
    loop: r
  }), /* @__PURE__ */ X(rt.div, ge({
    role: "tablist",
    "aria-orientation": o.orientation
  }, i, {
    ref: t
  })));
}), yZ = "TabsTrigger", wZ = /* @__PURE__ */ ke((e, t) => {
  const { __scopeTabs: n, value: r, disabled: i = !1, ...o } = e, a = Iy(yZ, n), s = ik(n), l = ok(a.baseId, r), u = ak(a.baseId, r), d = r === a.value;
  return /* @__PURE__ */ X(Cy, ge({
    asChild: !0
  }, s, {
    focusable: !i,
    active: d
  }), /* @__PURE__ */ X(rt.button, ge({
    type: "button",
    role: "tab",
    "aria-selected": d,
    "aria-controls": u,
    "data-state": d ? "active" : "inactive",
    "data-disabled": i ? "" : void 0,
    disabled: i,
    id: l
  }, o, {
    ref: t,
    onMouseDown: $e(e.onMouseDown, (f) => {
      !i && f.button === 0 && f.ctrlKey === !1 ? a.onValueChange(r) : f.preventDefault();
    }),
    onKeyDown: $e(e.onKeyDown, (f) => {
      [
        " ",
        "Enter"
      ].includes(f.key) && a.onValueChange(r);
    }),
    onFocus: $e(e.onFocus, () => {
      const f = a.activationMode !== "manual";
      !d && !i && f && a.onValueChange(r);
    })
  })));
}), bZ = "TabsContent", xZ = /* @__PURE__ */ ke((e, t) => {
  const { __scopeTabs: n, value: r, forceMount: i, children: o, ...a } = e, s = Iy(bZ, n), l = ok(s.baseId, r), u = ak(s.baseId, r), d = r === s.value, f = me(d);
  return be(() => {
    const p = requestAnimationFrame(
      () => f.current = !1
    );
    return () => cancelAnimationFrame(p);
  }, []), /* @__PURE__ */ X(
    On,
    {
      present: i || d
    },
    ({ present: p }) => /* @__PURE__ */ X(rt.div, ge({
      "data-state": d ? "active" : "inactive",
      "data-orientation": s.orientation,
      role: "tabpanel",
      "aria-labelledby": l,
      hidden: !p,
      id: u,
      tabIndex: 0
    }, a, {
      ref: t,
      style: {
        ...e.style,
        animationDuration: f.current ? "0s" : void 0
      }
    }), p && o)
  );
});
function ok(e, t) {
  return `${e}-trigger-${t}`;
}
function ak(e, t) {
  return `${e}-content-${t}`;
}
const Dy = mZ, Dh = vZ, Nh = wZ, $h = xZ;
var Cf = { exports: {} };
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
Cf.exports;
(function(e, t) {
  (function() {
    var n, r = "4.17.21", i = 200, o = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", a = "Expected a function", s = "Invalid `variable` option passed into `_.template`", l = "__lodash_hash_undefined__", u = 500, d = "__lodash_placeholder__", f = 1, p = 2, m = 4, g = 1, v = 2, y = 1, b = 2, E = 4, S = 8, _ = 16, k = 32, T = 64, A = 128, R = 256, F = 512, D = 30, W = "...", L = 800, z = 16, B = 1, G = 2, H = 3, J = 1 / 0, q = 9007199254740991, Z = 17976931348623157e292, O = 0 / 0, Q = 4294967295, he = Q - 1, N = Q >>> 1, ee = [
      ["ary", A],
      ["bind", y],
      ["bindKey", b],
      ["curry", S],
      ["curryRight", _],
      ["flip", F],
      ["partial", k],
      ["partialRight", T],
      ["rearg", R]
    ], ae = "[object Arguments]", pe = "[object Array]", se = "[object AsyncFunction]", Se = "[object Boolean]", le = "[object Date]", Ee = "[object DOMException]", Ie = "[object Error]", te = "[object Function]", Re = "[object GeneratorFunction]", we = "[object Map]", ze = "[object Number]", dt = "[object Null]", ht = "[object Object]", vt = "[object Promise]", mt = "[object Proxy]", Ht = "[object RegExp]", zt = "[object Set]", Wn = "[object String]", Vr = "[object Symbol]", gn = "[object Undefined]", nn = "[object WeakMap]", ui = "[object WeakSet]", re = "[object ArrayBuffer]", Ce = "[object DataView]", Fe = "[object Float32Array]", st = "[object Float64Array]", lt = "[object Int8Array]", bn = "[object Int16Array]", Un = "[object Int32Array]", Rn = "[object Uint8Array]", Br = "[object Uint8ClampedArray]", jr = "[object Uint16Array]", Pt = "[object Uint32Array]", Vo = /\b__p \+= '';/g, In = /\b(__p \+=) '' \+/g, Gc = /(__e\(.*?\)|\b__t\)) \+\n'';/g, Mi = /&(?:amp|lt|gt|quot|#39);/g, Da = /[&<>"']/g, el = RegExp(Mi.source), qc = RegExp(Da.source), fp = /<%-([\s\S]+?)%>/g, Yc = /<%([\s\S]+?)%>/g, Kc = /<%=([\s\S]+?)%>/g, Xc = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Zc = /^\w*$/, hp = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, tl = /[\\^$.*+?()[\]{}|]/g, Qc = RegExp(tl.source), nl = /^\s+/, pp = /\s/, mp = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, gp = /\{\n\/\* \[wrapped with (.+)\] \*/, j = /,? & /, xe = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g, Te = /[()=,{}\[\]\/\s]/, He = /\\(\\)?/g, pt = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g, yt = /\w*$/, it = /^[-+]0x[0-9a-f]+$/i, Je = /^0b[01]+$/i, xn = /^\[object .+?Constructor\]$/, jt = /^0o[0-7]+$/i, Gt = /^(?:0|[1-9]\d*)$/, Hn = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, Wr = /($^)/, Jc = /['\n\r\u2028\u2029\\]/g, Gn = "\\ud800-\\udfff", dM = "\\u0300-\\u036f", fM = "\\ufe20-\\ufe2f", hM = "\\u20d0-\\u20ff", Fw = dM + fM + hM, zw = "\\u2700-\\u27bf", Vw = "a-z\\xdf-\\xf6\\xf8-\\xff", pM = "\\xac\\xb1\\xd7\\xf7", mM = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", gM = "\\u2000-\\u206f", vM = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Bw = "A-Z\\xc0-\\xd6\\xd8-\\xde", jw = "\\ufe0e\\ufe0f", Ww = pM + mM + gM + vM, vp = "['’]", yM = "[" + Gn + "]", Uw = "[" + Ww + "]", eu = "[" + Fw + "]", Hw = "\\d+", wM = "[" + zw + "]", Gw = "[" + Vw + "]", qw = "[^" + Gn + Ww + Hw + zw + Vw + Bw + "]", yp = "\\ud83c[\\udffb-\\udfff]", bM = "(?:" + eu + "|" + yp + ")", Yw = "[^" + Gn + "]", wp = "(?:\\ud83c[\\udde6-\\uddff]){2}", bp = "[\\ud800-\\udbff][\\udc00-\\udfff]", Na = "[" + Bw + "]", Kw = "\\u200d", Xw = "(?:" + Gw + "|" + qw + ")", xM = "(?:" + Na + "|" + qw + ")", Zw = "(?:" + vp + "(?:d|ll|m|re|s|t|ve))?", Qw = "(?:" + vp + "(?:D|LL|M|RE|S|T|VE))?", Jw = bM + "?", eb = "[" + jw + "]?", EM = "(?:" + Kw + "(?:" + [Yw, wp, bp].join("|") + ")" + eb + Jw + ")*", CM = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", SM = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", tb = eb + Jw + EM, _M = "(?:" + [wM, wp, bp].join("|") + ")" + tb, PM = "(?:" + [Yw + eu + "?", eu, wp, bp, yM].join("|") + ")", kM = RegExp(vp, "g"), TM = RegExp(eu, "g"), xp = RegExp(yp + "(?=" + yp + ")|" + PM + tb, "g"), AM = RegExp([
      Na + "?" + Gw + "+" + Zw + "(?=" + [Uw, Na, "$"].join("|") + ")",
      xM + "+" + Qw + "(?=" + [Uw, Na + Xw, "$"].join("|") + ")",
      Na + "?" + Xw + "+" + Zw,
      Na + "+" + Qw,
      SM,
      CM,
      Hw,
      _M
    ].join("|"), "g"), MM = RegExp("[" + Kw + Gn + Fw + jw + "]"), OM = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/, RM = [
      "Array",
      "Buffer",
      "DataView",
      "Date",
      "Error",
      "Float32Array",
      "Float64Array",
      "Function",
      "Int8Array",
      "Int16Array",
      "Int32Array",
      "Map",
      "Math",
      "Object",
      "Promise",
      "RegExp",
      "Set",
      "String",
      "Symbol",
      "TypeError",
      "Uint8Array",
      "Uint8ClampedArray",
      "Uint16Array",
      "Uint32Array",
      "WeakMap",
      "_",
      "clearTimeout",
      "isFinite",
      "parseInt",
      "setTimeout"
    ], IM = -1, It = {};
    It[Fe] = It[st] = It[lt] = It[bn] = It[Un] = It[Rn] = It[Br] = It[jr] = It[Pt] = !0, It[ae] = It[pe] = It[re] = It[Se] = It[Ce] = It[le] = It[Ie] = It[te] = It[we] = It[ze] = It[ht] = It[Ht] = It[zt] = It[Wn] = It[nn] = !1;
    var Mt = {};
    Mt[ae] = Mt[pe] = Mt[re] = Mt[Ce] = Mt[Se] = Mt[le] = Mt[Fe] = Mt[st] = Mt[lt] = Mt[bn] = Mt[Un] = Mt[we] = Mt[ze] = Mt[ht] = Mt[Ht] = Mt[zt] = Mt[Wn] = Mt[Vr] = Mt[Rn] = Mt[Br] = Mt[jr] = Mt[Pt] = !0, Mt[Ie] = Mt[te] = Mt[nn] = !1;
    var DM = {
      // Latin-1 Supplement block.
      À: "A",
      Á: "A",
      Â: "A",
      Ã: "A",
      Ä: "A",
      Å: "A",
      à: "a",
      á: "a",
      â: "a",
      ã: "a",
      ä: "a",
      å: "a",
      Ç: "C",
      ç: "c",
      Ð: "D",
      ð: "d",
      È: "E",
      É: "E",
      Ê: "E",
      Ë: "E",
      è: "e",
      é: "e",
      ê: "e",
      ë: "e",
      Ì: "I",
      Í: "I",
      Î: "I",
      Ï: "I",
      ì: "i",
      í: "i",
      î: "i",
      ï: "i",
      Ñ: "N",
      ñ: "n",
      Ò: "O",
      Ó: "O",
      Ô: "O",
      Õ: "O",
      Ö: "O",
      Ø: "O",
      ò: "o",
      ó: "o",
      ô: "o",
      õ: "o",
      ö: "o",
      ø: "o",
      Ù: "U",
      Ú: "U",
      Û: "U",
      Ü: "U",
      ù: "u",
      ú: "u",
      û: "u",
      ü: "u",
      Ý: "Y",
      ý: "y",
      ÿ: "y",
      Æ: "Ae",
      æ: "ae",
      Þ: "Th",
      þ: "th",
      ß: "ss",
      // Latin Extended-A block.
      Ā: "A",
      Ă: "A",
      Ą: "A",
      ā: "a",
      ă: "a",
      ą: "a",
      Ć: "C",
      Ĉ: "C",
      Ċ: "C",
      Č: "C",
      ć: "c",
      ĉ: "c",
      ċ: "c",
      č: "c",
      Ď: "D",
      Đ: "D",
      ď: "d",
      đ: "d",
      Ē: "E",
      Ĕ: "E",
      Ė: "E",
      Ę: "E",
      Ě: "E",
      ē: "e",
      ĕ: "e",
      ė: "e",
      ę: "e",
      ě: "e",
      Ĝ: "G",
      Ğ: "G",
      Ġ: "G",
      Ģ: "G",
      ĝ: "g",
      ğ: "g",
      ġ: "g",
      ģ: "g",
      Ĥ: "H",
      Ħ: "H",
      ĥ: "h",
      ħ: "h",
      Ĩ: "I",
      Ī: "I",
      Ĭ: "I",
      Į: "I",
      İ: "I",
      ĩ: "i",
      ī: "i",
      ĭ: "i",
      į: "i",
      ı: "i",
      Ĵ: "J",
      ĵ: "j",
      Ķ: "K",
      ķ: "k",
      ĸ: "k",
      Ĺ: "L",
      Ļ: "L",
      Ľ: "L",
      Ŀ: "L",
      Ł: "L",
      ĺ: "l",
      ļ: "l",
      ľ: "l",
      ŀ: "l",
      ł: "l",
      Ń: "N",
      Ņ: "N",
      Ň: "N",
      Ŋ: "N",
      ń: "n",
      ņ: "n",
      ň: "n",
      ŋ: "n",
      Ō: "O",
      Ŏ: "O",
      Ő: "O",
      ō: "o",
      ŏ: "o",
      ő: "o",
      Ŕ: "R",
      Ŗ: "R",
      Ř: "R",
      ŕ: "r",
      ŗ: "r",
      ř: "r",
      Ś: "S",
      Ŝ: "S",
      Ş: "S",
      Š: "S",
      ś: "s",
      ŝ: "s",
      ş: "s",
      š: "s",
      Ţ: "T",
      Ť: "T",
      Ŧ: "T",
      ţ: "t",
      ť: "t",
      ŧ: "t",
      Ũ: "U",
      Ū: "U",
      Ŭ: "U",
      Ů: "U",
      Ű: "U",
      Ų: "U",
      ũ: "u",
      ū: "u",
      ŭ: "u",
      ů: "u",
      ű: "u",
      ų: "u",
      Ŵ: "W",
      ŵ: "w",
      Ŷ: "Y",
      ŷ: "y",
      Ÿ: "Y",
      Ź: "Z",
      Ż: "Z",
      Ž: "Z",
      ź: "z",
      ż: "z",
      ž: "z",
      Ĳ: "IJ",
      ĳ: "ij",
      Œ: "Oe",
      œ: "oe",
      ŉ: "'n",
      ſ: "s"
    }, NM = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;"
    }, $M = {
      "&amp;": "&",
      "&lt;": "<",
      "&gt;": ">",
      "&quot;": '"',
      "&#39;": "'"
    }, LM = {
      "\\": "\\",
      "'": "'",
      "\n": "n",
      "\r": "r",
      "\u2028": "u2028",
      "\u2029": "u2029"
    }, FM = parseFloat, zM = parseInt, nb = typeof Bi == "object" && Bi && Bi.Object === Object && Bi, VM = typeof self == "object" && self && self.Object === Object && self, En = nb || VM || Function("return this")(), Ep = t && !t.nodeType && t, Bo = Ep && !0 && e && !e.nodeType && e, rb = Bo && Bo.exports === Ep, Cp = rb && nb.process, xr = function() {
      try {
        var Y = Bo && Bo.require && Bo.require("util").types;
        return Y || Cp && Cp.binding && Cp.binding("util");
      } catch {
      }
    }(), ib = xr && xr.isArrayBuffer, ob = xr && xr.isDate, ab = xr && xr.isMap, sb = xr && xr.isRegExp, lb = xr && xr.isSet, cb = xr && xr.isTypedArray;
    function or(Y, oe, ne) {
      switch (ne.length) {
        case 0:
          return Y.call(oe);
        case 1:
          return Y.call(oe, ne[0]);
        case 2:
          return Y.call(oe, ne[0], ne[1]);
        case 3:
          return Y.call(oe, ne[0], ne[1], ne[2]);
      }
      return Y.apply(oe, ne);
    }
    function BM(Y, oe, ne, Oe) {
      for (var Ge = -1, gt = Y == null ? 0 : Y.length; ++Ge < gt; ) {
        var cn = Y[Ge];
        oe(Oe, cn, ne(cn), Y);
      }
      return Oe;
    }
    function Er(Y, oe) {
      for (var ne = -1, Oe = Y == null ? 0 : Y.length; ++ne < Oe && oe(Y[ne], ne, Y) !== !1; )
        ;
      return Y;
    }
    function jM(Y, oe) {
      for (var ne = Y == null ? 0 : Y.length; ne-- && oe(Y[ne], ne, Y) !== !1; )
        ;
      return Y;
    }
    function ub(Y, oe) {
      for (var ne = -1, Oe = Y == null ? 0 : Y.length; ++ne < Oe; )
        if (!oe(Y[ne], ne, Y))
          return !1;
      return !0;
    }
    function io(Y, oe) {
      for (var ne = -1, Oe = Y == null ? 0 : Y.length, Ge = 0, gt = []; ++ne < Oe; ) {
        var cn = Y[ne];
        oe(cn, ne, Y) && (gt[Ge++] = cn);
      }
      return gt;
    }
    function tu(Y, oe) {
      var ne = Y == null ? 0 : Y.length;
      return !!ne && $a(Y, oe, 0) > -1;
    }
    function Sp(Y, oe, ne) {
      for (var Oe = -1, Ge = Y == null ? 0 : Y.length; ++Oe < Ge; )
        if (ne(oe, Y[Oe]))
          return !0;
      return !1;
    }
    function Vt(Y, oe) {
      for (var ne = -1, Oe = Y == null ? 0 : Y.length, Ge = Array(Oe); ++ne < Oe; )
        Ge[ne] = oe(Y[ne], ne, Y);
      return Ge;
    }
    function oo(Y, oe) {
      for (var ne = -1, Oe = oe.length, Ge = Y.length; ++ne < Oe; )
        Y[Ge + ne] = oe[ne];
      return Y;
    }
    function _p(Y, oe, ne, Oe) {
      var Ge = -1, gt = Y == null ? 0 : Y.length;
      for (Oe && gt && (ne = Y[++Ge]); ++Ge < gt; )
        ne = oe(ne, Y[Ge], Ge, Y);
      return ne;
    }
    function WM(Y, oe, ne, Oe) {
      var Ge = Y == null ? 0 : Y.length;
      for (Oe && Ge && (ne = Y[--Ge]); Ge--; )
        ne = oe(ne, Y[Ge], Ge, Y);
      return ne;
    }
    function Pp(Y, oe) {
      for (var ne = -1, Oe = Y == null ? 0 : Y.length; ++ne < Oe; )
        if (oe(Y[ne], ne, Y))
          return !0;
      return !1;
    }
    var UM = kp("length");
    function HM(Y) {
      return Y.split("");
    }
    function GM(Y) {
      return Y.match(xe) || [];
    }
    function db(Y, oe, ne) {
      var Oe;
      return ne(Y, function(Ge, gt, cn) {
        if (oe(Ge, gt, cn))
          return Oe = gt, !1;
      }), Oe;
    }
    function nu(Y, oe, ne, Oe) {
      for (var Ge = Y.length, gt = ne + (Oe ? 1 : -1); Oe ? gt-- : ++gt < Ge; )
        if (oe(Y[gt], gt, Y))
          return gt;
      return -1;
    }
    function $a(Y, oe, ne) {
      return oe === oe ? iO(Y, oe, ne) : nu(Y, fb, ne);
    }
    function qM(Y, oe, ne, Oe) {
      for (var Ge = ne - 1, gt = Y.length; ++Ge < gt; )
        if (Oe(Y[Ge], oe))
          return Ge;
      return -1;
    }
    function fb(Y) {
      return Y !== Y;
    }
    function hb(Y, oe) {
      var ne = Y == null ? 0 : Y.length;
      return ne ? Ap(Y, oe) / ne : O;
    }
    function kp(Y) {
      return function(oe) {
        return oe == null ? n : oe[Y];
      };
    }
    function Tp(Y) {
      return function(oe) {
        return Y == null ? n : Y[oe];
      };
    }
    function pb(Y, oe, ne, Oe, Ge) {
      return Ge(Y, function(gt, cn, kt) {
        ne = Oe ? (Oe = !1, gt) : oe(ne, gt, cn, kt);
      }), ne;
    }
    function YM(Y, oe) {
      var ne = Y.length;
      for (Y.sort(oe); ne--; )
        Y[ne] = Y[ne].value;
      return Y;
    }
    function Ap(Y, oe) {
      for (var ne, Oe = -1, Ge = Y.length; ++Oe < Ge; ) {
        var gt = oe(Y[Oe]);
        gt !== n && (ne = ne === n ? gt : ne + gt);
      }
      return ne;
    }
    function Mp(Y, oe) {
      for (var ne = -1, Oe = Array(Y); ++ne < Y; )
        Oe[ne] = oe(ne);
      return Oe;
    }
    function KM(Y, oe) {
      return Vt(oe, function(ne) {
        return [ne, Y[ne]];
      });
    }
    function mb(Y) {
      return Y && Y.slice(0, wb(Y) + 1).replace(nl, "");
    }
    function ar(Y) {
      return function(oe) {
        return Y(oe);
      };
    }
    function Op(Y, oe) {
      return Vt(oe, function(ne) {
        return Y[ne];
      });
    }
    function rl(Y, oe) {
      return Y.has(oe);
    }
    function gb(Y, oe) {
      for (var ne = -1, Oe = Y.length; ++ne < Oe && $a(oe, Y[ne], 0) > -1; )
        ;
      return ne;
    }
    function vb(Y, oe) {
      for (var ne = Y.length; ne-- && $a(oe, Y[ne], 0) > -1; )
        ;
      return ne;
    }
    function XM(Y, oe) {
      for (var ne = Y.length, Oe = 0; ne--; )
        Y[ne] === oe && ++Oe;
      return Oe;
    }
    var ZM = Tp(DM), QM = Tp(NM);
    function JM(Y) {
      return "\\" + LM[Y];
    }
    function eO(Y, oe) {
      return Y == null ? n : Y[oe];
    }
    function La(Y) {
      return MM.test(Y);
    }
    function tO(Y) {
      return OM.test(Y);
    }
    function nO(Y) {
      for (var oe, ne = []; !(oe = Y.next()).done; )
        ne.push(oe.value);
      return ne;
    }
    function Rp(Y) {
      var oe = -1, ne = Array(Y.size);
      return Y.forEach(function(Oe, Ge) {
        ne[++oe] = [Ge, Oe];
      }), ne;
    }
    function yb(Y, oe) {
      return function(ne) {
        return Y(oe(ne));
      };
    }
    function ao(Y, oe) {
      for (var ne = -1, Oe = Y.length, Ge = 0, gt = []; ++ne < Oe; ) {
        var cn = Y[ne];
        (cn === oe || cn === d) && (Y[ne] = d, gt[Ge++] = ne);
      }
      return gt;
    }
    function ru(Y) {
      var oe = -1, ne = Array(Y.size);
      return Y.forEach(function(Oe) {
        ne[++oe] = Oe;
      }), ne;
    }
    function rO(Y) {
      var oe = -1, ne = Array(Y.size);
      return Y.forEach(function(Oe) {
        ne[++oe] = [Oe, Oe];
      }), ne;
    }
    function iO(Y, oe, ne) {
      for (var Oe = ne - 1, Ge = Y.length; ++Oe < Ge; )
        if (Y[Oe] === oe)
          return Oe;
      return -1;
    }
    function oO(Y, oe, ne) {
      for (var Oe = ne + 1; Oe--; )
        if (Y[Oe] === oe)
          return Oe;
      return Oe;
    }
    function Fa(Y) {
      return La(Y) ? sO(Y) : UM(Y);
    }
    function Ur(Y) {
      return La(Y) ? lO(Y) : HM(Y);
    }
    function wb(Y) {
      for (var oe = Y.length; oe-- && pp.test(Y.charAt(oe)); )
        ;
      return oe;
    }
    var aO = Tp($M);
    function sO(Y) {
      for (var oe = xp.lastIndex = 0; xp.test(Y); )
        ++oe;
      return oe;
    }
    function lO(Y) {
      return Y.match(xp) || [];
    }
    function cO(Y) {
      return Y.match(AM) || [];
    }
    var uO = function Y(oe) {
      oe = oe == null ? En : za.defaults(En.Object(), oe, za.pick(En, RM));
      var ne = oe.Array, Oe = oe.Date, Ge = oe.Error, gt = oe.Function, cn = oe.Math, kt = oe.Object, Ip = oe.RegExp, dO = oe.String, Cr = oe.TypeError, iu = ne.prototype, fO = gt.prototype, Va = kt.prototype, ou = oe["__core-js_shared__"], au = fO.toString, St = Va.hasOwnProperty, hO = 0, bb = function() {
        var c = /[^.]+$/.exec(ou && ou.keys && ou.keys.IE_PROTO || "");
        return c ? "Symbol(src)_1." + c : "";
      }(), su = Va.toString, pO = au.call(kt), mO = En._, gO = Ip(
        "^" + au.call(St).replace(tl, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
      ), lu = rb ? oe.Buffer : n, so = oe.Symbol, cu = oe.Uint8Array, xb = lu ? lu.allocUnsafe : n, uu = yb(kt.getPrototypeOf, kt), Eb = kt.create, Cb = Va.propertyIsEnumerable, du = iu.splice, Sb = so ? so.isConcatSpreadable : n, il = so ? so.iterator : n, jo = so ? so.toStringTag : n, fu = function() {
        try {
          var c = qo(kt, "defineProperty");
          return c({}, "", {}), c;
        } catch {
        }
      }(), vO = oe.clearTimeout !== En.clearTimeout && oe.clearTimeout, yO = Oe && Oe.now !== En.Date.now && Oe.now, wO = oe.setTimeout !== En.setTimeout && oe.setTimeout, hu = cn.ceil, pu = cn.floor, Dp = kt.getOwnPropertySymbols, bO = lu ? lu.isBuffer : n, _b = oe.isFinite, xO = iu.join, EO = yb(kt.keys, kt), un = cn.max, Pn = cn.min, CO = Oe.now, SO = oe.parseInt, Pb = cn.random, _O = iu.reverse, Np = qo(oe, "DataView"), ol = qo(oe, "Map"), $p = qo(oe, "Promise"), Ba = qo(oe, "Set"), al = qo(oe, "WeakMap"), sl = qo(kt, "create"), mu = al && new al(), ja = {}, PO = Yo(Np), kO = Yo(ol), TO = Yo($p), AO = Yo(Ba), MO = Yo(al), gu = so ? so.prototype : n, ll = gu ? gu.valueOf : n, kb = gu ? gu.toString : n;
      function I(c) {
        if (qt(c) && !qe(c) && !(c instanceof ot)) {
          if (c instanceof Sr)
            return c;
          if (St.call(c, "__wrapped__"))
            return T2(c);
        }
        return new Sr(c);
      }
      var Wa = function() {
        function c() {
        }
        return function(h) {
          if (!Wt(h))
            return {};
          if (Eb)
            return Eb(h);
          c.prototype = h;
          var w = new c();
          return c.prototype = n, w;
        };
      }();
      function vu() {
      }
      function Sr(c, h) {
        this.__wrapped__ = c, this.__actions__ = [], this.__chain__ = !!h, this.__index__ = 0, this.__values__ = n;
      }
      I.templateSettings = {
        /**
         * Used to detect `data` property values to be HTML-escaped.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        escape: fp,
        /**
         * Used to detect code to be evaluated.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        evaluate: Yc,
        /**
         * Used to detect `data` property values to inject.
         *
         * @memberOf _.templateSettings
         * @type {RegExp}
         */
        interpolate: Kc,
        /**
         * Used to reference the data object in the template text.
         *
         * @memberOf _.templateSettings
         * @type {string}
         */
        variable: "",
        /**
         * Used to import variables into the compiled template.
         *
         * @memberOf _.templateSettings
         * @type {Object}
         */
        imports: {
          /**
           * A reference to the `lodash` function.
           *
           * @memberOf _.templateSettings.imports
           * @type {Function}
           */
          _: I
        }
      }, I.prototype = vu.prototype, I.prototype.constructor = I, Sr.prototype = Wa(vu.prototype), Sr.prototype.constructor = Sr;
      function ot(c) {
        this.__wrapped__ = c, this.__actions__ = [], this.__dir__ = 1, this.__filtered__ = !1, this.__iteratees__ = [], this.__takeCount__ = Q, this.__views__ = [];
      }
      function OO() {
        var c = new ot(this.__wrapped__);
        return c.__actions__ = qn(this.__actions__), c.__dir__ = this.__dir__, c.__filtered__ = this.__filtered__, c.__iteratees__ = qn(this.__iteratees__), c.__takeCount__ = this.__takeCount__, c.__views__ = qn(this.__views__), c;
      }
      function RO() {
        if (this.__filtered__) {
          var c = new ot(this);
          c.__dir__ = -1, c.__filtered__ = !0;
        } else
          c = this.clone(), c.__dir__ *= -1;
        return c;
      }
      function IO() {
        var c = this.__wrapped__.value(), h = this.__dir__, w = qe(c), P = h < 0, M = w ? c.length : 0, $ = HR(0, M, this.__views__), V = $.start, U = $.end, K = U - V, ce = P ? U : V - 1, ue = this.__iteratees__, ve = ue.length, Ae = 0, Ne = Pn(K, this.__takeCount__);
        if (!w || !P && M == K && Ne == K)
          return Zb(c, this.__actions__);
        var je = [];
        e:
          for (; K-- && Ae < Ne; ) {
            ce += h;
            for (var Xe = -1, We = c[ce]; ++Xe < ve; ) {
              var et = ue[Xe], ct = et.iteratee, cr = et.type, $n = ct(We);
              if (cr == G)
                We = $n;
              else if (!$n) {
                if (cr == B)
                  continue e;
                break e;
              }
            }
            je[Ae++] = We;
          }
        return je;
      }
      ot.prototype = Wa(vu.prototype), ot.prototype.constructor = ot;
      function Wo(c) {
        var h = -1, w = c == null ? 0 : c.length;
        for (this.clear(); ++h < w; ) {
          var P = c[h];
          this.set(P[0], P[1]);
        }
      }
      function DO() {
        this.__data__ = sl ? sl(null) : {}, this.size = 0;
      }
      function NO(c) {
        var h = this.has(c) && delete this.__data__[c];
        return this.size -= h ? 1 : 0, h;
      }
      function $O(c) {
        var h = this.__data__;
        if (sl) {
          var w = h[c];
          return w === l ? n : w;
        }
        return St.call(h, c) ? h[c] : n;
      }
      function LO(c) {
        var h = this.__data__;
        return sl ? h[c] !== n : St.call(h, c);
      }
      function FO(c, h) {
        var w = this.__data__;
        return this.size += this.has(c) ? 0 : 1, w[c] = sl && h === n ? l : h, this;
      }
      Wo.prototype.clear = DO, Wo.prototype.delete = NO, Wo.prototype.get = $O, Wo.prototype.has = LO, Wo.prototype.set = FO;
      function Oi(c) {
        var h = -1, w = c == null ? 0 : c.length;
        for (this.clear(); ++h < w; ) {
          var P = c[h];
          this.set(P[0], P[1]);
        }
      }
      function zO() {
        this.__data__ = [], this.size = 0;
      }
      function VO(c) {
        var h = this.__data__, w = yu(h, c);
        if (w < 0)
          return !1;
        var P = h.length - 1;
        return w == P ? h.pop() : du.call(h, w, 1), --this.size, !0;
      }
      function BO(c) {
        var h = this.__data__, w = yu(h, c);
        return w < 0 ? n : h[w][1];
      }
      function jO(c) {
        return yu(this.__data__, c) > -1;
      }
      function WO(c, h) {
        var w = this.__data__, P = yu(w, c);
        return P < 0 ? (++this.size, w.push([c, h])) : w[P][1] = h, this;
      }
      Oi.prototype.clear = zO, Oi.prototype.delete = VO, Oi.prototype.get = BO, Oi.prototype.has = jO, Oi.prototype.set = WO;
      function Ri(c) {
        var h = -1, w = c == null ? 0 : c.length;
        for (this.clear(); ++h < w; ) {
          var P = c[h];
          this.set(P[0], P[1]);
        }
      }
      function UO() {
        this.size = 0, this.__data__ = {
          hash: new Wo(),
          map: new (ol || Oi)(),
          string: new Wo()
        };
      }
      function HO(c) {
        var h = Mu(this, c).delete(c);
        return this.size -= h ? 1 : 0, h;
      }
      function GO(c) {
        return Mu(this, c).get(c);
      }
      function qO(c) {
        return Mu(this, c).has(c);
      }
      function YO(c, h) {
        var w = Mu(this, c), P = w.size;
        return w.set(c, h), this.size += w.size == P ? 0 : 1, this;
      }
      Ri.prototype.clear = UO, Ri.prototype.delete = HO, Ri.prototype.get = GO, Ri.prototype.has = qO, Ri.prototype.set = YO;
      function Uo(c) {
        var h = -1, w = c == null ? 0 : c.length;
        for (this.__data__ = new Ri(); ++h < w; )
          this.add(c[h]);
      }
      function KO(c) {
        return this.__data__.set(c, l), this;
      }
      function XO(c) {
        return this.__data__.has(c);
      }
      Uo.prototype.add = Uo.prototype.push = KO, Uo.prototype.has = XO;
      function Hr(c) {
        var h = this.__data__ = new Oi(c);
        this.size = h.size;
      }
      function ZO() {
        this.__data__ = new Oi(), this.size = 0;
      }
      function QO(c) {
        var h = this.__data__, w = h.delete(c);
        return this.size = h.size, w;
      }
      function JO(c) {
        return this.__data__.get(c);
      }
      function eR(c) {
        return this.__data__.has(c);
      }
      function tR(c, h) {
        var w = this.__data__;
        if (w instanceof Oi) {
          var P = w.__data__;
          if (!ol || P.length < i - 1)
            return P.push([c, h]), this.size = ++w.size, this;
          w = this.__data__ = new Ri(P);
        }
        return w.set(c, h), this.size = w.size, this;
      }
      Hr.prototype.clear = ZO, Hr.prototype.delete = QO, Hr.prototype.get = JO, Hr.prototype.has = eR, Hr.prototype.set = tR;
      function Tb(c, h) {
        var w = qe(c), P = !w && Ko(c), M = !w && !P && ho(c), $ = !w && !P && !M && qa(c), V = w || P || M || $, U = V ? Mp(c.length, dO) : [], K = U.length;
        for (var ce in c)
          (h || St.call(c, ce)) && !(V && // Safari 9 has enumerable `arguments.length` in strict mode.
          (ce == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
          M && (ce == "offset" || ce == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
          $ && (ce == "buffer" || ce == "byteLength" || ce == "byteOffset") || // Skip index properties.
          $i(ce, K))) && U.push(ce);
        return U;
      }
      function Ab(c) {
        var h = c.length;
        return h ? c[qp(0, h - 1)] : n;
      }
      function nR(c, h) {
        return Ou(qn(c), Ho(h, 0, c.length));
      }
      function rR(c) {
        return Ou(qn(c));
      }
      function Lp(c, h, w) {
        (w !== n && !Gr(c[h], w) || w === n && !(h in c)) && Ii(c, h, w);
      }
      function cl(c, h, w) {
        var P = c[h];
        (!(St.call(c, h) && Gr(P, w)) || w === n && !(h in c)) && Ii(c, h, w);
      }
      function yu(c, h) {
        for (var w = c.length; w--; )
          if (Gr(c[w][0], h))
            return w;
        return -1;
      }
      function iR(c, h, w, P) {
        return lo(c, function(M, $, V) {
          h(P, M, w(M), V);
        }), P;
      }
      function Mb(c, h) {
        return c && fi(h, vn(h), c);
      }
      function oR(c, h) {
        return c && fi(h, Kn(h), c);
      }
      function Ii(c, h, w) {
        h == "__proto__" && fu ? fu(c, h, {
          configurable: !0,
          enumerable: !0,
          value: w,
          writable: !0
        }) : c[h] = w;
      }
      function Fp(c, h) {
        for (var w = -1, P = h.length, M = ne(P), $ = c == null; ++w < P; )
          M[w] = $ ? n : ym(c, h[w]);
        return M;
      }
      function Ho(c, h, w) {
        return c === c && (w !== n && (c = c <= w ? c : w), h !== n && (c = c >= h ? c : h)), c;
      }
      function _r(c, h, w, P, M, $) {
        var V, U = h & f, K = h & p, ce = h & m;
        if (w && (V = M ? w(c, P, M, $) : w(c)), V !== n)
          return V;
        if (!Wt(c))
          return c;
        var ue = qe(c);
        if (ue) {
          if (V = qR(c), !U)
            return qn(c, V);
        } else {
          var ve = kn(c), Ae = ve == te || ve == Re;
          if (ho(c))
            return e2(c, U);
          if (ve == ht || ve == ae || Ae && !M) {
            if (V = K || Ae ? {} : w2(c), !U)
              return K ? $R(c, oR(V, c)) : NR(c, Mb(V, c));
          } else {
            if (!Mt[ve])
              return M ? c : {};
            V = YR(c, ve, U);
          }
        }
        $ || ($ = new Hr());
        var Ne = $.get(c);
        if (Ne)
          return Ne;
        $.set(c, V), Y2(c) ? c.forEach(function(We) {
          V.add(_r(We, h, w, We, c, $));
        }) : G2(c) && c.forEach(function(We, et) {
          V.set(et, _r(We, h, w, et, c, $));
        });
        var je = ce ? K ? im : rm : K ? Kn : vn, Xe = ue ? n : je(c);
        return Er(Xe || c, function(We, et) {
          Xe && (et = We, We = c[et]), cl(V, et, _r(We, h, w, et, c, $));
        }), V;
      }
      function aR(c) {
        var h = vn(c);
        return function(w) {
          return Ob(w, c, h);
        };
      }
      function Ob(c, h, w) {
        var P = w.length;
        if (c == null)
          return !P;
        for (c = kt(c); P--; ) {
          var M = w[P], $ = h[M], V = c[M];
          if (V === n && !(M in c) || !$(V))
            return !1;
        }
        return !0;
      }
      function Rb(c, h, w) {
        if (typeof c != "function")
          throw new Cr(a);
        return gl(function() {
          c.apply(n, w);
        }, h);
      }
      function ul(c, h, w, P) {
        var M = -1, $ = tu, V = !0, U = c.length, K = [], ce = h.length;
        if (!U)
          return K;
        w && (h = Vt(h, ar(w))), P ? ($ = Sp, V = !1) : h.length >= i && ($ = rl, V = !1, h = new Uo(h));
        e:
          for (; ++M < U; ) {
            var ue = c[M], ve = w == null ? ue : w(ue);
            if (ue = P || ue !== 0 ? ue : 0, V && ve === ve) {
              for (var Ae = ce; Ae--; )
                if (h[Ae] === ve)
                  continue e;
              K.push(ue);
            } else
              $(h, ve, P) || K.push(ue);
          }
        return K;
      }
      var lo = o2(di), Ib = o2(Vp, !0);
      function sR(c, h) {
        var w = !0;
        return lo(c, function(P, M, $) {
          return w = !!h(P, M, $), w;
        }), w;
      }
      function wu(c, h, w) {
        for (var P = -1, M = c.length; ++P < M; ) {
          var $ = c[P], V = h($);
          if (V != null && (U === n ? V === V && !lr(V) : w(V, U)))
            var U = V, K = $;
        }
        return K;
      }
      function lR(c, h, w, P) {
        var M = c.length;
        for (w = Ke(w), w < 0 && (w = -w > M ? 0 : M + w), P = P === n || P > M ? M : Ke(P), P < 0 && (P += M), P = w > P ? 0 : X2(P); w < P; )
          c[w++] = h;
        return c;
      }
      function Db(c, h) {
        var w = [];
        return lo(c, function(P, M, $) {
          h(P, M, $) && w.push(P);
        }), w;
      }
      function Cn(c, h, w, P, M) {
        var $ = -1, V = c.length;
        for (w || (w = XR), M || (M = []); ++$ < V; ) {
          var U = c[$];
          h > 0 && w(U) ? h > 1 ? Cn(U, h - 1, w, P, M) : oo(M, U) : P || (M[M.length] = U);
        }
        return M;
      }
      var zp = a2(), Nb = a2(!0);
      function di(c, h) {
        return c && zp(c, h, vn);
      }
      function Vp(c, h) {
        return c && Nb(c, h, vn);
      }
      function bu(c, h) {
        return io(h, function(w) {
          return Li(c[w]);
        });
      }
      function Go(c, h) {
        h = uo(h, c);
        for (var w = 0, P = h.length; c != null && w < P; )
          c = c[hi(h[w++])];
        return w && w == P ? c : n;
      }
      function $b(c, h, w) {
        var P = h(c);
        return qe(c) ? P : oo(P, w(c));
      }
      function Dn(c) {
        return c == null ? c === n ? gn : dt : jo && jo in kt(c) ? UR(c) : r9(c);
      }
      function Bp(c, h) {
        return c > h;
      }
      function cR(c, h) {
        return c != null && St.call(c, h);
      }
      function uR(c, h) {
        return c != null && h in kt(c);
      }
      function dR(c, h, w) {
        return c >= Pn(h, w) && c < un(h, w);
      }
      function jp(c, h, w) {
        for (var P = w ? Sp : tu, M = c[0].length, $ = c.length, V = $, U = ne($), K = 1 / 0, ce = []; V--; ) {
          var ue = c[V];
          V && h && (ue = Vt(ue, ar(h))), K = Pn(ue.length, K), U[V] = !w && (h || M >= 120 && ue.length >= 120) ? new Uo(V && ue) : n;
        }
        ue = c[0];
        var ve = -1, Ae = U[0];
        e:
          for (; ++ve < M && ce.length < K; ) {
            var Ne = ue[ve], je = h ? h(Ne) : Ne;
            if (Ne = w || Ne !== 0 ? Ne : 0, !(Ae ? rl(Ae, je) : P(ce, je, w))) {
              for (V = $; --V; ) {
                var Xe = U[V];
                if (!(Xe ? rl(Xe, je) : P(c[V], je, w)))
                  continue e;
              }
              Ae && Ae.push(je), ce.push(Ne);
            }
          }
        return ce;
      }
      function fR(c, h, w, P) {
        return di(c, function(M, $, V) {
          h(P, w(M), $, V);
        }), P;
      }
      function dl(c, h, w) {
        h = uo(h, c), c = C2(c, h);
        var P = c == null ? c : c[hi(kr(h))];
        return P == null ? n : or(P, c, w);
      }
      function Lb(c) {
        return qt(c) && Dn(c) == ae;
      }
      function hR(c) {
        return qt(c) && Dn(c) == re;
      }
      function pR(c) {
        return qt(c) && Dn(c) == le;
      }
      function fl(c, h, w, P, M) {
        return c === h ? !0 : c == null || h == null || !qt(c) && !qt(h) ? c !== c && h !== h : mR(c, h, w, P, fl, M);
      }
      function mR(c, h, w, P, M, $) {
        var V = qe(c), U = qe(h), K = V ? pe : kn(c), ce = U ? pe : kn(h);
        K = K == ae ? ht : K, ce = ce == ae ? ht : ce;
        var ue = K == ht, ve = ce == ht, Ae = K == ce;
        if (Ae && ho(c)) {
          if (!ho(h))
            return !1;
          V = !0, ue = !1;
        }
        if (Ae && !ue)
          return $ || ($ = new Hr()), V || qa(c) ? g2(c, h, w, P, M, $) : jR(c, h, K, w, P, M, $);
        if (!(w & g)) {
          var Ne = ue && St.call(c, "__wrapped__"), je = ve && St.call(h, "__wrapped__");
          if (Ne || je) {
            var Xe = Ne ? c.value() : c, We = je ? h.value() : h;
            return $ || ($ = new Hr()), M(Xe, We, w, P, $);
          }
        }
        return Ae ? ($ || ($ = new Hr()), WR(c, h, w, P, M, $)) : !1;
      }
      function gR(c) {
        return qt(c) && kn(c) == we;
      }
      function Wp(c, h, w, P) {
        var M = w.length, $ = M, V = !P;
        if (c == null)
          return !$;
        for (c = kt(c); M--; ) {
          var U = w[M];
          if (V && U[2] ? U[1] !== c[U[0]] : !(U[0] in c))
            return !1;
        }
        for (; ++M < $; ) {
          U = w[M];
          var K = U[0], ce = c[K], ue = U[1];
          if (V && U[2]) {
            if (ce === n && !(K in c))
              return !1;
          } else {
            var ve = new Hr();
            if (P)
              var Ae = P(ce, ue, K, c, h, ve);
            if (!(Ae === n ? fl(ue, ce, g | v, P, ve) : Ae))
              return !1;
          }
        }
        return !0;
      }
      function Fb(c) {
        if (!Wt(c) || QR(c))
          return !1;
        var h = Li(c) ? gO : xn;
        return h.test(Yo(c));
      }
      function vR(c) {
        return qt(c) && Dn(c) == Ht;
      }
      function yR(c) {
        return qt(c) && kn(c) == zt;
      }
      function wR(c) {
        return qt(c) && Lu(c.length) && !!It[Dn(c)];
      }
      function zb(c) {
        return typeof c == "function" ? c : c == null ? Xn : typeof c == "object" ? qe(c) ? jb(c[0], c[1]) : Bb(c) : sx(c);
      }
      function Up(c) {
        if (!ml(c))
          return EO(c);
        var h = [];
        for (var w in kt(c))
          St.call(c, w) && w != "constructor" && h.push(w);
        return h;
      }
      function bR(c) {
        if (!Wt(c))
          return n9(c);
        var h = ml(c), w = [];
        for (var P in c)
          P == "constructor" && (h || !St.call(c, P)) || w.push(P);
        return w;
      }
      function Hp(c, h) {
        return c < h;
      }
      function Vb(c, h) {
        var w = -1, P = Yn(c) ? ne(c.length) : [];
        return lo(c, function(M, $, V) {
          P[++w] = h(M, $, V);
        }), P;
      }
      function Bb(c) {
        var h = am(c);
        return h.length == 1 && h[0][2] ? x2(h[0][0], h[0][1]) : function(w) {
          return w === c || Wp(w, c, h);
        };
      }
      function jb(c, h) {
        return lm(c) && b2(h) ? x2(hi(c), h) : function(w) {
          var P = ym(w, c);
          return P === n && P === h ? wm(w, c) : fl(h, P, g | v);
        };
      }
      function xu(c, h, w, P, M) {
        c !== h && zp(h, function($, V) {
          if (M || (M = new Hr()), Wt($))
            xR(c, h, V, w, xu, P, M);
          else {
            var U = P ? P(um(c, V), $, V + "", c, h, M) : n;
            U === n && (U = $), Lp(c, V, U);
          }
        }, Kn);
      }
      function xR(c, h, w, P, M, $, V) {
        var U = um(c, w), K = um(h, w), ce = V.get(K);
        if (ce) {
          Lp(c, w, ce);
          return;
        }
        var ue = $ ? $(U, K, w + "", c, h, V) : n, ve = ue === n;
        if (ve) {
          var Ae = qe(K), Ne = !Ae && ho(K), je = !Ae && !Ne && qa(K);
          ue = K, Ae || Ne || je ? qe(U) ? ue = U : Qt(U) ? ue = qn(U) : Ne ? (ve = !1, ue = e2(K, !0)) : je ? (ve = !1, ue = t2(K, !0)) : ue = [] : vl(K) || Ko(K) ? (ue = U, Ko(U) ? ue = Z2(U) : (!Wt(U) || Li(U)) && (ue = w2(K))) : ve = !1;
        }
        ve && (V.set(K, ue), M(ue, K, P, $, V), V.delete(K)), Lp(c, w, ue);
      }
      function Wb(c, h) {
        var w = c.length;
        if (w)
          return h += h < 0 ? w : 0, $i(h, w) ? c[h] : n;
      }
      function Ub(c, h, w) {
        h.length ? h = Vt(h, function($) {
          return qe($) ? function(V) {
            return Go(V, $.length === 1 ? $[0] : $);
          } : $;
        }) : h = [Xn];
        var P = -1;
        h = Vt(h, ar(Be()));
        var M = Vb(c, function($, V, U) {
          var K = Vt(h, function(ce) {
            return ce($);
          });
          return { criteria: K, index: ++P, value: $ };
        });
        return YM(M, function($, V) {
          return DR($, V, w);
        });
      }
      function ER(c, h) {
        return Hb(c, h, function(w, P) {
          return wm(c, P);
        });
      }
      function Hb(c, h, w) {
        for (var P = -1, M = h.length, $ = {}; ++P < M; ) {
          var V = h[P], U = Go(c, V);
          w(U, V) && hl($, uo(V, c), U);
        }
        return $;
      }
      function CR(c) {
        return function(h) {
          return Go(h, c);
        };
      }
      function Gp(c, h, w, P) {
        var M = P ? qM : $a, $ = -1, V = h.length, U = c;
        for (c === h && (h = qn(h)), w && (U = Vt(c, ar(w))); ++$ < V; )
          for (var K = 0, ce = h[$], ue = w ? w(ce) : ce; (K = M(U, ue, K, P)) > -1; )
            U !== c && du.call(U, K, 1), du.call(c, K, 1);
        return c;
      }
      function Gb(c, h) {
        for (var w = c ? h.length : 0, P = w - 1; w--; ) {
          var M = h[w];
          if (w == P || M !== $) {
            var $ = M;
            $i(M) ? du.call(c, M, 1) : Xp(c, M);
          }
        }
        return c;
      }
      function qp(c, h) {
        return c + pu(Pb() * (h - c + 1));
      }
      function SR(c, h, w, P) {
        for (var M = -1, $ = un(hu((h - c) / (w || 1)), 0), V = ne($); $--; )
          V[P ? $ : ++M] = c, c += w;
        return V;
      }
      function Yp(c, h) {
        var w = "";
        if (!c || h < 1 || h > q)
          return w;
        do
          h % 2 && (w += c), h = pu(h / 2), h && (c += c);
        while (h);
        return w;
      }
      function Ze(c, h) {
        return dm(E2(c, h, Xn), c + "");
      }
      function _R(c) {
        return Ab(Ya(c));
      }
      function PR(c, h) {
        var w = Ya(c);
        return Ou(w, Ho(h, 0, w.length));
      }
      function hl(c, h, w, P) {
        if (!Wt(c))
          return c;
        h = uo(h, c);
        for (var M = -1, $ = h.length, V = $ - 1, U = c; U != null && ++M < $; ) {
          var K = hi(h[M]), ce = w;
          if (K === "__proto__" || K === "constructor" || K === "prototype")
            return c;
          if (M != V) {
            var ue = U[K];
            ce = P ? P(ue, K, U) : n, ce === n && (ce = Wt(ue) ? ue : $i(h[M + 1]) ? [] : {});
          }
          cl(U, K, ce), U = U[K];
        }
        return c;
      }
      var qb = mu ? function(c, h) {
        return mu.set(c, h), c;
      } : Xn, kR = fu ? function(c, h) {
        return fu(c, "toString", {
          configurable: !0,
          enumerable: !1,
          value: xm(h),
          writable: !0
        });
      } : Xn;
      function TR(c) {
        return Ou(Ya(c));
      }
      function Pr(c, h, w) {
        var P = -1, M = c.length;
        h < 0 && (h = -h > M ? 0 : M + h), w = w > M ? M : w, w < 0 && (w += M), M = h > w ? 0 : w - h >>> 0, h >>>= 0;
        for (var $ = ne(M); ++P < M; )
          $[P] = c[P + h];
        return $;
      }
      function AR(c, h) {
        var w;
        return lo(c, function(P, M, $) {
          return w = h(P, M, $), !w;
        }), !!w;
      }
      function Eu(c, h, w) {
        var P = 0, M = c == null ? P : c.length;
        if (typeof h == "number" && h === h && M <= N) {
          for (; P < M; ) {
            var $ = P + M >>> 1, V = c[$];
            V !== null && !lr(V) && (w ? V <= h : V < h) ? P = $ + 1 : M = $;
          }
          return M;
        }
        return Kp(c, h, Xn, w);
      }
      function Kp(c, h, w, P) {
        var M = 0, $ = c == null ? 0 : c.length;
        if ($ === 0)
          return 0;
        h = w(h);
        for (var V = h !== h, U = h === null, K = lr(h), ce = h === n; M < $; ) {
          var ue = pu((M + $) / 2), ve = w(c[ue]), Ae = ve !== n, Ne = ve === null, je = ve === ve, Xe = lr(ve);
          if (V)
            var We = P || je;
          else
            ce ? We = je && (P || Ae) : U ? We = je && Ae && (P || !Ne) : K ? We = je && Ae && !Ne && (P || !Xe) : Ne || Xe ? We = !1 : We = P ? ve <= h : ve < h;
          We ? M = ue + 1 : $ = ue;
        }
        return Pn($, he);
      }
      function Yb(c, h) {
        for (var w = -1, P = c.length, M = 0, $ = []; ++w < P; ) {
          var V = c[w], U = h ? h(V) : V;
          if (!w || !Gr(U, K)) {
            var K = U;
            $[M++] = V === 0 ? 0 : V;
          }
        }
        return $;
      }
      function Kb(c) {
        return typeof c == "number" ? c : lr(c) ? O : +c;
      }
      function sr(c) {
        if (typeof c == "string")
          return c;
        if (qe(c))
          return Vt(c, sr) + "";
        if (lr(c))
          return kb ? kb.call(c) : "";
        var h = c + "";
        return h == "0" && 1 / c == -J ? "-0" : h;
      }
      function co(c, h, w) {
        var P = -1, M = tu, $ = c.length, V = !0, U = [], K = U;
        if (w)
          V = !1, M = Sp;
        else if ($ >= i) {
          var ce = h ? null : VR(c);
          if (ce)
            return ru(ce);
          V = !1, M = rl, K = new Uo();
        } else
          K = h ? [] : U;
        e:
          for (; ++P < $; ) {
            var ue = c[P], ve = h ? h(ue) : ue;
            if (ue = w || ue !== 0 ? ue : 0, V && ve === ve) {
              for (var Ae = K.length; Ae--; )
                if (K[Ae] === ve)
                  continue e;
              h && K.push(ve), U.push(ue);
            } else
              M(K, ve, w) || (K !== U && K.push(ve), U.push(ue));
          }
        return U;
      }
      function Xp(c, h) {
        return h = uo(h, c), c = C2(c, h), c == null || delete c[hi(kr(h))];
      }
      function Xb(c, h, w, P) {
        return hl(c, h, w(Go(c, h)), P);
      }
      function Cu(c, h, w, P) {
        for (var M = c.length, $ = P ? M : -1; (P ? $-- : ++$ < M) && h(c[$], $, c); )
          ;
        return w ? Pr(c, P ? 0 : $, P ? $ + 1 : M) : Pr(c, P ? $ + 1 : 0, P ? M : $);
      }
      function Zb(c, h) {
        var w = c;
        return w instanceof ot && (w = w.value()), _p(h, function(P, M) {
          return M.func.apply(M.thisArg, oo([P], M.args));
        }, w);
      }
      function Zp(c, h, w) {
        var P = c.length;
        if (P < 2)
          return P ? co(c[0]) : [];
        for (var M = -1, $ = ne(P); ++M < P; )
          for (var V = c[M], U = -1; ++U < P; )
            U != M && ($[M] = ul($[M] || V, c[U], h, w));
        return co(Cn($, 1), h, w);
      }
      function Qb(c, h, w) {
        for (var P = -1, M = c.length, $ = h.length, V = {}; ++P < M; ) {
          var U = P < $ ? h[P] : n;
          w(V, c[P], U);
        }
        return V;
      }
      function Qp(c) {
        return Qt(c) ? c : [];
      }
      function Jp(c) {
        return typeof c == "function" ? c : Xn;
      }
      function uo(c, h) {
        return qe(c) ? c : lm(c, h) ? [c] : k2(wt(c));
      }
      var MR = Ze;
      function fo(c, h, w) {
        var P = c.length;
        return w = w === n ? P : w, !h && w >= P ? c : Pr(c, h, w);
      }
      var Jb = vO || function(c) {
        return En.clearTimeout(c);
      };
      function e2(c, h) {
        if (h)
          return c.slice();
        var w = c.length, P = xb ? xb(w) : new c.constructor(w);
        return c.copy(P), P;
      }
      function em(c) {
        var h = new c.constructor(c.byteLength);
        return new cu(h).set(new cu(c)), h;
      }
      function OR(c, h) {
        var w = h ? em(c.buffer) : c.buffer;
        return new c.constructor(w, c.byteOffset, c.byteLength);
      }
      function RR(c) {
        var h = new c.constructor(c.source, yt.exec(c));
        return h.lastIndex = c.lastIndex, h;
      }
      function IR(c) {
        return ll ? kt(ll.call(c)) : {};
      }
      function t2(c, h) {
        var w = h ? em(c.buffer) : c.buffer;
        return new c.constructor(w, c.byteOffset, c.length);
      }
      function n2(c, h) {
        if (c !== h) {
          var w = c !== n, P = c === null, M = c === c, $ = lr(c), V = h !== n, U = h === null, K = h === h, ce = lr(h);
          if (!U && !ce && !$ && c > h || $ && V && K && !U && !ce || P && V && K || !w && K || !M)
            return 1;
          if (!P && !$ && !ce && c < h || ce && w && M && !P && !$ || U && w && M || !V && M || !K)
            return -1;
        }
        return 0;
      }
      function DR(c, h, w) {
        for (var P = -1, M = c.criteria, $ = h.criteria, V = M.length, U = w.length; ++P < V; ) {
          var K = n2(M[P], $[P]);
          if (K) {
            if (P >= U)
              return K;
            var ce = w[P];
            return K * (ce == "desc" ? -1 : 1);
          }
        }
        return c.index - h.index;
      }
      function r2(c, h, w, P) {
        for (var M = -1, $ = c.length, V = w.length, U = -1, K = h.length, ce = un($ - V, 0), ue = ne(K + ce), ve = !P; ++U < K; )
          ue[U] = h[U];
        for (; ++M < V; )
          (ve || M < $) && (ue[w[M]] = c[M]);
        for (; ce--; )
          ue[U++] = c[M++];
        return ue;
      }
      function i2(c, h, w, P) {
        for (var M = -1, $ = c.length, V = -1, U = w.length, K = -1, ce = h.length, ue = un($ - U, 0), ve = ne(ue + ce), Ae = !P; ++M < ue; )
          ve[M] = c[M];
        for (var Ne = M; ++K < ce; )
          ve[Ne + K] = h[K];
        for (; ++V < U; )
          (Ae || M < $) && (ve[Ne + w[V]] = c[M++]);
        return ve;
      }
      function qn(c, h) {
        var w = -1, P = c.length;
        for (h || (h = ne(P)); ++w < P; )
          h[w] = c[w];
        return h;
      }
      function fi(c, h, w, P) {
        var M = !w;
        w || (w = {});
        for (var $ = -1, V = h.length; ++$ < V; ) {
          var U = h[$], K = P ? P(w[U], c[U], U, w, c) : n;
          K === n && (K = c[U]), M ? Ii(w, U, K) : cl(w, U, K);
        }
        return w;
      }
      function NR(c, h) {
        return fi(c, sm(c), h);
      }
      function $R(c, h) {
        return fi(c, v2(c), h);
      }
      function Su(c, h) {
        return function(w, P) {
          var M = qe(w) ? BM : iR, $ = h ? h() : {};
          return M(w, c, Be(P, 2), $);
        };
      }
      function Ua(c) {
        return Ze(function(h, w) {
          var P = -1, M = w.length, $ = M > 1 ? w[M - 1] : n, V = M > 2 ? w[2] : n;
          for ($ = c.length > 3 && typeof $ == "function" ? (M--, $) : n, V && Nn(w[0], w[1], V) && ($ = M < 3 ? n : $, M = 1), h = kt(h); ++P < M; ) {
            var U = w[P];
            U && c(h, U, P, $);
          }
          return h;
        });
      }
      function o2(c, h) {
        return function(w, P) {
          if (w == null)
            return w;
          if (!Yn(w))
            return c(w, P);
          for (var M = w.length, $ = h ? M : -1, V = kt(w); (h ? $-- : ++$ < M) && P(V[$], $, V) !== !1; )
            ;
          return w;
        };
      }
      function a2(c) {
        return function(h, w, P) {
          for (var M = -1, $ = kt(h), V = P(h), U = V.length; U--; ) {
            var K = V[c ? U : ++M];
            if (w($[K], K, $) === !1)
              break;
          }
          return h;
        };
      }
      function LR(c, h, w) {
        var P = h & y, M = pl(c);
        function $() {
          var V = this && this !== En && this instanceof $ ? M : c;
          return V.apply(P ? w : this, arguments);
        }
        return $;
      }
      function s2(c) {
        return function(h) {
          h = wt(h);
          var w = La(h) ? Ur(h) : n, P = w ? w[0] : h.charAt(0), M = w ? fo(w, 1).join("") : h.slice(1);
          return P[c]() + M;
        };
      }
      function Ha(c) {
        return function(h) {
          return _p(ox(ix(h).replace(kM, "")), c, "");
        };
      }
      function pl(c) {
        return function() {
          var h = arguments;
          switch (h.length) {
            case 0:
              return new c();
            case 1:
              return new c(h[0]);
            case 2:
              return new c(h[0], h[1]);
            case 3:
              return new c(h[0], h[1], h[2]);
            case 4:
              return new c(h[0], h[1], h[2], h[3]);
            case 5:
              return new c(h[0], h[1], h[2], h[3], h[4]);
            case 6:
              return new c(h[0], h[1], h[2], h[3], h[4], h[5]);
            case 7:
              return new c(h[0], h[1], h[2], h[3], h[4], h[5], h[6]);
          }
          var w = Wa(c.prototype), P = c.apply(w, h);
          return Wt(P) ? P : w;
        };
      }
      function FR(c, h, w) {
        var P = pl(c);
        function M() {
          for (var $ = arguments.length, V = ne($), U = $, K = Ga(M); U--; )
            V[U] = arguments[U];
          var ce = $ < 3 && V[0] !== K && V[$ - 1] !== K ? [] : ao(V, K);
          if ($ -= ce.length, $ < w)
            return f2(
              c,
              h,
              _u,
              M.placeholder,
              n,
              V,
              ce,
              n,
              n,
              w - $
            );
          var ue = this && this !== En && this instanceof M ? P : c;
          return or(ue, this, V);
        }
        return M;
      }
      function l2(c) {
        return function(h, w, P) {
          var M = kt(h);
          if (!Yn(h)) {
            var $ = Be(w, 3);
            h = vn(h), w = function(U) {
              return $(M[U], U, M);
            };
          }
          var V = c(h, w, P);
          return V > -1 ? M[$ ? h[V] : V] : n;
        };
      }
      function c2(c) {
        return Ni(function(h) {
          var w = h.length, P = w, M = Sr.prototype.thru;
          for (c && h.reverse(); P--; ) {
            var $ = h[P];
            if (typeof $ != "function")
              throw new Cr(a);
            if (M && !V && Au($) == "wrapper")
              var V = new Sr([], !0);
          }
          for (P = V ? P : w; ++P < w; ) {
            $ = h[P];
            var U = Au($), K = U == "wrapper" ? om($) : n;
            K && cm(K[0]) && K[1] == (A | S | k | R) && !K[4].length && K[9] == 1 ? V = V[Au(K[0])].apply(V, K[3]) : V = $.length == 1 && cm($) ? V[U]() : V.thru($);
          }
          return function() {
            var ce = arguments, ue = ce[0];
            if (V && ce.length == 1 && qe(ue))
              return V.plant(ue).value();
            for (var ve = 0, Ae = w ? h[ve].apply(this, ce) : ue; ++ve < w; )
              Ae = h[ve].call(this, Ae);
            return Ae;
          };
        });
      }
      function _u(c, h, w, P, M, $, V, U, K, ce) {
        var ue = h & A, ve = h & y, Ae = h & b, Ne = h & (S | _), je = h & F, Xe = Ae ? n : pl(c);
        function We() {
          for (var et = arguments.length, ct = ne(et), cr = et; cr--; )
            ct[cr] = arguments[cr];
          if (Ne)
            var $n = Ga(We), ur = XM(ct, $n);
          if (P && (ct = r2(ct, P, M, Ne)), $ && (ct = i2(ct, $, V, Ne)), et -= ur, Ne && et < ce) {
            var Jt = ao(ct, $n);
            return f2(
              c,
              h,
              _u,
              We.placeholder,
              w,
              ct,
              Jt,
              U,
              K,
              ce - et
            );
          }
          var qr = ve ? w : this, zi = Ae ? qr[c] : c;
          return et = ct.length, U ? ct = i9(ct, U) : je && et > 1 && ct.reverse(), ue && K < et && (ct.length = K), this && this !== En && this instanceof We && (zi = Xe || pl(zi)), zi.apply(qr, ct);
        }
        return We;
      }
      function u2(c, h) {
        return function(w, P) {
          return fR(w, c, h(P), {});
        };
      }
      function Pu(c, h) {
        return function(w, P) {
          var M;
          if (w === n && P === n)
            return h;
          if (w !== n && (M = w), P !== n) {
            if (M === n)
              return P;
            typeof w == "string" || typeof P == "string" ? (w = sr(w), P = sr(P)) : (w = Kb(w), P = Kb(P)), M = c(w, P);
          }
          return M;
        };
      }
      function tm(c) {
        return Ni(function(h) {
          return h = Vt(h, ar(Be())), Ze(function(w) {
            var P = this;
            return c(h, function(M) {
              return or(M, P, w);
            });
          });
        });
      }
      function ku(c, h) {
        h = h === n ? " " : sr(h);
        var w = h.length;
        if (w < 2)
          return w ? Yp(h, c) : h;
        var P = Yp(h, hu(c / Fa(h)));
        return La(h) ? fo(Ur(P), 0, c).join("") : P.slice(0, c);
      }
      function zR(c, h, w, P) {
        var M = h & y, $ = pl(c);
        function V() {
          for (var U = -1, K = arguments.length, ce = -1, ue = P.length, ve = ne(ue + K), Ae = this && this !== En && this instanceof V ? $ : c; ++ce < ue; )
            ve[ce] = P[ce];
          for (; K--; )
            ve[ce++] = arguments[++U];
          return or(Ae, M ? w : this, ve);
        }
        return V;
      }
      function d2(c) {
        return function(h, w, P) {
          return P && typeof P != "number" && Nn(h, w, P) && (w = P = n), h = Fi(h), w === n ? (w = h, h = 0) : w = Fi(w), P = P === n ? h < w ? 1 : -1 : Fi(P), SR(h, w, P, c);
        };
      }
      function Tu(c) {
        return function(h, w) {
          return typeof h == "string" && typeof w == "string" || (h = Tr(h), w = Tr(w)), c(h, w);
        };
      }
      function f2(c, h, w, P, M, $, V, U, K, ce) {
        var ue = h & S, ve = ue ? V : n, Ae = ue ? n : V, Ne = ue ? $ : n, je = ue ? n : $;
        h |= ue ? k : T, h &= ~(ue ? T : k), h & E || (h &= ~(y | b));
        var Xe = [
          c,
          h,
          M,
          Ne,
          ve,
          je,
          Ae,
          U,
          K,
          ce
        ], We = w.apply(n, Xe);
        return cm(c) && S2(We, Xe), We.placeholder = P, _2(We, c, h);
      }
      function nm(c) {
        var h = cn[c];
        return function(w, P) {
          if (w = Tr(w), P = P == null ? 0 : Pn(Ke(P), 292), P && _b(w)) {
            var M = (wt(w) + "e").split("e"), $ = h(M[0] + "e" + (+M[1] + P));
            return M = (wt($) + "e").split("e"), +(M[0] + "e" + (+M[1] - P));
          }
          return h(w);
        };
      }
      var VR = Ba && 1 / ru(new Ba([, -0]))[1] == J ? function(c) {
        return new Ba(c);
      } : Sm;
      function h2(c) {
        return function(h) {
          var w = kn(h);
          return w == we ? Rp(h) : w == zt ? rO(h) : KM(h, c(h));
        };
      }
      function Di(c, h, w, P, M, $, V, U) {
        var K = h & b;
        if (!K && typeof c != "function")
          throw new Cr(a);
        var ce = P ? P.length : 0;
        if (ce || (h &= ~(k | T), P = M = n), V = V === n ? V : un(Ke(V), 0), U = U === n ? U : Ke(U), ce -= M ? M.length : 0, h & T) {
          var ue = P, ve = M;
          P = M = n;
        }
        var Ae = K ? n : om(c), Ne = [
          c,
          h,
          w,
          P,
          M,
          ue,
          ve,
          $,
          V,
          U
        ];
        if (Ae && t9(Ne, Ae), c = Ne[0], h = Ne[1], w = Ne[2], P = Ne[3], M = Ne[4], U = Ne[9] = Ne[9] === n ? K ? 0 : c.length : un(Ne[9] - ce, 0), !U && h & (S | _) && (h &= ~(S | _)), !h || h == y)
          var je = LR(c, h, w);
        else
          h == S || h == _ ? je = FR(c, h, U) : (h == k || h == (y | k)) && !M.length ? je = zR(c, h, w, P) : je = _u.apply(n, Ne);
        var Xe = Ae ? qb : S2;
        return _2(Xe(je, Ne), c, h);
      }
      function p2(c, h, w, P) {
        return c === n || Gr(c, Va[w]) && !St.call(P, w) ? h : c;
      }
      function m2(c, h, w, P, M, $) {
        return Wt(c) && Wt(h) && ($.set(h, c), xu(c, h, n, m2, $), $.delete(h)), c;
      }
      function BR(c) {
        return vl(c) ? n : c;
      }
      function g2(c, h, w, P, M, $) {
        var V = w & g, U = c.length, K = h.length;
        if (U != K && !(V && K > U))
          return !1;
        var ce = $.get(c), ue = $.get(h);
        if (ce && ue)
          return ce == h && ue == c;
        var ve = -1, Ae = !0, Ne = w & v ? new Uo() : n;
        for ($.set(c, h), $.set(h, c); ++ve < U; ) {
          var je = c[ve], Xe = h[ve];
          if (P)
            var We = V ? P(Xe, je, ve, h, c, $) : P(je, Xe, ve, c, h, $);
          if (We !== n) {
            if (We)
              continue;
            Ae = !1;
            break;
          }
          if (Ne) {
            if (!Pp(h, function(et, ct) {
              if (!rl(Ne, ct) && (je === et || M(je, et, w, P, $)))
                return Ne.push(ct);
            })) {
              Ae = !1;
              break;
            }
          } else if (!(je === Xe || M(je, Xe, w, P, $))) {
            Ae = !1;
            break;
          }
        }
        return $.delete(c), $.delete(h), Ae;
      }
      function jR(c, h, w, P, M, $, V) {
        switch (w) {
          case Ce:
            if (c.byteLength != h.byteLength || c.byteOffset != h.byteOffset)
              return !1;
            c = c.buffer, h = h.buffer;
          case re:
            return !(c.byteLength != h.byteLength || !$(new cu(c), new cu(h)));
          case Se:
          case le:
          case ze:
            return Gr(+c, +h);
          case Ie:
            return c.name == h.name && c.message == h.message;
          case Ht:
          case Wn:
            return c == h + "";
          case we:
            var U = Rp;
          case zt:
            var K = P & g;
            if (U || (U = ru), c.size != h.size && !K)
              return !1;
            var ce = V.get(c);
            if (ce)
              return ce == h;
            P |= v, V.set(c, h);
            var ue = g2(U(c), U(h), P, M, $, V);
            return V.delete(c), ue;
          case Vr:
            if (ll)
              return ll.call(c) == ll.call(h);
        }
        return !1;
      }
      function WR(c, h, w, P, M, $) {
        var V = w & g, U = rm(c), K = U.length, ce = rm(h), ue = ce.length;
        if (K != ue && !V)
          return !1;
        for (var ve = K; ve--; ) {
          var Ae = U[ve];
          if (!(V ? Ae in h : St.call(h, Ae)))
            return !1;
        }
        var Ne = $.get(c), je = $.get(h);
        if (Ne && je)
          return Ne == h && je == c;
        var Xe = !0;
        $.set(c, h), $.set(h, c);
        for (var We = V; ++ve < K; ) {
          Ae = U[ve];
          var et = c[Ae], ct = h[Ae];
          if (P)
            var cr = V ? P(ct, et, Ae, h, c, $) : P(et, ct, Ae, c, h, $);
          if (!(cr === n ? et === ct || M(et, ct, w, P, $) : cr)) {
            Xe = !1;
            break;
          }
          We || (We = Ae == "constructor");
        }
        if (Xe && !We) {
          var $n = c.constructor, ur = h.constructor;
          $n != ur && "constructor" in c && "constructor" in h && !(typeof $n == "function" && $n instanceof $n && typeof ur == "function" && ur instanceof ur) && (Xe = !1);
        }
        return $.delete(c), $.delete(h), Xe;
      }
      function Ni(c) {
        return dm(E2(c, n, O2), c + "");
      }
      function rm(c) {
        return $b(c, vn, sm);
      }
      function im(c) {
        return $b(c, Kn, v2);
      }
      var om = mu ? function(c) {
        return mu.get(c);
      } : Sm;
      function Au(c) {
        for (var h = c.name + "", w = ja[h], P = St.call(ja, h) ? w.length : 0; P--; ) {
          var M = w[P], $ = M.func;
          if ($ == null || $ == c)
            return M.name;
        }
        return h;
      }
      function Ga(c) {
        var h = St.call(I, "placeholder") ? I : c;
        return h.placeholder;
      }
      function Be() {
        var c = I.iteratee || Em;
        return c = c === Em ? zb : c, arguments.length ? c(arguments[0], arguments[1]) : c;
      }
      function Mu(c, h) {
        var w = c.__data__;
        return ZR(h) ? w[typeof h == "string" ? "string" : "hash"] : w.map;
      }
      function am(c) {
        for (var h = vn(c), w = h.length; w--; ) {
          var P = h[w], M = c[P];
          h[w] = [P, M, b2(M)];
        }
        return h;
      }
      function qo(c, h) {
        var w = eO(c, h);
        return Fb(w) ? w : n;
      }
      function UR(c) {
        var h = St.call(c, jo), w = c[jo];
        try {
          c[jo] = n;
          var P = !0;
        } catch {
        }
        var M = su.call(c);
        return P && (h ? c[jo] = w : delete c[jo]), M;
      }
      var sm = Dp ? function(c) {
        return c == null ? [] : (c = kt(c), io(Dp(c), function(h) {
          return Cb.call(c, h);
        }));
      } : _m, v2 = Dp ? function(c) {
        for (var h = []; c; )
          oo(h, sm(c)), c = uu(c);
        return h;
      } : _m, kn = Dn;
      (Np && kn(new Np(new ArrayBuffer(1))) != Ce || ol && kn(new ol()) != we || $p && kn($p.resolve()) != vt || Ba && kn(new Ba()) != zt || al && kn(new al()) != nn) && (kn = function(c) {
        var h = Dn(c), w = h == ht ? c.constructor : n, P = w ? Yo(w) : "";
        if (P)
          switch (P) {
            case PO:
              return Ce;
            case kO:
              return we;
            case TO:
              return vt;
            case AO:
              return zt;
            case MO:
              return nn;
          }
        return h;
      });
      function HR(c, h, w) {
        for (var P = -1, M = w.length; ++P < M; ) {
          var $ = w[P], V = $.size;
          switch ($.type) {
            case "drop":
              c += V;
              break;
            case "dropRight":
              h -= V;
              break;
            case "take":
              h = Pn(h, c + V);
              break;
            case "takeRight":
              c = un(c, h - V);
              break;
          }
        }
        return { start: c, end: h };
      }
      function GR(c) {
        var h = c.match(gp);
        return h ? h[1].split(j) : [];
      }
      function y2(c, h, w) {
        h = uo(h, c);
        for (var P = -1, M = h.length, $ = !1; ++P < M; ) {
          var V = hi(h[P]);
          if (!($ = c != null && w(c, V)))
            break;
          c = c[V];
        }
        return $ || ++P != M ? $ : (M = c == null ? 0 : c.length, !!M && Lu(M) && $i(V, M) && (qe(c) || Ko(c)));
      }
      function qR(c) {
        var h = c.length, w = new c.constructor(h);
        return h && typeof c[0] == "string" && St.call(c, "index") && (w.index = c.index, w.input = c.input), w;
      }
      function w2(c) {
        return typeof c.constructor == "function" && !ml(c) ? Wa(uu(c)) : {};
      }
      function YR(c, h, w) {
        var P = c.constructor;
        switch (h) {
          case re:
            return em(c);
          case Se:
          case le:
            return new P(+c);
          case Ce:
            return OR(c, w);
          case Fe:
          case st:
          case lt:
          case bn:
          case Un:
          case Rn:
          case Br:
          case jr:
          case Pt:
            return t2(c, w);
          case we:
            return new P();
          case ze:
          case Wn:
            return new P(c);
          case Ht:
            return RR(c);
          case zt:
            return new P();
          case Vr:
            return IR(c);
        }
      }
      function KR(c, h) {
        var w = h.length;
        if (!w)
          return c;
        var P = w - 1;
        return h[P] = (w > 1 ? "& " : "") + h[P], h = h.join(w > 2 ? ", " : " "), c.replace(mp, `{
/* [wrapped with ` + h + `] */
`);
      }
      function XR(c) {
        return qe(c) || Ko(c) || !!(Sb && c && c[Sb]);
      }
      function $i(c, h) {
        var w = typeof c;
        return h = h ?? q, !!h && (w == "number" || w != "symbol" && Gt.test(c)) && c > -1 && c % 1 == 0 && c < h;
      }
      function Nn(c, h, w) {
        if (!Wt(w))
          return !1;
        var P = typeof h;
        return (P == "number" ? Yn(w) && $i(h, w.length) : P == "string" && h in w) ? Gr(w[h], c) : !1;
      }
      function lm(c, h) {
        if (qe(c))
          return !1;
        var w = typeof c;
        return w == "number" || w == "symbol" || w == "boolean" || c == null || lr(c) ? !0 : Zc.test(c) || !Xc.test(c) || h != null && c in kt(h);
      }
      function ZR(c) {
        var h = typeof c;
        return h == "string" || h == "number" || h == "symbol" || h == "boolean" ? c !== "__proto__" : c === null;
      }
      function cm(c) {
        var h = Au(c), w = I[h];
        if (typeof w != "function" || !(h in ot.prototype))
          return !1;
        if (c === w)
          return !0;
        var P = om(w);
        return !!P && c === P[0];
      }
      function QR(c) {
        return !!bb && bb in c;
      }
      var JR = ou ? Li : Pm;
      function ml(c) {
        var h = c && c.constructor, w = typeof h == "function" && h.prototype || Va;
        return c === w;
      }
      function b2(c) {
        return c === c && !Wt(c);
      }
      function x2(c, h) {
        return function(w) {
          return w == null ? !1 : w[c] === h && (h !== n || c in kt(w));
        };
      }
      function e9(c) {
        var h = Nu(c, function(P) {
          return w.size === u && w.clear(), P;
        }), w = h.cache;
        return h;
      }
      function t9(c, h) {
        var w = c[1], P = h[1], M = w | P, $ = M < (y | b | A), V = P == A && w == S || P == A && w == R && c[7].length <= h[8] || P == (A | R) && h[7].length <= h[8] && w == S;
        if (!($ || V))
          return c;
        P & y && (c[2] = h[2], M |= w & y ? 0 : E);
        var U = h[3];
        if (U) {
          var K = c[3];
          c[3] = K ? r2(K, U, h[4]) : U, c[4] = K ? ao(c[3], d) : h[4];
        }
        return U = h[5], U && (K = c[5], c[5] = K ? i2(K, U, h[6]) : U, c[6] = K ? ao(c[5], d) : h[6]), U = h[7], U && (c[7] = U), P & A && (c[8] = c[8] == null ? h[8] : Pn(c[8], h[8])), c[9] == null && (c[9] = h[9]), c[0] = h[0], c[1] = M, c;
      }
      function n9(c) {
        var h = [];
        if (c != null)
          for (var w in kt(c))
            h.push(w);
        return h;
      }
      function r9(c) {
        return su.call(c);
      }
      function E2(c, h, w) {
        return h = un(h === n ? c.length - 1 : h, 0), function() {
          for (var P = arguments, M = -1, $ = un(P.length - h, 0), V = ne($); ++M < $; )
            V[M] = P[h + M];
          M = -1;
          for (var U = ne(h + 1); ++M < h; )
            U[M] = P[M];
          return U[h] = w(V), or(c, this, U);
        };
      }
      function C2(c, h) {
        return h.length < 2 ? c : Go(c, Pr(h, 0, -1));
      }
      function i9(c, h) {
        for (var w = c.length, P = Pn(h.length, w), M = qn(c); P--; ) {
          var $ = h[P];
          c[P] = $i($, w) ? M[$] : n;
        }
        return c;
      }
      function um(c, h) {
        if (!(h === "constructor" && typeof c[h] == "function") && h != "__proto__")
          return c[h];
      }
      var S2 = P2(qb), gl = wO || function(c, h) {
        return En.setTimeout(c, h);
      }, dm = P2(kR);
      function _2(c, h, w) {
        var P = h + "";
        return dm(c, KR(P, o9(GR(P), w)));
      }
      function P2(c) {
        var h = 0, w = 0;
        return function() {
          var P = CO(), M = z - (P - w);
          if (w = P, M > 0) {
            if (++h >= L)
              return arguments[0];
          } else
            h = 0;
          return c.apply(n, arguments);
        };
      }
      function Ou(c, h) {
        var w = -1, P = c.length, M = P - 1;
        for (h = h === n ? P : h; ++w < h; ) {
          var $ = qp(w, M), V = c[$];
          c[$] = c[w], c[w] = V;
        }
        return c.length = h, c;
      }
      var k2 = e9(function(c) {
        var h = [];
        return c.charCodeAt(0) === 46 && h.push(""), c.replace(hp, function(w, P, M, $) {
          h.push(M ? $.replace(He, "$1") : P || w);
        }), h;
      });
      function hi(c) {
        if (typeof c == "string" || lr(c))
          return c;
        var h = c + "";
        return h == "0" && 1 / c == -J ? "-0" : h;
      }
      function Yo(c) {
        if (c != null) {
          try {
            return au.call(c);
          } catch {
          }
          try {
            return c + "";
          } catch {
          }
        }
        return "";
      }
      function o9(c, h) {
        return Er(ee, function(w) {
          var P = "_." + w[0];
          h & w[1] && !tu(c, P) && c.push(P);
        }), c.sort();
      }
      function T2(c) {
        if (c instanceof ot)
          return c.clone();
        var h = new Sr(c.__wrapped__, c.__chain__);
        return h.__actions__ = qn(c.__actions__), h.__index__ = c.__index__, h.__values__ = c.__values__, h;
      }
      function a9(c, h, w) {
        (w ? Nn(c, h, w) : h === n) ? h = 1 : h = un(Ke(h), 0);
        var P = c == null ? 0 : c.length;
        if (!P || h < 1)
          return [];
        for (var M = 0, $ = 0, V = ne(hu(P / h)); M < P; )
          V[$++] = Pr(c, M, M += h);
        return V;
      }
      function s9(c) {
        for (var h = -1, w = c == null ? 0 : c.length, P = 0, M = []; ++h < w; ) {
          var $ = c[h];
          $ && (M[P++] = $);
        }
        return M;
      }
      function l9() {
        var c = arguments.length;
        if (!c)
          return [];
        for (var h = ne(c - 1), w = arguments[0], P = c; P--; )
          h[P - 1] = arguments[P];
        return oo(qe(w) ? qn(w) : [w], Cn(h, 1));
      }
      var c9 = Ze(function(c, h) {
        return Qt(c) ? ul(c, Cn(h, 1, Qt, !0)) : [];
      }), u9 = Ze(function(c, h) {
        var w = kr(h);
        return Qt(w) && (w = n), Qt(c) ? ul(c, Cn(h, 1, Qt, !0), Be(w, 2)) : [];
      }), d9 = Ze(function(c, h) {
        var w = kr(h);
        return Qt(w) && (w = n), Qt(c) ? ul(c, Cn(h, 1, Qt, !0), n, w) : [];
      });
      function f9(c, h, w) {
        var P = c == null ? 0 : c.length;
        return P ? (h = w || h === n ? 1 : Ke(h), Pr(c, h < 0 ? 0 : h, P)) : [];
      }
      function h9(c, h, w) {
        var P = c == null ? 0 : c.length;
        return P ? (h = w || h === n ? 1 : Ke(h), h = P - h, Pr(c, 0, h < 0 ? 0 : h)) : [];
      }
      function p9(c, h) {
        return c && c.length ? Cu(c, Be(h, 3), !0, !0) : [];
      }
      function m9(c, h) {
        return c && c.length ? Cu(c, Be(h, 3), !0) : [];
      }
      function g9(c, h, w, P) {
        var M = c == null ? 0 : c.length;
        return M ? (w && typeof w != "number" && Nn(c, h, w) && (w = 0, P = M), lR(c, h, w, P)) : [];
      }
      function A2(c, h, w) {
        var P = c == null ? 0 : c.length;
        if (!P)
          return -1;
        var M = w == null ? 0 : Ke(w);
        return M < 0 && (M = un(P + M, 0)), nu(c, Be(h, 3), M);
      }
      function M2(c, h, w) {
        var P = c == null ? 0 : c.length;
        if (!P)
          return -1;
        var M = P - 1;
        return w !== n && (M = Ke(w), M = w < 0 ? un(P + M, 0) : Pn(M, P - 1)), nu(c, Be(h, 3), M, !0);
      }
      function O2(c) {
        var h = c == null ? 0 : c.length;
        return h ? Cn(c, 1) : [];
      }
      function v9(c) {
        var h = c == null ? 0 : c.length;
        return h ? Cn(c, J) : [];
      }
      function y9(c, h) {
        var w = c == null ? 0 : c.length;
        return w ? (h = h === n ? 1 : Ke(h), Cn(c, h)) : [];
      }
      function w9(c) {
        for (var h = -1, w = c == null ? 0 : c.length, P = {}; ++h < w; ) {
          var M = c[h];
          P[M[0]] = M[1];
        }
        return P;
      }
      function R2(c) {
        return c && c.length ? c[0] : n;
      }
      function b9(c, h, w) {
        var P = c == null ? 0 : c.length;
        if (!P)
          return -1;
        var M = w == null ? 0 : Ke(w);
        return M < 0 && (M = un(P + M, 0)), $a(c, h, M);
      }
      function x9(c) {
        var h = c == null ? 0 : c.length;
        return h ? Pr(c, 0, -1) : [];
      }
      var E9 = Ze(function(c) {
        var h = Vt(c, Qp);
        return h.length && h[0] === c[0] ? jp(h) : [];
      }), C9 = Ze(function(c) {
        var h = kr(c), w = Vt(c, Qp);
        return h === kr(w) ? h = n : w.pop(), w.length && w[0] === c[0] ? jp(w, Be(h, 2)) : [];
      }), S9 = Ze(function(c) {
        var h = kr(c), w = Vt(c, Qp);
        return h = typeof h == "function" ? h : n, h && w.pop(), w.length && w[0] === c[0] ? jp(w, n, h) : [];
      });
      function _9(c, h) {
        return c == null ? "" : xO.call(c, h);
      }
      function kr(c) {
        var h = c == null ? 0 : c.length;
        return h ? c[h - 1] : n;
      }
      function P9(c, h, w) {
        var P = c == null ? 0 : c.length;
        if (!P)
          return -1;
        var M = P;
        return w !== n && (M = Ke(w), M = M < 0 ? un(P + M, 0) : Pn(M, P - 1)), h === h ? oO(c, h, M) : nu(c, fb, M, !0);
      }
      function k9(c, h) {
        return c && c.length ? Wb(c, Ke(h)) : n;
      }
      var T9 = Ze(I2);
      function I2(c, h) {
        return c && c.length && h && h.length ? Gp(c, h) : c;
      }
      function A9(c, h, w) {
        return c && c.length && h && h.length ? Gp(c, h, Be(w, 2)) : c;
      }
      function M9(c, h, w) {
        return c && c.length && h && h.length ? Gp(c, h, n, w) : c;
      }
      var O9 = Ni(function(c, h) {
        var w = c == null ? 0 : c.length, P = Fp(c, h);
        return Gb(c, Vt(h, function(M) {
          return $i(M, w) ? +M : M;
        }).sort(n2)), P;
      });
      function R9(c, h) {
        var w = [];
        if (!(c && c.length))
          return w;
        var P = -1, M = [], $ = c.length;
        for (h = Be(h, 3); ++P < $; ) {
          var V = c[P];
          h(V, P, c) && (w.push(V), M.push(P));
        }
        return Gb(c, M), w;
      }
      function fm(c) {
        return c == null ? c : _O.call(c);
      }
      function I9(c, h, w) {
        var P = c == null ? 0 : c.length;
        return P ? (w && typeof w != "number" && Nn(c, h, w) ? (h = 0, w = P) : (h = h == null ? 0 : Ke(h), w = w === n ? P : Ke(w)), Pr(c, h, w)) : [];
      }
      function D9(c, h) {
        return Eu(c, h);
      }
      function N9(c, h, w) {
        return Kp(c, h, Be(w, 2));
      }
      function $9(c, h) {
        var w = c == null ? 0 : c.length;
        if (w) {
          var P = Eu(c, h);
          if (P < w && Gr(c[P], h))
            return P;
        }
        return -1;
      }
      function L9(c, h) {
        return Eu(c, h, !0);
      }
      function F9(c, h, w) {
        return Kp(c, h, Be(w, 2), !0);
      }
      function z9(c, h) {
        var w = c == null ? 0 : c.length;
        if (w) {
          var P = Eu(c, h, !0) - 1;
          if (Gr(c[P], h))
            return P;
        }
        return -1;
      }
      function V9(c) {
        return c && c.length ? Yb(c) : [];
      }
      function B9(c, h) {
        return c && c.length ? Yb(c, Be(h, 2)) : [];
      }
      function j9(c) {
        var h = c == null ? 0 : c.length;
        return h ? Pr(c, 1, h) : [];
      }
      function W9(c, h, w) {
        return c && c.length ? (h = w || h === n ? 1 : Ke(h), Pr(c, 0, h < 0 ? 0 : h)) : [];
      }
      function U9(c, h, w) {
        var P = c == null ? 0 : c.length;
        return P ? (h = w || h === n ? 1 : Ke(h), h = P - h, Pr(c, h < 0 ? 0 : h, P)) : [];
      }
      function H9(c, h) {
        return c && c.length ? Cu(c, Be(h, 3), !1, !0) : [];
      }
      function G9(c, h) {
        return c && c.length ? Cu(c, Be(h, 3)) : [];
      }
      var q9 = Ze(function(c) {
        return co(Cn(c, 1, Qt, !0));
      }), Y9 = Ze(function(c) {
        var h = kr(c);
        return Qt(h) && (h = n), co(Cn(c, 1, Qt, !0), Be(h, 2));
      }), K9 = Ze(function(c) {
        var h = kr(c);
        return h = typeof h == "function" ? h : n, co(Cn(c, 1, Qt, !0), n, h);
      });
      function X9(c) {
        return c && c.length ? co(c) : [];
      }
      function Z9(c, h) {
        return c && c.length ? co(c, Be(h, 2)) : [];
      }
      function Q9(c, h) {
        return h = typeof h == "function" ? h : n, c && c.length ? co(c, n, h) : [];
      }
      function hm(c) {
        if (!(c && c.length))
          return [];
        var h = 0;
        return c = io(c, function(w) {
          if (Qt(w))
            return h = un(w.length, h), !0;
        }), Mp(h, function(w) {
          return Vt(c, kp(w));
        });
      }
      function D2(c, h) {
        if (!(c && c.length))
          return [];
        var w = hm(c);
        return h == null ? w : Vt(w, function(P) {
          return or(h, n, P);
        });
      }
      var J9 = Ze(function(c, h) {
        return Qt(c) ? ul(c, h) : [];
      }), eI = Ze(function(c) {
        return Zp(io(c, Qt));
      }), tI = Ze(function(c) {
        var h = kr(c);
        return Qt(h) && (h = n), Zp(io(c, Qt), Be(h, 2));
      }), nI = Ze(function(c) {
        var h = kr(c);
        return h = typeof h == "function" ? h : n, Zp(io(c, Qt), n, h);
      }), rI = Ze(hm);
      function iI(c, h) {
        return Qb(c || [], h || [], cl);
      }
      function oI(c, h) {
        return Qb(c || [], h || [], hl);
      }
      var aI = Ze(function(c) {
        var h = c.length, w = h > 1 ? c[h - 1] : n;
        return w = typeof w == "function" ? (c.pop(), w) : n, D2(c, w);
      });
      function N2(c) {
        var h = I(c);
        return h.__chain__ = !0, h;
      }
      function sI(c, h) {
        return h(c), c;
      }
      function Ru(c, h) {
        return h(c);
      }
      var lI = Ni(function(c) {
        var h = c.length, w = h ? c[0] : 0, P = this.__wrapped__, M = function($) {
          return Fp($, c);
        };
        return h > 1 || this.__actions__.length || !(P instanceof ot) || !$i(w) ? this.thru(M) : (P = P.slice(w, +w + (h ? 1 : 0)), P.__actions__.push({
          func: Ru,
          args: [M],
          thisArg: n
        }), new Sr(P, this.__chain__).thru(function($) {
          return h && !$.length && $.push(n), $;
        }));
      });
      function cI() {
        return N2(this);
      }
      function uI() {
        return new Sr(this.value(), this.__chain__);
      }
      function dI() {
        this.__values__ === n && (this.__values__ = K2(this.value()));
        var c = this.__index__ >= this.__values__.length, h = c ? n : this.__values__[this.__index__++];
        return { done: c, value: h };
      }
      function fI() {
        return this;
      }
      function hI(c) {
        for (var h, w = this; w instanceof vu; ) {
          var P = T2(w);
          P.__index__ = 0, P.__values__ = n, h ? M.__wrapped__ = P : h = P;
          var M = P;
          w = w.__wrapped__;
        }
        return M.__wrapped__ = c, h;
      }
      function pI() {
        var c = this.__wrapped__;
        if (c instanceof ot) {
          var h = c;
          return this.__actions__.length && (h = new ot(this)), h = h.reverse(), h.__actions__.push({
            func: Ru,
            args: [fm],
            thisArg: n
          }), new Sr(h, this.__chain__);
        }
        return this.thru(fm);
      }
      function mI() {
        return Zb(this.__wrapped__, this.__actions__);
      }
      var gI = Su(function(c, h, w) {
        St.call(c, w) ? ++c[w] : Ii(c, w, 1);
      });
      function vI(c, h, w) {
        var P = qe(c) ? ub : sR;
        return w && Nn(c, h, w) && (h = n), P(c, Be(h, 3));
      }
      function yI(c, h) {
        var w = qe(c) ? io : Db;
        return w(c, Be(h, 3));
      }
      var wI = l2(A2), bI = l2(M2);
      function xI(c, h) {
        return Cn(Iu(c, h), 1);
      }
      function EI(c, h) {
        return Cn(Iu(c, h), J);
      }
      function CI(c, h, w) {
        return w = w === n ? 1 : Ke(w), Cn(Iu(c, h), w);
      }
      function $2(c, h) {
        var w = qe(c) ? Er : lo;
        return w(c, Be(h, 3));
      }
      function L2(c, h) {
        var w = qe(c) ? jM : Ib;
        return w(c, Be(h, 3));
      }
      var SI = Su(function(c, h, w) {
        St.call(c, w) ? c[w].push(h) : Ii(c, w, [h]);
      });
      function _I(c, h, w, P) {
        c = Yn(c) ? c : Ya(c), w = w && !P ? Ke(w) : 0;
        var M = c.length;
        return w < 0 && (w = un(M + w, 0)), Fu(c) ? w <= M && c.indexOf(h, w) > -1 : !!M && $a(c, h, w) > -1;
      }
      var PI = Ze(function(c, h, w) {
        var P = -1, M = typeof h == "function", $ = Yn(c) ? ne(c.length) : [];
        return lo(c, function(V) {
          $[++P] = M ? or(h, V, w) : dl(V, h, w);
        }), $;
      }), kI = Su(function(c, h, w) {
        Ii(c, w, h);
      });
      function Iu(c, h) {
        var w = qe(c) ? Vt : Vb;
        return w(c, Be(h, 3));
      }
      function TI(c, h, w, P) {
        return c == null ? [] : (qe(h) || (h = h == null ? [] : [h]), w = P ? n : w, qe(w) || (w = w == null ? [] : [w]), Ub(c, h, w));
      }
      var AI = Su(function(c, h, w) {
        c[w ? 0 : 1].push(h);
      }, function() {
        return [[], []];
      });
      function MI(c, h, w) {
        var P = qe(c) ? _p : pb, M = arguments.length < 3;
        return P(c, Be(h, 4), w, M, lo);
      }
      function OI(c, h, w) {
        var P = qe(c) ? WM : pb, M = arguments.length < 3;
        return P(c, Be(h, 4), w, M, Ib);
      }
      function RI(c, h) {
        var w = qe(c) ? io : Db;
        return w(c, $u(Be(h, 3)));
      }
      function II(c) {
        var h = qe(c) ? Ab : _R;
        return h(c);
      }
      function DI(c, h, w) {
        (w ? Nn(c, h, w) : h === n) ? h = 1 : h = Ke(h);
        var P = qe(c) ? nR : PR;
        return P(c, h);
      }
      function NI(c) {
        var h = qe(c) ? rR : TR;
        return h(c);
      }
      function $I(c) {
        if (c == null)
          return 0;
        if (Yn(c))
          return Fu(c) ? Fa(c) : c.length;
        var h = kn(c);
        return h == we || h == zt ? c.size : Up(c).length;
      }
      function LI(c, h, w) {
        var P = qe(c) ? Pp : AR;
        return w && Nn(c, h, w) && (h = n), P(c, Be(h, 3));
      }
      var FI = Ze(function(c, h) {
        if (c == null)
          return [];
        var w = h.length;
        return w > 1 && Nn(c, h[0], h[1]) ? h = [] : w > 2 && Nn(h[0], h[1], h[2]) && (h = [h[0]]), Ub(c, Cn(h, 1), []);
      }), Du = yO || function() {
        return En.Date.now();
      };
      function zI(c, h) {
        if (typeof h != "function")
          throw new Cr(a);
        return c = Ke(c), function() {
          if (--c < 1)
            return h.apply(this, arguments);
        };
      }
      function F2(c, h, w) {
        return h = w ? n : h, h = c && h == null ? c.length : h, Di(c, A, n, n, n, n, h);
      }
      function z2(c, h) {
        var w;
        if (typeof h != "function")
          throw new Cr(a);
        return c = Ke(c), function() {
          return --c > 0 && (w = h.apply(this, arguments)), c <= 1 && (h = n), w;
        };
      }
      var pm = Ze(function(c, h, w) {
        var P = y;
        if (w.length) {
          var M = ao(w, Ga(pm));
          P |= k;
        }
        return Di(c, P, h, w, M);
      }), V2 = Ze(function(c, h, w) {
        var P = y | b;
        if (w.length) {
          var M = ao(w, Ga(V2));
          P |= k;
        }
        return Di(h, P, c, w, M);
      });
      function B2(c, h, w) {
        h = w ? n : h;
        var P = Di(c, S, n, n, n, n, n, h);
        return P.placeholder = B2.placeholder, P;
      }
      function j2(c, h, w) {
        h = w ? n : h;
        var P = Di(c, _, n, n, n, n, n, h);
        return P.placeholder = j2.placeholder, P;
      }
      function W2(c, h, w) {
        var P, M, $, V, U, K, ce = 0, ue = !1, ve = !1, Ae = !0;
        if (typeof c != "function")
          throw new Cr(a);
        h = Tr(h) || 0, Wt(w) && (ue = !!w.leading, ve = "maxWait" in w, $ = ve ? un(Tr(w.maxWait) || 0, h) : $, Ae = "trailing" in w ? !!w.trailing : Ae);
        function Ne(Jt) {
          var qr = P, zi = M;
          return P = M = n, ce = Jt, V = c.apply(zi, qr), V;
        }
        function je(Jt) {
          return ce = Jt, U = gl(et, h), ue ? Ne(Jt) : V;
        }
        function Xe(Jt) {
          var qr = Jt - K, zi = Jt - ce, lx = h - qr;
          return ve ? Pn(lx, $ - zi) : lx;
        }
        function We(Jt) {
          var qr = Jt - K, zi = Jt - ce;
          return K === n || qr >= h || qr < 0 || ve && zi >= $;
        }
        function et() {
          var Jt = Du();
          if (We(Jt))
            return ct(Jt);
          U = gl(et, Xe(Jt));
        }
        function ct(Jt) {
          return U = n, Ae && P ? Ne(Jt) : (P = M = n, V);
        }
        function cr() {
          U !== n && Jb(U), ce = 0, P = K = M = U = n;
        }
        function $n() {
          return U === n ? V : ct(Du());
        }
        function ur() {
          var Jt = Du(), qr = We(Jt);
          if (P = arguments, M = this, K = Jt, qr) {
            if (U === n)
              return je(K);
            if (ve)
              return Jb(U), U = gl(et, h), Ne(K);
          }
          return U === n && (U = gl(et, h)), V;
        }
        return ur.cancel = cr, ur.flush = $n, ur;
      }
      var VI = Ze(function(c, h) {
        return Rb(c, 1, h);
      }), BI = Ze(function(c, h, w) {
        return Rb(c, Tr(h) || 0, w);
      });
      function jI(c) {
        return Di(c, F);
      }
      function Nu(c, h) {
        if (typeof c != "function" || h != null && typeof h != "function")
          throw new Cr(a);
        var w = function() {
          var P = arguments, M = h ? h.apply(this, P) : P[0], $ = w.cache;
          if ($.has(M))
            return $.get(M);
          var V = c.apply(this, P);
          return w.cache = $.set(M, V) || $, V;
        };
        return w.cache = new (Nu.Cache || Ri)(), w;
      }
      Nu.Cache = Ri;
      function $u(c) {
        if (typeof c != "function")
          throw new Cr(a);
        return function() {
          var h = arguments;
          switch (h.length) {
            case 0:
              return !c.call(this);
            case 1:
              return !c.call(this, h[0]);
            case 2:
              return !c.call(this, h[0], h[1]);
            case 3:
              return !c.call(this, h[0], h[1], h[2]);
          }
          return !c.apply(this, h);
        };
      }
      function WI(c) {
        return z2(2, c);
      }
      var UI = MR(function(c, h) {
        h = h.length == 1 && qe(h[0]) ? Vt(h[0], ar(Be())) : Vt(Cn(h, 1), ar(Be()));
        var w = h.length;
        return Ze(function(P) {
          for (var M = -1, $ = Pn(P.length, w); ++M < $; )
            P[M] = h[M].call(this, P[M]);
          return or(c, this, P);
        });
      }), mm = Ze(function(c, h) {
        var w = ao(h, Ga(mm));
        return Di(c, k, n, h, w);
      }), U2 = Ze(function(c, h) {
        var w = ao(h, Ga(U2));
        return Di(c, T, n, h, w);
      }), HI = Ni(function(c, h) {
        return Di(c, R, n, n, n, h);
      });
      function GI(c, h) {
        if (typeof c != "function")
          throw new Cr(a);
        return h = h === n ? h : Ke(h), Ze(c, h);
      }
      function qI(c, h) {
        if (typeof c != "function")
          throw new Cr(a);
        return h = h == null ? 0 : un(Ke(h), 0), Ze(function(w) {
          var P = w[h], M = fo(w, 0, h);
          return P && oo(M, P), or(c, this, M);
        });
      }
      function YI(c, h, w) {
        var P = !0, M = !0;
        if (typeof c != "function")
          throw new Cr(a);
        return Wt(w) && (P = "leading" in w ? !!w.leading : P, M = "trailing" in w ? !!w.trailing : M), W2(c, h, {
          leading: P,
          maxWait: h,
          trailing: M
        });
      }
      function KI(c) {
        return F2(c, 1);
      }
      function XI(c, h) {
        return mm(Jp(h), c);
      }
      function ZI() {
        if (!arguments.length)
          return [];
        var c = arguments[0];
        return qe(c) ? c : [c];
      }
      function QI(c) {
        return _r(c, m);
      }
      function JI(c, h) {
        return h = typeof h == "function" ? h : n, _r(c, m, h);
      }
      function eD(c) {
        return _r(c, f | m);
      }
      function tD(c, h) {
        return h = typeof h == "function" ? h : n, _r(c, f | m, h);
      }
      function nD(c, h) {
        return h == null || Ob(c, h, vn(h));
      }
      function Gr(c, h) {
        return c === h || c !== c && h !== h;
      }
      var rD = Tu(Bp), iD = Tu(function(c, h) {
        return c >= h;
      }), Ko = Lb(function() {
        return arguments;
      }()) ? Lb : function(c) {
        return qt(c) && St.call(c, "callee") && !Cb.call(c, "callee");
      }, qe = ne.isArray, oD = ib ? ar(ib) : hR;
      function Yn(c) {
        return c != null && Lu(c.length) && !Li(c);
      }
      function Qt(c) {
        return qt(c) && Yn(c);
      }
      function aD(c) {
        return c === !0 || c === !1 || qt(c) && Dn(c) == Se;
      }
      var ho = bO || Pm, sD = ob ? ar(ob) : pR;
      function lD(c) {
        return qt(c) && c.nodeType === 1 && !vl(c);
      }
      function cD(c) {
        if (c == null)
          return !0;
        if (Yn(c) && (qe(c) || typeof c == "string" || typeof c.splice == "function" || ho(c) || qa(c) || Ko(c)))
          return !c.length;
        var h = kn(c);
        if (h == we || h == zt)
          return !c.size;
        if (ml(c))
          return !Up(c).length;
        for (var w in c)
          if (St.call(c, w))
            return !1;
        return !0;
      }
      function uD(c, h) {
        return fl(c, h);
      }
      function dD(c, h, w) {
        w = typeof w == "function" ? w : n;
        var P = w ? w(c, h) : n;
        return P === n ? fl(c, h, n, w) : !!P;
      }
      function gm(c) {
        if (!qt(c))
          return !1;
        var h = Dn(c);
        return h == Ie || h == Ee || typeof c.message == "string" && typeof c.name == "string" && !vl(c);
      }
      function fD(c) {
        return typeof c == "number" && _b(c);
      }
      function Li(c) {
        if (!Wt(c))
          return !1;
        var h = Dn(c);
        return h == te || h == Re || h == se || h == mt;
      }
      function H2(c) {
        return typeof c == "number" && c == Ke(c);
      }
      function Lu(c) {
        return typeof c == "number" && c > -1 && c % 1 == 0 && c <= q;
      }
      function Wt(c) {
        var h = typeof c;
        return c != null && (h == "object" || h == "function");
      }
      function qt(c) {
        return c != null && typeof c == "object";
      }
      var G2 = ab ? ar(ab) : gR;
      function hD(c, h) {
        return c === h || Wp(c, h, am(h));
      }
      function pD(c, h, w) {
        return w = typeof w == "function" ? w : n, Wp(c, h, am(h), w);
      }
      function mD(c) {
        return q2(c) && c != +c;
      }
      function gD(c) {
        if (JR(c))
          throw new Ge(o);
        return Fb(c);
      }
      function vD(c) {
        return c === null;
      }
      function yD(c) {
        return c == null;
      }
      function q2(c) {
        return typeof c == "number" || qt(c) && Dn(c) == ze;
      }
      function vl(c) {
        if (!qt(c) || Dn(c) != ht)
          return !1;
        var h = uu(c);
        if (h === null)
          return !0;
        var w = St.call(h, "constructor") && h.constructor;
        return typeof w == "function" && w instanceof w && au.call(w) == pO;
      }
      var vm = sb ? ar(sb) : vR;
      function wD(c) {
        return H2(c) && c >= -q && c <= q;
      }
      var Y2 = lb ? ar(lb) : yR;
      function Fu(c) {
        return typeof c == "string" || !qe(c) && qt(c) && Dn(c) == Wn;
      }
      function lr(c) {
        return typeof c == "symbol" || qt(c) && Dn(c) == Vr;
      }
      var qa = cb ? ar(cb) : wR;
      function bD(c) {
        return c === n;
      }
      function xD(c) {
        return qt(c) && kn(c) == nn;
      }
      function ED(c) {
        return qt(c) && Dn(c) == ui;
      }
      var CD = Tu(Hp), SD = Tu(function(c, h) {
        return c <= h;
      });
      function K2(c) {
        if (!c)
          return [];
        if (Yn(c))
          return Fu(c) ? Ur(c) : qn(c);
        if (il && c[il])
          return nO(c[il]());
        var h = kn(c), w = h == we ? Rp : h == zt ? ru : Ya;
        return w(c);
      }
      function Fi(c) {
        if (!c)
          return c === 0 ? c : 0;
        if (c = Tr(c), c === J || c === -J) {
          var h = c < 0 ? -1 : 1;
          return h * Z;
        }
        return c === c ? c : 0;
      }
      function Ke(c) {
        var h = Fi(c), w = h % 1;
        return h === h ? w ? h - w : h : 0;
      }
      function X2(c) {
        return c ? Ho(Ke(c), 0, Q) : 0;
      }
      function Tr(c) {
        if (typeof c == "number")
          return c;
        if (lr(c))
          return O;
        if (Wt(c)) {
          var h = typeof c.valueOf == "function" ? c.valueOf() : c;
          c = Wt(h) ? h + "" : h;
        }
        if (typeof c != "string")
          return c === 0 ? c : +c;
        c = mb(c);
        var w = Je.test(c);
        return w || jt.test(c) ? zM(c.slice(2), w ? 2 : 8) : it.test(c) ? O : +c;
      }
      function Z2(c) {
        return fi(c, Kn(c));
      }
      function _D(c) {
        return c ? Ho(Ke(c), -q, q) : c === 0 ? c : 0;
      }
      function wt(c) {
        return c == null ? "" : sr(c);
      }
      var PD = Ua(function(c, h) {
        if (ml(h) || Yn(h)) {
          fi(h, vn(h), c);
          return;
        }
        for (var w in h)
          St.call(h, w) && cl(c, w, h[w]);
      }), Q2 = Ua(function(c, h) {
        fi(h, Kn(h), c);
      }), zu = Ua(function(c, h, w, P) {
        fi(h, Kn(h), c, P);
      }), kD = Ua(function(c, h, w, P) {
        fi(h, vn(h), c, P);
      }), TD = Ni(Fp);
      function AD(c, h) {
        var w = Wa(c);
        return h == null ? w : Mb(w, h);
      }
      var MD = Ze(function(c, h) {
        c = kt(c);
        var w = -1, P = h.length, M = P > 2 ? h[2] : n;
        for (M && Nn(h[0], h[1], M) && (P = 1); ++w < P; )
          for (var $ = h[w], V = Kn($), U = -1, K = V.length; ++U < K; ) {
            var ce = V[U], ue = c[ce];
            (ue === n || Gr(ue, Va[ce]) && !St.call(c, ce)) && (c[ce] = $[ce]);
          }
        return c;
      }), OD = Ze(function(c) {
        return c.push(n, m2), or(J2, n, c);
      });
      function RD(c, h) {
        return db(c, Be(h, 3), di);
      }
      function ID(c, h) {
        return db(c, Be(h, 3), Vp);
      }
      function DD(c, h) {
        return c == null ? c : zp(c, Be(h, 3), Kn);
      }
      function ND(c, h) {
        return c == null ? c : Nb(c, Be(h, 3), Kn);
      }
      function $D(c, h) {
        return c && di(c, Be(h, 3));
      }
      function LD(c, h) {
        return c && Vp(c, Be(h, 3));
      }
      function FD(c) {
        return c == null ? [] : bu(c, vn(c));
      }
      function zD(c) {
        return c == null ? [] : bu(c, Kn(c));
      }
      function ym(c, h, w) {
        var P = c == null ? n : Go(c, h);
        return P === n ? w : P;
      }
      function VD(c, h) {
        return c != null && y2(c, h, cR);
      }
      function wm(c, h) {
        return c != null && y2(c, h, uR);
      }
      var BD = u2(function(c, h, w) {
        h != null && typeof h.toString != "function" && (h = su.call(h)), c[h] = w;
      }, xm(Xn)), jD = u2(function(c, h, w) {
        h != null && typeof h.toString != "function" && (h = su.call(h)), St.call(c, h) ? c[h].push(w) : c[h] = [w];
      }, Be), WD = Ze(dl);
      function vn(c) {
        return Yn(c) ? Tb(c) : Up(c);
      }
      function Kn(c) {
        return Yn(c) ? Tb(c, !0) : bR(c);
      }
      function UD(c, h) {
        var w = {};
        return h = Be(h, 3), di(c, function(P, M, $) {
          Ii(w, h(P, M, $), P);
        }), w;
      }
      function HD(c, h) {
        var w = {};
        return h = Be(h, 3), di(c, function(P, M, $) {
          Ii(w, M, h(P, M, $));
        }), w;
      }
      var GD = Ua(function(c, h, w) {
        xu(c, h, w);
      }), J2 = Ua(function(c, h, w, P) {
        xu(c, h, w, P);
      }), qD = Ni(function(c, h) {
        var w = {};
        if (c == null)
          return w;
        var P = !1;
        h = Vt(h, function($) {
          return $ = uo($, c), P || (P = $.length > 1), $;
        }), fi(c, im(c), w), P && (w = _r(w, f | p | m, BR));
        for (var M = h.length; M--; )
          Xp(w, h[M]);
        return w;
      });
      function YD(c, h) {
        return ex(c, $u(Be(h)));
      }
      var KD = Ni(function(c, h) {
        return c == null ? {} : ER(c, h);
      });
      function ex(c, h) {
        if (c == null)
          return {};
        var w = Vt(im(c), function(P) {
          return [P];
        });
        return h = Be(h), Hb(c, w, function(P, M) {
          return h(P, M[0]);
        });
      }
      function XD(c, h, w) {
        h = uo(h, c);
        var P = -1, M = h.length;
        for (M || (M = 1, c = n); ++P < M; ) {
          var $ = c == null ? n : c[hi(h[P])];
          $ === n && (P = M, $ = w), c = Li($) ? $.call(c) : $;
        }
        return c;
      }
      function ZD(c, h, w) {
        return c == null ? c : hl(c, h, w);
      }
      function QD(c, h, w, P) {
        return P = typeof P == "function" ? P : n, c == null ? c : hl(c, h, w, P);
      }
      var tx = h2(vn), nx = h2(Kn);
      function JD(c, h, w) {
        var P = qe(c), M = P || ho(c) || qa(c);
        if (h = Be(h, 4), w == null) {
          var $ = c && c.constructor;
          M ? w = P ? new $() : [] : Wt(c) ? w = Li($) ? Wa(uu(c)) : {} : w = {};
        }
        return (M ? Er : di)(c, function(V, U, K) {
          return h(w, V, U, K);
        }), w;
      }
      function eN(c, h) {
        return c == null ? !0 : Xp(c, h);
      }
      function tN(c, h, w) {
        return c == null ? c : Xb(c, h, Jp(w));
      }
      function nN(c, h, w, P) {
        return P = typeof P == "function" ? P : n, c == null ? c : Xb(c, h, Jp(w), P);
      }
      function Ya(c) {
        return c == null ? [] : Op(c, vn(c));
      }
      function rN(c) {
        return c == null ? [] : Op(c, Kn(c));
      }
      function iN(c, h, w) {
        return w === n && (w = h, h = n), w !== n && (w = Tr(w), w = w === w ? w : 0), h !== n && (h = Tr(h), h = h === h ? h : 0), Ho(Tr(c), h, w);
      }
      function oN(c, h, w) {
        return h = Fi(h), w === n ? (w = h, h = 0) : w = Fi(w), c = Tr(c), dR(c, h, w);
      }
      function aN(c, h, w) {
        if (w && typeof w != "boolean" && Nn(c, h, w) && (h = w = n), w === n && (typeof h == "boolean" ? (w = h, h = n) : typeof c == "boolean" && (w = c, c = n)), c === n && h === n ? (c = 0, h = 1) : (c = Fi(c), h === n ? (h = c, c = 0) : h = Fi(h)), c > h) {
          var P = c;
          c = h, h = P;
        }
        if (w || c % 1 || h % 1) {
          var M = Pb();
          return Pn(c + M * (h - c + FM("1e-" + ((M + "").length - 1))), h);
        }
        return qp(c, h);
      }
      var sN = Ha(function(c, h, w) {
        return h = h.toLowerCase(), c + (w ? rx(h) : h);
      });
      function rx(c) {
        return bm(wt(c).toLowerCase());
      }
      function ix(c) {
        return c = wt(c), c && c.replace(Hn, ZM).replace(TM, "");
      }
      function lN(c, h, w) {
        c = wt(c), h = sr(h);
        var P = c.length;
        w = w === n ? P : Ho(Ke(w), 0, P);
        var M = w;
        return w -= h.length, w >= 0 && c.slice(w, M) == h;
      }
      function cN(c) {
        return c = wt(c), c && qc.test(c) ? c.replace(Da, QM) : c;
      }
      function uN(c) {
        return c = wt(c), c && Qc.test(c) ? c.replace(tl, "\\$&") : c;
      }
      var dN = Ha(function(c, h, w) {
        return c + (w ? "-" : "") + h.toLowerCase();
      }), fN = Ha(function(c, h, w) {
        return c + (w ? " " : "") + h.toLowerCase();
      }), hN = s2("toLowerCase");
      function pN(c, h, w) {
        c = wt(c), h = Ke(h);
        var P = h ? Fa(c) : 0;
        if (!h || P >= h)
          return c;
        var M = (h - P) / 2;
        return ku(pu(M), w) + c + ku(hu(M), w);
      }
      function mN(c, h, w) {
        c = wt(c), h = Ke(h);
        var P = h ? Fa(c) : 0;
        return h && P < h ? c + ku(h - P, w) : c;
      }
      function gN(c, h, w) {
        c = wt(c), h = Ke(h);
        var P = h ? Fa(c) : 0;
        return h && P < h ? ku(h - P, w) + c : c;
      }
      function vN(c, h, w) {
        return w || h == null ? h = 0 : h && (h = +h), SO(wt(c).replace(nl, ""), h || 0);
      }
      function yN(c, h, w) {
        return (w ? Nn(c, h, w) : h === n) ? h = 1 : h = Ke(h), Yp(wt(c), h);
      }
      function wN() {
        var c = arguments, h = wt(c[0]);
        return c.length < 3 ? h : h.replace(c[1], c[2]);
      }
      var bN = Ha(function(c, h, w) {
        return c + (w ? "_" : "") + h.toLowerCase();
      });
      function xN(c, h, w) {
        return w && typeof w != "number" && Nn(c, h, w) && (h = w = n), w = w === n ? Q : w >>> 0, w ? (c = wt(c), c && (typeof h == "string" || h != null && !vm(h)) && (h = sr(h), !h && La(c)) ? fo(Ur(c), 0, w) : c.split(h, w)) : [];
      }
      var EN = Ha(function(c, h, w) {
        return c + (w ? " " : "") + bm(h);
      });
      function CN(c, h, w) {
        return c = wt(c), w = w == null ? 0 : Ho(Ke(w), 0, c.length), h = sr(h), c.slice(w, w + h.length) == h;
      }
      function SN(c, h, w) {
        var P = I.templateSettings;
        w && Nn(c, h, w) && (h = n), c = wt(c), h = zu({}, h, P, p2);
        var M = zu({}, h.imports, P.imports, p2), $ = vn(M), V = Op(M, $), U, K, ce = 0, ue = h.interpolate || Wr, ve = "__p += '", Ae = Ip(
          (h.escape || Wr).source + "|" + ue.source + "|" + (ue === Kc ? pt : Wr).source + "|" + (h.evaluate || Wr).source + "|$",
          "g"
        ), Ne = "//# sourceURL=" + (St.call(h, "sourceURL") ? (h.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++IM + "]") + `
`;
        c.replace(Ae, function(We, et, ct, cr, $n, ur) {
          return ct || (ct = cr), ve += c.slice(ce, ur).replace(Jc, JM), et && (U = !0, ve += `' +
__e(` + et + `) +
'`), $n && (K = !0, ve += `';
` + $n + `;
__p += '`), ct && (ve += `' +
((__t = (` + ct + `)) == null ? '' : __t) +
'`), ce = ur + We.length, We;
        }), ve += `';
`;
        var je = St.call(h, "variable") && h.variable;
        if (!je)
          ve = `with (obj) {
` + ve + `
}
`;
        else if (Te.test(je))
          throw new Ge(s);
        ve = (K ? ve.replace(Vo, "") : ve).replace(In, "$1").replace(Gc, "$1;"), ve = "function(" + (je || "obj") + `) {
` + (je ? "" : `obj || (obj = {});
`) + "var __t, __p = ''" + (U ? ", __e = _.escape" : "") + (K ? `, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
` : `;
`) + ve + `return __p
}`;
        var Xe = ax(function() {
          return gt($, Ne + "return " + ve).apply(n, V);
        });
        if (Xe.source = ve, gm(Xe))
          throw Xe;
        return Xe;
      }
      function _N(c) {
        return wt(c).toLowerCase();
      }
      function PN(c) {
        return wt(c).toUpperCase();
      }
      function kN(c, h, w) {
        if (c = wt(c), c && (w || h === n))
          return mb(c);
        if (!c || !(h = sr(h)))
          return c;
        var P = Ur(c), M = Ur(h), $ = gb(P, M), V = vb(P, M) + 1;
        return fo(P, $, V).join("");
      }
      function TN(c, h, w) {
        if (c = wt(c), c && (w || h === n))
          return c.slice(0, wb(c) + 1);
        if (!c || !(h = sr(h)))
          return c;
        var P = Ur(c), M = vb(P, Ur(h)) + 1;
        return fo(P, 0, M).join("");
      }
      function AN(c, h, w) {
        if (c = wt(c), c && (w || h === n))
          return c.replace(nl, "");
        if (!c || !(h = sr(h)))
          return c;
        var P = Ur(c), M = gb(P, Ur(h));
        return fo(P, M).join("");
      }
      function MN(c, h) {
        var w = D, P = W;
        if (Wt(h)) {
          var M = "separator" in h ? h.separator : M;
          w = "length" in h ? Ke(h.length) : w, P = "omission" in h ? sr(h.omission) : P;
        }
        c = wt(c);
        var $ = c.length;
        if (La(c)) {
          var V = Ur(c);
          $ = V.length;
        }
        if (w >= $)
          return c;
        var U = w - Fa(P);
        if (U < 1)
          return P;
        var K = V ? fo(V, 0, U).join("") : c.slice(0, U);
        if (M === n)
          return K + P;
        if (V && (U += K.length - U), vm(M)) {
          if (c.slice(U).search(M)) {
            var ce, ue = K;
            for (M.global || (M = Ip(M.source, wt(yt.exec(M)) + "g")), M.lastIndex = 0; ce = M.exec(ue); )
              var ve = ce.index;
            K = K.slice(0, ve === n ? U : ve);
          }
        } else if (c.indexOf(sr(M), U) != U) {
          var Ae = K.lastIndexOf(M);
          Ae > -1 && (K = K.slice(0, Ae));
        }
        return K + P;
      }
      function ON(c) {
        return c = wt(c), c && el.test(c) ? c.replace(Mi, aO) : c;
      }
      var RN = Ha(function(c, h, w) {
        return c + (w ? " " : "") + h.toUpperCase();
      }), bm = s2("toUpperCase");
      function ox(c, h, w) {
        return c = wt(c), h = w ? n : h, h === n ? tO(c) ? cO(c) : GM(c) : c.match(h) || [];
      }
      var ax = Ze(function(c, h) {
        try {
          return or(c, n, h);
        } catch (w) {
          return gm(w) ? w : new Ge(w);
        }
      }), IN = Ni(function(c, h) {
        return Er(h, function(w) {
          w = hi(w), Ii(c, w, pm(c[w], c));
        }), c;
      });
      function DN(c) {
        var h = c == null ? 0 : c.length, w = Be();
        return c = h ? Vt(c, function(P) {
          if (typeof P[1] != "function")
            throw new Cr(a);
          return [w(P[0]), P[1]];
        }) : [], Ze(function(P) {
          for (var M = -1; ++M < h; ) {
            var $ = c[M];
            if (or($[0], this, P))
              return or($[1], this, P);
          }
        });
      }
      function NN(c) {
        return aR(_r(c, f));
      }
      function xm(c) {
        return function() {
          return c;
        };
      }
      function $N(c, h) {
        return c == null || c !== c ? h : c;
      }
      var LN = c2(), FN = c2(!0);
      function Xn(c) {
        return c;
      }
      function Em(c) {
        return zb(typeof c == "function" ? c : _r(c, f));
      }
      function zN(c) {
        return Bb(_r(c, f));
      }
      function VN(c, h) {
        return jb(c, _r(h, f));
      }
      var BN = Ze(function(c, h) {
        return function(w) {
          return dl(w, c, h);
        };
      }), jN = Ze(function(c, h) {
        return function(w) {
          return dl(c, w, h);
        };
      });
      function Cm(c, h, w) {
        var P = vn(h), M = bu(h, P);
        w == null && !(Wt(h) && (M.length || !P.length)) && (w = h, h = c, c = this, M = bu(h, vn(h)));
        var $ = !(Wt(w) && "chain" in w) || !!w.chain, V = Li(c);
        return Er(M, function(U) {
          var K = h[U];
          c[U] = K, V && (c.prototype[U] = function() {
            var ce = this.__chain__;
            if ($ || ce) {
              var ue = c(this.__wrapped__), ve = ue.__actions__ = qn(this.__actions__);
              return ve.push({ func: K, args: arguments, thisArg: c }), ue.__chain__ = ce, ue;
            }
            return K.apply(c, oo([this.value()], arguments));
          });
        }), c;
      }
      function WN() {
        return En._ === this && (En._ = mO), this;
      }
      function Sm() {
      }
      function UN(c) {
        return c = Ke(c), Ze(function(h) {
          return Wb(h, c);
        });
      }
      var HN = tm(Vt), GN = tm(ub), qN = tm(Pp);
      function sx(c) {
        return lm(c) ? kp(hi(c)) : CR(c);
      }
      function YN(c) {
        return function(h) {
          return c == null ? n : Go(c, h);
        };
      }
      var KN = d2(), XN = d2(!0);
      function _m() {
        return [];
      }
      function Pm() {
        return !1;
      }
      function ZN() {
        return {};
      }
      function QN() {
        return "";
      }
      function JN() {
        return !0;
      }
      function e$(c, h) {
        if (c = Ke(c), c < 1 || c > q)
          return [];
        var w = Q, P = Pn(c, Q);
        h = Be(h), c -= Q;
        for (var M = Mp(P, h); ++w < c; )
          h(w);
        return M;
      }
      function t$(c) {
        return qe(c) ? Vt(c, hi) : lr(c) ? [c] : qn(k2(wt(c)));
      }
      function n$(c) {
        var h = ++hO;
        return wt(c) + h;
      }
      var r$ = Pu(function(c, h) {
        return c + h;
      }, 0), i$ = nm("ceil"), o$ = Pu(function(c, h) {
        return c / h;
      }, 1), a$ = nm("floor");
      function s$(c) {
        return c && c.length ? wu(c, Xn, Bp) : n;
      }
      function l$(c, h) {
        return c && c.length ? wu(c, Be(h, 2), Bp) : n;
      }
      function c$(c) {
        return hb(c, Xn);
      }
      function u$(c, h) {
        return hb(c, Be(h, 2));
      }
      function d$(c) {
        return c && c.length ? wu(c, Xn, Hp) : n;
      }
      function f$(c, h) {
        return c && c.length ? wu(c, Be(h, 2), Hp) : n;
      }
      var h$ = Pu(function(c, h) {
        return c * h;
      }, 1), p$ = nm("round"), m$ = Pu(function(c, h) {
        return c - h;
      }, 0);
      function g$(c) {
        return c && c.length ? Ap(c, Xn) : 0;
      }
      function v$(c, h) {
        return c && c.length ? Ap(c, Be(h, 2)) : 0;
      }
      return I.after = zI, I.ary = F2, I.assign = PD, I.assignIn = Q2, I.assignInWith = zu, I.assignWith = kD, I.at = TD, I.before = z2, I.bind = pm, I.bindAll = IN, I.bindKey = V2, I.castArray = ZI, I.chain = N2, I.chunk = a9, I.compact = s9, I.concat = l9, I.cond = DN, I.conforms = NN, I.constant = xm, I.countBy = gI, I.create = AD, I.curry = B2, I.curryRight = j2, I.debounce = W2, I.defaults = MD, I.defaultsDeep = OD, I.defer = VI, I.delay = BI, I.difference = c9, I.differenceBy = u9, I.differenceWith = d9, I.drop = f9, I.dropRight = h9, I.dropRightWhile = p9, I.dropWhile = m9, I.fill = g9, I.filter = yI, I.flatMap = xI, I.flatMapDeep = EI, I.flatMapDepth = CI, I.flatten = O2, I.flattenDeep = v9, I.flattenDepth = y9, I.flip = jI, I.flow = LN, I.flowRight = FN, I.fromPairs = w9, I.functions = FD, I.functionsIn = zD, I.groupBy = SI, I.initial = x9, I.intersection = E9, I.intersectionBy = C9, I.intersectionWith = S9, I.invert = BD, I.invertBy = jD, I.invokeMap = PI, I.iteratee = Em, I.keyBy = kI, I.keys = vn, I.keysIn = Kn, I.map = Iu, I.mapKeys = UD, I.mapValues = HD, I.matches = zN, I.matchesProperty = VN, I.memoize = Nu, I.merge = GD, I.mergeWith = J2, I.method = BN, I.methodOf = jN, I.mixin = Cm, I.negate = $u, I.nthArg = UN, I.omit = qD, I.omitBy = YD, I.once = WI, I.orderBy = TI, I.over = HN, I.overArgs = UI, I.overEvery = GN, I.overSome = qN, I.partial = mm, I.partialRight = U2, I.partition = AI, I.pick = KD, I.pickBy = ex, I.property = sx, I.propertyOf = YN, I.pull = T9, I.pullAll = I2, I.pullAllBy = A9, I.pullAllWith = M9, I.pullAt = O9, I.range = KN, I.rangeRight = XN, I.rearg = HI, I.reject = RI, I.remove = R9, I.rest = GI, I.reverse = fm, I.sampleSize = DI, I.set = ZD, I.setWith = QD, I.shuffle = NI, I.slice = I9, I.sortBy = FI, I.sortedUniq = V9, I.sortedUniqBy = B9, I.split = xN, I.spread = qI, I.tail = j9, I.take = W9, I.takeRight = U9, I.takeRightWhile = H9, I.takeWhile = G9, I.tap = sI, I.throttle = YI, I.thru = Ru, I.toArray = K2, I.toPairs = tx, I.toPairsIn = nx, I.toPath = t$, I.toPlainObject = Z2, I.transform = JD, I.unary = KI, I.union = q9, I.unionBy = Y9, I.unionWith = K9, I.uniq = X9, I.uniqBy = Z9, I.uniqWith = Q9, I.unset = eN, I.unzip = hm, I.unzipWith = D2, I.update = tN, I.updateWith = nN, I.values = Ya, I.valuesIn = rN, I.without = J9, I.words = ox, I.wrap = XI, I.xor = eI, I.xorBy = tI, I.xorWith = nI, I.zip = rI, I.zipObject = iI, I.zipObjectDeep = oI, I.zipWith = aI, I.entries = tx, I.entriesIn = nx, I.extend = Q2, I.extendWith = zu, Cm(I, I), I.add = r$, I.attempt = ax, I.camelCase = sN, I.capitalize = rx, I.ceil = i$, I.clamp = iN, I.clone = QI, I.cloneDeep = eD, I.cloneDeepWith = tD, I.cloneWith = JI, I.conformsTo = nD, I.deburr = ix, I.defaultTo = $N, I.divide = o$, I.endsWith = lN, I.eq = Gr, I.escape = cN, I.escapeRegExp = uN, I.every = vI, I.find = wI, I.findIndex = A2, I.findKey = RD, I.findLast = bI, I.findLastIndex = M2, I.findLastKey = ID, I.floor = a$, I.forEach = $2, I.forEachRight = L2, I.forIn = DD, I.forInRight = ND, I.forOwn = $D, I.forOwnRight = LD, I.get = ym, I.gt = rD, I.gte = iD, I.has = VD, I.hasIn = wm, I.head = R2, I.identity = Xn, I.includes = _I, I.indexOf = b9, I.inRange = oN, I.invoke = WD, I.isArguments = Ko, I.isArray = qe, I.isArrayBuffer = oD, I.isArrayLike = Yn, I.isArrayLikeObject = Qt, I.isBoolean = aD, I.isBuffer = ho, I.isDate = sD, I.isElement = lD, I.isEmpty = cD, I.isEqual = uD, I.isEqualWith = dD, I.isError = gm, I.isFinite = fD, I.isFunction = Li, I.isInteger = H2, I.isLength = Lu, I.isMap = G2, I.isMatch = hD, I.isMatchWith = pD, I.isNaN = mD, I.isNative = gD, I.isNil = yD, I.isNull = vD, I.isNumber = q2, I.isObject = Wt, I.isObjectLike = qt, I.isPlainObject = vl, I.isRegExp = vm, I.isSafeInteger = wD, I.isSet = Y2, I.isString = Fu, I.isSymbol = lr, I.isTypedArray = qa, I.isUndefined = bD, I.isWeakMap = xD, I.isWeakSet = ED, I.join = _9, I.kebabCase = dN, I.last = kr, I.lastIndexOf = P9, I.lowerCase = fN, I.lowerFirst = hN, I.lt = CD, I.lte = SD, I.max = s$, I.maxBy = l$, I.mean = c$, I.meanBy = u$, I.min = d$, I.minBy = f$, I.stubArray = _m, I.stubFalse = Pm, I.stubObject = ZN, I.stubString = QN, I.stubTrue = JN, I.multiply = h$, I.nth = k9, I.noConflict = WN, I.noop = Sm, I.now = Du, I.pad = pN, I.padEnd = mN, I.padStart = gN, I.parseInt = vN, I.random = aN, I.reduce = MI, I.reduceRight = OI, I.repeat = yN, I.replace = wN, I.result = XD, I.round = p$, I.runInContext = Y, I.sample = II, I.size = $I, I.snakeCase = bN, I.some = LI, I.sortedIndex = D9, I.sortedIndexBy = N9, I.sortedIndexOf = $9, I.sortedLastIndex = L9, I.sortedLastIndexBy = F9, I.sortedLastIndexOf = z9, I.startCase = EN, I.startsWith = CN, I.subtract = m$, I.sum = g$, I.sumBy = v$, I.template = SN, I.times = e$, I.toFinite = Fi, I.toInteger = Ke, I.toLength = X2, I.toLower = _N, I.toNumber = Tr, I.toSafeInteger = _D, I.toString = wt, I.toUpper = PN, I.trim = kN, I.trimEnd = TN, I.trimStart = AN, I.truncate = MN, I.unescape = ON, I.uniqueId = n$, I.upperCase = RN, I.upperFirst = bm, I.each = $2, I.eachRight = L2, I.first = R2, Cm(I, function() {
        var c = {};
        return di(I, function(h, w) {
          St.call(I.prototype, w) || (c[w] = h);
        }), c;
      }(), { chain: !1 }), I.VERSION = r, Er(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(c) {
        I[c].placeholder = I;
      }), Er(["drop", "take"], function(c, h) {
        ot.prototype[c] = function(w) {
          w = w === n ? 1 : un(Ke(w), 0);
          var P = this.__filtered__ && !h ? new ot(this) : this.clone();
          return P.__filtered__ ? P.__takeCount__ = Pn(w, P.__takeCount__) : P.__views__.push({
            size: Pn(w, Q),
            type: c + (P.__dir__ < 0 ? "Right" : "")
          }), P;
        }, ot.prototype[c + "Right"] = function(w) {
          return this.reverse()[c](w).reverse();
        };
      }), Er(["filter", "map", "takeWhile"], function(c, h) {
        var w = h + 1, P = w == B || w == H;
        ot.prototype[c] = function(M) {
          var $ = this.clone();
          return $.__iteratees__.push({
            iteratee: Be(M, 3),
            type: w
          }), $.__filtered__ = $.__filtered__ || P, $;
        };
      }), Er(["head", "last"], function(c, h) {
        var w = "take" + (h ? "Right" : "");
        ot.prototype[c] = function() {
          return this[w](1).value()[0];
        };
      }), Er(["initial", "tail"], function(c, h) {
        var w = "drop" + (h ? "" : "Right");
        ot.prototype[c] = function() {
          return this.__filtered__ ? new ot(this) : this[w](1);
        };
      }), ot.prototype.compact = function() {
        return this.filter(Xn);
      }, ot.prototype.find = function(c) {
        return this.filter(c).head();
      }, ot.prototype.findLast = function(c) {
        return this.reverse().find(c);
      }, ot.prototype.invokeMap = Ze(function(c, h) {
        return typeof c == "function" ? new ot(this) : this.map(function(w) {
          return dl(w, c, h);
        });
      }), ot.prototype.reject = function(c) {
        return this.filter($u(Be(c)));
      }, ot.prototype.slice = function(c, h) {
        c = Ke(c);
        var w = this;
        return w.__filtered__ && (c > 0 || h < 0) ? new ot(w) : (c < 0 ? w = w.takeRight(-c) : c && (w = w.drop(c)), h !== n && (h = Ke(h), w = h < 0 ? w.dropRight(-h) : w.take(h - c)), w);
      }, ot.prototype.takeRightWhile = function(c) {
        return this.reverse().takeWhile(c).reverse();
      }, ot.prototype.toArray = function() {
        return this.take(Q);
      }, di(ot.prototype, function(c, h) {
        var w = /^(?:filter|find|map|reject)|While$/.test(h), P = /^(?:head|last)$/.test(h), M = I[P ? "take" + (h == "last" ? "Right" : "") : h], $ = P || /^find/.test(h);
        M && (I.prototype[h] = function() {
          var V = this.__wrapped__, U = P ? [1] : arguments, K = V instanceof ot, ce = U[0], ue = K || qe(V), ve = function(et) {
            var ct = M.apply(I, oo([et], U));
            return P && Ae ? ct[0] : ct;
          };
          ue && w && typeof ce == "function" && ce.length != 1 && (K = ue = !1);
          var Ae = this.__chain__, Ne = !!this.__actions__.length, je = $ && !Ae, Xe = K && !Ne;
          if (!$ && ue) {
            V = Xe ? V : new ot(this);
            var We = c.apply(V, U);
            return We.__actions__.push({ func: Ru, args: [ve], thisArg: n }), new Sr(We, Ae);
          }
          return je && Xe ? c.apply(this, U) : (We = this.thru(ve), je ? P ? We.value()[0] : We.value() : We);
        });
      }), Er(["pop", "push", "shift", "sort", "splice", "unshift"], function(c) {
        var h = iu[c], w = /^(?:push|sort|unshift)$/.test(c) ? "tap" : "thru", P = /^(?:pop|shift)$/.test(c);
        I.prototype[c] = function() {
          var M = arguments;
          if (P && !this.__chain__) {
            var $ = this.value();
            return h.apply(qe($) ? $ : [], M);
          }
          return this[w](function(V) {
            return h.apply(qe(V) ? V : [], M);
          });
        };
      }), di(ot.prototype, function(c, h) {
        var w = I[h];
        if (w) {
          var P = w.name + "";
          St.call(ja, P) || (ja[P] = []), ja[P].push({ name: h, func: w });
        }
      }), ja[_u(n, b).name] = [{
        name: "wrapper",
        func: n
      }], ot.prototype.clone = OO, ot.prototype.reverse = RO, ot.prototype.value = IO, I.prototype.at = lI, I.prototype.chain = cI, I.prototype.commit = uI, I.prototype.next = dI, I.prototype.plant = hI, I.prototype.reverse = pI, I.prototype.toJSON = I.prototype.valueOf = I.prototype.value = mI, I.prototype.first = I.prototype.head, il && (I.prototype[il] = fI), I;
    }, za = uO();
    Bo ? ((Bo.exports = za)._ = za, Ep._ = za) : En._ = za;
  }).call(Bi);
})(Cf, Cf.exports);
var EZ = Cf.exports;
const CZ = $r(
  "ai-tw-cursor-pointer ai-tw-border-none ai-tw-bg-transparent ai-tw-outline-none data-[state=active]:ai-tw-text-element-brand",
  {
    variants: {
      size: {
        sm: "ai-tw-px-3 ai-tw-py-1.5 ai-tw-subtitle-sm",
        md: "ai-tw-px-4 ai-tw-py-2 ai-tw-subtitle-md"
      }
    }
  }
), sk = C.forwardRef(({ values: e, value: t, size: n = "sm", className: r, ...i }, o) => {
  var f;
  const a = ((f = e.find((p) => p.value === t)) == null ? void 0 : f.value) || e[0].value, [s, l] = C.useState({
    left: 0,
    width: 0
  }), [u, d] = C.useState(
    e.map(() => null)
  );
  return C.useLayoutEffect(() => {
    const p = e.findIndex((g) => g.value === a), m = u[p];
    m && requestAnimationFrame(() => {
      const g = e.slice(0, p).reduce((y, b, E) => {
        var _;
        const S = ((_ = u[E]) == null ? void 0 : _.getBoundingClientRect().width) ?? 0;
        return y + S;
      }, 0), { width: v } = m.getBoundingClientRect();
      g === s.left && v === s.width || l({ left: g, width: v });
    });
  }, [e, a, u, s]), /* @__PURE__ */ C.createElement(
    Dh,
    {
      className: ie(
        "ai-tw-relative ai-tw-w-max",
        "ai-tw-rounded-full ai-tw-border ai-tw-border-grey-20 ai-tw-text-content-primary-light",
        r
      ),
      ref: o,
      ...i
    },
    /* @__PURE__ */ C.createElement(
      mn.div,
      {
        animate: s,
        transition: { ease: "easeInOut", duration: 0.2 },
        className: ie(
          "ai-tw-pointer-events-none ai-tw-absolute ai-tw-h-full ",
          "ai-tw-rounded-full ai-tw-border-2 ai-tw-border-element-brand"
        )
      }
    ),
    e.map((p, m) => /* @__PURE__ */ C.createElement(
      Nh,
      {
        key: p.value + m,
        ref: (g) => {
          if (g && u[m] !== g) {
            if (u.length !== e.length) {
              d(e.map((v, y) => y === m ? g : null));
              return;
            }
            d((v) => v.map((y, b) => b === m ? g : y));
          }
        },
        className: CZ({ size: n }),
        value: p.value
      },
      p.display || EZ.startCase(p.value)
    ))
  );
});
sk.displayName = "TabTriggers";
const Ny = Dy, $y = C.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ C.createElement(
  Dh,
  {
    ref: n,
    className: ie(
      "ai-tw-inline-flex ai-tw-h-10 ai-tw-items-center ai-tw-justify-center ai-tw-gap-8 ai-tw-border-b  ai-tw-border-stroke-primary ai-tw-text-content-primary-light",
      e
    ),
    ...t
  }
));
$y.displayName = Dh.displayName;
const Sf = C.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ C.createElement(
  Nh,
  {
    ref: n,
    className: ie(
      "ai-tw-mt-0.5 ai-tw-inline-flex ai-tw-items-center ai-tw-justify-center ai-tw-whitespace-nowrap ai-tw-border-b-2  ai-tw-border-transparent ai-tw-py-2 ai-tw-uppercase ai-tw-transition-all ai-tw-button-md hover:ai-tw-text-content-brand-alt focus-visible:ai-tw-outline-none focus-visible:ai-tw-ring-1 focus-visible:ai-tw-ring-ring disabled:ai-tw-pointer-events-none disabled:ai-tw-opacity-50 data-[state=active]:ai-tw-border-content-brand-alt data-[state=active]:ai-tw-text-content-brand-alt",
      e
    ),
    ...t
  }
));
Sf.displayName = Nh.displayName;
const Rs = C.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ C.createElement(
  $h,
  {
    ref: n,
    className: ie(
      "ai-tw-py-4 ai-tw-ring-offset-background focus-visible:ai-tw-outline-none focus-visible:ai-tw-ring-2 focus-visible:ai-tw-ring-ring",
      e
    ),
    ...t
  }
));
Rs.displayName = $h.displayName;
function SZ(e, t, n) {
  return Math.min(Math.max(e, t), n);
}
const _Z = ({
  audioInfo: e,
  deleteError: t,
  setShowDeleteModal: n,
  setShowFeedbackModal: r,
  fetchError: i,
  isCallRecordingEnabled: o
}) => {
  var D;
  const { token: a } = Dc();
  if (!a)
    throw new Error("Missing user token for transcript component");
  const { hideAudio: s, hideSummary: l, hideTranscript: u } = Me(Ly) || {}, [d, f] = de(l), [p, m] = de(
    l ? "transcript" : "summary"
  );
  l !== d && (f(l), m(l ? "transcript" : "summary"));
  const g = me(null), v = me(null), [y, b] = de(""), [E, S] = de(!1), [_, k] = de(0);
  eo(() => {
    v.current && k(v.current.getBoundingClientRect().height);
  }, [v]);
  const T = () => n(!0), A = () => r(!0), R = [];
  l || R.push({
    value: "summary",
    display: u ? "AI Call Summary" : "AI Summary"
  }), u || R.push({
    value: "transcript",
    display: l ? "Call Transcript" : "Transcript"
  });
  const F = Lt(() => i ? o ? /* @__PURE__ */ x.createElement("div", { className: "ai-tw-grid ai-tw-place-items-center ai-tw-gap-2  ai-tw-text-grey-50" }, /* @__PURE__ */ x.createElement("p", null, "There was an error getting the transcript for this call. Please contact support if the issue persists.")) : /* @__PURE__ */ x.createElement("div", { className: "ai-tw-grid ai-tw-place-items-center ai-tw-gap-2  ai-tw-text-grey-50" }, /* @__PURE__ */ x.createElement("p", null, "Call recording is disabled for this tracking number. No transcription generated.")) : (e == null ? void 0 : e.status) === "too_short" ? /* @__PURE__ */ x.createElement("div", { className: "ai-tw-grid ai-tw-place-items-center ai-tw-gap-2  ai-tw-text-grey-50" }, /* @__PURE__ */ x.createElement("p", null, "This call was not long enough to generate a transcription.")) : (e == null ? void 0 : e.status) === "processing" || (e == null ? void 0 : e.status) === "pending" ? /* @__PURE__ */ x.createElement("div", { className: "ai-tw-grid ai-tw-place-items-center ai-tw-gap-2  ai-tw-text-grey-50" }, /* @__PURE__ */ x.createElement("p", null, "Audio recording and transcription for this call are on the way."), /* @__PURE__ */ x.createElement(jn, { size: "small" })) : (e == null ? void 0 : e.status) === "errored" ? /* @__PURE__ */ x.createElement("div", { className: "ai-tw-grid ai-tw-place-items-center ai-tw-gap-2  ai-tw-text-grey-50" }, /* @__PURE__ */ x.createElement("p", null, "There was an error processing the audio transcription for this call. Please contact support if this issue persists.")) : null, [e == null ? void 0 : e.status, i, o]);
  return /* @__PURE__ */ x.createElement(
    $P,
    {
      callback: (W) => {
        !y && W && (e != null && e.audioUrl) && (e.audioUrl.includes("write-a-plumber") ? b(`${e.audioUrl}/${a}`) : b(e.audioUrl));
      },
      root: document,
      rootMargin: "200px 0px",
      className: "ai-tw-preflight ai-tw-relative ai-tw-z-[2] ai-tw-overflow-hidden ai-tw-rounded-xl ai-tw-border ai-tw-border-grey-20 ai-tw-bg-white ai-tw-text-grey-60"
    },
    /* @__PURE__ */ x.createElement(Ny, { value: p, onValueChange: m }, /* @__PURE__ */ x.createElement("div", { className: "ai-tw-grid ai-tw-gap-4 ai-tw-border-b ai-tw-border-grey-20 ai-tw-p-6" }, s || !y ? null : /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-items-center ai-tw-gap-4" }, /* @__PURE__ */ x.createElement(
      Ry,
      {
        src: y,
        isPlaying: E,
        setIsPlaying: S
      }
    ), /* @__PURE__ */ x.createElement(
      mE,
      {
        openDeleteModal: T,
        openFeedbackModal: A
      }
    )), F, F || l && u ? null : /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-justify-between" }, /* @__PURE__ */ x.createElement(sk, { values: R, value: p }), s ? /* @__PURE__ */ x.createElement(
      mE,
      {
        openDeleteModal: T,
        openFeedbackModal: A
      }
    ) : null), t ? /* @__PURE__ */ x.createElement("span", { className: "ai-tw-flex ai-tw-items-center ai-tw-gap-2 ai-tw-text-destructive" }, /* @__PURE__ */ x.createElement(Le, { icon: to }), t) : null), F || l && u ? null : /* @__PURE__ */ x.createElement(
      nk,
      {
        key: p,
        withFade: !0,
        style: { height: SZ(_ + 52, 160, 400) },
        className: "ai-tw-overflow-auto ai-tw-px-6 ai-tw-py-3"
      },
      l ? null : /* @__PURE__ */ x.createElement(
        Rs,
        {
          className: "ai-tw-grid ai-tw-gap-4 ai-tw-body-md",
          ref: v,
          value: "summary",
          id: "summary"
        },
        (D = e == null ? void 0 : e.actionItems) != null && D.length ? /* @__PURE__ */ x.createElement("div", { className: "ai-tw-grid ai-tw-gap-1" }, /* @__PURE__ */ x.createElement("span", { className: "ai-tw-subtitle-md" }, "Action Items"), /* @__PURE__ */ x.createElement("ol", { className: "ai-tw-list-inside ai-tw-list-decimal" }, e.actionItems.map((W, L) => /* @__PURE__ */ x.createElement("li", { key: L }, W)))) : null,
        /* @__PURE__ */ x.createElement("div", { className: "ai-tw-grid ai-tw-gap-1" }, /* @__PURE__ */ x.createElement("span", { className: "ai-tw-subtitle-md" }, "Call Summary"), /* @__PURE__ */ x.createElement("p", { className: "ai-tw-whitespace-pre-wrap" }, (e == null ? void 0 : e.summary) || "No summary available."))
      ),
      u ? null : /* @__PURE__ */ x.createElement(Rs, { value: "transcript", id: "transcript" }, /* @__PURE__ */ x.createElement(
        wX,
        {
          onClickTime: (W) => {
            g.current && (S(!0), g.current.currentTime = +W, g.current.play());
          },
          transcript: e == null ? void 0 : e.transcription
        }
      ))
    ))
  );
};
function PZ() {
  return /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-w-max ai-tw-items-center ai-tw-gap-2 ai-tw-p-1 ai-tw-text-stroke-critical-dark" }, /* @__PURE__ */ x.createElement(Le, { icon: to }), /* @__PURE__ */ x.createElement("span", null, "Error Loading Transcript"));
}
const kZ = ({
  deletedAt: e,
  deletedBy: t
}) => {
  const n = e ? new Date(e).toLocaleDateString() : "";
  let r = `Audio recording, transcript, and call summary deleted on ${n}.`;
  return t && (r = `Audio recording, transcript, and call summary deleted${t.first_name ? ` by ${t.first_name}${t.last_name ? ` ${t.last_name}` : ""}` : ""} on ${n}`), /* @__PURE__ */ x.createElement("p", { className: "ai-tw-text-grey-50" }, r);
}, Ly = wn(null), xye = (e) => /* @__PURE__ */ x.createElement(Do, { fallback: /* @__PURE__ */ x.createElement(PZ, null) }, /* @__PURE__ */ x.createElement(Z1, null, /* @__PURE__ */ x.createElement(Ly.Provider, { value: e }, /* @__PURE__ */ x.createElement(TZ, null)))), TZ = () => {
  const [e, t] = de(!1), [n, r] = de(!1), {
    callSID: i,
    hideAudio: o,
    hideSummary: a,
    hideTranscript: s,
    isCallRecordingEnabled: l
  } = Me(Ly) || {}, {
    data: u,
    mutate: d,
    error: f,
    isLoading: p
  } = jY(i), [m, g] = de(null), v = WY(i);
  function y() {
    d(v, {
      optimisticData: {
        ...u,
        deletedAt: Date.now(),
        deletedBy: void 0
      },
      rollbackOnError: !0
    }).catch(() => {
      g(
        "Failed to delete transcription. Please try again or contact support."
      ), setTimeout(() => {
        g(null);
      }, 5e3);
    });
  }
  return o && a && s ? null : p ? /* @__PURE__ */ x.createElement(Fy, null, /* @__PURE__ */ x.createElement("p", null, "Loading"), /* @__PURE__ */ x.createElement(jn, { size: "small" })) : u != null && u.deletedAt ? /* @__PURE__ */ x.createElement(
    kZ,
    {
      deletedAt: u.deletedAt,
      deletedBy: u.deletedBy
    }
  ) : !u && !f ? null : /* @__PURE__ */ x.createElement("div", { className: "ai-tw-preflight" }, /* @__PURE__ */ x.createElement(
    _Z,
    {
      audioInfo: u,
      fetchError: !!f,
      deleteError: m,
      isCallRecordingEnabled: l || !1,
      setShowDeleteModal: t,
      setShowFeedbackModal: r
    }
  ), /* @__PURE__ */ x.createElement(
    uY,
    {
      handleDelete: y,
      open: e,
      setOpen: t
    }
  ), /* @__PURE__ */ x.createElement(
    JY,
    {
      open: n,
      setOpen: r,
      callSID: i,
      runId: u == null ? void 0 : u.summaryRunId
    }
  ));
};
function Fy({ className: e, ...t }) {
  return /* @__PURE__ */ x.createElement(
    "div",
    {
      className: ie(
        "ai-tw-preflight",
        "ai-tw-grid ai-tw-place-items-center ai-tw-gap-2 ai-tw-border ai-tw-border-grey-20 ai-tw-p-5 ai-tw-text-grey-50",
        e
      ),
      ...t
    }
  );
}
function Eye(e) {
  const [t, n] = de(!1);
  return /* @__PURE__ */ x.createElement("div", { className: "ai-tw-preflight ai-tw-flex ai-tw-items-center ai-tw-gap-4" }, /* @__PURE__ */ x.createElement(
    Ry,
    {
      isPlaying: t,
      setIsPlaying: n,
      ...e
    }
  ));
}
function AZ(e) {
  const t = dG(), n = e ? `/voicemails/${e}` : null;
  return yh(
    n,
    async (r) => {
      const i = await t(r, {
        timeout: 1e4
      });
      if (!i.ok && i.status !== 404)
        throw Error("error occurred while fetching voicemail");
      return await i.json();
    },
    {
      errorRetryCount: 1
    }
  );
}
const og = ({ children: e }) => /* @__PURE__ */ x.createElement("div", { className: " ai-tw-max-h-28 ai-tw-overflow-y-auto ai-tw-border-t ai-tw-border-grey-20 ai-tw-p-6 ai-tw-body-md" }, /* @__PURE__ */ x.createElement("p", { className: "ai-tw-italic" }, e)), MZ = ({
  audioUrl: e,
  audioInfo: t,
  error: n
}) => {
  const { status: r, transcription: i } = t || {};
  return e ? n || !t ? /* @__PURE__ */ x.createElement(og, null, "There was an error getting the transcript for this call. Please contact support if the issue persists.") : r === "processing" ? /* @__PURE__ */ x.createElement(Fy, { className: "ai-tw-border-t ai-tw-border-x-transparent ai-tw-border-b-transparent" }, /* @__PURE__ */ x.createElement("p", null, "The transcription for this call is on the way."), /* @__PURE__ */ x.createElement(jn, { size: "small" })) : r === "too_short" ? /* @__PURE__ */ x.createElement(og, null, "This call was not long enough to generate a transcription.") : r === "errored" ? /* @__PURE__ */ x.createElement(og, null, "There was an error processing the voicemail transcription for this call. Please contact support if this issue persists.") : /* @__PURE__ */ x.createElement("div", { className: "ai-tw-max-h-28 ai-tw-overflow-y-auto ai-tw-border-t ai-tw-border-t-grey-20 ai-tw-p-6 ai-tw-text-grey-60 ai-tw-body-md" }, /* @__PURE__ */ x.createElement("p", null, i)) : null;
};
function OZ() {
  return /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-w-max ai-tw-items-center ai-tw-gap-2 ai-tw-p-1 ai-tw-text-stroke-critical-dark" }, /* @__PURE__ */ x.createElement(Le, { icon: to }), /* @__PURE__ */ x.createElement("span", null, "Error Loading Voicemail"));
}
const Cye = ({ callSID: e, fallbackAudioUrl: t }) => /* @__PURE__ */ x.createElement(Do, { fallback: /* @__PURE__ */ x.createElement(OZ, null) }, /* @__PURE__ */ x.createElement(Z1, null, /* @__PURE__ */ x.createElement(
  RZ,
  {
    callSID: e,
    fallbackAudioUrl: t
  }
))), RZ = ({
  callSID: e,
  fallbackAudioUrl: t
}) => {
  const {
    data: n,
    error: r,
    isLoading: i
  } = AZ(e), [o, a] = de(!1), s = (n == null ? void 0 : n.audioUrl) || t;
  return i ? /* @__PURE__ */ x.createElement(Fy, null, /* @__PURE__ */ x.createElement("p", null, "Loading"), /* @__PURE__ */ x.createElement(jn, { size: "small" })) : /* @__PURE__ */ x.createElement("div", { className: "ai-tw-rounded-xl ai-tw-border ai-tw-border-grey-20" }, /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-items-center ai-tw-gap-4 ai-tw-border-grey-20 ai-tw-p-6" }, s ? /* @__PURE__ */ x.createElement(
    Ry,
    {
      src: s,
      isPlaying: o,
      setIsPlaying: a
    }
  ) : /* @__PURE__ */ x.createElement("div", { className: "ai-tw-italic" }, "Voicemail audio could not be found")), /* @__PURE__ */ x.createElement(
    MZ,
    {
      audioUrl: s,
      audioInfo: n,
      error: !!r
    }
  ));
};
function zy() {
  const e = ln();
  return br(
    "/gabbi/settings",
    () => e("/gabbi/settings", {
      method: "get"
    })
  );
}
const IZ = () => {
  const e = ln();
  return Hs("/gabbi/settings", async (n, {
    arg: r
  }) => {
    var i;
    try {
      await e(`${n}/agent`, {
        method: "post",
        json: r
      });
    } catch (o) {
      throw o instanceof hf ? await ((i = o == null ? void 0 : o.response) == null ? void 0 : i.json()) : new Error("Failed to save agent settings. Please try again later.");
    }
  });
}, DZ = () => {
  const e = ln();
  return Hs("/gabbi/settings", async (n, {
    arg: r
  }) => {
    var i;
    try {
      await e(`${n}/account`, {
        method: "post",
        json: r
      });
    } catch (o) {
      throw o instanceof hf ? await ((i = o == null ? void 0 : o.response) == null ? void 0 : i.json()) : new Error(
        "Failed to save account settings. Please try again later."
      );
    }
  });
}, bs = /* @__PURE__ */ new WeakMap(), Wd = /* @__PURE__ */ new WeakMap(), _f = {
  current: []
};
let ag = !1, Zl = 0;
const $l = /* @__PURE__ */ new Set(), cd = /* @__PURE__ */ new Map();
function lk(e) {
  const t = Array.from(e).sort((n, r) => n instanceof Hi && n.options.deps.includes(r) ? 1 : r instanceof Hi && r.options.deps.includes(n) ? -1 : 0);
  for (const n of t) {
    if (_f.current.includes(n))
      continue;
    _f.current.push(n), n.recompute();
    const r = Wd.get(n);
    if (r)
      for (const i of r) {
        const o = bs.get(i);
        o && lk(o);
      }
  }
}
function NZ(e) {
  e.listeners.forEach(
    (t) => t({
      prevVal: e.prevState,
      currentVal: e.state
    })
  );
}
function $Z(e) {
  e.listeners.forEach(
    (t) => t({
      prevVal: e.prevState,
      currentVal: e.state
    })
  );
}
function ck(e) {
  if (Zl > 0 && !cd.has(e) && cd.set(e, e.prevState), $l.add(e), !(Zl > 0) && !ag)
    try {
      for (ag = !0; $l.size > 0; ) {
        const t = Array.from($l);
        $l.clear();
        for (const n of t) {
          const r = cd.get(n) ?? n.prevState;
          n.prevState = r, NZ(n);
        }
        for (const n of t) {
          const r = bs.get(n);
          r && (_f.current.push(n), lk(r));
        }
        for (const n of t) {
          const r = bs.get(n);
          if (r)
            for (const i of r)
              $Z(i);
        }
      }
    } finally {
      ag = !1, _f.current = [], cd.clear();
    }
}
function pi(e) {
  Zl++;
  try {
    e();
  } finally {
    if (Zl--, Zl === 0) {
      const t = Array.from($l)[0];
      t && ck(t);
    }
  }
}
function LZ(e) {
  return typeof e == "function";
}
class a0 {
  constructor(t, n) {
    this.listeners = /* @__PURE__ */ new Set(), this.subscribe = (r) => {
      var i, o;
      this.listeners.add(r);
      const a = (o = (i = this.options) == null ? void 0 : i.onSubscribe) == null ? void 0 : o.call(i, r, this);
      return () => {
        this.listeners.delete(r), a == null || a();
      };
    }, this.prevState = t, this.state = t, this.options = n;
  }
  setState(t) {
    var n, r, i;
    this.prevState = this.state, (n = this.options) != null && n.updateFn ? this.state = this.options.updateFn(this.prevState)(t) : LZ(t) ? this.state = t(this.prevState) : this.state = t, (i = (r = this.options) == null ? void 0 : r.onUpdate) == null || i.call(r), ck(this);
  }
}
class Hi {
  constructor(t) {
    this.listeners = /* @__PURE__ */ new Set(), this._subscriptions = [], this.lastSeenDepValues = [], this.getDepVals = () => {
      const n = [], r = [];
      for (const i of this.options.deps)
        n.push(i.prevState), r.push(i.state);
      return this.lastSeenDepValues = r, {
        prevDepVals: n,
        currDepVals: r,
        prevVal: this.prevState ?? void 0
      };
    }, this.recompute = () => {
      var n, r;
      this.prevState = this.state;
      const { prevDepVals: i, currDepVals: o, prevVal: a } = this.getDepVals();
      this.state = this.options.fn({
        prevDepVals: i,
        currDepVals: o,
        prevVal: a
      }), (r = (n = this.options).onUpdate) == null || r.call(n);
    }, this.checkIfRecalculationNeededDeeply = () => {
      for (const o of this.options.deps)
        o instanceof Hi && o.checkIfRecalculationNeededDeeply();
      let n = !1;
      const r = this.lastSeenDepValues, { currDepVals: i } = this.getDepVals();
      for (let o = 0; o < i.length; o++)
        if (i[o] !== r[o]) {
          n = !0;
          break;
        }
      n && this.recompute();
    }, this.mount = () => (this.registerOnGraph(), this.checkIfRecalculationNeededDeeply(), () => {
      this.unregisterFromGraph();
      for (const n of this._subscriptions)
        n();
    }), this.subscribe = (n) => {
      var r, i;
      this.listeners.add(n);
      const o = (i = (r = this.options).onSubscribe) == null ? void 0 : i.call(r, n, this);
      return () => {
        this.listeners.delete(n), o == null || o();
      };
    }, this.options = t, this.state = t.fn({
      prevDepVals: void 0,
      prevVal: void 0,
      currDepVals: this.getDepVals().currDepVals
    });
  }
  registerOnGraph(t = this.options.deps) {
    for (const n of t)
      if (n instanceof Hi)
        n.registerOnGraph(), this.registerOnGraph(n.options.deps);
      else if (n instanceof a0) {
        let r = bs.get(n);
        r || (r = /* @__PURE__ */ new Set(), bs.set(n, r)), r.add(this);
        let i = Wd.get(this);
        i || (i = /* @__PURE__ */ new Set(), Wd.set(this, i)), i.add(n);
      }
  }
  unregisterFromGraph(t = this.options.deps) {
    for (const n of t)
      if (n instanceof Hi)
        this.unregisterFromGraph(n.options.deps);
      else if (n instanceof a0) {
        const r = bs.get(n);
        r && r.delete(this);
        const i = Wd.get(this);
        i && i.delete(n);
      }
  }
}
function Lh(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function Ll(e, t) {
  return Vy(t).reduce((r, i) => {
    if (r === null)
      return null;
    if (typeof r < "u")
      return r[i];
  }, e);
}
function ud(e, t, n) {
  const r = Vy(t);
  function i(o) {
    if (!r.length)
      return Lh(n, o);
    const a = r.shift();
    if (typeof a == "string" || typeof a == "number" && !Array.isArray(o))
      return typeof o == "object" ? (o === null && (o = {}), {
        ...o,
        [a]: i(o[a])
      }) : {
        [a]: i()
      };
    if (Array.isArray(o) && typeof a == "number") {
      const s = o.slice(0, a);
      return [
        ...s.length ? s : new Array(a),
        i(o[a]),
        ...o.slice(a + 1)
      ];
    }
    return [...new Array(a), i()];
  }
  return i(e);
}
function FZ(e, t) {
  const n = Vy(t);
  function r(i) {
    if (!i)
      return;
    if (n.length === 1) {
      const a = n[0];
      if (Array.isArray(i) && typeof a == "number")
        return i.filter((u, d) => d !== a);
      const { [a]: s, ...l } = i;
      return l;
    }
    const o = n.shift();
    if (typeof o == "string" && typeof i == "object")
      return {
        ...i,
        [o]: r(i[o])
      };
    if (typeof o == "number" && Array.isArray(i)) {
      if (o >= i.length)
        return i;
      const a = i.slice(0, o);
      return [
        ...a.length ? a : new Array(o),
        r(i[o]),
        ...i.slice(o + 1)
      ];
    }
    throw new Error("It seems we have created an infinite loop in deleteBy. ");
  }
  return r(e);
}
const zZ = /^(\d+)$/gm, VZ = /\.(\d+)(?=\.)/gm, BZ = /^(\d+)\./gm, jZ = /\.(\d+$)/gm, WZ = /\.{2,}/gm, s0 = "__int__", dd = `${s0}$1`;
function Vy(e) {
  if (Array.isArray(e))
    return [...e];
  if (typeof e != "string")
    throw new Error("Path must be a string.");
  return e.replace(/(^\[)|]/gm, "").replace(/\[/g, ".").replace(zZ, dd).replace(VZ, `.${dd}.`).replace(BZ, `${dd}.`).replace(jZ, `.${dd}`).replace(WZ, ".").split(".").map((t) => t.indexOf(s0) === 0 ? parseInt(t.substring(s0.length), 10) : t);
}
function UZ(e) {
  return !(Array.isArray(e) && e.length === 0);
}
function l0(e, t) {
  const { asyncDebounceMs: n } = t, {
    onChangeAsync: r,
    onBlurAsync: i,
    onSubmitAsync: o,
    onBlurAsyncDebounceMs: a,
    onChangeAsyncDebounceMs: s
  } = t.validators || {}, l = n ?? 0, u = {
    cause: "change",
    validate: r,
    debounceMs: s ?? l
  }, d = {
    cause: "blur",
    validate: i,
    debounceMs: a ?? l
  }, f = {
    cause: "submit",
    validate: o,
    debounceMs: 0
  }, p = (m) => ({ ...m, debounceMs: 0 });
  switch (e) {
    case "submit":
      return [
        p(u),
        p(d),
        f
      ];
    case "blur":
      return [d];
    case "change":
      return [u];
    case "server":
    default:
      return [];
  }
}
function c0(e, t) {
  const { onChange: n, onBlur: r, onSubmit: i, onMount: o } = t.validators || {}, a = { cause: "change", validate: n }, s = { cause: "blur", validate: r }, l = { cause: "submit", validate: i }, u = { cause: "mount", validate: o }, d = {
    cause: "server",
    validate: () => {
    }
  };
  switch (e) {
    case "mount":
      return [u];
    case "submit":
      return [
        a,
        s,
        l,
        d
      ];
    case "server":
      return [d];
    case "blur":
      return [s, d];
    case "change":
    default:
      return [a, d];
  }
}
const u0 = (e) => !!e && typeof e == "object" && "fields" in e;
function ss(e, t) {
  if (Object.is(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  if (e instanceof Map && t instanceof Map) {
    if (e.size !== t.size)
      return !1;
    for (const [i, o] of e)
      if (!t.has(i) || !Object.is(o, t.get(i)))
        return !1;
    return !0;
  }
  if (e instanceof Set && t instanceof Set) {
    if (e.size !== t.size)
      return !1;
    for (const i of e)
      if (!t.has(i))
        return !1;
    return !0;
  }
  const n = Object.keys(e), r = Object.keys(t);
  if (n.length !== r.length)
    return !1;
  for (const i of n)
    if (!r.includes(i) || !ss(e[i], t[i]))
      return !1;
  return !0;
}
const yE = ({
  newFormValidatorError: e,
  isPreviousErrorFromFormValidator: t,
  previousErrorValue: n
}) => e ? { newErrorValue: e, newSource: "form" } : t ? { newErrorValue: void 0, newSource: void 0 } : n ? { newErrorValue: n, newSource: "field" } : { newErrorValue: void 0, newSource: void 0 }, wE = ({
  formLevelError: e,
  fieldLevelError: t
}) => t ? { newErrorValue: t, newSource: "field" } : e ? { newErrorValue: e, newSource: "form" } : { newErrorValue: void 0, newSource: void 0 };
function HZ(e) {
  const t = /* @__PURE__ */ new Map();
  for (const n of e) {
    const r = [...n.path ?? []].map((i) => {
      const o = typeof i == "object" ? i.key : i;
      return typeof o == "number" ? `[${o}]` : o;
    }).join(".").replace(/\.\[/g, "[");
    t.set(r, (t.get(r) ?? []).concat(n));
  }
  return Object.fromEntries(t);
}
const bE = (e) => {
  const t = HZ(e);
  return {
    form: t,
    fields: t
  };
}, xs = {
  validate({
    value: e,
    validationSource: t
  }, n) {
    const r = n["~standard"].validate(e);
    if (r instanceof Promise)
      throw new Error("async function passed to sync validator");
    if (r.issues)
      return t === "field" ? r.issues : bE(r.issues);
  },
  async validateAsync({
    value: e,
    validationSource: t
  }, n) {
    const r = await n["~standard"].validate(e);
    if (r.issues)
      return t === "field" ? r.issues : bE(r.issues);
  }
}, uk = (e) => !!e && "~standard" in e, Pf = {
  isValidating: !1,
  isTouched: !1,
  isBlurred: !1,
  isDirty: !1,
  isPristine: !0,
  isValid: !0,
  isDefaultValue: !0,
  errors: [],
  errorMap: {},
  errorSourceMap: {}
};
function fd(e) {
  function t(f, p, m, g) {
    const v = r(f, p, m, g);
    ({
      insert: () => s(v, f, p),
      remove: () => l(v),
      swap: () => g !== void 0 && d(v, f, p, g),
      move: () => g !== void 0 && u(v, f, p, g)
    })[m]();
  }
  function n(f, p) {
    return `${f}[${p}]`;
  }
  function r(f, p, m, g) {
    const v = [n(f, p)];
    if (m === "swap")
      v.push(n(f, g));
    else if (m === "move") {
      const [y, b] = [
        Math.min(p, g),
        Math.max(p, g)
      ];
      for (let E = y; E <= b; E++)
        v.push(n(f, E));
    } else {
      const y = e.getFieldValue(f), b = Array.isArray(y) ? y.length : 0;
      for (let E = p + 1; E < b; E++)
        v.push(n(f, E));
    }
    return Object.keys(e.fieldInfo).filter(
      (y) => v.some((b) => y.startsWith(b))
    );
  }
  function i(f, p) {
    return f.replace(/\[(\d+)\]/, (m, g) => {
      const v = parseInt(g, 10);
      return `[${p === "up" ? v + 1 : Math.max(0, v - 1)}]`;
    });
  }
  function o(f, p) {
    (p === "up" ? f : [...f].reverse()).forEach((g) => {
      const v = i(g.toString(), p), y = e.getFieldMeta(v);
      y ? e.setFieldMeta(g, y) : e.setFieldMeta(g, a());
    });
  }
  const a = () => Pf, s = (f, p, m) => {
    o(f, "down"), f.forEach((g) => {
      g.toString().startsWith(n(p, m)) && e.setFieldMeta(g, a());
    });
  }, l = (f) => {
    o(f, "up");
  }, u = (f, p, m, g) => {
    const v = new Map(
      Object.keys(e.fieldInfo).filter(
        (y) => y.startsWith(n(p, m))
      ).map((y) => [
        y,
        e.getFieldMeta(y)
      ])
    );
    o(f, m < g ? "up" : "down"), Object.keys(e.fieldInfo).filter((y) => y.startsWith(n(p, g))).forEach((y) => {
      const b = y.replace(
        n(p, g),
        n(p, m)
      ), E = v.get(b);
      E && e.setFieldMeta(y, E);
    });
  }, d = (f, p, m, g) => {
    f.forEach((v) => {
      if (!v.toString().startsWith(n(p, m)))
        return;
      const y = v.toString().replace(
        n(p, m),
        n(p, g)
      ), [b, E] = [
        e.getFieldMeta(v),
        e.getFieldMeta(y)
      ];
      b && e.setFieldMeta(y, b), E && e.setFieldMeta(v, E);
    });
  };
  return { handleArrayFieldMetaShift: t };
}
function sg(e) {
  return {
    values: e.values ?? {},
    errorMap: e.errorMap ?? {},
    fieldMetaBase: e.fieldMetaBase ?? {},
    isSubmitted: e.isSubmitted ?? !1,
    isSubmitting: e.isSubmitting ?? !1,
    isValidating: e.isValidating ?? !1,
    submissionAttempts: e.submissionAttempts ?? 0,
    isSubmitSuccessful: e.isSubmitSuccessful ?? !1,
    validationMetaMap: e.validationMetaMap ?? {
      onChange: void 0,
      onBlur: void 0,
      onSubmit: void 0,
      onMount: void 0,
      onServer: void 0
    }
  };
}
class GZ {
  /**
   * Constructs a new `FormApi` instance with the given form options.
   */
  constructor(t) {
    var n;
    this.options = {}, this.fieldInfo = {}, this.prevTransformArray = [], this.mount = () => {
      var r, i;
      const o = this.fieldMetaDerived.mount(), a = this.store.mount(), s = () => {
        o(), a();
      };
      (i = (r = this.options.listeners) == null ? void 0 : r.onMount) == null || i.call(r, { formApi: this });
      const { onMount: l } = this.options.validators || {};
      return l && this.validateSync("mount"), s;
    }, this.update = (r) => {
      var i, o;
      if (!r)
        return;
      const a = this.options;
      this.options = r;
      const s = !!((o = (i = r.transform) == null ? void 0 : i.deps) != null && o.some(
        (d, f) => d !== this.prevTransformArray[f]
      )), l = r.defaultValues && !ss(r.defaultValues, a.defaultValues) && !this.state.isTouched, u = !ss(r.defaultState, a.defaultState) && !this.state.isTouched;
      !l && !u && !s || pi(() => {
        this.baseStore.setState(
          () => sg(
            Object.assign(
              {},
              this.state,
              u ? r.defaultState : {},
              l ? {
                values: r.defaultValues
              } : {},
              s ? { _force_re_eval: !this.state._force_re_eval } : {}
            )
          )
        );
      });
    }, this.reset = (r, i) => {
      const { fieldMeta: o } = this.state, a = this.resetFieldMeta(o);
      r && !(i != null && i.keepDefaultValues) && (this.options = {
        ...this.options,
        defaultValues: r
      }), this.baseStore.setState(
        () => {
          var s;
          return sg({
            ...this.options.defaultState,
            values: r ?? this.options.defaultValues ?? ((s = this.options.defaultState) == null ? void 0 : s.values),
            fieldMetaBase: a
          });
        }
      );
    }, this.validateAllFields = async (r) => {
      const i = [];
      return pi(() => {
        Object.values(this.fieldInfo).forEach(
          (a) => {
            if (!a.instance)
              return;
            const s = a.instance;
            i.push(
              // Remember, `validate` is either a sync operation or a promise
              Promise.resolve().then(
                () => s.validate(r, { skipFormValidation: !0 })
              )
            ), a.instance.state.meta.isTouched || a.instance.setMeta((l) => ({ ...l, isTouched: !0 }));
          }
        );
      }), (await Promise.all(i)).flat();
    }, this.validateArrayFieldsStartingFrom = async (r, i, o) => {
      const a = this.getFieldValue(r), s = Array.isArray(a) ? Math.max(a.length - 1, 0) : null, l = [`${r}[${i}]`];
      for (let p = i + 1; p <= (s ?? 0); p++)
        l.push(`${r}[${p}]`);
      const u = Object.keys(this.fieldInfo).filter(
        (p) => l.some((m) => p.startsWith(m))
      ), d = [];
      return pi(() => {
        u.forEach((p) => {
          d.push(
            Promise.resolve().then(() => this.validateField(p, o))
          );
        });
      }), (await Promise.all(d)).flat();
    }, this.validateField = (r, i) => {
      var o;
      const a = (o = this.fieldInfo[r]) == null ? void 0 : o.instance;
      return a ? (a.state.meta.isTouched || a.setMeta((s) => ({ ...s, isTouched: !0 })), a.validate(i)) : [];
    }, this.validateSync = (r) => {
      const i = c0(r, this.options);
      let o = !1;
      const a = {};
      return pi(() => {
        var s, l;
        for (const d of i) {
          if (!d.validate)
            continue;
          const f = this.runValidator({
            validate: d.validate,
            value: {
              value: this.state.values,
              formApi: this,
              validationSource: "form"
            },
            type: "validate"
          }), { formError: p, fieldErrors: m } = Ud(f), g = hd(d.cause);
          for (const v of Object.keys(
            this.state.fieldMeta
          )) {
            const y = this.getFieldMeta(v);
            if (!y)
              continue;
            const {
              errorMap: b,
              errorSourceMap: E
            } = y, S = m == null ? void 0 : m[v], { newErrorValue: _, newSource: k } = yE({
              newFormValidatorError: S,
              isPreviousErrorFromFormValidator: (
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                (E == null ? void 0 : E[g]) === "form"
              ),
              // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
              previousErrorValue: b == null ? void 0 : b[g]
            });
            k === "form" && (a[v] = {
              ...a[v],
              [g]: S
            }), // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            (b == null ? void 0 : b[g]) !== _ && this.setFieldMeta(v, (T) => ({
              ...T,
              errorMap: {
                ...T.errorMap,
                [g]: _
              },
              errorSourceMap: {
                ...T.errorSourceMap,
                [g]: k
              }
            }));
          }
          ((s = this.state.errorMap) == null ? void 0 : s[g]) !== p && this.baseStore.setState((v) => ({
            ...v,
            errorMap: {
              ...v.errorMap,
              [g]: p
            }
          })), (p || m) && (o = !0);
        }
        const u = hd("submit");
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        (l = this.state.errorMap) != null && l[u] && r !== "submit" && !o && this.baseStore.setState((d) => ({
          ...d,
          errorMap: {
            ...d.errorMap,
            [u]: void 0
          }
        }));
      }), { hasErrored: o, fieldsErrorMap: a };
    }, this.validateAsync = async (r) => {
      const i = l0(r, this.options);
      this.state.isFormValidating || this.baseStore.setState((u) => ({ ...u, isFormValidating: !0 }));
      const o = [];
      let a;
      for (const u of i) {
        if (!u.validate)
          continue;
        const d = hd(u.cause), f = this.state.validationMetaMap[d];
        f == null || f.lastAbortController.abort();
        const p = new AbortController();
        this.state.validationMetaMap[d] = {
          lastAbortController: p
        }, o.push(
          new Promise(async (m) => {
            let g;
            try {
              g = await new Promise((E, S) => {
                setTimeout(async () => {
                  if (p.signal.aborted)
                    return E(void 0);
                  try {
                    E(
                      await this.runValidator({
                        validate: u.validate,
                        value: {
                          value: this.state.values,
                          formApi: this,
                          validationSource: "form",
                          signal: p.signal
                        },
                        type: "validateAsync"
                      })
                    );
                  } catch (_) {
                    S(_);
                  }
                }, u.debounceMs);
              });
            } catch (E) {
              g = E;
            }
            const { formError: v, fieldErrors: y } = Ud(g);
            y && (a = a ? {
              ...a,
              ...y
            } : y);
            const b = hd(u.cause);
            for (const E of Object.keys(
              this.state.fieldMeta
            )) {
              const S = this.getFieldMeta(E);
              if (!S)
                continue;
              const {
                errorMap: _,
                errorSourceMap: k
              } = S, T = a == null ? void 0 : a[E], { newErrorValue: A, newSource: R } = yE({
                newFormValidatorError: T,
                isPreviousErrorFromFormValidator: (
                  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                  (k == null ? void 0 : k[b]) === "form"
                ),
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                previousErrorValue: _ == null ? void 0 : _[b]
              });
              // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
              (_ == null ? void 0 : _[b]) !== A && this.setFieldMeta(E, (F) => ({
                ...F,
                errorMap: {
                  ...F.errorMap,
                  [b]: A
                },
                errorSourceMap: {
                  ...F.errorSourceMap,
                  [b]: R
                }
              }));
            }
            this.baseStore.setState((E) => ({
              ...E,
              errorMap: {
                ...E.errorMap,
                [b]: v
              }
            })), m(
              a ? { fieldErrors: a, errorMapKey: b } : void 0
            );
          })
        );
      }
      let s = [];
      const l = {};
      if (o.length) {
        s = await Promise.all(o);
        for (const u of s)
          if (u != null && u.fieldErrors) {
            const { errorMapKey: d } = u;
            for (const [f, p] of Object.entries(
              u.fieldErrors
            )) {
              const g = {
                ...l[f] || {},
                [d]: p
              };
              l[f] = g;
            }
          }
      }
      return this.baseStore.setState((u) => ({
        ...u,
        isFormValidating: !1
      })), l;
    }, this.validate = (r) => {
      const { hasErrored: i, fieldsErrorMap: o } = this.validateSync(r);
      return i && !this.options.asyncAlways ? o : this.validateAsync(r);
    }, this.getFieldValue = (r) => Ll(this.state.values, r), this.getFieldMeta = (r) => this.state.fieldMeta[r], this.getFieldInfo = (r) => {
      var i;
      return (i = this.fieldInfo)[r] || (i[r] = {
        instance: null,
        validationMetaMap: {
          onChange: void 0,
          onBlur: void 0,
          onSubmit: void 0,
          onMount: void 0,
          onServer: void 0
        }
      });
    }, this.setFieldMeta = (r, i) => {
      this.baseStore.setState((o) => ({
        ...o,
        fieldMetaBase: {
          ...o.fieldMetaBase,
          [r]: Lh(
            i,
            o.fieldMetaBase[r]
          )
        }
      }));
    }, this.resetFieldMeta = (r) => Object.keys(r).reduce(
      (i, o) => {
        const a = o;
        return i[a] = Pf, i;
      },
      {}
    ), this.setFieldValue = (r, i, o) => {
      const a = (o == null ? void 0 : o.dontUpdateMeta) ?? !1;
      pi(() => {
        a || this.setFieldMeta(r, (s) => ({
          ...s,
          isTouched: !0,
          isDirty: !0,
          errorMap: {
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            ...s == null ? void 0 : s.errorMap,
            onMount: void 0
          }
        })), this.baseStore.setState((s) => ({
          ...s,
          values: ud(s.values, r, i)
        }));
      });
    }, this.deleteField = (r) => {
      const o = [...Object.keys(this.fieldInfo).filter((a) => {
        const s = r.toString();
        return a !== s && a.startsWith(s);
      }), r];
      this.baseStore.setState((a) => {
        const s = { ...a };
        return o.forEach((l) => {
          s.values = FZ(s.values, l), delete this.fieldInfo[l], delete s.fieldMetaBase[l];
        }), s;
      });
    }, this.pushFieldValue = (r, i, o) => {
      this.setFieldValue(
        r,
        (a) => [...Array.isArray(a) ? a : [], i],
        o
      ), this.validateField(r, "change");
    }, this.insertFieldValue = async (r, i, o, a) => {
      this.setFieldValue(
        r,
        (s) => [
          ...s.slice(0, i),
          o,
          ...s.slice(i)
        ],
        a
      ), await this.validateField(r, "change"), fd(this).handleArrayFieldMetaShift(r, i, "insert"), await this.validateArrayFieldsStartingFrom(r, i, "change");
    }, this.replaceFieldValue = async (r, i, o, a) => {
      this.setFieldValue(
        r,
        (s) => s.map(
          (l, u) => u === i ? o : l
        ),
        a
      ), await this.validateField(r, "change"), await this.validateArrayFieldsStartingFrom(r, i, "change");
    }, this.removeFieldValue = async (r, i, o) => {
      const a = this.getFieldValue(r), s = Array.isArray(a) ? Math.max(a.length - 1, 0) : null;
      if (this.setFieldValue(
        r,
        (l) => l.filter(
          (u, d) => d !== i
        ),
        o
      ), fd(this).handleArrayFieldMetaShift(r, i, "remove"), s !== null) {
        const l = `${r}[${s}]`;
        this.deleteField(l);
      }
      await this.validateField(r, "change"), await this.validateArrayFieldsStartingFrom(r, i, "change");
    }, this.swapFieldValues = (r, i, o, a) => {
      this.setFieldValue(
        r,
        (s) => {
          const l = s[i], u = s[o];
          return ud(ud(s, `${i}`, u), `${o}`, l);
        },
        a
      ), fd(this).handleArrayFieldMetaShift(r, i, "swap", o), this.validateField(r, "change"), this.validateField(`${r}[${i}]`, "change"), this.validateField(`${r}[${o}]`, "change");
    }, this.moveFieldValues = (r, i, o, a) => {
      this.setFieldValue(
        r,
        (s) => {
          const l = [...s];
          return l.splice(o, 0, l.splice(i, 1)[0]), l;
        },
        a
      ), fd(this).handleArrayFieldMetaShift(r, i, "move", o), this.validateField(r, "change"), this.validateField(`${r}[${i}]`, "change"), this.validateField(`${r}[${o}]`, "change");
    }, this.clearFieldValues = (r, i) => {
      const o = this.getFieldValue(r), a = Array.isArray(o) ? Math.max(o.length - 1, 0) : null;
      if (this.setFieldValue(r, [], i), a !== null)
        for (let s = 0; s <= a; s++) {
          const l = `${r}[${s}]`;
          this.deleteField(l);
        }
      this.validateField(r, "change");
    }, this.resetField = (r) => {
      this.baseStore.setState((i) => ({
        ...i,
        fieldMetaBase: {
          ...i.fieldMetaBase,
          [r]: Pf
        },
        values: this.options.defaultValues ? ud(i.values, r, Ll(this.options.defaultValues, r)) : i.values
      }));
    }, this.getAllErrors = () => ({
      form: {
        errors: this.state.errors,
        errorMap: this.state.errorMap
      },
      fields: Object.entries(this.state.fieldMeta).reduce(
        (r, [i, o]) => (Object.keys(o).length && o.errors.length && (r[i] = {
          errors: o.errors,
          errorMap: o.errorMap
        }), r),
        {}
      )
    }), this.parseValuesWithSchema = (r) => xs.validate(
      { value: this.state.values, validationSource: "form" },
      r
    ), this.parseValuesWithSchemaAsync = (r) => xs.validateAsync(
      { value: this.state.values, validationSource: "form" },
      r
    ), this.baseStore = new a0(
      sg({
        ...t == null ? void 0 : t.defaultState,
        values: (t == null ? void 0 : t.defaultValues) ?? ((n = t == null ? void 0 : t.defaultState) == null ? void 0 : n.values)
      })
    ), this.fieldMetaDerived = new Hi({
      deps: [this.baseStore],
      fn: ({ prevDepVals: r, currDepVals: i, prevVal: o }) => {
        var a, s, l;
        const u = o, d = r == null ? void 0 : r[0], f = i[0];
        let p = 0;
        const m = {};
        for (const g of Object.keys(
          f.fieldMetaBase
        )) {
          const v = f.fieldMetaBase[g], y = d == null ? void 0 : d.fieldMetaBase[g], b = u == null ? void 0 : u[g], E = Ll(f.values, g);
          let S = b == null ? void 0 : b.errors;
          if (!y || v.errorMap !== y.errorMap) {
            S = Object.values(v.errorMap ?? {}).filter(
              (R) => R !== void 0
            );
            const A = (a = this.getFieldInfo(g)) == null ? void 0 : a.instance;
            A && !A.options.disableErrorFlat && (S = S == null ? void 0 : S.flat(
              1
            ));
          }
          const _ = !UZ(S ?? []), k = !v.isDirty, T = ss(
            E,
            Ll(this.options.defaultValues, g)
          ) || ss(
            E,
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            (l = (s = this.getFieldInfo(g)) == null ? void 0 : s.instance) == null ? void 0 : l.options.defaultValue
          );
          if (b && b.isPristine === k && b.isValid === _ && b.isDefaultValue === T && b.errors === S && v === y) {
            m[g] = b, p++;
            continue;
          }
          m[g] = {
            ...v,
            errors: S,
            isPristine: k,
            isValid: _,
            isDefaultValue: T
          };
        }
        return Object.keys(f.fieldMetaBase).length && u && p === Object.keys(f.fieldMetaBase).length ? u : m;
      }
    }), this.store = new Hi({
      deps: [this.baseStore, this.fieldMetaDerived],
      fn: ({ prevDepVals: r, currDepVals: i, prevVal: o }) => {
        var a, s, l, u;
        const d = o, f = r == null ? void 0 : r[0], p = i[0], m = i[1], g = Object.values(m).filter(
          Boolean
        ), v = g.some(
          (q) => q.isValidating
        ), y = g.every((q) => q.isValid), b = g.some((q) => q.isTouched), E = g.some((q) => q.isBlurred), S = g.every(
          (q) => q.isDefaultValue
        ), _ = (
          // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
          b && ((a = p.errorMap) == null ? void 0 : a.onMount)
        ), k = g.some((q) => q.isDirty), T = !k, A = !!// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        ((s = p.errorMap) != null && s.onMount || // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        g.some((q) => {
          var Z;
          return (Z = q == null ? void 0 : q.errorMap) == null ? void 0 : Z.onMount;
        })), R = !!v;
        let F = (d == null ? void 0 : d.errors) ?? [];
        (!f || p.errorMap !== f.errorMap) && (F = Object.values(p.errorMap).reduce((q, Z) => Z === void 0 ? q : Z && u0(Z) ? (q.push(Z.form), q) : (q.push(Z), q), []));
        const D = F.length === 0, W = y && D, L = this.options.canSubmitWhenInvalid ?? !1, z = p.submissionAttempts === 0 && !b && !A || !R && !p.isSubmitting && W || L;
        let B = p.errorMap;
        if (_ && (F = F.filter(
          (q) => q !== p.errorMap.onMount
        ), B = Object.assign(B, { onMount: void 0 })), d && f && d.errorMap === B && d.fieldMeta === this.fieldMetaDerived.state && d.errors === F && d.isFieldsValidating === v && d.isFieldsValid === y && d.isFormValid === D && d.isValid === W && d.canSubmit === z && d.isTouched === b && d.isBlurred === E && d.isPristine === T && d.isDefaultValue === S && d.isDirty === k && ss(f, p))
          return d;
        let G = {
          ...p,
          errorMap: B,
          fieldMeta: this.fieldMetaDerived.state,
          errors: F,
          isFieldsValidating: v,
          isFieldsValid: y,
          isFormValid: D,
          isValid: W,
          canSubmit: z,
          isTouched: b,
          isBlurred: E,
          isPristine: T,
          isDefaultValue: S,
          isDirty: k
        };
        const H = ((l = this.options.transform) == null ? void 0 : l.deps) ?? [];
        if (H.length !== this.prevTransformArray.length || H.some((q, Z) => q !== this.prevTransformArray[Z])) {
          const q = Object.assign({}, this, { state: G });
          (u = this.options.transform) == null || u.fn(q), G = q.state, this.prevTransformArray = H;
        }
        return G;
      }
    }), this.handleSubmit = this.handleSubmit.bind(this), this.update(t || {});
  }
  get state() {
    return this.store.state;
  }
  /**
   * @private
   */
  runValidator(t) {
    return uk(t.validate) ? xs[t.type](
      t.value,
      t.validate
    ) : t.validate(t.value);
  }
  async handleSubmit(t) {
    var n, r, i, o, a, s, l, u;
    if (this.baseStore.setState((f) => ({
      ...f,
      // Submission attempts mark the form as not submitted
      isSubmitted: !1,
      // Count submission attempts
      submissionAttempts: f.submissionAttempts + 1,
      isSubmitSuccessful: !1
      // Reset isSubmitSuccessful at the start of submission
    })), pi(() => {
      Object.values(this.fieldInfo).forEach(
        (f) => {
          f.instance && (f.instance.state.meta.isTouched || f.instance.setMeta((p) => ({ ...p, isTouched: !0 })));
        }
      );
    }), !this.state.canSubmit)
      return;
    this.baseStore.setState((f) => ({ ...f, isSubmitting: !0 }));
    const d = () => {
      this.baseStore.setState((f) => ({ ...f, isSubmitting: !1 }));
    };
    if (await this.validateAllFields("submit"), !this.state.isFieldsValid) {
      d(), (r = (n = this.options).onSubmitInvalid) == null || r.call(n, {
        value: this.state.values,
        formApi: this
      });
      return;
    }
    if (await this.validate("submit"), !this.state.isValid) {
      d(), (o = (i = this.options).onSubmitInvalid) == null || o.call(i, {
        value: this.state.values,
        formApi: this
      });
      return;
    }
    pi(() => {
      Object.values(this.fieldInfo).forEach(
        (f) => {
          var p, m, g;
          (g = (m = (p = f.instance) == null ? void 0 : p.options.listeners) == null ? void 0 : m.onSubmit) == null || g.call(m, {
            value: f.instance.state.value,
            fieldApi: f.instance
          });
        }
      );
    }), (s = (a = this.options.listeners) == null ? void 0 : a.onSubmit) == null || s.call(a, { formApi: this });
    try {
      await ((u = (l = this.options).onSubmit) == null ? void 0 : u.call(l, {
        value: this.state.values,
        formApi: this,
        meta: t ?? this.options.onSubmitMeta
      })), pi(() => {
        this.baseStore.setState((f) => ({
          ...f,
          isSubmitted: !0,
          isSubmitSuccessful: !0
          // Set isSubmitSuccessful to true on successful submission
        })), d();
      });
    } catch (f) {
      throw this.baseStore.setState((p) => ({
        ...p,
        isSubmitSuccessful: !1
        // Ensure isSubmitSuccessful is false if an error occurs
      })), d(), f;
    }
  }
  /**
   * Updates the form's errorMap
   */
  setErrorMap(t) {
    pi(() => {
      Object.entries(t).forEach(([n, r]) => {
        const i = n;
        if (u0(r)) {
          const { formError: o, fieldErrors: a } = Ud(r);
          for (const s of Object.keys(
            this.fieldInfo
          ))
            this.getFieldMeta(s) && this.setFieldMeta(s, (u) => ({
              ...u,
              errorMap: {
                ...u.errorMap,
                [i]: a == null ? void 0 : a[s]
              },
              errorSourceMap: {
                ...u.errorSourceMap,
                [i]: "form"
              }
            }));
          this.baseStore.setState((s) => ({
            ...s,
            errorMap: {
              ...s.errorMap,
              [i]: o
            }
          }));
        } else
          this.baseStore.setState((o) => ({
            ...o,
            errorMap: {
              ...o.errorMap,
              [i]: r
            }
          }));
      });
    });
  }
}
function Ud(e) {
  if (e) {
    if (u0(e)) {
      const t = Ud(e.form).formError, n = e.fields;
      return { formError: t, fieldErrors: n };
    }
    return { formError: e };
  }
  return { formError: void 0 };
}
function hd(e) {
  switch (e) {
    case "submit":
      return "onSubmit";
    case "blur":
      return "onBlur";
    case "mount":
      return "onMount";
    case "server":
      return "onServer";
    case "change":
    default:
      return "onChange";
  }
}
class qZ {
  /**
   * Initializes a new `FieldApi` instance.
   */
  constructor(t) {
    this.options = {}, this.mount = () => {
      var n, r;
      const i = this.store.mount();
      this.options.defaultValue !== void 0 && this.form.setFieldValue(this.name, this.options.defaultValue, {
        dontUpdateMeta: !0
      });
      const o = this.getInfo();
      o.instance = this, this.update(this.options);
      const { onMount: a } = this.options.validators || {};
      if (a) {
        const s = this.runValidator({
          validate: a,
          value: {
            value: this.state.value,
            fieldApi: this,
            validationSource: "field"
          },
          type: "validate"
        });
        s && this.setMeta(
          (l) => ({
            ...l,
            // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
            errorMap: { ...l == null ? void 0 : l.errorMap, onMount: s },
            errorSourceMap: {
              // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
              ...l == null ? void 0 : l.errorSourceMap,
              onMount: "field"
            }
          })
        );
      }
      return (r = (n = this.options.listeners) == null ? void 0 : n.onMount) == null || r.call(n, {
        value: this.state.value,
        fieldApi: this
      }), i;
    }, this.update = (n) => {
      this.options = n;
      const r = this.name !== n.name;
      if (this.name = n.name, this.state.value === void 0) {
        const i = Ll(n.form.options.defaultValues, n.name), o = n.defaultValue ?? i;
        r ? this.setValue((a) => a || o, {
          dontUpdateMeta: !0
        }) : o !== void 0 && this.setValue(o, {
          dontUpdateMeta: !0
        });
      }
      this.form.getFieldMeta(this.name) === void 0 && this.setMeta(this.state.meta);
    }, this.getValue = () => this.form.getFieldValue(this.name), this.setValue = (n, r) => {
      this.form.setFieldValue(this.name, n, r), this.triggerOnChangeListener(), this.validate("change");
    }, this.getMeta = () => this.store.state.meta, this.setMeta = (n) => this.form.setFieldMeta(this.name, n), this.getInfo = () => this.form.getFieldInfo(this.name), this.pushValue = (n, r) => {
      this.form.pushFieldValue(this.name, n, r), this.triggerOnChangeListener();
    }, this.insertValue = (n, r, i) => {
      this.form.insertFieldValue(this.name, n, r, i), this.triggerOnChangeListener();
    }, this.replaceValue = (n, r, i) => {
      this.form.replaceFieldValue(this.name, n, r, i), this.triggerOnChangeListener();
    }, this.removeValue = (n, r) => {
      this.form.removeFieldValue(this.name, n, r), this.triggerOnChangeListener();
    }, this.swapValues = (n, r, i) => {
      this.form.swapFieldValues(this.name, n, r, i), this.triggerOnChangeListener();
    }, this.moveValue = (n, r, i) => {
      this.form.moveFieldValues(this.name, n, r, i), this.triggerOnChangeListener();
    }, this.clearValues = (n) => {
      this.form.clearFieldValues(this.name, n), this.triggerOnChangeListener();
    }, this.getLinkedFields = (n) => {
      const r = Object.values(this.form.fieldInfo), i = [];
      for (const o of r) {
        if (!o.instance)
          continue;
        const { onChangeListenTo: a, onBlurListenTo: s } = o.instance.options.validators || {};
        n === "change" && (a != null && a.includes(this.name)) && i.push(o.instance), n === "blur" && (s != null && s.includes(this.name)) && i.push(o.instance);
      }
      return i;
    }, this.validateSync = (n, r) => {
      var i;
      const o = c0(n, this.options), s = this.getLinkedFields(n).reduce(
        (d, f) => {
          const p = c0(n, f.options);
          return p.forEach((m) => {
            m.field = f;
          }), d.concat(p);
        },
        []
      );
      let l = !1;
      pi(() => {
        const d = (f, p) => {
          var m;
          const g = pd(p.cause), v = p.validate ? xE(
            f.runValidator({
              validate: p.validate,
              value: {
                value: f.store.state.value,
                validationSource: "field",
                fieldApi: f
              },
              type: "validate"
            })
          ) : void 0, y = r[g], { newErrorValue: b, newSource: E } = wE({
            formLevelError: y,
            fieldLevelError: v
          });
          ((m = f.state.meta.errorMap) == null ? void 0 : m[g]) !== b && f.setMeta((S) => ({
            ...S,
            errorMap: {
              ...S.errorMap,
              [g]: b
            },
            errorSourceMap: {
              ...S.errorSourceMap,
              [g]: E
            }
          })), b && (l = !0);
        };
        for (const f of o)
          d(this, f);
        for (const f of s)
          f.validate && d(f.field, f);
      });
      const u = pd("submit");
      return (
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        (i = this.state.meta.errorMap) != null && i[u] && n !== "submit" && !l && this.setMeta((d) => ({
          ...d,
          errorMap: {
            ...d.errorMap,
            [u]: void 0
          },
          errorSourceMap: {
            ...d.errorSourceMap,
            [u]: void 0
          }
        })), { hasErrored: l }
      );
    }, this.validateAsync = async (n, r) => {
      const i = l0(n, this.options), o = await r, a = this.getLinkedFields(n), s = a.reduce(
        (p, m) => {
          const g = l0(n, m.options);
          return g.forEach((v) => {
            v.field = m;
          }), p.concat(g);
        },
        []
      );
      this.state.meta.isValidating || this.setMeta((p) => ({ ...p, isValidating: !0 }));
      for (const p of a)
        p.setMeta((m) => ({ ...m, isValidating: !0 }));
      const l = [], u = [], d = (p, m, g) => {
        const v = pd(m.cause), y = p.getInfo().validationMetaMap[v];
        y == null || y.lastAbortController.abort();
        const b = new AbortController();
        this.getInfo().validationMetaMap[v] = {
          lastAbortController: b
        }, g.push(
          new Promise(async (E) => {
            var S;
            let _;
            try {
              _ = await new Promise((F, D) => {
                this.timeoutIds.validations[m.cause] && clearTimeout(this.timeoutIds.validations[m.cause]), this.timeoutIds.validations[m.cause] = setTimeout(
                  async () => {
                    if (b.signal.aborted)
                      return F(void 0);
                    try {
                      F(
                        await this.runValidator({
                          validate: m.validate,
                          value: {
                            value: p.store.state.value,
                            fieldApi: p,
                            signal: b.signal,
                            validationSource: "field"
                          },
                          type: "validateAsync"
                        })
                      );
                    } catch (W) {
                      D(W);
                    }
                  },
                  m.debounceMs
                );
              });
            } catch (F) {
              _ = F;
            }
            if (b.signal.aborted)
              return E(void 0);
            const k = xE(_), T = (S = o[this.name]) == null ? void 0 : S[v], { newErrorValue: A, newSource: R } = wE({
              formLevelError: T,
              fieldLevelError: k
            });
            p.setMeta((F) => ({
              ...F,
              errorMap: {
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                ...F == null ? void 0 : F.errorMap,
                [v]: A
              },
              errorSourceMap: {
                ...F.errorSourceMap,
                [v]: R
              }
            })), E(A);
          })
        );
      };
      for (const p of i)
        p.validate && d(this, p, l);
      for (const p of s)
        p.validate && d(
          p.field,
          p,
          u
        );
      let f = [];
      (l.length || u.length) && (f = await Promise.all(l), await Promise.all(u)), this.setMeta((p) => ({ ...p, isValidating: !1 }));
      for (const p of a)
        p.setMeta((m) => ({ ...m, isValidating: !1 }));
      return f.filter(Boolean);
    }, this.validate = (n, r) => {
      var i;
      if (!this.state.meta.isTouched)
        return [];
      const { fieldsErrorMap: o } = r != null && r.skipFormValidation ? { fieldsErrorMap: {} } : this.form.validateSync(n), { hasErrored: a } = this.validateSync(
        n,
        o[this.name] ?? {}
      );
      if (a && !this.options.asyncAlways)
        return (i = this.getInfo().validationMetaMap[pd(n)]) == null || i.lastAbortController.abort(), this.state.meta.errors;
      const s = r != null && r.skipFormValidation ? Promise.resolve({}) : this.form.validateAsync(n);
      return this.validateAsync(n, s);
    }, this.handleChange = (n) => {
      this.setValue(n);
    }, this.handleBlur = () => {
      this.state.meta.isTouched || this.setMeta((r) => ({ ...r, isTouched: !0 })), this.state.meta.isBlurred || this.setMeta((r) => ({ ...r, isBlurred: !0 })), this.validate("blur"), this.triggerOnBlurListener();
    }, this.parseValueWithSchema = (n) => xs.validate(
      { value: this.state.value, validationSource: "field" },
      n
    ), this.parseValueWithSchemaAsync = (n) => xs.validateAsync(
      { value: this.state.value, validationSource: "field" },
      n
    ), this.form = t.form, this.name = t.name, this.timeoutIds = {
      validations: {},
      listeners: {},
      formListeners: {}
    }, this.store = new Hi({
      deps: [this.form.store],
      fn: () => {
        const n = this.form.getFieldValue(this.name), r = this.form.getFieldMeta(this.name) ?? {
          ...Pf,
          ...t.defaultMeta
        };
        return {
          value: n,
          meta: r
        };
      }
    }), this.options = t;
  }
  /**
   * The current field state.
   */
  get state() {
    return this.store.state;
  }
  /**
   * @private
   */
  runValidator(t) {
    return uk(t.validate) ? xs[t.type](
      t.value,
      t.validate
    ) : t.validate(t.value);
  }
  /**
   * Updates the field's errorMap
   */
  setErrorMap(t) {
    this.setMeta((n) => ({
      ...n,
      errorMap: {
        ...n.errorMap,
        ...t
      }
    }));
  }
  triggerOnBlurListener() {
    var t, n, r, i, o, a;
    const s = (t = this.form.options.listeners) == null ? void 0 : t.onBlurDebounceMs;
    s && s > 0 ? (this.timeoutIds.formListeners.blur && clearTimeout(this.timeoutIds.formListeners.blur), this.timeoutIds.formListeners.blur = setTimeout(() => {
      var u, d;
      (d = (u = this.form.options.listeners) == null ? void 0 : u.onBlur) == null || d.call(u, {
        formApi: this.form,
        fieldApi: this
      });
    }, s)) : (r = (n = this.form.options.listeners) == null ? void 0 : n.onBlur) == null || r.call(n, {
      formApi: this.form,
      fieldApi: this
    });
    const l = (i = this.options.listeners) == null ? void 0 : i.onBlurDebounceMs;
    l && l > 0 ? (this.timeoutIds.listeners.blur && clearTimeout(this.timeoutIds.listeners.blur), this.timeoutIds.listeners.blur = setTimeout(() => {
      var u, d;
      (d = (u = this.options.listeners) == null ? void 0 : u.onBlur) == null || d.call(u, {
        value: this.state.value,
        fieldApi: this
      });
    }, l)) : (a = (o = this.options.listeners) == null ? void 0 : o.onBlur) == null || a.call(o, {
      value: this.state.value,
      fieldApi: this
    });
  }
  triggerOnChangeListener() {
    var t, n, r, i, o, a;
    const s = (t = this.form.options.listeners) == null ? void 0 : t.onChangeDebounceMs;
    s && s > 0 ? (this.timeoutIds.formListeners.change && clearTimeout(this.timeoutIds.formListeners.change), this.timeoutIds.formListeners.change = setTimeout(() => {
      var u, d;
      (d = (u = this.form.options.listeners) == null ? void 0 : u.onChange) == null || d.call(u, {
        formApi: this.form,
        fieldApi: this
      });
    }, s)) : (r = (n = this.form.options.listeners) == null ? void 0 : n.onChange) == null || r.call(n, {
      formApi: this.form,
      fieldApi: this
    });
    const l = (i = this.options.listeners) == null ? void 0 : i.onChangeDebounceMs;
    l && l > 0 ? (this.timeoutIds.listeners.change && clearTimeout(this.timeoutIds.listeners.change), this.timeoutIds.listeners.change = setTimeout(() => {
      var u, d;
      (d = (u = this.options.listeners) == null ? void 0 : u.onChange) == null || d.call(u, {
        value: this.state.value,
        fieldApi: this
      });
    }, l)) : (a = (o = this.options.listeners) == null ? void 0 : o.onChange) == null || a.call(o, {
      value: this.state.value,
      fieldApi: this
    });
  }
}
function xE(e) {
  if (e)
    return e;
}
function pd(e) {
  switch (e) {
    case "submit":
      return "onSubmit";
    case "blur":
      return "onBlur";
    case "mount":
      return "onMount";
    case "server":
      return "onServer";
    case "change":
    default:
      return "onChange";
  }
}
var d0 = { exports: {} }, lg = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var EE;
function YZ() {
  if (EE)
    return lg;
  EE = 1;
  var e = x, t = gh;
  function n(u, d) {
    return u === d && (u !== 0 || 1 / u === 1 / d) || u !== u && d !== d;
  }
  var r = typeof Object.is == "function" ? Object.is : n, i = t.useSyncExternalStore, o = e.useRef, a = e.useEffect, s = e.useMemo, l = e.useDebugValue;
  return lg.useSyncExternalStoreWithSelector = function(u, d, f, p, m) {
    var g = o(null);
    if (g.current === null) {
      var v = { hasValue: !1, value: null };
      g.current = v;
    } else
      v = g.current;
    g = s(
      function() {
        function b(T) {
          if (!E) {
            if (E = !0, S = T, T = p(T), m !== void 0 && v.hasValue) {
              var A = v.value;
              if (m(A, T))
                return _ = A;
            }
            return _ = T;
          }
          if (A = _, r(S, T))
            return A;
          var R = p(T);
          return m !== void 0 && m(A, R) ? (S = T, A) : (S = T, _ = R);
        }
        var E = !1, S, _, k = f === void 0 ? null : f;
        return [
          function() {
            return b(d());
          },
          k === null ? void 0 : function() {
            return b(k());
          }
        ];
      },
      [d, f, p, m]
    );
    var y = i(u, g[0], g[1]);
    return a(
      function() {
        v.hasValue = !0, v.value = y;
      },
      [y]
    ), l(y), y;
  }, lg;
}
var cg = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var CE;
function KZ() {
  return CE || (CE = 1, process.env.NODE_ENV !== "production" && function() {
    function e(u, d) {
      return u === d && (u !== 0 || 1 / u === 1 / d) || u !== u && d !== d;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var t = x, n = gh, r = typeof Object.is == "function" ? Object.is : e, i = n.useSyncExternalStore, o = t.useRef, a = t.useEffect, s = t.useMemo, l = t.useDebugValue;
    cg.useSyncExternalStoreWithSelector = function(u, d, f, p, m) {
      var g = o(null);
      if (g.current === null) {
        var v = { hasValue: !1, value: null };
        g.current = v;
      } else
        v = g.current;
      g = s(
        function() {
          function b(T) {
            if (!E) {
              if (E = !0, S = T, T = p(T), m !== void 0 && v.hasValue) {
                var A = v.value;
                if (m(A, T))
                  return _ = A;
              }
              return _ = T;
            }
            if (A = _, r(S, T))
              return A;
            var R = p(T);
            return m !== void 0 && m(A, R) ? (S = T, A) : (S = T, _ = R);
          }
          var E = !1, S, _, k = f === void 0 ? null : f;
          return [
            function() {
              return b(d());
            },
            k === null ? void 0 : function() {
              return b(k());
            }
          ];
        },
        [d, f, p, m]
      );
      var y = i(u, g[0], g[1]);
      return a(
        function() {
          v.hasValue = !0, v.value = y;
        },
        [y]
      ), l(y), y;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), cg;
}
process.env.NODE_ENV === "production" ? d0.exports = YZ() : d0.exports = KZ();
var XZ = d0.exports;
function By(e, t = (n) => n) {
  return XZ.useSyncExternalStoreWithSelector(
    e.subscribe,
    () => e.state,
    () => e.state,
    t,
    ZZ
  );
}
function ZZ(e, t) {
  if (Object.is(e, t))
    return !0;
  if (typeof e != "object" || e === null || typeof t != "object" || t === null)
    return !1;
  if (e instanceof Map && t instanceof Map) {
    if (e.size !== t.size)
      return !1;
    for (const [r, i] of e)
      if (!t.has(r) || !Object.is(i, t.get(r)))
        return !1;
    return !0;
  }
  if (e instanceof Set && t instanceof Set) {
    if (e.size !== t.size)
      return !1;
    for (const r of e)
      if (!t.has(r))
        return !1;
    return !0;
  }
  const n = Object.keys(e);
  if (n.length !== Object.keys(t).length)
    return !1;
  for (let r = 0; r < n.length; r++)
    if (!Object.prototype.hasOwnProperty.call(t, n[r]) || !Object.is(e[n[r]], t[n[r]]))
      return !1;
  return !0;
}
const kf = typeof window < "u" ? eo : be;
function QZ(e) {
  const [t] = de(() => {
    const r = new qZ({
      ...e,
      form: e.form,
      name: e.name
    });
    return r.Field = dk, r;
  });
  return kf(t.mount, [t]), kf(() => {
    t.update(e);
  }), By(
    t.store,
    e.mode === "array" ? (n) => [
      n.meta,
      Object.keys(n.value ?? []).length
    ] : void 0
  ), t;
}
const dk = ({
  children: e,
  ...t
}) => {
  const n = QZ(t), r = Lt(
    () => Lh(e, n),
    /**
     * The reason this exists is to fix an issue with the React Compiler.
     * Namely, functionalUpdate is memoized where it checks for `fieldApi`, which is a static type.
     * This means that when `state.value` changes, it does not trigger a re-render. The useMemo explicitly fixes this problem
     */
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [e, n, n.state.value, n.state.meta]
  );
  return /* @__PURE__ */ fe.jsx(fe.Fragment, { children: r });
};
function JZ({
  form: e,
  selector: t,
  children: n
}) {
  const r = By(e.store, t);
  return Lh(n, r);
}
function fk(e) {
  const [t] = de(() => {
    const n = new GZ(e), r = n;
    return r.Field = function(o) {
      return /* @__PURE__ */ fe.jsx(dk, { ...o, form: n });
    }, r.Subscribe = (i) => /* @__PURE__ */ fe.jsx(
      JZ,
      {
        form: n,
        selector: i.selector,
        children: i.children
      }
    ), r;
  });
  return kf(t.mount, []), By(t.store, (n) => n.isSubmitting), kf(() => {
    t.update(e);
  }), t;
}
const hk = 75;
function Tf(e = 8, t = 17) {
  return !e || !t || e < t;
}
function pk(e, t) {
  if (t && !e)
    return "Please select a loan officer.";
}
function eQ(e, t, n, r) {
  var i = -1, o = e == null ? 0 : e.length;
  for (r && o && (n = e[++i]); ++i < o; )
    n = t(n, e[i], i, e);
  return n;
}
var tQ = eQ;
function nQ(e) {
  return function(t) {
    return e == null ? void 0 : e[t];
  };
}
var rQ = nQ, iQ = rQ, oQ = {
  // Latin-1 Supplement block.
  À: "A",
  Á: "A",
  Â: "A",
  Ã: "A",
  Ä: "A",
  Å: "A",
  à: "a",
  á: "a",
  â: "a",
  ã: "a",
  ä: "a",
  å: "a",
  Ç: "C",
  ç: "c",
  Ð: "D",
  ð: "d",
  È: "E",
  É: "E",
  Ê: "E",
  Ë: "E",
  è: "e",
  é: "e",
  ê: "e",
  ë: "e",
  Ì: "I",
  Í: "I",
  Î: "I",
  Ï: "I",
  ì: "i",
  í: "i",
  î: "i",
  ï: "i",
  Ñ: "N",
  ñ: "n",
  Ò: "O",
  Ó: "O",
  Ô: "O",
  Õ: "O",
  Ö: "O",
  Ø: "O",
  ò: "o",
  ó: "o",
  ô: "o",
  õ: "o",
  ö: "o",
  ø: "o",
  Ù: "U",
  Ú: "U",
  Û: "U",
  Ü: "U",
  ù: "u",
  ú: "u",
  û: "u",
  ü: "u",
  Ý: "Y",
  ý: "y",
  ÿ: "y",
  Æ: "Ae",
  æ: "ae",
  Þ: "Th",
  þ: "th",
  ß: "ss",
  // Latin Extended-A block.
  Ā: "A",
  Ă: "A",
  Ą: "A",
  ā: "a",
  ă: "a",
  ą: "a",
  Ć: "C",
  Ĉ: "C",
  Ċ: "C",
  Č: "C",
  ć: "c",
  ĉ: "c",
  ċ: "c",
  č: "c",
  Ď: "D",
  Đ: "D",
  ď: "d",
  đ: "d",
  Ē: "E",
  Ĕ: "E",
  Ė: "E",
  Ę: "E",
  Ě: "E",
  ē: "e",
  ĕ: "e",
  ė: "e",
  ę: "e",
  ě: "e",
  Ĝ: "G",
  Ğ: "G",
  Ġ: "G",
  Ģ: "G",
  ĝ: "g",
  ğ: "g",
  ġ: "g",
  ģ: "g",
  Ĥ: "H",
  Ħ: "H",
  ĥ: "h",
  ħ: "h",
  Ĩ: "I",
  Ī: "I",
  Ĭ: "I",
  Į: "I",
  İ: "I",
  ĩ: "i",
  ī: "i",
  ĭ: "i",
  į: "i",
  ı: "i",
  Ĵ: "J",
  ĵ: "j",
  Ķ: "K",
  ķ: "k",
  ĸ: "k",
  Ĺ: "L",
  Ļ: "L",
  Ľ: "L",
  Ŀ: "L",
  Ł: "L",
  ĺ: "l",
  ļ: "l",
  ľ: "l",
  ŀ: "l",
  ł: "l",
  Ń: "N",
  Ņ: "N",
  Ň: "N",
  Ŋ: "N",
  ń: "n",
  ņ: "n",
  ň: "n",
  ŋ: "n",
  Ō: "O",
  Ŏ: "O",
  Ő: "O",
  ō: "o",
  ŏ: "o",
  ő: "o",
  Ŕ: "R",
  Ŗ: "R",
  Ř: "R",
  ŕ: "r",
  ŗ: "r",
  ř: "r",
  Ś: "S",
  Ŝ: "S",
  Ş: "S",
  Š: "S",
  ś: "s",
  ŝ: "s",
  ş: "s",
  š: "s",
  Ţ: "T",
  Ť: "T",
  Ŧ: "T",
  ţ: "t",
  ť: "t",
  ŧ: "t",
  Ũ: "U",
  Ū: "U",
  Ŭ: "U",
  Ů: "U",
  Ű: "U",
  Ų: "U",
  ũ: "u",
  ū: "u",
  ŭ: "u",
  ů: "u",
  ű: "u",
  ų: "u",
  Ŵ: "W",
  ŵ: "w",
  Ŷ: "Y",
  ŷ: "y",
  Ÿ: "Y",
  Ź: "Z",
  Ż: "Z",
  Ž: "Z",
  ź: "z",
  ż: "z",
  ž: "z",
  Ĳ: "IJ",
  ĳ: "ij",
  Œ: "Oe",
  œ: "oe",
  ŉ: "'n",
  ſ: "s"
}, aQ = iQ(oQ), sQ = aQ, lQ = typeof Bi == "object" && Bi && Bi.Object === Object && Bi, mk = lQ, cQ = mk, uQ = typeof self == "object" && self && self.Object === Object && self, dQ = cQ || uQ || Function("return this")(), No = dQ, fQ = No, hQ = fQ.Symbol, jy = hQ;
function pQ(e, t) {
  for (var n = -1, r = e == null ? 0 : e.length, i = Array(r); ++n < r; )
    i[n] = t(e[n], n, e);
  return i;
}
var mQ = pQ, gQ = Array.isArray, gk = gQ, SE = jy, vk = Object.prototype, vQ = vk.hasOwnProperty, yQ = vk.toString, Pl = SE ? SE.toStringTag : void 0;
function wQ(e) {
  var t = vQ.call(e, Pl), n = e[Pl];
  try {
    e[Pl] = void 0;
    var r = !0;
  } catch {
  }
  var i = yQ.call(e);
  return r && (t ? e[Pl] = n : delete e[Pl]), i;
}
var bQ = wQ, xQ = Object.prototype, EQ = xQ.toString;
function CQ(e) {
  return EQ.call(e);
}
var SQ = CQ, _E = jy, _Q = bQ, PQ = SQ, kQ = "[object Null]", TQ = "[object Undefined]", PE = _E ? _E.toStringTag : void 0;
function AQ(e) {
  return e == null ? e === void 0 ? TQ : kQ : PE && PE in Object(e) ? _Q(e) : PQ(e);
}
var Lc = AQ;
function MQ(e) {
  return e != null && typeof e == "object";
}
var Fh = MQ, OQ = Lc, RQ = Fh, IQ = "[object Symbol]";
function DQ(e) {
  return typeof e == "symbol" || RQ(e) && OQ(e) == IQ;
}
var NQ = DQ, kE = jy, $Q = mQ, LQ = gk, FQ = NQ, zQ = 1 / 0, TE = kE ? kE.prototype : void 0, AE = TE ? TE.toString : void 0;
function yk(e) {
  if (typeof e == "string")
    return e;
  if (LQ(e))
    return $Q(e, yk) + "";
  if (FQ(e))
    return AE ? AE.call(e) : "";
  var t = e + "";
  return t == "0" && 1 / e == -zQ ? "-0" : t;
}
var VQ = yk, BQ = VQ;
function jQ(e) {
  return e == null ? "" : BQ(e);
}
var Wy = jQ, WQ = sQ, UQ = Wy, HQ = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, GQ = "\\u0300-\\u036f", qQ = "\\ufe20-\\ufe2f", YQ = "\\u20d0-\\u20ff", KQ = GQ + qQ + YQ, XQ = "[" + KQ + "]", ZQ = RegExp(XQ, "g");
function QQ(e) {
  return e = UQ(e), e && e.replace(HQ, WQ).replace(ZQ, "");
}
var JQ = QQ, eJ = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function tJ(e) {
  return e.match(eJ) || [];
}
var nJ = tJ, rJ = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function iJ(e) {
  return rJ.test(e);
}
var oJ = iJ, wk = "\\ud800-\\udfff", aJ = "\\u0300-\\u036f", sJ = "\\ufe20-\\ufe2f", lJ = "\\u20d0-\\u20ff", cJ = aJ + sJ + lJ, bk = "\\u2700-\\u27bf", xk = "a-z\\xdf-\\xf6\\xf8-\\xff", uJ = "\\xac\\xb1\\xd7\\xf7", dJ = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", fJ = "\\u2000-\\u206f", hJ = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", Ek = "A-Z\\xc0-\\xd6\\xd8-\\xde", pJ = "\\ufe0e\\ufe0f", Ck = uJ + dJ + fJ + hJ, Sk = "['’]", ME = "[" + Ck + "]", mJ = "[" + cJ + "]", _k = "\\d+", gJ = "[" + bk + "]", Pk = "[" + xk + "]", kk = "[^" + wk + Ck + _k + bk + xk + Ek + "]", vJ = "\\ud83c[\\udffb-\\udfff]", yJ = "(?:" + mJ + "|" + vJ + ")", wJ = "[^" + wk + "]", Tk = "(?:\\ud83c[\\udde6-\\uddff]){2}", Ak = "[\\ud800-\\udbff][\\udc00-\\udfff]", ls = "[" + Ek + "]", bJ = "\\u200d", OE = "(?:" + Pk + "|" + kk + ")", xJ = "(?:" + ls + "|" + kk + ")", RE = "(?:" + Sk + "(?:d|ll|m|re|s|t|ve))?", IE = "(?:" + Sk + "(?:D|LL|M|RE|S|T|VE))?", Mk = yJ + "?", Ok = "[" + pJ + "]?", EJ = "(?:" + bJ + "(?:" + [wJ, Tk, Ak].join("|") + ")" + Ok + Mk + ")*", CJ = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", SJ = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", _J = Ok + Mk + EJ, PJ = "(?:" + [gJ, Tk, Ak].join("|") + ")" + _J, kJ = RegExp([
  ls + "?" + Pk + "+" + RE + "(?=" + [ME, ls, "$"].join("|") + ")",
  xJ + "+" + IE + "(?=" + [ME, ls + OE, "$"].join("|") + ")",
  ls + "?" + OE + "+" + RE,
  ls + "+" + IE,
  SJ,
  CJ,
  _k,
  PJ
].join("|"), "g");
function TJ(e) {
  return e.match(kJ) || [];
}
var AJ = TJ, MJ = nJ, OJ = oJ, RJ = Wy, IJ = AJ;
function DJ(e, t, n) {
  return e = RJ(e), t = n ? void 0 : t, t === void 0 ? OJ(e) ? IJ(e) : MJ(e) : e.match(t) || [];
}
var NJ = DJ, $J = tQ, LJ = JQ, FJ = NJ, zJ = "['’]", VJ = RegExp(zJ, "g");
function BJ(e) {
  return function(t) {
    return $J(FJ(LJ(t).replace(VJ, "")), e, "");
  };
}
var jJ = BJ;
function WJ(e, t, n) {
  var r = -1, i = e.length;
  t < 0 && (t = -t > i ? 0 : i + t), n = n > i ? i : n, n < 0 && (n += i), i = t > n ? 0 : n - t >>> 0, t >>>= 0;
  for (var o = Array(i); ++r < i; )
    o[r] = e[r + t];
  return o;
}
var UJ = WJ, HJ = UJ;
function GJ(e, t, n) {
  var r = e.length;
  return n = n === void 0 ? r : n, !t && n >= r ? e : HJ(e, t, n);
}
var qJ = GJ, YJ = "\\ud800-\\udfff", KJ = "\\u0300-\\u036f", XJ = "\\ufe20-\\ufe2f", ZJ = "\\u20d0-\\u20ff", QJ = KJ + XJ + ZJ, JJ = "\\ufe0e\\ufe0f", eee = "\\u200d", tee = RegExp("[" + eee + YJ + QJ + JJ + "]");
function nee(e) {
  return tee.test(e);
}
var Rk = nee;
function ree(e) {
  return e.split("");
}
var iee = ree, Ik = "\\ud800-\\udfff", oee = "\\u0300-\\u036f", aee = "\\ufe20-\\ufe2f", see = "\\u20d0-\\u20ff", lee = oee + aee + see, cee = "\\ufe0e\\ufe0f", uee = "[" + Ik + "]", f0 = "[" + lee + "]", h0 = "\\ud83c[\\udffb-\\udfff]", dee = "(?:" + f0 + "|" + h0 + ")", Dk = "[^" + Ik + "]", Nk = "(?:\\ud83c[\\udde6-\\uddff]){2}", $k = "[\\ud800-\\udbff][\\udc00-\\udfff]", fee = "\\u200d", Lk = dee + "?", Fk = "[" + cee + "]?", hee = "(?:" + fee + "(?:" + [Dk, Nk, $k].join("|") + ")" + Fk + Lk + ")*", pee = Fk + Lk + hee, mee = "(?:" + [Dk + f0 + "?", f0, Nk, $k, uee].join("|") + ")", gee = RegExp(h0 + "(?=" + h0 + ")|" + mee + pee, "g");
function vee(e) {
  return e.match(gee) || [];
}
var yee = vee, wee = iee, bee = Rk, xee = yee;
function Eee(e) {
  return bee(e) ? xee(e) : wee(e);
}
var Cee = Eee, See = qJ, _ee = Rk, Pee = Cee, kee = Wy;
function Tee(e) {
  return function(t) {
    t = kee(t);
    var n = _ee(t) ? Pee(t) : void 0, r = n ? n[0] : t.charAt(0), i = n ? See(n, 1).join("") : t.slice(1);
    return r[e]() + i;
  };
}
var Aee = Tee, Mee = Aee, Oee = Mee("toUpperCase"), Ree = Oee, Iee = jJ, Dee = Ree, Nee = Iee(function(e, t, n) {
  return e + (n ? " " : "") + Dee(t);
}), $ee = Nee;
const Lee = /* @__PURE__ */ Pi($ee);
function Fee(e) {
  return e !== null && typeof e == "object" && "errors" in e && Array.isArray(e.errors);
}
function zk({ error: e }) {
  return e ? Fee(e) ? /* @__PURE__ */ C.createElement("div", { className: "ai-tw-text-stroke-critical" }, "Error saving settings. Please fix the following issues and try again:", /* @__PURE__ */ C.createElement("ul", { className: "ai-tw-mt-1 ai-tw-list-disc ai-tw-pl-5" }, e.errors.map((t, n) => {
    const r = t.path.length > 1 && t.path[t.path.length - 1], i = r ? `${Lee(r)}: ` : "";
    return /* @__PURE__ */ C.createElement("li", { key: n }, `${i}${t.message}`);
  }))) : /* @__PURE__ */ C.createElement("div", { className: "ai-tw-text-stroke-critical" }, "An unexpected error occurred. Please try again later.") : null;
}
function DE(e, [t, n]) {
  return Math.min(n, Math.max(t, e));
}
function an(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function Uy(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = C.createContext(a), l = n.length;
    n = [...n, a];
    const u = (f) => {
      var b;
      const { scope: p, children: m, ...g } = f, v = ((b = p == null ? void 0 : p[e]) == null ? void 0 : b[l]) || s, y = C.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ fe.jsx(v.Provider, { value: y, children: m });
    };
    u.displayName = o + "Provider";
    function d(f, p) {
      var v;
      const m = ((v = p == null ? void 0 : p[e]) == null ? void 0 : v[l]) || s, g = C.useContext(m);
      if (g)
        return g;
      if (a !== void 0)
        return a;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [u, d];
  }
  const i = () => {
    const o = n.map((a) => C.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || o;
      return C.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return i.scopeName = e, [r, zee(i, ...t)];
}
function zee(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const a = r.reduce((s, { useScope: l, scopeName: u }) => {
        const f = l(o)[`__scope${u}`];
        return { ...s, ...f };
      }, {});
      return C.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function NE(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function Vk(...e) {
  return (t) => {
    let n = !1;
    const r = e.map((i) => {
      const o = NE(i, t);
      return !n && typeof o == "function" && (n = !0), o;
    });
    if (n)
      return () => {
        for (let i = 0; i < r.length; i++) {
          const o = r[i];
          typeof o == "function" ? o() : NE(e[i], null);
        }
      };
  };
}
function _n(...e) {
  return C.useCallback(Vk(...e), e);
}
function Af(e) {
  const t = /* @__PURE__ */ Vee(e), n = C.forwardRef((r, i) => {
    const { children: o, ...a } = r, s = C.Children.toArray(o), l = s.find(jee);
    if (l) {
      const u = l.props.children, d = s.map((f) => f === l ? C.Children.count(u) > 1 ? C.Children.only(null) : C.isValidElement(u) ? u.props.children : null : f);
      return /* @__PURE__ */ fe.jsx(t, { ...a, ref: i, children: C.isValidElement(u) ? C.cloneElement(u, void 0, d) : null });
    }
    return /* @__PURE__ */ fe.jsx(t, { ...a, ref: i, children: o });
  });
  return n.displayName = `${e}.Slot`, n;
}
function Vee(e) {
  const t = C.forwardRef((n, r) => {
    const { children: i, ...o } = n;
    if (C.isValidElement(i)) {
      const a = Uee(i), s = Wee(o, i.props);
      return i.type !== C.Fragment && (s.ref = r ? Vk(r, a) : a), C.cloneElement(i, s);
    }
    return C.Children.count(i) > 1 ? C.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Bee = Symbol("radix.slottable");
function jee(e) {
  return C.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Bee;
}
function Wee(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...s) => {
      const l = o(...s);
      return i(...s), l;
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Uee(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
function Hee(e) {
  const t = e + "CollectionProvider", [n, r] = Uy(t), [i, o] = n(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), a = (v) => {
    const { scope: y, children: b } = v, E = x.useRef(null), S = x.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ fe.jsx(i, { scope: y, itemMap: S, collectionRef: E, children: b });
  };
  a.displayName = t;
  const s = e + "CollectionSlot", l = Af(s), u = x.forwardRef(
    (v, y) => {
      const { scope: b, children: E } = v, S = o(s, b), _ = _n(y, S.collectionRef);
      return /* @__PURE__ */ fe.jsx(l, { ref: _, children: E });
    }
  );
  u.displayName = s;
  const d = e + "CollectionItemSlot", f = "data-radix-collection-item", p = Af(d), m = x.forwardRef(
    (v, y) => {
      const { scope: b, children: E, ...S } = v, _ = x.useRef(null), k = _n(y, _), T = o(d, b);
      return x.useEffect(() => (T.itemMap.set(_, { ref: _, ...S }), () => void T.itemMap.delete(_))), /* @__PURE__ */ fe.jsx(p, { [f]: "", ref: k, children: E });
    }
  );
  m.displayName = d;
  function g(v) {
    const y = o(e + "CollectionConsumer", v);
    return x.useCallback(() => {
      const E = y.collectionRef.current;
      if (!E)
        return [];
      const S = Array.from(E.querySelectorAll(`[${f}]`));
      return Array.from(y.itemMap.values()).sort(
        (T, A) => S.indexOf(T.ref.current) - S.indexOf(A.ref.current)
      );
    }, [y.collectionRef, y.itemMap]);
  }
  return [
    { Provider: a, Slot: u, ItemSlot: m },
    g,
    r
  ];
}
var Gee = C.createContext(void 0);
function qee(e) {
  const t = C.useContext(Gee);
  return e || t || "ltr";
}
var Yee = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], tn = Yee.reduce((e, t) => {
  const n = Af(`Primitive.${t}`), r = C.forwardRef((i, o) => {
    const { asChild: a, ...s } = i, l = a ? n : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ fe.jsx(l, { ...s, ref: o });
  });
  return r.displayName = `Primitive.${t}`, { ...e, [t]: r };
}, {});
function Kee(e, t) {
  e && Kf.flushSync(() => e.dispatchEvent(t));
}
function xa(e) {
  const t = C.useRef(e);
  return C.useEffect(() => {
    t.current = e;
  }), C.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function Xee(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = xa(e);
  C.useEffect(() => {
    const r = (i) => {
      i.key === "Escape" && n(i);
    };
    return t.addEventListener("keydown", r, { capture: !0 }), () => t.removeEventListener("keydown", r, { capture: !0 });
  }, [n, t]);
}
var Zee = "DismissableLayer", p0 = "dismissableLayer.update", Qee = "dismissableLayer.pointerDownOutside", Jee = "dismissableLayer.focusOutside", $E, Bk = C.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), jk = C.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      onFocusOutside: o,
      onInteractOutside: a,
      onDismiss: s,
      ...l
    } = e, u = C.useContext(Bk), [d, f] = C.useState(null), p = (d == null ? void 0 : d.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, m] = C.useState({}), g = _n(t, (A) => f(A)), v = Array.from(u.layers), [y] = [...u.layersWithOutsidePointerEventsDisabled].slice(-1), b = v.indexOf(y), E = d ? v.indexOf(d) : -1, S = u.layersWithOutsidePointerEventsDisabled.size > 0, _ = E >= b, k = nte((A) => {
      const R = A.target, F = [...u.branches].some((D) => D.contains(R));
      !_ || F || (i == null || i(A), a == null || a(A), A.defaultPrevented || s == null || s());
    }, p), T = rte((A) => {
      const R = A.target;
      [...u.branches].some((D) => D.contains(R)) || (o == null || o(A), a == null || a(A), A.defaultPrevented || s == null || s());
    }, p);
    return Xee((A) => {
      E === u.layers.size - 1 && (r == null || r(A), !A.defaultPrevented && s && (A.preventDefault(), s()));
    }, p), C.useEffect(() => {
      if (d)
        return n && (u.layersWithOutsidePointerEventsDisabled.size === 0 && ($E = p.body.style.pointerEvents, p.body.style.pointerEvents = "none"), u.layersWithOutsidePointerEventsDisabled.add(d)), u.layers.add(d), LE(), () => {
          n && u.layersWithOutsidePointerEventsDisabled.size === 1 && (p.body.style.pointerEvents = $E);
        };
    }, [d, p, n, u]), C.useEffect(() => () => {
      d && (u.layers.delete(d), u.layersWithOutsidePointerEventsDisabled.delete(d), LE());
    }, [d, u]), C.useEffect(() => {
      const A = () => m({});
      return document.addEventListener(p0, A), () => document.removeEventListener(p0, A);
    }, []), /* @__PURE__ */ fe.jsx(
      tn.div,
      {
        ...l,
        ref: g,
        style: {
          pointerEvents: S ? _ ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: an(e.onFocusCapture, T.onFocusCapture),
        onBlurCapture: an(e.onBlurCapture, T.onBlurCapture),
        onPointerDownCapture: an(
          e.onPointerDownCapture,
          k.onPointerDownCapture
        )
      }
    );
  }
);
jk.displayName = Zee;
var ete = "DismissableLayerBranch", tte = C.forwardRef((e, t) => {
  const n = C.useContext(Bk), r = C.useRef(null), i = _n(t, r);
  return C.useEffect(() => {
    const o = r.current;
    if (o)
      return n.branches.add(o), () => {
        n.branches.delete(o);
      };
  }, [n.branches]), /* @__PURE__ */ fe.jsx(tn.div, { ...e, ref: i });
});
tte.displayName = ete;
function nte(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = xa(e), r = C.useRef(!1), i = C.useRef(() => {
  });
  return C.useEffect(() => {
    const o = (s) => {
      if (s.target && !r.current) {
        let l = function() {
          Wk(
            Qee,
            n,
            u,
            { discrete: !0 }
          );
        };
        const u = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", i.current), i.current = l, t.addEventListener("click", i.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", i.current);
      r.current = !1;
    }, a = window.setTimeout(() => {
      t.addEventListener("pointerdown", o);
    }, 0);
    return () => {
      window.clearTimeout(a), t.removeEventListener("pointerdown", o), t.removeEventListener("click", i.current);
    };
  }, [t, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => r.current = !0
  };
}
function rte(e, t = globalThis == null ? void 0 : globalThis.document) {
  const n = xa(e), r = C.useRef(!1);
  return C.useEffect(() => {
    const i = (o) => {
      o.target && !r.current && Wk(Jee, n, { originalEvent: o }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", i), () => t.removeEventListener("focusin", i);
  }, [t, n]), {
    onFocusCapture: () => r.current = !0,
    onBlurCapture: () => r.current = !1
  };
}
function LE() {
  const e = new CustomEvent(p0);
  document.dispatchEvent(e);
}
function Wk(e, t, n, { discrete: r }) {
  const i = n.originalEvent.target, o = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: n });
  t && i.addEventListener(e, t, { once: !0 }), r ? Kee(i, o) : i.dispatchEvent(o);
}
var ug = 0;
function ite() {
  C.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? FE()), document.body.insertAdjacentElement("beforeend", e[1] ?? FE()), ug++, () => {
      ug === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), ug--;
    };
  }, []);
}
function FE() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var dg = "focusScope.autoFocusOnMount", fg = "focusScope.autoFocusOnUnmount", zE = { bubbles: !1, cancelable: !0 }, ote = "FocusScope", Uk = C.forwardRef((e, t) => {
  const {
    loop: n = !1,
    trapped: r = !1,
    onMountAutoFocus: i,
    onUnmountAutoFocus: o,
    ...a
  } = e, [s, l] = C.useState(null), u = xa(i), d = xa(o), f = C.useRef(null), p = _n(t, (v) => l(v)), m = C.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  C.useEffect(() => {
    if (r) {
      let v = function(S) {
        if (m.paused || !s)
          return;
        const _ = S.target;
        s.contains(_) ? f.current = _ : Co(f.current, { select: !0 });
      }, y = function(S) {
        if (m.paused || !s)
          return;
        const _ = S.relatedTarget;
        _ !== null && (s.contains(_) || Co(f.current, { select: !0 }));
      }, b = function(S) {
        if (document.activeElement === document.body)
          for (const k of S)
            k.removedNodes.length > 0 && Co(s);
      };
      document.addEventListener("focusin", v), document.addEventListener("focusout", y);
      const E = new MutationObserver(b);
      return s && E.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", v), document.removeEventListener("focusout", y), E.disconnect();
      };
    }
  }, [r, s, m.paused]), C.useEffect(() => {
    if (s) {
      BE.add(m);
      const v = document.activeElement;
      if (!s.contains(v)) {
        const b = new CustomEvent(dg, zE);
        s.addEventListener(dg, u), s.dispatchEvent(b), b.defaultPrevented || (ate(dte(Hk(s)), { select: !0 }), document.activeElement === v && Co(s));
      }
      return () => {
        s.removeEventListener(dg, u), setTimeout(() => {
          const b = new CustomEvent(fg, zE);
          s.addEventListener(fg, d), s.dispatchEvent(b), b.defaultPrevented || Co(v ?? document.body, { select: !0 }), s.removeEventListener(fg, d), BE.remove(m);
        }, 0);
      };
    }
  }, [s, u, d, m]);
  const g = C.useCallback(
    (v) => {
      if (!n && !r || m.paused)
        return;
      const y = v.key === "Tab" && !v.altKey && !v.ctrlKey && !v.metaKey, b = document.activeElement;
      if (y && b) {
        const E = v.currentTarget, [S, _] = ste(E);
        S && _ ? !v.shiftKey && b === _ ? (v.preventDefault(), n && Co(S, { select: !0 })) : v.shiftKey && b === S && (v.preventDefault(), n && Co(_, { select: !0 })) : b === E && v.preventDefault();
      }
    },
    [n, r, m.paused]
  );
  return /* @__PURE__ */ fe.jsx(tn.div, { tabIndex: -1, ...a, ref: p, onKeyDown: g });
});
Uk.displayName = ote;
function ate(e, { select: t = !1 } = {}) {
  const n = document.activeElement;
  for (const r of e)
    if (Co(r, { select: t }), document.activeElement !== n)
      return;
}
function ste(e) {
  const t = Hk(e), n = VE(t, e), r = VE(t.reverse(), e);
  return [n, r];
}
function Hk(e) {
  const t = [], n = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (r) => {
      const i = r.tagName === "INPUT" && r.type === "hidden";
      return r.disabled || r.hidden || i ? NodeFilter.FILTER_SKIP : r.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); )
    t.push(n.currentNode);
  return t;
}
function VE(e, t) {
  for (const n of e)
    if (!lte(n, { upTo: t }))
      return n;
}
function lte(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden")
    return !0;
  for (; e; ) {
    if (t !== void 0 && e === t)
      return !1;
    if (getComputedStyle(e).display === "none")
      return !0;
    e = e.parentElement;
  }
  return !1;
}
function cte(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Co(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const n = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== n && cte(e) && t && e.select();
  }
}
var BE = ute();
function ute() {
  let e = [];
  return {
    add(t) {
      const n = e[0];
      t !== n && (n == null || n.pause()), e = jE(e, t), e.unshift(t);
    },
    remove(t) {
      var n;
      e = jE(e, t), (n = e[0]) == null || n.resume();
    }
  };
}
function jE(e, t) {
  const n = [...e], r = n.indexOf(t);
  return r !== -1 && n.splice(r, 1), n;
}
function dte(e) {
  return e.filter((t) => t.tagName !== "A");
}
var tr = globalThis != null && globalThis.document ? C.useLayoutEffect : () => {
}, fte = C[" useId ".trim().toString()] || (() => {
}), hte = 0;
function Hy(e) {
  const [t, n] = C.useState(fte());
  return tr(() => {
    e || n((r) => r ?? String(hte++));
  }, [e]), e || (t ? `radix-${t}` : "");
}
var pte = "Arrow", Gk = C.forwardRef((e, t) => {
  const { children: n, width: r = 10, height: i = 5, ...o } = e;
  return /* @__PURE__ */ fe.jsx(
    tn.svg,
    {
      ...o,
      ref: t,
      width: r,
      height: i,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? n : /* @__PURE__ */ fe.jsx("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
Gk.displayName = pte;
var mte = Gk;
function gte(e) {
  const [t, n] = C.useState(void 0);
  return tr(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const o = i[0];
        let a, s;
        if ("borderBoxSize" in o) {
          const l = o.borderBoxSize, u = Array.isArray(l) ? l[0] : l;
          a = u.inlineSize, s = u.blockSize;
        } else
          a = e.offsetWidth, s = e.offsetHeight;
        n({ width: a, height: s });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var Gy = "Popper", [qk, Yk] = Uy(Gy), [vte, Kk] = qk(Gy), Xk = (e) => {
  const { __scopePopper: t, children: n } = e, [r, i] = C.useState(null);
  return /* @__PURE__ */ fe.jsx(vte, { scope: t, anchor: r, onAnchorChange: i, children: n });
};
Xk.displayName = Gy;
var Zk = "PopperAnchor", Qk = C.forwardRef(
  (e, t) => {
    const { __scopePopper: n, virtualRef: r, ...i } = e, o = Kk(Zk, n), a = C.useRef(null), s = _n(t, a);
    return C.useEffect(() => {
      o.onAnchorChange((r == null ? void 0 : r.current) || a.current);
    }), r ? null : /* @__PURE__ */ fe.jsx(tn.div, { ...i, ref: s });
  }
);
Qk.displayName = Zk;
var qy = "PopperContent", [yte, wte] = qk(qy), Jk = C.forwardRef(
  (e, t) => {
    var se, Se, le, Ee, Ie, te;
    const {
      __scopePopper: n,
      side: r = "bottom",
      sideOffset: i = 0,
      align: o = "center",
      alignOffset: a = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: u = [],
      collisionPadding: d = 0,
      sticky: f = "partial",
      hideWhenDetached: p = !1,
      updatePositionStrategy: m = "optimized",
      onPlaced: g,
      ...v
    } = e, y = Kk(qy, n), [b, E] = C.useState(null), S = _n(t, (Re) => E(Re)), [_, k] = C.useState(null), T = gte(_), A = (T == null ? void 0 : T.width) ?? 0, R = (T == null ? void 0 : T.height) ?? 0, F = r + (o !== "center" ? "-" + o : ""), D = typeof d == "number" ? d : { top: 0, right: 0, bottom: 0, left: 0, ...d }, W = Array.isArray(u) ? u : [u], L = W.length > 0, z = {
      padding: D,
      boundary: W.filter(xte),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: L
    }, { refs: B, floatingStyles: G, placement: H, isPositioned: J, middlewareData: q } = RS({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: F,
      whileElementsMounted: (...Re) => MS(...Re, {
        animationFrame: m === "always"
      }),
      elements: {
        reference: y.anchor
      },
      middleware: [
        IS({ mainAxis: i + R, alignmentAxis: a }),
        l && DS({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? NS() : void 0,
          ...z
        }),
        l && $S({ ...z }),
        LS({
          ...z,
          apply: ({ elements: Re, rects: we, availableWidth: ze, availableHeight: dt }) => {
            const { width: ht, height: vt } = we.reference, mt = Re.floating.style;
            mt.setProperty("--radix-popper-available-width", `${ze}px`), mt.setProperty("--radix-popper-available-height", `${dt}px`), mt.setProperty("--radix-popper-anchor-width", `${ht}px`), mt.setProperty("--radix-popper-anchor-height", `${vt}px`);
          }
        }),
        _ && zS({ element: _, padding: s }),
        Ete({ arrowWidth: A, arrowHeight: R }),
        p && FS({ strategy: "referenceHidden", ...z })
      ]
    }), [Z, O] = n8(H), Q = xa(g);
    tr(() => {
      J && (Q == null || Q());
    }, [J, Q]);
    const he = (se = q.arrow) == null ? void 0 : se.x, N = (Se = q.arrow) == null ? void 0 : Se.y, ee = ((le = q.arrow) == null ? void 0 : le.centerOffset) !== 0, [ae, pe] = C.useState();
    return tr(() => {
      b && pe(window.getComputedStyle(b).zIndex);
    }, [b]), /* @__PURE__ */ fe.jsx(
      "div",
      {
        ref: B.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...G,
          transform: J ? G.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: ae,
          ["--radix-popper-transform-origin"]: [
            (Ee = q.transformOrigin) == null ? void 0 : Ee.x,
            (Ie = q.transformOrigin) == null ? void 0 : Ie.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((te = q.hide) == null ? void 0 : te.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ fe.jsx(
          yte,
          {
            scope: n,
            placedSide: Z,
            onArrowChange: k,
            arrowX: he,
            arrowY: N,
            shouldHideArrow: ee,
            children: /* @__PURE__ */ fe.jsx(
              tn.div,
              {
                "data-side": Z,
                "data-align": O,
                ...v,
                ref: S,
                style: {
                  ...v.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: J ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
Jk.displayName = qy;
var e8 = "PopperArrow", bte = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, t8 = C.forwardRef(function(t, n) {
  const { __scopePopper: r, ...i } = t, o = wte(e8, r), a = bte[o.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ fe.jsx(
      "span",
      {
        ref: o.onArrowChange,
        style: {
          position: "absolute",
          left: o.arrowX,
          top: o.arrowY,
          [a]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[o.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[o.placedSide],
          visibility: o.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ fe.jsx(
          mte,
          {
            ...i,
            ref: n,
            style: {
              ...i.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
t8.displayName = e8;
function xte(e) {
  return e !== null;
}
var Ete = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    var y, b, E;
    const { placement: n, rects: r, middlewareData: i } = t, a = ((y = i.arrow) == null ? void 0 : y.centerOffset) !== 0, s = a ? 0 : e.arrowWidth, l = a ? 0 : e.arrowHeight, [u, d] = n8(n), f = { start: "0%", center: "50%", end: "100%" }[d], p = (((b = i.arrow) == null ? void 0 : b.x) ?? 0) + s / 2, m = (((E = i.arrow) == null ? void 0 : E.y) ?? 0) + l / 2;
    let g = "", v = "";
    return u === "bottom" ? (g = a ? f : `${p}px`, v = `${-l}px`) : u === "top" ? (g = a ? f : `${p}px`, v = `${r.floating.height + l}px`) : u === "right" ? (g = `${-l}px`, v = a ? f : `${m}px`) : u === "left" && (g = `${r.floating.width + l}px`, v = a ? f : `${m}px`), { data: { x: g, y: v } };
  }
});
function n8(e) {
  const [t, n = "center"] = e.split("-");
  return [t, n];
}
var Cte = Xk, Ste = Qk, _te = Jk, Pte = t8, kte = "Portal", r8 = C.forwardRef((e, t) => {
  var s;
  const { container: n, ...r } = e, [i, o] = C.useState(!1);
  tr(() => o(!0), []);
  const a = n || i && ((s = globalThis == null ? void 0 : globalThis.document) == null ? void 0 : s.body);
  return a ? Xf.createPortal(/* @__PURE__ */ fe.jsx(tn.div, { ...r, ref: t }), a) : null;
});
r8.displayName = kte;
var Tte = C[" useInsertionEffect ".trim().toString()] || tr;
function WE({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  },
  caller: r
}) {
  const [i, o, a] = Ate({
    defaultProp: t,
    onChange: n
  }), s = e !== void 0, l = s ? e : i;
  {
    const d = C.useRef(e !== void 0);
    C.useEffect(() => {
      const f = d.current;
      f !== s && console.warn(
        `${r} is changing from ${f ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), d.current = s;
    }, [s, r]);
  }
  const u = C.useCallback(
    (d) => {
      var f;
      if (s) {
        const p = Mte(d) ? d(e) : d;
        p !== e && ((f = a.current) == null || f.call(a, p));
      } else
        o(d);
    },
    [s, e, o, a]
  );
  return [l, u];
}
function Ate({
  defaultProp: e,
  onChange: t
}) {
  const [n, r] = C.useState(e), i = C.useRef(n), o = C.useRef(t);
  return Tte(() => {
    o.current = t;
  }, [t]), C.useEffect(() => {
    var a;
    i.current !== n && ((a = o.current) == null || a.call(o, n), i.current = n);
  }, [n, i]), [n, r, o];
}
function Mte(e) {
  return typeof e == "function";
}
function Ote(e) {
  const t = C.useRef({ value: e, previous: e });
  return C.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var i8 = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), Rte = "VisuallyHidden", Ite = C.forwardRef(
  (e, t) => /* @__PURE__ */ fe.jsx(
    tn.span,
    {
      ...e,
      ref: t,
      style: { ...i8, ...e.style }
    }
  )
);
Ite.displayName = Rte;
var o8 = YS(), hg = function() {
}, zh = C.forwardRef(function(e, t) {
  var n = C.useRef(null), r = C.useState({
    onScrollCapture: hg,
    onWheelCapture: hg,
    onTouchMoveCapture: hg
  }), i = r[0], o = r[1], a = e.forwardProps, s = e.children, l = e.className, u = e.removeScrollBar, d = e.enabled, f = e.shards, p = e.sideCar, m = e.noRelative, g = e.noIsolation, v = e.inert, y = e.allowPinchZoom, b = e.as, E = b === void 0 ? "div" : b, S = e.gapMode, _ = Bn(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noRelative", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), k = p, T = qS([n, t]), A = ye(ye({}, _), i);
  return C.createElement(
    C.Fragment,
    null,
    d && C.createElement(k, { sideCar: o8, removeScrollBar: u, shards: f, noRelative: m, noIsolation: g, inert: v, setCallbacks: o, allowPinchZoom: !!y, lockRef: n, gapMode: S }),
    a ? C.cloneElement(C.Children.only(s), ye(ye({}, A), { ref: T })) : C.createElement(E, ye({}, A, { className: l, ref: T }), s)
  );
});
zh.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
zh.classNames = {
  fullWidth: jl,
  zeroRight: Bl
};
var m0 = !1;
if (typeof window < "u")
  try {
    var md = Object.defineProperty({}, "passive", {
      get: function() {
        return m0 = !0, !0;
      }
    });
    window.addEventListener("test", md, md), window.removeEventListener("test", md, md);
  } catch {
    m0 = !1;
  }
var Qa = m0 ? { passive: !1 } : !1, Dte = function(e) {
  return e.tagName === "TEXTAREA";
}, a8 = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var n = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    n[t] !== "hidden" && // contains scroll inside self
    !(n.overflowY === n.overflowX && !Dte(e) && n[t] === "visible")
  );
}, Nte = function(e) {
  return a8(e, "overflowY");
}, $te = function(e) {
  return a8(e, "overflowX");
}, UE = function(e, t) {
  var n = t.ownerDocument, r = t;
  do {
    typeof ShadowRoot < "u" && r instanceof ShadowRoot && (r = r.host);
    var i = s8(e, r);
    if (i) {
      var o = l8(e, r), a = o[1], s = o[2];
      if (a > s)
        return !0;
    }
    r = r.parentNode;
  } while (r && r !== n.body);
  return !1;
}, Lte = function(e) {
  var t = e.scrollTop, n = e.scrollHeight, r = e.clientHeight;
  return [
    t,
    n,
    r
  ];
}, Fte = function(e) {
  var t = e.scrollLeft, n = e.scrollWidth, r = e.clientWidth;
  return [
    t,
    n,
    r
  ];
}, s8 = function(e, t) {
  return e === "v" ? Nte(t) : $te(t);
}, l8 = function(e, t) {
  return e === "v" ? Lte(t) : Fte(t);
}, zte = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Vte = function(e, t, n, r, i) {
  var o = zte(e, window.getComputedStyle(t).direction), a = o * r, s = n.target, l = t.contains(s), u = !1, d = a > 0, f = 0, p = 0;
  do {
    if (!s)
      break;
    var m = l8(e, s), g = m[0], v = m[1], y = m[2], b = v - y - o * g;
    (g || b) && s8(e, s) && (f += b, p += g);
    var E = s.parentNode;
    s = E && E.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? E.host : E;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (d && (i && Math.abs(f) < 1 || !i && a > f) || !d && (i && Math.abs(p) < 1 || !i && -a > p)) && (u = !0), u;
}, gd = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, HE = function(e) {
  return [e.deltaX, e.deltaY];
}, GE = function(e) {
  return e && "current" in e ? e.current : e;
}, Bte = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, jte = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Wte = 0, Ja = [];
function Ute(e) {
  var t = C.useRef([]), n = C.useRef([0, 0]), r = C.useRef(), i = C.useState(Wte++)[0], o = C.useState(v1)[0], a = C.useRef(e);
  C.useEffect(function() {
    a.current = e;
  }, [e]), C.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(i));
      var v = mr([e.lockRef.current], (e.shards || []).map(GE), !0).filter(Boolean);
      return v.forEach(function(y) {
        return y.classList.add("allow-interactivity-".concat(i));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(i)), v.forEach(function(y) {
          return y.classList.remove("allow-interactivity-".concat(i));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = C.useCallback(function(v, y) {
    if ("touches" in v && v.touches.length === 2 || v.type === "wheel" && v.ctrlKey)
      return !a.current.allowPinchZoom;
    var b = gd(v), E = n.current, S = "deltaX" in v ? v.deltaX : E[0] - b[0], _ = "deltaY" in v ? v.deltaY : E[1] - b[1], k, T = v.target, A = Math.abs(S) > Math.abs(_) ? "h" : "v";
    if ("touches" in v && A === "h" && T.type === "range")
      return !1;
    var R = UE(A, T);
    if (!R)
      return !0;
    if (R ? k = A : (k = A === "v" ? "h" : "v", R = UE(A, T)), !R)
      return !1;
    if (!r.current && "changedTouches" in v && (S || _) && (r.current = k), !k)
      return !0;
    var F = r.current || k;
    return Vte(F, y, v, F === "h" ? S : _, !0);
  }, []), l = C.useCallback(function(v) {
    var y = v;
    if (!(!Ja.length || Ja[Ja.length - 1] !== o)) {
      var b = "deltaY" in y ? HE(y) : gd(y), E = t.current.filter(function(k) {
        return k.name === y.type && (k.target === y.target || y.target === k.shadowParent) && Bte(k.delta, b);
      })[0];
      if (E && E.should) {
        y.cancelable && y.preventDefault();
        return;
      }
      if (!E) {
        var S = (a.current.shards || []).map(GE).filter(Boolean).filter(function(k) {
          return k.contains(y.target);
        }), _ = S.length > 0 ? s(y, S[0]) : !a.current.noIsolation;
        _ && y.cancelable && y.preventDefault();
      }
    }
  }, []), u = C.useCallback(function(v, y, b, E) {
    var S = { name: v, delta: y, target: b, should: E, shadowParent: Hte(b) };
    t.current.push(S), setTimeout(function() {
      t.current = t.current.filter(function(_) {
        return _ !== S;
      });
    }, 1);
  }, []), d = C.useCallback(function(v) {
    n.current = gd(v), r.current = void 0;
  }, []), f = C.useCallback(function(v) {
    u(v.type, HE(v), v.target, s(v, e.lockRef.current));
  }, []), p = C.useCallback(function(v) {
    u(v.type, gd(v), v.target, s(v, e.lockRef.current));
  }, []);
  C.useEffect(function() {
    return Ja.push(o), e.setCallbacks({
      onScrollCapture: f,
      onWheelCapture: f,
      onTouchMoveCapture: p
    }), document.addEventListener("wheel", l, Qa), document.addEventListener("touchmove", l, Qa), document.addEventListener("touchstart", d, Qa), function() {
      Ja = Ja.filter(function(v) {
        return v !== o;
      }), document.removeEventListener("wheel", l, Qa), document.removeEventListener("touchmove", l, Qa), document.removeEventListener("touchstart", d, Qa);
    };
  }, []);
  var m = e.removeScrollBar, g = e.inert;
  return C.createElement(
    C.Fragment,
    null,
    g ? C.createElement(o, { styles: jte(i) }) : null,
    m ? C.createElement(QS, { noRelative: e.noRelative, gapMode: e.gapMode }) : null
  );
}
function Hte(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Gte = XS(o8, Ute);
var c8 = C.forwardRef(function(e, t) {
  return C.createElement(zh, ye({}, e, { ref: t, sideCar: Gte }));
});
c8.classNames = zh.classNames;
const qte = c8;
var Yte = [" ", "Enter", "ArrowUp", "ArrowDown"], Kte = [" ", "Enter"], Ea = "Select", [Vh, Bh, Xte] = Hee(Ea), [Ys, Sye] = Uy(Ea, [
  Xte,
  Yk
]), jh = Yk(), [Zte, $o] = Ys(Ea), [Qte, Jte] = Ys(Ea), u8 = (e) => {
  const {
    __scopeSelect: t,
    children: n,
    open: r,
    defaultOpen: i,
    onOpenChange: o,
    value: a,
    defaultValue: s,
    onValueChange: l,
    dir: u,
    name: d,
    autoComplete: f,
    disabled: p,
    required: m,
    form: g
  } = e, v = jh(t), [y, b] = C.useState(null), [E, S] = C.useState(null), [_, k] = C.useState(!1), T = qee(u), [A, R] = WE({
    prop: r,
    defaultProp: i ?? !1,
    onChange: o,
    caller: Ea
  }), [F, D] = WE({
    prop: a,
    defaultProp: s,
    onChange: l,
    caller: Ea
  }), W = C.useRef(null), L = y ? g || !!y.closest("form") : !0, [z, B] = C.useState(/* @__PURE__ */ new Set()), G = Array.from(z).map((H) => H.props.value).join(";");
  return /* @__PURE__ */ fe.jsx(Cte, { ...v, children: /* @__PURE__ */ fe.jsxs(
    Zte,
    {
      required: m,
      scope: t,
      trigger: y,
      onTriggerChange: b,
      valueNode: E,
      onValueNodeChange: S,
      valueNodeHasChildren: _,
      onValueNodeHasChildrenChange: k,
      contentId: Hy(),
      value: F,
      onValueChange: D,
      open: A,
      onOpenChange: R,
      dir: T,
      triggerPointerDownPosRef: W,
      disabled: p,
      children: [
        /* @__PURE__ */ fe.jsx(Vh.Provider, { scope: t, children: /* @__PURE__ */ fe.jsx(
          Qte,
          {
            scope: e.__scopeSelect,
            onNativeOptionAdd: C.useCallback((H) => {
              B((J) => new Set(J).add(H));
            }, []),
            onNativeOptionRemove: C.useCallback((H) => {
              B((J) => {
                const q = new Set(J);
                return q.delete(H), q;
              });
            }, []),
            children: n
          }
        ) }),
        L ? /* @__PURE__ */ fe.jsxs(
          D8,
          {
            "aria-hidden": !0,
            required: m,
            tabIndex: -1,
            name: d,
            autoComplete: f,
            value: F,
            onChange: (H) => D(H.target.value),
            disabled: p,
            form: g,
            children: [
              F === void 0 ? /* @__PURE__ */ fe.jsx("option", { value: "" }) : null,
              Array.from(z)
            ]
          },
          G
        ) : null
      ]
    }
  ) });
};
u8.displayName = Ea;
var d8 = "SelectTrigger", f8 = C.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, disabled: r = !1, ...i } = e, o = jh(n), a = $o(d8, n), s = a.disabled || r, l = _n(t, a.onTriggerChange), u = Bh(n), d = C.useRef("touch"), [f, p, m] = $8((v) => {
      const y = u().filter((S) => !S.disabled), b = y.find((S) => S.value === a.value), E = L8(y, v, b);
      E !== void 0 && a.onValueChange(E.value);
    }), g = (v) => {
      s || (a.onOpenChange(!0), m()), v && (a.triggerPointerDownPosRef.current = {
        x: Math.round(v.pageX),
        y: Math.round(v.pageY)
      });
    };
    return /* @__PURE__ */ fe.jsx(Ste, { asChild: !0, ...o, children: /* @__PURE__ */ fe.jsx(
      tn.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": a.contentId,
        "aria-expanded": a.open,
        "aria-required": a.required,
        "aria-autocomplete": "none",
        dir: a.dir,
        "data-state": a.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": N8(a.value) ? "" : void 0,
        ...i,
        ref: l,
        onClick: an(i.onClick, (v) => {
          v.currentTarget.focus(), d.current !== "mouse" && g(v);
        }),
        onPointerDown: an(i.onPointerDown, (v) => {
          d.current = v.pointerType;
          const y = v.target;
          y.hasPointerCapture(v.pointerId) && y.releasePointerCapture(v.pointerId), v.button === 0 && v.ctrlKey === !1 && v.pointerType === "mouse" && (g(v), v.preventDefault());
        }),
        onKeyDown: an(i.onKeyDown, (v) => {
          const y = f.current !== "";
          !(v.ctrlKey || v.altKey || v.metaKey) && v.key.length === 1 && p(v.key), !(y && v.key === " ") && Yte.includes(v.key) && (g(), v.preventDefault());
        })
      }
    ) });
  }
);
f8.displayName = d8;
var h8 = "SelectValue", p8 = C.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: i, children: o, placeholder: a = "", ...s } = e, l = $o(h8, n), { onValueNodeHasChildrenChange: u } = l, d = o !== void 0, f = _n(t, l.onValueNodeChange);
    return tr(() => {
      u(d);
    }, [u, d]), /* @__PURE__ */ fe.jsx(
      tn.span,
      {
        ...s,
        ref: f,
        style: { pointerEvents: "none" },
        children: N8(l.value) ? /* @__PURE__ */ fe.jsx(fe.Fragment, { children: a }) : o
      }
    );
  }
);
p8.displayName = h8;
var ene = "SelectIcon", m8 = C.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, children: r, ...i } = e;
    return /* @__PURE__ */ fe.jsx(tn.span, { "aria-hidden": !0, ...i, ref: t, children: r || "▼" });
  }
);
m8.displayName = ene;
var tne = "SelectPortal", g8 = (e) => /* @__PURE__ */ fe.jsx(r8, { asChild: !0, ...e });
g8.displayName = tne;
var Ca = "SelectContent", v8 = C.forwardRef(
  (e, t) => {
    const n = $o(Ca, e.__scopeSelect), [r, i] = C.useState();
    if (tr(() => {
      i(new DocumentFragment());
    }, []), !n.open) {
      const o = r;
      return o ? Kf.createPortal(
        /* @__PURE__ */ fe.jsx(y8, { scope: e.__scopeSelect, children: /* @__PURE__ */ fe.jsx(Vh.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ fe.jsx("div", { children: e.children }) }) }),
        o
      ) : null;
    }
    return /* @__PURE__ */ fe.jsx(w8, { ...e, ref: t });
  }
);
v8.displayName = Ca;
var Zr = 10, [y8, Lo] = Ys(Ca), nne = "SelectContentImpl", rne = Af("SelectContent.RemoveScroll"), w8 = C.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      position: r = "item-aligned",
      onCloseAutoFocus: i,
      onEscapeKeyDown: o,
      onPointerDownOutside: a,
      //
      // PopperContent props
      side: s,
      sideOffset: l,
      align: u,
      alignOffset: d,
      arrowPadding: f,
      collisionBoundary: p,
      collisionPadding: m,
      sticky: g,
      hideWhenDetached: v,
      avoidCollisions: y,
      //
      ...b
    } = e, E = $o(Ca, n), [S, _] = C.useState(null), [k, T] = C.useState(null), A = _n(t, (se) => _(se)), [R, F] = C.useState(null), [D, W] = C.useState(
      null
    ), L = Bh(n), [z, B] = C.useState(!1), G = C.useRef(!1);
    C.useEffect(() => {
      if (S)
        return ah(S);
    }, [S]), ite();
    const H = C.useCallback(
      (se) => {
        const [Se, ...le] = L().map((te) => te.ref.current), [Ee] = le.slice(-1), Ie = document.activeElement;
        for (const te of se)
          if (te === Ie || (te == null || te.scrollIntoView({ block: "nearest" }), te === Se && k && (k.scrollTop = 0), te === Ee && k && (k.scrollTop = k.scrollHeight), te == null || te.focus(), document.activeElement !== Ie))
            return;
      },
      [L, k]
    ), J = C.useCallback(
      () => H([R, S]),
      [H, R, S]
    );
    C.useEffect(() => {
      z && J();
    }, [z, J]);
    const { onOpenChange: q, triggerPointerDownPosRef: Z } = E;
    C.useEffect(() => {
      if (S) {
        let se = { x: 0, y: 0 };
        const Se = (Ee) => {
          var Ie, te;
          se = {
            x: Math.abs(Math.round(Ee.pageX) - (((Ie = Z.current) == null ? void 0 : Ie.x) ?? 0)),
            y: Math.abs(Math.round(Ee.pageY) - (((te = Z.current) == null ? void 0 : te.y) ?? 0))
          };
        }, le = (Ee) => {
          se.x <= 10 && se.y <= 10 ? Ee.preventDefault() : S.contains(Ee.target) || q(!1), document.removeEventListener("pointermove", Se), Z.current = null;
        };
        return Z.current !== null && (document.addEventListener("pointermove", Se), document.addEventListener("pointerup", le, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", Se), document.removeEventListener("pointerup", le, { capture: !0 });
        };
      }
    }, [S, q, Z]), C.useEffect(() => {
      const se = () => q(!1);
      return window.addEventListener("blur", se), window.addEventListener("resize", se), () => {
        window.removeEventListener("blur", se), window.removeEventListener("resize", se);
      };
    }, [q]);
    const [O, Q] = $8((se) => {
      const Se = L().filter((Ie) => !Ie.disabled), le = Se.find((Ie) => Ie.ref.current === document.activeElement), Ee = L8(Se, se, le);
      Ee && setTimeout(() => Ee.ref.current.focus());
    }), he = C.useCallback(
      (se, Se, le) => {
        const Ee = !G.current && !le;
        (E.value !== void 0 && E.value === Se || Ee) && (F(se), Ee && (G.current = !0));
      },
      [E.value]
    ), N = C.useCallback(() => S == null ? void 0 : S.focus(), [S]), ee = C.useCallback(
      (se, Se, le) => {
        const Ee = !G.current && !le;
        (E.value !== void 0 && E.value === Se || Ee) && W(se);
      },
      [E.value]
    ), ae = r === "popper" ? g0 : b8, pe = ae === g0 ? {
      side: s,
      sideOffset: l,
      align: u,
      alignOffset: d,
      arrowPadding: f,
      collisionBoundary: p,
      collisionPadding: m,
      sticky: g,
      hideWhenDetached: v,
      avoidCollisions: y
    } : {};
    return /* @__PURE__ */ fe.jsx(
      y8,
      {
        scope: n,
        content: S,
        viewport: k,
        onViewportChange: T,
        itemRefCallback: he,
        selectedItem: R,
        onItemLeave: N,
        itemTextRefCallback: ee,
        focusSelectedItem: J,
        selectedItemText: D,
        position: r,
        isPositioned: z,
        searchRef: O,
        children: /* @__PURE__ */ fe.jsx(qte, { as: rne, allowPinchZoom: !0, children: /* @__PURE__ */ fe.jsx(
          Uk,
          {
            asChild: !0,
            trapped: E.open,
            onMountAutoFocus: (se) => {
              se.preventDefault();
            },
            onUnmountAutoFocus: an(i, (se) => {
              var Se;
              (Se = E.trigger) == null || Se.focus({ preventScroll: !0 }), se.preventDefault();
            }),
            children: /* @__PURE__ */ fe.jsx(
              jk,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: o,
                onPointerDownOutside: a,
                onFocusOutside: (se) => se.preventDefault(),
                onDismiss: () => E.onOpenChange(!1),
                children: /* @__PURE__ */ fe.jsx(
                  ae,
                  {
                    role: "listbox",
                    id: E.contentId,
                    "data-state": E.open ? "open" : "closed",
                    dir: E.dir,
                    onContextMenu: (se) => se.preventDefault(),
                    ...b,
                    ...pe,
                    onPlaced: () => B(!0),
                    ref: A,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...b.style
                    },
                    onKeyDown: an(b.onKeyDown, (se) => {
                      const Se = se.ctrlKey || se.altKey || se.metaKey;
                      if (se.key === "Tab" && se.preventDefault(), !Se && se.key.length === 1 && Q(se.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(se.key)) {
                        let Ee = L().filter((Ie) => !Ie.disabled).map((Ie) => Ie.ref.current);
                        if (["ArrowUp", "End"].includes(se.key) && (Ee = Ee.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(se.key)) {
                          const Ie = se.target, te = Ee.indexOf(Ie);
                          Ee = Ee.slice(te + 1);
                        }
                        setTimeout(() => H(Ee)), se.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
w8.displayName = nne;
var ine = "SelectItemAlignedPosition", b8 = C.forwardRef((e, t) => {
  const { __scopeSelect: n, onPlaced: r, ...i } = e, o = $o(Ca, n), a = Lo(Ca, n), [s, l] = C.useState(null), [u, d] = C.useState(null), f = _n(t, (A) => d(A)), p = Bh(n), m = C.useRef(!1), g = C.useRef(!0), { viewport: v, selectedItem: y, selectedItemText: b, focusSelectedItem: E } = a, S = C.useCallback(() => {
    if (o.trigger && o.valueNode && s && u && v && y && b) {
      const A = o.trigger.getBoundingClientRect(), R = u.getBoundingClientRect(), F = o.valueNode.getBoundingClientRect(), D = b.getBoundingClientRect();
      if (o.dir !== "rtl") {
        const Ie = D.left - R.left, te = F.left - Ie, Re = A.left - te, we = A.width + Re, ze = Math.max(we, R.width), dt = window.innerWidth - Zr, ht = DE(te, [
          Zr,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(Zr, dt - ze)
        ]);
        s.style.minWidth = we + "px", s.style.left = ht + "px";
      } else {
        const Ie = R.right - D.right, te = window.innerWidth - F.right - Ie, Re = window.innerWidth - A.right - te, we = A.width + Re, ze = Math.max(we, R.width), dt = window.innerWidth - Zr, ht = DE(te, [
          Zr,
          Math.max(Zr, dt - ze)
        ]);
        s.style.minWidth = we + "px", s.style.right = ht + "px";
      }
      const W = p(), L = window.innerHeight - Zr * 2, z = v.scrollHeight, B = window.getComputedStyle(u), G = parseInt(B.borderTopWidth, 10), H = parseInt(B.paddingTop, 10), J = parseInt(B.borderBottomWidth, 10), q = parseInt(B.paddingBottom, 10), Z = G + H + z + q + J, O = Math.min(y.offsetHeight * 5, Z), Q = window.getComputedStyle(v), he = parseInt(Q.paddingTop, 10), N = parseInt(Q.paddingBottom, 10), ee = A.top + A.height / 2 - Zr, ae = L - ee, pe = y.offsetHeight / 2, se = y.offsetTop + pe, Se = G + H + se, le = Z - Se;
      if (Se <= ee) {
        const Ie = W.length > 0 && y === W[W.length - 1].ref.current;
        s.style.bottom = "0px";
        const te = u.clientHeight - v.offsetTop - v.offsetHeight, Re = Math.max(
          ae,
          pe + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (Ie ? N : 0) + te + J
        ), we = Se + Re;
        s.style.height = we + "px";
      } else {
        const Ie = W.length > 0 && y === W[0].ref.current;
        s.style.top = "0px";
        const Re = Math.max(
          ee,
          G + v.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (Ie ? he : 0) + pe
        ) + le;
        s.style.height = Re + "px", v.scrollTop = Se - ee + v.offsetTop;
      }
      s.style.margin = `${Zr}px 0`, s.style.minHeight = O + "px", s.style.maxHeight = L + "px", r == null || r(), requestAnimationFrame(() => m.current = !0);
    }
  }, [
    p,
    o.trigger,
    o.valueNode,
    s,
    u,
    v,
    y,
    b,
    o.dir,
    r
  ]);
  tr(() => S(), [S]);
  const [_, k] = C.useState();
  tr(() => {
    u && k(window.getComputedStyle(u).zIndex);
  }, [u]);
  const T = C.useCallback(
    (A) => {
      A && g.current === !0 && (S(), E == null || E(), g.current = !1);
    },
    [S, E]
  );
  return /* @__PURE__ */ fe.jsx(
    ane,
    {
      scope: n,
      contentWrapper: s,
      shouldExpandOnScrollRef: m,
      onScrollButtonChange: T,
      children: /* @__PURE__ */ fe.jsx(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: _
          },
          children: /* @__PURE__ */ fe.jsx(
            tn.div,
            {
              ...i,
              ref: f,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...i.style
              }
            }
          )
        }
      )
    }
  );
});
b8.displayName = ine;
var one = "SelectPopperPosition", g0 = C.forwardRef((e, t) => {
  const {
    __scopeSelect: n,
    align: r = "start",
    collisionPadding: i = Zr,
    ...o
  } = e, a = jh(n);
  return /* @__PURE__ */ fe.jsx(
    _te,
    {
      ...a,
      ...o,
      ref: t,
      align: r,
      collisionPadding: i,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...o.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
g0.displayName = one;
var [ane, Yy] = Ys(Ca, {}), v0 = "SelectViewport", x8 = C.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, nonce: r, ...i } = e, o = Lo(v0, n), a = Yy(v0, n), s = _n(t, o.onViewportChange), l = C.useRef(0);
    return /* @__PURE__ */ fe.jsxs(fe.Fragment, { children: [
      /* @__PURE__ */ fe.jsx(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: r
        }
      ),
      /* @__PURE__ */ fe.jsx(Vh.Slot, { scope: n, children: /* @__PURE__ */ fe.jsx(
        tn.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...i,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...i.style
          },
          onScroll: an(i.onScroll, (u) => {
            const d = u.currentTarget, { contentWrapper: f, shouldExpandOnScrollRef: p } = a;
            if (p != null && p.current && f) {
              const m = Math.abs(l.current - d.scrollTop);
              if (m > 0) {
                const g = window.innerHeight - Zr * 2, v = parseFloat(f.style.minHeight), y = parseFloat(f.style.height), b = Math.max(v, y);
                if (b < g) {
                  const E = b + m, S = Math.min(g, E), _ = E - S;
                  f.style.height = S + "px", f.style.bottom === "0px" && (d.scrollTop = _ > 0 ? _ : 0, f.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = d.scrollTop;
          })
        }
      ) })
    ] });
  }
);
x8.displayName = v0;
var E8 = "SelectGroup", [sne, lne] = Ys(E8), cne = C.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, i = Hy();
    return /* @__PURE__ */ fe.jsx(sne, { scope: n, id: i, children: /* @__PURE__ */ fe.jsx(tn.div, { role: "group", "aria-labelledby": i, ...r, ref: t }) });
  }
);
cne.displayName = E8;
var C8 = "SelectLabel", S8 = C.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, i = lne(C8, n);
    return /* @__PURE__ */ fe.jsx(tn.div, { id: i.id, ...r, ref: t });
  }
);
S8.displayName = C8;
var Mf = "SelectItem", [une, _8] = Ys(Mf), P8 = C.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: n,
      value: r,
      disabled: i = !1,
      textValue: o,
      ...a
    } = e, s = $o(Mf, n), l = Lo(Mf, n), u = s.value === r, [d, f] = C.useState(o ?? ""), [p, m] = C.useState(!1), g = _n(
      t,
      (E) => {
        var S;
        return (S = l.itemRefCallback) == null ? void 0 : S.call(l, E, r, i);
      }
    ), v = Hy(), y = C.useRef("touch"), b = () => {
      i || (s.onValueChange(r), s.onOpenChange(!1));
    };
    if (r === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ fe.jsx(
      une,
      {
        scope: n,
        value: r,
        disabled: i,
        textId: v,
        isSelected: u,
        onItemTextChange: C.useCallback((E) => {
          f((S) => S || ((E == null ? void 0 : E.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ fe.jsx(
          Vh.ItemSlot,
          {
            scope: n,
            value: r,
            disabled: i,
            textValue: d,
            children: /* @__PURE__ */ fe.jsx(
              tn.div,
              {
                role: "option",
                "aria-labelledby": v,
                "data-highlighted": p ? "" : void 0,
                "aria-selected": u && p,
                "data-state": u ? "checked" : "unchecked",
                "aria-disabled": i || void 0,
                "data-disabled": i ? "" : void 0,
                tabIndex: i ? void 0 : -1,
                ...a,
                ref: g,
                onFocus: an(a.onFocus, () => m(!0)),
                onBlur: an(a.onBlur, () => m(!1)),
                onClick: an(a.onClick, () => {
                  y.current !== "mouse" && b();
                }),
                onPointerUp: an(a.onPointerUp, () => {
                  y.current === "mouse" && b();
                }),
                onPointerDown: an(a.onPointerDown, (E) => {
                  y.current = E.pointerType;
                }),
                onPointerMove: an(a.onPointerMove, (E) => {
                  var S;
                  y.current = E.pointerType, i ? (S = l.onItemLeave) == null || S.call(l) : y.current === "mouse" && E.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: an(a.onPointerLeave, (E) => {
                  var S;
                  E.currentTarget === document.activeElement && ((S = l.onItemLeave) == null || S.call(l));
                }),
                onKeyDown: an(a.onKeyDown, (E) => {
                  var _;
                  ((_ = l.searchRef) == null ? void 0 : _.current) !== "" && E.key === " " || (Kte.includes(E.key) && b(), E.key === " " && E.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
P8.displayName = Mf;
var Fl = "SelectItemText", k8 = C.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, className: r, style: i, ...o } = e, a = $o(Fl, n), s = Lo(Fl, n), l = _8(Fl, n), u = Jte(Fl, n), [d, f] = C.useState(null), p = _n(
      t,
      (b) => f(b),
      l.onItemTextChange,
      (b) => {
        var E;
        return (E = s.itemTextRefCallback) == null ? void 0 : E.call(s, b, l.value, l.disabled);
      }
    ), m = d == null ? void 0 : d.textContent, g = C.useMemo(
      () => /* @__PURE__ */ fe.jsx("option", { value: l.value, disabled: l.disabled, children: m }, l.value),
      [l.disabled, l.value, m]
    ), { onNativeOptionAdd: v, onNativeOptionRemove: y } = u;
    return tr(() => (v(g), () => y(g)), [v, y, g]), /* @__PURE__ */ fe.jsxs(fe.Fragment, { children: [
      /* @__PURE__ */ fe.jsx(tn.span, { id: l.textId, ...o, ref: p }),
      l.isSelected && a.valueNode && !a.valueNodeHasChildren ? Kf.createPortal(o.children, a.valueNode) : null
    ] });
  }
);
k8.displayName = Fl;
var T8 = "SelectItemIndicator", A8 = C.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return _8(T8, n).isSelected ? /* @__PURE__ */ fe.jsx(tn.span, { "aria-hidden": !0, ...r, ref: t }) : null;
  }
);
A8.displayName = T8;
var y0 = "SelectScrollUpButton", M8 = C.forwardRef((e, t) => {
  const n = Lo(y0, e.__scopeSelect), r = Yy(y0, e.__scopeSelect), [i, o] = C.useState(!1), a = _n(t, r.onScrollButtonChange);
  return tr(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const u = l.scrollTop > 0;
        o(u);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), i ? /* @__PURE__ */ fe.jsx(
    R8,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
M8.displayName = y0;
var w0 = "SelectScrollDownButton", O8 = C.forwardRef((e, t) => {
  const n = Lo(w0, e.__scopeSelect), r = Yy(w0, e.__scopeSelect), [i, o] = C.useState(!1), a = _n(t, r.onScrollButtonChange);
  return tr(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const u = l.scrollHeight - l.clientHeight, d = Math.ceil(l.scrollTop) < u;
        o(d);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), i ? /* @__PURE__ */ fe.jsx(
    R8,
    {
      ...e,
      ref: a,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
O8.displayName = w0;
var R8 = C.forwardRef((e, t) => {
  const { __scopeSelect: n, onAutoScroll: r, ...i } = e, o = Lo("SelectScrollButton", n), a = C.useRef(null), s = Bh(n), l = C.useCallback(() => {
    a.current !== null && (window.clearInterval(a.current), a.current = null);
  }, []);
  return C.useEffect(() => () => l(), [l]), tr(() => {
    var d;
    const u = s().find((f) => f.ref.current === document.activeElement);
    (d = u == null ? void 0 : u.ref.current) == null || d.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ fe.jsx(
    tn.div,
    {
      "aria-hidden": !0,
      ...i,
      ref: t,
      style: { flexShrink: 0, ...i.style },
      onPointerDown: an(i.onPointerDown, () => {
        a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerMove: an(i.onPointerMove, () => {
        var u;
        (u = o.onItemLeave) == null || u.call(o), a.current === null && (a.current = window.setInterval(r, 50));
      }),
      onPointerLeave: an(i.onPointerLeave, () => {
        l();
      })
    }
  );
}), dne = "SelectSeparator", I8 = C.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e;
    return /* @__PURE__ */ fe.jsx(tn.div, { "aria-hidden": !0, ...r, ref: t });
  }
);
I8.displayName = dne;
var b0 = "SelectArrow", fne = C.forwardRef(
  (e, t) => {
    const { __scopeSelect: n, ...r } = e, i = jh(n), o = $o(b0, n), a = Lo(b0, n);
    return o.open && a.position === "popper" ? /* @__PURE__ */ fe.jsx(Pte, { ...i, ...r, ref: t }) : null;
  }
);
fne.displayName = b0;
var hne = "SelectBubbleInput", D8 = C.forwardRef(
  ({ __scopeSelect: e, value: t, ...n }, r) => {
    const i = C.useRef(null), o = _n(r, i), a = Ote(t);
    return C.useEffect(() => {
      const s = i.current;
      if (!s)
        return;
      const l = window.HTMLSelectElement.prototype, d = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (a !== t && d) {
        const f = new Event("change", { bubbles: !0 });
        d.call(s, t), s.dispatchEvent(f);
      }
    }, [a, t]), /* @__PURE__ */ fe.jsx(
      tn.select,
      {
        ...n,
        style: { ...i8, ...n.style },
        ref: o,
        defaultValue: t
      }
    );
  }
);
D8.displayName = hne;
function N8(e) {
  return e === "" || e === void 0;
}
function $8(e) {
  const t = xa(e), n = C.useRef(""), r = C.useRef(0), i = C.useCallback(
    (a) => {
      const s = n.current + a;
      t(s), function l(u) {
        n.current = u, window.clearTimeout(r.current), u !== "" && (r.current = window.setTimeout(() => l(""), 1e3));
      }(s);
    },
    [t]
  ), o = C.useCallback(() => {
    n.current = "", window.clearTimeout(r.current);
  }, []);
  return C.useEffect(() => () => window.clearTimeout(r.current), []), [n, i, o];
}
function L8(e, t, n) {
  const i = t.length > 1 && Array.from(t).every((u) => u === t[0]) ? t[0] : t, o = n ? e.indexOf(n) : -1;
  let a = pne(e, Math.max(o, 0));
  i.length === 1 && (a = a.filter((u) => u !== n));
  const l = a.find(
    (u) => u.textValue.toLowerCase().startsWith(i.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function pne(e, t) {
  return e.map((n, r) => e[(t + r) % e.length]);
}
var mne = u8, F8 = f8, gne = p8, vne = m8, yne = g8, z8 = v8, wne = x8, V8 = S8, B8 = P8, bne = k8, xne = A8, j8 = M8, W8 = O8, U8 = I8;
const Ky = mne, Xy = gne, Wh = C.forwardRef(({ className: e, children: t, variant: n, ...r }, i) => /* @__PURE__ */ C.createElement(
  F8,
  {
    ref: i,
    className: ie(
      "ai-tw-flex ai-tw-w-full ai-tw-items-center ai-tw-justify-between ai-tw-rounded-md ai-tw-border ai-tw-border-stroke-primary-dark ai-tw-bg-element-primary-alt ai-tw-px-3 ai-tw-py-2 ai-tw-text-sm ai-tw-ring-offset-background disabled:ai-tw-cursor-not-allowed disabled:ai-tw-opacity-50 data-[placeholder]:ai-tw-text-muted-foreground [&>span]:ai-tw-line-clamp-1",
      "hover:ai-tw-border-stroke-brand-light focus:ai-tw-border-stroke-brand-light",
      "focus:ai-tw-bg-white focus:ai-tw-outline-none focus:ai-tw-ring-[1.5px] focus:ai-tw-ring-stroke-brand-lightest",
      n === "error" && "ai-tw-border-stroke-critical hover:ai-tw-border-stroke-critical-dark focus:ai-tw-border-stroke-critical-dark focus:ai-tw-ring-stroke-critical",
      e
    ),
    ...r
  },
  t,
  /* @__PURE__ */ C.createElement(vne, { asChild: !0 }, /* @__PURE__ */ C.createElement(Le, { icon: K$, className: "ai-tw-h-4 ai-tw-w-4" }))
));
Wh.displayName = F8.displayName;
const H8 = C.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ C.createElement(
  j8,
  {
    ref: n,
    className: ie(
      "ai-tw-flex ai-tw-cursor-default ai-tw-items-center ai-tw-justify-center ai-tw-py-1",
      e
    ),
    ...t
  },
  /* @__PURE__ */ C.createElement(ZY, { className: "ai-tw-h-4 ai-tw-w-4" })
));
H8.displayName = j8.displayName;
const G8 = C.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ C.createElement(
  W8,
  {
    ref: n,
    className: ie(
      "ai-tw-flex ai-tw-cursor-default ai-tw-items-center ai-tw-justify-center ai-tw-py-1",
      e
    ),
    ...t
  },
  /* @__PURE__ */ C.createElement(KY, { className: "ai-tw-h-4 ai-tw-w-4" })
));
G8.displayName = W8.displayName;
const Uh = C.forwardRef(({ className: e, children: t, position: n = "popper", ...r }, i) => /* @__PURE__ */ C.createElement(yne, null, /* @__PURE__ */ C.createElement(
  z8,
  {
    ref: i,
    className: ie(
      "ai-tw-relative ai-tw-z-[1200] ai-tw-max-h-[--radix-select-content-available-height] ai-tw-min-w-[8rem] ai-tw-origin-[--radix-select-content-transform-origin] ai-tw-overflow-y-auto ai-tw-overflow-x-hidden ai-tw-rounded-md ai-tw-border ai-tw-bg-popover ai-tw-text-popover-foreground ai-tw-shadow-md data-[state=open]:ai-tw-animate-in data-[state=closed]:ai-tw-animate-out data-[state=closed]:ai-tw-fade-out-0 data-[state=open]:ai-tw-fade-in-0 data-[state=closed]:ai-tw-zoom-out-95 data-[state=open]:ai-tw-zoom-in-95 data-[side=bottom]:ai-tw-slide-in-from-top-2 data-[side=left]:ai-tw-slide-in-from-right-2 data-[side=right]:ai-tw-slide-in-from-left-2 data-[side=top]:ai-tw-slide-in-from-bottom-2",
      n === "popper" && "data-[side=bottom]:ai-tw-translate-y-1 data-[side=left]:ai-tw--translate-x-1 data-[side=right]:ai-tw-translate-x-1 data-[side=top]:ai-tw--translate-y-1",
      e
    ),
    position: n,
    ...r
  },
  /* @__PURE__ */ C.createElement(H8, null),
  /* @__PURE__ */ C.createElement(
    wne,
    {
      className: ie(
        "ai-tw-p-1",
        n === "popper" && "ai-tw-h-[var(--radix-select-trigger-height)] ai-tw-w-full ai-tw-min-w-[var(--radix-select-trigger-width)]"
      )
    },
    t
  ),
  /* @__PURE__ */ C.createElement(G8, null)
)));
Uh.displayName = z8.displayName;
const Ene = C.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ C.createElement(
  V8,
  {
    ref: n,
    className: ie(
      "ai-tw-py-1.5 ai-tw-pl-8 ai-tw-pr-2 ai-tw-text-sm ai-tw-font-semibold",
      e
    ),
    ...t
  }
));
Ene.displayName = V8.displayName;
const Hh = C.forwardRef(({ className: e, children: t, ...n }, r) => /* @__PURE__ */ C.createElement(
  B8,
  {
    ref: r,
    className: ie(
      "ai-tw-relative ai-tw-flex ai-tw-w-full ai-tw-cursor-default ai-tw-select-none ai-tw-items-center ai-tw-rounded-sm ai-tw-py-1.5 ai-tw-pl-8 ai-tw-pr-2 ai-tw-text-sm ai-tw-outline-none focus:ai-tw-bg-accent focus:ai-tw-text-accent-foreground data-[disabled]:ai-tw-pointer-events-none data-[disabled]:ai-tw-opacity-50",
      e
    ),
    ...n
  },
  /* @__PURE__ */ C.createElement("span", { className: "ai-tw-absolute ai-tw-left-2 ai-tw-flex ai-tw-h-3.5 ai-tw-w-3.5 ai-tw-items-center ai-tw-justify-center" }, /* @__PURE__ */ C.createElement(xne, null, /* @__PURE__ */ C.createElement(uP, { className: "ai-tw-h-4 ai-tw-w-4" }))),
  /* @__PURE__ */ C.createElement(bne, null, t)
));
Hh.displayName = B8.displayName;
const Cne = C.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ C.createElement(
  U8,
  {
    ref: n,
    className: ie(
      "ai-tw--mx-1 ai-tw-my-1 ai-tw-h-px ai-tw-bg-muted",
      e
    ),
    ...t
  }
));
Cne.displayName = U8.displayName;
const Sne = [
  { value: "4", label: "4:00 AM" },
  { value: "5", label: "5:00 AM" },
  { value: "6", label: "6:00 AM" },
  { value: "7", label: "7:00 AM" },
  { value: "8", label: "8:00 AM" },
  { value: "9", label: "9:00 AM" },
  { value: "10", label: "10:00 AM" },
  { value: "11", label: "11:00 AM" },
  { value: "12", label: "12:00 PM" },
  { value: "13", label: "1:00 PM" },
  { value: "14", label: "2:00 PM" },
  { value: "15", label: "3:00 PM" },
  { value: "16", label: "4:00 PM" },
  { value: "17", label: "5:00 PM" },
  { value: "18", label: "6:00 PM" },
  { value: "19", label: "7:00 PM" },
  { value: "20", label: "8:00 PM" },
  { value: "21", label: "9:00 PM" },
  { value: "22", label: "10:00 PM" },
  { value: "23", label: "11:00 PM" }
], Ao = ({
  value: e,
  onValueChange: t,
  placeholder: n = "Select Time",
  name: r,
  className: i,
  disabled: o,
  isValid: a = !0
}) => /* @__PURE__ */ C.createElement(
  Ky,
  {
    name: r,
    value: `${e ?? ""}`,
    onValueChange: (s) => {
      t(s ? parseInt(s, 10) : void 0);
    },
    disabled: o
  },
  /* @__PURE__ */ C.createElement(
    Wh,
    {
      className: ie(i, "ai-tw-w-32"),
      variant: a ? "default" : "error"
    },
    /* @__PURE__ */ C.createElement(Xy, { placeholder: n })
  ),
  /* @__PURE__ */ C.createElement(Uh, null, Sne.map((s) => /* @__PURE__ */ C.createElement(Hh, { key: s.value, value: s.value }, s.label)))
);
var _ne = function e(t, n) {
  if (t === n)
    return !0;
  if (t && n && typeof t == "object" && typeof n == "object") {
    if (t.constructor !== n.constructor)
      return !1;
    var r, i, o;
    if (Array.isArray(t)) {
      if (r = t.length, r != n.length)
        return !1;
      for (i = r; i-- !== 0; )
        if (!e(t[i], n[i]))
          return !1;
      return !0;
    }
    if (t.constructor === RegExp)
      return t.source === n.source && t.flags === n.flags;
    if (t.valueOf !== Object.prototype.valueOf)
      return t.valueOf() === n.valueOf();
    if (t.toString !== Object.prototype.toString)
      return t.toString() === n.toString();
    if (o = Object.keys(t), r = o.length, r !== Object.keys(n).length)
      return !1;
    for (i = r; i-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(n, o[i]))
        return !1;
    for (i = r; i-- !== 0; ) {
      var a = o[i];
      if (!e(t[a], n[a]))
        return !1;
    }
    return !0;
  }
  return t !== t && n !== n;
};
const Pne = /* @__PURE__ */ Pi(_ne);
function bi() {
  return bi = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, bi.apply(null, arguments);
}
function Is(e, t) {
  if (e == null)
    return {};
  var n = {};
  for (var r in e)
    if ({}.hasOwnProperty.call(e, r)) {
      if (t.indexOf(r) !== -1)
        continue;
      n[r] = e[r];
    }
  return n;
}
function kne(e, t) {
  if (typeof e != "object" || !e)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function Tne(e) {
  var t = kne(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
const Wi = {
  NOT_LOADED: "NOT_LOADED",
  LOADING: "LOADING",
  LOADED: "LOADED",
  FAILED: "FAILED",
  AUTH_FAILURE: "AUTH_FAILURE"
}, Ane = "https://maps.googleapis.com/maps/api/js";
class xc {
  /**
   * Loads the Maps JavaScript API with the specified parameters.
   * Since the Maps library can only be loaded once per page, this will
   * produce a warning when called multiple times with different
   * parameters.
   *
   * The returned promise resolves when loading completes
   * and rejects in case of an error or when the loading was aborted.
   */
  static async load(t, n) {
    var r;
    const i = t.libraries ? t.libraries.split(",") : [], o = this.serializeParams(t);
    this.listeners.push(n), (r = window.google) != null && (r = r.maps) != null && r.importLibrary ? (this.serializedApiParams || (this.loadingStatus = Wi.LOADED), this.notifyLoadingStatusListeners()) : (this.serializedApiParams = o, this.initImportLibrary(t)), this.serializedApiParams && this.serializedApiParams !== o && console.warn("[google-maps-api-loader] The maps API has already been loaded with different parameters and will not be loaded again. Refresh the page for new values to have effect.");
    const a = ["maps", ...i];
    await Promise.all(a.map((s) => google.maps.importLibrary(s)));
  }
  /**
   * Serialize the parameters used to load the library for easier comparison.
   */
  static serializeParams(t) {
    return [t.v, t.key, t.language, t.region, t.authReferrerPolicy, t.solutionChannel].join("/");
  }
  /**
   * Creates the global `google.maps.importLibrary` function for bootstrapping.
   * This is essentially a formatted version of the dynamic loading script
   * from the official documentation with some minor adjustments.
   *
   * The created importLibrary function will load the Google Maps JavaScript API,
   * which will then replace the `google.maps.importLibrary` function with the full
   * implementation.
   *
   * @see https://developers.google.com/maps/documentation/javascript/load-maps-js-api#dynamic-library-import
   */
  static initImportLibrary(t) {
    if (window.google || (window.google = {}), window.google.maps || (window.google.maps = {}), window.google.maps.importLibrary) {
      console.error("[google-maps-api-loader-internal]: initImportLibrary must only be called once");
      return;
    }
    let n = null;
    const r = () => n || (n = new Promise((i, o) => {
      var a;
      const s = document.createElement("script"), l = new URLSearchParams();
      for (const [u, d] of Object.entries(t)) {
        const f = u.replace(/[A-Z]/g, (p) => "_" + p[0].toLowerCase());
        l.set(f, String(d));
      }
      l.set("loading", "async"), l.set("callback", "__googleMapsCallback__"), s.async = !0, s.src = Ane + "?" + l.toString(), s.nonce = ((a = document.querySelector("script[nonce]")) == null ? void 0 : a.nonce) || "", s.onerror = () => {
        this.loadingStatus = Wi.FAILED, this.notifyLoadingStatusListeners(), o(new Error("The Google Maps JavaScript API could not load."));
      }, window.__googleMapsCallback__ = () => {
        this.loadingStatus = Wi.LOADED, this.notifyLoadingStatusListeners(), i();
      }, window.gm_authFailure = () => {
        this.loadingStatus = Wi.AUTH_FAILURE, this.notifyLoadingStatusListeners();
      }, this.loadingStatus = Wi.LOADING, this.notifyLoadingStatusListeners(), document.head.append(s);
    }), n);
    google.maps.importLibrary = (i) => r().then(() => google.maps.importLibrary(i));
  }
  /**
   * Calls all registered loadingStatusListeners after a status update.
   */
  static notifyLoadingStatusListeners() {
    for (const t of this.listeners)
      t(this.loadingStatus);
  }
}
xc.loadingStatus = Wi.NOT_LOADED;
xc.serializedApiParams = void 0;
xc.listeners = [];
const Mne = ["onLoad", "onError", "apiKey", "version", "libraries"], One = ["children"], Rne = "GMP_visgl_rgmlibrary_v1_default", Fc = x.createContext(null);
function Ine() {
  const [e, t] = de({});
  return {
    mapInstances: e,
    addMapInstance: (o, a = "default") => {
      t((s) => bi({}, s, {
        [a]: o
      }));
    },
    removeMapInstance: (o = "default") => {
      t((a) => Is(a, [o].map(Tne)));
    },
    clearMapInstances: () => {
      t({});
    }
  };
}
function Dne(e) {
  const {
    onLoad: t,
    onError: n,
    apiKey: r,
    version: i,
    libraries: o = []
  } = e, a = Is(e, Mne), [s, l] = de(xc.loadingStatus), [u, d] = Yf((g, v) => g[v.name] ? g : bi({}, g, {
    [v.name]: v.value
  }), {}), f = Lt(() => o == null ? void 0 : o.join(","), [o]), p = Lt(() => JSON.stringify(bi({
    apiKey: r,
    version: i
  }, a)), [r, i, a]), m = De(async (g) => {
    var v;
    if (u[g])
      return u[g];
    if (!((v = google) != null && (v = v.maps) != null && v.importLibrary))
      throw new Error("[api-provider-internal] importLibrary was called before google.maps.importLibrary was defined.");
    const y = await window.google.maps.importLibrary(g);
    return d({
      name: g,
      value: y
    }), y;
  }, [u]);
  return be(
    () => {
      (async () => {
        try {
          const g = bi({
            key: r
          }, a);
          i && (g.v = i), (f == null ? void 0 : f.length) > 0 && (g.libraries = f), (g.channel === void 0 || g.channel < 0 || g.channel > 999) && delete g.channel, g.solutionChannel === void 0 ? g.solutionChannel = Rne : g.solutionChannel === "" && delete g.solutionChannel, await xc.load(g, (v) => l(v));
          for (const v of ["core", "maps", ...o])
            await m(v);
          t && t();
        } catch (g) {
          n ? n(g) : console.error("<ApiProvider> failed to load the Google Maps JavaScript API", g);
        }
      })();
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [r, f, p]
  ), {
    status: s,
    loadedLibraries: u,
    importLibrary: m
  };
}
const Nne = (e) => {
  const {
    children: t
  } = e, n = Is(e, One), {
    mapInstances: r,
    addMapInstance: i,
    removeMapInstance: o,
    clearMapInstances: a
  } = Ine(), {
    status: s,
    loadedLibraries: l,
    importLibrary: u
  } = Dne(n), d = Lt(() => ({
    mapInstances: r,
    addMapInstance: i,
    removeMapInstance: o,
    clearMapInstances: a,
    status: s,
    loadedLibraries: l,
    importLibrary: u
  }), [r, i, o, a, s, l, u]);
  return /* @__PURE__ */ x.createElement(Fc.Provider, {
    value: d
  }, t);
};
function $ne(e, t) {
  for (const n of Vne) {
    const r = t[n], i = q8[n];
    be(() => {
      if (!e || !r)
        return;
      const o = google.maps.event.addListener(e, i, (a) => {
        r(Lne(i, e, a));
      });
      return () => o.remove();
    }, [e, i, r]);
  }
}
function Lne(e, t, n) {
  const r = {
    type: e,
    map: t,
    detail: {},
    stoppable: !1,
    stop: () => {
    }
  };
  if (Fne.includes(e)) {
    const o = r, a = t.getCenter(), s = t.getZoom(), l = t.getHeading() || 0, u = t.getTilt() || 0, d = t.getBounds();
    return (!a || !d || !Number.isFinite(s)) && console.warn("[createEvent] at least one of the values from the map returned undefined. This is not expected to happen. Please report an issue at https://github.com/visgl/react-google-maps/issues/new"), o.detail = {
      center: (a == null ? void 0 : a.toJSON()) || {
        lat: 0,
        lng: 0
      },
      zoom: s || 0,
      heading: l,
      tilt: u,
      bounds: (d == null ? void 0 : d.toJSON()) || {
        north: 90,
        east: 180,
        south: -90,
        west: -180
      }
    }, o;
  } else if (zne.includes(e)) {
    var i;
    if (!n)
      throw new Error("[createEvent] mouse events must provide a srcEvent");
    const o = r;
    return o.domEvent = n.domEvent, o.stoppable = !0, o.stop = () => n.stop(), o.detail = {
      latLng: ((i = n.latLng) == null ? void 0 : i.toJSON()) || null,
      placeId: n.placeId
    }, o;
  }
  return r;
}
const q8 = {
  onBoundsChanged: "bounds_changed",
  onCenterChanged: "center_changed",
  onClick: "click",
  onContextmenu: "contextmenu",
  onDblclick: "dblclick",
  onDrag: "drag",
  onDragend: "dragend",
  onDragstart: "dragstart",
  onHeadingChanged: "heading_changed",
  onIdle: "idle",
  onIsFractionalZoomEnabledChanged: "isfractionalzoomenabled_changed",
  onMapCapabilitiesChanged: "mapcapabilities_changed",
  onMapTypeIdChanged: "maptypeid_changed",
  onMousemove: "mousemove",
  onMouseout: "mouseout",
  onMouseover: "mouseover",
  onProjectionChanged: "projection_changed",
  onRenderingTypeChanged: "renderingtype_changed",
  onTilesLoaded: "tilesloaded",
  onTiltChanged: "tilt_changed",
  onZoomChanged: "zoom_changed",
  // note: onCameraChanged is an alias for the bounds_changed event,
  // since that is going to be fired in every situation where the camera is
  // updated.
  onCameraChanged: "bounds_changed"
}, Fne = ["bounds_changed", "center_changed", "heading_changed", "tilt_changed", "zoom_changed"], zne = ["click", "contextmenu", "dblclick", "mousemove", "mouseout", "mouseover"], Vne = Object.keys(q8);
function Bne(e, t) {
  const n = me(e);
  return t(e, n.current) || (n.current = e), n.current;
}
function jne(e, t, n) {
  be(e, [Bne(t, n)]);
}
function Wne(e, t) {
  jne(e, t, Pne);
}
const Une = /* @__PURE__ */ new Set(["backgroundColor", "clickableIcons", "controlSize", "disableDefaultUI", "disableDoubleClickZoom", "draggable", "draggableCursor", "draggingCursor", "fullscreenControl", "fullscreenControlOptions", "gestureHandling", "headingInteractionEnabled", "isFractionalZoomEnabled", "keyboardShortcuts", "mapTypeControl", "mapTypeControlOptions", "mapTypeId", "maxZoom", "minZoom", "noClear", "panControl", "panControlOptions", "restriction", "rotateControl", "rotateControlOptions", "scaleControl", "scaleControlOptions", "scrollwheel", "streetView", "streetViewControl", "streetViewControlOptions", "styles", "tiltInteractionEnabled", "zoomControl", "zoomControlOptions"]);
function Hne(e, t) {
  const n = {}, r = Object.keys(t);
  for (const i of r)
    Une.has(i) && (n[i] = t[i]);
  Wne(() => {
    e && e.setOptions(n);
  }, [n]);
}
function Y8() {
  var e;
  return ((e = Me(Fc)) == null ? void 0 : e.status) || Wi.NOT_LOADED;
}
function Gne(e, t) {
  const {
    viewport: n,
    viewState: r
  } = t, i = !!n;
  return eo(() => {
    if (!e || !r)
      return;
    const {
      latitude: o,
      longitude: a,
      bearing: s,
      pitch: l,
      zoom: u
    } = r;
    e.moveCamera({
      center: {
        lat: o,
        lng: a
      },
      heading: s,
      tilt: l,
      zoom: u + 1
    });
  }, [e, r]), i;
}
function qne(e) {
  return !e || typeof e != "object" || !("lat" in e && "lng" in e) ? !1 : Number.isFinite(e.lat) && Number.isFinite(e.lng);
}
function K8(e) {
  return qne(e) ? e : e.toJSON();
}
function Yne(e, t, n) {
  const r = n.center ? K8(n.center) : null;
  let i = null, o = null;
  r && Number.isFinite(r.lat) && Number.isFinite(r.lng) && (i = r.lat, o = r.lng);
  const a = Number.isFinite(n.zoom) ? n.zoom : null, s = Number.isFinite(n.heading) ? n.heading : null, l = Number.isFinite(n.tilt) ? n.tilt : null;
  eo(() => {
    if (!e)
      return;
    const u = {};
    let d = !1;
    i !== null && o !== null && (t.current.center.lat !== i || t.current.center.lng !== o) && (u.center = {
      lat: i,
      lng: o
    }, d = !0), a !== null && t.current.zoom !== a && (u.zoom = a, d = !0), s !== null && t.current.heading !== s && (u.heading = s, d = !0), l !== null && t.current.tilt !== l && (u.tilt = l, d = !0), d && e.moveCamera(u);
  });
}
const Kne = () => {
  const e = {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    zIndex: 999,
    display: "flex",
    flexFlow: "column nowrap",
    textAlign: "center",
    justifyContent: "center",
    fontSize: ".8rem",
    color: "rgba(0,0,0,0.6)",
    background: "#dddddd",
    padding: "1rem 1.5rem"
  };
  return /* @__PURE__ */ x.createElement("div", {
    style: e
  }, /* @__PURE__ */ x.createElement("h2", null, "Error: AuthFailure"), /* @__PURE__ */ x.createElement("p", null, "A problem with your API key prevents the map from rendering correctly. Please make sure the value of the ", /* @__PURE__ */ x.createElement("code", null, "APIProvider.apiKey"), " prop is correct. Check the error-message in the console for further details."));
};
function Xne() {
  const [e, t] = de(null), n = De((r) => t(r), [t]);
  return [e, n];
}
function X8() {
  return Y8() === Wi.LOADED;
}
function Zne() {
  const [, e] = Yf((t) => t + 1, 0);
  return e;
}
function Qne(e, t) {
  const n = e.getCenter(), r = e.getZoom(), i = e.getHeading() || 0, o = e.getTilt() || 0, a = e.getBounds();
  (!n || !a || !Number.isFinite(r)) && console.warn("[useTrackedCameraState] at least one of the values from the map returned undefined. This is not expected to happen. Please report an issue at https://github.com/visgl/react-google-maps/issues/new"), Object.assign(t.current, {
    center: (n == null ? void 0 : n.toJSON()) || {
      lat: 0,
      lng: 0
    },
    zoom: r || 0,
    heading: i,
    tilt: o
  });
}
function Jne(e) {
  const t = Zne(), n = me({
    center: {
      lat: 0,
      lng: 0
    },
    heading: 0,
    tilt: 0,
    zoom: 0
  });
  return be(() => {
    if (!e)
      return;
    const r = google.maps.event.addListener(e, "bounds_changed", () => {
      Qne(e, n), t();
    });
    return () => r.remove();
  }, [e, t]), n;
}
const ere = ["id", "defaultBounds", "defaultCenter", "defaultZoom", "defaultHeading", "defaultTilt", "reuseMaps", "renderingType", "colorScheme"], tre = ["padding"];
class Hd {
  static has(t) {
    return this.entries[t] && this.entries[t].length > 0;
  }
  static pop(t) {
    return this.entries[t] && this.entries[t].pop() || null;
  }
  static push(t, n) {
    this.entries[t] || (this.entries[t] = []), this.entries[t].push(n);
  }
}
Hd.entries = {};
function nre(e, t) {
  const n = X8(), [r, i] = de(null), [o, a] = Xne(), s = Jne(r), {
    id: l,
    defaultBounds: u,
    defaultCenter: d,
    defaultZoom: f,
    defaultHeading: p,
    defaultTilt: m,
    reuseMaps: g,
    renderingType: v,
    colorScheme: y
  } = e, b = Is(e, ere), E = e.zoom !== void 0 || e.defaultZoom !== void 0, S = e.center !== void 0 || e.defaultCenter !== void 0;
  !u && (!E || !S) && console.warn("<Map> component is missing configuration. You have to provide zoom and center (via the `zoom`/`defaultZoom` and `center`/`defaultCenter` props) or specify the region to show using `defaultBounds`. See https://visgl.github.io/react-google-maps/docs/api-reference/components/map#required"), !b.center && d && (b.center = d), !b.zoom && Number.isFinite(f) && (b.zoom = f), !b.heading && Number.isFinite(p) && (b.heading = p), !b.tilt && Number.isFinite(m) && (b.tilt = m);
  for (const k of Object.keys(b))
    b[k] === void 0 && delete b[k];
  const _ = me(void 0);
  return be(
    () => {
      if (!o || !n)
        return;
      const {
        addMapInstance: k,
        removeMapInstance: T
      } = t, {
        mapId: A
      } = e, R = `${A || "default"}:${v || "default"}:${y || "LIGHT"}`;
      let F, D;
      if (g && Hd.has(R) ? (D = Hd.pop(R), F = D.getDiv(), o.appendChild(F), D.setOptions(b), setTimeout(() => D.setCenter(D.getCenter()), 0)) : (F = document.createElement("div"), F.style.height = "100%", o.appendChild(F), D = new google.maps.Map(F, bi({}, b, v ? {
        renderingType: v
      } : {}, y ? {
        colorScheme: y
      } : {}))), i(D), k(D, l), u) {
        const {
          padding: W
        } = u, L = Is(u, tre);
        D.fitBounds(L, W);
      } else
        (!E || !S) && D.fitBounds({
          east: 180,
          west: -180,
          south: -90,
          north: 90
        });
      if (_.current) {
        const {
          mapId: W,
          cameraState: L
        } = _.current;
        W !== A && D.setOptions(L);
      }
      return () => {
        _.current = {
          mapId: A,
          // eslint-disable-next-line react-hooks/exhaustive-deps
          cameraState: s.current
        }, F.remove(), g ? Hd.push(R, D) : google.maps.event.clearInstanceListeners(D), i(null), T(l);
      };
    },
    // some dependencies are ignored in the list below:
    //  - defaultBounds and the default* camera props will only be used once, and
    //    changes should be ignored
    //  - mapOptions has special hooks that take care of updating the options
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      o,
      n,
      l,
      // these props can't be changed after initialization and require a new
      // instance to be created
      e.mapId,
      e.renderingType,
      e.colorScheme
    ]
  ), [r, a, s];
}
const Z8 = x.createContext(null), Q8 = (e) => {
  const {
    children: t,
    id: n,
    className: r,
    style: i
  } = e, o = Me(Fc), a = Y8();
  if (!o)
    throw new Error("<Map> can only be used inside an <ApiProvider> component.");
  const [s, l, u] = nre(e, o);
  Yne(s, u, e), $ne(s, e), Hne(s, e);
  const d = Gne(s, e), f = !!e.controlled;
  be(() => {
    if (s)
      return d && s.setOptions({
        disableDefaultUI: !0
      }), (d || f) && s.setOptions({
        gestureHandling: "none",
        keyboardShortcuts: !1
      }), () => {
        s.setOptions({
          gestureHandling: e.gestureHandling,
          keyboardShortcuts: e.keyboardShortcuts
        });
      };
  }, [s, d, f, e.gestureHandling, e.keyboardShortcuts]);
  const p = e.center ? K8(e.center) : null;
  let m = null, g = null;
  p && Number.isFinite(p.lat) && Number.isFinite(p.lng) && (m = p.lat, g = p.lng);
  const v = Lt(() => {
    var E, S, _, k, T;
    return {
      center: {
        lat: (E = m) != null ? E : 0,
        lng: (S = g) != null ? S : 0
      },
      zoom: (_ = e.zoom) != null ? _ : 0,
      heading: (k = e.heading) != null ? k : 0,
      tilt: (T = e.tilt) != null ? T : 0
    };
  }, [m, g, e.zoom, e.heading, e.tilt]);
  eo(() => {
    if (!s || !f)
      return;
    s.moveCamera(v);
    const E = s.addListener("bounds_changed", () => {
      s.moveCamera(v);
    });
    return () => E.remove();
  }, [s, f, v]);
  const y = Lt(() => bi({
    width: "100%",
    height: "100%",
    position: "relative",
    // when using deckgl, the map should be sent to the back
    zIndex: d ? -1 : 0
  }, i), [i, d]), b = Lt(() => ({
    map: s
  }), [s]);
  return a === Wi.AUTH_FAILURE ? /* @__PURE__ */ x.createElement("div", {
    style: bi({
      position: "relative"
    }, r ? {} : y),
    className: r
  }, /* @__PURE__ */ x.createElement(Kne, null)) : /* @__PURE__ */ x.createElement("div", bi({
    ref: l,
    "data-testid": "map",
    style: r ? void 0 : y,
    className: r
  }, n ? {
    id: n
  } : {}), s ? /* @__PURE__ */ x.createElement(Z8.Provider, {
    value: b
  }, t) : null);
};
Q8.deckGLViewProps = !0;
const qE = /* @__PURE__ */ new Set();
function rre(...e) {
  const t = JSON.stringify(e);
  qE.has(t) || (qE.add(t), console.error(...e));
}
const Gh = (e = null) => {
  const t = Me(Fc), {
    map: n
  } = Me(Z8) || {};
  if (t === null)
    return rre("useMap(): failed to retrieve APIProviderContext. Make sure that the <APIProvider> component exists and that the component you are calling `useMap()` from is a sibling of the <APIProvider>."), null;
  const {
    mapInstances: r
  } = t;
  return e !== null ? r[e] || null : n || r.default || null;
};
function J8(e) {
  const t = X8(), n = Me(Fc);
  return be(() => {
    !t || !n || n.importLibrary(e);
  }, [t, n, e]), (n == null ? void 0 : n.loadedLibraries[e]) || null;
}
function vd(e, t, n) {
  be(() => {
    if (!e || !t || !n)
      return;
    const r = google.maps.event.addListener(e, t, n);
    return () => r.remove();
  }, [e, t, n]);
}
function yd(e, t, n) {
  be(() => {
    e && (e[t] = n);
  }, [e, t, n]);
}
function YE(e, t, n) {
  be(() => {
    if (!(!e || !t || !n))
      return e.addEventListener(t, n), () => e.removeEventListener(t, n);
  }, [e, t, n]);
}
function KE(e) {
  return e.nodeType === Node.ELEMENT_NODE;
}
const ire = x.createContext(null), ore = {
  TOP_LEFT: ["0%", "0%"],
  TOP_CENTER: ["50%", "0%"],
  TOP: ["50%", "0%"],
  TOP_RIGHT: ["100%", "0%"],
  LEFT_CENTER: ["0%", "50%"],
  LEFT_TOP: ["0%", "0%"],
  LEFT: ["0%", "50%"],
  LEFT_BOTTOM: ["0%", "100%"],
  RIGHT_TOP: ["100%", "0%"],
  RIGHT: ["100%", "50%"],
  RIGHT_CENTER: ["100%", "50%"],
  RIGHT_BOTTOM: ["100%", "100%"],
  BOTTOM_LEFT: ["0%", "100%"],
  BOTTOM_CENTER: ["50%", "100%"],
  BOTTOM: ["50%", "100%"],
  BOTTOM_RIGHT: ["100%", "100%"],
  CENTER: ["50%", "50%"]
}, are = ({
  children: e,
  styles: t,
  className: n,
  anchorPoint: r
}) => {
  const [i, o] = r ?? ore.BOTTOM;
  let a = `-${i}`, s = `-${o}`;
  i.trimStart().startsWith("-") && (a = i.substring(1)), o.trimStart().startsWith("-") && (s = o.substring(1));
  const l = `translate(50%, 100%) translate(${a}, ${s})`;
  return (
    // anchoring container
    /* @__PURE__ */ x.createElement("div", {
      style: {
        transform: l
      }
    }, /* @__PURE__ */ x.createElement("div", {
      className: n,
      style: t
    }, e))
  );
};
function sre(e) {
  const [t, n] = de(null), [r, i] = de(null), o = Gh(), a = J8("marker"), {
    children: s,
    onClick: l,
    className: u,
    onMouseEnter: d,
    onMouseLeave: f,
    onDrag: p,
    onDragStart: m,
    onDragEnd: g,
    collisionBehavior: v,
    clickable: y,
    draggable: b,
    position: E,
    title: S,
    zIndex: _
  } = e, k = Ui.count(s);
  return be(() => {
    if (!o || !a)
      return;
    const T = new a.AdvancedMarkerElement();
    T.map = o, n(T);
    let A = null;
    return k > 0 && (A = document.createElement("div"), A.isCustomMarker = !0, T.content = A, i(A)), () => {
      var R;
      T.map = null, (R = A) == null || R.remove(), n(null), i(null);
    };
  }, [o, a, k]), be(() => {
    !(t != null && t.content) || !KE(t.content) || k > 0 || (t.content.className = u ?? "");
  }, [t, u, k]), yd(t, "position", E), yd(t, "title", S ?? ""), yd(t, "zIndex", _), yd(t, "collisionBehavior", v), be(() => {
    t && (b !== void 0 ? t.gmpDraggable = b : p || m || g ? t.gmpDraggable = !0 : t.gmpDraggable = !1);
  }, [t, b, p, g, m]), be(() => {
    if (!t)
      return;
    const T = y !== void 0 || !!l || !!d || !!f;
    t.gmpClickable = T, T && t != null && t.content && KE(t.content) && (t.content.style.pointerEvents = "none", t.content.firstElementChild && (t.content.firstElementChild.style.pointerEvents = "all"));
  }, [t, y, l, d, f]), vd(t, "click", l), vd(t, "drag", p), vd(t, "dragstart", m), vd(t, "dragend", g), YE(t == null ? void 0 : t.element, "mouseenter", d), YE(t == null ? void 0 : t.element, "mouseleave", f), [t, r];
}
ke((e, t) => {
  const {
    children: n,
    style: r,
    className: i,
    anchorPoint: o
  } = e, [a, s] = sre(e), l = Lt(() => a ? {
    marker: a
  } : null, [a]);
  return aS(t, () => a, [a]), s ? /* @__PURE__ */ x.createElement(ire.Provider, {
    value: l
  }, _c(/* @__PURE__ */ x.createElement(are, {
    anchorPoint: o,
    styles: r,
    className: i
  }, n), s)) : null;
});
const lre = ["onClick", "onDrag", "onDragStart", "onDragEnd", "onMouseOver", "onMouseOut"];
function cre(e) {
  const [t, n] = de(null), r = Gh(), {
    onClick: i,
    onDrag: o,
    onDragStart: a,
    onDragEnd: s,
    onMouseOver: l,
    onMouseOut: u
  } = e, d = Is(e, lre), {
    position: f,
    draggable: p
  } = d;
  return be(() => {
    if (!r) {
      r === void 0 && console.error("<Marker> has to be inside a Map component.");
      return;
    }
    const m = new google.maps.Marker(d);
    return m.setMap(r), n(m), () => {
      m.setMap(null), n(null);
    };
  }, [r]), be(() => {
    if (!t)
      return;
    const m = t, g = google.maps.event;
    return i && g.addListener(m, "click", i), o && g.addListener(m, "drag", o), a && g.addListener(m, "dragstart", a), s && g.addListener(m, "dragend", s), l && g.addListener(m, "mouseover", l), u && g.addListener(m, "mouseout", u), t.setDraggable(!!p), () => {
      g.clearInstanceListeners(m);
    };
  }, [t, p, i, o, a, s, l, u]), be(() => {
    t && d && t.setOptions(d);
  }, [t, d]), be(() => {
    p || !f || !t || t.setPosition(f);
  }, [p, f, t]), t;
}
ke((e, t) => {
  const n = cre(e);
  return aS(t, () => n, [n]), /* @__PURE__ */ x.createElement(x.Fragment, null);
});
const ure = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let dre = (e = 21) => {
  let t = "", n = crypto.getRandomValues(new Uint8Array(e |= 0));
  for (; e--; )
    t += ure[n[e] & 63];
  return t;
};
function eT(e) {
  return (e == null ? void 0 : e.polygons) !== void 0;
}
function en() {
  return en = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var r in n)
        ({}).hasOwnProperty.call(n, r) && (e[r] = n[r]);
    }
    return e;
  }, en.apply(null, arguments);
}
var hn;
(function(e) {
  e.Commit = "commit", e.Provisional = "provisional", e.Finish = "finish";
})(hn || (hn = {}));
const fn = { SELECTED: "selected", MID_POINT: "midPoint", SELECTION_POINT_FEATURE_ID: "selectionPointFeatureId", SELECTION_POINT: "selectionPoint" }, tt = { MODE: "mode", CURRENTLY_DRAWING: "currentlyDrawing", EDITED: "edited", CLOSING_POINT: "closingPoint", SNAPPING_POINT: "snappingPoint", COORDINATE_POINT: "coordinatePoint", COORDINATE_POINT_FEATURE_ID: "coordinatePointFeatureId", COORDINATE_POINT_IDS: "coordinatePointIds", PROVISIONAL_COORDINATE_COUNT: "provisionalCoordinateCount", COMMITTED_COORDINATE_COUNT: "committedCoordinateCount" }, Es = 10;
function pg(e) {
  return !!(e && typeof e == "object" && e !== null && !Array.isArray(e));
}
function XE(e) {
  return !!(e && typeof e == "object" && "properties" in e && typeof e.properties == "object" && e.properties !== null && "mode" in e.properties);
}
function ZE(e) {
  return !!function(t) {
    return typeof t == "number" && !isNaN(new Date(t).valueOf());
  }(e);
}
const fre = "Feature mode property does not match the mode being added to";
var Ds;
(function(e) {
  e.Drawing = "drawing", e.Select = "select", e.Static = "static", e.Render = "render";
})(Ds || (Ds = {}));
const hre = { rightClick: !0, contextMenu: !1, leftClick: !0, onDragStart: !0, onDrag: !0, onDragEnd: !0 };
class Ks {
  get state() {
    return this._state;
  }
  set state(t) {
    throw new Error("Please use the modes lifecycle methods");
  }
  get styles() {
    return this._styles;
  }
  set styles(t) {
    if (typeof t != "object")
      throw new Error("Styling must be an object");
    this.onStyleChange && this.onStyleChange([], "styling"), this._styles = t;
  }
  registerBehaviors(t) {
  }
  constructor(t, n = !1) {
    this._state = "unregistered", this._styles = {}, this.pointerEvents = hre, this.behaviors = [], this.validate = void 0, this.pointerDistance = 40, this.coordinatePrecision = void 0, this.onStyleChange = void 0, this.store = void 0, this.projection = "web-mercator", this.setDoubleClickToZoom = void 0, this.unproject = void 0, this.project = void 0, this.setCursor = void 0, this.type = Ds.Drawing, this.mode = "base", n || this.updateOptions(t);
  }
  updateOptions(t) {
    t != null && t.styles && (this.styles = en({}, this._styles, t.styles)), t != null && t.pointerDistance && (this.pointerDistance = t.pointerDistance), t != null && t.validation && (this.validate = t && t.validation), t != null && t.projection && (this.projection = t.projection), (t == null ? void 0 : t.pointerEvents) !== void 0 && (this.pointerEvents = t.pointerEvents);
  }
  allowPointerEvent(t, n) {
    return typeof t == "boolean" ? t : typeof t != "function" || t(n);
  }
  setDrawing() {
    if (this._state !== "started")
      throw new Error("Mode must be unregistered or stopped to start");
    this._state = "drawing";
  }
  setStarted() {
    if (this._state !== "stopped" && this._state !== "registered" && this._state !== "drawing" && this._state !== "selecting")
      throw new Error("Mode must be unregistered or stopped to start");
    this._state = "started", this.setDoubleClickToZoom(!1);
  }
  setStopped() {
    if (this._state !== "started")
      throw new Error("Mode must be started to be stopped");
    this._state = "stopped", this.setDoubleClickToZoom(!0);
  }
  register(t) {
    if (this._state !== "unregistered")
      throw new Error("Can not register unless mode is unregistered");
    this._state = "registered", this.store = t.store, this.store.registerOnChange(t.onChange), this.setDoubleClickToZoom = t.setDoubleClickToZoom, this.project = t.project, this.unproject = t.unproject, this.onSelect = t.onSelect, this.onDeselect = t.onDeselect, this.setCursor = t.setCursor, this.onStyleChange = t.onChange, this.onFinish = t.onFinish, this.coordinatePrecision = t.coordinatePrecision, this.registerBehaviors({ mode: t.mode, store: this.store, project: this.project, unproject: this.unproject, pointerDistance: this.pointerDistance, coordinatePrecision: t.coordinatePrecision, projection: this.projection });
  }
  validateFeature(t) {
    return this.performFeatureValidation(t);
  }
  afterFeatureAdded(t) {
  }
  afterFeatureUpdated(t) {
  }
  performFeatureValidation(t) {
    if (this._state === "unregistered")
      throw new Error("Mode must be registered");
    const n = function(r, i) {
      let o;
      if (pg(r))
        if (r.id == null)
          o = "Feature has no id";
        else if (typeof r.id != "string" && typeof r.id != "number")
          o = "Feature must be string or number as per GeoJSON spec";
        else if (i(r.id))
          if (pg(r.geometry))
            if (pg(r.properties))
              if (typeof r.geometry.type == "string" && ["Polygon", "LineString", "Point"].includes(r.geometry.type))
                if (Array.isArray(r.geometry.coordinates)) {
                  if (!r.properties.mode || typeof r.properties.mode != "string")
                    return { valid: !1, reason: "Feature does not have a valid mode property" };
                } else
                  o = "Feature coordinates is not an array";
              else
                o = "Feature is not Point, LineString or Polygon";
            else
              o = "Feature has no properties";
          else
            o = "Feature has no geometry";
        else
          o = "Feature must match the id strategy (default is UUID4)";
      else
        o = "Feature is not object";
      return o ? { valid: !1, reason: o } : { valid: !0 };
    }(t, this.store.idStrategy.isValidId);
    if (this.validate) {
      const r = this.validate(t, { project: this.project, unproject: this.unproject, coordinatePrecision: this.coordinatePrecision, updateType: hn.Provisional });
      return { valid: n.valid && r.valid, reason: r.reason };
    }
    return { valid: n.valid, reason: n.reason };
  }
  validateModeFeature(t, n) {
    const r = this.performFeatureValidation(t);
    return r.valid ? t.properties.mode !== this.mode ? { valid: !1, reason: fre } : n(t) : { valid: !1, reason: r.reason };
  }
  onFinish(t, n) {
  }
  onDeselect(t) {
  }
  onSelect(t) {
  }
  onKeyDown(t) {
  }
  onKeyUp(t) {
  }
  onMouseMove(t) {
  }
  onClick(t) {
  }
  onDragStart(t, n) {
  }
  onDrag(t, n) {
  }
  onDragEnd(t, n) {
  }
  getHexColorStylingValue(t, n, r) {
    return this.getStylingValue(t, n, r);
  }
  getNumericStylingValue(t, n, r) {
    return this.getStylingValue(t, n, r);
  }
  getStylingValue(t, n, r) {
    return t === void 0 ? n : typeof t == "function" ? t(r) : t;
  }
}
class tT extends Ks {
  constructor(...t) {
    super(...t), this.type = Ds.Select;
  }
}
function Ns(e, t) {
  const n = (u) => u * Math.PI / 180, r = n(e[1]), i = n(e[0]), o = n(t[1]), a = o - r, s = n(t[0]) - i, l = Math.sin(a / 2) * Math.sin(a / 2) + Math.cos(r) * Math.cos(o) * Math.sin(s / 2) * Math.sin(s / 2);
  return 2 * Math.atan2(Math.sqrt(l), Math.sqrt(1 - l)) * 6371e3 / 1e3;
}
const nT = 63710088e-1;
function xi(e) {
  return e % 360 * Math.PI / 180;
}
function pre(e) {
  return e / 6371.0088;
}
function Ec(e) {
  return e % (2 * Math.PI) * 180 / Math.PI;
}
function Bt(e, t = 9) {
  const n = Math.pow(10, t);
  return Math.round(e * n) / n;
}
const QE = 57.29577951308232, JE = 0.017453292519943295, Of = 6378137, $t = (e, t) => ({ x: e === 0 ? 0 : e * JE * Of, y: t === 0 ? 0 : Math.log(Math.tan(Math.PI / 4 + t * JE / 2)) * Of }), Sa = (e, t) => ({ lng: e === 0 ? 0 : QE * (e / Of), lat: t === 0 ? 0 : (2 * Math.atan(Math.exp(t / Of)) - Math.PI / 2) * QE });
function mre(e, t, n) {
  const r = xi(e[0]), i = xi(e[1]), o = xi(n), a = pre(t), s = Math.asin(Math.sin(i) * Math.cos(a) + Math.cos(i) * Math.sin(a) * Math.cos(o));
  return [Ec(r + Math.atan2(Math.sin(o) * Math.sin(a) * Math.cos(i), Math.cos(a) - Math.sin(i) * Math.sin(s))), Ec(s)];
}
function eC(e) {
  const { center: t, radiusKilometers: n, coordinatePrecision: r } = e, i = e.steps ? e.steps : 64, o = [];
  for (let a = 0; a < i; a++) {
    const s = mre(t, n, -360 * a / i);
    o.push([Bt(s[0], r), Bt(s[1], r)]);
  }
  return o.push(o[0]), { type: "Feature", geometry: { type: "Polygon", coordinates: [o] }, properties: {} };
}
function rT(e) {
  let t;
  if (e.geometry.type === "Polygon")
    t = e.geometry.coordinates;
  else {
    if (e.geometry.type !== "LineString")
      throw new Error("Self intersects only accepts Polygons and LineStrings");
    t = [e.geometry.coordinates];
  }
  const n = [];
  for (let o = 0; o < t.length; o++)
    for (let a = 0; a < t[o].length - 1; a++)
      for (let s = 0; s < t.length; s++)
        for (let l = 0; l < t[s].length - 1; l++)
          i(o, a, s, l);
  return n.length > 0;
  function r(o) {
    return o < 0 || o > 1;
  }
  function i(o, a, s, l) {
    const u = t[o][a], d = t[o][a + 1], f = t[s][l], p = t[s][l + 1], m = function(y, b, E, S) {
      if (wd(y, E) || wd(y, S) || wd(b, E) || wd(S, E))
        return null;
      const _ = y[0], k = y[1], T = b[0], A = b[1], R = E[0], F = E[1], D = S[0], W = S[1], L = (_ - T) * (F - W) - (k - A) * (R - D);
      return L === 0 ? null : [((_ * A - k * T) * (R - D) - (_ - T) * (R * W - F * D)) / L, ((_ * A - k * T) * (F - W) - (k - A) * (R * W - F * D)) / L];
    }(u, d, f, p);
    if (m === null)
      return;
    let g, v;
    g = d[0] !== u[0] ? (m[0] - u[0]) / (d[0] - u[0]) : (m[1] - u[1]) / (d[1] - u[1]), v = p[0] !== f[0] ? (m[0] - f[0]) / (p[0] - f[0]) : (m[1] - f[1]) / (p[1] - f[1]), r(g) || r(v) || (m.toString(), n.push(m));
  }
}
function wd(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}
function iT(e, t) {
  return tC(e[0]) <= t && tC(e[1]) <= t;
}
function gre(e) {
  return e.length === 2 && typeof e[0] == "number" && typeof e[1] == "number" && e[0] !== 1 / 0 && e[1] !== 1 / 0 && (n = e[0]) >= -180 && n <= 180 && (t = e[1]) >= -90 && t <= 90;
  var t, n;
}
function tC(e) {
  let t = 1, n = 0;
  for (; Math.round(e * t) / t !== e; )
    t *= 10, n++;
  return n;
}
const vre = "Feature has holes", yre = "Feature has less than 4 coordinates", wre = "Feature has invalid coordinates", bre = "Feature coordinates are not closed";
function oT(e, t) {
  if (e.geometry.type !== "Polygon")
    return { valid: !1, reason: "Feature is not a Polygon" };
  if (e.geometry.coordinates.length !== 1)
    return { valid: !1, reason: vre };
  if (e.geometry.coordinates[0].length < 4)
    return { valid: !1, reason: yre };
  for (let i = 0; i < e.geometry.coordinates[0].length; i++) {
    if (!gre(e.geometry.coordinates[0][i]))
      return { valid: !1, reason: wre };
    if (!iT(e.geometry.coordinates[0][i], t))
      return { valid: !1, reason: "Feature has coordinates with excessive precision" };
  }
  return (n = e.geometry.coordinates[0][0])[0] !== (r = e.geometry.coordinates[0][e.geometry.coordinates[0].length - 1])[0] || n[1] !== r[1] ? { valid: !1, reason: bre } : { valid: !0 };
  var n, r;
}
function aT(e, t) {
  const n = oT(e, t);
  return n.valid ? rT(e) ? { valid: !1, reason: "Feature intersects itself" } : { valid: !0 } : n;
}
const xre = { cancel: "Escape", finish: "Enter" }, Ere = { start: "crosshair" };
class Cre extends Ks {
  constructor(t) {
    super(t, !0), this.mode = "circle", this.center = void 0, this.clickCount = 0, this.currentCircleId = void 0, this.keyEvents = xre, this.cursors = Ere, this.startingRadiusKilometers = 1e-5, this.cursorMovedAfterInitialCursorDown = !1, this.updateOptions(t);
  }
  updateOptions(t) {
    super.updateOptions(t), t != null && t.cursors && (this.cursors = en({}, this.cursors, t.cursors)), (t == null ? void 0 : t.keyEvents) === null ? this.keyEvents = { cancel: null, finish: null } : t != null && t.keyEvents && (this.keyEvents = en({}, this.keyEvents, t.keyEvents)), t != null && t.startingRadiusKilometers && (this.startingRadiusKilometers = t.startingRadiusKilometers);
  }
  close() {
    if (this.currentCircleId === void 0)
      return;
    this.store.updateProperty([{ id: this.currentCircleId, property: tt.CURRENTLY_DRAWING, value: void 0 }]);
    const t = this.currentCircleId;
    if (this.validate && t) {
      const n = this.store.getGeometryCopy(t);
      if (!this.validate({ type: "Feature", id: t, geometry: n, properties: {} }, { project: this.project, unproject: this.unproject, coordinatePrecision: this.coordinatePrecision, updateType: hn.Finish }).valid)
        return;
    }
    this.cursorMovedAfterInitialCursorDown = !1, this.center = void 0, this.currentCircleId = void 0, this.clickCount = 0, this.state === "drawing" && this.setStarted(), this.onFinish(t, { mode: this.mode, action: "draw" });
  }
  start() {
    this.setStarted(), this.setCursor(this.cursors.start);
  }
  stop() {
    this.cleanUp(), this.setStopped(), this.setCursor("unset");
  }
  onClick(t) {
    if (t.button === "right" && this.allowPointerEvent(this.pointerEvents.rightClick, t) || t.button === "left" && this.allowPointerEvent(this.pointerEvents.leftClick, t) || t.isContextMenu && this.allowPointerEvent(this.pointerEvents.contextMenu, t))
      if (this.clickCount === 0) {
        this.center = [t.lng, t.lat];
        const n = eC({ center: this.center, radiusKilometers: this.startingRadiusKilometers, coordinatePrecision: this.coordinatePrecision }), [r] = this.store.create([{ geometry: n.geometry, properties: { mode: this.mode, radiusKilometers: this.startingRadiusKilometers, [tt.CURRENTLY_DRAWING]: !0 } }]);
        this.currentCircleId = r, this.clickCount++, this.cursorMovedAfterInitialCursorDown = !1, this.setDrawing();
      } else
        this.clickCount === 1 && this.center && this.currentCircleId !== void 0 && this.cursorMovedAfterInitialCursorDown && this.updateCircle(t), this.close();
  }
  onMouseMove(t) {
    this.cursorMovedAfterInitialCursorDown = !0, this.updateCircle(t);
  }
  onKeyDown() {
  }
  onKeyUp(t) {
    t.key === this.keyEvents.cancel ? this.cleanUp() : t.key === this.keyEvents.finish && this.close();
  }
  onDragStart() {
  }
  onDrag() {
  }
  onDragEnd() {
  }
  cleanUp() {
    const t = this.currentCircleId;
    this.center = void 0, this.currentCircleId = void 0, this.clickCount = 0, this.state === "drawing" && this.setStarted();
    try {
      t !== void 0 && this.store.delete([t]);
    } catch {
    }
  }
  styleFeature(t) {
    const n = en({}, { polygonFillColor: "#3f97e0", polygonOutlineColor: "#3f97e0", polygonOutlineWidth: 4, polygonFillOpacity: 0.3, pointColor: "#3f97e0", pointOutlineColor: "#ffffff", pointOutlineWidth: 0, pointWidth: 6, lineStringColor: "#3f97e0", lineStringWidth: 4, zIndex: 0 });
    return t.type === "Feature" && t.geometry.type === "Polygon" && t.properties.mode === this.mode && (n.polygonFillColor = this.getHexColorStylingValue(this.styles.fillColor, n.polygonFillColor, t), n.polygonOutlineColor = this.getHexColorStylingValue(this.styles.outlineColor, n.polygonOutlineColor, t), n.polygonOutlineWidth = this.getNumericStylingValue(this.styles.outlineWidth, n.polygonOutlineWidth, t), n.polygonFillOpacity = this.getNumericStylingValue(this.styles.fillOpacity, n.polygonFillOpacity, t), n.zIndex = Es), n;
  }
  validateFeature(t) {
    return this.validateModeFeature(t, (n) => aT(n, this.coordinatePrecision));
  }
  updateCircle(t) {
    if (this.clickCount === 1 && this.center && this.currentCircleId) {
      const n = Ns(this.center, [t.lng, t.lat]);
      let r;
      if (this.projection === "web-mercator") {
        const i = function(o, a) {
          const s = 1e3 * Ns(o, a);
          if (s === 0)
            return 1;
          const { x: l, y: u } = $t(o[0], o[1]), { x: d, y: f } = $t(a[0], a[1]);
          return Math.sqrt(Math.pow(d - l, 2) + Math.pow(f - u, 2)) / s;
        }(this.center, [t.lng, t.lat]);
        r = function(o) {
          const { center: a, radiusKilometers: s, coordinatePrecision: l } = o, u = o.steps ? o.steps : 64, d = 1e3 * s, [f, p] = a, { x: m, y: g } = $t(f, p), v = [];
          for (let y = 0; y < u; y++) {
            const b = 360 * y / u * Math.PI / 180, E = d * Math.cos(b), S = d * Math.sin(b), [_, k] = [m + E, g + S], { lng: T, lat: A } = Sa(_, k);
            v.push([Bt(T, l), Bt(A, l)]);
          }
          return v.push(v[0]), { type: "Feature", geometry: { type: "Polygon", coordinates: [v] }, properties: {} };
        }({ center: this.center, radiusKilometers: n * i, coordinatePrecision: this.coordinatePrecision });
      } else {
        if (this.projection !== "globe")
          throw new Error("Invalid projection");
        r = eC({ center: this.center, radiusKilometers: n, coordinatePrecision: this.coordinatePrecision });
      }
      if (this.validate && !this.validate({ type: "Feature", id: this.currentCircleId, geometry: r.geometry, properties: { radiusKilometers: n } }, { project: this.project, unproject: this.unproject, coordinatePrecision: this.coordinatePrecision, updateType: hn.Provisional }).valid)
        return;
      this.store.updateGeometry([{ id: this.currentCircleId, geometry: r.geometry }]), this.store.updateProperty([{ id: this.currentCircleId, property: "radiusKilometers", value: n }]);
    }
  }
  afterFeatureUpdated(t) {
    this.currentCircleId === t.id && (this.cursorMovedAfterInitialCursorDown = !1, this.center = void 0, this.currentCircleId = void 0, this.clickCount = 0, this.state === "drawing" && this.setStarted());
  }
}
const fa = (e, t) => {
  const { x: n, y: r } = e, { x: i, y: o } = t, a = i - n, s = o - r;
  return Math.sqrt(s * s + a * a);
};
function sT(e) {
  if (!function(n) {
    const r = n.coordinates[0];
    let i = 0;
    for (let o = 0; o < r.length - 1; o++) {
      const [a, s] = r[o], [l, u] = r[o + 1];
      i += (l - a) * (u + s);
    }
    return i < 0;
  }(e))
    return { type: "Polygon", coordinates: [e.coordinates[0].reverse()] };
}
class ir {
  constructor({ store: t, mode: n, project: r, unproject: i, pointerDistance: o, coordinatePrecision: a, projection: s }) {
    this.store = void 0, this.mode = void 0, this.project = void 0, this.unproject = void 0, this.pointerDistance = void 0, this.coordinatePrecision = void 0, this.projection = void 0, this.store = t, this.mode = n, this.project = r, this.unproject = i, this.pointerDistance = o, this.coordinatePrecision = a, this.projection = s;
  }
}
function lT({ unproject: e, point: t, pointerDistance: n }) {
  const r = n / 2, { x: i, y: o } = t;
  return { type: "Feature", properties: {}, geometry: { type: "Polygon", coordinates: [[e(i - r, o - r), e(i + r, o - r), e(i + r, o + r), e(i - r, o + r), e(i - r, o - r)].map((a) => [a.lng, a.lat])] } };
}
class cT extends ir {
  constructor(t) {
    super(t);
  }
  create(t) {
    const { containerX: n, containerY: r } = t;
    return lT({ unproject: this.unproject, point: { x: n, y: r }, pointerDistance: this.pointerDistance });
  }
}
class uT extends ir {
  constructor(t) {
    super(t);
  }
  measure(t, n) {
    const { x: r, y: i } = this.project(n[0], n[1]);
    return fa({ x: r, y: i }, { x: t.containerX, y: t.containerY });
  }
}
class dT extends ir {
  constructor(t, n, r) {
    super(t), this.config = void 0, this.pixelDistance = void 0, this.clickBoundingBox = void 0, this.getSnappableCoordinateFirstClick = (i) => this.getSnappable(i, (o) => !!(o.properties && o.properties.mode === this.mode)).coordinate, this.getSnappableCoordinate = (i, o) => this.getSnappable(i, (a) => !!(a.properties && a.properties.mode === this.mode && a.id !== o)).coordinate, this.config = t, this.pixelDistance = n, this.clickBoundingBox = r;
  }
  getSnappable(t, n) {
    const r = this.clickBoundingBox.create(t), i = this.store.search(r, n), o = { featureId: void 0, featureCoordinateIndex: void 0, coordinate: void 0, minDist: 1 / 0 };
    return i.forEach((a) => {
      let s;
      if (a.geometry.type === "Polygon")
        s = a.geometry.coordinates[0];
      else {
        if (a.geometry.type !== "LineString")
          return;
        s = a.geometry.coordinates;
      }
      s.forEach((l, u) => {
        const d = this.pixelDistance.measure(t, l);
        d < o.minDist && d < this.pointerDistance && (o.coordinate = l, o.minDist = d, o.featureId = a.id, o.featureCoordinateIndex = u);
      });
    }), o;
  }
}
function Sre({ x: e, y: t }, { x: n, y: r }) {
  const i = n - e, o = r - t;
  if (i === 0 && o === 0)
    return 0;
  let a = Math.atan2(o, i);
  return a *= 180 / Math.PI, a > 180 ? a -= 360 : a < -180 && (a += 360), a;
}
function mg(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}
function nC(e) {
  return Math.sqrt(Math.pow(e[0], 2) + Math.pow(e[1], 2) + Math.pow(e[2], 2));
}
function Qo(e, t) {
  const n = function(r, i) {
    const [o, a, s] = r, [l, u, d] = i;
    return o * l + a * u + s * d;
  }(e, t) / (nC(e) * nC(t));
  return Math.acos(Math.min(Math.max(n, -1), 1));
}
function gg(e) {
  const t = xi(e[1]), n = xi(e[0]);
  return [Math.cos(t) * Math.cos(n), Math.cos(t) * Math.sin(n), Math.sin(t)];
}
function Jo(e) {
  const [t, n, r] = e, i = Ec(Math.asin(r));
  return [Ec(Math.atan2(n, t)), i];
}
function _re(e, t, n) {
  const r = gg(e), i = gg(t), o = gg(n), [a, s, l] = o, [u, d, f] = function(W, L) {
    const [z, B, G] = W, [H, J, q] = L;
    return [B * q - G * J, G * H - z * q, z * J - B * H];
  }(r, i), p = d * l - f * s, m = f * a - u * l, g = u * s - d * a, v = g * d - m * f, y = p * f - g * u, b = m * u - p * d, E = 1 / Math.sqrt(Math.pow(v, 2) + Math.pow(y, 2) + Math.pow(b, 2)), S = [v * E, y * E, b * E], _ = [-1 * v * E, -1 * y * E, -1 * b * E], k = Qo(r, i), T = Qo(r, S), A = Qo(i, S), R = Qo(r, _), F = Qo(i, _);
  let D;
  return D = T < R && T < F || A < R && A < F ? S : _, Qo(r, D) > k || Qo(i, D) > k ? Ns(Jo(D), Jo(r)) <= Ns(Jo(D), Jo(i)) ? [Jo(r), !0, !1] : [Jo(i), !1, !0] : [Jo(D), !1, !1];
}
function Pre(e, t, n) {
  const r = t.x - e.x, i = t.y - e.y, o = Math.max(0, Math.min(1, ((n.x - e.x) * r + (n.y - e.y) * i) / (r * r + i * i)));
  return { x: e.x + o * r, y: e.y + o * i };
}
class fT extends ir {
  constructor(t, n, r) {
    super(t), this.config = void 0, this.pixelDistance = void 0, this.clickBoundingBox = void 0, this.getSnappableCoordinateFirstClick = (i) => {
      const o = this.getSnappable(i, (a) => !!(a.properties && a.properties.mode === this.mode));
      return o.coordinate ? [Bt(o.coordinate[0], this.config.coordinatePrecision), Bt(o.coordinate[1], this.config.coordinatePrecision)] : void 0;
    }, this.getSnappableCoordinate = (i, o) => {
      const a = this.getSnappable(i, (s) => !!(s.properties && s.properties.mode === this.mode && s.id !== o));
      return a.coordinate ? [Bt(a.coordinate[0], this.config.coordinatePrecision), Bt(a.coordinate[1], this.config.coordinatePrecision)] : void 0;
    }, this.config = t, this.pixelDistance = n, this.clickBoundingBox = r;
  }
  getSnappable(t, n) {
    const r = this.clickBoundingBox.create(t), i = this.store.search(r, n), o = { featureId: void 0, featureCoordinateIndex: void 0, coordinate: void 0, minDistance: 1 / 0 };
    return i.forEach((a) => {
      let s;
      if (a.geometry.type === "Polygon")
        s = a.geometry.coordinates[0];
      else {
        if (a.geometry.type !== "LineString")
          return;
        s = a.geometry.coordinates;
      }
      const l = [];
      for (let p = 0; p < s.length - 1; p++)
        l.push([s[p], s[p + 1]]);
      let u;
      const d = [t.lng, t.lat];
      if (this.config.projection === "web-mercator" ? u = function(p, m) {
        let g = [1 / 0, 1 / 0], v = 1 / 0, y = 0;
        for (let b of m) {
          const E = b[0], S = b[1];
          let _, k = 1 / 0;
          const T = $t(E[0], E[1]), A = $t(S[0], S[1]), R = $t(p[0], p[1]);
          if (E[0] === p[0] && E[1] === p[1])
            _ = E;
          else if (S[0] === p[0] && S[1] === p[1])
            _ = S;
          else {
            const { x: F, y: D } = Pre(T, A, R), { lng: W, lat: L } = Sa(F, D);
            _ = [W, L];
          }
          _ && (k = fa(R, $t(_[0], _[1])), k < v && (g = _, v = k, y = m.indexOf(b)));
        }
        return v === 1 / 0 ? void 0 : { coordinate: g, lineIndex: y, distance: v };
      }(d, l) : this.config.projection === "globe" && (u = function(p, m) {
        let g = [1 / 0, 1 / 0], v = 1 / 0, y = 0;
        for (let b of m) {
          const E = b[0], S = b[1];
          let _, k = 1 / 0;
          E[0] === p[0] && E[1] === p[1] ? _ = E : S[0] === p[0] && S[1] === p[1] ? _ = S : [_] = _re(E, S, p), _ && (k = Ns(p, _), k < v && (g = _, v = k, y = m.indexOf(b)));
        }
        return v === 1 / 0 ? void 0 : { coordinate: g, distance: v, lineIndex: y };
      }(d, l)), !u)
        return;
      const f = this.pixelDistance.measure(t, u.coordinate);
      f < o.minDistance && f < this.pointerDistance && (o.featureId = a.id, o.coordinate = [Bt(u.coordinate[0], this.config.coordinatePrecision), Bt(u.coordinate[1], this.config.coordinatePrecision)], o.featureCoordinateIndex = u.lineIndex, o.minDistance = f);
    }), o;
  }
}
class kre extends ir {
  constructor(t, n) {
    super(t), this.config = void 0, this.pixelDistance = void 0, this._startEndPoints = [], this.config = t, this.pixelDistance = n;
  }
  get ids() {
    return this._startEndPoints.concat();
  }
  set ids(t) {
  }
  create(t, n) {
    if (this.ids.length)
      throw new Error("Opening and closing points already created");
    if (t.length <= 3)
      throw new Error("Requires at least 4 coordinates");
    this._startEndPoints = this.store.create([{ geometry: { type: "Point", coordinates: t[0] }, properties: { mode: n, [tt.CLOSING_POINT]: !0 } }, { geometry: { type: "Point", coordinates: t[t.length - 2] }, properties: { mode: n, [tt.CLOSING_POINT]: !0 } }]);
  }
  delete() {
    this.ids.length && (this.store.delete(this.ids), this._startEndPoints = []);
  }
  update(t) {
    if (this.ids.length !== 2)
      throw new Error("No closing points to update");
    this.store.updateGeometry([{ id: this.ids[0], geometry: { type: "Point", coordinates: t[0] } }, { id: this.ids[1], geometry: { type: "Point", coordinates: t[t.length - 3] } }]);
  }
  isClosingPoint(t) {
    const n = this.store.getGeometryCopy(this.ids[0]), r = this.store.getGeometryCopy(this.ids[1]), i = this.pixelDistance.measure(t, n.coordinates), o = this.pixelDistance.measure(t, r.coordinates);
    return { isClosing: i < this.pointerDistance, isPreviousClosing: o < this.pointerDistance };
  }
}
class hT extends ir {
  constructor(t) {
    super(t);
  }
  createOrUpdate(t) {
    const n = this.store.getGeometryCopy(t), r = this.store.getPropertiesCopy(t);
    let i;
    if (n.type === "Polygon")
      i = n.coordinates[0].slice(0, -1);
    else {
      if (n.type !== "LineString")
        return;
      i = n.coordinates;
    }
    const o = this.store.getPropertiesCopy(t), a = o.coordinatePointIds;
    if (a)
      if (a && a.every((s) => this.store.has(s))) {
        const s = o.coordinatePointIds, l = s.map((u) => this.store.getGeometryCopy(u).coordinates);
        if (s.length !== i.length) {
          this.deleteCoordinatePoints(s);
          const u = this.createPoints(i, r.mode, t);
          this.setFeatureCoordinatePoints(t, u);
        } else
          i.forEach((u, d) => {
            u[0] === l[d][0] && u[1] === l[d][1] || this.store.updateGeometry([{ id: s[d], geometry: { type: "Point", coordinates: u } }]);
          });
      } else {
        const s = a.filter((u) => this.store.has(u));
        s.length && this.deleteCoordinatePoints(s);
        const l = this.createPoints(i, r.mode, t);
        this.setFeatureCoordinatePoints(t, l);
      }
    else {
      const s = this.createPoints(i, r.mode, t);
      this.setFeatureCoordinatePoints(t, s);
    }
  }
  deletePointsByFeatureIds(t) {
    for (const n of t)
      this.deleteIfPresent(n);
  }
  getUpdated(t, n) {
    const r = this.store.getPropertiesCopy(t);
    if (r.coordinatePointIds)
      return r.coordinatePointIds.map((i, o) => ({ id: i, geometry: en({}, this.store.getGeometryCopy(i), { coordinates: n[o] }) }));
  }
  createPoints(t, n, r) {
    return this.store.create(t.map((i, o) => ({ geometry: { type: "Point", coordinates: i }, properties: { mode: n, [tt.COORDINATE_POINT]: !0, [tt.COORDINATE_POINT_FEATURE_ID]: r, index: o } })));
  }
  setFeatureCoordinatePoints(t, n) {
    this.store.updateProperty([{ id: t, property: tt.COORDINATE_POINT_IDS, value: n }]);
  }
  deleteCoordinatePoints(t) {
    const n = t.filter((r) => this.store.has(r));
    this.store.delete(n);
  }
  deleteIfPresent(t) {
    const n = this.store.getPropertiesCopy(t).coordinatePointIds;
    n && (this.deleteCoordinatePoints(n), this.setFeatureCoordinatePoints(t, null));
  }
}
const Tre = { cancel: "Escape", finish: "Enter" }, Are = { start: "crosshair", close: "pointer", dragStart: "grabbing", dragEnd: "crosshair" };
class Mre extends Ks {
  constructor(t) {
    super(t, !0), this.mode = "polygon", this.currentCoordinate = 0, this.currentId = void 0, this.keyEvents = Tre, this.cursors = Are, this.mouseMove = !1, this.showCoordinatePoints = !1, this.lastMouseMoveEvent = void 0, this.snapping = void 0, this.snappedPointId = void 0, this.editable = !1, this.editedFeatureId = void 0, this.editedFeatureCoordinateIndex = void 0, this.editedSnapType = void 0, this.editedInsertIndex = void 0, this.editedPointId = void 0, this.coordinatePoints = void 0, this.lineSnapping = void 0, this.coordinateSnapping = void 0, this.pixelDistance = void 0, this.closingPoints = void 0, this.clickBoundingBox = void 0, this.updateOptions(t);
  }
  updateOptions(t) {
    if (super.updateOptions(t), t != null && t.cursors && (this.cursors = en({}, this.cursors, t.cursors)), (t == null ? void 0 : t.keyEvents) === null ? this.keyEvents = { cancel: null, finish: null } : t != null && t.keyEvents && (this.keyEvents = en({}, this.keyEvents, t.keyEvents)), t != null && t.snapping && (this.snapping = t.snapping), (t == null ? void 0 : t.editable) !== void 0 && (this.editable = t.editable), (t == null ? void 0 : t.pointerEvents) !== void 0 && (this.pointerEvents = t.pointerEvents), (t == null ? void 0 : t.showCoordinatePoints) !== void 0) {
      if (this.showCoordinatePoints = t.showCoordinatePoints, this.coordinatePoints && t.showCoordinatePoints === !0)
        this.store.copyAllWhere((n) => n.mode === this.mode).map((n) => n.id).forEach((n) => {
          this.coordinatePoints.createOrUpdate(n);
        });
      else if (this.coordinatePoints && this.showCoordinatePoints === !1) {
        const n = this.store.copyAllWhere((r) => r.mode === this.mode && !!r[tt.COORDINATE_POINT_IDS]);
        this.coordinatePoints.deletePointsByFeatureIds(n.map((r) => r.id));
      }
    }
  }
  close() {
    if (this.currentId === void 0)
      return;
    const t = this.store.getGeometryCopy(this.currentId).coordinates[0];
    if (t.length < 5 || !this.updatePolygonGeometry([...t.slice(0, -2), t[0]], hn.Finish))
      return;
    const n = this.currentId;
    if (this.currentId) {
      const r = sT(this.store.getGeometryCopy(this.currentId));
      r && (this.store.updateGeometry([{ id: this.currentId, geometry: r }]), this.showCoordinatePoints && this.coordinatePoints.createOrUpdate(this.currentId)), this.store.updateProperty([{ id: this.currentId, property: tt.CURRENTLY_DRAWING, value: void 0 }, { id: this.currentId, property: tt.COMMITTED_COORDINATE_COUNT, value: void 0 }, { id: this.currentId, property: tt.PROVISIONAL_COORDINATE_COUNT, value: void 0 }]);
    }
    this.snappedPointId && this.store.delete([this.snappedPointId]), this.currentCoordinate = 0, this.currentId = void 0, this.snappedPointId = void 0, this.closingPoints.delete(), this.state === "drawing" && this.setStarted(), this.onFinish(n, { mode: this.mode, action: "draw" });
  }
  registerBehaviors(t) {
    this.clickBoundingBox = new cT(t), this.pixelDistance = new uT(t), this.lineSnapping = new fT(t, this.pixelDistance, this.clickBoundingBox), this.coordinateSnapping = new dT(t, this.pixelDistance, this.clickBoundingBox), this.closingPoints = new kre(t, this.pixelDistance), this.coordinatePoints = new hT(t);
  }
  start() {
    this.setStarted(), this.setCursor(this.cursors.start);
  }
  stop() {
    this.cleanUp(), this.setStopped(), this.setCursor("unset");
  }
  updateSnappedCoordinate(t) {
    const n = this.snapCoordinate(t);
    if (n) {
      if (this.snappedPointId)
        this.store.updateGeometry([{ id: this.snappedPointId, geometry: { type: "Point", coordinates: n } }]);
      else {
        const [r] = this.store.create([{ geometry: { type: "Point", coordinates: n }, properties: { mode: this.mode, [tt.SNAPPING_POINT]: !0 } }]);
        this.snappedPointId = r;
      }
      t.lng = n[0], t.lat = n[1];
    } else
      this.snappedPointId && (this.store.delete([this.snappedPointId]), this.snappedPointId = void 0);
  }
  onMouseMove(t) {
    if (this.mouseMove = !0, this.setCursor(this.cursors.start), this.lastMouseMoveEvent = t, this.updateSnappedCoordinate(t), this.currentId === void 0 || this.currentCoordinate === 0)
      return;
    const n = this.store.getGeometryCopy(this.currentId).coordinates[0];
    let r;
    if (this.currentCoordinate === 1) {
      const i = 1 / Math.pow(10, this.coordinatePrecision - 1), o = Math.max(1e-6, i);
      r = [n[0], [t.lng, t.lat], [t.lng, t.lat - o], n[0]];
    } else if (this.currentCoordinate === 2)
      r = [n[0], n[1], [t.lng, t.lat], n[0]];
    else {
      const { isClosing: i, isPreviousClosing: o } = this.closingPoints.isClosingPoint(t);
      o || i ? (this.snappedPointId && (this.store.delete([this.snappedPointId]), this.snappedPointId = void 0), this.setCursor(this.cursors.close), r = [...n.slice(0, -2), n[0], n[0]]) : r = [...n.slice(0, -2), [t.lng, t.lat], n[0]];
    }
    this.store.updateProperty([{ id: this.currentId, property: tt.PROVISIONAL_COORDINATE_COUNT, value: this.currentCoordinate + 1 }]), this.updatePolygonGeometry(r, hn.Provisional);
  }
  updatePolygonGeometry(t, n) {
    if (!this.currentId)
      return !1;
    const r = { type: "Polygon", coordinates: [t] };
    return !(this.validate && !this.validate({ type: "Feature", geometry: r }, { project: this.project, unproject: this.unproject, coordinatePrecision: this.coordinatePrecision, updateType: n }).valid || (this.store.updateGeometry([{ id: this.currentId, geometry: r }]), this.showCoordinatePoints && this.coordinatePoints.createOrUpdate(this.currentId), 0));
  }
  snapCoordinate(t) {
    var n, r, i;
    let o;
    if ((n = this.snapping) != null && n.toLine) {
      let a;
      a = this.currentId ? this.lineSnapping.getSnappableCoordinate(t, this.currentId) : this.lineSnapping.getSnappableCoordinateFirstClick(t), a && (o = a);
    }
    if ((r = this.snapping) != null && r.toCoordinate) {
      let a;
      a = this.currentId ? this.coordinateSnapping.getSnappableCoordinate(t, this.currentId) : this.coordinateSnapping.getSnappableCoordinateFirstClick(t), a && (o = a);
    }
    return (i = this.snapping) != null && i.toCustom && (o = this.snapping.toCustom(t, { currentCoordinate: this.currentCoordinate, currentId: this.currentId, getCurrentGeometrySnapshot: this.currentId ? () => this.store.getGeometryCopy(this.currentId) : () => null, project: this.project, unproject: this.unproject })), o;
  }
  polygonFilter(t) {
    return !!(t.geometry.type === "Polygon" && t.properties && t.properties.mode === this.mode);
  }
  onRightClick(t) {
    if (!this.editable || this.state !== "started")
      return;
    const { featureId: n, featureCoordinateIndex: r } = this.coordinateSnapping.getSnappable(t, (a) => this.polygonFilter(a));
    if (!n || r === void 0)
      return;
    const i = this.store.getGeometryCopy(n);
    let o;
    i.type === "Polygon" && (o = i.coordinates[0], o.length <= 4 || (i.type !== "Polygon" || r !== 0 && r !== o.length - 1 ? o.splice(r, 1) : (o.shift(), o.pop(), o.push([o[0][0], o[0][1]])), (!this.validate || this.validate({ id: n, type: "Feature", geometry: i, properties: {} }, { project: this.project, unproject: this.unproject, coordinatePrecision: this.coordinatePrecision, updateType: hn.Commit }).valid) && (this.snappedPointId && (this.store.delete([this.snappedPointId]), this.snappedPointId = void 0), this.store.updateGeometry([{ id: n, geometry: i }]), this.showCoordinatePoints && this.coordinatePoints.createOrUpdate(n), this.onFinish(n, { mode: this.mode, action: "edit" }))));
  }
  onLeftClick(t) {
    if (this.snappedPointId && (this.store.delete([this.snappedPointId]), this.snappedPointId = void 0), this.currentCoordinate === 0) {
      const n = this.snapCoordinate(t);
      n && (t.lng = n[0], t.lat = n[1]);
      const [r] = this.store.create([{ geometry: { type: "Polygon", coordinates: [[[t.lng, t.lat], [t.lng, t.lat], [t.lng, t.lat], [t.lng, t.lat]]] }, properties: { mode: this.mode, [tt.CURRENTLY_DRAWING]: !0, [tt.COMMITTED_COORDINATE_COUNT]: this.currentCoordinate + 1, [tt.PROVISIONAL_COORDINATE_COUNT]: this.currentCoordinate + 1 } }]);
      this.currentId = r, this.currentCoordinate++, this.showCoordinatePoints && this.coordinatePoints.createOrUpdate(r), this.setDrawing();
    } else if (this.currentCoordinate === 1 && this.currentId) {
      const n = this.snapCoordinate(t);
      n && (t.lng = n[0], t.lat = n[1]);
      const r = this.store.getGeometryCopy(this.currentId);
      if (mg([t.lng, t.lat], r.coordinates[0][0]) || !this.updatePolygonGeometry([r.coordinates[0][0], [t.lng, t.lat], [t.lng, t.lat], r.coordinates[0][0]], hn.Commit))
        return;
      this.store.updateProperty([{ id: this.currentId, property: tt.COMMITTED_COORDINATE_COUNT, value: this.currentCoordinate + 1 }]), this.currentCoordinate++;
    } else if (this.currentCoordinate === 2 && this.currentId) {
      const n = this.snapCoordinate(t);
      n && (t.lng = n[0], t.lat = n[1]);
      const r = this.store.getGeometryCopy(this.currentId).coordinates[0];
      if (mg([t.lng, t.lat], r[1]) || !this.updatePolygonGeometry([r[0], r[1], [t.lng, t.lat], [t.lng, t.lat], r[0]], hn.Commit))
        return;
      this.currentCoordinate === 2 && this.closingPoints.create(r, "polygon"), this.store.updateProperty([{ id: this.currentId, property: tt.COMMITTED_COORDINATE_COUNT, value: this.currentCoordinate + 1 }]), this.currentCoordinate++;
    } else if (this.currentId) {
      const n = this.store.getGeometryCopy(this.currentId).coordinates[0], { isClosing: r, isPreviousClosing: i } = this.closingPoints.isClosingPoint(t);
      if (i || r)
        this.close();
      else {
        const o = this.snapCoordinate(t);
        if (o && (t.lng = o[0], t.lat = o[1]), mg([t.lng, t.lat], n[this.currentCoordinate - 1]))
          return;
        const a = function(s = [[[0, 0], [0, 1], [1, 1], [1, 0], [0, 0]]]) {
          return { type: "Feature", geometry: { type: "Polygon", coordinates: s }, properties: {} };
        }([[...n.slice(0, -1), [t.lng, t.lat], n[0]]]);
        if (!this.updatePolygonGeometry(a.geometry.coordinates[0], hn.Commit))
          return;
        this.store.updateProperty([{ id: this.currentId, property: tt.COMMITTED_COORDINATE_COUNT, value: this.currentCoordinate + 1 }]), this.currentCoordinate++, this.closingPoints.ids.length && this.closingPoints.update(a.geometry.coordinates[0]);
      }
    }
  }
  onClick(t) {
    this.currentCoordinate > 0 && !this.mouseMove && this.onMouseMove(t), this.mouseMove = !1, t.button === "right" && this.allowPointerEvent(this.pointerEvents.rightClick, t) || t.isContextMenu && this.allowPointerEvent(this.pointerEvents.contextMenu, t) ? this.onRightClick(t) : t.button === "left" && this.allowPointerEvent(this.pointerEvents.leftClick, t) && this.onLeftClick(t);
  }
  onKeyUp(t) {
    t.key === this.keyEvents.cancel ? this.cleanUp() : t.key === this.keyEvents.finish && this.close();
  }
  onKeyDown() {
  }
  onDragStart(t, n) {
    if (!this.allowPointerEvent(this.pointerEvents.onDragStart, t) || !this.editable)
      return;
    let r;
    if (this.state === "started") {
      const i = this.lineSnapping.getSnappable(t, (a) => this.polygonFilter(a));
      i.coordinate && (this.editedSnapType = "line", this.editedFeatureCoordinateIndex = i.featureCoordinateIndex, this.editedFeatureId = i.featureId, r = i.coordinate);
      const o = this.coordinateSnapping.getSnappable(t, (a) => this.polygonFilter(a));
      o.coordinate && (this.editedSnapType = "coordinate", this.editedFeatureCoordinateIndex = o.featureCoordinateIndex, this.editedFeatureId = o.featureId, r = o.coordinate);
    }
    if (this.editedFeatureId && r) {
      if (!this.editedPointId) {
        const [i] = this.store.create([{ geometry: { type: "Point", coordinates: r }, properties: { mode: this.mode, [tt.EDITED]: !0 } }]);
        this.editedPointId = i;
      }
      this.setCursor(this.cursors.dragStart), n(!1);
    }
  }
  onDrag(t, n) {
    if (!this.allowPointerEvent(this.pointerEvents.onDrag, t) || this.editedFeatureId === void 0 || this.editedFeatureCoordinateIndex === void 0)
      return;
    const r = this.store.getGeometryCopy(this.editedFeatureId), i = r.coordinates[0];
    this.editedSnapType === "coordinate" || this.editedSnapType === "line" && this.editedInsertIndex !== void 0 ? this.editedFeatureCoordinateIndex === 0 || this.editedFeatureCoordinateIndex === r.coordinates[0].length - 1 ? (i[0] = [t.lng, t.lat], i[i.length - 1] = [t.lng, t.lat]) : i[this.editedFeatureCoordinateIndex] = [t.lng, t.lat] : this.editedSnapType === "line" && this.editedInsertIndex === void 0 && (this.editedInsertIndex = this.editedFeatureCoordinateIndex + 1, r.coordinates[0].splice(this.editedInsertIndex, 0, [t.lng, t.lat]), this.editedFeatureCoordinateIndex++);
    const o = { type: "Polygon", coordinates: r.coordinates };
    this.validate && !this.validate({ type: "Feature", geometry: o, properties: this.store.getPropertiesCopy(this.editedFeatureId) }, { project: this.project, unproject: this.unproject, coordinatePrecision: this.coordinatePrecision, updateType: hn.Provisional }).valid || (this.snapping && this.snappedPointId && (this.store.delete([this.snappedPointId]), this.snappedPointId = void 0), this.store.updateGeometry([{ id: this.editedFeatureId, geometry: o }]), this.showCoordinatePoints && this.coordinatePoints.createOrUpdate(this.editedFeatureId), this.editedPointId && this.store.updateGeometry([{ id: this.editedPointId, geometry: { type: "Point", coordinates: [t.lng, t.lat] } }]), this.store.updateProperty([{ id: this.editedFeatureId, property: tt.EDITED, value: !0 }]));
  }
  onDragEnd(t, n) {
    this.allowPointerEvent(this.pointerEvents.onDragEnd, t) && this.editedFeatureId !== void 0 && (this.setCursor(this.cursors.dragEnd), this.editedPointId && (this.store.delete([this.editedPointId]), this.editedPointId = void 0), this.store.updateProperty([{ id: this.editedFeatureId, property: tt.EDITED, value: !1 }]), this.onFinish(this.editedFeatureId, { mode: this.mode, action: "edit" }), this.editedFeatureId = void 0, this.editedFeatureCoordinateIndex = void 0, this.editedInsertIndex = void 0, this.editedSnapType = void 0, n(!0));
  }
  cleanUp() {
    const t = this.currentId, n = this.snappedPointId, r = this.editedPointId;
    this.currentId = void 0, this.snappedPointId = void 0, this.editedPointId = void 0, this.editedFeatureId = void 0, this.editedFeatureCoordinateIndex = void 0, this.editedInsertIndex = void 0, this.editedSnapType = void 0, this.currentCoordinate = 0, this.state === "drawing" && this.setStarted();
    try {
      t && this.coordinatePoints.deletePointsByFeatureIds([t]), t !== void 0 && this.store.delete([t]), r !== void 0 && this.store.delete([r]), n !== void 0 && this.store.delete([n]), this.closingPoints.ids.length && this.closingPoints.delete();
    } catch {
    }
  }
  styleFeature(t) {
    const n = en({}, { polygonFillColor: "#3f97e0", polygonOutlineColor: "#3f97e0", polygonOutlineWidth: 4, polygonFillOpacity: 0.3, pointColor: "#3f97e0", pointOutlineColor: "#ffffff", pointOutlineWidth: 0, pointWidth: 6, lineStringColor: "#3f97e0", lineStringWidth: 4, zIndex: 0 });
    if (t.properties.mode === this.mode) {
      if (t.geometry.type === "Polygon")
        return n.polygonFillColor = this.getHexColorStylingValue(this.styles.fillColor, n.polygonFillColor, t), n.polygonOutlineColor = this.getHexColorStylingValue(this.styles.outlineColor, n.polygonOutlineColor, t), n.polygonOutlineWidth = this.getNumericStylingValue(this.styles.outlineWidth, n.polygonOutlineWidth, t), n.polygonFillOpacity = this.getNumericStylingValue(this.styles.fillOpacity, n.polygonFillOpacity, t), n.zIndex = Es, n;
      if (t.geometry.type === "Point") {
        const r = t.properties[tt.EDITED], i = t.properties[tt.COORDINATE_POINT], o = r ? "editedPoint" : t.properties[tt.CLOSING_POINT] ? "closingPoint" : t.properties[tt.SNAPPING_POINT] ? "snappingPoint" : i ? "coordinatePoint" : void 0;
        if (!o)
          return n;
        const a = { editedPoint: { width: this.styles.editedPointOutlineWidth, color: this.styles.editedPointColor, outlineColor: this.styles.editedPointOutlineColor, outlineWidth: this.styles.editedPointOutlineWidth }, closingPoint: { width: this.styles.closingPointWidth, color: this.styles.closingPointColor, outlineColor: this.styles.closingPointOutlineColor, outlineWidth: this.styles.closingPointOutlineWidth }, snappingPoint: { width: this.styles.snappingPointWidth, color: this.styles.snappingPointColor, outlineColor: this.styles.snappingPointOutlineColor, outlineWidth: this.styles.snappingPointOutlineWidth }, coordinatePoint: { width: this.styles.coordinatePointWidth, color: this.styles.coordinatePointColor, outlineColor: this.styles.coordinatePointOutlineColor, outlineWidth: this.styles.coordinatePointOutlineWidth } };
        return n.pointWidth = this.getNumericStylingValue(a[o].width, n.pointWidth, t), n.pointColor = this.getHexColorStylingValue(a[o].color, n.pointColor, t), n.pointOutlineColor = this.getHexColorStylingValue(a[o].outlineColor, n.pointOutlineColor, t), n.pointOutlineWidth = this.getNumericStylingValue(a[o].outlineWidth, 2, t), n.zIndex = r ? 40 : i ? 20 : 30, n;
      }
    }
    return n;
  }
  afterFeatureAdded(t) {
    this.showCoordinatePoints && this.coordinatePoints.createOrUpdate(t.id);
  }
  afterFeatureUpdated(t) {
    this.showCoordinatePoints && this.coordinatePoints.createOrUpdate(t.id), this.editedFeatureId === t.id && this.editedPointId && (this.store.delete([this.editedPointId]), this.editedPointId = void 0, this.editedFeatureId = void 0, this.editedFeatureCoordinateIndex = void 0, this.editedSnapType = void 0), this.snappedPointId && this.lastMouseMoveEvent && this.updateSnappedCoordinate(this.lastMouseMoveEvent), this.currentId === t.id && (this.currentCoordinate = 0, this.currentId = void 0, this.closingPoints.delete(), this.state === "drawing" && this.setStarted());
  }
  validateFeature(t) {
    return this.validateModeFeature(t, (n) => oT(n, this.coordinatePrecision));
  }
}
const Ore = { cancel: "Escape", finish: "Enter" }, Rre = { start: "crosshair" };
class Ire extends Ks {
  constructor(t) {
    super(t, !0), this.mode = "rectangle", this.center = void 0, this.clickCount = 0, this.currentRectangleId = void 0, this.keyEvents = Ore, this.cursors = Rre, this.updateOptions(t);
  }
  updateOptions(t) {
    super.updateOptions(t), t != null && t.cursors && (this.cursors = en({}, this.cursors, t.cursors)), (t == null ? void 0 : t.keyEvents) === null ? this.keyEvents = { cancel: null, finish: null } : t != null && t.keyEvents && (this.keyEvents = en({}, this.keyEvents, t.keyEvents));
  }
  updateRectangle(t, n) {
    if (this.clickCount === 1 && this.center && this.currentRectangleId) {
      const r = this.store.getGeometryCopy(this.currentRectangleId).coordinates[0][0], i = { type: "Polygon", coordinates: [[r, [t.lng, r[1]], [t.lng, t.lat], [r[0], t.lat], r]] };
      if (this.validate && !this.validate({ id: this.currentRectangleId, geometry: i }, { project: this.project, unproject: this.unproject, coordinatePrecision: this.coordinatePrecision, updateType: n }).valid)
        return;
      this.store.updateGeometry([{ id: this.currentRectangleId, geometry: i }]);
    }
  }
  close() {
    const t = this.currentRectangleId;
    if (t) {
      const n = sT(this.store.getGeometryCopy(t));
      n && this.store.updateGeometry([{ id: t, geometry: n }]), this.store.updateProperty([{ id: t, property: tt.CURRENTLY_DRAWING, value: void 0 }]);
    }
    this.center = void 0, this.currentRectangleId = void 0, this.clickCount = 0, this.state === "drawing" && this.setStarted(), t !== void 0 && this.onFinish(t, { mode: this.mode, action: "draw" });
  }
  start() {
    this.setStarted(), this.setCursor(this.cursors.start);
  }
  stop() {
    this.cleanUp(), this.setStopped(), this.setCursor("unset");
  }
  onClick(t) {
    if (t.button === "right" && this.allowPointerEvent(this.pointerEvents.rightClick, t) || t.button === "left" && this.allowPointerEvent(this.pointerEvents.leftClick, t) || t.isContextMenu && this.allowPointerEvent(this.pointerEvents.contextMenu, t))
      if (this.clickCount === 0) {
        this.center = [t.lng, t.lat];
        const [n] = this.store.create([{ geometry: { type: "Polygon", coordinates: [[[t.lng, t.lat], [t.lng, t.lat], [t.lng, t.lat], [t.lng, t.lat]]] }, properties: { mode: this.mode, [tt.CURRENTLY_DRAWING]: !0 } }]);
        this.currentRectangleId = n, this.clickCount++, this.setDrawing();
      } else
        this.updateRectangle(t, hn.Finish), this.close();
  }
  onMouseMove(t) {
    this.updateRectangle(t, hn.Provisional);
  }
  onKeyDown() {
  }
  onKeyUp(t) {
    t.key === this.keyEvents.cancel ? this.cleanUp() : t.key === this.keyEvents.finish && this.close();
  }
  onDragStart() {
  }
  onDrag() {
  }
  onDragEnd() {
  }
  cleanUp() {
    const t = this.currentRectangleId;
    this.center = void 0, this.currentRectangleId = void 0, this.clickCount = 0, this.state === "drawing" && this.setStarted(), t !== void 0 && this.store.delete([t]);
  }
  styleFeature(t) {
    const n = en({}, { polygonFillColor: "#3f97e0", polygonOutlineColor: "#3f97e0", polygonOutlineWidth: 4, polygonFillOpacity: 0.3, pointColor: "#3f97e0", pointOutlineColor: "#ffffff", pointOutlineWidth: 0, pointWidth: 6, lineStringColor: "#3f97e0", lineStringWidth: 4, zIndex: 0 });
    return t.type === "Feature" && t.geometry.type === "Polygon" && t.properties.mode === this.mode && (n.polygonFillColor = this.getHexColorStylingValue(this.styles.fillColor, n.polygonFillColor, t), n.polygonOutlineColor = this.getHexColorStylingValue(this.styles.outlineColor, n.polygonOutlineColor, t), n.polygonOutlineWidth = this.getNumericStylingValue(this.styles.outlineWidth, n.polygonOutlineWidth, t), n.polygonFillOpacity = this.getNumericStylingValue(this.styles.fillOpacity, n.polygonFillOpacity, t), n.zIndex = Es), n;
  }
  validateFeature(t) {
    return this.validateModeFeature(t, (n) => aT(n, this.coordinatePrecision));
  }
  afterFeatureUpdated(t) {
    this.currentRectangleId === t.id && (this.center = void 0, this.currentRectangleId = void 0, this.clickCount = 0, this.state === "drawing" && this.setStarted());
  }
}
function x0(e, t) {
  const n = e, r = t, i = xi(n[1]), o = xi(r[1]);
  let a = xi(r[0] - n[0]);
  a > Math.PI && (a -= 2 * Math.PI), a < -Math.PI && (a += 2 * Math.PI);
  const s = Math.log(Math.tan(o / 2 + Math.PI / 4) / Math.tan(i / 2 + Math.PI / 4)), l = (Ec(Math.atan2(a, s)) + 360) % 360;
  return l > 180 ? -(360 - l) : l;
}
function pT(e, t, n) {
  let r = t;
  t < 0 && (r = -Math.abs(r));
  const i = r / nT, o = e[0] * Math.PI / 180, a = xi(e[1]), s = xi(n), l = i * Math.cos(s);
  let u = a + l;
  Math.abs(u) > Math.PI / 2 && (u = u > 0 ? Math.PI - u : -Math.PI - u);
  const d = Math.log(Math.tan(u / 2 + Math.PI / 4) / Math.tan(a / 2 + Math.PI / 4)), f = Math.abs(d) > 1e-11 ? l / d : Math.cos(a), p = [(180 * (o + i * Math.sin(s) / f) / Math.PI + 540) % 360 - 180, 180 * u / Math.PI];
  return p[0] += p[0] - e[0] > 180 ? -360 : e[0] - p[0] > 180 ? 360 : 0, p;
}
function Dre(e, t, n, r, i) {
  const o = r(e[0], e[1]), a = r(t[0], t[1]), { lng: s, lat: l } = i((o.x + a.x) / 2, (o.y + a.y) / 2);
  return [Bt(s, n), Bt(l, n)];
}
function Nre(e, t, n) {
  const r = pT(e, 1e3 * Ns(e, t) / 2, x0(e, t));
  return [Bt(r[0], n), Bt(r[1], n)];
}
function rC({ featureCoords: e, precision: t, unproject: n, project: r, projection: i }) {
  const o = [];
  for (let a = 0; a < e.length - 1; a++) {
    let s;
    if (i === "web-mercator")
      s = Dre(e[a], e[a + 1], t, r, n);
    else {
      if (i !== "globe")
        throw new Error("Invalid projection");
      s = Nre(e[a], e[a + 1], t);
    }
    o.push(s);
  }
  return o;
}
class $re extends ir {
  constructor(t, n, r) {
    super(t), this.config = void 0, this.selectionPointBehavior = void 0, this.coordinatePointBehavior = void 0, this._midPoints = [], this.config = t, this.selectionPointBehavior = n, this.coordinatePointBehavior = r;
  }
  get ids() {
    return this._midPoints.concat();
  }
  set ids(t) {
  }
  insert(t, n, r) {
    const i = this.store.getGeometryCopy(n), { midPointFeatureId: o, midPointSegment: a } = this.store.getPropertiesCopy(n), s = this.store.getGeometryCopy(o), l = s.type === "Polygon" ? s.coordinates[0] : s.coordinates;
    l.splice(a + 1, 0, i.coordinates), s.coordinates = s.type === "Polygon" ? [l] : l, this.store.updateGeometry([{ id: o, geometry: s }]), this.store.getPropertiesCopy(t)[tt.COORDINATE_POINT_IDS] && this.coordinatePointBehavior.createOrUpdate(t), this.store.delete([...this._midPoints, ...this.selectionPointBehavior.ids]), this.create(l, o, r), this.selectionPointBehavior.create(l, s.type, o);
  }
  create(t, n, r) {
    if (!this.store.has(n))
      throw new Error("Store does not have feature with this id");
    this._midPoints = this.store.create(function(i, o, a, s, l, u) {
      return rC({ featureCoords: i, precision: a, project: s, unproject: l, projection: u }).map((d, f) => ({ geometry: { type: "Point", coordinates: d }, properties: o(f) }));
    }(t, (i) => ({ mode: this.mode, [fn.MID_POINT]: !0, midPointSegment: i, midPointFeatureId: n }), r, this.config.project, this.config.unproject, this.projection));
  }
  delete() {
    this._midPoints.length && (this.store.delete(this._midPoints), this._midPoints = []);
  }
  getUpdated(t) {
    if (this._midPoints.length !== 0)
      return rC({ featureCoords: t, precision: this.coordinatePrecision, project: this.config.project, unproject: this.config.unproject, projection: this.config.projection }).map((n, r) => ({ id: this._midPoints[r], geometry: { type: "Point", coordinates: n } }));
  }
}
class Lre extends ir {
  constructor(t) {
    super(t), this._selectionPoints = [];
  }
  get ids() {
    return this._selectionPoints.concat();
  }
  set ids(t) {
  }
  create(t, n, r) {
    this._selectionPoints = this.store.create(function(i, o, a) {
      const s = [], l = o === "Polygon" ? i.length - 1 : i.length;
      for (let u = 0; u < l; u++)
        s.push({ geometry: { type: "Point", coordinates: i[u] }, properties: a(u) });
      return s;
    }(t, n, (i) => ({ mode: this.mode, index: i, [fn.SELECTION_POINT]: !0, [fn.SELECTION_POINT_FEATURE_ID]: r })));
  }
  delete() {
    this.ids.length && (this.store.delete(this.ids), this._selectionPoints = []);
  }
  getUpdated(t) {
    if (this._selectionPoints.length !== 0)
      return this._selectionPoints.map((n, r) => ({ id: n, geometry: { type: "Point", coordinates: t[r] } }));
  }
  getOneUpdated(t, n) {
    if (this._selectionPoints[t] !== void 0)
      return { id: this._selectionPoints[t], geometry: { type: "Point", coordinates: n } };
  }
}
function mT(e, t) {
  let n = !1;
  for (let a = 0, s = t.length; a < s; a++) {
    const l = t[a];
    for (let u = 0, d = l.length, f = d - 1; u < d; f = u++)
      (i = l[u])[1] > (r = e)[1] != (o = l[f])[1] > r[1] && r[0] < (o[0] - i[0]) * (r[1] - i[1]) / (o[1] - i[1]) + i[0] && (n = !n);
  }
  var r, i, o;
  return n;
}
const E0 = (e, t, n) => {
  const r = (o) => o * o, i = (o, a) => r(o.x - a.x) + r(o.y - a.y);
  return Math.sqrt(((o, a, s) => {
    const l = i(a, s);
    if (l === 0)
      return i(o, a);
    let u = ((o.x - a.x) * (s.x - a.x) + (o.y - a.y) * (s.y - a.y)) / l;
    return u = Math.max(0, Math.min(1, u)), i(o, { x: a.x + u * (s.x - a.x), y: a.y + u * (s.y - a.y) });
  })(e, t, n));
};
class Fre extends ir {
  constructor(t, n, r) {
    super(t), this.config = void 0, this.createClickBoundingBox = void 0, this.pixelDistance = void 0, this.config = t, this.createClickBoundingBox = n, this.pixelDistance = r;
  }
  find(t, n) {
    let r, i, o, a, s = 1 / 0, l = 1 / 0, u = 1 / 0;
    const d = this.createClickBoundingBox.create(t), f = this.store.search(d);
    for (let p = 0; p < f.length; p++) {
      const m = f[p], g = m.geometry;
      if (g.type === "Point") {
        if (m.properties.selectionPoint || m.properties.coordinatePoint || !n && m.properties[fn.MID_POINT])
          continue;
        const v = this.pixelDistance.measure(t, g.coordinates);
        m.properties[fn.MID_POINT] && v < this.pointerDistance && v < u ? (u = v, o = m) : !m.properties[fn.MID_POINT] && v < this.pointerDistance && v < s && (s = v, r = m);
      } else if (g.type === "LineString") {
        if (r)
          continue;
        for (let v = 0; v < g.coordinates.length - 1; v++) {
          const y = g.coordinates[v], b = g.coordinates[v + 1], E = E0({ x: t.containerX, y: t.containerY }, this.project(y[0], y[1]), this.project(b[0], b[1]));
          E < this.pointerDistance && E < l && (l = E, i = m);
        }
      } else if (g.type === "Polygon") {
        if (r || i)
          continue;
        mT([t.lng, t.lat], g.coordinates) && (a = m);
      }
    }
    return { clickedFeature: r || i || a, clickedMidPoint: o };
  }
}
class zre extends ir {
  constructor(t, n, r, i, o) {
    super(t), this.config = void 0, this.featuresAtCursorEvent = void 0, this.selectionPoints = void 0, this.midPoints = void 0, this.coordinatePoints = void 0, this.draggedFeatureId = null, this.dragPosition = void 0, this.config = t, this.featuresAtCursorEvent = n, this.selectionPoints = r, this.midPoints = i, this.coordinatePoints = o;
  }
  startDragging(t, n) {
    this.draggedFeatureId = n, this.dragPosition = [t.lng, t.lat];
  }
  stopDragging() {
    this.draggedFeatureId = null, this.dragPosition = void 0;
  }
  isDragging() {
    return this.draggedFeatureId !== null;
  }
  canDrag(t, n) {
    const { clickedFeature: r } = this.featuresAtCursorEvent.find(t, !0);
    return !(!r || r.id !== n);
  }
  drag(t, n) {
    if (!this.draggedFeatureId)
      return;
    const r = this.store.getGeometryCopy(this.draggedFeatureId), i = [t.lng, t.lat];
    if (r.type === "Polygon" || r.type === "LineString") {
      let o, a;
      if (r.type === "Polygon" ? (o = r.coordinates[0], a = o.length - 1) : (o = r.coordinates, a = o.length), !this.dragPosition)
        return !1;
      for (let d = 0; d < a; d++) {
        const f = o[d];
        let p, m;
        if (this.config.projection === "web-mercator") {
          const g = $t(this.dragPosition[0], this.dragPosition[1]), v = $t(i[0], i[1]), y = $t(f[0], f[1]), b = { x: g.x - v.x, y: g.y - v.y }, E = y.x - b.x, S = y.y - b.y, { lng: _, lat: k } = Sa(E, S);
          p = _, m = k;
        } else {
          const g = [this.dragPosition[0] - i[0], this.dragPosition[1] - i[1]];
          p = f[0] - g[0], m = f[1] - g[1];
        }
        if (p = Bt(p, this.config.coordinatePrecision), m = Bt(m, this.config.coordinatePrecision), p > 180 || p < -180 || m > 90 || m < -90)
          return !1;
        o[d] = [p, m];
      }
      r.type === "Polygon" && (o[o.length - 1] = [o[0][0], o[0][1]]);
      const s = this.selectionPoints.getUpdated(o) || [], l = this.midPoints.getUpdated(o) || [], u = this.coordinatePoints.getUpdated(this.draggedFeatureId, o) || [];
      if (n && !n({ type: "Feature", id: this.draggedFeatureId, geometry: r, properties: {} }, { project: this.config.project, unproject: this.config.unproject, coordinatePrecision: this.config.coordinatePrecision, updateType: hn.Provisional }).valid)
        return !1;
      this.store.updateGeometry([{ id: this.draggedFeatureId, geometry: r }, ...s, ...l, ...u]), this.dragPosition = [t.lng, t.lat];
    } else
      r.type === "Point" && (this.store.updateGeometry([{ id: this.draggedFeatureId, geometry: { type: "Point", coordinates: i } }]), this.dragPosition = [t.lng, t.lat]);
  }
}
class Vre extends ir {
  constructor(t, n, r, i, o, a, s) {
    super(t), this.config = void 0, this.pixelDistance = void 0, this.selectionPoints = void 0, this.midPoints = void 0, this.coordinatePoints = void 0, this.coordinateSnapping = void 0, this.lineSnapping = void 0, this.draggedCoordinate = { id: null, index: -1 }, this.config = t, this.pixelDistance = n, this.selectionPoints = r, this.midPoints = i, this.coordinatePoints = o, this.coordinateSnapping = a, this.lineSnapping = s;
  }
  getClosestCoordinate(t, n) {
    const r = { dist: 1 / 0, index: -1, isFirstOrLastPolygonCoord: !1 };
    let i;
    if (n.type === "LineString")
      i = n.coordinates;
    else {
      if (n.type !== "Polygon")
        return r;
      i = n.coordinates[0];
    }
    for (let o = 0; o < i.length; o++) {
      const a = this.pixelDistance.measure(t, i[o]);
      if (a < this.pointerDistance && a < r.dist) {
        const s = n.type === "Polygon" && (o === i.length - 1 || o === 0);
        r.dist = a, r.index = s ? 0 : o, r.isFirstOrLastPolygonCoord = s;
      }
    }
    return r;
  }
  getDraggableIndex(t, n) {
    const r = this.store.getGeometryCopy(n), i = this.getClosestCoordinate(t, r);
    return i.index === -1 ? -1 : i.index;
  }
  snapCoordinate(t, n, r) {
    let i = [t.lng, t.lat];
    const o = (a) => !!(a.properties && a.properties.mode === r.properties.mode && a.id !== this.draggedCoordinate.id);
    if (n != null && n.toLine) {
      let a;
      a = this.lineSnapping.getSnappable(t, o).coordinate, a && (i = a);
    }
    if (n.toCoordinate) {
      let a;
      a = this.coordinateSnapping.getSnappable(t, o).coordinate, a && (i = a);
    }
    if (n != null && n.toCustom) {
      let a;
      a = n.toCustom(t, { currentCoordinate: this.draggedCoordinate.index, currentId: r.id, getCurrentGeometrySnapshot: r.id ? () => this.store.getGeometryCopy(r.id) : () => null, project: this.project, unproject: this.unproject }), a && (i = a);
    }
    return i;
  }
  drag(t, n, r, i) {
    const o = this.draggedCoordinate.id;
    if (o === null)
      return !1;
    const a = this.draggedCoordinate.index, s = this.store.getGeometryCopy(o), l = this.store.getPropertiesCopy(o), u = s.type === "LineString" ? s.coordinates : s.coordinates[0], d = s.type === "Polygon" && (a === u.length - 1 || a === 0), f = { type: "Feature", id: o, geometry: s, properties: l }, p = this.snapCoordinate(t, i, f);
    if (t.lng > 180 || t.lng < -180 || t.lat > 90 || t.lat < -90)
      return !1;
    if (d) {
      const b = u.length - 1;
      u[0] = p, u[b] = p;
    } else
      u[a] = p;
    const m = this.selectionPoints.getOneUpdated(a, p), g = m ? [m] : [], v = this.midPoints.getUpdated(u) || [], y = this.coordinatePoints.getUpdated(o, u) || [];
    return !(s.type !== "Point" && !n && rT({ type: "Feature", geometry: s, properties: {} }) || r && !r(f, { project: this.config.project, unproject: this.config.unproject, coordinatePrecision: this.config.coordinatePrecision, updateType: hn.Provisional }).valid || (this.store.updateGeometry([{ id: o, geometry: s }, ...g, ...v, ...y]), 0));
  }
  isDragging() {
    return this.draggedCoordinate.id !== null;
  }
  startDragging(t, n) {
    this.draggedCoordinate = { id: t, index: n };
  }
  stopDragging() {
    this.draggedCoordinate = { id: null, index: -1 };
  }
}
function iC(e) {
  let t = 0, n = 0, r = 0;
  return (e.geometry.type === "Polygon" ? e.geometry.coordinates[0].slice(0, -1) : e.geometry.coordinates).forEach((i) => {
    t += i[0], n += i[1], r++;
  }, !0), [t / r, n / r];
}
const gT = (e, t) => {
  if (t === 0 || t === 360 || t === -360)
    return e;
  const n = 0.017453292519943295 * t, r = (e.geometry.type === "Polygon" ? e.geometry.coordinates[0] : e.geometry.coordinates).map(([a, s]) => $t(a, s)), i = r.reduce((a, s) => ({ x: a.x + s.x, y: a.y + s.y }), { x: 0, y: 0 });
  i.x /= r.length, i.y /= r.length;
  const o = r.map((a) => ({ x: i.x + (a.x - i.x) * Math.cos(n) - (a.y - i.y) * Math.sin(n), y: i.y + (a.x - i.x) * Math.sin(n) + (a.y - i.y) * Math.cos(n) })).map(({ x: a, y: s }) => [Sa(a, s).lng, Sa(a, s).lat]);
  return e.geometry.type === "Polygon" ? e.geometry.coordinates[0] = o : e.geometry.coordinates = o, e;
};
function C0(e) {
  const t = (e.geometry.type === "Polygon" ? e.geometry.coordinates[0] : e.geometry.coordinates).map((n) => {
    const { x: r, y: i } = $t(n[0], n[1]);
    return [r, i];
  });
  return e.geometry.type === "Polygon" ? function(n) {
    let r = 0, i = 0, o = 0;
    const a = n.length;
    for (let s = 0; s < a - 1; s++) {
      const [l, u] = n[s], [d, f] = n[s + 1], p = l * f - d * u;
      r += p, i += (l + d) * p, o += (u + f) * p;
    }
    return r /= 2, i /= 6 * r, o /= 6 * r, { x: i, y: o };
  }(t) : function(n) {
    const r = n.length;
    let i = 0, o = 0;
    for (let a = 0; a < r; a++) {
      const [s, l] = n[a];
      i += s, o += l;
    }
    return { x: i / r, y: o / r };
  }(t);
}
class Bre extends ir {
  constructor(t, n, r, i) {
    super(t), this.config = void 0, this.selectionPoints = void 0, this.midPoints = void 0, this.coordinatePoints = void 0, this.lastBearing = void 0, this.selectedGeometry = void 0, this.selectedGeometryCentroid = void 0, this.selectedGeometryWebMercatorCentroid = void 0, this.config = t, this.selectionPoints = n, this.midPoints = r, this.coordinatePoints = i;
  }
  reset() {
    this.lastBearing = void 0, this.selectedGeometry = void 0, this.selectedGeometryWebMercatorCentroid = void 0, this.selectedGeometryCentroid = void 0;
  }
  rotate(t, n, r) {
    this.selectedGeometry || (this.selectedGeometry = this.store.getGeometryCopy(n));
    const i = this.selectedGeometry;
    if (i.type !== "Polygon" && i.type !== "LineString")
      return;
    const o = [t.lng, t.lat];
    let a;
    const s = { type: "Feature", geometry: i, properties: {} };
    if (this.config.projection === "web-mercator") {
      this.selectedGeometryWebMercatorCentroid || (this.selectedGeometryWebMercatorCentroid = C0(s));
      const p = $t(t.lng, t.lat);
      if (a = Sre(this.selectedGeometryWebMercatorCentroid, p), a === 0)
        return;
      if (!this.lastBearing)
        return void (this.lastBearing = a);
      gT(s, -(this.lastBearing - a));
    } else {
      if (this.config.projection !== "globe")
        throw new Error("Unsupported projection");
      if (this.selectedGeometryCentroid || (this.selectedGeometryCentroid = iC({ type: "Feature", geometry: i, properties: {} })), a = x0(this.selectedGeometryCentroid, o), !this.lastBearing)
        return void (this.lastBearing = a + 180);
      (function(p, m) {
        if (m === 0 || m === 360 || m === -360)
          return p;
        const g = iC(p);
        (p.geometry.type === "Polygon" ? p.geometry.coordinates[0] : p.geometry.coordinates).forEach((v) => {
          const y = x0(g, v) + m, b = function(S, _) {
            S[0] += S[0] - _[0] > 180 ? -360 : _[0] - S[0] > 180 ? 360 : 0;
            const k = nT, T = _[1] * Math.PI / 180, A = S[1] * Math.PI / 180, R = A - T;
            let F = Math.abs(S[0] - _[0]) * Math.PI / 180;
            F > Math.PI && (F -= 2 * Math.PI);
            const D = Math.log(Math.tan(A / 2 + Math.PI / 4) / Math.tan(T / 2 + Math.PI / 4)), W = Math.abs(D) > 1e-11 ? R / D : Math.cos(T);
            return Math.sqrt(R * R + W * W * F * F) * k;
          }(g, v), E = pT(g, b, y);
          v[0] = E[0], v[1] = E[1];
        });
      })(s, -(this.lastBearing - (a + 180)));
    }
    const l = i.type === "Polygon" ? i.coordinates[0] : i.coordinates;
    l.forEach((p) => {
      p[0] = Bt(p[0], this.coordinatePrecision), p[1] = Bt(p[1], this.coordinatePrecision);
    });
    const u = this.midPoints.getUpdated(l) || [], d = this.selectionPoints.getUpdated(l) || [], f = this.coordinatePoints.getUpdated(n, l) || [];
    if (r && !r({ id: n, type: "Feature", geometry: i, properties: {} }, { project: this.config.project, unproject: this.config.unproject, coordinatePrecision: this.config.coordinatePrecision, updateType: hn.Provisional }))
      return !1;
    this.store.updateGeometry([{ id: n, geometry: i }, ...d, ...u, ...f]), this.projection === "web-mercator" ? this.lastBearing = a : this.projection === "globe" && (this.lastBearing = a + 180);
  }
}
class jre extends ir {
  constructor(t, n) {
    super(t), this.config = void 0, this.dragCoordinateResizeBehavior = void 0, this.config = t, this.dragCoordinateResizeBehavior = n;
  }
  scale(t, n, r) {
    if (!this.dragCoordinateResizeBehavior.isDragging()) {
      const i = this.dragCoordinateResizeBehavior.getDraggableIndex(t, n);
      this.dragCoordinateResizeBehavior.startDragging(n, i);
    }
    this.dragCoordinateResizeBehavior.drag(t, "center-fixed", r);
  }
  reset() {
    this.dragCoordinateResizeBehavior.stopDragging();
  }
}
function vT({ coordinates: e, originX: t, originY: n, xScale: r, yScale: i }) {
  r === 1 && i === 1 || e.forEach((o) => {
    const { x: a, y: s } = $t(o[0], o[1]), l = t + (a - t) * r, u = n + (s - n) * i, { lng: d, lat: f } = Sa(l, u);
    o[0] = d, o[1] = f;
  });
}
class Wre extends ir {
  constructor(t, n, r, i, o) {
    super(t), this.config = void 0, this.pixelDistance = void 0, this.selectionPoints = void 0, this.midPoints = void 0, this.coordinatePoints = void 0, this.minimumScale = 1e-4, this.draggedCoordinate = { id: null, index: -1 }, this.boundingBoxMaps = { opposite: { 0: 4, 1: 5, 2: 6, 3: 7, 4: 0, 5: 1, 6: 2, 7: 3 } }, this.config = t, this.pixelDistance = n, this.selectionPoints = r, this.midPoints = i, this.coordinatePoints = o;
  }
  getClosestCoordinate(t, n) {
    const r = { dist: 1 / 0, index: -1, isFirstOrLastPolygonCoord: !1 };
    let i;
    if (n.type === "LineString")
      i = n.coordinates;
    else {
      if (n.type !== "Polygon")
        return r;
      i = n.coordinates[0];
    }
    for (let o = 0; o < i.length; o++) {
      const a = this.pixelDistance.measure(t, i[o]);
      if (a < this.pointerDistance && a < r.dist) {
        const s = n.type === "Polygon" && (o === i.length - 1 || o === 0);
        r.dist = a, r.index = s ? 0 : o, r.isFirstOrLastPolygonCoord = s;
      }
    }
    return r;
  }
  isValidDragWebMercator(t, n, r) {
    switch (t) {
      case 0:
        if (n <= 0 || r >= 0)
          return !1;
        break;
      case 1:
        if (r >= 0)
          return !1;
        break;
      case 2:
        if (n >= 0 || r >= 0)
          return !1;
        break;
      case 3:
        if (n >= 0)
          return !1;
        break;
      case 4:
        if (n >= 0 || r <= 0)
          return !1;
        break;
      case 5:
        if (r <= 0)
          return !1;
        break;
      case 6:
        if (n <= 0 || r <= 0)
          return !1;
        break;
      case 7:
        if (n <= 0)
          return !1;
    }
    return !0;
  }
  getSelectedFeatureDataWebMercator() {
    if (!this.draggedCoordinate.id || this.draggedCoordinate.index === -1)
      return null;
    const t = this.getFeature(this.draggedCoordinate.id);
    if (!t)
      return null;
    const n = this.getNormalisedCoordinates(t.geometry);
    return { boundingBox: this.getBBoxWebMercator(n), feature: t, updatedCoords: n, selectedCoordinate: n[this.draggedCoordinate.index] };
  }
  centerWebMercatorDrag(t) {
    const n = this.getSelectedFeatureDataWebMercator();
    if (!n)
      return null;
    const { feature: r, boundingBox: i, updatedCoords: o, selectedCoordinate: a } = n, s = C0(r);
    if (!s)
      return null;
    const l = $t(a[0], a[1]), { closestBBoxIndex: u } = this.getIndexesWebMercator(i, l), d = $t(t.lng, t.lat);
    return this.scaleWebMercator({ closestBBoxIndex: u, updatedCoords: o, webMercatorCursor: d, webMercatorSelected: l, webMercatorOrigin: s }), o;
  }
  centerFixedWebMercatorDrag(t) {
    const n = this.getSelectedFeatureDataWebMercator();
    if (!n)
      return null;
    const { feature: r, boundingBox: i, updatedCoords: o, selectedCoordinate: a } = n, s = C0(r);
    if (!s)
      return null;
    const l = $t(a[0], a[1]), { closestBBoxIndex: u } = this.getIndexesWebMercator(i, l), d = $t(t.lng, t.lat);
    return this.scaleFixedWebMercator({ closestBBoxIndex: u, updatedCoords: o, webMercatorCursor: d, webMercatorSelected: l, webMercatorOrigin: s }), o;
  }
  scaleFixedWebMercator({ closestBBoxIndex: t, webMercatorOrigin: n, webMercatorSelected: r, webMercatorCursor: i, updatedCoords: o }) {
    if (!this.isValidDragWebMercator(t, n.x - i.x, n.y - i.y))
      return null;
    let a = fa(n, i) / fa(n, r);
    return a < 0 && (a = this.minimumScale), vT({ coordinates: o, originX: n.x, originY: n.y, xScale: a, yScale: a }), o;
  }
  oppositeFixedWebMercatorDrag(t) {
    const n = this.getSelectedFeatureDataWebMercator();
    if (!n)
      return null;
    const { boundingBox: r, updatedCoords: i, selectedCoordinate: o } = n, a = $t(o[0], o[1]), { oppositeBboxIndex: s, closestBBoxIndex: l } = this.getIndexesWebMercator(r, a), u = { x: r[s][0], y: r[s][1] }, d = $t(t.lng, t.lat);
    return this.scaleFixedWebMercator({ closestBBoxIndex: l, updatedCoords: i, webMercatorCursor: d, webMercatorSelected: a, webMercatorOrigin: u }), i;
  }
  oppositeWebMercatorDrag(t) {
    const n = this.getSelectedFeatureDataWebMercator();
    if (!n)
      return null;
    const { boundingBox: r, updatedCoords: i, selectedCoordinate: o } = n, a = $t(o[0], o[1]), { oppositeBboxIndex: s, closestBBoxIndex: l } = this.getIndexesWebMercator(r, a), u = { x: r[s][0], y: r[s][1] }, d = $t(t.lng, t.lat);
    return this.scaleWebMercator({ closestBBoxIndex: l, updatedCoords: i, webMercatorCursor: d, webMercatorSelected: a, webMercatorOrigin: u }), i;
  }
  scaleWebMercator({ closestBBoxIndex: t, webMercatorOrigin: n, webMercatorSelected: r, webMercatorCursor: i, updatedCoords: o }) {
    const a = n.x - i.x, s = n.y - i.y;
    if (!this.isValidDragWebMercator(t, a, s))
      return null;
    let l = 1;
    a !== 0 && t !== 1 && t !== 5 && (l = 1 - (n.x - r.x - a) / a);
    let u = 1;
    return s !== 0 && t !== 3 && t !== 7 && (u = 1 - (n.y - r.y - s) / s), this.validateScale(l, u) ? (l < 0 && (l = this.minimumScale), u < 0 && (u = this.minimumScale), this.performWebMercatorScale(o, n.x, n.y, l, u), o) : null;
  }
  getFeature(t) {
    if (this.draggedCoordinate.id === null)
      return null;
    const n = this.store.getGeometryCopy(t);
    return n.type !== "Polygon" && n.type !== "LineString" ? null : { id: t, type: "Feature", geometry: n, properties: {} };
  }
  getNormalisedCoordinates(t) {
    return t.type === "Polygon" ? t.coordinates[0] : t.coordinates;
  }
  validateScale(t, n) {
    const r = !isNaN(t) && n < Number.MAX_SAFE_INTEGER, i = !isNaN(n) && n < Number.MAX_SAFE_INTEGER;
    return r && i;
  }
  performWebMercatorScale(t, n, r, i, o) {
    t.forEach((a) => {
      const { x: s, y: l } = $t(a[0], a[1]), u = n + (s - n) * i, d = r + (l - r) * o, { lng: f, lat: p } = Sa(u, d);
      a[0] = f, a[1] = p;
    });
  }
  getBBoxWebMercator(t) {
    const n = [1 / 0, 1 / 0, -1 / 0, -1 / 0];
    (t = t.map((s) => {
      const { x: l, y: u } = $t(s[0], s[1]);
      return [l, u];
    })).forEach(([s, l]) => {
      s < n[0] && (n[0] = s), l < n[1] && (n[1] = l), s > n[2] && (n[2] = s), l > n[3] && (n[3] = l);
    });
    const [r, i, o, a] = n;
    return [[r, a], [(r + o) / 2, a], [o, a], [o, a + (i - a) / 2], [o, i], [(r + o) / 2, i], [r, i], [r, a + (i - a) / 2]];
  }
  getIndexesWebMercator(t, n) {
    let r, i = 1 / 0;
    for (let o = 0; o < t.length; o++) {
      const a = fa({ x: n.x, y: n.y }, { x: t[o][0], y: t[o][1] });
      a < i && (r = o, i = a);
    }
    if (r === void 0)
      throw new Error("No closest coordinate found");
    return { oppositeBboxIndex: this.boundingBoxMaps.opposite[r], closestBBoxIndex: r };
  }
  isDragging() {
    return this.draggedCoordinate.id !== null;
  }
  startDragging(t, n) {
    this.draggedCoordinate = { id: t, index: n };
  }
  stopDragging() {
    this.draggedCoordinate = { id: null, index: -1 };
  }
  getDraggableIndex(t, n) {
    const r = this.store.getGeometryCopy(n), i = this.getClosestCoordinate(t, r);
    return i.index === -1 ? -1 : i.index;
  }
  drag(t, n, r) {
    if (!this.draggedCoordinate.id)
      return !1;
    const i = this.getFeature(this.draggedCoordinate.id);
    if (!i)
      return !1;
    let o = null;
    if (n === "center" ? o = this.centerWebMercatorDrag(t) : n === "opposite" ? o = this.oppositeWebMercatorDrag(t) : n === "center-fixed" ? o = this.centerFixedWebMercatorDrag(t) : n === "opposite-fixed" && (o = this.oppositeFixedWebMercatorDrag(t)), !o)
      return !1;
    for (let d = 0; d < o.length; d++) {
      const f = o[d];
      if (f[0] = Bt(f[0], this.coordinatePrecision), f[1] = Bt(f[1], this.coordinatePrecision), !iT(f, this.coordinatePrecision))
        return !1;
    }
    const a = this.midPoints.getUpdated(o) || [], s = this.selectionPoints.getUpdated(o) || [], l = this.coordinatePoints.getUpdated(i.id, o) || [], u = { type: i.geometry.type, coordinates: i.geometry.type === "Polygon" ? [o] : o };
    return !(r && !r({ id: this.draggedCoordinate.id, type: "Feature", geometry: u, properties: {} }, { project: this.config.project, unproject: this.config.unproject, coordinatePrecision: this.config.coordinatePrecision, updateType: hn.Provisional }).valid || (this.store.updateGeometry([{ id: this.draggedCoordinate.id, geometry: u }, ...s, ...a, ...l]), 0));
  }
}
const Ure = { deselect: "Escape", delete: "Delete", rotate: ["Control", "r"], scale: ["Control", "s"] }, oC = { pointerOver: "move", dragStart: "move", dragEnd: "move", insertMidpoint: "crosshair" };
class Hre extends tT {
  constructor(t) {
    super(t, !0), this.mode = "select", this.allowManualDeselection = !0, this.dragEventThrottle = 5, this.dragEventCount = 0, this.selected = [], this.flags = {}, this.keyEvents = Ure, this.cursors = oC, this.validations = {}, this.selectionPoints = void 0, this.midPoints = void 0, this.coordinateSnap = void 0, this.featuresAtMouseEvent = void 0, this.pixelDistance = void 0, this.clickBoundingBox = void 0, this.dragFeature = void 0, this.dragCoordinate = void 0, this.rotateFeature = void 0, this.scaleFeature = void 0, this.dragCoordinateResizeFeature = void 0, this.coordinatePoints = void 0, this.lineSnap = void 0, this.updateOptions(t);
  }
  updateOptions(t) {
    if (super.updateOptions(t), this.cursors = t && t.cursors ? en({}, this.cursors, t.cursors) : oC, (t == null ? void 0 : t.keyEvents) === null ? this.keyEvents = { deselect: null, delete: null, rotate: null, scale: null } : t != null && t.keyEvents && (this.keyEvents = en({}, this.keyEvents, t.keyEvents)), (t == null ? void 0 : t.dragEventThrottle) !== void 0 && (this.dragEventThrottle = t.dragEventThrottle), (t == null ? void 0 : t.allowManualDeselection) !== void 0 && (this.allowManualDeselection = t.allowManualDeselection), t != null && t.flags) {
      this.flags = en({}, this.flags, t.flags), this.validations = {};
      for (const n in this.flags) {
        const r = this.flags[n].feature;
        r && r.validation && (this.validations[n] = r.validation);
      }
    }
  }
  selectFeature(t) {
    this.select(t, !1);
  }
  setSelecting() {
    if (this._state !== "started")
      throw new Error("Mode must be started to move to selecting state");
    this._state = "selecting";
  }
  registerBehaviors(t) {
    this.pixelDistance = new uT(t), this.clickBoundingBox = new cT(t), this.featuresAtMouseEvent = new Fre(t, this.clickBoundingBox, this.pixelDistance), this.selectionPoints = new Lre(t), this.coordinatePoints = new hT(t), this.midPoints = new $re(t, this.selectionPoints, this.coordinatePoints), this.coordinateSnap = new dT(t, this.pixelDistance, this.clickBoundingBox), this.lineSnap = new fT(t, this.pixelDistance, this.clickBoundingBox), this.rotateFeature = new Bre(t, this.selectionPoints, this.midPoints, this.coordinatePoints), this.dragFeature = new zre(t, this.featuresAtMouseEvent, this.selectionPoints, this.midPoints, this.coordinatePoints), this.dragCoordinate = new Vre(t, this.pixelDistance, this.selectionPoints, this.midPoints, this.coordinatePoints, this.coordinateSnap, this.lineSnap), this.dragCoordinateResizeFeature = new Wre(t, this.pixelDistance, this.selectionPoints, this.midPoints, this.coordinatePoints), this.scaleFeature = new jre(t, this.dragCoordinateResizeFeature);
  }
  deselectFeature() {
    this.deselect();
  }
  deselect() {
    const t = this.selected.filter((n) => this.store.has(n)).map((n) => ({ id: n, property: fn.SELECTED, value: !1 }));
    this.store.updateProperty(t), this.onDeselect(this.selected[0]), this.selected = [], this.selectionPoints.delete(), this.midPoints.delete();
  }
  deleteSelected() {
    this.store.delete(this.selected), this.selected = [];
  }
  onRightClick(t) {
    if (!this.selectionPoints.ids.length)
      return;
    let n, r = 1 / 0;
    if (this.selectionPoints.ids.forEach((p) => {
      const m = this.store.getGeometryCopy(p), g = this.pixelDistance.measure(t, m.coordinates);
      g < this.pointerDistance && g < r && (r = g, n = this.store.getPropertiesCopy(p));
    }), !n)
      return;
    const i = n.selectionPointFeatureId, o = n.index, a = this.store.getPropertiesCopy(i), s = this.flags[a.mode], l = this.validations[a.mode];
    if (!(s && s.feature && s.feature.coordinates && s.feature.coordinates.deletable))
      return;
    const u = this.store.getGeometryCopy(i);
    let d;
    if (u.type === "Polygon") {
      if (d = u.coordinates[0], d.length <= 4)
        return;
    } else if (u.type === "LineString" && (d = u.coordinates, d.length <= 2))
      return;
    if (!d || (u.type !== "Polygon" || o !== 0 && o !== d.length - 1 ? d.splice(o, 1) : (d.shift(), d.pop(), d.push([d[0][0], d[0][1]])), l && !l({ id: i, type: "Feature", geometry: u, properties: a }, { project: this.project, unproject: this.unproject, coordinatePrecision: this.coordinatePrecision, updateType: hn.Commit }).valid))
      return;
    const f = [...this.midPoints.ids, ...this.selectionPoints.ids];
    this.store.delete(f), this.store.updateGeometry([{ id: i, geometry: u }]), a.coordinatePointIds && this.coordinatePoints.createOrUpdate(i), this.selectionPoints.create(d, u.type, i), s && s.feature && s.feature.coordinates && s.feature.coordinates.midpoints && this.midPoints.create(d, i, this.coordinatePrecision);
  }
  select(t, n = !0) {
    if (this.selected[0] === t)
      return;
    const { mode: r } = this.store.getPropertiesCopy(t), i = this.flags[r];
    if (!i || !i.feature)
      return;
    const o = this.selected[0];
    if (o) {
      if (o === t)
        return;
      this.deselect();
    }
    n && this.setCursor(this.cursors.pointerOver), this.selected = [t], this.store.updateProperty([{ id: t, property: fn.SELECTED, value: !0 }]), this.onSelect(t);
    const { type: a, coordinates: s } = this.store.getGeometryCopy(t);
    if (a !== "LineString" && a !== "Polygon")
      return;
    const l = a === "LineString" ? s : s[0];
    l && i && i.feature.coordinates && (this.selectionPoints.create(l, a, t), i.feature.coordinates.midpoints && this.midPoints.create(l, t, this.coordinatePrecision));
  }
  onLeftClick(t) {
    const { clickedFeature: n, clickedMidPoint: r } = this.featuresAtMouseEvent.find(t, this.selected.length > 0);
    if (this.selected.length && r)
      this.midPoints.insert(this.selected[0], r.id, this.coordinatePrecision);
    else if (n && n.id)
      this.select(n.id, !0);
    else if (this.selected.length && this.allowManualDeselection)
      return void this.deselect();
  }
  start() {
    this.setStarted(), this.setSelecting();
  }
  stop() {
    this.cleanUp(), this.setStarted(), this.setStopped();
  }
  onClick(t) {
    t.button === "right" && this.allowPointerEvent(this.pointerEvents.rightClick, t) || t.isContextMenu && this.allowPointerEvent(this.pointerEvents.contextMenu, t) ? this.onRightClick(t) : t.button === "left" && this.allowPointerEvent(this.pointerEvents.leftClick, t) && this.onLeftClick(t);
  }
  canScale(t) {
    return this.keyEvents.scale && this.keyEvents.scale.every((n) => t.heldKeys.includes(n));
  }
  canRotate(t) {
    return this.keyEvents.rotate && this.keyEvents.rotate.every((n) => t.heldKeys.includes(n));
  }
  preventDefaultKeyEvent(t) {
    const n = this.canRotate(t), r = this.canScale(t);
    (n || r) && t.preventDefault();
  }
  onKeyDown(t) {
    this.preventDefaultKeyEvent(t);
  }
  onKeyUp(t) {
    if (this.preventDefaultKeyEvent(t), this.keyEvents.delete && t.key === this.keyEvents.delete) {
      if (!this.selected.length)
        return;
      const n = this.selected[0];
      this.onDeselect(this.selected[0]), this.coordinatePoints.deletePointsByFeatureIds([n]), this.deleteSelected(), this.selectionPoints.delete(), this.midPoints.delete();
    } else
      this.keyEvents.deselect && t.key === this.keyEvents.deselect && this.cleanUp();
  }
  cleanUp() {
    this.selected.length && this.deselect();
  }
  onDragStart(t, n) {
    if (!this.allowPointerEvent(this.pointerEvents.onDragStart, t) || !this.selected.length)
      return;
    const r = this.store.getPropertiesCopy(this.selected[0]), i = this.flags[r.mode];
    if (!(i && i.feature && (i.feature.draggable || i.feature.coordinates && i.feature.coordinates.draggable || i.feature.coordinates && i.feature.coordinates.resizable || i.feature.coordinates && typeof i.feature.coordinates.midpoints == "object" && i.feature.coordinates.midpoints.draggable)))
      return;
    this.dragEventCount = 0;
    const o = this.selected[0], a = this.dragCoordinate.getDraggableIndex(t, o);
    if (i && i.feature && i.feature.coordinates && (i.feature.coordinates.draggable || i.feature.coordinates.resizable) && a !== -1)
      return this.setCursor(this.cursors.dragStart), i.feature.coordinates.resizable ? this.dragCoordinateResizeFeature.startDragging(o, a) : this.dragCoordinate.startDragging(o, a), void n(!1);
    if (i && i.feature && i.feature.coordinates && typeof i.feature.coordinates.midpoints == "object" && i.feature.coordinates.midpoints.draggable) {
      const { clickedMidPoint: s } = this.featuresAtMouseEvent.find(t, this.selected.length > 0);
      if (this.selected.length && s) {
        this.midPoints.insert(o, s.id, this.coordinatePrecision);
        const l = this.dragCoordinate.getDraggableIndex(t, o);
        return this.dragCoordinate.startDragging(o, l), void n(!1);
      }
    }
    return i && i.feature && i.feature.draggable && this.dragFeature.canDrag(t, o) ? (this.setCursor(this.cursors.dragStart), this.dragFeature.startDragging(t, o), void n(!1)) : void 0;
  }
  onDrag(t, n) {
    if (!this.allowPointerEvent(this.pointerEvents.onDrag, t))
      return;
    const r = this.selected[0];
    if (!r)
      return;
    const i = this.store.getPropertiesCopy(r), o = this.flags[i.mode], a = (o && o.feature && o.feature.selfIntersectable) === !0;
    if (this.dragEventCount++, this.dragEventCount % this.dragEventThrottle == 0)
      return;
    const s = this.validations[i.mode];
    if (o && o.feature && o.feature.rotateable && this.canRotate(t))
      return n(!1), void this.rotateFeature.rotate(t, r, s);
    if (o && o.feature && o.feature.scaleable && this.canScale(t))
      return n(!1), void this.scaleFeature.scale(t, r, s);
    if (this.dragCoordinateResizeFeature.isDragging() && o.feature && o.feature.coordinates && o.feature.coordinates.resizable) {
      if (this.projection === "globe")
        throw new Error("Globe is currently unsupported projection for resizable");
      return n(!1), void this.dragCoordinateResizeFeature.drag(t, o.feature.coordinates.resizable, s);
    }
    if (this.dragCoordinate.isDragging()) {
      var l;
      const u = (l = o.feature) == null || (l = l.coordinates) == null ? void 0 : l.snappable;
      let d = { toCoordinate: !1 };
      return u === !0 ? d = { toCoordinate: !0 } : typeof u == "object" && (d = u), void this.dragCoordinate.drag(t, a, s, d);
    }
    this.dragFeature.isDragging() ? this.dragFeature.drag(t, s) : n(!0);
  }
  onDragEnd(t, n) {
    this.allowPointerEvent(this.pointerEvents.onDragEnd, t) && (this.setCursor(this.cursors.dragEnd), this.dragCoordinate.isDragging() ? this.onFinish(this.selected[0], { mode: this.mode, action: "dragCoordinate" }) : this.dragFeature.isDragging() ? this.onFinish(this.selected[0], { mode: this.mode, action: "dragFeature" }) : this.dragCoordinateResizeFeature.isDragging() && this.onFinish(this.selected[0], { mode: this.mode, action: "dragCoordinateResize" }), this.dragCoordinate.stopDragging(), this.dragFeature.stopDragging(), this.dragCoordinateResizeFeature.stopDragging(), this.rotateFeature.reset(), this.scaleFeature.reset(), n(!0));
  }
  onMouseMove(t) {
    if (!this.selected.length)
      return void this.setCursor("unset");
    if (this.dragFeature.isDragging())
      return;
    let n = !1;
    this.midPoints.ids.forEach((o) => {
      if (n)
        return;
      const a = this.store.getGeometryCopy(o);
      this.pixelDistance.measure(t, a.coordinates) < this.pointerDistance && (n = !0);
    });
    let r = !1;
    if (this.selectionPoints.ids.forEach((o) => {
      const a = this.store.getGeometryCopy(o);
      this.pixelDistance.measure(t, a.coordinates) < this.pointerDistance && (n = !1, r = !0);
    }), n)
      return void this.setCursor(this.cursors.insertMidpoint);
    const { clickedFeature: i } = this.featuresAtMouseEvent.find(t, !0);
    this.setCursor(this.selected.length > 0 && (i && i.id === this.selected[0] || r) ? this.cursors.pointerOver : "unset");
  }
  styleFeature(t) {
    const n = en({}, { polygonFillColor: "#3f97e0", polygonOutlineColor: "#3f97e0", polygonOutlineWidth: 4, polygonFillOpacity: 0.3, pointColor: "#3f97e0", pointOutlineColor: "#ffffff", pointOutlineWidth: 0, pointWidth: 6, lineStringColor: "#3f97e0", lineStringWidth: 4, zIndex: 0 });
    if (t.properties.mode === this.mode && t.geometry.type === "Point") {
      if (t.properties.selectionPoint)
        return n.pointColor = this.getHexColorStylingValue(this.styles.selectionPointColor, n.pointColor, t), n.pointOutlineColor = this.getHexColorStylingValue(this.styles.selectionPointOutlineColor, n.pointOutlineColor, t), n.pointWidth = this.getNumericStylingValue(this.styles.selectionPointWidth, n.pointWidth, t), n.pointOutlineWidth = this.getNumericStylingValue(this.styles.selectionPointOutlineWidth, 2, t), n.zIndex = 30, n;
      if (t.properties.midPoint)
        return n.pointColor = this.getHexColorStylingValue(this.styles.midPointColor, n.pointColor, t), n.pointOutlineColor = this.getHexColorStylingValue(this.styles.midPointOutlineColor, n.pointOutlineColor, t), n.pointWidth = this.getNumericStylingValue(this.styles.midPointWidth, 4, t), n.pointOutlineWidth = this.getNumericStylingValue(this.styles.midPointOutlineWidth, 2, t), n.zIndex = 50, n;
    } else if (t.properties[fn.SELECTED]) {
      if (t.geometry.type === "Polygon")
        return n.polygonFillColor = this.getHexColorStylingValue(this.styles.selectedPolygonColor, n.polygonFillColor, t), n.polygonOutlineWidth = this.getNumericStylingValue(this.styles.selectedPolygonOutlineWidth, n.polygonOutlineWidth, t), n.polygonOutlineColor = this.getHexColorStylingValue(this.styles.selectedPolygonOutlineColor, n.polygonOutlineColor, t), n.polygonFillOpacity = this.getNumericStylingValue(this.styles.selectedPolygonFillOpacity, n.polygonFillOpacity, t), n.zIndex = Es, n;
      if (t.geometry.type === "LineString")
        return n.lineStringColor = this.getHexColorStylingValue(this.styles.selectedLineStringColor, n.lineStringColor, t), n.lineStringWidth = this.getNumericStylingValue(this.styles.selectedLineStringWidth, n.lineStringWidth, t), n.zIndex = Es, n;
      if (t.geometry.type === "Point")
        return n.pointWidth = this.getNumericStylingValue(this.styles.selectedPointWidth, n.pointWidth, t), n.pointColor = this.getHexColorStylingValue(this.styles.selectedPointColor, n.pointColor, t), n.pointOutlineColor = this.getHexColorStylingValue(this.styles.selectedPointOutlineColor, n.pointOutlineColor, t), n.pointOutlineWidth = this.getNumericStylingValue(this.styles.selectedPointOutlineWidth, n.pointOutlineWidth, t), n.zIndex = Es, n;
    }
    return n;
  }
  afterFeatureUpdated(t) {
    if (this.selected.length && t.id === this.selected[0]) {
      var n, r;
      const i = this.flags[t.properties.mode];
      if (i == null || (n = i.feature) == null || !n.coordinates)
        return;
      const o = t.geometry.type, a = t.id;
      let s;
      if (this.selectionPoints.delete(), this.midPoints.delete(), o === "Polygon")
        s = t.geometry.coordinates[0];
      else {
        if (o !== "LineString")
          return;
        s = t.geometry.coordinates;
      }
      this.selectionPoints.create(s, o, a), i != null && (r = i.feature) != null && (r = r.coordinates) != null && r.midpoints && this.midPoints.create(o === "Polygon" ? t.geometry.coordinates[0] : t.geometry.coordinates, a, this.coordinatePrecision);
    }
  }
}
class Gre extends Ks {
  constructor(...t) {
    super(...t), this.type = Ds.Static, this.mode = "static";
  }
  start() {
  }
  stop() {
  }
  onKeyUp() {
  }
  onKeyDown() {
  }
  onClick() {
  }
  onDragStart() {
  }
  onDrag() {
  }
  onDragEnd() {
  }
  onMouseMove() {
  }
  cleanUp() {
  }
  styleFeature() {
    return en({}, { polygonFillColor: "#3f97e0", polygonOutlineColor: "#3f97e0", polygonOutlineWidth: 4, polygonFillOpacity: 0.3, pointColor: "#3f97e0", pointOutlineColor: "#ffffff", pointOutlineWidth: 0, pointWidth: 6, lineStringColor: "#3f97e0", lineStringWidth: 4, zIndex: 0 });
  }
}
function yT(e, t, n, r, i) {
  for (; r > n; ) {
    if (r - n > 600) {
      const l = r - n + 1, u = t - n + 1, d = Math.log(l), f = 0.5 * Math.exp(2 * d / 3), p = 0.5 * Math.sqrt(d * f * (l - f) / l) * (u - l / 2 < 0 ? -1 : 1);
      yT(e, t, Math.max(n, Math.floor(t - u * f / l + p)), Math.min(r, Math.floor(t + (l - u) * f / l + p)), i);
    }
    const o = e[t];
    let a = n, s = r;
    for (kl(e, n, t), i(e[r], o) > 0 && kl(e, n, r); a < s; ) {
      for (kl(e, a, s), a++, s--; i(e[a], o) < 0; )
        a++;
      for (; i(e[s], o) > 0; )
        s--;
    }
    i(e[n], o) === 0 ? kl(e, n, s) : (s++, kl(e, s, r)), s <= t && (n = s + 1), t <= s && (r = s - 1);
  }
}
function kl(e, t, n) {
  const r = e[t];
  e[t] = e[n], e[n] = r;
}
function es(e, t) {
  zl(e, 0, e.children.length, t, e);
}
function zl(e, t, n, r, i) {
  i || (i = cs([])), i.minX = 1 / 0, i.minY = 1 / 0, i.maxX = -1 / 0, i.maxY = -1 / 0;
  for (let o = t; o < n; o++) {
    const a = e.children[o];
    Vl(i, e.leaf ? r(a) : a);
  }
  return i;
}
function Vl(e, t) {
  return e.minX = Math.min(e.minX, t.minX), e.minY = Math.min(e.minY, t.minY), e.maxX = Math.max(e.maxX, t.maxX), e.maxY = Math.max(e.maxY, t.maxY), e;
}
function qre(e, t) {
  return e.minX - t.minX;
}
function Yre(e, t) {
  return e.minY - t.minY;
}
function vg(e) {
  return (e.maxX - e.minX) * (e.maxY - e.minY);
}
function bd(e) {
  return e.maxX - e.minX + (e.maxY - e.minY);
}
function Kre(e, t) {
  const n = Math.max(e.minX, t.minX), r = Math.max(e.minY, t.minY), i = Math.min(e.maxX, t.maxX), o = Math.min(e.maxY, t.maxY);
  return Math.max(0, i - n) * Math.max(0, o - r);
}
function yg(e, t) {
  return e.minX <= t.minX && e.minY <= t.minY && t.maxX <= e.maxX && t.maxY <= e.maxY;
}
function xd(e, t) {
  return t.minX <= e.maxX && t.minY <= e.maxY && t.maxX >= e.minX && t.maxY >= e.minY;
}
function cs(e) {
  return { children: e, height: 1, leaf: !0, minX: 1 / 0, minY: 1 / 0, maxX: -1 / 0, maxY: -1 / 0 };
}
function aC(e, t, n, r, i) {
  const o = [t, n];
  for (; o.length; ) {
    if ((n = o.pop()) - (t = o.pop()) <= r)
      continue;
    const a = t + Math.ceil((n - t) / r / 2) * r;
    yT(e, a, t, n, i), o.push(t, a, a, n);
  }
}
class Xre {
  constructor(t) {
    this._maxEntries = void 0, this._minEntries = void 0, this.data = void 0, this._maxEntries = Math.max(4, t), this._minEntries = Math.max(2, Math.ceil(0.4 * this._maxEntries)), this.clear();
  }
  search(t) {
    let n = this.data;
    const r = [];
    if (!xd(t, n))
      return r;
    const i = this.toBBox, o = [];
    for (; n; ) {
      for (let a = 0; a < n.children.length; a++) {
        const s = n.children[a], l = n.leaf ? i(s) : s;
        xd(t, l) && (n.leaf ? r.push(s) : yg(t, l) ? this._all(s, r) : o.push(s));
      }
      n = o.pop();
    }
    return r;
  }
  collides(t) {
    let n = this.data;
    if (xd(t, n)) {
      const r = [];
      for (; n; ) {
        for (let i = 0; i < n.children.length; i++) {
          const o = n.children[i], a = n.leaf ? this.toBBox(o) : o;
          if (xd(t, a)) {
            if (n.leaf || yg(t, a))
              return !0;
            r.push(o);
          }
        }
        n = r.pop();
      }
    }
    return !1;
  }
  load(t) {
    if (t.length < this._minEntries) {
      for (let r = 0; r < t.length; r++)
        this.insert(t[r]);
      return;
    }
    let n = this._build(t.slice(), 0, t.length - 1, 0);
    if (this.data.children.length)
      if (this.data.height === n.height)
        this._splitRoot(this.data, n);
      else {
        if (this.data.height < n.height) {
          const r = this.data;
          this.data = n, n = r;
        }
        this._insert(n, this.data.height - n.height - 1, !0);
      }
    else
      this.data = n;
  }
  insert(t) {
    this._insert(t, this.data.height - 1);
  }
  clear() {
    this.data = cs([]);
  }
  remove(t) {
    let n = this.data;
    const r = this.toBBox(t), i = [], o = [];
    let a, s, l = !1;
    for (; n || i.length; ) {
      if (n || (n = i.pop(), s = i[i.length - 1], a = o.pop(), l = !0), n.leaf) {
        const u = n.children.indexOf(t);
        u !== -1 && (n.children.splice(u, 1), i.push(n), this._condense(i));
      }
      l || n.leaf || !yg(n, r) ? s ? (a++, n = s.children[a], l = !1) : n = null : (i.push(n), o.push(a), a = 0, s = n, n = n.children[0]);
    }
  }
  toBBox(t) {
    return t;
  }
  compareMinX(t, n) {
    return t.minX - n.minX;
  }
  compareMinY(t, n) {
    return t.minY - n.minY;
  }
  _all(t, n) {
    const r = [];
    for (; t; )
      t.leaf ? n.push(...t.children) : r.push(...t.children), t = r.pop();
    return n;
  }
  _build(t, n, r, i) {
    const o = r - n + 1;
    let a, s = this._maxEntries;
    if (o <= s)
      return a = cs(t.slice(n, r + 1)), es(a, this.toBBox), a;
    i || (i = Math.ceil(Math.log(o) / Math.log(s)), s = Math.ceil(o / Math.pow(s, i - 1))), a = cs([]), a.leaf = !1, a.height = i;
    const l = Math.ceil(o / s), u = l * Math.ceil(Math.sqrt(s));
    aC(t, n, r, u, this.compareMinX);
    for (let d = n; d <= r; d += u) {
      const f = Math.min(d + u - 1, r);
      aC(t, d, f, l, this.compareMinY);
      for (let p = d; p <= f; p += l) {
        const m = Math.min(p + l - 1, f);
        a.children.push(this._build(t, p, m, i - 1));
      }
    }
    return es(a, this.toBBox), a;
  }
  _chooseSubtree(t, n, r, i) {
    for (; i.push(n), !n.leaf && i.length - 1 !== r; ) {
      let s, l = 1 / 0, u = 1 / 0;
      for (let d = 0; d < n.children.length; d++) {
        const f = n.children[d], p = vg(f), m = (o = t, a = f, (Math.max(a.maxX, o.maxX) - Math.min(a.minX, o.minX)) * (Math.max(a.maxY, o.maxY) - Math.min(a.minY, o.minY)) - p);
        m < u ? (u = m, l = p < l ? p : l, s = f) : m === u && p < l && (l = p, s = f);
      }
      n = s || n.children[0];
    }
    var o, a;
    return n;
  }
  _insert(t, n, r) {
    const i = r ? t : this.toBBox(t), o = [], a = this._chooseSubtree(i, this.data, n, o);
    for (a.children.push(t), Vl(a, i); n >= 0 && o[n].children.length > this._maxEntries; )
      this._split(o, n), n--;
    this._adjustParentBBoxes(i, o, n);
  }
  _split(t, n) {
    const r = t[n], i = r.children.length, o = this._minEntries;
    this._chooseSplitAxis(r, o, i);
    const a = this._chooseSplitIndex(r, o, i), s = cs(r.children.splice(a, r.children.length - a));
    s.height = r.height, s.leaf = r.leaf, es(r, this.toBBox), es(s, this.toBBox), n ? t[n - 1].children.push(s) : this._splitRoot(r, s);
  }
  _splitRoot(t, n) {
    this.data = cs([t, n]), this.data.height = t.height + 1, this.data.leaf = !1, es(this.data, this.toBBox);
  }
  _chooseSplitIndex(t, n, r) {
    let i, o = 1 / 0, a = 1 / 0;
    for (let s = n; s <= r - n; s++) {
      const l = zl(t, 0, s, this.toBBox), u = zl(t, s, r, this.toBBox), d = Kre(l, u), f = vg(l) + vg(u);
      d < o ? (o = d, i = s, a = f < a ? f : a) : d === o && f < a && (a = f, i = s);
    }
    return i || r - n;
  }
  _chooseSplitAxis(t, n, r) {
    const i = t.leaf ? this.compareMinX : qre, o = t.leaf ? this.compareMinY : Yre;
    this._allDistMargin(t, n, r, i) < this._allDistMargin(t, n, r, o) && t.children.sort(i);
  }
  _allDistMargin(t, n, r, i) {
    t.children.sort(i);
    const o = this.toBBox, a = zl(t, 0, n, o), s = zl(t, r - n, r, o);
    let l = bd(a) + bd(s);
    for (let u = n; u < r - n; u++) {
      const d = t.children[u];
      Vl(a, t.leaf ? o(d) : d), l += bd(a);
    }
    for (let u = r - n - 1; u >= n; u--) {
      const d = t.children[u];
      Vl(s, t.leaf ? o(d) : d), l += bd(s);
    }
    return l;
  }
  _adjustParentBBoxes(t, n, r) {
    for (let i = r; i >= 0; i--)
      Vl(n[i], t);
  }
  _condense(t) {
    for (let n, r = t.length - 1; r >= 0; r--)
      t[r].children.length === 0 ? r > 0 ? (n = t[r - 1].children, n.splice(n.indexOf(t[r]), 1)) : this.clear() : es(t[r], this.toBBox);
  }
}
class Zre {
  constructor(t) {
    this.tree = void 0, this.idToNode = void 0, this.nodeToId = void 0, this.tree = new Xre(t && t.maxEntries ? t.maxEntries : 9), this.idToNode = /* @__PURE__ */ new Map(), this.nodeToId = /* @__PURE__ */ new Map();
  }
  setMaps(t, n) {
    this.idToNode.set(t.id, n), this.nodeToId.set(n, t.id);
  }
  toBBox(t) {
    const n = [], r = [];
    let i;
    if (t.geometry.type === "Polygon")
      i = t.geometry.coordinates[0];
    else if (t.geometry.type === "LineString")
      i = t.geometry.coordinates;
    else {
      if (t.geometry.type !== "Point")
        throw new Error("Not a valid feature to turn into a bounding box");
      i = [t.geometry.coordinates];
    }
    for (let s = 0; s < i.length; s++)
      r.push(i[s][1]), n.push(i[s][0]);
    const o = Math.min(...r), a = Math.max(...r);
    return { minX: Math.min(...n), minY: o, maxX: Math.max(...n), maxY: a };
  }
  insert(t) {
    if (this.idToNode.get(String(t.id)))
      throw new Error("Feature already exists");
    const n = this.toBBox(t);
    this.setMaps(t, n), this.tree.insert(n);
  }
  load(t) {
    const n = [], r = /* @__PURE__ */ new Set();
    t.forEach((i) => {
      const o = this.toBBox(i);
      if (this.setMaps(i, o), r.has(String(i.id)))
        throw new Error(`Duplicate feature ID found ${i.id}`);
      r.add(String(i.id)), n.push(o);
    }), this.tree.load(n);
  }
  update(t) {
    this.remove(t.id);
    const n = this.toBBox(t);
    this.setMaps(t, n), this.tree.insert(n);
  }
  remove(t) {
    const n = this.idToNode.get(t);
    if (!n)
      throw new Error(`${t} not inserted into the spatial index`);
    this.tree.remove(n);
  }
  clear() {
    this.tree.clear();
  }
  search(t) {
    return this.tree.search(this.toBBox(t)).map((n) => this.nodeToId.get(n));
  }
  collides(t) {
    return this.tree.collides(this.toBBox(t));
  }
}
const Qre = { getId: () => "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(e) {
  const t = 16 * Math.random() | 0;
  return (e == "x" ? t : 3 & t | 8).toString(16);
}), isValidId: (e) => typeof e == "string" && e.length === 36 };
class wT {
  constructor(t) {
    this.idStrategy = void 0, this.tracked = void 0, this.spatialIndex = void 0, this.store = void 0, this._onChange = () => {
    }, this.store = {}, this.spatialIndex = new Zre(), this.tracked = !t || t.tracked !== !1, this.idStrategy = t && t.idStrategy ? t.idStrategy : Qre;
  }
  clone(t) {
    return JSON.parse(JSON.stringify(t));
  }
  getId() {
    return this.idStrategy.getId();
  }
  has(t) {
    return !!this.store[t];
  }
  load(t, n, r, i) {
    if (t.length === 0)
      return [];
    let o = this.clone(t);
    const a = [], s = [];
    return o = o.filter((l) => {
      l.id == null && (l.id = this.idStrategy.getId());
      const u = l.id;
      if (n) {
        const d = n(l);
        if (!d.valid)
          return s.push({ id: u, valid: !1, reason: d.reason }), !1;
      }
      if (this.tracked) {
        if (l.properties.createdAt) {
          if (!ZE(l.properties.createdAt))
            return s.push({ id: l.id, valid: !1, reason: "createdAt is not a valid numeric timestamp" }), !1;
        } else
          l.properties.createdAt = +/* @__PURE__ */ new Date();
        if (l.properties.updatedAt) {
          if (!ZE(l.properties.updatedAt))
            return s.push({ id: l.id, valid: !1, reason: "updatedAt is not a valid numeric timestamp" }), !1;
        } else
          l.properties.updatedAt = +/* @__PURE__ */ new Date();
      }
      return this.has(u) ? (s.push({ id: u, valid: !1, reason: `Feature already exists with this id: ${u}` }), !1) : (this.store[u] = l, a.push(u), r && r(l), s.push({ id: u, valid: !0 }), !0);
    }), this.spatialIndex.load(o), a.length > 0 && this._onChange(a, "create", i), s;
  }
  search(t, n) {
    const r = this.spatialIndex.search(t).map((i) => this.store[i]);
    return this.clone(n ? r.filter(n) : r);
  }
  registerOnChange(t) {
    this._onChange = (n, r, i) => {
      t(n, r, i);
    };
  }
  getGeometryCopy(t) {
    const n = this.store[t];
    if (!n)
      throw new Error(`No feature with this id (${t}), can not get geometry copy`);
    return this.clone(n.geometry);
  }
  getPropertiesCopy(t) {
    const n = this.store[t];
    if (!n)
      throw new Error(`No feature with this id (${t}), can not get properties copy`);
    return this.clone(n.properties);
  }
  updateProperty(t, n) {
    const r = [];
    t.forEach(({ id: i, property: o, value: a }) => {
      const s = this.store[i];
      if (!s)
        throw new Error(`No feature with this (${i}), can not update geometry`);
      r.push(i), a === void 0 ? delete s.properties[o] : s.properties[o] = a, this.tracked && (s.properties.updatedAt = +/* @__PURE__ */ new Date());
    }), this._onChange && this._onChange(r, "update", n);
  }
  updateGeometry(t, n) {
    const r = [];
    t.forEach(({ id: i, geometry: o }) => {
      r.push(i);
      const a = this.store[i];
      if (!a)
        throw new Error(`No feature with this (${i}), can not update geometry`);
      a.geometry = this.clone(o), this.spatialIndex.update(a), this.tracked && (a.properties.updatedAt = +/* @__PURE__ */ new Date());
    }), this._onChange && this._onChange(r, "update", n);
  }
  create(t, n) {
    const r = [];
    return t.forEach(({ geometry: i, properties: o }) => {
      let a, s = en({}, o);
      this.tracked && (a = +/* @__PURE__ */ new Date(), o ? (s.createdAt = typeof o.createdAt == "number" ? o.createdAt : a, s.updatedAt = typeof o.updatedAt == "number" ? o.updatedAt : a) : s = { createdAt: a, updatedAt: a });
      const l = this.getId(), u = { id: l, type: "Feature", geometry: i, properties: s };
      this.store[l] = u, this.spatialIndex.insert(u), r.push(l);
    }), this._onChange && this._onChange([...r], "create", n), r;
  }
  delete(t, n) {
    t.forEach((r) => {
      if (!this.store[r])
        throw new Error(`No feature with id ${r}, can not delete`);
      delete this.store[r], this.spatialIndex.remove(r);
    }), this._onChange && this._onChange([...t], "delete", n);
  }
  copy(t) {
    return this.clone(this.store[t]);
  }
  copyAll() {
    return this.clone(Object.keys(this.store).map((t) => this.store[t]));
  }
  copyAllWhere(t) {
    return this.clone(Object.keys(this.store).map((n) => this.store[n]).filter((n) => n.properties && t(n.properties)));
  }
  clear() {
    this.store = {}, this.spatialIndex.clear();
  }
  size() {
    return Object.keys(this.store).length;
  }
}
class ts {
  constructor({ name: t, callback: n, unregister: r, register: i }) {
    this.name = void 0, this.callback = void 0, this.registered = !1, this.register = void 0, this.unregister = void 0, this.name = t, this.register = () => {
      this.registered || (this.registered = !0, i(n));
    }, this.unregister = () => {
      this.register && (this.registered = !1, r(n));
    }, this.callback = n;
  }
}
var Jre = { __proto__: null, GeoJSONStore: wT, TerraDrawBaseDrawMode: Ks, TerraDrawBaseSelectMode: tT, TerraDrawBaseAdapter: class {
  constructor(e) {
    this._nextKeyUpIsContextMenu = !1, this._minPixelDragDistance = void 0, this._minPixelDragDistanceDrawing = void 0, this._minPixelDragDistanceSelecting = void 0, this._lastDrawEvent = void 0, this._coordinatePrecision = void 0, this._heldKeys = /* @__PURE__ */ new Set(), this._listeners = [], this._dragState = "not-dragging", this._currentModeCallbacks = void 0, this._minPixelDragDistance = typeof e.minPixelDragDistance == "number" ? e.minPixelDragDistance : 1, this._minPixelDragDistanceSelecting = typeof e.minPixelDragDistanceSelecting == "number" ? e.minPixelDragDistanceSelecting : 1, this._minPixelDragDistanceDrawing = typeof e.minPixelDragDistanceDrawing == "number" ? e.minPixelDragDistanceDrawing : 8, this._coordinatePrecision = typeof e.coordinatePrecision == "number" ? e.coordinatePrecision : 9;
  }
  getButton(e) {
    return e.button === -1 ? "neither" : e.button === 0 ? "left" : e.button === 1 ? "middle" : e.button === 2 ? "right" : "neither";
  }
  getMapElementXYPosition(e) {
    const t = this.getMapEventElement(), { left: n, top: r } = t.getBoundingClientRect();
    return { containerX: e.clientX - n, containerY: e.clientY - r };
  }
  getDrawEventFromEvent(e, t = !1) {
    const n = this.getLngLatFromEvent(e);
    if (!n)
      return null;
    const { lng: r, lat: i } = n, { containerX: o, containerY: a } = this.getMapElementXYPosition(e), s = this.getButton(e), l = Array.from(this._heldKeys);
    return { lng: Bt(r, this._coordinatePrecision), lat: Bt(i, this._coordinatePrecision), containerX: o, containerY: a, button: s, heldKeys: l, isContextMenu: t };
  }
  register(e) {
    this._currentModeCallbacks = e, this._listeners = this.getAdapterListeners(), this._listeners.forEach((t) => {
      t.register();
    });
  }
  getCoordinatePrecision() {
    return this._coordinatePrecision;
  }
  getAdapterListeners() {
    return [new ts({ name: "pointerdown", callback: (e) => {
      if (!this._currentModeCallbacks || !e.isPrimary)
        return;
      const t = this.getDrawEventFromEvent(e);
      t && (this._dragState = "pre-dragging", this._lastDrawEvent = t);
    }, register: (e) => {
      this.getMapEventElement().addEventListener("pointerdown", e);
    }, unregister: (e) => {
      this.getMapEventElement().removeEventListener("pointerdown", e);
    } }), new ts({ name: "pointermove", callback: (e) => {
      if (!this._currentModeCallbacks || !e.isPrimary)
        return;
      e.preventDefault();
      const t = this.getDrawEventFromEvent(e);
      if (t)
        if (this._dragState === "not-dragging")
          this._currentModeCallbacks.onMouseMove(t), this._lastDrawEvent = t;
        else if (this._dragState === "pre-dragging") {
          if (!this._lastDrawEvent)
            return;
          const n = { x: this._lastDrawEvent.containerX, y: this._lastDrawEvent.containerY }, r = { x: t.containerX, y: t.containerY }, i = this._currentModeCallbacks.getState(), o = fa(n, r);
          let a = !1;
          if (a = i === "drawing" ? o < this._minPixelDragDistanceDrawing : i === "selecting" ? o < this._minPixelDragDistanceSelecting : o < this._minPixelDragDistance, a)
            return;
          this._nextKeyUpIsContextMenu = !1, this._dragState = "dragging", this._currentModeCallbacks.onDragStart(t, (s) => {
            this.setDraggability.bind(this)(s);
          });
        } else
          this._dragState === "dragging" && this._currentModeCallbacks.onDrag(t, (n) => {
            this.setDraggability.bind(this)(n);
          });
    }, register: (e) => {
      this.getMapEventElement().addEventListener("pointermove", e);
    }, unregister: (e) => {
      this.getMapEventElement().removeEventListener("pointermove", e);
    } }), new ts({ name: "contextmenu", callback: (e) => {
      this._currentModeCallbacks && (e.preventDefault(), this._nextKeyUpIsContextMenu = !0);
    }, register: (e) => {
      this.getMapEventElement().addEventListener("contextmenu", e);
    }, unregister: (e) => {
      this.getMapEventElement().removeEventListener("contextmenu", e);
    } }), new ts({ name: "pointerup", callback: (e) => {
      if (!this._currentModeCallbacks || e.target !== this.getMapEventElement() || !e.isPrimary)
        return;
      const t = this.getDrawEventFromEvent(e);
      t && (this._dragState === "dragging" ? this._currentModeCallbacks.onDragEnd(t, (n) => {
        this.setDraggability.bind(this)(n);
      }) : this._dragState !== "not-dragging" && this._dragState !== "pre-dragging" || (this._nextKeyUpIsContextMenu && (t.isContextMenu = !0, this._nextKeyUpIsContextMenu = !1), this._currentModeCallbacks.onClick(t)), this._dragState = "not-dragging", this.setDraggability(!0));
    }, register: (e) => {
      this.getMapEventElement().addEventListener("pointerup", e);
    }, unregister: (e) => {
      this.getMapEventElement().removeEventListener("pointerup", e);
    } }), new ts({ name: "keyup", callback: (e) => {
      this._currentModeCallbacks && (this._heldKeys.delete(e.key), this._currentModeCallbacks.onKeyUp({ key: e.key, heldKeys: Array.from(this._heldKeys), preventDefault: () => e.preventDefault() }));
    }, register: (e) => {
      this.getMapEventElement().addEventListener("keyup", e);
    }, unregister: (e) => {
      this.getMapEventElement().removeEventListener("keyup", e);
    } }), new ts({ name: "keydown", callback: (e) => {
      this._currentModeCallbacks && (this._heldKeys.add(e.key), this._currentModeCallbacks.onKeyDown({ key: e.key, heldKeys: Array.from(this._heldKeys), preventDefault: () => e.preventDefault() }));
    }, register: (e) => {
      this.getMapEventElement().addEventListener("keydown", e);
    }, unregister: (e) => {
      this.getMapEventElement().removeEventListener("keydown", e);
    } })];
  }
  unregister() {
    this._listeners.forEach((e) => {
      e.unregister();
    }), this.clear(), this._currentModeCallbacks = void 0;
  }
}, getDefaultStyling: () => ({ polygonFillColor: "#3f97e0", polygonOutlineColor: "#3f97e0", polygonOutlineWidth: 4, polygonFillOpacity: 0.3, pointColor: "#3f97e0", pointOutlineColor: "#ffffff", pointOutlineWidth: 0, pointWidth: 6, lineStringColor: "#3f97e0", lineStringWidth: 4, zIndex: 0 }), SELECT_PROPERTIES: fn };
function S0(e) {
  if (e === null || typeof e == "boolean" || typeof e == "string")
    return !0;
  if (e === void 0)
    return !1;
  if (typeof e == "number")
    return Number.isFinite(e);
  if (typeof e == "bigint" || typeof e == "symbol" || typeof e == "function" || e instanceof RegExp || e instanceof Map || e instanceof Set || e instanceof Date)
    return !1;
  if (typeof e == "object" && e !== null && !Array.isArray(e)) {
    const t = Object.getPrototypeOf(e);
    if (t !== Object.prototype && t !== null)
      return !1;
  }
  if (ArrayBuffer.isView(e) && !(e instanceof DataView))
    return !1;
  if (Array.isArray(e)) {
    for (const t of e)
      if (!S0(t))
        return !1;
  }
  return typeof e == "object" && Object.keys(e).every((t) => typeof t == "string" && S0(e[t]));
}
class eie {
  constructor(t) {
    this._modes = void 0, this._mode = void 0, this._adapter = void 0, this._enabled = !1, this._store = void 0, this._eventListeners = void 0, this._instanceSelectMode = void 0, this._adapter = t.adapter, this._mode = new Gre();
    const n = /* @__PURE__ */ new Set(), r = t.modes.reduce((d, f) => {
      if (n.has(f.mode))
        throw new Error(`There is already a ${f.mode} mode provided`);
      return n.add(f.mode), d[f.mode] = f, d;
    }, {}), i = Object.keys(r);
    if (i.length === 0)
      throw new Error("No modes provided");
    i.forEach((d) => {
      if (r[d].type === Ds.Select) {
        if (this._instanceSelectMode)
          throw new Error("only one type of select mode can be provided");
        this._instanceSelectMode = d;
      }
    }), this._modes = en({}, r, { static: this._mode }), this._eventListeners = { change: [], select: [], deselect: [], finish: [], ready: [] }, this._store = new wT({ tracked: !!t.tracked, idStrategy: t.idStrategy ? t.idStrategy : void 0 });
    const o = (d) => {
      const f = [], p = this._store.copyAll().filter((m) => !d.includes(m.id) || (f.push(m), !1));
      return { changed: f, unchanged: p };
    }, a = (d, f) => {
      this._enabled && this._eventListeners.finish.forEach((p) => {
        p(d, f);
      });
    }, s = (d, f, p) => {
      if (!this._enabled)
        return;
      this._eventListeners.change.forEach((v) => {
        v(d, f, p);
      });
      const { changed: m, unchanged: g } = o(d);
      f === "create" ? this._adapter.render({ created: m, deletedIds: [], unchanged: g, updated: [] }, this.getModeStyles()) : f === "update" ? this._adapter.render({ created: [], deletedIds: [], unchanged: g, updated: m }, this.getModeStyles()) : f === "delete" ? this._adapter.render({ created: [], deletedIds: d, unchanged: g, updated: [] }, this.getModeStyles()) : f === "styling" && this._adapter.render({ created: [], deletedIds: [], unchanged: g, updated: [] }, this.getModeStyles());
    }, l = (d) => {
      if (!this._enabled)
        return;
      this._eventListeners.select.forEach((m) => {
        m(d);
      });
      const { changed: f, unchanged: p } = o([d]);
      this._adapter.render({ created: [], deletedIds: [], unchanged: p, updated: f }, this.getModeStyles());
    }, u = (d) => {
      if (!this._enabled)
        return;
      this._eventListeners.deselect.forEach((m) => {
        m();
      });
      const { changed: f, unchanged: p } = o([d]);
      f && this._adapter.render({ created: [], deletedIds: [], unchanged: p, updated: f }, this.getModeStyles());
    };
    Object.keys(this._modes).forEach((d) => {
      this._modes[d].register({ mode: d, store: this._store, setCursor: this._adapter.setCursor.bind(this._adapter), project: this._adapter.project.bind(this._adapter), unproject: this._adapter.unproject.bind(this._adapter), setDoubleClickToZoom: this._adapter.setDoubleClickToZoom.bind(this._adapter), onChange: s, onSelect: l, onDeselect: u, onFinish: a, coordinatePrecision: this._adapter.getCoordinatePrecision() });
    });
  }
  checkEnabled() {
    if (!this._enabled)
      throw new Error("Terra Draw is not enabled");
  }
  getModeStyles() {
    const t = {};
    return Object.keys(this._modes).forEach((n) => {
      t[n] = (r) => this._instanceSelectMode && r.properties[fn.SELECTED] ? this._modes[this._instanceSelectMode].styleFeature.bind(this._modes[this._instanceSelectMode])(r) : this._modes[n].styleFeature.bind(this._modes[n])(r);
    }), t;
  }
  featuresAtLocation({ lng: t, lat: n }, r) {
    const i = r && r.pointerDistance !== void 0 ? r.pointerDistance : 30, o = !r || r.ignoreSelectFeatures === void 0 || r.ignoreSelectFeatures, a = !(!r || r.ignoreCoordinatePoints === void 0) && r.ignoreCoordinatePoints, s = !(!r || r.ignoreCurrentlyDrawing === void 0) && r.ignoreCurrentlyDrawing, l = !(!r || r.ignoreClosingPoints === void 0) && r.ignoreClosingPoints, u = this._adapter.unproject.bind(this._adapter), d = this._adapter.project.bind(this._adapter), f = d(t, n), p = lT({ unproject: u, point: f, pointerDistance: i });
    return this._store.search(p).filter((m) => {
      if (o && (m.properties[fn.MID_POINT] || m.properties[fn.SELECTION_POINT]) || a && m.properties[tt.COORDINATE_POINT] || l && m.properties[tt.CLOSING_POINT] || s && m.properties[tt.CURRENTLY_DRAWING])
        return !1;
      if (m.geometry.type === "Point") {
        const g = m.geometry.coordinates, v = d(g[0], g[1]);
        return fa(f, v) < i;
      }
      if (m.geometry.type === "LineString") {
        const g = m.geometry.coordinates;
        for (let v = 0; v < g.length - 1; v++) {
          const y = g[v], b = g[v + 1];
          if (E0(f, d(y[0], y[1]), d(b[0], b[1])) < i)
            return !0;
        }
        return !1;
      }
      if (mT([t, n], m.geometry.coordinates))
        return !0;
      if (r != null && r.includePolygonsWithinPointerDistance) {
        const g = m.geometry.coordinates;
        for (const v of g)
          for (let y = 0; y < v.length - 1; y++) {
            const b = v[y], E = v[y + 1], S = d(b[0], b[1]), _ = d(E[0], E[1]);
            if (E0(f, S, _) < i)
              return !0;
          }
      }
      return !1;
    });
  }
  getSelectModeOrThrow() {
    const t = this.getSelectMode({ switchToSelectMode: !0 });
    if (!t)
      throw new Error("No select mode defined in instance");
    return t;
  }
  getSelectMode({ switchToSelectMode: t }) {
    if (this.checkEnabled(), !this._instanceSelectMode)
      return null;
    const n = this.getMode();
    return t && n !== this._instanceSelectMode && this.setMode(this._instanceSelectMode), this._modes[this._instanceSelectMode];
  }
  isGuidanceFeature(t) {
    return !!(t.properties[fn.MID_POINT] || t.properties[fn.SELECTION_POINT] || t.properties[tt.COORDINATE_POINT] || t.properties[tt.SNAPPING_POINT]);
  }
  setModeStyles(t, n) {
    if (this.checkEnabled(), !this._modes[t])
      throw new Error("No mode with this name present");
    this._modes[t].styles = n;
  }
  updateModeOptions(t, n) {
    if (this.checkEnabled(), !this._modes[t])
      throw new Error("No mode with this name present");
    this._modes[t].updateOptions(n);
  }
  getSnapshot() {
    return this._store.copyAll();
  }
  getSnapshotFeature(t) {
    if (this._store.has(t))
      return this._store.copy(t);
  }
  clear() {
    this.checkEnabled(), this._adapter.clear();
  }
  get enabled() {
    return this._enabled;
  }
  set enabled(t) {
    throw new Error("Enabled is read only");
  }
  getMode() {
    return this._mode.mode;
  }
  getModeState() {
    return this._mode.state;
  }
  setMode(t) {
    if (this.checkEnabled(), !this._modes[t])
      throw new Error("No mode with this name present");
    this._mode.stop(), this._mode = this._modes[t], this._mode.start();
  }
  removeFeatures(t) {
    this.checkEnabled();
    const n = [];
    t.forEach((r) => {
      if (!this._store.has(r))
        throw new Error(`No feature with id ${r}, can not delete`);
      const i = this._store.copy(r);
      i.properties[fn.SELECTED] && this.deselectFeature(r), i.properties[tt.COORDINATE_POINT_IDS] && n.push(...i.properties[tt.COORDINATE_POINT_IDS]);
    }), this._store.delete([...t, ...n], { origin: "api" });
  }
  selectFeature(t) {
    this.getSelectModeOrThrow().selectFeature(t);
  }
  deselectFeature(t) {
    this.getSelectModeOrThrow().deselectFeature(t);
  }
  getFeatureId() {
    return this._store.getId();
  }
  hasFeature(t) {
    return this._store.has(t);
  }
  checkIsReservedProperty(t) {
    return ![...Object.values(fn), ...Object.values(tt)].includes(t);
  }
  updateFeatureProperties(t, n) {
    if (!this._store.has(t))
      throw new Error(`No feature with id ${t} present in store`);
    const r = this._store.copy(t);
    if (this.isGuidanceFeature(r))
      throw new Error("Guidance features are not allowed to be updated directly.");
    const i = r.properties.mode;
    if (!this._modes[i])
      throw new Error(`No mode with name ${i} present in instance`);
    const o = Object.entries(n);
    o.forEach(([a, s]) => {
      if (!this.checkIsReservedProperty(a))
        throw new Error(`You are trying to update a reserved property name: ${a}. Please choose another name.`);
      if (s !== void 0 && !S0(s))
        throw new Error(`Invalid JSON value provided for property ${a}`);
    }), this._store.updateProperty(o.map(([a, s]) => ({ id: r.id, property: a, value: s })), { origin: "api" });
  }
  updateFeatureGeometry(t, n) {
    if (!this._store.has(t))
      throw new Error(`No feature with id ${t} present in store`);
    const r = this._store.copy(t);
    if (this.isGuidanceFeature(r))
      throw new Error("Guidance features are not allowed to be updated directly.");
    if (!(r && n && n.type && n.coordinates))
      throw new Error("Invalid geometry provided");
    if (n.type !== r.geometry.type)
      throw new Error(`Geometry type mismatch: expected ${r.geometry.type}, got ${n.type}`);
    const i = r.properties.mode, o = this._modes[i];
    if (!o)
      throw new Error(`No mode with name ${i} present in instance`);
    const a = en({}, r, { geometry: n }), s = o.validateFeature(a);
    if (!s.valid)
      throw new Error(`Feature validation failed: ${s.reason || "Unknown reason"}`);
    if (this._store.updateGeometry([{ id: r.id, geometry: n }], { origin: "api" }), o.afterFeatureUpdated) {
      o.afterFeatureUpdated(a);
      const l = a.properties[fn.SELECTED], u = this.getSelectMode({ switchToSelectMode: !1 });
      u && l && u.afterFeatureUpdated(a);
    }
  }
  transformFeatureGeometry(t, n) {
    if (!this._store.has(t))
      throw new Error(`No feature with id ${t} present in store`);
    let r = this._store.copy(t);
    if (this.isGuidanceFeature(r))
      throw new Error("Guidance features are not allowed to be updated directly.");
    const i = r.properties.mode, o = this._modes[i];
    if (!o)
      throw new Error(`No mode with name ${i} present in instance`);
    let a;
    if (r.geometry.type === "Polygon")
      a = r.geometry.coordinates[0];
    else {
      if (r.geometry.type !== "LineString")
        throw new Error(`Feature geometry type ${r.geometry.type} is not supported for transformation`);
      a = r.geometry.coordinates;
    }
    if (n.projection != "web-mercator")
      throw new Error(`Projection ${n.projection} is not currently supported for transformation`);
    if (n.type === "scale") {
      const { x: s, y: l } = $t(n.origin[0], n.origin[1]);
      vT({ coordinates: a, originX: s, originY: l, xScale: n.options.xScale || 1, yScale: n.options.yScale || 1 });
    } else
      n.type === "rotate" && (r = gT(r, n.options.angle || 0), a = r.geometry.type === "Polygon" ? r.geometry.coordinates[0] : r.geometry.coordinates);
    if (a = a.map((s) => [Bt(s[0], this._adapter.getCoordinatePrecision()), Bt(s[1], this._adapter.getCoordinatePrecision())]), r.geometry.coordinates = r.geometry.type === "Polygon" ? [a] : a, this._store.updateGeometry([{ id: r.id, geometry: r.geometry }], { origin: "api" }), o.afterFeatureUpdated) {
      o.afterFeatureUpdated(r);
      const s = r.properties[fn.SELECTED], l = this.getSelectMode({ switchToSelectMode: !1 });
      l && s && l.afterFeatureUpdated(r);
    }
  }
  addFeatures(t) {
    return this.checkEnabled(), t.length === 0 ? [] : this._store.load(t, (n) => {
      if (XE(n)) {
        const r = n.properties.mode, i = this._modes[r];
        if (!i)
          return { id: n.id, valid: !1, reason: `${r} mode is not in the list of instantiated modes` };
        const o = i.validateFeature.bind(i)(n);
        return { id: n.id, valid: o.valid, reason: o.reason ? o.reason : o.valid ? void 0 : "Feature is invalid" };
      }
      return { id: n.id, valid: !1, reason: "Mode property does not exist" };
    }, (n) => {
      if (XE(n)) {
        const r = this._modes[n.properties.mode];
        r && r.afterFeatureAdded && r.afterFeatureAdded(n);
      }
    }, { origin: "api" });
  }
  start() {
    this._enabled || (this._enabled = !0, this._adapter.register({ onReady: () => {
      this._eventListeners.ready.forEach((t) => {
        t();
      });
    }, getState: () => this._mode.state, onClick: (t) => {
      this._mode.onClick(t);
    }, onMouseMove: (t) => {
      this._mode.onMouseMove(t);
    }, onKeyDown: (t) => {
      this._mode.onKeyDown(t);
    }, onKeyUp: (t) => {
      this._mode.onKeyUp(t);
    }, onDragStart: (t, n) => {
      this._mode.onDragStart(t, n);
    }, onDrag: (t, n) => {
      this._mode.onDrag(t, n);
    }, onDragEnd: (t, n) => {
      this._mode.onDragEnd(t, n);
    }, onClear: () => {
      this._mode.cleanUp(), this._store.clear();
    } }));
  }
  getFeaturesAtLngLat(t, n) {
    const { lng: r, lat: i } = t;
    return this.featuresAtLocation({ lng: r, lat: i }, n);
  }
  getFeaturesAtPointerEvent(t, n) {
    const r = this._adapter.getLngLatFromEvent.bind(this._adapter)(t);
    return r === null ? [] : this.featuresAtLocation(r, n);
  }
  stop() {
    this._enabled && (this._enabled = !1, this._adapter.unregister());
  }
  on(t, n) {
    const r = this._eventListeners[t];
    r.includes(n) || r.push(n);
  }
  off(t, n) {
    const r = this._eventListeners[t];
    r.includes(n) && r.splice(r.indexOf(n), 1);
  }
}
class tie extends Jre.TerraDrawBaseAdapter {
  constructor(t) {
    if (super(t), this._cursor = void 0, this._cursorStyleSheet = void 0, this._lib = void 0, this._map = void 0, this._overlay = void 0, this._clickEventListener = void 0, this._mouseMoveEventListener = void 0, this._readyCalled = !1, this.renderedFeatureIds = /* @__PURE__ */ new Set(), this._lib = t.lib, this._map = t.map, !this._map.getDiv().id)
      throw new Error("Google Map container div requires and id to be set");
    this._coordinatePrecision = typeof t.coordinatePrecision == "number" ? t.coordinatePrecision : 9;
  }
  get _layers() {
    var t;
    return ((t = this.renderedFeatureIds) == null ? void 0 : t.size) > 0;
  }
  circlePath(t, n, r) {
    const i = 2 * r;
    return `M ${t} ${n} m -${r}, 0 a ${r},${r} 0 1,0 ${i},0 a ${r},${r} 0 1,0 -${i},0`;
  }
  register(t) {
    super.register(t), this._overlay = new this._lib.OverlayView(), this._overlay.draw = function() {
    }, this._overlay.onAdd = () => {
      var n;
      (n = this._currentModeCallbacks) != null && n.onReady && !this._readyCalled && (this._currentModeCallbacks.onReady(), this._readyCalled = !0);
    }, this._overlay.setMap(this._map), this._overlay.onRemove = () => {
    }, this._clickEventListener = this._map.data.addListener("click", (n) => {
      const r = this._listeners.find(({ name: i }) => i === "click");
      r && r.callback(n);
    }), this._mouseMoveEventListener = this._map.data.addListener("mousemove", (n) => {
      const r = this._listeners.find(({ name: i }) => i === "mousemove");
      r && r.callback(n);
    });
  }
  unregister() {
    var t, n;
    super.unregister(), (t = this._clickEventListener) == null || t.remove(), (n = this._mouseMoveEventListener) == null || n.remove(), this._overlay && this._overlay.getMap() && this._overlay.setMap(null), this._overlay = void 0, this._readyCalled = !1;
  }
  getLngLatFromEvent(t) {
    if (!this._overlay)
      throw new Error("cannot get overlay");
    const n = this._map.getBounds();
    if (!n)
      return null;
    const r = n.getNorthEast(), i = n.getSouthWest(), o = new this._lib.LatLngBounds(i, r), a = this._map.getDiv(), s = t.clientX - a.getBoundingClientRect().left, l = t.clientY - a.getBoundingClientRect().top, u = new this._lib.Point(s, l), d = this._overlay.getProjection();
    if (!d)
      return null;
    const f = d.fromContainerPixelToLatLng(u);
    return f && o.contains(f) ? { lng: f.lng(), lat: f.lat() } : null;
  }
  getMapEventElement() {
    return this._map.getDiv().querySelector('div[style*="z-index: 3;"]');
  }
  project(t, n) {
    if (!this._overlay)
      throw new Error("cannot get overlay");
    if (this._map.getBounds() === void 0)
      throw new Error("cannot get bounds");
    const r = this._overlay.getProjection();
    if (r === void 0)
      throw new Error("cannot get projection");
    const i = r.fromLatLngToContainerPixel(new this._lib.LatLng(n, t));
    if (i === null)
      throw new Error("cannot project coordinates");
    return { x: i.x, y: i.y };
  }
  unproject(t, n) {
    if (!this._overlay)
      throw new Error("cannot get overlay");
    const r = this._overlay.getProjection();
    if (r === void 0)
      throw new Error("cannot get projection");
    const i = r.fromContainerPixelToLatLng(new this._lib.Point(t, n));
    if (i === null)
      throw new Error("cannot unproject coordinates");
    return { lng: i.lng(), lat: i.lat() };
  }
  setCursor(t) {
    if (t !== this._cursor) {
      if (this._cursorStyleSheet && (this._cursorStyleSheet.remove(), this._cursorStyleSheet = void 0), t !== "unset") {
        const n = this._map.getDiv(), r = document.querySelector(`#${n.id} .gm-style > div`);
        if (r) {
          r.classList.add("terra-draw-google-maps");
          const i = document.createElement("style");
          i.innerHTML = `.terra-draw-google-maps { cursor: ${t} !important; }`, document.getElementsByTagName("head")[0].appendChild(i), this._cursorStyleSheet = i;
        }
      }
      this._cursor = t;
    }
  }
  setDoubleClickToZoom(t) {
    this._map.setOptions(t ? { disableDoubleClickZoom: !1 } : { disableDoubleClickZoom: !0 });
  }
  setDraggability(t) {
    this._map.setOptions({ draggable: t });
  }
  render(t, n) {
    this._layers && (t.deletedIds.forEach((i) => {
      const o = this._map.data.getFeatureById(i);
      o && (this._map.data.remove(o), this.renderedFeatureIds.delete(i));
    }), t.updated.forEach((i) => {
      if (!i || !i.id)
        throw new Error("Feature is not valid");
      const o = this._map.data.getFeatureById(i.id);
      if (!o)
        throw new Error("Feature could not be found by Google Maps API");
      switch (o.forEachProperty((a, s) => {
        o.setProperty(s, void 0);
      }), Object.keys(i.properties).forEach((a) => {
        o.setProperty(a, i.properties[a]);
      }), i.geometry.type) {
        case "Point":
          {
            const a = i.geometry.coordinates;
            o.setGeometry(new this._lib.Data.Point(new this._lib.LatLng(a[1], a[0])));
          }
          break;
        case "LineString":
          {
            const a = i.geometry.coordinates, s = [];
            for (let l = 0; l < a.length; l++) {
              const u = a[l], d = new this._lib.LatLng(u[1], u[0]);
              s.push(d);
            }
            o.setGeometry(new this._lib.Data.LineString(s));
          }
          break;
        case "Polygon": {
          const a = i.geometry.coordinates, s = [];
          for (let l = 0; l < a.length; l++) {
            const u = [];
            for (let d = 0; d < a[l].length; d++) {
              const f = new this._lib.LatLng(a[l][d][1], a[l][d][0]);
              u.push(f);
            }
            s.push(u);
          }
          o.setGeometry(new this._lib.Data.Polygon(s));
        }
      }
    }), t.created.forEach((i) => {
      this.renderedFeatureIds.add(i.id), this._map.data.addGeoJson(i);
    })), t.created.forEach((i) => {
      this.renderedFeatureIds.add(i.id);
    });
    const r = { type: "FeatureCollection", features: [...t.created] };
    this._map.data.addGeoJson(r), this._map.data.setStyle((i) => {
      const o = i.getProperty("mode"), a = i.getGeometry();
      if (!a)
        throw new Error("Google Maps geometry not found");
      const s = a.getType(), l = {}, u = i.getId();
      i.forEachProperty((f, p) => {
        l[p] = f;
      });
      const d = n[o]({ type: "Feature", id: u, geometry: { type: s, coordinates: [] }, properties: l });
      switch (s) {
        case "Point":
          return { clickable: !1, icon: { path: this.circlePath(0, 0, d.pointWidth), fillColor: d.pointColor, fillOpacity: 1, strokeColor: d.pointOutlineColor, strokeWeight: d.pointOutlineWidth, rotation: 0, scale: 1 }, zIndex: d.zIndex };
        case "LineString":
          return { strokeColor: d.lineStringColor, strokeWeight: d.lineStringWidth, zIndex: d.zIndex };
        case "Polygon":
          return { strokeColor: d.polygonOutlineColor, strokeWeight: d.polygonOutlineWidth, fillOpacity: d.polygonFillOpacity, fillColor: d.polygonFillColor, zIndex: d.zIndex };
      }
      throw Error("Unknown feature type");
    });
  }
  clearLayers() {
    this._layers && (this._map.data.forEach((t) => {
      const n = t.getId();
      this.renderedFeatureIds.has(n) && this._map.data.remove(t);
    }), this.renderedFeatureIds = /* @__PURE__ */ new Set());
  }
  clear() {
    this._currentModeCallbacks && (this._currentModeCallbacks.onClear(), this.clearLayers());
  }
  getCoordinatePrecision() {
    return super.getCoordinatePrecision();
  }
}
function nie({
  terraDraw: e,
  setTerraDraw: t,
  onDrawFinish: n,
  map_id: r
}) {
  const i = Gh(r);
  i && (i.getDiv().id = r);
  const [o, a] = x.useState("select");
  let s = null;
  return o === "polygon" && (s = "Double click last point or click the starting point to close a polygon"), ["circle", "rectangle"].includes(o) && (s = `Click the map to start drawing a ${o}, move mouse to adjust size`), be(() => {
    e == null || e.setMode(o);
  }, [o, e]), be(() => {
    if (!i)
      return;
    const l = i.addListener("projection_changed", () => {
      const u = new eie({
        adapter: new tie({
          lib: google.maps,
          map: i,
          coordinatePrecision: 9
        }),
        modes: [
          new Hre({
            flags: {
              circle: {
                feature: {
                  draggable: !0,
                  coordinates: {
                    draggable: !1
                  }
                }
              },
              rectangle: {
                feature: {
                  draggable: !0,
                  coordinates: {
                    draggable: !0
                  }
                }
              },
              polygon: {
                feature: {
                  draggable: !0,
                  coordinates: {
                    draggable: !0
                  }
                }
              }
            }
          }),
          new Ire({
            styles: { outlineWidth: 2, fillOpacity: 0.3 }
          }),
          new Mre({
            styles: { outlineWidth: 2, fillOpacity: 0.3 }
          }),
          new Cre({
            styles: { outlineWidth: 2, fillOpacity: 0.3 }
          })
        ]
      });
      u.start(), u.on("finish", () => {
        const d = u.getSnapshot().filter((f) => f.geometry.type === "Polygon");
        n(d);
      }), t(u);
    });
    return () => {
      l && l.remove();
    };
  }, [i, e, t, n]), /* @__PURE__ */ x.createElement(x.Fragment, null, s ? /* @__PURE__ */ x.createElement("div", { className: "ai-tw-absolute ai-tw-right-3 ai-tw-top-3 ai-tw-flex ai-tw-max-w-md ai-tw-items-center ai-tw-gap-2 ai-tw-rounded ai-tw-border ai-tw-border-blue-50 ai-tw-bg-blue-10 ai-tw-p-2 ai-tw-text-blue-50 ai-tw-subtitle-sm" }, /* @__PURE__ */ x.createElement(Le, { icon: sS, className: "ai-tw-text-blue-50" }), /* @__PURE__ */ x.createElement("span", null, s)) : null, /* @__PURE__ */ x.createElement("div", { className: "ai-tw-absolute ai-tw-left-48 ai-tw-top-2.5 ai-tw-flex ai-tw-h-10 ai-tw-overflow-hidden ai-tw-rounded-sm ai-tw-bg-white ai-tw-shadow" }, /* @__PURE__ */ x.createElement(
    Tl,
    {
      icon: aL,
      title: "Draw Polygon",
      onClick: () => a("polygon"),
      active: o === "polygon"
    }
  ), /* @__PURE__ */ x.createElement(
    Tl,
    {
      icon: T$,
      title: "Draw Rectangle",
      onClick: () => a("rectangle"),
      active: o === "rectangle"
    }
  ), /* @__PURE__ */ x.createElement(
    Tl,
    {
      icon: z$,
      title: "Draw Circle",
      onClick: () => a("circle"),
      active: o === "circle"
    }
  ), /* @__PURE__ */ x.createElement(
    Tl,
    {
      title: "Select/Move",
      onClick: () => a("select"),
      active: o === "select",
      icon: q$
    }
  ), /* @__PURE__ */ x.createElement(
    Tl,
    {
      onClick: () => {
        e && e.clear(), n([]);
      },
      title: "Clear"
    },
    "Clear"
  )));
}
function Tl({
  icon: e,
  title: t,
  onClick: n,
  active: r,
  children: i,
  ...o
}) {
  return /* @__PURE__ */ x.createElement(
    "button",
    {
      type: "button",
      onClick: n,
      className: ie(
        "ai-tw-flex ai-tw-h-10 ai-tw-items-center ai-tw-justify-center ai-tw-border ai-tw-border-element-primary-alt ai-tw-bg-white ai-tw-p-2 ai-tw-text-content-primary hover:ai-tw-bg-element-primary-subtle hover:ai-tw-shadow-sm",
        "[&:not(:last-child)]:ai-tw-border-r",
        r ? "ai-tw-bg-element-primary-subtle" : ""
      ),
      title: t,
      ...o
    },
    e ? /* @__PURE__ */ x.createElement(Le, { icon: e, className: "ai-tw-h-5 ai-tw-w-5" }) : i
  );
}
function sC({
  children: e
}) {
  return /* @__PURE__ */ x.createElement("div", { className: "ai-tw-absolute ai-tw-right-3 ai-tw-top-1/2 -ai-tw-translate-y-1/2 ai-tw-text-sm ai-tw-text-content-primary-light" }, e);
}
const Zy = ke(
  ({ variant: e = "default", className: t, onClear: n, wrapperClassName: r, ...i }, o) => /* @__PURE__ */ x.createElement(
    "div",
    {
      className: ie(
        "ai-tw-preflight ai-tw-relative ai-tw-flex",
        r
      )
    },
    /* @__PURE__ */ x.createElement(
      "input",
      {
        className: ie(ry({ variant: e }), "ai-tw-pr-8", t),
        ...i,
        ref: o
      }
    ),
    i.value ? null : /* @__PURE__ */ x.createElement(sC, null, /* @__PURE__ */ x.createElement(Le, { icon: tL })),
    i.value ? /* @__PURE__ */ x.createElement(sC, null, /* @__PURE__ */ x.createElement("button", { onClick: n }, /* @__PURE__ */ x.createElement(Le, { icon: Qf }))) : null
  )
);
Zy.displayName = "ClearableInput";
function bT(e, t) {
  const [n, r] = de(e);
  return be(() => {
    const i = setTimeout(() => r(e), t || 500);
    return () => {
      clearTimeout(i);
    };
  }, [e, t]), n;
}
function rie(e) {
  const t = ln(), n = bT(e, 500), r = n.length >= 3 ? `/address-service/area-search?prefix=${encodeURIComponent(n)}` : null;
  async function i() {
    return r ? await t(r) : null;
  }
  return { swr: br(r, i), debouncedValue: n };
}
function iie({
  onAreaSelect: e
}) {
  const [t, n] = x.useState(""), { swr: r, debouncedValue: i } = rie(t), { isLoading: o } = r || {}, a = o || t.length > 0, s = x.useCallback(
    (l) => {
      e(l), n("");
    },
    [e, n]
  );
  return /* @__PURE__ */ x.createElement(LP, { open: a }, /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-max-w-2xl ai-tw-items-center" }, /* @__PURE__ */ x.createElement(_X, { asChild: !0 }, /* @__PURE__ */ x.createElement(
    Zy,
    {
      wrapperClassName: "ai-tw-w-full",
      placeholder: "Search by state, county, city, zip/postal code, or neighborhood",
      onClear: () => n(""),
      value: t,
      onChange: (l) => n(l.target.value)
    }
  )), /* @__PURE__ */ x.createElement(
    Oh,
    {
      onOpenAutoFocus: (l) => l.preventDefault(),
      className: "ai-tw-preflight ai-tw-max-h-[400px] ai-tw-w-[--radix-popover-trigger-width] ai-tw-overflow-auto ai-tw-p-0"
    },
    /* @__PURE__ */ x.createElement(
      oie,
      {
        isLoading: o,
        prefix: i,
        results: r.data,
        onSelect: s
      }
    )
  )));
}
function oie({
  isLoading: e,
  prefix: t,
  results: n,
  onSelect: r
}) {
  return e ? /* @__PURE__ */ x.createElement("div", { className: "ai-tw-p-1" }, Array.from({ length: 5 }).map((o, a) => /* @__PURE__ */ x.createElement(
    yf,
    {
      key: a,
      className: ie(
        "ai-tw-mb-2 ai-tw-h-8 ai-tw-w-full",
        a === 2 && "ai-tw-mb-0"
      )
    }
  ))) : t.length < 3 ? /* @__PURE__ */ x.createElement("div", { className: "ai-tw-p-3 ai-tw-text-center ai-tw-text-sm ai-tw-text-muted-foreground" }, "Please enter at least 3 characters to search.") : n && Object.values(n).some((o) => o.length > 0) ? /* @__PURE__ */ x.createElement("div", { id: "service-area-search-results" }, Object.entries(n).map(([o, a]) => /* @__PURE__ */ x.createElement("div", { key: o }, /* @__PURE__ */ x.createElement("h4", { className: "ai-tw-flex ai-tw-w-full ai-tw-p-2 ai-tw-font-semibold ai-tw-capitalize" }, o), a.map((s) => /* @__PURE__ */ x.createElement(
    "button",
    {
      role: "option",
      className: "ai-tw-flex ai-tw-w-full ai-tw-cursor-pointer ai-tw-p-2 hover:ai-tw-bg-element-primary-subtle-light ",
      key: s.id,
      onMouseDown: (l) => l.preventDefault(),
      onClick: () => r(s),
      onKeyDown: (l) => {
        (l.key === "Enter" || l.key === " ") && (l.preventDefault(), r(s));
      }
    },
    s.name
  ))))) : /* @__PURE__ */ x.createElement("div", { className: "ai-tw-p-3 ai-tw-text-center ai-tw-text-sm ai-tw-text-muted-foreground" }, "No results found.");
}
function wg(e, t) {
  if (!(!t || !e))
    if (eT(t)) {
      const n = new google.maps.LatLngBounds();
      t.polygons.forEach((r) => {
        r.getPath().forEach((i) => {
          n.extend(i);
        });
      }), e.fitBounds(n);
    } else {
      const n = new google.maps.LatLngBounds();
      n.extend({
        lat: t.boundingBox.minLatitude,
        lng: t.boundingBox.minLongitude
      }), n.extend({
        lat: t.boundingBox.maxLatitude,
        lng: t.boundingBox.maxLongitude
      }), e.fitBounds(n);
    }
}
function lC(e, t, n) {
  const r = [];
  return n.forEach((i) => {
    const o = "uuid" in i ? i.uuid : i.id, a = i.geometry.type === "Polygon" ? i.geometry.coordinates : i.geometry.coordinates.flat(), s = [];
    a.forEach((l) => {
      const u = new t.Polygon({
        paths: l.map(([d, f]) => ({ lng: d, lat: f })),
        strokeWeight: 2,
        fillOpacity: 0.3,
        strokeOpacity: 0.9,
        fillColor: "#59C4C4",
        strokeColor: "#59C4C4"
      });
      u.setMap(e), s.push(u);
    }), r.push({ id: o, name: i.name, polygons: s });
  }), r;
}
function aie({
  label: e,
  onRemove: t
}) {
  return /* @__PURE__ */ C.createElement("div", { className: "ai-tw-inline-flex ai-tw-items-center ai-tw-gap-2 ai-tw-rounded-full ai-tw-bg-element-primary-subtle ai-tw-px-2 ai-tw-py-1 ai-tw-text-content-primary ai-tw-tag" }, /* @__PURE__ */ C.createElement("span", null, e), t && /* @__PURE__ */ C.createElement(sie, { onClick: t }));
}
function sie({
  onClick: e,
  className: t,
  ...n
}) {
  return /* @__PURE__ */ C.createElement(
    "button",
    {
      type: "button",
      onClick: e,
      className: ie(
        "ai-tw-grid ai-tw-h-4 ai-tw-w-4 ai-tw-place-items-center ai-tw-rounded-full ai-tw-bg-transparent hover:ai-tw-bg-element-primary-subtle-darkest active:ai-tw-bg-element-primary-bold-light active:ai-tw-text-white",
        t
      ),
      ...n
    },
    /* @__PURE__ */ C.createElement(Le, { className: "ai-tw-h-3 ai-tw-w-3", icon: nL })
  );
}
const lie = "AIzaSyDtAhuJZGjruRbzXJBs1lLIJ9DkC0CglXo", bg = "gabbi-map";
function xT({
  initial_map_center: e = { lat: 48.74908, lng: -122.478147 },
  // Default to Bellingham, WA
  saved_service_areas: t,
  serviceAreaUpdates: n,
  setServiceAreaUpdates: r,
  terraDraw: i,
  setTerraDraw: o
}) {
  return /* @__PURE__ */ x.createElement(Nne, { apiKey: lie }, /* @__PURE__ */ x.createElement("div", { className: "ai-tw-h-auto ai-tw-w-full ai-tw-overflow-hidden ai-tw-rounded-lg" }, /* @__PURE__ */ x.createElement(
    cie,
    {
      initial_map_center: e,
      saved_service_areas: t,
      serviceAreaUpdates: n,
      setServiceAreaUpdates: r,
      terraDraw: i,
      setTerraDraw: o
    }
  )));
}
function cie({
  initial_map_center: e,
  saved_service_areas: t,
  serviceAreaUpdates: n,
  setServiceAreaUpdates: r,
  terraDraw: i,
  setTerraDraw: o
}) {
  const a = J8("maps"), s = Gh(bg), [l, u] = x.useState([]);
  be(() => {
    if (s && a && t) {
      const g = lC(s, a, t);
      u(g), wg(s, g[0]);
    }
  }, [t, s, a]);
  const d = De(
    (g) => {
      if (!a) {
        console.warn("Maps library not loaded yet");
        return;
      }
      if (!s) {
        console.warn("Map instance not available yet");
        return;
      }
      if (l.find((y) => y.id === g.id))
        return;
      const v = lC(s, a, [g]);
      u((y) => [...y, ...v]), wg(s, v[0]), r((y) => [
        ...y,
        {
          update_type: "create",
          id: g.id,
          geometry: g.geometry,
          name: g.name,
          description: g.name
        }
      ]);
    },
    [a, s, l, r]
  );
  function f(g) {
    const v = n.filter((b) => b.update_type === "create").map((b) => b.id), y = g.map(() => `User Area_${dre(4)}`);
    r((b) => {
      if (g.length === 0)
        return b.filter((k) => k.update_type !== "create" ? !0 : typeof k.id == "number");
      const E = g.map((k) => k.id), S = b.filter(
        (k) => !(k.update_type === "create" && E.includes(k.id))
      ), _ = g.map((k, T) => ({
        update_type: "create",
        id: k.id,
        geometry: k.geometry,
        name: y[T],
        description: "User defined service area for Gabbi AI agent"
      }));
      return [...S, ..._];
    }), u((b) => {
      if (g.length === 0)
        return b.filter(
          (k) => typeof k.id == "number" || !v.includes(k.id)
        );
      const E = g.map((k) => k.id), S = b.filter((k) => !E.includes(k.id)), _ = g.map((k, T) => ({
        id: k.id,
        name: y[T],
        boundingBox: {
          minLatitude: Math.min(
            ...k.geometry.coordinates[0].map((A) => A[1])
          ),
          minLongitude: Math.min(
            ...k.geometry.coordinates[0].map((A) => A[0])
          ),
          maxLatitude: Math.max(
            ...k.geometry.coordinates[0].map((A) => A[1])
          ),
          maxLongitude: Math.max(
            ...k.geometry.coordinates[0].map((A) => A[0])
          )
        }
      }));
      return [...S, ..._];
    });
  }
  function p(g) {
    s && wg(s, g);
  }
  function m(g, v) {
    g.stopPropagation(), eT(v) ? v.polygons.forEach((y) => y.setMap(null)) : i == null || i.removeFeatures([v.id]), u((y) => y.filter((b) => b.id !== v.id)), r((y) => {
      const b = y.findIndex(
        (E) => E.update_type === "create" && E.name === v.name
      );
      return b !== -1 ? y.filter((E, S) => S !== b) : [
        ...y,
        {
          update_type: "delete",
          service_area_id: v.id
        }
      ];
    });
  }
  return /* @__PURE__ */ x.createElement("div", { className: "ai-tw-grid ai-tw-gap-4" }, /* @__PURE__ */ x.createElement("h4", { className: "ai-tw-text-content-primary-light ai-tw-subtitle-md" }, "Service Areas"), /* @__PURE__ */ x.createElement(iie, { onAreaSelect: d }), /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-flex-wrap ai-tw-gap-2" }, l.map((g) => /* @__PURE__ */ x.createElement(
    "div",
    {
      className: "ai-tw-cursor-pointer",
      key: g.id,
      onClick: () => p(g)
    },
    /* @__PURE__ */ x.createElement(
      aie,
      {
        label: g.name,
        onRemove: (v) => m(v, g)
      }
    )
  ))), /* @__PURE__ */ x.createElement("div", { className: "ai-tw-relative ai-tw-mt-4 ai-tw-h-[600px] ai-tw-w-full ai-tw-overflow-hidden ai-tw-rounded-lg ai-tw-fill-content-primary" }, /* @__PURE__ */ x.createElement(
    Q8,
    {
      id: bg,
      defaultZoom: 10,
      defaultCenter: e,
      zoomControl: !0,
      mapTypeControl: !0,
      fullscreenControl: !1,
      disableDefaultUI: !0
    }
  ), /* @__PURE__ */ x.createElement(
    nie,
    {
      map_id: bg,
      terraDraw: i,
      setTerraDraw: o,
      onDrawFinish: f
    }
  )));
}
const ET = "Checkbox", [uie, _ye] = rr(ET), [die, fie] = uie(ET), hie = /* @__PURE__ */ ke((e, t) => {
  const { __scopeCheckbox: n, name: r, checked: i, defaultChecked: o, required: a, disabled: s, value: l = "on", onCheckedChange: u, ...d } = e, [f, p] = de(null), m = Ft(
    t,
    (S) => p(S)
  ), g = me(!1), v = f ? !!f.closest("form") : !0, [y = !1, b] = li({
    prop: i,
    defaultProp: o,
    onChange: u
  }), E = me(y);
  return be(() => {
    const S = f == null ? void 0 : f.form;
    if (S) {
      const _ = () => b(E.current);
      return S.addEventListener("reset", _), () => S.removeEventListener("reset", _);
    }
  }, [
    f,
    b
  ]), /* @__PURE__ */ X(die, {
    scope: n,
    state: y,
    disabled: s
  }, /* @__PURE__ */ X(rt.button, ge({
    type: "button",
    role: "checkbox",
    "aria-checked": ha(y) ? "mixed" : y,
    "aria-required": a,
    "data-state": CT(y),
    "data-disabled": s ? "" : void 0,
    disabled: s,
    value: l
  }, d, {
    ref: m,
    onKeyDown: $e(e.onKeyDown, (S) => {
      S.key === "Enter" && S.preventDefault();
    }),
    onClick: $e(e.onClick, (S) => {
      b(
        (_) => ha(_) ? !0 : !_
      ), v && (g.current = S.isPropagationStopped(), g.current || S.stopPropagation());
    })
  })), v && /* @__PURE__ */ X(gie, {
    control: f,
    bubbles: !g.current,
    name: r,
    value: l,
    checked: y,
    required: a,
    disabled: s,
    style: {
      transform: "translateX(-100%)"
    }
  }));
}), pie = "CheckboxIndicator", mie = /* @__PURE__ */ ke((e, t) => {
  const { __scopeCheckbox: n, forceMount: r, ...i } = e, o = fie(pie, n);
  return /* @__PURE__ */ X(On, {
    present: r || ha(o.state) || o.state === !0
  }, /* @__PURE__ */ X(rt.span, ge({
    "data-state": CT(o.state),
    "data-disabled": o.disabled ? "" : void 0
  }, i, {
    ref: t,
    style: {
      pointerEvents: "none",
      ...e.style
    }
  })));
}), gie = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...i } = e, o = me(null), a = tP(n), s = p1(t);
  return be(() => {
    const l = o.current, u = window.HTMLInputElement.prototype, f = Object.getOwnPropertyDescriptor(u, "checked").set;
    if (a !== n && f) {
      const p = new Event("click", {
        bubbles: r
      });
      l.indeterminate = ha(n), f.call(l, ha(n) ? !1 : n), l.dispatchEvent(p);
    }
  }, [
    a,
    n,
    r
  ]), /* @__PURE__ */ X("input", ge({
    type: "checkbox",
    "aria-hidden": !0,
    defaultChecked: ha(n) ? !1 : n
  }, i, {
    tabIndex: -1,
    ref: o,
    style: {
      ...e.style,
      ...s,
      position: "absolute",
      pointerEvents: "none",
      opacity: 0,
      margin: 0
    }
  }));
};
function ha(e) {
  return e === "indeterminate";
}
function CT(e) {
  return ha(e) ? "indeterminate" : e ? "checked" : "unchecked";
}
const ST = hie, vie = mie, yie = $r(
  "ai-tw-peer ai-tw-h-4 ai-tw-w-4 ai-tw-shrink-0 ai-tw-rounded-[2px] ai-tw-border-2 ai-tw-border-stroke-primary-darkest ai-tw-bg-white ai-tw-ring-offset-background focus-visible:ai-tw-outline-none focus-visible:ai-tw-ring-2 focus-visible:ai-tw-ring-ring focus-visible:ai-tw-ring-offset-2 disabled:ai-tw-opacity-50 data-[state=checked]:ai-tw-text-primary-foreground",
  {
    variants: {
      variant: {
        primary: "hover:enabled:ai-tw-border-primary data-[state=checked]:enabled:ai-tw-border-primary data-[state=checked]:enabled:ai-tw-bg-primary data-[state=checked]:enabled:hover:ai-tw-border-content-brand-dark data-[state=checked]:enabled:hover:ai-tw-bg-content-brand-dark data-[state=checked]:disabled:ai-tw-bg-content-primary-disabled",
        tertiary: "hover:enabled:ai-tw-border-content-primary data-[state=checked]:enabled:ai-tw-border-content-primary data-[state=checked]:enabled:ai-tw-bg-content-primary data-[state=checked]:enabled:hover:ai-tw-border-content-primary data-[state=checked]:enabled:hover:ai-tw-bg-content-primary data-[state=checked]:disabled:ai-tw-bg-content-primary-disabled",
        "ai-primary": "hover:enabled:ai-tw-border-stroke-ai data-[state=checked]:enabled:ai-tw-border-stroke-ai data-[state=checked]:enabled:ai-tw-bg-content-ai data-[state=checked]:enabled:hover:ai-tw-border-content-ai-dark data-[state=checked]:enabled:hover:ai-tw-bg-content-ai-dark data-[state=checked]:disabled:ai-tw-bg-content-ai-disabled"
      }
    }
  }
), Rr = C.forwardRef(({ className: e, variant: t = "primary", ...n }, r) => /* @__PURE__ */ C.createElement(
  ST,
  {
    ref: r,
    className: ie(yie({ variant: t }), e),
    ...n
  },
  /* @__PURE__ */ C.createElement(
    vie,
    {
      className: ie("ai-tw-grid ai-tw-place-items-center ai-tw-text-current")
    },
    /* @__PURE__ */ C.createElement(Le, { icon: gS, className: "ai-tw-h-2.5 ai-tw-w-2.5" })
  )
));
Rr.displayName = ST.displayName;
function wie(e, t, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(i) {
    if (e == null || e(i), n === !1 || !i.defaultPrevented)
      return t == null ? void 0 : t(i);
  };
}
function bie(e, t) {
  typeof e == "function" ? e(t) : e != null && (e.current = t);
}
function _T(...e) {
  return (t) => e.forEach((n) => bie(n, t));
}
function xie(...e) {
  return C.useCallback(_T(...e), e);
}
function Eie(e, t = []) {
  let n = [];
  function r(o, a) {
    const s = C.createContext(a), l = n.length;
    n = [...n, a];
    const u = (f) => {
      var b;
      const { scope: p, children: m, ...g } = f, v = ((b = p == null ? void 0 : p[e]) == null ? void 0 : b[l]) || s, y = C.useMemo(() => g, Object.values(g));
      return /* @__PURE__ */ fe.jsx(v.Provider, { value: y, children: m });
    };
    u.displayName = o + "Provider";
    function d(f, p) {
      var v;
      const m = ((v = p == null ? void 0 : p[e]) == null ? void 0 : v[l]) || s, g = C.useContext(m);
      if (g)
        return g;
      if (a !== void 0)
        return a;
      throw new Error(`\`${f}\` must be used within \`${o}\``);
    }
    return [u, d];
  }
  const i = () => {
    const o = n.map((a) => C.createContext(a));
    return function(s) {
      const l = (s == null ? void 0 : s[e]) || o;
      return C.useMemo(
        () => ({ [`__scope${e}`]: { ...s, [e]: l } }),
        [s, l]
      );
    };
  };
  return i.scopeName = e, [r, Cie(i, ...t)];
}
function Cie(...e) {
  const t = e[0];
  if (e.length === 1)
    return t;
  const n = () => {
    const r = e.map((i) => ({
      useScope: i(),
      scopeName: i.scopeName
    }));
    return function(o) {
      const a = r.reduce((s, { useScope: l, scopeName: u }) => {
        const f = l(o)[`__scope${u}`];
        return { ...s, ...f };
      }, {});
      return C.useMemo(() => ({ [`__scope${t.scopeName}`]: a }), [a]);
    };
  };
  return n.scopeName = t.scopeName, n;
}
function PT(e) {
  const t = C.useRef(e);
  return C.useEffect(() => {
    t.current = e;
  }), C.useMemo(() => (...n) => {
    var r;
    return (r = t.current) == null ? void 0 : r.call(t, ...n);
  }, []);
}
function Sie({
  prop: e,
  defaultProp: t,
  onChange: n = () => {
  }
}) {
  const [r, i] = _ie({ defaultProp: t, onChange: n }), o = e !== void 0, a = o ? e : r, s = PT(n), l = C.useCallback(
    (u) => {
      if (o) {
        const f = typeof u == "function" ? u(e) : u;
        f !== e && s(f);
      } else
        i(u);
    },
    [o, e, i, s]
  );
  return [a, l];
}
function _ie({
  defaultProp: e,
  onChange: t
}) {
  const n = C.useState(e), [r] = n, i = C.useRef(r), o = PT(t);
  return C.useEffect(() => {
    i.current !== r && (o(r), i.current = r);
  }, [r, i, o]), n;
}
function Pie(e) {
  const t = C.useRef({ value: e, previous: e });
  return C.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
var kie = globalThis != null && globalThis.document ? C.useLayoutEffect : () => {
};
function Tie(e) {
  const [t, n] = C.useState(void 0);
  return kie(() => {
    if (e) {
      n({ width: e.offsetWidth, height: e.offsetHeight });
      const r = new ResizeObserver((i) => {
        if (!Array.isArray(i) || !i.length)
          return;
        const o = i[0];
        let a, s;
        if ("borderBoxSize" in o) {
          const l = o.borderBoxSize, u = Array.isArray(l) ? l[0] : l;
          a = u.inlineSize, s = u.blockSize;
        } else
          a = e.offsetWidth, s = e.offsetHeight;
        n({ width: a, height: s });
      });
      return r.observe(e, { box: "border-box" }), () => r.unobserve(e);
    } else
      n(void 0);
  }, [e]), t;
}
var kT = C.forwardRef((e, t) => {
  const { children: n, ...r } = e, i = C.Children.toArray(n), o = i.find(Mie);
  if (o) {
    const a = o.props.children, s = i.map((l) => l === o ? C.Children.count(a) > 1 ? C.Children.only(null) : C.isValidElement(a) ? a.props.children : null : l);
    return /* @__PURE__ */ fe.jsx(_0, { ...r, ref: t, children: C.isValidElement(a) ? C.cloneElement(a, void 0, s) : null });
  }
  return /* @__PURE__ */ fe.jsx(_0, { ...r, ref: t, children: n });
});
kT.displayName = "Slot";
var _0 = C.forwardRef((e, t) => {
  const { children: n, ...r } = e;
  if (C.isValidElement(n)) {
    const i = Rie(n);
    return C.cloneElement(n, {
      ...Oie(r, n.props),
      // @ts-ignore
      ref: t ? _T(t, i) : i
    });
  }
  return C.Children.count(n) > 1 ? C.Children.only(null) : null;
});
_0.displayName = "SlotClone";
var Aie = ({ children: e }) => /* @__PURE__ */ fe.jsx(fe.Fragment, { children: e });
function Mie(e) {
  return C.isValidElement(e) && e.type === Aie;
}
function Oie(e, t) {
  const n = { ...t };
  for (const r in t) {
    const i = e[r], o = t[r];
    /^on[A-Z]/.test(r) ? i && o ? n[r] = (...s) => {
      o(...s), i(...s);
    } : i && (n[r] = i) : r === "style" ? n[r] = { ...i, ...o } : r === "className" && (n[r] = [i, o].filter(Boolean).join(" "));
  }
  return { ...e, ...n };
}
function Rie(e) {
  var r, i;
  let t = (r = Object.getOwnPropertyDescriptor(e.props, "ref")) == null ? void 0 : r.get, n = t && "isReactWarning" in t && t.isReactWarning;
  return n ? e.ref : (t = (i = Object.getOwnPropertyDescriptor(e, "ref")) == null ? void 0 : i.get, n = t && "isReactWarning" in t && t.isReactWarning, n ? e.props.ref : e.props.ref || e.ref);
}
var Iie = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], TT = Iie.reduce((e, t) => {
  const n = C.forwardRef((r, i) => {
    const { asChild: o, ...a } = r, s = o ? kT : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ fe.jsx(s, { ...a, ref: i });
  });
  return n.displayName = `Primitive.${t}`, { ...e, [t]: n };
}, {}), Qy = "Switch", [Die, Pye] = Eie(Qy), [Nie, $ie] = Die(Qy), AT = C.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: n,
      name: r,
      checked: i,
      defaultChecked: o,
      required: a,
      disabled: s,
      value: l = "on",
      onCheckedChange: u,
      form: d,
      ...f
    } = e, [p, m] = C.useState(null), g = xie(t, (S) => m(S)), v = C.useRef(!1), y = p ? d || !!p.closest("form") : !0, [b = !1, E] = Sie({
      prop: i,
      defaultProp: o,
      onChange: u
    });
    return /* @__PURE__ */ fe.jsxs(Nie, { scope: n, checked: b, disabled: s, children: [
      /* @__PURE__ */ fe.jsx(
        TT.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": b,
          "aria-required": a,
          "data-state": RT(b),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: l,
          ...f,
          ref: g,
          onClick: wie(e.onClick, (S) => {
            E((_) => !_), y && (v.current = S.isPropagationStopped(), v.current || S.stopPropagation());
          })
        }
      ),
      y && /* @__PURE__ */ fe.jsx(
        Lie,
        {
          control: p,
          bubbles: !v.current,
          name: r,
          value: l,
          checked: b,
          required: a,
          disabled: s,
          form: d,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
AT.displayName = Qy;
var MT = "SwitchThumb", OT = C.forwardRef(
  (e, t) => {
    const { __scopeSwitch: n, ...r } = e, i = $ie(MT, n);
    return /* @__PURE__ */ fe.jsx(
      TT.span,
      {
        "data-state": RT(i.checked),
        "data-disabled": i.disabled ? "" : void 0,
        ...r,
        ref: t
      }
    );
  }
);
OT.displayName = MT;
var Lie = (e) => {
  const { control: t, checked: n, bubbles: r = !0, ...i } = e, o = C.useRef(null), a = Pie(n), s = Tie(t);
  return C.useEffect(() => {
    const l = o.current, u = window.HTMLInputElement.prototype, f = Object.getOwnPropertyDescriptor(u, "checked").set;
    if (a !== n && f) {
      const p = new Event("click", { bubbles: r });
      f.call(l, n), l.dispatchEvent(p);
    }
  }, [a, n, r]), /* @__PURE__ */ fe.jsx(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: n,
      ...i,
      tabIndex: -1,
      ref: o,
      style: {
        ...e.style,
        ...s,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function RT(e) {
  return e ? "checked" : "unchecked";
}
var IT = AT, Fie = OT;
const zie = $r(
  "focus-visible:ai-tw-outline-none focus-visible:ai-tw-ring-2 focus-visible:ai-tw-ring-offset-2 focus-visible:ai-tw-ring-offset-background disabled:ai-tw-cursor-not-allowed disabled:ai-tw-opacity-50 data-[state=unchecked]:ai-tw-bg-element-primary-bold-light",
  {
    variants: {
      variant: {
        brand: "focus-visible:ai-tw-ring-ring data-[state=checked]:ai-tw-bg-primary",
        ai: "focus-visible:ai-tw-ring-stroke-ai data-[state=checked]:ai-tw-bg-content-ai-dark",
        success: "focus-visible:ai-tw-ring-stroke-success data-[state=checked]:ai-tw-bg-content-success"
      }
    },
    defaultVariants: {
      variant: "brand"
    }
  }
), Jy = C.forwardRef(({ className: e, ...t }, n) => /* @__PURE__ */ C.createElement(
  IT,
  {
    className: ie(
      "ai-tw-peer ai-tw-inline-flex ai-tw-h-5 ai-tw-w-9 ai-tw-shrink-0 ai-tw-cursor-pointer ai-tw-items-center ai-tw-rounded-full ai-tw-border-2 ai-tw-border-transparent ai-tw-transition-colors",
      zie({ variant: t.variant }),
      e
    ),
    ...t,
    ref: n
  },
  /* @__PURE__ */ C.createElement(
    Fie,
    {
      className: ie(
        "ai-tw-pointer-events-none ai-tw-block ai-tw-h-4 ai-tw-w-4 ai-tw-rounded-full ai-tw-bg-background ai-tw-shadow-lg ai-tw-ring-0 ai-tw-transition-transform data-[state=checked]:ai-tw-translate-x-4 data-[state=unchecked]:ai-tw-translate-x-0"
      )
    }
  )
));
Jy.displayName = IT.displayName;
const ew = "ai-settings-form-account";
function Vie() {
  const e = sessionStorage.getItem(ew);
  if (!e)
    return null;
  try {
    return JSON.parse(e);
  } catch {
    return null;
  }
}
function mo(e) {
  sessionStorage.setItem(ew, JSON.stringify(e));
}
function Bie() {
  sessionStorage.removeItem(ew);
}
function jie({
  envoy_enabled: e,
  initial_map_center: t,
  loan_officers: n,
  saved_service_areas: r,
  saved_settings: i
}) {
  const o = Vie(), { isLoading: a } = zy(), { trigger: s, isMutating: l, error: u } = DZ(), [d, f] = C.useState([]), [p, m] = C.useState(null), g = fk({
    defaultValues: {
      assistant_name: i.assistantName || "",
      mention_brokerage_name: !i.disableMentionBrokerageName,
      call_transfer: !i.disablePhoneTransfer,
      audience_commercial_rentals: !i.declineCommercialRentals,
      audience_residential_rentals: !i.declineResidentialRentals,
      envoy_referrals: i.envoyReferrals,
      envoy_loan_officer: i.envoyReferralLoanOfficer || "",
      saturday_active: !i.disableTextingSaturday,
      sunday_active: !i.disableTextingSunday,
      weekday_end: i.officeHoursEnd,
      weekday_start: i.officeHoursStart,
      weekend_end: i.officeHoursEndWeekend,
      weekend_start: i.officeHoursStartWeekend
    },
    validators: {
      onChange: ({ value: y }) => {
        const b = Tf(
          y.weekday_start,
          y.weekday_end
        ), E = Tf(
          y.weekend_start,
          y.weekend_end
        );
        return {
          fields: {
            envoy_loan_officer: pk(
              y.envoy_loan_officer,
              y.envoy_referrals
            ),
            weekday_start: b ? void 0 : "Start time must be before end time.",
            weekday_end: b ? void 0 : "Start time must be before end time.",
            weekend_start: E ? void 0 : "Start time must be before end time.",
            weekend_end: E ? void 0 : "Start time must be before end time."
          }
        };
      }
    },
    onSubmit: async (y) => {
      const b = y.value;
      await s({
        assistantName: b.assistant_name || void 0,
        disableMentionBrokerageName: !b.mention_brokerage_name,
        disablePhoneTransfer: !b.call_transfer,
        declineCommercialRentals: !b.audience_commercial_rentals,
        declineResidentialRentals: !b.audience_residential_rentals,
        envoyReferrals: !!b.envoy_referrals,
        envoyReferralLoanOfficer: b.envoy_loan_officer,
        disableTextingSaturday: !b.saturday_active,
        disableTextingSunday: !b.sunday_active,
        officeHoursStart: b.weekday_start,
        officeHoursEnd: b.weekday_end,
        officeHoursStartWeekend: b.weekend_start,
        officeHoursEndWeekend: b.weekend_end,
        serviceAreaUpdates: d
      }), p && p.clear(), y.formApi.reset(b), Bie();
    }
  });
  C.useEffect(() => {
    o && i && Object.entries(o).forEach(([y, b]) => {
      b !== void 0 && g.setFieldValue(y, b);
    });
  }, [i, o, g]);
  function v(y, b) {
    b !== void 0 && (y.handleChange(b), mo({
      ...g.state.values,
      [y.name]: b
    }));
  }
  return /* @__PURE__ */ C.createElement(
    "form",
    {
      className: "ai-tw-preflight ai-tw-grid ai-tw-gap-8 ai-tw-p-1 ai-tw-body-md",
      onSubmit: (y) => {
        y.preventDefault(), y.stopPropagation(), g.handleSubmit();
      }
    },
    /* @__PURE__ */ C.createElement(
      g.Subscribe,
      {
        selector: (y) => [y.canSubmit, y.isDefaultValue]
      },
      ([y, b]) => {
        const E = d.length === 0 && (!y || !!b);
        return /* @__PURE__ */ C.createElement("div", { className: "ai-tw-sticky ai-tw-right-4 ai-tw-top-24 ai-tw-z-10 -ai-tw-mt-16 ai-tw-ml-auto ai-tw-px-4" }, /* @__PURE__ */ C.createElement(
          Xt,
          {
            type: "submit",
            status: a || l ? "loading" : "default",
            disabled: E
          },
          "Save"
        ));
      }
    ),
    /* @__PURE__ */ C.createElement("div", { className: "-ai-tw-mt-10 ai-tw-grid ai-tw-gap-6" }, /* @__PURE__ */ C.createElement(zk, { error: u }), /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-gap-2" }, /* @__PURE__ */ C.createElement("h3", { className: "ai-tw-heading-3" }, "Branding and Compliance"), /* @__PURE__ */ C.createElement("p", { className: "ai-tw-text-content-primary-light" }, 'Your AI assistant will introduce itself as "Gabbi" and mention your team’s name.')), /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-gap-6" }, /* @__PURE__ */ C.createElement(g.Field, { name: "mention_brokerage_name" }, (y) => /* @__PURE__ */ C.createElement("div", { className: "ai-tw-flex ai-tw-items-center ai-tw-gap-1.5" }, /* @__PURE__ */ C.createElement(
      Rr,
      {
        id: "mention_brokerage_name",
        checked: !!y.state.value,
        onCheckedChange: (b) => {
          y.handleChange(!!b), mo({
            ...g.state.values,
            mention_brokerage_name: !!b
          });
        }
      }
    ), /* @__PURE__ */ C.createElement(yn, { htmlFor: "mention_brokerage_name" }, "Mention the brokerage name in initial message")))), /* @__PURE__ */ C.createElement("hr", { className: "ai-tw-text-grey-10" }), /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-max-w-2xl ai-tw-gap-2" }, /* @__PURE__ */ C.createElement("h2", { className: "ai-tw-heading-2" }, "Team Defaults"), /* @__PURE__ */ C.createElement("p", { className: "ai-tw-text-content-primary-light" }, "The team default settings will appear for all users on your account. Users can override these settings to better align with their individual business needs in the My Settings tab. Changes to the team defaults will not override the individual user settings.", " ")), /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-max-w-2xl ai-tw-gap-2" }, /* @__PURE__ */ C.createElement("h3", { className: "ai-tw-heading-3" }, "Notifications"), /* @__PURE__ */ C.createElement("p", { className: "ai-tw-text-content-primary-light" }, "The AI assistant will mention the primary agent in a note when a lead is ready for your attention.")), /* @__PURE__ */ C.createElement(g.Field, { name: "call_transfer" }, (y) => /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-max-w-2xl ai-tw-grid-cols-[auto_1fr] ai-tw-items-center ai-tw-gap-x-1.5" }, /* @__PURE__ */ C.createElement(
      Rr,
      {
        id: "call_transfer",
        checked: y.state.value,
        onCheckedChange: (b) => {
          y.handleChange(!!b), mo({
            ...g.state.values,
            call_transfer: !!b
          });
        }
      }
    ), /* @__PURE__ */ C.createElement(yn, { htmlFor: "call_transfer" }, "Call Transfer"), /* @__PURE__ */ C.createElement("p", { className: "ai-tw-col-start-2 ai-tw-text-content-primary-light" }, "When selected, the AI Assistant will call your phone as soon as a lead is ready for your attention. You must have a Brivity number set up in order to receive call notifications.")))),
    /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-gap-6" }, /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-max-w-2xl ai-tw-gap-2" }, /* @__PURE__ */ C.createElement("h3", { className: "ai-tw-heading-3" }, "Team Service Areas"), /* @__PURE__ */ C.createElement("p", { className: "ai-tw-text-content-primary-light" }, `The AI assistant will recommend listings within your service area.
            If no service area is specified, it will recommend listings within a
            ${hk} mile radius of your business
            addresses.`)), /* @__PURE__ */ C.createElement(
      xT,
      {
        initial_map_center: t,
        saved_service_areas: r,
        serviceAreaUpdates: d,
        setServiceAreaUpdates: f,
        terraDraw: p,
        setTerraDraw: m
      }
    )),
    /* @__PURE__ */ C.createElement("hr", { className: "ai-tw-text-grey-10" }),
    /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-max-w-2xl ai-tw-gap-6" }, /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-gap-2" }, /* @__PURE__ */ C.createElement("h3", { className: "ai-tw-heading-3" }, "Hours of Operation"), /* @__PURE__ */ C.createElement("p", { className: "ai-tw-text-content-primary-light" }, "Set your hours of operation to determine when the AI Assistant will start new conversations or send drip messages. The AI assistant will still respond to a message sent by a lead at any time of day. If a lead comes in after hours, your AI assistant will begin texting once office hours start again. Hours are based on your timezone.")), /* @__PURE__ */ C.createElement("div", { className: "ai-tw-mb-2 ai-tw-grid ai-tw-grid-cols-2 ai-tw-gap-2 ai-tw-text-content-primary-light" }, /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-gap-1" }, /* @__PURE__ */ C.createElement("span", null, "Weekday Active Hours"), /* @__PURE__ */ C.createElement("span", null, "(Monday - Friday)"), /* @__PURE__ */ C.createElement("div", { className: "ai-tw-relative ai-tw-mt-1 ai-tw-flex ai-tw-w-fit ai-tw-items-center ai-tw-gap-4" }, /* @__PURE__ */ C.createElement(g.Field, { name: "weekday_start" }, (y) => /* @__PURE__ */ C.createElement(C.Fragment, null, /* @__PURE__ */ C.createElement(
      Ao,
      {
        name: y.name,
        value: y.state.value,
        onValueChange: (b) => {
          v(y, b);
        },
        placeholder: "8:00 AM",
        isValid: y.state.meta.isValid
      }
    ), y.state.meta.errors.map((b, E) => /* @__PURE__ */ C.createElement(
      "p",
      {
        key: E,
        className: "ai-tw-absolute ai-tw-top-12 ai-tw-text-stroke-critical ai-tw-subtitle-sm"
      },
      b
    )))), /* @__PURE__ */ C.createElement("hr", { className: "ai-tw-w-4" }), /* @__PURE__ */ C.createElement(g.Field, { name: "weekday_end" }, (y) => {
      var b;
      return /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-gap-2" }, /* @__PURE__ */ C.createElement(
        Ao,
        {
          name: y.name,
          value: y.state.value,
          onValueChange: (E) => {
            v(y, E);
          },
          placeholder: "7:00 PM",
          isValid: (b = y.form.getFieldMeta("weekday_end")) == null ? void 0 : b.isValid
        }
      ));
    }))), /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-gap-1" }, /* @__PURE__ */ C.createElement("span", null, "Weekend Active Hours"), /* @__PURE__ */ C.createElement("div", { className: "ai-tw-flex ai-tw-items-center ai-tw-gap-4" }, /* @__PURE__ */ C.createElement(g.Field, { name: "saturday_active" }, (y) => /* @__PURE__ */ C.createElement("div", { className: "ai-tw-flex ai-tw-items-center ai-tw-gap-1.5" }, /* @__PURE__ */ C.createElement(
      Rr,
      {
        id: "saturday_active",
        checked: y.state.value,
        onCheckedChange: (b) => {
          y.handleChange(!!b), mo({
            ...g.state.values,
            saturday_active: !!b
          });
        }
      }
    ), /* @__PURE__ */ C.createElement(yn, { htmlFor: "saturday_active" }, "Saturday"))), /* @__PURE__ */ C.createElement(g.Field, { name: "sunday_active" }, (y) => /* @__PURE__ */ C.createElement("div", { className: "ai-tw-flex ai-tw-items-center ai-tw-gap-1.5" }, /* @__PURE__ */ C.createElement(
      Rr,
      {
        id: "sunday_active",
        checked: !!y.state.value,
        onCheckedChange: (b) => {
          y.handleChange(!!b), mo({
            ...g.state.values,
            sunday_active: !!b
          });
        }
      }
    ), /* @__PURE__ */ C.createElement(yn, { htmlFor: "sunday_active" }, "Sunday")))), /* @__PURE__ */ C.createElement("div", { className: "ai-tw-relative ai-tw-mt-1 ai-tw-flex ai-tw-w-fit ai-tw-items-center ai-tw-gap-4" }, /* @__PURE__ */ C.createElement(g.Field, { name: "weekend_start" }, (y) => /* @__PURE__ */ C.createElement(C.Fragment, null, /* @__PURE__ */ C.createElement(
      Ao,
      {
        name: y.name,
        value: y.state.value,
        onValueChange: (b) => {
          v(y, b);
        },
        placeholder: "8:00 AM",
        isValid: y.state.meta.isValid
      }
    ), y.state.meta.errors.map((b, E) => /* @__PURE__ */ C.createElement(
      "p",
      {
        key: E,
        className: "ai-tw-absolute ai-tw-top-12 ai-tw-text-stroke-critical ai-tw-subtitle-sm"
      },
      b
    )))), /* @__PURE__ */ C.createElement("hr", { className: "ai-tw-w-4" }), /* @__PURE__ */ C.createElement(g.Field, { name: "weekend_end" }, (y) => {
      var b;
      return /* @__PURE__ */ C.createElement(
        Ao,
        {
          name: y.name,
          value: y.state.value,
          onValueChange: (E) => {
            v(y, E);
          },
          placeholder: "7:00 PM",
          isValid: (b = y.form.getFieldMeta("weekend_end")) == null ? void 0 : b.isValid
        }
      );
    })))), /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-gap-6" }, /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-gap-2" }, /* @__PURE__ */ C.createElement("h3", { className: "ai-tw-heading-3" }, "Audience"), /* @__PURE__ */ C.createElement("p", { className: "ai-tw-text-content-primary-light" }, "Specify which types of leads you want to be notified about. When unselected, the AI assistant will politely decline services to leads that do not match your target audience.")), /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-gap-4" }, /* @__PURE__ */ C.createElement(g.Field, { name: "audience_residential_rentals" }, (y) => /* @__PURE__ */ C.createElement("div", { className: "ai-tw-flex ai-tw-items-center ai-tw-gap-1.5" }, /* @__PURE__ */ C.createElement(
      Rr,
      {
        id: "audience_residential_rentals",
        checked: !!y.state.value,
        onCheckedChange: (b) => {
          y.handleChange(!!b), mo({
            ...g.state.values,
            audience_residential_rentals: !!b
          });
        }
      }
    ), /* @__PURE__ */ C.createElement(yn, { htmlFor: "audience_residential_rentals" }, "Residential Property Rentals"))), /* @__PURE__ */ C.createElement(g.Field, { name: "audience_commercial_rentals" }, (y) => /* @__PURE__ */ C.createElement("div", { className: "ai-tw-flex ai-tw-items-center ai-tw-gap-1.5" }, /* @__PURE__ */ C.createElement(
      Rr,
      {
        id: "audience_commercial_rentals",
        checked: !!y.state.value,
        onCheckedChange: (b) => {
          y.handleChange(!!b), mo({
            ...g.state.values,
            audience_commercial_rentals: !!b
          });
        }
      }
    ), /* @__PURE__ */ C.createElement(yn, { htmlFor: "audience_commercial_rentals" }, "Commercial Property Rentals"))))), e ? /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-gap-6" }, /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-gap-2" }, /* @__PURE__ */ C.createElement("h3", { className: "ai-tw-heading-3" }, "Envoy Mortgage Referrals"), /* @__PURE__ */ C.createElement("p", { className: "ai-tw-text-content-primary-light" }, "Gabbi can quality leads for lenders and automatically send referrals to Envoy Mortgage. You can specify a preferred loan officer or pick the first available lender who is licensed in your service area.")), /* @__PURE__ */ C.createElement(g.Field, { name: "envoy_referrals" }, (y) => /* @__PURE__ */ C.createElement("div", { className: "ai-tw-flex ai-tw-items-center ai-tw-gap-1.5" }, /* @__PURE__ */ C.createElement(
      Jy,
      {
        id: "envoy_referrals",
        checked: y.state.value,
        onCheckedChange: (b) => {
          y.handleChange(!!b), mo({
            ...g.state.values,
            envoy_referrals: !!b
          });
        }
      }
    ), /* @__PURE__ */ C.createElement(
      yn,
      {
        htmlFor: "envoy_referrals",
        className: "ai-tw-text-content-primary-light"
      },
      "Allow Gabbi to send referrals to Envoy Mortgage"
    ))), /* @__PURE__ */ C.createElement(g.Field, { name: "envoy_loan_officer" }, (y) => /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-gap-2" }, /* @__PURE__ */ C.createElement(
      yn,
      {
        htmlFor: "loan_officer",
        className: "ai-tw-text-content-primary-light"
      },
      "Select Preferred Loan Officer"
    ), /* @__PURE__ */ C.createElement(
      Ky,
      {
        value: y.state.value,
        onValueChange: (b) => {
          v(y, b);
        }
      },
      /* @__PURE__ */ C.createElement(Wh, null, /* @__PURE__ */ C.createElement(Xy, { placeholder: "Select Loan Officer" })),
      /* @__PURE__ */ C.createElement(Uh, null, n.map((b) => /* @__PURE__ */ C.createElement(Hh, { key: b.value, value: b.value }, b.label)))
    ), y.state.meta.errors.map((b, E) => /* @__PURE__ */ C.createElement("p", { key: E, className: "ai-tw-text-stroke-critical" }, b))))) : null)
  );
}
const tw = "ai-settings-form-agent";
function Wie() {
  const e = sessionStorage.getItem(tw);
  if (!e)
    return null;
  try {
    return JSON.parse(e);
  } catch {
    return null;
  }
}
function ea(e) {
  sessionStorage.setItem(tw, JSON.stringify(e));
}
function Uie() {
  sessionStorage.removeItem(tw);
}
function Hie({
  envoy_enabled: e,
  initial_map_center: t,
  loan_officers: n,
  saved_service_areas: r,
  saved_settings: i
}) {
  const o = Wie(), { isLoading: a } = zy(), { trigger: s, isMutating: l, error: u } = IZ(), [d, f] = C.useState([]), [p, m] = C.useState(null), g = fk({
    defaultValues: {
      call_transfer: !i.disablePhoneTransfer,
      audience_commercial_rentals: !i.declineCommercialRentals,
      audience_residential_rentals: !i.declineResidentialRentals,
      envoy_referrals: i.envoyReferrals,
      envoy_loan_officer: i.envoyReferralLoanOfficer || "",
      saturday_active: !i.disableTextingSaturday,
      sunday_active: !i.disableTextingSunday,
      weekday_end: i.officeHoursEnd,
      weekday_start: i.officeHoursStart,
      weekend_end: i.officeHoursEndWeekend,
      weekend_start: i.officeHoursStartWeekend
    },
    validators: {
      onChange: ({ value: y }) => {
        const b = Tf(
          y.weekday_start,
          y.weekday_end
        ), E = Tf(
          y.weekend_start,
          y.weekend_end
        );
        return {
          fields: {
            envoy_loan_officer: pk(
              y.envoy_loan_officer,
              y.envoy_referrals
            ),
            weekday_start: b ? void 0 : "Start time must be before end time.",
            weekday_end: b ? void 0 : "Start time must be before end time.",
            weekend_start: E ? void 0 : "Start time must be before end time.",
            weekend_end: E ? void 0 : "Start time must be before end time."
          }
        };
      }
    },
    onSubmit: async (y) => {
      const b = y.value;
      await s({
        disablePhoneTransfer: !b.call_transfer,
        declineCommercialRentals: !b.audience_commercial_rentals,
        declineResidentialRentals: !b.audience_residential_rentals,
        envoyReferrals: b.envoy_referrals,
        envoyReferralLoanOfficer: b.envoy_loan_officer || "",
        disableTextingSaturday: !b.saturday_active,
        disableTextingSunday: !b.sunday_active,
        officeHoursEnd: b.weekday_end,
        officeHoursStart: b.weekday_start,
        officeHoursEndWeekend: b.weekend_end,
        officeHoursStartWeekend: b.weekend_start,
        serviceAreaUpdates: d
      }), p && p.clear(), y.formApi.reset(b), Uie();
    }
  });
  C.useEffect(() => {
    o && i && Object.entries(o).forEach(([y, b]) => {
      b !== void 0 && g.setFieldValue(y, b);
    });
  }, [i, o, g]);
  function v(y, b) {
    b !== void 0 && (y.handleChange(b), ea({
      ...g.state.values,
      [y.name]: b
    }));
  }
  return /* @__PURE__ */ C.createElement(
    "form",
    {
      className: "ai-tw-preflight ai-tw-grid ai-tw-gap-8 ai-tw-overflow-visible ai-tw-p-1 ai-tw-body-md",
      onSubmit: (y) => {
        y.preventDefault(), y.stopPropagation(), g.handleSubmit();
      }
    },
    /* @__PURE__ */ C.createElement(
      g.Subscribe,
      {
        selector: (y) => [y.canSubmit, y.isDefaultValue]
      },
      ([y, b]) => {
        const E = d.length === 0 && (!y || !!b);
        return /* @__PURE__ */ C.createElement("div", { className: "ai-tw-sticky ai-tw-right-4 ai-tw-top-24 ai-tw-z-10 -ai-tw-mt-16 ai-tw-ml-auto ai-tw-px-4" }, /* @__PURE__ */ C.createElement(
          Xt,
          {
            type: "submit",
            status: a || l ? "loading" : "default",
            disabled: E
          },
          "Save"
        ));
      }
    ),
    /* @__PURE__ */ C.createElement("div", { className: "-ai-tw-mt-10 ai-tw-grid ai-tw-gap-6" }, /* @__PURE__ */ C.createElement(zk, { error: u }), /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-max-w-2xl ai-tw-gap-2" }, /* @__PURE__ */ C.createElement("h3", { className: "ai-tw-heading-3" }, "Notifications"), /* @__PURE__ */ C.createElement("p", { className: "ai-tw-text-content-primary-light" }, "The AI assistant will mention the primary agent in a note when a lead is ready for your attention.")), /* @__PURE__ */ C.createElement(g.Field, { name: "call_transfer" }, (y) => /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-max-w-2xl ai-tw-grid-cols-[auto_1fr] ai-tw-items-center ai-tw-gap-x-1.5" }, /* @__PURE__ */ C.createElement(
      Rr,
      {
        id: "call_transfer",
        checked: y.state.value,
        onCheckedChange: (b) => {
          y.handleChange(!!b), ea({
            ...g.state.values,
            call_transfer: !!b
          });
        }
      }
    ), /* @__PURE__ */ C.createElement(yn, { htmlFor: "call_transfer" }, "Call Transfer"), /* @__PURE__ */ C.createElement("p", { className: "ai-tw-col-start-2 ai-tw-text-content-primary-light" }, "When selected, the AI Assistant will call your phone as soon as a lead is ready for your attention. You must have a Brivity number set up in order to receive call notifications.")))),
    /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-gap-6" }, /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-max-w-2xl ai-tw-gap-2" }, /* @__PURE__ */ C.createElement("h3", { className: "ai-tw-heading-3" }, "Service Areas"), /* @__PURE__ */ C.createElement("p", { className: "ai-tw-text-content-primary-light" }, `The AI assistant will recommend listings within your service area.
            If no service area is specified, it will recommend listings within a
            ${hk} mile radius of your business
            addresses.`)), /* @__PURE__ */ C.createElement(
      xT,
      {
        initial_map_center: t,
        saved_service_areas: r,
        serviceAreaUpdates: d,
        setServiceAreaUpdates: f,
        terraDraw: p,
        setTerraDraw: m
      }
    )),
    /* @__PURE__ */ C.createElement("hr", { className: "ai-tw-text-grey-10" }),
    /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-max-w-2xl ai-tw-gap-6" }, /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-gap-2" }, /* @__PURE__ */ C.createElement("h3", { className: "ai-tw-heading-3" }, "Hours of Operation"), /* @__PURE__ */ C.createElement("p", { className: "ai-tw-text-content-primary-light" }, "Set your hours of operation to determine when the AI Assistant will start new conversations or send drip messages. The AI assistant will still respond to a message sent by a lead at any time of day. If a lead comes in after hours, your AI assistant will begin texting once office hours start again. Hours are based on your timezone.")), /* @__PURE__ */ C.createElement("div", { className: "ai-tw-mb-2 ai-tw-grid ai-tw-grid-cols-2 ai-tw-gap-2 ai-tw-text-content-primary-light" }, /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-gap-1" }, /* @__PURE__ */ C.createElement("span", null, "Weekday Active Hours"), /* @__PURE__ */ C.createElement("span", null, "(Monday - Friday)"), /* @__PURE__ */ C.createElement("div", { className: "ai-tw-relative ai-tw-mt-1 ai-tw-flex ai-tw-w-fit ai-tw-items-center ai-tw-gap-4" }, /* @__PURE__ */ C.createElement(g.Field, { name: "weekday_start" }, (y) => /* @__PURE__ */ C.createElement(C.Fragment, null, /* @__PURE__ */ C.createElement(
      Ao,
      {
        name: y.name,
        value: y.state.value,
        onValueChange: (b) => {
          v(y, b);
        },
        placeholder: "8:00 AM",
        isValid: y.state.meta.isValid
      }
    ), y.state.meta.errors.map((b, E) => /* @__PURE__ */ C.createElement(
      "p",
      {
        key: E,
        className: "ai-tw-absolute ai-tw-top-12 ai-tw-text-stroke-critical ai-tw-subtitle-sm"
      },
      b
    )))), /* @__PURE__ */ C.createElement("hr", { className: "ai-tw-w-4" }), /* @__PURE__ */ C.createElement(g.Field, { name: "weekday_end" }, (y) => {
      var b;
      return /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-gap-2" }, /* @__PURE__ */ C.createElement(
        Ao,
        {
          name: y.name,
          value: y.state.value,
          onValueChange: (E) => {
            v(y, E);
          },
          placeholder: "7:00 PM",
          isValid: (b = y.form.getFieldMeta("weekday_end")) == null ? void 0 : b.isValid
        }
      ));
    }))), /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-gap-1" }, /* @__PURE__ */ C.createElement("span", null, "Weekend Active Hours"), /* @__PURE__ */ C.createElement("div", { className: "ai-tw-flex ai-tw-items-center ai-tw-gap-4" }, /* @__PURE__ */ C.createElement(g.Field, { name: "saturday_active" }, (y) => /* @__PURE__ */ C.createElement("div", { className: "ai-tw-flex ai-tw-items-center ai-tw-gap-1.5" }, /* @__PURE__ */ C.createElement(
      Rr,
      {
        id: "saturday_active",
        checked: y.state.value,
        onCheckedChange: (b) => {
          y.handleChange(!!b), ea({
            ...g.state.values,
            saturday_active: !!b
          });
        }
      }
    ), /* @__PURE__ */ C.createElement(yn, { htmlFor: "saturday_active" }, "Saturday"))), /* @__PURE__ */ C.createElement(g.Field, { name: "sunday_active" }, (y) => /* @__PURE__ */ C.createElement("div", { className: "ai-tw-flex ai-tw-items-center ai-tw-gap-1.5" }, /* @__PURE__ */ C.createElement(
      Rr,
      {
        id: "sunday_active",
        checked: !!y.state.value,
        onCheckedChange: (b) => {
          y.handleChange(!!b), ea({
            ...g.state.values,
            sunday_active: !!b
          });
        }
      }
    ), /* @__PURE__ */ C.createElement(yn, { htmlFor: "sunday_active" }, "Sunday")))), /* @__PURE__ */ C.createElement("div", { className: "ai-tw-relative ai-tw-mt-1 ai-tw-flex ai-tw-w-fit ai-tw-items-center ai-tw-gap-4" }, /* @__PURE__ */ C.createElement(g.Field, { name: "weekend_start" }, (y) => /* @__PURE__ */ C.createElement(C.Fragment, null, /* @__PURE__ */ C.createElement(
      Ao,
      {
        name: y.name,
        value: y.state.value,
        onValueChange: (b) => {
          v(y, b);
        },
        placeholder: "8:00 AM",
        isValid: y.state.meta.isValid
      }
    ), y.state.meta.errors.map((b, E) => /* @__PURE__ */ C.createElement(
      "p",
      {
        key: E,
        className: "ai-tw-absolute ai-tw-top-12 ai-tw-text-stroke-critical ai-tw-subtitle-sm"
      },
      b
    )))), /* @__PURE__ */ C.createElement("hr", { className: "ai-tw-w-4" }), /* @__PURE__ */ C.createElement(g.Field, { name: "weekend_end" }, (y) => {
      var b;
      return /* @__PURE__ */ C.createElement(
        Ao,
        {
          name: y.name,
          value: y.state.value,
          onValueChange: (E) => {
            v(y, E);
          },
          placeholder: "7:00 PM",
          isValid: (b = y.form.getFieldMeta("weekend_end")) == null ? void 0 : b.isValid
        }
      );
    })))), /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-gap-6" }, /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-gap-2" }, /* @__PURE__ */ C.createElement("h3", { className: "ai-tw-heading-3" }, "Audience"), /* @__PURE__ */ C.createElement("p", { className: "ai-tw-text-content-primary-light" }, "Specify which types of leads you want to be notified about. When unselected, the AI assistant will politely decline services to leads that do not match your target audience.")), /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-gap-4" }, /* @__PURE__ */ C.createElement(g.Field, { name: "audience_residential_rentals" }, (y) => /* @__PURE__ */ C.createElement("div", { className: "ai-tw-flex ai-tw-items-center ai-tw-gap-1.5" }, /* @__PURE__ */ C.createElement(
      Rr,
      {
        id: "audience_residential_rentals",
        checked: !!y.state.value,
        onCheckedChange: (b) => {
          y.handleChange(!!b), ea({
            ...g.state.values,
            audience_residential_rentals: !!b
          });
        }
      }
    ), /* @__PURE__ */ C.createElement(yn, { htmlFor: "audience_residential_rentals" }, "Residential Property Rentals"))), /* @__PURE__ */ C.createElement(g.Field, { name: "audience_commercial_rentals" }, (y) => /* @__PURE__ */ C.createElement("div", { className: "ai-tw-flex ai-tw-items-center ai-tw-gap-1.5" }, /* @__PURE__ */ C.createElement(
      Rr,
      {
        id: "audience_commercial_rentals",
        checked: !!y.state.value,
        onCheckedChange: (b) => {
          y.handleChange(!!b), ea({
            ...g.state.values,
            audience_commercial_rentals: !!b
          });
        }
      }
    ), /* @__PURE__ */ C.createElement(yn, { htmlFor: "audience_commercial_rentals" }, "Commercial Property Rentals"))))), e ? /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-gap-6" }, /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-gap-2" }, /* @__PURE__ */ C.createElement("h3", { className: "ai-tw-heading-3" }, "Envoy Mortgage Referrals"), /* @__PURE__ */ C.createElement("p", { className: "ai-tw-text-content-primary-light" }, "Gabbi can quality leads for lenders and automatically send referrals to Envoy Mortgage. You can specify a preferred loan officer or pick the first available lender who is licensed in your service area.")), /* @__PURE__ */ C.createElement(g.Field, { name: "envoy_referrals" }, (y) => /* @__PURE__ */ C.createElement("div", { className: "ai-tw-flex ai-tw-items-center ai-tw-gap-1.5" }, /* @__PURE__ */ C.createElement(
      Jy,
      {
        id: "envoy_referrals",
        checked: y.state.value,
        onCheckedChange: (b) => {
          y.handleChange(!!b), ea({
            ...g.state.values,
            envoy_referrals: !!b
          });
        }
      }
    ), /* @__PURE__ */ C.createElement(
      yn,
      {
        htmlFor: "envoy_referrals",
        className: "ai-tw-text-content-primary-light"
      },
      "Allow Gabbi to send referrals to Envoy Mortgage"
    ))), /* @__PURE__ */ C.createElement(g.Field, { name: "envoy_loan_officer" }, (y) => /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-gap-2" }, /* @__PURE__ */ C.createElement(
      yn,
      {
        htmlFor: "loan_officer",
        className: "ai-tw-text-content-primary-light"
      },
      "Select Preferred Loan Officer"
    ), /* @__PURE__ */ C.createElement(
      Ky,
      {
        value: y.state.value,
        onValueChange: (b) => {
          v(y, b);
        }
      },
      /* @__PURE__ */ C.createElement(Wh, null, /* @__PURE__ */ C.createElement(Xy, { placeholder: "Select Loan Officer" })),
      /* @__PURE__ */ C.createElement(Uh, null, n.map((b) => /* @__PURE__ */ C.createElement(Hh, { key: b.value, value: b.value }, b.label)))
    ), y.state.meta.errors.map((b, E) => /* @__PURE__ */ C.createElement("p", { key: E, className: "ai-tw-text-stroke-critical" }, b))))) : null)
  );
}
function kye({ envoy_enabled: e }) {
  var s;
  const { data: t, isLoading: n, error: r } = zy();
  if (n)
    return /* @__PURE__ */ C.createElement(Gie, null);
  if (r)
    return /* @__PURE__ */ C.createElement("div", { className: "ai-tw-grid ai-tw-gap-2 ai-tw-text-stroke-critical" }, /* @__PURE__ */ C.createElement("p", { className: "ai-tw-flex ai-tw-items-center ai-tw-gap-2 ai-tw-heading-3" }, /* @__PURE__ */ C.createElement(Le, { icon: to }), "Error loading AI settings form"), /* @__PURE__ */ C.createElement("p", { className: "ai-tw-body-md" }, "If you continue to experience issues, please contact support."));
  if (!t)
    return null;
  const { latitude: i, longitude: o } = ((s = t.organization_addresses) == null ? void 0 : s[0]) || {}, a = i && o ? { lat: i, lng: o } : void 0;
  return /* @__PURE__ */ C.createElement(Ny, { className: "ai-tw-preflight ai-tw-relative", defaultValue: "agent" }, /* @__PURE__ */ C.createElement($y, null, /* @__PURE__ */ C.createElement(Sf, { value: "agent" }, "My Settings"), t.is_admin && /* @__PURE__ */ C.createElement(C.Fragment, null, /* @__PURE__ */ C.createElement(Sf, { value: "account" }, "Team Settings"))), /* @__PURE__ */ C.createElement(Rs, { className: "ai-tw-py-6", value: "agent" }, /* @__PURE__ */ C.createElement(
    Hie,
    {
      envoy_enabled: e,
      initial_map_center: a,
      loan_officers: t.loan_officers,
      saved_service_areas: t.agent_service_areas,
      saved_settings: t.agent
    }
  )), t.is_admin && /* @__PURE__ */ C.createElement(C.Fragment, null, /* @__PURE__ */ C.createElement(Rs, { className: "ai-tw-py-6", value: "account" }, /* @__PURE__ */ C.createElement(
    jie,
    {
      envoy_enabled: e,
      initial_map_center: a,
      loan_officers: t.loan_officers,
      saved_service_areas: t.account_service_areas,
      saved_settings: t.account
    }
  ))));
}
function Gie() {
  return /* @__PURE__ */ C.createElement(Ny, { className: "ai-tw-preflight ai-tw-relative", defaultValue: "agent" }, /* @__PURE__ */ C.createElement($y, null, /* @__PURE__ */ C.createElement(Sf, { value: "agent" }, "My Settings")), /* @__PURE__ */ C.createElement(Rs, { className: "ai-tw-py-3", value: "agent" }, Array.from({ length: 4 }).map((e, t) => /* @__PURE__ */ C.createElement(
    yf,
    {
      key: t,
      style: { width: `${Math.random() * 30 + 60}%` },
      className: "ai-tw-mt-4 ai-tw-h-7"
    }
  ))));
}
function qie(e) {
  return e === "transparent-secondary" ? e : !e || ["primary", "tertiary", "ai-primary"].includes(e) ? "contained" : "transparent";
}
const Yie = $r("", {
  variants: {
    variant: {
      contained: "ai-tw-border-l-white hover:!ai-tw-border-l hover:!ai-tw-border-l-white hover:!ai-tw-pl-2 hover:!ai-tw-pr-[7px]",
      transparent: "active:ai-tw-border-l-transparent",
      "transparent-secondary": ""
    }
  }
});
function Kie({
  variant: e,
  onClick: t,
  onContextMenuButtonClick: n,
  children: r,
  renderContextMenuButton: i
}) {
  const o = /* @__PURE__ */ C.createElement(
    Xt,
    {
      variant: e,
      size: "sm",
      className: ie(
        "ai-tw-h-auto ai-tw-rounded-l-none ai-tw-border-l-transparent hover:ai-tw-border-l-[unset]",
        Yie({
          variant: qie(e)
        })
      ),
      onClick: n
    },
    /* @__PURE__ */ C.createElement(Le, { icon: r1, className: "ai-tw-mr-1" })
  );
  return /* @__PURE__ */ C.createElement("div", { className: "ai-tw-flex ai-tw-items-stretch" }, /* @__PURE__ */ C.createElement(
    Xt,
    {
      variant: e,
      size: "sm",
      className: "ai-tw-rounded-r-none",
      contentClassName: "ai-tw-flex ai-tw-items-center",
      onClick: t
    },
    r
  ), i ? i(o) : o);
}
function Tye(e) {
  return /* @__PURE__ */ x.createElement(
    Oh,
    {
      className: "ai-tw-bg-transparent ai-tw-p-0 ai-tw-shadow-none",
      ...e
    }
  );
}
function Aye({
  onClick: e,
  label: t = "AI: Help Me Write"
}) {
  return /* @__PURE__ */ x.createElement(
    Kie,
    {
      variant: "ai-secondary",
      onClick: e,
      renderContextMenuButton: (n) => /* @__PURE__ */ x.createElement(My, { asChild: !0 }, n)
    },
    /* @__PURE__ */ x.createElement(Le, { icon: Ls, className: "ai-tw-mr-1" }),
    t
  );
}
function Mye({
  label: e = "AI: Help Me Write"
}) {
  return /* @__PURE__ */ x.createElement(My, { asChild: !0 }, /* @__PURE__ */ x.createElement(
    Xt,
    {
      variant: "ai-secondary",
      size: "sm",
      contentClassName: "ai-tw-flex ai-tw-items-center"
    },
    /* @__PURE__ */ x.createElement(Le, { icon: Ls, className: "ai-tw-mr-1" }),
    e,
    /* @__PURE__ */ x.createElement(Le, { icon: r1, className: "ai-tw-ml-2" })
  ));
}
function Al({ icon: e }) {
  return /* @__PURE__ */ C.createElement(Le, { className: "ai-tw-w-4 ai-tw-py-1", icon: e, fixedWidth: !0 });
}
function Oye({
  className: e,
  onSelect: t,
  buildItems: n = (r) => r
}) {
  return /* @__PURE__ */ C.createElement(
    "div",
    {
      role: "menu",
      className: ie(
        "ai-tw-ml-auto ai-tw-min-w-[140px] ai-tw-rounded ai-tw-bg-white ai-tw-py-1 ai-tw-shadow-purple",
        e
      )
    },
    /* @__PURE__ */ C.createElement("p", { className: "ai-tw-mb-1 ai-tw-mt-0 ai-tw-px-2 ai-tw-py-1 ai-tw-text-xs ai-tw-font-semibold ai-tw-text-grey-50" }, "Edit or Review"),
    n([
      {
        title: "Rephrase",
        icon: /* @__PURE__ */ C.createElement(Al, { icon: V$ })
      },
      {
        title: "Make Shorter",
        icon: /* @__PURE__ */ C.createElement(Al, { icon: cS })
      },
      {
        title: "Make Longer",
        icon: /* @__PURE__ */ C.createElement(Al, { icon: mS })
      },
      { title: "Formalize", icon: /* @__PURE__ */ C.createElement(Al, { icon: F$ }) },
      {
        title: "Relax Tone",
        icon: /* @__PURE__ */ C.createElement(Al, { icon: hL })
      }
    ]).map(({ title: r, icon: i }) => /* @__PURE__ */ C.createElement(
      "div",
      {
        key: r,
        role: "menuitem",
        className: "ai-tw-flex ai-tw-cursor-pointer ai-tw-items-center ai-tw-gap-2 ai-tw-px-2 ai-tw-py-1 ai-tw-text-purple-60 hover:ai-tw-bg-grey-10 active:ai-tw-bg-grey-20",
        onClick: () => t == null ? void 0 : t(r)
      },
      i,
      /* @__PURE__ */ C.createElement("span", { className: "ai-tw-text-grey-60 ai-tw-body-md" }, r)
    ))
  );
}
const Xie = x.forwardRef(({ placeholder: e, variant: t, onConfirm: n, onChange: r }, i) => {
  const [o, a] = de("");
  return /* @__PURE__ */ x.createElement("div", { className: "ai-tw-relative" }, /* @__PURE__ */ x.createElement(
    v6,
    {
      ref: i,
      className: "ai-tw-pr-8 ai-tw-shadow-md ai-tw-shadow-purple-10",
      placeholder: e || "What would you like to write?",
      variant: t || "ai",
      onChange: (s) => {
        a(s.target.value), r == null || r(s);
      },
      onKeyDown: (s) => s.code === "Enter" && o && n(o)
    }
  ), /* @__PURE__ */ x.createElement(
    xh,
    {
      disabled: !o,
      onClick: () => o && n(o),
      className: "ai-tw-absolute ai-tw-right-1 ai-tw-top-1/2 -ai-tw-translate-y-1/2"
    },
    /* @__PURE__ */ x.createElement(Le, { icon: n1 })
  ));
});
Xie.displayName = "HelpMeWriteRecruiterPromptInput";
function Rye({
  className: e,
  title: t,
  onGenerate: n,
  onDismiss: r
}) {
  return /* @__PURE__ */ x.createElement(
    "div",
    {
      className: ie(
        "ai-tw-flex ai-tw-items-center ai-tw-justify-between ai-tw-rounded-lg ai-tw-bg-element-ai-light ai-tw-px-4 ai-tw-py-3 ai-tw-leading-5 ai-tw-body-md",
        e
      )
    },
    /* @__PURE__ */ x.createElement("p", { className: "ai-tw-pr-4 ai-tw-text-content-ai-dark" }, t),
    /* @__PURE__ */ x.createElement("div", { className: "ai-tw-min-w-max" }, /* @__PURE__ */ x.createElement(
      wf,
      {
        variant: "ai",
        className: "ai-tw-mr-2",
        size: "sm",
        onClick: r
      },
      "Dismiss"
    ), /* @__PURE__ */ x.createElement(
      Xt,
      {
        variant: "ai-secondary",
        size: "sm",
        contentClassName: "ai-tw-flex ai-tw-items-center",
        onClick: n
      },
      /* @__PURE__ */ x.createElement(Le, { icon: Ls, className: "ai-tw-mr-1" }),
      "Generate"
    ))
  );
}
function DT(e) {
  return { all: e = e || /* @__PURE__ */ new Map(), on: function(t, n) {
    var r = e.get(t);
    r ? r.push(n) : e.set(t, [n]);
  }, off: function(t, n) {
    var r = e.get(t);
    r && (n ? r.splice(r.indexOf(n) >>> 0, 1) : e.set(t, []));
  }, emit: function(t, n) {
    var r = e.get(t);
    r && r.slice().map(function(i) {
      i(n);
    }), (r = e.get("*")) && r.slice().map(function(i) {
      i(t, n);
    });
  } };
}
const nw = DT();
function Zie() {
  nw.emit("ask-place-closed");
}
function Qie(e) {
  nw.on("ask-place-closed", e);
}
function Ed() {
  nw.all.clear();
}
function P0(e) {
  const t = me(e);
  return be(() => {
    t.current = e;
  }, [e]), t;
}
function Jie({
  notifyCitationReceived: e,
  notifyCitationMetadataReceived: t,
  notifyErrorMessageReceived: n,
  notifyFollowUpQuestionsReceived: r,
  notifyGenerationStarted: i,
  notifyGenerationTokenReceived: o,
  notifyGenerationReceived: a,
  notifySourceReceived: s,
  notifySourceMetadataReceived: l,
  notForProduction_accountEmail: u,
  leadUuid: d
}) {
  const { apiUrl: f, token: p } = Dc(), g = `${f || "https://write-a-plumber.brivity.com"}/v1/rag-chat/generations/stream`, [v, y] = de(null), b = P0(v);
  function E() {
    const T = Xl(g, {
      auth: { token: p },
      timeout: 1e4,
      requestTimeout: 1e4,
      reconnectionAttempts: 3,
      withCredentials: !0,
      transports: ["websocket"]
    });
    return y(T), T;
  }
  function S(T) {
    i == null || i(), Qie(k), T.on("data", (A) => {
      o(A);
    }), T.on("sources", (A) => {
      s(A);
    }), T.on("citations", (A) => {
      e(A);
    }), T.on("generation", ({ chatId: A }) => {
      a({ chatId: A }), Ed();
    }), T.on("follow-up-questions", (A) => {
      r(A);
    }), T.on("source-metadata", (A) => {
      l(A);
    }), T.on("citation-metadata", (A) => {
      t(A);
    }), T.on("stopped", () => {
      T.disconnect(), Ed();
    }), T.on("error-message", (A) => {
      n(A);
    }), T.on("error", (A) => {
      T.disconnect(), console.error(A, "error occurred"), Ed();
    }), T.on("disconnect", () => {
      T.disconnect(), T.removeAllListeners(), y(null), Ed();
    });
  }
  function _({ socket: T, question: A, selectedChat: R }) {
    if (!T)
      return;
    const F = {
      message: A,
      chatId: R,
      leadUuid: d,
      notForProduction_accountEmail: u,
      duplicateVideoCitationsV2: !0
    };
    T.emit("payload", F);
  }
  function k() {
    b.current && b.current.emit("stop");
  }
  return {
    isGenerationInProgress: !!v,
    createSocket: E,
    startListening: S,
    sendPayload: _,
    stopGenerating: k
  };
}
function eoe(e) {
  return e.timestamp;
}
function toe(e) {
  return e.sourceID;
}
function noe(e) {
  return e.sourceTimestamp;
}
function roe(e) {
  return e.split("__")[1];
}
function ioe(e) {
  return e.split("__")[1];
}
function ooe(e) {
  return e.startsWith("rag-chat-video");
}
function aoe(e) {
  return e.startsWith("rag-chat-video--duplicate");
}
function xg(e) {
  return e.startsWith("v2-rag-chat-video--duplicate");
}
function cC(e) {
  const t = document.createElement("textarea");
  t.innerHTML = e;
  const n = t.value;
  return t.remove(), n;
}
const soe = "/rag-chat/chats";
function Rf(e) {
  return `${soe}/${e}`;
}
function qh({
  chatId: e,
  enabled: t = !0
}) {
  const n = ln();
  function r(i) {
    return i ? n(Rf(i)) : null;
  }
  return {
    swr: br(
      t && e ? Rf(e) : null,
      () => r(e)
    ),
    fetchChatById: r
  };
}
function loe(e) {
  return e.sort((t, n) => t.timestamp - n.timestamp);
}
function coe(e) {
  return e == null ? void 0 : e.sources;
}
function uoe(e) {
  return e == null ? void 0 : e.followUpQuestions;
}
function doe(e) {
  return e.metadata;
}
function NT(e) {
  return "_id" in e;
}
function foe(e) {
  return NT(e) ? e._id : null;
}
function hoe(e) {
  return NT(e) ? e.chatId : null;
}
function poe(e, t) {
  var n;
  return (n = e == null ? void 0 : e.source_metadata) == null ? void 0 : n[t];
}
function $T(e, t) {
  var n;
  return (n = e == null ? void 0 : e.citation_metadata) == null ? void 0 : n[t];
}
function moe(e) {
  return e == null ? void 0 : e.message;
}
function goe(e) {
  return e.from;
}
function voe() {
  return {
    followUpQuestions: [],
    from: "ai",
    message: "",
    metadata: {
      source_metadata: {},
      citation_metadata: {}
    },
    sources: {}
  };
}
function k0(e) {
  return e.contentID;
}
function rw(e) {
  return e.contentTitle;
}
function iw(e) {
  return e.contentURL;
}
function ow(e) {
  return e.contentModifiedAt;
}
function Yh(e) {
  return e.contentSource;
}
function $s(e) {
  return "contentSource" in e;
}
function LT(e) {
  return e.type;
}
function yoe(e) {
  return e == null ? void 0 : e.transcript;
}
function woe(e, t) {
  return e.slice(0, t);
}
function FT(e, t) {
  const n = poe(e, t);
  if (n != null && n.timestamp)
    return eoe(n);
}
function boe(e, t) {
  const n = $T(
    e,
    t
  );
  return n ? toe(n) : null;
}
function xoe(e, t) {
  const n = $T(
    e,
    t
  );
  return n ? noe(n) : void 0;
}
function Eoe(e, t) {
  return e.transcript.find((n) => n._id === t);
}
function zT(e) {
  return e == null ? void 0 : e.message;
}
function uC(e, t) {
  return Object.values(e).find((n) => cC(iw(n)) === cC(t));
}
function VT(e, t) {
  return e[t];
}
const Coe = "$inf$", Soe = (e) => va(e ? e(0, null) : null)[0], Eg = Promise.resolve(), _oe = (e) => (t, n, r) => {
  const i = me(!1), { cache: o, initialSize: a = 1, revalidateAll: s = !1, persistSize: l = !1, revalidateFirstPage: u = !0, revalidateOnMount: d = !1, parallel: f = !1 } = r;
  let p;
  try {
    p = Soe(t), p && (p = Coe + p);
  } catch {
  }
  const [m, g, v] = _o(o, p), y = De(() => Qe(m()._l) ? a : m()._l, [
    o,
    p,
    a
  ]);
  gh.useSyncExternalStore(De(
    (A) => p ? v(p, () => {
      A();
    }) : () => {
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      o,
      p
    ]
  ), y, y);
  const b = De(() => {
    const A = m()._l;
    return Qe(A) ? a : A;
  }, [
    p,
    a
  ]), E = me(b());
  da(() => {
    if (!i.current) {
      i.current = !0;
      return;
    }
    p && g({
      _l: l ? E.current : b()
    });
  }, [
    p,
    o
  ]);
  const S = d && !i.current, _ = e(p, async (A) => {
    const R = m()._i, F = [], D = b(), [W] = _o(o, A), L = W().data, z = [];
    let B = null;
    for (let G = 0; G < D; ++G) {
      const [H, J] = va(t(G, f ? null : B));
      if (!H)
        break;
      const [q, Z] = _o(o, H);
      let O = q().data;
      const Q = s || R || Qe(O) || u && !G && !Qe(L) || S || L && !Qe(L[G]) && !r.compare(L[G], O);
      if (n && Q) {
        const he = async () => {
          O = await n(J), Z({
            data: O,
            _k: J
          }), F[G] = O;
        };
        f ? z.push(he) : await he();
      } else
        F[G] = O;
      f || (B = O);
    }
    return f && await Promise.all(z.map((G) => G())), g({
      _i: pn
    }), F;
  }, r), k = De(
    // eslint-disable-next-line func-names
    function(A, R) {
      const F = typeof R == "boolean" ? {
        revalidate: R
      } : R || {}, D = F.revalidate !== !1;
      return p ? (D && (Qe(A) ? g({
        _i: !0
      }) : g({
        _i: !1
      })), arguments.length ? _.mutate(A, {
        ...F,
        revalidate: D
      }) : _.mutate()) : Eg;
    },
    // swr.mutate is always the same reference
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      p,
      o
    ]
  ), T = De(
    (A) => {
      if (!p)
        return Eg;
      const [, R] = _o(o, p);
      let F;
      if (ei(A) ? F = A(b()) : typeof A == "number" && (F = A), typeof F != "number")
        return Eg;
      R({
        _l: F
      }), E.current = F;
      const D = [], [W] = _o(o, p);
      let L = null;
      for (let z = 0; z < F; ++z) {
        const [B] = va(t(z, L)), [G] = _o(o, B), H = B ? G().data : pn;
        if (Qe(H))
          return k(W().data);
        D.push(H), L = H;
      }
      return k(D);
    },
    // exclude getKey from the dependencies, which isn't allowed to change during the lifecycle
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
      p,
      o,
      k,
      b
    ]
  );
  return {
    size: b(),
    setSize: T,
    mutate: k,
    get data() {
      return _.data;
    },
    get error() {
      return _.error;
    },
    get isValidating() {
      return _.isValidating;
    },
    get isLoading() {
      return _.isLoading;
    }
  };
}, Poe = X1(br, _oe), koe = 50, Toe = "/rag-chat/chats";
function Aoe(e, t) {
  if (t && !t.hasMore)
    return null;
  const n = new URLSearchParams({
    page: String(e + 1),
    limit: String(koe)
  });
  return `${Toe}?${n}`;
}
function zc() {
  const e = ln();
  return Poe(Aoe, e, {
    onErrorRetry: (t) => {
      t.status;
    }
  });
}
function BT(e) {
  return e == null ? void 0 : e.chats;
}
function jT(e) {
  return e == null ? void 0 : e._id;
}
function WT(e) {
  return e == null ? void 0 : e.title;
}
function Moe(e) {
  return e == null ? void 0 : e.createdAt;
}
function Ooe(e = [], t) {
  return e == null ? void 0 : e.find((n) => n._id === t);
}
function Roe(e, t) {
  return e == null ? void 0 : e.filter((n) => n._id !== t);
}
function Ioe(e = [], t) {
  return e.map((n) => ({
    chats: Roe(n.chats, t),
    hasMore: n.hasMore
  }));
}
function aw() {
  return { chats: [], hasMore: !1 };
}
function UT(e) {
  return e.reduce(
    (t, n) => ({
      ...t,
      chats: [...t.chats, ...n.chats]
    }),
    aw()
  );
}
function Doe(e) {
  var t;
  return (t = e[e.length - 1]) == null ? void 0 : t.hasMore;
}
function Noe() {
}
var $oe = Noe;
const Mr = /* @__PURE__ */ Pi($oe), HT = {
  activeNavigationItem: void 0,
  startingQuestions: {
    activeCategory: void 0
  }
};
function Loe(e, t) {
  switch (t.type) {
    case "setActiveNavigationItem": {
      e.activeNavigationItem = t.payload, t.payload || (e.startingQuestions.activeCategory = void 0);
      break;
    }
    case "setActiveStartingQuestionsCategory": {
      e.startingQuestions.activeCategory = t.payload;
      break;
    }
  }
}
function Foe(e) {
  return !!e.activeNavigationItem;
}
function GT(e) {
  return e.activeNavigationItem;
}
function zoe(e) {
  return e.startingQuestions.activeCategory;
}
const qT = {
  generation: null,
  selectedChat: null,
  selectedChatForDeletion: null,
  selectedChatMessageForFeedback: null,
  userInput: ""
};
function Voe(e, t) {
  switch (t.type) {
    case "askQuestion": {
      e.userInput = t.question, e.generation = null;
      break;
    }
    case "citationMetadataReceived": {
      const n = ta(e);
      n.metadata.citation_metadata[t.metadata.citationID] = t.metadata, e.generation = n;
      break;
    }
    case "citationReceived": {
      const n = ta(e);
      n.message = `${n.message} ${t.citation}`, e.generation = n;
      break;
    }
    case "cleanOptimisticChatState": {
      e.generation = null, e.userInput = "";
      break;
    }
    case "createChat": {
      e.selectedChat = null;
      break;
    }
    case "errorMessageReceived": {
      const n = ta(e);
      n.errors = n.errors ? [...n.errors, t.message] : [t.message], e.generation = n;
      break;
    }
    case "followUpQuestionsReceived": {
      const n = ta(e);
      n.followUpQuestions = t.questions;
      break;
    }
    case "generationTokenReceived": {
      const n = ta(e);
      n.message = `${n.message}${t.word.chunk}`, e.generation = n;
      break;
    }
    case "selectChat": {
      e.selectedChat = t.chatId;
      break;
    }
    case "selectChatForDeletion": {
      e.selectedChatForDeletion = t.chatId;
      break;
    }
    case "selectChatMessageForFeedback": {
      e.selectedChatMessageForFeedback = t.messageId;
      break;
    }
    case "sourceReceived": {
      const n = ta(e);
      n.sources[t.source.contentID] = t.source, e.generation = n;
      break;
    }
    case "sourceMetadataReceived": {
      const n = ta(e);
      n.metadata.source_metadata[t.metadata.sourceId] = t.metadata, e.generation = n;
      break;
    }
    case "unselectChatForDeletion": {
      e.selectedChatForDeletion = null;
      break;
    }
    case "unselectChatMessageForFeedback": {
      e.selectedChatMessageForFeedback = null;
      break;
    }
    case "videoStarted": {
      e.isVideoPlaying = !0;
      break;
    }
    case "videoStopped": {
      e.isVideoPlaying = !1;
      break;
    }
  }
}
function Vc(e) {
  return e.selectedChat;
}
function no(e) {
  return e.generation;
}
function Boe(e) {
  const t = no(e);
  return t == null ? void 0 : t.followUpQuestions;
}
function joe(e) {
  const t = no(e);
  return t == null ? void 0 : t.message;
}
function Woe(e) {
  const t = no(e);
  return t == null ? void 0 : t.sources;
}
function Uoe(e) {
  return e.userInput;
}
function Hoe(e) {
  const t = no(e);
  return t == null ? void 0 : t.metadata;
}
function YT(e) {
  const t = no(e);
  return t == null ? void 0 : t.errors;
}
function ta(e) {
  const t = no(e);
  return t || voe();
}
function Goe(e) {
  return e.isVideoPlaying;
}
function KT(e) {
  return e.selectedChatForDeletion;
}
function XT(e) {
  return e.selectedChatMessageForFeedback;
}
const ZT = {
  askPlaceSize: "midsize",
  chatState: qT,
  isGenerationInProgress: !1,
  isReleaseNotesOpen: !1,
  isStreamingAutoScrollEnabled: !1,
  navigationState: HT,
  allowStreamingAutoScroll: Mr,
  askQuestion: Mr,
  chatDispatch: Mr,
  disableStreamingAutoScroll: Mr,
  navigationDispatch: Mr,
  selectChat: Mr,
  setAskPlaceSize: Mr,
  setIsReleaseNotesOpen: Mr,
  stopGenerating: Mr,
  onMinimize: Mr,
  createNewChat: Mr
}, At = wn(
  ZT
);
function QT(e) {
  e != null && e.current && (e.current.scrollTop = e.current.scrollHeight);
}
const qoe = -12, Yoe = 12, Ql = 450, Koe = 350, Xoe = 600, JT = 600, sw = "prevent_dragging", Zoe = `#${sw}`;
function Cg(e) {
  e = e || Yoe;
  const t = window.localStorage.getItem("askPlaceHeight"), n = t ? Number(t) : Gd();
  return e > 0 ? e : window.innerHeight - e - n;
}
function Sg(e) {
  e = e || qoe;
  const t = window.localStorage.getItem("askPlaceWidth"), n = t ? Number(t) : Ql;
  return e > 0 ? e : document.documentElement.clientWidth + e - n;
}
function Gd() {
  return Math.max(JT, Math.round(window.innerHeight * 0.75));
}
const Xs = wn(null);
function e7({
  children: e,
  defaultX: t,
  defaultY: n
}) {
  const r = window.localStorage.getItem("askPlaceX"), i = r ? Number(r) : Sg(t), [o, a] = de(i), s = window.localStorage.getItem("askPlaceY"), l = s ? Number(s) : Cg(n), [u, d] = de(l), f = Number(window.localStorage.getItem("askPlaceWidth")) || Ql, [p, m] = de(f), g = Number(window.localStorage.getItem("askPlaceHeight")) || Gd(), [v, y] = de(g), [b, E] = de(!1), [S, _] = de(!1), k = De(() => {
    window.localStorage.removeItem("askPlaceX"), window.localStorage.removeItem("askPlaceY"), window.localStorage.removeItem("askPlaceWidth"), window.localStorage.removeItem("askPlaceHeight"), a(Sg(t)), d(Cg(n)), m(Ql), y(Gd()), E(!1);
  }, [t, n]);
  return be(() => {
    (o !== Sg(t) || u !== Cg(n) || p !== Ql || v !== Gd()) && E(!0);
  }, [o, u, p, v, t, n]), /* @__PURE__ */ x.createElement(
    Xs.Provider,
    {
      value: {
        x: o,
        y: u,
        width: p,
        height: v,
        hasDimensionsChanged: b,
        isResizing: S,
        setX: a,
        setY: d,
        setWidth: m,
        setHeight: y,
        resetDimensions: k,
        setIsResizing: _
      }
    },
    e
  );
}
const lw = DT();
function dC() {
  lw.emit("video-stopped");
}
function Qoe(e) {
  lw.on("video-stopped", e);
}
function Joe() {
  lw.all.clear();
}
const eae = "/rag-chat/chats";
function tae({ chatId: e }) {
  const t = ln(), { isLoading: n, mutate: r } = zc(), i = `${eae}/${e}`;
  async function o(a) {
    n || !e || (r(
      (s) => Ioe(s, e),
      !1
    ), await t(a, { method: "DELETE" }), r());
  }
  return Hs(i, o);
}
const Kh = "Ask Gabbi", cw = "Untitled Chat";
function t7({
  children: e,
  className: t,
  onClick: n
}) {
  return /* @__PURE__ */ x.createElement(
    mn.div,
    {
      initial: { opacity: 0 },
      animate: { opacity: 1, transition: { duration: 0.2 } },
      exit: { opacity: 0 },
      className: ie(
        "ai-tw-absolute ai-tw-inset-0 ai-tw-cursor-pointer ai-tw-rounded-lg ai-tw-bg-black/25",
        t
      ),
      onClick: n
    },
    e
  );
}
function nae({
  children: e,
  title: t,
  confirmText: n = "Confirm",
  open: r,
  onCancel: i,
  onConfirm: o
}) {
  function a(s) {
    switch (s.key) {
      case "Enter":
        s.preventDefault(), o && o();
        break;
      case "Escape":
        i && i();
        break;
    }
  }
  return /* @__PURE__ */ x.createElement(X6, { open: r }, /* @__PURE__ */ x.createElement(hy, null, /* @__PURE__ */ x.createElement(t7, null, /* @__PURE__ */ x.createElement(
    py,
    {
      onPointerDownOutside: i,
      onKeyDown: a,
      className: "ai-tw-absolute ai-tw-left-1/2 ai-tw-top-1/2 ai-tw-z-20 ai-tw-max-w-[300px] -ai-tw-translate-x-1/2 -ai-tw-translate-y-1/2 ai-tw-rounded-lg ai-tw-bg-white ai-tw-p-4"
    },
    /* @__PURE__ */ x.createElement(my, { className: "ai-tw-text-content-primary ai-tw-subtitle-md" }, t),
    /* @__PURE__ */ x.createElement(gy, { className: "ai-tw-mt-5 ai-tw-text-content-primary-light ai-tw-body-md" }, e),
    /* @__PURE__ */ x.createElement("div", { className: "ai-tw-mt-5 ai-tw-flex ai-tw-justify-between" }, /* @__PURE__ */ x.createElement(Xt, { variant: "tertiary", size: "sm", onClick: i }, "Cancel"), /* @__PURE__ */ x.createElement(Xt, { variant: "destructive", size: "sm", onClick: o }, n))
  ))));
}
function rae({
  chatTitle: e
}) {
  return /* @__PURE__ */ x.createElement("span", null, "This will delete the chat", " ", /* @__PURE__ */ x.createElement("span", { className: "ai-tw-font-bold" }, e || cw));
}
function iae() {
  const { chatState: e, chatDispatch: t, selectChat: n, stopGenerating: r } = Me(At), i = KT(e), { data: o, isLoading: a } = zc(), s = o ? UT(o) : aw(), l = BT(s), u = Vc(e), { trigger: d } = tae({
    chatId: i
  });
  function f() {
    u || (r(), t({ type: "cleanOptimisticChatState" })), u === i && n(null), d(), t({ type: "unselectChatForDeletion" });
  }
  if (a)
    return null;
  const p = Ooe(l, i);
  return p ? /* @__PURE__ */ x.createElement(
    nae,
    {
      title: "Delete chat?",
      open: !!i,
      onCancel: () => t({ type: "unselectChatForDeletion" }),
      onConfirm: f
    },
    /* @__PURE__ */ x.createElement(rae, { chatTitle: p.title })
  ) : null;
}
function oae(e) {
  const t = e ? `/rag-chat/chat-messages/${e}/feedback` : null, n = ln();
  function r(i, { arg: o }) {
    return n(i, {
      json: o.json,
      method: "PUT"
    });
  }
  return Hs(t, r);
}
function aae(e, t = !0) {
  const n = ln(), r = `/rag-chat/chat-messages/${e}/feedback`;
  function i() {
    return n(r);
  }
  return br(t && e ? r : null, i, {
    onErrorRetry: (o) => {
      o.status;
    }
  });
}
const fC = {
  positive: "What did you like about this generation?",
  negative: "What can be improved?",
  default: "Additional feedback"
}, sae = "Error submitting feedback. Please try again.";
function lae({
  actionsContainerClassName: e,
  errorText: t,
  feedbackRadioProps: n,
  formClassName: r,
  isSubmitButtonDisabled: i,
  submitButtonProps: o,
  textAreaProps: a,
  onSubmit: s
}) {
  const [l, u] = de(), d = t || l, f = n != null && n.value ? fC[n == null ? void 0 : n.value] : fC.default;
  async function p(m) {
    m.preventDefault(), m.stopPropagation();
    try {
      const g = new FormData(m.currentTarget), v = Object.fromEntries(g.entries());
      if (!v.result) {
        u("Rating is required."), setTimeout(() => u(null), 2e3);
        return;
      }
      await s(v);
    } catch (g) {
      console.error(g), u(sae), setTimeout(() => u(null), 2e3);
    }
  }
  return /* @__PURE__ */ x.createElement(
    "form",
    {
      className: ie(
        "ai-tw-grid ai-tw-grow ai-tw-grid-rows-[auto_auto_1fr_auto] ai-tw-gap-3",
        r
      ),
      onSubmit: p
    },
    /* @__PURE__ */ x.createElement("h3", { className: "ai-tw-heading-3" }, "Provide Feedback"),
    /* @__PURE__ */ x.createElement(lP, { ...n }),
    /* @__PURE__ */ x.createElement(
      Eh,
      {
        name: "message",
        labelText: f,
        rows: 7,
        ...a,
        containerClassName: ie(
          "ai-tw-flex ai-tw-flex-col",
          a == null ? void 0 : a.containerClassName
        ),
        className: ie("ai-tw-grow", a == null ? void 0 : a.className)
      }
    ),
    /* @__PURE__ */ x.createElement(
      "div",
      {
        className: ie(
          "ai-tw-flex ai-tw-items-center ai-tw-justify-end ai-tw-gap-3",
          e
        )
      },
      d ? /* @__PURE__ */ x.createElement("p", { className: "ai-tw-text-xs ai-tw-text-red-50" }, /* @__PURE__ */ x.createElement(Le, { icon: to }), /* @__PURE__ */ x.createElement("span", null, d)) : null,
      /* @__PURE__ */ x.createElement(
        Xt,
        {
          variant: "ai-primary",
          disabled: i,
          ...o
        },
        "Submit"
      )
    )
  );
}
function cae({
  isOpen: e,
  onClose: t,
  className: n,
  children: r,
  ...i
}) {
  return /* @__PURE__ */ x.createElement(ri, null, e ? /* @__PURE__ */ x.createElement(
    mn.div,
    {
      initial: { opacity: 0, scale: 0, transformOrigin: "top left" },
      animate: { opacity: 1, scale: 1 },
      exit: { opacity: 0, scale: 0 },
      transition: { duration: 0.2 },
      className: ie(
        "ai-tw-absolute ai-tw-left-0 ai-tw-top-0 ai-tw-z-20",
        "ai-tw-flex ai-tw-h-full ai-tw-w-full ai-tw-flex-col ai-tw-gap-3 ai-tw-bg-white ai-tw-p-3",
        n
      ),
      ...i
    },
    /* @__PURE__ */ x.createElement(G1, { "aria-label": "back", onClick: t }, /* @__PURE__ */ x.createElement(Le, { icon: Y$ })),
    r
  ) : null);
}
function uae({
  isOpen: e,
  onClose: t
}) {
  const { chatState: n } = Me(At), r = XT(n), [i, o] = de(null), [a, s] = de(), [l, u] = de(), { data: d, isValidating: f } = aae(
    r,
    !!r
  ), { trigger: p, isMutating: m } = oae(r);
  async function g(k) {
    r && (u("loading"), await p(
      { json: k },
      {
        onError: y
      }
    ), o(k), u("success"), setTimeout(() => {
      u(void 0), v();
    }, 2e3));
  }
  function v() {
    s(null), o(null), t();
  }
  function y(k) {
    console.error(k), s(
      "Unknown error occurred while submitting feedback. Please try again or contact the support team."
    ), setTimeout(() => {
      s(null);
    }, 5e3);
  }
  const b = f || m || !!l, E = {
    className: "ai-tw-mt-5",
    disabled: b,
    value: d == null ? void 0 : d.result,
    onValueChange: (k) => {
      const T = { result: k };
      p(
        {
          json: i ? {
            ...i,
            ...T
          } : T
        },
        {
          onError: y
        }
      );
    }
  }, S = {
    disabled: b,
    status: l
  }, _ = {
    containerClassName: "ai-tw-mt-5",
    variant: "ai",
    defaultValue: d == null ? void 0 : d.message
  };
  return /* @__PURE__ */ x.createElement(
    cae,
    {
      isOpen: e,
      onClose: v,
      className: "ai-tw-p-8"
    },
    /* @__PURE__ */ x.createElement(
      lae,
      {
        actionsContainerClassName: "ai-tw-mt-6",
        errorText: a,
        formClassName: "ai-tw-gap-0",
        feedbackRadioProps: E,
        submitButtonProps: S,
        textAreaProps: _,
        onSubmit: g
      }
    )
  );
}
function hC({
  children: e,
  className: t,
  onClick: n,
  disabled: r
}) {
  return /* @__PURE__ */ x.createElement(
    xh,
    {
      "aria-label": "stop",
      type: "button",
      className: ie(
        "ai-tw-group ai-tw-h-7 ai-tw-w-7 ai-tw-text-white active:!ai-tw-bg-transparent",
        t
      ),
      onClick: n,
      disabled: r
    },
    e
  );
}
function pC({ isIconActive: e, icon: t }) {
  return /* @__PURE__ */ x.createElement(
    Le,
    {
      icon: t,
      mask: fL,
      className: ie("ai-tw-bg-content-primary-lightest ai-tw-bg-none", {
        "ai-tw-bg-gradient-to-r ai-tw-from-purple-40 ai-tw-to-purple-20": e
      })
    }
  );
}
function n7({
  onFocus: e,
  onBlur: t,
  onSubmit: n
}) {
  const [r, i] = de(""), [o, a] = de(!1);
  function s() {
    i("");
  }
  function l() {
    u(r), s(), n == null || n();
  }
  const { askQuestion: u, stopGenerating: d, isGenerationInProgress: f } = Me(At);
  function p(v) {
    if (v.key === "Enter" && !v.shiftKey && r) {
      if (f) {
        v.preventDefault();
        return;
      }
      l(), v.preventDefault();
    }
  }
  function m(v) {
    e == null || e(v), a(!0);
  }
  function g(v) {
    t == null || t(v), a(!1);
  }
  return /* @__PURE__ */ x.createElement("div", { className: "ai-tw-relative ai-tw-flex" }, /* @__PURE__ */ x.createElement(
    iy,
    {
      variant: "ai",
      className: ie(
        "ai-tw-h-10 ai-tw-border !ai-tw-border-purple-40 !ai-tw-bg-white focus:ai-tw-text-content-primary",
        f ? "ai-tw-pr-16" : "ai-tw-pr-10"
      ),
      placeholder: Kh,
      value: r,
      onChange: (v) => i(v.target.value),
      onKeyDown: p,
      onFocus: m,
      onBlur: g
    }
  ), f ? /* @__PURE__ */ x.createElement("div", { className: "ai-tw-absolute ai-tw-bottom-1.5 ai-tw-right-3 ai-tw-flex ai-tw-items-center" }, /* @__PURE__ */ x.createElement(jn, { size: "small", variant: "ai", className: "ai-tw-mr-1" }), /* @__PURE__ */ x.createElement(hC, { onClick: d }, /* @__PURE__ */ x.createElement(pC, { icon: fS, isIconActive: !0 }))) : /* @__PURE__ */ x.createElement(
    hC,
    {
      className: "ai-tw-absolute ai-tw-bottom-1.5 ai-tw-right-3",
      onClick: l,
      disabled: !r
    },
    /* @__PURE__ */ x.createElement(
      pC,
      {
        icon: n1,
        isIconActive: o
      }
    )
  ));
}
var Iye = {
  prefix: "far",
  iconName: "message",
  icon: [512, 512, ["comment-alt"], "f27a", "M160 368c26.5 0 48 21.5 48 48v16l72.5-54.4c8.3-6.2 18.4-9.6 28.8-9.6H448c8.8 0 16-7.2 16-16V64c0-8.8-7.2-16-16-16H64c-8.8 0-16 7.2-16 16V352c0 8.8 7.2 16 16 16h96zm48 124l-.2 .2-5.1 3.8-17.1 12.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3V474.7v-6.4V468v-4V416H112 64c-35.3 0-64-28.7-64-64V64C0 28.7 28.7 0 64 0H448c35.3 0 64 28.7 64 64V352c0 35.3-28.7 64-64 64H309.3L208 492z"]
}, Dye = {
  prefix: "far",
  iconName: "comments",
  icon: [640, 512, [128490, 61670], "f086", "M88.2 309.1c9.8-18.3 6.8-40.8-7.5-55.8C59.4 230.9 48 204 48 176c0-63.5 63.8-128 160-128s160 64.5 160 128s-63.8 128-160 128c-13.1 0-25.8-1.3-37.8-3.6c-10.4-2-21.2-.6-30.7 4.2c-4.1 2.1-8.3 4.1-12.6 6c-16 7.2-32.9 13.5-49.9 18c2.8-4.6 5.4-9.1 7.9-13.6c1.1-1.9 2.2-3.9 3.2-5.9zM0 176c0 41.8 17.2 80.1 45.9 110.3c-.9 1.7-1.9 3.5-2.8 5.1c-10.3 18.4-22.3 36.5-36.6 52.1c-6.6 7-8.3 17.2-4.6 25.9C5.8 378.3 14.4 384 24 384c43 0 86.5-13.3 122.7-29.7c4.8-2.2 9.6-4.5 14.2-6.8c15.1 3 30.9 4.5 47.1 4.5c114.9 0 208-78.8 208-176S322.9 0 208 0S0 78.8 0 176zM432 480c16.2 0 31.9-1.6 47.1-4.5c4.6 2.3 9.4 4.6 14.2 6.8C529.5 498.7 573 512 616 512c9.6 0 18.2-5.7 22-14.5c3.8-8.8 2-19-4.6-25.9c-14.2-15.6-26.2-33.7-36.6-52.1c-.9-1.7-1.9-3.4-2.8-5.1C622.8 384.1 640 345.8 640 304c0-94.4-87.9-171.5-198.2-175.8c4.1 15.2 6.2 31.2 6.2 47.8l0 .6c87.2 6.7 144 67.5 144 127.4c0 28-11.4 54.9-32.7 77.2c-14.3 15-17.3 37.6-7.5 55.8c1.1 2 2.2 4 3.2 5.9c2.5 4.5 5.2 9 7.9 13.6c-17-4.5-33.9-10.7-49.9-18c-4.3-1.9-8.5-3.9-12.6-6c-9.5-4.8-20.3-6.2-30.7-4.2c-12.1 2.4-24.7 3.6-37.8 3.6c-61.7 0-110-26.5-136.8-62.3c-16 5.4-32.8 9.4-50 11.8C279 439.8 350 480 432 480z"]
}, Nye = {
  prefix: "far",
  iconName: "octagon-minus",
  icon: [512, 512, ["minus-octagon"], "f308", "M191.5 48.1c-6.4 0-12.5 2.5-17 7L55.1 174.5c-4.5 4.5-7 10.6-7 17v129c0 6.4 2.5 12.5 7 17L21.2 371.4C7.7 357.9 .1 339.6 .1 320.5v-129c0-19.1 7.6-37.4 21.1-50.9L140.6 21.2C154.1 7.7 172.4 .1 191.5 .1h129c19.1 0 37.4 7.6 50.9 21.1L490.8 140.6c13.5 13.5 21.1 31.8 21.1 50.9v129c0 19.1-7.6 37.4-21.1 50.9L371.4 490.8c-13.5 13.5-31.8 21.1-50.9 21.1h-129c-19.1 0-37.4-7.6-50.9-21.1L21.2 371.4l33.9-33.9L174.5 456.9c4.5 4.5 10.6 7 17 7h129c6.4 0 12.5-2.5 17-7L456.9 337.5c4.5-4.5 7-10.6 7-17v-129c0-6.4-2.5-12.5-7-17L337.5 55.1c-4.5-4.5-10.6-7-17-7h-129zM184 232H328c13.3 0 24 10.7 24 24s-10.7 24-24 24H184c-13.3 0-24-10.7-24-24s10.7-24 24-24z"]
}, dae = {
  prefix: "far",
  iconName: "bullhorn",
  icon: [512, 512, [128226, 128363], "f0a1", "M432 73.9L421.3 84.6C364.5 141.4 288.1 174 208 175.9v.1V304v0 .1c80.1 1.9 156.5 34.5 213.3 91.3L432 406.1V73.9zM160 128h40.7c70 0 137.2-27.8 186.7-77.3l38-38C445.5-7.5 480 6.8 480 35.3V179.6c18.6 8.8 32 32.5 32 60.4s-13.4 51.6-32 60.4V444.7c0 28.5-34.5 42.8-54.6 22.6l-38-38c-47.8-47.8-112-75.4-179.4-77.2V456c0 30.9-25.1 56-56 56H120c-30.9 0-56-25.1-56-56l0-104c-35.3 0-64-28.7-64-64V192c0-35.3 28.7-64 64-64h96zM112 352V456c0 4.4 3.6 8 8 8h32c4.4 0 8-3.6 8-8V352H112zM64 176c-8.8 0-16 7.2-16 16v96c0 8.8 7.2 16 16 16l0 0h48 48V176l-96 0z"]
}, r7 = {
  prefix: "far",
  iconName: "clock-three",
  icon: [512, 512, [], "e356", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120V256c0 13.3 10.7 24 24 24H360c13.3 0 24-10.7 24-24s-10.7-24-24-24H280V120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"]
}, $ye = {
  prefix: "far",
  iconName: "circle-stop",
  icon: [512, 512, [62094, "stop-circle"], "f28d", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm192-96H320c17.7 0 32 14.3 32 32V320c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V192c0-17.7 14.3-32 32-32z"]
}, fae = {
  prefix: "far",
  iconName: "square-arrow-down-left",
  icon: [448, 512, [], "e261", "M64 432c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16H384c8.8 0 16 7.2 16 16V416c0 8.8-7.2 16-16 16H64zM0 416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64C28.7 32 0 60.7 0 96V416zm288-48c13.3 0 24-10.7 24-24s-10.7-24-24-24H193.9L329 185c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-135 135V184c0-13.3-10.7-24-24-24s-24 10.7-24 24V344c0 13.3 10.7 24 24 24H288z"]
}, Lye = {
  prefix: "far",
  iconName: "clock-eight",
  icon: [512, 512, [], "e345", "M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM280 120V256c0 8-4 15.5-10.7 20l-96 64c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3L232 243.2V120c0-13.3 10.7-24 24-24s24 10.7 24 24z"]
}, Fye = {
  prefix: "far",
  iconName: "shirt",
  icon: [640, 512, [128085, "t-shirt", "tshirt"], "f553", "M233.7 33.1l-23.5 4.6 0 0 23.5-4.6zm172.7 0l-23.5-4.6v0l23.5 4.6zm71.9 13.2l15.4-18.4 0 0L478.3 46.3zM604.5 151.4L619.8 133v0l-15.4 18.4zm3.6 45.7L590 181.3v0l18.1 15.8zm-56 64l18.1 15.8-18.1-15.8zm-44.6 3.5L492.2 283v0l15.4-18.4zM456 221.7l15.4-18.4c-7.2-6-17.1-7.2-25.5-3.3s-13.8 12.4-13.8 21.7h24zm-272 0h24c0-9.3-5.4-17.8-13.8-21.7s-18.4-2.7-25.5 3.3L184 221.7zm-51.5 42.9L147.9 283h0l-15.4-18.4zm-44.6-3.5L69.9 276.9l18.1-15.8zm-56-64L50 181.3l0 0L31.9 197.1zm-7.8-23.6L.2 171.6l23.9 1.9zm11.4-22.1L20.1 133l0 0 15.4 18.4zM161.7 46.3l15.4 18.4L161.7 46.3zm95.5-17.8C254.3 13.6 241.3 0 223.2 0V48c-7.8 0-12.2-5.7-13.1-10.3l47.1-9.3zM320 80c-31.1 0-57-22.2-62.8-51.5l-47.1 9.3C220.2 89.2 265.6 128 320 128V80zm62.8-51.5C377 57.8 351.1 80 320 80v48c54.4 0 99.8-38.8 109.9-90.3l-47.1-9.3zM416.8 0c-18.2 0-31.1 13.6-34 28.5l47.1 9.3C429 42.3 424.6 48 416.8 48V0zm76.8 27.8C472.1 9.8 444.9 0 416.8 0V48c16.8 0 33.2 5.9 46.1 16.7l30.7-36.9zM619.8 133L493.7 27.8 462.9 64.7 589.1 169.9 619.8 133zm20 38.6c-1.2-15-8.4-29-20-38.6l-30.7 36.9c1.7 1.4 2.7 3.4 2.9 5.5l47.9-3.8zm-13.7 41.3c9.9-11.4 14.9-26.2 13.7-41.3L592 175.4c.2 2.1-.5 4.3-2 5.9l36.1 31.6zm-56 64l56-64L590 181.3l-56 64 36.1 31.6zm-78 6.1c23.4 19.5 58 16.7 78-6.1L534 245.3c-2.9 3.3-7.8 3.7-11.1 .9L492.2 283zm-51.5-42.9L492.2 283l30.7-36.9-51.5-42.9-30.7 36.9zM432 221.7V448h48V221.7H432zM432 448c0 8.8-7.2 16-16 16v48c35.3 0 64-28.7 64-64H432zm-16 16H224v48H416V464zm-192 0c-8.8 0-16-7.2-16-16H160c0 35.3 28.7 64 64 64V464zm-16-16V221.7H160V448h48zM147.9 283l51.5-42.9-30.7-36.9-51.5 42.9L147.9 283zm-78-6.1c20 22.9 54.6 25.6 78 6.1l-30.7-36.9c-3.3 2.8-8.3 2.4-11.1-.9L69.9 276.9zm-56-64l56 64L106 245.3l-56-64L13.9 212.9zM.2 171.6c-1.2 15 3.7 29.9 13.7 41.3L50 181.3c-1.4-1.6-2.1-3.7-2-5.9L.2 171.6zm20-38.6c-11.6 9.7-18.8 23.6-20 38.6L48 175.4c.2-2.1 1.2-4.1 2.9-5.5L20.1 133zM146.3 27.8L20.1 133l30.7 36.9L177.1 64.7 146.3 27.8zM223.2 0c-28.1 0-55.3 9.8-76.8 27.8l30.7 36.9C190 53.9 206.3 48 223.2 48V0z"]
}, hae = {
  prefix: "far",
  iconName: "circle-info",
  icon: [512, 512, ["info-circle"], "f05a", "M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24h80c13.3 0 24-10.7 24-24s-10.7-24-24-24h-8V248c0-13.3-10.7-24-24-24H216c-13.3 0-24 10.7-24 24s10.7 24 24 24h24v64H216zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"]
}, zye = hae, Vye = {
  prefix: "far",
  iconName: "droplet-slash",
  icon: [640, 512, ["tint-slash"], "f5c7", "M320 464c37.9 0 72.4-14.6 98.1-38.6l38 30C421.4 490.3 373.2 512 320 512c-106 0-192-86-192-192c0-27.7 12-62.9 29.8-99.6l38.7 30.5c-1.2 2.7-2.4 5.4-3.6 8c-11.9 27.6-17 48.2-17 61.1c0 79.5 64.5 144 144 144zm185.2-93.3l125.6 98.4c10.4 8.2 12.3 23.3 4.1 33.7s-23.3 12.3-33.7 4.1L9.2 42.9C-1.2 34.7-3.1 19.6 5.1 9.2S28.4-3.1 38.8 5.1L205.8 136c34.9-54.7 72-103 88.9-124.3C300.6 4.2 309.5 0 319.1 0h1.8c9.6 0 18.5 4.2 24.5 11.7C381.8 57.7 512 228.8 512 320c0 17.5-2.4 34.6-6.8 50.7zm-42.3-33.1c.7-5.8 1.1-11.6 1.1-17.6c0-13-5.1-33.5-17-61.1c-11.5-26.6-27.6-55.8-45.5-84.7c-29-46.8-61-90.2-81.5-117c-19.3 25.1-48.7 65-76.3 108.5L462.9 337.5zM224 312c0-11.9 8.7-21.8 20.1-23.7l27.9 21.9c0 .6 .1 1.2 .1 1.7c0 30.9 25.1 56 56 56c13.3 0 24 10.7 24 24s-10.7 24-24 24c-57.4 0-104-46.6-104-104z"]
}, Bye = {
  prefix: "far",
  iconName: "face-meh",
  icon: [512, 512, [128528, "meh"], "f11a", "M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM256 0a256 256 0 1 0 0 512A256 256 0 1 0 256 0zM176.4 240a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm192-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM184 328c-13.3 0-24 10.7-24 24s10.7 24 24 24H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H184z"]
}, jye = {
  prefix: "far",
  iconName: "message-slash",
  icon: [640, 512, ["comment-alt-slash"], "f4a9", "M38.8 5.1C28.4-3.1 13.3-1.2 5.1 9.2S-1.2 34.7 9.2 42.9l592 464c10.4 8.2 25.5 6.3 33.7-4.1s6.3-25.5-4.1-33.7l-82.3-64.5C565.1 393 576 373.8 576 352V64c0-35.3-28.7-64-64-64H128C104.4 0 83.8 12.7 72.7 31.7L38.8 5.1zm73.3 57.4c.7-8.1 7.6-14.5 15.9-14.5H512c8.8 0 16 7.2 16 16V352c0 8.8-7.2 16-16 16H501.8L112.1 62.5zM406.2 416l-54.4-42.9c-2.5 1.3-4.9 2.8-7.2 4.5L272 432V416c0-26.5-21.5-48-48-48H128c-8.8 0-16-7.2-16-16V184.2L64 146.4V352c0 35.3 28.7 64 64 64h48 48v48 4 .3 6.4V496c0 6.1 3.4 11.6 8.8 14.3s11.9 2.1 16.8-1.5L266.7 496l5.1-3.8 .2-.2 101.3-76h32.8z"]
}, pae = {
  prefix: "far",
  iconName: "thumbs-down",
  icon: [512, 512, [128078, 61576], "f165", "M323.8 477.2c-38.2 10.9-78.1-11.2-89-49.4l-5.7-20c-3.7-13-10.4-25-19.5-35l-51.3-56.4c-8.9-9.8-8.2-25 1.6-33.9s25-8.2 33.9 1.6l51.3 56.4c14.1 15.5 24.4 34 30.1 54.1l5.7 20c3.6 12.7 16.9 20.1 29.7 16.5s20.1-16.9 16.5-29.7l-5.7-20c-5.7-19.9-14.7-38.7-26.6-55.5c-5.2-7.3-5.8-16.9-1.7-24.9s12.3-13 21.3-13L448 288c8.8 0 16-7.2 16-16c0-6.8-4.3-12.7-10.4-15c-7.4-2.8-13-9-14.9-16.7s.1-15.8 5.3-21.7c2.5-2.8 4-6.5 4-10.6c0-7.8-5.6-14.3-13-15.7c-8.2-1.6-15.1-7.3-18-15.2s-1.6-16.7 3.6-23.3c2.1-2.7 3.4-6.1 3.4-9.9c0-6.7-4.2-12.6-10.2-14.9c-11.5-4.5-17.7-16.9-14.4-28.8c.4-1.3 .6-2.8 .6-4.3c0-8.8-7.2-16-16-16H286.5c-12.6 0-25 3.7-35.5 10.7l-61.7 41.1c-11 7.4-25.9 4.4-33.3-6.7s-4.4-25.9 6.7-33.3l61.7-41.1c18.4-12.3 40-18.8 62.1-18.8H384c34.7 0 62.9 27.6 64 62c14.6 11.7 24 29.7 24 50c0 4.5-.5 8.8-1.3 13c15.4 11.7 25.3 30.2 25.3 51c0 6.5-1 12.8-2.8 18.7C504.8 238.3 512 254.3 512 272c0 35.3-28.6 64-64 64l-92.3 0c4.7 10.4 8.7 21.2 11.8 32.2l5.7 20c10.9 38.2-11.2 78.1-49.4 89zM32 384c-17.7 0-32-14.3-32-32V128c0-17.7 14.3-32 32-32H96c17.7 0 32 14.3 32 32V352c0 17.7-14.3 32-32 32H32z"]
}, Wye = {
  prefix: "far",
  iconName: "droplet",
  icon: [384, 512, [128167, "tint"], "f043", "M192 464c-79.5 0-144-64.5-144-144c0-13 5.1-33.5 17-61.1c11.5-26.6 27.6-55.8 45.5-84.7c29-46.8 61-90.2 81.5-117c20.5 26.7 52.6 70.2 81.5 117c17.9 28.9 34 58 45.5 84.7c11.9 27.6 17 48.2 17 61.1c0 79.5-64.5 144-144 144zM0 320C0 426 86 512 192 512s192-86 192-192c0-91.2-130.2-262.3-166.6-308.3C211.4 4.2 202.5 0 192.9 0h-1.8c-9.6 0-18.5 4.2-24.5 11.7C130.2 57.7 0 228.8 0 320zm144-8c0-13.3-10.7-24-24-24s-24 10.7-24 24c0 57.4 46.6 104 104 104c13.3 0 24-10.7 24-24s-10.7-24-24-24c-30.9 0-56-25.1-56-56z"]
}, mae = {
  prefix: "far",
  iconName: "copy",
  icon: [448, 512, [], "f0c5", "M384 336H192c-8.8 0-16-7.2-16-16V64c0-8.8 7.2-16 16-16l140.1 0L400 115.9V320c0 8.8-7.2 16-16 16zM192 384H384c35.3 0 64-28.7 64-64V115.9c0-12.7-5.1-24.9-14.1-33.9L366.1 14.1c-9-9-21.2-14.1-33.9-14.1H192c-35.3 0-64 28.7-64 64V320c0 35.3 28.7 64 64 64zM64 128c-35.3 0-64 28.7-64 64V448c0 35.3 28.7 64 64 64H256c35.3 0 64-28.7 64-64V416H272v32c0 8.8-7.2 16-16 16H64c-8.8 0-16-7.2-16-16V192c0-8.8 7.2-16 16-16H96V128H64z"]
}, Uye = {
  prefix: "far",
  iconName: "briefcase",
  icon: [512, 512, [128188], "f0b1", "M176 56V96H336V56c0-4.4-3.6-8-8-8H184c-4.4 0-8 3.6-8 8zM128 96V56c0-30.9 25.1-56 56-56H328c30.9 0 56 25.1 56 56V96h64c35.3 0 64 28.7 64 64V280 416c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V280 160c0-35.3 28.7-64 64-64h64zM48 304V416c0 8.8 7.2 16 16 16H448c8.8 0 16-7.2 16-16V304H320v16c0 17.7-14.3 32-32 32H224c-17.7 0-32-14.3-32-32V304H48zm144-48H320 464V160c0-8.8-7.2-16-16-16H360 152 64c-8.8 0-16 7.2-16 16v96H192z"]
};
function Oa({
  children: e,
  className: t,
  contentClassName: n,
  icon: r,
  onClick: i
}) {
  return /* @__PURE__ */ x.createElement(
    "button",
    {
      className: ie(
        "ai-tw-flex ai-tw-min-h-[32px] ai-tw-items-center ai-tw-rounded-lg ai-tw-p-3 ai-tw-text-content-primary ai-tw-body-sm hover:ai-tw-bg-element-primary-subtle-dark active:ai-tw-bg-element-primary-subtle-dark",
        t
      ),
      onClick: i
    },
    r ? /* @__PURE__ */ x.createElement(Le, { icon: r }) : null,
    e ? /* @__PURE__ */ x.createElement("span", { className: ie("ai-tw-ml-2", n) }, e) : null
  );
}
function i7({ className: e }) {
  const { navigationState: t, navigationDispatch: n } = Me(At), { width: r } = Me(Xs) || {}, i = GT(t), o = [
    ["previous-chats", "Previous Chats", r7],
    ["prompt-library", "Prompt Library", dS]
  ];
  return /* @__PURE__ */ x.createElement("nav", { className: e }, /* @__PURE__ */ x.createElement("ul", { className: "ai-tw-flex ai-tw-gap-x-4 ai-tw-overflow-x-auto" }, o.map(([a, s, l]) => /* @__PURE__ */ x.createElement("li", { key: a, className: "ai-tw-shrink-0" }, /* @__PURE__ */ x.createElement(
    Oa,
    {
      className: ie({
        "ai-tw-bg-element-primary-subtle-dark": i === a
      }),
      contentClassName: "ai-tw-ml-0",
      onClick: () => {
        if (i === a) {
          n({
            type: "setActiveNavigationItem",
            payload: void 0
          });
          return;
        }
        n({
          type: "setActiveNavigationItem",
          payload: a
        });
      },
      icon: l
    },
    /* @__PURE__ */ x.createElement(ri, null, r && r < Ql ? null : /* @__PURE__ */ x.createElement(
      mn.span,
      {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        className: "ai-tw-ml-2"
      },
      s
    ))
  )))));
}
const { VITE_COPILOT_TERMS_AND_CONDITIONS_URL: gae } = { VITE_API_URL: "https://write-a-plumber.brivity.com", VITE_COPILOT_TERMS_AND_CONDITIONS_URL: "https://www.brivity.com/brivity-terms-of-service", VITE_COPILOT_VIDEO_ASPECT_RATIO: "16:9", VITE_GOOGLE_MAPS_API_KEY: "AIzaSyDtAhuJZGjruRbzXJBs1lLIJ9DkC0CglXo", VITE_VIMEO_API_BASE_URL: "https://vimeo.com/api", BASE_URL: "/", MODE: "production", DEV: !1, PROD: !0, SSR: !1 };
function vae({
  className: e
}) {
  return /* @__PURE__ */ x.createElement(
    "span",
    {
      className: ie(
        "ai-tw-inline-block ai-tw-text-content-primary-light ai-tw-body-sm",
        e
      )
    },
    "AI-generated content may be inaccurate.",
    /* @__PURE__ */ x.createElement(
      "a",
      {
        href: gae,
        target: "_blank",
        rel: "noreferrer",
        className: "ai-tw-ml-1 ai-tw-underline"
      },
      "See Terms"
    )
  );
}
function yae() {
  const [e, t] = de(!1);
  function n() {
    t(!0);
  }
  function r() {
    t(!1);
  }
  return /* @__PURE__ */ x.createElement("div", { className: "ai-tw-px-3 ai-tw-pb-4 ai-tw-pt-1" }, /* @__PURE__ */ x.createElement(
    "div",
    {
      className: uc(
        "ai-tw-rounded-lg ai-tw-bg-tinted-grey-50 ai-tw-p-3 ai-tw-pb-2 ai-tw-transition-shadow ai-tw-relative",
        {
          "ai-tw-shadow-purple-10 ai-tw-shadow-dropdown": e
        }
      )
    },
    /* @__PURE__ */ x.createElement(
      n7,
      {
        onFocus: n,
        onBlur: r
      }
    ),
    /* @__PURE__ */ x.createElement(i7, { className: "ai-tw-mt-1.5" })
  ), /* @__PURE__ */ x.createElement(vae, { className: "ai-tw-mt-2" }));
}
function Cd(e) {
  return /* @__PURE__ */ x.createElement(
    Oa,
    {
      ...e,
      className: ie(
        "ai-tw-flex ai-tw-min-w-[32px] ai-tw-justify-center ai-tw-p-2",
        e.className
      )
    }
  );
}
function uw() {
  const { resetDimensions: e } = Me(Xs) || {}, {
    onMinimize: t,
    askPlaceSize: n,
    setAskPlaceSize: r,
    createNewChat: i,
    chatState: o
  } = Me(At), a = Vc(o), {
    swr: { data: s }
  } = qh({
    chatId: a,
    enabled: !!a
  }), l = jT(s), u = WT(s);
  return /* @__PURE__ */ x.createElement(
    "header",
    {
      onDoubleClick: () => {
        n === "midsize" && e && e();
      },
      className: ie(
        "ai-tw-flex ai-tw-items-center ai-tw-justify-between ai-tw-border-b ai-tw-border-stroke-primary ai-tw-bg-container-primary ai-tw-px-2.5 ai-tw-py-2 ai-tw-text-content-primary ai-tw-body-sm",
        {
          "ai-tw-cursor-move": n !== "maximized"
        }
      )
    },
    l ? /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-items-center ai-tw-overflow-hidden" }, n === "minimized" ? null : /* @__PURE__ */ x.createElement("div", { className: "ai-tw-mr-2 ai-tw-border-r ai-tw-border-stroke-primary" }, /* @__PURE__ */ x.createElement(
      Oa,
      {
        icon: P$,
        onClick: i,
        className: "ai-tw-mr-2 !ai-tw-body-md"
      }
    )), /* @__PURE__ */ x.createElement("p", { className: "ai-tw-truncate", title: u }, u || cw)) : /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-items-center ai-tw-px-2 ai-tw-subtitle-sm" }, /* @__PURE__ */ x.createElement(Le, { icon: k$, className: "ai-tw-mr-2" }), /* @__PURE__ */ x.createElement("p", { className: "ai-tw-uppercase ai-tw-tracking-[.18em]" }, Kh)),
    /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-gap-x-2" }, n !== "maximized" ? /* @__PURE__ */ x.createElement(
      Cd,
      {
        onClick: () => r("maximized"),
        icon: j$
      }
    ) : null, n !== "midsize" ? /* @__PURE__ */ x.createElement(
      Cd,
      {
        className: ie({
          "!ai-tw-body-md": n === "maximized"
        }),
        onClick: () => {
          r("midsize");
        },
        icon: n === "maximized" ? fae : N$
      }
    ) : null, n !== "minimized" ? /* @__PURE__ */ x.createElement(
      Cd,
      {
        onClick: () => r("minimized"),
        icon: dL
      }
    ) : null, /* @__PURE__ */ x.createElement(Cd, { onClick: t, icon: hS }))
  );
}
const Xh = "ask_place_navigation_modal_backdrop_container";
function wae() {
  const e = document.getElementById(
    Xh
  ), { navigationDispatch: t } = Me(At);
  function n() {
    t({
      type: "setActiveNavigationItem",
      payload: void 0
    });
  }
  return e ? _c(/* @__PURE__ */ x.createElement(t7, { onClick: n }), e) : null;
}
function mC({
  children: e,
  icon: t,
  title: n,
  onClose: r,
  className: i
}) {
  return /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-flex-initial ai-tw-justify-between ai-tw-pb-2" }, /* @__PURE__ */ x.createElement("p", { className: "ai-tw-flex ai-tw-items-center ai-tw-text-content-primary ai-tw-subtitle-md" }, /* @__PURE__ */ x.createElement(Le, { icon: t, className: "ai-tw-mr-1.5 ai-tw-body-sm" }), /* @__PURE__ */ x.createElement("span", null, n)), /* @__PURE__ */ x.createElement(
    "button",
    {
      className: "ai-tw-text-content-primary ai-tw-body-md",
      onClick: r
    },
    /* @__PURE__ */ x.createElement(Le, { icon: r1 })
  )), /* @__PURE__ */ x.createElement(
    mn.div,
    {
      className: ie("ai-tw-flex-initial ai-tw-overflow-y-auto", i),
      initial: { opacity: 0 },
      animate: { opacity: 1 },
      exit: { opacity: 0 }
    },
    e
  ));
}
function If(e) {
  "@babel/helpers - typeof";
  return If = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(t) {
    return typeof t;
  } : function(t) {
    return t && typeof Symbol == "function" && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  }, If(e);
}
function Ji(e) {
  if (e === null || e === !0 || e === !1)
    return NaN;
  var t = Number(e);
  return isNaN(t) ? t : t < 0 ? Math.ceil(t) : Math.floor(t);
}
function Ut(e, t) {
  if (t.length < e)
    throw new TypeError(e + " argument" + (e > 1 ? "s" : "") + " required, but only " + t.length + " present");
}
function nr(e) {
  Ut(1, arguments);
  var t = Object.prototype.toString.call(e);
  return e instanceof Date || If(e) === "object" && t === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || t === "[object Number]" ? new Date(e) : ((typeof e == "string" || t === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
}
function bae(e, t) {
  Ut(2, arguments);
  var n = nr(e), r = Ji(t);
  return isNaN(r) ? /* @__PURE__ */ new Date(NaN) : (r && n.setDate(n.getDate() + r), n);
}
function xae(e, t) {
  Ut(2, arguments);
  var n = nr(e).getTime(), r = Ji(t);
  return new Date(n + r);
}
var Eae = {};
function Zh() {
  return Eae;
}
function T0(e) {
  var t = new Date(Date.UTC(e.getFullYear(), e.getMonth(), e.getDate(), e.getHours(), e.getMinutes(), e.getSeconds(), e.getMilliseconds()));
  return t.setUTCFullYear(e.getFullYear()), e.getTime() - t.getTime();
}
function Df(e) {
  Ut(1, arguments);
  var t = nr(e);
  return t.setHours(0, 0, 0, 0), t;
}
var Cae = 864e5;
function Sae(e, t) {
  Ut(2, arguments);
  var n = Df(e), r = Df(t), i = n.getTime() - T0(n), o = r.getTime() - T0(r);
  return Math.round((i - o) / Cae);
}
function o7(e, t) {
  Ut(2, arguments);
  var n = Df(e), r = Df(t);
  return n.getTime() === r.getTime();
}
function _ae(e) {
  return Ut(1, arguments), e instanceof Date || If(e) === "object" && Object.prototype.toString.call(e) === "[object Date]";
}
function Pae(e) {
  if (Ut(1, arguments), !_ae(e) && typeof e != "number")
    return !1;
  var t = nr(e);
  return !isNaN(Number(t));
}
function gC(e, t) {
  var n = e.getFullYear() - t.getFullYear() || e.getMonth() - t.getMonth() || e.getDate() - t.getDate() || e.getHours() - t.getHours() || e.getMinutes() - t.getMinutes() || e.getSeconds() - t.getSeconds() || e.getMilliseconds() - t.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function kae(e, t) {
  Ut(2, arguments);
  var n = nr(e), r = nr(t), i = gC(n, r), o = Math.abs(Sae(n, r));
  n.setDate(n.getDate() - i * o);
  var a = +(gC(n, r) === -i), s = i * (o - a);
  return s === 0 ? 0 : s;
}
function Tae(e, t) {
  Ut(2, arguments);
  var n = Ji(t);
  return xae(e, -n);
}
var Aae = 864e5;
function Mae(e) {
  Ut(1, arguments);
  var t = nr(e), n = t.getTime();
  t.setUTCMonth(0, 1), t.setUTCHours(0, 0, 0, 0);
  var r = t.getTime(), i = n - r;
  return Math.floor(i / Aae) + 1;
}
function Nf(e) {
  Ut(1, arguments);
  var t = 1, n = nr(e), r = n.getUTCDay(), i = (r < t ? 7 : 0) + r - t;
  return n.setUTCDate(n.getUTCDate() - i), n.setUTCHours(0, 0, 0, 0), n;
}
function a7(e) {
  Ut(1, arguments);
  var t = nr(e), n = t.getUTCFullYear(), r = /* @__PURE__ */ new Date(0);
  r.setUTCFullYear(n + 1, 0, 4), r.setUTCHours(0, 0, 0, 0);
  var i = Nf(r), o = /* @__PURE__ */ new Date(0);
  o.setUTCFullYear(n, 0, 4), o.setUTCHours(0, 0, 0, 0);
  var a = Nf(o);
  return t.getTime() >= i.getTime() ? n + 1 : t.getTime() >= a.getTime() ? n : n - 1;
}
function Oae(e) {
  Ut(1, arguments);
  var t = a7(e), n = /* @__PURE__ */ new Date(0);
  n.setUTCFullYear(t, 0, 4), n.setUTCHours(0, 0, 0, 0);
  var r = Nf(n);
  return r;
}
var Rae = 6048e5;
function Iae(e) {
  Ut(1, arguments);
  var t = nr(e), n = Nf(t).getTime() - Oae(t).getTime();
  return Math.round(n / Rae) + 1;
}
function $f(e, t) {
  var n, r, i, o, a, s, l, u;
  Ut(1, arguments);
  var d = Zh(), f = Ji((n = (r = (i = (o = t == null ? void 0 : t.weekStartsOn) !== null && o !== void 0 ? o : t == null || (a = t.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.weekStartsOn) !== null && i !== void 0 ? i : d.weekStartsOn) !== null && r !== void 0 ? r : (l = d.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.weekStartsOn) !== null && n !== void 0 ? n : 0);
  if (!(f >= 0 && f <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  var p = nr(e), m = p.getUTCDay(), g = (m < f ? 7 : 0) + m - f;
  return p.setUTCDate(p.getUTCDate() - g), p.setUTCHours(0, 0, 0, 0), p;
}
function s7(e, t) {
  var n, r, i, o, a, s, l, u;
  Ut(1, arguments);
  var d = nr(e), f = d.getUTCFullYear(), p = Zh(), m = Ji((n = (r = (i = (o = t == null ? void 0 : t.firstWeekContainsDate) !== null && o !== void 0 ? o : t == null || (a = t.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : p.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = p.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && n !== void 0 ? n : 1);
  if (!(m >= 1 && m <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var g = /* @__PURE__ */ new Date(0);
  g.setUTCFullYear(f + 1, 0, m), g.setUTCHours(0, 0, 0, 0);
  var v = $f(g, t), y = /* @__PURE__ */ new Date(0);
  y.setUTCFullYear(f, 0, m), y.setUTCHours(0, 0, 0, 0);
  var b = $f(y, t);
  return d.getTime() >= v.getTime() ? f + 1 : d.getTime() >= b.getTime() ? f : f - 1;
}
function Dae(e, t) {
  var n, r, i, o, a, s, l, u;
  Ut(1, arguments);
  var d = Zh(), f = Ji((n = (r = (i = (o = t == null ? void 0 : t.firstWeekContainsDate) !== null && o !== void 0 ? o : t == null || (a = t.locale) === null || a === void 0 || (s = a.options) === null || s === void 0 ? void 0 : s.firstWeekContainsDate) !== null && i !== void 0 ? i : d.firstWeekContainsDate) !== null && r !== void 0 ? r : (l = d.locale) === null || l === void 0 || (u = l.options) === null || u === void 0 ? void 0 : u.firstWeekContainsDate) !== null && n !== void 0 ? n : 1), p = s7(e, t), m = /* @__PURE__ */ new Date(0);
  m.setUTCFullYear(p, 0, f), m.setUTCHours(0, 0, 0, 0);
  var g = $f(m, t);
  return g;
}
var Nae = 6048e5;
function $ae(e, t) {
  Ut(1, arguments);
  var n = nr(e), r = $f(n, t).getTime() - Dae(n, t).getTime();
  return Math.round(r / Nae) + 1;
}
function _t(e, t) {
  for (var n = e < 0 ? "-" : "", r = Math.abs(e).toString(); r.length < t; )
    r = "0" + r;
  return n + r;
}
var Lae = {
  // Year
  y: function(t, n) {
    var r = t.getUTCFullYear(), i = r > 0 ? r : 1 - r;
    return _t(n === "yy" ? i % 100 : i, n.length);
  },
  // Month
  M: function(t, n) {
    var r = t.getUTCMonth();
    return n === "M" ? String(r + 1) : _t(r + 1, 2);
  },
  // Day of the month
  d: function(t, n) {
    return _t(t.getUTCDate(), n.length);
  },
  // AM or PM
  a: function(t, n) {
    var r = t.getUTCHours() / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.toUpperCase();
      case "aaa":
        return r;
      case "aaaaa":
        return r[0];
      case "aaaa":
      default:
        return r === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h: function(t, n) {
    return _t(t.getUTCHours() % 12 || 12, n.length);
  },
  // Hour [0-23]
  H: function(t, n) {
    return _t(t.getUTCHours(), n.length);
  },
  // Minute
  m: function(t, n) {
    return _t(t.getUTCMinutes(), n.length);
  },
  // Second
  s: function(t, n) {
    return _t(t.getUTCSeconds(), n.length);
  },
  // Fraction of second
  S: function(t, n) {
    var r = n.length, i = t.getUTCMilliseconds(), o = Math.floor(i * Math.pow(10, r - 3));
    return _t(o, n.length);
  }
};
const go = Lae;
var ns = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, Fae = {
  // Era
  G: function(t, n, r) {
    var i = t.getUTCFullYear() > 0 ? 1 : 0;
    switch (n) {
      case "G":
      case "GG":
      case "GGG":
        return r.era(i, {
          width: "abbreviated"
        });
      case "GGGGG":
        return r.era(i, {
          width: "narrow"
        });
      case "GGGG":
      default:
        return r.era(i, {
          width: "wide"
        });
    }
  },
  // Year
  y: function(t, n, r) {
    if (n === "yo") {
      var i = t.getUTCFullYear(), o = i > 0 ? i : 1 - i;
      return r.ordinalNumber(o, {
        unit: "year"
      });
    }
    return go.y(t, n);
  },
  // Local week-numbering year
  Y: function(t, n, r, i) {
    var o = s7(t, i), a = o > 0 ? o : 1 - o;
    if (n === "YY") {
      var s = a % 100;
      return _t(s, 2);
    }
    return n === "Yo" ? r.ordinalNumber(a, {
      unit: "year"
    }) : _t(a, n.length);
  },
  // ISO week-numbering year
  R: function(t, n) {
    var r = a7(t);
    return _t(r, n.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, n) {
    var r = t.getUTCFullYear();
    return _t(r, n.length);
  },
  // Quarter
  Q: function(t, n, r) {
    var i = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "Q":
        return String(i);
      case "QQ":
        return _t(i, 2);
      case "Qo":
        return r.ordinalNumber(i, {
          unit: "quarter"
        });
      case "QQQ":
        return r.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return r.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return r.quarter(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, n, r) {
    var i = Math.ceil((t.getUTCMonth() + 1) / 3);
    switch (n) {
      case "q":
        return String(i);
      case "qq":
        return _t(i, 2);
      case "qo":
        return r.ordinalNumber(i, {
          unit: "quarter"
        });
      case "qqq":
        return r.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return r.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return r.quarter(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, n, r) {
    var i = t.getUTCMonth();
    switch (n) {
      case "M":
      case "MM":
        return go.M(t, n);
      case "Mo":
        return r.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "MMM":
        return r.month(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return r.month(i, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return r.month(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone month
  L: function(t, n, r) {
    var i = t.getUTCMonth();
    switch (n) {
      case "L":
        return String(i + 1);
      case "LL":
        return _t(i + 1, 2);
      case "Lo":
        return r.ordinalNumber(i + 1, {
          unit: "month"
        });
      case "LLL":
        return r.month(i, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return r.month(i, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return r.month(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Local week of year
  w: function(t, n, r, i) {
    var o = $ae(t, i);
    return n === "wo" ? r.ordinalNumber(o, {
      unit: "week"
    }) : _t(o, n.length);
  },
  // ISO week of year
  I: function(t, n, r) {
    var i = Iae(t);
    return n === "Io" ? r.ordinalNumber(i, {
      unit: "week"
    }) : _t(i, n.length);
  },
  // Day of the month
  d: function(t, n, r) {
    return n === "do" ? r.ordinalNumber(t.getUTCDate(), {
      unit: "date"
    }) : go.d(t, n);
  },
  // Day of year
  D: function(t, n, r) {
    var i = Mae(t);
    return n === "Do" ? r.ordinalNumber(i, {
      unit: "dayOfYear"
    }) : _t(i, n.length);
  },
  // Day of week
  E: function(t, n, r) {
    var i = t.getUTCDay();
    switch (n) {
      case "E":
      case "EE":
      case "EEE":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, n, r, i) {
    var o = t.getUTCDay(), a = (o - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "e":
        return String(a);
      case "ee":
        return _t(a, 2);
      case "eo":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      case "eee":
        return r.day(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return r.day(o, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return r.day(o, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return r.day(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, n, r, i) {
    var o = t.getUTCDay(), a = (o - i.weekStartsOn + 8) % 7 || 7;
    switch (n) {
      case "c":
        return String(a);
      case "cc":
        return _t(a, n.length);
      case "co":
        return r.ordinalNumber(a, {
          unit: "day"
        });
      case "ccc":
        return r.day(o, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return r.day(o, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return r.day(o, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return r.day(o, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, n, r) {
    var i = t.getUTCDay(), o = i === 0 ? 7 : i;
    switch (n) {
      case "i":
        return String(o);
      case "ii":
        return _t(o, n.length);
      case "io":
        return r.ordinalNumber(o, {
          unit: "day"
        });
      case "iii":
        return r.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return r.day(i, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return r.day(i, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return r.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, n, r) {
    var i = t.getUTCHours(), o = i / 12 >= 1 ? "pm" : "am";
    switch (n) {
      case "a":
      case "aa":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, n, r) {
    var i = t.getUTCHours(), o;
    switch (i === 12 ? o = ns.noon : i === 0 ? o = ns.midnight : o = i / 12 >= 1 ? "pm" : "am", n) {
      case "b":
      case "bb":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, n, r) {
    var i = t.getUTCHours(), o;
    switch (i >= 17 ? o = ns.evening : i >= 12 ? o = ns.afternoon : i >= 4 ? o = ns.morning : o = ns.night, n) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(o, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(o, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(o, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, n, r) {
    if (n === "ho") {
      var i = t.getUTCHours() % 12;
      return i === 0 && (i = 12), r.ordinalNumber(i, {
        unit: "hour"
      });
    }
    return go.h(t, n);
  },
  // Hour [0-23]
  H: function(t, n, r) {
    return n === "Ho" ? r.ordinalNumber(t.getUTCHours(), {
      unit: "hour"
    }) : go.H(t, n);
  },
  // Hour [0-11]
  K: function(t, n, r) {
    var i = t.getUTCHours() % 12;
    return n === "Ko" ? r.ordinalNumber(i, {
      unit: "hour"
    }) : _t(i, n.length);
  },
  // Hour [1-24]
  k: function(t, n, r) {
    var i = t.getUTCHours();
    return i === 0 && (i = 24), n === "ko" ? r.ordinalNumber(i, {
      unit: "hour"
    }) : _t(i, n.length);
  },
  // Minute
  m: function(t, n, r) {
    return n === "mo" ? r.ordinalNumber(t.getUTCMinutes(), {
      unit: "minute"
    }) : go.m(t, n);
  },
  // Second
  s: function(t, n, r) {
    return n === "so" ? r.ordinalNumber(t.getUTCSeconds(), {
      unit: "second"
    }) : go.s(t, n);
  },
  // Fraction of second
  S: function(t, n) {
    return go.S(t, n);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, n, r, i) {
    var o = i._originalDate || t, a = o.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (n) {
      case "X":
        return yC(a);
      case "XXXX":
      case "XX":
        return oa(a);
      case "XXXXX":
      case "XXX":
      default:
        return oa(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, n, r, i) {
    var o = i._originalDate || t, a = o.getTimezoneOffset();
    switch (n) {
      case "x":
        return yC(a);
      case "xxxx":
      case "xx":
        return oa(a);
      case "xxxxx":
      case "xxx":
      default:
        return oa(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, n, r, i) {
    var o = i._originalDate || t, a = o.getTimezoneOffset();
    switch (n) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + vC(a, ":");
      case "OOOO":
      default:
        return "GMT" + oa(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, n, r, i) {
    var o = i._originalDate || t, a = o.getTimezoneOffset();
    switch (n) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + vC(a, ":");
      case "zzzz":
      default:
        return "GMT" + oa(a, ":");
    }
  },
  // Seconds timestamp
  t: function(t, n, r, i) {
    var o = i._originalDate || t, a = Math.floor(o.getTime() / 1e3);
    return _t(a, n.length);
  },
  // Milliseconds timestamp
  T: function(t, n, r, i) {
    var o = i._originalDate || t, a = o.getTime();
    return _t(a, n.length);
  }
};
function vC(e, t) {
  var n = e > 0 ? "-" : "+", r = Math.abs(e), i = Math.floor(r / 60), o = r % 60;
  if (o === 0)
    return n + String(i);
  var a = t || "";
  return n + String(i) + a + _t(o, 2);
}
function yC(e, t) {
  if (e % 60 === 0) {
    var n = e > 0 ? "-" : "+";
    return n + _t(Math.abs(e) / 60, 2);
  }
  return oa(e, t);
}
function oa(e, t) {
  var n = t || "", r = e > 0 ? "-" : "+", i = Math.abs(e), o = _t(Math.floor(i / 60), 2), a = _t(i % 60, 2);
  return r + o + n + a;
}
const zae = Fae;
var wC = function(t, n) {
  switch (t) {
    case "P":
      return n.date({
        width: "short"
      });
    case "PP":
      return n.date({
        width: "medium"
      });
    case "PPP":
      return n.date({
        width: "long"
      });
    case "PPPP":
    default:
      return n.date({
        width: "full"
      });
  }
}, l7 = function(t, n) {
  switch (t) {
    case "p":
      return n.time({
        width: "short"
      });
    case "pp":
      return n.time({
        width: "medium"
      });
    case "ppp":
      return n.time({
        width: "long"
      });
    case "pppp":
    default:
      return n.time({
        width: "full"
      });
  }
}, Vae = function(t, n) {
  var r = t.match(/(P+)(p+)?/) || [], i = r[1], o = r[2];
  if (!o)
    return wC(t, n);
  var a;
  switch (i) {
    case "P":
      a = n.dateTime({
        width: "short"
      });
      break;
    case "PP":
      a = n.dateTime({
        width: "medium"
      });
      break;
    case "PPP":
      a = n.dateTime({
        width: "long"
      });
      break;
    case "PPPP":
    default:
      a = n.dateTime({
        width: "full"
      });
      break;
  }
  return a.replace("{{date}}", wC(i, n)).replace("{{time}}", l7(o, n));
}, Bae = {
  p: l7,
  P: Vae
};
const jae = Bae;
var Wae = ["D", "DD"], Uae = ["YY", "YYYY"];
function Hae(e) {
  return Wae.indexOf(e) !== -1;
}
function Gae(e) {
  return Uae.indexOf(e) !== -1;
}
function bC(e, t, n) {
  if (e === "YYYY")
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "YY")
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(t, "`) for formatting years to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "D")
    throw new RangeError("Use `d` instead of `D` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  if (e === "DD")
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(t, "`) for formatting days of the month to the input `").concat(n, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
}
var qae = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Yae = function(t, n, r) {
  var i, o = qae[t];
  return typeof o == "string" ? i = o : n === 1 ? i = o.one : i = o.other.replace("{{count}}", n.toString()), r != null && r.addSuffix ? r.comparison && r.comparison > 0 ? "in " + i : i + " ago" : i;
};
const Kae = Yae;
function _g(e) {
  return function() {
    var t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, n = t.width ? String(t.width) : e.defaultWidth, r = e.formats[n] || e.formats[e.defaultWidth];
    return r;
  };
}
var Xae = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Zae = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Qae = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Jae = {
  date: _g({
    formats: Xae,
    defaultWidth: "full"
  }),
  time: _g({
    formats: Zae,
    defaultWidth: "full"
  }),
  dateTime: _g({
    formats: Qae,
    defaultWidth: "full"
  })
};
const ese = Jae;
var tse = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, nse = function(t, n, r, i) {
  return tse[t];
};
const rse = nse;
function Ml(e) {
  return function(t, n) {
    var r = n != null && n.context ? String(n.context) : "standalone", i;
    if (r === "formatting" && e.formattingValues) {
      var o = e.defaultFormattingWidth || e.defaultWidth, a = n != null && n.width ? String(n.width) : o;
      i = e.formattingValues[a] || e.formattingValues[o];
    } else {
      var s = e.defaultWidth, l = n != null && n.width ? String(n.width) : e.defaultWidth;
      i = e.values[l] || e.values[s];
    }
    var u = e.argumentCallback ? e.argumentCallback(t) : t;
    return i[u];
  };
}
var ise = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, ose = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, ase = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
  wide: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
}, sse = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
}, lse = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, cse = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, use = function(t, n) {
  var r = Number(t), i = r % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return r + "st";
      case 2:
        return r + "nd";
      case 3:
        return r + "rd";
    }
  return r + "th";
}, dse = {
  ordinalNumber: use,
  era: Ml({
    values: ise,
    defaultWidth: "wide"
  }),
  quarter: Ml({
    values: ose,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return t - 1;
    }
  }),
  month: Ml({
    values: ase,
    defaultWidth: "wide"
  }),
  day: Ml({
    values: sse,
    defaultWidth: "wide"
  }),
  dayPeriod: Ml({
    values: lse,
    defaultWidth: "wide",
    formattingValues: cse,
    defaultFormattingWidth: "wide"
  })
};
const fse = dse;
function Ol(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = n.width, i = r && e.matchPatterns[r] || e.matchPatterns[e.defaultMatchWidth], o = t.match(i);
    if (!o)
      return null;
    var a = o[0], s = r && e.parsePatterns[r] || e.parsePatterns[e.defaultParseWidth], l = Array.isArray(s) ? pse(s, function(f) {
      return f.test(a);
    }) : hse(s, function(f) {
      return f.test(a);
    }), u;
    u = e.valueCallback ? e.valueCallback(l) : l, u = n.valueCallback ? n.valueCallback(u) : u;
    var d = t.slice(a.length);
    return {
      value: u,
      rest: d
    };
  };
}
function hse(e, t) {
  for (var n in e)
    if (e.hasOwnProperty(n) && t(e[n]))
      return n;
}
function pse(e, t) {
  for (var n = 0; n < e.length; n++)
    if (t(e[n]))
      return n;
}
function mse(e) {
  return function(t) {
    var n = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r = t.match(e.matchPattern);
    if (!r)
      return null;
    var i = r[0], o = t.match(e.parsePattern);
    if (!o)
      return null;
    var a = e.valueCallback ? e.valueCallback(o[0]) : o[0];
    a = n.valueCallback ? n.valueCallback(a) : a;
    var s = t.slice(i.length);
    return {
      value: a,
      rest: s
    };
  };
}
var gse = /^(\d+)(th|st|nd|rd)?/i, vse = /\d+/i, yse = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, wse = {
  any: [/^b/i, /^(a|c)/i]
}, bse = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, xse = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ese = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Cse = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
}, Sse = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, _se = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Pse = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, kse = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Tse = {
  ordinalNumber: mse({
    matchPattern: gse,
    parsePattern: vse,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: Ol({
    matchPatterns: yse,
    defaultMatchWidth: "wide",
    parsePatterns: wse,
    defaultParseWidth: "any"
  }),
  quarter: Ol({
    matchPatterns: bse,
    defaultMatchWidth: "wide",
    parsePatterns: xse,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: Ol({
    matchPatterns: Ese,
    defaultMatchWidth: "wide",
    parsePatterns: Cse,
    defaultParseWidth: "any"
  }),
  day: Ol({
    matchPatterns: Sse,
    defaultMatchWidth: "wide",
    parsePatterns: _se,
    defaultParseWidth: "any"
  }),
  dayPeriod: Ol({
    matchPatterns: Pse,
    defaultMatchWidth: "any",
    parsePatterns: kse,
    defaultParseWidth: "any"
  })
};
const Ase = Tse;
var Mse = {
  code: "en-US",
  formatDistance: Kae,
  formatLong: ese,
  formatRelative: rse,
  localize: fse,
  match: Ase,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const Ose = Mse;
var Rse = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, Ise = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, Dse = /^'([^]*?)'?$/, Nse = /''/g, $se = /[a-zA-Z]/;
function Lse(e, t, n) {
  var r, i, o, a, s, l, u, d, f, p, m, g, v, y, b, E, S, _;
  Ut(2, arguments);
  var k = String(t), T = Zh(), A = (r = (i = n == null ? void 0 : n.locale) !== null && i !== void 0 ? i : T.locale) !== null && r !== void 0 ? r : Ose, R = Ji((o = (a = (s = (l = n == null ? void 0 : n.firstWeekContainsDate) !== null && l !== void 0 ? l : n == null || (u = n.locale) === null || u === void 0 || (d = u.options) === null || d === void 0 ? void 0 : d.firstWeekContainsDate) !== null && s !== void 0 ? s : T.firstWeekContainsDate) !== null && a !== void 0 ? a : (f = T.locale) === null || f === void 0 || (p = f.options) === null || p === void 0 ? void 0 : p.firstWeekContainsDate) !== null && o !== void 0 ? o : 1);
  if (!(R >= 1 && R <= 7))
    throw new RangeError("firstWeekContainsDate must be between 1 and 7 inclusively");
  var F = Ji((m = (g = (v = (y = n == null ? void 0 : n.weekStartsOn) !== null && y !== void 0 ? y : n == null || (b = n.locale) === null || b === void 0 || (E = b.options) === null || E === void 0 ? void 0 : E.weekStartsOn) !== null && v !== void 0 ? v : T.weekStartsOn) !== null && g !== void 0 ? g : (S = T.locale) === null || S === void 0 || (_ = S.options) === null || _ === void 0 ? void 0 : _.weekStartsOn) !== null && m !== void 0 ? m : 0);
  if (!(F >= 0 && F <= 6))
    throw new RangeError("weekStartsOn must be between 0 and 6 inclusively");
  if (!A.localize)
    throw new RangeError("locale must contain localize property");
  if (!A.formatLong)
    throw new RangeError("locale must contain formatLong property");
  var D = nr(e);
  if (!Pae(D))
    throw new RangeError("Invalid time value");
  var W = T0(D), L = Tae(D, W), z = {
    firstWeekContainsDate: R,
    weekStartsOn: F,
    locale: A,
    _originalDate: D
  }, B = k.match(Ise).map(function(G) {
    var H = G[0];
    if (H === "p" || H === "P") {
      var J = jae[H];
      return J(G, A.formatLong);
    }
    return G;
  }).join("").match(Rse).map(function(G) {
    if (G === "''")
      return "'";
    var H = G[0];
    if (H === "'")
      return Fse(G);
    var J = zae[H];
    if (J)
      return !(n != null && n.useAdditionalWeekYearTokens) && Gae(G) && bC(G, t, String(e)), !(n != null && n.useAdditionalDayOfYearTokens) && Hae(G) && bC(G, t, String(e)), J(L, G, A.localize, z);
    if (H.match($se))
      throw new RangeError("Format string contains an unescaped latin alphabet character `" + H + "`");
    return G;
  }).join("");
  return B;
}
function Fse(e) {
  var t = e.match(Dse);
  return t ? t[1].replace(Nse, "'") : e;
}
function zse(e) {
  return Ut(1, arguments), o7(e, Date.now());
}
function Vse(e, t) {
  Ut(2, arguments);
  var n = Ji(t);
  return bae(e, -n);
}
function Bse(e) {
  return Ut(1, arguments), o7(e, Vse(Date.now(), 1));
}
function Qh(e) {
  try {
    return Lse(new Date(e), "MM/dd/yyyy");
  } catch {
    return "";
  }
}
function jse(e) {
  if (!e)
    return "";
  const t = /* @__PURE__ */ new Date(), n = new Date(e);
  if (zse(n))
    return "Today";
  if (Bse(n))
    return "1 day ago";
  const r = kae(t, n);
  return r <= 7 ? `${r} days ago` : Qh(e);
}
function Wse({
  scrollThresholdRef: e,
  enabled: t = !0,
  rootMargin: n,
  rootRef: r,
  onReachedThreshold: i
}) {
  be(() => {
    if (!e.current || !t)
      return;
    const o = new IntersectionObserver(
      (a) => {
        a.forEach((s) => {
          s.isIntersecting && i(o);
        });
      },
      {
        root: r == null ? void 0 : r.current,
        rootMargin: n
      }
    );
    return o.observe(e.current), () => {
      o.disconnect();
    };
  }, [e, i, r, n, t]);
}
function Use({
  children: e,
  className: t
}) {
  const {
    data: n,
    isValidating: r,
    isLoading: i,
    setSize: o
  } = zc(), a = r || i, s = x.useRef(null), l = x.useRef(null), u = n ? Doe(n) : !1;
  return Wse({
    scrollThresholdRef: s,
    enabled: u,
    rootMargin: "0px 0px 100px 0px",
    rootRef: l,
    onReachedThreshold: () => {
      a || o((d) => d + 1);
    }
  }), /* @__PURE__ */ x.createElement(
    "ul",
    {
      className: ie(
        "ai-tw-flex ai-tw-flex-1 ai-tw-flex-col ai-tw-gap-y-1 ai-tw-overflow-auto",
        t
      ),
      ref: l
    },
    e,
    /* @__PURE__ */ x.createElement("li", { ref: s }),
    a && /* @__PURE__ */ x.createElement("li", { className: "ai-tw-my-2 ai-tw-flex ai-tw-items-center ai-tw-justify-center" }, /* @__PURE__ */ x.createElement(jn, { size: "small" }))
  );
}
function Hse({
  title: e,
  date: t,
  isSelected: n,
  onSelectChat: r,
  onDeleteChat: i
}) {
  return /* @__PURE__ */ x.createElement("div", { tabIndex: 0, className: "ai-tw-group/container ai-tw-relative" }, /* @__PURE__ */ x.createElement(
    "button",
    {
      onClick: r,
      className: ie(
        "ai-tw-flex ai-tw-w-full ai-tw-items-center ai-tw-rounded-lg ai-tw-border ai-tw-border-stroke-primary ai-tw-bg-container-primary ai-tw-px-3 ai-tw-py-2 ai-tw-text-left ai-tw-text-content-primary ai-tw-body-sm hover:ai-tw-border-stroke-primary-darkest",
        {
          "ai-tw-border-stroke-primary-darkest ai-tw-cursor-default": n
        }
      )
    },
    /* @__PURE__ */ x.createElement("span", { className: "ai-tw-grow ai-tw-pr-4" }, e || cw),
    /* @__PURE__ */ x.createElement("span", { className: "ai-tw-flex-initial ai-tw-shrink-0 ai-tw-text-[11px] ai-tw-text-content-primary-light group-focus-within/container:ai-tw-invisible group-hover/container:ai-tw-invisible" }, t)
  ), /* @__PURE__ */ x.createElement(
    Oa,
    {
      icon: Qf,
      onClick: (o) => {
        o.stopPropagation(), i();
      },
      className: "ai-tw-group ai-tw-invisible ai-tw-absolute ai-tw-right-1.5 ai-tw-top-1/2 -ai-tw-translate-y-1/2 ai-tw-p-1.5 group-focus-within/container:ai-tw-visible group-hover/container:ai-tw-visible"
    }
  ));
}
function Gse() {
  const { data: e } = zc(), t = e ? UT(e) : aw(), { chatState: n, selectChat: r, chatDispatch: i, navigationDispatch: o } = Me(At), a = Vc(n), s = BT(t);
  function l(u) {
    i({
      type: "selectChatForDeletion",
      chatId: u
    });
  }
  return /* @__PURE__ */ x.createElement(Use, null, s && s.map((u) => {
    const d = jT(u), f = WT(u), p = Moe(u);
    return /* @__PURE__ */ x.createElement("li", { key: d }, /* @__PURE__ */ x.createElement(
      Hse,
      {
        title: f,
        date: jse(p),
        isSelected: d === a,
        onSelectChat: () => {
          d && r(d), o({
            type: "setActiveNavigationItem",
            payload: void 0
          });
        },
        onDeleteChat: () => d && l(d)
      }
    ));
  }));
}
const c7 = "Collapsible", [qse, u7] = rr(c7), [Yse, dw] = qse(c7), Kse = /* @__PURE__ */ ke((e, t) => {
  const { __scopeCollapsible: n, open: r, defaultOpen: i, disabled: o, onOpenChange: a, ...s } = e, [l = !1, u] = li({
    prop: r,
    defaultProp: i,
    onChange: a
  });
  return /* @__PURE__ */ X(Yse, {
    scope: n,
    disabled: o,
    contentId: ti(),
    open: l,
    onOpenToggle: De(
      () => u(
        (d) => !d
      ),
      [
        u
      ]
    )
  }, /* @__PURE__ */ X(rt.div, ge({
    "data-state": fw(l),
    "data-disabled": o ? "" : void 0
  }, s, {
    ref: t
  })));
}), Xse = "CollapsibleTrigger", Zse = /* @__PURE__ */ ke((e, t) => {
  const { __scopeCollapsible: n, ...r } = e, i = dw(Xse, n);
  return /* @__PURE__ */ X(rt.button, ge({
    type: "button",
    "aria-controls": i.contentId,
    "aria-expanded": i.open || !1,
    "data-state": fw(i.open),
    "data-disabled": i.disabled ? "" : void 0,
    disabled: i.disabled
  }, r, {
    ref: t,
    onClick: $e(e.onClick, i.onOpenToggle)
  }));
}), d7 = "CollapsibleContent", Qse = /* @__PURE__ */ ke((e, t) => {
  const { forceMount: n, ...r } = e, i = dw(d7, e.__scopeCollapsible);
  return /* @__PURE__ */ X(
    On,
    {
      present: n || i.open
    },
    ({ present: o }) => /* @__PURE__ */ X(Jse, ge({}, r, {
      ref: t,
      present: o
    }))
  );
}), Jse = /* @__PURE__ */ ke((e, t) => {
  const { __scopeCollapsible: n, present: r, children: i, ...o } = e, a = dw(d7, n), [s, l] = de(r), u = me(null), d = Ft(t, u), f = me(0), p = f.current, m = me(0), g = m.current, v = a.open || s, y = me(v), b = me();
  return be(() => {
    const E = requestAnimationFrame(
      () => y.current = !1
    );
    return () => cancelAnimationFrame(E);
  }, []), ma(() => {
    const E = u.current;
    if (E) {
      b.current = b.current || {
        transitionDuration: E.style.transitionDuration,
        animationName: E.style.animationName
      }, E.style.transitionDuration = "0s", E.style.animationName = "none";
      const S = E.getBoundingClientRect();
      f.current = S.height, m.current = S.width, y.current || (E.style.transitionDuration = b.current.transitionDuration, E.style.animationName = b.current.animationName), l(r);
    }
  }, [
    a.open,
    r
  ]), /* @__PURE__ */ X(rt.div, ge({
    "data-state": fw(a.open),
    "data-disabled": a.disabled ? "" : void 0,
    id: a.contentId,
    hidden: !v
  }, o, {
    ref: d,
    style: {
      ["--radix-collapsible-content-height"]: p ? `${p}px` : void 0,
      ["--radix-collapsible-content-width"]: g ? `${g}px` : void 0,
      ...e.style
    }
  }), v && i);
});
function fw(e) {
  return e ? "open" : "closed";
}
const ele = Kse, tle = Zse, nle = Qse, Fo = "Accordion", rle = [
  "Home",
  "End",
  "ArrowDown",
  "ArrowUp",
  "ArrowLeft",
  "ArrowRight"
], [hw, ile, ole] = by(Fo), [Jh, Hye] = rr(Fo, [
  ole,
  u7
]), pw = u7(), f7 = /* @__PURE__ */ x.forwardRef((e, t) => {
  const { type: n, ...r } = e, i = r, o = r;
  return /* @__PURE__ */ x.createElement(hw.Provider, {
    scope: e.__scopeAccordion
  }, n === "multiple" ? /* @__PURE__ */ x.createElement(cle, ge({}, o, {
    ref: t
  })) : /* @__PURE__ */ x.createElement(lle, ge({}, i, {
    ref: t
  })));
});
f7.propTypes = {
  type(e) {
    const t = e.value || e.defaultValue;
    return e.type && ![
      "single",
      "multiple"
    ].includes(e.type) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected one of `single | multiple`.") : e.type === "multiple" && typeof t == "string" ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `single` when `defaultValue` or `value` is type `string`.") : e.type === "single" && Array.isArray(t) ? new Error("Invalid prop `type` supplied to `Accordion`. Expected `multiple` when `defaultValue` or `value` is type `string[]`.") : null;
  }
};
const [h7, ale] = Jh(Fo), [p7, sle] = Jh(Fo, {
  collapsible: !1
}), lle = /* @__PURE__ */ x.forwardRef((e, t) => {
  const { value: n, defaultValue: r, onValueChange: i = () => {
  }, collapsible: o = !1, ...a } = e, [s, l] = li({
    prop: n,
    defaultProp: r,
    onChange: i
  });
  return /* @__PURE__ */ x.createElement(h7, {
    scope: e.__scopeAccordion,
    value: s ? [
      s
    ] : [],
    onItemOpen: l,
    onItemClose: x.useCallback(
      () => o && l(""),
      [
        o,
        l
      ]
    )
  }, /* @__PURE__ */ x.createElement(p7, {
    scope: e.__scopeAccordion,
    collapsible: o
  }, /* @__PURE__ */ x.createElement(m7, ge({}, a, {
    ref: t
  }))));
}), cle = /* @__PURE__ */ x.forwardRef((e, t) => {
  const { value: n, defaultValue: r, onValueChange: i = () => {
  }, ...o } = e, [a = [], s] = li({
    prop: n,
    defaultProp: r,
    onChange: i
  }), l = x.useCallback(
    (d) => s(
      (f = []) => [
        ...f,
        d
      ]
    ),
    [
      s
    ]
  ), u = x.useCallback(
    (d) => s(
      (f = []) => f.filter(
        (p) => p !== d
      )
    ),
    [
      s
    ]
  );
  return /* @__PURE__ */ x.createElement(h7, {
    scope: e.__scopeAccordion,
    value: a,
    onItemOpen: l,
    onItemClose: u
  }, /* @__PURE__ */ x.createElement(p7, {
    scope: e.__scopeAccordion,
    collapsible: !0
  }, /* @__PURE__ */ x.createElement(m7, ge({}, o, {
    ref: t
  }))));
}), [ule, ep] = Jh(Fo), m7 = /* @__PURE__ */ x.forwardRef((e, t) => {
  const { __scopeAccordion: n, disabled: r, dir: i, orientation: o = "vertical", ...a } = e, s = x.useRef(null), l = Ft(s, t), u = ile(n), f = Nc(i) === "ltr", p = $e(e.onKeyDown, (m) => {
    var g;
    if (!rle.includes(m.key))
      return;
    const v = m.target, y = u().filter((F) => {
      var D;
      return !((D = F.ref.current) !== null && D !== void 0 && D.disabled);
    }), b = y.findIndex(
      (F) => F.ref.current === v
    ), E = y.length;
    if (b === -1)
      return;
    m.preventDefault();
    let S = b;
    const _ = 0, k = E - 1, T = () => {
      S = b + 1, S > k && (S = _);
    }, A = () => {
      S = b - 1, S < _ && (S = k);
    };
    switch (m.key) {
      case "Home":
        S = _;
        break;
      case "End":
        S = k;
        break;
      case "ArrowRight":
        o === "horizontal" && (f ? T() : A());
        break;
      case "ArrowDown":
        o === "vertical" && T();
        break;
      case "ArrowLeft":
        o === "horizontal" && (f ? A() : T());
        break;
      case "ArrowUp":
        o === "vertical" && A();
        break;
    }
    const R = S % E;
    (g = y[R].ref.current) === null || g === void 0 || g.focus();
  });
  return /* @__PURE__ */ x.createElement(ule, {
    scope: n,
    disabled: r,
    direction: i,
    orientation: o
  }, /* @__PURE__ */ x.createElement(hw.Slot, {
    scope: n
  }, /* @__PURE__ */ x.createElement(rt.div, ge({}, a, {
    "data-orientation": o,
    ref: l,
    onKeyDown: r ? void 0 : p
  }))));
}), A0 = "AccordionItem", [dle, mw] = Jh(A0), fle = /* @__PURE__ */ x.forwardRef((e, t) => {
  const { __scopeAccordion: n, value: r, ...i } = e, o = ep(A0, n), a = ale(A0, n), s = pw(n), l = ti(), u = r && a.value.includes(r) || !1, d = o.disabled || e.disabled;
  return /* @__PURE__ */ x.createElement(dle, {
    scope: n,
    open: u,
    disabled: d,
    triggerId: l
  }, /* @__PURE__ */ x.createElement(ele, ge({
    "data-orientation": o.orientation,
    "data-state": g7(u)
  }, s, i, {
    ref: t,
    disabled: d,
    open: u,
    onOpenChange: (f) => {
      f ? a.onItemOpen(r) : a.onItemClose(r);
    }
  })));
}), hle = "AccordionHeader", ple = /* @__PURE__ */ x.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...r } = e, i = ep(Fo, n), o = mw(hle, n);
  return /* @__PURE__ */ x.createElement(rt.h3, ge({
    "data-orientation": i.orientation,
    "data-state": g7(o.open),
    "data-disabled": o.disabled ? "" : void 0
  }, r, {
    ref: t
  }));
}), xC = "AccordionTrigger", mle = /* @__PURE__ */ x.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...r } = e, i = ep(Fo, n), o = mw(xC, n), a = sle(xC, n), s = pw(n);
  return /* @__PURE__ */ x.createElement(hw.ItemSlot, {
    scope: n
  }, /* @__PURE__ */ x.createElement(tle, ge({
    "aria-disabled": o.open && !a.collapsible || void 0,
    "data-orientation": i.orientation,
    id: o.triggerId
  }, s, r, {
    ref: t
  })));
}), gle = "AccordionContent", vle = /* @__PURE__ */ x.forwardRef((e, t) => {
  const { __scopeAccordion: n, ...r } = e, i = ep(Fo, n), o = mw(gle, n), a = pw(n);
  return /* @__PURE__ */ x.createElement(nle, ge({
    role: "region",
    "aria-labelledby": o.triggerId,
    "data-orientation": i.orientation
  }, a, r, {
    ref: t,
    style: {
      ["--radix-accordion-content-height"]: "var(--radix-collapsible-content-height)",
      ["--radix-accordion-content-width"]: "var(--radix-collapsible-content-width)",
      ...e.style
    }
  }));
});
function g7(e) {
  return e ? "open" : "closed";
}
const yle = f7, wle = fle, ble = ple, xle = mle, Ele = vle, Cle = "/rag-chat/categories";
function EC() {
  return Cle;
}
function v7() {
  const e = ln();
  function t() {
    return e(EC());
  }
  return br(EC(), t);
}
function y7(e) {
  return e.categories;
}
function CC(e) {
  return e.id;
}
function Lf(e) {
  return e.title;
}
function w7(e) {
  return e.startingQuestions;
}
const Sle = "/rag-chat/starting-questions";
function _le(e) {
  const t = new URLSearchParams();
  return e && t.set("search", e), `${Sle}?${t}`;
}
function Ple({
  search: e
}) {
  const t = ln(), n = _le(e);
  function r() {
    return t(n);
  }
  return br(n, () => e ? r() : Promise.resolve({
    startingQuestions: []
  }));
}
function kle(e) {
  return e.startingQuestions;
}
function b7({
  question: e
}) {
  const { askQuestion: t, navigationDispatch: n, isGenerationInProgress: r } = Me(At);
  function i() {
    n({
      type: "setActiveNavigationItem",
      payload: void 0
    }), t(e);
  }
  return /* @__PURE__ */ x.createElement(f6, null, /* @__PURE__ */ x.createElement(h6, { asChild: !0 }, /* @__PURE__ */ x.createElement(
    "button",
    {
      disabled: r,
      className: ie(
        "ai-tw-rounded-lg ai-tw-border ai-tw-border-stroke-primary ai-tw-bg-container-primary ai-tw-px-3 ai-tw-py-2 ai-tw-text-left disabled:ai-tw-opacity-70",
        {
          "hover:ai-tw-border-stroke-primary-darkest": !r
        }
      ),
      onClick: i
    },
    /* @__PURE__ */ x.createElement("p", { className: "ai-tw-text-content-primary ai-tw-body-sm" }, e)
  )), r ? /* @__PURE__ */ x.createElement(ny, null, "Please wait while ", Kh, " completes the generation.") : null);
}
function Tle({
  isLoading: e,
  startingQuestions: t
}) {
  return /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-flex-col ai-tw-gap-y-1" }, !e && (t != null && t.length) ? t.map((n) => /* @__PURE__ */ x.createElement(
    b7,
    {
      key: n,
      question: n
    }
  )) : null, !e && !(t != null && t.length) ? /* @__PURE__ */ x.createElement("p", { className: "ai-tw-text-sm" }, "No results found for your search.") : null, e ? /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-justify-center ai-tw-py-2" }, /* @__PURE__ */ x.createElement(jn, { size: "small" })) : null);
}
function Ale({
  className: e
}) {
  const { navigationState: t } = Me(At), [n, r] = de(""), i = bT(n, 500), { data: o, isLoading: a } = v7(), {
    data: s,
    isLoading: l
  } = Ple({ search: i }), u = s ? kle(s) : [], d = zoe(t);
  if (a)
    return /* @__PURE__ */ x.createElement(jn, { size: "small" });
  const f = o ? y7(o) : [];
  return /* @__PURE__ */ x.createElement(
    yle,
    {
      defaultValue: [d],
      className: ie("ai-tw-grid ai-tw-w-full ai-tw-gap-2", e),
      type: "multiple"
    },
    /* @__PURE__ */ x.createElement(
      Zy,
      {
        variant: "default",
        placeholder: "Search Prompts",
        value: n,
        onChange: (p) => r(p.target.value),
        onClear: () => r("")
      }
    ),
    i ? /* @__PURE__ */ x.createElement(
      Tle,
      {
        isLoading: l,
        startingQuestions: u
      }
    ) : null,
    !i && !f.length ? /* @__PURE__ */ x.createElement("p", { className: "ai-tw-text-content-primary ai-tw-body-sm" }, "Sorry, no prompts are available at the moment, please try again later.") : null,
    !i && f.length ? f.map((p) => {
      const m = Lf(p);
      return /* @__PURE__ */ x.createElement(wle, { key: m, value: m }, /* @__PURE__ */ x.createElement(ble, { className: "ai-tw-group ai-tw-subtitle-md data-[state=open]:ai-tw-mb-2" }, /* @__PURE__ */ x.createElement(xle, { className: "ai-tw-flex ai-tw-w-full ai-tw-items-center ai-tw-gap-2 ai-tw-rounded ai-tw-text-content-primary hover:ai-tw-cursor-pointer focus:ai-tw-cursor-pointer focus:ai-tw-outline focus:ai-tw-outline-1 focus:ai-tw-outline-grey-30" }, /* @__PURE__ */ x.createElement(
        Le,
        {
          className: "ai-tw-transition-transform group-data-[state=open]:ai-tw-rotate-90",
          icon: pS,
          size: "xs"
        }
      ), /* @__PURE__ */ x.createElement("span", null, Lf(p)))), /* @__PURE__ */ x.createElement(Ele, { asChild: !0 }, /* @__PURE__ */ x.createElement(
        mn.div,
        {
          className: "ai-tw-grid ai-tw-gap-1 ai-tw-p-1",
          initial: { y: -5, opacity: 0 },
          animate: { y: 0, opacity: 1 }
        },
        w7(p).map(
          (g) => /* @__PURE__ */ x.createElement(
            b7,
            {
              key: g,
              question: g
            }
          )
        )
      )));
    }) : null
  );
}
function x7(e) {
  const [t, n] = de(e);
  return be(() => () => {
    n(e);
  }, [e]), t;
}
function SC({ children: e, value: t, className: n }) {
  return /* @__PURE__ */ x.createElement(
    $h,
    {
      value: t,
      className: ie(
        "ai-tw-flex ai-tw-min-h-0 ai-tw-flex-initial ai-tw-flex-col",
        n
      )
    },
    e
  );
}
function Mle() {
  const { navigationState: e, navigationDispatch: t } = Me(At), n = GT(e), r = x7(n);
  function i() {
    t({
      type: "setActiveNavigationItem",
      payload: void 0
    });
  }
  return /* @__PURE__ */ x.createElement(
    Dy,
    {
      value: n || r,
      className: "ai-tw-flex ai-tw-min-h-0 ai-tw-flex-initial ai-tw-flex-col"
    },
    /* @__PURE__ */ x.createElement(SC, { value: "prompt-library" }, /* @__PURE__ */ x.createElement(
      mC,
      {
        title: "Prompt Library",
        icon: dS,
        onClose: i
      },
      /* @__PURE__ */ x.createElement(Ale, null)
    )),
    /* @__PURE__ */ x.createElement(SC, { value: "previous-chats" }, /* @__PURE__ */ x.createElement(
      mC,
      {
        title: "Previous Chats",
        icon: r7,
        onClose: i,
        className: "ai-tw-flex ai-tw-flex-col"
      },
      /* @__PURE__ */ x.createElement(Gse, null)
    ))
  );
}
function Ole({
  className: e
}) {
  const { navigationDispatch: t } = Me(At);
  function n() {
    t({
      type: "setActiveNavigationItem",
      payload: void 0
    });
  }
  return /* @__PURE__ */ x.createElement(
    "div",
    {
      className: ie(
        "ai-tw-absolute ai-tw-flex ai-tw-cursor-pointer ai-tw-flex-col ai-tw-justify-end",
        e
      ),
      onClick: n
    },
    /* @__PURE__ */ x.createElement(
      mn.div,
      {
        initial: { opacity: 0 },
        animate: { opacity: 1 },
        exit: { opacity: 0 },
        className: "ai-tw-flex ai-tw-min-h-0 ai-tw-flex-initial ai-tw-cursor-auto ai-tw-flex-col ai-tw-rounded-lg ai-tw-bg-tinted-grey-50",
        onClick: (r) => r.stopPropagation()
      },
      /* @__PURE__ */ x.createElement(
        mn.div,
        {
          initial: { opacity: 0, y: 10 },
          animate: { opacity: 1, y: 0 },
          exit: { opacity: 0, y: 10 },
          className: "ai-tw-flex ai-tw-min-h-0 ai-tw-flex-initial ai-tw-flex-col ai-tw-px-6 ai-tw-pb-2 ai-tw-pt-8"
        },
        /* @__PURE__ */ x.createElement(Mle, null)
      ),
      /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex-initial ai-tw-border-t-2 ai-tw-border-white ai-tw-px-3 ai-tw-pb-2 ai-tw-pt-3" }, /* @__PURE__ */ x.createElement(i7, null)),
      /* @__PURE__ */ x.createElement(wae, null)
    )
  );
}
function Rle(e) {
  return `/rag-chat/leads/${e}/details`;
}
function Ile({ personUuid: e }) {
  const t = ln(), n = e ? Rle(e) : null;
  async function r(i) {
    return t(i);
  }
  return br(n, r);
}
function Dle(e) {
  return [e.first_name, e.last_name].filter(Boolean).join(" ");
}
const Nle = "/rag-chat/release-notes";
function _C() {
  return `${Nle}`;
}
function tp() {
  const e = ln();
  function t() {
    return e(_C());
  }
  return br(_C(), () => t());
}
function np(e) {
  return e.releaseNotes;
}
function M0(e) {
  return e._id;
}
function E7(e) {
  return e.title;
}
function C7(e) {
  return e.createdAt;
}
function $le(e) {
  return e.tags;
}
function Lle(e) {
  return e.markdown;
}
const S7 = "ai-components-ask-place-updates-banner-closed-ts";
function Fle(e) {
  if (!e)
    return !1;
  const t = window.localStorage.getItem(S7);
  return !t || !Number(t) ? !0 : e > Number(t);
}
function zle() {
  const [e, t] = de(!1), {
    data: n,
    isLoading: r,
    error: i
  } = tp(), o = r || i || !n ? null : np(n), a = o ? o[0] : null, s = a ? C7(a) : null;
  if (be(() => {
    s && t(Fle(s));
  }, [s]), i)
    return {
      isVisible: !1,
      onClose: Mr
    };
  function l() {
    window.localStorage.setItem(S7, Date.now().toString()), t(!1);
  }
  return {
    isVisible: e,
    onClose: l
  };
}
function Ff({
  children: e,
  className: t,
  hidden: n = {},
  visible: r = {},
  exit: i = {}
}) {
  return /* @__PURE__ */ x.createElement(
    mn.div,
    {
      className: t,
      initial: "hidden",
      animate: "visible",
      exit: "exit",
      variants: {
        hidden: { opacity: 0, ...n },
        visible: { opacity: 1, ...r },
        exit: i
      },
      transition: { duration: 0.35 }
    },
    e
  );
}
function Vle(e) {
  return `/rag-chat/leads/${e}/starting-questions`;
}
function Ble({
  personUuid: e
}) {
  const t = ln(), n = e ? Vle(e) : null;
  async function r(i) {
    return t(i);
  }
  return br(
    n,
    r
  );
}
function jle(e) {
  return e.startingQuestions;
}
function O0({
  children: e,
  className: t,
  onClick: n
}) {
  return /* @__PURE__ */ x.createElement(
    "button",
    {
      onClick: n,
      className: ie(
        "ai-tw-flex ai-tw-w-full ai-tw-items-center ai-tw-rounded-sm ai-tw-border-b ai-tw-border-grey-20 ai-tw-px-4 ai-tw-py-3 ai-tw-text-content-primary hover:ai-tw-bg-element-primary-subtle",
        t
      )
    },
    e
  );
}
function Wle({
  onMoreCategoriesClick: e
}) {
  const { askQuestion: t, leadUuid: n } = Me(At), {
    data: r,
    isLoading: i,
    error: o
  } = Ble({
    personUuid: n
  }), a = r ? jle(r) : void 0;
  return /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-min-h-0 ai-tw-flex-col ai-tw-items-center" }, i ? /* @__PURE__ */ x.createElement(jn, { size: "small" }) : null, o ? /* @__PURE__ */ x.createElement("p", { className: "ai-tw-text-content-primary ai-tw-body-sm" }, "Something went wrong while fetching the lead questions. Please try again later.") : null, a ? /* @__PURE__ */ x.createElement("ul", { className: "ai-tw-overflow-y-auto ai-tw-px-10" }, a.map((s) => /* @__PURE__ */ x.createElement("li", { key: s }, /* @__PURE__ */ x.createElement(
    O0,
    {
      onClick: () => t(s)
    },
    /* @__PURE__ */ x.createElement(
      Le,
      {
        icon: uS,
        className: "ai-tw-mr-2 ai-tw-body-sm"
      }
    ),
    /* @__PURE__ */ x.createElement("p", { className: "ai-tw-text-left ai-tw-body-md" }, "“", s, "”")
  )))) : null, i ? null : /* @__PURE__ */ x.createElement(
    "button",
    {
      className: "ai-tw-mt-9 ai-tw-text-content-brand ai-tw-body-sm",
      onClick: e
    },
    "More Categories"
  ));
}
function gw({
  height: e = 12,
  pathClassName: t,
  width: n = 62
}) {
  return /* @__PURE__ */ x.createElement(
    "svg",
    {
      width: n,
      height: e,
      viewBox: "0 0 62 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ x.createElement(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.98016 0.0996094C8.20082 0.0996094 9.65378 1.15928 10.5761 2.47484L8.93074 3.39711C8.59475 2.92665 8.15123 2.54326 7.63711 2.27887C7.12298 2.01449 6.55313 1.87677 5.97501 1.87717C3.72 1.87717 2.04548 3.59462 2.04548 5.99905C2.04548 8.40348 3.72515 10.1295 5.98016 10.1295C6.97407 10.1184 7.9314 9.75296 8.67999 9.09905V7.32664H5.27944V5.56797H10.6791V9.83927C10.0891 10.4991 9.36418 11.0246 8.55352 11.3802C7.74285 11.7357 6.86528 11.9131 5.98016 11.9002C2.68266 11.9071 0 9.56619 0 5.9939C0 2.4216 2.68266 0.0996094 5.98016 0.0996094ZM19.3763 0.288522L14.9007 11.6838H17.1728L20.6335 2.30137L22.6292 7.74225H20.4618L19.8074 9.49749H23.2835L24.077 11.6838H26.3492L21.8735 0.288522H19.3763ZM31.0138 0.286771V11.6838H36.7707C38.9072 11.6838 40.0871 10.3682 40.0871 8.60781C40.0871 7.20809 39.0944 5.99386 37.8819 5.80665C38.9416 5.5851 39.8638 4.62677 39.8638 3.1927C39.8638 1.58688 38.7028 0.286771 36.6179 0.286771H31.0138ZM36.2074 5.00289H33.0129V2.04716H36.2074C37.2327 2.04716 37.8132 2.6809 37.8132 3.53447C37.8132 4.38804 37.2379 5.00289 36.2074 5.00289ZM36.2933 9.9251H33.0129V6.76327H36.2933C37.4371 6.76327 38.0365 7.47601 38.0365 8.33474C38.0365 9.32571 37.3873 9.9251 36.2933 9.9251ZM45.5124 11.6838V0.286771H51.1164C53.2014 0.286771 54.3624 1.58688 54.3624 3.1927C54.3624 4.62677 53.4401 5.5851 52.3805 5.80665C53.593 5.99386 54.5839 7.20809 54.5839 8.60781C54.5839 10.3682 53.4058 11.6838 51.2693 11.6838H45.5124ZM47.5115 5.00289H50.7059C51.7364 5.00289 52.3118 4.38804 52.3118 3.53447C52.3118 2.6809 51.7313 2.04716 50.7059 2.04716H47.5115V5.00289ZM47.5115 9.9251H50.7918C51.8858 9.9251 52.535 9.32571 52.535 8.33474C52.535 7.47601 51.9356 6.76327 50.7918 6.76327H47.5115V9.9251ZM59.9923 0.286771V11.6838H62V0.286771H59.9923Z",
        fill: "black",
        className: t
      }
    )
  );
}
function Ule() {
  return /* @__PURE__ */ x.createElement(
    "svg",
    {
      width: "10",
      height: "13",
      viewBox: "0 0 10 13",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    },
    /* @__PURE__ */ x.createElement(
      "path",
      {
        d: "M5.6624 0.753906H0.5V12.7539H2.56222V2.60762H5.3824C6.54333 2.60762 7.39005 3.36017 7.39005 4.51706C7.38319 5.66676 6.54333 6.42646 5.37564 6.42646H4.5564L3.89233 8.27316H5.6624C8.10699 8.27316 9.5 6.54486 9.5 4.51706C9.5 2.48207 8.12747 0.753906 5.6624 0.753906Z",
        fill: "currentColor"
      }
    )
  );
}
function Hle({
  categoryId: e
}) {
  let t = sS;
  switch (e) {
    case "3584e4c1":
      t = X$;
      break;
    case "9cb3e57a":
      t = C$;
      break;
    case "b78f52d3":
      t = R$;
      break;
  }
  return e === "637cf278" ? /* @__PURE__ */ x.createElement(Ule, null) : /* @__PURE__ */ x.createElement(Le, { icon: t, className: "ai-tw-body-sm" });
}
const vw = ke(
  ({ active: e, children: t, className: n, label: r, icon: i, ...o }, a) => /* @__PURE__ */ x.createElement(
    "button",
    {
      ref: a,
      className: ie(
        "ai-tw-inline-flex ai-tw-w-max ai-tw-items-center ai-tw-gap-1.5 ai-tw-rounded-full ai-tw-border ai-tw-border-stroke-primary-dark ai-tw-bg-white ai-tw-px-4 ai-tw-py-1 ai-tw-text-content-primary",
        {
          "ai-tw-border-element-primary-bold ai-tw-bg-element-primary-bold ai-tw-text-white ai-tw-cursor-default": e,
          "hover:ai-tw-border-element-primary-subtle hover:ai-tw-bg-element-primary-subtle": !e
        },
        n
      ),
      ...o
    },
    i || null,
    r ? /* @__PURE__ */ x.createElement("p", { className: "ai-tw-body-md" }, r) : t
  )
);
vw.displayName = "HelperPill";
const Gle = 6, PC = 4;
function qle({
  className: e
}) {
  const { askQuestion: t, navigationDispatch: n } = Me(At), { data: r, isLoading: i } = v7(), [o, a] = de();
  if (i)
    return /* @__PURE__ */ x.createElement(jn, { size: "small", className: "ai-tw-mx-auto" });
  const s = r ? y7(r) : [];
  return s[0] ? /* @__PURE__ */ x.createElement(
    Dy,
    {
      className: ie("ai-tw-flex ai-tw-flex-col", e),
      value: o,
      onValueChange: (l) => a(l)
    },
    /* @__PURE__ */ x.createElement(Dh, { className: "ai-tw-mx-auto ai-tw-flex ai-tw-w-fit ai-tw-flex-initial ai-tw-flex-wrap ai-tw-justify-center ai-tw-gap-x-1 ai-tw-gap-y-2" }, s.slice(0, Gle).map((l) => {
      const u = CC(l), d = Lf(l);
      return /* @__PURE__ */ x.createElement(Nh, { key: u, value: u, asChild: !0 }, /* @__PURE__ */ x.createElement(
        vw,
        {
          key: u,
          label: d,
          icon: /* @__PURE__ */ x.createElement(Hle, { categoryId: u }),
          active: o === u,
          className: "ai-tw-mr-1"
        }
      ));
    })),
    o && /* @__PURE__ */ x.createElement("div", { className: "ai-tw-mt-4 ai-tw-flex-1 ai-tw-overflow-y-auto ai-tw-px-10" }, s.map((l) => {
      const u = CC(l), d = w7(l);
      return /* @__PURE__ */ x.createElement($h, { key: u, value: u }, /* @__PURE__ */ x.createElement(ri, null, /* @__PURE__ */ x.createElement(
        mn.ul,
        {
          initial: { opacity: 0, y: -5 },
          animate: { opacity: 1, y: 0 },
          exit: { opacity: 0, y: -5 },
          transition: { duration: 0.2 }
        },
        d.slice(0, PC).map((f) => /* @__PURE__ */ x.createElement("li", { key: f }, /* @__PURE__ */ x.createElement(
          O0,
          {
            onClick: () => t(f)
          },
          /* @__PURE__ */ x.createElement(
            Le,
            {
              icon: S$,
              className: "ai-tw-mr-2 ai-tw-body-sm"
            }
          ),
          /* @__PURE__ */ x.createElement("p", { className: "ai-tw-text-left ai-tw-body-md" }, "“", f, "”")
        ))),
        d.length > PC ? /* @__PURE__ */ x.createElement("li", null, /* @__PURE__ */ x.createElement(
          O0,
          {
            onClick: () => {
              n({
                type: "setActiveNavigationItem",
                payload: "prompt-library"
              }), n({
                type: "setActiveStartingQuestionsCategory",
                payload: Lf(l)
              });
            },
            className: "ai-tw-text-content-brand"
          },
          /* @__PURE__ */ x.createElement(
            Le,
            {
              icon: W$,
              className: "ai-tw-mr-2 ai-tw-body-sm"
            }
          ),
          /* @__PURE__ */ x.createElement("p", { className: "ai-tw-body-md" }, "More Prompts")
        )) : null
      )));
    }))
  ) : null;
}
function Yle() {
  const { setIsReleaseNotesOpen: e } = Me(At), { data: t } = tp(), n = t ? np(t) : [];
  return /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-min-h-0 ai-tw-flex-col" }, /* @__PURE__ */ x.createElement(qle, { className: "ai-tw-min-h-0 ai-tw-flex-initial" }), n != null && n.length ? /* @__PURE__ */ x.createElement(
    "button",
    {
      onClick: () => e(!0),
      className: "ai-tw-mt-8 ai-tw-text-content-brand ai-tw-body-sm"
    },
    "What’s New with Gabbi?"
  ) : null);
}
function Kle({
  className: e,
  onClose: t,
  onLearnMore: n
}) {
  const { data: r, isLoading: i } = tp(), o = i || !r ? null : np(r);
  if (!(o != null && o.length))
    return null;
  const a = o[0];
  return /* @__PURE__ */ x.createElement(
    mn.div,
    {
      initial: { opacity: 0, y: -10 },
      animate: { opacity: 1, y: 0 },
      exit: { opacity: 0, y: -10 },
      transition: { duration: 0.2 },
      role: "button",
      onClick: () => n && n(M0(a)),
      className: ie(
        "ai-tw-flex ai-tw-cursor-pointer ai-tw-items-start ai-tw-rounded-lg ai-tw-bg-gradient-to-r ai-tw-from-[hsla(260,60%,47%,0.8)] ai-tw-to-[hsla(260,66%,73%,0.8)] ai-tw-p-2 hover:ai-tw-from-[hsla(260,60%,47%,1)] hover:ai-tw-to-[hsla(260,66%,73%,1)]",
        e
      )
    },
    /* @__PURE__ */ x.createElement("span", { className: "ai-tw-mr-2.5 ai-tw-inline-block ai-tw-rounded-lg ai-tw-bg-gradient-to-r ai-tw-from-content-on-color/75 ai-tw-to-content-on-color/30 ai-tw-p-2.5 ai-tw-text-content-on-color" }, /* @__PURE__ */ x.createElement(Le, { icon: dae })),
    /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex-1" }, /* @__PURE__ */ x.createElement("p", { className: "ai-tw-text-content-on-color ai-tw-subtitle-sm" }, "Latest Updates"), /* @__PURE__ */ x.createElement("p", { className: "ai-tw-line-clamp-2 ai-tw-text-content-on-color ai-tw-body-md" }, E7(a)), /* @__PURE__ */ x.createElement(wf, { className: "ai-tw-mt-2", variant: "on-color", size: "sm" }, "Learn More")),
    /* @__PURE__ */ x.createElement(
      wf,
      {
        className: "hover:ai-tw-text-content-ai-dark",
        size: "sm",
        variant: "on-color",
        onClick: (s) => {
          s.stopPropagation(), t == null || t();
        }
      },
      /* @__PURE__ */ x.createElement(Le, { icon: hS })
    )
  );
}
function Xle({
  setSelectedReleaseNoteId: e
}) {
  const { isVisible: t, onClose: n } = zle(), { leadUuid: r, setIsReleaseNotesOpen: i } = Me(At), { data: o, isLoading: a } = Ile(
    {
      personUuid: r
    }
  ), [s, l] = de("loading");
  be(() => {
    a || s !== "loading" || l(o ? "lead-questions" : "starting-questions");
  }, [s, o, a]);
  function u() {
    l("starting-questions");
  }
  const d = o ? Dle(o) : void 0;
  return /* @__PURE__ */ x.createElement("div", { className: "ai-tw-mx-auto ai-tw-flex ai-tw-h-full ai-tw-min-h-0 ai-tw-min-w-full ai-tw-flex-1 ai-tw-grow ai-tw-flex-col ai-tw-items-center ai-tw-px-3 ai-tw-py-2" }, /* @__PURE__ */ x.createElement(ri, null, t ? /* @__PURE__ */ x.createElement(
    Kle,
    {
      className: "ai-tw-mx-2 ai-tw-w-full",
      onLearnMore: (f) => {
        i(!0), n(), e(f);
      },
      onClose: n
    }
  ) : null), s === "loading" ? /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-h-full ai-tw-flex-col ai-tw-items-center ai-tw-justify-center" }, /* @__PURE__ */ x.createElement(jn, { size: "small" })) : null, s !== "loading" ? /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-flex-col ai-tw-items-center ai-tw-pt-4" }, /* @__PURE__ */ x.createElement("div", { className: "ai-tw-mb-2" }, /* @__PURE__ */ x.createElement(gw, { width: 79, height: 15 })), /* @__PURE__ */ x.createElement("p", { className: "ai-tw-mb-4 ai-tw-flex-initial ai-tw-text-center ai-tw-text-content-primary ai-tw-subtitle-md" }, "What would you like help with?"), d ? /* @__PURE__ */ x.createElement(
    vw,
    {
      active: s === "lead-questions",
      className: "ai-tw-mb-8",
      icon: /* @__PURE__ */ x.createElement(Le, { icon: uS }),
      label: `Ask about ${d}`,
      onClick: () => l("lead-questions")
    }
  ) : null) : null, /* @__PURE__ */ x.createElement(ri, null, s === "lead-questions" && d ? /* @__PURE__ */ x.createElement(
    Ff,
    {
      hidden: { y: 10 },
      visible: { y: 0 },
      exit: { display: "none" },
      className: "ai-tw-flex ai-tw-min-h-0 ai-tw-flex-col"
    },
    /* @__PURE__ */ x.createElement(
      Wle,
      {
        leadFullName: d,
        onMoreCategoriesClick: u
      }
    )
  ) : null), /* @__PURE__ */ x.createElement(ri, null, s === "starting-questions" ? /* @__PURE__ */ x.createElement(
    Ff,
    {
      hidden: { y: -10 },
      visible: { y: 0 },
      exit: { display: "none" },
      className: "ai-tw-flex ai-tw-min-h-0 ai-tw-flex-col"
    },
    /* @__PURE__ */ x.createElement(Yle, null)
  ) : null));
}
const Bc = wn(null);
function Zle(e) {
  if (!e)
    return 0;
  const [t, n, r] = e.split(":").map(Number);
  return t * 3600 + n * 60 + r;
}
function _7(e, t) {
  return t ? `${e}#t=${t}` : e;
}
function P7({
  href: e,
  node: t,
  sourceID: n,
  src: r,
  timestamp: i
}) {
  const o = i ? `at timestamp ${i}` : "";
  return /* @__PURE__ */ x.createElement(
    Cw,
    {
      className: "ai-tw-inline-block ai-tw-whitespace-nowrap ai-tw-no-underline",
      node: t,
      id: r,
      href: e
    },
    "[",
    n,
    ": watch from ",
    o,
    "]."
  );
}
function Qle({
  node: e,
  sourceID: t,
  src: n
}) {
  const { metadata: r } = Me(Bc) || {}, i = FT(r, t), o = _7(n, i);
  return /* @__PURE__ */ x.createElement(
    P7,
    {
      node: e,
      sourceID: t,
      src: n,
      timestamp: i,
      href: o
    }
  );
}
function Jle(e) {
  if (!e)
    return 0;
  const [t, n, r] = e.split(":").map(Number);
  return t * 3600 + n * 60 + r;
}
function ece(e, t) {
  if (!t)
    return e;
  const n = new URL(e);
  return n.searchParams.set("t", Jle(t).toString()), n.toString();
}
function tce({
  sourceContentSource: e,
  src: t,
  timestamp: n
}) {
  switch (e) {
    case "Brivity":
    case "Our Place":
      return _7(t, n);
    case "YouTube":
      return ece(t, n);
  }
}
function nce({
  node: e,
  citationID: t,
  src: n
}) {
  const { metadata: r, sources: i } = Me(Bc) || {}, o = xoe(
    r,
    t
  ), a = boe(r, t), s = i && a ? VT(i, a) : void 0, l = s ? Yh(s) : null, u = l ? tce({
    sourceContentSource: l,
    src: n,
    timestamp: o
  }) : void 0;
  return u ? /* @__PURE__ */ x.createElement(
    P7,
    {
      node: e,
      sourceID: a,
      src: n,
      timestamp: o,
      href: u
    }
  ) : null;
}
function rce() {
  const e = 1.7777777777777777;
  try {
    const [t, n] = "16:9".split(":").map(Number);
    return isNaN(t) || isNaN(n) || n === 0 ? e : t / n;
  } catch {
    return e;
  }
}
function R0(e) {
  switch (e) {
    case "Brivity":
      return "BRIVITY KNOWLEDGE CENTER";
    case "Our Place":
      return "OUR PLACE";
    default:
      return e;
  }
}
var I0 = { exports: {} }, Sd = { exports: {} }, bt = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var kC;
function ice() {
  if (kC)
    return bt;
  kC = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
  function S(k) {
    if (typeof k == "object" && k !== null) {
      var T = k.$$typeof;
      switch (T) {
        case t:
          switch (k = k.type, k) {
            case l:
            case u:
            case r:
            case o:
            case i:
            case f:
              return k;
            default:
              switch (k = k && k.$$typeof, k) {
                case s:
                case d:
                case g:
                case m:
                case a:
                  return k;
                default:
                  return T;
              }
          }
        case n:
          return T;
      }
    }
  }
  function _(k) {
    return S(k) === u;
  }
  return bt.AsyncMode = l, bt.ConcurrentMode = u, bt.ContextConsumer = s, bt.ContextProvider = a, bt.Element = t, bt.ForwardRef = d, bt.Fragment = r, bt.Lazy = g, bt.Memo = m, bt.Portal = n, bt.Profiler = o, bt.StrictMode = i, bt.Suspense = f, bt.isAsyncMode = function(k) {
    return _(k) || S(k) === l;
  }, bt.isConcurrentMode = _, bt.isContextConsumer = function(k) {
    return S(k) === s;
  }, bt.isContextProvider = function(k) {
    return S(k) === a;
  }, bt.isElement = function(k) {
    return typeof k == "object" && k !== null && k.$$typeof === t;
  }, bt.isForwardRef = function(k) {
    return S(k) === d;
  }, bt.isFragment = function(k) {
    return S(k) === r;
  }, bt.isLazy = function(k) {
    return S(k) === g;
  }, bt.isMemo = function(k) {
    return S(k) === m;
  }, bt.isPortal = function(k) {
    return S(k) === n;
  }, bt.isProfiler = function(k) {
    return S(k) === o;
  }, bt.isStrictMode = function(k) {
    return S(k) === i;
  }, bt.isSuspense = function(k) {
    return S(k) === f;
  }, bt.isValidElementType = function(k) {
    return typeof k == "string" || typeof k == "function" || k === r || k === u || k === o || k === i || k === f || k === p || typeof k == "object" && k !== null && (k.$$typeof === g || k.$$typeof === m || k.$$typeof === a || k.$$typeof === s || k.$$typeof === d || k.$$typeof === y || k.$$typeof === b || k.$$typeof === E || k.$$typeof === v);
  }, bt.typeOf = S, bt;
}
var xt = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var TC;
function oce() {
  return TC || (TC = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, n = e ? Symbol.for("react.portal") : 60106, r = e ? Symbol.for("react.fragment") : 60107, i = e ? Symbol.for("react.strict_mode") : 60108, o = e ? Symbol.for("react.profiler") : 60114, a = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, u = e ? Symbol.for("react.concurrent_mode") : 60111, d = e ? Symbol.for("react.forward_ref") : 60112, f = e ? Symbol.for("react.suspense") : 60113, p = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, g = e ? Symbol.for("react.lazy") : 60116, v = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, b = e ? Symbol.for("react.responder") : 60118, E = e ? Symbol.for("react.scope") : 60119;
    function S(te) {
      return typeof te == "string" || typeof te == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      te === r || te === u || te === o || te === i || te === f || te === p || typeof te == "object" && te !== null && (te.$$typeof === g || te.$$typeof === m || te.$$typeof === a || te.$$typeof === s || te.$$typeof === d || te.$$typeof === y || te.$$typeof === b || te.$$typeof === E || te.$$typeof === v);
    }
    function _(te) {
      if (typeof te == "object" && te !== null) {
        var Re = te.$$typeof;
        switch (Re) {
          case t:
            var we = te.type;
            switch (we) {
              case l:
              case u:
              case r:
              case o:
              case i:
              case f:
                return we;
              default:
                var ze = we && we.$$typeof;
                switch (ze) {
                  case s:
                  case d:
                  case g:
                  case m:
                  case a:
                    return ze;
                  default:
                    return Re;
                }
            }
          case n:
            return Re;
        }
      }
    }
    var k = l, T = u, A = s, R = a, F = t, D = d, W = r, L = g, z = m, B = n, G = o, H = i, J = f, q = !1;
    function Z(te) {
      return q || (q = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), O(te) || _(te) === l;
    }
    function O(te) {
      return _(te) === u;
    }
    function Q(te) {
      return _(te) === s;
    }
    function he(te) {
      return _(te) === a;
    }
    function N(te) {
      return typeof te == "object" && te !== null && te.$$typeof === t;
    }
    function ee(te) {
      return _(te) === d;
    }
    function ae(te) {
      return _(te) === r;
    }
    function pe(te) {
      return _(te) === g;
    }
    function se(te) {
      return _(te) === m;
    }
    function Se(te) {
      return _(te) === n;
    }
    function le(te) {
      return _(te) === o;
    }
    function Ee(te) {
      return _(te) === i;
    }
    function Ie(te) {
      return _(te) === f;
    }
    xt.AsyncMode = k, xt.ConcurrentMode = T, xt.ContextConsumer = A, xt.ContextProvider = R, xt.Element = F, xt.ForwardRef = D, xt.Fragment = W, xt.Lazy = L, xt.Memo = z, xt.Portal = B, xt.Profiler = G, xt.StrictMode = H, xt.Suspense = J, xt.isAsyncMode = Z, xt.isConcurrentMode = O, xt.isContextConsumer = Q, xt.isContextProvider = he, xt.isElement = N, xt.isForwardRef = ee, xt.isFragment = ae, xt.isLazy = pe, xt.isMemo = se, xt.isPortal = Se, xt.isProfiler = le, xt.isStrictMode = Ee, xt.isSuspense = Ie, xt.isValidElementType = S, xt.typeOf = _;
  }()), xt;
}
var AC;
function k7() {
  return AC || (AC = 1, process.env.NODE_ENV === "production" ? Sd.exports = ice() : Sd.exports = oce()), Sd.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var Pg, MC;
function ace() {
  if (MC)
    return Pg;
  MC = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, n = Object.prototype.propertyIsEnumerable;
  function r(o) {
    if (o == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(o);
  }
  function i() {
    try {
      if (!Object.assign)
        return !1;
      var o = new String("abc");
      if (o[5] = "de", Object.getOwnPropertyNames(o)[0] === "5")
        return !1;
      for (var a = {}, s = 0; s < 10; s++)
        a["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(a).map(function(d) {
        return a[d];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var u = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(d) {
        u[d] = d;
      }), Object.keys(Object.assign({}, u)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return Pg = i() ? Object.assign : function(o, a) {
    for (var s, l = r(o), u, d = 1; d < arguments.length; d++) {
      s = Object(arguments[d]);
      for (var f in s)
        t.call(s, f) && (l[f] = s[f]);
      if (e) {
        u = e(s);
        for (var p = 0; p < u.length; p++)
          n.call(s, u[p]) && (l[u[p]] = s[u[p]]);
      }
    }
    return l;
  }, Pg;
}
var kg, OC;
function yw() {
  if (OC)
    return kg;
  OC = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return kg = e, kg;
}
var Tg, RC;
function T7() {
  return RC || (RC = 1, Tg = Function.call.bind(Object.prototype.hasOwnProperty)), Tg;
}
var Ag, IC;
function sce() {
  if (IC)
    return Ag;
  IC = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = yw(), n = {}, r = T7();
    e = function(o) {
      var a = "Warning: " + o;
      typeof console < "u" && console.error(a);
      try {
        throw new Error(a);
      } catch {
      }
    };
  }
  function i(o, a, s, l, u) {
    if (process.env.NODE_ENV !== "production") {
      for (var d in o)
        if (r(o, d)) {
          var f;
          try {
            if (typeof o[d] != "function") {
              var p = Error(
                (l || "React class") + ": " + s + " type `" + d + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof o[d] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw p.name = "Invariant Violation", p;
            }
            f = o[d](a, d, l, s, null, t);
          } catch (g) {
            f = g;
          }
          if (f && !(f instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + d + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof f + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), f instanceof Error && !(f.message in n)) {
            n[f.message] = !0;
            var m = u ? u() : "";
            e(
              "Failed " + s + " type: " + f.message + (m ?? "")
            );
          }
        }
    }
  }
  return i.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (n = {});
  }, Ag = i, Ag;
}
var Mg, DC;
function lce() {
  if (DC)
    return Mg;
  DC = 1;
  var e = k7(), t = ace(), n = yw(), r = T7(), i = sce(), o = function() {
  };
  process.env.NODE_ENV !== "production" && (o = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function a() {
    return null;
  }
  return Mg = function(s, l) {
    var u = typeof Symbol == "function" && Symbol.iterator, d = "@@iterator";
    function f(O) {
      var Q = O && (u && O[u] || O[d]);
      if (typeof Q == "function")
        return Q;
    }
    var p = "<<anonymous>>", m = {
      array: b("array"),
      bigint: b("bigint"),
      bool: b("boolean"),
      func: b("function"),
      number: b("number"),
      object: b("object"),
      string: b("string"),
      symbol: b("symbol"),
      any: E(),
      arrayOf: S,
      element: _(),
      elementType: k(),
      instanceOf: T,
      node: D(),
      objectOf: R,
      oneOf: A,
      oneOfType: F,
      shape: L,
      exact: z
    };
    function g(O, Q) {
      return O === Q ? O !== 0 || 1 / O === 1 / Q : O !== O && Q !== Q;
    }
    function v(O, Q) {
      this.message = O, this.data = Q && typeof Q == "object" ? Q : {}, this.stack = "";
    }
    v.prototype = Error.prototype;
    function y(O) {
      if (process.env.NODE_ENV !== "production")
        var Q = {}, he = 0;
      function N(ae, pe, se, Se, le, Ee, Ie) {
        if (Se = Se || p, Ee = Ee || se, Ie !== n) {
          if (l) {
            var te = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw te.name = "Invariant Violation", te;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var Re = Se + ":" + se;
            !Q[Re] && // Avoid spamming the console because they are often not actionable except for lib authors
            he < 3 && (o(
              "You are manually calling a React.PropTypes validation function for the `" + Ee + "` prop on `" + Se + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), Q[Re] = !0, he++);
          }
        }
        return pe[se] == null ? ae ? pe[se] === null ? new v("The " + le + " `" + Ee + "` is marked as required " + ("in `" + Se + "`, but its value is `null`.")) : new v("The " + le + " `" + Ee + "` is marked as required in " + ("`" + Se + "`, but its value is `undefined`.")) : null : O(pe, se, Se, le, Ee);
      }
      var ee = N.bind(null, !1);
      return ee.isRequired = N.bind(null, !0), ee;
    }
    function b(O) {
      function Q(he, N, ee, ae, pe, se) {
        var Se = he[N], le = H(Se);
        if (le !== O) {
          var Ee = J(Se);
          return new v(
            "Invalid " + ae + " `" + pe + "` of type " + ("`" + Ee + "` supplied to `" + ee + "`, expected ") + ("`" + O + "`."),
            { expectedType: O }
          );
        }
        return null;
      }
      return y(Q);
    }
    function E() {
      return y(a);
    }
    function S(O) {
      function Q(he, N, ee, ae, pe) {
        if (typeof O != "function")
          return new v("Property `" + pe + "` of component `" + ee + "` has invalid PropType notation inside arrayOf.");
        var se = he[N];
        if (!Array.isArray(se)) {
          var Se = H(se);
          return new v("Invalid " + ae + " `" + pe + "` of type " + ("`" + Se + "` supplied to `" + ee + "`, expected an array."));
        }
        for (var le = 0; le < se.length; le++) {
          var Ee = O(se, le, ee, ae, pe + "[" + le + "]", n);
          if (Ee instanceof Error)
            return Ee;
        }
        return null;
      }
      return y(Q);
    }
    function _() {
      function O(Q, he, N, ee, ae) {
        var pe = Q[he];
        if (!s(pe)) {
          var se = H(pe);
          return new v("Invalid " + ee + " `" + ae + "` of type " + ("`" + se + "` supplied to `" + N + "`, expected a single ReactElement."));
        }
        return null;
      }
      return y(O);
    }
    function k() {
      function O(Q, he, N, ee, ae) {
        var pe = Q[he];
        if (!e.isValidElementType(pe)) {
          var se = H(pe);
          return new v("Invalid " + ee + " `" + ae + "` of type " + ("`" + se + "` supplied to `" + N + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return y(O);
    }
    function T(O) {
      function Q(he, N, ee, ae, pe) {
        if (!(he[N] instanceof O)) {
          var se = O.name || p, Se = Z(he[N]);
          return new v("Invalid " + ae + " `" + pe + "` of type " + ("`" + Se + "` supplied to `" + ee + "`, expected ") + ("instance of `" + se + "`."));
        }
        return null;
      }
      return y(Q);
    }
    function A(O) {
      if (!Array.isArray(O))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? o(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : o("Invalid argument supplied to oneOf, expected an array.")), a;
      function Q(he, N, ee, ae, pe) {
        for (var se = he[N], Se = 0; Se < O.length; Se++)
          if (g(se, O[Se]))
            return null;
        var le = JSON.stringify(O, function(Ie, te) {
          var Re = J(te);
          return Re === "symbol" ? String(te) : te;
        });
        return new v("Invalid " + ae + " `" + pe + "` of value `" + String(se) + "` " + ("supplied to `" + ee + "`, expected one of " + le + "."));
      }
      return y(Q);
    }
    function R(O) {
      function Q(he, N, ee, ae, pe) {
        if (typeof O != "function")
          return new v("Property `" + pe + "` of component `" + ee + "` has invalid PropType notation inside objectOf.");
        var se = he[N], Se = H(se);
        if (Se !== "object")
          return new v("Invalid " + ae + " `" + pe + "` of type " + ("`" + Se + "` supplied to `" + ee + "`, expected an object."));
        for (var le in se)
          if (r(se, le)) {
            var Ee = O(se, le, ee, ae, pe + "." + le, n);
            if (Ee instanceof Error)
              return Ee;
          }
        return null;
      }
      return y(Q);
    }
    function F(O) {
      if (!Array.isArray(O))
        return process.env.NODE_ENV !== "production" && o("Invalid argument supplied to oneOfType, expected an instance of array."), a;
      for (var Q = 0; Q < O.length; Q++) {
        var he = O[Q];
        if (typeof he != "function")
          return o(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + q(he) + " at index " + Q + "."
          ), a;
      }
      function N(ee, ae, pe, se, Se) {
        for (var le = [], Ee = 0; Ee < O.length; Ee++) {
          var Ie = O[Ee], te = Ie(ee, ae, pe, se, Se, n);
          if (te == null)
            return null;
          te.data && r(te.data, "expectedType") && le.push(te.data.expectedType);
        }
        var Re = le.length > 0 ? ", expected one of type [" + le.join(", ") + "]" : "";
        return new v("Invalid " + se + " `" + Se + "` supplied to " + ("`" + pe + "`" + Re + "."));
      }
      return y(N);
    }
    function D() {
      function O(Q, he, N, ee, ae) {
        return B(Q[he]) ? null : new v("Invalid " + ee + " `" + ae + "` supplied to " + ("`" + N + "`, expected a ReactNode."));
      }
      return y(O);
    }
    function W(O, Q, he, N, ee) {
      return new v(
        (O || "React class") + ": " + Q + " type `" + he + "." + N + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + ee + "`."
      );
    }
    function L(O) {
      function Q(he, N, ee, ae, pe) {
        var se = he[N], Se = H(se);
        if (Se !== "object")
          return new v("Invalid " + ae + " `" + pe + "` of type `" + Se + "` " + ("supplied to `" + ee + "`, expected `object`."));
        for (var le in O) {
          var Ee = O[le];
          if (typeof Ee != "function")
            return W(ee, ae, pe, le, J(Ee));
          var Ie = Ee(se, le, ee, ae, pe + "." + le, n);
          if (Ie)
            return Ie;
        }
        return null;
      }
      return y(Q);
    }
    function z(O) {
      function Q(he, N, ee, ae, pe) {
        var se = he[N], Se = H(se);
        if (Se !== "object")
          return new v("Invalid " + ae + " `" + pe + "` of type `" + Se + "` " + ("supplied to `" + ee + "`, expected `object`."));
        var le = t({}, he[N], O);
        for (var Ee in le) {
          var Ie = O[Ee];
          if (r(O, Ee) && typeof Ie != "function")
            return W(ee, ae, pe, Ee, J(Ie));
          if (!Ie)
            return new v(
              "Invalid " + ae + " `" + pe + "` key `" + Ee + "` supplied to `" + ee + "`.\nBad object: " + JSON.stringify(he[N], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(O), null, "  ")
            );
          var te = Ie(se, Ee, ee, ae, pe + "." + Ee, n);
          if (te)
            return te;
        }
        return null;
      }
      return y(Q);
    }
    function B(O) {
      switch (typeof O) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !O;
        case "object":
          if (Array.isArray(O))
            return O.every(B);
          if (O === null || s(O))
            return !0;
          var Q = f(O);
          if (Q) {
            var he = Q.call(O), N;
            if (Q !== O.entries) {
              for (; !(N = he.next()).done; )
                if (!B(N.value))
                  return !1;
            } else
              for (; !(N = he.next()).done; ) {
                var ee = N.value;
                if (ee && !B(ee[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function G(O, Q) {
      return O === "symbol" ? !0 : Q ? Q["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && Q instanceof Symbol : !1;
    }
    function H(O) {
      var Q = typeof O;
      return Array.isArray(O) ? "array" : O instanceof RegExp ? "object" : G(Q, O) ? "symbol" : Q;
    }
    function J(O) {
      if (typeof O > "u" || O === null)
        return "" + O;
      var Q = H(O);
      if (Q === "object") {
        if (O instanceof Date)
          return "date";
        if (O instanceof RegExp)
          return "regexp";
      }
      return Q;
    }
    function q(O) {
      var Q = J(O);
      switch (Q) {
        case "array":
        case "object":
          return "an " + Q;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + Q;
        default:
          return Q;
      }
    }
    function Z(O) {
      return !O.constructor || !O.constructor.name ? p : O.constructor.name;
    }
    return m.checkPropTypes = i, m.resetWarningCache = i.resetWarningCache, m.PropTypes = m, m;
  }, Mg;
}
var Og, NC;
function cce() {
  if (NC)
    return Og;
  NC = 1;
  var e = yw();
  function t() {
  }
  function n() {
  }
  return n.resetWarningCache = t, Og = function() {
    function r(a, s, l, u, d, f) {
      if (f !== e) {
        var p = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw p.name = "Invariant Violation", p;
      }
    }
    r.isRequired = r;
    function i() {
      return r;
    }
    var o = {
      array: r,
      bigint: r,
      bool: r,
      func: r,
      number: r,
      object: r,
      string: r,
      symbol: r,
      any: r,
      arrayOf: i,
      element: r,
      elementType: r,
      instanceOf: i,
      node: r,
      objectOf: i,
      oneOf: i,
      oneOfType: i,
      shape: i,
      exact: i,
      checkPropTypes: n,
      resetWarningCache: t
    };
    return o.PropTypes = o, o;
  }, Og;
}
if (process.env.NODE_ENV !== "production") {
  var uce = k7(), dce = !0;
  I0.exports = lce()(uce.isElement, dce);
} else
  I0.exports = cce()();
var ww = I0.exports;
const _e = /* @__PURE__ */ Pi(ww);
/*! @vimeo/player v2.26.0 | (c) 2025 Vimeo | MIT License | https://github.com/vimeo/player.js */
function $C(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(e);
    t && (r = r.filter(function(i) {
      return Object.getOwnPropertyDescriptor(e, i).enumerable;
    })), n.push.apply(n, r);
  }
  return n;
}
function LC(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? $C(Object(n), !0).forEach(function(r) {
      qd(e, r, n[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : $C(Object(n)).forEach(function(r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(n, r));
    });
  }
  return e;
}
function Ln() {
  Ln = function() {
    return e;
  };
  var e = {}, t = Object.prototype, n = t.hasOwnProperty, r = Object.defineProperty || function(L, z, B) {
    L[z] = B.value;
  }, i = typeof Symbol == "function" ? Symbol : {}, o = i.iterator || "@@iterator", a = i.asyncIterator || "@@asyncIterator", s = i.toStringTag || "@@toStringTag";
  function l(L, z, B) {
    return Object.defineProperty(L, z, {
      value: B,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), L[z];
  }
  try {
    l({}, "");
  } catch {
    l = function(z, B, G) {
      return z[B] = G;
    };
  }
  function u(L, z, B, G) {
    var H = z && z.prototype instanceof p ? z : p, J = Object.create(H.prototype), q = new F(G || []);
    return r(J, "_invoke", {
      value: k(L, B, q)
    }), J;
  }
  function d(L, z, B) {
    try {
      return {
        type: "normal",
        arg: L.call(z, B)
      };
    } catch (G) {
      return {
        type: "throw",
        arg: G
      };
    }
  }
  e.wrap = u;
  var f = {};
  function p() {
  }
  function m() {
  }
  function g() {
  }
  var v = {};
  l(v, o, function() {
    return this;
  });
  var y = Object.getPrototypeOf, b = y && y(y(D([])));
  b && b !== t && n.call(b, o) && (v = b);
  var E = g.prototype = p.prototype = Object.create(v);
  function S(L) {
    ["next", "throw", "return"].forEach(function(z) {
      l(L, z, function(B) {
        return this._invoke(z, B);
      });
    });
  }
  function _(L, z) {
    function B(H, J, q, Z) {
      var O = d(L[H], L, J);
      if (O.type !== "throw") {
        var Q = O.arg, he = Q.value;
        return he && typeof he == "object" && n.call(he, "__await") ? z.resolve(he.__await).then(function(N) {
          B("next", N, q, Z);
        }, function(N) {
          B("throw", N, q, Z);
        }) : z.resolve(he).then(function(N) {
          Q.value = N, q(Q);
        }, function(N) {
          return B("throw", N, q, Z);
        });
      }
      Z(O.arg);
    }
    var G;
    r(this, "_invoke", {
      value: function(H, J) {
        function q() {
          return new z(function(Z, O) {
            B(H, J, Z, O);
          });
        }
        return G = G ? G.then(q, q) : q();
      }
    });
  }
  function k(L, z, B) {
    var G = "suspendedStart";
    return function(H, J) {
      if (G === "executing")
        throw new Error("Generator is already running");
      if (G === "completed") {
        if (H === "throw")
          throw J;
        return W();
      }
      for (B.method = H, B.arg = J; ; ) {
        var q = B.delegate;
        if (q) {
          var Z = T(q, B);
          if (Z) {
            if (Z === f)
              continue;
            return Z;
          }
        }
        if (B.method === "next")
          B.sent = B._sent = B.arg;
        else if (B.method === "throw") {
          if (G === "suspendedStart")
            throw G = "completed", B.arg;
          B.dispatchException(B.arg);
        } else
          B.method === "return" && B.abrupt("return", B.arg);
        G = "executing";
        var O = d(L, z, B);
        if (O.type === "normal") {
          if (G = B.done ? "completed" : "suspendedYield", O.arg === f)
            continue;
          return {
            value: O.arg,
            done: B.done
          };
        }
        O.type === "throw" && (G = "completed", B.method = "throw", B.arg = O.arg);
      }
    };
  }
  function T(L, z) {
    var B = z.method, G = L.iterator[B];
    if (G === void 0)
      return z.delegate = null, B === "throw" && L.iterator.return && (z.method = "return", z.arg = void 0, T(L, z), z.method === "throw") || B !== "return" && (z.method = "throw", z.arg = new TypeError("The iterator does not provide a '" + B + "' method")), f;
    var H = d(G, L.iterator, z.arg);
    if (H.type === "throw")
      return z.method = "throw", z.arg = H.arg, z.delegate = null, f;
    var J = H.arg;
    return J ? J.done ? (z[L.resultName] = J.value, z.next = L.nextLoc, z.method !== "return" && (z.method = "next", z.arg = void 0), z.delegate = null, f) : J : (z.method = "throw", z.arg = new TypeError("iterator result is not an object"), z.delegate = null, f);
  }
  function A(L) {
    var z = {
      tryLoc: L[0]
    };
    1 in L && (z.catchLoc = L[1]), 2 in L && (z.finallyLoc = L[2], z.afterLoc = L[3]), this.tryEntries.push(z);
  }
  function R(L) {
    var z = L.completion || {};
    z.type = "normal", delete z.arg, L.completion = z;
  }
  function F(L) {
    this.tryEntries = [{
      tryLoc: "root"
    }], L.forEach(A, this), this.reset(!0);
  }
  function D(L) {
    if (L) {
      var z = L[o];
      if (z)
        return z.call(L);
      if (typeof L.next == "function")
        return L;
      if (!isNaN(L.length)) {
        var B = -1, G = function H() {
          for (; ++B < L.length; )
            if (n.call(L, B))
              return H.value = L[B], H.done = !1, H;
          return H.value = void 0, H.done = !0, H;
        };
        return G.next = G;
      }
    }
    return {
      next: W
    };
  }
  function W() {
    return {
      value: void 0,
      done: !0
    };
  }
  return m.prototype = g, r(E, "constructor", {
    value: g,
    configurable: !0
  }), r(g, "constructor", {
    value: m,
    configurable: !0
  }), m.displayName = l(g, s, "GeneratorFunction"), e.isGeneratorFunction = function(L) {
    var z = typeof L == "function" && L.constructor;
    return !!z && (z === m || (z.displayName || z.name) === "GeneratorFunction");
  }, e.mark = function(L) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(L, g) : (L.__proto__ = g, l(L, s, "GeneratorFunction")), L.prototype = Object.create(E), L;
  }, e.awrap = function(L) {
    return {
      __await: L
    };
  }, S(_.prototype), l(_.prototype, a, function() {
    return this;
  }), e.AsyncIterator = _, e.async = function(L, z, B, G, H) {
    H === void 0 && (H = Promise);
    var J = new _(u(L, z, B, G), H);
    return e.isGeneratorFunction(z) ? J : J.next().then(function(q) {
      return q.done ? q.value : J.next();
    });
  }, S(E), l(E, s, "Generator"), l(E, o, function() {
    return this;
  }), l(E, "toString", function() {
    return "[object Generator]";
  }), e.keys = function(L) {
    var z = Object(L), B = [];
    for (var G in z)
      B.push(G);
    return B.reverse(), function H() {
      for (; B.length; ) {
        var J = B.pop();
        if (J in z)
          return H.value = J, H.done = !1, H;
      }
      return H.done = !0, H;
    };
  }, e.values = D, F.prototype = {
    constructor: F,
    reset: function(L) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = void 0, this.done = !1, this.delegate = null, this.method = "next", this.arg = void 0, this.tryEntries.forEach(R), !L)
        for (var z in this)
          z.charAt(0) === "t" && n.call(this, z) && !isNaN(+z.slice(1)) && (this[z] = void 0);
    },
    stop: function() {
      this.done = !0;
      var L = this.tryEntries[0].completion;
      if (L.type === "throw")
        throw L.arg;
      return this.rval;
    },
    dispatchException: function(L) {
      if (this.done)
        throw L;
      var z = this;
      function B(O, Q) {
        return J.type = "throw", J.arg = L, z.next = O, Q && (z.method = "next", z.arg = void 0), !!Q;
      }
      for (var G = this.tryEntries.length - 1; G >= 0; --G) {
        var H = this.tryEntries[G], J = H.completion;
        if (H.tryLoc === "root")
          return B("end");
        if (H.tryLoc <= this.prev) {
          var q = n.call(H, "catchLoc"), Z = n.call(H, "finallyLoc");
          if (q && Z) {
            if (this.prev < H.catchLoc)
              return B(H.catchLoc, !0);
            if (this.prev < H.finallyLoc)
              return B(H.finallyLoc);
          } else if (q) {
            if (this.prev < H.catchLoc)
              return B(H.catchLoc, !0);
          } else {
            if (!Z)
              throw new Error("try statement without catch or finally");
            if (this.prev < H.finallyLoc)
              return B(H.finallyLoc);
          }
        }
      }
    },
    abrupt: function(L, z) {
      for (var B = this.tryEntries.length - 1; B >= 0; --B) {
        var G = this.tryEntries[B];
        if (G.tryLoc <= this.prev && n.call(G, "finallyLoc") && this.prev < G.finallyLoc) {
          var H = G;
          break;
        }
      }
      H && (L === "break" || L === "continue") && H.tryLoc <= z && z <= H.finallyLoc && (H = null);
      var J = H ? H.completion : {};
      return J.type = L, J.arg = z, H ? (this.method = "next", this.next = H.finallyLoc, f) : this.complete(J);
    },
    complete: function(L, z) {
      if (L.type === "throw")
        throw L.arg;
      return L.type === "break" || L.type === "continue" ? this.next = L.arg : L.type === "return" ? (this.rval = this.arg = L.arg, this.method = "return", this.next = "end") : L.type === "normal" && z && (this.next = z), f;
    },
    finish: function(L) {
      for (var z = this.tryEntries.length - 1; z >= 0; --z) {
        var B = this.tryEntries[z];
        if (B.finallyLoc === L)
          return this.complete(B.completion, B.afterLoc), R(B), f;
      }
    },
    catch: function(L) {
      for (var z = this.tryEntries.length - 1; z >= 0; --z) {
        var B = this.tryEntries[z];
        if (B.tryLoc === L) {
          var G = B.completion;
          if (G.type === "throw") {
            var H = G.arg;
            R(B);
          }
          return H;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function(L, z, B) {
      return this.delegate = {
        iterator: D(L),
        resultName: z,
        nextLoc: B
      }, this.method === "next" && (this.arg = void 0), f;
    }
  }, e;
}
function FC(e, t, n, r, i, o, a) {
  try {
    var s = e[o](a), l = s.value;
  } catch (u) {
    n(u);
    return;
  }
  s.done ? t(l) : Promise.resolve(l).then(r, i);
}
function aa(e) {
  return function() {
    var t = this, n = arguments;
    return new Promise(function(r, i) {
      var o = e.apply(t, n);
      function a(l) {
        FC(o, r, i, a, s, "next", l);
      }
      function s(l) {
        FC(o, r, i, a, s, "throw", l);
      }
      a(void 0);
    });
  };
}
function A7(e, t) {
  if (!(e instanceof t))
    throw new TypeError("Cannot call a class as a function");
}
function zC(e, t) {
  for (var n = 0; n < t.length; n++) {
    var r = t[n];
    r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, R7(r.key), r);
  }
}
function M7(e, t, n) {
  return t && zC(e.prototype, t), n && zC(e, n), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function qd(e, t, n) {
  return t = R7(t), t in e ? Object.defineProperty(e, t, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[t] = n, e;
}
function fce(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Super expression must either be null or a function");
  e.prototype = Object.create(t && t.prototype, {
    constructor: {
      value: e,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(e, "prototype", {
    writable: !1
  }), t && Sc(e, t);
}
function Cc(e) {
  return Cc = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Cc(e);
}
function Sc(e, t) {
  return Sc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(r, i) {
    return r.__proto__ = i, r;
  }, Sc(e, t);
}
function O7() {
  if (typeof Reflect > "u" || !Reflect.construct || Reflect.construct.sham)
    return !1;
  if (typeof Proxy == "function")
    return !0;
  try {
    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    })), !0;
  } catch {
    return !1;
  }
}
function Yd(e, t, n) {
  return O7() ? Yd = Reflect.construct.bind() : Yd = function(i, o, a) {
    var s = [null];
    s.push.apply(s, o);
    var l = Function.bind.apply(i, s), u = new l();
    return a && Sc(u, a.prototype), u;
  }, Yd.apply(null, arguments);
}
function hce(e) {
  return Function.toString.call(e).indexOf("[native code]") !== -1;
}
function D0(e) {
  var t = typeof Map == "function" ? /* @__PURE__ */ new Map() : void 0;
  return D0 = function(r) {
    if (r === null || !hce(r))
      return r;
    if (typeof r != "function")
      throw new TypeError("Super expression must either be null or a function");
    if (typeof t < "u") {
      if (t.has(r))
        return t.get(r);
      t.set(r, i);
    }
    function i() {
      return Yd(r, arguments, Cc(this).constructor);
    }
    return i.prototype = Object.create(r.prototype, {
      constructor: {
        value: i,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), Sc(i, r);
  }, D0(e);
}
function Kd(e) {
  if (e === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function pce(e, t) {
  if (t && (typeof t == "object" || typeof t == "function"))
    return t;
  if (t !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return Kd(e);
}
function mce(e) {
  var t = O7();
  return function() {
    var r = Cc(e), i;
    if (t) {
      var o = Cc(this).constructor;
      i = Reflect.construct(r, arguments, o);
    } else
      i = r.apply(this, arguments);
    return pce(this, i);
  };
}
function gce(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function R7(e) {
  var t = gce(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
var I7 = typeof global < "u" && {}.toString.call(global) === "[object global]";
function VC(e, t) {
  return e.indexOf(t.toLowerCase()) === 0 ? e : "".concat(t.toLowerCase()).concat(e.substr(0, 1).toUpperCase()).concat(e.substr(1));
}
function vce(e) {
  return !!(e && e.nodeType === 1 && "nodeName" in e && e.ownerDocument && e.ownerDocument.defaultView);
}
function yce(e) {
  return !isNaN(parseFloat(e)) && isFinite(e) && Math.floor(e) == e;
}
function _a(e) {
  return /^(https?:)?\/\/((((player|www)\.)?vimeo\.com)|((player\.)?[a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))(?=$|\/)/.test(e);
}
function D7(e) {
  var t = /^https:\/\/player\.((vimeo\.com)|([a-zA-Z0-9-]+\.(videoji\.(hk|cn)|vimeo\.work)))\/video\/\d+/;
  return t.test(e);
}
function wce(e) {
  for (var t = (e || "").match(/^(?:https?:)?(?:\/\/)?([^/?]+)/), n = (t && t[1] || "").replace("player.", ""), r = [".videoji.hk", ".vimeo.work", ".videoji.cn"], i = 0, o = r; i < o.length; i++) {
    var a = o[i];
    if (n.endsWith(a))
      return n;
  }
  return "vimeo.com";
}
function N7() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = e.id, n = e.url, r = t || n;
  if (!r)
    throw new Error("An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute.");
  if (yce(r))
    return "https://vimeo.com/".concat(r);
  if (_a(r))
    return r.replace("http:", "https:");
  throw t ? new TypeError("“".concat(t, "” is not a valid video id.")) : new TypeError("“".concat(r, "” is not a vimeo.com url."));
}
var BC = function(t, n, r) {
  var i = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "addEventListener", o = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "removeEventListener", a = typeof n == "string" ? [n] : n;
  return a.forEach(function(s) {
    t[i](s, r);
  }), {
    cancel: function() {
      return a.forEach(function(l) {
        return t[o](l, r);
      });
    }
  };
}, bce = typeof Array.prototype.indexOf < "u", xce = typeof window < "u" && typeof window.postMessage < "u";
if (!I7 && (!bce || !xce))
  throw new Error("Sorry, the Vimeo Player API is not available in this browser.");
var Cs = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Ece(e, t) {
  return t = { exports: {} }, e(t, t.exports), t.exports;
}
/*!
 * weakmap-polyfill v2.0.4 - ECMAScript6 WeakMap polyfill
 * https://github.com/polygonplanet/weakmap-polyfill
 * Copyright (c) 2015-2021 polygonplanet <polygon.planet.aqua@gmail.com>
 * @license MIT
 */
(function(e) {
  if (e.WeakMap)
    return;
  var t = Object.prototype.hasOwnProperty, n = Object.defineProperty && function() {
    try {
      return Object.defineProperty({}, "x", {
        value: 1
      }).x === 1;
    } catch {
    }
  }(), r = function(o, a, s) {
    n ? Object.defineProperty(o, a, {
      configurable: !0,
      writable: !0,
      value: s
    }) : o[a] = s;
  };
  e.WeakMap = function() {
    function o() {
      if (this === void 0)
        throw new TypeError("Constructor WeakMap requires 'new'");
      if (r(this, "_id", s("_WeakMap")), arguments.length > 0)
        throw new TypeError("WeakMap iterable is not supported");
    }
    r(o.prototype, "delete", function(u) {
      if (a(this, "delete"), !i(u))
        return !1;
      var d = u[this._id];
      return d && d[0] === u ? (delete u[this._id], !0) : !1;
    }), r(o.prototype, "get", function(u) {
      if (a(this, "get"), !!i(u)) {
        var d = u[this._id];
        if (d && d[0] === u)
          return d[1];
      }
    }), r(o.prototype, "has", function(u) {
      if (a(this, "has"), !i(u))
        return !1;
      var d = u[this._id];
      return !!(d && d[0] === u);
    }), r(o.prototype, "set", function(u, d) {
      if (a(this, "set"), !i(u))
        throw new TypeError("Invalid value used as weak map key");
      var f = u[this._id];
      return f && f[0] === u ? (f[1] = d, this) : (r(u, this._id, [u, d]), this);
    });
    function a(u, d) {
      if (!i(u) || !t.call(u, "_id"))
        throw new TypeError(d + " method called on incompatible receiver " + typeof u);
    }
    function s(u) {
      return u + "_" + l() + "." + l();
    }
    function l() {
      return Math.random().toString().substring(2);
    }
    return r(o, "_polyfill", !0), o;
  }();
  function i(o) {
    return Object(o) === o;
  }
})(typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : Cs);
var Ar = Ece(function(e) {
  /*! Native Promise Only
      v0.8.1 (c) Kyle Simpson
      MIT License: http://getify.mit-license.org
  */
  (function(n, r, i) {
    r[n] = r[n] || i(), e.exports && (e.exports = r[n]);
  })("Promise", Cs, function() {
    var n, r, i, o = Object.prototype.toString, a = typeof setImmediate < "u" ? function(S) {
      return setImmediate(S);
    } : setTimeout;
    try {
      Object.defineProperty({}, "x", {}), n = function(S, _, k, T) {
        return Object.defineProperty(S, _, {
          value: k,
          writable: !0,
          configurable: T !== !1
        });
      };
    } catch {
      n = function(_, k, T) {
        return _[k] = T, _;
      };
    }
    i = function() {
      var S, _, k;
      function T(A, R) {
        this.fn = A, this.self = R, this.next = void 0;
      }
      return {
        add: function(R, F) {
          k = new T(R, F), _ ? _.next = k : S = k, _ = k, k = void 0;
        },
        drain: function() {
          var R = S;
          for (S = _ = r = void 0; R; )
            R.fn.call(R.self), R = R.next;
        }
      };
    }();
    function s(E, S) {
      i.add(E, S), r || (r = a(i.drain));
    }
    function l(E) {
      var S, _ = typeof E;
      return E != null && (_ == "object" || _ == "function") && (S = E.then), typeof S == "function" ? S : !1;
    }
    function u() {
      for (var E = 0; E < this.chain.length; E++)
        d(this, this.state === 1 ? this.chain[E].success : this.chain[E].failure, this.chain[E]);
      this.chain.length = 0;
    }
    function d(E, S, _) {
      var k, T;
      try {
        S === !1 ? _.reject(E.msg) : (S === !0 ? k = E.msg : k = S.call(void 0, E.msg), k === _.promise ? _.reject(TypeError("Promise-chain cycle")) : (T = l(k)) ? T.call(k, _.resolve, _.reject) : _.resolve(k));
      } catch (A) {
        _.reject(A);
      }
    }
    function f(E) {
      var S, _ = this;
      if (!_.triggered) {
        _.triggered = !0, _.def && (_ = _.def);
        try {
          (S = l(E)) ? s(function() {
            var k = new g(_);
            try {
              S.call(E, function() {
                f.apply(k, arguments);
              }, function() {
                p.apply(k, arguments);
              });
            } catch (T) {
              p.call(k, T);
            }
          }) : (_.msg = E, _.state = 1, _.chain.length > 0 && s(u, _));
        } catch (k) {
          p.call(new g(_), k);
        }
      }
    }
    function p(E) {
      var S = this;
      S.triggered || (S.triggered = !0, S.def && (S = S.def), S.msg = E, S.state = 2, S.chain.length > 0 && s(u, S));
    }
    function m(E, S, _, k) {
      for (var T = 0; T < S.length; T++)
        (function(R) {
          E.resolve(S[R]).then(function(D) {
            _(R, D);
          }, k);
        })(T);
    }
    function g(E) {
      this.def = E, this.triggered = !1;
    }
    function v(E) {
      this.promise = E, this.state = 0, this.triggered = !1, this.chain = [], this.msg = void 0;
    }
    function y(E) {
      if (typeof E != "function")
        throw TypeError("Not a function");
      if (this.__NPO__ !== 0)
        throw TypeError("Not a promise");
      this.__NPO__ = 1;
      var S = new v(this);
      this.then = function(k, T) {
        var A = {
          success: typeof k == "function" ? k : !0,
          failure: typeof T == "function" ? T : !1
        };
        return A.promise = new this.constructor(function(F, D) {
          if (typeof F != "function" || typeof D != "function")
            throw TypeError("Not a function");
          A.resolve = F, A.reject = D;
        }), S.chain.push(A), S.state !== 0 && s(u, S), A.promise;
      }, this.catch = function(k) {
        return this.then(void 0, k);
      };
      try {
        E.call(void 0, function(k) {
          f.call(S, k);
        }, function(k) {
          p.call(S, k);
        });
      } catch (_) {
        p.call(S, _);
      }
    }
    var b = n(
      {},
      "constructor",
      y,
      /*configurable=*/
      !1
    );
    return y.prototype = b, n(
      b,
      "__NPO__",
      0,
      /*configurable=*/
      !1
    ), n(y, "resolve", function(S) {
      var _ = this;
      return S && typeof S == "object" && S.__NPO__ === 1 ? S : new _(function(T, A) {
        if (typeof T != "function" || typeof A != "function")
          throw TypeError("Not a function");
        T(S);
      });
    }), n(y, "reject", function(S) {
      return new this(function(k, T) {
        if (typeof k != "function" || typeof T != "function")
          throw TypeError("Not a function");
        T(S);
      });
    }), n(y, "all", function(S) {
      var _ = this;
      return o.call(S) != "[object Array]" ? _.reject(TypeError("Not an array")) : S.length === 0 ? _.resolve([]) : new _(function(T, A) {
        if (typeof T != "function" || typeof A != "function")
          throw TypeError("Not a function");
        var R = S.length, F = Array(R), D = 0;
        m(_, S, function(L, z) {
          F[L] = z, ++D === R && T(F);
        }, A);
      });
    }), n(y, "race", function(S) {
      var _ = this;
      return o.call(S) != "[object Array]" ? _.reject(TypeError("Not an array")) : new _(function(T, A) {
        if (typeof T != "function" || typeof A != "function")
          throw TypeError("Not a function");
        m(_, S, function(F, D) {
          T(D);
        }, A);
      });
    }), y;
  });
}), Gi = /* @__PURE__ */ new WeakMap();
function Rl(e, t, n) {
  var r = Gi.get(e.element) || {};
  t in r || (r[t] = []), r[t].push(n), Gi.set(e.element, r);
}
function zf(e, t) {
  var n = Gi.get(e.element) || {};
  return n[t] || [];
}
function Vf(e, t, n) {
  var r = Gi.get(e.element) || {};
  if (!r[t])
    return !0;
  if (!n)
    return r[t] = [], Gi.set(e.element, r), !0;
  var i = r[t].indexOf(n);
  return i !== -1 && r[t].splice(i, 1), Gi.set(e.element, r), r[t] && r[t].length === 0;
}
function Cce(e, t) {
  var n = zf(e, t);
  if (n.length < 1)
    return !1;
  var r = n.shift();
  return Vf(e, t, r), r;
}
function Sce(e, t) {
  var n = Gi.get(e);
  Gi.set(t, n), Gi.delete(e);
}
function rp(e) {
  if (typeof e == "string")
    try {
      e = JSON.parse(e);
    } catch (t) {
      return console.warn(t), {};
    }
  return e;
}
function na(e, t, n) {
  if (!(!e.element.contentWindow || !e.element.contentWindow.postMessage)) {
    var r = {
      method: t
    };
    n !== void 0 && (r.value = n);
    var i = parseFloat(navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1"));
    i >= 8 && i < 10 && (r = JSON.stringify(r)), e.element.contentWindow.postMessage(r, e.origin);
  }
}
function _ce(e, t) {
  t = rp(t);
  var n = [], r;
  if (t.event) {
    if (t.event === "error") {
      var i = zf(e, t.data.method);
      i.forEach(function(a) {
        var s = new Error(t.data.message);
        s.name = t.data.name, a.reject(s), Vf(e, t.data.method, a);
      });
    }
    n = zf(e, "event:".concat(t.event)), r = t.data;
  } else if (t.method) {
    var o = Cce(e, t.method);
    o && (n.push(o), r = t.value);
  }
  n.forEach(function(a) {
    try {
      if (typeof a == "function") {
        a.call(e, r);
        return;
      }
      a.resolve(r);
    } catch {
    }
  });
}
var Pce = ["airplay", "audio_tracks", "audiotrack", "autopause", "autoplay", "background", "byline", "cc", "chapter_id", "chapters", "chromecast", "color", "colors", "controls", "dnt", "end_time", "fullscreen", "height", "id", "interactive_params", "keyboard", "loop", "maxheight", "maxwidth", "muted", "play_button_position", "playsinline", "portrait", "progress_bar", "quality_selector", "responsive", "skipping_forward", "speed", "start_time", "texttrack", "title", "transcript", "transparent", "unmute_button", "url", "vimeo_logo", "volume", "watch_full_video", "width"];
function $7(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return Pce.reduce(function(n, r) {
    var i = e.getAttribute("data-vimeo-".concat(r));
    return (i || i === "") && (n[r] = i === "" ? 1 : i), n;
  }, t);
}
function bw(e, t) {
  var n = e.html;
  if (!t)
    throw new TypeError("An element must be provided");
  if (t.getAttribute("data-vimeo-initialized") !== null)
    return t.querySelector("iframe");
  var r = document.createElement("div");
  return r.innerHTML = n, t.appendChild(r.firstChild), t.setAttribute("data-vimeo-initialized", "true"), t.querySelector("iframe");
}
function L7(e) {
  var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 ? arguments[2] : void 0;
  return new Promise(function(r, i) {
    if (!_a(e))
      throw new TypeError("“".concat(e, "” is not a vimeo.com url."));
    var o = wce(e), a = "https://".concat(o, "/api/oembed.json?url=").concat(encodeURIComponent(e));
    for (var s in t)
      t.hasOwnProperty(s) && (a += "&".concat(s, "=").concat(encodeURIComponent(t[s])));
    var l = "XDomainRequest" in window ? new XDomainRequest() : new XMLHttpRequest();
    l.open("GET", a, !0), l.onload = function() {
      if (l.status === 404) {
        i(new Error("“".concat(e, "” was not found.")));
        return;
      }
      if (l.status === 403) {
        i(new Error("“".concat(e, "” is not embeddable.")));
        return;
      }
      try {
        var u = JSON.parse(l.responseText);
        if (u.domain_status_code === 403) {
          bw(u, n), i(new Error("“".concat(e, "” is not embeddable.")));
          return;
        }
        r(u);
      } catch (d) {
        i(d);
      }
    }, l.onerror = function() {
      var u = l.status ? " (".concat(l.status, ")") : "";
      i(new Error("There was an error fetching the embed code from Vimeo".concat(u, ".")));
    }, l.send();
  });
}
function kce() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document, t = [].slice.call(e.querySelectorAll("[data-vimeo-id], [data-vimeo-url]")), n = function(i) {
    "console" in window && console.error && console.error("There was an error creating an embed: ".concat(i));
  };
  t.forEach(function(r) {
    try {
      if (r.getAttribute("data-vimeo-defer") !== null)
        return;
      var i = $7(r), o = N7(i);
      L7(o, i, r).then(function(a) {
        return bw(a, r);
      }).catch(n);
    } catch (a) {
      n(a);
    }
  });
}
function Tce() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoPlayerResizeEmbeds_) {
    window.VimeoPlayerResizeEmbeds_ = !0;
    var t = function(r) {
      if (_a(r.origin) && !(!r.data || r.data.event !== "spacechange")) {
        for (var i = e.querySelectorAll("iframe"), o = 0; o < i.length; o++)
          if (i[o].contentWindow === r.source) {
            var a = i[o].parentElement;
            a.style.paddingBottom = "".concat(r.data.data[0].bottom, "px");
            break;
          }
      }
    };
    window.addEventListener("message", t);
  }
}
function Ace() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoSeoMetadataAppended) {
    window.VimeoSeoMetadataAppended = !0;
    var t = function(r) {
      if (_a(r.origin)) {
        var i = rp(r.data);
        if (!(!i || i.event !== "ready"))
          for (var o = e.querySelectorAll("iframe"), a = 0; a < o.length; a++) {
            var s = o[a], l = s.contentWindow === r.source;
            if (D7(s.src) && l) {
              var u = new xw(s);
              u.callMethod("appendVideoMetadata", window.location.href);
            }
          }
      }
    };
    window.addEventListener("message", t);
  }
}
function Mce() {
  var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document;
  if (!window.VimeoCheckedUrlTimeParam) {
    window.VimeoCheckedUrlTimeParam = !0;
    var t = function(i) {
      "console" in window && console.error && console.error("There was an error getting video Id: ".concat(i));
    }, n = function(i) {
      if (_a(i.origin)) {
        var o = rp(i.data);
        if (!(!o || o.event !== "ready"))
          for (var a = e.querySelectorAll("iframe"), s = function() {
            var d = a[l], f = d.contentWindow === i.source;
            if (D7(d.src) && f) {
              var p = new xw(d);
              p.getVideoId().then(function(m) {
                var g = new RegExp("[?&]vimeo_t_".concat(m, "=([^&#]*)")).exec(window.location.href);
                if (g && g[1]) {
                  var v = decodeURI(g[1]);
                  p.setCurrentTime(v);
                }
              }).catch(t);
            }
          }, l = 0; l < a.length; l++)
            s();
      }
    };
    window.addEventListener("message", n);
  }
}
function Oce() {
  var e = function() {
    for (var r, i = [
      ["requestFullscreen", "exitFullscreen", "fullscreenElement", "fullscreenEnabled", "fullscreenchange", "fullscreenerror"],
      // New WebKit
      ["webkitRequestFullscreen", "webkitExitFullscreen", "webkitFullscreenElement", "webkitFullscreenEnabled", "webkitfullscreenchange", "webkitfullscreenerror"],
      // Old WebKit
      ["webkitRequestFullScreen", "webkitCancelFullScreen", "webkitCurrentFullScreenElement", "webkitCancelFullScreen", "webkitfullscreenchange", "webkitfullscreenerror"],
      ["mozRequestFullScreen", "mozCancelFullScreen", "mozFullScreenElement", "mozFullScreenEnabled", "mozfullscreenchange", "mozfullscreenerror"],
      ["msRequestFullscreen", "msExitFullscreen", "msFullscreenElement", "msFullscreenEnabled", "MSFullscreenChange", "MSFullscreenError"]
    ], o = 0, a = i.length, s = {}; o < a; o++)
      if (r = i[o], r && r[1] in document) {
        for (o = 0; o < r.length; o++)
          s[i[0][o]] = r[o];
        return s;
      }
    return !1;
  }(), t = {
    fullscreenchange: e.fullscreenchange,
    fullscreenerror: e.fullscreenerror
  }, n = {
    request: function(i) {
      return new Promise(function(o, a) {
        var s = function u() {
          n.off("fullscreenchange", u), o();
        };
        n.on("fullscreenchange", s), i = i || document.documentElement;
        var l = i[e.requestFullscreen]();
        l instanceof Promise && l.then(s).catch(a);
      });
    },
    exit: function() {
      return new Promise(function(i, o) {
        if (!n.isFullscreen) {
          i();
          return;
        }
        var a = function l() {
          n.off("fullscreenchange", l), i();
        };
        n.on("fullscreenchange", a);
        var s = document[e.exitFullscreen]();
        s instanceof Promise && s.then(a).catch(o);
      });
    },
    on: function(i, o) {
      var a = t[i];
      a && document.addEventListener(a, o);
    },
    off: function(i, o) {
      var a = t[i];
      a && document.removeEventListener(a, o);
    }
  };
  return Object.defineProperties(n, {
    isFullscreen: {
      get: function() {
        return !!document[e.fullscreenElement];
      }
    },
    element: {
      enumerable: !0,
      get: function() {
        return document[e.fullscreenElement];
      }
    },
    isEnabled: {
      enumerable: !0,
      get: function() {
        return !!document[e.fullscreenEnabled];
      }
    }
  }), n;
}
var Rce = {
  role: "viewer",
  autoPlayMuted: !0,
  allowedDrift: 0.3,
  maxAllowedDrift: 1,
  minCheckInterval: 0.1,
  maxRateAdjustment: 0.2,
  maxTimeToCatchUp: 1
}, Ice = /* @__PURE__ */ function(e) {
  fce(n, e);
  var t = mce(n);
  function n(r, i) {
    var o, a = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = arguments.length > 3 ? arguments[3] : void 0;
    return A7(this, n), o = t.call(this), qd(Kd(o), "logger", void 0), qd(Kd(o), "speedAdjustment", 0), qd(Kd(o), "adjustSpeed", /* @__PURE__ */ function() {
      var l = aa(/* @__PURE__ */ Ln().mark(function u(d, f) {
        var p;
        return Ln().wrap(function(g) {
          for (; ; )
            switch (g.prev = g.next) {
              case 0:
                if (o.speedAdjustment !== f) {
                  g.next = 2;
                  break;
                }
                return g.abrupt("return");
              case 2:
                return g.next = 4, d.getPlaybackRate();
              case 4:
                return g.t0 = g.sent, g.t1 = o.speedAdjustment, g.t2 = g.t0 - g.t1, g.t3 = f, p = g.t2 + g.t3, o.log("New playbackRate:  ".concat(p)), g.next = 12, d.setPlaybackRate(p);
              case 12:
                o.speedAdjustment = f;
              case 13:
              case "end":
                return g.stop();
            }
        }, u);
      }));
      return function(u, d) {
        return l.apply(this, arguments);
      };
    }()), o.logger = s, o.init(i, r, LC(LC({}, Rce), a)), o;
  }
  return M7(n, [{
    key: "disconnect",
    value: function() {
      this.dispatchEvent(new Event("disconnect"));
    }
    /**
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {Promise<void>}
     */
  }, {
    key: "init",
    value: function() {
      var r = aa(/* @__PURE__ */ Ln().mark(function o(a, s, l) {
        var u = this, d, f, p;
        return Ln().wrap(function(g) {
          for (; ; )
            switch (g.prev = g.next) {
              case 0:
                return g.next = 2, this.waitForTOReadyState(a, "open");
              case 2:
                if (l.role !== "viewer") {
                  g.next = 10;
                  break;
                }
                return g.next = 5, this.updatePlayer(a, s, l);
              case 5:
                d = BC(a, "change", function() {
                  return u.updatePlayer(a, s, l);
                }), f = this.maintainPlaybackPosition(a, s, l), this.addEventListener("disconnect", function() {
                  f.cancel(), d.cancel();
                }), g.next = 14;
                break;
              case 10:
                return g.next = 12, this.updateTimingObject(a, s);
              case 12:
                p = BC(s, ["seeked", "play", "pause", "ratechange"], function() {
                  return u.updateTimingObject(a, s);
                }, "on", "off"), this.addEventListener("disconnect", function() {
                  return p.cancel();
                });
              case 14:
              case "end":
                return g.stop();
            }
        }, o, this);
      }));
      function i(o, a, s) {
        return r.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Sets the TimingObject's state to reflect that of the player
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @return {Promise<void>}
     */
  }, {
    key: "updateTimingObject",
    value: function() {
      var r = aa(/* @__PURE__ */ Ln().mark(function o(a, s) {
        return Ln().wrap(function(u) {
          for (; ; )
            switch (u.prev = u.next) {
              case 0:
                return u.t0 = a, u.next = 3, s.getCurrentTime();
              case 3:
                return u.t1 = u.sent, u.next = 6, s.getPaused();
              case 6:
                if (!u.sent) {
                  u.next = 10;
                  break;
                }
                u.t2 = 0, u.next = 13;
                break;
              case 10:
                return u.next = 12, s.getPlaybackRate();
              case 12:
                u.t2 = u.sent;
              case 13:
                u.t3 = u.t2, u.t4 = {
                  position: u.t1,
                  velocity: u.t3
                }, u.t0.update.call(u.t0, u.t4);
              case 16:
              case "end":
                return u.stop();
            }
        }, o);
      }));
      function i(o, a) {
        return r.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Sets the player's timing state to reflect that of the TimingObject
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {Promise<void>}
     */
  }, {
    key: "updatePlayer",
    value: function() {
      var r = aa(/* @__PURE__ */ Ln().mark(function o(a, s, l) {
        var u, d, f;
        return Ln().wrap(function(m) {
          for (; ; )
            switch (m.prev = m.next) {
              case 0:
                if (u = a.query(), d = u.position, f = u.velocity, typeof d == "number" && s.setCurrentTime(d), typeof f != "number") {
                  m.next = 25;
                  break;
                }
                if (f !== 0) {
                  m.next = 11;
                  break;
                }
                return m.next = 6, s.getPaused();
              case 6:
                if (m.t0 = m.sent, m.t0 !== !1) {
                  m.next = 9;
                  break;
                }
                s.pause();
              case 9:
                m.next = 25;
                break;
              case 11:
                if (!(f > 0)) {
                  m.next = 25;
                  break;
                }
                return m.next = 14, s.getPaused();
              case 14:
                if (m.t1 = m.sent, m.t1 !== !0) {
                  m.next = 19;
                  break;
                }
                return m.next = 18, s.play().catch(/* @__PURE__ */ function() {
                  var g = aa(/* @__PURE__ */ Ln().mark(function v(y) {
                    return Ln().wrap(function(E) {
                      for (; ; )
                        switch (E.prev = E.next) {
                          case 0:
                            if (!(y.name === "NotAllowedError" && l.autoPlayMuted)) {
                              E.next = 5;
                              break;
                            }
                            return E.next = 3, s.setMuted(!0);
                          case 3:
                            return E.next = 5, s.play().catch(function(S) {
                              return console.error("Couldn't play the video from TimingSrcConnector. Error:", S);
                            });
                          case 5:
                          case "end":
                            return E.stop();
                        }
                    }, v);
                  }));
                  return function(v) {
                    return g.apply(this, arguments);
                  };
                }());
              case 18:
                this.updatePlayer(a, s, l);
              case 19:
                return m.next = 21, s.getPlaybackRate();
              case 21:
                if (m.t2 = m.sent, m.t3 = f, m.t2 === m.t3) {
                  m.next = 25;
                  break;
                }
                s.setPlaybackRate(f);
              case 25:
              case "end":
                return m.stop();
            }
        }, o, this);
      }));
      function i(o, a, s) {
        return r.apply(this, arguments);
      }
      return i;
    }()
    /**
     * Since video players do not play with 100% time precision, we need to closely monitor
     * our player to be sure it remains in sync with the TimingObject.
     *
     * If out of sync, we use the current conditions and the options provided to determine
     * whether to re-sync via setting currentTime or adjusting the playbackRate
     *
     * @param {TimingObject} timingObject
     * @param {PlayerControls} player
     * @param {TimingSrcConnectorOptions} options
     * @return {{cancel: (function(): void)}}
     */
  }, {
    key: "maintainPlaybackPosition",
    value: function(i, o, a) {
      var s = this, l = a.allowedDrift, u = a.maxAllowedDrift, d = a.minCheckInterval, f = a.maxRateAdjustment, p = a.maxTimeToCatchUp, m = Math.min(p, Math.max(d, u)) * 1e3, g = /* @__PURE__ */ function() {
        var y = aa(/* @__PURE__ */ Ln().mark(function b() {
          var E, S, _, k, T;
          return Ln().wrap(function(R) {
            for (; ; )
              switch (R.prev = R.next) {
                case 0:
                  if (R.t0 = i.query().velocity === 0, R.t0) {
                    R.next = 6;
                    break;
                  }
                  return R.next = 4, o.getPaused();
                case 4:
                  R.t1 = R.sent, R.t0 = R.t1 === !0;
                case 6:
                  if (!R.t0) {
                    R.next = 8;
                    break;
                  }
                  return R.abrupt("return");
                case 8:
                  return R.t2 = i.query().position, R.next = 11, o.getCurrentTime();
                case 11:
                  if (R.t3 = R.sent, E = R.t2 - R.t3, S = Math.abs(E), s.log("Drift: ".concat(E)), !(S > u)) {
                    R.next = 22;
                    break;
                  }
                  return R.next = 18, s.adjustSpeed(o, 0);
                case 18:
                  o.setCurrentTime(i.query().position), s.log("Resync by currentTime"), R.next = 29;
                  break;
                case 22:
                  if (!(S > l)) {
                    R.next = 29;
                    break;
                  }
                  return _ = S / p, k = f, T = _ < k ? (k - _) / 2 : k, R.next = 28, s.adjustSpeed(o, T * Math.sign(E));
                case 28:
                  s.log("Resync by playbackRate");
                case 29:
                case "end":
                  return R.stop();
              }
          }, b);
        }));
        return function() {
          return y.apply(this, arguments);
        };
      }(), v = setInterval(function() {
        return g();
      }, m);
      return {
        cancel: function() {
          return clearInterval(v);
        }
      };
    }
    /**
     * @param {string} msg
     */
  }, {
    key: "log",
    value: function(i) {
      var o;
      (o = this.logger) === null || o === void 0 || o.call(this, "TimingSrcConnector: ".concat(i));
    }
  }, {
    key: "waitForTOReadyState",
    value: (
      /**
       * @param {TimingObject} timingObject
       * @param {TConnectionState} state
       * @return {Promise<void>}
       */
      function(i, o) {
        return new Promise(function(a) {
          var s = function l() {
            i.readyState === o ? a() : i.addEventListener("readystatechange", l, {
              once: !0
            });
          };
          s();
        });
      }
    )
  }]), n;
}(/* @__PURE__ */ D0(EventTarget)), rs = /* @__PURE__ */ new WeakMap(), Rg = /* @__PURE__ */ new WeakMap(), Qn = {}, xw = /* @__PURE__ */ function() {
  function e(t) {
    var n = this, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (A7(this, e), window.jQuery && t instanceof jQuery && (t.length > 1 && window.console && console.warn && console.warn("A jQuery object with multiple elements was passed, using the first element."), t = t[0]), typeof document < "u" && typeof t == "string" && (t = document.getElementById(t)), !vce(t))
      throw new TypeError("You must pass either a valid element or a valid id.");
    if (t.nodeName !== "IFRAME") {
      var i = t.querySelector("iframe");
      i && (t = i);
    }
    if (t.nodeName === "IFRAME" && !_a(t.getAttribute("src") || ""))
      throw new Error("The player element passed isn’t a Vimeo embed.");
    if (rs.has(t))
      return rs.get(t);
    this._window = t.ownerDocument.defaultView, this.element = t, this.origin = "*";
    var o = new Ar(function(s, l) {
      if (n._onMessage = function(f) {
        if (!(!_a(f.origin) || n.element.contentWindow !== f.source)) {
          n.origin === "*" && (n.origin = f.origin);
          var p = rp(f.data), m = p && p.event === "error", g = m && p.data && p.data.method === "ready";
          if (g) {
            var v = new Error(p.data.message);
            v.name = p.data.name, l(v);
            return;
          }
          var y = p && p.event === "ready", b = p && p.method === "ping";
          if (y || b) {
            n.element.setAttribute("data-ready", "true"), s();
            return;
          }
          _ce(n, p);
        }
      }, n._window.addEventListener("message", n._onMessage), n.element.nodeName !== "IFRAME") {
        var u = $7(t, r), d = N7(u);
        L7(d, u, t).then(function(f) {
          var p = bw(f, t);
          return n.element = p, n._originalElement = t, Sce(t, p), rs.set(n.element, n), f;
        }).catch(l);
      }
    });
    if (Rg.set(this, o), rs.set(this.element, this), this.element.nodeName === "IFRAME" && na(this, "ping"), Qn.isEnabled) {
      var a = function() {
        return Qn.exit();
      };
      this.fullscreenchangeHandler = function() {
        Qn.isFullscreen ? Rl(n, "event:exitFullscreen", a) : Vf(n, "event:exitFullscreen", a), n.ready().then(function() {
          na(n, "fullscreenchange", Qn.isFullscreen);
        });
      }, Qn.on("fullscreenchange", this.fullscreenchangeHandler);
    }
    return this;
  }
  return M7(e, [{
    key: "callMethod",
    value: function(n) {
      var r = this, i = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return new Ar(function(o, a) {
        return r.ready().then(function() {
          Rl(r, n, {
            resolve: o,
            reject: a
          }), na(r, n, i);
        }).catch(a);
      });
    }
    /**
     * Get a promise for the value of a player property.
     *
     * @param {string} name The property name
     * @return {Promise}
     */
  }, {
    key: "get",
    value: function(n) {
      var r = this;
      return new Ar(function(i, o) {
        return n = VC(n, "get"), r.ready().then(function() {
          Rl(r, n, {
            resolve: i,
            reject: o
          }), na(r, n);
        }).catch(o);
      });
    }
    /**
     * Get a promise for setting the value of a player property.
     *
     * @param {string} name The API method to call.
     * @param {mixed} value The value to set.
     * @return {Promise}
     */
  }, {
    key: "set",
    value: function(n, r) {
      var i = this;
      return new Ar(function(o, a) {
        if (n = VC(n, "set"), r == null)
          throw new TypeError("There must be a value to set.");
        return i.ready().then(function() {
          Rl(i, n, {
            resolve: o,
            reject: a
          }), na(i, n, r);
        }).catch(a);
      });
    }
    /**
     * Add an event listener for the specified event. Will call the
     * callback with a single parameter, `data`, that contains the data for
     * that event.
     *
     * @param {string} eventName The name of the event.
     * @param {function(*)} callback The function to call when the event fires.
     * @return {void}
     */
  }, {
    key: "on",
    value: function(n, r) {
      if (!n)
        throw new TypeError("You must pass an event name.");
      if (!r)
        throw new TypeError("You must pass a callback function.");
      if (typeof r != "function")
        throw new TypeError("The callback must be a function.");
      var i = zf(this, "event:".concat(n));
      i.length === 0 && this.callMethod("addEventListener", n).catch(function() {
      }), Rl(this, "event:".concat(n), r);
    }
    /**
     * Remove an event listener for the specified event. Will remove all
     * listeners for that event if a `callback` isn’t passed, or only that
     * specific callback if it is passed.
     *
     * @param {string} eventName The name of the event.
     * @param {function} [callback] The specific callback to remove.
     * @return {void}
     */
  }, {
    key: "off",
    value: function(n, r) {
      if (!n)
        throw new TypeError("You must pass an event name.");
      if (r && typeof r != "function")
        throw new TypeError("The callback must be a function.");
      var i = Vf(this, "event:".concat(n), r);
      i && this.callMethod("removeEventListener", n).catch(function(o) {
      });
    }
    /**
     * A promise to load a new video.
     *
     * @promise LoadVideoPromise
     * @fulfill {number} The video with this id or url successfully loaded.
     * @reject {TypeError} The id was not a number.
     */
    /**
     * Load a new video into this embed. The promise will be resolved if
     * the video is successfully loaded, or it will be rejected if it could
     * not be loaded.
     *
     * @param {number|string|object} options The id of the video, the url of the video, or an object with embed options.
     * @return {LoadVideoPromise}
     */
  }, {
    key: "loadVideo",
    value: function(n) {
      return this.callMethod("loadVideo", n);
    }
    /**
     * A promise to perform an action when the Player is ready.
     *
     * @todo document errors
     * @promise LoadVideoPromise
     * @fulfill {void}
     */
    /**
     * Trigger a function when the player iframe has initialized. You do not
     * need to wait for `ready` to trigger to begin adding event listeners
     * or calling other methods.
     *
     * @return {ReadyPromise}
     */
  }, {
    key: "ready",
    value: function() {
      var n = Rg.get(this) || new Ar(function(r, i) {
        i(new Error("Unknown player. Probably unloaded."));
      });
      return Ar.resolve(n);
    }
    /**
     * A promise to add a cue point to the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point to use for removeCuePoint.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Add a cue point to the player.
     *
     * @param {number} time The time for the cue point.
     * @param {object} [data] Arbitrary data to be returned with the cue point.
     * @return {AddCuePointPromise}
     */
  }, {
    key: "addCuePoint",
    value: function(n) {
      var r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
      return this.callMethod("addCuePoint", {
        time: n,
        data: r
      });
    }
    /**
     * A promise to remove a cue point from the player.
     *
     * @promise AddCuePointPromise
     * @fulfill {string} The id of the cue point that was removed.
     * @reject {InvalidCuePoint} The cue point with the specified id was not
     *         found.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Remove a cue point from the video.
     *
     * @param {string} id The id of the cue point to remove.
     * @return {RemoveCuePointPromise}
     */
  }, {
    key: "removeCuePoint",
    value: function(n) {
      return this.callMethod("removeCuePoint", n);
    }
    /**
     * A representation of a text track on a video.
     *
     * @typedef {Object} VimeoTextTrack
     * @property {string} language The ISO language code.
     * @property {string} kind The kind of track it is (captions or subtitles).
     * @property {string} label The human‐readable label for the track.
     */
    /**
     * A promise to enable a text track.
     *
     * @promise EnableTextTrackPromise
     * @fulfill {VimeoTextTrack} The text track that was enabled.
     * @reject {InvalidTrackLanguageError} No track was available with the
     *         specified language.
     * @reject {InvalidTrackError} No track was available with the specified
     *         language and kind.
     */
    /**
     * Enable the text track with the specified language, and optionally the
     * specified kind (captions or subtitles).
     *
     * When set via the API, the track language will not change the viewer’s
     * stored preference.
     *
     * @param {string} language The two‐letter language code.
     * @param {string} [kind] The kind of track to enable (captions or subtitles).
     * @return {EnableTextTrackPromise}
     */
  }, {
    key: "enableTextTrack",
    value: function(n, r) {
      if (!n)
        throw new TypeError("You must pass a language.");
      return this.callMethod("enableTextTrack", {
        language: n,
        kind: r
      });
    }
    /**
     * A promise to disable the active text track.
     *
     * @promise DisableTextTrackPromise
     * @fulfill {void} The track was disabled.
     */
    /**
     * Disable the currently-active text track.
     *
     * @return {DisableTextTrackPromise}
     */
  }, {
    key: "disableTextTrack",
    value: function() {
      return this.callMethod("disableTextTrack");
    }
    /**
     * A promise to pause the video.
     *
     * @promise PausePromise
     * @fulfill {void} The video was paused.
     */
    /**
     * Pause the video if it’s playing.
     *
     * @return {PausePromise}
     */
  }, {
    key: "pause",
    value: function() {
      return this.callMethod("pause");
    }
    /**
     * A promise to play the video.
     *
     * @promise PlayPromise
     * @fulfill {void} The video was played.
     */
    /**
     * Play the video if it’s paused. **Note:** on iOS and some other
     * mobile devices, you cannot programmatically trigger play. Once the
     * viewer has tapped on the play button in the player, however, you
     * will be able to use this function.
     *
     * @return {PlayPromise}
     */
  }, {
    key: "play",
    value: function() {
      return this.callMethod("play");
    }
    /**
     * Request that the player enters fullscreen.
     * @return {Promise}
     */
  }, {
    key: "requestFullscreen",
    value: function() {
      return Qn.isEnabled ? Qn.request(this.element) : this.callMethod("requestFullscreen");
    }
    /**
     * Request that the player exits fullscreen.
     * @return {Promise}
     */
  }, {
    key: "exitFullscreen",
    value: function() {
      return Qn.isEnabled ? Qn.exit() : this.callMethod("exitFullscreen");
    }
    /**
     * Returns true if the player is currently fullscreen.
     * @return {Promise}
     */
  }, {
    key: "getFullscreen",
    value: function() {
      return Qn.isEnabled ? Ar.resolve(Qn.isFullscreen) : this.get("fullscreen");
    }
    /**
     * Request that the player enters picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "requestPictureInPicture",
    value: function() {
      return this.callMethod("requestPictureInPicture");
    }
    /**
     * Request that the player exits picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "exitPictureInPicture",
    value: function() {
      return this.callMethod("exitPictureInPicture");
    }
    /**
     * Returns true if the player is currently picture-in-picture.
     * @return {Promise}
     */
  }, {
    key: "getPictureInPicture",
    value: function() {
      return this.get("pictureInPicture");
    }
    /**
     * A promise to prompt the viewer to initiate remote playback.
     *
     * @promise RemotePlaybackPromptPromise
     * @fulfill {void}
     * @reject {NotFoundError} No remote playback device is available.
     */
    /**
     * Request to prompt the user to initiate remote playback.
     *
     * @return {RemotePlaybackPromptPromise}
     */
  }, {
    key: "remotePlaybackPrompt",
    value: function() {
      return this.callMethod("remotePlaybackPrompt");
    }
    /**
     * A promise to unload the video.
     *
     * @promise UnloadPromise
     * @fulfill {void} The video was unloaded.
     */
    /**
     * Return the player to its initial state.
     *
     * @return {UnloadPromise}
     */
  }, {
    key: "unload",
    value: function() {
      return this.callMethod("unload");
    }
    /**
     * Cleanup the player and remove it from the DOM
     *
     * It won't be usable and a new one should be constructed
     *  in order to do any operations.
     *
     * @return {Promise}
     */
  }, {
    key: "destroy",
    value: function() {
      var n = this;
      return new Ar(function(r) {
        if (Rg.delete(n), rs.delete(n.element), n._originalElement && (rs.delete(n._originalElement), n._originalElement.removeAttribute("data-vimeo-initialized")), n.element && n.element.nodeName === "IFRAME" && n.element.parentNode && (n.element.parentNode.parentNode && n._originalElement && n._originalElement !== n.element.parentNode ? n.element.parentNode.parentNode.removeChild(n.element.parentNode) : n.element.parentNode.removeChild(n.element)), n.element && n.element.nodeName === "DIV" && n.element.parentNode) {
          n.element.removeAttribute("data-vimeo-initialized");
          var i = n.element.querySelector("iframe");
          i && i.parentNode && (i.parentNode.parentNode && n._originalElement && n._originalElement !== i.parentNode ? i.parentNode.parentNode.removeChild(i.parentNode) : i.parentNode.removeChild(i));
        }
        n._window.removeEventListener("message", n._onMessage), Qn.isEnabled && Qn.off("fullscreenchange", n.fullscreenchangeHandler), r();
      });
    }
    /**
     * A promise to get the autopause behavior of the video.
     *
     * @promise GetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */
    /**
     * Get the autopause behavior for this player.
     *
     * @return {GetAutopausePromise}
     */
  }, {
    key: "getAutopause",
    value: function() {
      return this.get("autopause");
    }
    /**
     * A promise to set the autopause behavior of the video.
     *
     * @promise SetAutopausePromise
     * @fulfill {boolean} Whether autopause is turned on or off.
     * @reject {UnsupportedError} Autopause is not supported with the current
     *         player or browser.
     */
    /**
     * Enable or disable the autopause behavior of this player.
     *
     * By default, when another video is played in the same browser, this
     * player will automatically pause. Unless you have a specific reason
     * for doing so, we recommend that you leave autopause set to the
     * default (`true`).
     *
     * @param {boolean} autopause
     * @return {SetAutopausePromise}
     */
  }, {
    key: "setAutopause",
    value: function(n) {
      return this.set("autopause", n);
    }
    /**
     * A promise to get the buffered property of the video.
     *
     * @promise GetBufferedPromise
     * @fulfill {Array} Buffered Timeranges converted to an Array.
     */
    /**
     * Get the buffered property of the video.
     *
     * @return {GetBufferedPromise}
     */
  }, {
    key: "getBuffered",
    value: function() {
      return this.get("buffered");
    }
    /**
     * @typedef {Object} CameraProperties
     * @prop {number} props.yaw - Number between 0 and 360.
     * @prop {number} props.pitch - Number between -90 and 90.
     * @prop {number} props.roll - Number between -180 and 180.
     * @prop {number} props.fov - The field of view in degrees.
     */
    /**
     * A promise to get the camera properties of the player.
     *
     * @promise GetCameraPromise
     * @fulfill {CameraProperties} The camera properties.
     */
    /**
     * For 360° videos get the camera properties for this player.
     *
     * @return {GetCameraPromise}
     */
  }, {
    key: "getCameraProps",
    value: function() {
      return this.get("cameraProps");
    }
    /**
     * A promise to set the camera properties of the player.
     *
     * @promise SetCameraPromise
     * @fulfill {Object} The camera was successfully set.
     * @reject {RangeError} The range was out of bounds.
     */
    /**
     * For 360° videos set the camera properties for this player.
     *
     * @param {CameraProperties} camera The camera properties
     * @return {SetCameraPromise}
     */
  }, {
    key: "setCameraProps",
    value: function(n) {
      return this.set("cameraProps", n);
    }
    /**
     * A representation of a chapter.
     *
     * @typedef {Object} VimeoChapter
     * @property {number} startTime The start time of the chapter.
     * @property {object} title The title of the chapter.
     * @property {number} index The place in the order of Chapters. Starts at 1.
     */
    /**
     * A promise to get chapters for the video.
     *
     * @promise GetChaptersPromise
     * @fulfill {VimeoChapter[]} The chapters for the video.
     */
    /**
     * Get an array of all the chapters for the video.
     *
     * @return {GetChaptersPromise}
     */
  }, {
    key: "getChapters",
    value: function() {
      return this.get("chapters");
    }
    /**
     * A promise to get the currently active chapter.
     *
     * @promise GetCurrentChaptersPromise
     * @fulfill {VimeoChapter|undefined} The current chapter for the video.
     */
    /**
     * Get the currently active chapter for the video.
     *
     * @return {GetCurrentChaptersPromise}
     */
  }, {
    key: "getCurrentChapter",
    value: function() {
      return this.get("currentChapter");
    }
    /**
     * A promise to get the accent color of the player.
     *
     * @promise GetColorPromise
     * @fulfill {string} The hex color of the player.
     */
    /**
     * Get the accent color for this player. Note this is deprecated in place of `getColorTwo`.
     *
     * @return {GetColorPromise}
     */
  }, {
    key: "getColor",
    value: function() {
      return this.get("color");
    }
    /**
     * A promise to get all colors for the player in an array.
     *
     * @promise GetColorsPromise
     * @fulfill {string[]} The hex colors of the player.
     */
    /**
     * Get all the colors for this player in an array: [colorOne, colorTwo, colorThree, colorFour]
     *
     * @return {GetColorPromise}
     */
  }, {
    key: "getColors",
    value: function() {
      return Ar.all([this.get("colorOne"), this.get("colorTwo"), this.get("colorThree"), this.get("colorFour")]);
    }
    /**
     * A promise to set the accent color of the player.
     *
     * @promise SetColorPromise
     * @fulfill {string} The color was successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */
    /**
     * Set the accent color of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     * Note this is deprecated in place of `setColorTwo`.
     *
     * @param {string} color The hex or rgb color string to set.
     * @return {SetColorPromise}
     */
  }, {
    key: "setColor",
    value: function(n) {
      return this.set("color", n);
    }
    /**
     * A promise to set all colors for the player.
     *
     * @promise SetColorsPromise
     * @fulfill {string[]} The colors were successfully set.
     * @reject {TypeError} The string was not a valid hex or rgb color.
     * @reject {ContrastError} The color was set, but the contrast is
     *         outside of the acceptable range.
     * @reject {EmbedSettingsError} The owner of the player has chosen to
     *         use a specific color.
     */
    /**
     * Set the colors of this player to a hex or rgb string. Setting the
     * color may fail if the owner of the video has set their embed
     * preferences to force a specific color.
     * The colors should be passed in as an array: [colorOne, colorTwo, colorThree, colorFour].
     * If a color should not be set, the index in the array can be left as null.
     *
     * @param {string[]} colors Array of the hex or rgb color strings to set.
     * @return {SetColorsPromise}
     */
  }, {
    key: "setColors",
    value: function(n) {
      if (!Array.isArray(n))
        return new Ar(function(o, a) {
          return a(new TypeError("Argument must be an array."));
        });
      var r = new Ar(function(o) {
        return o(null);
      }), i = [n[0] ? this.set("colorOne", n[0]) : r, n[1] ? this.set("colorTwo", n[1]) : r, n[2] ? this.set("colorThree", n[2]) : r, n[3] ? this.set("colorFour", n[3]) : r];
      return Ar.all(i);
    }
    /**
     * A representation of a cue point.
     *
     * @typedef {Object} VimeoCuePoint
     * @property {number} time The time of the cue point.
     * @property {object} data The data passed when adding the cue point.
     * @property {string} id The unique id for use with removeCuePoint.
     */
    /**
     * A promise to get the cue points of a video.
     *
     * @promise GetCuePointsPromise
     * @fulfill {VimeoCuePoint[]} The cue points added to the video.
     * @reject {UnsupportedError} Cue points are not supported with the current
     *         player or browser.
     */
    /**
     * Get an array of the cue points added to the video.
     *
     * @return {GetCuePointsPromise}
     */
  }, {
    key: "getCuePoints",
    value: function() {
      return this.get("cuePoints");
    }
    /**
     * A promise to get the current time of the video.
     *
     * @promise GetCurrentTimePromise
     * @fulfill {number} The current time in seconds.
     */
    /**
     * Get the current playback position in seconds.
     *
     * @return {GetCurrentTimePromise}
     */
  }, {
    key: "getCurrentTime",
    value: function() {
      return this.get("currentTime");
    }
    /**
     * A promise to set the current time of the video.
     *
     * @promise SetCurrentTimePromise
     * @fulfill {number} The actual current time that was set.
     * @reject {RangeError} the time was less than 0 or greater than the
     *         video’s duration.
     */
    /**
     * Set the current playback position in seconds. If the player was
     * paused, it will remain paused. Likewise, if the player was playing,
     * it will resume playing once the video has buffered.
     *
     * You can provide an accurate time and the player will attempt to seek
     * to as close to that time as possible. The exact time will be the
     * fulfilled value of the promise.
     *
     * @param {number} currentTime
     * @return {SetCurrentTimePromise}
     */
  }, {
    key: "setCurrentTime",
    value: function(n) {
      return this.set("currentTime", n);
    }
    /**
     * A promise to get the duration of the video.
     *
     * @promise GetDurationPromise
     * @fulfill {number} The duration in seconds.
     */
    /**
     * Get the duration of the video in seconds. It will be rounded to the
     * nearest second before playback begins, and to the nearest thousandth
     * of a second after playback begins.
     *
     * @return {GetDurationPromise}
     */
  }, {
    key: "getDuration",
    value: function() {
      return this.get("duration");
    }
    /**
     * A promise to get the ended state of the video.
     *
     * @promise GetEndedPromise
     * @fulfill {boolean} Whether or not the video has ended.
     */
    /**
     * Get the ended state of the video. The video has ended if
     * `currentTime === duration`.
     *
     * @return {GetEndedPromise}
     */
  }, {
    key: "getEnded",
    value: function() {
      return this.get("ended");
    }
    /**
     * A promise to get the loop state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the player is set to loop.
     */
    /**
     * Get the loop state of the player.
     *
     * @return {GetLoopPromise}
     */
  }, {
    key: "getLoop",
    value: function() {
      return this.get("loop");
    }
    /**
     * A promise to set the loop state of the player.
     *
     * @promise SetLoopPromise
     * @fulfill {boolean} The loop state that was set.
     */
    /**
     * Set the loop state of the player. When set to `true`, the player
     * will start over immediately once playback ends.
     *
     * @param {boolean} loop
     * @return {SetLoopPromise}
     */
  }, {
    key: "setLoop",
    value: function(n) {
      return this.set("loop", n);
    }
    /**
     * A promise to set the muted state of the player.
     *
     * @promise SetMutedPromise
     * @fulfill {boolean} The muted state that was set.
     */
    /**
     * Set the muted state of the player. When set to `true`, the player
     * volume will be muted.
     *
     * @param {boolean} muted
     * @return {SetMutedPromise}
     */
  }, {
    key: "setMuted",
    value: function(n) {
      return this.set("muted", n);
    }
    /**
     * A promise to get the muted state of the player.
     *
     * @promise GetMutedPromise
     * @fulfill {boolean} Whether or not the player is muted.
     */
    /**
     * Get the muted state of the player.
     *
     * @return {GetMutedPromise}
     */
  }, {
    key: "getMuted",
    value: function() {
      return this.get("muted");
    }
    /**
     * A promise to get the paused state of the player.
     *
     * @promise GetLoopPromise
     * @fulfill {boolean} Whether or not the video is paused.
     */
    /**
     * Get the paused state of the player.
     *
     * @return {GetLoopPromise}
     */
  }, {
    key: "getPaused",
    value: function() {
      return this.get("paused");
    }
    /**
     * A promise to get the playback rate of the player.
     *
     * @promise GetPlaybackRatePromise
     * @fulfill {number} The playback rate of the player on a scale from 0 to 2.
     */
    /**
     * Get the playback rate of the player on a scale from `0` to `2`.
     *
     * @return {GetPlaybackRatePromise}
     */
  }, {
    key: "getPlaybackRate",
    value: function() {
      return this.get("playbackRate");
    }
    /**
     * A promise to set the playbackrate of the player.
     *
     * @promise SetPlaybackRatePromise
     * @fulfill {number} The playback rate was set.
     * @reject {RangeError} The playback rate was less than 0 or greater than 2.
     */
    /**
     * Set the playback rate of the player on a scale from `0` to `2`. When set
     * via the API, the playback rate will not be synchronized to other
     * players or stored as the viewer's preference.
     *
     * @param {number} playbackRate
     * @return {SetPlaybackRatePromise}
     */
  }, {
    key: "setPlaybackRate",
    value: function(n) {
      return this.set("playbackRate", n);
    }
    /**
     * A promise to get the played property of the video.
     *
     * @promise GetPlayedPromise
     * @fulfill {Array} Played Timeranges converted to an Array.
     */
    /**
     * Get the played property of the video.
     *
     * @return {GetPlayedPromise}
     */
  }, {
    key: "getPlayed",
    value: function() {
      return this.get("played");
    }
    /**
     * A promise to get the qualities available of the current video.
     *
     * @promise GetQualitiesPromise
     * @fulfill {Array} The qualities of the video.
     */
    /**
     * Get the qualities of the current video.
     *
     * @return {GetQualitiesPromise}
     */
  }, {
    key: "getQualities",
    value: function() {
      return this.get("qualities");
    }
    /**
     * A promise to get the current set quality of the video.
     *
     * @promise GetQualityPromise
     * @fulfill {string} The current set quality.
     */
    /**
     * Get the current set quality of the video.
     *
     * @return {GetQualityPromise}
     */
  }, {
    key: "getQuality",
    value: function() {
      return this.get("quality");
    }
    /**
     * A promise to set the video quality.
     *
     * @promise SetQualityPromise
     * @fulfill {number} The quality was set.
     * @reject {RangeError} The quality is not available.
     */
    /**
     * Set a video quality.
     *
     * @param {string} quality
     * @return {SetQualityPromise}
     */
  }, {
    key: "setQuality",
    value: function(n) {
      return this.set("quality", n);
    }
    /**
     * A promise to get the remote playback availability.
     *
     * @promise RemotePlaybackAvailabilityPromise
     * @fulfill {boolean} Whether remote playback is available.
     */
    /**
     * Get the availability of remote playback.
     *
     * @return {RemotePlaybackAvailabilityPromise}
     */
  }, {
    key: "getRemotePlaybackAvailability",
    value: function() {
      return this.get("remotePlaybackAvailability");
    }
    /**
     * A promise to get the current remote playback state.
     *
     * @promise RemotePlaybackStatePromise
     * @fulfill {string} The state of the remote playback: connecting, connected, or disconnected.
     */
    /**
     * Get the current remote playback state.
     *
     * @return {RemotePlaybackStatePromise}
     */
  }, {
    key: "getRemotePlaybackState",
    value: function() {
      return this.get("remotePlaybackState");
    }
    /**
     * A promise to get the seekable property of the video.
     *
     * @promise GetSeekablePromise
     * @fulfill {Array} Seekable Timeranges converted to an Array.
     */
    /**
     * Get the seekable property of the video.
     *
     * @return {GetSeekablePromise}
     */
  }, {
    key: "getSeekable",
    value: function() {
      return this.get("seekable");
    }
    /**
     * A promise to get the seeking property of the player.
     *
     * @promise GetSeekingPromise
     * @fulfill {boolean} Whether or not the player is currently seeking.
     */
    /**
     * Get if the player is currently seeking.
     *
     * @return {GetSeekingPromise}
     */
  }, {
    key: "getSeeking",
    value: function() {
      return this.get("seeking");
    }
    /**
     * A promise to get the text tracks of a video.
     *
     * @promise GetTextTracksPromise
     * @fulfill {VimeoTextTrack[]} The text tracks associated with the video.
     */
    /**
     * Get an array of the text tracks that exist for the video.
     *
     * @return {GetTextTracksPromise}
     */
  }, {
    key: "getTextTracks",
    value: function() {
      return this.get("textTracks");
    }
    /**
     * A promise to get the embed code for the video.
     *
     * @promise GetVideoEmbedCodePromise
     * @fulfill {string} The `<iframe>` embed code for the video.
     */
    /**
     * Get the `<iframe>` embed code for the video.
     *
     * @return {GetVideoEmbedCodePromise}
     */
  }, {
    key: "getVideoEmbedCode",
    value: function() {
      return this.get("videoEmbedCode");
    }
    /**
     * A promise to get the id of the video.
     *
     * @promise GetVideoIdPromise
     * @fulfill {number} The id of the video.
     */
    /**
     * Get the id of the video.
     *
     * @return {GetVideoIdPromise}
     */
  }, {
    key: "getVideoId",
    value: function() {
      return this.get("videoId");
    }
    /**
     * A promise to get the title of the video.
     *
     * @promise GetVideoTitlePromise
     * @fulfill {number} The title of the video.
     */
    /**
     * Get the title of the video.
     *
     * @return {GetVideoTitlePromise}
     */
  }, {
    key: "getVideoTitle",
    value: function() {
      return this.get("videoTitle");
    }
    /**
     * A promise to get the native width of the video.
     *
     * @promise GetVideoWidthPromise
     * @fulfill {number} The native width of the video.
     */
    /**
     * Get the native width of the currently‐playing video. The width of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoWidthPromise}
     */
  }, {
    key: "getVideoWidth",
    value: function() {
      return this.get("videoWidth");
    }
    /**
     * A promise to get the native height of the video.
     *
     * @promise GetVideoHeightPromise
     * @fulfill {number} The native height of the video.
     */
    /**
     * Get the native height of the currently‐playing video. The height of
     * the highest‐resolution available will be used before playback begins.
     *
     * @return {GetVideoHeightPromise}
     */
  }, {
    key: "getVideoHeight",
    value: function() {
      return this.get("videoHeight");
    }
    /**
     * A promise to get the vimeo.com url for the video.
     *
     * @promise GetVideoUrlPromise
     * @fulfill {number} The vimeo.com url for the video.
     * @reject {PrivacyError} The url isn’t available because of the video’s privacy setting.
     */
    /**
     * Get the vimeo.com url for the video.
     *
     * @return {GetVideoUrlPromise}
     */
  }, {
    key: "getVideoUrl",
    value: function() {
      return this.get("videoUrl");
    }
    /**
     * A promise to get the volume level of the player.
     *
     * @promise GetVolumePromise
     * @fulfill {number} The volume level of the player on a scale from 0 to 1.
     */
    /**
     * Get the current volume level of the player on a scale from `0` to `1`.
     *
     * Most mobile devices do not support an independent volume from the
     * system volume. In those cases, this method will always return `1`.
     *
     * @return {GetVolumePromise}
     */
  }, {
    key: "getVolume",
    value: function() {
      return this.get("volume");
    }
    /**
     * A promise to set the volume level of the player.
     *
     * @promise SetVolumePromise
     * @fulfill {number} The volume was set.
     * @reject {RangeError} The volume was less than 0 or greater than 1.
     */
    /**
     * Set the volume of the player on a scale from `0` to `1`. When set
     * via the API, the volume level will not be synchronized to other
     * players or stored as the viewer’s preference.
     *
     * Most mobile devices do not support setting the volume. An error will
     * *not* be triggered in that situation.
     *
     * @param {number} volume
     * @return {SetVolumePromise}
     */
  }, {
    key: "setVolume",
    value: function(n) {
      return this.set("volume", n);
    }
    /** @typedef {import('./lib/timing-object.types').TimingObject} TimingObject */
    /** @typedef {import('./lib/timing-src-connector.types').TimingSrcConnectorOptions} TimingSrcConnectorOptions */
    /** @typedef {import('./lib/timing-src-connector').TimingSrcConnector} TimingSrcConnector */
    /**
     * Connects a TimingObject to the video player (https://webtiming.github.io/timingobject/)
     *
     * @param {TimingObject} timingObject
     * @param {TimingSrcConnectorOptions} options
     *
     * @return {Promise<TimingSrcConnector>}
     */
  }, {
    key: "setTimingSrc",
    value: function() {
      var t = aa(/* @__PURE__ */ Ln().mark(function r(i, o) {
        var a = this, s;
        return Ln().wrap(function(u) {
          for (; ; )
            switch (u.prev = u.next) {
              case 0:
                if (i) {
                  u.next = 2;
                  break;
                }
                throw new TypeError("A Timing Object must be provided.");
              case 2:
                return u.next = 4, this.ready();
              case 4:
                return s = new Ice(this, i, o), na(this, "notifyTimingObjectConnect"), s.addEventListener("disconnect", function() {
                  return na(a, "notifyTimingObjectDisconnect");
                }), u.abrupt("return", s);
              case 8:
              case "end":
                return u.stop();
            }
        }, r, this);
      }));
      function n(r, i) {
        return t.apply(this, arguments);
      }
      return n;
    }()
  }]), e;
}();
I7 || (Qn = Oce(), kce(), Tce(), Ace(), Mce());
function Dce(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, N0(e, t);
}
function N0(e, t) {
  return N0 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(n, r) {
    return n.__proto__ = r, n;
  }, N0(e, t);
}
var jC = {
  play: "onPlay",
  playing: "onPlaying",
  pause: "onPause",
  ended: "onEnd",
  timeupdate: "onTimeUpdate",
  progress: "onProgress",
  seeked: "onSeeked",
  texttrackchange: "onTextTrackChange",
  cuechange: "onCueChange",
  cuepoint: "onCuePoint",
  volumechange: "onVolumeChange",
  playbackratechange: "onPlaybackRateChange",
  error: "onError",
  loaded: "onLoaded"
}, Ew = /* @__PURE__ */ function(e) {
  function t(r) {
    var i;
    return i = e.call(this, r) || this, i.refContainer = i.refContainer.bind(i), i;
  }
  Dce(t, e);
  var n = t.prototype;
  return n.componentDidMount = function() {
    this.createPlayer();
  }, n.componentDidUpdate = function(i) {
    var o = this, a = Object.keys(this.props).filter(function(s) {
      return o.props[s] !== i[s];
    });
    this.updateProps(a);
  }, n.componentWillUnmount = function() {
    this.player.destroy();
  }, n.getInitialOptions = function() {
    var i, o = this.props.video, a = /^https?:/i.test(o) ? "url" : "id";
    return i = {}, i[a] = o, i.width = this.props.width, i.height = this.props.height, i.autopause = this.props.autopause, i.autoplay = this.props.autoplay, i.byline = this.props.showByline, i.color = this.props.color, i.controls = this.props.controls, i.loop = this.props.loop, i.portrait = this.props.showPortrait, i.title = this.props.showTitle, i.muted = this.props.muted, i.background = this.props.background, i.responsive = this.props.responsive, i.dnt = this.props.dnt, i.speed = this.props.speed, i.keyboard = this.props.keyboard, i.pip = this.props.pip, i.playsinline = this.props.playsInline, i.quality = this.props.quality, i.texttrack = this.props.textTrack, i.transparent = this.props.transparent, i;
  }, n.updateProps = function(i) {
    var o = this, a = this.player;
    i.forEach(function(s) {
      var l = o.props[s];
      switch (s) {
        case "autopause":
          a.setAutopause(l);
          break;
        case "color":
          a.setColor(l);
          break;
        case "loop":
          a.setLoop(l);
          break;
        case "volume":
          a.setVolume(l);
          break;
        case "paused":
          a.getPaused().then(function(f) {
            return l && !f ? a.pause() : !l && f ? a.play() : null;
          });
          break;
        case "width":
        case "height":
          a.element[s] = l;
          break;
        case "video":
          if (l) {
            var u = o.props.start, d = a.loadVideo(l);
            typeof u == "number" && d.then(function() {
              a.setCurrentTime(u);
            });
          } else
            a.unload();
          break;
        case "playbackRate":
          a.setPlaybackRate(l);
          break;
        case "quality":
          a.setQuality(l);
          break;
      }
    });
  }, n.createPlayer = function() {
    var i = this, o = this.props, a = o.start, s = o.volume, l = o.playbackRate;
    this.player = new xw(this.container, this.getInitialOptions()), Object.keys(jC).forEach(function(p) {
      var m = jC[p];
      i.player.on(p, function(g) {
        var v = i.props[m];
        v && v(g);
      });
    });
    var u = this.props, d = u.onError, f = u.onReady;
    this.player.ready().then(function() {
      f && f(i.player);
    }, function(p) {
      if (d)
        d(p);
      else
        throw p;
    }), typeof a == "number" && this.player.setCurrentTime(a), typeof s == "number" && this.updateProps(["volume"]), typeof l == "number" && this.updateProps(["playbackRate"]);
  }, n.refContainer = function(i) {
    this.container = i;
  }, n.render = function() {
    var i = this.props, o = i.id, a = i.className, s = i.style;
    return /* @__PURE__ */ x.createElement("div", {
      id: o,
      className: a,
      style: s,
      ref: this.refContainer
    });
  }, t;
}(x.Component);
process.env.NODE_ENV !== "production" && (Ew.propTypes = {
  /**
   * A Vimeo video ID or URL.
   */
  video: _e.oneOfType([_e.number, _e.string]),
  /**
   * DOM ID for the player element.
   */
  id: _e.string,
  /**
   * CSS className for the player element.
   */
  className: _e.string,
  /**
   * Inline style for container element.
   */
  style: _e.object,
  // eslint-disable-line react/forbid-prop-types
  /**
   * Width of the player element.
   */
  width: _e.oneOfType([_e.number, _e.string]),
  /**
   * Height of the player element.
   */
  height: _e.oneOfType([_e.number, _e.string]),
  /**
   * Pause the video.
   */
  paused: _e.bool,
  // eslint-disable-line react/no-unused-prop-types
  /**
   * The playback volume as a number between 0 and 1.
   */
  volume: _e.number,
  /**
   * The time in seconds at which to start playing the video.
   */
  start: _e.number,
  // Player parameters
  /**
   * Pause this video automatically when another one plays.
   */
  autopause: _e.bool,
  /**
   * Automatically start playback of the video. Note that this won’t work on
   * some devices.
   */
  autoplay: _e.bool,
  /**
   * Show the byline on the video.
   */
  showByline: _e.bool,
  /**
   * Specify the color of the video controls. Colors may be overridden by the
   * embed settings of the video. _(Ex: "ef2f9f")_
   */
  color: _e.string,
  /**
   * Blocks the player from tracking any session data, including all cookies and analytics.
   */
  dnt: _e.bool,
  // Player controls
  /**
   * Hide all elements in the player, such as the progress bar, sharing buttons, etc.
   * (requires Vimeo PRO / Business account)
   */
  controls: _e.bool,
  /**
   * Play the video again when it reaches the end.
   */
  loop: _e.bool,
  /**
   * Show the portrait on the video.
   */
  showPortrait: _e.bool,
  /**
   * Show the title on the video.
   */
  showTitle: _e.bool,
  /**
   * Starts in a muted state to help with autoplay
   */
  muted: _e.bool,
  /**
   * Starts in a background state with no controls to help with autoplay
   */
  background: _e.bool,
  /**
   * Enable responsive mode and resize according to parent element (experimental)
   */
  responsive: _e.bool,
  /**
   * Specify playback rate (requires Vimeo PRO / Business account)
   */
  playbackRate: _e.number,
  /**
   * Enable playback rate controls (requires Vimeo PRO / Business account)
   */
  speed: _e.bool,
  /**
   * Allows for keyboard input to trigger player events.
   */
  keyboard: _e.bool,
  /**
   * Show the picture-in-picture button in the controlbar
   * and enable the picture-in-picture API.
   */
  pip: _e.bool,
  /**
   * Play video inline on mobile devices, to automatically
   * go fullscreen on playback set this parameter to false.
   */
  playsInline: _e.bool,
  /**
   * Vimeo Plus, PRO, and Business members can default
   * an embedded video to a specific quality on desktop.
   */
  quality: _e.string,
  /**
   * Turn captions/subtitles on for a specific language by default.
   */
  textTrack: _e.string,
  /**
   * The responsive player and transparent background are enabled
   * by default, to disable set this parameter to false.
   */
  transparent: _e.bool,
  // Events
  /* eslint-disable react/no-unused-prop-types */
  /**
   * Sent when the Vimeo player API has loaded.
   * Receives the Vimeo player object in the first parameter.
   */
  onReady: _e.func,
  /**
   * Sent when the player triggers an error.
   */
  onError: _e.func,
  /**
   * Triggered when video playback is initiated.
   */
  onPlay: _e.func,
  /**
   * Triggered when the video starts playing.
   */
  onPlaying: _e.func,
  /**
   * Triggered when the video pauses.
   */
  onPause: _e.func,
  /**
   * Triggered any time the video playback reaches the end.
   * Note: when `loop` is turned on, the ended event will not fire.
   */
  onEnd: _e.func,
  /**
   * Triggered as the `currentTime` of the video updates. It generally fires
   * every 250ms, but it may vary depending on the browser.
   */
  onTimeUpdate: _e.func,
  /**
   * Triggered as the video is loaded. Reports back the amount of the video
   * that has been buffered.
   */
  onProgress: _e.func,
  /**
   * Triggered when the player seeks to a specific time. An `onTimeUpdate`
   * event will also be fired at the same time.
   */
  onSeeked: _e.func,
  /**
   * Triggered when the active text track (captions/subtitles) changes. The
   * values will be `null` if text tracks are turned off.
   */
  onTextTrackChange: _e.func,
  /**
   * Triggered when the active cue for the current text track changes. It also
   * fires when the active text track changes. There may be multiple cues
   * active.
   */
  onCueChange: _e.func,
  /**
   * Triggered when the current time hits a registered cue point.
   */
  onCuePoint: _e.func,
  /**
   * Triggered when the volume in the player changes. Some devices do not
   * support setting the volume of the video independently from the system
   * volume, so this event will never fire on those devices.
   */
  onVolumeChange: _e.func,
  /**
   * Triggered when the playback rate changes.
   */
  onPlaybackRateChange: _e.func,
  /**
   * Triggered when a new video is loaded in the player.
   */
  onLoaded: _e.func
  /* eslint-enable react/no-unused-prop-types */
});
Ew.defaultProps = {
  autopause: !0,
  autoplay: !1,
  showByline: !0,
  controls: !0,
  loop: !1,
  showPortrait: !0,
  showTitle: !0,
  muted: !1,
  background: !1,
  responsive: !1,
  dnt: !1,
  speed: !1,
  keyboard: !0,
  pip: !1,
  playsInline: !0,
  transparent: !0
};
function F7({ className: e }) {
  return /* @__PURE__ */ x.createElement(
    "span",
    {
      className: ie(
        "ai-tw-absolute ai-tw-inset-0 ai-tw-flex ai-tw-items-center ai-tw-justify-center ai-tw-bg-tinted-grey-50",
        e
      )
    },
    /* @__PURE__ */ x.createElement("span", { className: "ai-tw-mr-2 ai-tw-leading-none ai-tw-text-content-primary" }, "Loading Video Source"),
    /* @__PURE__ */ x.createElement(jn, { size: "small" })
  );
}
function Nce({
  width: e,
  height: t,
  src: n,
  start: r,
  onPlayerReady: i
}) {
  const [o, a] = de(!0), { chatDispatch: s } = Me(At);
  return /* @__PURE__ */ x.createElement("div", { className: "ai-tw-relative" }, /* @__PURE__ */ x.createElement(
    "div",
    {
      style: {
        width: `${e}px`,
        height: `${t}px`
      }
    },
    /* @__PURE__ */ x.createElement(
      Ew,
      {
        width: `${e}px`,
        height: `${t}px`,
        video: n,
        start: r,
        onLoaded: () => a(!1),
        onPlay: () => s({ type: "videoStarted" }),
        onPause: () => {
          s({ type: "videoStopped" }), dC();
        },
        onReady: i,
        onEnd: () => {
          s({ type: "videoStopped" }), dC();
        }
      }
    )
  ), o && /* @__PURE__ */ x.createElement(F7, null));
}
function $ce({
  src: e,
  start: t,
  width: n,
  height: r,
  onPlayerReady: i
}) {
  const o = me(`yt-${I6()}`), s = new URL(e).searchParams.get("v"), l = me(n), u = me(r), [d, f] = de(), [p, m] = de(!0);
  return be(() => {
    d && d.setSize(n, r);
  }, [n, r, d]), be(() => {
    var b;
    const g = (E) => {
      i == null || i(E.target), f(E.target), m(!1);
    };
    let v;
    function y() {
      v = new window.YT.Player(o.current, {
        width: l.current,
        height: u.current,
        videoId: s,
        playerVars: {
          playsinline: 1,
          start: t
        },
        events: {
          onReady: g
        }
      });
    }
    if (window.YT)
      y();
    else {
      const E = document.createElement("script");
      E.src = "https://www.youtube.com/iframe_api";
      const S = document.getElementsByTagName("script")[0];
      (b = S.parentNode) == null || b.insertBefore(E, S), E.addEventListener("load", () => {
        if (window.YT.Player)
          y();
        else {
          let _ = 0;
          const k = window.setInterval(() => {
            if (_++, window.YT.Player) {
              window.clearInterval(k), y();
              return;
            }
            _ > 3 && window.clearInterval(k);
          }, 500);
        }
      });
    }
    return () => {
      v && v.destroy();
    };
  }, [s, t, i]), /* @__PURE__ */ x.createElement(
    "div",
    {
      className: "ai-tw-relative",
      style: { width: `${n}px`, height: `${r}px` }
    },
    /* @__PURE__ */ x.createElement("div", { id: o.current, "data-testid": o.current }),
    p && /* @__PURE__ */ x.createElement(F7, null)
  );
}
function Lce({
  sourceID: e,
  metadata: t
}) {
  const n = FT(t, e);
  return n ? Zle(n) : 0;
}
function Fce({ sourceID: e, src: t }) {
  const { sources: n, metadata: r } = Me(Bc) || {}, [i, o] = de(null), [a, s] = de(null), [l, u] = de(), [d, f] = de(0), [p, m] = de(0), { width: g } = Me(Xs) || {}, v = Lce({
    sourceID: e,
    metadata: r
  });
  function y(k) {
    k || (i && i.pause(), a && a.pauseVideo());
  }
  const b = n ? VT(n, e) : void 0, E = b ? rw(b) : null, S = b && $s(b) ? Yh(b) : null, _ = b && $s(b) ? ow(b) : null;
  return be(() => {
    const k = rce(), T = l != null && l.parentElement ? l.parentElement.clientWidth : 0, A = T / k;
    f(T), m(A);
  }, [l, g]), /* @__PURE__ */ x.createElement($P, { callback: y, threshold: 0.1 }, /* @__PURE__ */ x.createElement(
    "div",
    {
      ref: (k) => u(k || void 0),
      className: "ai-tw-my-6"
    },
    l && d && p ? /* @__PURE__ */ x.createElement(x.Fragment, null, S === "YouTube" ? /* @__PURE__ */ x.createElement(
      $ce,
      {
        src: t,
        start: v,
        width: d,
        height: p,
        onPlayerReady: s
      }
    ) : null, S && ["Brivity", "Our Place"].includes(S) ? /* @__PURE__ */ x.createElement(
      Nce,
      {
        width: d,
        height: p,
        src: t,
        start: v,
        onPlayerReady: o
      }
    ) : null, /* @__PURE__ */ x.createElement("div", { className: "ai-tw-mt-1 ai-tw-flex ai-tw-justify-between ai-tw-text-content-primary" }, /* @__PURE__ */ x.createElement(
      "p",
      {
        title: E || void 0,
        className: "ai-tw-line-clamp-2 ai-tw-flex-1 ai-tw-pr-4 ai-tw-subtitle-sm"
      },
      E
    ), /* @__PURE__ */ x.createElement("p", { className: "ai-tw-max-w-[50%] ai-tw-shrink-0 ai-tw-body-sm" }, R0(S), " ", _ ? Qh(_) : null))) : null
  ));
}
function zce({
  node: e,
  ...t
}) {
  const n = t.alt && !xg(t.alt) ? roe(t.alt) : null, r = t.alt && xg(t.alt) ? ioe(t.alt) : null;
  return t != null && t.alt && aoe(t.alt) ? n && t.src ? /* @__PURE__ */ x.createElement(
    Qle,
    {
      node: e,
      sourceID: n,
      src: t.src
    }
  ) : null : t.alt && xg(t.alt) ? r && t.src ? /* @__PURE__ */ x.createElement(
    nce,
    {
      node: e,
      citationID: r,
      src: t.src
    }
  ) : null : t.alt && ooe(t.alt) && n && t.src ? /* @__PURE__ */ x.createElement(Fce, { sourceID: n, src: t.src }) : null;
}
function Vce({
  className: e,
  ...t
}) {
  return /* @__PURE__ */ x.createElement(
    "a",
    {
      className: ie(
        "ai-tw-inline-flex ai-tw-h-[100px] ai-tw-w-[200px] ai-tw-shrink-0 ai-tw-flex-col ai-tw-rounded-lg ai-tw-bg-white ai-tw-body-sm hover:ai-tw-bg-stroke-primary active:ai-tw-bg-stroke-primary-dark",
        e
      ),
      ...t
    },
    t.children
  );
}
function Bce(e) {
  return e === "video_source" ? "video" : e;
}
function z7({
  id: e,
  title: t,
  url: n,
  className: r,
  modifiedAt: i,
  type: o,
  source: a
}) {
  const s = o === "source" ? R0(a) : `${R0(a)}: ${Bce(o)}`;
  return n ? /* @__PURE__ */ x.createElement(
    Vce,
    {
      href: n,
      target: "_blank",
      rel: "noreferrer",
      title: t,
      className: ie("ai-tw-px-3 ai-tw-py-2", r)
    },
    /* @__PURE__ */ x.createElement(
      "p",
      {
        className: ie(
          "ai-tw-line-clamp-3 ai-tw-text-content-primary ai-tw-body-sm"
        )
      },
      e,
      ": ",
      t
    ),
    /* @__PURE__ */ x.createElement("div", { className: "ai-tw-mt-auto ai-tw-text-[11px] ai-tw-text-content-primary-light ai-tw-body-sm" }, a ? /* @__PURE__ */ x.createElement("p", { className: "ai-tw-truncate ai-tw-uppercase" }, s) : /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-items-center" }, /* @__PURE__ */ x.createElement(Le, { icon: eL, className: "ai-tw-mr-1" }), /* @__PURE__ */ x.createElement("p", { className: "ai-tw-truncate ai-tw-uppercase" }, n)), i ? /* @__PURE__ */ x.createElement("p", null, Qh(i)) : null)
  ) : null;
}
const jce = l6, Wce = c6, Uce = u6, Hce = ty;
function Gce({
  children: e,
  ...t
}) {
  return /* @__PURE__ */ x.createElement(jce, { delayDuration: 300 }, /* @__PURE__ */ x.createElement(Wce, { asChild: !0 }, e), /* @__PURE__ */ x.createElement(Uce, null, /* @__PURE__ */ x.createElement(Hce, { className: "ai-tw-z-[5001]", side: "bottom" }, /* @__PURE__ */ x.createElement(
    mn.div,
    {
      initial: { y: 30, opacity: 0 },
      animate: { y: 0, opacity: 1 },
      transition: { duration: 0.2 }
    },
    /* @__PURE__ */ x.createElement(
      z7,
      {
        className: "ai-tw-box-border ai-tw-border ai-tw-border-stroke-primary ai-tw-no-underline ai-tw-shadow-lg [&_p]:ai-tw-m-0",
        ...t
      }
    )
  ))));
}
const $0 = x.forwardRef(
  ({ node: e, className: t, ...n }, r) => /* @__PURE__ */ x.createElement(
    "a",
    {
      ref: r,
      target: "_blank",
      rel: "noreferrer",
      className: ie("ai-tw-font-semibold ai-tw-text-blue-50", t),
      ...n
    }
  )
);
$0.displayName = "Link";
const Cw = x.forwardRef((e, t) => {
  const { sources: n } = Me(Bc) || {}, r = n && e.href ? uC(n, e.href) || n && e.id && uC(n, e.id) : null;
  return r ? /* @__PURE__ */ x.createElement(
    Gce,
    {
      id: k0(r),
      title: rw(r),
      url: iw(r),
      type: LT(r),
      modifiedAt: $s(r) ? ow(r) : null,
      source: $s(r) ? Yh(r) : null
    },
    /* @__PURE__ */ x.createElement($0, { ...e, ref: t })
  ) : /* @__PURE__ */ x.createElement($0, { ...e, ref: t });
});
Cw.displayName = "LinkRemarkRenderer";
function qce({
  node: e,
  ...t
}) {
  return (
    // we use div instead of p to prevent DOM validation errors
    // we render videos inside p tags that have div containers around them that is not allowed
    /* @__PURE__ */ x.createElement("div", { className: "ai-tw-mb-2 ai-tw-leading-normal ai-tw-body-md", ...t })
  );
}
function Yce({
  chatId: e,
  messageId: t
}) {
  const {
    swr: { data: n }
  } = qh({
    chatId: e
  }), [r, i] = de(!1), [o, a] = de(null);
  if (!n)
    return null;
  const s = Eoe(n, t);
  if (!s)
    return null;
  async function l() {
    const u = zT(s);
    if (!u || (await navigator.clipboard.writeText(u), o))
      return;
    i(!0);
    const d = setTimeout(() => {
      i(!1), a(null);
    }, 2e3);
    a(d);
  }
  return /* @__PURE__ */ x.createElement(Oa, { icon: mae, onClick: l }, r ? "Copied!" : "Copy");
}
function Kce({
  chatId: e,
  messageId: t
}) {
  const { chatDispatch: n } = Me(At);
  return /* @__PURE__ */ x.createElement("div", { className: "ai-tw-mt-4 ai-tw-flex" }, /* @__PURE__ */ x.createElement(Yce, { chatId: e, messageId: t }), /* @__PURE__ */ x.createElement(
    Oa,
    {
      className: "ai-tw-ml-2",
      icon: pae,
      onClick: () => n({ type: "selectChatMessageForFeedback", messageId: t })
    }
  ));
}
function V7({
  children: e,
  icon: t,
  title: n,
  className: r,
  headerClassName: i
}) {
  return /* @__PURE__ */ x.createElement("div", { className: ie("ai-tw-my-6", r) }, /* @__PURE__ */ x.createElement(
    "header",
    {
      className: ie(
        "ai-tw-mb-6 ai-tw-flex ai-tw-items-center ai-tw-text-content-primary",
        i
      )
    },
    /* @__PURE__ */ x.createElement(Le, { icon: t, className: "ai-tw-mr-2" }),
    /* @__PURE__ */ x.createElement("p", { className: "ai-tw-subtitle-md" }, n)
  ), e);
}
function Xce({
  followUpQuestions: e
}) {
  const { askQuestion: t } = Me(At);
  return e != null && e.length ? /* @__PURE__ */ x.createElement(Ff, null, /* @__PURE__ */ x.createElement(
    V7,
    {
      icon: G$,
      title: "Follow-up Questions",
      className: "ai-tw-mb-0",
      headerClassName: "ai-tw-mb-4"
    },
    /* @__PURE__ */ x.createElement("ul", { className: "ai-tw-list-none" }, woe(e, 3).map((n) => /* @__PURE__ */ x.createElement(
      "li",
      {
        key: n,
        role: "button",
        className: "ai-tw-cursor-pointer ai-tw-rounded-lg ai-tw-px-4 ai-tw-py-3 ai-tw-text-content-primary ai-tw-body-md hover:ai-tw-bg-element-primary-subtle hover:ai-tw-text-content-primary active:ai-tw-bg-element-primary-subtle-dark",
        onClick: () => t(n)
      },
      "“",
      n,
      "”"
    )))
  )) : null;
}
function L0({ children: e, className: t }) {
  return /* @__PURE__ */ x.createElement("span", { className: ie("ai-tw-text-content-primary ai-tw-body-md", t) }, e);
}
var Zce = Object.prototype;
function Qce(e) {
  var t = e && e.constructor, n = typeof t == "function" && t.prototype || Zce;
  return e === n;
}
var B7 = Qce;
function Jce(e, t) {
  return function(n) {
    return e(t(n));
  };
}
var eue = Jce, tue = eue, nue = tue(Object.keys, Object), rue = nue, iue = B7, oue = rue, aue = Object.prototype, sue = aue.hasOwnProperty;
function lue(e) {
  if (!iue(e))
    return oue(e);
  var t = [];
  for (var n in Object(e))
    sue.call(e, n) && n != "constructor" && t.push(n);
  return t;
}
var cue = lue;
function uue(e) {
  var t = typeof e;
  return e != null && (t == "object" || t == "function");
}
var j7 = uue, due = Lc, fue = j7, hue = "[object AsyncFunction]", pue = "[object Function]", mue = "[object GeneratorFunction]", gue = "[object Proxy]";
function vue(e) {
  if (!fue(e))
    return !1;
  var t = due(e);
  return t == pue || t == mue || t == hue || t == gue;
}
var W7 = vue, yue = No, wue = yue["__core-js_shared__"], bue = wue, Ig = bue, WC = function() {
  var e = /[^.]+$/.exec(Ig && Ig.keys && Ig.keys.IE_PROTO || "");
  return e ? "Symbol(src)_1." + e : "";
}();
function xue(e) {
  return !!WC && WC in e;
}
var Eue = xue, Cue = Function.prototype, Sue = Cue.toString;
function _ue(e) {
  if (e != null) {
    try {
      return Sue.call(e);
    } catch {
    }
    try {
      return e + "";
    } catch {
    }
  }
  return "";
}
var U7 = _ue, Pue = W7, kue = Eue, Tue = j7, Aue = U7, Mue = /[\\^$.*+?()[\]{}|]/g, Oue = /^\[object .+?Constructor\]$/, Rue = Function.prototype, Iue = Object.prototype, Due = Rue.toString, Nue = Iue.hasOwnProperty, $ue = RegExp(
  "^" + Due.call(Nue).replace(Mue, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function Lue(e) {
  if (!Tue(e) || kue(e))
    return !1;
  var t = Pue(e) ? $ue : Oue;
  return t.test(Aue(e));
}
var Fue = Lue;
function zue(e, t) {
  return e == null ? void 0 : e[t];
}
var Vue = zue, Bue = Fue, jue = Vue;
function Wue(e, t) {
  var n = jue(e, t);
  return Bue(n) ? n : void 0;
}
var jc = Wue, Uue = jc, Hue = No, Gue = Uue(Hue, "DataView"), que = Gue, Yue = jc, Kue = No, Xue = Yue(Kue, "Map"), Zue = Xue, Que = jc, Jue = No, ede = Que(Jue, "Promise"), tde = ede, nde = jc, rde = No, ide = nde(rde, "Set"), ode = ide, ade = jc, sde = No, lde = ade(sde, "WeakMap"), cde = lde, F0 = que, z0 = Zue, V0 = tde, B0 = ode, j0 = cde, H7 = Lc, Zs = U7, UC = "[object Map]", ude = "[object Object]", HC = "[object Promise]", GC = "[object Set]", qC = "[object WeakMap]", YC = "[object DataView]", dde = Zs(F0), fde = Zs(z0), hde = Zs(V0), pde = Zs(B0), mde = Zs(j0), sa = H7;
(F0 && sa(new F0(new ArrayBuffer(1))) != YC || z0 && sa(new z0()) != UC || V0 && sa(V0.resolve()) != HC || B0 && sa(new B0()) != GC || j0 && sa(new j0()) != qC) && (sa = function(e) {
  var t = H7(e), n = t == ude ? e.constructor : void 0, r = n ? Zs(n) : "";
  if (r)
    switch (r) {
      case dde:
        return YC;
      case fde:
        return UC;
      case hde:
        return HC;
      case pde:
        return GC;
      case mde:
        return qC;
    }
  return t;
});
var gde = sa, vde = Lc, yde = Fh, wde = "[object Arguments]";
function bde(e) {
  return yde(e) && vde(e) == wde;
}
var xde = bde, KC = xde, Ede = Fh, G7 = Object.prototype, Cde = G7.hasOwnProperty, Sde = G7.propertyIsEnumerable, _de = KC(function() {
  return arguments;
}()) ? KC : function(e) {
  return Ede(e) && Cde.call(e, "callee") && !Sde.call(e, "callee");
}, Pde = _de, kde = 9007199254740991;
function Tde(e) {
  return typeof e == "number" && e > -1 && e % 1 == 0 && e <= kde;
}
var q7 = Tde, Ade = W7, Mde = q7;
function Ode(e) {
  return e != null && Mde(e.length) && !Ade(e);
}
var Rde = Ode, Bf = { exports: {} };
function Ide() {
  return !1;
}
var Dde = Ide;
Bf.exports;
(function(e, t) {
  var n = No, r = Dde, i = t && !t.nodeType && t, o = i && !0 && e && !e.nodeType && e, a = o && o.exports === i, s = a ? n.Buffer : void 0, l = s ? s.isBuffer : void 0, u = l || r;
  e.exports = u;
})(Bf, Bf.exports);
var Nde = Bf.exports, $de = Lc, Lde = q7, Fde = Fh, zde = "[object Arguments]", Vde = "[object Array]", Bde = "[object Boolean]", jde = "[object Date]", Wde = "[object Error]", Ude = "[object Function]", Hde = "[object Map]", Gde = "[object Number]", qde = "[object Object]", Yde = "[object RegExp]", Kde = "[object Set]", Xde = "[object String]", Zde = "[object WeakMap]", Qde = "[object ArrayBuffer]", Jde = "[object DataView]", efe = "[object Float32Array]", tfe = "[object Float64Array]", nfe = "[object Int8Array]", rfe = "[object Int16Array]", ife = "[object Int32Array]", ofe = "[object Uint8Array]", afe = "[object Uint8ClampedArray]", sfe = "[object Uint16Array]", lfe = "[object Uint32Array]", Nt = {};
Nt[efe] = Nt[tfe] = Nt[nfe] = Nt[rfe] = Nt[ife] = Nt[ofe] = Nt[afe] = Nt[sfe] = Nt[lfe] = !0;
Nt[zde] = Nt[Vde] = Nt[Qde] = Nt[Bde] = Nt[Jde] = Nt[jde] = Nt[Wde] = Nt[Ude] = Nt[Hde] = Nt[Gde] = Nt[qde] = Nt[Yde] = Nt[Kde] = Nt[Xde] = Nt[Zde] = !1;
function cfe(e) {
  return Fde(e) && Lde(e.length) && !!Nt[$de(e)];
}
var ufe = cfe;
function dfe(e) {
  return function(t) {
    return e(t);
  };
}
var ffe = dfe, jf = { exports: {} };
jf.exports;
(function(e, t) {
  var n = mk, r = t && !t.nodeType && t, i = r && !0 && e && !e.nodeType && e, o = i && i.exports === r, a = o && n.process, s = function() {
    try {
      var l = i && i.require && i.require("util").types;
      return l || a && a.binding && a.binding("util");
    } catch {
    }
  }();
  e.exports = s;
})(jf, jf.exports);
var hfe = jf.exports, pfe = ufe, mfe = ffe, XC = hfe, ZC = XC && XC.isTypedArray, gfe = ZC ? mfe(ZC) : pfe, vfe = gfe, yfe = cue, wfe = gde, bfe = Pde, xfe = gk, Efe = Rde, Cfe = Nde, Sfe = B7, _fe = vfe, Pfe = "[object Map]", kfe = "[object Set]", Tfe = Object.prototype, Afe = Tfe.hasOwnProperty;
function Mfe(e) {
  if (e == null)
    return !0;
  if (Efe(e) && (xfe(e) || typeof e == "string" || typeof e.splice == "function" || Cfe(e) || _fe(e) || bfe(e)))
    return !e.length;
  var t = wfe(e);
  if (t == Pfe || t == kfe)
    return !e.size;
  if (Sfe(e))
    return !yfe(e).length;
  for (var n in e)
    if (Afe.call(e, n))
      return !1;
  return !0;
}
var Ofe = Mfe;
const Rfe = /* @__PURE__ */ Pi(Ofe);
function Ife({ sources: e }) {
  const { chatState: t } = Me(At), n = no(t);
  if (Rfe(e) || n)
    return null;
  const r = `${Object.keys(e).length} Sources`;
  return /* @__PURE__ */ x.createElement(Ff, null, /* @__PURE__ */ x.createElement(V7, { icon: lS, title: r }, /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-max-w-full ai-tw-gap-x-2 ai-tw-overflow-auto" }, Object.values(e || {}).map((i) => /* @__PURE__ */ x.createElement(
    z7,
    {
      key: k0(i),
      id: k0(i),
      title: rw(i),
      url: iw(i),
      type: LT(i),
      source: $s(i) ? Yh(i) : null,
      modifiedAt: $s(i) ? ow(i) : null
    }
  )))));
}
function Dfe() {
  const [e, t] = de("");
  return be(() => {
    const n = setInterval(() => {
      t((r) => r.length < 3 ? r + "." : "");
    }, 250);
    return () => clearInterval(n);
  }, []), /* @__PURE__ */ x.createElement("p", null, "Thinking", e);
}
const QC = ["http", "https", "mailto", "tel"];
function Nfe(e) {
  const t = (e || "").trim(), n = t.charAt(0);
  if (n === "#" || n === "/")
    return t;
  const r = t.indexOf(":");
  if (r === -1)
    return t;
  let i = -1;
  for (; ++i < QC.length; ) {
    const o = QC[i];
    if (r === o.length && t.slice(0, o.length).toLowerCase() === o)
      return t;
  }
  return i = t.indexOf("?"), i !== -1 && r > i || (i = t.indexOf("#"), i !== -1 && r > i) ? t : "javascript:void(0)";
}
/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
var $fe = function(t) {
  return t != null && t.constructor != null && typeof t.constructor.isBuffer == "function" && t.constructor.isBuffer(t);
};
const Y7 = /* @__PURE__ */ Pi($fe);
function Jl(e) {
  return !e || typeof e != "object" ? "" : "position" in e || "type" in e ? JC(e.position) : "start" in e || "end" in e ? JC(e) : "line" in e || "column" in e ? W0(e) : "";
}
function W0(e) {
  return e4(e && e.line) + ":" + e4(e && e.column);
}
function JC(e) {
  return W0(e && e.start) + "-" + W0(e && e.end);
}
function e4(e) {
  return e && typeof e == "number" ? e : 1;
}
class Fr extends Error {
  /**
   * Create a message for `reason` at `place` from `origin`.
   *
   * When an error is passed in as `reason`, the `stack` is copied.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   *
   *   > 👉 **Note**: you should use markdown.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // To do: next major: expose `undefined` everywhere instead of `null`.
  constructor(t, n, r) {
    const i = [null, null];
    let o = {
      // @ts-expect-error: we always follows the structure of `position`.
      start: { line: null, column: null },
      // @ts-expect-error: "
      end: { line: null, column: null }
    };
    if (super(), typeof n == "string" && (r = n, n = void 0), typeof r == "string") {
      const a = r.indexOf(":");
      a === -1 ? i[1] = r : (i[0] = r.slice(0, a), i[1] = r.slice(a + 1));
    }
    n && ("type" in n || "position" in n ? n.position && (o = n.position) : "start" in n || "end" in n ? o = n : ("line" in n || "column" in n) && (o.start = n)), this.name = Jl(n) || "1:1", this.message = typeof t == "object" ? t.message : t, this.stack = "", typeof t == "object" && t.stack && (this.stack = t.stack), this.reason = this.message, this.fatal, this.line = o.start.line, this.column = o.start.column, this.position = o, this.source = i[0], this.ruleId = i[1], this.file, this.actual, this.expected, this.url, this.note;
  }
}
Fr.prototype.file = "";
Fr.prototype.name = "";
Fr.prototype.reason = "";
Fr.prototype.message = "";
Fr.prototype.stack = "";
Fr.prototype.fatal = null;
Fr.prototype.column = null;
Fr.prototype.line = null;
Fr.prototype.source = null;
Fr.prototype.ruleId = null;
Fr.prototype.position = null;
const gi = { basename: Lfe, dirname: Ffe, extname: zfe, join: Vfe, sep: "/" };
function Lfe(e, t) {
  if (t !== void 0 && typeof t != "string")
    throw new TypeError('"ext" argument must be a string');
  Wc(e);
  let n = 0, r = -1, i = e.length, o;
  if (t === void 0 || t.length === 0 || t.length > e.length) {
    for (; i--; )
      if (e.charCodeAt(i) === 47) {
        if (o) {
          n = i + 1;
          break;
        }
      } else
        r < 0 && (o = !0, r = i + 1);
    return r < 0 ? "" : e.slice(n, r);
  }
  if (t === e)
    return "";
  let a = -1, s = t.length - 1;
  for (; i--; )
    if (e.charCodeAt(i) === 47) {
      if (o) {
        n = i + 1;
        break;
      }
    } else
      a < 0 && (o = !0, a = i + 1), s > -1 && (e.charCodeAt(i) === t.charCodeAt(s--) ? s < 0 && (r = i) : (s = -1, r = a));
  return n === r ? r = a : r < 0 && (r = e.length), e.slice(n, r);
}
function Ffe(e) {
  if (Wc(e), e.length === 0)
    return ".";
  let t = -1, n = e.length, r;
  for (; --n; )
    if (e.charCodeAt(n) === 47) {
      if (r) {
        t = n;
        break;
      }
    } else
      r || (r = !0);
  return t < 0 ? e.charCodeAt(0) === 47 ? "/" : "." : t === 1 && e.charCodeAt(0) === 47 ? "//" : e.slice(0, t);
}
function zfe(e) {
  Wc(e);
  let t = e.length, n = -1, r = 0, i = -1, o = 0, a;
  for (; t--; ) {
    const s = e.charCodeAt(t);
    if (s === 47) {
      if (a) {
        r = t + 1;
        break;
      }
      continue;
    }
    n < 0 && (a = !0, n = t + 1), s === 46 ? i < 0 ? i = t : o !== 1 && (o = 1) : i > -1 && (o = -1);
  }
  return i < 0 || n < 0 || // We saw a non-dot character immediately before the dot.
  o === 0 || // The (right-most) trimmed path component is exactly `..`.
  o === 1 && i === n - 1 && i === r + 1 ? "" : e.slice(i, n);
}
function Vfe(...e) {
  let t = -1, n;
  for (; ++t < e.length; )
    Wc(e[t]), e[t] && (n = n === void 0 ? e[t] : n + "/" + e[t]);
  return n === void 0 ? "." : Bfe(n);
}
function Bfe(e) {
  Wc(e);
  const t = e.charCodeAt(0) === 47;
  let n = jfe(e, !t);
  return n.length === 0 && !t && (n = "."), n.length > 0 && e.charCodeAt(e.length - 1) === 47 && (n += "/"), t ? "/" + n : n;
}
function jfe(e, t) {
  let n = "", r = 0, i = -1, o = 0, a = -1, s, l;
  for (; ++a <= e.length; ) {
    if (a < e.length)
      s = e.charCodeAt(a);
    else {
      if (s === 47)
        break;
      s = 47;
    }
    if (s === 47) {
      if (!(i === a - 1 || o === 1))
        if (i !== a - 1 && o === 2) {
          if (n.length < 2 || r !== 2 || n.charCodeAt(n.length - 1) !== 46 || n.charCodeAt(n.length - 2) !== 46) {
            if (n.length > 2) {
              if (l = n.lastIndexOf("/"), l !== n.length - 1) {
                l < 0 ? (n = "", r = 0) : (n = n.slice(0, l), r = n.length - 1 - n.lastIndexOf("/")), i = a, o = 0;
                continue;
              }
            } else if (n.length > 0) {
              n = "", r = 0, i = a, o = 0;
              continue;
            }
          }
          t && (n = n.length > 0 ? n + "/.." : "..", r = 2);
        } else
          n.length > 0 ? n += "/" + e.slice(i + 1, a) : n = e.slice(i + 1, a), r = a - i - 1;
      i = a, o = 0;
    } else
      s === 46 && o > -1 ? o++ : o = -1;
  }
  return n;
}
function Wc(e) {
  if (typeof e != "string")
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(e)
    );
}
const Wfe = { cwd: Ufe };
function Ufe() {
  return "/";
}
function U0(e) {
  return e !== null && typeof e == "object" && // @ts-expect-error: indexable.
  e.href && // @ts-expect-error: indexable.
  e.origin;
}
function Hfe(e) {
  if (typeof e == "string")
    e = new URL(e);
  else if (!U0(e)) {
    const t = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + e + "`"
    );
    throw t.code = "ERR_INVALID_ARG_TYPE", t;
  }
  if (e.protocol !== "file:") {
    const t = new TypeError("The URL must be of scheme file");
    throw t.code = "ERR_INVALID_URL_SCHEME", t;
  }
  return Gfe(e);
}
function Gfe(e) {
  if (e.hostname !== "") {
    const r = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    throw r.code = "ERR_INVALID_FILE_URL_HOST", r;
  }
  const t = e.pathname;
  let n = -1;
  for (; ++n < t.length; )
    if (t.charCodeAt(n) === 37 && t.charCodeAt(n + 1) === 50) {
      const r = t.charCodeAt(n + 2);
      if (r === 70 || r === 102) {
        const i = new TypeError(
          "File URL path must not include encoded / characters"
        );
        throw i.code = "ERR_INVALID_FILE_URL_PATH", i;
      }
    }
  return decodeURIComponent(t);
}
const Dg = ["history", "path", "basename", "stem", "extname", "dirname"];
class K7 {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Buffer` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(t) {
    let n;
    t ? typeof t == "string" || qfe(t) ? n = { value: t } : U0(t) ? n = { path: t } : n = t : n = {}, this.data = {}, this.messages = [], this.history = [], this.cwd = Wfe.cwd(), this.value, this.stored, this.result, this.map;
    let r = -1;
    for (; ++r < Dg.length; ) {
      const o = Dg[r];
      o in n && n[o] !== void 0 && n[o] !== null && (this[o] = o === "history" ? [...n[o]] : n[o]);
    }
    let i;
    for (i in n)
      Dg.includes(i) || (this[i] = n[i]);
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {string | URL} path
   */
  set path(t) {
    U0(t) && (t = Hfe(t)), $g(t, "path"), this.path !== t && this.history.push(t);
  }
  /**
   * Get the parent path (example: `'~'`).
   */
  get dirname() {
    return typeof this.path == "string" ? gi.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   */
  set dirname(t) {
    t4(this.basename, "dirname"), this.path = gi.join(t || "", this.basename);
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   */
  get basename() {
    return typeof this.path == "string" ? gi.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set basename(t) {
    $g(t, "basename"), Ng(t, "basename"), this.path = gi.join(this.dirname || "", t);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   */
  get extname() {
    return typeof this.path == "string" ? gi.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   */
  set extname(t) {
    if (Ng(t, "extname"), t4(this.dirname, "extname"), t) {
      if (t.charCodeAt(0) !== 46)
        throw new Error("`extname` must start with `.`");
      if (t.includes(".", 1))
        throw new Error("`extname` cannot contain multiple dots");
    }
    this.path = gi.join(this.dirname, this.stem + (t || ""));
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   */
  get stem() {
    return typeof this.path == "string" ? gi.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   */
  set stem(t) {
    $g(t, "stem"), Ng(t, "stem"), this.path = gi.join(this.dirname || "", t + (this.extname || ""));
  }
  /**
   * Serialize the file.
   *
   * @param {BufferEncoding | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Buffer`
   *   (default: `'utf8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(t) {
    return (this.value || "").toString(t || void 0);
  }
  /**
   * Create a warning message associated with the file.
   *
   * Its `fatal` is set to `false` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(t, n, r) {
    const i = new Fr(t, n, r);
    return this.path && (i.name = this.path + ":" + i.name, i.file = this.path), i.fatal = !1, this.messages.push(i), i;
  }
  /**
   * Create an info message associated with the file.
   *
   * Its `fatal` is set to `null` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(t, n, r) {
    const i = this.message(t, n, r);
    return i.fatal = null, i;
  }
  /**
   * Create a fatal error associated with the file.
   *
   * Its `fatal` is set to `true` and `file` is set to the current file path.
   * Its added to `file.messages`.
   *
   * > 👉 **Note**: a fatal error means that a file is no longer processable.
   *
   * @param {string | Error | VFileMessage} reason
   *   Reason for message, uses the stack and message of the error if given.
   * @param {Node | NodeLike | Position | Point | null | undefined} [place]
   *   Place in file where the message occurred.
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Message.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(t, n, r) {
    const i = this.message(t, n, r);
    throw i.fatal = !0, i;
  }
}
function Ng(e, t) {
  if (e && e.includes(gi.sep))
    throw new Error(
      "`" + t + "` cannot be a path: did not expect `" + gi.sep + "`"
    );
}
function $g(e, t) {
  if (!e)
    throw new Error("`" + t + "` cannot be empty");
}
function t4(e, t) {
  if (!e)
    throw new Error("Setting `" + t + "` requires `path` to be set too");
}
function qfe(e) {
  return Y7(e);
}
function n4(e) {
  if (e)
    throw e;
}
var Xd = Object.prototype.hasOwnProperty, X7 = Object.prototype.toString, r4 = Object.defineProperty, i4 = Object.getOwnPropertyDescriptor, o4 = function(t) {
  return typeof Array.isArray == "function" ? Array.isArray(t) : X7.call(t) === "[object Array]";
}, a4 = function(t) {
  if (!t || X7.call(t) !== "[object Object]")
    return !1;
  var n = Xd.call(t, "constructor"), r = t.constructor && t.constructor.prototype && Xd.call(t.constructor.prototype, "isPrototypeOf");
  if (t.constructor && !n && !r)
    return !1;
  var i;
  for (i in t)
    ;
  return typeof i > "u" || Xd.call(t, i);
}, s4 = function(t, n) {
  r4 && n.name === "__proto__" ? r4(t, n.name, {
    enumerable: !0,
    configurable: !0,
    value: n.newValue,
    writable: !0
  }) : t[n.name] = n.newValue;
}, l4 = function(t, n) {
  if (n === "__proto__")
    if (Xd.call(t, n)) {
      if (i4)
        return i4(t, n).value;
    } else
      return;
  return t[n];
}, Yfe = function e() {
  var t, n, r, i, o, a, s = arguments[0], l = 1, u = arguments.length, d = !1;
  for (typeof s == "boolean" && (d = s, s = arguments[1] || {}, l = 2), (s == null || typeof s != "object" && typeof s != "function") && (s = {}); l < u; ++l)
    if (t = arguments[l], t != null)
      for (n in t)
        r = l4(s, n), i = l4(t, n), s !== i && (d && i && (a4(i) || (o = o4(i))) ? (o ? (o = !1, a = r && o4(r) ? r : []) : a = r && a4(r) ? r : {}, s4(s, { name: n, newValue: e(d, a, i) })) : typeof i < "u" && s4(s, { name: n, newValue: i }));
  return s;
};
const c4 = /* @__PURE__ */ Pi(Yfe);
function H0(e) {
  if (typeof e != "object" || e === null)
    return !1;
  const t = Object.getPrototypeOf(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Symbol.toStringTag in e) && !(Symbol.iterator in e);
}
function Kfe() {
  const e = [], t = { run: n, use: r };
  return t;
  function n(...i) {
    let o = -1;
    const a = i.pop();
    if (typeof a != "function")
      throw new TypeError("Expected function as last argument, not " + a);
    s(null, ...i);
    function s(l, ...u) {
      const d = e[++o];
      let f = -1;
      if (l) {
        a(l);
        return;
      }
      for (; ++f < i.length; )
        (u[f] === null || u[f] === void 0) && (u[f] = i[f]);
      i = u, d ? Xfe(d, s)(...u) : a(null, ...u);
    }
  }
  function r(i) {
    if (typeof i != "function")
      throw new TypeError(
        "Expected `middelware` to be a function, not " + i
      );
    return e.push(i), t;
  }
}
function Xfe(e, t) {
  let n;
  return r;
  function r(...a) {
    const s = e.length > a.length;
    let l;
    s && a.push(i);
    try {
      l = e.apply(this, a);
    } catch (u) {
      const d = (
        /** @type {Error} */
        u
      );
      if (s && n)
        throw d;
      return i(d);
    }
    s || (l && l.then && typeof l.then == "function" ? l.then(o, i) : l instanceof Error ? i(l) : o(l));
  }
  function i(a, ...s) {
    n || (n = !0, t(a, ...s));
  }
  function o(a) {
    i(null, a);
  }
}
const Zfe = Q7().freeze(), Z7 = {}.hasOwnProperty;
function Q7() {
  const e = Kfe(), t = [];
  let n = {}, r, i = -1;
  return o.data = a, o.Parser = void 0, o.Compiler = void 0, o.freeze = s, o.attachers = t, o.use = l, o.parse = u, o.stringify = d, o.run = f, o.runSync = p, o.process = m, o.processSync = g, o;
  function o() {
    const v = Q7();
    let y = -1;
    for (; ++y < t.length; )
      v.use(...t[y]);
    return v.data(c4(!0, {}, n)), v;
  }
  function a(v, y) {
    return typeof v == "string" ? arguments.length === 2 ? (zg("data", r), n[v] = y, o) : Z7.call(n, v) && n[v] || null : v ? (zg("data", r), n = v, o) : n;
  }
  function s() {
    if (r)
      return o;
    for (; ++i < t.length; ) {
      const [v, ...y] = t[i];
      if (y[0] === !1)
        continue;
      y[0] === !0 && (y[0] = void 0);
      const b = v.call(o, ...y);
      typeof b == "function" && e.use(b);
    }
    return r = !0, i = Number.POSITIVE_INFINITY, o;
  }
  function l(v, ...y) {
    let b;
    if (zg("use", r), v != null)
      if (typeof v == "function")
        k(v, ...y);
      else if (typeof v == "object")
        Array.isArray(v) ? _(v) : S(v);
      else
        throw new TypeError("Expected usable value, not `" + v + "`");
    return b && (n.settings = Object.assign(n.settings || {}, b)), o;
    function E(T) {
      if (typeof T == "function")
        k(T);
      else if (typeof T == "object")
        if (Array.isArray(T)) {
          const [A, ...R] = T;
          k(A, ...R);
        } else
          S(T);
      else
        throw new TypeError("Expected usable value, not `" + T + "`");
    }
    function S(T) {
      _(T.plugins), T.settings && (b = Object.assign(b || {}, T.settings));
    }
    function _(T) {
      let A = -1;
      if (T != null)
        if (Array.isArray(T))
          for (; ++A < T.length; ) {
            const R = T[A];
            E(R);
          }
        else
          throw new TypeError("Expected a list of plugins, not `" + T + "`");
    }
    function k(T, A) {
      let R = -1, F;
      for (; ++R < t.length; )
        if (t[R][0] === T) {
          F = t[R];
          break;
        }
      F ? (H0(F[1]) && H0(A) && (A = c4(!0, F[1], A)), F[1] = A) : t.push([...arguments]);
    }
  }
  function u(v) {
    o.freeze();
    const y = Il(v), b = o.Parser;
    return Lg("parse", b), u4(b, "parse") ? new b(String(y), y).parse() : b(String(y), y);
  }
  function d(v, y) {
    o.freeze();
    const b = Il(y), E = o.Compiler;
    return Fg("stringify", E), d4(v), u4(E, "compile") ? new E(v, b).compile() : E(v, b);
  }
  function f(v, y, b) {
    if (d4(v), o.freeze(), !b && typeof y == "function" && (b = y, y = void 0), !b)
      return new Promise(E);
    E(null, b);
    function E(S, _) {
      e.run(v, Il(y), k);
      function k(T, A, R) {
        A = A || v, T ? _(T) : S ? S(A) : b(null, A, R);
      }
    }
  }
  function p(v, y) {
    let b, E;
    return o.run(v, y, S), f4("runSync", "run", E), b;
    function S(_, k) {
      n4(_), b = k, E = !0;
    }
  }
  function m(v, y) {
    if (o.freeze(), Lg("process", o.Parser), Fg("process", o.Compiler), !y)
      return new Promise(b);
    b(null, y);
    function b(E, S) {
      const _ = Il(v);
      o.run(o.parse(_), _, (T, A, R) => {
        if (T || !A || !R)
          k(T);
        else {
          const F = o.stringify(A, R);
          F == null || (ehe(F) ? R.value = F : R.result = F), k(T, R);
        }
      });
      function k(T, A) {
        T || !A ? S(T) : E ? E(A) : y(null, A);
      }
    }
  }
  function g(v) {
    let y;
    o.freeze(), Lg("processSync", o.Parser), Fg("processSync", o.Compiler);
    const b = Il(v);
    return o.process(b, E), f4("processSync", "process", y), b;
    function E(S) {
      y = !0, n4(S);
    }
  }
}
function u4(e, t) {
  return typeof e == "function" && // Prototypes do exist.
  // type-coverage:ignore-next-line
  e.prototype && // A function with keys in its prototype is probably a constructor.
  // Classes’ prototype methods are not enumerable, so we check if some value
  // exists in the prototype.
  // type-coverage:ignore-next-line
  (Qfe(e.prototype) || t in e.prototype);
}
function Qfe(e) {
  let t;
  for (t in e)
    if (Z7.call(e, t))
      return !0;
  return !1;
}
function Lg(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `Parser`");
}
function Fg(e, t) {
  if (typeof t != "function")
    throw new TypeError("Cannot `" + e + "` without `Compiler`");
}
function zg(e, t) {
  if (t)
    throw new Error(
      "Cannot call `" + e + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
}
function d4(e) {
  if (!H0(e) || typeof e.type != "string")
    throw new TypeError("Expected node, got `" + e + "`");
}
function f4(e, t, n) {
  if (!n)
    throw new Error(
      "`" + e + "` finished async. Use `" + t + "` instead"
    );
}
function Il(e) {
  return Jfe(e) ? e : new K7(e);
}
function Jfe(e) {
  return !!(e && typeof e == "object" && "message" in e && "messages" in e);
}
function ehe(e) {
  return typeof e == "string" || Y7(e);
}
const the = {};
function nhe(e, t) {
  const n = t || the, r = typeof n.includeImageAlt == "boolean" ? n.includeImageAlt : !0, i = typeof n.includeHtml == "boolean" ? n.includeHtml : !0;
  return J7(e, r, i);
}
function J7(e, t, n) {
  if (rhe(e)) {
    if ("value" in e)
      return e.type === "html" && !n ? "" : e.value;
    if (t && "alt" in e && e.alt)
      return e.alt;
    if ("children" in e)
      return h4(e.children, t, n);
  }
  return Array.isArray(e) ? h4(e, t, n) : "";
}
function h4(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; )
    r[i] = J7(e[i], t, n);
  return r.join("");
}
function rhe(e) {
  return !!(e && typeof e == "object");
}
function gr(e, t, n, r) {
  const i = e.length;
  let o = 0, a;
  if (t < 0 ? t = -t > i ? 0 : i + t : t = t > i ? i : t, n = n > 0 ? n : 0, r.length < 1e4)
    a = Array.from(r), a.unshift(t, n), e.splice(...a);
  else
    for (n && e.splice(t, n); o < r.length; )
      a = r.slice(o, o + 1e4), a.unshift(t, 0), e.splice(...a), o += 1e4, t += 1e4;
}
function Ir(e, t) {
  return e.length > 0 ? (gr(e, e.length, 0, t), e) : t;
}
const p4 = {}.hasOwnProperty;
function eA(e) {
  const t = {};
  let n = -1;
  for (; ++n < e.length; )
    ihe(t, e[n]);
  return t;
}
function ihe(e, t) {
  let n;
  for (n in t) {
    const i = (p4.call(e, n) ? e[n] : void 0) || (e[n] = {}), o = t[n];
    let a;
    if (o)
      for (a in o) {
        p4.call(i, a) || (i[a] = []);
        const s = o[a];
        ohe(
          // @ts-expect-error Looks like a list.
          i[a],
          Array.isArray(s) ? s : s ? [s] : []
        );
      }
  }
}
function ohe(e, t) {
  let n = -1;
  const r = [];
  for (; ++n < t.length; )
    (t[n].add === "after" ? e : r).push(t[n]);
  gr(e, 0, 0, r);
}
const ahe = /[!-\/:-@\[-`\{-~\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061D-\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0A76\u0AF0\u0C77\u0C84\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1B7D\u1B7E\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E4F\u2E52-\u2E5D\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]/, Vn = zo(/[A-Za-z]/), Mn = zo(/[\dA-Za-z]/), she = zo(/[#-'*+\--9=?A-Z^-~]/);
function Wf(e) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    e !== null && (e < 32 || e === 127)
  );
}
const G0 = zo(/\d/), lhe = zo(/[\dA-Fa-f]/), che = zo(/[!-/:-@[-`{-~]/);
function Ve(e) {
  return e !== null && e < -2;
}
function Tt(e) {
  return e !== null && (e < 0 || e === 32);
}
function nt(e) {
  return e === -2 || e === -1 || e === 32;
}
const ip = zo(ahe), Pa = zo(/\s/);
function zo(e) {
  return t;
  function t(n) {
    return n !== null && e.test(String.fromCharCode(n));
  }
}
function ft(e, t, n, r) {
  const i = r ? r - 1 : Number.POSITIVE_INFINITY;
  let o = 0;
  return a;
  function a(l) {
    return nt(l) ? (e.enter(n), s(l)) : t(l);
  }
  function s(l) {
    return nt(l) && o++ < i ? (e.consume(l), s) : (e.exit(n), t(l));
  }
}
const uhe = {
  tokenize: dhe
};
function dhe(e) {
  const t = e.attempt(
    this.parser.constructs.contentInitial,
    r,
    i
  );
  let n;
  return t;
  function r(s) {
    if (s === null) {
      e.consume(s);
      return;
    }
    return e.enter("lineEnding"), e.consume(s), e.exit("lineEnding"), ft(e, t, "linePrefix");
  }
  function i(s) {
    return e.enter("paragraph"), o(s);
  }
  function o(s) {
    const l = e.enter("chunkText", {
      contentType: "text",
      previous: n
    });
    return n && (n.next = l), n = l, a(s);
  }
  function a(s) {
    if (s === null) {
      e.exit("chunkText"), e.exit("paragraph"), e.consume(s);
      return;
    }
    return Ve(s) ? (e.consume(s), e.exit("chunkText"), o) : (e.consume(s), a);
  }
}
const fhe = {
  tokenize: hhe
}, m4 = {
  tokenize: phe
};
function hhe(e) {
  const t = this, n = [];
  let r = 0, i, o, a;
  return s;
  function s(S) {
    if (r < n.length) {
      const _ = n[r];
      return t.containerState = _[1], e.attempt(
        _[0].continuation,
        l,
        u
      )(S);
    }
    return u(S);
  }
  function l(S) {
    if (r++, t.containerState._closeFlow) {
      t.containerState._closeFlow = void 0, i && E();
      const _ = t.events.length;
      let k = _, T;
      for (; k--; )
        if (t.events[k][0] === "exit" && t.events[k][1].type === "chunkFlow") {
          T = t.events[k][1].end;
          break;
        }
      b(r);
      let A = _;
      for (; A < t.events.length; )
        t.events[A][1].end = Object.assign({}, T), A++;
      return gr(
        t.events,
        k + 1,
        0,
        t.events.slice(_)
      ), t.events.length = A, u(S);
    }
    return s(S);
  }
  function u(S) {
    if (r === n.length) {
      if (!i)
        return p(S);
      if (i.currentConstruct && i.currentConstruct.concrete)
        return g(S);
      t.interrupt = !!(i.currentConstruct && !i._gfmTableDynamicInterruptHack);
    }
    return t.containerState = {}, e.check(
      m4,
      d,
      f
    )(S);
  }
  function d(S) {
    return i && E(), b(r), p(S);
  }
  function f(S) {
    return t.parser.lazy[t.now().line] = r !== n.length, a = t.now().offset, g(S);
  }
  function p(S) {
    return t.containerState = {}, e.attempt(
      m4,
      m,
      g
    )(S);
  }
  function m(S) {
    return r++, n.push([t.currentConstruct, t.containerState]), p(S);
  }
  function g(S) {
    if (S === null) {
      i && E(), b(0), e.consume(S);
      return;
    }
    return i = i || t.parser.flow(t.now()), e.enter("chunkFlow", {
      contentType: "flow",
      previous: o,
      _tokenizer: i
    }), v(S);
  }
  function v(S) {
    if (S === null) {
      y(e.exit("chunkFlow"), !0), b(0), e.consume(S);
      return;
    }
    return Ve(S) ? (e.consume(S), y(e.exit("chunkFlow")), r = 0, t.interrupt = void 0, s) : (e.consume(S), v);
  }
  function y(S, _) {
    const k = t.sliceStream(S);
    if (_ && k.push(null), S.previous = o, o && (o.next = S), o = S, i.defineSkip(S.start), i.write(k), t.parser.lazy[S.start.line]) {
      let T = i.events.length;
      for (; T--; )
        if (
          // The token starts before the line ending…
          i.events[T][1].start.offset < a && // …and either is not ended yet…
          (!i.events[T][1].end || // …or ends after it.
          i.events[T][1].end.offset > a)
        )
          return;
      const A = t.events.length;
      let R = A, F, D;
      for (; R--; )
        if (t.events[R][0] === "exit" && t.events[R][1].type === "chunkFlow") {
          if (F) {
            D = t.events[R][1].end;
            break;
          }
          F = !0;
        }
      for (b(r), T = A; T < t.events.length; )
        t.events[T][1].end = Object.assign({}, D), T++;
      gr(
        t.events,
        R + 1,
        0,
        t.events.slice(A)
      ), t.events.length = T;
    }
  }
  function b(S) {
    let _ = n.length;
    for (; _-- > S; ) {
      const k = n[_];
      t.containerState = k[1], k[0].exit.call(t, e);
    }
    n.length = S;
  }
  function E() {
    i.write([null]), o = void 0, i = void 0, t.containerState._closeFlow = void 0;
  }
}
function phe(e, t, n) {
  return ft(
    e,
    e.attempt(this.parser.constructs.document, t, n),
    "linePrefix",
    this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
  );
}
function Uf(e) {
  if (e === null || Tt(e) || Pa(e))
    return 1;
  if (ip(e))
    return 2;
}
function op(e, t, n) {
  const r = [];
  let i = -1;
  for (; ++i < e.length; ) {
    const o = e[i].resolveAll;
    o && !r.includes(o) && (t = o(t, n), r.push(o));
  }
  return t;
}
const q0 = {
  name: "attention",
  tokenize: ghe,
  resolveAll: mhe
};
function mhe(e, t) {
  let n = -1, r, i, o, a, s, l, u, d;
  for (; ++n < e.length; )
    if (e[n][0] === "enter" && e[n][1].type === "attentionSequence" && e[n][1]._close) {
      for (r = n; r--; )
        if (e[r][0] === "exit" && e[r][1].type === "attentionSequence" && e[r][1]._open && // If the markers are the same:
        t.sliceSerialize(e[r][1]).charCodeAt(0) === t.sliceSerialize(e[n][1]).charCodeAt(0)) {
          if ((e[r][1]._close || e[n][1]._open) && (e[n][1].end.offset - e[n][1].start.offset) % 3 && !((e[r][1].end.offset - e[r][1].start.offset + e[n][1].end.offset - e[n][1].start.offset) % 3))
            continue;
          l = e[r][1].end.offset - e[r][1].start.offset > 1 && e[n][1].end.offset - e[n][1].start.offset > 1 ? 2 : 1;
          const f = Object.assign({}, e[r][1].end), p = Object.assign({}, e[n][1].start);
          g4(f, -l), g4(p, l), a = {
            type: l > 1 ? "strongSequence" : "emphasisSequence",
            start: f,
            end: Object.assign({}, e[r][1].end)
          }, s = {
            type: l > 1 ? "strongSequence" : "emphasisSequence",
            start: Object.assign({}, e[n][1].start),
            end: p
          }, o = {
            type: l > 1 ? "strongText" : "emphasisText",
            start: Object.assign({}, e[r][1].end),
            end: Object.assign({}, e[n][1].start)
          }, i = {
            type: l > 1 ? "strong" : "emphasis",
            start: Object.assign({}, a.start),
            end: Object.assign({}, s.end)
          }, e[r][1].end = Object.assign({}, a.start), e[n][1].start = Object.assign({}, s.end), u = [], e[r][1].end.offset - e[r][1].start.offset && (u = Ir(u, [
            ["enter", e[r][1], t],
            ["exit", e[r][1], t]
          ])), u = Ir(u, [
            ["enter", i, t],
            ["enter", a, t],
            ["exit", a, t],
            ["enter", o, t]
          ]), u = Ir(
            u,
            op(
              t.parser.constructs.insideSpan.null,
              e.slice(r + 1, n),
              t
            )
          ), u = Ir(u, [
            ["exit", o, t],
            ["enter", s, t],
            ["exit", s, t],
            ["exit", i, t]
          ]), e[n][1].end.offset - e[n][1].start.offset ? (d = 2, u = Ir(u, [
            ["enter", e[n][1], t],
            ["exit", e[n][1], t]
          ])) : d = 0, gr(e, r - 1, n - r + 3, u), n = r + u.length - d - 2;
          break;
        }
    }
  for (n = -1; ++n < e.length; )
    e[n][1].type === "attentionSequence" && (e[n][1].type = "data");
  return e;
}
function ghe(e, t) {
  const n = this.parser.constructs.attentionMarkers.null, r = this.previous, i = Uf(r);
  let o;
  return a;
  function a(l) {
    return o = l, e.enter("attentionSequence"), s(l);
  }
  function s(l) {
    if (l === o)
      return e.consume(l), s;
    const u = e.exit("attentionSequence"), d = Uf(l), f = !d || d === 2 && i || n.includes(l), p = !i || i === 2 && d || n.includes(r);
    return u._open = !!(o === 42 ? f : f && (i || !p)), u._close = !!(o === 42 ? p : p && (d || !f)), t(l);
  }
}
function g4(e, t) {
  e.column += t, e.offset += t, e._bufferIndex += t;
}
const vhe = {
  name: "autolink",
  tokenize: yhe
};
function yhe(e, t, n) {
  let r = 0;
  return i;
  function i(m) {
    return e.enter("autolink"), e.enter("autolinkMarker"), e.consume(m), e.exit("autolinkMarker"), e.enter("autolinkProtocol"), o;
  }
  function o(m) {
    return Vn(m) ? (e.consume(m), a) : u(m);
  }
  function a(m) {
    return m === 43 || m === 45 || m === 46 || Mn(m) ? (r = 1, s(m)) : u(m);
  }
  function s(m) {
    return m === 58 ? (e.consume(m), r = 0, l) : (m === 43 || m === 45 || m === 46 || Mn(m)) && r++ < 32 ? (e.consume(m), s) : (r = 0, u(m));
  }
  function l(m) {
    return m === 62 ? (e.exit("autolinkProtocol"), e.enter("autolinkMarker"), e.consume(m), e.exit("autolinkMarker"), e.exit("autolink"), t) : m === null || m === 32 || m === 60 || Wf(m) ? n(m) : (e.consume(m), l);
  }
  function u(m) {
    return m === 64 ? (e.consume(m), d) : she(m) ? (e.consume(m), u) : n(m);
  }
  function d(m) {
    return Mn(m) ? f(m) : n(m);
  }
  function f(m) {
    return m === 46 ? (e.consume(m), r = 0, d) : m === 62 ? (e.exit("autolinkProtocol").type = "autolinkEmail", e.enter("autolinkMarker"), e.consume(m), e.exit("autolinkMarker"), e.exit("autolink"), t) : p(m);
  }
  function p(m) {
    if ((m === 45 || Mn(m)) && r++ < 63) {
      const g = m === 45 ? p : f;
      return e.consume(m), g;
    }
    return n(m);
  }
}
const Uc = {
  tokenize: whe,
  partial: !0
};
function whe(e, t, n) {
  return r;
  function r(o) {
    return nt(o) ? ft(e, i, "linePrefix")(o) : i(o);
  }
  function i(o) {
    return o === null || Ve(o) ? t(o) : n(o);
  }
}
const tA = {
  name: "blockQuote",
  tokenize: bhe,
  continuation: {
    tokenize: xhe
  },
  exit: Ehe
};
function bhe(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    if (a === 62) {
      const s = r.containerState;
      return s.open || (e.enter("blockQuote", {
        _container: !0
      }), s.open = !0), e.enter("blockQuotePrefix"), e.enter("blockQuoteMarker"), e.consume(a), e.exit("blockQuoteMarker"), o;
    }
    return n(a);
  }
  function o(a) {
    return nt(a) ? (e.enter("blockQuotePrefixWhitespace"), e.consume(a), e.exit("blockQuotePrefixWhitespace"), e.exit("blockQuotePrefix"), t) : (e.exit("blockQuotePrefix"), t(a));
  }
}
function xhe(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return nt(a) ? ft(
      e,
      o,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(a) : o(a);
  }
  function o(a) {
    return e.attempt(tA, t, n)(a);
  }
}
function Ehe(e) {
  e.exit("blockQuote");
}
const nA = {
  name: "characterEscape",
  tokenize: Che
};
function Che(e, t, n) {
  return r;
  function r(o) {
    return e.enter("characterEscape"), e.enter("escapeMarker"), e.consume(o), e.exit("escapeMarker"), i;
  }
  function i(o) {
    return che(o) ? (e.enter("characterEscapeValue"), e.consume(o), e.exit("characterEscapeValue"), e.exit("characterEscape"), t) : n(o);
  }
}
const v4 = document.createElement("i");
function Sw(e) {
  const t = "&" + e + ";";
  v4.innerHTML = t;
  const n = v4.textContent;
  return (
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    n.charCodeAt(n.length - 1) === 59 && e !== "semi" || n === t ? !1 : n
  );
}
const rA = {
  name: "characterReference",
  tokenize: She
};
function She(e, t, n) {
  const r = this;
  let i = 0, o, a;
  return s;
  function s(f) {
    return e.enter("characterReference"), e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), l;
  }
  function l(f) {
    return f === 35 ? (e.enter("characterReferenceMarkerNumeric"), e.consume(f), e.exit("characterReferenceMarkerNumeric"), u) : (e.enter("characterReferenceValue"), o = 31, a = Mn, d(f));
  }
  function u(f) {
    return f === 88 || f === 120 ? (e.enter("characterReferenceMarkerHexadecimal"), e.consume(f), e.exit("characterReferenceMarkerHexadecimal"), e.enter("characterReferenceValue"), o = 6, a = lhe, d) : (e.enter("characterReferenceValue"), o = 7, a = G0, d(f));
  }
  function d(f) {
    if (f === 59 && i) {
      const p = e.exit("characterReferenceValue");
      return a === Mn && !Sw(r.sliceSerialize(p)) ? n(f) : (e.enter("characterReferenceMarker"), e.consume(f), e.exit("characterReferenceMarker"), e.exit("characterReference"), t);
    }
    return a(f) && i++ < o ? (e.consume(f), d) : n(f);
  }
}
const y4 = {
  tokenize: Phe,
  partial: !0
}, w4 = {
  name: "codeFenced",
  tokenize: _he,
  concrete: !0
};
function _he(e, t, n) {
  const r = this, i = {
    tokenize: k,
    partial: !0
  };
  let o = 0, a = 0, s;
  return l;
  function l(T) {
    return u(T);
  }
  function u(T) {
    const A = r.events[r.events.length - 1];
    return o = A && A[1].type === "linePrefix" ? A[2].sliceSerialize(A[1], !0).length : 0, s = T, e.enter("codeFenced"), e.enter("codeFencedFence"), e.enter("codeFencedFenceSequence"), d(T);
  }
  function d(T) {
    return T === s ? (a++, e.consume(T), d) : a < 3 ? n(T) : (e.exit("codeFencedFenceSequence"), nt(T) ? ft(e, f, "whitespace")(T) : f(T));
  }
  function f(T) {
    return T === null || Ve(T) ? (e.exit("codeFencedFence"), r.interrupt ? t(T) : e.check(y4, v, _)(T)) : (e.enter("codeFencedFenceInfo"), e.enter("chunkString", {
      contentType: "string"
    }), p(T));
  }
  function p(T) {
    return T === null || Ve(T) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), f(T)) : nt(T) ? (e.exit("chunkString"), e.exit("codeFencedFenceInfo"), ft(e, m, "whitespace")(T)) : T === 96 && T === s ? n(T) : (e.consume(T), p);
  }
  function m(T) {
    return T === null || Ve(T) ? f(T) : (e.enter("codeFencedFenceMeta"), e.enter("chunkString", {
      contentType: "string"
    }), g(T));
  }
  function g(T) {
    return T === null || Ve(T) ? (e.exit("chunkString"), e.exit("codeFencedFenceMeta"), f(T)) : T === 96 && T === s ? n(T) : (e.consume(T), g);
  }
  function v(T) {
    return e.attempt(i, _, y)(T);
  }
  function y(T) {
    return e.enter("lineEnding"), e.consume(T), e.exit("lineEnding"), b;
  }
  function b(T) {
    return o > 0 && nt(T) ? ft(
      e,
      E,
      "linePrefix",
      o + 1
    )(T) : E(T);
  }
  function E(T) {
    return T === null || Ve(T) ? e.check(y4, v, _)(T) : (e.enter("codeFlowValue"), S(T));
  }
  function S(T) {
    return T === null || Ve(T) ? (e.exit("codeFlowValue"), E(T)) : (e.consume(T), S);
  }
  function _(T) {
    return e.exit("codeFenced"), t(T);
  }
  function k(T, A, R) {
    let F = 0;
    return D;
    function D(G) {
      return T.enter("lineEnding"), T.consume(G), T.exit("lineEnding"), W;
    }
    function W(G) {
      return T.enter("codeFencedFence"), nt(G) ? ft(
        T,
        L,
        "linePrefix",
        r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
      )(G) : L(G);
    }
    function L(G) {
      return G === s ? (T.enter("codeFencedFenceSequence"), z(G)) : R(G);
    }
    function z(G) {
      return G === s ? (F++, T.consume(G), z) : F >= a ? (T.exit("codeFencedFenceSequence"), nt(G) ? ft(T, B, "whitespace")(G) : B(G)) : R(G);
    }
    function B(G) {
      return G === null || Ve(G) ? (T.exit("codeFencedFence"), A(G)) : R(G);
    }
  }
}
function Phe(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return a === null ? n(a) : (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), o);
  }
  function o(a) {
    return r.parser.lazy[r.now().line] ? n(a) : t(a);
  }
}
const Vg = {
  name: "codeIndented",
  tokenize: The
}, khe = {
  tokenize: Ahe,
  partial: !0
};
function The(e, t, n) {
  const r = this;
  return i;
  function i(u) {
    return e.enter("codeIndented"), ft(e, o, "linePrefix", 4 + 1)(u);
  }
  function o(u) {
    const d = r.events[r.events.length - 1];
    return d && d[1].type === "linePrefix" && d[2].sliceSerialize(d[1], !0).length >= 4 ? a(u) : n(u);
  }
  function a(u) {
    return u === null ? l(u) : Ve(u) ? e.attempt(khe, a, l)(u) : (e.enter("codeFlowValue"), s(u));
  }
  function s(u) {
    return u === null || Ve(u) ? (e.exit("codeFlowValue"), a(u)) : (e.consume(u), s);
  }
  function l(u) {
    return e.exit("codeIndented"), t(u);
  }
}
function Ahe(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return r.parser.lazy[r.now().line] ? n(a) : Ve(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), i) : ft(e, o, "linePrefix", 4 + 1)(a);
  }
  function o(a) {
    const s = r.events[r.events.length - 1];
    return s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? t(a) : Ve(a) ? i(a) : n(a);
  }
}
const Mhe = {
  name: "codeText",
  tokenize: Ihe,
  resolve: Ohe,
  previous: Rhe
};
function Ohe(e) {
  let t = e.length - 4, n = 3, r, i;
  if ((e[n][1].type === "lineEnding" || e[n][1].type === "space") && (e[t][1].type === "lineEnding" || e[t][1].type === "space")) {
    for (r = n; ++r < t; )
      if (e[r][1].type === "codeTextData") {
        e[n][1].type = "codeTextPadding", e[t][1].type = "codeTextPadding", n += 2, t -= 2;
        break;
      }
  }
  for (r = n - 1, t++; ++r <= t; )
    i === void 0 ? r !== t && e[r][1].type !== "lineEnding" && (i = r) : (r === t || e[r][1].type === "lineEnding") && (e[i][1].type = "codeTextData", r !== i + 2 && (e[i][1].end = e[r - 1][1].end, e.splice(i + 2, r - i - 2), t -= r - i - 2, r = i + 2), i = void 0);
  return e;
}
function Rhe(e) {
  return e !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function Ihe(e, t, n) {
  let r = 0, i, o;
  return a;
  function a(f) {
    return e.enter("codeText"), e.enter("codeTextSequence"), s(f);
  }
  function s(f) {
    return f === 96 ? (e.consume(f), r++, s) : (e.exit("codeTextSequence"), l(f));
  }
  function l(f) {
    return f === null ? n(f) : f === 32 ? (e.enter("space"), e.consume(f), e.exit("space"), l) : f === 96 ? (o = e.enter("codeTextSequence"), i = 0, d(f)) : Ve(f) ? (e.enter("lineEnding"), e.consume(f), e.exit("lineEnding"), l) : (e.enter("codeTextData"), u(f));
  }
  function u(f) {
    return f === null || f === 32 || f === 96 || Ve(f) ? (e.exit("codeTextData"), l(f)) : (e.consume(f), u);
  }
  function d(f) {
    return f === 96 ? (e.consume(f), i++, d) : i === r ? (e.exit("codeTextSequence"), e.exit("codeText"), t(f)) : (o.type = "codeTextData", u(f));
  }
}
function iA(e) {
  const t = {};
  let n = -1, r, i, o, a, s, l, u;
  for (; ++n < e.length; ) {
    for (; n in t; )
      n = t[n];
    if (r = e[n], n && r[1].type === "chunkFlow" && e[n - 1][1].type === "listItemPrefix" && (l = r[1]._tokenizer.events, o = 0, o < l.length && l[o][1].type === "lineEndingBlank" && (o += 2), o < l.length && l[o][1].type === "content"))
      for (; ++o < l.length && l[o][1].type !== "content"; )
        l[o][1].type === "chunkText" && (l[o][1]._isInFirstContentOfListItem = !0, o++);
    if (r[0] === "enter")
      r[1].contentType && (Object.assign(t, Dhe(e, n)), n = t[n], u = !0);
    else if (r[1]._container) {
      for (o = n, i = void 0; o-- && (a = e[o], a[1].type === "lineEnding" || a[1].type === "lineEndingBlank"); )
        a[0] === "enter" && (i && (e[i][1].type = "lineEndingBlank"), a[1].type = "lineEnding", i = o);
      i && (r[1].end = Object.assign({}, e[i][1].start), s = e.slice(i, n), s.unshift(r), gr(e, i, n - i + 1, s));
    }
  }
  return !u;
}
function Dhe(e, t) {
  const n = e[t][1], r = e[t][2];
  let i = t - 1;
  const o = [], a = n._tokenizer || r.parser[n.contentType](n.start), s = a.events, l = [], u = {};
  let d, f, p = -1, m = n, g = 0, v = 0;
  const y = [v];
  for (; m; ) {
    for (; e[++i][1] !== m; )
      ;
    o.push(i), m._tokenizer || (d = r.sliceStream(m), m.next || d.push(null), f && a.defineSkip(m.start), m._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = !0), a.write(d), m._isInFirstContentOfListItem && (a._gfmTasklistFirstContentOfListItem = void 0)), f = m, m = m.next;
  }
  for (m = n; ++p < s.length; )
    // Find a void token that includes a break.
    s[p][0] === "exit" && s[p - 1][0] === "enter" && s[p][1].type === s[p - 1][1].type && s[p][1].start.line !== s[p][1].end.line && (v = p + 1, y.push(v), m._tokenizer = void 0, m.previous = void 0, m = m.next);
  for (a.events = [], m ? (m._tokenizer = void 0, m.previous = void 0) : y.pop(), p = y.length; p--; ) {
    const b = s.slice(y[p], y[p + 1]), E = o.pop();
    l.unshift([E, E + b.length - 1]), gr(e, E, 2, b);
  }
  for (p = -1; ++p < l.length; )
    u[g + l[p][0]] = g + l[p][1], g += l[p][1] - l[p][0] - 1;
  return u;
}
const Nhe = {
  tokenize: Fhe,
  resolve: Lhe
}, $he = {
  tokenize: zhe,
  partial: !0
};
function Lhe(e) {
  return iA(e), e;
}
function Fhe(e, t) {
  let n;
  return r;
  function r(s) {
    return e.enter("content"), n = e.enter("chunkContent", {
      contentType: "content"
    }), i(s);
  }
  function i(s) {
    return s === null ? o(s) : Ve(s) ? e.check(
      $he,
      a,
      o
    )(s) : (e.consume(s), i);
  }
  function o(s) {
    return e.exit("chunkContent"), e.exit("content"), t(s);
  }
  function a(s) {
    return e.consume(s), e.exit("chunkContent"), n.next = e.enter("chunkContent", {
      contentType: "content",
      previous: n
    }), n = n.next, i;
  }
}
function zhe(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return e.exit("chunkContent"), e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), ft(e, o, "linePrefix");
  }
  function o(a) {
    if (a === null || Ve(a))
      return n(a);
    const s = r.events[r.events.length - 1];
    return !r.parser.constructs.disable.null.includes("codeIndented") && s && s[1].type === "linePrefix" && s[2].sliceSerialize(s[1], !0).length >= 4 ? t(a) : e.interrupt(r.parser.constructs.flow, n, t)(a);
  }
}
function oA(e, t, n, r, i, o, a, s, l) {
  const u = l || Number.POSITIVE_INFINITY;
  let d = 0;
  return f;
  function f(b) {
    return b === 60 ? (e.enter(r), e.enter(i), e.enter(o), e.consume(b), e.exit(o), p) : b === null || b === 32 || b === 41 || Wf(b) ? n(b) : (e.enter(r), e.enter(a), e.enter(s), e.enter("chunkString", {
      contentType: "string"
    }), v(b));
  }
  function p(b) {
    return b === 62 ? (e.enter(o), e.consume(b), e.exit(o), e.exit(i), e.exit(r), t) : (e.enter(s), e.enter("chunkString", {
      contentType: "string"
    }), m(b));
  }
  function m(b) {
    return b === 62 ? (e.exit("chunkString"), e.exit(s), p(b)) : b === null || b === 60 || Ve(b) ? n(b) : (e.consume(b), b === 92 ? g : m);
  }
  function g(b) {
    return b === 60 || b === 62 || b === 92 ? (e.consume(b), m) : m(b);
  }
  function v(b) {
    return !d && (b === null || b === 41 || Tt(b)) ? (e.exit("chunkString"), e.exit(s), e.exit(a), e.exit(r), t(b)) : d < u && b === 40 ? (e.consume(b), d++, v) : b === 41 ? (e.consume(b), d--, v) : b === null || b === 32 || b === 40 || Wf(b) ? n(b) : (e.consume(b), b === 92 ? y : v);
  }
  function y(b) {
    return b === 40 || b === 41 || b === 92 ? (e.consume(b), v) : v(b);
  }
}
function aA(e, t, n, r, i, o) {
  const a = this;
  let s = 0, l;
  return u;
  function u(m) {
    return e.enter(r), e.enter(i), e.consume(m), e.exit(i), e.enter(o), d;
  }
  function d(m) {
    return s > 999 || m === null || m === 91 || m === 93 && !l || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    m === 94 && !s && "_hiddenFootnoteSupport" in a.parser.constructs ? n(m) : m === 93 ? (e.exit(o), e.enter(i), e.consume(m), e.exit(i), e.exit(r), t) : Ve(m) ? (e.enter("lineEnding"), e.consume(m), e.exit("lineEnding"), d) : (e.enter("chunkString", {
      contentType: "string"
    }), f(m));
  }
  function f(m) {
    return m === null || m === 91 || m === 93 || Ve(m) || s++ > 999 ? (e.exit("chunkString"), d(m)) : (e.consume(m), l || (l = !nt(m)), m === 92 ? p : f);
  }
  function p(m) {
    return m === 91 || m === 92 || m === 93 ? (e.consume(m), s++, f) : f(m);
  }
}
function sA(e, t, n, r, i, o) {
  let a;
  return s;
  function s(p) {
    return p === 34 || p === 39 || p === 40 ? (e.enter(r), e.enter(i), e.consume(p), e.exit(i), a = p === 40 ? 41 : p, l) : n(p);
  }
  function l(p) {
    return p === a ? (e.enter(i), e.consume(p), e.exit(i), e.exit(r), t) : (e.enter(o), u(p));
  }
  function u(p) {
    return p === a ? (e.exit(o), l(a)) : p === null ? n(p) : Ve(p) ? (e.enter("lineEnding"), e.consume(p), e.exit("lineEnding"), ft(e, u, "linePrefix")) : (e.enter("chunkString", {
      contentType: "string"
    }), d(p));
  }
  function d(p) {
    return p === a || p === null || Ve(p) ? (e.exit("chunkString"), u(p)) : (e.consume(p), p === 92 ? f : d);
  }
  function f(p) {
    return p === a || p === 92 ? (e.consume(p), d) : d(p);
  }
}
function ec(e, t) {
  let n;
  return r;
  function r(i) {
    return Ve(i) ? (e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), n = !0, r) : nt(i) ? ft(
      e,
      r,
      n ? "linePrefix" : "lineSuffix"
    )(i) : t(i);
  }
}
function oi(e) {
  return e.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const Vhe = {
  name: "definition",
  tokenize: jhe
}, Bhe = {
  tokenize: Whe,
  partial: !0
};
function jhe(e, t, n) {
  const r = this;
  let i;
  return o;
  function o(m) {
    return e.enter("definition"), a(m);
  }
  function a(m) {
    return aA.call(
      r,
      e,
      s,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(m);
  }
  function s(m) {
    return i = oi(
      r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
    ), m === 58 ? (e.enter("definitionMarker"), e.consume(m), e.exit("definitionMarker"), l) : n(m);
  }
  function l(m) {
    return Tt(m) ? ec(e, u)(m) : u(m);
  }
  function u(m) {
    return oA(
      e,
      d,
      // Note: we don’t need to reset the way `markdown-rs` does.
      n,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(m);
  }
  function d(m) {
    return e.attempt(Bhe, f, f)(m);
  }
  function f(m) {
    return nt(m) ? ft(e, p, "whitespace")(m) : p(m);
  }
  function p(m) {
    return m === null || Ve(m) ? (e.exit("definition"), r.parser.defined.push(i), t(m)) : n(m);
  }
}
function Whe(e, t, n) {
  return r;
  function r(s) {
    return Tt(s) ? ec(e, i)(s) : n(s);
  }
  function i(s) {
    return sA(
      e,
      o,
      n,
      "definitionTitle",
      "definitionTitleMarker",
      "definitionTitleString"
    )(s);
  }
  function o(s) {
    return nt(s) ? ft(e, a, "whitespace")(s) : a(s);
  }
  function a(s) {
    return s === null || Ve(s) ? t(s) : n(s);
  }
}
const Uhe = {
  name: "hardBreakEscape",
  tokenize: Hhe
};
function Hhe(e, t, n) {
  return r;
  function r(o) {
    return e.enter("hardBreakEscape"), e.consume(o), i;
  }
  function i(o) {
    return Ve(o) ? (e.exit("hardBreakEscape"), t(o)) : n(o);
  }
}
const Ghe = {
  name: "headingAtx",
  tokenize: Yhe,
  resolve: qhe
};
function qhe(e, t) {
  let n = e.length - 2, r = 3, i, o;
  return e[r][1].type === "whitespace" && (r += 2), n - 2 > r && e[n][1].type === "whitespace" && (n -= 2), e[n][1].type === "atxHeadingSequence" && (r === n - 1 || n - 4 > r && e[n - 2][1].type === "whitespace") && (n -= r + 1 === n ? 2 : 4), n > r && (i = {
    type: "atxHeadingText",
    start: e[r][1].start,
    end: e[n][1].end
  }, o = {
    type: "chunkText",
    start: e[r][1].start,
    end: e[n][1].end,
    contentType: "text"
  }, gr(e, r, n - r + 1, [
    ["enter", i, t],
    ["enter", o, t],
    ["exit", o, t],
    ["exit", i, t]
  ])), e;
}
function Yhe(e, t, n) {
  let r = 0;
  return i;
  function i(d) {
    return e.enter("atxHeading"), o(d);
  }
  function o(d) {
    return e.enter("atxHeadingSequence"), a(d);
  }
  function a(d) {
    return d === 35 && r++ < 6 ? (e.consume(d), a) : d === null || Tt(d) ? (e.exit("atxHeadingSequence"), s(d)) : n(d);
  }
  function s(d) {
    return d === 35 ? (e.enter("atxHeadingSequence"), l(d)) : d === null || Ve(d) ? (e.exit("atxHeading"), t(d)) : nt(d) ? ft(e, s, "whitespace")(d) : (e.enter("atxHeadingText"), u(d));
  }
  function l(d) {
    return d === 35 ? (e.consume(d), l) : (e.exit("atxHeadingSequence"), s(d));
  }
  function u(d) {
    return d === null || d === 35 || Tt(d) ? (e.exit("atxHeadingText"), s(d)) : (e.consume(d), u);
  }
}
const Khe = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
], b4 = ["pre", "script", "style", "textarea"], Xhe = {
  name: "htmlFlow",
  tokenize: epe,
  resolveTo: Jhe,
  concrete: !0
}, Zhe = {
  tokenize: npe,
  partial: !0
}, Qhe = {
  tokenize: tpe,
  partial: !0
};
function Jhe(e) {
  let t = e.length;
  for (; t-- && !(e[t][0] === "enter" && e[t][1].type === "htmlFlow"); )
    ;
  return t > 1 && e[t - 2][1].type === "linePrefix" && (e[t][1].start = e[t - 2][1].start, e[t + 1][1].start = e[t - 2][1].start, e.splice(t - 2, 2)), e;
}
function epe(e, t, n) {
  const r = this;
  let i, o, a, s, l;
  return u;
  function u(N) {
    return d(N);
  }
  function d(N) {
    return e.enter("htmlFlow"), e.enter("htmlFlowData"), e.consume(N), f;
  }
  function f(N) {
    return N === 33 ? (e.consume(N), p) : N === 47 ? (e.consume(N), o = !0, v) : N === 63 ? (e.consume(N), i = 3, r.interrupt ? t : O) : Vn(N) ? (e.consume(N), a = String.fromCharCode(N), y) : n(N);
  }
  function p(N) {
    return N === 45 ? (e.consume(N), i = 2, m) : N === 91 ? (e.consume(N), i = 5, s = 0, g) : Vn(N) ? (e.consume(N), i = 4, r.interrupt ? t : O) : n(N);
  }
  function m(N) {
    return N === 45 ? (e.consume(N), r.interrupt ? t : O) : n(N);
  }
  function g(N) {
    const ee = "CDATA[";
    return N === ee.charCodeAt(s++) ? (e.consume(N), s === ee.length ? r.interrupt ? t : L : g) : n(N);
  }
  function v(N) {
    return Vn(N) ? (e.consume(N), a = String.fromCharCode(N), y) : n(N);
  }
  function y(N) {
    if (N === null || N === 47 || N === 62 || Tt(N)) {
      const ee = N === 47, ae = a.toLowerCase();
      return !ee && !o && b4.includes(ae) ? (i = 1, r.interrupt ? t(N) : L(N)) : Khe.includes(a.toLowerCase()) ? (i = 6, ee ? (e.consume(N), b) : r.interrupt ? t(N) : L(N)) : (i = 7, r.interrupt && !r.parser.lazy[r.now().line] ? n(N) : o ? E(N) : S(N));
    }
    return N === 45 || Mn(N) ? (e.consume(N), a += String.fromCharCode(N), y) : n(N);
  }
  function b(N) {
    return N === 62 ? (e.consume(N), r.interrupt ? t : L) : n(N);
  }
  function E(N) {
    return nt(N) ? (e.consume(N), E) : D(N);
  }
  function S(N) {
    return N === 47 ? (e.consume(N), D) : N === 58 || N === 95 || Vn(N) ? (e.consume(N), _) : nt(N) ? (e.consume(N), S) : D(N);
  }
  function _(N) {
    return N === 45 || N === 46 || N === 58 || N === 95 || Mn(N) ? (e.consume(N), _) : k(N);
  }
  function k(N) {
    return N === 61 ? (e.consume(N), T) : nt(N) ? (e.consume(N), k) : S(N);
  }
  function T(N) {
    return N === null || N === 60 || N === 61 || N === 62 || N === 96 ? n(N) : N === 34 || N === 39 ? (e.consume(N), l = N, A) : nt(N) ? (e.consume(N), T) : R(N);
  }
  function A(N) {
    return N === l ? (e.consume(N), l = null, F) : N === null || Ve(N) ? n(N) : (e.consume(N), A);
  }
  function R(N) {
    return N === null || N === 34 || N === 39 || N === 47 || N === 60 || N === 61 || N === 62 || N === 96 || Tt(N) ? k(N) : (e.consume(N), R);
  }
  function F(N) {
    return N === 47 || N === 62 || nt(N) ? S(N) : n(N);
  }
  function D(N) {
    return N === 62 ? (e.consume(N), W) : n(N);
  }
  function W(N) {
    return N === null || Ve(N) ? L(N) : nt(N) ? (e.consume(N), W) : n(N);
  }
  function L(N) {
    return N === 45 && i === 2 ? (e.consume(N), H) : N === 60 && i === 1 ? (e.consume(N), J) : N === 62 && i === 4 ? (e.consume(N), Q) : N === 63 && i === 3 ? (e.consume(N), O) : N === 93 && i === 5 ? (e.consume(N), Z) : Ve(N) && (i === 6 || i === 7) ? (e.exit("htmlFlowData"), e.check(
      Zhe,
      he,
      z
    )(N)) : N === null || Ve(N) ? (e.exit("htmlFlowData"), z(N)) : (e.consume(N), L);
  }
  function z(N) {
    return e.check(
      Qhe,
      B,
      he
    )(N);
  }
  function B(N) {
    return e.enter("lineEnding"), e.consume(N), e.exit("lineEnding"), G;
  }
  function G(N) {
    return N === null || Ve(N) ? z(N) : (e.enter("htmlFlowData"), L(N));
  }
  function H(N) {
    return N === 45 ? (e.consume(N), O) : L(N);
  }
  function J(N) {
    return N === 47 ? (e.consume(N), a = "", q) : L(N);
  }
  function q(N) {
    if (N === 62) {
      const ee = a.toLowerCase();
      return b4.includes(ee) ? (e.consume(N), Q) : L(N);
    }
    return Vn(N) && a.length < 8 ? (e.consume(N), a += String.fromCharCode(N), q) : L(N);
  }
  function Z(N) {
    return N === 93 ? (e.consume(N), O) : L(N);
  }
  function O(N) {
    return N === 62 ? (e.consume(N), Q) : N === 45 && i === 2 ? (e.consume(N), O) : L(N);
  }
  function Q(N) {
    return N === null || Ve(N) ? (e.exit("htmlFlowData"), he(N)) : (e.consume(N), Q);
  }
  function he(N) {
    return e.exit("htmlFlow"), t(N);
  }
}
function tpe(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return Ve(a) ? (e.enter("lineEnding"), e.consume(a), e.exit("lineEnding"), o) : n(a);
  }
  function o(a) {
    return r.parser.lazy[r.now().line] ? n(a) : t(a);
  }
}
function npe(e, t, n) {
  return r;
  function r(i) {
    return e.enter("lineEnding"), e.consume(i), e.exit("lineEnding"), e.attempt(Uc, t, n);
  }
}
const rpe = {
  name: "htmlText",
  tokenize: ipe
};
function ipe(e, t, n) {
  const r = this;
  let i, o, a;
  return s;
  function s(O) {
    return e.enter("htmlText"), e.enter("htmlTextData"), e.consume(O), l;
  }
  function l(O) {
    return O === 33 ? (e.consume(O), u) : O === 47 ? (e.consume(O), k) : O === 63 ? (e.consume(O), S) : Vn(O) ? (e.consume(O), R) : n(O);
  }
  function u(O) {
    return O === 45 ? (e.consume(O), d) : O === 91 ? (e.consume(O), o = 0, g) : Vn(O) ? (e.consume(O), E) : n(O);
  }
  function d(O) {
    return O === 45 ? (e.consume(O), m) : n(O);
  }
  function f(O) {
    return O === null ? n(O) : O === 45 ? (e.consume(O), p) : Ve(O) ? (a = f, J(O)) : (e.consume(O), f);
  }
  function p(O) {
    return O === 45 ? (e.consume(O), m) : f(O);
  }
  function m(O) {
    return O === 62 ? H(O) : O === 45 ? p(O) : f(O);
  }
  function g(O) {
    const Q = "CDATA[";
    return O === Q.charCodeAt(o++) ? (e.consume(O), o === Q.length ? v : g) : n(O);
  }
  function v(O) {
    return O === null ? n(O) : O === 93 ? (e.consume(O), y) : Ve(O) ? (a = v, J(O)) : (e.consume(O), v);
  }
  function y(O) {
    return O === 93 ? (e.consume(O), b) : v(O);
  }
  function b(O) {
    return O === 62 ? H(O) : O === 93 ? (e.consume(O), b) : v(O);
  }
  function E(O) {
    return O === null || O === 62 ? H(O) : Ve(O) ? (a = E, J(O)) : (e.consume(O), E);
  }
  function S(O) {
    return O === null ? n(O) : O === 63 ? (e.consume(O), _) : Ve(O) ? (a = S, J(O)) : (e.consume(O), S);
  }
  function _(O) {
    return O === 62 ? H(O) : S(O);
  }
  function k(O) {
    return Vn(O) ? (e.consume(O), T) : n(O);
  }
  function T(O) {
    return O === 45 || Mn(O) ? (e.consume(O), T) : A(O);
  }
  function A(O) {
    return Ve(O) ? (a = A, J(O)) : nt(O) ? (e.consume(O), A) : H(O);
  }
  function R(O) {
    return O === 45 || Mn(O) ? (e.consume(O), R) : O === 47 || O === 62 || Tt(O) ? F(O) : n(O);
  }
  function F(O) {
    return O === 47 ? (e.consume(O), H) : O === 58 || O === 95 || Vn(O) ? (e.consume(O), D) : Ve(O) ? (a = F, J(O)) : nt(O) ? (e.consume(O), F) : H(O);
  }
  function D(O) {
    return O === 45 || O === 46 || O === 58 || O === 95 || Mn(O) ? (e.consume(O), D) : W(O);
  }
  function W(O) {
    return O === 61 ? (e.consume(O), L) : Ve(O) ? (a = W, J(O)) : nt(O) ? (e.consume(O), W) : F(O);
  }
  function L(O) {
    return O === null || O === 60 || O === 61 || O === 62 || O === 96 ? n(O) : O === 34 || O === 39 ? (e.consume(O), i = O, z) : Ve(O) ? (a = L, J(O)) : nt(O) ? (e.consume(O), L) : (e.consume(O), B);
  }
  function z(O) {
    return O === i ? (e.consume(O), i = void 0, G) : O === null ? n(O) : Ve(O) ? (a = z, J(O)) : (e.consume(O), z);
  }
  function B(O) {
    return O === null || O === 34 || O === 39 || O === 60 || O === 61 || O === 96 ? n(O) : O === 47 || O === 62 || Tt(O) ? F(O) : (e.consume(O), B);
  }
  function G(O) {
    return O === 47 || O === 62 || Tt(O) ? F(O) : n(O);
  }
  function H(O) {
    return O === 62 ? (e.consume(O), e.exit("htmlTextData"), e.exit("htmlText"), t) : n(O);
  }
  function J(O) {
    return e.exit("htmlTextData"), e.enter("lineEnding"), e.consume(O), e.exit("lineEnding"), q;
  }
  function q(O) {
    return nt(O) ? ft(
      e,
      Z,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(O) : Z(O);
  }
  function Z(O) {
    return e.enter("htmlTextData"), a(O);
  }
}
const _w = {
  name: "labelEnd",
  tokenize: upe,
  resolveTo: cpe,
  resolveAll: lpe
}, ope = {
  tokenize: dpe
}, ape = {
  tokenize: fpe
}, spe = {
  tokenize: hpe
};
function lpe(e) {
  let t = -1;
  for (; ++t < e.length; ) {
    const n = e[t][1];
    (n.type === "labelImage" || n.type === "labelLink" || n.type === "labelEnd") && (e.splice(t + 1, n.type === "labelImage" ? 4 : 2), n.type = "data", t++);
  }
  return e;
}
function cpe(e, t) {
  let n = e.length, r = 0, i, o, a, s;
  for (; n--; )
    if (i = e[n][1], o) {
      if (i.type === "link" || i.type === "labelLink" && i._inactive)
        break;
      e[n][0] === "enter" && i.type === "labelLink" && (i._inactive = !0);
    } else if (a) {
      if (e[n][0] === "enter" && (i.type === "labelImage" || i.type === "labelLink") && !i._balanced && (o = n, i.type !== "labelLink")) {
        r = 2;
        break;
      }
    } else
      i.type === "labelEnd" && (a = n);
  const l = {
    type: e[o][1].type === "labelLink" ? "link" : "image",
    start: Object.assign({}, e[o][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, u = {
    type: "label",
    start: Object.assign({}, e[o][1].start),
    end: Object.assign({}, e[a][1].end)
  }, d = {
    type: "labelText",
    start: Object.assign({}, e[o + r + 2][1].end),
    end: Object.assign({}, e[a - 2][1].start)
  };
  return s = [
    ["enter", l, t],
    ["enter", u, t]
  ], s = Ir(s, e.slice(o + 1, o + r + 3)), s = Ir(s, [["enter", d, t]]), s = Ir(
    s,
    op(
      t.parser.constructs.insideSpan.null,
      e.slice(o + r + 4, a - 3),
      t
    )
  ), s = Ir(s, [
    ["exit", d, t],
    e[a - 2],
    e[a - 1],
    ["exit", u, t]
  ]), s = Ir(s, e.slice(a + 1)), s = Ir(s, [["exit", l, t]]), gr(e, o, e.length, s), e;
}
function upe(e, t, n) {
  const r = this;
  let i = r.events.length, o, a;
  for (; i--; )
    if ((r.events[i][1].type === "labelImage" || r.events[i][1].type === "labelLink") && !r.events[i][1]._balanced) {
      o = r.events[i][1];
      break;
    }
  return s;
  function s(p) {
    return o ? o._inactive ? f(p) : (a = r.parser.defined.includes(
      oi(
        r.sliceSerialize({
          start: o.end,
          end: r.now()
        })
      )
    ), e.enter("labelEnd"), e.enter("labelMarker"), e.consume(p), e.exit("labelMarker"), e.exit("labelEnd"), l) : n(p);
  }
  function l(p) {
    return p === 40 ? e.attempt(
      ope,
      d,
      a ? d : f
    )(p) : p === 91 ? e.attempt(
      ape,
      d,
      a ? u : f
    )(p) : a ? d(p) : f(p);
  }
  function u(p) {
    return e.attempt(
      spe,
      d,
      f
    )(p);
  }
  function d(p) {
    return t(p);
  }
  function f(p) {
    return o._balanced = !0, n(p);
  }
}
function dpe(e, t, n) {
  return r;
  function r(f) {
    return e.enter("resource"), e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), i;
  }
  function i(f) {
    return Tt(f) ? ec(e, o)(f) : o(f);
  }
  function o(f) {
    return f === 41 ? d(f) : oA(
      e,
      a,
      s,
      "resourceDestination",
      "resourceDestinationLiteral",
      "resourceDestinationLiteralMarker",
      "resourceDestinationRaw",
      "resourceDestinationString",
      32
    )(f);
  }
  function a(f) {
    return Tt(f) ? ec(e, l)(f) : d(f);
  }
  function s(f) {
    return n(f);
  }
  function l(f) {
    return f === 34 || f === 39 || f === 40 ? sA(
      e,
      u,
      n,
      "resourceTitle",
      "resourceTitleMarker",
      "resourceTitleString"
    )(f) : d(f);
  }
  function u(f) {
    return Tt(f) ? ec(e, d)(f) : d(f);
  }
  function d(f) {
    return f === 41 ? (e.enter("resourceMarker"), e.consume(f), e.exit("resourceMarker"), e.exit("resource"), t) : n(f);
  }
}
function fpe(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return aA.call(
      r,
      e,
      o,
      a,
      "reference",
      "referenceMarker",
      "referenceString"
    )(s);
  }
  function o(s) {
    return r.parser.defined.includes(
      oi(
        r.sliceSerialize(r.events[r.events.length - 1][1]).slice(1, -1)
      )
    ) ? t(s) : n(s);
  }
  function a(s) {
    return n(s);
  }
}
function hpe(e, t, n) {
  return r;
  function r(o) {
    return e.enter("reference"), e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), i;
  }
  function i(o) {
    return o === 93 ? (e.enter("referenceMarker"), e.consume(o), e.exit("referenceMarker"), e.exit("reference"), t) : n(o);
  }
}
const ppe = {
  name: "labelStartImage",
  tokenize: mpe,
  resolveAll: _w.resolveAll
};
function mpe(e, t, n) {
  const r = this;
  return i;
  function i(s) {
    return e.enter("labelImage"), e.enter("labelImageMarker"), e.consume(s), e.exit("labelImageMarker"), o;
  }
  function o(s) {
    return s === 91 ? (e.enter("labelMarker"), e.consume(s), e.exit("labelMarker"), e.exit("labelImage"), a) : n(s);
  }
  function a(s) {
    return s === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(s) : t(s);
  }
}
const gpe = {
  name: "labelStartLink",
  tokenize: vpe,
  resolveAll: _w.resolveAll
};
function vpe(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return e.enter("labelLink"), e.enter("labelMarker"), e.consume(a), e.exit("labelMarker"), e.exit("labelLink"), o;
  }
  function o(a) {
    return a === 94 && "_hiddenFootnoteSupport" in r.parser.constructs ? n(a) : t(a);
  }
}
const Bg = {
  name: "lineEnding",
  tokenize: ype
};
function ype(e, t) {
  return n;
  function n(r) {
    return e.enter("lineEnding"), e.consume(r), e.exit("lineEnding"), ft(e, t, "linePrefix");
  }
}
const Zd = {
  name: "thematicBreak",
  tokenize: wpe
};
function wpe(e, t, n) {
  let r = 0, i;
  return o;
  function o(u) {
    return e.enter("thematicBreak"), a(u);
  }
  function a(u) {
    return i = u, s(u);
  }
  function s(u) {
    return u === i ? (e.enter("thematicBreakSequence"), l(u)) : r >= 3 && (u === null || Ve(u)) ? (e.exit("thematicBreak"), t(u)) : n(u);
  }
  function l(u) {
    return u === i ? (e.consume(u), r++, l) : (e.exit("thematicBreakSequence"), nt(u) ? ft(e, s, "whitespace")(u) : s(u));
  }
}
const Jn = {
  name: "list",
  tokenize: Epe,
  continuation: {
    tokenize: Cpe
  },
  exit: _pe
}, bpe = {
  tokenize: Ppe,
  partial: !0
}, xpe = {
  tokenize: Spe,
  partial: !0
};
function Epe(e, t, n) {
  const r = this, i = r.events[r.events.length - 1];
  let o = i && i[1].type === "linePrefix" ? i[2].sliceSerialize(i[1], !0).length : 0, a = 0;
  return s;
  function s(m) {
    const g = r.containerState.type || (m === 42 || m === 43 || m === 45 ? "listUnordered" : "listOrdered");
    if (g === "listUnordered" ? !r.containerState.marker || m === r.containerState.marker : G0(m)) {
      if (r.containerState.type || (r.containerState.type = g, e.enter(g, {
        _container: !0
      })), g === "listUnordered")
        return e.enter("listItemPrefix"), m === 42 || m === 45 ? e.check(Zd, n, u)(m) : u(m);
      if (!r.interrupt || m === 49)
        return e.enter("listItemPrefix"), e.enter("listItemValue"), l(m);
    }
    return n(m);
  }
  function l(m) {
    return G0(m) && ++a < 10 ? (e.consume(m), l) : (!r.interrupt || a < 2) && (r.containerState.marker ? m === r.containerState.marker : m === 41 || m === 46) ? (e.exit("listItemValue"), u(m)) : n(m);
  }
  function u(m) {
    return e.enter("listItemMarker"), e.consume(m), e.exit("listItemMarker"), r.containerState.marker = r.containerState.marker || m, e.check(
      Uc,
      // Can’t be empty when interrupting.
      r.interrupt ? n : d,
      e.attempt(
        bpe,
        p,
        f
      )
    );
  }
  function d(m) {
    return r.containerState.initialBlankLine = !0, o++, p(m);
  }
  function f(m) {
    return nt(m) ? (e.enter("listItemPrefixWhitespace"), e.consume(m), e.exit("listItemPrefixWhitespace"), p) : n(m);
  }
  function p(m) {
    return r.containerState.size = o + r.sliceSerialize(e.exit("listItemPrefix"), !0).length, t(m);
  }
}
function Cpe(e, t, n) {
  const r = this;
  return r.containerState._closeFlow = void 0, e.check(Uc, i, o);
  function i(s) {
    return r.containerState.furtherBlankLines = r.containerState.furtherBlankLines || r.containerState.initialBlankLine, ft(
      e,
      t,
      "listItemIndent",
      r.containerState.size + 1
    )(s);
  }
  function o(s) {
    return r.containerState.furtherBlankLines || !nt(s) ? (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, a(s)) : (r.containerState.furtherBlankLines = void 0, r.containerState.initialBlankLine = void 0, e.attempt(xpe, t, a)(s));
  }
  function a(s) {
    return r.containerState._closeFlow = !0, r.interrupt = void 0, ft(
      e,
      e.attempt(Jn, t, n),
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(s);
  }
}
function Spe(e, t, n) {
  const r = this;
  return ft(
    e,
    i,
    "listItemIndent",
    r.containerState.size + 1
  );
  function i(o) {
    const a = r.events[r.events.length - 1];
    return a && a[1].type === "listItemIndent" && a[2].sliceSerialize(a[1], !0).length === r.containerState.size ? t(o) : n(o);
  }
}
function _pe(e) {
  e.exit(this.containerState.type);
}
function Ppe(e, t, n) {
  const r = this;
  return ft(
    e,
    i,
    "listItemPrefixWhitespace",
    r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4 + 1
  );
  function i(o) {
    const a = r.events[r.events.length - 1];
    return !nt(o) && a && a[1].type === "listItemPrefixWhitespace" ? t(o) : n(o);
  }
}
const x4 = {
  name: "setextUnderline",
  tokenize: Tpe,
  resolveTo: kpe
};
function kpe(e, t) {
  let n = e.length, r, i, o;
  for (; n--; )
    if (e[n][0] === "enter") {
      if (e[n][1].type === "content") {
        r = n;
        break;
      }
      e[n][1].type === "paragraph" && (i = n);
    } else
      e[n][1].type === "content" && e.splice(n, 1), !o && e[n][1].type === "definition" && (o = n);
  const a = {
    type: "setextHeading",
    start: Object.assign({}, e[i][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  };
  return e[i][1].type = "setextHeadingText", o ? (e.splice(i, 0, ["enter", a, t]), e.splice(o + 1, 0, ["exit", e[r][1], t]), e[r][1].end = Object.assign({}, e[o][1].end)) : e[r][1] = a, e.push(["exit", a, t]), e;
}
function Tpe(e, t, n) {
  const r = this;
  let i;
  return o;
  function o(u) {
    let d = r.events.length, f;
    for (; d--; )
      if (r.events[d][1].type !== "lineEnding" && r.events[d][1].type !== "linePrefix" && r.events[d][1].type !== "content") {
        f = r.events[d][1].type === "paragraph";
        break;
      }
    return !r.parser.lazy[r.now().line] && (r.interrupt || f) ? (e.enter("setextHeadingLine"), i = u, a(u)) : n(u);
  }
  function a(u) {
    return e.enter("setextHeadingLineSequence"), s(u);
  }
  function s(u) {
    return u === i ? (e.consume(u), s) : (e.exit("setextHeadingLineSequence"), nt(u) ? ft(e, l, "lineSuffix")(u) : l(u));
  }
  function l(u) {
    return u === null || Ve(u) ? (e.exit("setextHeadingLine"), t(u)) : n(u);
  }
}
const Ape = {
  tokenize: Mpe
};
function Mpe(e) {
  const t = this, n = e.attempt(
    // Try to parse a blank line.
    Uc,
    r,
    // Try to parse initial flow (essentially, only code).
    e.attempt(
      this.parser.constructs.flowInitial,
      i,
      ft(
        e,
        e.attempt(
          this.parser.constructs.flow,
          i,
          e.attempt(Nhe, i)
        ),
        "linePrefix"
      )
    )
  );
  return n;
  function r(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEndingBlank"), e.consume(o), e.exit("lineEndingBlank"), t.currentConstruct = void 0, n;
  }
  function i(o) {
    if (o === null) {
      e.consume(o);
      return;
    }
    return e.enter("lineEnding"), e.consume(o), e.exit("lineEnding"), t.currentConstruct = void 0, n;
  }
}
const Ope = {
  resolveAll: cA()
}, Rpe = lA("string"), Ipe = lA("text");
function lA(e) {
  return {
    tokenize: t,
    resolveAll: cA(
      e === "text" ? Dpe : void 0
    )
  };
  function t(n) {
    const r = this, i = this.parser.constructs[e], o = n.attempt(i, a, s);
    return a;
    function a(d) {
      return u(d) ? o(d) : s(d);
    }
    function s(d) {
      if (d === null) {
        n.consume(d);
        return;
      }
      return n.enter("data"), n.consume(d), l;
    }
    function l(d) {
      return u(d) ? (n.exit("data"), o(d)) : (n.consume(d), l);
    }
    function u(d) {
      if (d === null)
        return !0;
      const f = i[d];
      let p = -1;
      if (f)
        for (; ++p < f.length; ) {
          const m = f[p];
          if (!m.previous || m.previous.call(r, r.previous))
            return !0;
        }
      return !1;
    }
  }
}
function cA(e) {
  return t;
  function t(n, r) {
    let i = -1, o;
    for (; ++i <= n.length; )
      o === void 0 ? n[i] && n[i][1].type === "data" && (o = i, i++) : (!n[i] || n[i][1].type !== "data") && (i !== o + 2 && (n[o][1].end = n[i - 1][1].end, n.splice(o + 2, i - o - 2), i = o + 2), o = void 0);
    return e ? e(n, r) : n;
  }
}
function Dpe(e, t) {
  let n = 0;
  for (; ++n <= e.length; )
    if ((n === e.length || e[n][1].type === "lineEnding") && e[n - 1][1].type === "data") {
      const r = e[n - 1][1], i = t.sliceStream(r);
      let o = i.length, a = -1, s = 0, l;
      for (; o--; ) {
        const u = i[o];
        if (typeof u == "string") {
          for (a = u.length; u.charCodeAt(a - 1) === 32; )
            s++, a--;
          if (a)
            break;
          a = -1;
        } else if (u === -2)
          l = !0, s++;
        else if (u !== -1) {
          o++;
          break;
        }
      }
      if (s) {
        const u = {
          type: n === e.length || l || s < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            line: r.end.line,
            column: r.end.column - s,
            offset: r.end.offset - s,
            _index: r.start._index + o,
            _bufferIndex: o ? a : r.start._bufferIndex + a
          },
          end: Object.assign({}, r.end)
        };
        r.end = Object.assign({}, u.start), r.start.offset === r.end.offset ? Object.assign(r, u) : (e.splice(
          n,
          0,
          ["enter", u, t],
          ["exit", u, t]
        ), n += 2);
      }
      n++;
    }
  return e;
}
function Npe(e, t, n) {
  let r = Object.assign(
    n ? Object.assign({}, n) : {
      line: 1,
      column: 1,
      offset: 0
    },
    {
      _index: 0,
      _bufferIndex: -1
    }
  );
  const i = {}, o = [];
  let a = [], s = [];
  const l = {
    consume: E,
    enter: S,
    exit: _,
    attempt: A(k),
    check: A(T),
    interrupt: A(T, {
      interrupt: !0
    })
  }, u = {
    previous: null,
    code: null,
    containerState: {},
    events: [],
    parser: e,
    sliceStream: m,
    sliceSerialize: p,
    now: g,
    defineSkip: v,
    write: f
  };
  let d = t.tokenize.call(u, l);
  return t.resolveAll && o.push(t), u;
  function f(W) {
    return a = Ir(a, W), y(), a[a.length - 1] !== null ? [] : (R(t, 0), u.events = op(o, u.events, u), u.events);
  }
  function p(W, L) {
    return Lpe(m(W), L);
  }
  function m(W) {
    return $pe(a, W);
  }
  function g() {
    const { line: W, column: L, offset: z, _index: B, _bufferIndex: G } = r;
    return {
      line: W,
      column: L,
      offset: z,
      _index: B,
      _bufferIndex: G
    };
  }
  function v(W) {
    i[W.line] = W.column, D();
  }
  function y() {
    let W;
    for (; r._index < a.length; ) {
      const L = a[r._index];
      if (typeof L == "string")
        for (W = r._index, r._bufferIndex < 0 && (r._bufferIndex = 0); r._index === W && r._bufferIndex < L.length; )
          b(L.charCodeAt(r._bufferIndex));
      else
        b(L);
    }
  }
  function b(W) {
    d = d(W);
  }
  function E(W) {
    Ve(W) ? (r.line++, r.column = 1, r.offset += W === -3 ? 2 : 1, D()) : W !== -1 && (r.column++, r.offset++), r._bufferIndex < 0 ? r._index++ : (r._bufferIndex++, r._bufferIndex === a[r._index].length && (r._bufferIndex = -1, r._index++)), u.previous = W;
  }
  function S(W, L) {
    const z = L || {};
    return z.type = W, z.start = g(), u.events.push(["enter", z, u]), s.push(z), z;
  }
  function _(W) {
    const L = s.pop();
    return L.end = g(), u.events.push(["exit", L, u]), L;
  }
  function k(W, L) {
    R(W, L.from);
  }
  function T(W, L) {
    L.restore();
  }
  function A(W, L) {
    return z;
    function z(B, G, H) {
      let J, q, Z, O;
      return Array.isArray(B) ? he(B) : "tokenize" in B ? (
        // @ts-expect-error Looks like a construct.
        he([B])
      ) : Q(B);
      function Q(pe) {
        return se;
        function se(Se) {
          const le = Se !== null && pe[Se], Ee = Se !== null && pe.null, Ie = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(le) ? le : le ? [le] : [],
            ...Array.isArray(Ee) ? Ee : Ee ? [Ee] : []
          ];
          return he(Ie)(Se);
        }
      }
      function he(pe) {
        return J = pe, q = 0, pe.length === 0 ? H : N(pe[q]);
      }
      function N(pe) {
        return se;
        function se(Se) {
          return O = F(), Z = pe, pe.partial || (u.currentConstruct = pe), pe.name && u.parser.constructs.disable.null.includes(pe.name) ? ae() : pe.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            L ? Object.assign(Object.create(u), L) : u,
            l,
            ee,
            ae
          )(Se);
        }
      }
      function ee(pe) {
        return W(Z, O), G;
      }
      function ae(pe) {
        return O.restore(), ++q < J.length ? N(J[q]) : H;
      }
    }
  }
  function R(W, L) {
    W.resolveAll && !o.includes(W) && o.push(W), W.resolve && gr(
      u.events,
      L,
      u.events.length - L,
      W.resolve(u.events.slice(L), u)
    ), W.resolveTo && (u.events = W.resolveTo(u.events, u));
  }
  function F() {
    const W = g(), L = u.previous, z = u.currentConstruct, B = u.events.length, G = Array.from(s);
    return {
      restore: H,
      from: B
    };
    function H() {
      r = W, u.previous = L, u.currentConstruct = z, u.events.length = B, s = G, D();
    }
  }
  function D() {
    r.line in i && r.column < 2 && (r.column = i[r.line], r.offset += i[r.line] - 1);
  }
}
function $pe(e, t) {
  const n = t.start._index, r = t.start._bufferIndex, i = t.end._index, o = t.end._bufferIndex;
  let a;
  if (n === i)
    a = [e[n].slice(r, o)];
  else {
    if (a = e.slice(n, i), r > -1) {
      const s = a[0];
      typeof s == "string" ? a[0] = s.slice(r) : a.shift();
    }
    o > 0 && a.push(e[i].slice(0, o));
  }
  return a;
}
function Lpe(e, t) {
  let n = -1;
  const r = [];
  let i;
  for (; ++n < e.length; ) {
    const o = e[n];
    let a;
    if (typeof o == "string")
      a = o;
    else
      switch (o) {
        case -5: {
          a = "\r";
          break;
        }
        case -4: {
          a = `
`;
          break;
        }
        case -3: {
          a = `\r
`;
          break;
        }
        case -2: {
          a = t ? " " : "	";
          break;
        }
        case -1: {
          if (!t && i)
            continue;
          a = " ";
          break;
        }
        default:
          a = String.fromCharCode(o);
      }
    i = o === -2, r.push(a);
  }
  return r.join("");
}
const Fpe = {
  [42]: Jn,
  [43]: Jn,
  [45]: Jn,
  [48]: Jn,
  [49]: Jn,
  [50]: Jn,
  [51]: Jn,
  [52]: Jn,
  [53]: Jn,
  [54]: Jn,
  [55]: Jn,
  [56]: Jn,
  [57]: Jn,
  [62]: tA
}, zpe = {
  [91]: Vhe
}, Vpe = {
  [-2]: Vg,
  [-1]: Vg,
  [32]: Vg
}, Bpe = {
  [35]: Ghe,
  [42]: Zd,
  [45]: [x4, Zd],
  [60]: Xhe,
  [61]: x4,
  [95]: Zd,
  [96]: w4,
  [126]: w4
}, jpe = {
  [38]: rA,
  [92]: nA
}, Wpe = {
  [-5]: Bg,
  [-4]: Bg,
  [-3]: Bg,
  [33]: ppe,
  [38]: rA,
  [42]: q0,
  [60]: [vhe, rpe],
  [91]: gpe,
  [92]: [Uhe, nA],
  [93]: _w,
  [95]: q0,
  [96]: Mhe
}, Upe = {
  null: [q0, Ope]
}, Hpe = {
  null: [42, 95]
}, Gpe = {
  null: []
}, qpe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: Hpe,
  contentInitial: zpe,
  disable: Gpe,
  document: Fpe,
  flow: Bpe,
  flowInitial: Vpe,
  insideSpan: Upe,
  string: jpe,
  text: Wpe
}, Symbol.toStringTag, { value: "Module" }));
function Ype(e) {
  const n = (
    /** @type {FullNormalizedExtension} */
    eA([qpe, ...(e || {}).extensions || []])
  ), r = {
    defined: [],
    lazy: {},
    constructs: n,
    content: i(uhe),
    document: i(fhe),
    flow: i(Ape),
    string: i(Rpe),
    text: i(Ipe)
  };
  return r;
  function i(o) {
    return a;
    function a(s) {
      return Npe(r, o, s);
    }
  }
}
const E4 = /[\0\t\n\r]/g;
function Kpe() {
  let e = 1, t = "", n = !0, r;
  return i;
  function i(o, a, s) {
    const l = [];
    let u, d, f, p, m;
    for (o = t + o.toString(a), f = 0, t = "", n && (o.charCodeAt(0) === 65279 && f++, n = void 0); f < o.length; ) {
      if (E4.lastIndex = f, u = E4.exec(o), p = u && u.index !== void 0 ? u.index : o.length, m = o.charCodeAt(p), !u) {
        t = o.slice(f);
        break;
      }
      if (m === 10 && f === p && r)
        l.push(-3), r = void 0;
      else
        switch (r && (l.push(-5), r = void 0), f < p && (l.push(o.slice(f, p)), e += p - f), m) {
          case 0: {
            l.push(65533), e++;
            break;
          }
          case 9: {
            for (d = Math.ceil(e / 4) * 4, l.push(-2); e++ < d; )
              l.push(-1);
            break;
          }
          case 10: {
            l.push(-4), e = 1;
            break;
          }
          default:
            r = !0, e = 1;
        }
      f = p + 1;
    }
    return s && (r && l.push(-5), t && l.push(t), l.push(null)), l;
  }
}
function Xpe(e) {
  for (; !iA(e); )
    ;
  return e;
}
function uA(e, t) {
  const n = Number.parseInt(e, t);
  return (
    // C0 except for HT, LF, FF, CR, space.
    n < 9 || n === 11 || n > 13 && n < 32 || // Control character (DEL) of C0, and C1 controls.
    n > 126 && n < 160 || // Lone high surrogates and low surrogates.
    n > 55295 && n < 57344 || // Noncharacters.
    n > 64975 && n < 65008 || (n & 65535) === 65535 || (n & 65535) === 65534 || // Out of range
    n > 1114111 ? "�" : String.fromCharCode(n)
  );
}
const Zpe = /\\([!-/:-@[-`{-~])|&(#(?:\d{1,7}|x[\da-f]{1,6})|[\da-z]{1,31});/gi;
function dA(e) {
  return e.replace(Zpe, Qpe);
}
function Qpe(e, t, n) {
  if (t)
    return t;
  if (n.charCodeAt(0) === 35) {
    const i = n.charCodeAt(1), o = i === 120 || i === 88;
    return uA(n.slice(o ? 2 : 1), o ? 16 : 10);
  }
  return Sw(n) || e;
}
const fA = {}.hasOwnProperty, Jpe = (
  /**
   * @type {(
   *   ((value: Value, encoding: Encoding, options?: Options | null | undefined) => Root) &
   *   ((value: Value, options?: Options | null | undefined) => Root)
   * )}
   */
  /**
   * @param {Value} value
   * @param {Encoding | Options | null | undefined} [encoding]
   * @param {Options | null | undefined} [options]
   * @returns {Root}
   */
  function(e, t, n) {
    return typeof t != "string" && (n = t, t = void 0), eme(n)(
      Xpe(
        Ype(n).document().write(Kpe()(e, t, !0))
      )
    );
  }
);
function eme(e) {
  const t = {
    transforms: [],
    canContainEols: ["emphasis", "fragment", "heading", "paragraph", "strong"],
    enter: {
      autolink: s(Ht),
      autolinkProtocol: W,
      autolinkEmail: W,
      atxHeading: s(dt),
      blockQuote: s(Ie),
      characterEscape: W,
      characterReference: W,
      codeFenced: s(te),
      codeFencedFenceInfo: l,
      codeFencedFenceMeta: l,
      codeIndented: s(te, l),
      codeText: s(Re, l),
      codeTextData: W,
      data: W,
      codeFlowValue: W,
      definition: s(we),
      definitionDestinationString: l,
      definitionLabelString: l,
      definitionTitleString: l,
      emphasis: s(ze),
      hardBreakEscape: s(ht),
      hardBreakTrailing: s(ht),
      htmlFlow: s(vt, l),
      htmlFlowData: W,
      htmlText: s(vt, l),
      htmlTextData: W,
      image: s(mt),
      label: l,
      link: s(Ht),
      listItem: s(Wn),
      listItemValue: g,
      listOrdered: s(zt, m),
      listUnordered: s(zt),
      paragraph: s(Vr),
      reference: ae,
      referenceString: l,
      resourceDestinationString: l,
      resourceTitleString: l,
      setextHeading: s(dt),
      strong: s(gn),
      thematicBreak: s(ui)
    },
    exit: {
      atxHeading: d(),
      atxHeadingSequence: A,
      autolink: d(),
      autolinkEmail: Ee,
      autolinkProtocol: le,
      blockQuote: d(),
      characterEscapeValue: L,
      characterReferenceMarkerHexadecimal: se,
      characterReferenceMarkerNumeric: se,
      characterReferenceValue: Se,
      codeFenced: d(E),
      codeFencedFence: b,
      codeFencedFenceInfo: v,
      codeFencedFenceMeta: y,
      codeFlowValue: L,
      codeIndented: d(S),
      codeText: d(J),
      codeTextData: L,
      data: L,
      definition: d(),
      definitionDestinationString: T,
      definitionLabelString: _,
      definitionTitleString: k,
      emphasis: d(),
      hardBreakEscape: d(B),
      hardBreakTrailing: d(B),
      htmlFlow: d(G),
      htmlFlowData: L,
      htmlText: d(H),
      htmlTextData: L,
      image: d(Z),
      label: Q,
      labelText: O,
      lineEnding: z,
      link: d(q),
      listItem: d(),
      listOrdered: d(),
      listUnordered: d(),
      paragraph: d(),
      referenceString: pe,
      resourceDestinationString: he,
      resourceTitleString: N,
      resource: ee,
      setextHeading: d(D),
      setextHeadingLineSequence: F,
      setextHeadingText: R,
      strong: d(),
      thematicBreak: d()
    }
  };
  hA(t, (e || {}).mdastExtensions || []);
  const n = {};
  return r;
  function r(re) {
    let Ce = {
      type: "root",
      children: []
    };
    const Fe = {
      stack: [Ce],
      tokenStack: [],
      config: t,
      enter: u,
      exit: f,
      buffer: l,
      resume: p,
      setData: o,
      getData: a
    }, st = [];
    let lt = -1;
    for (; ++lt < re.length; )
      if (re[lt][1].type === "listOrdered" || re[lt][1].type === "listUnordered")
        if (re[lt][0] === "enter")
          st.push(lt);
        else {
          const bn = st.pop();
          lt = i(re, bn, lt);
        }
    for (lt = -1; ++lt < re.length; ) {
      const bn = t[re[lt][0]];
      fA.call(bn, re[lt][1].type) && bn[re[lt][1].type].call(
        Object.assign(
          {
            sliceSerialize: re[lt][2].sliceSerialize
          },
          Fe
        ),
        re[lt][1]
      );
    }
    if (Fe.tokenStack.length > 0) {
      const bn = Fe.tokenStack[Fe.tokenStack.length - 1];
      (bn[1] || C4).call(Fe, void 0, bn[0]);
    }
    for (Ce.position = {
      start: vo(
        re.length > 0 ? re[0][1].start : {
          line: 1,
          column: 1,
          offset: 0
        }
      ),
      end: vo(
        re.length > 0 ? re[re.length - 2][1].end : {
          line: 1,
          column: 1,
          offset: 0
        }
      )
    }, lt = -1; ++lt < t.transforms.length; )
      Ce = t.transforms[lt](Ce) || Ce;
    return Ce;
  }
  function i(re, Ce, Fe) {
    let st = Ce - 1, lt = -1, bn = !1, Un, Rn, Br, jr;
    for (; ++st <= Fe; ) {
      const Pt = re[st];
      if (Pt[1].type === "listUnordered" || Pt[1].type === "listOrdered" || Pt[1].type === "blockQuote" ? (Pt[0] === "enter" ? lt++ : lt--, jr = void 0) : Pt[1].type === "lineEndingBlank" ? Pt[0] === "enter" && (Un && !jr && !lt && !Br && (Br = st), jr = void 0) : Pt[1].type === "linePrefix" || Pt[1].type === "listItemValue" || Pt[1].type === "listItemMarker" || Pt[1].type === "listItemPrefix" || Pt[1].type === "listItemPrefixWhitespace" || (jr = void 0), !lt && Pt[0] === "enter" && Pt[1].type === "listItemPrefix" || lt === -1 && Pt[0] === "exit" && (Pt[1].type === "listUnordered" || Pt[1].type === "listOrdered")) {
        if (Un) {
          let Vo = st;
          for (Rn = void 0; Vo--; ) {
            const In = re[Vo];
            if (In[1].type === "lineEnding" || In[1].type === "lineEndingBlank") {
              if (In[0] === "exit")
                continue;
              Rn && (re[Rn][1].type = "lineEndingBlank", bn = !0), In[1].type = "lineEnding", Rn = Vo;
            } else if (!(In[1].type === "linePrefix" || In[1].type === "blockQuotePrefix" || In[1].type === "blockQuotePrefixWhitespace" || In[1].type === "blockQuoteMarker" || In[1].type === "listItemIndent"))
              break;
          }
          Br && (!Rn || Br < Rn) && (Un._spread = !0), Un.end = Object.assign(
            {},
            Rn ? re[Rn][1].start : Pt[1].end
          ), re.splice(Rn || st, 0, ["exit", Un, Pt[2]]), st++, Fe++;
        }
        Pt[1].type === "listItemPrefix" && (Un = {
          type: "listItem",
          _spread: !1,
          start: Object.assign({}, Pt[1].start),
          // @ts-expect-error: we’ll add `end` in a second.
          end: void 0
        }, re.splice(st, 0, ["enter", Un, Pt[2]]), st++, Fe++, Br = void 0, jr = !0);
      }
    }
    return re[Ce][1]._spread = bn, Fe;
  }
  function o(re, Ce) {
    n[re] = Ce;
  }
  function a(re) {
    return n[re];
  }
  function s(re, Ce) {
    return Fe;
    function Fe(st) {
      u.call(this, re(st), st), Ce && Ce.call(this, st);
    }
  }
  function l() {
    this.stack.push({
      type: "fragment",
      children: []
    });
  }
  function u(re, Ce, Fe) {
    return this.stack[this.stack.length - 1].children.push(re), this.stack.push(re), this.tokenStack.push([Ce, Fe]), re.position = {
      start: vo(Ce.start)
    }, re;
  }
  function d(re) {
    return Ce;
    function Ce(Fe) {
      re && re.call(this, Fe), f.call(this, Fe);
    }
  }
  function f(re, Ce) {
    const Fe = this.stack.pop(), st = this.tokenStack.pop();
    if (st)
      st[0].type !== re.type && (Ce ? Ce.call(this, re, st[0]) : (st[1] || C4).call(this, re, st[0]));
    else
      throw new Error(
        "Cannot close `" + re.type + "` (" + Jl({
          start: re.start,
          end: re.end
        }) + "): it’s not open"
      );
    return Fe.position.end = vo(re.end), Fe;
  }
  function p() {
    return nhe(this.stack.pop());
  }
  function m() {
    o("expectingFirstListItemValue", !0);
  }
  function g(re) {
    if (a("expectingFirstListItemValue")) {
      const Ce = this.stack[this.stack.length - 2];
      Ce.start = Number.parseInt(this.sliceSerialize(re), 10), o("expectingFirstListItemValue");
    }
  }
  function v() {
    const re = this.resume(), Ce = this.stack[this.stack.length - 1];
    Ce.lang = re;
  }
  function y() {
    const re = this.resume(), Ce = this.stack[this.stack.length - 1];
    Ce.meta = re;
  }
  function b() {
    a("flowCodeInside") || (this.buffer(), o("flowCodeInside", !0));
  }
  function E() {
    const re = this.resume(), Ce = this.stack[this.stack.length - 1];
    Ce.value = re.replace(/^(\r?\n|\r)|(\r?\n|\r)$/g, ""), o("flowCodeInside");
  }
  function S() {
    const re = this.resume(), Ce = this.stack[this.stack.length - 1];
    Ce.value = re.replace(/(\r?\n|\r)$/g, "");
  }
  function _(re) {
    const Ce = this.resume(), Fe = this.stack[this.stack.length - 1];
    Fe.label = Ce, Fe.identifier = oi(
      this.sliceSerialize(re)
    ).toLowerCase();
  }
  function k() {
    const re = this.resume(), Ce = this.stack[this.stack.length - 1];
    Ce.title = re;
  }
  function T() {
    const re = this.resume(), Ce = this.stack[this.stack.length - 1];
    Ce.url = re;
  }
  function A(re) {
    const Ce = this.stack[this.stack.length - 1];
    if (!Ce.depth) {
      const Fe = this.sliceSerialize(re).length;
      Ce.depth = Fe;
    }
  }
  function R() {
    o("setextHeadingSlurpLineEnding", !0);
  }
  function F(re) {
    const Ce = this.stack[this.stack.length - 1];
    Ce.depth = this.sliceSerialize(re).charCodeAt(0) === 61 ? 1 : 2;
  }
  function D() {
    o("setextHeadingSlurpLineEnding");
  }
  function W(re) {
    const Ce = this.stack[this.stack.length - 1];
    let Fe = Ce.children[Ce.children.length - 1];
    (!Fe || Fe.type !== "text") && (Fe = nn(), Fe.position = {
      start: vo(re.start)
    }, Ce.children.push(Fe)), this.stack.push(Fe);
  }
  function L(re) {
    const Ce = this.stack.pop();
    Ce.value += this.sliceSerialize(re), Ce.position.end = vo(re.end);
  }
  function z(re) {
    const Ce = this.stack[this.stack.length - 1];
    if (a("atHardBreak")) {
      const Fe = Ce.children[Ce.children.length - 1];
      Fe.position.end = vo(re.end), o("atHardBreak");
      return;
    }
    !a("setextHeadingSlurpLineEnding") && t.canContainEols.includes(Ce.type) && (W.call(this, re), L.call(this, re));
  }
  function B() {
    o("atHardBreak", !0);
  }
  function G() {
    const re = this.resume(), Ce = this.stack[this.stack.length - 1];
    Ce.value = re;
  }
  function H() {
    const re = this.resume(), Ce = this.stack[this.stack.length - 1];
    Ce.value = re;
  }
  function J() {
    const re = this.resume(), Ce = this.stack[this.stack.length - 1];
    Ce.value = re;
  }
  function q() {
    const re = this.stack[this.stack.length - 1];
    if (a("inReference")) {
      const Ce = a("referenceType") || "shortcut";
      re.type += "Reference", re.referenceType = Ce, delete re.url, delete re.title;
    } else
      delete re.identifier, delete re.label;
    o("referenceType");
  }
  function Z() {
    const re = this.stack[this.stack.length - 1];
    if (a("inReference")) {
      const Ce = a("referenceType") || "shortcut";
      re.type += "Reference", re.referenceType = Ce, delete re.url, delete re.title;
    } else
      delete re.identifier, delete re.label;
    o("referenceType");
  }
  function O(re) {
    const Ce = this.sliceSerialize(re), Fe = this.stack[this.stack.length - 2];
    Fe.label = dA(Ce), Fe.identifier = oi(Ce).toLowerCase();
  }
  function Q() {
    const re = this.stack[this.stack.length - 1], Ce = this.resume(), Fe = this.stack[this.stack.length - 1];
    if (o("inReference", !0), Fe.type === "link") {
      const st = re.children;
      Fe.children = st;
    } else
      Fe.alt = Ce;
  }
  function he() {
    const re = this.resume(), Ce = this.stack[this.stack.length - 1];
    Ce.url = re;
  }
  function N() {
    const re = this.resume(), Ce = this.stack[this.stack.length - 1];
    Ce.title = re;
  }
  function ee() {
    o("inReference");
  }
  function ae() {
    o("referenceType", "collapsed");
  }
  function pe(re) {
    const Ce = this.resume(), Fe = this.stack[this.stack.length - 1];
    Fe.label = Ce, Fe.identifier = oi(
      this.sliceSerialize(re)
    ).toLowerCase(), o("referenceType", "full");
  }
  function se(re) {
    o("characterReferenceType", re.type);
  }
  function Se(re) {
    const Ce = this.sliceSerialize(re), Fe = a("characterReferenceType");
    let st;
    Fe ? (st = uA(
      Ce,
      Fe === "characterReferenceMarkerNumeric" ? 10 : 16
    ), o("characterReferenceType")) : st = Sw(Ce);
    const lt = this.stack.pop();
    lt.value += st, lt.position.end = vo(re.end);
  }
  function le(re) {
    L.call(this, re);
    const Ce = this.stack[this.stack.length - 1];
    Ce.url = this.sliceSerialize(re);
  }
  function Ee(re) {
    L.call(this, re);
    const Ce = this.stack[this.stack.length - 1];
    Ce.url = "mailto:" + this.sliceSerialize(re);
  }
  function Ie() {
    return {
      type: "blockquote",
      children: []
    };
  }
  function te() {
    return {
      type: "code",
      lang: null,
      meta: null,
      value: ""
    };
  }
  function Re() {
    return {
      type: "inlineCode",
      value: ""
    };
  }
  function we() {
    return {
      type: "definition",
      identifier: "",
      label: null,
      title: null,
      url: ""
    };
  }
  function ze() {
    return {
      type: "emphasis",
      children: []
    };
  }
  function dt() {
    return {
      type: "heading",
      depth: void 0,
      children: []
    };
  }
  function ht() {
    return {
      type: "break"
    };
  }
  function vt() {
    return {
      type: "html",
      value: ""
    };
  }
  function mt() {
    return {
      type: "image",
      title: null,
      url: "",
      alt: null
    };
  }
  function Ht() {
    return {
      type: "link",
      title: null,
      url: "",
      children: []
    };
  }
  function zt(re) {
    return {
      type: "list",
      ordered: re.type === "listOrdered",
      start: null,
      spread: re._spread,
      children: []
    };
  }
  function Wn(re) {
    return {
      type: "listItem",
      spread: re._spread,
      checked: null,
      children: []
    };
  }
  function Vr() {
    return {
      type: "paragraph",
      children: []
    };
  }
  function gn() {
    return {
      type: "strong",
      children: []
    };
  }
  function nn() {
    return {
      type: "text",
      value: ""
    };
  }
  function ui() {
    return {
      type: "thematicBreak"
    };
  }
}
function vo(e) {
  return {
    line: e.line,
    column: e.column,
    offset: e.offset
  };
}
function hA(e, t) {
  let n = -1;
  for (; ++n < t.length; ) {
    const r = t[n];
    Array.isArray(r) ? hA(e, r) : tme(e, r);
  }
}
function tme(e, t) {
  let n;
  for (n in t)
    if (fA.call(t, n)) {
      if (n === "canContainEols") {
        const r = t[n];
        r && e[n].push(...r);
      } else if (n === "transforms") {
        const r = t[n];
        r && e[n].push(...r);
      } else if (n === "enter" || n === "exit") {
        const r = t[n];
        r && Object.assign(e[n], r);
      }
    }
}
function C4(e, t) {
  throw e ? new Error(
    "Cannot close `" + e.type + "` (" + Jl({
      start: e.start,
      end: e.end
    }) + "): a different token (`" + t.type + "`, " + Jl({
      start: t.start,
      end: t.end
    }) + ") is open"
  ) : new Error(
    "Cannot close document, a token (`" + t.type + "`, " + Jl({
      start: t.start,
      end: t.end
    }) + ") is still open"
  );
}
function nme(e) {
  Object.assign(this, { Parser: (n) => {
    const r = (
      /** @type {Options} */
      this.data("settings")
    );
    return Jpe(
      n,
      Object.assign({}, r, e, {
        // Note: these options are not in the readme.
        // The goal is for them to be set by plugins on `data` instead of being
        // passed by users.
        extensions: this.data("micromarkExtensions") || [],
        mdastExtensions: this.data("fromMarkdownExtensions") || []
      })
    );
  } });
}
function rme(e, t) {
  const n = {
    type: "element",
    tagName: "blockquote",
    properties: {},
    children: e.wrap(e.all(t), !0)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function ime(e, t) {
  const n = { type: "element", tagName: "br", properties: {}, children: [] };
  return e.patch(t, n), [e.applyData(t, n), { type: "text", value: `
` }];
}
function ome(e, t) {
  const n = t.value ? t.value + `
` : "", r = t.lang ? t.lang.match(/^[^ \t]+(?=[ \t]|$)/) : null, i = {};
  r && (i.className = ["language-" + r]);
  let o = {
    type: "element",
    tagName: "code",
    properties: i,
    children: [{ type: "text", value: n }]
  };
  return t.meta && (o.data = { meta: t.meta }), e.patch(t, o), o = e.applyData(t, o), o = { type: "element", tagName: "pre", properties: {}, children: [o] }, e.patch(t, o), o;
}
function ame(e, t) {
  const n = {
    type: "element",
    tagName: "del",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function sme(e, t) {
  const n = {
    type: "element",
    tagName: "em",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function Qs(e) {
  const t = [];
  let n = -1, r = 0, i = 0;
  for (; ++n < e.length; ) {
    const o = e.charCodeAt(n);
    let a = "";
    if (o === 37 && Mn(e.charCodeAt(n + 1)) && Mn(e.charCodeAt(n + 2)))
      i = 2;
    else if (o < 128)
      /[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(o)) || (a = String.fromCharCode(o));
    else if (o > 55295 && o < 57344) {
      const s = e.charCodeAt(n + 1);
      o < 56320 && s > 56319 && s < 57344 ? (a = String.fromCharCode(o, s), i = 1) : a = "�";
    } else
      a = String.fromCharCode(o);
    a && (t.push(e.slice(r, n), encodeURIComponent(a)), r = n + i + 1, a = ""), i && (n += i, i = 0);
  }
  return t.join("") + e.slice(r);
}
function pA(e, t) {
  const n = String(t.identifier).toUpperCase(), r = Qs(n.toLowerCase()), i = e.footnoteOrder.indexOf(n);
  let o;
  i === -1 ? (e.footnoteOrder.push(n), e.footnoteCounts[n] = 1, o = e.footnoteOrder.length) : (e.footnoteCounts[n]++, o = i + 1);
  const a = e.footnoteCounts[n], s = {
    type: "element",
    tagName: "a",
    properties: {
      href: "#" + e.clobberPrefix + "fn-" + r,
      id: e.clobberPrefix + "fnref-" + r + (a > 1 ? "-" + a : ""),
      dataFootnoteRef: !0,
      ariaDescribedBy: ["footnote-label"]
    },
    children: [{ type: "text", value: String(o) }]
  };
  e.patch(t, s);
  const l = {
    type: "element",
    tagName: "sup",
    properties: {},
    children: [s]
  };
  return e.patch(t, l), e.applyData(t, l);
}
function lme(e, t) {
  const n = e.footnoteById;
  let r = 1;
  for (; r in n; )
    r++;
  const i = String(r);
  return n[i] = {
    type: "footnoteDefinition",
    identifier: i,
    children: [{ type: "paragraph", children: t.children }],
    position: t.position
  }, pA(e, {
    type: "footnoteReference",
    identifier: i,
    position: t.position
  });
}
function cme(e, t) {
  const n = {
    type: "element",
    tagName: "h" + t.depth,
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function ume(e, t) {
  if (e.dangerous) {
    const n = { type: "raw", value: t.value };
    return e.patch(t, n), e.applyData(t, n);
  }
  return null;
}
function mA(e, t) {
  const n = t.referenceType;
  let r = "]";
  if (n === "collapsed" ? r += "[]" : n === "full" && (r += "[" + (t.label || t.identifier) + "]"), t.type === "imageReference")
    return { type: "text", value: "![" + t.alt + r };
  const i = e.all(t), o = i[0];
  o && o.type === "text" ? o.value = "[" + o.value : i.unshift({ type: "text", value: "[" });
  const a = i[i.length - 1];
  return a && a.type === "text" ? a.value += r : i.push({ type: "text", value: r }), i;
}
function dme(e, t) {
  const n = e.definition(t.identifier);
  if (!n)
    return mA(e, t);
  const r = { src: Qs(n.url || ""), alt: t.alt };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = { type: "element", tagName: "img", properties: r, children: [] };
  return e.patch(t, i), e.applyData(t, i);
}
function fme(e, t) {
  const n = { src: Qs(t.url) };
  t.alt !== null && t.alt !== void 0 && (n.alt = t.alt), t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = { type: "element", tagName: "img", properties: n, children: [] };
  return e.patch(t, r), e.applyData(t, r);
}
function hme(e, t) {
  const n = { type: "text", value: t.value.replace(/\r?\n|\r/g, " ") };
  e.patch(t, n);
  const r = {
    type: "element",
    tagName: "code",
    properties: {},
    children: [n]
  };
  return e.patch(t, r), e.applyData(t, r);
}
function pme(e, t) {
  const n = e.definition(t.identifier);
  if (!n)
    return mA(e, t);
  const r = { href: Qs(n.url || "") };
  n.title !== null && n.title !== void 0 && (r.title = n.title);
  const i = {
    type: "element",
    tagName: "a",
    properties: r,
    children: e.all(t)
  };
  return e.patch(t, i), e.applyData(t, i);
}
function mme(e, t) {
  const n = { href: Qs(t.url) };
  t.title !== null && t.title !== void 0 && (n.title = t.title);
  const r = {
    type: "element",
    tagName: "a",
    properties: n,
    children: e.all(t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function gme(e, t, n) {
  const r = e.all(t), i = n ? vme(n) : gA(t), o = {}, a = [];
  if (typeof t.checked == "boolean") {
    const d = r[0];
    let f;
    d && d.type === "element" && d.tagName === "p" ? f = d : (f = { type: "element", tagName: "p", properties: {}, children: [] }, r.unshift(f)), f.children.length > 0 && f.children.unshift({ type: "text", value: " " }), f.children.unshift({
      type: "element",
      tagName: "input",
      properties: { type: "checkbox", checked: t.checked, disabled: !0 },
      children: []
    }), o.className = ["task-list-item"];
  }
  let s = -1;
  for (; ++s < r.length; ) {
    const d = r[s];
    (i || s !== 0 || d.type !== "element" || d.tagName !== "p") && a.push({ type: "text", value: `
` }), d.type === "element" && d.tagName === "p" && !i ? a.push(...d.children) : a.push(d);
  }
  const l = r[r.length - 1];
  l && (i || l.type !== "element" || l.tagName !== "p") && a.push({ type: "text", value: `
` });
  const u = { type: "element", tagName: "li", properties: o, children: a };
  return e.patch(t, u), e.applyData(t, u);
}
function vme(e) {
  let t = !1;
  if (e.type === "list") {
    t = e.spread || !1;
    const n = e.children;
    let r = -1;
    for (; !t && ++r < n.length; )
      t = gA(n[r]);
  }
  return t;
}
function gA(e) {
  const t = e.spread;
  return t ?? e.children.length > 1;
}
function yme(e, t) {
  const n = {}, r = e.all(t);
  let i = -1;
  for (typeof t.start == "number" && t.start !== 1 && (n.start = t.start); ++i < r.length; ) {
    const a = r[i];
    if (a.type === "element" && a.tagName === "li" && a.properties && Array.isArray(a.properties.className) && a.properties.className.includes("task-list-item")) {
      n.className = ["contains-task-list"];
      break;
    }
  }
  const o = {
    type: "element",
    tagName: t.ordered ? "ol" : "ul",
    properties: n,
    children: e.wrap(r, !0)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function wme(e, t) {
  const n = {
    type: "element",
    tagName: "p",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
function bme(e, t) {
  const n = { type: "root", children: e.wrap(e.all(t)) };
  return e.patch(t, n), e.applyData(t, n);
}
function xme(e, t) {
  const n = {
    type: "element",
    tagName: "strong",
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const Pw = vA("start"), kw = vA("end");
function Eme(e) {
  return { start: Pw(e), end: kw(e) };
}
function vA(e) {
  return t;
  function t(n) {
    const r = n && n.position && n.position[e] || {};
    return {
      // @ts-expect-error: in practice, null is allowed.
      line: r.line || null,
      // @ts-expect-error: in practice, null is allowed.
      column: r.column || null,
      // @ts-expect-error: in practice, null is allowed.
      offset: r.offset > -1 ? r.offset : null
    };
  }
}
function Cme(e, t) {
  const n = e.all(t), r = n.shift(), i = [];
  if (r) {
    const a = {
      type: "element",
      tagName: "thead",
      properties: {},
      children: e.wrap([r], !0)
    };
    e.patch(t.children[0], a), i.push(a);
  }
  if (n.length > 0) {
    const a = {
      type: "element",
      tagName: "tbody",
      properties: {},
      children: e.wrap(n, !0)
    }, s = Pw(t.children[1]), l = kw(t.children[t.children.length - 1]);
    s.line && l.line && (a.position = { start: s, end: l }), i.push(a);
  }
  const o = {
    type: "element",
    tagName: "table",
    properties: {},
    children: e.wrap(i, !0)
  };
  return e.patch(t, o), e.applyData(t, o);
}
function Sme(e, t, n) {
  const r = n ? n.children : void 0, o = (r ? r.indexOf(t) : 1) === 0 ? "th" : "td", a = n && n.type === "table" ? n.align : void 0, s = a ? a.length : t.children.length;
  let l = -1;
  const u = [];
  for (; ++l < s; ) {
    const f = t.children[l], p = {}, m = a ? a[l] : void 0;
    m && (p.align = m);
    let g = { type: "element", tagName: o, properties: p, children: [] };
    f && (g.children = e.all(f), e.patch(f, g), g = e.applyData(t, g)), u.push(g);
  }
  const d = {
    type: "element",
    tagName: "tr",
    properties: {},
    children: e.wrap(u, !0)
  };
  return e.patch(t, d), e.applyData(t, d);
}
function _me(e, t) {
  const n = {
    type: "element",
    tagName: "td",
    // Assume body cell.
    properties: {},
    children: e.all(t)
  };
  return e.patch(t, n), e.applyData(t, n);
}
const S4 = 9, _4 = 32;
function Pme(e) {
  const t = String(e), n = /\r?\n|\r/g;
  let r = n.exec(t), i = 0;
  const o = [];
  for (; r; )
    o.push(
      P4(t.slice(i, r.index), i > 0, !0),
      r[0]
    ), i = r.index + r[0].length, r = n.exec(t);
  return o.push(P4(t.slice(i), i > 0, !1)), o.join("");
}
function P4(e, t, n) {
  let r = 0, i = e.length;
  if (t) {
    let o = e.codePointAt(r);
    for (; o === S4 || o === _4; )
      r++, o = e.codePointAt(r);
  }
  if (n) {
    let o = e.codePointAt(i - 1);
    for (; o === S4 || o === _4; )
      i--, o = e.codePointAt(i - 1);
  }
  return i > r ? e.slice(r, i) : "";
}
function kme(e, t) {
  const n = { type: "text", value: Pme(String(t.value)) };
  return e.patch(t, n), e.applyData(t, n);
}
function Tme(e, t) {
  const n = {
    type: "element",
    tagName: "hr",
    properties: {},
    children: []
  };
  return e.patch(t, n), e.applyData(t, n);
}
const Ame = {
  blockquote: rme,
  break: ime,
  code: ome,
  delete: ame,
  emphasis: sme,
  footnoteReference: pA,
  footnote: lme,
  heading: cme,
  html: ume,
  imageReference: dme,
  image: fme,
  inlineCode: hme,
  linkReference: pme,
  link: mme,
  listItem: gme,
  list: yme,
  paragraph: wme,
  root: bme,
  strong: xme,
  table: Cme,
  tableCell: _me,
  tableRow: Sme,
  text: kme,
  thematicBreak: Tme,
  toml: _d,
  yaml: _d,
  definition: _d,
  footnoteDefinition: _d
};
function _d() {
  return null;
}
const Tw = (
  /**
   * @type {(
   *   (<Kind extends Node>(test: PredicateTest<Kind>) => AssertPredicate<Kind>) &
   *   ((test?: Test) => AssertAnything)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {AssertAnything}
   */
  function(e) {
    if (e == null)
      return Ime;
    if (typeof e == "string")
      return Rme(e);
    if (typeof e == "object")
      return Array.isArray(e) ? Mme(e) : Ome(e);
    if (typeof e == "function")
      return ap(e);
    throw new Error("Expected function, string, or object as test");
  }
);
function Mme(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.length; )
    t[n] = Tw(e[n]);
  return ap(r);
  function r(...i) {
    let o = -1;
    for (; ++o < t.length; )
      if (t[o].call(this, ...i))
        return !0;
    return !1;
  }
}
function Ome(e) {
  return ap(t);
  function t(n) {
    let r;
    for (r in e)
      if (n[r] !== e[r])
        return !1;
    return !0;
  }
}
function Rme(e) {
  return ap(t);
  function t(n) {
    return n && n.type === e;
  }
}
function ap(e) {
  return t;
  function t(n, ...r) {
    return !!(n && typeof n == "object" && "type" in n && e.call(this, n, ...r));
  }
}
function Ime() {
  return !0;
}
const Dme = !0, k4 = !1, Nme = "skip", yA = (
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {Test} test
   * @param {Visitor<Node>} visitor
   * @param {boolean | null | undefined} [reverse]
   * @returns {void}
   */
  function(e, t, n, r) {
    typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null);
    const i = Tw(t), o = r ? -1 : 1;
    a(e, void 0, [])();
    function a(s, l, u) {
      const d = s && typeof s == "object" ? s : {};
      if (typeof d.type == "string") {
        const p = (
          // `hast`
          typeof d.tagName == "string" ? d.tagName : (
            // `xast`
            typeof d.name == "string" ? d.name : void 0
          )
        );
        Object.defineProperty(f, "name", {
          value: "node (" + (s.type + (p ? "<" + p + ">" : "")) + ")"
        });
      }
      return f;
      function f() {
        let p = [], m, g, v;
        if ((!t || i(s, l, u[u.length - 1] || null)) && (p = $me(n(s, u)), p[0] === k4))
          return p;
        if (s.children && p[0] !== Nme)
          for (g = (r ? s.children.length : -1) + o, v = u.concat(s); g > -1 && g < s.children.length; ) {
            if (m = a(s.children[g], g, v)(), m[0] === k4)
              return m;
            g = typeof m[1] == "number" ? m[1] : g + o;
          }
        return p;
      }
    }
  }
);
function $me(e) {
  return Array.isArray(e) ? e : typeof e == "number" ? [Dme, e] : [e];
}
const Aw = (
  /**
   * @type {(
   *   (<Tree extends Node, Check extends Test>(tree: Tree, test: Check, visitor: BuildVisitor<Tree, Check>, reverse?: boolean | null | undefined) => void) &
   *   (<Tree extends Node>(tree: Tree, visitor: BuildVisitor<Tree>, reverse?: boolean | null | undefined) => void)
   * )}
   */
  /**
   * @param {Node} tree
   * @param {Test} test
   * @param {Visitor} visitor
   * @param {boolean | null | undefined} [reverse]
   * @returns {void}
   */
  function(e, t, n, r) {
    typeof t == "function" && typeof n != "function" && (r = n, n = t, t = null), yA(e, t, i, r);
    function i(o, a) {
      const s = a[a.length - 1];
      return n(
        o,
        s ? s.children.indexOf(o) : null,
        s
      );
    }
  }
);
function Lme(e) {
  return !e || !e.position || !e.position.start || !e.position.start.line || !e.position.start.column || !e.position.end || !e.position.end.line || !e.position.end.column;
}
const T4 = {}.hasOwnProperty;
function Fme(e) {
  const t = /* @__PURE__ */ Object.create(null);
  if (!e || !e.type)
    throw new Error("mdast-util-definitions expected node");
  return Aw(e, "definition", (r) => {
    const i = A4(r.identifier);
    i && !T4.call(t, i) && (t[i] = r);
  }), n;
  function n(r) {
    const i = A4(r);
    return i && T4.call(t, i) ? t[i] : null;
  }
}
function A4(e) {
  return String(e || "").toUpperCase();
}
const Hf = {}.hasOwnProperty;
function zme(e, t) {
  const n = t || {}, r = n.allowDangerousHtml || !1, i = {};
  return a.dangerous = r, a.clobberPrefix = n.clobberPrefix === void 0 || n.clobberPrefix === null ? "user-content-" : n.clobberPrefix, a.footnoteLabel = n.footnoteLabel || "Footnotes", a.footnoteLabelTagName = n.footnoteLabelTagName || "h2", a.footnoteLabelProperties = n.footnoteLabelProperties || {
    className: ["sr-only"]
  }, a.footnoteBackLabel = n.footnoteBackLabel || "Back to content", a.unknownHandler = n.unknownHandler, a.passThrough = n.passThrough, a.handlers = { ...Ame, ...n.handlers }, a.definition = Fme(e), a.footnoteById = i, a.footnoteOrder = [], a.footnoteCounts = {}, a.patch = Vme, a.applyData = Bme, a.one = s, a.all = l, a.wrap = Wme, a.augment = o, Aw(e, "footnoteDefinition", (u) => {
    const d = String(u.identifier).toUpperCase();
    Hf.call(i, d) || (i[d] = u);
  }), a;
  function o(u, d) {
    if (u && "data" in u && u.data) {
      const f = u.data;
      f.hName && (d.type !== "element" && (d = {
        type: "element",
        tagName: "",
        properties: {},
        children: []
      }), d.tagName = f.hName), d.type === "element" && f.hProperties && (d.properties = { ...d.properties, ...f.hProperties }), "children" in d && d.children && f.hChildren && (d.children = f.hChildren);
    }
    if (u) {
      const f = "type" in u ? u : { position: u };
      Lme(f) || (d.position = { start: Pw(f), end: kw(f) });
    }
    return d;
  }
  function a(u, d, f, p) {
    return Array.isArray(f) && (p = f, f = {}), o(u, {
      type: "element",
      tagName: d,
      properties: f || {},
      children: p || []
    });
  }
  function s(u, d) {
    return wA(a, u, d);
  }
  function l(u) {
    return Mw(a, u);
  }
}
function Vme(e, t) {
  e.position && (t.position = Eme(e));
}
function Bme(e, t) {
  let n = t;
  if (e && e.data) {
    const r = e.data.hName, i = e.data.hChildren, o = e.data.hProperties;
    typeof r == "string" && (n.type === "element" ? n.tagName = r : n = {
      type: "element",
      tagName: r,
      properties: {},
      children: []
    }), n.type === "element" && o && (n.properties = { ...n.properties, ...o }), "children" in n && n.children && i !== null && i !== void 0 && (n.children = i);
  }
  return n;
}
function wA(e, t, n) {
  const r = t && t.type;
  if (!r)
    throw new Error("Expected node, got `" + t + "`");
  return Hf.call(e.handlers, r) ? e.handlers[r](e, t, n) : e.passThrough && e.passThrough.includes(r) ? "children" in t ? { ...t, children: Mw(e, t) } : t : e.unknownHandler ? e.unknownHandler(e, t, n) : jme(e, t);
}
function Mw(e, t) {
  const n = [];
  if ("children" in t) {
    const r = t.children;
    let i = -1;
    for (; ++i < r.length; ) {
      const o = wA(e, r[i], t);
      if (o) {
        if (i && r[i - 1].type === "break" && (!Array.isArray(o) && o.type === "text" && (o.value = o.value.replace(/^\s+/, "")), !Array.isArray(o) && o.type === "element")) {
          const a = o.children[0];
          a && a.type === "text" && (a.value = a.value.replace(/^\s+/, ""));
        }
        Array.isArray(o) ? n.push(...o) : n.push(o);
      }
    }
  }
  return n;
}
function jme(e, t) {
  const n = t.data || {}, r = "value" in t && !(Hf.call(n, "hProperties") || Hf.call(n, "hChildren")) ? { type: "text", value: t.value } : {
    type: "element",
    tagName: "div",
    properties: {},
    children: Mw(e, t)
  };
  return e.patch(t, r), e.applyData(t, r);
}
function Wme(e, t) {
  const n = [];
  let r = -1;
  for (t && n.push({ type: "text", value: `
` }); ++r < e.length; )
    r && n.push({ type: "text", value: `
` }), n.push(e[r]);
  return t && e.length > 0 && n.push({ type: "text", value: `
` }), n;
}
function Ume(e) {
  const t = [];
  let n = -1;
  for (; ++n < e.footnoteOrder.length; ) {
    const r = e.footnoteById[e.footnoteOrder[n]];
    if (!r)
      continue;
    const i = e.all(r), o = String(r.identifier).toUpperCase(), a = Qs(o.toLowerCase());
    let s = 0;
    const l = [];
    for (; ++s <= e.footnoteCounts[o]; ) {
      const f = {
        type: "element",
        tagName: "a",
        properties: {
          href: "#" + e.clobberPrefix + "fnref-" + a + (s > 1 ? "-" + s : ""),
          dataFootnoteBackref: !0,
          className: ["data-footnote-backref"],
          ariaLabel: e.footnoteBackLabel
        },
        children: [{ type: "text", value: "↩" }]
      };
      s > 1 && f.children.push({
        type: "element",
        tagName: "sup",
        children: [{ type: "text", value: String(s) }]
      }), l.length > 0 && l.push({ type: "text", value: " " }), l.push(f);
    }
    const u = i[i.length - 1];
    if (u && u.type === "element" && u.tagName === "p") {
      const f = u.children[u.children.length - 1];
      f && f.type === "text" ? f.value += " " : u.children.push({ type: "text", value: " " }), u.children.push(...l);
    } else
      i.push(...l);
    const d = {
      type: "element",
      tagName: "li",
      properties: { id: e.clobberPrefix + "fn-" + a },
      children: e.wrap(i, !0)
    };
    e.patch(r, d), t.push(d);
  }
  if (t.length !== 0)
    return {
      type: "element",
      tagName: "section",
      properties: { dataFootnotes: !0, className: ["footnotes"] },
      children: [
        {
          type: "element",
          tagName: e.footnoteLabelTagName,
          properties: {
            // To do: use structured clone.
            ...JSON.parse(JSON.stringify(e.footnoteLabelProperties)),
            id: "footnote-label"
          },
          children: [{ type: "text", value: e.footnoteLabel }]
        },
        { type: "text", value: `
` },
        {
          type: "element",
          tagName: "ol",
          properties: {},
          children: e.wrap(t, !0)
        },
        { type: "text", value: `
` }
      ]
    };
}
function bA(e, t) {
  const n = zme(e, t), r = n.one(e, null), i = Ume(n);
  return i && r.children.push({ type: "text", value: `
` }, i), Array.isArray(r) ? { type: "root", children: r } : r;
}
const Hme = (
  /** @type {(import('unified').Plugin<[Processor, Options?]|[null|undefined, Options?]|[Options]|[], MdastRoot>)} */
  function(e, t) {
    return e && "run" in e ? qme(e, t) : Yme(e || t);
  }
), Gme = Hme;
function qme(e, t) {
  return (n, r, i) => {
    e.run(bA(n, t), r, (o) => {
      i(o);
    });
  };
}
function Yme(e) {
  return (t) => bA(t, e);
}
class Hc {
  /**
   * @constructor
   * @param {Properties} property
   * @param {Normal} normal
   * @param {string} [space]
   */
  constructor(t, n, r) {
    this.property = t, this.normal = n, r && (this.space = r);
  }
}
Hc.prototype.property = {};
Hc.prototype.normal = {};
Hc.prototype.space = null;
function xA(e, t) {
  const n = {}, r = {};
  let i = -1;
  for (; ++i < e.length; )
    Object.assign(n, e[i].property), Object.assign(r, e[i].normal);
  return new Hc(n, r, t);
}
function Y0(e) {
  return e.toLowerCase();
}
class zr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   */
  constructor(t, n) {
    this.property = t, this.attribute = n;
  }
}
zr.prototype.space = null;
zr.prototype.boolean = !1;
zr.prototype.booleanish = !1;
zr.prototype.overloadedBoolean = !1;
zr.prototype.number = !1;
zr.prototype.commaSeparated = !1;
zr.prototype.spaceSeparated = !1;
zr.prototype.commaOrSpaceSeparated = !1;
zr.prototype.mustUseProperty = !1;
zr.prototype.defined = !1;
let Kme = 0;
const Ye = Ra(), on = Ra(), EA = Ra(), Pe = Ra(), Ot = Ra(), Ss = Ra(), dr = Ra();
function Ra() {
  return 2 ** ++Kme;
}
const K0 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  boolean: Ye,
  booleanish: on,
  commaOrSpaceSeparated: dr,
  commaSeparated: Ss,
  number: Pe,
  overloadedBoolean: EA,
  spaceSeparated: Ot
}, Symbol.toStringTag, { value: "Module" })), jg = Object.keys(K0);
class Ow extends zr {
  /**
   * @constructor
   * @param {string} property
   * @param {string} attribute
   * @param {number|null} [mask]
   * @param {string} [space]
   */
  constructor(t, n, r, i) {
    let o = -1;
    if (super(t, n), M4(this, "space", i), typeof r == "number")
      for (; ++o < jg.length; ) {
        const a = jg[o];
        M4(this, jg[o], (r & K0[a]) === K0[a]);
      }
  }
}
Ow.prototype.defined = !0;
function M4(e, t, n) {
  n && (e[t] = n);
}
const Xme = {}.hasOwnProperty;
function Js(e) {
  const t = {}, n = {};
  let r;
  for (r in e.properties)
    if (Xme.call(e.properties, r)) {
      const i = e.properties[r], o = new Ow(
        r,
        e.transform(e.attributes || {}, r),
        i,
        e.space
      );
      e.mustUseProperty && e.mustUseProperty.includes(r) && (o.mustUseProperty = !0), t[r] = o, n[Y0(r)] = r, n[Y0(o.attribute)] = r;
    }
  return new Hc(t, n, e.space);
}
const CA = Js({
  space: "xlink",
  transform(e, t) {
    return "xlink:" + t.slice(5).toLowerCase();
  },
  properties: {
    xLinkActuate: null,
    xLinkArcRole: null,
    xLinkHref: null,
    xLinkRole: null,
    xLinkShow: null,
    xLinkTitle: null,
    xLinkType: null
  }
}), SA = Js({
  space: "xml",
  transform(e, t) {
    return "xml:" + t.slice(3).toLowerCase();
  },
  properties: { xmlLang: null, xmlBase: null, xmlSpace: null }
});
function _A(e, t) {
  return t in e ? e[t] : t;
}
function PA(e, t) {
  return _A(e, t.toLowerCase());
}
const kA = Js({
  space: "xmlns",
  attributes: { xmlnsxlink: "xmlns:xlink" },
  transform: PA,
  properties: { xmlns: null, xmlnsXLink: null }
}), TA = Js({
  transform(e, t) {
    return t === "role" ? t : "aria-" + t.slice(4).toLowerCase();
  },
  properties: {
    ariaActiveDescendant: null,
    ariaAtomic: on,
    ariaAutoComplete: null,
    ariaBusy: on,
    ariaChecked: on,
    ariaColCount: Pe,
    ariaColIndex: Pe,
    ariaColSpan: Pe,
    ariaControls: Ot,
    ariaCurrent: null,
    ariaDescribedBy: Ot,
    ariaDetails: null,
    ariaDisabled: on,
    ariaDropEffect: Ot,
    ariaErrorMessage: null,
    ariaExpanded: on,
    ariaFlowTo: Ot,
    ariaGrabbed: on,
    ariaHasPopup: null,
    ariaHidden: on,
    ariaInvalid: null,
    ariaKeyShortcuts: null,
    ariaLabel: null,
    ariaLabelledBy: Ot,
    ariaLevel: Pe,
    ariaLive: null,
    ariaModal: on,
    ariaMultiLine: on,
    ariaMultiSelectable: on,
    ariaOrientation: null,
    ariaOwns: Ot,
    ariaPlaceholder: null,
    ariaPosInSet: Pe,
    ariaPressed: on,
    ariaReadOnly: on,
    ariaRelevant: null,
    ariaRequired: on,
    ariaRoleDescription: Ot,
    ariaRowCount: Pe,
    ariaRowIndex: Pe,
    ariaRowSpan: Pe,
    ariaSelected: on,
    ariaSetSize: Pe,
    ariaSort: null,
    ariaValueMax: Pe,
    ariaValueMin: Pe,
    ariaValueNow: Pe,
    ariaValueText: null,
    role: null
  }
}), Zme = Js({
  space: "html",
  attributes: {
    acceptcharset: "accept-charset",
    classname: "class",
    htmlfor: "for",
    httpequiv: "http-equiv"
  },
  transform: PA,
  mustUseProperty: ["checked", "multiple", "muted", "selected"],
  properties: {
    // Standard Properties.
    abbr: null,
    accept: Ss,
    acceptCharset: Ot,
    accessKey: Ot,
    action: null,
    allow: null,
    allowFullScreen: Ye,
    allowPaymentRequest: Ye,
    allowUserMedia: Ye,
    alt: null,
    as: null,
    async: Ye,
    autoCapitalize: null,
    autoComplete: Ot,
    autoFocus: Ye,
    autoPlay: Ye,
    blocking: Ot,
    capture: null,
    charSet: null,
    checked: Ye,
    cite: null,
    className: Ot,
    cols: Pe,
    colSpan: null,
    content: null,
    contentEditable: on,
    controls: Ye,
    controlsList: Ot,
    coords: Pe | Ss,
    crossOrigin: null,
    data: null,
    dateTime: null,
    decoding: null,
    default: Ye,
    defer: Ye,
    dir: null,
    dirName: null,
    disabled: Ye,
    download: EA,
    draggable: on,
    encType: null,
    enterKeyHint: null,
    fetchPriority: null,
    form: null,
    formAction: null,
    formEncType: null,
    formMethod: null,
    formNoValidate: Ye,
    formTarget: null,
    headers: Ot,
    height: Pe,
    hidden: Ye,
    high: Pe,
    href: null,
    hrefLang: null,
    htmlFor: Ot,
    httpEquiv: Ot,
    id: null,
    imageSizes: null,
    imageSrcSet: null,
    inert: Ye,
    inputMode: null,
    integrity: null,
    is: null,
    isMap: Ye,
    itemId: null,
    itemProp: Ot,
    itemRef: Ot,
    itemScope: Ye,
    itemType: Ot,
    kind: null,
    label: null,
    lang: null,
    language: null,
    list: null,
    loading: null,
    loop: Ye,
    low: Pe,
    manifest: null,
    max: null,
    maxLength: Pe,
    media: null,
    method: null,
    min: null,
    minLength: Pe,
    multiple: Ye,
    muted: Ye,
    name: null,
    nonce: null,
    noModule: Ye,
    noValidate: Ye,
    onAbort: null,
    onAfterPrint: null,
    onAuxClick: null,
    onBeforeMatch: null,
    onBeforePrint: null,
    onBeforeToggle: null,
    onBeforeUnload: null,
    onBlur: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onContextLost: null,
    onContextMenu: null,
    onContextRestored: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFormData: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLanguageChange: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadEnd: null,
    onLoadStart: null,
    onMessage: null,
    onMessageError: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRejectionHandled: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onScrollEnd: null,
    onSecurityPolicyViolation: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onSlotChange: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnhandledRejection: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onWheel: null,
    open: Ye,
    optimum: Pe,
    pattern: null,
    ping: Ot,
    placeholder: null,
    playsInline: Ye,
    popover: null,
    popoverTarget: null,
    popoverTargetAction: null,
    poster: null,
    preload: null,
    readOnly: Ye,
    referrerPolicy: null,
    rel: Ot,
    required: Ye,
    reversed: Ye,
    rows: Pe,
    rowSpan: Pe,
    sandbox: Ot,
    scope: null,
    scoped: Ye,
    seamless: Ye,
    selected: Ye,
    shadowRootClonable: Ye,
    shadowRootDelegatesFocus: Ye,
    shadowRootMode: null,
    shape: null,
    size: Pe,
    sizes: null,
    slot: null,
    span: Pe,
    spellCheck: on,
    src: null,
    srcDoc: null,
    srcLang: null,
    srcSet: null,
    start: Pe,
    step: null,
    style: null,
    tabIndex: Pe,
    target: null,
    title: null,
    translate: null,
    type: null,
    typeMustMatch: Ye,
    useMap: null,
    value: on,
    width: Pe,
    wrap: null,
    writingSuggestions: null,
    // Legacy.
    // See: https://html.spec.whatwg.org/#other-elements,-attributes-and-apis
    align: null,
    // Several. Use CSS `text-align` instead,
    aLink: null,
    // `<body>`. Use CSS `a:active {color}` instead
    archive: Ot,
    // `<object>`. List of URIs to archives
    axis: null,
    // `<td>` and `<th>`. Use `scope` on `<th>`
    background: null,
    // `<body>`. Use CSS `background-image` instead
    bgColor: null,
    // `<body>` and table elements. Use CSS `background-color` instead
    border: Pe,
    // `<table>`. Use CSS `border-width` instead,
    borderColor: null,
    // `<table>`. Use CSS `border-color` instead,
    bottomMargin: Pe,
    // `<body>`
    cellPadding: null,
    // `<table>`
    cellSpacing: null,
    // `<table>`
    char: null,
    // Several table elements. When `align=char`, sets the character to align on
    charOff: null,
    // Several table elements. When `char`, offsets the alignment
    classId: null,
    // `<object>`
    clear: null,
    // `<br>`. Use CSS `clear` instead
    code: null,
    // `<object>`
    codeBase: null,
    // `<object>`
    codeType: null,
    // `<object>`
    color: null,
    // `<font>` and `<hr>`. Use CSS instead
    compact: Ye,
    // Lists. Use CSS to reduce space between items instead
    declare: Ye,
    // `<object>`
    event: null,
    // `<script>`
    face: null,
    // `<font>`. Use CSS instead
    frame: null,
    // `<table>`
    frameBorder: null,
    // `<iframe>`. Use CSS `border` instead
    hSpace: Pe,
    // `<img>` and `<object>`
    leftMargin: Pe,
    // `<body>`
    link: null,
    // `<body>`. Use CSS `a:link {color: *}` instead
    longDesc: null,
    // `<frame>`, `<iframe>`, and `<img>`. Use an `<a>`
    lowSrc: null,
    // `<img>`. Use a `<picture>`
    marginHeight: Pe,
    // `<body>`
    marginWidth: Pe,
    // `<body>`
    noResize: Ye,
    // `<frame>`
    noHref: Ye,
    // `<area>`. Use no href instead of an explicit `nohref`
    noShade: Ye,
    // `<hr>`. Use background-color and height instead of borders
    noWrap: Ye,
    // `<td>` and `<th>`
    object: null,
    // `<applet>`
    profile: null,
    // `<head>`
    prompt: null,
    // `<isindex>`
    rev: null,
    // `<link>`
    rightMargin: Pe,
    // `<body>`
    rules: null,
    // `<table>`
    scheme: null,
    // `<meta>`
    scrolling: on,
    // `<frame>`. Use overflow in the child context
    standby: null,
    // `<object>`
    summary: null,
    // `<table>`
    text: null,
    // `<body>`. Use CSS `color` instead
    topMargin: Pe,
    // `<body>`
    valueType: null,
    // `<param>`
    version: null,
    // `<html>`. Use a doctype.
    vAlign: null,
    // Several. Use CSS `vertical-align` instead
    vLink: null,
    // `<body>`. Use CSS `a:visited {color}` instead
    vSpace: Pe,
    // `<img>` and `<object>`
    // Non-standard Properties.
    allowTransparency: null,
    autoCorrect: null,
    autoSave: null,
    disablePictureInPicture: Ye,
    disableRemotePlayback: Ye,
    prefix: null,
    property: null,
    results: Pe,
    security: null,
    unselectable: null
  }
}), Qme = Js({
  space: "svg",
  attributes: {
    accentHeight: "accent-height",
    alignmentBaseline: "alignment-baseline",
    arabicForm: "arabic-form",
    baselineShift: "baseline-shift",
    capHeight: "cap-height",
    className: "class",
    clipPath: "clip-path",
    clipRule: "clip-rule",
    colorInterpolation: "color-interpolation",
    colorInterpolationFilters: "color-interpolation-filters",
    colorProfile: "color-profile",
    colorRendering: "color-rendering",
    crossOrigin: "crossorigin",
    dataType: "datatype",
    dominantBaseline: "dominant-baseline",
    enableBackground: "enable-background",
    fillOpacity: "fill-opacity",
    fillRule: "fill-rule",
    floodColor: "flood-color",
    floodOpacity: "flood-opacity",
    fontFamily: "font-family",
    fontSize: "font-size",
    fontSizeAdjust: "font-size-adjust",
    fontStretch: "font-stretch",
    fontStyle: "font-style",
    fontVariant: "font-variant",
    fontWeight: "font-weight",
    glyphName: "glyph-name",
    glyphOrientationHorizontal: "glyph-orientation-horizontal",
    glyphOrientationVertical: "glyph-orientation-vertical",
    hrefLang: "hreflang",
    horizAdvX: "horiz-adv-x",
    horizOriginX: "horiz-origin-x",
    horizOriginY: "horiz-origin-y",
    imageRendering: "image-rendering",
    letterSpacing: "letter-spacing",
    lightingColor: "lighting-color",
    markerEnd: "marker-end",
    markerMid: "marker-mid",
    markerStart: "marker-start",
    navDown: "nav-down",
    navDownLeft: "nav-down-left",
    navDownRight: "nav-down-right",
    navLeft: "nav-left",
    navNext: "nav-next",
    navPrev: "nav-prev",
    navRight: "nav-right",
    navUp: "nav-up",
    navUpLeft: "nav-up-left",
    navUpRight: "nav-up-right",
    onAbort: "onabort",
    onActivate: "onactivate",
    onAfterPrint: "onafterprint",
    onBeforePrint: "onbeforeprint",
    onBegin: "onbegin",
    onCancel: "oncancel",
    onCanPlay: "oncanplay",
    onCanPlayThrough: "oncanplaythrough",
    onChange: "onchange",
    onClick: "onclick",
    onClose: "onclose",
    onCopy: "oncopy",
    onCueChange: "oncuechange",
    onCut: "oncut",
    onDblClick: "ondblclick",
    onDrag: "ondrag",
    onDragEnd: "ondragend",
    onDragEnter: "ondragenter",
    onDragExit: "ondragexit",
    onDragLeave: "ondragleave",
    onDragOver: "ondragover",
    onDragStart: "ondragstart",
    onDrop: "ondrop",
    onDurationChange: "ondurationchange",
    onEmptied: "onemptied",
    onEnd: "onend",
    onEnded: "onended",
    onError: "onerror",
    onFocus: "onfocus",
    onFocusIn: "onfocusin",
    onFocusOut: "onfocusout",
    onHashChange: "onhashchange",
    onInput: "oninput",
    onInvalid: "oninvalid",
    onKeyDown: "onkeydown",
    onKeyPress: "onkeypress",
    onKeyUp: "onkeyup",
    onLoad: "onload",
    onLoadedData: "onloadeddata",
    onLoadedMetadata: "onloadedmetadata",
    onLoadStart: "onloadstart",
    onMessage: "onmessage",
    onMouseDown: "onmousedown",
    onMouseEnter: "onmouseenter",
    onMouseLeave: "onmouseleave",
    onMouseMove: "onmousemove",
    onMouseOut: "onmouseout",
    onMouseOver: "onmouseover",
    onMouseUp: "onmouseup",
    onMouseWheel: "onmousewheel",
    onOffline: "onoffline",
    onOnline: "ononline",
    onPageHide: "onpagehide",
    onPageShow: "onpageshow",
    onPaste: "onpaste",
    onPause: "onpause",
    onPlay: "onplay",
    onPlaying: "onplaying",
    onPopState: "onpopstate",
    onProgress: "onprogress",
    onRateChange: "onratechange",
    onRepeat: "onrepeat",
    onReset: "onreset",
    onResize: "onresize",
    onScroll: "onscroll",
    onSeeked: "onseeked",
    onSeeking: "onseeking",
    onSelect: "onselect",
    onShow: "onshow",
    onStalled: "onstalled",
    onStorage: "onstorage",
    onSubmit: "onsubmit",
    onSuspend: "onsuspend",
    onTimeUpdate: "ontimeupdate",
    onToggle: "ontoggle",
    onUnload: "onunload",
    onVolumeChange: "onvolumechange",
    onWaiting: "onwaiting",
    onZoom: "onzoom",
    overlinePosition: "overline-position",
    overlineThickness: "overline-thickness",
    paintOrder: "paint-order",
    panose1: "panose-1",
    pointerEvents: "pointer-events",
    referrerPolicy: "referrerpolicy",
    renderingIntent: "rendering-intent",
    shapeRendering: "shape-rendering",
    stopColor: "stop-color",
    stopOpacity: "stop-opacity",
    strikethroughPosition: "strikethrough-position",
    strikethroughThickness: "strikethrough-thickness",
    strokeDashArray: "stroke-dasharray",
    strokeDashOffset: "stroke-dashoffset",
    strokeLineCap: "stroke-linecap",
    strokeLineJoin: "stroke-linejoin",
    strokeMiterLimit: "stroke-miterlimit",
    strokeOpacity: "stroke-opacity",
    strokeWidth: "stroke-width",
    tabIndex: "tabindex",
    textAnchor: "text-anchor",
    textDecoration: "text-decoration",
    textRendering: "text-rendering",
    transformOrigin: "transform-origin",
    typeOf: "typeof",
    underlinePosition: "underline-position",
    underlineThickness: "underline-thickness",
    unicodeBidi: "unicode-bidi",
    unicodeRange: "unicode-range",
    unitsPerEm: "units-per-em",
    vAlphabetic: "v-alphabetic",
    vHanging: "v-hanging",
    vIdeographic: "v-ideographic",
    vMathematical: "v-mathematical",
    vectorEffect: "vector-effect",
    vertAdvY: "vert-adv-y",
    vertOriginX: "vert-origin-x",
    vertOriginY: "vert-origin-y",
    wordSpacing: "word-spacing",
    writingMode: "writing-mode",
    xHeight: "x-height",
    // These were camelcased in Tiny. Now lowercased in SVG 2
    playbackOrder: "playbackorder",
    timelineBegin: "timelinebegin"
  },
  transform: _A,
  properties: {
    about: dr,
    accentHeight: Pe,
    accumulate: null,
    additive: null,
    alignmentBaseline: null,
    alphabetic: Pe,
    amplitude: Pe,
    arabicForm: null,
    ascent: Pe,
    attributeName: null,
    attributeType: null,
    azimuth: Pe,
    bandwidth: null,
    baselineShift: null,
    baseFrequency: null,
    baseProfile: null,
    bbox: null,
    begin: null,
    bias: Pe,
    by: null,
    calcMode: null,
    capHeight: Pe,
    className: Ot,
    clip: null,
    clipPath: null,
    clipPathUnits: null,
    clipRule: null,
    color: null,
    colorInterpolation: null,
    colorInterpolationFilters: null,
    colorProfile: null,
    colorRendering: null,
    content: null,
    contentScriptType: null,
    contentStyleType: null,
    crossOrigin: null,
    cursor: null,
    cx: null,
    cy: null,
    d: null,
    dataType: null,
    defaultAction: null,
    descent: Pe,
    diffuseConstant: Pe,
    direction: null,
    display: null,
    dur: null,
    divisor: Pe,
    dominantBaseline: null,
    download: Ye,
    dx: null,
    dy: null,
    edgeMode: null,
    editable: null,
    elevation: Pe,
    enableBackground: null,
    end: null,
    event: null,
    exponent: Pe,
    externalResourcesRequired: null,
    fill: null,
    fillOpacity: Pe,
    fillRule: null,
    filter: null,
    filterRes: null,
    filterUnits: null,
    floodColor: null,
    floodOpacity: null,
    focusable: null,
    focusHighlight: null,
    fontFamily: null,
    fontSize: null,
    fontSizeAdjust: null,
    fontStretch: null,
    fontStyle: null,
    fontVariant: null,
    fontWeight: null,
    format: null,
    fr: null,
    from: null,
    fx: null,
    fy: null,
    g1: Ss,
    g2: Ss,
    glyphName: Ss,
    glyphOrientationHorizontal: null,
    glyphOrientationVertical: null,
    glyphRef: null,
    gradientTransform: null,
    gradientUnits: null,
    handler: null,
    hanging: Pe,
    hatchContentUnits: null,
    hatchUnits: null,
    height: null,
    href: null,
    hrefLang: null,
    horizAdvX: Pe,
    horizOriginX: Pe,
    horizOriginY: Pe,
    id: null,
    ideographic: Pe,
    imageRendering: null,
    initialVisibility: null,
    in: null,
    in2: null,
    intercept: Pe,
    k: Pe,
    k1: Pe,
    k2: Pe,
    k3: Pe,
    k4: Pe,
    kernelMatrix: dr,
    kernelUnitLength: null,
    keyPoints: null,
    // SEMI_COLON_SEPARATED
    keySplines: null,
    // SEMI_COLON_SEPARATED
    keyTimes: null,
    // SEMI_COLON_SEPARATED
    kerning: null,
    lang: null,
    lengthAdjust: null,
    letterSpacing: null,
    lightingColor: null,
    limitingConeAngle: Pe,
    local: null,
    markerEnd: null,
    markerMid: null,
    markerStart: null,
    markerHeight: null,
    markerUnits: null,
    markerWidth: null,
    mask: null,
    maskContentUnits: null,
    maskUnits: null,
    mathematical: null,
    max: null,
    media: null,
    mediaCharacterEncoding: null,
    mediaContentEncodings: null,
    mediaSize: Pe,
    mediaTime: null,
    method: null,
    min: null,
    mode: null,
    name: null,
    navDown: null,
    navDownLeft: null,
    navDownRight: null,
    navLeft: null,
    navNext: null,
    navPrev: null,
    navRight: null,
    navUp: null,
    navUpLeft: null,
    navUpRight: null,
    numOctaves: null,
    observer: null,
    offset: null,
    onAbort: null,
    onActivate: null,
    onAfterPrint: null,
    onBeforePrint: null,
    onBegin: null,
    onCancel: null,
    onCanPlay: null,
    onCanPlayThrough: null,
    onChange: null,
    onClick: null,
    onClose: null,
    onCopy: null,
    onCueChange: null,
    onCut: null,
    onDblClick: null,
    onDrag: null,
    onDragEnd: null,
    onDragEnter: null,
    onDragExit: null,
    onDragLeave: null,
    onDragOver: null,
    onDragStart: null,
    onDrop: null,
    onDurationChange: null,
    onEmptied: null,
    onEnd: null,
    onEnded: null,
    onError: null,
    onFocus: null,
    onFocusIn: null,
    onFocusOut: null,
    onHashChange: null,
    onInput: null,
    onInvalid: null,
    onKeyDown: null,
    onKeyPress: null,
    onKeyUp: null,
    onLoad: null,
    onLoadedData: null,
    onLoadedMetadata: null,
    onLoadStart: null,
    onMessage: null,
    onMouseDown: null,
    onMouseEnter: null,
    onMouseLeave: null,
    onMouseMove: null,
    onMouseOut: null,
    onMouseOver: null,
    onMouseUp: null,
    onMouseWheel: null,
    onOffline: null,
    onOnline: null,
    onPageHide: null,
    onPageShow: null,
    onPaste: null,
    onPause: null,
    onPlay: null,
    onPlaying: null,
    onPopState: null,
    onProgress: null,
    onRateChange: null,
    onRepeat: null,
    onReset: null,
    onResize: null,
    onScroll: null,
    onSeeked: null,
    onSeeking: null,
    onSelect: null,
    onShow: null,
    onStalled: null,
    onStorage: null,
    onSubmit: null,
    onSuspend: null,
    onTimeUpdate: null,
    onToggle: null,
    onUnload: null,
    onVolumeChange: null,
    onWaiting: null,
    onZoom: null,
    opacity: null,
    operator: null,
    order: null,
    orient: null,
    orientation: null,
    origin: null,
    overflow: null,
    overlay: null,
    overlinePosition: Pe,
    overlineThickness: Pe,
    paintOrder: null,
    panose1: null,
    path: null,
    pathLength: Pe,
    patternContentUnits: null,
    patternTransform: null,
    patternUnits: null,
    phase: null,
    ping: Ot,
    pitch: null,
    playbackOrder: null,
    pointerEvents: null,
    points: null,
    pointsAtX: Pe,
    pointsAtY: Pe,
    pointsAtZ: Pe,
    preserveAlpha: null,
    preserveAspectRatio: null,
    primitiveUnits: null,
    propagate: null,
    property: dr,
    r: null,
    radius: null,
    referrerPolicy: null,
    refX: null,
    refY: null,
    rel: dr,
    rev: dr,
    renderingIntent: null,
    repeatCount: null,
    repeatDur: null,
    requiredExtensions: dr,
    requiredFeatures: dr,
    requiredFonts: dr,
    requiredFormats: dr,
    resource: null,
    restart: null,
    result: null,
    rotate: null,
    rx: null,
    ry: null,
    scale: null,
    seed: null,
    shapeRendering: null,
    side: null,
    slope: null,
    snapshotTime: null,
    specularConstant: Pe,
    specularExponent: Pe,
    spreadMethod: null,
    spacing: null,
    startOffset: null,
    stdDeviation: null,
    stemh: null,
    stemv: null,
    stitchTiles: null,
    stopColor: null,
    stopOpacity: null,
    strikethroughPosition: Pe,
    strikethroughThickness: Pe,
    string: null,
    stroke: null,
    strokeDashArray: dr,
    strokeDashOffset: null,
    strokeLineCap: null,
    strokeLineJoin: null,
    strokeMiterLimit: Pe,
    strokeOpacity: Pe,
    strokeWidth: null,
    style: null,
    surfaceScale: Pe,
    syncBehavior: null,
    syncBehaviorDefault: null,
    syncMaster: null,
    syncTolerance: null,
    syncToleranceDefault: null,
    systemLanguage: dr,
    tabIndex: Pe,
    tableValues: null,
    target: null,
    targetX: Pe,
    targetY: Pe,
    textAnchor: null,
    textDecoration: null,
    textRendering: null,
    textLength: null,
    timelineBegin: null,
    title: null,
    transformBehavior: null,
    type: null,
    typeOf: dr,
    to: null,
    transform: null,
    transformOrigin: null,
    u1: null,
    u2: null,
    underlinePosition: Pe,
    underlineThickness: Pe,
    unicode: null,
    unicodeBidi: null,
    unicodeRange: null,
    unitsPerEm: Pe,
    values: null,
    vAlphabetic: Pe,
    vMathematical: Pe,
    vectorEffect: null,
    vHanging: Pe,
    vIdeographic: Pe,
    version: null,
    vertAdvY: Pe,
    vertOriginX: Pe,
    vertOriginY: Pe,
    viewBox: null,
    viewTarget: null,
    visibility: null,
    width: null,
    widths: null,
    wordSpacing: null,
    writingMode: null,
    x: null,
    x1: null,
    x2: null,
    xChannelSelector: null,
    xHeight: Pe,
    y: null,
    y1: null,
    y2: null,
    yChannelSelector: null,
    z: null,
    zoomAndPan: null
  }
}), Jme = /^data[-\w.:]+$/i, O4 = /-[a-z]/g, ege = /[A-Z]/g;
function tge(e, t) {
  const n = Y0(t);
  let r = t, i = zr;
  if (n in e.normal)
    return e.property[e.normal[n]];
  if (n.length > 4 && n.slice(0, 4) === "data" && Jme.test(t)) {
    if (t.charAt(4) === "-") {
      const o = t.slice(5).replace(O4, rge);
      r = "data" + o.charAt(0).toUpperCase() + o.slice(1);
    } else {
      const o = t.slice(4);
      if (!O4.test(o)) {
        let a = o.replace(ege, nge);
        a.charAt(0) !== "-" && (a = "-" + a), t = "data" + a;
      }
    }
    i = Ow;
  }
  return new i(r, t);
}
function nge(e) {
  return "-" + e.toLowerCase();
}
function rge(e) {
  return e.charAt(1).toUpperCase();
}
const R4 = {
  classId: "classID",
  dataType: "datatype",
  itemId: "itemID",
  strokeDashArray: "strokeDasharray",
  strokeDashOffset: "strokeDashoffset",
  strokeLineCap: "strokeLinecap",
  strokeLineJoin: "strokeLinejoin",
  strokeMiterLimit: "strokeMiterlimit",
  typeOf: "typeof",
  xLinkActuate: "xlinkActuate",
  xLinkArcRole: "xlinkArcrole",
  xLinkHref: "xlinkHref",
  xLinkRole: "xlinkRole",
  xLinkShow: "xlinkShow",
  xLinkTitle: "xlinkTitle",
  xLinkType: "xlinkType",
  xmlnsXLink: "xmlnsXlink"
}, ige = xA([SA, CA, kA, TA, Zme], "html"), oge = xA([SA, CA, kA, TA, Qme], "svg");
function age(e) {
  if (e.allowedElements && e.disallowedElements)
    throw new TypeError(
      "Only one of `allowedElements` and `disallowedElements` should be defined"
    );
  if (e.allowedElements || e.disallowedElements || e.allowElement)
    return (t) => {
      Aw(t, "element", (n, r, i) => {
        const o = (
          /** @type {Element|Root} */
          i
        );
        let a;
        if (e.allowedElements ? a = !e.allowedElements.includes(n.tagName) : e.disallowedElements && (a = e.disallowedElements.includes(n.tagName)), !a && e.allowElement && typeof r == "number" && (a = !e.allowElement(n, r, o)), a && typeof r == "number")
          return e.unwrapDisallowed && n.children ? o.children.splice(r, 1, ...n.children) : o.children.splice(r, 1), r;
      });
    };
}
var X0 = { exports: {} }, Et = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var I4;
function sge() {
  if (I4)
    return Et;
  I4 = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), g;
  g = Symbol.for("react.module.reference");
  function v(y) {
    if (typeof y == "object" && y !== null) {
      var b = y.$$typeof;
      switch (b) {
        case e:
          switch (y = y.type, y) {
            case n:
            case i:
            case r:
            case u:
            case d:
              return y;
            default:
              switch (y = y && y.$$typeof, y) {
                case s:
                case a:
                case l:
                case p:
                case f:
                case o:
                  return y;
                default:
                  return b;
              }
          }
        case t:
          return b;
      }
    }
  }
  return Et.ContextConsumer = a, Et.ContextProvider = o, Et.Element = e, Et.ForwardRef = l, Et.Fragment = n, Et.Lazy = p, Et.Memo = f, Et.Portal = t, Et.Profiler = i, Et.StrictMode = r, Et.Suspense = u, Et.SuspenseList = d, Et.isAsyncMode = function() {
    return !1;
  }, Et.isConcurrentMode = function() {
    return !1;
  }, Et.isContextConsumer = function(y) {
    return v(y) === a;
  }, Et.isContextProvider = function(y) {
    return v(y) === o;
  }, Et.isElement = function(y) {
    return typeof y == "object" && y !== null && y.$$typeof === e;
  }, Et.isForwardRef = function(y) {
    return v(y) === l;
  }, Et.isFragment = function(y) {
    return v(y) === n;
  }, Et.isLazy = function(y) {
    return v(y) === p;
  }, Et.isMemo = function(y) {
    return v(y) === f;
  }, Et.isPortal = function(y) {
    return v(y) === t;
  }, Et.isProfiler = function(y) {
    return v(y) === i;
  }, Et.isStrictMode = function(y) {
    return v(y) === r;
  }, Et.isSuspense = function(y) {
    return v(y) === u;
  }, Et.isSuspenseList = function(y) {
    return v(y) === d;
  }, Et.isValidElementType = function(y) {
    return typeof y == "string" || typeof y == "function" || y === n || y === i || y === r || y === u || y === d || y === m || typeof y == "object" && y !== null && (y.$$typeof === p || y.$$typeof === f || y.$$typeof === o || y.$$typeof === a || y.$$typeof === l || y.$$typeof === g || y.getModuleId !== void 0);
  }, Et.typeOf = v, Et;
}
var Ct = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var D4;
function lge() {
  return D4 || (D4 = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), n = Symbol.for("react.fragment"), r = Symbol.for("react.strict_mode"), i = Symbol.for("react.profiler"), o = Symbol.for("react.provider"), a = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), u = Symbol.for("react.suspense"), d = Symbol.for("react.suspense_list"), f = Symbol.for("react.memo"), p = Symbol.for("react.lazy"), m = Symbol.for("react.offscreen"), g = !1, v = !1, y = !1, b = !1, E = !1, S;
    S = Symbol.for("react.module.reference");
    function _(we) {
      return !!(typeof we == "string" || typeof we == "function" || we === n || we === i || E || we === r || we === u || we === d || b || we === m || g || v || y || typeof we == "object" && we !== null && (we.$$typeof === p || we.$$typeof === f || we.$$typeof === o || we.$$typeof === a || we.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      we.$$typeof === S || we.getModuleId !== void 0));
    }
    function k(we) {
      if (typeof we == "object" && we !== null) {
        var ze = we.$$typeof;
        switch (ze) {
          case e:
            var dt = we.type;
            switch (dt) {
              case n:
              case i:
              case r:
              case u:
              case d:
                return dt;
              default:
                var ht = dt && dt.$$typeof;
                switch (ht) {
                  case s:
                  case a:
                  case l:
                  case p:
                  case f:
                  case o:
                    return ht;
                  default:
                    return ze;
                }
            }
          case t:
            return ze;
        }
      }
    }
    var T = a, A = o, R = e, F = l, D = n, W = p, L = f, z = t, B = i, G = r, H = u, J = d, q = !1, Z = !1;
    function O(we) {
      return q || (q = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function Q(we) {
      return Z || (Z = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function he(we) {
      return k(we) === a;
    }
    function N(we) {
      return k(we) === o;
    }
    function ee(we) {
      return typeof we == "object" && we !== null && we.$$typeof === e;
    }
    function ae(we) {
      return k(we) === l;
    }
    function pe(we) {
      return k(we) === n;
    }
    function se(we) {
      return k(we) === p;
    }
    function Se(we) {
      return k(we) === f;
    }
    function le(we) {
      return k(we) === t;
    }
    function Ee(we) {
      return k(we) === i;
    }
    function Ie(we) {
      return k(we) === r;
    }
    function te(we) {
      return k(we) === u;
    }
    function Re(we) {
      return k(we) === d;
    }
    Ct.ContextConsumer = T, Ct.ContextProvider = A, Ct.Element = R, Ct.ForwardRef = F, Ct.Fragment = D, Ct.Lazy = W, Ct.Memo = L, Ct.Portal = z, Ct.Profiler = B, Ct.StrictMode = G, Ct.Suspense = H, Ct.SuspenseList = J, Ct.isAsyncMode = O, Ct.isConcurrentMode = Q, Ct.isContextConsumer = he, Ct.isContextProvider = N, Ct.isElement = ee, Ct.isForwardRef = ae, Ct.isFragment = pe, Ct.isLazy = se, Ct.isMemo = Se, Ct.isPortal = le, Ct.isProfiler = Ee, Ct.isStrictMode = Ie, Ct.isSuspense = te, Ct.isSuspenseList = Re, Ct.isValidElementType = _, Ct.typeOf = k;
  }()), Ct;
}
process.env.NODE_ENV === "production" ? X0.exports = sge() : X0.exports = lge();
var cge = X0.exports;
const uge = /* @__PURE__ */ Pi(cge);
function dge(e) {
  const t = (
    // @ts-expect-error looks like a node.
    e && typeof e == "object" && e.type === "text" ? (
      // @ts-expect-error looks like a text.
      e.value || ""
    ) : e
  );
  return typeof t == "string" && t.replace(/[ \t\n\f\r]/g, "") === "";
}
function fge(e) {
  return e.join(" ").trim();
}
function hge(e, t) {
  const n = t || {};
  return (e[e.length - 1] === "" ? [...e, ""] : e).join(
    (n.padRight ? " " : "") + "," + (n.padLeft === !1 ? "" : " ")
  ).trim();
}
var Rw = { exports: {} }, N4 = /\/\*[^*]*\*+([^/*][^*]*\*+)*\//g, pge = /\n/g, mge = /^\s*/, gge = /^(\*?[-#/*\\\w]+(\[[0-9a-z_-]+\])?)\s*/, vge = /^:\s*/, yge = /^((?:'(?:\\'|.)*?'|"(?:\\"|.)*?"|\([^)]*?\)|[^};])+)/, wge = /^[;\s]*/, bge = /^\s+|\s+$/g, xge = `
`, $4 = "/", L4 = "*", la = "", Ege = "comment", Cge = "declaration", Sge = function(e, t) {
  if (typeof e != "string")
    throw new TypeError("First argument must be a string");
  if (!e)
    return [];
  t = t || {};
  var n = 1, r = 1;
  function i(g) {
    var v = g.match(pge);
    v && (n += v.length);
    var y = g.lastIndexOf(xge);
    r = ~y ? g.length - y : r + g.length;
  }
  function o() {
    var g = { line: n, column: r };
    return function(v) {
      return v.position = new a(g), u(), v;
    };
  }
  function a(g) {
    this.start = g, this.end = { line: n, column: r }, this.source = t.source;
  }
  a.prototype.content = e;
  function s(g) {
    var v = new Error(
      t.source + ":" + n + ":" + r + ": " + g
    );
    if (v.reason = g, v.filename = t.source, v.line = n, v.column = r, v.source = e, !t.silent)
      throw v;
  }
  function l(g) {
    var v = g.exec(e);
    if (v) {
      var y = v[0];
      return i(y), e = e.slice(y.length), v;
    }
  }
  function u() {
    l(mge);
  }
  function d(g) {
    var v;
    for (g = g || []; v = f(); )
      v !== !1 && g.push(v);
    return g;
  }
  function f() {
    var g = o();
    if (!($4 != e.charAt(0) || L4 != e.charAt(1))) {
      for (var v = 2; la != e.charAt(v) && (L4 != e.charAt(v) || $4 != e.charAt(v + 1)); )
        ++v;
      if (v += 2, la === e.charAt(v - 1))
        return s("End of comment missing");
      var y = e.slice(2, v - 2);
      return r += 2, i(y), e = e.slice(v), r += 2, g({
        type: Ege,
        comment: y
      });
    }
  }
  function p() {
    var g = o(), v = l(gge);
    if (v) {
      if (f(), !l(vge))
        return s("property missing ':'");
      var y = l(yge), b = g({
        type: Cge,
        property: F4(v[0].replace(N4, la)),
        value: y ? F4(y[0].replace(N4, la)) : la
      });
      return l(wge), b;
    }
  }
  function m() {
    var g = [];
    d(g);
    for (var v; v = p(); )
      v !== !1 && (g.push(v), d(g));
    return g;
  }
  return u(), m();
};
function F4(e) {
  return e ? e.replace(bge, la) : la;
}
var _ge = Sge;
function AA(e, t) {
  var n = null;
  if (!e || typeof e != "string")
    return n;
  for (var r, i = _ge(e), o = typeof t == "function", a, s, l = 0, u = i.length; l < u; l++)
    r = i[l], a = r.property, s = r.value, o ? t(a, s, r) : s && (n || (n = {}), n[a] = s);
  return n;
}
Rw.exports = AA;
Rw.exports.default = AA;
var Pge = Rw.exports;
const kge = /* @__PURE__ */ Pi(Pge), Z0 = {}.hasOwnProperty, Tge = /* @__PURE__ */ new Set(["table", "thead", "tbody", "tfoot", "tr"]);
function MA(e, t) {
  const n = [];
  let r = -1, i;
  for (; ++r < t.children.length; )
    i = t.children[r], i.type === "element" ? n.push(Age(e, i, r, t)) : i.type === "text" ? (t.type !== "element" || !Tge.has(t.tagName) || !dge(i)) && n.push(i.value) : i.type === "raw" && !e.options.skipHtml && n.push(i.value);
  return n;
}
function Age(e, t, n, r) {
  const i = e.options, o = i.transformLinkUri === void 0 ? Nfe : i.transformLinkUri, a = e.schema, s = t.tagName, l = {};
  let u = a, d;
  if (a.space === "html" && s === "svg" && (u = oge, e.schema = u), t.properties)
    for (d in t.properties)
      Z0.call(t.properties, d) && Oge(l, d, t.properties[d], e);
  (s === "ol" || s === "ul") && e.listDepth++;
  const f = MA(e, t);
  (s === "ol" || s === "ul") && e.listDepth--, e.schema = a;
  const p = t.position || {
    start: { line: null, column: null, offset: null },
    end: { line: null, column: null, offset: null }
  }, m = i.components && Z0.call(i.components, s) ? i.components[s] : s, g = typeof m == "string" || m === x.Fragment;
  if (!uge.isValidElementType(m))
    throw new TypeError(
      `Component for name \`${s}\` not defined or is not renderable`
    );
  if (l.key = n, s === "a" && i.linkTarget && (l.target = typeof i.linkTarget == "function" ? i.linkTarget(
    String(l.href || ""),
    t.children,
    typeof l.title == "string" ? l.title : null
  ) : i.linkTarget), s === "a" && o && (l.href = o(
    String(l.href || ""),
    t.children,
    typeof l.title == "string" ? l.title : null
  )), !g && s === "code" && r.type === "element" && r.tagName !== "pre" && (l.inline = !0), !g && (s === "h1" || s === "h2" || s === "h3" || s === "h4" || s === "h5" || s === "h6") && (l.level = Number.parseInt(s.charAt(1), 10)), s === "img" && i.transformImageUri && (l.src = i.transformImageUri(
    String(l.src || ""),
    String(l.alt || ""),
    typeof l.title == "string" ? l.title : null
  )), !g && s === "li" && r.type === "element") {
    const v = Mge(t);
    l.checked = v && v.properties ? !!v.properties.checked : null, l.index = Wg(r, t), l.ordered = r.tagName === "ol";
  }
  return !g && (s === "ol" || s === "ul") && (l.ordered = s === "ol", l.depth = e.listDepth), (s === "td" || s === "th") && (l.align && (l.style || (l.style = {}), l.style.textAlign = l.align, delete l.align), g || (l.isHeader = s === "th")), !g && s === "tr" && r.type === "element" && (l.isHeader = r.tagName === "thead"), i.sourcePos && (l["data-sourcepos"] = Dge(p)), !g && i.rawSourcePos && (l.sourcePosition = t.position), !g && i.includeElementIndex && (l.index = Wg(r, t), l.siblingCount = Wg(r)), g || (l.node = t), f.length > 0 ? x.createElement(m, l, f) : x.createElement(m, l);
}
function Mge(e) {
  let t = -1;
  for (; ++t < e.children.length; ) {
    const n = e.children[t];
    if (n.type === "element" && n.tagName === "input")
      return n;
  }
  return null;
}
function Wg(e, t) {
  let n = -1, r = 0;
  for (; ++n < e.children.length && e.children[n] !== t; )
    e.children[n].type === "element" && r++;
  return r;
}
function Oge(e, t, n, r) {
  const i = tge(r.schema, t);
  let o = n;
  o == null || o !== o || (Array.isArray(o) && (o = i.commaSeparated ? hge(o) : fge(o)), i.property === "style" && typeof o == "string" && (o = Rge(o)), i.space && i.property ? e[Z0.call(R4, i.property) ? R4[i.property] : i.property] = o : i.attribute && (e[i.attribute] = o));
}
function Rge(e) {
  const t = {};
  try {
    kge(e, n);
  } catch {
  }
  return t;
  function n(r, i) {
    const o = r.slice(0, 4) === "-ms-" ? `ms-${r.slice(4)}` : r;
    t[o.replace(/-([a-z])/g, Ige)] = i;
  }
}
function Ige(e, t) {
  return t.toUpperCase();
}
function Dge(e) {
  return [
    e.start.line,
    ":",
    e.start.column,
    "-",
    e.end.line,
    ":",
    e.end.column
  ].map(String).join("");
}
const z4 = {}.hasOwnProperty, Nge = "https://github.com/remarkjs/react-markdown/blob/main/changelog.md", Pd = {
  plugins: { to: "remarkPlugins", id: "change-plugins-to-remarkplugins" },
  renderers: { to: "components", id: "change-renderers-to-components" },
  astPlugins: { id: "remove-buggy-html-in-markdown-parser" },
  allowDangerousHtml: { id: "remove-buggy-html-in-markdown-parser" },
  escapeHtml: { id: "remove-buggy-html-in-markdown-parser" },
  source: { to: "children", id: "change-source-to-children" },
  allowNode: {
    to: "allowElement",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  allowedTypes: {
    to: "allowedElements",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  disallowedTypes: {
    to: "disallowedElements",
    id: "replace-allownode-allowedtypes-and-disallowedtypes"
  },
  includeNodeIndex: {
    to: "includeElementIndex",
    id: "change-includenodeindex-to-includeelementindex"
  }
};
function OA(e) {
  for (const o in Pd)
    if (z4.call(Pd, o) && z4.call(e, o)) {
      const a = Pd[o];
      console.warn(
        `[react-markdown] Warning: please ${a.to ? `use \`${a.to}\` instead of` : "remove"} \`${o}\` (see <${Nge}#${a.id}> for more info)`
      ), delete Pd[o];
    }
  const t = Zfe().use(nme).use(e.remarkPlugins || []).use(Gme, {
    ...e.remarkRehypeOptions,
    allowDangerousHtml: !0
  }).use(e.rehypePlugins || []).use(age, e), n = new K7();
  typeof e.children == "string" ? n.value = e.children : e.children !== void 0 && e.children !== null && console.warn(
    `[react-markdown] Warning: please pass a string as \`children\` (not: \`${e.children}\`)`
  );
  const r = t.runSync(t.parse(n), n);
  if (r.type !== "root")
    throw new TypeError("Expected a `root` node");
  let i = x.createElement(
    x.Fragment,
    {},
    MA({ options: e, schema: ige, listDepth: 0 }, r)
  );
  return e.className && (i = x.createElement("div", { className: e.className }, i)), i;
}
OA.propTypes = {
  // Core options:
  children: _e.string,
  // Layout options:
  className: _e.string,
  // Filter options:
  allowElement: _e.func,
  allowedElements: _e.arrayOf(_e.string),
  disallowedElements: _e.arrayOf(_e.string),
  unwrapDisallowed: _e.bool,
  // Plugin options:
  remarkPlugins: _e.arrayOf(
    _e.oneOfType([
      _e.object,
      _e.func,
      _e.arrayOf(
        _e.oneOfType([
          _e.bool,
          _e.string,
          _e.object,
          _e.func,
          _e.arrayOf(
            // prettier-ignore
            // type-coverage:ignore-next-line
            _e.any
          )
        ])
      )
    ])
  ),
  rehypePlugins: _e.arrayOf(
    _e.oneOfType([
      _e.object,
      _e.func,
      _e.arrayOf(
        _e.oneOfType([
          _e.bool,
          _e.string,
          _e.object,
          _e.func,
          _e.arrayOf(
            // prettier-ignore
            // type-coverage:ignore-next-line
            _e.any
          )
        ])
      )
    ])
  ),
  // Transform options:
  sourcePos: _e.bool,
  rawSourcePos: _e.bool,
  skipHtml: _e.bool,
  includeElementIndex: _e.bool,
  transformLinkUri: _e.oneOfType([_e.func, _e.bool]),
  linkTarget: _e.oneOfType([_e.func, _e.string]),
  transformImageUri: _e.func,
  components: _e.object
};
const $ge = {
  tokenize: jge,
  partial: !0
}, RA = {
  tokenize: Wge,
  partial: !0
}, IA = {
  tokenize: Uge,
  partial: !0
}, DA = {
  tokenize: Hge,
  partial: !0
}, Lge = {
  tokenize: Gge,
  partial: !0
}, NA = {
  tokenize: Vge,
  previous: LA
}, $A = {
  tokenize: Bge,
  previous: FA
}, ro = {
  tokenize: zge,
  previous: zA
}, ki = {}, Fge = {
  text: ki
};
let ra = 48;
for (; ra < 123; )
  ki[ra] = ro, ra++, ra === 58 ? ra = 65 : ra === 91 && (ra = 97);
ki[43] = ro;
ki[45] = ro;
ki[46] = ro;
ki[95] = ro;
ki[72] = [ro, $A];
ki[104] = [ro, $A];
ki[87] = [ro, NA];
ki[119] = [ro, NA];
function zge(e, t, n) {
  const r = this;
  let i, o;
  return a;
  function a(f) {
    return !Q0(f) || !zA.call(r, r.previous) || Iw(r.events) ? n(f) : (e.enter("literalAutolink"), e.enter("literalAutolinkEmail"), s(f));
  }
  function s(f) {
    return Q0(f) ? (e.consume(f), s) : f === 64 ? (e.consume(f), l) : n(f);
  }
  function l(f) {
    return f === 46 ? e.check(
      Lge,
      d,
      u
    )(f) : f === 45 || f === 95 || Mn(f) ? (o = !0, e.consume(f), l) : d(f);
  }
  function u(f) {
    return e.consume(f), i = !0, l;
  }
  function d(f) {
    return o && i && Vn(r.previous) ? (e.exit("literalAutolinkEmail"), e.exit("literalAutolink"), t(f)) : n(f);
  }
}
function Vge(e, t, n) {
  const r = this;
  return i;
  function i(a) {
    return a !== 87 && a !== 119 || !LA.call(r, r.previous) || Iw(r.events) ? n(a) : (e.enter("literalAutolink"), e.enter("literalAutolinkWww"), e.check(
      $ge,
      e.attempt(RA, e.attempt(IA, o), n),
      n
    )(a));
  }
  function o(a) {
    return e.exit("literalAutolinkWww"), e.exit("literalAutolink"), t(a);
  }
}
function Bge(e, t, n) {
  const r = this;
  let i = "", o = !1;
  return a;
  function a(f) {
    return (f === 72 || f === 104) && FA.call(r, r.previous) && !Iw(r.events) ? (e.enter("literalAutolink"), e.enter("literalAutolinkHttp"), i += String.fromCodePoint(f), e.consume(f), s) : n(f);
  }
  function s(f) {
    if (Vn(f) && i.length < 5)
      return i += String.fromCodePoint(f), e.consume(f), s;
    if (f === 58) {
      const p = i.toLowerCase();
      if (p === "http" || p === "https")
        return e.consume(f), l;
    }
    return n(f);
  }
  function l(f) {
    return f === 47 ? (e.consume(f), o ? u : (o = !0, l)) : n(f);
  }
  function u(f) {
    return f === null || Wf(f) || Tt(f) || Pa(f) || ip(f) ? n(f) : e.attempt(RA, e.attempt(IA, d), n)(f);
  }
  function d(f) {
    return e.exit("literalAutolinkHttp"), e.exit("literalAutolink"), t(f);
  }
}
function jge(e, t, n) {
  let r = 0;
  return i;
  function i(a) {
    return (a === 87 || a === 119) && r < 3 ? (r++, e.consume(a), i) : a === 46 && r === 3 ? (e.consume(a), o) : n(a);
  }
  function o(a) {
    return a === null ? n(a) : t(a);
  }
}
function Wge(e, t, n) {
  let r, i, o;
  return a;
  function a(u) {
    return u === 46 || u === 95 ? e.check(DA, l, s)(u) : u === null || Tt(u) || Pa(u) || u !== 45 && ip(u) ? l(u) : (o = !0, e.consume(u), a);
  }
  function s(u) {
    return u === 95 ? r = !0 : (i = r, r = void 0), e.consume(u), a;
  }
  function l(u) {
    return i || r || !o ? n(u) : t(u);
  }
}
function Uge(e, t) {
  let n = 0, r = 0;
  return i;
  function i(a) {
    return a === 40 ? (n++, e.consume(a), i) : a === 41 && r < n ? o(a) : a === 33 || a === 34 || a === 38 || a === 39 || a === 41 || a === 42 || a === 44 || a === 46 || a === 58 || a === 59 || a === 60 || a === 63 || a === 93 || a === 95 || a === 126 ? e.check(DA, t, o)(a) : a === null || Tt(a) || Pa(a) ? t(a) : (e.consume(a), i);
  }
  function o(a) {
    return a === 41 && r++, e.consume(a), i;
  }
}
function Hge(e, t, n) {
  return r;
  function r(s) {
    return s === 33 || s === 34 || s === 39 || s === 41 || s === 42 || s === 44 || s === 46 || s === 58 || s === 59 || s === 63 || s === 95 || s === 126 ? (e.consume(s), r) : s === 38 ? (e.consume(s), o) : s === 93 ? (e.consume(s), i) : (
      // `<` is an end.
      s === 60 || // So is whitespace.
      s === null || Tt(s) || Pa(s) ? t(s) : n(s)
    );
  }
  function i(s) {
    return s === null || s === 40 || s === 91 || Tt(s) || Pa(s) ? t(s) : r(s);
  }
  function o(s) {
    return Vn(s) ? a(s) : n(s);
  }
  function a(s) {
    return s === 59 ? (e.consume(s), r) : Vn(s) ? (e.consume(s), a) : n(s);
  }
}
function Gge(e, t, n) {
  return r;
  function r(o) {
    return e.consume(o), i;
  }
  function i(o) {
    return Mn(o) ? n(o) : t(o);
  }
}
function LA(e) {
  return e === null || e === 40 || e === 42 || e === 95 || e === 91 || e === 93 || e === 126 || Tt(e);
}
function FA(e) {
  return !Vn(e);
}
function zA(e) {
  return !(e === 47 || Q0(e));
}
function Q0(e) {
  return e === 43 || e === 45 || e === 46 || e === 95 || Mn(e);
}
function Iw(e) {
  let t = e.length, n = !1;
  for (; t--; ) {
    const r = e[t][1];
    if ((r.type === "labelLink" || r.type === "labelImage") && !r._balanced) {
      n = !0;
      break;
    }
    if (r._gfmAutolinkLiteralWalkedInto) {
      n = !1;
      break;
    }
  }
  return e.length > 0 && !n && (e[e.length - 1][1]._gfmAutolinkLiteralWalkedInto = !0), n;
}
const qge = {
  tokenize: tve,
  partial: !0
};
function Yge() {
  return {
    document: {
      [91]: {
        tokenize: Qge,
        continuation: {
          tokenize: Jge
        },
        exit: eve
      }
    },
    text: {
      [91]: {
        tokenize: Zge
      },
      [93]: {
        add: "after",
        tokenize: Kge,
        resolveTo: Xge
      }
    }
  };
}
function Kge(e, t, n) {
  const r = this;
  let i = r.events.length;
  const o = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let a;
  for (; i--; ) {
    const l = r.events[i][1];
    if (l.type === "labelImage") {
      a = l;
      break;
    }
    if (l.type === "gfmFootnoteCall" || l.type === "labelLink" || l.type === "label" || l.type === "image" || l.type === "link")
      break;
  }
  return s;
  function s(l) {
    if (!a || !a._balanced)
      return n(l);
    const u = oi(
      r.sliceSerialize({
        start: a.end,
        end: r.now()
      })
    );
    return u.codePointAt(0) !== 94 || !o.includes(u.slice(1)) ? n(l) : (e.enter("gfmFootnoteCallLabelMarker"), e.consume(l), e.exit("gfmFootnoteCallLabelMarker"), t(l));
  }
}
function Xge(e, t) {
  let n = e.length;
  for (; n--; )
    if (e[n][1].type === "labelImage" && e[n][0] === "enter") {
      e[n][1];
      break;
    }
  e[n + 1][1].type = "data", e[n + 3][1].type = "gfmFootnoteCallLabelMarker";
  const r = {
    type: "gfmFootnoteCall",
    start: Object.assign({}, e[n + 3][1].start),
    end: Object.assign({}, e[e.length - 1][1].end)
  }, i = {
    type: "gfmFootnoteCallMarker",
    start: Object.assign({}, e[n + 3][1].end),
    end: Object.assign({}, e[n + 3][1].end)
  };
  i.end.column++, i.end.offset++, i.end._bufferIndex++;
  const o = {
    type: "gfmFootnoteCallString",
    start: Object.assign({}, i.end),
    end: Object.assign({}, e[e.length - 1][1].start)
  }, a = {
    type: "chunkString",
    contentType: "string",
    start: Object.assign({}, o.start),
    end: Object.assign({}, o.end)
  }, s = [
    // Take the `labelImageMarker` (now `data`, the `!`)
    e[n + 1],
    e[n + 2],
    ["enter", r, t],
    // The `[`
    e[n + 3],
    e[n + 4],
    // The `^`.
    ["enter", i, t],
    ["exit", i, t],
    // Everything in between.
    ["enter", o, t],
    ["enter", a, t],
    ["exit", a, t],
    ["exit", o, t],
    // The ending (`]`, properly parsed and labelled).
    e[e.length - 2],
    e[e.length - 1],
    ["exit", r, t]
  ];
  return e.splice(n, e.length - n + 1, ...s), e;
}
function Zge(e, t, n) {
  const r = this, i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let o = 0, a;
  return s;
  function s(f) {
    return e.enter("gfmFootnoteCall"), e.enter("gfmFootnoteCallLabelMarker"), e.consume(f), e.exit("gfmFootnoteCallLabelMarker"), l;
  }
  function l(f) {
    return f !== 94 ? n(f) : (e.enter("gfmFootnoteCallMarker"), e.consume(f), e.exit("gfmFootnoteCallMarker"), e.enter("gfmFootnoteCallString"), e.enter("chunkString").contentType = "string", u);
  }
  function u(f) {
    if (
      // Too long.
      o > 999 || // Closing brace with nothing.
      f === 93 && !a || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      f === null || f === 91 || Tt(f)
    )
      return n(f);
    if (f === 93) {
      e.exit("chunkString");
      const p = e.exit("gfmFootnoteCallString");
      return i.includes(oi(r.sliceSerialize(p))) ? (e.enter("gfmFootnoteCallLabelMarker"), e.consume(f), e.exit("gfmFootnoteCallLabelMarker"), e.exit("gfmFootnoteCall"), t) : n(f);
    }
    return Tt(f) || (a = !0), o++, e.consume(f), f === 92 ? d : u;
  }
  function d(f) {
    return f === 91 || f === 92 || f === 93 ? (e.consume(f), o++, u) : u(f);
  }
}
function Qge(e, t, n) {
  const r = this, i = r.parser.gfmFootnotes || (r.parser.gfmFootnotes = []);
  let o, a = 0, s;
  return l;
  function l(g) {
    return e.enter("gfmFootnoteDefinition")._container = !0, e.enter("gfmFootnoteDefinitionLabel"), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(g), e.exit("gfmFootnoteDefinitionLabelMarker"), u;
  }
  function u(g) {
    return g === 94 ? (e.enter("gfmFootnoteDefinitionMarker"), e.consume(g), e.exit("gfmFootnoteDefinitionMarker"), e.enter("gfmFootnoteDefinitionLabelString"), e.enter("chunkString").contentType = "string", d) : n(g);
  }
  function d(g) {
    if (
      // Too long.
      a > 999 || // Closing brace with nothing.
      g === 93 && !s || // Space or tab is not supported by GFM for some reason.
      // `\n` and `[` not being supported makes sense.
      g === null || g === 91 || Tt(g)
    )
      return n(g);
    if (g === 93) {
      e.exit("chunkString");
      const v = e.exit("gfmFootnoteDefinitionLabelString");
      return o = oi(r.sliceSerialize(v)), e.enter("gfmFootnoteDefinitionLabelMarker"), e.consume(g), e.exit("gfmFootnoteDefinitionLabelMarker"), e.exit("gfmFootnoteDefinitionLabel"), p;
    }
    return Tt(g) || (s = !0), a++, e.consume(g), g === 92 ? f : d;
  }
  function f(g) {
    return g === 91 || g === 92 || g === 93 ? (e.consume(g), a++, d) : d(g);
  }
  function p(g) {
    return g === 58 ? (e.enter("definitionMarker"), e.consume(g), e.exit("definitionMarker"), i.includes(o) || i.push(o), ft(
      e,
      m,
      "gfmFootnoteDefinitionWhitespace"
    )) : n(g);
  }
  function m(g) {
    return t(g);
  }
}
function Jge(e, t, n) {
  return e.check(Uc, t, e.attempt(qge, t, n));
}
function eve(e) {
  e.exit("gfmFootnoteDefinition");
}
function tve(e, t, n) {
  const r = this;
  return ft(
    e,
    i,
    "gfmFootnoteDefinitionIndent",
    4 + 1
  );
  function i(o) {
    const a = r.events[r.events.length - 1];
    return a && a[1].type === "gfmFootnoteDefinitionIndent" && a[2].sliceSerialize(a[1], !0).length === 4 ? t(o) : n(o);
  }
}
function nve(e) {
  let n = (e || {}).singleTilde;
  const r = {
    tokenize: o,
    resolveAll: i
  };
  return n == null && (n = !0), {
    text: {
      [126]: r
    },
    insideSpan: {
      null: [r]
    },
    attentionMarkers: {
      null: [126]
    }
  };
  function i(a, s) {
    let l = -1;
    for (; ++l < a.length; )
      if (a[l][0] === "enter" && a[l][1].type === "strikethroughSequenceTemporary" && a[l][1]._close) {
        let u = l;
        for (; u--; )
          if (a[u][0] === "exit" && a[u][1].type === "strikethroughSequenceTemporary" && a[u][1]._open && // If the sizes are the same:
          a[l][1].end.offset - a[l][1].start.offset === a[u][1].end.offset - a[u][1].start.offset) {
            a[l][1].type = "strikethroughSequence", a[u][1].type = "strikethroughSequence";
            const d = {
              type: "strikethrough",
              start: Object.assign({}, a[u][1].start),
              end: Object.assign({}, a[l][1].end)
            }, f = {
              type: "strikethroughText",
              start: Object.assign({}, a[u][1].end),
              end: Object.assign({}, a[l][1].start)
            }, p = [
              ["enter", d, s],
              ["enter", a[u][1], s],
              ["exit", a[u][1], s],
              ["enter", f, s]
            ], m = s.parser.constructs.insideSpan.null;
            m && gr(
              p,
              p.length,
              0,
              op(m, a.slice(u + 1, l), s)
            ), gr(p, p.length, 0, [
              ["exit", f, s],
              ["enter", a[l][1], s],
              ["exit", a[l][1], s],
              ["exit", d, s]
            ]), gr(a, u - 1, l - u + 3, p), l = u + p.length - 2;
            break;
          }
      }
    for (l = -1; ++l < a.length; )
      a[l][1].type === "strikethroughSequenceTemporary" && (a[l][1].type = "data");
    return a;
  }
  function o(a, s, l) {
    const u = this.previous, d = this.events;
    let f = 0;
    return p;
    function p(g) {
      return u === 126 && d[d.length - 1][1].type !== "characterEscape" ? l(g) : (a.enter("strikethroughSequenceTemporary"), m(g));
    }
    function m(g) {
      const v = Uf(u);
      if (g === 126)
        return f > 1 ? l(g) : (a.consume(g), f++, m);
      if (f < 2 && !n)
        return l(g);
      const y = a.exit("strikethroughSequenceTemporary"), b = Uf(g);
      return y._open = !b || b === 2 && !!v, y._close = !v || v === 2 && !!b, s(g);
    }
  }
}
class rve {
  /**
   * Create a new edit map.
   */
  constructor() {
    this.map = [];
  }
  /**
   * Create an edit: a remove and/or add at a certain place.
   *
   * @param {number} index
   * @param {number} remove
   * @param {Array<Event>} add
   * @returns {void}
   */
  add(t, n, r) {
    ive(this, t, n, r);
  }
  // To do: not used here.
  // /**
  //  * Create an edit: but insert `add` before existing additions.
  //  *
  //  * @param {number} index
  //  * @param {number} remove
  //  * @param {Array<Event>} add
  //  * @returns {void}
  //  */
  // addBefore(index, remove, add) {
  //   addImpl(this, index, remove, add, true)
  // }
  /**
   * Done, change the events.
   *
   * @param {Array<Event>} events
   * @returns {void}
   */
  consume(t) {
    if (this.map.sort((o, a) => o[0] - a[0]), this.map.length === 0)
      return;
    let n = this.map.length;
    const r = [];
    for (; n > 0; )
      n -= 1, r.push(t.slice(this.map[n][0] + this.map[n][1])), r.push(this.map[n][2]), t.length = this.map[n][0];
    r.push([...t]), t.length = 0;
    let i = r.pop();
    for (; i; )
      t.push(...i), i = r.pop();
    this.map.length = 0;
  }
}
function ive(e, t, n, r) {
  let i = 0;
  if (!(n === 0 && r.length === 0)) {
    for (; i < e.map.length; ) {
      if (e.map[i][0] === t) {
        e.map[i][1] += n, e.map[i][2].push(...r);
        return;
      }
      i += 1;
    }
    e.map.push([t, n, r]);
  }
}
function ove(e, t) {
  let n = !1;
  const r = [];
  for (; t < e.length; ) {
    const i = e[t];
    if (n) {
      if (i[0] === "enter")
        i[1].type === "tableContent" && r.push(
          e[t + 1][1].type === "tableDelimiterMarker" ? "left" : "none"
        );
      else if (i[1].type === "tableContent") {
        if (e[t - 1][1].type === "tableDelimiterMarker") {
          const o = r.length - 1;
          r[o] = r[o] === "left" ? "center" : "right";
        }
      } else if (i[1].type === "tableDelimiterRow")
        break;
    } else
      i[0] === "enter" && i[1].type === "tableDelimiterRow" && (n = !0);
    t += 1;
  }
  return r;
}
const ave = {
  flow: {
    null: {
      tokenize: sve,
      resolveAll: lve
    }
  }
};
function sve(e, t, n) {
  const r = this;
  let i = 0, o = 0, a;
  return s;
  function s(D) {
    let W = r.events.length - 1;
    for (; W > -1; ) {
      const B = r.events[W][1].type;
      if (B === "lineEnding" || // Note: markdown-rs uses `whitespace` instead of `linePrefix`
      B === "linePrefix")
        W--;
      else
        break;
    }
    const L = W > -1 ? r.events[W][1].type : null, z = L === "tableHead" || L === "tableRow" ? T : l;
    return z === T && r.parser.lazy[r.now().line] ? n(D) : z(D);
  }
  function l(D) {
    return e.enter("tableHead"), e.enter("tableRow"), u(D);
  }
  function u(D) {
    return D === 124 || (a = !0, o += 1), d(D);
  }
  function d(D) {
    return D === null ? n(D) : Ve(D) ? o > 1 ? (o = 0, r.interrupt = !0, e.exit("tableRow"), e.enter("lineEnding"), e.consume(D), e.exit("lineEnding"), m) : n(D) : nt(D) ? ft(e, d, "whitespace")(D) : (o += 1, a && (a = !1, i += 1), D === 124 ? (e.enter("tableCellDivider"), e.consume(D), e.exit("tableCellDivider"), a = !0, d) : (e.enter("data"), f(D)));
  }
  function f(D) {
    return D === null || D === 124 || Tt(D) ? (e.exit("data"), d(D)) : (e.consume(D), D === 92 ? p : f);
  }
  function p(D) {
    return D === 92 || D === 124 ? (e.consume(D), f) : f(D);
  }
  function m(D) {
    return r.interrupt = !1, r.parser.lazy[r.now().line] ? n(D) : (e.enter("tableDelimiterRow"), a = !1, nt(D) ? ft(
      e,
      g,
      "linePrefix",
      r.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4
    )(D) : g(D));
  }
  function g(D) {
    return D === 45 || D === 58 ? y(D) : D === 124 ? (a = !0, e.enter("tableCellDivider"), e.consume(D), e.exit("tableCellDivider"), v) : k(D);
  }
  function v(D) {
    return nt(D) ? ft(e, y, "whitespace")(D) : y(D);
  }
  function y(D) {
    return D === 58 ? (o += 1, a = !0, e.enter("tableDelimiterMarker"), e.consume(D), e.exit("tableDelimiterMarker"), b) : D === 45 ? (o += 1, b(D)) : D === null || Ve(D) ? _(D) : k(D);
  }
  function b(D) {
    return D === 45 ? (e.enter("tableDelimiterFiller"), E(D)) : k(D);
  }
  function E(D) {
    return D === 45 ? (e.consume(D), E) : D === 58 ? (a = !0, e.exit("tableDelimiterFiller"), e.enter("tableDelimiterMarker"), e.consume(D), e.exit("tableDelimiterMarker"), S) : (e.exit("tableDelimiterFiller"), S(D));
  }
  function S(D) {
    return nt(D) ? ft(e, _, "whitespace")(D) : _(D);
  }
  function _(D) {
    return D === 124 ? g(D) : D === null || Ve(D) ? !a || i !== o ? k(D) : (e.exit("tableDelimiterRow"), e.exit("tableHead"), t(D)) : k(D);
  }
  function k(D) {
    return n(D);
  }
  function T(D) {
    return e.enter("tableRow"), A(D);
  }
  function A(D) {
    return D === 124 ? (e.enter("tableCellDivider"), e.consume(D), e.exit("tableCellDivider"), A) : D === null || Ve(D) ? (e.exit("tableRow"), t(D)) : nt(D) ? ft(e, A, "whitespace")(D) : (e.enter("data"), R(D));
  }
  function R(D) {
    return D === null || D === 124 || Tt(D) ? (e.exit("data"), A(D)) : (e.consume(D), D === 92 ? F : R);
  }
  function F(D) {
    return D === 92 || D === 124 ? (e.consume(D), R) : R(D);
  }
}
function lve(e, t) {
  let n = -1, r = !0, i = 0, o = [0, 0, 0, 0], a = [0, 0, 0, 0], s = !1, l = 0, u, d, f;
  const p = new rve();
  for (; ++n < e.length; ) {
    const m = e[n], g = m[1];
    m[0] === "enter" ? g.type === "tableHead" ? (s = !1, l !== 0 && (V4(p, t, l, u, d), d = void 0, l = 0), u = {
      type: "table",
      start: Object.assign({}, g.start),
      // Note: correct end is set later.
      end: Object.assign({}, g.end)
    }, p.add(n, 0, [["enter", u, t]])) : g.type === "tableRow" || g.type === "tableDelimiterRow" ? (r = !0, f = void 0, o = [0, 0, 0, 0], a = [0, n + 1, 0, 0], s && (s = !1, d = {
      type: "tableBody",
      start: Object.assign({}, g.start),
      // Note: correct end is set later.
      end: Object.assign({}, g.end)
    }, p.add(n, 0, [["enter", d, t]])), i = g.type === "tableDelimiterRow" ? 2 : d ? 3 : 1) : i && (g.type === "data" || g.type === "tableDelimiterMarker" || g.type === "tableDelimiterFiller") ? (r = !1, a[2] === 0 && (o[1] !== 0 && (a[0] = a[1], f = kd(
      p,
      t,
      o,
      i,
      void 0,
      f
    ), o = [0, 0, 0, 0]), a[2] = n)) : g.type === "tableCellDivider" && (r ? r = !1 : (o[1] !== 0 && (a[0] = a[1], f = kd(
      p,
      t,
      o,
      i,
      void 0,
      f
    )), o = a, a = [o[1], n, 0, 0])) : g.type === "tableHead" ? (s = !0, l = n) : g.type === "tableRow" || g.type === "tableDelimiterRow" ? (l = n, o[1] !== 0 ? (a[0] = a[1], f = kd(
      p,
      t,
      o,
      i,
      n,
      f
    )) : a[1] !== 0 && (f = kd(p, t, a, i, n, f)), i = 0) : i && (g.type === "data" || g.type === "tableDelimiterMarker" || g.type === "tableDelimiterFiller") && (a[3] = n);
  }
  for (l !== 0 && V4(p, t, l, u, d), p.consume(t.events), n = -1; ++n < t.events.length; ) {
    const m = t.events[n];
    m[0] === "enter" && m[1].type === "table" && (m[1]._align = ove(t.events, n));
  }
  return e;
}
function kd(e, t, n, r, i, o) {
  const a = r === 1 ? "tableHeader" : r === 2 ? "tableDelimiter" : "tableData", s = "tableContent";
  n[0] !== 0 && (o.end = Object.assign({}, us(t.events, n[0])), e.add(n[0], 0, [["exit", o, t]]));
  const l = us(t.events, n[1]);
  if (o = {
    type: a,
    start: Object.assign({}, l),
    // Note: correct end is set later.
    end: Object.assign({}, l)
  }, e.add(n[1], 0, [["enter", o, t]]), n[2] !== 0) {
    const u = us(t.events, n[2]), d = us(t.events, n[3]), f = {
      type: s,
      start: Object.assign({}, u),
      end: Object.assign({}, d)
    };
    if (e.add(n[2], 0, [["enter", f, t]]), r !== 2) {
      const p = t.events[n[2]], m = t.events[n[3]];
      if (p[1].end = Object.assign({}, m[1].end), p[1].type = "chunkText", p[1].contentType = "text", n[3] > n[2] + 1) {
        const g = n[2] + 1, v = n[3] - n[2] - 1;
        e.add(g, v, []);
      }
    }
    e.add(n[3] + 1, 0, [["exit", f, t]]);
  }
  return i !== void 0 && (o.end = Object.assign({}, us(t.events, i)), e.add(i, 0, [["exit", o, t]]), o = void 0), o;
}
function V4(e, t, n, r, i) {
  const o = [], a = us(t.events, n);
  i && (i.end = Object.assign({}, a), o.push(["exit", i, t])), r.end = Object.assign({}, a), o.push(["exit", r, t]), e.add(n + 1, 0, o);
}
function us(e, t) {
  const n = e[t], r = n[0] === "enter" ? "start" : "end";
  return n[1][r];
}
const cve = {
  tokenize: dve
}, uve = {
  text: {
    [91]: cve
  }
};
function dve(e, t, n) {
  const r = this;
  return i;
  function i(l) {
    return (
      // Exit if there’s stuff before.
      r.previous !== null || // Exit if not in the first content that is the first child of a list
      // item.
      !r._gfmTasklistFirstContentOfListItem ? n(l) : (e.enter("taskListCheck"), e.enter("taskListCheckMarker"), e.consume(l), e.exit("taskListCheckMarker"), o)
    );
  }
  function o(l) {
    return Tt(l) ? (e.enter("taskListCheckValueUnchecked"), e.consume(l), e.exit("taskListCheckValueUnchecked"), a) : l === 88 || l === 120 ? (e.enter("taskListCheckValueChecked"), e.consume(l), e.exit("taskListCheckValueChecked"), a) : n(l);
  }
  function a(l) {
    return l === 93 ? (e.enter("taskListCheckMarker"), e.consume(l), e.exit("taskListCheckMarker"), e.exit("taskListCheck"), s) : n(l);
  }
  function s(l) {
    return Ve(l) ? t(l) : nt(l) ? e.check(
      {
        tokenize: fve
      },
      t,
      n
    )(l) : n(l);
  }
}
function fve(e, t, n) {
  return ft(e, r, "whitespace");
  function r(i) {
    return i === null ? n(i) : t(i);
  }
}
function hve(e) {
  return eA([
    Fge,
    Yge(),
    nve(e),
    ave,
    uve
  ]);
}
function B4(e, t) {
  const n = String(e);
  if (typeof t != "string")
    throw new TypeError("Expected character");
  let r = 0, i = n.indexOf(t);
  for (; i !== -1; )
    r++, i = n.indexOf(t, i + t.length);
  return r;
}
function pve(e) {
  if (typeof e != "string")
    throw new TypeError("Expected a string");
  return e.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
const mve = {}.hasOwnProperty, gve = (
  /**
   * @type {(
   *   (<Tree extends Node>(tree: Tree, find: Find, replace?: Replace | null | undefined, options?: Options | null | undefined) => Tree) &
   *   (<Tree extends Node>(tree: Tree, schema: FindAndReplaceSchema | FindAndReplaceList, options?: Options | null | undefined) => Tree)
   * )}
   **/
  /**
   * @template {Node} Tree
   * @param {Tree} tree
   * @param {Find | FindAndReplaceSchema | FindAndReplaceList} find
   * @param {Replace | Options | null | undefined} [replace]
   * @param {Options | null | undefined} [options]
   * @returns {Tree}
   */
  function(e, t, n, r) {
    let i, o;
    typeof t == "string" || t instanceof RegExp ? (o = [[t, n]], i = r) : (o = t, i = n), i || (i = {});
    const a = Tw(i.ignore || []), s = vve(o);
    let l = -1;
    for (; ++l < s.length; )
      yA(e, "text", u);
    return e;
    function u(f, p) {
      let m = -1, g;
      for (; ++m < p.length; ) {
        const v = p[m];
        if (a(
          v,
          // @ts-expect-error: TS doesn’t understand but it’s perfect.
          g ? g.children.indexOf(v) : void 0,
          g
        ))
          return;
        g = v;
      }
      if (g)
        return d(f, p);
    }
    function d(f, p) {
      const m = p[p.length - 1], g = s[l][0], v = s[l][1];
      let y = 0;
      const b = m.children.indexOf(f);
      let E = !1, S = [];
      g.lastIndex = 0;
      let _ = g.exec(f.value);
      for (; _; ) {
        const k = _.index, T = {
          index: _.index,
          input: _.input,
          // @ts-expect-error: stack is fine.
          stack: [...p, f]
        };
        let A = v(..._, T);
        if (typeof A == "string" && (A = A.length > 0 ? { type: "text", value: A } : void 0), A !== !1 && (y !== k && S.push({
          type: "text",
          value: f.value.slice(y, k)
        }), Array.isArray(A) ? S.push(...A) : A && S.push(A), y = k + _[0].length, E = !0), !g.global)
          break;
        _ = g.exec(f.value);
      }
      return E ? (y < f.value.length && S.push({ type: "text", value: f.value.slice(y) }), m.children.splice(b, 1, ...S)) : S = [f], b + S.length;
    }
  }
);
function vve(e) {
  const t = [];
  if (typeof e != "object")
    throw new TypeError("Expected array or object as schema");
  if (Array.isArray(e)) {
    let n = -1;
    for (; ++n < e.length; )
      t.push([
        j4(e[n][0]),
        W4(e[n][1])
      ]);
  } else {
    let n;
    for (n in e)
      mve.call(e, n) && t.push([j4(n), W4(e[n])]);
  }
  return t;
}
function j4(e) {
  return typeof e == "string" ? new RegExp(pve(e), "g") : e;
}
function W4(e) {
  return typeof e == "function" ? e : () => e;
}
const Ug = "phrasing", Hg = ["autolink", "link", "image", "label"], yve = {
  transforms: [_ve],
  enter: {
    literalAutolink: bve,
    literalAutolinkEmail: Gg,
    literalAutolinkHttp: Gg,
    literalAutolinkWww: Gg
  },
  exit: {
    literalAutolink: Sve,
    literalAutolinkEmail: Cve,
    literalAutolinkHttp: xve,
    literalAutolinkWww: Eve
  }
}, wve = {
  unsafe: [
    {
      character: "@",
      before: "[+\\-.\\w]",
      after: "[\\-.\\w]",
      inConstruct: Ug,
      notInConstruct: Hg
    },
    {
      character: ".",
      before: "[Ww]",
      after: "[\\-.\\w]",
      inConstruct: Ug,
      notInConstruct: Hg
    },
    { character: ":", before: "[ps]", after: "\\/", inConstruct: Ug, notInConstruct: Hg }
  ]
};
function bve(e) {
  this.enter({ type: "link", title: null, url: "", children: [] }, e);
}
function Gg(e) {
  this.config.enter.autolinkProtocol.call(this, e);
}
function xve(e) {
  this.config.exit.autolinkProtocol.call(this, e);
}
function Eve(e) {
  this.config.exit.data.call(this, e);
  const t = (
    /** @type {Link} */
    this.stack[this.stack.length - 1]
  );
  t.url = "http://" + this.sliceSerialize(e);
}
function Cve(e) {
  this.config.exit.autolinkEmail.call(this, e);
}
function Sve(e) {
  this.exit(e);
}
function _ve(e) {
  gve(
    e,
    [
      [/(https?:\/\/|www(?=\.))([-.\w]+)([^ \t\r\n]*)/gi, Pve],
      [/([-.\w+]+)@([-\w]+(?:\.[-\w]+)+)/g, kve]
    ],
    { ignore: ["link", "linkReference"] }
  );
}
function Pve(e, t, n, r, i) {
  let o = "";
  if (!VA(i) || (/^w/i.test(t) && (n = t + n, t = "", o = "http://"), !Tve(n)))
    return !1;
  const a = Ave(n + r);
  if (!a[0])
    return !1;
  const s = {
    type: "link",
    title: null,
    url: o + t + a[0],
    children: [{ type: "text", value: t + a[0] }]
  };
  return a[1] ? [s, { type: "text", value: a[1] }] : s;
}
function kve(e, t, n, r) {
  return (
    // Not an expected previous character.
    !VA(r, !0) || // Label ends in not allowed character.
    /[-\d_]$/.test(n) ? !1 : {
      type: "link",
      title: null,
      url: "mailto:" + t + "@" + n,
      children: [{ type: "text", value: t + "@" + n }]
    }
  );
}
function Tve(e) {
  const t = e.split(".");
  return !(t.length < 2 || t[t.length - 1] && (/_/.test(t[t.length - 1]) || !/[a-zA-Z\d]/.test(t[t.length - 1])) || t[t.length - 2] && (/_/.test(t[t.length - 2]) || !/[a-zA-Z\d]/.test(t[t.length - 2])));
}
function Ave(e) {
  const t = /[!"&'),.:;<>?\]}]+$/.exec(e);
  if (!t)
    return [e, void 0];
  e = e.slice(0, t.index);
  let n = t[0], r = n.indexOf(")");
  const i = B4(e, "(");
  let o = B4(e, ")");
  for (; r !== -1 && i > o; )
    e += n.slice(0, r + 1), n = n.slice(r + 1), r = n.indexOf(")"), o++;
  return [e, n];
}
function VA(e, t) {
  const n = e.input.charCodeAt(e.index - 1);
  return (e.index === 0 || Pa(n) || ip(n)) && (!t || n !== 47);
}
function BA(e) {
  return e.label || !e.identifier ? e.label || "" : dA(e.identifier);
}
function Mve(e, t, n) {
  const r = t.indexStack, i = e.children || [], o = t.createTracker(n), a = [];
  let s = -1;
  for (r.push(-1); ++s < i.length; ) {
    const l = i[s];
    r[r.length - 1] = s, a.push(
      o.move(
        t.handle(l, e, t, {
          before: `
`,
          after: `
`,
          ...o.current()
        })
      )
    ), l.type !== "list" && (t.bulletLastUsed = void 0), s < i.length - 1 && a.push(
      o.move(Ove(l, i[s + 1], e, t))
    );
  }
  return r.pop(), a.join("");
}
function Ove(e, t, n, r) {
  let i = r.join.length;
  for (; i--; ) {
    const o = r.join[i](e, t, n, r);
    if (o === !0 || o === 1)
      break;
    if (typeof o == "number")
      return `
`.repeat(1 + o);
    if (o === !1)
      return `

<!---->

`;
  }
  return `

`;
}
const Rve = /\r?\n|\r/g;
function Ive(e, t) {
  const n = [];
  let r = 0, i = 0, o;
  for (; o = Rve.exec(e); )
    a(e.slice(r, o.index)), n.push(o[0]), r = o.index + o[0].length, i++;
  return a(e.slice(r)), n.join("");
  function a(s) {
    n.push(t(s, i, !s));
  }
}
function jA(e) {
  if (!e._compiled) {
    const t = (e.atBreak ? "[\\r\\n][\\t ]*" : "") + (e.before ? "(?:" + e.before + ")" : "");
    e._compiled = new RegExp(
      (t ? "(" + t + ")" : "") + (/[|\\{}()[\]^$+*?.-]/.test(e.character) ? "\\" : "") + e.character + (e.after ? "(?:" + e.after + ")" : ""),
      "g"
    );
  }
  return e._compiled;
}
function Dve(e, t) {
  return U4(e, t.inConstruct, !0) && !U4(e, t.notInConstruct, !1);
}
function U4(e, t, n) {
  if (typeof t == "string" && (t = [t]), !t || t.length === 0)
    return n;
  let r = -1;
  for (; ++r < t.length; )
    if (e.includes(t[r]))
      return !0;
  return !1;
}
function WA(e, t, n) {
  const r = (n.before || "") + (t || "") + (n.after || ""), i = [], o = [], a = {};
  let s = -1;
  for (; ++s < e.unsafe.length; ) {
    const d = e.unsafe[s];
    if (!Dve(e.stack, d))
      continue;
    const f = jA(d);
    let p;
    for (; p = f.exec(r); ) {
      const m = "before" in d || !!d.atBreak, g = "after" in d, v = p.index + (m ? p[1].length : 0);
      i.includes(v) ? (a[v].before && !m && (a[v].before = !1), a[v].after && !g && (a[v].after = !1)) : (i.push(v), a[v] = { before: m, after: g });
    }
  }
  i.sort(Nve);
  let l = n.before ? n.before.length : 0;
  const u = r.length - (n.after ? n.after.length : 0);
  for (s = -1; ++s < i.length; ) {
    const d = i[s];
    d < l || d >= u || d + 1 < u && i[s + 1] === d + 1 && a[d].after && !a[d + 1].before && !a[d + 1].after || i[s - 1] === d - 1 && a[d].before && !a[d - 1].before && !a[d - 1].after || (l !== d && o.push(H4(r.slice(l, d), "\\")), l = d, /[!-/:-@[-`{-~]/.test(r.charAt(d)) && (!n.encode || !n.encode.includes(r.charAt(d))) ? o.push("\\") : (o.push(
      "&#x" + r.charCodeAt(d).toString(16).toUpperCase() + ";"
    ), l++));
  }
  return o.push(H4(r.slice(l, u), n.after)), o.join("");
}
function Nve(e, t) {
  return e - t;
}
function H4(e, t) {
  const n = /\\(?=[!-/:-@[-`{-~])/g, r = [], i = [], o = e + t;
  let a = -1, s = 0, l;
  for (; l = n.exec(o); )
    r.push(l.index);
  for (; ++a < r.length; )
    s !== r[a] && i.push(e.slice(s, r[a])), i.push("\\"), s = r[a];
  return i.push(e.slice(s)), i.join("");
}
function sp(e) {
  const t = e || {}, n = t.now || {};
  let r = t.lineShift || 0, i = n.line || 1, o = n.column || 1;
  return { move: l, current: a, shift: s };
  function a() {
    return { now: { line: i, column: o }, lineShift: r };
  }
  function s(u) {
    r += u;
  }
  function l(u) {
    const d = u || "", f = d.split(/\r?\n|\r/g), p = f[f.length - 1];
    return i += f.length - 1, o = f.length === 1 ? o + p.length : 1 + p.length + r, d;
  }
}
UA.peek = Gve;
function $ve() {
  return {
    enter: {
      gfmFootnoteDefinition: Fve,
      gfmFootnoteDefinitionLabelString: zve,
      gfmFootnoteCall: jve,
      gfmFootnoteCallString: Wve
    },
    exit: {
      gfmFootnoteDefinition: Bve,
      gfmFootnoteDefinitionLabelString: Vve,
      gfmFootnoteCall: Hve,
      gfmFootnoteCallString: Uve
    }
  };
}
function Lve() {
  return {
    // This is on by default already.
    unsafe: [{ character: "[", inConstruct: ["phrasing", "label", "reference"] }],
    handlers: { footnoteDefinition: qve, footnoteReference: UA }
  };
}
function Fve(e) {
  this.enter(
    { type: "footnoteDefinition", identifier: "", label: "", children: [] },
    e
  );
}
function zve() {
  this.buffer();
}
function Vve(e) {
  const t = this.resume(), n = (
    /** @type {FootnoteDefinition} */
    this.stack[this.stack.length - 1]
  );
  n.label = t, n.identifier = oi(
    this.sliceSerialize(e)
  ).toLowerCase();
}
function Bve(e) {
  this.exit(e);
}
function jve(e) {
  this.enter({ type: "footnoteReference", identifier: "", label: "" }, e);
}
function Wve() {
  this.buffer();
}
function Uve(e) {
  const t = this.resume(), n = (
    /** @type {FootnoteDefinition} */
    this.stack[this.stack.length - 1]
  );
  n.label = t, n.identifier = oi(
    this.sliceSerialize(e)
  ).toLowerCase();
}
function Hve(e) {
  this.exit(e);
}
function UA(e, t, n, r) {
  const i = sp(r);
  let o = i.move("[^");
  const a = n.enter("footnoteReference"), s = n.enter("reference");
  return o += i.move(
    WA(n, BA(e), {
      ...i.current(),
      before: o,
      after: "]"
    })
  ), s(), a(), o += i.move("]"), o;
}
function Gve() {
  return "[";
}
function qve(e, t, n, r) {
  const i = sp(r);
  let o = i.move("[^");
  const a = n.enter("footnoteDefinition"), s = n.enter("label");
  return o += i.move(
    WA(n, BA(e), {
      ...i.current(),
      before: o,
      after: "]"
    })
  ), s(), o += i.move(
    "]:" + (e.children && e.children.length > 0 ? " " : "")
  ), i.shift(4), o += i.move(
    Ive(Mve(e, n, i.current()), Yve)
  ), a(), o;
}
function Yve(e, t, n) {
  return t === 0 ? e : (n ? "" : "    ") + e;
}
function HA(e, t, n) {
  const r = t.indexStack, i = e.children || [], o = [];
  let a = -1, s = n.before;
  r.push(-1);
  let l = t.createTracker(n);
  for (; ++a < i.length; ) {
    const u = i[a];
    let d;
    if (r[r.length - 1] = a, a + 1 < i.length) {
      let f = t.handle.handlers[i[a + 1].type];
      f && f.peek && (f = f.peek), d = f ? f(i[a + 1], e, t, {
        before: "",
        after: "",
        ...l.current()
      }).charAt(0) : "";
    } else
      d = n.after;
    o.length > 0 && (s === "\r" || s === `
`) && u.type === "html" && (o[o.length - 1] = o[o.length - 1].replace(
      /(\r?\n|\r)$/,
      " "
    ), s = " ", l = t.createTracker(n), l.move(o.join(""))), o.push(
      l.move(
        t.handle(u, e, t, {
          ...l.current(),
          before: s,
          after: d
        })
      )
    ), s = o[o.length - 1].slice(-1);
  }
  return r.pop(), o.join("");
}
const Kve = [
  "autolink",
  "destinationLiteral",
  "destinationRaw",
  "reference",
  "titleQuote",
  "titleApostrophe"
];
GA.peek = e0e;
const Xve = {
  canContainEols: ["delete"],
  enter: { strikethrough: Qve },
  exit: { strikethrough: Jve }
}, Zve = {
  unsafe: [
    {
      character: "~",
      inConstruct: "phrasing",
      notInConstruct: Kve
    }
  ],
  handlers: { delete: GA }
};
function Qve(e) {
  this.enter({ type: "delete", children: [] }, e);
}
function Jve(e) {
  this.exit(e);
}
function GA(e, t, n, r) {
  const i = sp(r), o = n.enter("strikethrough");
  let a = i.move("~~");
  return a += HA(e, n, {
    ...i.current(),
    before: a,
    after: "~"
  }), a += i.move("~~"), o(), a;
}
function e0e() {
  return "~";
}
qA.peek = t0e;
function qA(e, t, n) {
  let r = e.value || "", i = "`", o = -1;
  for (; new RegExp("(^|[^`])" + i + "([^`]|$)").test(r); )
    i += "`";
  for (/[^ \r\n]/.test(r) && (/^[ \r\n]/.test(r) && /[ \r\n]$/.test(r) || /^`|`$/.test(r)) && (r = " " + r + " "); ++o < n.unsafe.length; ) {
    const a = n.unsafe[o], s = jA(a);
    let l;
    if (a.atBreak)
      for (; l = s.exec(r); ) {
        let u = l.index;
        r.charCodeAt(u) === 10 && r.charCodeAt(u - 1) === 13 && u--, r = r.slice(0, u) + " " + r.slice(l.index + 1);
      }
  }
  return i + r + i;
}
function t0e() {
  return "`";
}
function n0e(e) {
  return e.length;
}
function r0e(e, t) {
  const n = t || {}, r = (n.align || []).concat(), i = n.stringLength || n0e, o = [], a = [], s = [], l = [];
  let u = 0, d = -1;
  for (; ++d < e.length; ) {
    const v = [], y = [];
    let b = -1;
    for (e[d].length > u && (u = e[d].length); ++b < e[d].length; ) {
      const E = i0e(e[d][b]);
      if (n.alignDelimiters !== !1) {
        const S = i(E);
        y[b] = S, (l[b] === void 0 || S > l[b]) && (l[b] = S);
      }
      v.push(E);
    }
    a[d] = v, s[d] = y;
  }
  let f = -1;
  if (typeof r == "object" && "length" in r)
    for (; ++f < u; )
      o[f] = G4(r[f]);
  else {
    const v = G4(r);
    for (; ++f < u; )
      o[f] = v;
  }
  f = -1;
  const p = [], m = [];
  for (; ++f < u; ) {
    const v = o[f];
    let y = "", b = "";
    v === 99 ? (y = ":", b = ":") : v === 108 ? y = ":" : v === 114 && (b = ":");
    let E = n.alignDelimiters === !1 ? 1 : Math.max(
      1,
      l[f] - y.length - b.length
    );
    const S = y + "-".repeat(E) + b;
    n.alignDelimiters !== !1 && (E = y.length + E + b.length, E > l[f] && (l[f] = E), m[f] = E), p[f] = S;
  }
  a.splice(1, 0, p), s.splice(1, 0, m), d = -1;
  const g = [];
  for (; ++d < a.length; ) {
    const v = a[d], y = s[d];
    f = -1;
    const b = [];
    for (; ++f < u; ) {
      const E = v[f] || "";
      let S = "", _ = "";
      if (n.alignDelimiters !== !1) {
        const k = l[f] - (y[f] || 0), T = o[f];
        T === 114 ? S = " ".repeat(k) : T === 99 ? k % 2 ? (S = " ".repeat(k / 2 + 0.5), _ = " ".repeat(k / 2 - 0.5)) : (S = " ".repeat(k / 2), _ = S) : _ = " ".repeat(k);
      }
      n.delimiterStart !== !1 && !f && b.push("|"), n.padding !== !1 && // Don’t add the opening space if we’re not aligning and the cell is
      // empty: there will be a closing space.
      !(n.alignDelimiters === !1 && E === "") && (n.delimiterStart !== !1 || f) && b.push(" "), n.alignDelimiters !== !1 && b.push(S), b.push(E), n.alignDelimiters !== !1 && b.push(_), n.padding !== !1 && b.push(" "), (n.delimiterEnd !== !1 || f !== u - 1) && b.push("|");
    }
    g.push(
      n.delimiterEnd === !1 ? b.join("").replace(/ +$/, "") : b.join("")
    );
  }
  return g.join(`
`);
}
function i0e(e) {
  return e == null ? "" : String(e);
}
function G4(e) {
  const t = typeof e == "string" ? e.codePointAt(0) : 0;
  return t === 67 || t === 99 ? 99 : t === 76 || t === 108 ? 108 : t === 82 || t === 114 ? 114 : 0;
}
const o0e = {
  enter: {
    table: a0e,
    tableData: q4,
    tableHeader: q4,
    tableRow: l0e
  },
  exit: {
    codeText: c0e,
    table: s0e,
    tableData: qg,
    tableHeader: qg,
    tableRow: qg
  }
};
function a0e(e) {
  const t = e._align;
  this.enter(
    {
      type: "table",
      align: t.map((n) => n === "none" ? null : n),
      children: []
    },
    e
  ), this.setData("inTable", !0);
}
function s0e(e) {
  this.exit(e), this.setData("inTable");
}
function l0e(e) {
  this.enter({ type: "tableRow", children: [] }, e);
}
function qg(e) {
  this.exit(e);
}
function q4(e) {
  this.enter({ type: "tableCell", children: [] }, e);
}
function c0e(e) {
  let t = this.resume();
  this.getData("inTable") && (t = t.replace(/\\([\\|])/g, u0e));
  const n = (
    /** @type {InlineCode} */
    this.stack[this.stack.length - 1]
  );
  n.value = t, this.exit(e);
}
function u0e(e, t) {
  return t === "|" ? t : e;
}
function d0e(e) {
  const t = e || {}, n = t.tableCellPadding, r = t.tablePipeAlign, i = t.stringLength, o = n ? " " : "|";
  return {
    unsafe: [
      { character: "\r", inConstruct: "tableCell" },
      { character: `
`, inConstruct: "tableCell" },
      // A pipe, when followed by a tab or space (padding), or a dash or colon
      // (unpadded delimiter row), could result in a table.
      { atBreak: !0, character: "|", after: "[	 :-]" },
      // A pipe in a cell must be encoded.
      { character: "|", inConstruct: "tableCell" },
      // A colon must be followed by a dash, in which case it could start a
      // delimiter row.
      { atBreak: !0, character: ":", after: "-" },
      // A delimiter row can also start with a dash, when followed by more
      // dashes, a colon, or a pipe.
      // This is a stricter version than the built in check for lists, thematic
      // breaks, and setex heading underlines though:
      // <https://github.com/syntax-tree/mdast-util-to-markdown/blob/51a2038/lib/unsafe.js#L57>
      { atBreak: !0, character: "-", after: "[:|-]" }
    ],
    handlers: {
      table: a,
      tableRow: s,
      tableCell: l,
      inlineCode: p
    }
  };
  function a(m, g, v, y) {
    return u(
      d(m, v, y),
      m.align
    );
  }
  function s(m, g, v, y) {
    const b = f(m, v, y), E = u([b]);
    return E.slice(0, E.indexOf(`
`));
  }
  function l(m, g, v, y) {
    const b = v.enter("tableCell"), E = v.enter("phrasing"), S = HA(m, v, {
      ...y,
      before: o,
      after: o
    });
    return E(), b(), S;
  }
  function u(m, g) {
    return r0e(m, {
      align: g,
      // @ts-expect-error: `markdown-table` types should support `null`.
      alignDelimiters: r,
      // @ts-expect-error: `markdown-table` types should support `null`.
      padding: n,
      // @ts-expect-error: `markdown-table` types should support `null`.
      stringLength: i
    });
  }
  function d(m, g, v) {
    const y = m.children;
    let b = -1;
    const E = [], S = g.enter("table");
    for (; ++b < y.length; )
      E[b] = f(
        y[b],
        g,
        v
      );
    return S(), E;
  }
  function f(m, g, v) {
    const y = m.children;
    let b = -1;
    const E = [], S = g.enter("tableRow");
    for (; ++b < y.length; )
      E[b] = l(
        y[b],
        m,
        g,
        v
      );
    return S(), E;
  }
  function p(m, g, v) {
    let y = qA(m, g, v);
    return v.stack.includes("tableCell") && (y = y.replace(/\|/g, "\\$&")), y;
  }
}
function f0e(e) {
  const t = e.options.bullet || "*";
  if (t !== "*" && t !== "+" && t !== "-")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.bullet`, expected `*`, `+`, or `-`"
    );
  return t;
}
function h0e(e) {
  const t = e.options.listItemIndent || "tab";
  if (t === 1 || t === "1")
    return "one";
  if (t !== "tab" && t !== "one" && t !== "mixed")
    throw new Error(
      "Cannot serialize items with `" + t + "` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`"
    );
  return t;
}
function p0e(e, t, n, r) {
  const i = h0e(n);
  let o = n.bulletCurrent || f0e(n);
  t && t.type === "list" && t.ordered && (o = (typeof t.start == "number" && t.start > -1 ? t.start : 1) + (n.options.incrementListMarker === !1 ? 0 : t.children.indexOf(e)) + o);
  let a = o.length + 1;
  (i === "tab" || i === "mixed" && (t && t.type === "list" && t.spread || e.spread)) && (a = Math.ceil(a / 4) * 4);
  const s = n.createTracker(r);
  s.move(o + " ".repeat(a - o.length)), s.shift(a);
  const l = n.enter("listItem"), u = n.indentLines(
    n.containerFlow(e, s.current()),
    d
  );
  return l(), u;
  function d(f, p, m) {
    return p ? (m ? "" : " ".repeat(a)) + f : (m ? o : o + " ".repeat(a - o.length)) + f;
  }
}
const m0e = {
  exit: {
    taskListCheckValueChecked: Y4,
    taskListCheckValueUnchecked: Y4,
    paragraph: v0e
  }
}, g0e = {
  unsafe: [{ atBreak: !0, character: "-", after: "[:|-]" }],
  handlers: { listItem: y0e }
};
function Y4(e) {
  const t = (
    /** @type {ListItem} */
    this.stack[this.stack.length - 2]
  );
  t.checked = e.type === "taskListCheckValueChecked";
}
function v0e(e) {
  const t = (
    /** @type {Parents} */
    this.stack[this.stack.length - 2]
  );
  if (t && t.type === "listItem" && typeof t.checked == "boolean") {
    const n = (
      /** @type {Paragraph} */
      this.stack[this.stack.length - 1]
    ), r = n.children[0];
    if (r && r.type === "text") {
      const i = t.children;
      let o = -1, a;
      for (; ++o < i.length; ) {
        const s = i[o];
        if (s.type === "paragraph") {
          a = s;
          break;
        }
      }
      a === n && (r.value = r.value.slice(1), r.value.length === 0 ? n.children.shift() : n.position && r.position && typeof r.position.start.offset == "number" && (r.position.start.column++, r.position.start.offset++, n.position.start = Object.assign({}, r.position.start)));
    }
  }
  this.exit(e);
}
function y0e(e, t, n, r) {
  const i = e.children[0], o = typeof e.checked == "boolean" && i && i.type === "paragraph", a = "[" + (e.checked ? "x" : " ") + "] ", s = sp(r);
  o && s.move(a);
  let l = p0e(e, t, n, {
    ...r,
    ...s.current()
  });
  return o && (l = l.replace(/^(?:[*+-]|\d+\.)([\r\n]| {1,3})/, u)), l;
  function u(d) {
    return d + a;
  }
}
function w0e() {
  return [
    yve,
    $ve(),
    Xve,
    o0e,
    m0e
  ];
}
function b0e(e) {
  return {
    extensions: [
      wve,
      Lve(),
      Zve,
      d0e(e),
      g0e
    ]
  };
}
function x0e(e = {}) {
  const t = this.data();
  n("micromarkExtensions", hve(e)), n("fromMarkdownExtensions", w0e()), n("toMarkdownExtensions", b0e(e));
  function n(r, i) {
    /** @type {unknown[]} */
    // Other extensions
    /* c8 ignore next 2 */
    (t[r] ? t[r] : t[r] = []).push(i);
  }
}
function YA({
  remarkPlugins: e = [],
  components: t = {},
  ...n
}) {
  const r = Lt(
    () => ({
      h1: (i) => /* @__PURE__ */ x.createElement("h1", { className: "ai-tw-heading-1", ...i }),
      h2: (i) => /* @__PURE__ */ x.createElement("h2", { className: "ai-tw-heading-2", ...i }),
      h3: (i) => /* @__PURE__ */ x.createElement("h3", { className: "ai-tw-heading-3", ...i }),
      h4: (i) => /* @__PURE__ */ x.createElement("h4", { className: "ai-tw-subtitle-md-bold", ...i }),
      h5: (i) => /* @__PURE__ */ x.createElement("h5", { className: "ai-tw-subtitle-md", ...i }),
      h6: (i) => /* @__PURE__ */ x.createElement("h6", { className: "ai-tw-subtitle-sm", ...i }),
      p: (i) => /* @__PURE__ */ x.createElement("p", { className: "ai-tw-my-2 ai-tw-body-md", ...i }),
      hr: (i) => /* @__PURE__ */ x.createElement(
        "hr",
        {
          className: "ai-tw-my-4 ai-tw-border-stroke-primary ai-tw-bg-stroke-primary",
          ...i
        }
      ),
      a: (i) => /* @__PURE__ */ x.createElement(
        "a",
        {
          className: "ai-tw-text-element-brand ai-tw-underline hover:ai-tw-text-element-brand-dark",
          target: "_blank",
          ...i
        }
      ),
      br: (i) => /* @__PURE__ */ x.createElement("br", { className: "ai-tw-my-2", ...i }),
      blockquote: (i) => /* @__PURE__ */ x.createElement(
        "blockquote",
        {
          className: "ai-tw-my-4 ai-tw-rounded ai-tw-border-l-4 ai-tw-border-stroke-primary ai-tw-bg-container-backdrop ai-tw-p-2 ai-tw-body-md",
          ...i
        }
      ),
      code: ({ inline: i, ...o }) => /* @__PURE__ */ x.createElement(
        "code",
        {
          className: "ai-tw-rounded-sm ai-tw-px-1.5 ai-tw-py-0.5 ai-tw-body-sm",
          ...o
        }
      ),
      em: (i) => /* @__PURE__ */ x.createElement("em", { className: "ai-tw-italic ai-tw-body-md", ...i }),
      img: (i) => /* @__PURE__ */ x.createElement(
        "img",
        {
          className: "ai-tw-mx-auto ai-tw-my-4 ai-tw-rounded-lg ai-tw-shadow-base",
          ...i
        }
      ),
      li: ({ ordered: i, ...o }) => /* @__PURE__ */ x.createElement(
        "li",
        {
          className: ie(
            "ai-tw-ml-4 ai-tw-body-md",
            i ? "ai-tw-list-decimal" : "ai-tw-list-disc"
          ),
          ...o
        }
      ),
      ol: ({ ordered: i, ...o }) => /* @__PURE__ */ x.createElement(
        "ol",
        {
          className: "ai-tw-my-2 ai-tw-list-decimal ai-tw-space-y-1 ai-tw-pl-2",
          ...o
        }
      ),
      ul: ({ ordered: i, ...o }) => /* @__PURE__ */ x.createElement(
        "ul",
        {
          className: "ai-tw-my-2 ai-tw-list-disc ai-tw-space-y-1 ai-tw-pl-2",
          ...o
        }
      ),
      pre: (i) => /* @__PURE__ */ x.createElement(
        "pre",
        {
          className: "ai-tw-my-4 ai-tw-overflow-x-auto ai-tw-whitespace-pre-wrap ai-tw-rounded-lg ai-tw-bg-container-backdrop ai-tw-p-4 ai-tw-body-sm",
          ...i
        }
      ),
      strong: (i) => /* @__PURE__ */ x.createElement("strong", { className: "ai-tw-subtitle-md-bold", ...i }),
      del: (i) => /* @__PURE__ */ x.createElement(
        "del",
        {
          className: "ai-tw-text-content-primary-light ai-tw-line-through ai-tw-body-md",
          ...i
        }
      ),
      input: (i) => /* @__PURE__ */ x.createElement("input", { className: "ai-tw-mr-2 ai-tw-accent-element-brand", ...i }),
      table: (i) => /* @__PURE__ */ x.createElement(
        "table",
        {
          className: "ai-tw-my-4 ai-tw-w-full ai-tw-border-collapse ai-tw-border ai-tw-border-stroke-primary",
          ...i
        }
      ),
      tbody: (i) => /* @__PURE__ */ x.createElement(
        "tbody",
        {
          className: "ai-tw-divide-y ai-tw-border-stroke-primary",
          ...i
        }
      ),
      td: ({ isHeader: i, ...o }) => /* @__PURE__ */ x.createElement(
        "td",
        {
          className: "ai-tw-border ai-tw-border-stroke-primary ai-tw-p-2 ai-tw-body-md",
          ...o
        }
      ),
      th: ({ isHeader: i, ...o }) => /* @__PURE__ */ x.createElement(
        "th",
        {
          className: "ai-tw-border ai-tw-border-stroke-primary ai-tw-p-2 ai-tw-text-left ai-tw-subtitle-md-bold",
          ...o
        }
      ),
      thead: (i) => /* @__PURE__ */ x.createElement(
        "thead",
        {
          className: "ai-tw-border-b-2 ai-tw-border-stroke-primary",
          ...i
        }
      ),
      tr: ({ isHeader: i, ...o }) => /* @__PURE__ */ x.createElement(
        "tr",
        {
          className: "ai-tw-border-stroke-primary even:ai-tw-bg-container-backdrop/50",
          ...o
        }
      ),
      ...t
    }),
    [t]
  );
  return /* @__PURE__ */ x.createElement(
    OA,
    {
      remarkPlugins: [x0e, ...e],
      components: r,
      ...n
    }
  );
}
const E0e = {
  a: Cw,
  p: qce,
  img: zce
};
function J0({
  id: e,
  chatId: t,
  message: n,
  answerLoading: r,
  followUpQuestions: i,
  sources: o,
  metadata: a
}) {
  return /* @__PURE__ */ x.createElement(
    "div",
    {
      className: ie(
        "ai-tw-mt-2 ai-tw-rounded-lg ai-tw-bg-container-backdrop ai-tw-p-5"
      )
    },
    /* @__PURE__ */ x.createElement("div", { className: "ai-tw-mb-6" }, /* @__PURE__ */ x.createElement(gw, { width: 53, height: 10 })),
    r ? /* @__PURE__ */ x.createElement("div", { className: "ai-tw-ml-1 ai-tw-mt-2" }, /* @__PURE__ */ x.createElement(L0, null, /* @__PURE__ */ x.createElement(Dfe, null))) : /* @__PURE__ */ x.createElement(L0, null, /* @__PURE__ */ x.createElement(Bc.Provider, { value: { metadata: a, sources: o } }, /* @__PURE__ */ x.createElement(YA, { components: E0e }, n || ""))),
    e && t ? /* @__PURE__ */ x.createElement(Kce, { messageId: e, chatId: t }) : null,
    !r && n ? /* @__PURE__ */ x.createElement(Ife, { sources: o }) : null,
    i ? /* @__PURE__ */ x.createElement(Xce, { followUpQuestions: i }) : null
  );
}
function C0e({ children: e }) {
  return /* @__PURE__ */ x.createElement("div", { className: "ai-tw-my-2 ai-tw-flex ai-tw-items-center ai-tw-rounded-lg ai-tw-bg-red-10 ai-tw-p-4" }, /* @__PURE__ */ x.createElement(
    Le,
    {
      icon: cL,
      className: "ai-tw-mr-4 ai-tw-grow-0 ai-tw-text-red-60"
    }
  ), /* @__PURE__ */ x.createElement("span", { className: "ai-tw-flex-1 ai-tw-text-sm ai-tw-text-red-60" }, e));
}
function S0e() {
  const { chatState: e } = Me(At), t = YT(e);
  return t != null && t.length ? /* @__PURE__ */ x.createElement("div", null, t.map((n) => /* @__PURE__ */ x.createElement(C0e, { key: n }, n))) : null;
}
function _0e() {
  const { chatState: e, isGenerationInProgress: t } = Me(At);
  if (!no(e))
    return t ? /* @__PURE__ */ x.createElement(J0, { answerLoading: !0 }) : null;
  const r = joe(e);
  return /* @__PURE__ */ x.createElement(x.Fragment, null, r && /* @__PURE__ */ x.createElement(
    J0,
    {
      message: r,
      followUpQuestions: Boe(e),
      sources: Woe(e),
      metadata: Hoe(e)
    }
  ), /* @__PURE__ */ x.createElement(S0e, null));
}
function KA({ message: e }) {
  return /* @__PURE__ */ x.createElement("div", { className: "ai-tw-ml-auto ai-tw-mt-2 ai-tw-w-max ai-tw-max-w-[75%] ai-tw-rounded-lg ai-tw-bg-element-primary-subtle ai-tw-p-4" }, /* @__PURE__ */ x.createElement(L0, null, e));
}
function P0e() {
  const { chatState: e } = Me(At), t = Uoe(e);
  return t ? /* @__PURE__ */ x.createElement(KA, { message: t }) : null;
}
function k0e({
  transcript: e = [],
  transcriptRef: t,
  generation: n
}) {
  const { disableStreamingAutoScroll: r, isStreamingAutoScrollEnabled: i } = Me(At), o = x7(n);
  return n !== o && i && QT(t), /* @__PURE__ */ x.createElement(
    "div",
    {
      ref: t,
      onWheel: r,
      className: "ai-tw-flex ai-tw-h-full ai-tw-flex-col ai-tw-overflow-auto ai-tw-px-4 ai-tw-py-2"
    },
    /* @__PURE__ */ x.createElement("div", { className: "ai-tw-mt-auto" }, loe(e).map((a, s) => {
      if (goe(a) === "human") {
        const u = a;
        return /* @__PURE__ */ x.createElement(
          KA,
          {
            key: s,
            message: moe(u)
          }
        );
      }
      const l = a;
      return /* @__PURE__ */ x.createElement(
        J0,
        {
          key: s,
          id: foe(l),
          chatId: hoe(l),
          message: zT(l),
          followUpQuestions: uoe(l),
          sources: coe(l),
          metadata: doe(l)
        }
      );
    }), /* @__PURE__ */ x.createElement(P0e, null), /* @__PURE__ */ x.createElement(_0e, null))
  );
}
function T0e({ children: e, className: t }) {
  return /* @__PURE__ */ x.createElement(
    "div",
    {
      className: ie(
        "ai-tw-w-fit ai-tw-rounded ai-tw-bg-element-brand-lightest ai-tw-px-2 ai-tw-py-1 ai-tw-text-content-brand-dark",
        t
      )
    },
    /* @__PURE__ */ x.createElement("p", { className: "ai-tw-capitalize ai-tw-subtitle-sm" }, e)
  );
}
function A0e({
  releaseNote: e,
  selected: t
}) {
  const n = $le(e);
  return /* @__PURE__ */ x.createElement(
    "div",
    {
      className: ie(
        "ai-tw-rounded-lg ai-tw-border ai-tw-border-transparent ai-tw-p-6",
        {
          "ai-tw-border-stroke-brand": t,
          "ai-tw-shadow-md": !t
        }
      )
    },
    /* @__PURE__ */ x.createElement("p", { className: "ai-tw-text-content-primary ai-tw-heading-2" }, E7(e)),
    /* @__PURE__ */ x.createElement("p", { className: "ai-tw-mt-1 ai-tw-text-content-primary-light ai-tw-body-sm" }, Qh(C7(e))),
    n != null && n.length ? /* @__PURE__ */ x.createElement("ul", { className: "ai-tw-mt-4 ai-tw-flex ai-tw-flex-wrap ai-tw-gap-1" }, n.map((r) => /* @__PURE__ */ x.createElement("li", { key: r }, /* @__PURE__ */ x.createElement(T0e, null, r)))) : null,
    /* @__PURE__ */ x.createElement(YA, { className: "ai-tw-mt-4 ai-tw-text-content-primary" }, Lle(e))
  );
}
function M0e({
  className: e,
  selectedReleaseNoteId: t,
  onClose: n
}) {
  const { data: r, isLoading: i } = tp(), o = i || !r ? null : np(r);
  return /* @__PURE__ */ x.createElement(
    mn.div,
    {
      className: ie("ai-tw-flex ai-tw-flex-col ai-tw-bg-white", e),
      initial: { opacity: 0, y: 10 },
      animate: { opacity: 1, y: 0 },
      exit: { opacity: 0, y: 10 },
      transition: { duration: 0.2 }
    },
    /* @__PURE__ */ x.createElement("div", { className: "ai-tw-relative ai-tw-border-b ai-tw-border-stroke-primary ai-tw-px-6 ai-tw-py-4" }, /* @__PURE__ */ x.createElement(
      Oa,
      {
        icon: E$,
        className: "ai-tw-absolute ai-tw-left-3 ai-tw-top-1/2 -ai-tw-translate-y-1/2 ai-tw-text-xs ai-tw-text-content-primary-light",
        onClick: n
      }
    ), /* @__PURE__ */ x.createElement("p", { className: "ai-tw-px-4 ai-tw-text-center ai-tw-text-content-primary ai-tw-subtitle-md" }, "What’s New with Gabbi")),
    /* @__PURE__ */ x.createElement("div", { className: "ai-tw-min-h-0 ai-tw-flex-1 ai-tw-overflow-auto ai-tw-px-6 ai-tw-py-2" }, /* @__PURE__ */ x.createElement("p", { className: "ai-tw-text-content-primary-light ai-tw-subtitle-sm" }, "Latest Updates"), i ? /* @__PURE__ */ x.createElement(jn, { size: "small" }) : /* @__PURE__ */ x.createElement("ul", { className: "ai-tw-mt-2 ai-tw-flex ai-tw-flex-col ai-tw-gap-y-2" }, o == null ? void 0 : o.map((a) => /* @__PURE__ */ x.createElement("li", { key: M0(a) }, /* @__PURE__ */ x.createElement(
      A0e,
      {
        selected: t === M0(a),
        releaseNote: a
      }
    )))))
  );
}
function O0e(e) {
  return /* @__PURE__ */ x.createElement(
    Do,
    {
      fallback: /* @__PURE__ */ x.createElement(
        "div",
        {
          className: ie(
            "ai-tw-flex ai-tw-items-center ai-tw-justify-center ai-tw-bg-white",
            e.className
          )
        },
        /* @__PURE__ */ x.createElement("div", null, /* @__PURE__ */ x.createElement("p", { className: "ai-tw-text-center ai-tw-text-red-50 ai-tw-subtitle-md" }, "Release notes are currently unavailable. Please try again later."), /* @__PURE__ */ x.createElement(
          Xt,
          {
            size: "sm",
            variant: "tertiary",
            className: "ai-tw-mx-auto ai-tw-mt-4 ai-tw-block ai-tw-w-fit",
            onClick: e.onClose
          },
          "Go Back"
        ))
      )
    },
    /* @__PURE__ */ x.createElement(M0e, { ...e })
  );
}
function K4({ transcriptRef: e }) {
  const [t, n] = de(), {
    chatState: r,
    chatDispatch: i,
    navigationState: o,
    isGenerationInProgress: a,
    isReleaseNotesOpen: s,
    setIsReleaseNotesOpen: l
  } = Me(At), u = Vc(r), d = no(r), f = KT(r), {
    swr: { data: p }
  } = qh({
    chatId: u,
    enabled: !!u
  }), m = yoe(p) || [], g = Foe(o);
  return /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement(uw, null), /* @__PURE__ */ x.createElement(
    "div",
    {
      id: sw,
      className: "ai-tw-relative ai-tw-mx-auto ai-tw-flex ai-tw-w-full ai-tw-max-w-[600px] ai-tw-grow ai-tw-cursor-default ai-tw-flex-col ai-tw-overflow-auto"
    },
    m.length || a || d || u ? /* @__PURE__ */ x.createElement(
      k0e,
      {
        transcript: m,
        generation: d,
        transcriptRef: e
      }
    ) : /* @__PURE__ */ x.createElement(
      Xle,
      {
        setSelectedReleaseNoteId: n
      }
    ),
    /* @__PURE__ */ x.createElement(yae, null),
    /* @__PURE__ */ x.createElement(
      uae,
      {
        isOpen: !!XT(r),
        onClose: () => i({ type: "unselectChatMessageForFeedback" })
      }
    ),
    /* @__PURE__ */ x.createElement(ri, null, s ? /* @__PURE__ */ x.createElement(
      O0e,
      {
        className: "ai-tw-absolute ai-tw-inset-0",
        selectedReleaseNoteId: t,
        onClose: () => {
          l(!1), n(void 0);
        }
      }
    ) : null),
    /* @__PURE__ */ x.createElement(ri, null, !f && g ? /* @__PURE__ */ x.createElement(Ole, { className: "ai-tw-inset-x-0 ai-tw-bottom-[41px] ai-tw-top-2 ai-tw-z-10 ai-tw-mx-3" }) : null)
  ), /* @__PURE__ */ x.createElement(iae, null));
}
var lp = { exports: {} }, XA = {};
const R0e = /* @__PURE__ */ KU(yU);
var Zt = {}, Ti = {};
Object.defineProperty(Ti, "__esModule", {
  value: !0
});
Ti.dontSetMe = L0e;
Ti.findInArray = I0e;
Ti.int = $0e;
Ti.isFunction = D0e;
Ti.isNum = N0e;
function I0e(e, t) {
  for (let n = 0, r = e.length; n < r; n++)
    if (t.apply(t, [e[n], n, e]))
      return e[n];
}
function D0e(e) {
  return typeof e == "function" || Object.prototype.toString.call(e) === "[object Function]";
}
function N0e(e) {
  return typeof e == "number" && !isNaN(e);
}
function $0e(e) {
  return parseInt(e, 10);
}
function L0e(e, t, n) {
  if (e[t])
    return new Error("Invalid prop ".concat(t, " passed to ").concat(n, " - do not set this, set it on the child."));
}
var Ia = {};
Object.defineProperty(Ia, "__esModule", {
  value: !0
});
Ia.browserPrefixToKey = QA;
Ia.browserPrefixToStyle = F0e;
Ia.default = void 0;
Ia.getPrefix = ZA;
const Yg = ["Moz", "Webkit", "O", "ms"];
function ZA() {
  var e;
  let t = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "transform";
  if (typeof window > "u")
    return "";
  const n = (e = window.document) === null || e === void 0 || (e = e.documentElement) === null || e === void 0 ? void 0 : e.style;
  if (!n || t in n)
    return "";
  for (let r = 0; r < Yg.length; r++)
    if (QA(t, Yg[r]) in n)
      return Yg[r];
  return "";
}
function QA(e, t) {
  return t ? "".concat(t).concat(z0e(e)) : e;
}
function F0e(e, t) {
  return t ? "-".concat(t.toLowerCase(), "-").concat(e) : e;
}
function z0e(e) {
  let t = "", n = !0;
  for (let r = 0; r < e.length; r++)
    n ? (t += e[r].toUpperCase(), n = !1) : e[r] === "-" ? n = !0 : t += e[r];
  return t;
}
Ia.default = ZA();
Object.defineProperty(Zt, "__esModule", {
  value: !0
});
Zt.addClassName = tM;
Zt.addEvent = j0e;
Zt.addUserSelectStyles = J0e;
Zt.createCSSTransform = K0e;
Zt.createSVGTransform = X0e;
Zt.getTouch = Z0e;
Zt.getTouchIdentifier = Q0e;
Zt.getTranslation = Dw;
Zt.innerHeight = G0e;
Zt.innerWidth = q0e;
Zt.matchesSelector = eM;
Zt.matchesSelectorAndParentsTo = B0e;
Zt.offsetXYFromParent = Y0e;
Zt.outerHeight = U0e;
Zt.outerWidth = H0e;
Zt.removeClassName = nM;
Zt.removeEvent = W0e;
Zt.removeUserSelectStyles = e1e;
var vr = Ti, X4 = V0e(Ia);
function JA(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (JA = function(r) {
    return r ? n : t;
  })(e);
}
function V0e(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = JA(t);
  if (n && n.has(e))
    return n.get(e);
  var r = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var o in e)
    if (o !== "default" && Object.prototype.hasOwnProperty.call(e, o)) {
      var a = i ? Object.getOwnPropertyDescriptor(e, o) : null;
      a && (a.get || a.set) ? Object.defineProperty(r, o, a) : r[o] = e[o];
    }
  return r.default = e, n && n.set(e, r), r;
}
let Td = "";
function eM(e, t) {
  return Td || (Td = (0, vr.findInArray)(["matches", "webkitMatchesSelector", "mozMatchesSelector", "msMatchesSelector", "oMatchesSelector"], function(n) {
    return (0, vr.isFunction)(e[n]);
  })), (0, vr.isFunction)(e[Td]) ? e[Td](t) : !1;
}
function B0e(e, t, n) {
  let r = e;
  do {
    if (eM(r, t))
      return !0;
    if (r === n)
      return !1;
    r = r.parentNode;
  } while (r);
  return !1;
}
function j0e(e, t, n, r) {
  if (!e)
    return;
  const i = {
    capture: !0,
    ...r
  };
  e.addEventListener ? e.addEventListener(t, n, i) : e.attachEvent ? e.attachEvent("on" + t, n) : e["on" + t] = n;
}
function W0e(e, t, n, r) {
  if (!e)
    return;
  const i = {
    capture: !0,
    ...r
  };
  e.removeEventListener ? e.removeEventListener(t, n, i) : e.detachEvent ? e.detachEvent("on" + t, n) : e["on" + t] = null;
}
function U0e(e) {
  let t = e.clientHeight;
  const n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t += (0, vr.int)(n.borderTopWidth), t += (0, vr.int)(n.borderBottomWidth), t;
}
function H0e(e) {
  let t = e.clientWidth;
  const n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t += (0, vr.int)(n.borderLeftWidth), t += (0, vr.int)(n.borderRightWidth), t;
}
function G0e(e) {
  let t = e.clientHeight;
  const n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t -= (0, vr.int)(n.paddingTop), t -= (0, vr.int)(n.paddingBottom), t;
}
function q0e(e) {
  let t = e.clientWidth;
  const n = e.ownerDocument.defaultView.getComputedStyle(e);
  return t -= (0, vr.int)(n.paddingLeft), t -= (0, vr.int)(n.paddingRight), t;
}
function Y0e(e, t, n) {
  const i = t === t.ownerDocument.body ? {
    left: 0,
    top: 0
  } : t.getBoundingClientRect(), o = (e.clientX + t.scrollLeft - i.left) / n, a = (e.clientY + t.scrollTop - i.top) / n;
  return {
    x: o,
    y: a
  };
}
function K0e(e, t) {
  const n = Dw(e, t, "px");
  return {
    [(0, X4.browserPrefixToKey)("transform", X4.default)]: n
  };
}
function X0e(e, t) {
  return Dw(e, t, "");
}
function Dw(e, t, n) {
  let {
    x: r,
    y: i
  } = e, o = "translate(".concat(r).concat(n, ",").concat(i).concat(n, ")");
  if (t) {
    const a = "".concat(typeof t.x == "string" ? t.x : t.x + n), s = "".concat(typeof t.y == "string" ? t.y : t.y + n);
    o = "translate(".concat(a, ", ").concat(s, ")") + o;
  }
  return o;
}
function Z0e(e, t) {
  return e.targetTouches && (0, vr.findInArray)(e.targetTouches, (n) => t === n.identifier) || e.changedTouches && (0, vr.findInArray)(e.changedTouches, (n) => t === n.identifier);
}
function Q0e(e) {
  if (e.targetTouches && e.targetTouches[0])
    return e.targetTouches[0].identifier;
  if (e.changedTouches && e.changedTouches[0])
    return e.changedTouches[0].identifier;
}
function J0e(e) {
  if (!e)
    return;
  let t = e.getElementById("react-draggable-style-el");
  t || (t = e.createElement("style"), t.type = "text/css", t.id = "react-draggable-style-el", t.innerHTML = `.react-draggable-transparent-selection *::-moz-selection {all: inherit;}
`, t.innerHTML += `.react-draggable-transparent-selection *::selection {all: inherit;}
`, e.getElementsByTagName("head")[0].appendChild(t)), e.body && tM(e.body, "react-draggable-transparent-selection");
}
function e1e(e) {
  if (e)
    try {
      if (e.body && nM(e.body, "react-draggable-transparent-selection"), e.selection)
        e.selection.empty();
      else {
        const t = (e.defaultView || window).getSelection();
        t && t.type !== "Caret" && t.removeAllRanges();
      }
    } catch {
    }
}
function tM(e, t) {
  e.classList ? e.classList.add(t) : e.className.match(new RegExp("(?:^|\\s)".concat(t, "(?!\\S)"))) || (e.className += " ".concat(t));
}
function nM(e, t) {
  e.classList ? e.classList.remove(t) : e.className = e.className.replace(new RegExp("(?:^|\\s)".concat(t, "(?!\\S)"), "g"), "");
}
var Ai = {};
Object.defineProperty(Ai, "__esModule", {
  value: !0
});
Ai.canDragX = r1e;
Ai.canDragY = i1e;
Ai.createCoreData = a1e;
Ai.createDraggableData = s1e;
Ai.getBoundPosition = t1e;
Ai.getControlPosition = o1e;
Ai.snapToGrid = n1e;
var fr = Ti, ps = Zt;
function t1e(e, t, n) {
  if (!e.props.bounds)
    return [t, n];
  let {
    bounds: r
  } = e.props;
  r = typeof r == "string" ? r : l1e(r);
  const i = Nw(e);
  if (typeof r == "string") {
    const {
      ownerDocument: o
    } = i, a = o.defaultView;
    let s;
    if (r === "parent" ? s = i.parentNode : s = o.querySelector(r), !(s instanceof a.HTMLElement))
      throw new Error('Bounds selector "' + r + '" could not find an element.');
    const l = s, u = a.getComputedStyle(i), d = a.getComputedStyle(l);
    r = {
      left: -i.offsetLeft + (0, fr.int)(d.paddingLeft) + (0, fr.int)(u.marginLeft),
      top: -i.offsetTop + (0, fr.int)(d.paddingTop) + (0, fr.int)(u.marginTop),
      right: (0, ps.innerWidth)(l) - (0, ps.outerWidth)(i) - i.offsetLeft + (0, fr.int)(d.paddingRight) - (0, fr.int)(u.marginRight),
      bottom: (0, ps.innerHeight)(l) - (0, ps.outerHeight)(i) - i.offsetTop + (0, fr.int)(d.paddingBottom) - (0, fr.int)(u.marginBottom)
    };
  }
  return (0, fr.isNum)(r.right) && (t = Math.min(t, r.right)), (0, fr.isNum)(r.bottom) && (n = Math.min(n, r.bottom)), (0, fr.isNum)(r.left) && (t = Math.max(t, r.left)), (0, fr.isNum)(r.top) && (n = Math.max(n, r.top)), [t, n];
}
function n1e(e, t, n) {
  const r = Math.round(t / e[0]) * e[0], i = Math.round(n / e[1]) * e[1];
  return [r, i];
}
function r1e(e) {
  return e.props.axis === "both" || e.props.axis === "x";
}
function i1e(e) {
  return e.props.axis === "both" || e.props.axis === "y";
}
function o1e(e, t, n) {
  const r = typeof t == "number" ? (0, ps.getTouch)(e, t) : null;
  if (typeof t == "number" && !r)
    return null;
  const i = Nw(n), o = n.props.offsetParent || i.offsetParent || i.ownerDocument.body;
  return (0, ps.offsetXYFromParent)(r || e, o, n.props.scale);
}
function a1e(e, t, n) {
  const r = !(0, fr.isNum)(e.lastX), i = Nw(e);
  return r ? {
    node: i,
    deltaX: 0,
    deltaY: 0,
    lastX: t,
    lastY: n,
    x: t,
    y: n
  } : {
    node: i,
    deltaX: t - e.lastX,
    deltaY: n - e.lastY,
    lastX: e.lastX,
    lastY: e.lastY,
    x: t,
    y: n
  };
}
function s1e(e, t) {
  const n = e.props.scale;
  return {
    node: t.node,
    x: e.state.x + t.deltaX / n,
    y: e.state.y + t.deltaY / n,
    deltaX: t.deltaX / n,
    deltaY: t.deltaY / n,
    lastX: e.state.x,
    lastY: e.state.y
  };
}
function l1e(e) {
  return {
    left: e.left,
    top: e.top,
    right: e.right,
    bottom: e.bottom
  };
}
function Nw(e) {
  const t = e.findDOMNode();
  if (!t)
    throw new Error("<DraggableCore>: Unmounted during event!");
  return t;
}
var cp = {}, up = {};
Object.defineProperty(up, "__esModule", {
  value: !0
});
up.default = c1e;
function c1e() {
}
Object.defineProperty(cp, "__esModule", {
  value: !0
});
cp.default = void 0;
var Kg = d1e(x), Zn = $w(ww), u1e = $w(Xf), Tn = Zt, yo = Ai, Xg = Ti, Dl = $w(up);
function $w(e) {
  return e && e.__esModule ? e : { default: e };
}
function rM(e) {
  if (typeof WeakMap != "function")
    return null;
  var t = /* @__PURE__ */ new WeakMap(), n = /* @__PURE__ */ new WeakMap();
  return (rM = function(r) {
    return r ? n : t;
  })(e);
}
function d1e(e, t) {
  if (!t && e && e.__esModule)
    return e;
  if (e === null || typeof e != "object" && typeof e != "function")
    return { default: e };
  var n = rM(t);
  if (n && n.has(e))
    return n.get(e);
  var r = {}, i = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var o in e)
    if (o !== "default" && Object.prototype.hasOwnProperty.call(e, o)) {
      var a = i ? Object.getOwnPropertyDescriptor(e, o) : null;
      a && (a.get || a.set) ? Object.defineProperty(r, o, a) : r[o] = e[o];
    }
  return r.default = e, n && n.set(e, r), r;
}
function Fn(e, t, n) {
  return t = f1e(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function f1e(e) {
  var t = h1e(e, "string");
  return typeof t == "symbol" ? t : String(t);
}
function h1e(e, t) {
  if (typeof e != "object" || e === null)
    return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var r = n.call(e, t || "default");
    if (typeof r != "object")
      return r;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
const Xr = {
  touch: {
    start: "touchstart",
    move: "touchmove",
    stop: "touchend"
  },
  mouse: {
    start: "mousedown",
    move: "mousemove",
    stop: "mouseup"
  }
};
let wo = Xr.mouse, dp = class extends Kg.Component {
  constructor() {
    super(...arguments), Fn(this, "dragging", !1), Fn(this, "lastX", NaN), Fn(this, "lastY", NaN), Fn(this, "touchIdentifier", null), Fn(this, "mounted", !1), Fn(this, "handleDragStart", (t) => {
      if (this.props.onMouseDown(t), !this.props.allowAnyClick && typeof t.button == "number" && t.button !== 0)
        return !1;
      const n = this.findDOMNode();
      if (!n || !n.ownerDocument || !n.ownerDocument.body)
        throw new Error("<DraggableCore> not mounted on DragStart!");
      const {
        ownerDocument: r
      } = n;
      if (this.props.disabled || !(t.target instanceof r.defaultView.Node) || this.props.handle && !(0, Tn.matchesSelectorAndParentsTo)(t.target, this.props.handle, n) || this.props.cancel && (0, Tn.matchesSelectorAndParentsTo)(t.target, this.props.cancel, n))
        return;
      t.type === "touchstart" && t.preventDefault();
      const i = (0, Tn.getTouchIdentifier)(t);
      this.touchIdentifier = i;
      const o = (0, yo.getControlPosition)(t, i, this);
      if (o == null)
        return;
      const {
        x: a,
        y: s
      } = o, l = (0, yo.createCoreData)(this, a, s);
      (0, Dl.default)("DraggableCore: handleDragStart: %j", l), (0, Dl.default)("calling", this.props.onStart), !(this.props.onStart(t, l) === !1 || this.mounted === !1) && (this.props.enableUserSelectHack && (0, Tn.addUserSelectStyles)(r), this.dragging = !0, this.lastX = a, this.lastY = s, (0, Tn.addEvent)(r, wo.move, this.handleDrag), (0, Tn.addEvent)(r, wo.stop, this.handleDragStop));
    }), Fn(this, "handleDrag", (t) => {
      const n = (0, yo.getControlPosition)(t, this.touchIdentifier, this);
      if (n == null)
        return;
      let {
        x: r,
        y: i
      } = n;
      if (Array.isArray(this.props.grid)) {
        let s = r - this.lastX, l = i - this.lastY;
        if ([s, l] = (0, yo.snapToGrid)(this.props.grid, s, l), !s && !l)
          return;
        r = this.lastX + s, i = this.lastY + l;
      }
      const o = (0, yo.createCoreData)(this, r, i);
      if ((0, Dl.default)("DraggableCore: handleDrag: %j", o), this.props.onDrag(t, o) === !1 || this.mounted === !1) {
        try {
          this.handleDragStop(new MouseEvent("mouseup"));
        } catch {
          const l = document.createEvent("MouseEvents");
          l.initMouseEvent("mouseup", !0, !0, window, 0, 0, 0, 0, 0, !1, !1, !1, !1, 0, null), this.handleDragStop(l);
        }
        return;
      }
      this.lastX = r, this.lastY = i;
    }), Fn(this, "handleDragStop", (t) => {
      if (!this.dragging)
        return;
      const n = (0, yo.getControlPosition)(t, this.touchIdentifier, this);
      if (n == null)
        return;
      let {
        x: r,
        y: i
      } = n;
      if (Array.isArray(this.props.grid)) {
        let l = r - this.lastX || 0, u = i - this.lastY || 0;
        [l, u] = (0, yo.snapToGrid)(this.props.grid, l, u), r = this.lastX + l, i = this.lastY + u;
      }
      const o = (0, yo.createCoreData)(this, r, i);
      if (this.props.onStop(t, o) === !1 || this.mounted === !1)
        return !1;
      const s = this.findDOMNode();
      s && this.props.enableUserSelectHack && (0, Tn.removeUserSelectStyles)(s.ownerDocument), (0, Dl.default)("DraggableCore: handleDragStop: %j", o), this.dragging = !1, this.lastX = NaN, this.lastY = NaN, s && ((0, Dl.default)("DraggableCore: Removing handlers"), (0, Tn.removeEvent)(s.ownerDocument, wo.move, this.handleDrag), (0, Tn.removeEvent)(s.ownerDocument, wo.stop, this.handleDragStop));
    }), Fn(this, "onMouseDown", (t) => (wo = Xr.mouse, this.handleDragStart(t))), Fn(this, "onMouseUp", (t) => (wo = Xr.mouse, this.handleDragStop(t))), Fn(this, "onTouchStart", (t) => (wo = Xr.touch, this.handleDragStart(t))), Fn(this, "onTouchEnd", (t) => (wo = Xr.touch, this.handleDragStop(t)));
  }
  componentDidMount() {
    this.mounted = !0;
    const t = this.findDOMNode();
    t && (0, Tn.addEvent)(t, Xr.touch.start, this.onTouchStart, {
      passive: !1
    });
  }
  componentWillUnmount() {
    this.mounted = !1;
    const t = this.findDOMNode();
    if (t) {
      const {
        ownerDocument: n
      } = t;
      (0, Tn.removeEvent)(n, Xr.mouse.move, this.handleDrag), (0, Tn.removeEvent)(n, Xr.touch.move, this.handleDrag), (0, Tn.removeEvent)(n, Xr.mouse.stop, this.handleDragStop), (0, Tn.removeEvent)(n, Xr.touch.stop, this.handleDragStop), (0, Tn.removeEvent)(t, Xr.touch.start, this.onTouchStart, {
        passive: !1
      }), this.props.enableUserSelectHack && (0, Tn.removeUserSelectStyles)(n);
    }
  }
  // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
  // the underlying DOM node ourselves. See the README for more information.
  findDOMNode() {
    var t, n;
    return (t = this.props) !== null && t !== void 0 && t.nodeRef ? (n = this.props) === null || n === void 0 || (n = n.nodeRef) === null || n === void 0 ? void 0 : n.current : u1e.default.findDOMNode(this);
  }
  render() {
    return /* @__PURE__ */ Kg.cloneElement(Kg.Children.only(this.props.children), {
      // Note: mouseMove handler is attached to document so it will still function
      // when the user drags quickly and leaves the bounds of the element.
      onMouseDown: this.onMouseDown,
      onMouseUp: this.onMouseUp,
      // onTouchStart is added on `componentDidMount` so they can be added with
      // {passive: false}, which allows it to cancel. See
      // https://developers.google.com/web/updates/2017/01/scrolling-intervention
      onTouchEnd: this.onTouchEnd
    });
  }
};
cp.default = dp;
Fn(dp, "displayName", "DraggableCore");
Fn(dp, "propTypes", {
  /**
   * `allowAnyClick` allows dragging using any mouse button.
   * By default, we only accept the left button.
   *
   * Defaults to `false`.
   */
  allowAnyClick: Zn.default.bool,
  children: Zn.default.node.isRequired,
  /**
   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
   * with the exception of `onMouseDown`, will not fire.
   */
  disabled: Zn.default.bool,
  /**
   * By default, we add 'user-select:none' attributes to the document body
   * to prevent ugly text selection during drag. If this is causing problems
   * for your app, set this to `false`.
   */
  enableUserSelectHack: Zn.default.bool,
  /**
   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
   * instead of using the parent node.
   */
  offsetParent: function(e, t) {
    if (e[t] && e[t].nodeType !== 1)
      throw new Error("Draggable's offsetParent must be a DOM Node.");
  },
  /**
   * `grid` specifies the x and y that dragging should snap to.
   */
  grid: Zn.default.arrayOf(Zn.default.number),
  /**
   * `handle` specifies a selector to be used as the handle that initiates drag.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *         return (
   *            <Draggable handle=".handle">
   *              <div>
   *                  <div className="handle">Click me to drag</div>
   *                  <div>This is some other content</div>
   *              </div>
   *           </Draggable>
   *         );
   *       }
   *   });
   * ```
   */
  handle: Zn.default.string,
  /**
   * `cancel` specifies a selector to be used to prevent drag initialization.
   *
   * Example:
   *
   * ```jsx
   *   let App = React.createClass({
   *       render: function () {
   *           return(
   *               <Draggable cancel=".cancel">
   *                   <div>
   *                     <div className="cancel">You can't drag from here</div>
   *                     <div>Dragging here works fine</div>
   *                   </div>
   *               </Draggable>
   *           );
   *       }
   *   });
   * ```
   */
  cancel: Zn.default.string,
  /* If running in React Strict mode, ReactDOM.findDOMNode() is deprecated.
   * Unfortunately, in order for <Draggable> to work properly, we need raw access
   * to the underlying DOM node. If you want to avoid the warning, pass a `nodeRef`
   * as in this example:
   *
   * function MyComponent() {
   *   const nodeRef = React.useRef(null);
   *   return (
   *     <Draggable nodeRef={nodeRef}>
   *       <div ref={nodeRef}>Example Target</div>
   *     </Draggable>
   *   );
   * }
   *
   * This can be used for arbitrarily nested components, so long as the ref ends up
   * pointing to the actual child DOM node and not a custom component.
   */
  nodeRef: Zn.default.object,
  /**
   * Called when dragging starts.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onStart: Zn.default.func,
  /**
   * Called while dragging.
   * If this function returns the boolean false, dragging will be canceled.
   */
  onDrag: Zn.default.func,
  /**
   * Called when dragging stops.
   * If this function returns the boolean false, the drag will remain active.
   */
  onStop: Zn.default.func,
  /**
   * A workaround option which can be passed if onMouseDown needs to be accessed,
   * since it'll always be blocked (as there is internal use of onMouseDown)
   */
  onMouseDown: Zn.default.func,
  /**
   * `scale`, if set, applies scaling while dragging an element
   */
  scale: Zn.default.number,
  /**
   * These properties should be defined on the child, not here.
   */
  className: Xg.dontSetMe,
  style: Xg.dontSetMe,
  transform: Xg.dontSetMe
});
Fn(dp, "defaultProps", {
  allowAnyClick: !1,
  // by default only accept left click
  disabled: !1,
  enableUserSelectHack: !0,
  onStart: function() {
  },
  onDrag: function() {
  },
  onStop: function() {
  },
  onMouseDown: function() {
  },
  scale: 1
});
(function(e) {
  Object.defineProperty(e, "__esModule", {
    value: !0
  }), Object.defineProperty(e, "DraggableCore", {
    enumerable: !0,
    get: function() {
      return l.default;
    }
  }), e.default = void 0;
  var t = p(x), n = d(ww), r = d(Xf), i = d(R0e), o = Zt, a = Ai, s = Ti, l = d(cp), u = d(up);
  function d(E) {
    return E && E.__esModule ? E : { default: E };
  }
  function f(E) {
    if (typeof WeakMap != "function")
      return null;
    var S = /* @__PURE__ */ new WeakMap(), _ = /* @__PURE__ */ new WeakMap();
    return (f = function(k) {
      return k ? _ : S;
    })(E);
  }
  function p(E, S) {
    if (!S && E && E.__esModule)
      return E;
    if (E === null || typeof E != "object" && typeof E != "function")
      return { default: E };
    var _ = f(S);
    if (_ && _.has(E))
      return _.get(E);
    var k = {}, T = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var A in E)
      if (A !== "default" && Object.prototype.hasOwnProperty.call(E, A)) {
        var R = T ? Object.getOwnPropertyDescriptor(E, A) : null;
        R && (R.get || R.set) ? Object.defineProperty(k, A, R) : k[A] = E[A];
      }
    return k.default = E, _ && _.set(E, k), k;
  }
  function m() {
    return m = Object.assign ? Object.assign.bind() : function(E) {
      for (var S = 1; S < arguments.length; S++) {
        var _ = arguments[S];
        for (var k in _)
          Object.prototype.hasOwnProperty.call(_, k) && (E[k] = _[k]);
      }
      return E;
    }, m.apply(this, arguments);
  }
  function g(E, S, _) {
    return S = v(S), S in E ? Object.defineProperty(E, S, { value: _, enumerable: !0, configurable: !0, writable: !0 }) : E[S] = _, E;
  }
  function v(E) {
    var S = y(E, "string");
    return typeof S == "symbol" ? S : String(S);
  }
  function y(E, S) {
    if (typeof E != "object" || E === null)
      return E;
    var _ = E[Symbol.toPrimitive];
    if (_ !== void 0) {
      var k = _.call(E, S || "default");
      if (typeof k != "object")
        return k;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (S === "string" ? String : Number)(E);
  }
  class b extends t.Component {
    // React 16.3+
    // Arity (props, state)
    static getDerivedStateFromProps(S, _) {
      let {
        position: k
      } = S, {
        prevPropsPosition: T
      } = _;
      return k && (!T || k.x !== T.x || k.y !== T.y) ? ((0, u.default)("Draggable: getDerivedStateFromProps %j", {
        position: k,
        prevPropsPosition: T
      }), {
        x: k.x,
        y: k.y,
        prevPropsPosition: {
          ...k
        }
      }) : null;
    }
    constructor(S) {
      super(S), g(this, "onDragStart", (_, k) => {
        if ((0, u.default)("Draggable: onDragStart: %j", k), this.props.onStart(_, (0, a.createDraggableData)(this, k)) === !1)
          return !1;
        this.setState({
          dragging: !0,
          dragged: !0
        });
      }), g(this, "onDrag", (_, k) => {
        if (!this.state.dragging)
          return !1;
        (0, u.default)("Draggable: onDrag: %j", k);
        const T = (0, a.createDraggableData)(this, k), A = {
          x: T.x,
          y: T.y,
          slackX: 0,
          slackY: 0
        };
        if (this.props.bounds) {
          const {
            x: F,
            y: D
          } = A;
          A.x += this.state.slackX, A.y += this.state.slackY;
          const [W, L] = (0, a.getBoundPosition)(this, A.x, A.y);
          A.x = W, A.y = L, A.slackX = this.state.slackX + (F - A.x), A.slackY = this.state.slackY + (D - A.y), T.x = A.x, T.y = A.y, T.deltaX = A.x - this.state.x, T.deltaY = A.y - this.state.y;
        }
        if (this.props.onDrag(_, T) === !1)
          return !1;
        this.setState(A);
      }), g(this, "onDragStop", (_, k) => {
        if (!this.state.dragging || this.props.onStop(_, (0, a.createDraggableData)(this, k)) === !1)
          return !1;
        (0, u.default)("Draggable: onDragStop: %j", k);
        const A = {
          dragging: !1,
          slackX: 0,
          slackY: 0
        };
        if (!!this.props.position) {
          const {
            x: F,
            y: D
          } = this.props.position;
          A.x = F, A.y = D;
        }
        this.setState(A);
      }), this.state = {
        // Whether or not we are currently dragging.
        dragging: !1,
        // Whether or not we have been dragged before.
        dragged: !1,
        // Current transform x and y.
        x: S.position ? S.position.x : S.defaultPosition.x,
        y: S.position ? S.position.y : S.defaultPosition.y,
        prevPropsPosition: {
          ...S.position
        },
        // Used for compensating for out-of-bounds drags
        slackX: 0,
        slackY: 0,
        // Can only determine if SVG after mounting
        isElementSVG: !1
      }, S.position && !(S.onDrag || S.onStop) && console.warn("A `position` was applied to this <Draggable>, without drag handlers. This will make this component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the `position` of this element.");
    }
    componentDidMount() {
      typeof window.SVGElement < "u" && this.findDOMNode() instanceof window.SVGElement && this.setState({
        isElementSVG: !0
      });
    }
    componentWillUnmount() {
      this.setState({
        dragging: !1
      });
    }
    // React Strict Mode compatibility: if `nodeRef` is passed, we will use it instead of trying to find
    // the underlying DOM node ourselves. See the README for more information.
    findDOMNode() {
      var S, _;
      return (S = (_ = this.props) === null || _ === void 0 || (_ = _.nodeRef) === null || _ === void 0 ? void 0 : _.current) !== null && S !== void 0 ? S : r.default.findDOMNode(this);
    }
    render() {
      const {
        axis: S,
        bounds: _,
        children: k,
        defaultPosition: T,
        defaultClassName: A,
        defaultClassNameDragging: R,
        defaultClassNameDragged: F,
        position: D,
        positionOffset: W,
        scale: L,
        ...z
      } = this.props;
      let B = {}, G = null;
      const J = !!!D || this.state.dragging, q = D || T, Z = {
        // Set left if horizontal drag is enabled
        x: (0, a.canDragX)(this) && J ? this.state.x : q.x,
        // Set top if vertical drag is enabled
        y: (0, a.canDragY)(this) && J ? this.state.y : q.y
      };
      this.state.isElementSVG ? G = (0, o.createSVGTransform)(Z, W) : B = (0, o.createCSSTransform)(Z, W);
      const O = (0, i.default)(k.props.className || "", A, {
        [R]: this.state.dragging,
        [F]: this.state.dragged
      });
      return /* @__PURE__ */ t.createElement(l.default, m({}, z, {
        onStart: this.onDragStart,
        onDrag: this.onDrag,
        onStop: this.onDragStop
      }), /* @__PURE__ */ t.cloneElement(t.Children.only(k), {
        className: O,
        style: {
          ...k.props.style,
          ...B
        },
        transform: G
      }));
    }
  }
  e.default = b, g(b, "displayName", "Draggable"), g(b, "propTypes", {
    // Accepts all props <DraggableCore> accepts.
    ...l.default.propTypes,
    /**
     * `axis` determines which axis the draggable can move.
     *
     *  Note that all callbacks will still return data as normal. This only
     *  controls flushing to the DOM.
     *
     * 'both' allows movement horizontally and vertically.
     * 'x' limits movement to horizontal axis.
     * 'y' limits movement to vertical axis.
     * 'none' limits all movement.
     *
     * Defaults to 'both'.
     */
    axis: n.default.oneOf(["both", "x", "y", "none"]),
    /**
     * `bounds` determines the range of movement available to the element.
     * Available values are:
     *
     * 'parent' restricts movement within the Draggable's parent node.
     *
     * Alternatively, pass an object with the following properties, all of which are optional:
     *
     * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
     *
     * All values are in px.
     *
     * Example:
     *
     * ```jsx
     *   let App = React.createClass({
     *       render: function () {
     *         return (
     *            <Draggable bounds={{right: 300, bottom: 300}}>
     *              <div>Content</div>
     *           </Draggable>
     *         );
     *       }
     *   });
     * ```
     */
    bounds: n.default.oneOfType([n.default.shape({
      left: n.default.number,
      right: n.default.number,
      top: n.default.number,
      bottom: n.default.number
    }), n.default.string, n.default.oneOf([!1])]),
    defaultClassName: n.default.string,
    defaultClassNameDragging: n.default.string,
    defaultClassNameDragged: n.default.string,
    /**
     * `defaultPosition` specifies the x and y that the dragged item should start at
     *
     * Example:
     *
     * ```jsx
     *      let App = React.createClass({
     *          render: function () {
     *              return (
     *                  <Draggable defaultPosition={{x: 25, y: 25}}>
     *                      <div>I start with transformX: 25px and transformY: 25px;</div>
     *                  </Draggable>
     *              );
     *          }
     *      });
     * ```
     */
    defaultPosition: n.default.shape({
      x: n.default.number,
      y: n.default.number
    }),
    positionOffset: n.default.shape({
      x: n.default.oneOfType([n.default.number, n.default.string]),
      y: n.default.oneOfType([n.default.number, n.default.string])
    }),
    /**
     * `position`, if present, defines the current position of the element.
     *
     *  This is similar to how form elements in React work - if no `position` is supplied, the component
     *  is uncontrolled.
     *
     * Example:
     *
     * ```jsx
     *      let App = React.createClass({
     *          render: function () {
     *              return (
     *                  <Draggable position={{x: 25, y: 25}}>
     *                      <div>I start with transformX: 25px and transformY: 25px;</div>
     *                  </Draggable>
     *              );
     *          }
     *      });
     * ```
     */
    position: n.default.shape({
      x: n.default.number,
      y: n.default.number
    }),
    /**
     * These properties should be defined on the child, not here.
     */
    className: s.dontSetMe,
    style: s.dontSetMe,
    transform: s.dontSetMe
  }), g(b, "defaultProps", {
    ...l.default.defaultProps,
    axis: "both",
    bounds: !1,
    defaultClassName: "react-draggable",
    defaultClassNameDragging: "react-draggable-dragging",
    defaultClassNameDragged: "react-draggable-dragged",
    defaultPosition: {
      x: 0,
      y: 0
    },
    scale: 1
  });
})(XA);
const {
  default: iM,
  DraggableCore: p1e
} = XA;
lp.exports = iM;
lp.exports.default = iM;
lp.exports.DraggableCore = p1e;
var m1e = lp.exports;
const g1e = /* @__PURE__ */ Pi(m1e);
var v1e = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), rn = globalThis && globalThis.__assign || function() {
  return rn = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, rn.apply(this, arguments);
}, Z4 = {
  width: "100%",
  height: "10px",
  top: "0px",
  left: "0px",
  cursor: "row-resize"
}, Q4 = {
  width: "10px",
  height: "100%",
  top: "0px",
  left: "0px",
  cursor: "col-resize"
}, Ad = {
  width: "20px",
  height: "20px",
  position: "absolute"
}, y1e = {
  top: rn(rn({}, Z4), { top: "-5px" }),
  right: rn(rn({}, Q4), { left: void 0, right: "-5px" }),
  bottom: rn(rn({}, Z4), { top: void 0, bottom: "-5px" }),
  left: rn(rn({}, Q4), { left: "-5px" }),
  topRight: rn(rn({}, Ad), { right: "-10px", top: "-10px", cursor: "ne-resize" }),
  bottomRight: rn(rn({}, Ad), { right: "-10px", bottom: "-10px", cursor: "se-resize" }),
  bottomLeft: rn(rn({}, Ad), { left: "-10px", bottom: "-10px", cursor: "sw-resize" }),
  topLeft: rn(rn({}, Ad), { left: "-10px", top: "-10px", cursor: "nw-resize" })
}, w1e = (
  /** @class */
  function(e) {
    v1e(t, e);
    function t() {
      var n = e !== null && e.apply(this, arguments) || this;
      return n.onMouseDown = function(r) {
        n.props.onResizeStart(r, n.props.direction);
      }, n.onTouchStart = function(r) {
        n.props.onResizeStart(r, n.props.direction);
      }, n;
    }
    return t.prototype.render = function() {
      return C.createElement("div", { className: this.props.className || "", style: rn(rn({ position: "absolute", userSelect: "none" }, y1e[this.props.direction]), this.props.replaceStyles || {}), onMouseDown: this.onMouseDown, onTouchStart: this.onTouchStart }, this.props.children);
    }, t;
  }(C.PureComponent)
), b1e = globalThis && globalThis.__extends || function() {
  var e = function(t, n) {
    return e = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
      r.__proto__ = i;
    } || function(r, i) {
      for (var o in i)
        Object.prototype.hasOwnProperty.call(i, o) && (r[o] = i[o]);
    }, e(t, n);
  };
  return function(t, n) {
    e(t, n);
    function r() {
      this.constructor = t;
    }
    t.prototype = n === null ? Object.create(n) : (r.prototype = n.prototype, new r());
  };
}(), vi = globalThis && globalThis.__assign || function() {
  return vi = Object.assign || function(e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      t = arguments[n];
      for (var i in t)
        Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]);
    }
    return e;
  }, vi.apply(this, arguments);
}, x1e = {
  width: "auto",
  height: "auto"
}, Md = function(e, t, n) {
  return Math.max(Math.min(e, n), t);
}, J4 = function(e, t, n) {
  var r = Math.round(e / t);
  return r * t + n * (r - 1);
}, is = function(e, t) {
  return new RegExp(e, "i").test(t);
}, Od = function(e) {
  return !!(e.touches && e.touches.length);
}, E1e = function(e) {
  return !!((e.clientX || e.clientX === 0) && (e.clientY || e.clientY === 0));
}, eS = function(e, t, n) {
  n === void 0 && (n = 0);
  var r = t.reduce(function(o, a, s) {
    return Math.abs(a - e) < Math.abs(t[o] - e) ? s : o;
  }, 0), i = Math.abs(t[r] - e);
  return n === 0 || i < n ? t[r] : e;
}, Zg = function(e) {
  return e = e.toString(), e === "auto" || e.endsWith("px") || e.endsWith("%") || e.endsWith("vh") || e.endsWith("vw") || e.endsWith("vmax") || e.endsWith("vmin") ? e : e + "px";
}, Rd = function(e, t, n, r) {
  if (e && typeof e == "string") {
    if (e.endsWith("px"))
      return Number(e.replace("px", ""));
    if (e.endsWith("%")) {
      var i = Number(e.replace("%", "")) / 100;
      return t * i;
    }
    if (e.endsWith("vw")) {
      var i = Number(e.replace("vw", "")) / 100;
      return n * i;
    }
    if (e.endsWith("vh")) {
      var i = Number(e.replace("vh", "")) / 100;
      return r * i;
    }
  }
  return e;
}, C1e = function(e, t, n, r, i, o, a) {
  return r = Rd(r, e.width, t, n), i = Rd(i, e.height, t, n), o = Rd(o, e.width, t, n), a = Rd(a, e.height, t, n), {
    maxWidth: typeof r > "u" ? void 0 : Number(r),
    maxHeight: typeof i > "u" ? void 0 : Number(i),
    minWidth: typeof o > "u" ? void 0 : Number(o),
    minHeight: typeof a > "u" ? void 0 : Number(a)
  };
}, S1e = function(e) {
  return Array.isArray(e) ? e : [e, e];
}, _1e = [
  "as",
  "ref",
  "style",
  "className",
  "grid",
  "gridGap",
  "snap",
  "bounds",
  "boundsByDirection",
  "size",
  "defaultSize",
  "minWidth",
  "minHeight",
  "maxWidth",
  "maxHeight",
  "lockAspectRatio",
  "lockAspectRatioExtraWidth",
  "lockAspectRatioExtraHeight",
  "enable",
  "handleStyles",
  "handleClasses",
  "handleWrapperStyle",
  "handleWrapperClass",
  "children",
  "onResizeStart",
  "onResize",
  "onResizeStop",
  "handleComponent",
  "scale",
  "resizeRatio",
  "snapGap"
], tS = "__resizable_base__", P1e = (
  /** @class */
  function(e) {
    b1e(t, e);
    function t(n) {
      var r, i, o, a, s = e.call(this, n) || this;
      return s.ratio = 1, s.resizable = null, s.parentLeft = 0, s.parentTop = 0, s.resizableLeft = 0, s.resizableRight = 0, s.resizableTop = 0, s.resizableBottom = 0, s.targetLeft = 0, s.targetTop = 0, s.appendBase = function() {
        if (!s.resizable || !s.window)
          return null;
        var l = s.parentNode;
        if (!l)
          return null;
        var u = s.window.document.createElement("div");
        return u.style.width = "100%", u.style.height = "100%", u.style.position = "absolute", u.style.transform = "scale(0, 0)", u.style.left = "0", u.style.flex = "0 0 100%", u.classList ? u.classList.add(tS) : u.className += tS, l.appendChild(u), u;
      }, s.removeBase = function(l) {
        var u = s.parentNode;
        u && u.removeChild(l);
      }, s.state = {
        isResizing: !1,
        width: (i = (r = s.propsSize) === null || r === void 0 ? void 0 : r.width) !== null && i !== void 0 ? i : "auto",
        height: (a = (o = s.propsSize) === null || o === void 0 ? void 0 : o.height) !== null && a !== void 0 ? a : "auto",
        direction: "right",
        original: {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        },
        backgroundStyle: {
          height: "100%",
          width: "100%",
          backgroundColor: "rgba(0,0,0,0)",
          cursor: "auto",
          opacity: 0,
          position: "fixed",
          zIndex: 9999,
          top: "0",
          left: "0",
          bottom: "0",
          right: "0"
        },
        flexBasis: void 0
      }, s.onResizeStart = s.onResizeStart.bind(s), s.onMouseMove = s.onMouseMove.bind(s), s.onMouseUp = s.onMouseUp.bind(s), s;
    }
    return Object.defineProperty(t.prototype, "parentNode", {
      get: function() {
        return this.resizable ? this.resizable.parentNode : null;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "window", {
      get: function() {
        return !this.resizable || !this.resizable.ownerDocument ? null : this.resizable.ownerDocument.defaultView;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "propsSize", {
      get: function() {
        return this.props.size || this.props.defaultSize || x1e;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "size", {
      get: function() {
        var n = 0, r = 0;
        if (this.resizable && this.window) {
          var i = this.resizable.offsetWidth, o = this.resizable.offsetHeight, a = this.resizable.style.position;
          a !== "relative" && (this.resizable.style.position = "relative"), n = this.resizable.style.width !== "auto" ? this.resizable.offsetWidth : i, r = this.resizable.style.height !== "auto" ? this.resizable.offsetHeight : o, this.resizable.style.position = a;
        }
        return { width: n, height: r };
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(t.prototype, "sizeStyle", {
      get: function() {
        var n = this, r = this.props.size, i = function(s) {
          var l;
          if (typeof n.state[s] > "u" || n.state[s] === "auto")
            return "auto";
          if (n.propsSize && n.propsSize[s] && (!((l = n.propsSize[s]) === null || l === void 0) && l.toString().endsWith("%"))) {
            if (n.state[s].toString().endsWith("%"))
              return n.state[s].toString();
            var u = n.getParentSize(), d = Number(n.state[s].toString().replace("px", "")), f = d / u[s] * 100;
            return f + "%";
          }
          return Zg(n.state[s]);
        }, o = r && typeof r.width < "u" && !this.state.isResizing ? Zg(r.width) : i("width"), a = r && typeof r.height < "u" && !this.state.isResizing ? Zg(r.height) : i("height");
        return { width: o, height: a };
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.getParentSize = function() {
      if (!this.parentNode)
        return this.window ? { width: this.window.innerWidth, height: this.window.innerHeight } : { width: 0, height: 0 };
      var n = this.appendBase();
      if (!n)
        return { width: 0, height: 0 };
      var r = !1, i = this.parentNode.style.flexWrap;
      i !== "wrap" && (r = !0, this.parentNode.style.flexWrap = "wrap"), n.style.position = "relative", n.style.minWidth = "100%", n.style.minHeight = "100%";
      var o = {
        width: n.offsetWidth,
        height: n.offsetHeight
      };
      return r && (this.parentNode.style.flexWrap = i), this.removeBase(n), o;
    }, t.prototype.bindEvents = function() {
      this.window && (this.window.addEventListener("mouseup", this.onMouseUp), this.window.addEventListener("mousemove", this.onMouseMove), this.window.addEventListener("mouseleave", this.onMouseUp), this.window.addEventListener("touchmove", this.onMouseMove, {
        capture: !0,
        passive: !1
      }), this.window.addEventListener("touchend", this.onMouseUp));
    }, t.prototype.unbindEvents = function() {
      this.window && (this.window.removeEventListener("mouseup", this.onMouseUp), this.window.removeEventListener("mousemove", this.onMouseMove), this.window.removeEventListener("mouseleave", this.onMouseUp), this.window.removeEventListener("touchmove", this.onMouseMove, !0), this.window.removeEventListener("touchend", this.onMouseUp));
    }, t.prototype.componentDidMount = function() {
      if (!(!this.resizable || !this.window)) {
        var n = this.window.getComputedStyle(this.resizable);
        this.setState({
          width: this.state.width || this.size.width,
          height: this.state.height || this.size.height,
          flexBasis: n.flexBasis !== "auto" ? n.flexBasis : void 0
        });
      }
    }, t.prototype.componentWillUnmount = function() {
      this.window && this.unbindEvents();
    }, t.prototype.createSizeForCssProperty = function(n, r) {
      var i = this.propsSize && this.propsSize[r];
      return this.state[r] === "auto" && this.state.original[r] === n && (typeof i > "u" || i === "auto") ? "auto" : n;
    }, t.prototype.calculateNewMaxFromBoundary = function(n, r) {
      var i = this.props.boundsByDirection, o = this.state.direction, a = i && is("left", o), s = i && is("top", o), l, u;
      if (this.props.bounds === "parent") {
        var d = this.parentNode;
        d && (l = a ? this.resizableRight - this.parentLeft : d.offsetWidth + (this.parentLeft - this.resizableLeft), u = s ? this.resizableBottom - this.parentTop : d.offsetHeight + (this.parentTop - this.resizableTop));
      } else
        this.props.bounds === "window" ? this.window && (l = a ? this.resizableRight : this.window.innerWidth - this.resizableLeft, u = s ? this.resizableBottom : this.window.innerHeight - this.resizableTop) : this.props.bounds && (l = a ? this.resizableRight - this.targetLeft : this.props.bounds.offsetWidth + (this.targetLeft - this.resizableLeft), u = s ? this.resizableBottom - this.targetTop : this.props.bounds.offsetHeight + (this.targetTop - this.resizableTop));
      return l && Number.isFinite(l) && (n = n && n < l ? n : l), u && Number.isFinite(u) && (r = r && r < u ? r : u), { maxWidth: n, maxHeight: r };
    }, t.prototype.calculateNewSizeFromDirection = function(n, r) {
      var i = this.props.scale || 1, o = S1e(this.props.resizeRatio || 1), a = o[0], s = o[1], l = this.state, u = l.direction, d = l.original, f = this.props, p = f.lockAspectRatio, m = f.lockAspectRatioExtraHeight, g = f.lockAspectRatioExtraWidth, v = d.width, y = d.height, b = m || 0, E = g || 0;
      return is("right", u) && (v = d.width + (n - d.x) * a / i, p && (y = (v - E) / this.ratio + b)), is("left", u) && (v = d.width - (n - d.x) * a / i, p && (y = (v - E) / this.ratio + b)), is("bottom", u) && (y = d.height + (r - d.y) * s / i, p && (v = (y - b) * this.ratio + E)), is("top", u) && (y = d.height - (r - d.y) * s / i, p && (v = (y - b) * this.ratio + E)), { newWidth: v, newHeight: y };
    }, t.prototype.calculateNewSizeFromAspectRatio = function(n, r, i, o) {
      var a = this.props, s = a.lockAspectRatio, l = a.lockAspectRatioExtraHeight, u = a.lockAspectRatioExtraWidth, d = typeof o.width > "u" ? 10 : o.width, f = typeof i.width > "u" || i.width < 0 ? n : i.width, p = typeof o.height > "u" ? 10 : o.height, m = typeof i.height > "u" || i.height < 0 ? r : i.height, g = l || 0, v = u || 0;
      if (s) {
        var y = (p - g) * this.ratio + v, b = (m - g) * this.ratio + v, E = (d - v) / this.ratio + g, S = (f - v) / this.ratio + g, _ = Math.max(d, y), k = Math.min(f, b), T = Math.max(p, E), A = Math.min(m, S);
        n = Md(n, _, k), r = Md(r, T, A);
      } else
        n = Md(n, d, f), r = Md(r, p, m);
      return { newWidth: n, newHeight: r };
    }, t.prototype.setBoundingClientRect = function() {
      var n = 1 / (this.props.scale || 1);
      if (this.props.bounds === "parent") {
        var r = this.parentNode;
        if (r) {
          var i = r.getBoundingClientRect();
          this.parentLeft = i.left * n, this.parentTop = i.top * n;
        }
      }
      if (this.props.bounds && typeof this.props.bounds != "string") {
        var o = this.props.bounds.getBoundingClientRect();
        this.targetLeft = o.left * n, this.targetTop = o.top * n;
      }
      if (this.resizable) {
        var a = this.resizable.getBoundingClientRect(), s = a.left, l = a.top, u = a.right, d = a.bottom;
        this.resizableLeft = s * n, this.resizableRight = u * n, this.resizableTop = l * n, this.resizableBottom = d * n;
      }
    }, t.prototype.onResizeStart = function(n, r) {
      if (!(!this.resizable || !this.window)) {
        var i = 0, o = 0;
        if (n.nativeEvent && E1e(n.nativeEvent) ? (i = n.nativeEvent.clientX, o = n.nativeEvent.clientY) : n.nativeEvent && Od(n.nativeEvent) && (i = n.nativeEvent.touches[0].clientX, o = n.nativeEvent.touches[0].clientY), this.props.onResizeStart && this.resizable) {
          var a = this.props.onResizeStart(n, r, this.resizable);
          if (a === !1)
            return;
        }
        this.props.size && (typeof this.props.size.height < "u" && this.props.size.height !== this.state.height && this.setState({ height: this.props.size.height }), typeof this.props.size.width < "u" && this.props.size.width !== this.state.width && this.setState({ width: this.props.size.width })), this.ratio = typeof this.props.lockAspectRatio == "number" ? this.props.lockAspectRatio : this.size.width / this.size.height;
        var s, l = this.window.getComputedStyle(this.resizable);
        if (l.flexBasis !== "auto") {
          var u = this.parentNode;
          if (u) {
            var d = this.window.getComputedStyle(u).flexDirection;
            this.flexDir = d.startsWith("row") ? "row" : "column", s = l.flexBasis;
          }
        }
        this.setBoundingClientRect(), this.bindEvents();
        var f = {
          original: {
            x: i,
            y: o,
            width: this.size.width,
            height: this.size.height
          },
          isResizing: !0,
          backgroundStyle: vi(vi({}, this.state.backgroundStyle), { cursor: this.window.getComputedStyle(n.target).cursor || "auto" }),
          direction: r,
          flexBasis: s
        };
        this.setState(f);
      }
    }, t.prototype.onMouseMove = function(n) {
      var r = this;
      if (!(!this.state.isResizing || !this.resizable || !this.window)) {
        if (this.window.TouchEvent && Od(n))
          try {
            n.preventDefault(), n.stopPropagation();
          } catch {
          }
        var i = this.props, o = i.maxWidth, a = i.maxHeight, s = i.minWidth, l = i.minHeight, u = Od(n) ? n.touches[0].clientX : n.clientX, d = Od(n) ? n.touches[0].clientY : n.clientY, f = this.state, p = f.direction, m = f.original, g = f.width, v = f.height, y = this.getParentSize(), b = C1e(y, this.window.innerWidth, this.window.innerHeight, o, a, s, l);
        o = b.maxWidth, a = b.maxHeight, s = b.minWidth, l = b.minHeight;
        var E = this.calculateNewSizeFromDirection(u, d), S = E.newHeight, _ = E.newWidth, k = this.calculateNewMaxFromBoundary(o, a);
        this.props.snap && this.props.snap.x && (_ = eS(_, this.props.snap.x, this.props.snapGap)), this.props.snap && this.props.snap.y && (S = eS(S, this.props.snap.y, this.props.snapGap));
        var T = this.calculateNewSizeFromAspectRatio(_, S, { width: k.maxWidth, height: k.maxHeight }, { width: s, height: l });
        if (_ = T.newWidth, S = T.newHeight, this.props.grid) {
          var A = J4(_, this.props.grid[0], this.props.gridGap ? this.props.gridGap[0] : 0), R = J4(S, this.props.grid[1], this.props.gridGap ? this.props.gridGap[1] : 0), F = this.props.snapGap || 0, D = F === 0 || Math.abs(A - _) <= F ? A : _, W = F === 0 || Math.abs(R - S) <= F ? R : S;
          _ = D, S = W;
        }
        var L = {
          width: _ - m.width,
          height: S - m.height
        };
        if (g && typeof g == "string") {
          if (g.endsWith("%")) {
            var z = _ / y.width * 100;
            _ = z + "%";
          } else if (g.endsWith("vw")) {
            var B = _ / this.window.innerWidth * 100;
            _ = B + "vw";
          } else if (g.endsWith("vh")) {
            var G = _ / this.window.innerHeight * 100;
            _ = G + "vh";
          }
        }
        if (v && typeof v == "string") {
          if (v.endsWith("%")) {
            var z = S / y.height * 100;
            S = z + "%";
          } else if (v.endsWith("vw")) {
            var B = S / this.window.innerWidth * 100;
            S = B + "vw";
          } else if (v.endsWith("vh")) {
            var G = S / this.window.innerHeight * 100;
            S = G + "vh";
          }
        }
        var H = {
          width: this.createSizeForCssProperty(_, "width"),
          height: this.createSizeForCssProperty(S, "height")
        };
        this.flexDir === "row" ? H.flexBasis = H.width : this.flexDir === "column" && (H.flexBasis = H.height);
        var J = this.state.width !== H.width, q = this.state.height !== H.height, Z = this.state.flexBasis !== H.flexBasis, O = J || q || Z;
        O && Zf(function() {
          r.setState(H);
        }), this.props.onResize && O && this.props.onResize(n, p, this.resizable, L);
      }
    }, t.prototype.onMouseUp = function(n) {
      var r, i, o = this.state, a = o.isResizing, s = o.direction, l = o.original;
      if (!(!a || !this.resizable)) {
        var u = {
          width: this.size.width - l.width,
          height: this.size.height - l.height
        };
        this.props.onResizeStop && this.props.onResizeStop(n, s, this.resizable, u), this.props.size && this.setState({ width: (r = this.props.size.width) !== null && r !== void 0 ? r : "auto", height: (i = this.props.size.height) !== null && i !== void 0 ? i : "auto" }), this.unbindEvents(), this.setState({
          isResizing: !1,
          backgroundStyle: vi(vi({}, this.state.backgroundStyle), { cursor: "auto" })
        });
      }
    }, t.prototype.updateSize = function(n) {
      var r, i;
      this.setState({ width: (r = n.width) !== null && r !== void 0 ? r : "auto", height: (i = n.height) !== null && i !== void 0 ? i : "auto" });
    }, t.prototype.renderResizer = function() {
      var n = this, r = this.props, i = r.enable, o = r.handleStyles, a = r.handleClasses, s = r.handleWrapperStyle, l = r.handleWrapperClass, u = r.handleComponent;
      if (!i)
        return null;
      var d = Object.keys(i).map(function(f) {
        return i[f] !== !1 ? C.createElement(w1e, { key: f, direction: f, onResizeStart: n.onResizeStart, replaceStyles: o && o[f], className: a && a[f] }, u && u[f] ? u[f] : null) : null;
      });
      return C.createElement("div", { className: l, style: s }, d);
    }, t.prototype.render = function() {
      var n = this, r = Object.keys(this.props).reduce(function(a, s) {
        return _1e.indexOf(s) !== -1 || (a[s] = n.props[s]), a;
      }, {}), i = vi(vi(vi({ position: "relative", userSelect: this.state.isResizing ? "none" : "auto" }, this.props.style), this.sizeStyle), { maxWidth: this.props.maxWidth, maxHeight: this.props.maxHeight, minWidth: this.props.minWidth, minHeight: this.props.minHeight, boxSizing: "border-box", flexShrink: 0 });
      this.state.flexBasis && (i.flexBasis = this.state.flexBasis);
      var o = this.props.as || "div";
      return C.createElement(
        o,
        vi({ style: i, className: this.props.className }, r, {
          // `ref` is after `extendsProps` to ensure this one wins over a version
          // passed in
          ref: function(a) {
            a && (n.resizable = a);
          }
        }),
        this.state.isResizing && C.createElement("div", { style: this.state.backgroundStyle }),
        this.props.children,
        this.renderResizer()
      );
    }, t.defaultProps = {
      as: "div",
      onResizeStart: function() {
      },
      onResize: function() {
      },
      onResizeStop: function() {
      },
      enable: {
        top: !0,
        right: !0,
        bottom: !0,
        left: !0,
        topRight: !0,
        bottomRight: !0,
        bottomLeft: !0,
        topLeft: !0
      },
      style: {},
      grid: [1, 1],
      gridGap: [0, 0],
      lockAspectRatio: !1,
      lockAspectRatioExtraWidth: 0,
      lockAspectRatioExtraHeight: 0,
      scale: 1,
      resizeRatio: 1,
      snapGap: 0
    }, t;
  }(C.PureComponent)
);
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
var e1 = function(e, t) {
  return e1 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(n, r) {
    n.__proto__ = r;
  } || function(n, r) {
    for (var i in r)
      r.hasOwnProperty(i) && (n[i] = r[i]);
  }, e1(e, t);
};
function k1e(e, t) {
  e1(e, t);
  function n() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n());
}
var dn = function() {
  return dn = Object.assign || function(t) {
    for (var n, r = 1, i = arguments.length; r < i; r++) {
      n = arguments[r];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
    }
    return t;
  }, dn.apply(this, arguments);
};
function T1e(e, t) {
  var n = {};
  for (var r in e)
    Object.prototype.hasOwnProperty.call(e, r) && t.indexOf(r) < 0 && (n[r] = e[r]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var i = 0, r = Object.getOwnPropertySymbols(e); i < r.length; i++)
      t.indexOf(r[i]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[i]) && (n[r[i]] = e[r[i]]);
  return n;
}
var A1e = {
  width: "auto",
  height: "auto",
  display: "inline-block",
  position: "absolute",
  top: 0,
  left: 0
}, M1e = function(e) {
  return {
    bottom: e,
    bottomLeft: e,
    bottomRight: e,
    left: e,
    right: e,
    top: e,
    topLeft: e,
    topRight: e
  };
}, O1e = (
  /** @class */
  function(e) {
    k1e(t, e);
    function t(n) {
      var r = e.call(this, n) || this;
      return r.resizingPosition = { x: 0, y: 0 }, r.offsetFromParent = { left: 0, top: 0 }, r.resizableElement = { current: null }, r.originalPosition = { x: 0, y: 0 }, r.state = {
        resizing: !1,
        bounds: {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        },
        maxWidth: n.maxWidth,
        maxHeight: n.maxHeight
      }, r.onResizeStart = r.onResizeStart.bind(r), r.onResize = r.onResize.bind(r), r.onResizeStop = r.onResizeStop.bind(r), r.onDragStart = r.onDragStart.bind(r), r.onDrag = r.onDrag.bind(r), r.onDragStop = r.onDragStop.bind(r), r.getMaxSizesFromProps = r.getMaxSizesFromProps.bind(r), r;
    }
    return t.prototype.componentDidMount = function() {
      this.updateOffsetFromParent();
      var n = this.offsetFromParent, r = n.left, i = n.top, o = this.getDraggablePosition(), a = o.x, s = o.y;
      this.draggable.setState({
        x: a - r,
        y: s - i
      }), this.forceUpdate();
    }, t.prototype.getDraggablePosition = function() {
      var n = this.draggable.state, r = n.x, i = n.y;
      return { x: r, y: i };
    }, t.prototype.getParent = function() {
      return this.resizable && this.resizable.parentNode;
    }, t.prototype.getParentSize = function() {
      return this.resizable.getParentSize();
    }, t.prototype.getMaxSizesFromProps = function() {
      var n = typeof this.props.maxWidth > "u" ? Number.MAX_SAFE_INTEGER : this.props.maxWidth, r = typeof this.props.maxHeight > "u" ? Number.MAX_SAFE_INTEGER : this.props.maxHeight;
      return { maxWidth: n, maxHeight: r };
    }, t.prototype.getSelfElement = function() {
      return this.resizable && this.resizable.resizable;
    }, t.prototype.getOffsetHeight = function(n) {
      var r = this.props.scale;
      switch (this.props.bounds) {
        case "window":
          return window.innerHeight / r;
        case "body":
          return document.body.offsetHeight / r;
        default:
          return n.offsetHeight;
      }
    }, t.prototype.getOffsetWidth = function(n) {
      var r = this.props.scale;
      switch (this.props.bounds) {
        case "window":
          return window.innerWidth / r;
        case "body":
          return document.body.offsetWidth / r;
        default:
          return n.offsetWidth;
      }
    }, t.prototype.onDragStart = function(n, r) {
      this.props.onDragStart && this.props.onDragStart(n, r);
      var i = this.getDraggablePosition();
      if (this.originalPosition = i, !!this.props.bounds) {
        var o = this.getParent(), a = this.props.scale, s;
        if (this.props.bounds === "parent")
          s = o;
        else if (this.props.bounds === "body") {
          var l = o.getBoundingClientRect(), u = l.left, d = l.top, f = document.body.getBoundingClientRect(), p = -(u - o.offsetLeft * a - f.left) / a, m = -(d - o.offsetTop * a - f.top) / a, g = (document.body.offsetWidth - this.resizable.size.width * a) / a + p, v = (document.body.offsetHeight - this.resizable.size.height * a) / a + m;
          return this.setState({ bounds: { top: m, right: g, bottom: v, left: p } });
        } else if (this.props.bounds === "window") {
          if (!this.resizable)
            return;
          var y = o.getBoundingClientRect(), b = y.left, E = y.top, S = -(b - o.offsetLeft * a) / a, _ = -(E - o.offsetTop * a) / a, g = (window.innerWidth - this.resizable.size.width * a) / a + S, v = (window.innerHeight - this.resizable.size.height * a) / a + _;
          return this.setState({ bounds: { top: _, right: g, bottom: v, left: S } });
        } else
          typeof this.props.bounds == "string" ? s = document.querySelector(this.props.bounds) : this.props.bounds instanceof HTMLElement && (s = this.props.bounds);
        if (!(!(s instanceof HTMLElement) || !(o instanceof HTMLElement))) {
          var k = s.getBoundingClientRect(), T = k.left, A = k.top, R = o.getBoundingClientRect(), F = R.left, D = R.top, W = (T - F) / a, L = A - D;
          if (this.resizable) {
            this.updateOffsetFromParent();
            var z = this.offsetFromParent;
            this.setState({
              bounds: {
                top: L - z.top,
                right: W + (s.offsetWidth - this.resizable.size.width) - z.left / a,
                bottom: L + (s.offsetHeight - this.resizable.size.height) - z.top,
                left: W - z.left / a
              }
            });
          }
        }
      }
    }, t.prototype.onDrag = function(n, r) {
      if (this.props.onDrag) {
        var i = this.offsetFromParent, o = i.left, a = i.top;
        if (!this.props.dragAxis || this.props.dragAxis === "both")
          return this.props.onDrag(n, dn(dn({}, r), { x: r.x + o, y: r.y + a }));
        if (this.props.dragAxis === "x")
          return this.props.onDrag(n, dn(dn({}, r), { x: r.x + o, y: this.originalPosition.y + a, deltaY: 0 }));
        if (this.props.dragAxis === "y")
          return this.props.onDrag(n, dn(dn({}, r), { x: this.originalPosition.x + o, y: r.y + a, deltaX: 0 }));
      }
    }, t.prototype.onDragStop = function(n, r) {
      if (this.props.onDragStop) {
        var i = this.offsetFromParent, o = i.left, a = i.top;
        if (!this.props.dragAxis || this.props.dragAxis === "both")
          return this.props.onDragStop(n, dn(dn({}, r), { x: r.x + o, y: r.y + a }));
        if (this.props.dragAxis === "x")
          return this.props.onDragStop(n, dn(dn({}, r), { x: r.x + o, y: this.originalPosition.y + a, deltaY: 0 }));
        if (this.props.dragAxis === "y")
          return this.props.onDragStop(n, dn(dn({}, r), { x: this.originalPosition.x + o, y: r.y + a, deltaX: 0 }));
      }
    }, t.prototype.onResizeStart = function(n, r, i) {
      n.stopPropagation(), this.setState({
        resizing: !0
      });
      var o = this.props.scale, a = this.offsetFromParent, s = this.getDraggablePosition();
      if (this.resizingPosition = { x: s.x + a.left, y: s.y + a.top }, this.originalPosition = s, this.props.bounds) {
        var l = this.getParent(), u = void 0;
        this.props.bounds === "parent" ? u = l : this.props.bounds === "body" ? u = document.body : this.props.bounds === "window" ? u = window : typeof this.props.bounds == "string" ? u = document.querySelector(this.props.bounds) : this.props.bounds instanceof HTMLElement && (u = this.props.bounds);
        var d = this.getSelfElement();
        if (d instanceof Element && (u instanceof HTMLElement || u === window) && l instanceof HTMLElement) {
          var f = this.getMaxSizesFromProps(), p = f.maxWidth, m = f.maxHeight, g = this.getParentSize();
          if (p && typeof p == "string")
            if (p.endsWith("%")) {
              var v = Number(p.replace("%", "")) / 100;
              p = g.width * v;
            } else
              p.endsWith("px") && (p = Number(p.replace("px", "")));
          if (m && typeof m == "string")
            if (m.endsWith("%")) {
              var v = Number(m.replace("%", "")) / 100;
              m = g.height * v;
            } else
              m.endsWith("px") && (m = Number(m.replace("px", "")));
          var y = d.getBoundingClientRect(), b = y.left, E = y.top, S = this.props.bounds === "window" ? { left: 0, top: 0 } : u.getBoundingClientRect(), _ = S.left, k = S.top, T = this.getOffsetWidth(u), A = this.getOffsetHeight(u), R = r.toLowerCase().endsWith("left"), F = r.toLowerCase().endsWith("right"), D = r.startsWith("top"), W = r.startsWith("bottom");
          if ((R || D) && this.resizable) {
            var L = (b - _) / o + this.resizable.size.width;
            this.setState({ maxWidth: L > Number(p) ? p : L });
          }
          if (F || this.props.lockAspectRatio && !R && !D) {
            var L = T + (_ - b) / o;
            this.setState({ maxWidth: L > Number(p) ? p : L });
          }
          if ((D || R) && this.resizable) {
            var L = (E - k) / o + this.resizable.size.height;
            this.setState({
              maxHeight: L > Number(m) ? m : L
            });
          }
          if (W || this.props.lockAspectRatio && !D && !R) {
            var L = A + (k - E) / o;
            this.setState({
              maxHeight: L > Number(m) ? m : L
            });
          }
        }
      } else
        this.setState({
          maxWidth: this.props.maxWidth,
          maxHeight: this.props.maxHeight
        });
      this.props.onResizeStart && this.props.onResizeStart(n, r, i);
    }, t.prototype.onResize = function(n, r, i, o) {
      var a = this, s = { x: this.originalPosition.x, y: this.originalPosition.y }, l = -o.width, u = -o.height, d = ["top", "left", "topLeft", "bottomLeft", "topRight"];
      d.includes(r) && (r === "bottomLeft" ? s.x += l : (r === "topRight" || (s.x += l), s.y += u));
      var f = this.draggable.state;
      (s.x !== f.x || s.y !== f.y) && Zf(function() {
        a.draggable.setState(s);
      }), this.updateOffsetFromParent();
      var p = this.offsetFromParent, m = this.getDraggablePosition().x + p.left, g = this.getDraggablePosition().y + p.top;
      this.resizingPosition = { x: m, y: g }, this.props.onResize && this.props.onResize(n, r, i, o, {
        x: m,
        y: g
      });
    }, t.prototype.onResizeStop = function(n, r, i, o) {
      this.setState({
        resizing: !1
      });
      var a = this.getMaxSizesFromProps(), s = a.maxWidth, l = a.maxHeight;
      this.setState({ maxWidth: s, maxHeight: l }), this.props.onResizeStop && this.props.onResizeStop(n, r, i, o, this.resizingPosition);
    }, t.prototype.updateSize = function(n) {
      this.resizable && this.resizable.updateSize({ width: n.width, height: n.height });
    }, t.prototype.updatePosition = function(n) {
      this.draggable.setState(n);
    }, t.prototype.updateOffsetFromParent = function() {
      var n = this.props.scale, r = this.getParent(), i = this.getSelfElement();
      if (!r || i === null)
        return {
          top: 0,
          left: 0
        };
      var o = r.getBoundingClientRect(), a = o.left, s = o.top, l = i.getBoundingClientRect(), u = this.getDraggablePosition(), d = r.scrollLeft, f = r.scrollTop;
      this.offsetFromParent = {
        left: l.left - a + d - u.x * n,
        top: l.top - s + f - u.y * n
      };
    }, t.prototype.render = function() {
      var n = this, r = this.props, i = r.disableDragging, o = r.style, a = r.dragHandleClassName, s = r.position, l = r.onMouseDown, u = r.onMouseUp, d = r.dragAxis, f = r.dragGrid, p = r.bounds, m = r.enableUserSelectHack, g = r.cancel, v = r.children;
      r.onResizeStart, r.onResize, r.onResizeStop, r.onDragStart, r.onDrag, r.onDragStop;
      var y = r.resizeHandleStyles, b = r.resizeHandleClasses, E = r.resizeHandleComponent, S = r.enableResizing, _ = r.resizeGrid, k = r.resizeHandleWrapperClass, T = r.resizeHandleWrapperStyle, A = r.scale, R = r.allowAnyClick, F = T1e(r, ["disableDragging", "style", "dragHandleClassName", "position", "onMouseDown", "onMouseUp", "dragAxis", "dragGrid", "bounds", "enableUserSelectHack", "cancel", "children", "onResizeStart", "onResize", "onResizeStop", "onDragStart", "onDrag", "onDragStop", "resizeHandleStyles", "resizeHandleClasses", "resizeHandleComponent", "enableResizing", "resizeGrid", "resizeHandleWrapperClass", "resizeHandleWrapperStyle", "scale", "allowAnyClick"]), D = this.props.default ? dn({}, this.props.default) : void 0;
      delete F.default;
      var W = i || a ? { cursor: "auto" } : { cursor: "move" }, L = dn(dn(dn({}, A1e), W), o), z = this.offsetFromParent, B = z.left, G = z.top, H;
      s && (H = {
        x: s.x - B,
        y: s.y - G
      });
      var J = this.state.resizing ? void 0 : H, q = this.state.resizing ? "both" : d;
      return X(
        g1e,
        {
          ref: function(Z) {
            Z && (n.draggable = Z);
          },
          handle: a ? ".".concat(a) : void 0,
          defaultPosition: D,
          onMouseDown: l,
          // @ts-expect-error
          onMouseUp: u,
          onStart: this.onDragStart,
          onDrag: this.onDrag,
          onStop: this.onDragStop,
          axis: q,
          disabled: i,
          grid: f,
          bounds: p ? this.state.bounds : void 0,
          position: J,
          enableUserSelectHack: m,
          cancel: g,
          scale: A,
          allowAnyClick: R,
          nodeRef: this.resizableElement
        },
        X(P1e, dn({}, F, { ref: function(Z) {
          Z && (n.resizable = Z, n.resizableElement.current = Z.resizable);
        }, defaultSize: D, size: this.props.size, enable: typeof S == "boolean" ? M1e(S) : S, onResizeStart: this.onResizeStart, onResize: this.onResize, onResizeStop: this.onResizeStop, style: L, minWidth: this.props.minWidth, minHeight: this.props.minHeight, maxWidth: this.state.resizing ? this.state.maxWidth : this.props.maxWidth, maxHeight: this.state.resizing ? this.state.maxHeight : this.props.maxHeight, grid: _, handleWrapperClass: k, handleWrapperStyle: T, lockAspectRatio: this.props.lockAspectRatio, lockAspectRatioExtraWidth: this.props.lockAspectRatioExtraWidth, lockAspectRatioExtraHeight: this.props.lockAspectRatioExtraHeight, handleStyles: y, handleClasses: b, handleComponent: E, scale: this.props.scale }), v)
      );
    }, t.defaultProps = {
      maxWidth: Number.MAX_SAFE_INTEGER,
      maxHeight: Number.MAX_SAFE_INTEGER,
      scale: 1,
      onResizeStart: function() {
      },
      onResize: function() {
      },
      onResizeStop: function() {
      },
      onDragStart: function() {
      },
      onDrag: function() {
      },
      onDragStop: function() {
      }
    }, t;
  }(b$)
);
function oM({
  x: e,
  y: t,
  children: n,
  enableResizing: r = !0,
  maxWidth: i,
  minWidth: o,
  minHeight: a,
  size: s,
  setDraggableElement: l,
  handleDragStop: u,
  handleResizeStop: d,
  handleResize: f,
  onClipped: p
}) {
  const { setIsResizing: m } = Me(Xs) || {}, [g, v] = de(
    null
  );
  be(() => {
    if (!g || !p)
      return;
    const E = new IntersectionObserver(
      (S) => {
        S.forEach((_) => {
          _.isIntersecting || p == null || p();
        });
      },
      {
        threshold: 1
      }
    );
    return E.observe(g), () => {
      E && E.disconnect();
    };
  }, [g, p]);
  const y = () => {
    m && m(!0);
  }, b = (...E) => {
    d == null || d(...E), m && m(!1);
  };
  return _c(
    // the fixed container allows the draggable element to follow the scroll
    // https://github.com/bokuweb/react-rnd/issues/395#issuecomment-1039422876
    /* @__PURE__ */ x.createElement("div", { className: "ai-tw-pointer-events-none ai-tw-fixed ai-tw-inset-0 ai-tw-z-[5000]" }, /* @__PURE__ */ x.createElement(
      O1e,
      {
        ref: (E) => {
          if (!E)
            return;
          const S = E.resizableElement.current;
          l && l(S), v(S);
        },
        enableResizing: r,
        bounds: "window",
        cancel: Zoe,
        maxWidth: i,
        minWidth: o,
        minHeight: a,
        position: {
          x: e,
          y: t
        },
        size: s,
        onDragStop: u,
        onResizeStart: y,
        onResize: f,
        onResizeStop: b,
        className: "ai-tw-pointer-events-auto"
      },
      n
    )),
    document.body
  );
}
function aM({ children: e, className: t }) {
  const { x: n, y: r, width: i, height: o, setX: a, setY: s, setWidth: l, setHeight: u } = Me(Xs) || {}, [d, f] = de(
    null
  ), p = (y, b) => {
    a && a(b.x), s && s(b.y), window.localStorage.setItem("askPlaceX", String(b.x)), window.localStorage.setItem("askPlaceY", String(b.y));
  }, m = (y, b, E, S, _) => {
    const k = E.getBoundingClientRect();
    window.localStorage.setItem("askPlaceWidth", String(k.width)), window.localStorage.setItem("askPlaceHeight", String(k.height)), window.localStorage.setItem("askPlaceX", String(_.x)), window.localStorage.setItem("askPlaceY", String(_.y));
  }, g = (y, b, E, S, _) => {
    const k = E.getBoundingClientRect();
    a && a(_.x), s && s(_.y), l && l(k.width), u && u(k.height);
  }, v = De(() => {
    d && (window.innerHeight < d.clientHeight || window.innerWidth < d.clientWidth || (n && n < 0 && a && a(0), r && r < 0 && s && s(0), n && n + d.clientWidth > window.innerWidth && a && a(window.innerWidth - d.clientWidth), r && r + d.clientHeight > window.innerHeight && s && s(window.innerHeight - d.clientHeight)));
  }, [d, a, s, n, r]);
  return /* @__PURE__ */ x.createElement(
    oM,
    {
      x: n,
      y: r,
      maxWidth: Xoe,
      minWidth: Koe,
      minHeight: JT,
      size: i && o ? { width: i, height: o } : void 0,
      setDraggableElement: f,
      handleDragStop: p,
      handleResizeStop: m,
      handleResize: g,
      onClipped: v
    },
    /* @__PURE__ */ x.createElement(
      mn.div,
      {
        initial: { opacity: 0, scale: 0.5 },
        animate: { opacity: 1, scale: 1 },
        className: t,
        id: Xh
      },
      e
    )
  );
}
function R1e(e) {
  return e && typeof e == "object" && "message" in e ? e.message : "";
}
function I1e({
  error: e,
  resetErrorBoundary: t,
  onMinimize: n
}) {
  return /* @__PURE__ */ x.createElement(e7, null, /* @__PURE__ */ x.createElement(
    At.Provider,
    {
      value: {
        ...ZT,
        onMinimize: n
      }
    },
    /* @__PURE__ */ x.createElement(aM, { className: "ai-tw-preflight ai-tw-relative ai-tw-mx-auto ai-tw-flex ai-tw-flex-col ai-tw-overflow-hidden ai-tw-rounded-lg ai-tw-bg-container-primary ai-tw-shadow-modal ai-tw-shadow-purple-20" }, /* @__PURE__ */ x.createElement(uw, null), /* @__PURE__ */ x.createElement("div", { className: "ai-tw-flex ai-tw-h-full ai-tw-flex-col ai-tw-items-center ai-tw-justify-center ai-tw-p-8 ai-tw-text-center" }, /* @__PURE__ */ x.createElement("p", { className: "ai-tw-font-semibold ai-tw-text-red-40" }, "Unexpected Error Occurred. Please press Retry or reach out to the support team: ", R1e(e), "."), /* @__PURE__ */ x.createElement(
      Xt,
      {
        className: "ai-tw-mt-4",
        variant: "tertiary",
        onClick: t
      },
      "Retry"
    )))
  ));
}
function Id(e) {
  return typeof e == "number" ? Math.max(e, 0) : 0;
}
function D1e({
  children: e,
  className: t,
  offset: n = {}
}) {
  const r = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...n,
    width: n ? `calc(100vw - ${Id(n.left) + Id(n.right)}px)` : "100vw",
    height: n ? `calc(100vh - ${Id(n.top) + Id(n.bottom)}px)` : "100vh"
  };
  return _c(
    /* @__PURE__ */ x.createElement(
      mn.div,
      {
        id: Xh,
        initial: { opacity: 0, scale: 0.5 },
        animate: { opacity: 1, scale: 1 },
        className: ie("ai-tw-fixed ai-tw-bg-white", t),
        style: r
      },
      e
    ),
    document.body
  );
}
const nS = 12;
function N1e({
  children: e,
  className: t,
  offset: n = {}
}) {
  const [r, i] = de(
    null
  ), o = window.localStorage.getItem("askPlaceMinimizedX"), a = o ? Number(o) : window.innerWidth, [s, l] = de(a), u = window.localStorage.getItem("askPlaceMinimizedY"), d = u ? Number(u) : window.innerHeight, [f, p] = de(d), m = me(n.x || 0), g = me(n.y || 0);
  be(() => {
    if (!r)
      return;
    const b = window.innerWidth - r.clientWidth - nS + m.current, E = window.innerHeight - r.clientHeight - nS + g.current;
    !window.localStorage.getItem("askPlaceMinimizedX") && !window.localStorage.getItem("askPlaceMinimizedY") && (l(b), p(E));
  }, [r]);
  const v = (b, E) => {
    l(E.x), p(E.y), window.localStorage.setItem("askPlaceMinimizedX", String(E.x)), window.localStorage.setItem("askPlaceMinimizedY", String(E.y));
  }, y = De(() => {
    r && (window.innerHeight < r.clientHeight || window.innerWidth < r.clientWidth || (s < 0 && l(0), f < 0 && p(0), s + r.clientWidth > window.innerWidth && l(window.innerWidth - r.clientWidth), f + r.clientHeight > window.innerHeight && p(window.innerHeight - r.clientHeight)));
  }, [r, l, p, s, f]);
  return /* @__PURE__ */ x.createElement(
    oM,
    {
      x: s,
      y: f,
      setDraggableElement: i,
      enableResizing: !1,
      handleDragStop: v,
      onClipped: y
    },
    /* @__PURE__ */ x.createElement(
      mn.div,
      {
        initial: { opacity: 0, scale: 0.5 },
        animate: { opacity: 1, scale: 1 },
        className: t,
        id: Xh
      },
      e
    )
  );
}
function $1e() {
  const { setAskPlaceSize: e } = Me(At);
  return /* @__PURE__ */ x.createElement(x.Fragment, null, /* @__PURE__ */ x.createElement(uw, null), /* @__PURE__ */ x.createElement(
    "div",
    {
      id: sw,
      className: "ai-tw-cursor-default ai-tw-p-4"
    },
    /* @__PURE__ */ x.createElement(
      n7,
      {
        onSubmit: () => {
          e("midsize");
        }
      }
    )
  ));
}
function L1e({
  onMinimize: e,
  defaultX: t,
  defaultY: n,
  leadUuid: r,
  maximized: i = {},
  minimized: o = {},
  notForProduction_accountEmail: a
}) {
  const [s, l] = fE(
    Voe,
    qT
  ), [u, d] = fE(
    Loe,
    HT
  ), f = P0(s), p = Vc(s), [
    m,
    g
  ] = de(null), v = P0(
    m
  ), { fetchChatById: y } = qh({
    chatId: p,
    enabled: !!p
  }), { mutate: b } = zc();
  function E(le) {
    l({
      type: "citationReceived",
      citation: le
    });
  }
  function S(le) {
    l({
      type: "errorMessageReceived",
      message: le
    });
  }
  function _(le) {
    l({ type: "generationTokenReceived", word: le });
  }
  function k(le) {
    l({
      type: "sourceReceived",
      source: le
    });
  }
  function T(le) {
    l({
      type: "followUpQuestionsReceived",
      questions: le
    });
  }
  function A(le) {
    l({
      type: "sourceMetadataReceived",
      metadata: le
    });
  }
  function R(le) {
    l({
      type: "citationMetadataReceived",
      metadata: le
    });
  }
  function F({ chatId: le }) {
    async function Ee() {
      await b(), !p ? await Ov(Rf(le), y(le), !1) : await Ov(Rf(le));
      const te = YT(f.current);
      if (te != null && te.length)
        return;
      l({
        type: "cleanOptimisticChatState"
      });
      const Re = v.current;
      l({
        type: "selectChat",
        chatId: Re ?? le
      }), g(null);
    }
    if (Goe(f.current)) {
      Qoe(() => {
        Joe(), Ee();
      });
      return;
    }
    Ee();
  }
  const {
    isGenerationInProgress: D,
    createSocket: W,
    sendPayload: L,
    startListening: z,
    stopGenerating: B
  } = Jie({
    leadUuid: r,
    notifyCitationReceived: E,
    notifyCitationMetadataReceived: R,
    notifyErrorMessageReceived: S,
    notifyFollowUpQuestionsReceived: T,
    notifyGenerationReceived: F,
    notifyGenerationTokenReceived: _,
    notifySourceReceived: k,
    notifySourceMetadataReceived: A,
    notForProduction_accountEmail: a
  });
  be(() => () => {
    Zie();
  }, []);
  const [G, H] = de(!0);
  function J() {
    if (D) {
      B(), g(null);
      return;
    }
    l({ type: "createChat" });
  }
  function q(le) {
    if (!(!le || D)) {
      Q(), l({
        type: "askQuestion",
        question: le
      }), window.setTimeout(() => QT(he), 0);
      try {
        const Ee = W();
        Ee.on("connect", () => {
          L({ socket: Ee, question: le, selectedChat: p }), z(Ee);
        });
      } catch (Ee) {
        console.error(Ee, "error occurred");
      }
    }
  }
  function Z(le) {
    if (D) {
      B(), g(le);
      return;
    }
    l({ type: "selectChat", chatId: le });
  }
  function O() {
    H(!1);
  }
  function Q() {
    H(!0);
  }
  const he = me(null), N = window.localStorage.getItem(
    "askPlaceSize"
  ), [ee, ae] = de(
    N || "midsize"
  );
  function pe(le) {
    window.localStorage.setItem("askPlaceSize", le), ae(le);
  }
  const [se, Se] = de(!1);
  return /* @__PURE__ */ x.createElement(e7, { defaultX: t, defaultY: n }, /* @__PURE__ */ x.createElement(
    At.Provider,
    {
      value: {
        askQuestion: q,
        disableStreamingAutoScroll: O,
        allowStreamingAutoScroll: Q,
        isStreamingAutoScrollEnabled: G,
        chatState: s,
        chatDispatch: l,
        stopGenerating: B,
        isGenerationInProgress: D,
        selectChat: Z,
        navigationState: u,
        navigationDispatch: d,
        onMinimize: e,
        createNewChat: J,
        askPlaceSize: ee,
        setAskPlaceSize: pe,
        leadUuid: r,
        isReleaseNotesOpen: se,
        setIsReleaseNotesOpen: Se
      }
    },
    /* @__PURE__ */ x.createElement(ri, null, ee === "midsize" ? /* @__PURE__ */ x.createElement(aM, { className: "ai-tw-preflight ai-tw-mx-auto ai-tw-flex ai-tw-h-full ai-tw-flex-col ai-tw-overflow-hidden ai-tw-rounded-lg ai-tw-bg-container-primary ai-tw-shadow-modal ai-tw-shadow-purple-20" }, /* @__PURE__ */ x.createElement(K4, { transcriptRef: he })) : null),
    /* @__PURE__ */ x.createElement(ri, null, ee === "maximized" ? /* @__PURE__ */ x.createElement(
      D1e,
      {
        offset: i.offset,
        className: "ai-tw-preflight ai-tw-z-[999] ai-tw-flex ai-tw-h-full ai-tw-flex-col"
      },
      /* @__PURE__ */ x.createElement(K4, { transcriptRef: he })
    ) : null),
    /* @__PURE__ */ x.createElement(ri, null, ee === "minimized" ? /* @__PURE__ */ x.createElement(
      N1e,
      {
        offset: o.offset,
        className: "ai-tw-preflight ai-tw-flex ai-tw-w-[340px] ai-tw-flex-col ai-tw-overflow-hidden ai-tw-rounded-xl ai-tw-bg-white ai-tw-shadow-modal ai-tw-shadow-purple-20"
      },
      /* @__PURE__ */ x.createElement($1e, null)
    ) : null)
  ));
}
function qye(e) {
  return /* @__PURE__ */ x.createElement(
    Do,
    {
      FallbackComponent: (t) => /* @__PURE__ */ x.createElement(I1e, { ...t, onMinimize: e.onMinimize })
    },
    /* @__PURE__ */ x.createElement(L1e, { ...e })
  );
}
const pa = {
  windows: "Windows",
  macOS: "macOS",
  unknown: "Unknown OS"
};
function F1e() {
  if (navigator.userAgentData) {
    const e = navigator.userAgentData.platform;
    return Object.values(pa).includes(e) ? e : pa.unknown;
  } else
    return z1e();
}
function z1e() {
  const e = navigator.userAgent;
  return /Windows NT/.test(e) ? pa.windows : /Mac OS X/.test(e) ? pa.macOS : pa.unknown;
}
function V1e() {
  const e = F1e(), t = e === pa.macOS ? /* @__PURE__ */ x.createElement(QY, { className: "ai-tw-h-3 ai-tw-w-3" }) : e === pa.windows ? "Alt" : "";
  return /* @__PURE__ */ x.createElement("div", null, Kh, t ? /* @__PURE__ */ x.createElement("div", { className: "ai-tw-ml-1 ai-tw-inline-flex ai-tw-items-center" }, "(", t, " ", /* @__PURE__ */ x.createElement("span", { className: "ai-tw-ml-1" }, "+ P"), ")") : null);
}
function Yye({
  onClick: e,
  isAskPlaceOpen: t,
  showKeyboardShortcutTooltip: n
}) {
  return /* @__PURE__ */ x.createElement(f6, null, /* @__PURE__ */ x.createElement(h6, { asChild: !0 }, /* @__PURE__ */ x.createElement(
    Xt,
    {
      onClick: e,
      variant: "transparent-secondary",
      className: ie(
        "ai-tw-rounded-sm !ai-tw-border-[1.5px] ai-tw-border-content-primary !ai-tw-bg-white/10 !ai-tw-px-[14px] !ai-tw-py-[8.5px]",
        {
          "ai-tw-border-purple-20": t,
          "active:ai-tw-border-purple-20 active:!ai-tw-px-[12.5px] active:!ai-tw-py-[7px] active:!ai-tw-border-[3px] hover:ai-tw-border-content-primary-light hover:ai-tw-shadow-md hover:ai-tw-shadow-white/40 hover:!ai-tw-bg-white/20 active:!ai-tw-bg-white/30": !t
        }
      ),
      contentClassName: "ai-tw-flex ai-tw-items-center"
    },
    /* @__PURE__ */ x.createElement("div", { className: "ai-tw-mr-2 ai-tw-flex ai-tw-h-4 ai-tw-w-4 ai-tw-items-center ai-tw-justify-center" }, /* @__PURE__ */ x.createElement(
      Le,
      {
        icon: t ? U$ : Ls,
        className: ie({
          "ai-tw-text-[8px] ai-tw-text-purple-20": t
        })
      }
    )),
    /* @__PURE__ */ x.createElement(
      gw,
      {
        width: 48,
        height: 9,
        pathClassName: ie("ai-tw-fill-white", {
          "ai-tw-fill-purple-20": t
        })
      }
    )
  )), /* @__PURE__ */ x.createElement(sG, null, n && !t && /* @__PURE__ */ x.createElement(
    ny,
    {
      side: "bottom",
      className: "ai-tw-w-auto ai-tw-bg-place-black ai-tw-shadow-md ai-tw-shadow-white/40",
      tooltipArrowClassName: "ai-tw-fill-place-black"
    },
    /* @__PURE__ */ x.createElement("span", { className: "ai-tw-body-md" }, /* @__PURE__ */ x.createElement(V1e, null))
  )));
}
function Kye({
  setIsAskPlaceOpen: e
}) {
  return be(() => {
    function t(n) {
      n.code === "KeyP" && n.altKey && e((r) => !r);
    }
    return document.addEventListener("keydown", t), () => document.removeEventListener("keydown", t);
  }, [e]), null;
}
function _s(e) {
  return !!(e != null && e.insightId);
}
const rS = "/areapro-external/insights";
function sM({ addresses: e, mlsIds: t }) {
  const n = ln(), r = De(async () => n(rS, {
    json: { addresses: e, mlsIds: t },
    method: "POST"
  }), [e, t, n]);
  return Hs(rS, r);
}
const Lw = ({ className: e }) => /* @__PURE__ */ C.createElement(
  "svg",
  {
    className: ie("ai-tw-h-4 ai-tw-w-4 ai-tw-fill-current", e),
    viewBox: "0 0 48 50",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ C.createElement("path", { d: "M35.4712 8.87053C32.7969 7.41478 29.8367 6.56126 26.7979 6.36976C26.3919 3.60419 26.1212 1.80952 26.1212 1.80952C26.0792 1.5007 25.9267 1.21757 25.6919 1.01258C25.4571 0.807596 25.156 0.694641 24.8444 0.694641C24.5327 0.694641 24.2316 0.807596 23.9968 1.01258C23.762 1.21757 23.6095 1.5007 23.5675 1.80952L22.9791 6.43448C14.1528 7.42303 6.11501 13.7485 4.02025 23.0926C3.67667 24.5155 3.48923 25.9716 3.46125 27.4351L0.966357 27.5293C0.734838 27.5478 0.518791 27.6528 0.361244 27.8235C0.203697 27.9941 0.116211 28.2179 0.116211 28.4501C0.116211 28.6824 0.203697 28.9061 0.361244 29.0768C0.518791 29.2474 0.734838 29.3525 0.966357 29.371L3.50244 29.4652C3.73567 32.7786 4.72517 35.9944 6.39496 38.8658C8.06475 41.7372 10.3704 44.1877 13.1348 46.0291C13.3336 46.1406 13.567 46.1731 13.7887 46.1202C14.0103 46.0673 14.2039 45.9328 14.3308 45.7435C14.4577 45.5542 14.5087 45.3241 14.4735 45.099C14.4383 44.8738 14.3196 44.6702 14.141 44.5287C11.6818 42.8379 9.63717 40.6123 8.16056 38.0188C6.68394 35.4253 5.81362 32.5312 5.61486 29.5534L10.2928 29.7182L11.6285 32.7662C11.7027 32.9325 11.8105 33.0816 11.9452 33.2041C12.0799 33.3267 12.2385 33.42 12.4111 33.4782C12.7373 33.5823 13.0914 33.5536 13.3965 33.3983C13.7017 33.243 13.9333 32.9735 14.041 32.6485L14.7118 30.5714L17.8186 48.0592C17.8762 48.3605 18.039 48.6317 18.2778 48.8242C18.5167 49.0167 18.8163 49.1182 19.123 49.1104C19.4297 49.1026 19.7237 48.9862 19.9525 48.7818C20.1814 48.5774 20.3302 48.2983 20.3724 47.9944L24.9503 11.5125L28.5337 35.7789C28.5752 36.0565 28.7058 36.3131 28.9058 36.51C29.1058 36.707 29.3644 36.8336 29.6426 36.8708C29.9208 36.9079 30.2035 36.8537 30.4482 36.7162C30.6929 36.5787 30.8863 36.3654 30.9992 36.1084L32.6527 32.2896C33.7707 35.926 35.1534 39.4977 37.8366 42.4162L37.9014 42.4692L39.0782 43.493C39.4102 43.7662 39.8342 43.902 40.2631 43.8724C40.692 43.8429 41.0934 43.6503 41.3848 43.3342C51.1702 32.8368 48.1928 15.5314 35.4712 8.87053ZM18.8719 39.2329C17.748 32.8074 16.3535 25.0403 16.3535 25.0403C16.304 24.757 16.1617 24.4984 15.9489 24.305C15.7362 24.1116 15.4651 23.9946 15.1785 23.9723C14.8918 23.9501 14.606 24.0239 14.3659 24.1821C14.1259 24.3403 13.9453 24.5739 13.8527 24.8461L12.6288 28.612L12.3346 27.9294V27.8882C12.2357 27.6615 12.0702 27.4702 11.8599 27.3399C11.6497 27.2096 11.4048 27.1463 11.1578 27.1586L5.61486 27.3586C5.67906 26.092 5.87628 24.8357 6.20328 23.6104C7.13307 19.7973 9.21219 16.3621 12.1591 13.7698C15.1061 11.1776 18.7784 9.55354 22.679 9.11767L18.8719 39.2329ZM39.9432 39.8743C38.5524 38.3234 37.4163 36.5618 36.5774 34.655C35.6482 32.53 34.8312 30.3577 34.1296 28.1471C34.0539 27.8935 33.902 27.6694 33.6946 27.5052C33.4871 27.3409 33.234 27.2445 32.9699 27.2291C32.7057 27.2137 32.4432 27.28 32.218 27.4189C31.9928 27.5579 31.8159 27.7628 31.7112 28.0059L30.4284 30.948L27.2039 9.12944C30.5755 9.51834 33.7818 10.8013 36.491 12.8455C39.2002 14.8898 41.3137 17.621 42.6129 20.7564C43.9121 23.8918 44.3496 27.3174 43.8802 30.6787C43.4108 34.04 42.0516 37.2147 39.9432 39.8743Z" })
), lM = () => /* @__PURE__ */ C.createElement("div", { className: "ai-tw-flex ai-tw-w-max ai-tw-items-center ai-tw-gap-2 ai-tw-p-1 ai-tw-text-stroke-critical-dark" }, /* @__PURE__ */ C.createElement(Le, { icon: to }), /* @__PURE__ */ C.createElement("span", null, "Error Loading AreaPro")), Gf = ({
  className: e,
  ...t
}) => /* @__PURE__ */ C.createElement(
  Xt,
  {
    variant: "secondary-alt",
    className: ie("ai-tw-w-full ai-tw-rounded-lg ai-tw-button-sm", e),
    ...t
  }
), B1e = {
  SMALL: "ai-tw-w-full ai-tw-max-w-xl ai-tw-h-[80vh] sm:ai-tw-h-1/2",
  MEDIUM: "ai-tw-w-full ai-tw-max-w-3xl ai-tw-h-[80vh] sm:ai-tw-h-[60vh]",
  LARGE: "ai-tw-w-full ai-tw-max-w-5xl ai-tw-h-[80vh] sm:ai-tw-h-3/4",
  XLARGE: "ai-tw-w-full ai-tw-max-w-7xl ai-tw-h-[90vh]"
};
function cM({
  show: e,
  onClose: t,
  url: n,
  containerStyle: r
}) {
  const [i, o] = de("XLARGE");
  return be(() => {
    const a = (s) => {
      s.data.type === "CLOSE_MODAL" && t && t(), s.data.type === "SET_MODAL_SIZE" && o(s.data.value || "XLARGE");
    };
    return window.addEventListener("message", a), () => {
      window.removeEventListener("message", a);
    };
  }, [t]), e ? /* @__PURE__ */ x.createElement(
    vy,
    {
      onOpenChange: (a) => {
        !a && t && t();
      },
      defaultOpen: !0
    },
    /* @__PURE__ */ x.createElement(
      Ah,
      {
        className: ie(
          "ai-tw-z-[1200] ai-tw-flex ai-tw-flex-col ai-tw-p-0 ai-tw-font-lato",
          B1e[i]
        ),
        style: r
      },
      /* @__PURE__ */ x.createElement("div", { className: ie("ai-tw-flex-1 ai-tw-overflow-hidden") }, /* @__PURE__ */ x.createElement("iframe", { src: n, className: "ai-tw-h-full ai-tw-w-full" }))
    )
  ) : null;
}
const uM = ({
  remoUrl: e,
  activeTabKey: t
}) => {
  try {
    const n = new URL(e);
    return t && n.searchParams.set("activeTab", `${t}`), n;
  } catch {
    return null;
  }
}, j1e = {
  overview: 0,
  insights: 1,
  ai: 2
};
function Xye({
  addresses: e,
  children: t,
  style: n,
  tab: r,
  dialogStyle: i
}) {
  var m, g, v, y, b, E, S, _;
  const { trigger: o, data: a, isMutating: s, reset: l } = sM({
    addresses: e
  }), u = !!(_s(a) ? ((m = a == null ? void 0 : a.addresses) == null ? void 0 : m.length) > 0 : a != null && a.url), d = _s(a) ? (y = Object.keys(((v = (g = a == null ? void 0 : a.addresses) == null ? void 0 : g[0]) == null ? void 0 : v.remo) || {})) == null ? void 0 : y[0] : "", f = (_s(a) ? (_ = (S = (E = (b = a == null ? void 0 : a.addresses) == null ? void 0 : b[0]) == null ? void 0 : E.remo) == null ? void 0 : S[d]) == null ? void 0 : _.url : a == null ? void 0 : a.url) || "", p = uM({
    remoUrl: f,
    activeTabKey: r ? `${j1e[r] || ""}` : void 0
  });
  return /* @__PURE__ */ C.createElement(Do, { fallback: /* @__PURE__ */ C.createElement(lM, null) }, e != null && e.length ? /* @__PURE__ */ C.createElement(C.Fragment, null, /* @__PURE__ */ C.createElement(
    cM,
    {
      show: u,
      onClose: () => l(),
      url: p == null ? void 0 : p.href,
      containerStyle: i
    }
  ), /* @__PURE__ */ C.createElement(
    Gf,
    {
      onClick: () => o(),
      status: s ? "loading" : "default",
      disabled: s,
      style: n
    },
    t
  )) : /* @__PURE__ */ C.createElement("a", { href: "https://app.areapro.com", target: "_blank", rel: "noreferrer" }, /* @__PURE__ */ C.createElement(Gf, { style: n }, /* @__PURE__ */ C.createElement("span", { className: "ai-tw-flex ai-tw-items-center ai-tw-justify-center ai-tw-gap-1 ai-tw-uppercase" }, /* @__PURE__ */ C.createElement(Lw, null), " Go To AreaPro"))));
}
const Qg = {
  overview: {
    key: "0",
    icon: /* @__PURE__ */ C.createElement(Lw, null),
    label: "Area Insights"
  },
  insights: {
    key: "1",
    icon: /* @__PURE__ */ C.createElement(Le, { icon: M$ }),
    label: "Price Range Graphs"
  },
  ai: {
    key: "2",
    icon: /* @__PURE__ */ C.createElement(Le, { icon: Ls }),
    label: "Rapid AI Insights"
  }
};
function Zye({
  addresses: e,
  tabs: t = ["overview", "ai"],
  options: n,
  containerStyle: r,
  buttonStyle: i,
  dialogStyle: o
}) {
  var y, b, E, S, _, k, T, A, R;
  const [a, s] = C.useState("overview"), { trigger: l, data: u, isMutating: d, reset: f } = sM({
    addresses: e
  }), p = !!(_s(u) ? ((y = u == null ? void 0 : u.addresses) == null ? void 0 : y.length) > 0 : u != null && u.url), m = _s(u) ? (S = Object.keys(((E = (b = u == null ? void 0 : u.addresses) == null ? void 0 : b[0]) == null ? void 0 : E.remo) || {})) == null ? void 0 : S[0] : "", g = (_s(u) ? (A = (T = (k = (_ = u == null ? void 0 : u.addresses) == null ? void 0 : _[0]) == null ? void 0 : k.remo) == null ? void 0 : T[m]) == null ? void 0 : A.url : u == null ? void 0 : u.url) || "";
  let v = null;
  return v = uM({ remoUrl: g, activeTabKey: (R = Qg[a]) == null ? void 0 : R.key }), /* @__PURE__ */ C.createElement(Do, { fallback: /* @__PURE__ */ C.createElement(lM, null) }, e != null && e.length ? /* @__PURE__ */ C.createElement(C.Fragment, null, /* @__PURE__ */ C.createElement(
    cM,
    {
      show: p,
      onClose: () => {
        f(), s("overview");
      },
      url: v == null ? void 0 : v.href,
      containerStyle: o
    }
  ), /* @__PURE__ */ C.createElement(
    "div",
    {
      className: ie("ai-tw-flex ai-tw-flex-col ai-tw-gap-2"),
      style: r
    },
    t.map((F) => {
      var L, z;
      const D = (n == null ? void 0 : n[F]) || ((L = Qg[F]) == null ? void 0 : L.label), W = (z = Qg[F]) == null ? void 0 : z.icon;
      return D ? /* @__PURE__ */ C.createElement(
        Gf,
        {
          key: F,
          onClick: () => {
            l(), s(F);
          },
          status: a === F && d ? "loading" : "default",
          disabled: d,
          style: i
        },
        /* @__PURE__ */ C.createElement("span", { className: "ai-tw-flex ai-tw-items-center ai-tw-justify-center ai-tw-gap-1 ai-tw-uppercase" }, W, " ", D)
      ) : null;
    })
  )) : /* @__PURE__ */ C.createElement("a", { href: "https://app.areapro.com", target: "_blank", rel: "noreferrer" }, /* @__PURE__ */ C.createElement(Gf, { style: i }, /* @__PURE__ */ C.createElement("span", { className: "ai-tw-flex ai-tw-items-center ai-tw-justify-center ai-tw-gap-1 ai-tw-uppercase" }, /* @__PURE__ */ C.createElement(Lw, null), " Go To AreaPro"))));
}
export {
  Rz as $,
  cae as A,
  Xt as B,
  $q as C,
  sae as D,
  Ey as E,
  Cy as F,
  i1 as G,
  Q1e as H,
  Ls as I,
  sS as J,
  Aq as K,
  Oq as L,
  Ch as M,
  fG as N,
  bT as O,
  uye as P,
  pG as Q,
  ri as R,
  jn as S,
  yle as T,
  wle as U,
  ble as V,
  xle as W,
  pS as X,
  Ele as Y,
  bz as Z,
  ge as _,
  bae as a,
  nk as a$,
  Ez as a0,
  kz as a1,
  Tz as a2,
  nye as a3,
  J1e as a4,
  pq as a5,
  iy as a6,
  xh as a7,
  n1 as a8,
  dS as a9,
  vy as aA,
  pye as aB,
  Ah as aC,
  yy as aD,
  wy as aE,
  lY as aF,
  Yv as aG,
  Lye as aH,
  YA as aI,
  gS as aJ,
  nL as aK,
  K1e as aL,
  Z1e as aM,
  Y1e as aN,
  Iye as aO,
  tye as aP,
  My as aQ,
  eye as aR,
  r1 as aS,
  LP as aT,
  Oh as aU,
  W$ as aV,
  ele as aW,
  Zse as aX,
  Vq as aY,
  Ny as aZ,
  sk as a_,
  tL as aa,
  G1e as ab,
  oye as ac,
  aye as ad,
  $ye as ae,
  Do as af,
  yh as ag,
  Dc as ah,
  Lse as ai,
  q1e as aj,
  Dye as ak,
  iye as al,
  jye as am,
  X1e as an,
  Nye as ao,
  Vye as ap,
  rye as aq,
  Wye as ar,
  $r as as,
  f6 as at,
  ny as au,
  h6 as av,
  Jy as aw,
  Rr as ax,
  yn as ay,
  zye as az,
  Hs as b,
  Rs as b0,
  dye as b1,
  fye as b2,
  wf as b3,
  G1 as b4,
  xye as b5,
  Eye as b6,
  Cye as b7,
  kye as b8,
  Tye as b9,
  Aye as ba,
  Oye as bb,
  Xie as bc,
  Rye as bd,
  Mye as be,
  qye as bf,
  Yye as bg,
  Kye as bh,
  Xye as bi,
  Zye as bj,
  cye as bk,
  ie as c,
  br as d,
  lae as e,
  iL as f,
  cS as g,
  mS as h,
  O$ as i,
  yf as j,
  to as k,
  Fye as l,
  mn as m,
  Bye as n,
  Uye as o,
  Sy as p,
  bf as q,
  Ut as r,
  li as s,
  Ji as t,
  ln as u,
  rt as v,
  $e as w,
  rr as x,
  Us as y,
  Nc as z
};
